/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// use `yarn generate:graphql to regenerate

import { useMemo } from "react";
import parseVariables, { useMutationVariables, useQueryVariables, useLazyQueryVariables } from "@virtuslab/nfs-shared/src/schema/parseVariables";
import { scalarPaths } from "./scalarPaths";
import { scalarParsers } from "./scalars";
import * as ApolloReact from "@apollo/client/react"
import { gql } from 'graphql.macro';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export const AbsenceRecordTypename = 'AbsenceRecord';
export interface AbsenceRecordTypeLike extends TypeLike { readonly __typename?: typeof AbsenceRecordTypename; }
export const NfsErrorTypename = 'NfsError';
export interface NfsErrorTypeLike extends TypeLike { readonly __typename?: typeof NfsErrorTypename; }
export const ActiveReportingRangeErrorTypename = 'ActiveReportingRangeError';
export interface ActiveReportingRangeErrorTypeLike extends TypeLike { readonly __typename?: typeof ActiveReportingRangeErrorTypename; }
export const AggregatedValidationErrorsTypename = 'AggregatedValidationErrors';
export interface AggregatedValidationErrorsTypeLike extends TypeLike { readonly __typename?: typeof AggregatedValidationErrorsTypename; }
export const DuplicatedEntityErrorTypename = 'DuplicatedEntityError';
export interface DuplicatedEntityErrorTypeLike extends TypeLike { readonly __typename?: typeof DuplicatedEntityErrorTypename; }
export const EmptyRequestInputErrorTypename = 'EmptyRequestInputError';
export interface EmptyRequestInputErrorTypeLike extends TypeLike { readonly __typename?: typeof EmptyRequestInputErrorTypename; }
export const EntitiesNotFoundErrorTypename = 'EntitiesNotFoundError';
export interface EntitiesNotFoundErrorTypeLike extends TypeLike { readonly __typename?: typeof EntitiesNotFoundErrorTypename; }
export const EntityNotFoundErrorTypename = 'EntityNotFoundError';
export interface EntityNotFoundErrorTypeLike extends TypeLike { readonly __typename?: typeof EntityNotFoundErrorTypename; }
export const EntityVersionMismatchedTypename = 'EntityVersionMismatched';
export interface EntityVersionMismatchedTypeLike extends TypeLike { readonly __typename?: typeof EntityVersionMismatchedTypename; }
export const ForeignKeyConstraintErrorTypename = 'ForeignKeyConstraintError';
export interface ForeignKeyConstraintErrorTypeLike extends TypeLike { readonly __typename?: typeof ForeignKeyConstraintErrorTypename; }
export const IllegalPositionRemovalErrorTypename = 'IllegalPositionRemovalError';
export interface IllegalPositionRemovalErrorTypeLike extends TypeLike { readonly __typename?: typeof IllegalPositionRemovalErrorTypename; }
export const IncompleteArgumentErrorTypename = 'IncompleteArgumentError';
export interface IncompleteArgumentErrorTypeLike extends TypeLike { readonly __typename?: typeof IncompleteArgumentErrorTypename; }
export const IncompleteArgumentsErrorTypename = 'IncompleteArgumentsError';
export interface IncompleteArgumentsErrorTypeLike extends TypeLike { readonly __typename?: typeof IncompleteArgumentsErrorTypename; }
export const InternalNfsErrorTypename = 'InternalNfsError';
export interface InternalNfsErrorTypeLike extends TypeLike { readonly __typename?: typeof InternalNfsErrorTypename; }
export const InvalidApiTokenErrorTypename = 'InvalidApiTokenError';
export interface InvalidApiTokenErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidApiTokenErrorTypename; }
export const InvalidArgumentsErrorTypename = 'InvalidArgumentsError';
export interface InvalidArgumentsErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidArgumentsErrorTypename; }
export const InvalidCompanyTypeErrorTypename = 'InvalidCompanyTypeError';
export interface InvalidCompanyTypeErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidCompanyTypeErrorTypename; }
export const InvalidContentTypeErrorTypename = 'InvalidContentTypeError';
export interface InvalidContentTypeErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidContentTypeErrorTypename; }
export const InvalidCursorErrorTypename = 'InvalidCursorError';
export interface InvalidCursorErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidCursorErrorTypename; }
export const InvalidEmailAddressTypename = 'InvalidEmailAddress';
export interface InvalidEmailAddressTypeLike extends TypeLike { readonly __typename?: typeof InvalidEmailAddressTypename; }
export const InvalidStateErrorTypename = 'InvalidStateError';
export interface InvalidStateErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidStateErrorTypename; }
export const InvoiceAlreadyAcceptedErrorTypename = 'InvoiceAlreadyAcceptedError';
export interface InvoiceAlreadyAcceptedErrorTypeLike extends TypeLike { readonly __typename?: typeof InvoiceAlreadyAcceptedErrorTypename; }
export const InvoiceImportedFromSaldeoErrorTypename = 'InvoiceImportedFromSaldeoError';
export interface InvoiceImportedFromSaldeoErrorTypeLike extends TypeLike { readonly __typename?: typeof InvoiceImportedFromSaldeoErrorTypename; }
export const LeaveEntitlementExceededErrorTypename = 'LeaveEntitlementExceededError';
export interface LeaveEntitlementExceededErrorTypeLike extends TypeLike { readonly __typename?: typeof LeaveEntitlementExceededErrorTypename; }
export const MissingFileMetadataErrorTypename = 'MissingFileMetadataError';
export interface MissingFileMetadataErrorTypeLike extends TypeLike { readonly __typename?: typeof MissingFileMetadataErrorTypename; }
export const NbpBaseCurrencyErrorTypename = 'NbpBaseCurrencyError';
export interface NbpBaseCurrencyErrorTypeLike extends TypeLike { readonly __typename?: typeof NbpBaseCurrencyErrorTypename; }
export const NoParkingSpotAvailableErrorTypename = 'NoParkingSpotAvailableError';
export interface NoParkingSpotAvailableErrorTypeLike extends TypeLike { readonly __typename?: typeof NoParkingSpotAvailableErrorTypename; }
export const OperationAlreadyInProgressErrorTypename = 'OperationAlreadyInProgressError';
export interface OperationAlreadyInProgressErrorTypeLike extends TypeLike { readonly __typename?: typeof OperationAlreadyInProgressErrorTypename; }
export const OperationNotAvailableErrorTypename = 'OperationNotAvailableError';
export interface OperationNotAvailableErrorTypeLike extends TypeLike { readonly __typename?: typeof OperationNotAvailableErrorTypename; }
export const OtherInvalidRequestErrorTypename = 'OtherInvalidRequestError';
export interface OtherInvalidRequestErrorTypeLike extends TypeLike { readonly __typename?: typeof OtherInvalidRequestErrorTypename; }
export const PaymentCouldNotBeChangedErrorTypename = 'PaymentCouldNotBeChangedError';
export interface PaymentCouldNotBeChangedErrorTypeLike extends TypeLike { readonly __typename?: typeof PaymentCouldNotBeChangedErrorTypename; }
export const PositionInactiveErrorTypename = 'PositionInactiveError';
export interface PositionInactiveErrorTypeLike extends TypeLike { readonly __typename?: typeof PositionInactiveErrorTypename; }
export const RaiseNoLongerDueErrorTypename = 'RaiseNoLongerDueError';
export interface RaiseNoLongerDueErrorTypeLike extends TypeLike { readonly __typename?: typeof RaiseNoLongerDueErrorTypename; }
export const ReservationNotPendingErrorTypename = 'ReservationNotPendingError';
export interface ReservationNotPendingErrorTypeLike extends TypeLike { readonly __typename?: typeof ReservationNotPendingErrorTypename; }
export const ReservationRequestStateErrorTypename = 'ReservationRequestStateError';
export interface ReservationRequestStateErrorTypeLike extends TypeLike { readonly __typename?: typeof ReservationRequestStateErrorTypename; }
export const ResourceAlreadyReservedErrorTypename = 'ResourceAlreadyReservedError';
export interface ResourceAlreadyReservedErrorTypeLike extends TypeLike { readonly __typename?: typeof ResourceAlreadyReservedErrorTypename; }
export const TimeBasedActivityOverlapErrorTypename = 'TimeBasedActivityOverlapError';
export interface TimeBasedActivityOverlapErrorTypeLike extends TypeLike { readonly __typename?: typeof TimeBasedActivityOverlapErrorTypename; }
export const TimeBasedEffectiveFromInPastErrorTypename = 'TimeBasedEffectiveFromInPastError';
export interface TimeBasedEffectiveFromInPastErrorTypeLike extends TypeLike { readonly __typename?: typeof TimeBasedEffectiveFromInPastErrorTypename; }
export const TimeReportOverlapErrorTypename = 'TimeReportOverlapError';
export interface TimeReportOverlapErrorTypeLike extends TypeLike { readonly __typename?: typeof TimeReportOverlapErrorTypename; }
export const TimeReportRecordApprovalNotInPendingStateErrorTypename = 'TimeReportRecordApprovalNotInPendingStateError';
export interface TimeReportRecordApprovalNotInPendingStateErrorTypeLike extends TypeLike { readonly __typename?: typeof TimeReportRecordApprovalNotInPendingStateErrorTypename; }
export const UnauthorizedOperationErrorTypename = 'UnauthorizedOperationError';
export interface UnauthorizedOperationErrorTypeLike extends TypeLike { readonly __typename?: typeof UnauthorizedOperationErrorTypename; }
export const UnknownContentTypeErrorTypename = 'UnknownContentTypeError';
export interface UnknownContentTypeErrorTypeLike extends TypeLike { readonly __typename?: typeof UnknownContentTypeErrorTypename; }
export const UserFacingAuthzErrorTypename = 'UserFacingAuthzError';
export interface UserFacingAuthzErrorTypeLike extends TypeLike { readonly __typename?: typeof UserFacingAuthzErrorTypename; }
export const ValidationErrorTypename = 'ValidationError';
export interface ValidationErrorTypeLike extends TypeLike { readonly __typename?: typeof ValidationErrorTypename; }
export const AddClientContractDrawerTypename = 'AddClientContractDrawer';
export interface AddClientContractDrawerTypeLike extends TypeLike { readonly __typename?: typeof AddClientContractDrawerTypename; }
export const AddCompanyDrawerTypename = 'AddCompanyDrawer';
export interface AddCompanyDrawerTypeLike extends TypeLike { readonly __typename?: typeof AddCompanyDrawerTypename; }
export const AddInternalProjectDrawerTypename = 'AddInternalProjectDrawer';
export interface AddInternalProjectDrawerTypeLike extends TypeLike { readonly __typename?: typeof AddInternalProjectDrawerTypename; }
export const AddOfficeDrawerTypename = 'AddOfficeDrawer';
export interface AddOfficeDrawerTypeLike extends TypeLike { readonly __typename?: typeof AddOfficeDrawerTypename; }
export const AddPersonDrawerTypename = 'AddPersonDrawer';
export interface AddPersonDrawerTypeLike extends TypeLike { readonly __typename?: typeof AddPersonDrawerTypename; }
export const AddProgressionSchemeDrawerTypename = 'AddProgressionSchemeDrawer';
export interface AddProgressionSchemeDrawerTypeLike extends TypeLike { readonly __typename?: typeof AddProgressionSchemeDrawerTypename; }
export const AddProjectDrawerTypename = 'AddProjectDrawer';
export interface AddProjectDrawerTypeLike extends TypeLike { readonly __typename?: typeof AddProjectDrawerTypename; }
export const AddSpaceDrawerTypename = 'AddSpaceDrawer';
export interface AddSpaceDrawerTypeLike extends TypeLike { readonly __typename?: typeof AddSpaceDrawerTypename; }
export const AddThirdPersonDrawerTypename = 'AddThirdPersonDrawer';
export interface AddThirdPersonDrawerTypeLike extends TypeLike { readonly __typename?: typeof AddThirdPersonDrawerTypename; }
export const AdditionalCostsDrawerTypename = 'AdditionalCostsDrawer';
export interface AdditionalCostsDrawerTypeLike extends TypeLike { readonly __typename?: typeof AdditionalCostsDrawerTypename; }
export const AllBonusesDrawerTypename = 'AllBonusesDrawer';
export interface AllBonusesDrawerTypeLike extends TypeLike { readonly __typename?: typeof AllBonusesDrawerTypename; }
export const AnnualLeaveEntitlementDrawerTypename = 'AnnualLeaveEntitlementDrawer';
export interface AnnualLeaveEntitlementDrawerTypeLike extends TypeLike { readonly __typename?: typeof AnnualLeaveEntitlementDrawerTypename; }
export const AnnualLeavePreferencesDrawerTypename = 'AnnualLeavePreferencesDrawer';
export interface AnnualLeavePreferencesDrawerTypeLike extends TypeLike { readonly __typename?: typeof AnnualLeavePreferencesDrawerTypename; }
export const AnnualLeaveSummaryDrawerTypename = 'AnnualLeaveSummaryDrawer';
export interface AnnualLeaveSummaryDrawerTypeLike extends TypeLike { readonly __typename?: typeof AnnualLeaveSummaryDrawerTypename; }
export const AssignBenefitDrawerTypename = 'AssignBenefitDrawer';
export interface AssignBenefitDrawerTypeLike extends TypeLike { readonly __typename?: typeof AssignBenefitDrawerTypename; }
export const B2BContractDraftDrawerTypename = 'B2BContractDraftDrawer';
export interface B2BContractDraftDrawerTypeLike extends TypeLike { readonly __typename?: typeof B2BContractDraftDrawerTypename; }
export const B2BContractNoteDrawerTypename = 'B2BContractNoteDrawer';
export interface B2BContractNoteDrawerTypeLike extends TypeLike { readonly __typename?: typeof B2BContractNoteDrawerTypename; }
export const B2BSalaryDetailsDrawerTypename = 'B2BSalaryDetailsDrawer';
export interface B2BSalaryDetailsDrawerTypeLike extends TypeLike { readonly __typename?: typeof B2BSalaryDetailsDrawerTypename; }
export const BasicFinancialReportDrawerTypename = 'BasicFinancialReportDrawer';
export interface BasicFinancialReportDrawerTypeLike extends TypeLike { readonly __typename?: typeof BasicFinancialReportDrawerTypename; }
export const BenefitInvoicesReportDrawerTypename = 'BenefitInvoicesReportDrawer';
export interface BenefitInvoicesReportDrawerTypeLike extends TypeLike { readonly __typename?: typeof BenefitInvoicesReportDrawerTypename; }
export const BenefitNoteDrawerTypename = 'BenefitNoteDrawer';
export interface BenefitNoteDrawerTypeLike extends TypeLike { readonly __typename?: typeof BenefitNoteDrawerTypename; }
export const BonusDrawerTypename = 'BonusDrawer';
export interface BonusDrawerTypeLike extends TypeLike { readonly __typename?: typeof BonusDrawerTypename; }
export const BonusPreviewDrawerTypename = 'BonusPreviewDrawer';
export interface BonusPreviewDrawerTypeLike extends TypeLike { readonly __typename?: typeof BonusPreviewDrawerTypename; }
export const BookDeskOnBehalfDrawerTypename = 'BookDeskOnBehalfDrawer';
export interface BookDeskOnBehalfDrawerTypeLike extends TypeLike { readonly __typename?: typeof BookDeskOnBehalfDrawerTypename; }
export const BookParkingOnBehalfDrawerTypename = 'BookParkingOnBehalfDrawer';
export interface BookParkingOnBehalfDrawerTypeLike extends TypeLike { readonly __typename?: typeof BookParkingOnBehalfDrawerTypename; }
export const ClientInvoicingReportDrawerTypename = 'ClientInvoicingReportDrawer';
export interface ClientInvoicingReportDrawerTypeLike extends TypeLike { readonly __typename?: typeof ClientInvoicingReportDrawerTypename; }
export const CompanyBankAccountDrawerTypename = 'CompanyBankAccountDrawer';
export interface CompanyBankAccountDrawerTypeLike extends TypeLike { readonly __typename?: typeof CompanyBankAccountDrawerTypename; }
export const CompanyDetailsDrawerTypename = 'CompanyDetailsDrawer';
export interface CompanyDetailsDrawerTypeLike extends TypeLike { readonly __typename?: typeof CompanyDetailsDrawerTypename; }
export const ContractBankAccountDrawerTypename = 'ContractBankAccountDrawer';
export interface ContractBankAccountDrawerTypeLike extends TypeLike { readonly __typename?: typeof ContractBankAccountDrawerTypename; }
export const ContractBonusesSettingsDrawerTypename = 'ContractBonusesSettingsDrawer';
export interface ContractBonusesSettingsDrawerTypeLike extends TypeLike { readonly __typename?: typeof ContractBonusesSettingsDrawerTypename; }
export const ContractDetailsDrawerTypename = 'ContractDetailsDrawer';
export interface ContractDetailsDrawerTypeLike extends TypeLike { readonly __typename?: typeof ContractDetailsDrawerTypename; }
export const CopyrightsDrawerTypename = 'CopyrightsDrawer';
export interface CopyrightsDrawerTypeLike extends TypeLike { readonly __typename?: typeof CopyrightsDrawerTypename; }
export const CostAndRevenueItemDrawerTypename = 'CostAndRevenueItemDrawer';
export interface CostAndRevenueItemDrawerTypeLike extends TypeLike { readonly __typename?: typeof CostAndRevenueItemDrawerTypename; }
export const CostSummariesDrawerTypename = 'CostSummariesDrawer';
export interface CostSummariesDrawerTypeLike extends TypeLike { readonly __typename?: typeof CostSummariesDrawerTypename; }
export const CreateBenefitDrawerTypename = 'CreateBenefitDrawer';
export interface CreateBenefitDrawerTypeLike extends TypeLike { readonly __typename?: typeof CreateBenefitDrawerTypename; }
export const CreateVariantDrawerTypename = 'CreateVariantDrawer';
export interface CreateVariantDrawerTypeLike extends TypeLike { readonly __typename?: typeof CreateVariantDrawerTypename; }
export const DeskAssignmentDrawerTypename = 'DeskAssignmentDrawer';
export interface DeskAssignmentDrawerTypeLike extends TypeLike { readonly __typename?: typeof DeskAssignmentDrawerTypename; }
export const DeskDrawerTypename = 'DeskDrawer';
export interface DeskDrawerTypeLike extends TypeLike { readonly __typename?: typeof DeskDrawerTypename; }
export const DirectReportingDrawerTypename = 'DirectReportingDrawer';
export interface DirectReportingDrawerTypeLike extends TypeLike { readonly __typename?: typeof DirectReportingDrawerTypename; }
export const EditBenefitDrawerTypename = 'EditBenefitDrawer';
export interface EditBenefitDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditBenefitDrawerTypename; }
export const EditBenefitVariantDrawerTypename = 'EditBenefitVariantDrawer';
export interface EditBenefitVariantDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditBenefitVariantDrawerTypename; }
export const EditBenefitVariantPriceDrawerTypename = 'EditBenefitVariantPriceDrawer';
export interface EditBenefitVariantPriceDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditBenefitVariantPriceDrawerTypename; }
export const EditClientContractDrawerTypename = 'EditClientContractDrawer';
export interface EditClientContractDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditClientContractDrawerTypename; }
export const EditDeskRequestDrawerTypename = 'EditDeskRequestDrawer';
export interface EditDeskRequestDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditDeskRequestDrawerTypename; }
export const EditOfficeDrawerTypename = 'EditOfficeDrawer';
export interface EditOfficeDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditOfficeDrawerTypename; }
export const EditOfficeSettingsDrawerTypename = 'EditOfficeSettingsDrawer';
export interface EditOfficeSettingsDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditOfficeSettingsDrawerTypename; }
export const EditParkingRequestDrawerTypename = 'EditParkingRequestDrawer';
export interface EditParkingRequestDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditParkingRequestDrawerTypename; }
export const EditProfileAdditionalDataDrawerTypename = 'EditProfileAdditionalDataDrawer';
export interface EditProfileAdditionalDataDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditProfileAdditionalDataDrawerTypename; }
export const EditProfileAddressDrawerTypename = 'EditProfileAddressDrawer';
export interface EditProfileAddressDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditProfileAddressDrawerTypename; }
export const EditProfileBasicInfoDrawerTypename = 'EditProfileBasicInfoDrawer';
export interface EditProfileBasicInfoDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditProfileBasicInfoDrawerTypename; }
export const EditProjectCrossSellDrawerTypename = 'EditProjectCrossSellDrawer';
export interface EditProjectCrossSellDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditProjectCrossSellDrawerTypename; }
export const EditProjectDrawerTypename = 'EditProjectDrawer';
export interface EditProjectDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditProjectDrawerTypename; }
export const EditProjectTechStackAndCompetencesDrawerTypename = 'EditProjectTechStackAndCompetencesDrawer';
export interface EditProjectTechStackAndCompetencesDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditProjectTechStackAndCompetencesDrawerTypename; }
export const EditSkillsAndCertificatesDrawerTypename = 'EditSkillsAndCertificatesDrawer';
export interface EditSkillsAndCertificatesDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditSkillsAndCertificatesDrawerTypename; }
export const EditSocialMediaHandlesDrawerTypename = 'EditSocialMediaHandlesDrawer';
export interface EditSocialMediaHandlesDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditSocialMediaHandlesDrawerTypename; }
export const EditSpaceDrawerTypename = 'EditSpaceDrawer';
export interface EditSpaceDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditSpaceDrawerTypename; }
export const EmployeeDueDatesDrawerTypename = 'EmployeeDueDatesDrawer';
export interface EmployeeDueDatesDrawerTypeLike extends TypeLike { readonly __typename?: typeof EmployeeDueDatesDrawerTypename; }
export const EmploymentBankAccountDrawerTypename = 'EmploymentBankAccountDrawer';
export interface EmploymentBankAccountDrawerTypeLike extends TypeLike { readonly __typename?: typeof EmploymentBankAccountDrawerTypename; }
export const EmploymentContractDraftDrawerTypename = 'EmploymentContractDraftDrawer';
export interface EmploymentContractDraftDrawerTypeLike extends TypeLike { readonly __typename?: typeof EmploymentContractDraftDrawerTypename; }
export const EmploymentContractNoteDrawerTypename = 'EmploymentContractNoteDrawer';
export interface EmploymentContractNoteDrawerTypeLike extends TypeLike { readonly __typename?: typeof EmploymentContractNoteDrawerTypename; }
export const EmploymentSalaryDetailsDrawerTypename = 'EmploymentSalaryDetailsDrawer';
export interface EmploymentSalaryDetailsDrawerTypeLike extends TypeLike { readonly __typename?: typeof EmploymentSalaryDetailsDrawerTypename; }
export const InvoiceTransferLinksDrawerTypename = 'InvoiceTransferLinksDrawer';
export interface InvoiceTransferLinksDrawerTypeLike extends TypeLike { readonly __typename?: typeof InvoiceTransferLinksDrawerTypename; }
export const InvoicesDrawerTypename = 'InvoicesDrawer';
export interface InvoicesDrawerTypeLike extends TypeLike { readonly __typename?: typeof InvoicesDrawerTypename; }
export const ListColumnControllsDrawerTypename = 'ListColumnControllsDrawer';
export interface ListColumnControllsDrawerTypeLike extends TypeLike { readonly __typename?: typeof ListColumnControllsDrawerTypename; }
export const ManageKeyPeopleDrawerTypename = 'ManageKeyPeopleDrawer';
export interface ManageKeyPeopleDrawerTypeLike extends TypeLike { readonly __typename?: typeof ManageKeyPeopleDrawerTypename; }
export const ManageProjectTimelineDrawerTypename = 'ManageProjectTimelineDrawer';
export interface ManageProjectTimelineDrawerTypeLike extends TypeLike { readonly __typename?: typeof ManageProjectTimelineDrawerTypename; }
export const OtherEmployeeInformationDrawerTypename = 'OtherEmployeeInformationDrawer';
export interface OtherEmployeeInformationDrawerTypeLike extends TypeLike { readonly __typename?: typeof OtherEmployeeInformationDrawerTypename; }
export const ParkingSpotDrawerTypename = 'ParkingSpotDrawer';
export interface ParkingSpotDrawerTypeLike extends TypeLike { readonly __typename?: typeof ParkingSpotDrawerTypename; }
export const PaymentDetailsDraftDrawerTypename = 'PaymentDetailsDraftDrawer';
export interface PaymentDetailsDraftDrawerTypeLike extends TypeLike { readonly __typename?: typeof PaymentDetailsDraftDrawerTypename; }
export const PaymentDetailsDrawerTypename = 'PaymentDetailsDrawer';
export interface PaymentDetailsDrawerTypeLike extends TypeLike { readonly __typename?: typeof PaymentDetailsDrawerTypename; }
export const PendingCopyrightsDrawerTypename = 'PendingCopyrightsDrawer';
export interface PendingCopyrightsDrawerTypeLike extends TypeLike { readonly __typename?: typeof PendingCopyrightsDrawerTypename; }
export const PeopleListReportDrawerTypename = 'PeopleListReportDrawer';
export interface PeopleListReportDrawerTypeLike extends TypeLike { readonly __typename?: typeof PeopleListReportDrawerTypename; }
export const ProgressionSchemeLevelDrawerTypename = 'ProgressionSchemeLevelDrawer';
export interface ProgressionSchemeLevelDrawerTypeLike extends TypeLike { readonly __typename?: typeof ProgressionSchemeLevelDrawerTypename; }
export const ProjectBillablesReportDrawerTypename = 'ProjectBillablesReportDrawer';
export interface ProjectBillablesReportDrawerTypeLike extends TypeLike { readonly __typename?: typeof ProjectBillablesReportDrawerTypename; }
export const ProjectMembersDrawerTypename = 'ProjectMembersDrawer';
export interface ProjectMembersDrawerTypeLike extends TypeLike { readonly __typename?: typeof ProjectMembersDrawerTypename; }
export const RateCardDrawerTypename = 'RateCardDrawer';
export interface RateCardDrawerTypeLike extends TypeLike { readonly __typename?: typeof RateCardDrawerTypename; }
export const RateChangesReportDrawerTypename = 'RateChangesReportDrawer';
export interface RateChangesReportDrawerTypeLike extends TypeLike { readonly __typename?: typeof RateChangesReportDrawerTypename; }
export const ReservationLimitsDrawerTypename = 'ReservationLimitsDrawer';
export interface ReservationLimitsDrawerTypeLike extends TypeLike { readonly __typename?: typeof ReservationLimitsDrawerTypename; }
export const RoomDrawerTypename = 'RoomDrawer';
export interface RoomDrawerTypeLike extends TypeLike { readonly __typename?: typeof RoomDrawerTypename; }
export const SalariesSummaryReportDrawerTypename = 'SalariesSummaryReportDrawer';
export interface SalariesSummaryReportDrawerTypeLike extends TypeLike { readonly __typename?: typeof SalariesSummaryReportDrawerTypename; }
export const SetFutureEntitlementDrawerTypename = 'SetFutureEntitlementDrawer';
export interface SetFutureEntitlementDrawerTypeLike extends TypeLike { readonly __typename?: typeof SetFutureEntitlementDrawerTypename; }
export const SetRateAndProgressionDrawerTypename = 'SetRateAndProgressionDrawer';
export interface SetRateAndProgressionDrawerTypeLike extends TypeLike { readonly __typename?: typeof SetRateAndProgressionDrawerTypename; }
export const SkillsAndCertificatesReportDrawerTypename = 'SkillsAndCertificatesReportDrawer';
export interface SkillsAndCertificatesReportDrawerTypeLike extends TypeLike { readonly __typename?: typeof SkillsAndCertificatesReportDrawerTypename; }
export const SubcontractDraftDrawerTypename = 'SubcontractDraftDrawer';
export interface SubcontractDraftDrawerTypeLike extends TypeLike { readonly __typename?: typeof SubcontractDraftDrawerTypename; }
export const SubcontractNoteDrawerTypename = 'SubcontractNoteDrawer';
export interface SubcontractNoteDrawerTypeLike extends TypeLike { readonly __typename?: typeof SubcontractNoteDrawerTypename; }
export const TaxResidencyCertificatesDrawerTypename = 'TaxResidencyCertificatesDrawer';
export interface TaxResidencyCertificatesDrawerTypeLike extends TypeLike { readonly __typename?: typeof TaxResidencyCertificatesDrawerTypename; }
export const TimeReportsReportDrawerTypename = 'TimeReportsReportDrawer';
export interface TimeReportsReportDrawerTypeLike extends TypeLike { readonly __typename?: typeof TimeReportsReportDrawerTypename; }
export const TrainingPackageReportDrawerTypename = 'TrainingPackageReportDrawer';
export interface TrainingPackageReportDrawerTypeLike extends TypeLike { readonly __typename?: typeof TrainingPackageReportDrawerTypename; }
export const TransferDetailsDrawerTypename = 'TransferDetailsDrawer';
export interface TransferDetailsDrawerTypeLike extends TypeLike { readonly __typename?: typeof TransferDetailsDrawerTypename; }
export const TransferListExportDrawerTypename = 'TransferListExportDrawer';
export interface TransferListExportDrawerTypeLike extends TypeLike { readonly __typename?: typeof TransferListExportDrawerTypename; }
export const UopHolidaysReportDrawerTypename = 'UopHolidaysReportDrawer';
export interface UopHolidaysReportDrawerTypeLike extends TypeLike { readonly __typename?: typeof UopHolidaysReportDrawerTypename; }
export const UploadDocumentDrawerTypename = 'UploadDocumentDrawer';
export interface UploadDocumentDrawerTypeLike extends TypeLike { readonly __typename?: typeof UploadDocumentDrawerTypename; }
export const UserProjectsDrawerTypename = 'UserProjectsDrawer';
export interface UserProjectsDrawerTypeLike extends TypeLike { readonly __typename?: typeof UserProjectsDrawerTypename; }
export const YearlyCostSummaryDrawerTypename = 'YearlyCostSummaryDrawer';
export interface YearlyCostSummaryDrawerTypeLike extends TypeLike { readonly __typename?: typeof YearlyCostSummaryDrawerTypename; }
export const AdminTypename = 'Admin';
export interface AdminTypeLike extends TypeLike { readonly __typename?: typeof AdminTypename; }
export const AnnualLeaveSummaryTypename = 'AnnualLeaveSummary';
export interface AnnualLeaveSummaryTypeLike extends TypeLike { readonly __typename?: typeof AnnualLeaveSummaryTypename; }
export const ApplyRaiseResultTypename = 'ApplyRaiseResult';
export interface ApplyRaiseResultTypeLike extends TypeLike { readonly __typename?: typeof ApplyRaiseResultTypename; }
export const AppreciationBonusTypename = 'AppreciationBonus';
export interface AppreciationBonusTypeLike extends TypeLike { readonly __typename?: typeof AppreciationBonusTypename; }
export const BusinessTravelBonusTypename = 'BusinessTravelBonus';
export interface BusinessTravelBonusTypeLike extends TypeLike { readonly __typename?: typeof BusinessTravelBonusTypename; }
export const ClientReferralBonusTypename = 'ClientReferralBonus';
export interface ClientReferralBonusTypeLike extends TypeLike { readonly __typename?: typeof ClientReferralBonusTypename; }
export const ConferenceBonusTypename = 'ConferenceBonus';
export interface ConferenceBonusTypeLike extends TypeLike { readonly __typename?: typeof ConferenceBonusTypename; }
export const CostRechargeBonusTypename = 'CostRechargeBonus';
export interface CostRechargeBonusTypeLike extends TypeLike { readonly __typename?: typeof CostRechargeBonusTypename; }
export const EmployeeReferralBonusTypename = 'EmployeeReferralBonus';
export interface EmployeeReferralBonusTypeLike extends TypeLike { readonly __typename?: typeof EmployeeReferralBonusTypename; }
export const LanguageLearningBonusTypename = 'LanguageLearningBonus';
export interface LanguageLearningBonusTypeLike extends TypeLike { readonly __typename?: typeof LanguageLearningBonusTypename; }
export const OtherBonusTypename = 'OtherBonus';
export interface OtherBonusTypeLike extends TypeLike { readonly __typename?: typeof OtherBonusTypename; }
export const RemoteWorkEquipmentBonusTypename = 'RemoteWorkEquipmentBonus';
export interface RemoteWorkEquipmentBonusTypeLike extends TypeLike { readonly __typename?: typeof RemoteWorkEquipmentBonusTypename; }
export const SalesCommissionsBonusTypename = 'SalesCommissionsBonus';
export interface SalesCommissionsBonusTypeLike extends TypeLike { readonly __typename?: typeof SalesCommissionsBonusTypename; }
export const SeverancePayBonusTypename = 'SeverancePayBonus';
export interface SeverancePayBonusTypeLike extends TypeLike { readonly __typename?: typeof SeverancePayBonusTypename; }
export const ShareholderDividendBonusTypename = 'ShareholderDividendBonus';
export interface ShareholderDividendBonusTypeLike extends TypeLike { readonly __typename?: typeof ShareholderDividendBonusTypename; }
export const TrainingPackageBonusTypename = 'TrainingPackageBonus';
export interface TrainingPackageBonusTypeLike extends TypeLike { readonly __typename?: typeof TrainingPackageBonusTypename; }
export const TrainingPackageExternalDeductionValueTypename = 'TrainingPackageExternalDeductionValue';
export interface TrainingPackageExternalDeductionValueTypeLike extends TypeLike { readonly __typename?: typeof TrainingPackageExternalDeductionValueTypename; }
export const ApprovedTypename = 'Approved';
export interface ApprovedTypeLike extends TypeLike { readonly __typename?: typeof ApprovedTypename; }
export const NotRequiredTypename = 'NotRequired';
export interface NotRequiredTypeLike extends TypeLike { readonly __typename?: typeof NotRequiredTypename; }
export const PendingApprovalTypename = 'PendingApproval';
export interface PendingApprovalTypeLike extends TypeLike { readonly __typename?: typeof PendingApprovalTypename; }
export const AssignedVariantTypename = 'AssignedVariant';
export interface AssignedVariantTypeLike extends TypeLike { readonly __typename?: typeof AssignedVariantTypename; }
export const B2BContractTypename = 'B2BContract';
export interface B2BContractTypeLike extends TypeLike { readonly __typename?: typeof B2BContractTypename; }
export const EmploymentContractTypename = 'EmploymentContract';
export interface EmploymentContractTypeLike extends TypeLike { readonly __typename?: typeof EmploymentContractTypename; }
export const SubcontractTypename = 'Subcontract';
export interface SubcontractTypeLike extends TypeLike { readonly __typename?: typeof SubcontractTypename; }
export const B2BContractDraftTypename = 'B2BContractDraft';
export interface B2BContractDraftTypeLike extends TypeLike { readonly __typename?: typeof B2BContractDraftTypename; }
export const EmploymentContractDraftTypename = 'EmploymentContractDraft';
export interface EmploymentContractDraftTypeLike extends TypeLike { readonly __typename?: typeof EmploymentContractDraftTypename; }
export const SubcontractDraftTypename = 'SubcontractDraft';
export interface SubcontractDraftTypeLike extends TypeLike { readonly __typename?: typeof SubcontractDraftTypename; }
export const B2BContractSalaryDetailsTypename = 'B2BContractSalaryDetails';
export interface B2BContractSalaryDetailsTypeLike extends TypeLike { readonly __typename?: typeof B2BContractSalaryDetailsTypename; }
export const EmploymentContractSalaryDetailsTypename = 'EmploymentContractSalaryDetails';
export interface EmploymentContractSalaryDetailsTypeLike extends TypeLike { readonly __typename?: typeof EmploymentContractSalaryDetailsTypename; }
export const B2BTimeReportStatsTypename = 'B2BTimeReportStats';
export interface B2BTimeReportStatsTypeLike extends TypeLike { readonly __typename?: typeof B2BTimeReportStatsTypename; }
export const EmploymentTimeReportStatsTypename = 'EmploymentTimeReportStats';
export interface EmploymentTimeReportStatsTypeLike extends TypeLike { readonly __typename?: typeof EmploymentTimeReportStatsTypename; }
export const BankAccountResponseTypename = 'BankAccountResponse';
export interface BankAccountResponseTypeLike extends TypeLike { readonly __typename?: typeof BankAccountResponseTypename; }
export const AccessGrantedBankAccountTypename = 'AccessGrantedBankAccount';
export interface AccessGrantedBankAccountTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedBankAccountTypename; }
export const UnauthorizedTypename = 'Unauthorized';
export interface UnauthorizedTypeLike extends TypeLike { readonly __typename?: typeof UnauthorizedTypename; }
export const BankAccountsResponseTypename = 'BankAccountsResponse';
export interface BankAccountsResponseTypeLike extends TypeLike { readonly __typename?: typeof BankAccountsResponseTypename; }
export const BankIncomeTransferTypename = 'BankIncomeTransfer';
export interface BankIncomeTransferTypeLike extends TypeLike { readonly __typename?: typeof BankIncomeTransferTypename; }
export const BankOutcomeTransferTypename = 'BankOutcomeTransfer';
export interface BankOutcomeTransferTypeLike extends TypeLike { readonly __typename?: typeof BankOutcomeTransferTypename; }
export const BankTransferResponseTypename = 'BankTransferResponse';
export interface BankTransferResponseTypeLike extends TypeLike { readonly __typename?: typeof BankTransferResponseTypename; }
export const BaseInfoTypename = 'BaseInfo';
export interface BaseInfoTypeLike extends TypeLike { readonly __typename?: typeof BaseInfoTypename; }
export const BenefitTypename = 'Benefit';
export interface BenefitTypeLike extends TypeLike { readonly __typename?: typeof BenefitTypename; }
export const SubBenefitTypename = 'SubBenefit';
export interface SubBenefitTypeLike extends TypeLike { readonly __typename?: typeof SubBenefitTypename; }
export const BenefitAdditionalAdultsTypename = 'BenefitAdditionalAdults';
export interface BenefitAdditionalAdultsTypeLike extends TypeLike { readonly __typename?: typeof BenefitAdditionalAdultsTypename; }
export const BenefitAdditionalFamilyTypename = 'BenefitAdditionalFamily';
export interface BenefitAdditionalFamilyTypeLike extends TypeLike { readonly __typename?: typeof BenefitAdditionalFamilyTypename; }
export const BenefitAdditionalKidsTypename = 'BenefitAdditionalKids';
export interface BenefitAdditionalKidsTypeLike extends TypeLike { readonly __typename?: typeof BenefitAdditionalKidsTypename; }
export const BenefitCommonResponseTypename = 'BenefitCommonResponse';
export interface BenefitCommonResponseTypeLike extends TypeLike { readonly __typename?: typeof BenefitCommonResponseTypename; }
export const BenefitVariantTypename = 'BenefitVariant';
export interface BenefitVariantTypeLike extends TypeLike { readonly __typename?: typeof BenefitVariantTypename; }
export const BfrExportCompletedTypename = 'BfrExportCompleted';
export interface BfrExportCompletedTypeLike extends TypeLike { readonly __typename?: typeof BfrExportCompletedTypename; }
export const BfrExportFailedTypename = 'BfrExportFailed';
export interface BfrExportFailedTypeLike extends TypeLike { readonly __typename?: typeof BfrExportFailedTypename; }
export const BfrExportIdleTypename = 'BfrExportIdle';
export interface BfrExportIdleTypeLike extends TypeLike { readonly __typename?: typeof BfrExportIdleTypename; }
export const BfrExportInterruptedTypename = 'BfrExportInterrupted';
export interface BfrExportInterruptedTypeLike extends TypeLike { readonly __typename?: typeof BfrExportInterruptedTypename; }
export const BfrExportRunningTypename = 'BfrExportRunning';
export interface BfrExportRunningTypeLike extends TypeLike { readonly __typename?: typeof BfrExportRunningTypename; }
export const BfrExportStatusResponseTypename = 'BfrExportStatusResponse';
export interface BfrExportStatusResponseTypeLike extends TypeLike { readonly __typename?: typeof BfrExportStatusResponseTypename; }
export const BonusResponseTypename = 'BonusResponse';
export interface BonusResponseTypeLike extends TypeLike { readonly __typename?: typeof BonusResponseTypename; }
export const AccessGrantedBonusesTypename = 'AccessGrantedBonuses';
export interface AccessGrantedBonusesTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedBonusesTypename; }
export const BooleanResponseTypename = 'BooleanResponse';
export interface BooleanResponseTypeLike extends TypeLike { readonly __typename?: typeof BooleanResponseTypename; }
export const AccessGrantedBooleanTypename = 'AccessGrantedBoolean';
export interface AccessGrantedBooleanTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedBooleanTypename; }
export const CertificateTypename = 'Certificate';
export interface CertificateTypeLike extends TypeLike { readonly __typename?: typeof CertificateTypename; }
export const ClientContractTypename = 'ClientContract';
export interface ClientContractTypeLike extends TypeLike { readonly __typename?: typeof ClientContractTypename; }
export const AccessGrantedClientContractTypename = 'AccessGrantedClientContract';
export interface AccessGrantedClientContractTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedClientContractTypename; }
export const ClientPositionTypename = 'ClientPosition';
export interface ClientPositionTypeLike extends TypeLike { readonly __typename?: typeof ClientPositionTypename; }
export const AccessGrantedClientPositionTypename = 'AccessGrantedClientPosition';
export interface AccessGrantedClientPositionTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedClientPositionTypename; }
export const ClosedEndLocalDateRangeTypename = 'ClosedEndLocalDateRange';
export interface ClosedEndLocalDateRangeTypeLike extends TypeLike { readonly __typename?: typeof ClosedEndLocalDateRangeTypename; }
export const CompanyInfoTypename = 'CompanyInfo';
export interface CompanyInfoTypeLike extends TypeLike { readonly __typename?: typeof CompanyInfoTypename; }
export const CompanyTypename = 'Company';
export interface CompanyTypeLike extends TypeLike { readonly __typename?: typeof CompanyTypename; }
export const AccessGrantedCompanyTypename = 'AccessGrantedCompany';
export interface AccessGrantedCompanyTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedCompanyTypename; }
export const ContractDraftResponseTypename = 'ContractDraftResponse';
export interface ContractDraftResponseTypeLike extends TypeLike { readonly __typename?: typeof ContractDraftResponseTypename; }
export const ContractResponseTypename = 'ContractResponse';
export interface ContractResponseTypeLike extends TypeLike { readonly __typename?: typeof ContractResponseTypename; }
export const ContractSalaryDetailsAdditionalDataTypename = 'ContractSalaryDetailsAdditionalData';
export interface ContractSalaryDetailsAdditionalDataTypeLike extends TypeLike { readonly __typename?: typeof ContractSalaryDetailsAdditionalDataTypename; }
export const ContractSalaryDetailsResponseTypename = 'ContractSalaryDetailsResponse';
export interface ContractSalaryDetailsResponseTypeLike extends TypeLike { readonly __typename?: typeof ContractSalaryDetailsResponseTypename; }
export const CostInvoiceTypename = 'CostInvoice';
export interface CostInvoiceTypeLike extends TypeLike { readonly __typename?: typeof CostInvoiceTypename; }
export const ByAdminTypename = 'ByAdmin';
export interface ByAdminTypeLike extends TypeLike { readonly __typename?: typeof ByAdminTypename; }
export const ByUserTypename = 'ByUser';
export interface ByUserTypeLike extends TypeLike { readonly __typename?: typeof ByUserTypename; }
export const DaysBalanceTypename = 'DaysBalance';
export interface DaysBalanceTypeLike extends TypeLike { readonly __typename?: typeof DaysBalanceTypename; }
export const DeskAssignmentTypename = 'DeskAssignment';
export interface DeskAssignmentTypeLike extends TypeLike { readonly __typename?: typeof DeskAssignmentTypename; }
export const DeskTypename = 'Desk';
export interface DeskTypeLike extends TypeLike { readonly __typename?: typeof DeskTypename; }
export const DownloadableFileUrlTypename = 'DownloadableFileUrl';
export interface DownloadableFileUrlTypeLike extends TypeLike { readonly __typename?: typeof DownloadableFileUrlTypename; }
export const DraftPreviewResponseTypename = 'DraftPreviewResponse';
export interface DraftPreviewResponseTypeLike extends TypeLike { readonly __typename?: typeof DraftPreviewResponseTypename; }
export const ExternalBeneficiaryTypename = 'ExternalBeneficiary';
export interface ExternalBeneficiaryTypeLike extends TypeLike { readonly __typename?: typeof ExternalBeneficiaryTypename; }
export const FspResponseAssignedVariantTypename = 'FspResponseAssignedVariant';
export interface FspResponseAssignedVariantTypeLike extends TypeLike { readonly __typename?: typeof FspResponseAssignedVariantTypename; }
export const FspResponseB2BContractSalaryDetailsTypename = 'FspResponseB2BContractSalaryDetails';
export interface FspResponseB2BContractSalaryDetailsTypeLike extends TypeLike { readonly __typename?: typeof FspResponseB2BContractSalaryDetailsTypename; }
export const FspResponseBankTransferTypename = 'FspResponseBankTransfer';
export interface FspResponseBankTransferTypeLike extends TypeLike { readonly __typename?: typeof FspResponseBankTransferTypename; }
export const FspResponseClientContractTypename = 'FspResponseClientContract';
export interface FspResponseClientContractTypeLike extends TypeLike { readonly __typename?: typeof FspResponseClientContractTypename; }
export const FspResponseCompanyTypename = 'FspResponseCompany';
export interface FspResponseCompanyTypeLike extends TypeLike { readonly __typename?: typeof FspResponseCompanyTypename; }
export const FspResponseContractDraftTypename = 'FspResponseContractDraft';
export interface FspResponseContractDraftTypeLike extends TypeLike { readonly __typename?: typeof FspResponseContractDraftTypename; }
export const FspResponseContractTypename = 'FspResponseContract';
export interface FspResponseContractTypeLike extends TypeLike { readonly __typename?: typeof FspResponseContractTypename; }
export const FspResponseEmploymentContractSalaryDetailsTypename = 'FspResponseEmploymentContractSalaryDetails';
export interface FspResponseEmploymentContractSalaryDetailsTypeLike extends TypeLike { readonly __typename?: typeof FspResponseEmploymentContractSalaryDetailsTypename; }
export const FspResponseOfficeReservationTypename = 'FspResponseOfficeReservation';
export interface FspResponseOfficeReservationTypeLike extends TypeLike { readonly __typename?: typeof FspResponseOfficeReservationTypename; }
export const FspResponseProjectTypename = 'FspResponseProject';
export interface FspResponseProjectTypeLike extends TypeLike { readonly __typename?: typeof FspResponseProjectTypename; }
export const FspResponseRevenueAdministrationOfficeTypename = 'FspResponseRevenueAdministrationOffice';
export interface FspResponseRevenueAdministrationOfficeTypeLike extends TypeLike { readonly __typename?: typeof FspResponseRevenueAdministrationOfficeTypename; }
export const FspResponseSpaceTypename = 'FspResponseSpace';
export interface FspResponseSpaceTypeLike extends TypeLike { readonly __typename?: typeof FspResponseSpaceTypename; }
export const FspResponseUserTypename = 'FspResponseUser';
export interface FspResponseUserTypeLike extends TypeLike { readonly __typename?: typeof FspResponseUserTypename; }
export const GmailConnectionTypename = 'GmailConnection';
export interface GmailConnectionTypeLike extends TypeLike { readonly __typename?: typeof GmailConnectionTypename; }
export const GoogleSpreadsheetUrlTypename = 'GoogleSpreadsheetUrl';
export interface GoogleSpreadsheetUrlTypeLike extends TypeLike { readonly __typename?: typeof GoogleSpreadsheetUrlTypename; }
export const IbanTypename = 'Iban';
export interface IbanTypeLike extends TypeLike { readonly __typename?: typeof IbanTypename; }
export const OtherBankAccountNumberTypename = 'OtherBankAccountNumber';
export interface OtherBankAccountNumberTypeLike extends TypeLike { readonly __typename?: typeof OtherBankAccountNumberTypename; }
export const DailyIncomeRowTypename = 'DailyIncomeRow';
export interface DailyIncomeRowTypeLike extends TypeLike { readonly __typename?: typeof DailyIncomeRowTypename; }
export const HourlyIncomeRowTypename = 'HourlyIncomeRow';
export interface HourlyIncomeRowTypeLike extends TypeLike { readonly __typename?: typeof HourlyIncomeRowTypename; }
export const MonthlyIncomeRowTypename = 'MonthlyIncomeRow';
export interface MonthlyIncomeRowTypeLike extends TypeLike { readonly __typename?: typeof MonthlyIncomeRowTypename; }
export const AccountingDataMissingTypename = 'AccountingDataMissing';
export interface AccountingDataMissingTypeLike extends TypeLike { readonly __typename?: typeof AccountingDataMissingTypename; }
export const BonusRequiresApprovalTypename = 'BonusRequiresApproval';
export interface BonusRequiresApprovalTypeLike extends TypeLike { readonly __typename?: typeof BonusRequiresApprovalTypename; }
export const InvoiceFileMissingTypename = 'InvoiceFileMissing';
export interface InvoiceFileMissingTypeLike extends TypeLike { readonly __typename?: typeof InvoiceFileMissingTypename; }
export const InvoiceMissingTypename = 'InvoiceMissing';
export interface InvoiceMissingTypeLike extends TypeLike { readonly __typename?: typeof InvoiceMissingTypename; }
export const InvoiceUncheckedTypename = 'InvoiceUnchecked';
export interface InvoiceUncheckedTypeLike extends TypeLike { readonly __typename?: typeof InvoiceUncheckedTypename; }
export const NoBankAccountTypename = 'NoBankAccount';
export interface NoBankAccountTypeLike extends TypeLike { readonly __typename?: typeof NoBankAccountTypename; }
export const TimeReportIncompleteTypename = 'TimeReportIncomplete';
export interface TimeReportIncompleteTypeLike extends TypeLike { readonly __typename?: typeof TimeReportIncompleteTypename; }
export const TimeReportRequiresApprovalTypename = 'TimeReportRequiresApproval';
export interface TimeReportRequiresApprovalTypeLike extends TypeLike { readonly __typename?: typeof TimeReportRequiresApprovalTypename; }
export const WhiteListInvalidTypename = 'WhiteListInvalid';
export interface WhiteListInvalidTypeLike extends TypeLike { readonly __typename?: typeof WhiteListInvalidTypename; }
export const IntResponseTypename = 'IntResponse';
export interface IntResponseTypeLike extends TypeLike { readonly __typename?: typeof IntResponseTypename; }
export const InvoiceDetailsTypename = 'InvoiceDetails';
export interface InvoiceDetailsTypeLike extends TypeLike { readonly __typename?: typeof InvoiceDetailsTypename; }
export const ListOfAbsenceRecordResponseTypename = 'ListOfAbsenceRecordResponse';
export interface ListOfAbsenceRecordResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfAbsenceRecordResponseTypename; }
export const ListOfAdminResponseTypename = 'ListOfAdminResponse';
export interface ListOfAdminResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfAdminResponseTypename; }
export const ListOfApiTokenResponseTypename = 'ListOfApiTokenResponse';
export interface ListOfApiTokenResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfApiTokenResponseTypename; }
export const ListOfAssignedProjectResponseTypename = 'ListOfAssignedProjectResponse';
export interface ListOfAssignedProjectResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfAssignedProjectResponseTypename; }
export const ListOfAssignedVariantResponseTypename = 'ListOfAssignedVariantResponse';
export interface ListOfAssignedVariantResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfAssignedVariantResponseTypename; }
export const AccessGrantedListOfAssignedVariantTypename = 'AccessGrantedListOfAssignedVariant';
export interface AccessGrantedListOfAssignedVariantTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfAssignedVariantTypename; }
export const ListOfBankTransferResponseTypename = 'ListOfBankTransferResponse';
export interface ListOfBankTransferResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfBankTransferResponseTypename; }
export const ListOfBenefitGroupResponseTypename = 'ListOfBenefitGroupResponse';
export interface ListOfBenefitGroupResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfBenefitGroupResponseTypename; }
export const ListOfBfrFileUrlResponseTypename = 'ListOfBfrFileUrlResponse';
export interface ListOfBfrFileUrlResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfBfrFileUrlResponseTypename; }
export const AccessGrantedListOfCertificateTypename = 'AccessGrantedListOfCertificate';
export interface AccessGrantedListOfCertificateTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfCertificateTypename; }
export const ListOfClientContractResponseTypename = 'ListOfClientContractResponse';
export interface ListOfClientContractResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfClientContractResponseTypename; }
export const AccessGrantedListOfClientContractTypename = 'AccessGrantedListOfClientContract';
export interface AccessGrantedListOfClientContractTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfClientContractTypename; }
export const AccessGrantedListOfClientPositionTypename = 'AccessGrantedListOfClientPosition';
export interface AccessGrantedListOfClientPositionTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfClientPositionTypename; }
export const ListOfContractDocumentTemplateDescriptionResponseTypename = 'ListOfContractDocumentTemplateDescriptionResponse';
export interface ListOfContractDocumentTemplateDescriptionResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfContractDocumentTemplateDescriptionResponseTypename; }
export const ListOfContractDraftResponseTypename = 'ListOfContractDraftResponse';
export interface ListOfContractDraftResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfContractDraftResponseTypename; }
export const ListOfContractSalaryDetailsResponseTypename = 'ListOfContractSalaryDetailsResponse';
export interface ListOfContractSalaryDetailsResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfContractSalaryDetailsResponseTypename; }
export const AccessGrantedListOfContractTypename = 'AccessGrantedListOfContract';
export interface AccessGrantedListOfContractTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfContractTypename; }
export const AccessGrantedListOfCostAndRevenueItemTypename = 'AccessGrantedListOfCostAndRevenueItem';
export interface AccessGrantedListOfCostAndRevenueItemTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfCostAndRevenueItemTypename; }
export const ListOfCostInvoiceResponseTypename = 'ListOfCostInvoiceResponse';
export interface ListOfCostInvoiceResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfCostInvoiceResponseTypename; }
export const ListOfDeskAssignmentResponseTypename = 'ListOfDeskAssignmentResponse';
export interface ListOfDeskAssignmentResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfDeskAssignmentResponseTypename; }
export const AccessGrantedListOfExternalBeneficiaryTypename = 'AccessGrantedListOfExternalBeneficiary';
export interface AccessGrantedListOfExternalBeneficiaryTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfExternalBeneficiaryTypename; }
export const ListOfFakturowniaProfileResponseTypename = 'ListOfFakturowniaProfileResponse';
export interface ListOfFakturowniaProfileResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfFakturowniaProfileResponseTypename; }
export const ListOfHolidaySummaryFileUrlResponseTypename = 'ListOfHolidaySummaryFileUrlResponse';
export interface ListOfHolidaySummaryFileUrlResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfHolidaySummaryFileUrlResponseTypename; }
export const AccessGrantedListOfIncomeDetailsTypename = 'AccessGrantedListOfIncomeDetails';
export interface AccessGrantedListOfIncomeDetailsTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfIncomeDetailsTypename; }
export const ListOfKvWorkTagIdMinutesResponseTypename = 'ListOfKvWorkTagIdMinutesResponse';
export interface ListOfKvWorkTagIdMinutesResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfKvWorkTagIdMinutesResponseTypename; }
export const ListOfOfficeResponseTypename = 'ListOfOfficeResponse';
export interface ListOfOfficeResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfOfficeResponseTypename; }
export const ListOfOnCallRecordResponseTypename = 'ListOfOnCallRecordResponse';
export interface ListOfOnCallRecordResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfOnCallRecordResponseTypename; }
export const ListOfProgressionSchemeResponseTypename = 'ListOfProgressionSchemeResponse';
export interface ListOfProgressionSchemeResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfProgressionSchemeResponseTypename; }
export const ListOfProjectAssignmentResponseTypename = 'ListOfProjectAssignmentResponse';
export interface ListOfProjectAssignmentResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfProjectAssignmentResponseTypename; }
export const AccessGrantedListOfProjectAssignmentTypename = 'AccessGrantedListOfProjectAssignment';
export interface AccessGrantedListOfProjectAssignmentTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfProjectAssignmentTypename; }
export const ListOfProjectIdResponseTypename = 'ListOfProjectIdResponse';
export interface ListOfProjectIdResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfProjectIdResponseTypename; }
export const ListOfProjectUtilizationResponseTypename = 'ListOfProjectUtilizationResponse';
export interface ListOfProjectUtilizationResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfProjectUtilizationResponseTypename; }
export const ListOfRaiseProposalResponseTypename = 'ListOfRaiseProposalResponse';
export interface ListOfRaiseProposalResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfRaiseProposalResponseTypename; }
export const ListOfReportingPeriodResponseTypename = 'ListOfReportingPeriodResponse';
export interface ListOfReportingPeriodResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfReportingPeriodResponseTypename; }
export const ListOfReservationRequestResponseTypename = 'ListOfReservationRequestResponse';
export interface ListOfReservationRequestResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfReservationRequestResponseTypename; }
export const ListOfSalesInvoiceResponseTypename = 'ListOfSalesInvoiceResponse';
export interface ListOfSalesInvoiceResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfSalesInvoiceResponseTypename; }
export const AccessGrantedListOfSocialMediaHandleTypename = 'AccessGrantedListOfSocialMediaHandle';
export interface AccessGrantedListOfSocialMediaHandleTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfSocialMediaHandleTypename; }
export const ListOfStringResponseTypename = 'ListOfStringResponse';
export interface ListOfStringResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfStringResponseTypename; }
export const AccessGrantedListOfStringTypename = 'AccessGrantedListOfString';
export interface AccessGrantedListOfStringTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfStringTypename; }
export const AccessGrantedListOfTaxResidencyCertificateTypename = 'AccessGrantedListOfTaxResidencyCertificate';
export interface AccessGrantedListOfTaxResidencyCertificateTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfTaxResidencyCertificateTypename; }
export const ListOfTimeReportValidationResponseTypename = 'ListOfTimeReportValidationResponse';
export interface ListOfTimeReportValidationResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfTimeReportValidationResponseTypename; }
export const ListOfTransfersSummariesResponseTypename = 'ListOfTransfersSummariesResponse';
export interface ListOfTransfersSummariesResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfTransfersSummariesResponseTypename; }
export const ListOfWorkRecordResponseTypename = 'ListOfWorkRecordResponse';
export interface ListOfWorkRecordResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfWorkRecordResponseTypename; }
export const ListOfWorkTransferProtocolResponseTypename = 'ListOfWorkTransferProtocolResponse';
export interface ListOfWorkTransferProtocolResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfWorkTransferProtocolResponseTypename; }
export const AccessGrantedListOfWorkTransferProtocolTypename = 'AccessGrantedListOfWorkTransferProtocol';
export interface AccessGrantedListOfWorkTransferProtocolTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedListOfWorkTransferProtocolTypename; }
export const AccessGrantedLocalDateTypename = 'AccessGrantedLocalDate';
export interface AccessGrantedLocalDateTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedLocalDateTypename; }
export const OfficeAvailabilityTypename = 'OfficeAvailability';
export interface OfficeAvailabilityTypeLike extends TypeLike { readonly __typename?: typeof OfficeAvailabilityTypename; }
export const OfficeCatalogueTypename = 'OfficeCatalogue';
export interface OfficeCatalogueTypeLike extends TypeLike { readonly __typename?: typeof OfficeCatalogueTypename; }
export const OfficeTypename = 'Office';
export interface OfficeTypeLike extends TypeLike { readonly __typename?: typeof OfficeTypename; }
export const OfficeReservationSettingsTypename = 'OfficeReservationSettings';
export interface OfficeReservationSettingsTypeLike extends TypeLike { readonly __typename?: typeof OfficeReservationSettingsTypename; }
export const OfficeSettingsTypename = 'OfficeSettings';
export interface OfficeSettingsTypeLike extends TypeLike { readonly __typename?: typeof OfficeSettingsTypename; }
export const OnCallMultipliersTypename = 'OnCallMultipliers';
export interface OnCallMultipliersTypeLike extends TypeLike { readonly __typename?: typeof OnCallMultipliersTypename; }
export const OnCallRecordTypename = 'OnCallRecord';
export interface OnCallRecordTypeLike extends TypeLike { readonly __typename?: typeof OnCallRecordTypename; }
export const AccessGrantedOptionalAddressTypename = 'AccessGrantedOptionalAddress';
export interface AccessGrantedOptionalAddressTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalAddressTypename; }
export const AccessGrantedOptionalAnnualLeaveEntitlementTypename = 'AccessGrantedOptionalAnnualLeaveEntitlement';
export interface AccessGrantedOptionalAnnualLeaveEntitlementTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalAnnualLeaveEntitlementTypename; }
export const AccessGrantedOptionalBankAccountTypename = 'AccessGrantedOptionalBankAccount';
export interface AccessGrantedOptionalBankAccountTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalBankAccountTypename; }
export const AccessGrantedOptionalClientPositionTypename = 'AccessGrantedOptionalClientPosition';
export interface AccessGrantedOptionalClientPositionTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalClientPositionTypename; }
export const AccessGrantedOptionalContractDraftTypename = 'AccessGrantedOptionalContractDraft';
export interface AccessGrantedOptionalContractDraftTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalContractDraftTypename; }
export const AccessGrantedOptionalCountryCodeTypename = 'AccessGrantedOptionalCountryCode';
export interface AccessGrantedOptionalCountryCodeTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalCountryCodeTypename; }
export const AccessGrantedOptionalCrossSellTypename = 'AccessGrantedOptionalCrossSell';
export interface AccessGrantedOptionalCrossSellTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalCrossSellTypename; }
export const AccessGrantedOptionalDownloadableExternallyHostedFileUrlTypename = 'AccessGrantedOptionalDownloadableExternallyHostedFileUrl';
export interface AccessGrantedOptionalDownloadableExternallyHostedFileUrlTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalDownloadableExternallyHostedFileUrlTypename; }
export const AccessGrantedOptionalEmailAddressTypename = 'AccessGrantedOptionalEmailAddress';
export interface AccessGrantedOptionalEmailAddressTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalEmailAddressTypename; }
export const AccessGrantedOptionalIdTypeTypename = 'AccessGrantedOptionalIdType';
export interface AccessGrantedOptionalIdTypeTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalIdTypeTypename; }
export const AccessGrantedOptionalLocalDateTypename = 'AccessGrantedOptionalLocalDate';
export interface AccessGrantedOptionalLocalDateTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalLocalDateTypename; }
export const AccessGrantedOptionalOffsetDateTimeTypename = 'AccessGrantedOptionalOffsetDateTime';
export interface AccessGrantedOptionalOffsetDateTimeTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalOffsetDateTimeTypename; }
export const AccessGrantedOptionalPeselTypename = 'AccessGrantedOptionalPesel';
export interface AccessGrantedOptionalPeselTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalPeselTypename; }
export const AccessGrantedOptionalPhoneNumberTypename = 'AccessGrantedOptionalPhoneNumber';
export interface AccessGrantedOptionalPhoneNumberTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalPhoneNumberTypename; }
export const AccessGrantedOptionalRevenueAdministrationOfficeTypename = 'AccessGrantedOptionalRevenueAdministrationOffice';
export interface AccessGrantedOptionalRevenueAdministrationOfficeTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalRevenueAdministrationOfficeTypename; }
export const AccessGrantedOptionalStringTypename = 'AccessGrantedOptionalString';
export interface AccessGrantedOptionalStringTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalStringTypename; }
export const AccessGrantedOptionalUriTypename = 'AccessGrantedOptionalUri';
export interface AccessGrantedOptionalUriTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedOptionalUriTypename; }
export const ParkingSpotTypename = 'ParkingSpot';
export interface ParkingSpotTypeLike extends TypeLike { readonly __typename?: typeof ParkingSpotTypename; }
export const PaymentConnectionTypename = 'PaymentConnection';
export interface PaymentConnectionTypeLike extends TypeLike { readonly __typename?: typeof PaymentConnectionTypename; }
export const PayrollTransfersOrderViewTypename = 'PayrollTransfersOrderView';
export interface PayrollTransfersOrderViewTypeLike extends TypeLike { readonly __typename?: typeof PayrollTransfersOrderViewTypename; }
export const AccessGrantedPersonalDataProcessingAuthorizationTypename = 'AccessGrantedPersonalDataProcessingAuthorization';
export interface AccessGrantedPersonalDataProcessingAuthorizationTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedPersonalDataProcessingAuthorizationTypename; }
export const PolishVatTypename = 'PolishVat';
export interface PolishVatTypeLike extends TypeLike { readonly __typename?: typeof PolishVatTypename; }
export const ProgressionSchemeTypename = 'ProgressionScheme';
export interface ProgressionSchemeTypeLike extends TypeLike { readonly __typename?: typeof ProgressionSchemeTypename; }
export const ProjectAssignmentTypename = 'ProjectAssignment';
export interface ProjectAssignmentTypeLike extends TypeLike { readonly __typename?: typeof ProjectAssignmentTypename; }
export const ProjectTypename = 'Project';
export interface ProjectTypeLike extends TypeLike { readonly __typename?: typeof ProjectTypename; }
export const ProjectRoleAssignmentTypename = 'ProjectRoleAssignment';
export interface ProjectRoleAssignmentTypeLike extends TypeLike { readonly __typename?: typeof ProjectRoleAssignmentTypename; }
export const RequiredActionsTypename = 'RequiredActions';
export interface RequiredActionsTypeLike extends TypeLike { readonly __typename?: typeof RequiredActionsTypename; }
export const ReservationRequestTypename = 'ReservationRequest';
export interface ReservationRequestTypeLike extends TypeLike { readonly __typename?: typeof ReservationRequestTypename; }
export const RoomTypename = 'Room';
export interface RoomTypeLike extends TypeLike { readonly __typename?: typeof RoomTypename; }
export const IncompleteDataTypename = 'IncompleteData';
export interface IncompleteDataTypeLike extends TypeLike { readonly __typename?: typeof IncompleteDataTypename; }
export const PaymentDisbursedTypename = 'PaymentDisbursed';
export interface PaymentDisbursedTypeLike extends TypeLike { readonly __typename?: typeof PaymentDisbursedTypename; }
export const ReadyTypename = 'Ready';
export interface ReadyTypeLike extends TypeLike { readonly __typename?: typeof ReadyTypename; }
export const SalesInvoiceDetailsTypename = 'SalesInvoiceDetails';
export interface SalesInvoiceDetailsTypeLike extends TypeLike { readonly __typename?: typeof SalesInvoiceDetailsTypename; }
export const SalesInvoiceTypename = 'SalesInvoice';
export interface SalesInvoiceTypeLike extends TypeLike { readonly __typename?: typeof SalesInvoiceTypename; }
export const SetRateAndProgressionResultTypename = 'SetRateAndProgressionResult';
export interface SetRateAndProgressionResultTypeLike extends TypeLike { readonly __typename?: typeof SetRateAndProgressionResultTypename; }
export const SpaceTypename = 'Space';
export interface SpaceTypeLike extends TypeLike { readonly __typename?: typeof SpaceTypename; }
export const AccessGrantedStringTypename = 'AccessGrantedString';
export interface AccessGrantedStringTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedStringTypename; }
export const TaxResidencyCertificateTypename = 'TaxResidencyCertificate';
export interface TaxResidencyCertificateTypeLike extends TypeLike { readonly __typename?: typeof TaxResidencyCertificateTypename; }
export const AccessGrantedTimeBasedBooleanTypename = 'AccessGrantedTimeBasedBoolean';
export interface AccessGrantedTimeBasedBooleanTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedBooleanTypename; }
export const AccessGrantedTimeBasedCurrencyTypename = 'AccessGrantedTimeBasedCurrency';
export interface AccessGrantedTimeBasedCurrencyTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedCurrencyTypename; }
export const TimeBasedHighlightTypename = 'TimeBasedHighlight';
export interface TimeBasedHighlightTypeLike extends TypeLike { readonly __typename?: typeof TimeBasedHighlightTypename; }
export const AccessGrantedTimeBasedOptClearableBasisPointTypename = 'AccessGrantedTimeBasedOptClearableBasisPoint';
export interface AccessGrantedTimeBasedOptClearableBasisPointTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedOptClearableBasisPointTypename; }
export const AccessGrantedTimeBasedOptClearableDaysTypename = 'AccessGrantedTimeBasedOptClearableDays';
export interface AccessGrantedTimeBasedOptClearableDaysTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedOptClearableDaysTypename; }
export const AccessGrantedTimeBasedOptClearableDeductibleCostsTypeTypename = 'AccessGrantedTimeBasedOptClearableDeductibleCostsType';
export interface AccessGrantedTimeBasedOptClearableDeductibleCostsTypeTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedOptClearableDeductibleCostsTypeTypename; }
export const AccessGrantedTimeBasedOptClearableNetGrossTypename = 'AccessGrantedTimeBasedOptClearableNetGross';
export interface AccessGrantedTimeBasedOptClearableNetGrossTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedOptClearableNetGrossTypename; }
export const AccessGrantedTimeBasedOptClearableOnCallRateTypename = 'AccessGrantedTimeBasedOptClearableOnCallRate';
export interface AccessGrantedTimeBasedOptClearableOnCallRateTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedOptClearableOnCallRateTypename; }
export const AccessGrantedTimeBasedOptClearableProgressionSchemeTypename = 'AccessGrantedTimeBasedOptClearableProgressionScheme';
export interface AccessGrantedTimeBasedOptClearableProgressionSchemeTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedOptClearableProgressionSchemeTypename; }
export const AccessGrantedTimeBasedOptCurrencyTypename = 'AccessGrantedTimeBasedOptCurrency';
export interface AccessGrantedTimeBasedOptCurrencyTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedOptCurrencyTypename; }
export const AccessGrantedTimeBasedRateTypename = 'AccessGrantedTimeBasedRate';
export interface AccessGrantedTimeBasedRateTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedRateTypename; }
export const AccessGrantedTimeBasedStringTypename = 'AccessGrantedTimeBasedString';
export interface AccessGrantedTimeBasedStringTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedStringTypename; }
export const AccessGrantedTimeBasedVatTypeTypename = 'AccessGrantedTimeBasedVatType';
export interface AccessGrantedTimeBasedVatTypeTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedVatTypeTypename; }
export const AccessGrantedTimeBasedWorkingTimeTypename = 'AccessGrantedTimeBasedWorkingTime';
export interface AccessGrantedTimeBasedWorkingTimeTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeBasedWorkingTimeTypename; }
export const TimeReportTypename = 'TimeReport';
export interface TimeReportTypeLike extends TypeLike { readonly __typename?: typeof TimeReportTypename; }
export const IncompleteEntriesTypename = 'IncompleteEntries';
export interface IncompleteEntriesTypeLike extends TypeLike { readonly __typename?: typeof IncompleteEntriesTypename; }
export const MissingEntriesTypename = 'MissingEntries';
export interface MissingEntriesTypeLike extends TypeLike { readonly __typename?: typeof MissingEntriesTypename; }
export const NegativeFlexTimeBalanceTypename = 'NegativeFlexTimeBalance';
export interface NegativeFlexTimeBalanceTypeLike extends TypeLike { readonly __typename?: typeof NegativeFlexTimeBalanceTypename; }
export const TimeReportsRequiringApprovalTypename = 'TimeReportsRequiringApproval';
export interface TimeReportsRequiringApprovalTypeLike extends TypeLike { readonly __typename?: typeof TimeReportsRequiringApprovalTypename; }
export const AccessGrantedTimeReportsTypename = 'AccessGrantedTimeReports';
export interface AccessGrantedTimeReportsTypeLike extends TypeLike { readonly __typename?: typeof AccessGrantedTimeReportsTypename; }
export const TrainingBudgetSummaryTypename = 'TrainingBudgetSummary';
export interface TrainingBudgetSummaryTypeLike extends TypeLike { readonly __typename?: typeof TrainingBudgetSummaryTypename; }
export const TransferExecutedTypename = 'TransferExecuted';
export interface TransferExecutedTypeLike extends TypeLike { readonly __typename?: typeof TransferExecutedTypename; }
export const TransferOrderedTypename = 'TransferOrdered';
export interface TransferOrderedTypeLike extends TypeLike { readonly __typename?: typeof TransferOrderedTypename; }
export const UriResponseTypename = 'UriResponse';
export interface UriResponseTypeLike extends TypeLike { readonly __typename?: typeof UriResponseTypename; }
export const UnitResponseTypename = 'UnitResponse';
export interface UnitResponseTypeLike extends TypeLike { readonly __typename?: typeof UnitResponseTypename; }
export const UserTypename = 'User';
export interface UserTypeLike extends TypeLike { readonly __typename?: typeof UserTypename; }
export const VatAppliedTypename = 'VatApplied';
export interface VatAppliedTypeLike extends TypeLike { readonly __typename?: typeof VatAppliedTypename; }
export const VatNotAppliedTypename = 'VatNotApplied';
export interface VatNotAppliedTypeLike extends TypeLike { readonly __typename?: typeof VatNotAppliedTypename; }
export const NotVerifiedBankAccountStatusTypename = 'NotVerifiedBankAccountStatus';
export interface NotVerifiedBankAccountStatusTypeLike extends TypeLike { readonly __typename?: typeof NotVerifiedBankAccountStatusTypename; }
export const VerifiedBankAccountStatusTypename = 'VerifiedBankAccountStatus';
export interface VerifiedBankAccountStatusTypeLike extends TypeLike { readonly __typename?: typeof VerifiedBankAccountStatusTypename; }
export const NotVerifiedEuVatTypeTypename = 'NotVerifiedEuVatType';
export interface NotVerifiedEuVatTypeTypeLike extends TypeLike { readonly __typename?: typeof NotVerifiedEuVatTypeTypename; }
export const VerifiedEuVatTypeTypename = 'VerifiedEuVatType';
export interface VerifiedEuVatTypeTypeLike extends TypeLike { readonly __typename?: typeof VerifiedEuVatTypeTypename; }
export const VerificationStateEuVatTypeResponseTypename = 'VerificationStateEuVatTypeResponse';
export interface VerificationStateEuVatTypeResponseTypeLike extends TypeLike { readonly __typename?: typeof VerificationStateEuVatTypeResponseTypename; }
export const NotVerifiedBooleanVatStatusTypename = 'NotVerifiedBooleanVatStatus';
export interface NotVerifiedBooleanVatStatusTypeLike extends TypeLike { readonly __typename?: typeof NotVerifiedBooleanVatStatusTypename; }
export const VerifiedWithDescriptionBooleanVatStatusTypename = 'VerifiedWithDescriptionBooleanVatStatus';
export interface VerifiedWithDescriptionBooleanVatStatusTypeLike extends TypeLike { readonly __typename?: typeof VerifiedWithDescriptionBooleanVatStatusTypename; }
export const WorkRecordTypename = 'WorkRecord';
export interface WorkRecordTypeLike extends TypeLike { readonly __typename?: typeof WorkRecordTypename; }
export const WorkTransferProtocolTypename = 'WorkTransferProtocol';
export interface WorkTransferProtocolTypeLike extends TypeLike { readonly __typename?: typeof WorkTransferProtocolTypename; }
export const FileTypename = 'File';
export interface FileTypeLike extends TypeLike { readonly __typename?: typeof FileTypename; }
export const NoWorkToBeTransferedThisMonthTypename = 'NoWorkToBeTransferedThisMonth';
export interface NoWorkToBeTransferedThisMonthTypeLike extends TypeLike { readonly __typename?: typeof NoWorkToBeTransferedThisMonthTypename; }

/** types implementing AbsenceRecordOrNfsError */
export type AbsenceRecordOrNfsErrorUnionInterface = AbsenceRecord | NfsError;
export const AbsenceRecordOrNfsErrorTypename = 'AbsenceRecordOrNfsError';
export const AbsenceRecordOrNfsErrorTypenames = [AbsenceRecordTypename, NfsErrorTypename] as const;

/** types implementing UserError */
export type UserErrorUnionInterface = ActiveReportingRangeError | AggregatedValidationErrors | DuplicatedEntityError | EmptyRequestInputError | EntitiesNotFoundError | EntityNotFoundError | EntityVersionMismatched | ForeignKeyConstraintError | IllegalPositionRemovalError | IncompleteArgumentError | IncompleteArgumentsError | InternalNfsError | InvalidApiTokenError | InvalidArgumentsError | InvalidCompanyTypeError | InvalidContentTypeError | InvalidCursorError | InvalidEmailAddress | InvalidStateError | InvoiceAlreadyAcceptedError | InvoiceImportedFromSaldeoError | LeaveEntitlementExceededError | MissingFileMetadataError | NbpBaseCurrencyError | NoParkingSpotAvailableError | OperationAlreadyInProgressError | OperationNotAvailableError | OtherInvalidRequestError | PaymentCouldNotBeChangedError | PositionInactiveError | RaiseNoLongerDueError | ReservationNotPendingError | ReservationRequestStateError | ResourceAlreadyReservedError | TimeBasedActivityOverlapError | TimeBasedEffectiveFromInPastError | TimeReportOverlapError | TimeReportRecordApprovalNotInPendingStateError | UnauthorizedOperationError | UnknownContentTypeError | UserFacingAuthzError | ValidationError;
export const UserErrorTypename = 'UserError';
export const UserErrorTypenames = [ActiveReportingRangeErrorTypename, AggregatedValidationErrorsTypename, DuplicatedEntityErrorTypename, EmptyRequestInputErrorTypename, EntitiesNotFoundErrorTypename, EntityNotFoundErrorTypename, EntityVersionMismatchedTypename, ForeignKeyConstraintErrorTypename, IllegalPositionRemovalErrorTypename, IncompleteArgumentErrorTypename, IncompleteArgumentsErrorTypename, InternalNfsErrorTypename, InvalidApiTokenErrorTypename, InvalidArgumentsErrorTypename, InvalidCompanyTypeErrorTypename, InvalidContentTypeErrorTypename, InvalidCursorErrorTypename, InvalidEmailAddressTypename, InvalidStateErrorTypename, InvoiceAlreadyAcceptedErrorTypename, InvoiceImportedFromSaldeoErrorTypename, LeaveEntitlementExceededErrorTypename, MissingFileMetadataErrorTypename, NbpBaseCurrencyErrorTypename, NoParkingSpotAvailableErrorTypename, OperationAlreadyInProgressErrorTypename, OperationNotAvailableErrorTypename, OtherInvalidRequestErrorTypename, PaymentCouldNotBeChangedErrorTypename, PositionInactiveErrorTypename, RaiseNoLongerDueErrorTypename, ReservationNotPendingErrorTypename, ReservationRequestStateErrorTypename, ResourceAlreadyReservedErrorTypename, TimeBasedActivityOverlapErrorTypename, TimeBasedEffectiveFromInPastErrorTypename, TimeReportOverlapErrorTypename, TimeReportRecordApprovalNotInPendingStateErrorTypename, UnauthorizedOperationErrorTypename, UnknownContentTypeErrorTypename, UserFacingAuthzErrorTypename, ValidationErrorTypename] as const;

/** types implementing AbstractDrawer */
export type AbstractDrawerUnionInterface = AddClientContractDrawer | AddCompanyDrawer | AddInternalProjectDrawer | AddOfficeDrawer | AddPersonDrawer | AddProgressionSchemeDrawer | AddProjectDrawer | AddSpaceDrawer | AddThirdPersonDrawer | AdditionalCostsDrawer | AllBonusesDrawer | AnnualLeaveEntitlementDrawer | AnnualLeavePreferencesDrawer | AnnualLeaveSummaryDrawer | AssignBenefitDrawer | B2BContractDraftDrawer | B2BContractNoteDrawer | B2BSalaryDetailsDrawer | BasicFinancialReportDrawer | BenefitInvoicesReportDrawer | BenefitNoteDrawer | BonusDrawer | BonusPreviewDrawer | BookDeskOnBehalfDrawer | BookParkingOnBehalfDrawer | ClientInvoicingReportDrawer | CompanyBankAccountDrawer | CompanyDetailsDrawer | ContractBankAccountDrawer | ContractBonusesSettingsDrawer | ContractDetailsDrawer | CopyrightsDrawer | CostAndRevenueItemDrawer | CostSummariesDrawer | CreateBenefitDrawer | CreateVariantDrawer | DeskAssignmentDrawer | DeskDrawer | DirectReportingDrawer | EditBenefitDrawer | EditBenefitVariantDrawer | EditBenefitVariantPriceDrawer | EditClientContractDrawer | EditDeskRequestDrawer | EditOfficeDrawer | EditOfficeSettingsDrawer | EditParkingRequestDrawer | EditProfileAdditionalDataDrawer | EditProfileAddressDrawer | EditProfileBasicInfoDrawer | EditProjectCrossSellDrawer | EditProjectDrawer | EditProjectTechStackAndCompetencesDrawer | EditSkillsAndCertificatesDrawer | EditSocialMediaHandlesDrawer | EditSpaceDrawer | EmployeeDueDatesDrawer | EmploymentBankAccountDrawer | EmploymentContractDraftDrawer | EmploymentContractNoteDrawer | EmploymentSalaryDetailsDrawer | InvoiceTransferLinksDrawer | InvoicesDrawer | ListColumnControllsDrawer | ManageKeyPeopleDrawer | ManageProjectTimelineDrawer | OtherEmployeeInformationDrawer | ParkingSpotDrawer | PaymentDetailsDraftDrawer | PaymentDetailsDrawer | PendingCopyrightsDrawer | PeopleListReportDrawer | ProgressionSchemeLevelDrawer | ProjectBillablesReportDrawer | ProjectMembersDrawer | RateCardDrawer | RateChangesReportDrawer | ReservationLimitsDrawer | RoomDrawer | SalariesSummaryReportDrawer | SetFutureEntitlementDrawer | SetRateAndProgressionDrawer | SkillsAndCertificatesReportDrawer | SubcontractDraftDrawer | SubcontractNoteDrawer | TaxResidencyCertificatesDrawer | TimeReportsReportDrawer | TrainingPackageReportDrawer | TransferDetailsDrawer | TransferListExportDrawer | UopHolidaysReportDrawer | UploadDocumentDrawer | UserProjectsDrawer | YearlyCostSummaryDrawer;
export const AbstractDrawerTypename = 'AbstractDrawer';
export const AbstractDrawerTypenames = [AddClientContractDrawerTypename, AddCompanyDrawerTypename, AddInternalProjectDrawerTypename, AddOfficeDrawerTypename, AddPersonDrawerTypename, AddProgressionSchemeDrawerTypename, AddProjectDrawerTypename, AddSpaceDrawerTypename, AddThirdPersonDrawerTypename, AdditionalCostsDrawerTypename, AllBonusesDrawerTypename, AnnualLeaveEntitlementDrawerTypename, AnnualLeavePreferencesDrawerTypename, AnnualLeaveSummaryDrawerTypename, AssignBenefitDrawerTypename, B2BContractDraftDrawerTypename, B2BContractNoteDrawerTypename, B2BSalaryDetailsDrawerTypename, BasicFinancialReportDrawerTypename, BenefitInvoicesReportDrawerTypename, BenefitNoteDrawerTypename, BonusDrawerTypename, BonusPreviewDrawerTypename, BookDeskOnBehalfDrawerTypename, BookParkingOnBehalfDrawerTypename, ClientInvoicingReportDrawerTypename, CompanyBankAccountDrawerTypename, CompanyDetailsDrawerTypename, ContractBankAccountDrawerTypename, ContractBonusesSettingsDrawerTypename, ContractDetailsDrawerTypename, CopyrightsDrawerTypename, CostAndRevenueItemDrawerTypename, CostSummariesDrawerTypename, CreateBenefitDrawerTypename, CreateVariantDrawerTypename, DeskAssignmentDrawerTypename, DeskDrawerTypename, DirectReportingDrawerTypename, EditBenefitDrawerTypename, EditBenefitVariantDrawerTypename, EditBenefitVariantPriceDrawerTypename, EditClientContractDrawerTypename, EditDeskRequestDrawerTypename, EditOfficeDrawerTypename, EditOfficeSettingsDrawerTypename, EditParkingRequestDrawerTypename, EditProfileAdditionalDataDrawerTypename, EditProfileAddressDrawerTypename, EditProfileBasicInfoDrawerTypename, EditProjectCrossSellDrawerTypename, EditProjectDrawerTypename, EditProjectTechStackAndCompetencesDrawerTypename, EditSkillsAndCertificatesDrawerTypename, EditSocialMediaHandlesDrawerTypename, EditSpaceDrawerTypename, EmployeeDueDatesDrawerTypename, EmploymentBankAccountDrawerTypename, EmploymentContractDraftDrawerTypename, EmploymentContractNoteDrawerTypename, EmploymentSalaryDetailsDrawerTypename, InvoiceTransferLinksDrawerTypename, InvoicesDrawerTypename, ListColumnControllsDrawerTypename, ManageKeyPeopleDrawerTypename, ManageProjectTimelineDrawerTypename, OtherEmployeeInformationDrawerTypename, ParkingSpotDrawerTypename, PaymentDetailsDraftDrawerTypename, PaymentDetailsDrawerTypename, PendingCopyrightsDrawerTypename, PeopleListReportDrawerTypename, ProgressionSchemeLevelDrawerTypename, ProjectBillablesReportDrawerTypename, ProjectMembersDrawerTypename, RateCardDrawerTypename, RateChangesReportDrawerTypename, ReservationLimitsDrawerTypename, RoomDrawerTypename, SalariesSummaryReportDrawerTypename, SetFutureEntitlementDrawerTypename, SetRateAndProgressionDrawerTypename, SkillsAndCertificatesReportDrawerTypename, SubcontractDraftDrawerTypename, SubcontractNoteDrawerTypename, TaxResidencyCertificatesDrawerTypename, TimeReportsReportDrawerTypename, TrainingPackageReportDrawerTypename, TransferDetailsDrawerTypename, TransferListExportDrawerTypename, UopHolidaysReportDrawerTypename, UploadDocumentDrawerTypename, UserProjectsDrawerTypename, YearlyCostSummaryDrawerTypename] as const;

/** types implementing AdminOrNfsError */
export type AdminOrNfsErrorUnionInterface = Admin | NfsError;
export const AdminOrNfsErrorTypename = 'AdminOrNfsError';
export const AdminOrNfsErrorTypenames = [AdminTypename, NfsErrorTypename] as const;

/** types implementing AnnualLeaveSummaryOrNfsError */
export type AnnualLeaveSummaryOrNfsErrorUnionInterface = AnnualLeaveSummary | NfsError;
export const AnnualLeaveSummaryOrNfsErrorTypename = 'AnnualLeaveSummaryOrNfsError';
export const AnnualLeaveSummaryOrNfsErrorTypenames = [AnnualLeaveSummaryTypename, NfsErrorTypename] as const;

/** types implementing ApplyRaiseResultOrNfsError */
export type ApplyRaiseResultOrNfsErrorUnionInterface = ApplyRaiseResult | NfsError;
export const ApplyRaiseResultOrNfsErrorTypename = 'ApplyRaiseResultOrNfsError';
export const ApplyRaiseResultOrNfsErrorTypenames = [ApplyRaiseResultTypename, NfsErrorTypename] as const;

/** types implementing Bonus */
export type BonusUnionInterface = AppreciationBonus | BusinessTravelBonus | ClientReferralBonus | ConferenceBonus | CostRechargeBonus | EmployeeReferralBonus | LanguageLearningBonus | OtherBonus | RemoteWorkEquipmentBonus | SalesCommissionsBonus | SeverancePayBonus | ShareholderDividendBonus | TrainingPackageBonus | TrainingPackageExternalDeductionValue;
export const BonusTypename = 'Bonus';
export const BonusTypenames = [AppreciationBonusTypename, BusinessTravelBonusTypename, ClientReferralBonusTypename, ConferenceBonusTypename, CostRechargeBonusTypename, EmployeeReferralBonusTypename, LanguageLearningBonusTypename, OtherBonusTypename, RemoteWorkEquipmentBonusTypename, SalesCommissionsBonusTypename, SeverancePayBonusTypename, ShareholderDividendBonusTypename, TrainingPackageBonusTypename, TrainingPackageExternalDeductionValueTypename] as const;

/** types implementing Approval */
export type ApprovalUnionInterface = Approved | NotRequired | PendingApproval;
export const ApprovalTypename = 'Approval';
export const ApprovalTypenames = [ApprovedTypename, NotRequiredTypename, PendingApprovalTypename] as const;

/** types implementing AssignedVariantOrNfsError */
export type AssignedVariantOrNfsErrorUnionInterface = AssignedVariant | NfsError;
export const AssignedVariantOrNfsErrorTypename = 'AssignedVariantOrNfsError';
export const AssignedVariantOrNfsErrorTypenames = [AssignedVariantTypename, NfsErrorTypename] as const;

/** types implementing Contract */
export type ContractUnionInterface = B2BContract | EmploymentContract | Subcontract;
export const ContractTypename = 'Contract';
export const ContractTypenames = [B2BContractTypename, EmploymentContractTypename, SubcontractTypename] as const;

/** types implementing ContractDraft */
export type ContractDraftUnionInterface = B2BContractDraft | EmploymentContractDraft | SubcontractDraft;
export const ContractDraftTypename = 'ContractDraft';
export const ContractDraftTypenames = [B2BContractDraftTypename, EmploymentContractDraftTypename, SubcontractDraftTypename] as const;

/** types implementing B2BContractDraftOrNfsError */
export type B2BContractDraftOrNfsErrorUnionInterface = B2BContractDraft | NfsError;
export const B2BContractDraftOrNfsErrorTypename = 'B2BContractDraftOrNfsError';
export const B2BContractDraftOrNfsErrorTypenames = [B2BContractDraftTypename, NfsErrorTypename] as const;

/** types implementing B2BContractOrNfsError */
export type B2BContractOrNfsErrorUnionInterface = B2BContract | NfsError;
export const B2BContractOrNfsErrorTypename = 'B2BContractOrNfsError';
export const B2BContractOrNfsErrorTypenames = [B2BContractTypename, NfsErrorTypename] as const;

/** types implementing ContractSalaryDetails */
export type ContractSalaryDetailsUnionInterface = B2BContractSalaryDetails | EmploymentContractSalaryDetails;
export const ContractSalaryDetailsTypename = 'ContractSalaryDetails';
export const ContractSalaryDetailsTypenames = [B2BContractSalaryDetailsTypename, EmploymentContractSalaryDetailsTypename] as const;

/** types implementing TimeReportStats */
export type TimeReportStatsUnionInterface = B2BTimeReportStats | EmploymentTimeReportStats;
export const TimeReportStatsTypename = 'TimeReportStats';
export const TimeReportStatsTypenames = [B2BTimeReportStatsTypename, EmploymentTimeReportStatsTypename] as const;

/** types implementing BankAccountResponseOrNfsError */
export type BankAccountResponseOrNfsErrorUnionInterface = BankAccountResponse | NfsError;
export const BankAccountResponseOrNfsErrorTypename = 'BankAccountResponseOrNfsError';
export const BankAccountResponseOrNfsErrorTypenames = [BankAccountResponseTypename, NfsErrorTypename] as const;

/** types implementing BankAccountOrUnauthorized */
export type BankAccountOrUnauthorizedUnionInterface = AccessGrantedBankAccount | Unauthorized;
export const BankAccountOrUnauthorizedTypename = 'BankAccountOrUnauthorized';
export const BankAccountOrUnauthorizedTypenames = [AccessGrantedBankAccountTypename, UnauthorizedTypename] as const;

/** types implementing BankAccountsResponseOrNfsError */
export type BankAccountsResponseOrNfsErrorUnionInterface = BankAccountsResponse | NfsError;
export const BankAccountsResponseOrNfsErrorTypename = 'BankAccountsResponseOrNfsError';
export const BankAccountsResponseOrNfsErrorTypenames = [BankAccountsResponseTypename, NfsErrorTypename] as const;

/** types implementing BankTransfer */
export type BankTransferUnionInterface = BankIncomeTransfer | BankOutcomeTransfer;
export const BankTransferTypename = 'BankTransfer';
export const BankTransferTypenames = [BankIncomeTransferTypename, BankOutcomeTransferTypename] as const;

/** types implementing BankIncomeTransferOrNfsError */
export type BankIncomeTransferOrNfsErrorUnionInterface = BankIncomeTransfer | NfsError;
export const BankIncomeTransferOrNfsErrorTypename = 'BankIncomeTransferOrNfsError';
export const BankIncomeTransferOrNfsErrorTypenames = [BankIncomeTransferTypename, NfsErrorTypename] as const;

/** types implementing BankTransferResponseOrNfsError */
export type BankTransferResponseOrNfsErrorUnionInterface = BankTransferResponse | NfsError;
export const BankTransferResponseOrNfsErrorTypename = 'BankTransferResponseOrNfsError';
export const BankTransferResponseOrNfsErrorTypenames = [BankTransferResponseTypename, NfsErrorTypename] as const;

/** types implementing BaseInfoOrNfsError */
export type BaseInfoOrNfsErrorUnionInterface = BaseInfo | NfsError;
export const BaseInfoOrNfsErrorTypename = 'BaseInfoOrNfsError';
export const BaseInfoOrNfsErrorTypenames = [BaseInfoTypename, NfsErrorTypename] as const;

/** types implementing BenefitCommon */
export type BenefitCommonUnionInterface = Benefit | SubBenefit;
export const BenefitCommonTypename = 'BenefitCommon';
export const BenefitCommonTypenames = [BenefitTypename, SubBenefitTypename] as const;

/** types implementing BenefitAdditionalPeople */
export type BenefitAdditionalPeopleUnionInterface = BenefitAdditionalAdults | BenefitAdditionalFamily | BenefitAdditionalKids;
export const BenefitAdditionalPeopleTypename = 'BenefitAdditionalPeople';
export const BenefitAdditionalPeopleTypenames = [BenefitAdditionalAdultsTypename, BenefitAdditionalFamilyTypename, BenefitAdditionalKidsTypename] as const;

/** types implementing BenefitCommonResponseOrNfsError */
export type BenefitCommonResponseOrNfsErrorUnionInterface = BenefitCommonResponse | NfsError;
export const BenefitCommonResponseOrNfsErrorTypename = 'BenefitCommonResponseOrNfsError';
export const BenefitCommonResponseOrNfsErrorTypenames = [BenefitCommonResponseTypename, NfsErrorTypename] as const;

/** types implementing BenefitOrNfsError */
export type BenefitOrNfsErrorUnionInterface = Benefit | NfsError;
export const BenefitOrNfsErrorTypename = 'BenefitOrNfsError';
export const BenefitOrNfsErrorTypenames = [BenefitTypename, NfsErrorTypename] as const;

/** types implementing BenefitVariantOrNfsError */
export type BenefitVariantOrNfsErrorUnionInterface = BenefitVariant | NfsError;
export const BenefitVariantOrNfsErrorTypename = 'BenefitVariantOrNfsError';
export const BenefitVariantOrNfsErrorTypenames = [BenefitVariantTypename, NfsErrorTypename] as const;

/** types implementing BfrExportStatus */
export type BfrExportStatusUnionInterface = BfrExportCompleted | BfrExportFailed | BfrExportIdle | BfrExportInterrupted | BfrExportRunning;
export const BfrExportStatusTypename = 'BfrExportStatus';
export const BfrExportStatusTypenames = [BfrExportCompletedTypename, BfrExportFailedTypename, BfrExportIdleTypename, BfrExportInterruptedTypename, BfrExportRunningTypename] as const;

/** types implementing BfrExportStatusResponseOrNfsError */
export type BfrExportStatusResponseOrNfsErrorUnionInterface = BfrExportStatusResponse | NfsError;
export const BfrExportStatusResponseOrNfsErrorTypename = 'BfrExportStatusResponseOrNfsError';
export const BfrExportStatusResponseOrNfsErrorTypenames = [BfrExportStatusResponseTypename, NfsErrorTypename] as const;

/** types implementing BonusResponseOrNfsError */
export type BonusResponseOrNfsErrorUnionInterface = BonusResponse | NfsError;
export const BonusResponseOrNfsErrorTypename = 'BonusResponseOrNfsError';
export const BonusResponseOrNfsErrorTypenames = [BonusResponseTypename, NfsErrorTypename] as const;

/** types implementing BonusesOrUnauthorized */
export type BonusesOrUnauthorizedUnionInterface = AccessGrantedBonuses | Unauthorized;
export const BonusesOrUnauthorizedTypename = 'BonusesOrUnauthorized';
export const BonusesOrUnauthorizedTypenames = [AccessGrantedBonusesTypename, UnauthorizedTypename] as const;

/** types implementing BooleanResponseOrNfsError */
export type BooleanResponseOrNfsErrorUnionInterface = BooleanResponse | NfsError;
export const BooleanResponseOrNfsErrorTypename = 'BooleanResponseOrNfsError';
export const BooleanResponseOrNfsErrorTypenames = [BooleanResponseTypename, NfsErrorTypename] as const;

/** types implementing BooleanOrUnauthorized */
export type BooleanOrUnauthorizedUnionInterface = AccessGrantedBoolean | Unauthorized;
export const BooleanOrUnauthorizedTypename = 'BooleanOrUnauthorized';
export const BooleanOrUnauthorizedTypenames = [AccessGrantedBooleanTypename, UnauthorizedTypename] as const;

/** types implementing CertificateOrNfsError */
export type CertificateOrNfsErrorUnionInterface = Certificate | NfsError;
export const CertificateOrNfsErrorTypename = 'CertificateOrNfsError';
export const CertificateOrNfsErrorTypenames = [CertificateTypename, NfsErrorTypename] as const;

/** types implementing ClientContractOrNfsError */
export type ClientContractOrNfsErrorUnionInterface = ClientContract | NfsError;
export const ClientContractOrNfsErrorTypename = 'ClientContractOrNfsError';
export const ClientContractOrNfsErrorTypenames = [ClientContractTypename, NfsErrorTypename] as const;

/** types implementing ClientContractOrUnauthorized */
export type ClientContractOrUnauthorizedUnionInterface = AccessGrantedClientContract | Unauthorized;
export const ClientContractOrUnauthorizedTypename = 'ClientContractOrUnauthorized';
export const ClientContractOrUnauthorizedTypenames = [AccessGrantedClientContractTypename, UnauthorizedTypename] as const;

/** types implementing ClientPositionOrNfsError */
export type ClientPositionOrNfsErrorUnionInterface = ClientPosition | NfsError;
export const ClientPositionOrNfsErrorTypename = 'ClientPositionOrNfsError';
export const ClientPositionOrNfsErrorTypenames = [ClientPositionTypename, NfsErrorTypename] as const;

/** types implementing ClientPositionOrUnauthorized */
export type ClientPositionOrUnauthorizedUnionInterface = AccessGrantedClientPosition | Unauthorized;
export const ClientPositionOrUnauthorizedTypename = 'ClientPositionOrUnauthorized';
export const ClientPositionOrUnauthorizedTypenames = [AccessGrantedClientPositionTypename, UnauthorizedTypename] as const;

/** types implementing ClosedEndLocalDateRangeOrNfsError */
export type ClosedEndLocalDateRangeOrNfsErrorUnionInterface = ClosedEndLocalDateRange | NfsError;
export const ClosedEndLocalDateRangeOrNfsErrorTypename = 'ClosedEndLocalDateRangeOrNfsError';
export const ClosedEndLocalDateRangeOrNfsErrorTypenames = [ClosedEndLocalDateRangeTypename, NfsErrorTypename] as const;

/** types implementing CompanyInfoOrNfsError */
export type CompanyInfoOrNfsErrorUnionInterface = CompanyInfo | NfsError;
export const CompanyInfoOrNfsErrorTypename = 'CompanyInfoOrNfsError';
export const CompanyInfoOrNfsErrorTypenames = [CompanyInfoTypename, NfsErrorTypename] as const;

/** types implementing CompanyOrNfsError */
export type CompanyOrNfsErrorUnionInterface = Company | NfsError;
export const CompanyOrNfsErrorTypename = 'CompanyOrNfsError';
export const CompanyOrNfsErrorTypenames = [CompanyTypename, NfsErrorTypename] as const;

/** types implementing CompanyOrUnauthorized */
export type CompanyOrUnauthorizedUnionInterface = AccessGrantedCompany | Unauthorized;
export const CompanyOrUnauthorizedTypename = 'CompanyOrUnauthorized';
export const CompanyOrUnauthorizedTypenames = [AccessGrantedCompanyTypename, UnauthorizedTypename] as const;

/** types implementing ContractDraftResponseOrNfsError */
export type ContractDraftResponseOrNfsErrorUnionInterface = ContractDraftResponse | NfsError;
export const ContractDraftResponseOrNfsErrorTypename = 'ContractDraftResponseOrNfsError';
export const ContractDraftResponseOrNfsErrorTypenames = [ContractDraftResponseTypename, NfsErrorTypename] as const;

/** types implementing ContractResponseOrNfsError */
export type ContractResponseOrNfsErrorUnionInterface = ContractResponse | NfsError;
export const ContractResponseOrNfsErrorTypename = 'ContractResponseOrNfsError';
export const ContractResponseOrNfsErrorTypenames = [ContractResponseTypename, NfsErrorTypename] as const;

/** types implementing ContractSalaryDetailsAdditionalDataOrNfsError */
export type ContractSalaryDetailsAdditionalDataOrNfsErrorUnionInterface = ContractSalaryDetailsAdditionalData | NfsError;
export const ContractSalaryDetailsAdditionalDataOrNfsErrorTypename = 'ContractSalaryDetailsAdditionalDataOrNfsError';
export const ContractSalaryDetailsAdditionalDataOrNfsErrorTypenames = [ContractSalaryDetailsAdditionalDataTypename, NfsErrorTypename] as const;

/** types implementing ContractSalaryDetailsResponseOrNfsError */
export type ContractSalaryDetailsResponseOrNfsErrorUnionInterface = ContractSalaryDetailsResponse | NfsError;
export const ContractSalaryDetailsResponseOrNfsErrorTypename = 'ContractSalaryDetailsResponseOrNfsError';
export const ContractSalaryDetailsResponseOrNfsErrorTypenames = [ContractSalaryDetailsResponseTypename, NfsErrorTypename] as const;

/** types implementing CostInvoiceOrNfsError */
export type CostInvoiceOrNfsErrorUnionInterface = CostInvoice | NfsError;
export const CostInvoiceOrNfsErrorTypename = 'CostInvoiceOrNfsError';
export const CostInvoiceOrNfsErrorTypenames = [CostInvoiceTypename, NfsErrorTypename] as const;

/** types implementing CreatedBy */
export type CreatedByUnionInterface = ByAdmin | ByUser;
export const CreatedByTypename = 'CreatedBy';
export const CreatedByTypenames = [ByAdminTypename, ByUserTypename] as const;

/** types implementing DaysBalanceOrNfsError */
export type DaysBalanceOrNfsErrorUnionInterface = DaysBalance | NfsError;
export const DaysBalanceOrNfsErrorTypename = 'DaysBalanceOrNfsError';
export const DaysBalanceOrNfsErrorTypenames = [DaysBalanceTypename, NfsErrorTypename] as const;

/** types implementing DeskAssignmentOrNfsError */
export type DeskAssignmentOrNfsErrorUnionInterface = DeskAssignment | NfsError;
export const DeskAssignmentOrNfsErrorTypename = 'DeskAssignmentOrNfsError';
export const DeskAssignmentOrNfsErrorTypenames = [DeskAssignmentTypename, NfsErrorTypename] as const;

/** types implementing DeskOrNfsError */
export type DeskOrNfsErrorUnionInterface = Desk | NfsError;
export const DeskOrNfsErrorTypename = 'DeskOrNfsError';
export const DeskOrNfsErrorTypenames = [DeskTypename, NfsErrorTypename] as const;

/** types implementing DownloadableFileUrlOrNfsError */
export type DownloadableFileUrlOrNfsErrorUnionInterface = DownloadableFileUrl | NfsError;
export const DownloadableFileUrlOrNfsErrorTypename = 'DownloadableFileUrlOrNfsError';
export const DownloadableFileUrlOrNfsErrorTypenames = [DownloadableFileUrlTypename, NfsErrorTypename] as const;

/** types implementing DraftPreviewResponseOrNfsError */
export type DraftPreviewResponseOrNfsErrorUnionInterface = DraftPreviewResponse | NfsError;
export const DraftPreviewResponseOrNfsErrorTypename = 'DraftPreviewResponseOrNfsError';
export const DraftPreviewResponseOrNfsErrorTypenames = [DraftPreviewResponseTypename, NfsErrorTypename] as const;

/** types implementing EmploymentContractDraftOrNfsError */
export type EmploymentContractDraftOrNfsErrorUnionInterface = EmploymentContractDraft | NfsError;
export const EmploymentContractDraftOrNfsErrorTypename = 'EmploymentContractDraftOrNfsError';
export const EmploymentContractDraftOrNfsErrorTypenames = [EmploymentContractDraftTypename, NfsErrorTypename] as const;

/** types implementing EmploymentContractOrNfsError */
export type EmploymentContractOrNfsErrorUnionInterface = EmploymentContract | NfsError;
export const EmploymentContractOrNfsErrorTypename = 'EmploymentContractOrNfsError';
export const EmploymentContractOrNfsErrorTypenames = [EmploymentContractTypename, NfsErrorTypename] as const;

/** types implementing ExternalBeneficiaryOrNfsError */
export type ExternalBeneficiaryOrNfsErrorUnionInterface = ExternalBeneficiary | NfsError;
export const ExternalBeneficiaryOrNfsErrorTypename = 'ExternalBeneficiaryOrNfsError';
export const ExternalBeneficiaryOrNfsErrorTypenames = [ExternalBeneficiaryTypename, NfsErrorTypename] as const;

/** types implementing FspResponseAssignedVariantOrNfsError */
export type FspResponseAssignedVariantOrNfsErrorUnionInterface = FspResponseAssignedVariant | NfsError;
export const FspResponseAssignedVariantOrNfsErrorTypename = 'FspResponseAssignedVariantOrNfsError';
export const FspResponseAssignedVariantOrNfsErrorTypenames = [FspResponseAssignedVariantTypename, NfsErrorTypename] as const;

/** types implementing FspResponseB2BContractSalaryDetailsOrNfsError */
export type FspResponseB2BContractSalaryDetailsOrNfsErrorUnionInterface = FspResponseB2BContractSalaryDetails | NfsError;
export const FspResponseB2BContractSalaryDetailsOrNfsErrorTypename = 'FspResponseB2BContractSalaryDetailsOrNfsError';
export const FspResponseB2BContractSalaryDetailsOrNfsErrorTypenames = [FspResponseB2BContractSalaryDetailsTypename, NfsErrorTypename] as const;

/** types implementing FspResponseBankTransferOrNfsError */
export type FspResponseBankTransferOrNfsErrorUnionInterface = FspResponseBankTransfer | NfsError;
export const FspResponseBankTransferOrNfsErrorTypename = 'FspResponseBankTransferOrNfsError';
export const FspResponseBankTransferOrNfsErrorTypenames = [FspResponseBankTransferTypename, NfsErrorTypename] as const;

/** types implementing FspResponseClientContractOrNfsError */
export type FspResponseClientContractOrNfsErrorUnionInterface = FspResponseClientContract | NfsError;
export const FspResponseClientContractOrNfsErrorTypename = 'FspResponseClientContractOrNfsError';
export const FspResponseClientContractOrNfsErrorTypenames = [FspResponseClientContractTypename, NfsErrorTypename] as const;

/** types implementing FspResponseCompanyOrNfsError */
export type FspResponseCompanyOrNfsErrorUnionInterface = FspResponseCompany | NfsError;
export const FspResponseCompanyOrNfsErrorTypename = 'FspResponseCompanyOrNfsError';
export const FspResponseCompanyOrNfsErrorTypenames = [FspResponseCompanyTypename, NfsErrorTypename] as const;

/** types implementing FspResponseContractDraftOrNfsError */
export type FspResponseContractDraftOrNfsErrorUnionInterface = FspResponseContractDraft | NfsError;
export const FspResponseContractDraftOrNfsErrorTypename = 'FspResponseContractDraftOrNfsError';
export const FspResponseContractDraftOrNfsErrorTypenames = [FspResponseContractDraftTypename, NfsErrorTypename] as const;

/** types implementing FspResponseContractOrNfsError */
export type FspResponseContractOrNfsErrorUnionInterface = FspResponseContract | NfsError;
export const FspResponseContractOrNfsErrorTypename = 'FspResponseContractOrNfsError';
export const FspResponseContractOrNfsErrorTypenames = [FspResponseContractTypename, NfsErrorTypename] as const;

/** types implementing FspResponseEmploymentContractSalaryDetailsOrNfsError */
export type FspResponseEmploymentContractSalaryDetailsOrNfsErrorUnionInterface = FspResponseEmploymentContractSalaryDetails | NfsError;
export const FspResponseEmploymentContractSalaryDetailsOrNfsErrorTypename = 'FspResponseEmploymentContractSalaryDetailsOrNfsError';
export const FspResponseEmploymentContractSalaryDetailsOrNfsErrorTypenames = [FspResponseEmploymentContractSalaryDetailsTypename, NfsErrorTypename] as const;

/** types implementing FspResponseOfficeReservationOrNfsError */
export type FspResponseOfficeReservationOrNfsErrorUnionInterface = FspResponseOfficeReservation | NfsError;
export const FspResponseOfficeReservationOrNfsErrorTypename = 'FspResponseOfficeReservationOrNfsError';
export const FspResponseOfficeReservationOrNfsErrorTypenames = [FspResponseOfficeReservationTypename, NfsErrorTypename] as const;

/** types implementing FspResponseProjectOrNfsError */
export type FspResponseProjectOrNfsErrorUnionInterface = FspResponseProject | NfsError;
export const FspResponseProjectOrNfsErrorTypename = 'FspResponseProjectOrNfsError';
export const FspResponseProjectOrNfsErrorTypenames = [FspResponseProjectTypename, NfsErrorTypename] as const;

/** types implementing FspResponseRevenueAdministrationOfficeOrNfsError */
export type FspResponseRevenueAdministrationOfficeOrNfsErrorUnionInterface = FspResponseRevenueAdministrationOffice | NfsError;
export const FspResponseRevenueAdministrationOfficeOrNfsErrorTypename = 'FspResponseRevenueAdministrationOfficeOrNfsError';
export const FspResponseRevenueAdministrationOfficeOrNfsErrorTypenames = [FspResponseRevenueAdministrationOfficeTypename, NfsErrorTypename] as const;

/** types implementing FspResponseSpaceOrNfsError */
export type FspResponseSpaceOrNfsErrorUnionInterface = FspResponseSpace | NfsError;
export const FspResponseSpaceOrNfsErrorTypename = 'FspResponseSpaceOrNfsError';
export const FspResponseSpaceOrNfsErrorTypenames = [FspResponseSpaceTypename, NfsErrorTypename] as const;

/** types implementing FspResponseUserOrNfsError */
export type FspResponseUserOrNfsErrorUnionInterface = FspResponseUser | NfsError;
export const FspResponseUserOrNfsErrorTypename = 'FspResponseUserOrNfsError';
export const FspResponseUserOrNfsErrorTypenames = [FspResponseUserTypename, NfsErrorTypename] as const;

/** types implementing GmailConnectionOrNfsError */
export type GmailConnectionOrNfsErrorUnionInterface = GmailConnection | NfsError;
export const GmailConnectionOrNfsErrorTypename = 'GmailConnectionOrNfsError';
export const GmailConnectionOrNfsErrorTypenames = [GmailConnectionTypename, NfsErrorTypename] as const;

/** types implementing GoogleSpreadsheetUrlOrNfsError */
export type GoogleSpreadsheetUrlOrNfsErrorUnionInterface = GoogleSpreadsheetUrl | NfsError;
export const GoogleSpreadsheetUrlOrNfsErrorTypename = 'GoogleSpreadsheetUrlOrNfsError';
export const GoogleSpreadsheetUrlOrNfsErrorTypenames = [GoogleSpreadsheetUrlTypename, NfsErrorTypename] as const;

/** types implementing BankAccountNumber */
export type BankAccountNumberUnionInterface = Iban | OtherBankAccountNumber;
export const BankAccountNumberTypename = 'BankAccountNumber';
export const BankAccountNumberTypenames = [IbanTypename, OtherBankAccountNumberTypename] as const;

/** types implementing IncomeRow */
export type IncomeRowUnionInterface = DailyIncomeRow | HourlyIncomeRow | MonthlyIncomeRow;
export const IncomeRowTypename = 'IncomeRow';
export const IncomeRowTypenames = [DailyIncomeRowTypename, HourlyIncomeRowTypename, MonthlyIncomeRowTypename] as const;

/** types implementing IncompleteDataDescription */
export type IncompleteDataDescriptionUnionInterface = AccountingDataMissing | BonusRequiresApproval | InvoiceFileMissing | InvoiceMissing | InvoiceUnchecked | NoBankAccount | TimeReportIncomplete | TimeReportRequiresApproval | WhiteListInvalid;
export const IncompleteDataDescriptionTypename = 'IncompleteDataDescription';
export const IncompleteDataDescriptionTypenames = [AccountingDataMissingTypename, BonusRequiresApprovalTypename, InvoiceFileMissingTypename, InvoiceMissingTypename, InvoiceUncheckedTypename, NoBankAccountTypename, TimeReportIncompleteTypename, TimeReportRequiresApprovalTypename, WhiteListInvalidTypename] as const;

/** types implementing IntResponseOrNfsError */
export type IntResponseOrNfsErrorUnionInterface = IntResponse | NfsError;
export const IntResponseOrNfsErrorTypename = 'IntResponseOrNfsError';
export const IntResponseOrNfsErrorTypenames = [IntResponseTypename, NfsErrorTypename] as const;

/** types implementing InvoiceDetailsOrNfsError */
export type InvoiceDetailsOrNfsErrorUnionInterface = InvoiceDetails | NfsError;
export const InvoiceDetailsOrNfsErrorTypename = 'InvoiceDetailsOrNfsError';
export const InvoiceDetailsOrNfsErrorTypenames = [InvoiceDetailsTypename, NfsErrorTypename] as const;

/** types implementing ListOfAbsenceRecordResponseOrNfsError */
export type ListOfAbsenceRecordResponseOrNfsErrorUnionInterface = ListOfAbsenceRecordResponse | NfsError;
export const ListOfAbsenceRecordResponseOrNfsErrorTypename = 'ListOfAbsenceRecordResponseOrNfsError';
export const ListOfAbsenceRecordResponseOrNfsErrorTypenames = [ListOfAbsenceRecordResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfAdminResponseOrNfsError */
export type ListOfAdminResponseOrNfsErrorUnionInterface = ListOfAdminResponse | NfsError;
export const ListOfAdminResponseOrNfsErrorTypename = 'ListOfAdminResponseOrNfsError';
export const ListOfAdminResponseOrNfsErrorTypenames = [ListOfAdminResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfApiTokenResponseOrNfsError */
export type ListOfApiTokenResponseOrNfsErrorUnionInterface = ListOfApiTokenResponse | NfsError;
export const ListOfApiTokenResponseOrNfsErrorTypename = 'ListOfApiTokenResponseOrNfsError';
export const ListOfApiTokenResponseOrNfsErrorTypenames = [ListOfApiTokenResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfAssignedProjectResponseOrNfsError */
export type ListOfAssignedProjectResponseOrNfsErrorUnionInterface = ListOfAssignedProjectResponse | NfsError;
export const ListOfAssignedProjectResponseOrNfsErrorTypename = 'ListOfAssignedProjectResponseOrNfsError';
export const ListOfAssignedProjectResponseOrNfsErrorTypenames = [ListOfAssignedProjectResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfAssignedVariantResponseOrNfsError */
export type ListOfAssignedVariantResponseOrNfsErrorUnionInterface = ListOfAssignedVariantResponse | NfsError;
export const ListOfAssignedVariantResponseOrNfsErrorTypename = 'ListOfAssignedVariantResponseOrNfsError';
export const ListOfAssignedVariantResponseOrNfsErrorTypenames = [ListOfAssignedVariantResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfAssignedVariantOrUnauthorized */
export type ListOfAssignedVariantOrUnauthorizedUnionInterface = AccessGrantedListOfAssignedVariant | Unauthorized;
export const ListOfAssignedVariantOrUnauthorizedTypename = 'ListOfAssignedVariantOrUnauthorized';
export const ListOfAssignedVariantOrUnauthorizedTypenames = [AccessGrantedListOfAssignedVariantTypename, UnauthorizedTypename] as const;

/** types implementing ListOfBankTransferResponseOrNfsError */
export type ListOfBankTransferResponseOrNfsErrorUnionInterface = ListOfBankTransferResponse | NfsError;
export const ListOfBankTransferResponseOrNfsErrorTypename = 'ListOfBankTransferResponseOrNfsError';
export const ListOfBankTransferResponseOrNfsErrorTypenames = [ListOfBankTransferResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfBenefitGroupResponseOrNfsError */
export type ListOfBenefitGroupResponseOrNfsErrorUnionInterface = ListOfBenefitGroupResponse | NfsError;
export const ListOfBenefitGroupResponseOrNfsErrorTypename = 'ListOfBenefitGroupResponseOrNfsError';
export const ListOfBenefitGroupResponseOrNfsErrorTypenames = [ListOfBenefitGroupResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfBfrFileUrlResponseOrNfsError */
export type ListOfBfrFileUrlResponseOrNfsErrorUnionInterface = ListOfBfrFileUrlResponse | NfsError;
export const ListOfBfrFileUrlResponseOrNfsErrorTypename = 'ListOfBfrFileUrlResponseOrNfsError';
export const ListOfBfrFileUrlResponseOrNfsErrorTypenames = [ListOfBfrFileUrlResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfCertificateOrUnauthorized */
export type ListOfCertificateOrUnauthorizedUnionInterface = AccessGrantedListOfCertificate | Unauthorized;
export const ListOfCertificateOrUnauthorizedTypename = 'ListOfCertificateOrUnauthorized';
export const ListOfCertificateOrUnauthorizedTypenames = [AccessGrantedListOfCertificateTypename, UnauthorizedTypename] as const;

/** types implementing ListOfClientContractResponseOrNfsError */
export type ListOfClientContractResponseOrNfsErrorUnionInterface = ListOfClientContractResponse | NfsError;
export const ListOfClientContractResponseOrNfsErrorTypename = 'ListOfClientContractResponseOrNfsError';
export const ListOfClientContractResponseOrNfsErrorTypenames = [ListOfClientContractResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfClientContractOrUnauthorized */
export type ListOfClientContractOrUnauthorizedUnionInterface = AccessGrantedListOfClientContract | Unauthorized;
export const ListOfClientContractOrUnauthorizedTypename = 'ListOfClientContractOrUnauthorized';
export const ListOfClientContractOrUnauthorizedTypenames = [AccessGrantedListOfClientContractTypename, UnauthorizedTypename] as const;

/** types implementing ListOfClientPositionOrUnauthorized */
export type ListOfClientPositionOrUnauthorizedUnionInterface = AccessGrantedListOfClientPosition | Unauthorized;
export const ListOfClientPositionOrUnauthorizedTypename = 'ListOfClientPositionOrUnauthorized';
export const ListOfClientPositionOrUnauthorizedTypenames = [AccessGrantedListOfClientPositionTypename, UnauthorizedTypename] as const;

/** types implementing ListOfContractDocumentTemplateDescriptionResponseOrNfsError */
export type ListOfContractDocumentTemplateDescriptionResponseOrNfsErrorUnionInterface = ListOfContractDocumentTemplateDescriptionResponse | NfsError;
export const ListOfContractDocumentTemplateDescriptionResponseOrNfsErrorTypename = 'ListOfContractDocumentTemplateDescriptionResponseOrNfsError';
export const ListOfContractDocumentTemplateDescriptionResponseOrNfsErrorTypenames = [ListOfContractDocumentTemplateDescriptionResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfContractDraftResponseOrNfsError */
export type ListOfContractDraftResponseOrNfsErrorUnionInterface = ListOfContractDraftResponse | NfsError;
export const ListOfContractDraftResponseOrNfsErrorTypename = 'ListOfContractDraftResponseOrNfsError';
export const ListOfContractDraftResponseOrNfsErrorTypenames = [ListOfContractDraftResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfContractSalaryDetailsResponseOrNfsError */
export type ListOfContractSalaryDetailsResponseOrNfsErrorUnionInterface = ListOfContractSalaryDetailsResponse | NfsError;
export const ListOfContractSalaryDetailsResponseOrNfsErrorTypename = 'ListOfContractSalaryDetailsResponseOrNfsError';
export const ListOfContractSalaryDetailsResponseOrNfsErrorTypenames = [ListOfContractSalaryDetailsResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfContractOrUnauthorized */
export type ListOfContractOrUnauthorizedUnionInterface = AccessGrantedListOfContract | Unauthorized;
export const ListOfContractOrUnauthorizedTypename = 'ListOfContractOrUnauthorized';
export const ListOfContractOrUnauthorizedTypenames = [AccessGrantedListOfContractTypename, UnauthorizedTypename] as const;

/** types implementing ListOfCostAndRevenueItemOrUnauthorized */
export type ListOfCostAndRevenueItemOrUnauthorizedUnionInterface = AccessGrantedListOfCostAndRevenueItem | Unauthorized;
export const ListOfCostAndRevenueItemOrUnauthorizedTypename = 'ListOfCostAndRevenueItemOrUnauthorized';
export const ListOfCostAndRevenueItemOrUnauthorizedTypenames = [AccessGrantedListOfCostAndRevenueItemTypename, UnauthorizedTypename] as const;

/** types implementing ListOfCostInvoiceResponseOrNfsError */
export type ListOfCostInvoiceResponseOrNfsErrorUnionInterface = ListOfCostInvoiceResponse | NfsError;
export const ListOfCostInvoiceResponseOrNfsErrorTypename = 'ListOfCostInvoiceResponseOrNfsError';
export const ListOfCostInvoiceResponseOrNfsErrorTypenames = [ListOfCostInvoiceResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfDeskAssignmentResponseOrNfsError */
export type ListOfDeskAssignmentResponseOrNfsErrorUnionInterface = ListOfDeskAssignmentResponse | NfsError;
export const ListOfDeskAssignmentResponseOrNfsErrorTypename = 'ListOfDeskAssignmentResponseOrNfsError';
export const ListOfDeskAssignmentResponseOrNfsErrorTypenames = [ListOfDeskAssignmentResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfExternalBeneficiaryOrUnauthorized */
export type ListOfExternalBeneficiaryOrUnauthorizedUnionInterface = AccessGrantedListOfExternalBeneficiary | Unauthorized;
export const ListOfExternalBeneficiaryOrUnauthorizedTypename = 'ListOfExternalBeneficiaryOrUnauthorized';
export const ListOfExternalBeneficiaryOrUnauthorizedTypenames = [AccessGrantedListOfExternalBeneficiaryTypename, UnauthorizedTypename] as const;

/** types implementing ListOfFakturowniaProfileResponseOrNfsError */
export type ListOfFakturowniaProfileResponseOrNfsErrorUnionInterface = ListOfFakturowniaProfileResponse | NfsError;
export const ListOfFakturowniaProfileResponseOrNfsErrorTypename = 'ListOfFakturowniaProfileResponseOrNfsError';
export const ListOfFakturowniaProfileResponseOrNfsErrorTypenames = [ListOfFakturowniaProfileResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfHolidaySummaryFileUrlResponseOrNfsError */
export type ListOfHolidaySummaryFileUrlResponseOrNfsErrorUnionInterface = ListOfHolidaySummaryFileUrlResponse | NfsError;
export const ListOfHolidaySummaryFileUrlResponseOrNfsErrorTypename = 'ListOfHolidaySummaryFileUrlResponseOrNfsError';
export const ListOfHolidaySummaryFileUrlResponseOrNfsErrorTypenames = [ListOfHolidaySummaryFileUrlResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfIncomeDetailsOrUnauthorized */
export type ListOfIncomeDetailsOrUnauthorizedUnionInterface = AccessGrantedListOfIncomeDetails | Unauthorized;
export const ListOfIncomeDetailsOrUnauthorizedTypename = 'ListOfIncomeDetailsOrUnauthorized';
export const ListOfIncomeDetailsOrUnauthorizedTypenames = [AccessGrantedListOfIncomeDetailsTypename, UnauthorizedTypename] as const;

/** types implementing ListOfKvWorkTagIdMinutesResponseOrNfsError */
export type ListOfKvWorkTagIdMinutesResponseOrNfsErrorUnionInterface = ListOfKvWorkTagIdMinutesResponse | NfsError;
export const ListOfKvWorkTagIdMinutesResponseOrNfsErrorTypename = 'ListOfKvWorkTagIdMinutesResponseOrNfsError';
export const ListOfKvWorkTagIdMinutesResponseOrNfsErrorTypenames = [ListOfKvWorkTagIdMinutesResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfOfficeResponseOrNfsError */
export type ListOfOfficeResponseOrNfsErrorUnionInterface = ListOfOfficeResponse | NfsError;
export const ListOfOfficeResponseOrNfsErrorTypename = 'ListOfOfficeResponseOrNfsError';
export const ListOfOfficeResponseOrNfsErrorTypenames = [ListOfOfficeResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfOnCallRecordResponseOrNfsError */
export type ListOfOnCallRecordResponseOrNfsErrorUnionInterface = ListOfOnCallRecordResponse | NfsError;
export const ListOfOnCallRecordResponseOrNfsErrorTypename = 'ListOfOnCallRecordResponseOrNfsError';
export const ListOfOnCallRecordResponseOrNfsErrorTypenames = [ListOfOnCallRecordResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfProgressionSchemeResponseOrNfsError */
export type ListOfProgressionSchemeResponseOrNfsErrorUnionInterface = ListOfProgressionSchemeResponse | NfsError;
export const ListOfProgressionSchemeResponseOrNfsErrorTypename = 'ListOfProgressionSchemeResponseOrNfsError';
export const ListOfProgressionSchemeResponseOrNfsErrorTypenames = [ListOfProgressionSchemeResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfProjectAssignmentResponseOrNfsError */
export type ListOfProjectAssignmentResponseOrNfsErrorUnionInterface = ListOfProjectAssignmentResponse | NfsError;
export const ListOfProjectAssignmentResponseOrNfsErrorTypename = 'ListOfProjectAssignmentResponseOrNfsError';
export const ListOfProjectAssignmentResponseOrNfsErrorTypenames = [ListOfProjectAssignmentResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfProjectAssignmentOrUnauthorized */
export type ListOfProjectAssignmentOrUnauthorizedUnionInterface = AccessGrantedListOfProjectAssignment | Unauthorized;
export const ListOfProjectAssignmentOrUnauthorizedTypename = 'ListOfProjectAssignmentOrUnauthorized';
export const ListOfProjectAssignmentOrUnauthorizedTypenames = [AccessGrantedListOfProjectAssignmentTypename, UnauthorizedTypename] as const;

/** types implementing ListOfProjectIdResponseOrNfsError */
export type ListOfProjectIdResponseOrNfsErrorUnionInterface = ListOfProjectIdResponse | NfsError;
export const ListOfProjectIdResponseOrNfsErrorTypename = 'ListOfProjectIdResponseOrNfsError';
export const ListOfProjectIdResponseOrNfsErrorTypenames = [ListOfProjectIdResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfProjectUtilizationResponseOrNfsError */
export type ListOfProjectUtilizationResponseOrNfsErrorUnionInterface = ListOfProjectUtilizationResponse | NfsError;
export const ListOfProjectUtilizationResponseOrNfsErrorTypename = 'ListOfProjectUtilizationResponseOrNfsError';
export const ListOfProjectUtilizationResponseOrNfsErrorTypenames = [ListOfProjectUtilizationResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfRaiseProposalResponseOrNfsError */
export type ListOfRaiseProposalResponseOrNfsErrorUnionInterface = ListOfRaiseProposalResponse | NfsError;
export const ListOfRaiseProposalResponseOrNfsErrorTypename = 'ListOfRaiseProposalResponseOrNfsError';
export const ListOfRaiseProposalResponseOrNfsErrorTypenames = [ListOfRaiseProposalResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfReportingPeriodResponseOrNfsError */
export type ListOfReportingPeriodResponseOrNfsErrorUnionInterface = ListOfReportingPeriodResponse | NfsError;
export const ListOfReportingPeriodResponseOrNfsErrorTypename = 'ListOfReportingPeriodResponseOrNfsError';
export const ListOfReportingPeriodResponseOrNfsErrorTypenames = [ListOfReportingPeriodResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfReservationRequestResponseOrNfsError */
export type ListOfReservationRequestResponseOrNfsErrorUnionInterface = ListOfReservationRequestResponse | NfsError;
export const ListOfReservationRequestResponseOrNfsErrorTypename = 'ListOfReservationRequestResponseOrNfsError';
export const ListOfReservationRequestResponseOrNfsErrorTypenames = [ListOfReservationRequestResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfSalesInvoiceResponseOrNfsError */
export type ListOfSalesInvoiceResponseOrNfsErrorUnionInterface = ListOfSalesInvoiceResponse | NfsError;
export const ListOfSalesInvoiceResponseOrNfsErrorTypename = 'ListOfSalesInvoiceResponseOrNfsError';
export const ListOfSalesInvoiceResponseOrNfsErrorTypenames = [ListOfSalesInvoiceResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfSocialMediaHandleOrUnauthorized */
export type ListOfSocialMediaHandleOrUnauthorizedUnionInterface = AccessGrantedListOfSocialMediaHandle | Unauthorized;
export const ListOfSocialMediaHandleOrUnauthorizedTypename = 'ListOfSocialMediaHandleOrUnauthorized';
export const ListOfSocialMediaHandleOrUnauthorizedTypenames = [AccessGrantedListOfSocialMediaHandleTypename, UnauthorizedTypename] as const;

/** types implementing ListOfStringResponseOrNfsError */
export type ListOfStringResponseOrNfsErrorUnionInterface = ListOfStringResponse | NfsError;
export const ListOfStringResponseOrNfsErrorTypename = 'ListOfStringResponseOrNfsError';
export const ListOfStringResponseOrNfsErrorTypenames = [ListOfStringResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfStringOrUnauthorized */
export type ListOfStringOrUnauthorizedUnionInterface = AccessGrantedListOfString | Unauthorized;
export const ListOfStringOrUnauthorizedTypename = 'ListOfStringOrUnauthorized';
export const ListOfStringOrUnauthorizedTypenames = [AccessGrantedListOfStringTypename, UnauthorizedTypename] as const;

/** types implementing ListOfTaxResidencyCertificateOrUnauthorized */
export type ListOfTaxResidencyCertificateOrUnauthorizedUnionInterface = AccessGrantedListOfTaxResidencyCertificate | Unauthorized;
export const ListOfTaxResidencyCertificateOrUnauthorizedTypename = 'ListOfTaxResidencyCertificateOrUnauthorized';
export const ListOfTaxResidencyCertificateOrUnauthorizedTypenames = [AccessGrantedListOfTaxResidencyCertificateTypename, UnauthorizedTypename] as const;

/** types implementing ListOfTimeReportValidationResponseOrNfsError */
export type ListOfTimeReportValidationResponseOrNfsErrorUnionInterface = ListOfTimeReportValidationResponse | NfsError;
export const ListOfTimeReportValidationResponseOrNfsErrorTypename = 'ListOfTimeReportValidationResponseOrNfsError';
export const ListOfTimeReportValidationResponseOrNfsErrorTypenames = [ListOfTimeReportValidationResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfTransfersSummariesResponseOrNfsError */
export type ListOfTransfersSummariesResponseOrNfsErrorUnionInterface = ListOfTransfersSummariesResponse | NfsError;
export const ListOfTransfersSummariesResponseOrNfsErrorTypename = 'ListOfTransfersSummariesResponseOrNfsError';
export const ListOfTransfersSummariesResponseOrNfsErrorTypenames = [ListOfTransfersSummariesResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfWorkRecordResponseOrNfsError */
export type ListOfWorkRecordResponseOrNfsErrorUnionInterface = ListOfWorkRecordResponse | NfsError;
export const ListOfWorkRecordResponseOrNfsErrorTypename = 'ListOfWorkRecordResponseOrNfsError';
export const ListOfWorkRecordResponseOrNfsErrorTypenames = [ListOfWorkRecordResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfWorkTransferProtocolResponseOrNfsError */
export type ListOfWorkTransferProtocolResponseOrNfsErrorUnionInterface = ListOfWorkTransferProtocolResponse | NfsError;
export const ListOfWorkTransferProtocolResponseOrNfsErrorTypename = 'ListOfWorkTransferProtocolResponseOrNfsError';
export const ListOfWorkTransferProtocolResponseOrNfsErrorTypenames = [ListOfWorkTransferProtocolResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfWorkTransferProtocolOrUnauthorized */
export type ListOfWorkTransferProtocolOrUnauthorizedUnionInterface = AccessGrantedListOfWorkTransferProtocol | Unauthorized;
export const ListOfWorkTransferProtocolOrUnauthorizedTypename = 'ListOfWorkTransferProtocolOrUnauthorized';
export const ListOfWorkTransferProtocolOrUnauthorizedTypenames = [AccessGrantedListOfWorkTransferProtocolTypename, UnauthorizedTypename] as const;

/** types implementing LocalDateOrUnauthorized */
export type LocalDateOrUnauthorizedUnionInterface = AccessGrantedLocalDate | Unauthorized;
export const LocalDateOrUnauthorizedTypename = 'LocalDateOrUnauthorized';
export const LocalDateOrUnauthorizedTypenames = [AccessGrantedLocalDateTypename, UnauthorizedTypename] as const;

/** types implementing OfficeAvailabilityOrNfsError */
export type OfficeAvailabilityOrNfsErrorUnionInterface = NfsError | OfficeAvailability;
export const OfficeAvailabilityOrNfsErrorTypename = 'OfficeAvailabilityOrNfsError';
export const OfficeAvailabilityOrNfsErrorTypenames = [NfsErrorTypename, OfficeAvailabilityTypename] as const;

/** types implementing OfficeCatalogueOrNfsError */
export type OfficeCatalogueOrNfsErrorUnionInterface = NfsError | OfficeCatalogue;
export const OfficeCatalogueOrNfsErrorTypename = 'OfficeCatalogueOrNfsError';
export const OfficeCatalogueOrNfsErrorTypenames = [NfsErrorTypename, OfficeCatalogueTypename] as const;

/** types implementing OfficeOrNfsError */
export type OfficeOrNfsErrorUnionInterface = NfsError | Office;
export const OfficeOrNfsErrorTypename = 'OfficeOrNfsError';
export const OfficeOrNfsErrorTypenames = [NfsErrorTypename, OfficeTypename] as const;

/** types implementing OfficeReservationSettingsOrNfsError */
export type OfficeReservationSettingsOrNfsErrorUnionInterface = NfsError | OfficeReservationSettings;
export const OfficeReservationSettingsOrNfsErrorTypename = 'OfficeReservationSettingsOrNfsError';
export const OfficeReservationSettingsOrNfsErrorTypenames = [NfsErrorTypename, OfficeReservationSettingsTypename] as const;

/** types implementing OfficeSettingsOrNfsError */
export type OfficeSettingsOrNfsErrorUnionInterface = NfsError | OfficeSettings;
export const OfficeSettingsOrNfsErrorTypename = 'OfficeSettingsOrNfsError';
export const OfficeSettingsOrNfsErrorTypenames = [NfsErrorTypename, OfficeSettingsTypename] as const;

/** types implementing OnCallMultipliersOrNfsError */
export type OnCallMultipliersOrNfsErrorUnionInterface = NfsError | OnCallMultipliers;
export const OnCallMultipliersOrNfsErrorTypename = 'OnCallMultipliersOrNfsError';
export const OnCallMultipliersOrNfsErrorTypenames = [NfsErrorTypename, OnCallMultipliersTypename] as const;

/** types implementing OnCallRecordOrNfsError */
export type OnCallRecordOrNfsErrorUnionInterface = NfsError | OnCallRecord;
export const OnCallRecordOrNfsErrorTypename = 'OnCallRecordOrNfsError';
export const OnCallRecordOrNfsErrorTypenames = [NfsErrorTypename, OnCallRecordTypename] as const;

/** types implementing OptionalAddressOrUnauthorized */
export type OptionalAddressOrUnauthorizedUnionInterface = AccessGrantedOptionalAddress | Unauthorized;
export const OptionalAddressOrUnauthorizedTypename = 'OptionalAddressOrUnauthorized';
export const OptionalAddressOrUnauthorizedTypenames = [AccessGrantedOptionalAddressTypename, UnauthorizedTypename] as const;

/** types implementing OptionalAnnualLeaveEntitlementOrUnauthorized */
export type OptionalAnnualLeaveEntitlementOrUnauthorizedUnionInterface = AccessGrantedOptionalAnnualLeaveEntitlement | Unauthorized;
export const OptionalAnnualLeaveEntitlementOrUnauthorizedTypename = 'OptionalAnnualLeaveEntitlementOrUnauthorized';
export const OptionalAnnualLeaveEntitlementOrUnauthorizedTypenames = [AccessGrantedOptionalAnnualLeaveEntitlementTypename, UnauthorizedTypename] as const;

/** types implementing OptionalBankAccountOrUnauthorized */
export type OptionalBankAccountOrUnauthorizedUnionInterface = AccessGrantedOptionalBankAccount | Unauthorized;
export const OptionalBankAccountOrUnauthorizedTypename = 'OptionalBankAccountOrUnauthorized';
export const OptionalBankAccountOrUnauthorizedTypenames = [AccessGrantedOptionalBankAccountTypename, UnauthorizedTypename] as const;

/** types implementing OptionalClientPositionOrUnauthorized */
export type OptionalClientPositionOrUnauthorizedUnionInterface = AccessGrantedOptionalClientPosition | Unauthorized;
export const OptionalClientPositionOrUnauthorizedTypename = 'OptionalClientPositionOrUnauthorized';
export const OptionalClientPositionOrUnauthorizedTypenames = [AccessGrantedOptionalClientPositionTypename, UnauthorizedTypename] as const;

/** types implementing OptionalContractDraftOrUnauthorized */
export type OptionalContractDraftOrUnauthorizedUnionInterface = AccessGrantedOptionalContractDraft | Unauthorized;
export const OptionalContractDraftOrUnauthorizedTypename = 'OptionalContractDraftOrUnauthorized';
export const OptionalContractDraftOrUnauthorizedTypenames = [AccessGrantedOptionalContractDraftTypename, UnauthorizedTypename] as const;

/** types implementing OptionalCountryCodeOrUnauthorized */
export type OptionalCountryCodeOrUnauthorizedUnionInterface = AccessGrantedOptionalCountryCode | Unauthorized;
export const OptionalCountryCodeOrUnauthorizedTypename = 'OptionalCountryCodeOrUnauthorized';
export const OptionalCountryCodeOrUnauthorizedTypenames = [AccessGrantedOptionalCountryCodeTypename, UnauthorizedTypename] as const;

/** types implementing OptionalCrossSellOrUnauthorized */
export type OptionalCrossSellOrUnauthorizedUnionInterface = AccessGrantedOptionalCrossSell | Unauthorized;
export const OptionalCrossSellOrUnauthorizedTypename = 'OptionalCrossSellOrUnauthorized';
export const OptionalCrossSellOrUnauthorizedTypenames = [AccessGrantedOptionalCrossSellTypename, UnauthorizedTypename] as const;

/** types implementing OptionalDownloadableExternallyHostedFileUrlOrUnauthorized */
export type OptionalDownloadableExternallyHostedFileUrlOrUnauthorizedUnionInterface = AccessGrantedOptionalDownloadableExternallyHostedFileUrl | Unauthorized;
export const OptionalDownloadableExternallyHostedFileUrlOrUnauthorizedTypename = 'OptionalDownloadableExternallyHostedFileUrlOrUnauthorized';
export const OptionalDownloadableExternallyHostedFileUrlOrUnauthorizedTypenames = [AccessGrantedOptionalDownloadableExternallyHostedFileUrlTypename, UnauthorizedTypename] as const;

/** types implementing OptionalEmailAddressOrUnauthorized */
export type OptionalEmailAddressOrUnauthorizedUnionInterface = AccessGrantedOptionalEmailAddress | Unauthorized;
export const OptionalEmailAddressOrUnauthorizedTypename = 'OptionalEmailAddressOrUnauthorized';
export const OptionalEmailAddressOrUnauthorizedTypenames = [AccessGrantedOptionalEmailAddressTypename, UnauthorizedTypename] as const;

/** types implementing OptionalIdTypeOrUnauthorized */
export type OptionalIdTypeOrUnauthorizedUnionInterface = AccessGrantedOptionalIdType | Unauthorized;
export const OptionalIdTypeOrUnauthorizedTypename = 'OptionalIdTypeOrUnauthorized';
export const OptionalIdTypeOrUnauthorizedTypenames = [AccessGrantedOptionalIdTypeTypename, UnauthorizedTypename] as const;

/** types implementing OptionalLocalDateOrUnauthorized */
export type OptionalLocalDateOrUnauthorizedUnionInterface = AccessGrantedOptionalLocalDate | Unauthorized;
export const OptionalLocalDateOrUnauthorizedTypename = 'OptionalLocalDateOrUnauthorized';
export const OptionalLocalDateOrUnauthorizedTypenames = [AccessGrantedOptionalLocalDateTypename, UnauthorizedTypename] as const;

/** types implementing OptionalOffsetDateTimeOrUnauthorized */
export type OptionalOffsetDateTimeOrUnauthorizedUnionInterface = AccessGrantedOptionalOffsetDateTime | Unauthorized;
export const OptionalOffsetDateTimeOrUnauthorizedTypename = 'OptionalOffsetDateTimeOrUnauthorized';
export const OptionalOffsetDateTimeOrUnauthorizedTypenames = [AccessGrantedOptionalOffsetDateTimeTypename, UnauthorizedTypename] as const;

/** types implementing OptionalPeselOrUnauthorized */
export type OptionalPeselOrUnauthorizedUnionInterface = AccessGrantedOptionalPesel | Unauthorized;
export const OptionalPeselOrUnauthorizedTypename = 'OptionalPeselOrUnauthorized';
export const OptionalPeselOrUnauthorizedTypenames = [AccessGrantedOptionalPeselTypename, UnauthorizedTypename] as const;

/** types implementing OptionalPhoneNumberOrUnauthorized */
export type OptionalPhoneNumberOrUnauthorizedUnionInterface = AccessGrantedOptionalPhoneNumber | Unauthorized;
export const OptionalPhoneNumberOrUnauthorizedTypename = 'OptionalPhoneNumberOrUnauthorized';
export const OptionalPhoneNumberOrUnauthorizedTypenames = [AccessGrantedOptionalPhoneNumberTypename, UnauthorizedTypename] as const;

/** types implementing OptionalRevenueAdministrationOfficeOrUnauthorized */
export type OptionalRevenueAdministrationOfficeOrUnauthorizedUnionInterface = AccessGrantedOptionalRevenueAdministrationOffice | Unauthorized;
export const OptionalRevenueAdministrationOfficeOrUnauthorizedTypename = 'OptionalRevenueAdministrationOfficeOrUnauthorized';
export const OptionalRevenueAdministrationOfficeOrUnauthorizedTypenames = [AccessGrantedOptionalRevenueAdministrationOfficeTypename, UnauthorizedTypename] as const;

/** types implementing OptionalStringOrUnauthorized */
export type OptionalStringOrUnauthorizedUnionInterface = AccessGrantedOptionalString | Unauthorized;
export const OptionalStringOrUnauthorizedTypename = 'OptionalStringOrUnauthorized';
export const OptionalStringOrUnauthorizedTypenames = [AccessGrantedOptionalStringTypename, UnauthorizedTypename] as const;

/** types implementing OptionalUriOrUnauthorized */
export type OptionalUriOrUnauthorizedUnionInterface = AccessGrantedOptionalUri | Unauthorized;
export const OptionalUriOrUnauthorizedTypename = 'OptionalUriOrUnauthorized';
export const OptionalUriOrUnauthorizedTypenames = [AccessGrantedOptionalUriTypename, UnauthorizedTypename] as const;

/** types implementing ParkingSpotOrNfsError */
export type ParkingSpotOrNfsErrorUnionInterface = NfsError | ParkingSpot;
export const ParkingSpotOrNfsErrorTypename = 'ParkingSpotOrNfsError';
export const ParkingSpotOrNfsErrorTypenames = [NfsErrorTypename, ParkingSpotTypename] as const;

/** types implementing PaymentConnectionOrNfsError */
export type PaymentConnectionOrNfsErrorUnionInterface = NfsError | PaymentConnection;
export const PaymentConnectionOrNfsErrorTypename = 'PaymentConnectionOrNfsError';
export const PaymentConnectionOrNfsErrorTypenames = [NfsErrorTypename, PaymentConnectionTypename] as const;

/** types implementing PayrollTransfersOrderViewOrNfsError */
export type PayrollTransfersOrderViewOrNfsErrorUnionInterface = NfsError | PayrollTransfersOrderView;
export const PayrollTransfersOrderViewOrNfsErrorTypename = 'PayrollTransfersOrderViewOrNfsError';
export const PayrollTransfersOrderViewOrNfsErrorTypenames = [NfsErrorTypename, PayrollTransfersOrderViewTypename] as const;

/** types implementing PersonalDataProcessingAuthorizationOrUnauthorized */
export type PersonalDataProcessingAuthorizationOrUnauthorizedUnionInterface = AccessGrantedPersonalDataProcessingAuthorization | Unauthorized;
export const PersonalDataProcessingAuthorizationOrUnauthorizedTypename = 'PersonalDataProcessingAuthorizationOrUnauthorized';
export const PersonalDataProcessingAuthorizationOrUnauthorizedTypenames = [AccessGrantedPersonalDataProcessingAuthorizationTypename, UnauthorizedTypename] as const;

/** types implementing PolishVatOrNfsError */
export type PolishVatOrNfsErrorUnionInterface = NfsError | PolishVat;
export const PolishVatOrNfsErrorTypename = 'PolishVatOrNfsError';
export const PolishVatOrNfsErrorTypenames = [NfsErrorTypename, PolishVatTypename] as const;

/** types implementing ProgressionSchemeOrNfsError */
export type ProgressionSchemeOrNfsErrorUnionInterface = NfsError | ProgressionScheme;
export const ProgressionSchemeOrNfsErrorTypename = 'ProgressionSchemeOrNfsError';
export const ProgressionSchemeOrNfsErrorTypenames = [NfsErrorTypename, ProgressionSchemeTypename] as const;

/** types implementing ProjectAssignmentOrNfsError */
export type ProjectAssignmentOrNfsErrorUnionInterface = NfsError | ProjectAssignment;
export const ProjectAssignmentOrNfsErrorTypename = 'ProjectAssignmentOrNfsError';
export const ProjectAssignmentOrNfsErrorTypenames = [NfsErrorTypename, ProjectAssignmentTypename] as const;

/** types implementing ProjectOrNfsError */
export type ProjectOrNfsErrorUnionInterface = NfsError | Project;
export const ProjectOrNfsErrorTypename = 'ProjectOrNfsError';
export const ProjectOrNfsErrorTypenames = [NfsErrorTypename, ProjectTypename] as const;

/** types implementing ProjectRoleAssignmentOrNfsError */
export type ProjectRoleAssignmentOrNfsErrorUnionInterface = NfsError | ProjectRoleAssignment;
export const ProjectRoleAssignmentOrNfsErrorTypename = 'ProjectRoleAssignmentOrNfsError';
export const ProjectRoleAssignmentOrNfsErrorTypenames = [NfsErrorTypename, ProjectRoleAssignmentTypename] as const;

/** types implementing RequiredActionsOrNfsError */
export type RequiredActionsOrNfsErrorUnionInterface = NfsError | RequiredActions;
export const RequiredActionsOrNfsErrorTypename = 'RequiredActionsOrNfsError';
export const RequiredActionsOrNfsErrorTypenames = [NfsErrorTypename, RequiredActionsTypename] as const;

/** types implementing ReservationRequestOrNfsError */
export type ReservationRequestOrNfsErrorUnionInterface = NfsError | ReservationRequest;
export const ReservationRequestOrNfsErrorTypename = 'ReservationRequestOrNfsError';
export const ReservationRequestOrNfsErrorTypenames = [NfsErrorTypename, ReservationRequestTypename] as const;

/** types implementing RoomOrNfsError */
export type RoomOrNfsErrorUnionInterface = NfsError | Room;
export const RoomOrNfsErrorTypename = 'RoomOrNfsError';
export const RoomOrNfsErrorTypenames = [NfsErrorTypename, RoomTypename] as const;

/** types implementing SalaryState */
export type SalaryStateUnionInterface = IncompleteData | PaymentDisbursed | Ready;
export const SalaryStateTypename = 'SalaryState';
export const SalaryStateTypenames = [IncompleteDataTypename, PaymentDisbursedTypename, ReadyTypename] as const;

/** types implementing SalesInvoiceDetailsOrNfsError */
export type SalesInvoiceDetailsOrNfsErrorUnionInterface = NfsError | SalesInvoiceDetails;
export const SalesInvoiceDetailsOrNfsErrorTypename = 'SalesInvoiceDetailsOrNfsError';
export const SalesInvoiceDetailsOrNfsErrorTypenames = [NfsErrorTypename, SalesInvoiceDetailsTypename] as const;

/** types implementing SalesInvoiceOrNfsError */
export type SalesInvoiceOrNfsErrorUnionInterface = NfsError | SalesInvoice;
export const SalesInvoiceOrNfsErrorTypename = 'SalesInvoiceOrNfsError';
export const SalesInvoiceOrNfsErrorTypenames = [NfsErrorTypename, SalesInvoiceTypename] as const;

/** types implementing SetRateAndProgressionResultOrNfsError */
export type SetRateAndProgressionResultOrNfsErrorUnionInterface = NfsError | SetRateAndProgressionResult;
export const SetRateAndProgressionResultOrNfsErrorTypename = 'SetRateAndProgressionResultOrNfsError';
export const SetRateAndProgressionResultOrNfsErrorTypenames = [NfsErrorTypename, SetRateAndProgressionResultTypename] as const;

/** types implementing SpaceOrNfsError */
export type SpaceOrNfsErrorUnionInterface = NfsError | Space;
export const SpaceOrNfsErrorTypename = 'SpaceOrNfsError';
export const SpaceOrNfsErrorTypenames = [NfsErrorTypename, SpaceTypename] as const;

/** types implementing StringOrUnauthorized */
export type StringOrUnauthorizedUnionInterface = AccessGrantedString | Unauthorized;
export const StringOrUnauthorizedTypename = 'StringOrUnauthorized';
export const StringOrUnauthorizedTypenames = [AccessGrantedStringTypename, UnauthorizedTypename] as const;

/** types implementing SubBenefitOrNfsError */
export type SubBenefitOrNfsErrorUnionInterface = NfsError | SubBenefit;
export const SubBenefitOrNfsErrorTypename = 'SubBenefitOrNfsError';
export const SubBenefitOrNfsErrorTypenames = [NfsErrorTypename, SubBenefitTypename] as const;

/** types implementing SubcontractDraftOrNfsError */
export type SubcontractDraftOrNfsErrorUnionInterface = NfsError | SubcontractDraft;
export const SubcontractDraftOrNfsErrorTypename = 'SubcontractDraftOrNfsError';
export const SubcontractDraftOrNfsErrorTypenames = [NfsErrorTypename, SubcontractDraftTypename] as const;

/** types implementing SubcontractOrNfsError */
export type SubcontractOrNfsErrorUnionInterface = NfsError | Subcontract;
export const SubcontractOrNfsErrorTypename = 'SubcontractOrNfsError';
export const SubcontractOrNfsErrorTypenames = [NfsErrorTypename, SubcontractTypename] as const;

/** types implementing TaxResidencyCertificateOrNfsError */
export type TaxResidencyCertificateOrNfsErrorUnionInterface = NfsError | TaxResidencyCertificate;
export const TaxResidencyCertificateOrNfsErrorTypename = 'TaxResidencyCertificateOrNfsError';
export const TaxResidencyCertificateOrNfsErrorTypenames = [NfsErrorTypename, TaxResidencyCertificateTypename] as const;

/** types implementing TimeBasedBooleanOrUnauthorized */
export type TimeBasedBooleanOrUnauthorizedUnionInterface = AccessGrantedTimeBasedBoolean | Unauthorized;
export const TimeBasedBooleanOrUnauthorizedTypename = 'TimeBasedBooleanOrUnauthorized';
export const TimeBasedBooleanOrUnauthorizedTypenames = [AccessGrantedTimeBasedBooleanTypename, UnauthorizedTypename] as const;

/** types implementing TimeBasedCurrencyOrUnauthorized */
export type TimeBasedCurrencyOrUnauthorizedUnionInterface = AccessGrantedTimeBasedCurrency | Unauthorized;
export const TimeBasedCurrencyOrUnauthorizedTypename = 'TimeBasedCurrencyOrUnauthorized';
export const TimeBasedCurrencyOrUnauthorizedTypenames = [AccessGrantedTimeBasedCurrencyTypename, UnauthorizedTypename] as const;

/** types implementing Highlight */
export type HighlightUnionInterface = TimeBasedHighlight;
export const HighlightTypename = 'Highlight';
export const HighlightTypenames = [TimeBasedHighlightTypename] as const;

/** types implementing TimeBasedOptClearableBasisPointOrUnauthorized */
export type TimeBasedOptClearableBasisPointOrUnauthorizedUnionInterface = AccessGrantedTimeBasedOptClearableBasisPoint | Unauthorized;
export const TimeBasedOptClearableBasisPointOrUnauthorizedTypename = 'TimeBasedOptClearableBasisPointOrUnauthorized';
export const TimeBasedOptClearableBasisPointOrUnauthorizedTypenames = [AccessGrantedTimeBasedOptClearableBasisPointTypename, UnauthorizedTypename] as const;

/** types implementing TimeBasedOptClearableDaysOrUnauthorized */
export type TimeBasedOptClearableDaysOrUnauthorizedUnionInterface = AccessGrantedTimeBasedOptClearableDays | Unauthorized;
export const TimeBasedOptClearableDaysOrUnauthorizedTypename = 'TimeBasedOptClearableDaysOrUnauthorized';
export const TimeBasedOptClearableDaysOrUnauthorizedTypenames = [AccessGrantedTimeBasedOptClearableDaysTypename, UnauthorizedTypename] as const;

/** types implementing TimeBasedOptClearableDeductibleCostsTypeOrUnauthorized */
export type TimeBasedOptClearableDeductibleCostsTypeOrUnauthorizedUnionInterface = AccessGrantedTimeBasedOptClearableDeductibleCostsType | Unauthorized;
export const TimeBasedOptClearableDeductibleCostsTypeOrUnauthorizedTypename = 'TimeBasedOptClearableDeductibleCostsTypeOrUnauthorized';
export const TimeBasedOptClearableDeductibleCostsTypeOrUnauthorizedTypenames = [AccessGrantedTimeBasedOptClearableDeductibleCostsTypeTypename, UnauthorizedTypename] as const;

/** types implementing TimeBasedOptClearableNetGrossOrUnauthorized */
export type TimeBasedOptClearableNetGrossOrUnauthorizedUnionInterface = AccessGrantedTimeBasedOptClearableNetGross | Unauthorized;
export const TimeBasedOptClearableNetGrossOrUnauthorizedTypename = 'TimeBasedOptClearableNetGrossOrUnauthorized';
export const TimeBasedOptClearableNetGrossOrUnauthorizedTypenames = [AccessGrantedTimeBasedOptClearableNetGrossTypename, UnauthorizedTypename] as const;

/** types implementing TimeBasedOptClearableOnCallRateOrUnauthorized */
export type TimeBasedOptClearableOnCallRateOrUnauthorizedUnionInterface = AccessGrantedTimeBasedOptClearableOnCallRate | Unauthorized;
export const TimeBasedOptClearableOnCallRateOrUnauthorizedTypename = 'TimeBasedOptClearableOnCallRateOrUnauthorized';
export const TimeBasedOptClearableOnCallRateOrUnauthorizedTypenames = [AccessGrantedTimeBasedOptClearableOnCallRateTypename, UnauthorizedTypename] as const;

/** types implementing TimeBasedOptClearableProgressionSchemeOrUnauthorized */
export type TimeBasedOptClearableProgressionSchemeOrUnauthorizedUnionInterface = AccessGrantedTimeBasedOptClearableProgressionScheme | Unauthorized;
export const TimeBasedOptClearableProgressionSchemeOrUnauthorizedTypename = 'TimeBasedOptClearableProgressionSchemeOrUnauthorized';
export const TimeBasedOptClearableProgressionSchemeOrUnauthorizedTypenames = [AccessGrantedTimeBasedOptClearableProgressionSchemeTypename, UnauthorizedTypename] as const;

/** types implementing TimeBasedOptCurrencyOrUnauthorized */
export type TimeBasedOptCurrencyOrUnauthorizedUnionInterface = AccessGrantedTimeBasedOptCurrency | Unauthorized;
export const TimeBasedOptCurrencyOrUnauthorizedTypename = 'TimeBasedOptCurrencyOrUnauthorized';
export const TimeBasedOptCurrencyOrUnauthorizedTypenames = [AccessGrantedTimeBasedOptCurrencyTypename, UnauthorizedTypename] as const;

/** types implementing TimeBasedRateOrUnauthorized */
export type TimeBasedRateOrUnauthorizedUnionInterface = AccessGrantedTimeBasedRate | Unauthorized;
export const TimeBasedRateOrUnauthorizedTypename = 'TimeBasedRateOrUnauthorized';
export const TimeBasedRateOrUnauthorizedTypenames = [AccessGrantedTimeBasedRateTypename, UnauthorizedTypename] as const;

/** types implementing TimeBasedStringOrUnauthorized */
export type TimeBasedStringOrUnauthorizedUnionInterface = AccessGrantedTimeBasedString | Unauthorized;
export const TimeBasedStringOrUnauthorizedTypename = 'TimeBasedStringOrUnauthorized';
export const TimeBasedStringOrUnauthorizedTypenames = [AccessGrantedTimeBasedStringTypename, UnauthorizedTypename] as const;

/** types implementing TimeBasedVatTypeOrUnauthorized */
export type TimeBasedVatTypeOrUnauthorizedUnionInterface = AccessGrantedTimeBasedVatType | Unauthorized;
export const TimeBasedVatTypeOrUnauthorizedTypename = 'TimeBasedVatTypeOrUnauthorized';
export const TimeBasedVatTypeOrUnauthorizedTypenames = [AccessGrantedTimeBasedVatTypeTypename, UnauthorizedTypename] as const;

/** types implementing TimeBasedWorkingTimeOrUnauthorized */
export type TimeBasedWorkingTimeOrUnauthorizedUnionInterface = AccessGrantedTimeBasedWorkingTime | Unauthorized;
export const TimeBasedWorkingTimeOrUnauthorizedTypename = 'TimeBasedWorkingTimeOrUnauthorized';
export const TimeBasedWorkingTimeOrUnauthorizedTypenames = [AccessGrantedTimeBasedWorkingTimeTypename, UnauthorizedTypename] as const;

/** types implementing TimeReportOrNfsError */
export type TimeReportOrNfsErrorUnionInterface = NfsError | TimeReport;
export const TimeReportOrNfsErrorTypename = 'TimeReportOrNfsError';
export const TimeReportOrNfsErrorTypenames = [NfsErrorTypename, TimeReportTypename] as const;

/** types implementing TimeReportValidation */
export type TimeReportValidationUnionInterface = IncompleteEntries | MissingEntries | NegativeFlexTimeBalance;
export const TimeReportValidationTypename = 'TimeReportValidation';
export const TimeReportValidationTypenames = [IncompleteEntriesTypename, MissingEntriesTypename, NegativeFlexTimeBalanceTypename] as const;

/** types implementing TimeReportsRequiringApprovalOrNfsError */
export type TimeReportsRequiringApprovalOrNfsErrorUnionInterface = NfsError | TimeReportsRequiringApproval;
export const TimeReportsRequiringApprovalOrNfsErrorTypename = 'TimeReportsRequiringApprovalOrNfsError';
export const TimeReportsRequiringApprovalOrNfsErrorTypenames = [NfsErrorTypename, TimeReportsRequiringApprovalTypename] as const;

/** types implementing TimeReportsOrUnauthorized */
export type TimeReportsOrUnauthorizedUnionInterface = AccessGrantedTimeReports | Unauthorized;
export const TimeReportsOrUnauthorizedTypename = 'TimeReportsOrUnauthorized';
export const TimeReportsOrUnauthorizedTypenames = [AccessGrantedTimeReportsTypename, UnauthorizedTypename] as const;

/** types implementing TrainingBudgetSummaryOrNfsError */
export type TrainingBudgetSummaryOrNfsErrorUnionInterface = NfsError | TrainingBudgetSummary;
export const TrainingBudgetSummaryOrNfsErrorTypename = 'TrainingBudgetSummaryOrNfsError';
export const TrainingBudgetSummaryOrNfsErrorTypenames = [NfsErrorTypename, TrainingBudgetSummaryTypename] as const;

/** types implementing TransferState */
export type TransferStateUnionInterface = TransferExecuted | TransferOrdered;
export const TransferStateTypename = 'TransferState';
export const TransferStateTypenames = [TransferExecutedTypename, TransferOrderedTypename] as const;

/** types implementing UriResponseOrNfsError */
export type UriResponseOrNfsErrorUnionInterface = NfsError | UriResponse;
export const UriResponseOrNfsErrorTypename = 'UriResponseOrNfsError';
export const UriResponseOrNfsErrorTypenames = [NfsErrorTypename, UriResponseTypename] as const;

/** types implementing UnitResponseOrNfsError */
export type UnitResponseOrNfsErrorUnionInterface = NfsError | UnitResponse;
export const UnitResponseOrNfsErrorTypename = 'UnitResponseOrNfsError';
export const UnitResponseOrNfsErrorTypenames = [NfsErrorTypename, UnitResponseTypename] as const;

/** types implementing UserOrNfsError */
export type UserOrNfsErrorUnionInterface = NfsError | User;
export const UserOrNfsErrorTypename = 'UserOrNfsError';
export const UserOrNfsErrorTypenames = [NfsErrorTypename, UserTypename] as const;

/** types implementing VatType */
export type VatTypeUnionInterface = VatApplied | VatNotApplied;
export const VatTypeTypename = 'VatType';
export const VatTypeTypenames = [VatAppliedTypename, VatNotAppliedTypename] as const;

/** types implementing VerificationStateBankAccountStatus */
export type VerificationStateBankAccountStatusUnionInterface = NotVerifiedBankAccountStatus | VerifiedBankAccountStatus;
export const VerificationStateBankAccountStatusTypename = 'VerificationStateBankAccountStatus';
export const VerificationStateBankAccountStatusTypenames = [NotVerifiedBankAccountStatusTypename, VerifiedBankAccountStatusTypename] as const;

/** types implementing VerificationStateEuVatType */
export type VerificationStateEuVatTypeUnionInterface = NotVerifiedEuVatType | VerifiedEuVatType;
export const VerificationStateEuVatTypeTypename = 'VerificationStateEuVatType';
export const VerificationStateEuVatTypeTypenames = [NotVerifiedEuVatTypeTypename, VerifiedEuVatTypeTypename] as const;

/** types implementing VerificationStateEuVatTypeResponseOrNfsError */
export type VerificationStateEuVatTypeResponseOrNfsErrorUnionInterface = NfsError | VerificationStateEuVatTypeResponse;
export const VerificationStateEuVatTypeResponseOrNfsErrorTypename = 'VerificationStateEuVatTypeResponseOrNfsError';
export const VerificationStateEuVatTypeResponseOrNfsErrorTypenames = [NfsErrorTypename, VerificationStateEuVatTypeResponseTypename] as const;

/** types implementing VerificationStateWithDescriptionBooleanVatStatus */
export type VerificationStateWithDescriptionBooleanVatStatusUnionInterface = NotVerifiedBooleanVatStatus | VerifiedWithDescriptionBooleanVatStatus;
export const VerificationStateWithDescriptionBooleanVatStatusTypename = 'VerificationStateWithDescriptionBooleanVatStatus';
export const VerificationStateWithDescriptionBooleanVatStatusTypenames = [NotVerifiedBooleanVatStatusTypename, VerifiedWithDescriptionBooleanVatStatusTypename] as const;

/** types implementing WorkRecordOrNfsError */
export type WorkRecordOrNfsErrorUnionInterface = NfsError | WorkRecord;
export const WorkRecordOrNfsErrorTypename = 'WorkRecordOrNfsError';
export const WorkRecordOrNfsErrorTypenames = [NfsErrorTypename, WorkRecordTypename] as const;

/** types implementing WorkTransferProtocolOrNfsError */
export type WorkTransferProtocolOrNfsErrorUnionInterface = NfsError | WorkTransferProtocol;
export const WorkTransferProtocolOrNfsErrorTypename = 'WorkTransferProtocolOrNfsError';
export const WorkTransferProtocolOrNfsErrorTypenames = [NfsErrorTypename, WorkTransferProtocolTypename] as const;

/** types implementing WorkTransferProtocolPayload */
export type WorkTransferProtocolPayloadUnionInterface = File | NoWorkToBeTransferedThisMonth;
export const WorkTransferProtocolPayloadTypename = 'WorkTransferProtocolPayload';
export const WorkTransferProtocolPayloadTypenames = [FileTypename, NoWorkToBeTransferedThisMonthTypename] as const;

type TypeLike = { readonly __typename?: string };
export type InstanceOf<T extends TypeLike, U extends string> = Extract<T, { __typename?: U | undefined}>
export interface StrictTypeLike extends TypeLike { readonly __typename: string }
export function isInstanceOf<T extends TypeLike, U extends string>(typ: T, typename: U): typ is InstanceOf<T, U> {
  return typ.__typename === typename;
}
export const NetGrossFragmentDoc = /*#__PURE__*/ gql`
    fragment NetGross on NetGross {
  net
  gross
}
    `;
export const AllBonusesDrawerBonusFragmentDoc = /*#__PURE__*/ gql`
    fragment AllBonusesDrawer_Bonus on Bonus {
  id
  paidOutAt
  createdAt
  note
  revoked
  applyAt
  amount {
    ...NetGross
  }
  ... on OtherBonus {
    description
  }
}
    ${NetGrossFragmentDoc}`;
export const AllBonusesDrawerCurrencyFragmentDoc = /*#__PURE__*/ gql`
    fragment AllBonusesDrawer_Currency on TimeBasedCurrency {
  value
  history {
    applyDate
    value
  }
  futureUpdates {
    applyDate
    value
  }
}
    `;
export const AnnualLeaveEntitlementValueFragmentDoc = /*#__PURE__*/ gql`
    fragment AnnualLeaveEntitlementValue on AnnualLeaveEntitlementValue {
  days
  minutes
}
    `;
export const AnnualLeaveBalanceFragmentDoc = /*#__PURE__*/ gql`
    fragment AnnualLeaveBalance on AnnualLeaveBalance {
  entitlement {
    ...AnnualLeaveEntitlementValue
  }
  used {
    ...AnnualLeaveEntitlementValue
  }
  available {
    ...AnnualLeaveEntitlementValue
  }
}
    ${AnnualLeaveEntitlementValueFragmentDoc}`;
export const AnnualLeaveSummaryHistoryFragmentDoc = /*#__PURE__*/ gql`
    fragment AnnualLeaveSummary_History on AnnualLeaveSummary {
  yearlySummary {
    key
    value {
      year
      totalBalance {
        ...AnnualLeaveBalance
      }
      balanceThisYear {
        ...AnnualLeaveBalance
      }
      carriedOverEntitlementBalance {
        ...AnnualLeaveBalance
      }
    }
  }
}
    ${AnnualLeaveBalanceFragmentDoc}`;
export const BenefitAdditionalPeopleFragmentDoc = /*#__PURE__*/ gql`
    fragment BenefitAdditionalPeople on BenefitAdditionalPeople {
  ... on BenefitAdditionalAdults {
    adults
  }
  ... on BenefitAdditionalKids {
    kids
  }
  ... on BenefitAdditionalFamily {
    adults
    kids
  }
}
    `;
export const VatTypeFragmentDoc = /*#__PURE__*/ gql`
    fragment VatType on VatType {
  ... on VatApplied {
    value
  }
  ... on VatNotApplied {
    reason
  }
}
    `;
export const BenefitVariantRateFragmentDoc = /*#__PURE__*/ gql`
    fragment BenefitVariantRate on BenefitVariantRate {
  vat {
    ...VatType
  }
  netGross {
    net
    gross
  }
  period
}
    ${VatTypeFragmentDoc}`;
export const AssignBenefitDrawerBenefitVariantFragmentDoc = /*#__PURE__*/ gql`
    fragment AssignBenefitDrawer_BenefitVariant on BenefitVariant {
  id
  entityVersion
  startDate
  endDate
  productId
  buyerType
  contractTypes
  description
  parent {
    id
    entityVersion
    alternativeBenefitsGroupId
    name
    ... on Benefit {
      benefitParent: parent
    }
  }
  additionalPeople {
    ...BenefitAdditionalPeople
  }
  promiseeRate {
    value {
      ...BenefitVariantRate
    }
  }
  promisorRate {
    value {
      ...BenefitVariantRate
    }
    history {
      value {
        value {
          period
        }
      }
      applyDate
      activityId
    }
    futureUpdates {
      value {
        value {
          period
        }
      }
      applyDate
      activityId
    }
  }
}
    ${BenefitAdditionalPeopleFragmentDoc}
${BenefitVariantRateFragmentDoc}`;
export const AddressFragmentDoc = /*#__PURE__*/ gql`
    fragment Address on Address {
  country
  region
  city
  postalCode
  streetLine
}
    `;
export const ExternalBeneficiaryFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalBeneficiary on ExternalBeneficiary {
  id
  firstName
  lastName
  email
  address {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const AssignBenefitDrawerAssignedVariantFragmentDoc = /*#__PURE__*/ gql`
    fragment AssignBenefitDrawer_AssignedVariant on AssignedVariant {
  id
  variant {
    value {
      ...AssignBenefitDrawer_BenefitVariant
    }
    futureUpdates {
      activityId
      applyDate
      value {
        ...AssignBenefitDrawer_BenefitVariant
      }
    }
    history {
      activityId
      applyDate
      value {
        ...AssignBenefitDrawer_BenefitVariant
      }
    }
  }
  invoiceTo {
    value {
      ...ExternalBeneficiary
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          ...ExternalBeneficiary
        }
      }
    }
    history {
      activityId
      applyDate
      value {
        value {
          ...ExternalBeneficiary
        }
      }
    }
  }
  externalBeneficiaries {
    value {
      ...ExternalBeneficiary
    }
    futureUpdates {
      activityId
      applyDate
      value {
        ...ExternalBeneficiary
      }
    }
    history {
      activityId
      applyDate
      value {
        ...ExternalBeneficiary
      }
    }
  }
  active {
    value
    futureUpdates {
      activityId
      applyDate
      value
    }
    history {
      activityId
      applyDate
      value
    }
  }
  buyerType {
    value
    futureUpdates {
      activityId
      applyDate
      value
    }
    history {
      activityId
      applyDate
      value
    }
  }
}
    ${AssignBenefitDrawerBenefitVariantFragmentDoc}
${ExternalBeneficiaryFragmentDoc}`;
export const UnauthorizedFragmentDoc = /*#__PURE__*/ gql`
    fragment Unauthorized on Unauthorized {
  reason
}
    `;
export const AssignBenefitDrawerRateFragmentDoc = /*#__PURE__*/ gql`
    fragment AssignBenefitDrawer_Rate on TimeBasedRate {
  value {
    settlement
  }
  history {
    value {
      settlement
    }
    applyDate
    activityId
  }
  futureUpdates {
    value {
      settlement
    }
    applyDate
    activityId
  }
}
    `;
export const AssignBenefitDrawerContractFragmentDoc = /*#__PURE__*/ gql`
    fragment AssignBenefitDrawer_Contract on Contract {
  id
  entityVersion
  terminationDate
  startDate
  ... on B2BContract {
    b2bContractType: type
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          ...AssignBenefitDrawer_Rate
        }
      }
    }
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          value
          futureUpdates {
            applyDate
            activityId
            value
          }
          history {
            applyDate
            activityId
            value
          }
        }
      }
    }
  }
  ... on EmploymentContract {
    employmentContractType: type
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          ...AssignBenefitDrawer_Rate
        }
      }
    }
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          value
          futureUpdates {
            applyDate
            activityId
            value
          }
          history {
            applyDate
            activityId
            value
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${AssignBenefitDrawerRateFragmentDoc}`;
export const AssignBenefitsDrawerCurrencyFragmentDoc = /*#__PURE__*/ gql`
    fragment AssignBenefitsDrawer_Currency on TimeBasedCurrency {
  value
  history {
    activityId
    value
    applyDate
  }
  futureUpdates {
    activityId
    value
    applyDate
  }
}
    `;
export const CompanyAutocompleteCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyAutocomplete_Company on Company {
  id
  entityVersion
  name
  logo
  taxNumber
  euVatType {
    value {
      value
    }
  }
}
    `;
export const B2BContractDraftDrawerDraftFragmentDoc = /*#__PURE__*/ gql`
    fragment B2BContractDraftDrawer_Draft on ContractDraft {
  id
  entityVersion
  ... on B2BContractDraft {
    name
    scopeOfWork
    startDate
    expectedEndDate
    position
    b2bContractType: type
    holidayCalendar {
      id
    }
    promisee {
      id
      entityVersion
    }
    promisor {
      ...CompanyAutocomplete_Company
    }
    promiseeCompany {
      ...CompanyAutocomplete_Company
    }
  }
}
    ${CompanyAutocompleteCompanyFragmentDoc}`;
export const B2BContractDraftDrawerUserFragmentDoc = /*#__PURE__*/ gql`
    fragment B2BContractDraftDrawer_User on User {
  id
  entityVersion
  firstName
  lastName
  email
  emergencyContact {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
  pesel {
    ...Unauthorized
    ... on AccessGranted__OptionalPESEL {
      value
    }
  }
  birthDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const B2BSalariesDetailsDrawerInvoiceDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment B2BSalariesDetailsDrawer_InvoiceDetails on InvoiceDetails {
  id
  correct
  number
  userNote
  adminNote
  ksefNumber
  saldeoDocumentUrl
  currency
  grossValue
  file {
    downloadUrl
    openUrl
    fileName
  }
}
    `;
export const RateFragmentDoc = /*#__PURE__*/ gql`
    fragment Rate on Rate {
  settlement
  amount {
    ...NetGross
  }
}
    ${NetGrossFragmentDoc}`;
export const RateDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment RateDetails on RateDetails {
  rate {
    ...Rate
  }
  overtimeRate {
    ...NetGross
  }
  vat
  currency
  rateIncreaseDueToRefundedBenefits {
    ...NetGross
  }
}
    ${RateFragmentDoc}
${NetGrossFragmentDoc}`;
export const DailyIncomeRowFragmentDoc = /*#__PURE__*/ gql`
    fragment DailyIncomeRow on DailyIncomeRow {
  workDays
  value {
    ...NetGross
  }
  rateAmount {
    ...NetGross
  }
}
    ${NetGrossFragmentDoc}`;
export const HourlyIncomeRowFragmentDoc = /*#__PURE__*/ gql`
    fragment HourlyIncomeRow on HourlyIncomeRow {
  workHours
  rateAmount {
    ...NetGross
  }
  rateIncreaseDueToRefundedBenefits {
    ...NetGross
  }
  valueWithoutRateIncrease {
    ...NetGross
  }
  valueIncludingRateIncrease {
    ...NetGross
  }
}
    ${NetGrossFragmentDoc}`;
export const MonthlyIncomeRowFragmentDoc = /*#__PURE__*/ gql`
    fragment MonthlyIncomeRow on MonthlyIncomeRow {
  rateAmount {
    ...NetGross
  }
}
    ${NetGrossFragmentDoc}`;
export const IncomeRowFragmentDoc = /*#__PURE__*/ gql`
    fragment IncomeRow on IncomeRow {
  ...DailyIncomeRow
  ...HourlyIncomeRow
  ...MonthlyIncomeRow
}
    ${DailyIncomeRowFragmentDoc}
${HourlyIncomeRowFragmentDoc}
${MonthlyIncomeRowFragmentDoc}`;
export const B2BSalariesDetailsDrawerBenefitValueFragmentDoc = /*#__PURE__*/ gql`
    fragment B2BSalariesDetailsDrawer_BenefitValue on BenefitValue {
  variant {
    id
    productId
    promiseeRate {
      value {
        ...BenefitVariantRate
      }
    }
    promisorRate {
      value {
        ...BenefitVariantRate
      }
    }
    parent {
      id
      name
      alternativeBenefitsGroupId
    }
  }
  refundedValue {
    ...NetGross
  }
  notRefundedValue {
    ...NetGross
  }
  totalValue {
    ...NetGross
  }
}
    ${BenefitVariantRateFragmentDoc}
${NetGrossFragmentDoc}`;
export const B2BSalariesDetailsDrawerIncomeDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment B2BSalariesDetailsDrawer_IncomeDetails on IncomeDetails {
  totalWorkTime
  overtimeWorkTime
  standardWorkTime
  rateDetails {
    ...RateDetails
  }
  rateDetails {
    ...RateDetails
  }
  totalPayout {
    ...NetGross
  }
  totalValueStandardTimeIncome {
    ...NetGross
  }
  totalValueOvertimeIncome {
    ...NetGross
  }
  standardTimeIncome {
    ...IncomeRow
  }
  overtimeIncome {
    ...IncomeRow
  }
  totalValueOnCalls {
    ...NetGross
  }
  totalValueBonuses {
    ...NetGross
  }
  bonusesValueByCategory {
    bonusCategory
    amount {
      ...NetGross
    }
  }
  totalValueStandardTimeIncomeIncludingBenefits {
    ...NetGross
  }
  totalValueOvertimeIncomeIncludingBenefits {
    ...NetGross
  }
  onCallLogs {
    multiplier
    shifts
  }
  benefitsValue {
    totalValueRefunded {
      ...NetGross
    }
    refunded {
      ...B2BSalariesDetailsDrawer_BenefitValue
    }
    totalValueNotRefunded {
      ...NetGross
    }
    notRefunded {
      ...B2BSalariesDetailsDrawer_BenefitValue
    }
    totalValueThirdParty {
      ...NetGross
    }
    thirdParty {
      ...B2BSalariesDetailsDrawer_BenefitValue
    }
    totalValueAll {
      ...NetGross
    }
  }
}
    ${RateDetailsFragmentDoc}
${NetGrossFragmentDoc}
${IncomeRowFragmentDoc}
${B2BSalariesDetailsDrawerBenefitValueFragmentDoc}`;
export const IncompleteDataDescriptionFragmentDoc = /*#__PURE__*/ gql`
    fragment IncompleteDataDescription on IncompleteDataDescription {
  ... on AccountingDataMissing {
    __typename
  }
  ... on InvoiceMissing {
    __typename
  }
  ... on InvoiceUnchecked {
    __typename
  }
  ... on NoBankAccount {
    __typename
  }
  ... on TimeReportIncomplete {
    __typename
  }
  ... on WhiteListInvalid {
    __typename
  }
  ... on InvoiceFileMissing {
    __typename
  }
}
    `;
export const SalaryStateFragmentDoc = /*#__PURE__*/ gql`
    fragment SalaryState on SalaryState {
  __typename
  ... on PaymentDisbursed {
    disbursedAt
    transferState {
      __typename
    }
  }
  ... on IncompleteData {
    description {
      ...IncompleteDataDescription
    }
  }
}
    ${IncompleteDataDescriptionFragmentDoc}`;
export const B2BSalariesListItemSalaryStateChangeFragmentDoc = /*#__PURE__*/ gql`
    fragment B2BSalariesListItem_SalaryStateChange on ListOfContractSalaryDetailsResponse {
  value {
    contractId
    yearMonth
    salaryState {
      ...SalaryState
    }
  }
}
    ${SalaryStateFragmentDoc}`;
export const BankTransfersImportModalImportResultFragmentDoc = /*#__PURE__*/ gql`
    fragment BankTransfersImportModal_ImportResult on ListOfBankTransferResponse {
  value {
    id
    amount
    operationDate
    currency
    fromName
    toName
    title
  }
}
    `;
export const BenefitsAssignmentsAssignedVariantFragmentDoc = /*#__PURE__*/ gql`
    fragment BenefitsAssignments_AssignedVariant on AssignedVariant {
  id
  active {
    value
    history {
      applyDate
      value
    }
    futureUpdates {
      applyDate
      value
    }
  }
  buyerType {
    value
  }
  variant {
    value {
      id
      productId
      productName
      parent {
        id
        name
      }
    }
  }
  user {
    id
    firstName
    lastName
    avatar
  }
  contract {
    id
    name
  }
}
    `;
export const BenefitsProductsVariantFragmentDoc = /*#__PURE__*/ gql`
    fragment BenefitsProducts_Variant on BenefitVariant {
  id
  entityVersion
  productId
  productName
  contractTypes
  promiseeRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      applyDate
      activityId
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  promisorRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      applyDate
      activityId
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  additionalPeople {
    ...BenefitAdditionalPeople
  }
  buyerType
  startDate
  endDate
  description
  meansOfProduction
  invoiceCategory
}
    ${BenefitVariantRateFragmentDoc}
${BenefitAdditionalPeopleFragmentDoc}`;
export const BenefitsProductsBenefitCommonFragmentDoc = /*#__PURE__*/ gql`
    fragment BenefitsProducts_BenefitCommon on BenefitCommon {
  id
  entityVersion
  name
  startDate
  endDate
  variants {
    ...BenefitsProducts_Variant
  }
}
    ${BenefitsProductsVariantFragmentDoc}`;
export const BlockOfficeModalOfficeSettingsFragmentDoc = /*#__PURE__*/ gql`
    fragment BlockOfficeModal_OfficeSettings on OfficeSettings {
  office {
    officeId
    blocked
    entityVersion
  }
}
    `;
export const ApprovalFragmentDoc = /*#__PURE__*/ gql`
    fragment Approval on Approval {
  ... on Approved {
    by {
      id
      firstName
      lastName
    }
    at
  }
  ... on PendingApproval {
    isCurrentUserAllowedToApprove
  }
}
    `;
export const BonusDrawerBonusFragmentDoc = /*#__PURE__*/ gql`
    fragment BonusDrawer_Bonus on Bonus {
  id
  note
  revoked
  allocateCostToProject {
    id
    name
  }
  applyAt
  amount {
    ...NetGross
  }
  revoked
  approval {
    ...Approval
  }
  taxation {
    taxApplicable
    zusApplicable
  }
  ... on EmployeeReferralBonus {
    referredEmployeeContract {
      id
      promisee {
        id
        entityVersion
        firstName
        lastName
        progressionLevel {
          value
        }
        contracts {
          ...Unauthorized
          ... on AccessGranted__ListOfContract {
            value {
              id
            }
          }
        }
        avatar
        email
      }
    }
  }
  ... on LanguageLearningBonus {
    quarterYear {
      quarter
      year
    }
    language
  }
  ... on OtherBonus {
    description
  }
  ... on CostRechargeBonus {
    description
  }
}
    ${NetGrossFragmentDoc}
${ApprovalFragmentDoc}
${UnauthorizedFragmentDoc}`;
export const BonusDrawerCurrencyFragmentDoc = /*#__PURE__*/ gql`
    fragment BonusDrawer_Currency on TimeBasedCurrency {
  value
  futureUpdates {
    value
    applyDate
    activityId
  }
  history {
    value
    applyDate
    activityId
  }
}
    `;
export const BonusPreviewCurrencyFragmentDoc = /*#__PURE__*/ gql`
    fragment BonusPreview_Currency on TimeBasedCurrency {
  value
  futureUpdates {
    applyDate
    value
  }
  history {
    applyDate
    value
  }
}
    `;
export const BonusPreviewBonusFragmentDoc = /*#__PURE__*/ gql`
    fragment BonusPreview_Bonus on Bonus {
  id
  note
  revoked
  applyAt
  allocateCostToProject {
    id
    name
  }
  amount {
    ...NetGross
  }
  taxation {
    taxApplicable
    zusApplicable
  }
  ... on EmployeeReferralBonus {
    referredEmployeeContract {
      id
      entityVersion
      name
      startDate
      status
      promisee {
        id
        entityVersion
        firstName
        lastName
        progressionLevel {
          value
        }
        contracts {
          ...Unauthorized
          ... on AccessGranted__ListOfContract {
            value {
              id
            }
          }
        }
        avatar
        email
      }
    }
  }
  ... on LanguageLearningBonus {
    quarterYear {
      quarter
    }
    language
  }
  ... on OtherBonus {
    description
  }
  ... on CostRechargeBonus {
    description
  }
}
    ${NetGrossFragmentDoc}
${UnauthorizedFragmentDoc}`;
export const ClientContractDetailsFutureUpdatesFragmentDoc = /*#__PURE__*/ gql`
    fragment ClientContractDetails_FutureUpdates on ClientContract {
  id
  entityVersion
  positions {
    ...Unauthorized
    ... on AccessGranted__ListOfClientPosition {
      value {
        id
        name
        createdAt
        serviceLine {
          value
          history {
            applyDate
            activityId
            value {
              value
            }
          }
          futureUpdates {
            applyDate
            activityId
            value {
              value
            }
          }
        }
        assignments {
          user {
            id
            firstName
            lastName
            avatar
          }
          project {
            id
            name
          }
          periods {
            dateRange {
              from
              to
            }
            clientPosition {
              ...Unauthorized
              ... on AccessGranted__ClientPosition {
                value {
                  id
                }
              }
            }
            subcontractPosition {
              ...Unauthorized
              ... on AccessGranted__OptionalClientPosition {
                value {
                  id
                }
              }
            }
          }
        }
        rateNet {
          value {
            daily
            hourly
          }
          history {
            applyDate
            activityId
            value {
              daily
              hourly
            }
          }
          futureUpdates {
            applyDate
            activityId
            value {
              daily
              hourly
            }
          }
        }
        overtimeNet {
          value {
            daily
            hourly
          }
          history {
            applyDate
            activityId
            value {
              value {
                daily
                hourly
              }
            }
          }
          futureUpdates {
            applyDate
            activityId
            value {
              value {
                daily
                hourly
              }
            }
          }
        }
        active {
          value
          history {
            applyDate
            activityId
            value
          }
          futureUpdates {
            applyDate
            activityId
            value
          }
        }
        currency {
          value
          futureUpdates {
            value
            applyDate
            activityId
          }
          history {
            value
            applyDate
            activityId
          }
        }
        onCallRates {
          value {
            night
            weekend
            holiday
          }
          history {
            applyDate
            activityId
            value {
              value {
                night
                weekend
                holiday
              }
            }
          }
          futureUpdates {
            value {
              value {
                night
                weekend
                holiday
              }
            }
            applyDate
            activityId
          }
        }
      }
    }
  }
  vat {
    ...Unauthorized
    ... on AccessGranted__TimeBasedOptClearableBasisPoint {
      value {
        value
        futureUpdates {
          value {
            value
          }
          applyDate
          activityId
        }
        history {
          value {
            value
          }
          applyDate
          activityId
        }
      }
    }
  }
  currency {
    ...Unauthorized
    ... on AccessGranted__TimeBasedOptCurrency {
      value {
        value
        futureUpdates {
          value
          applyDate
          activityId
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const CompanyDetailsDrawerVatsFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyDetailsDrawer_Vats on Company {
  id
  entityVersion
  isPolishVat {
    value {
      value
      state {
        ... on VerifiedWithDescriptionBooleanVATStatus {
          result
          when
        }
      }
    }
  }
  euVatType {
    value {
      value
      state {
        ... on VerifiedEuVatType {
          result
          when
        }
      }
    }
  }
  isOtherVatType {
    value
  }
}
    `;
export const CompanyDetailsDrawerCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyDetailsDrawer_Company on Company {
  id
  entityVersion
  isPolishVat {
    value {
      value
      state {
        ... on VerifiedWithDescriptionBooleanVATStatus {
          result
          when
        }
      }
    }
  }
  euVatType {
    value {
      value
      state {
        ... on VerifiedEuVatType {
          result
          when
        }
      }
    }
  }
}
    `;
export const BankAccountNumberFragmentDoc = /*#__PURE__*/ gql`
    fragment BankAccountNumber on BankAccountNumber {
  value
}
    `;
export const BankAccountVerificationStateFragmentDoc = /*#__PURE__*/ gql`
    fragment BankAccountVerificationState on VerifiedBankAccountStatus {
  result
  when
}
    `;
export const BankAccountFragmentDoc = /*#__PURE__*/ gql`
    fragment BankAccount on BankAccount {
  accountNumber {
    ...BankAccountNumber
  }
  bic
  currency
  description
  monitorTransfers
  verificationState {
    ...BankAccountVerificationState
  }
}
    ${BankAccountNumberFragmentDoc}
${BankAccountVerificationStateFragmentDoc}`;
export const ContractBankAccountDrawerCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractBankAccountDrawer_Company on Company {
  id
  entityVersion
  companyType
  defaultBankAccount {
    accountNumber {
      ...BankAccountNumber
    }
  }
  bankAccounts {
    ...BankAccount
  }
}
    ${BankAccountNumberFragmentDoc}
${BankAccountFragmentDoc}`;
export const ContractBankAccountDrawerDraftContractFieldsPromiseeFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractBankAccountDrawer_DraftContractFieldsPromisee on ContractDraft {
  id
  entityVersion
  ... on B2BContractDraft {
    promiseeCompany {
      ...ContractBankAccountDrawer_Company
    }
    promiseeCompanyTransferBankAccount {
      ...BankAccount
    }
  }
}
    ${ContractBankAccountDrawerCompanyFragmentDoc}
${BankAccountFragmentDoc}`;
export const ContractBankAccountDrawerDraftContractFieldsPromisorFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractBankAccountDrawer_DraftContractFieldsPromisor on ContractDraft {
  id
  entityVersion
  promisorTransferBankAccount {
    value {
      ...BankAccount
    }
  }
  promisor {
    ...ContractBankAccountDrawer_Company
  }
}
    ${BankAccountFragmentDoc}
${ContractBankAccountDrawerCompanyFragmentDoc}`;
export const ContractBankAccountDrawerContractFieldsPromisorFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractBankAccountDrawer_ContractFieldsPromisor on Contract {
  id
  entityVersion
  terminationDate
  startDate
  promisee {
    id
    entityVersion
  }
  promisorTransferBankAccount {
    value {
      ...BankAccount
    }
  }
  promisor {
    value {
      ...ContractBankAccountDrawer_Company
    }
  }
}
    ${BankAccountFragmentDoc}
${ContractBankAccountDrawerCompanyFragmentDoc}`;
export const ContractBankAccountDrawerContractFieldsPromiseeFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractBankAccountDrawer_ContractFieldsPromisee on Contract {
  id
  entityVersion
  terminationDate
  startDate
  promisee {
    id
    entityVersion
  }
  ... on B2BContract {
    promiseeCompany {
      ...Unauthorized
      ... on AccessGranted__Company {
        value {
          ...ContractBankAccountDrawer_Company
        }
      }
    }
    promiseeCompanyTransferBankAccount {
      ...Unauthorized
      ... on AccessGranted__OptionalBankAccount {
        value {
          ...BankAccount
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${ContractBankAccountDrawerCompanyFragmentDoc}
${BankAccountFragmentDoc}`;
export const ContractBenefitsCurrencyFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractBenefits_Currency on TimeBasedCurrency {
  value
  futureUpdates {
    applyDate
    activityId
    value
  }
  history {
    applyDate
    activityId
    value
  }
}
    `;
export const ContractBonusesCurrencyFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractBonuses_Currency on TimeBasedCurrency {
  value
  futureUpdates {
    applyDate
    value
  }
  history {
    applyDate
    value
  }
}
    `;
export const ContractBonusesBonusFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractBonuses_Bonus on Bonus {
  id
  createdAt
  paidOutAt
  note
  revoked
  amount {
    ...NetGross
  }
  applyAt
  ... on OtherBonus {
    description
  }
}
    ${NetGrossFragmentDoc}`;
export const ContractDetailsCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractDetails_Company on Company {
  id
  entityVersion
  taxNumber
  name
  logo
  address {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const ContractDetailsUserFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractDetails_User on User {
  id
  entityVersion
  firstName
  lastName
  pesel {
    ...Unauthorized
    ... on AccessGranted__OptionalPESEL {
      value
    }
  }
  idType {
    ...Unauthorized
    ... on AccessGranted__OptionalIDType {
      value
    }
  }
  idNumber {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
  address {
    ...Unauthorized
    ... on AccessGranted__OptionalAddress {
      value {
        ...Address
      }
    }
  }
  mailingAddress {
    ...Unauthorized
    ... on AccessGranted__OptionalAddress {
      value {
        ...Address
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${AddressFragmentDoc}`;
export const ContractDetailsDrawerContractFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractDetailsDrawer_Contract on Contract {
  id
  entityVersion
  startDate
  terminationDate
  ... on EmploymentContract {
    type
    position {
      value
      history {
        activityId
        applyDate
        value {
          value
        }
      }
      futureUpdates {
        activityId
        applyDate
        value {
          value
        }
      }
    }
    scopeOfWork {
      ...Unauthorized
      ... on AccessGranted__TimeBasedString {
        value {
          value
          history {
            activityId
            applyDate
            value
          }
          futureUpdates {
            activityId
            applyDate
            value
          }
        }
      }
    }
    paidLeaveEntitlement {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableDays {
        value {
          value
          futureUpdates {
            activityId
            applyDate
            value {
              value
            }
          }
          history {
            activityId
            value {
              value
            }
            applyDate
          }
        }
      }
    }
    annualLeaveEntitlement {
      ...Unauthorized
      ... on AccessGranted__OptionalAnnualLeaveEntitlement {
        value {
          history {
            entitlement {
              ...AnnualLeaveEntitlementValue
            }
          }
        }
      }
    }
  }
  ... on B2BContract {
    position {
      value
      history {
        activityId
        applyDate
        value {
          value
        }
      }
      futureUpdates {
        activityId
        applyDate
        value {
          value
        }
      }
    }
    scopeOfWork {
      ...Unauthorized
      ... on AccessGranted__TimeBasedString {
        value {
          value
          history {
            activityId
            applyDate
            value
          }
          futureUpdates {
            activityId
            applyDate
            value
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${AnnualLeaveEntitlementValueFragmentDoc}`;
export const ContractDetailsSectionPositionFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractDetailsSection_Position on TimeBasedOptClearableString {
  value
  futureUpdates {
    activityId
    applyDate
    value {
      value
    }
  }
  history {
    activityId
    applyDate
    value {
      value
    }
  }
}
    `;
export const ContractDetailsSectionScopeOfWorkFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractDetailsSection_ScopeOfWork on AccessGranted__TimeBasedString {
  value {
    value
    futureUpdates {
      activityId
      applyDate
      value
    }
    history {
      activityId
      value
      applyDate
    }
  }
}
    `;
export const ContractDetailsSectionPaidLeaveFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractDetailsSection_PaidLeave on AccessGranted__TimeBasedOptClearableDays {
  value {
    value
    futureUpdates {
      activityId
      applyDate
      value {
        value
      }
    }
    history {
      activityId
      value {
        value
      }
      applyDate
    }
  }
}
    `;
export const ContractDetailsSectionContractFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractDetailsSection_Contract on Contract {
  id
  entityVersion
  startDate
  ... on B2BContract {
    position {
      ...ContractDetailsSection_Position
    }
    scopeOfWork {
      ...Unauthorized
      ...ContractDetailsSection_ScopeOfWork
    }
  }
  ... on EmploymentContract {
    type
    position {
      ...ContractDetailsSection_Position
    }
    scopeOfWork {
      ...Unauthorized
      ...ContractDetailsSection_ScopeOfWork
    }
    paidLeaveEntitlement {
      ...Unauthorized
      ...ContractDetailsSection_PaidLeave
    }
  }
}
    ${ContractDetailsSectionPositionFragmentDoc}
${UnauthorizedFragmentDoc}
${ContractDetailsSectionScopeOfWorkFragmentDoc}
${ContractDetailsSectionPaidLeaveFragmentDoc}`;
export const ContractDraftDetailsCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractDraftDetails_Company on Company {
  id
  entityVersion
  taxNumber
  name
  defaultBankAccount {
    accountNumber {
      ...BankAccountNumber
    }
  }
  bankAccounts {
    ...BankAccount
  }
  address {
    ...Address
  }
  mailingAddress {
    ...Address
  }
}
    ${BankAccountNumberFragmentDoc}
${BankAccountFragmentDoc}
${AddressFragmentDoc}`;
export const ContractPaymentDetailsCurrencyFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractPaymentDetails_Currency on TimeBasedCurrency {
  value
  futureUpdates {
    activityId
    applyDate
    value
  }
  history {
    activityId
    applyDate
    value
  }
}
    `;
export const ContractPaymentDetailsRateFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractPaymentDetails_Rate on TimeBasedRate {
  value {
    ...Rate
  }
  futureUpdates {
    activityId
    applyDate
    value {
      ...Rate
    }
  }
  history {
    activityId
    applyDate
    value {
      ...Rate
    }
  }
}
    ${RateFragmentDoc}`;
export const ContractPaymentDetailsOvertimeRateFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractPaymentDetails_OvertimeRate on TimeBasedOptClearableNetGross {
  value {
    ...NetGross
  }
  futureUpdates {
    activityId
    applyDate
    value {
      value {
        ...NetGross
      }
    }
  }
  history {
    activityId
    applyDate
    value {
      value {
        ...NetGross
      }
    }
  }
}
    ${NetGrossFragmentDoc}`;
export const ContractPaymentDetailsOnCallFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractPaymentDetails_OnCall on TimeBasedOptClearableOnCallRate {
  value {
    night {
      ...NetGross
    }
    holiday {
      ...NetGross
    }
    weekend {
      ...NetGross
    }
  }
  futureUpdates {
    activityId
    applyDate
    value {
      value {
        night {
          ...NetGross
        }
        holiday {
          ...NetGross
        }
        weekend {
          ...NetGross
        }
      }
    }
  }
  history {
    activityId
    applyDate
    value {
      value {
        night {
          ...NetGross
        }
        holiday {
          ...NetGross
        }
        weekend {
          ...NetGross
        }
      }
    }
  }
}
    ${NetGrossFragmentDoc}`;
export const WorkingTimeFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkingTime on WorkingTime {
  numerator
  denominator
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
}
    `;
export const ContractPaymentDetailsBenefitVariantFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractPaymentDetails_BenefitVariant on BenefitVariant {
  id
  parent {
    id
    name
    alternativeBenefitsGroupId
  }
  promisorRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      applyDate
      activityId
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  promiseeRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      applyDate
      activityId
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
}
    ${BenefitVariantRateFragmentDoc}`;
export const ContractPaymentDetailsFutureUpdatesFragmentDoc = /*#__PURE__*/ gql`
    fragment ContractPaymentDetails_FutureUpdates on Contract {
  id
  entityVersion
  startDate
  terminationDate
  ... on B2BContract {
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          ...ContractPaymentDetails_Currency
        }
      }
    }
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          ...ContractPaymentDetails_Rate
        }
      }
    }
    overtimeRate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableNetGross {
        value {
          ...ContractPaymentDetails_OvertimeRate
        }
      }
    }
    onCall {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableOnCallRate {
        value {
          ...ContractPaymentDetails_OnCall
        }
      }
    }
    separatePaymentForBenefits {
      ...Unauthorized
      ... on AccessGranted__TimeBasedBoolean {
        value {
          value
          futureUpdates {
            activityId
            applyDate
            value
          }
        }
      }
    }
    vat {
      ...Unauthorized
      ... on AccessGranted__TimeBasedVatType {
        value {
          value {
            ...VatType
          }
          futureUpdates {
            activityId
            applyDate
            value {
              ...VatType
            }
          }
        }
      }
    }
  }
  ... on EmploymentContract {
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          ...ContractPaymentDetails_Currency
        }
      }
    }
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          ...ContractPaymentDetails_Rate
        }
      }
    }
    overtimeRate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableNetGross {
        value {
          ...ContractPaymentDetails_OvertimeRate
        }
      }
    }
    onCall {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableOnCallRate {
        value {
          ...ContractPaymentDetails_OnCall
        }
      }
    }
    ppk {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableBasisPoint {
        value {
          value
          futureUpdates {
            activityId
            applyDate
            value {
              value
            }
          }
          history {
            activityId
            applyDate
            value {
              value
            }
          }
        }
      }
    }
    taxDeductibleCosts {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableDeductibleCostsType {
        value {
          value
          futureUpdates {
            activityId
            applyDate
            value {
              value
            }
          }
          history {
            activityId
            applyDate
            value {
              value
            }
          }
        }
      }
    }
    copyrightCosts {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableBasisPoint {
        value {
          value
          futureUpdates {
            activityId
            applyDate
            value {
              value
            }
          }
          history {
            activityId
            applyDate
            value {
              value
            }
          }
        }
      }
    }
    workingTime {
      ...Unauthorized
      ... on AccessGranted__TimeBasedWorkingTime {
        value {
          value {
            ...WorkingTime
          }
          history {
            activityId
            applyDate
            value {
              ...WorkingTime
            }
          }
          futureUpdates {
            activityId
            applyDate
            value {
              ...WorkingTime
            }
          }
        }
      }
    }
    applyRemoteWorkReimbursement {
      ...Unauthorized
      ... on AccessGranted__TimeBasedBoolean {
        value {
          value
          futureUpdates {
            activityId
            applyDate
            value
          }
          history {
            activityId
            applyDate
            value
          }
        }
      }
    }
  }
  assignedVariants(activeOnly: false) {
    ...Unauthorized
    ... on AccessGranted__ListOfAssignedVariant {
      value {
        id
        active {
          value
          futureUpdates {
            activityId
            applyDate
            value
          }
          history {
            activityId
            applyDate
            value
          }
        }
        variant {
          value {
            ...ContractPaymentDetails_BenefitVariant
          }
          futureUpdates {
            activityId
            applyDate
            value {
              ...ContractPaymentDetails_BenefitVariant
            }
          }
          history {
            applyDate
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${ContractPaymentDetailsCurrencyFragmentDoc}
${ContractPaymentDetailsRateFragmentDoc}
${ContractPaymentDetailsOvertimeRateFragmentDoc}
${ContractPaymentDetailsOnCallFragmentDoc}
${VatTypeFragmentDoc}
${WorkingTimeFragmentDoc}
${ContractPaymentDetailsBenefitVariantFragmentDoc}`;
export const CentsWithCurrencyFragmentDoc = /*#__PURE__*/ gql`
    fragment CentsWithCurrency on CentsWithCurrency {
  amount
  currency
}
    `;
export const CostAndRevenueItemDrawerProjectFragmentDoc = /*#__PURE__*/ gql`
    fragment CostAndRevenueItemDrawer_Project on Project {
  id
  entityVersion
  costAndRevenueItems {
    ...Unauthorized
    ... on AccessGranted__ListOfCostAndRevenueItem {
      value {
        tpe
        netValue {
          ...CentsWithCurrency
        }
        date
        description
        serviceLine
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${CentsWithCurrencyFragmentDoc}`;
export const DeskAssignmentDrawerAssignmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DeskAssignmentDrawer_Assignment on DeskAssignment {
  id
  from
  to
  desk {
    id
  }
  user {
    id
    firstName
    lastName
    avatar
  }
}
    `;
export const DeskDrawerDeskFragmentDoc = /*#__PURE__*/ gql`
    fragment DeskDrawer_Desk on Desk {
  id
  name
  monitors
  standing
  pedestalNumber
}
    `;
export const DirectReportingDrawerSpaceFragmentDoc = /*#__PURE__*/ gql`
    fragment DirectReportingDrawer_Space on Space {
  id
  name
  owner {
    id
    firstName
    lastName
  }
}
    `;
export const DirectReportingDrawerUserFragmentDoc = /*#__PURE__*/ gql`
    fragment DirectReportingDrawer_User on User {
  id
  entityVersion
  role {
    value
    futureUpdates {
      applyDate
      activityId
    }
    history {
      applyDate
      activityId
    }
  }
  directReporting {
    primaryProjectId {
      value
      futureUpdates {
        applyDate
        activityId
      }
      history {
        applyDate
        activityId
      }
    }
    practiceLead {
      value {
        id
        firstName
        lastName
        entityVersion
        email
        avatar
      }
      futureUpdates {
        applyDate
        activityId
      }
      history {
        applyDate
        activityId
      }
    }
    operationalLead {
      value {
        id
        firstName
        lastName
        entityVersion
        email
        avatar
      }
      futureUpdates {
        applyDate
        activityId
      }
      history {
        applyDate
        activityId
      }
    }
    space {
      value {
        ...DirectReportingDrawer_Space
      }
      futureUpdates {
        value {
          ...DirectReportingDrawer_Space
        }
        applyDate
        activityId
      }
      history {
        value {
          ...DirectReportingDrawer_Space
        }
        applyDate
        activityId
      }
    }
    assignedProjects(status_oneOf: [Live], orderByFirstPositionStartDate: Desc) {
      ...Unauthorized
      ... on AccessGranted__ListOfProjectAssignment {
        value {
          user {
            id
          }
          project {
            id
            name
          }
        }
      }
    }
  }
}
    ${DirectReportingDrawerSpaceFragmentDoc}
${UnauthorizedFragmentDoc}`;
export const EditBenefitVariantPriceDrawerBenefitVariantFragmentDoc = /*#__PURE__*/ gql`
    fragment EditBenefitVariantPriceDrawer_BenefitVariant on BenefitVariant {
  id
  at
  entityVersion
  promiseeRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
    history {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  promisorRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
    history {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
}
    ${BenefitVariantRateFragmentDoc}`;
export const EditClientContractDrawerContractFragmentDoc = /*#__PURE__*/ gql`
    fragment EditClientContractDrawer_Contract on ClientContract {
  id
  entityVersion
  name {
    ...Unauthorized
    ... on AccessGranted__String {
      value
    }
  }
  contractDurationFrom {
    ...Unauthorized
    ... on AccessGranted__LocalDate {
      value
    }
  }
  contractDurationTo {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  docUri {
    ...Unauthorized
    ... on AccessGranted__OptionalURI {
      value
    }
  }
  promisor {
    ...CompanyAutocomplete_Company
  }
  promisee {
    ...CompanyAutocomplete_Company
  }
}
    ${UnauthorizedFragmentDoc}
${CompanyAutocompleteCompanyFragmentDoc}`;
export const EditOfficeDrawerOfficeFragmentDoc = /*#__PURE__*/ gql`
    fragment EditOfficeDrawer_Office on Office {
  officeId
  name
  validFrom
  validTo
  avatar
  entityVersion
}
    `;
export const EditOfficeSettingsDrawerOfficeSettingsFragmentDoc = /*#__PURE__*/ gql`
    fragment EditOfficeSettingsDrawer_OfficeSettings on OfficeSettings {
  office {
    officeId
    entityVersion
  }
  receptionEmails
  parkingInformation
  floorMap {
    fileName
    openUrl
  }
  parkingMap {
    fileName
    openUrl
  }
}
    `;
export const EditProfileAdditionalDataDrawerUserFragmentDoc = /*#__PURE__*/ gql`
    fragment EditProfileAdditionalDataDrawer_User on User {
  id
  entityVersion
  idType {
    ...Unauthorized
    ... on AccessGranted__OptionalIDType {
      value
    }
  }
  idNumber {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
  pesel {
    ...Unauthorized
    ... on AccessGranted__OptionalPESEL {
      value
    }
  }
  citizenship {
    ...Unauthorized
    ... on AccessGranted__OptionalCountryCode {
      value
    }
  }
  birthDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  nextMedicalExaminationDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  passportExpirationDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  nextOhsTrainingDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  revenueAdministrationOffice {
    ...Unauthorized
    ... on AccessGranted__OptionalRevenueAdministrationOffice {
      value {
        id
        officeName
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const EditProfileAddressDrawerUserFragmentDoc = /*#__PURE__*/ gql`
    fragment EditProfileAddressDrawer_User on User {
  id
  entityVersion
  contactEmail {
    ...Unauthorized
    ... on AccessGranted__OptionalEmailAddress {
      value
    }
  }
  phoneNumber {
    ...Unauthorized
    ... on AccessGranted__OptionalPhoneNumber {
      value
    }
  }
  address {
    ...Unauthorized
    ... on AccessGranted__OptionalAddress {
      value {
        ...Address
      }
    }
  }
  mailingAddress {
    ...Unauthorized
    ... on AccessGranted__OptionalAddress {
      value {
        ...Address
      }
    }
  }
  paczkomat {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
  plateNumber {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
  emergencyContact {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
}
    ${UnauthorizedFragmentDoc}
${AddressFragmentDoc}`;
export const EditProfileBasicInfoDrawerSpaceFragmentDoc = /*#__PURE__*/ gql`
    fragment EditProfileBasicInfoDrawer_Space on Space {
  id
  name
  owner {
    id
    firstName
    lastName
  }
}
    `;
export const EditProfileBasicInfoDrawerUserFragmentDoc = /*#__PURE__*/ gql`
    fragment EditProfileBasicInfoDrawer_User on User {
  id
  entityVersion
  firstName
  lastName
  middleName
  familyName
  areaOfExpertise
  consentedForUseOfImage
  isStudent {
    ...Unauthorized
    ... on AccessGranted__Boolean {
      value
    }
  }
  isStudentRevisionDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  progressionLevel {
    value
  }
  office {
    officeId
  }
  documentsDirectory {
    ...Unauthorized
    ... on AccessGranted__OptionalURI {
      value
    }
  }
  personalDataProcessingAuthorization {
    ...Unauthorized
    ... on AccessGranted__PersonalDataProcessingAuthorization {
      value {
        isAuthorized
        document {
          ...Unauthorized
          ... on AccessGranted__OptionalURI {
            value
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const EditProjectCrossSellDrawerProjectFragmentDoc = /*#__PURE__*/ gql`
    fragment EditProjectCrossSellDrawer_Project on Project {
  id
  entityVersion
  crossSell {
    ...Unauthorized
    ... on AccessGranted__OptionalCrossSell {
      value {
        description
        client {
          ...CompanyAutocomplete_Company
        }
        project {
          id
          name
        }
        space {
          id
          name
          owner {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${CompanyAutocompleteCompanyFragmentDoc}`;
export const EditProjectDrawerProjectFragmentDoc = /*#__PURE__*/ gql`
    fragment EditProjectDrawer_Project on Project {
  id
  entityVersion
  name
  description {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
  areaOfVlEngagement {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
  costLedgerAccountNumber {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
  revenueLedgerAccountNumber {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
  clientContract {
    id
    entityVersion
    promisor {
      ...CompanyAutocomplete_Company
      clientContracts {
        ...Unauthorized
        ... on AccessGranted__ListOfClientContract {
          value {
            id
            entityVersion
            name {
              ...Unauthorized
              ... on AccessGranted__String {
                value
              }
            }
          }
        }
      }
    }
    promisee {
      ...CompanyAutocomplete_Company
      clientContracts {
        ...Unauthorized
        ... on AccessGranted__ListOfClientContract {
          value {
            id
            entityVersion
            name {
              ...Unauthorized
              ... on AccessGranted__String {
                value
              }
            }
          }
        }
      }
    }
  }
  space {
    id
    name
    owner {
      id
      firstName
      lastName
    }
  }
}
    ${UnauthorizedFragmentDoc}
${CompanyAutocompleteCompanyFragmentDoc}`;
export const EditProjectTechStackAndCompetencesDrawerProjectFragmentDoc = /*#__PURE__*/ gql`
    fragment EditProjectTechStackAndCompetencesDrawer_Project on Project {
  id
  entityVersion
  techStack {
    ...Unauthorized
    ... on AccessGranted__ListOfString {
      value
    }
  }
  competences {
    ...Unauthorized
    ... on AccessGranted__ListOfString {
      value
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const EditSkillsAndCertificatesDrawerUserFragmentDoc = /*#__PURE__*/ gql`
    fragment EditSkillsAndCertificatesDrawer_User on User {
  id
  entityVersion
  skillsAndCompetences
  declaredNoCertificates
  certificates {
    ...Unauthorized
    ... on AccessGranted__ListOfCertificate {
      value {
        id
        name
        issueDate
        expirationDate
        file {
          downloadUrl
          fileName
          openUrl
        }
        userId
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const EditSocialMediaHandlesDrawerUserFragmentDoc = /*#__PURE__*/ gql`
    fragment EditSocialMediaHandlesDrawer_User on User {
  id
  entityVersion
  socialMediaHandles {
    ...Unauthorized
    ... on AccessGranted__ListOfSocialMediaHandle {
      value {
        platform
        handle
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const EditSpaceDrawerSpaceFragmentDoc = /*#__PURE__*/ gql`
    fragment EditSpaceDrawer_Space on Space {
  id
  entityVersion
  name
  owner {
    id
    entityVersion
    firstName
    lastName
    email
  }
  directors {
    id
    entityVersion
    firstName
    lastName
    email
    avatar
  }
}
    `;
export const EditVariantDrawerBenefitVariantFragmentDoc = /*#__PURE__*/ gql`
    fragment EditVariantDrawer_BenefitVariant on BenefitVariant {
  id
  entityVersion
  startDate
  endDate
  productId
  productName
  promiseeRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
    history {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  promisorRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
    history {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  additionalPeople {
    ...BenefitAdditionalPeople
  }
  meansOfProduction
  buyerType
  invoiceCategory
  description
}
    ${BenefitVariantRateFragmentDoc}
${BenefitAdditionalPeopleFragmentDoc}`;
export const EmployeeDueDatesDrawerUserFragmentDoc = /*#__PURE__*/ gql`
    fragment EmployeeDueDatesDrawer_User on User {
  id
  entityVersion
  isStudent {
    ...Unauthorized
    ... on AccessGranted__Boolean {
      value
    }
  }
  nextOhsTrainingDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  isStudentRevisionDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  nextMedicalExaminationDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const EmploymentContractDraftDrawerDraftFragmentDoc = /*#__PURE__*/ gql`
    fragment EmploymentContractDraftDrawer_Draft on ContractDraft {
  id
  entityVersion
  ... on EmploymentContractDraft {
    name
    type
    paidLeaveEntitlement
    holidayCalendar {
      id
    }
    startDate
    expectedEndDate
    position
    scopeOfWork
    promisee {
      id
      entityVersion
    }
    promisor {
      ...CompanyAutocomplete_Company
    }
  }
}
    ${CompanyAutocompleteCompanyFragmentDoc}`;
export const EmploymentContractDraftDrawerUserFragmentDoc = /*#__PURE__*/ gql`
    fragment EmploymentContractDraftDrawer_User on User {
  id
  entityVersion
  firstName
  lastName
  idType {
    ...Unauthorized
    ... on AccessGranted__OptionalIDType {
      value
    }
  }
  idNumber {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
  pesel {
    ...Unauthorized
    ... on AccessGranted__OptionalPESEL {
      value
    }
  }
  email
  birthDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  isStudent {
    ...Unauthorized
    ... on AccessGranted__Boolean {
      value
    }
  }
  isStudentRevisionDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  nextMedicalExaminationDate {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  emergencyContact {
    ...Unauthorized
    ... on AccessGranted__OptionalString {
      value
    }
  }
  address {
    ...Unauthorized
    ... on AccessGranted__OptionalAddress {
      value {
        ...Address
      }
    }
  }
  mailingAddress {
    ...Unauthorized
    ... on AccessGranted__OptionalAddress {
      value {
        ...Address
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${AddressFragmentDoc}`;
export const EmploymentSalariesListItemSalaryStateChangeFragmentDoc = /*#__PURE__*/ gql`
    fragment EmploymentSalariesListItem_SalaryStateChange on ListOfContractSalaryDetailsResponse {
  value {
    contractId
    yearMonth
    salaryState {
      ...SalaryState
    }
  }
}
    ${SalaryStateFragmentDoc}`;
export const EmploymentSalaryDetailsDrawerWorkTransferFragmentDoc = /*#__PURE__*/ gql`
    fragment EmploymentSalaryDetailsDrawer_WorkTransfer on WorkTransferProtocol {
  id
  description
  payload {
    ... on File {
      value {
        downloadUrl
        openUrl
        fileName
      }
    }
  }
  approval {
    ...Approval
  }
}
    ${ApprovalFragmentDoc}`;
export const EmploymentSalaryDetailsDrawerAccountingDataFragmentDoc = /*#__PURE__*/ gql`
    fragment EmploymentSalaryDetailsDrawer_AccountingData on AccountingData {
  taxPrepayment
  taxRefund
  zusContribution
  ppkAmount
  maternityLeaveAllowance
  paternityLeaveAllowance
  sicknessBenefit
  overtimePayout
  transferAmount
  zusContributionDetails {
    employeeSocialContribution
    employerSocialContribution
    healthInsuranceContribution
  }
  ppkDetails {
    employee
    employer
  }
}
    `;
export const EmploymentSalariesDetailsDrawerBenefitValueFragmentDoc = /*#__PURE__*/ gql`
    fragment EmploymentSalariesDetailsDrawer_BenefitValue on BenefitValue {
  variant {
    id
    productId
    promiseeRate {
      value {
        ...BenefitVariantRate
      }
    }
    promisorRate {
      value {
        ...BenefitVariantRate
      }
    }
    parent {
      alternativeBenefitsGroupId
      id
      name
    }
  }
  refundedValue {
    ...NetGross
  }
  notRefundedValue {
    ...NetGross
  }
  totalValue {
    ...NetGross
  }
}
    ${BenefitVariantRateFragmentDoc}
${NetGrossFragmentDoc}`;
export const EmploymentSalaryIncomeDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment EmploymentSalaryIncomeDetails on IncomeDetails {
  totalWorkTime
  overtimeWorkTime
  standardWorkTime
  rateDetails {
    ...RateDetails
  }
  remoteWorkReimbursement {
    time
  }
  onCallLogs {
    multiplier
    shifts
  }
  totalPayout {
    ...NetGross
  }
  overtimeIncome {
    ...HourlyIncomeRow
  }
  totalValueStandardTimeIncome {
    ...NetGross
  }
  totalValueOvertimeIncome {
    ...NetGross
  }
  standardTimeIncome {
    ...IncomeRow
  }
  overtimeIncome {
    ...IncomeRow
  }
  totalValueOnCalls {
    ...NetGross
  }
  bonusesValueByCategory {
    bonusCategory
    amount {
      ...NetGross
    }
  }
  totalValueStandardTimeIncomeIncludingBenefits {
    ...NetGross
  }
  totalValueOvertimeIncomeIncludingBenefits {
    ...NetGross
  }
  benefitsValue {
    totalValueRefunded {
      ...NetGross
    }
    refunded {
      ...EmploymentSalariesDetailsDrawer_BenefitValue
    }
    totalValueNotRefunded {
      ...NetGross
    }
    notRefunded {
      ...EmploymentSalariesDetailsDrawer_BenefitValue
    }
    totalValueThirdParty {
      ...NetGross
    }
    thirdParty {
      ...EmploymentSalariesDetailsDrawer_BenefitValue
    }
    totalValueMeansOfProduction {
      ...NetGross
    }
    meansOfProduction {
      ...EmploymentSalariesDetailsDrawer_BenefitValue
    }
    totalValueAll {
      ...NetGross
    }
  }
}
    ${RateDetailsFragmentDoc}
${NetGrossFragmentDoc}
${HourlyIncomeRowFragmentDoc}
${IncomeRowFragmentDoc}
${EmploymentSalariesDetailsDrawerBenefitValueFragmentDoc}`;
export const FriendsAndFamilyBenefitVariantFragmentDoc = /*#__PURE__*/ gql`
    fragment FriendsAndFamily_BenefitVariant on BenefitVariant {
  id
  productId
  startDate
  endDate
  buyerType
  contractTypes
  promiseeRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  promisorRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  parent {
    id
    name
    alternativeBenefitsGroupId
    ... on Benefit {
      benefitParent: parent
    }
  }
  additionalPeople {
    ...BenefitAdditionalPeople
  }
}
    ${BenefitVariantRateFragmentDoc}
${BenefitAdditionalPeopleFragmentDoc}`;
export const InvoiceTransferLinksDraweInvoiceFragmentDoc = /*#__PURE__*/ gql`
    fragment InvoiceTransferLinksDrawe_Invoice on SalesInvoice {
  id
  number
  status
}
    `;
export const InvoiceTransferLinksDrawerPaymentConnectionFragmentDoc = /*#__PURE__*/ gql`
    fragment InvoiceTransferLinksDrawer_PaymentConnection on PaymentConnection {
  transfer {
    id
    amount
    currency
    fromName
    toName
    title
    bookDate
    discrepancy
    status
  }
  invoice {
    ...InvoiceTransferLinksDrawe_Invoice
  }
  tpe
}
    ${InvoiceTransferLinksDraweInvoiceFragmentDoc}`;
export const ManageProjectTimelineDrawerProjectFragmentDoc = /*#__PURE__*/ gql`
    fragment ManageProjectTimelineDrawer_Project on Project {
  id
  entityVersion
  statusHistory {
    status
    dateRange {
      from
      to
    }
  }
}
    `;
export const OfficeCatalogueDeskFragmentDoc = /*#__PURE__*/ gql`
    fragment OfficeCatalogue_Desk on Desk {
  id
  name
  monitors
  standing
  pedestalNumber
  blocked
}
    `;
export const OfficeCatalogueRoomFragmentDoc = /*#__PURE__*/ gql`
    fragment OfficeCatalogue_Room on Room {
  id
  name
  restrictedToSpace {
    id
    name
  }
  securityZone
  blocked
  desks {
    ...OfficeCatalogue_Desk
  }
}
    ${OfficeCatalogueDeskFragmentDoc}`;
export const OfficeCatalogueParkingSpotFragmentDoc = /*#__PURE__*/ gql`
    fragment OfficeCatalogue_ParkingSpot on ParkingSpot {
  id
  number
  name
  guest
  blocked
}
    `;
export const OfficeCatalogueDeskAssignmentFragmentDoc = /*#__PURE__*/ gql`
    fragment OfficeCatalogue_DeskAssignment on DeskAssignment {
  id
  from
  to
  desk {
    id
  }
  user {
    id
    firstName
    lastName
    avatar
  }
}
    `;
export const OfficeSettingsMapFileFragmentDoc = /*#__PURE__*/ gql`
    fragment OfficeSettings_MapFile on DownloadableExternallyHostedFileUrl {
  fileName
  downloadUrl
}
    `;
export const OfficeSpotsUserFragmentDoc = /*#__PURE__*/ gql`
    fragment OfficeSpots_User on User {
  id
  firstName
  lastName
  avatar
}
    `;
export const OfficeSpotsReservationFragmentDoc = /*#__PURE__*/ gql`
    fragment OfficeSpots_Reservation on OfficeReservation {
  id
  requestId
  date
  kind
  resource {
    id
    name
  }
  user {
    ...OfficeSpots_User
  }
  approval {
    __typename
  }
  plateNumber
  notes
  guestEmails
}
    ${OfficeSpotsUserFragmentDoc}`;
export const OtherEmployeeInformationUserFragmentDoc = /*#__PURE__*/ gql`
    fragment OtherEmployeeInformation_User on User {
  id
  entityVersion
  consentedForUseOfImage
  documentsDirectory {
    ...Unauthorized
    ... on AccessGranted__OptionalURI {
      value
    }
  }
  personalDataProcessingAuthorization {
    ...Unauthorized
    ... on AccessGranted__PersonalDataProcessingAuthorization {
      value {
        isAuthorized
        document {
          ...Unauthorized
          ... on AccessGranted__OptionalURI {
            value
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const ParkingSpotDrawerParkingSpotFragmentDoc = /*#__PURE__*/ gql`
    fragment ParkingSpotDrawer_ParkingSpot on ParkingSpot {
  id
  number
  name
  guest
}
    `;
export const PaymentDetailsDraftDrawerPromiseeCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment PaymentDetailsDraftDrawer_PromiseeCompany on Company {
  id
  entityVersion
  isPolishVat {
    value {
      value
    }
  }
}
    `;
export const PaymentDetailsDraftDrawerOnCallFragmentDoc = /*#__PURE__*/ gql`
    fragment PaymentDetailsDraftDrawer_OnCall on OnCallRate {
  night {
    ...NetGross
  }
  holiday {
    ...NetGross
  }
  weekend {
    ...NetGross
  }
}
    ${NetGrossFragmentDoc}`;
export const PaymentDetailsDraftDrawerContractDraftFragmentDoc = /*#__PURE__*/ gql`
    fragment PaymentDetailsDraftDrawer_ContractDraft on ContractDraft {
  id
  entityVersion
  promisee {
    id
    entityVersion
  }
  ... on B2BContractDraft {
    currency
    vat {
      ...VatType
    }
    promiseeCompany {
      ...PaymentDetailsDraftDrawer_PromiseeCompany
    }
    rate {
      ...Rate
    }
    overtimeRate {
      ...NetGross
    }
    onCall {
      ...PaymentDetailsDraftDrawer_OnCall
    }
    separatePaymentForBenefits
  }
  ... on EmploymentContractDraft {
    type
    ppk
    copyrightCosts
    taxDeductibleCosts
    applyRemoteWorkReimbursement
    currency
    workingTime {
      ...WorkingTime
    }
    rate {
      ...Rate
    }
    overtimeRate {
      ...NetGross
    }
    onCall {
      ...PaymentDetailsDraftDrawer_OnCall
    }
  }
}
    ${VatTypeFragmentDoc}
${PaymentDetailsDraftDrawerPromiseeCompanyFragmentDoc}
${RateFragmentDoc}
${NetGrossFragmentDoc}
${PaymentDetailsDraftDrawerOnCallFragmentDoc}
${WorkingTimeFragmentDoc}`;
export const PaymentDetailsDrawerTimeBasedCurrencyFragmentDoc = /*#__PURE__*/ gql`
    fragment PaymentDetailsDrawer_TimeBasedCurrency on TimeBasedCurrency {
  value
  history {
    activityId
    applyDate
    value
  }
  futureUpdates {
    activityId
    applyDate
    value
  }
}
    `;
export const PaymentDetailsDrawerTimeBasedRateFragmentDoc = /*#__PURE__*/ gql`
    fragment PaymentDetailsDrawer_TimeBasedRate on TimeBasedRate {
  value {
    ...Rate
  }
  history {
    activityId
    applyDate
    value {
      ...Rate
    }
  }
  futureUpdates {
    activityId
    applyDate
    value {
      ...Rate
    }
  }
}
    ${RateFragmentDoc}`;
export const PaymentDetailsDrawerTimeBasedOvertimeRateFragmentDoc = /*#__PURE__*/ gql`
    fragment PaymentDetailsDrawer_TimeBasedOvertimeRate on TimeBasedOptClearableNetGross {
  value {
    ...NetGross
  }
  history {
    activityId
    applyDate
    value {
      value {
        ...NetGross
      }
    }
  }
  futureUpdates {
    activityId
    applyDate
    value {
      value {
        ...NetGross
      }
    }
  }
}
    ${NetGrossFragmentDoc}`;
export const PaymentDetailsDrawerOnCallFragmentDoc = /*#__PURE__*/ gql`
    fragment PaymentDetailsDrawer_OnCall on OnCallRate {
  night {
    ...NetGross
  }
  holiday {
    ...NetGross
  }
  weekend {
    ...NetGross
  }
}
    ${NetGrossFragmentDoc}`;
export const PaymentDetailsDrawerTimeBasedOnCallFragmentDoc = /*#__PURE__*/ gql`
    fragment PaymentDetailsDrawer_TimeBasedOnCall on TimeBasedOptClearableOnCallRate {
  value {
    ...PaymentDetailsDrawer_OnCall
  }
  history {
    activityId
    applyDate
    value {
      value {
        ...PaymentDetailsDrawer_OnCall
      }
    }
  }
  futureUpdates {
    activityId
    applyDate
    value {
      value {
        ...PaymentDetailsDrawer_OnCall
      }
    }
  }
}
    ${PaymentDetailsDrawerOnCallFragmentDoc}`;
export const PaymentDetailsDrawerPromiseeCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment PaymentDetailsDrawer_PromiseeCompany on Company {
  id
  entityVersion
  isPolishVat {
    value {
      value
    }
  }
}
    `;
export const PaymentDetailsDrawerContractFragmentDoc = /*#__PURE__*/ gql`
    fragment PaymentDetailsDrawer_Contract on Contract {
  id
  entityVersion
  startDate
  promisee {
    id
    entityVersion
  }
  ... on B2BContract {
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          ...PaymentDetailsDrawer_TimeBasedCurrency
        }
      }
    }
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          ...PaymentDetailsDrawer_TimeBasedRate
        }
      }
    }
    overtimeRate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableNetGross {
        value {
          ...PaymentDetailsDrawer_TimeBasedOvertimeRate
        }
      }
    }
    onCall {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableOnCallRate {
        value {
          ...PaymentDetailsDrawer_TimeBasedOnCall
        }
      }
    }
    separatePaymentForBenefits {
      ...Unauthorized
      ... on AccessGranted__TimeBasedBoolean {
        value {
          value
          history {
            activityId
            applyDate
            value
          }
          futureUpdates {
            activityId
            applyDate
            value
          }
        }
      }
    }
    vat {
      ...Unauthorized
      ... on AccessGranted__TimeBasedVatType {
        value {
          value {
            ...VatType
          }
          history {
            activityId
            applyDate
            value {
              ...VatType
            }
          }
          futureUpdates {
            activityId
            applyDate
            value {
              ...VatType
            }
          }
        }
      }
    }
    promiseeCompany {
      ...Unauthorized
      ... on AccessGranted__Company {
        value {
          ...PaymentDetailsDrawer_PromiseeCompany
        }
      }
    }
  }
  ... on EmploymentContract {
    type
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          ...PaymentDetailsDrawer_TimeBasedCurrency
        }
      }
    }
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          ...PaymentDetailsDrawer_TimeBasedRate
        }
      }
    }
    overtimeRate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableNetGross {
        value {
          ...PaymentDetailsDrawer_TimeBasedOvertimeRate
        }
      }
    }
    onCall {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableOnCallRate {
        value {
          ...PaymentDetailsDrawer_TimeBasedOnCall
        }
      }
    }
    taxDeductibleCosts {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableDeductibleCostsType {
        value {
          value
          history {
            activityId
            applyDate
            value {
              value
            }
          }
          futureUpdates {
            activityId
            applyDate
            value {
              value
            }
          }
        }
      }
    }
    ppk {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableBasisPoint {
        value {
          value
          history {
            activityId
            applyDate
            value {
              value
            }
          }
          futureUpdates {
            activityId
            applyDate
            value {
              value
            }
          }
        }
      }
    }
    copyrightCosts {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableBasisPoint {
        value {
          value
          history {
            activityId
            applyDate
            value {
              value
            }
          }
          futureUpdates {
            activityId
            applyDate
            value {
              value
            }
          }
        }
      }
    }
    workingTime {
      ...Unauthorized
      ... on AccessGranted__TimeBasedWorkingTime {
        value {
          value {
            ...WorkingTime
          }
          futureUpdates {
            activityId
            applyDate
            value {
              ...WorkingTime
            }
          }
          history {
            activityId
            applyDate
            value {
              ...WorkingTime
            }
          }
        }
      }
    }
    applyRemoteWorkReimbursement {
      ...Unauthorized
      ... on AccessGranted__TimeBasedBoolean {
        value {
          value
          history {
            activityId
            applyDate
            value
          }
          futureUpdates {
            activityId
            applyDate
            value
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${PaymentDetailsDrawerTimeBasedCurrencyFragmentDoc}
${PaymentDetailsDrawerTimeBasedRateFragmentDoc}
${PaymentDetailsDrawerTimeBasedOvertimeRateFragmentDoc}
${PaymentDetailsDrawerTimeBasedOnCallFragmentDoc}
${VatTypeFragmentDoc}
${PaymentDetailsDrawerPromiseeCompanyFragmentDoc}
${WorkingTimeFragmentDoc}`;
export const PayrollTransfersOrderResultModalResultFragmentDoc = /*#__PURE__*/ gql`
    fragment PayrollTransfersOrderResultModal_Result on PayrollTransfersOrderView {
  count
  totalCount
  batches {
    senderName
    outgoingAccount {
      ...BankAccountNumber
    }
    isDomestic
    transfersCount
    totalAmount {
      ...CentsWithCurrency
    }
    error
  }
}
    ${BankAccountNumberFragmentDoc}
${CentsWithCurrencyFragmentDoc}`;
export const PendingCopyrightsDrawerWorkTransferFragmentDoc = /*#__PURE__*/ gql`
    fragment PendingCopyrightsDrawer_WorkTransfer on WorkTransferProtocol {
  id
  description
  payload {
    ... on File {
      value {
        downloadUrl
        openUrl
        fileName
      }
    }
  }
  createdBy
  createdAt
  approval {
    ...Approval
  }
}
    ${ApprovalFragmentDoc}`;
export const PendingCopyrightsDrawerSalaryFragmentDoc = /*#__PURE__*/ gql`
    fragment PendingCopyrightsDrawer_Salary on EmploymentContractSalaryDetails {
  contractId
  yearMonth
  contract {
    id
    startDate
    terminationDate
    type
    name
    status
    promisee {
      id
      firstName
      lastName
      email
      avatar
    }
    conclusionDate {
      ...Unauthorized
      ... on AccessGranted__LocalDate {
        value
      }
    }
  }
  workTransferProtocols {
    ...PendingCopyrightsDrawer_WorkTransfer
  }
}
    ${UnauthorizedFragmentDoc}
${PendingCopyrightsDrawerWorkTransferFragmentDoc}`;
export const ProfileSpaceFragmentDoc = /*#__PURE__*/ gql`
    fragment Profile_Space on Space {
  id
  name
  owner {
    id
    firstName
    lastName
  }
}
    `;
export const ProgressionDetailsCurrencyFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionDetails_Currency on TimeBasedCurrency {
  value
  futureUpdates {
    applyDate
    activityId
    value
  }
  history {
    applyDate
    activityId
    value
  }
}
    `;
export const ProgressionDetailsRateFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionDetails_Rate on TimeBasedRate {
  value {
    ...Rate
  }
  history {
    value {
      ...Rate
    }
    applyDate
    activityId
  }
  futureUpdates {
    value {
      ...Rate
    }
    applyDate
    activityId
  }
}
    ${RateFragmentDoc}`;
export const ProgressionDetailsOvertimeRateFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionDetails_OvertimeRate on TimeBasedOptClearableNetGross {
  value {
    ...NetGross
  }
  history {
    value {
      value {
        ...NetGross
      }
    }
    applyDate
    activityId
  }
  futureUpdates {
    value {
      value {
        ...NetGross
      }
    }
    applyDate
    activityId
  }
}
    ${NetGrossFragmentDoc}`;
export const ProgressionDetailsOnCallsFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionDetails_OnCalls on TimeBasedOptClearableOnCallRate {
  value {
    night {
      ...NetGross
    }
    holiday {
      ...NetGross
    }
    weekend {
      ...NetGross
    }
  }
  futureUpdates {
    activityId
    applyDate
    value {
      value {
        night {
          ...NetGross
        }
        holiday {
          ...NetGross
        }
        weekend {
          ...NetGross
        }
      }
    }
  }
  history {
    activityId
    applyDate
    value {
      value {
        night {
          ...NetGross
        }
        holiday {
          ...NetGross
        }
        weekend {
          ...NetGross
        }
      }
    }
  }
}
    ${NetGrossFragmentDoc}`;
export const ProgressionDetailsPositionFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionDetails_Position on TimeBasedOptClearableString {
  value
  futureUpdates {
    activityId
    applyDate
    value {
      value
    }
  }
  history {
    activityId
    applyDate
    value {
      value
    }
  }
}
    `;
export const ProgressionDetailsSchemeLadderFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionDetails_SchemeLadder on ProgressionScheme {
  archivedAt
  levels {
    level
  }
}
    `;
export const ProgressionDetailsProgressionSchemeFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionDetails_ProgressionScheme on TimeBasedOptClearableProgressionScheme {
  value {
    id
    name
    ...ProgressionDetails_SchemeLadder
  }
  futureUpdates {
    activityId
    applyDate
    value {
      value {
        id
        name
        ...ProgressionDetails_SchemeLadder
      }
    }
  }
  history {
    activityId
    applyDate
    value {
      value {
        id
        name
      }
    }
  }
}
    ${ProgressionDetailsSchemeLadderFragmentDoc}`;
export const ProgressionDetailsWorkingTimeFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionDetails_WorkingTime on TimeBasedWorkingTime {
  value {
    ...WorkingTime
  }
  history {
    activityId
    applyDate
    value {
      ...WorkingTime
    }
  }
  futureUpdates {
    activityId
    applyDate
    value {
      ...WorkingTime
    }
  }
}
    ${WorkingTimeFragmentDoc}`;
export const ProgressionDetailsContractFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionDetails_Contract on Contract {
  id
  entityVersion
  status
  startDate
  terminationDate
  promisee {
    id
  }
  ... on B2BContract {
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          ...ProgressionDetails_Currency
        }
      }
    }
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          ...ProgressionDetails_Rate
        }
      }
    }
    overtimeRate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableNetGross {
        value {
          ...ProgressionDetails_OvertimeRate
        }
      }
    }
    onCall {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableOnCallRate {
        value {
          ...ProgressionDetails_OnCalls
        }
      }
    }
    position {
      ...ProgressionDetails_Position
    }
    progressionScheme {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableProgressionScheme {
        value {
          ...ProgressionDetails_ProgressionScheme
        }
      }
    }
  }
  ... on EmploymentContract {
    type
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          ...ProgressionDetails_Currency
        }
      }
    }
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          ...ProgressionDetails_Rate
        }
      }
    }
    overtimeRate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableNetGross {
        value {
          ...ProgressionDetails_OvertimeRate
        }
      }
    }
    onCall {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableOnCallRate {
        value {
          ...ProgressionDetails_OnCalls
        }
      }
    }
    position {
      ...ProgressionDetails_Position
    }
    progressionScheme {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableProgressionScheme {
        value {
          ...ProgressionDetails_ProgressionScheme
        }
      }
    }
    workingTime {
      ...Unauthorized
      ... on AccessGranted__TimeBasedWorkingTime {
        value {
          ...ProgressionDetails_WorkingTime
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${ProgressionDetailsCurrencyFragmentDoc}
${ProgressionDetailsRateFragmentDoc}
${ProgressionDetailsOvertimeRateFragmentDoc}
${ProgressionDetailsOnCallsFragmentDoc}
${ProgressionDetailsPositionFragmentDoc}
${ProgressionDetailsProgressionSchemeFragmentDoc}
${ProgressionDetailsWorkingTimeFragmentDoc}`;
export const ProgressionDetailsUserFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionDetails_User on User {
  id
  entityVersion
  progressionLevel {
    value
    history {
      applyDate
      activityId
      value {
        value
      }
    }
    futureUpdates {
      applyDate
      activityId
      value {
        value
      }
    }
  }
}
    `;
export const ProjectCostAndRevenueItemsProjectFragmentDoc = /*#__PURE__*/ gql`
    fragment ProjectCostAndRevenueItems_Project on Project {
  id
  entityVersion
  costAndRevenueItems {
    ...Unauthorized
    ... on AccessGranted__ListOfCostAndRevenueItem {
      value {
        tpe
        netValue {
          ...CentsWithCurrency
        }
        date
        description
        serviceLine
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${CentsWithCurrencyFragmentDoc}`;
export const CrossSellFragmentDoc = /*#__PURE__*/ gql`
    fragment CrossSell on CrossSell {
  description
  client {
    id
    name
  }
  project {
    id
    name
  }
  space {
    id
    name
  }
}
    `;
export const ProjectCrossSellProjectFragmentDoc = /*#__PURE__*/ gql`
    fragment ProjectCrossSell_Project on Project {
  id
  entityVersion
  crossSell {
    ...Unauthorized
    ... on AccessGranted__OptionalCrossSell {
      value {
        ...CrossSell
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${CrossSellFragmentDoc}`;
export const ProjectMembersDrawerClientContractFragmentDoc = /*#__PURE__*/ gql`
    fragment ProjectMembersDrawer_ClientContract on ClientContract {
  id
  contractDurationFrom {
    ...Unauthorized
    ... on AccessGranted__LocalDate {
      value
    }
  }
  contractDurationTo {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  name {
    ...Unauthorized
    ... on AccessGranted__String {
      value
    }
  }
  promisor {
    id
    name
  }
  promisee {
    id
    name
  }
  positions {
    ...Unauthorized
    ... on AccessGranted__ListOfClientPosition {
      value {
        id
        name
        active {
          value
          futureUpdates {
            activityId
            value
            applyDate
          }
          history {
            activityId
            value
            applyDate
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const ProjectMembersAssignmentUserFragmentDoc = /*#__PURE__*/ gql`
    fragment ProjectMembersAssignment_User on User {
  id
  entityVersion
  avatar
  firstName
  lastName
  progressionLevel {
    value
  }
  contracts {
    ...Unauthorized
    ... on AccessGranted__ListOfContract {
      value {
        id
        status
        startDate
        terminationDate
        promisor {
          value {
            id
            name
          }
        }
        ... on B2BContract {
          promiseeCompany {
            ...Unauthorized
            ... on AccessGranted__Company {
              value {
                id
              }
            }
          }
        }
        ... on Subcontract {
          clientContract {
            ...Unauthorized
            ... on AccessGranted__ClientContract {
              value {
                id
                positions {
                  ...Unauthorized
                  ... on AccessGranted__ListOfClientPosition {
                    value {
                      id
                      name
                      active {
                        value
                        futureUpdates {
                          activityId
                          value
                          applyDate
                        }
                        history {
                          activityId
                          value
                          applyDate
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const ProjectMembersDrawerProjectAssignmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ProjectMembersDrawer_ProjectAssignment on ProjectAssignment {
  user {
    ...ProjectMembersAssignment_User
  }
  project {
    id
    entityVersion
  }
  periods {
    dateRange {
      from
      to
    }
    clientPosition {
      ...Unauthorized
      ... on AccessGranted__ClientPosition {
        value {
          id
          name
        }
      }
    }
    subcontractPosition {
      ...Unauthorized
      ... on AccessGranted__OptionalClientPosition {
        value {
          id
          name
        }
      }
    }
  }
}
    ${ProjectMembersAssignmentUserFragmentDoc}
${UnauthorizedFragmentDoc}`;
export const ProjectsAndActivitiesSpaceFragmentDoc = /*#__PURE__*/ gql`
    fragment ProjectsAndActivities_Space on Space {
  id
  name
  owner {
    id
    firstName
    lastName
  }
}
    `;
export const ProjectsAndActivitiesClientPositionFragmentDoc = /*#__PURE__*/ gql`
    fragment ProjectsAndActivities_ClientPosition on ClientPosition {
  id
  name
  active {
    value
    futureUpdates {
      activityId
      value
      applyDate
    }
    history {
      activityId
      value
      applyDate
    }
  }
  currency {
    value
  }
  rateNet {
    value {
      daily
      hourly
    }
    futureUpdates {
      applyDate
      activityId
    }
  }
  overtimeNet {
    value {
      daily
      hourly
    }
    futureUpdates {
      applyDate
      activityId
    }
  }
  onCallRates {
    value {
      night
      weekend
      holiday
    }
    futureUpdates {
      applyDate
      activityId
    }
  }
}
    `;
export const RateCardDrawerClientPositionFragmentDoc = /*#__PURE__*/ gql`
    fragment RateCardDrawer_ClientPosition on ClientPosition {
  id
  name
  createdAt
  serviceLine {
    value
    futureUpdates {
      activityId
      applyDate
      value {
        value
      }
    }
    history {
      activityId
      applyDate
      value {
        value
      }
    }
  }
  currency {
    value
    futureUpdates {
      activityId
      applyDate
      value
    }
    history {
      activityId
      applyDate
      value
    }
  }
  rateNet {
    value {
      daily
      hourly
    }
    futureUpdates {
      activityId
      applyDate
      value {
        daily
        hourly
      }
    }
    history {
      activityId
      applyDate
      value {
        daily
        hourly
      }
    }
  }
  overtimeNet {
    value {
      daily
      hourly
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          daily
          hourly
        }
      }
    }
    history {
      activityId
      applyDate
      value {
        value {
          daily
          hourly
        }
      }
    }
  }
  active {
    value
    futureUpdates {
      activityId
      applyDate
      value
    }
    history {
      activityId
      applyDate
      value
    }
  }
  onCallRates {
    value {
      night
      weekend
      holiday
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          night
          weekend
          holiday
        }
      }
    }
    history {
      activityId
      applyDate
      value {
        value {
          night
          weekend
          holiday
        }
      }
    }
  }
}
    `;
export const RateCardDrawerClientContractFragmentDoc = /*#__PURE__*/ gql`
    fragment RateCardDrawer_ClientContract on ClientContract {
  id
  entityVersion
  contractDurationFrom {
    ...Unauthorized
    ... on AccessGranted__LocalDate {
      value
    }
  }
  contractDurationTo {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  promisor {
    id
    entityVersion
    companyType
  }
  positions {
    ...Unauthorized
    ... on AccessGranted__ListOfClientPosition {
      value {
        ...RateCardDrawer_ClientPosition
      }
    }
  }
  vat {
    ...Unauthorized
    ... on AccessGranted__TimeBasedOptClearableBasisPoint {
      value {
        value
        futureUpdates {
          activityId
          applyDate
          value {
            value
          }
        }
        history {
          activityId
          applyDate
          value {
            value
          }
        }
      }
    }
  }
  currency {
    ...Unauthorized
    ... on AccessGranted__TimeBasedOptCurrency {
      value {
        value
        futureUpdates {
          activityId
          applyDate
          value
        }
        history {
          activityId
          applyDate
          value
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${RateCardDrawerClientPositionFragmentDoc}`;
export const RateCardDrawerClientContractTimeBasedFragmentDoc = /*#__PURE__*/ gql`
    fragment RateCardDrawer_ClientContractTimeBased on ClientContract {
  at
  ...RateCardDrawer_ClientContract
  positions {
    ...Unauthorized
    ... on AccessGranted__ListOfClientPosition {
      value {
        at
        ...RateCardDrawer_ClientPosition
      }
    }
  }
}
    ${RateCardDrawerClientContractFragmentDoc}
${UnauthorizedFragmentDoc}
${RateCardDrawerClientPositionFragmentDoc}`;
export const ReservationLimitsDrawerSettingsFragmentDoc = /*#__PURE__*/ gql`
    fragment ReservationLimitsDrawer_Settings on OfficeReservationSettings {
  deskMaxDays
  deskMaxAdvanceDays
  deskMaxUpcomingDays
  parkingMaxAdvanceDays
  parkingMaxDays
  parkingMaxUpcomingDays
}
    `;
export const RoomDrawerRoomFragmentDoc = /*#__PURE__*/ gql`
    fragment RoomDrawer_Room on Room {
  id
  name
  securityZone
  restrictedToSpace {
    id
    name
    owner {
      id
      firstName
      lastName
    }
  }
}
    `;
export const SalariesControllsModifiedEntriesFragmentDoc = /*#__PURE__*/ gql`
    fragment SalariesControlls_ModifiedEntries on ListOfContractSalaryDetailsResponse {
  value {
    contractId
    yearMonth
    salaryState {
      ...SalaryState
    }
  }
}
    ${SalaryStateFragmentDoc}`;
export const SalariesControllsFileFragmentDoc = /*#__PURE__*/ gql`
    fragment SalariesControlls_File on DownloadableFileUrl {
  url
  fileName
}
    `;
export const SalaryTransferDetailsSalaryStateChangeFragmentDoc = /*#__PURE__*/ gql`
    fragment SalaryTransferDetails_SalaryStateChange on ListOfContractSalaryDetailsResponse {
  value {
    contractId
    yearMonth
    salaryState {
      ...SalaryState
    }
  }
}
    ${SalaryStateFragmentDoc}`;
export const SaldeoInvoiceFormCostInvoiceFragmentDoc = /*#__PURE__*/ gql`
    fragment SaldeoInvoiceForm_CostInvoice on CostInvoice {
  number
  grossValue
  currency
  contractor {
    name
  }
  saldeoDocumentId {
    documentId
    companyProgramId
  }
}
    `;
export const SetRateAndProgressionDrawerOnCallFragmentDoc = /*#__PURE__*/ gql`
    fragment SetRateAndProgressionDrawer_OnCall on TimeBasedOptClearableOnCallRate {
  value {
    night {
      ...NetGross
    }
    holiday {
      ...NetGross
    }
    weekend {
      ...NetGross
    }
  }
  futureUpdates {
    activityId
    applyDate
    value {
      value {
        night {
          ...NetGross
        }
        holiday {
          ...NetGross
        }
        weekend {
          ...NetGross
        }
      }
    }
  }
  history {
    activityId
    applyDate
  }
}
    ${NetGrossFragmentDoc}`;
export const SetRateAndProgressionDrawerAvailableProgressionSchemeFragmentDoc = /*#__PURE__*/ gql`
    fragment SetRateAndProgressionDrawer_AvailableProgressionScheme on ProgressionScheme {
  id
  name
  levels {
    level
    hourlyRate
    noticePeriod
  }
}
    `;
export const SetRateAndProgressionDrawerWorkingTimeFragmentDoc = /*#__PURE__*/ gql`
    fragment SetRateAndProgressionDrawer_WorkingTime on TimeBasedWorkingTime {
  value {
    ...WorkingTime
  }
  history {
    activityId
    applyDate
  }
  futureUpdates {
    activityId
    applyDate
    value {
      ...WorkingTime
    }
  }
}
    ${WorkingTimeFragmentDoc}`;
export const SetRateAndProgressionDrawerVatFragmentDoc = /*#__PURE__*/ gql`
    fragment SetRateAndProgressionDrawer_Vat on TimeBasedVatType {
  value {
    ...VatType
  }
  history {
    activityId
    applyDate
  }
  futureUpdates {
    activityId
    applyDate
    value {
      ...VatType
    }
  }
}
    ${VatTypeFragmentDoc}`;
export const SetRateAndProgressionDrawerScopeOfWorkFragmentDoc = /*#__PURE__*/ gql`
    fragment SetRateAndProgressionDrawer_ScopeOfWork on TimeBasedString {
  value
  history {
    activityId
    applyDate
  }
  futureUpdates {
    activityId
    applyDate
    value
  }
}
    `;
export const SetRateAndProgressionDrawerPositionFragmentDoc = /*#__PURE__*/ gql`
    fragment SetRateAndProgressionDrawer_Position on TimeBasedOptClearableString {
  value
  history {
    activityId
    applyDate
  }
  futureUpdates {
    activityId
    applyDate
    value {
      value
    }
  }
}
    `;
export const SetRateAndProgressionDrawerProgressionSchemeFragmentDoc = /*#__PURE__*/ gql`
    fragment SetRateAndProgressionDrawer_ProgressionScheme on TimeBasedOptClearableProgressionScheme {
  value {
    id
    name
  }
  history {
    activityId
    applyDate
  }
  futureUpdates {
    activityId
    applyDate
    value {
      value {
        id
      }
    }
  }
}
    `;
export const SetRateAndProgressionDrawerRateFragmentDoc = /*#__PURE__*/ gql`
    fragment SetRateAndProgressionDrawer_Rate on TimeBasedRate {
  value {
    ...Rate
  }
  futureUpdates {
    activityId
    applyDate
    value {
      ...Rate
    }
  }
  history {
    activityId
    applyDate
  }
}
    ${RateFragmentDoc}`;
export const SetRateAndProgressionDrawerOvertimeRateFragmentDoc = /*#__PURE__*/ gql`
    fragment SetRateAndProgressionDrawer_OvertimeRate on TimeBasedOptClearableNetGross {
  value {
    ...NetGross
  }
  futureUpdates {
    activityId
    applyDate
    value {
      value {
        ...NetGross
      }
    }
  }
  history {
    activityId
    applyDate
  }
}
    ${NetGrossFragmentDoc}`;
export const SetRateAndProgressionDrawerContractFragmentDoc = /*#__PURE__*/ gql`
    fragment SetRateAndProgressionDrawer_Contract on Contract {
  id
  entityVersion
  name
  promisee {
    id
    firstName
    lastName
    email
  }
  startDate
  terminationDate
  promisor {
    value {
      id
      name
    }
  }
  ... on B2BContract {
    vat {
      ...Unauthorized
      ... on AccessGranted__TimeBasedVatType {
        value {
          ...SetRateAndProgressionDrawer_Vat
        }
      }
    }
    scopeOfWork {
      ...Unauthorized
      ... on AccessGranted__TimeBasedString {
        value {
          ...SetRateAndProgressionDrawer_ScopeOfWork
        }
      }
    }
    position {
      ...SetRateAndProgressionDrawer_Position
    }
    progressionScheme {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableProgressionScheme {
        value {
          ...SetRateAndProgressionDrawer_ProgressionScheme
        }
      }
    }
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          ...SetRateAndProgressionDrawer_Rate
        }
      }
    }
    overtimeRate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableNetGross {
        value {
          ...SetRateAndProgressionDrawer_OvertimeRate
        }
      }
    }
    onCall {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableOnCallRate {
        value {
          ...ContractPaymentDetails_OnCall
        }
      }
    }
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          value
        }
      }
    }
  }
  ... on EmploymentContract {
    type
    position {
      ...SetRateAndProgressionDrawer_Position
    }
    progressionScheme {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableProgressionScheme {
        value {
          ...SetRateAndProgressionDrawer_ProgressionScheme
        }
      }
    }
    scopeOfWork {
      ...Unauthorized
      ... on AccessGranted__TimeBasedString {
        value {
          ...SetRateAndProgressionDrawer_ScopeOfWork
        }
      }
    }
    workingTime {
      ...Unauthorized
      ... on AccessGranted__TimeBasedWorkingTime {
        value {
          ...ProgressionDetails_WorkingTime
        }
      }
    }
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          ...SetRateAndProgressionDrawer_Rate
        }
      }
    }
    overtimeRate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableNetGross {
        value {
          ...SetRateAndProgressionDrawer_OvertimeRate
        }
      }
    }
    onCall {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableOnCallRate {
        value {
          ...ContractPaymentDetails_OnCall
        }
      }
    }
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          value
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${SetRateAndProgressionDrawerVatFragmentDoc}
${SetRateAndProgressionDrawerScopeOfWorkFragmentDoc}
${SetRateAndProgressionDrawerPositionFragmentDoc}
${SetRateAndProgressionDrawerProgressionSchemeFragmentDoc}
${SetRateAndProgressionDrawerRateFragmentDoc}
${SetRateAndProgressionDrawerOvertimeRateFragmentDoc}
${ContractPaymentDetailsOnCallFragmentDoc}
${ProgressionDetailsWorkingTimeFragmentDoc}`;
export const SetRateAndProgressionDrawerResultFragmentDoc = /*#__PURE__*/ gql`
    fragment SetRateAndProgressionDrawer_Result on SetRateAndProgressionResult {
  contract {
    ... on B2BContract {
      ...SetRateAndProgressionDrawer_Contract
    }
    ... on EmploymentContract {
      ...SetRateAndProgressionDrawer_Contract
    }
  }
  user {
    id
    entityVersion
    progressionLevel {
      value
      futureUpdates {
        applyDate
        activityId
        value {
          value
        }
      }
    }
  }
}
    ${SetRateAndProgressionDrawerContractFragmentDoc}`;
export const SubcontractDraftDrawerDraftFragmentDoc = /*#__PURE__*/ gql`
    fragment SubcontractDraftDrawer_Draft on ContractDraft {
  id
  entityVersion
  promisee {
    id
    entityVersion
  }
  ... on SubcontractDraft {
    name
    startDate
    expectedEndDate
    clientContract {
      id
      name {
        ...Unauthorized
        ... on AccessGranted__String {
          value
        }
      }
      contractDurationFrom {
        ...Unauthorized
        ... on AccessGranted__LocalDate {
          value
        }
      }
    }
    holidayCalendar {
      id
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const BankTransfersBankAccountNumberFragmentDoc = /*#__PURE__*/ gql`
    fragment BankTransfers_BankAccountNumber on BankAccountNumber {
  ... on Iban {
    value
  }
  ... on OtherBankAccountNumber {
    value
  }
}
    `;
export const BankTransfersBankTransferFragmentDoc = /*#__PURE__*/ gql`
    fragment BankTransfers_BankTransfer on BankTransfer {
  id
  bookDate
  operationDate
  title
  amount
  currency
  status
  note
  toName
  fromName
  fromAccountNumber {
    ...BankTransfers_BankAccountNumber
  }
  toAccountNumber {
    ...BankTransfers_BankAccountNumber
  }
  ... on BankIncomeTransfer {
    toAccount {
      ...BankAccount
    }
  }
}
    ${BankTransfersBankAccountNumberFragmentDoc}
${BankAccountFragmentDoc}`;
export const TransferDetailsDrawerInvoiceFragmentDoc = /*#__PURE__*/ gql`
    fragment TransferDetailsDrawer_Invoice on SalesInvoice {
  id
  number
  status
  price {
    net
    gross
  }
  currency
  buyer {
    name
    taxNumber
  }
  seller {
    name
    taxNumber
  }
  buyerCompany {
    id
    name
  }
  sellerCompany {
    id
    name
    taxNumber
  }
}
    `;
export const TransferDetailsDrawerPaymentConnectionFragmentDoc = /*#__PURE__*/ gql`
    fragment TransferDetailsDrawer_PaymentConnection on PaymentConnection {
  transfer {
    id
    discrepancy
    ...BankTransfers_BankTransfer
  }
  invoice {
    ...TransferDetailsDrawer_Invoice
  }
  tpe
}
    ${BankTransfersBankTransferFragmentDoc}
${TransferDetailsDrawerInvoiceFragmentDoc}`;
export const TransferSummaryModalCurrencyConversionFragmentDoc = /*#__PURE__*/ gql`
    fragment TransferSummaryModal_CurrencyConversion on CurrencyConversion {
  originalCurrency {
    ...CentsWithCurrency
  }
  targetCurrency {
    ...CentsWithCurrency
  }
}
    ${CentsWithCurrencyFragmentDoc}`;
export const TransfersSummaryModalEmploymentTransfersSummaryFragmentDoc = /*#__PURE__*/ gql`
    fragment TransfersSummaryModal_EmploymentTransfersSummary on EmploymentTransfersSummary {
  contractCount
  totalSalary {
    ...CentsWithCurrency
  }
  salariesByCurrency {
    ...TransferSummaryModal_CurrencyConversion
  }
  totalTransferAmount {
    ...CentsWithCurrency
  }
  transferAmountsByCurrency {
    ...TransferSummaryModal_CurrencyConversion
  }
  totalTaxPrepayment {
    ...CentsWithCurrency
  }
  taxPrepaymentsByCurrency {
    ...TransferSummaryModal_CurrencyConversion
  }
  totalTaxRefund {
    ...CentsWithCurrency
  }
  taxRefundsByCurrency {
    ...TransferSummaryModal_CurrencyConversion
  }
  totalZusContribution {
    ...CentsWithCurrency
  }
  zusContributionsByCurrency {
    ...TransferSummaryModal_CurrencyConversion
  }
  totalPpkAmount {
    ...CentsWithCurrency
  }
  ppkAmountsByCurrency {
    ...TransferSummaryModal_CurrencyConversion
  }
}
    ${CentsWithCurrencyFragmentDoc}
${TransferSummaryModalCurrencyConversionFragmentDoc}`;
export const TransfersSummaryModalB2BTransfersSummaryFragmentDoc = /*#__PURE__*/ gql`
    fragment TransfersSummaryModal_B2BTransfersSummary on B2BTransfersSummary {
  contractCount
  totalNetSalary {
    ...CentsWithCurrency
  }
  netSalariesByCurrency {
    ...TransferSummaryModal_CurrencyConversion
  }
  totalGrossSalary {
    ...CentsWithCurrency
  }
  grossSalariesByCurrency {
    ...TransferSummaryModal_CurrencyConversion
  }
  totalTax {
    ...CentsWithCurrency
  }
  taxByCurrency {
    ...TransferSummaryModal_CurrencyConversion
  }
  totalTransferAmount {
    ...CentsWithCurrency
  }
  transferAmountsByCurrency {
    ...TransferSummaryModal_CurrencyConversion
  }
}
    ${CentsWithCurrencyFragmentDoc}
${TransferSummaryModalCurrencyConversionFragmentDoc}`;
export const UserDocumentsUserFragmentDoc = /*#__PURE__*/ gql`
    fragment UserDocuments_User on User {
  id
  entityVersion
  firstName
  lastName
  documentsDirectory {
    ...Unauthorized
    ... on AccessGranted__OptionalURI {
      value
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const UserProjectFormClientContractFragmentDoc = /*#__PURE__*/ gql`
    fragment UserProjectForm_ClientContract on ClientContract {
  id
  promisor {
    id
    name
  }
  promisee {
    id
    name
  }
  contractDurationFrom {
    ...Unauthorized
    ... on AccessGranted__LocalDate {
      value
    }
  }
  contractDurationTo {
    ...Unauthorized
    ... on AccessGranted__OptionalLocalDate {
      value
    }
  }
  name {
    ...Unauthorized
    ... on AccessGranted__String {
      value
    }
  }
  positions {
    ...Unauthorized
    ... on AccessGranted__ListOfClientPosition {
      value {
        id
        name
        active {
          value
          futureUpdates {
            activityId
            value
            applyDate
          }
          history {
            activityId
            value
            applyDate
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const UserProjectsDrawerProjectAssignmentFragmentDoc = /*#__PURE__*/ gql`
    fragment UserProjectsDrawer_ProjectAssignment on ProjectAssignment {
  user {
    id
  }
  project {
    id
    entityVersion
    name
    statusHistory {
      status
      dateRange {
        from
        to
      }
    }
    clientContract {
      id
      contractDurationFrom {
        ...Unauthorized
        ... on AccessGranted__LocalDate {
          value
        }
      }
      contractDurationTo {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
      name {
        ...Unauthorized
        ... on AccessGranted__String {
          value
        }
      }
      promisor {
        id
        name
      }
      promisee {
        id
        name
      }
      positions {
        ...Unauthorized
        ... on AccessGranted__ListOfClientPosition {
          value {
            id
            name
            active {
              value
              futureUpdates {
                activityId
                value
                applyDate
              }
              history {
                activityId
                value
                applyDate
              }
            }
          }
        }
      }
    }
  }
  periods {
    dateRange {
      from
      to
    }
    clientPosition {
      ...Unauthorized
      ... on AccessGranted__ClientPosition {
        value {
          id
          name
        }
      }
    }
    subcontractPosition {
      ...Unauthorized
      ... on AccessGranted__OptionalClientPosition {
        value {
          id
          name
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const UserProjectsDrawerProjectAssignmentUpdateFragmentDoc = /*#__PURE__*/ gql`
    fragment UserProjectsDrawer_ProjectAssignment_Update on ProjectAssignment {
  ...UserProjectsDrawer_ProjectAssignment
  user {
    id
    progressionLevel {
      value
    }
    directReporting {
      assignedProjects {
        ...Unauthorized
        ... on AccessGranted__ListOfProjectAssignment {
          value {
            ...UserProjectsDrawer_ProjectAssignment
          }
        }
      }
    }
  }
}
    ${UserProjectsDrawerProjectAssignmentFragmentDoc}
${UnauthorizedFragmentDoc}`;
export const CostInvoiceDetailsCostInvoiceFragmentDoc = /*#__PURE__*/ gql`
    fragment CostInvoiceDetails_CostInvoice on CostInvoice {
  number
  issueDate
  saleDate
  paymentDate
  category
  description
  grossValue
  currency
  ksefNumber
  ksefPreviewSource
  isCorrective
  saldeoDocumentUrl
  previewUrls
  contractor {
    name
    taxNumber
  }
  saldeoDocumentId {
    companyProgramId
    documentId
  }
}
    `;
export const CostInvoicesCostInvoiceFragmentDoc = /*#__PURE__*/ gql`
    fragment CostInvoices_CostInvoice on CostInvoice {
  number
  issueDate
  saleDate
  paymentDate
  category
  description
  grossValue
  currency
  ksefNumber
  ksefPreviewSource
  isCorrective
  saldeoDocumentUrl
  previewUrls
  contractor {
    name
    taxNumber
  }
  saldeoDocumentId {
    companyProgramId
    documentId
  }
}
    `;
export const ReportsEmployeeDueDatesPersonFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportsEmployeeDueDates_Person on FSPResponseUser {
  hasNextPage
  totalCount
  filteredCount
  edges {
    cursor
    node {
      id
      entityVersion
      firstName
      lastName
      avatar
      email
      nextOhsTrainingDate {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
      isStudentRevisionDate {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
      nextMedicalExaminationDate {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const OfficeReservationsRowFragmentDoc = /*#__PURE__*/ gql`
    fragment OfficeReservationsRow on OfficeReservation {
  id
  requestId
  date
  kind
  notes
  guestEmails
  plateNumber
  createdAt
  resource {
    id
    name
  }
  office {
    officeId
    name
  }
  user {
    id
    firstName
    lastName
    avatar
  }
}
    `;
export const OfficesOfficeFragmentDoc = /*#__PURE__*/ gql`
    fragment Offices_Office on Office {
  officeId
  name
  physical
  validFrom
  validTo
  blocked
  avatar
}
    `;
export const PeoplePersonFragmentDoc = /*#__PURE__*/ gql`
    fragment People_Person on FSPResponseUser {
  hasNextPage
  totalCount
  filteredCount
  edges {
    cursor
    node {
      id
      entityVersion
      firstName
      lastName
      avatar
      email
      skillsAndCompetences
      areaOfExpertise
      certificates {
        ...Unauthorized
        ... on AccessGranted__ListOfCertificate {
          value {
            id
            name
          }
        }
      }
      role {
        value
      }
      progressionLevel {
        value
      }
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            status
            ... on EmploymentContract {
              type
              position {
                value
              }
            }
            ... on B2BContract {
              position {
                value
              }
            }
          }
        }
      }
      newestRateChangeDate {
        ...Unauthorized
        ... on AccessGranted__OptionalOffsetDateTime {
          value
        }
      }
      directReporting {
        practiceLead {
          value {
            id
            firstName
            lastName
            email
            avatar
          }
        }
        operationalLead {
          value {
            id
            firstName
            lastName
            email
            avatar
          }
        }
        assignedProjects(status_oneOf: [Live, Planned]) {
          ...Unauthorized
          ... on AccessGranted__ListOfProjectAssignment {
            value {
              user {
                id
              }
              project {
                id
                entityVersion
                name
                clientContract {
                  id
                  promisor {
                    id
                    name
                  }
                }
              }
            }
          }
        }
        space {
          value {
            id
            name
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const ProgressionSchemesProgressionSchemeLevelFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionSchemes_ProgressionSchemeLevel on ProgressionSchemeLevel {
  schemeId
  level
  title
  hourlyRate
  noticePeriod
}
    `;
export const ProgressionSchemesProgressionSchemeFragmentDoc = /*#__PURE__*/ gql`
    fragment ProgressionSchemes_ProgressionScheme on ProgressionScheme {
  id
  name
  isEngineering
  yearlyRaise
  createdAt
  archivedAt
  levels {
    ...ProgressionSchemes_ProgressionSchemeLevel
  }
}
    ${ProgressionSchemesProgressionSchemeLevelFragmentDoc}`;
export const RaisesRaiseProposalFragmentDoc = /*#__PURE__*/ gql`
    fragment Raises_RaiseProposal on RaiseProposal {
  contract {
    id
    entityVersion
    name
    ... on EmploymentContract {
      type
    }
    promisee {
      id
      firstName
      lastName
      avatar
      email
      contactEmail {
        ...Unauthorized
        ... on AccessGranted__OptionalEmailAddress {
          value
        }
      }
    }
  }
  progressionScheme {
    id
    name
  }
  level
  currentHourlyRate
  proposedHourlyRate
  hourlyRateIncrease
  lastRateChangeDate
}
    ${UnauthorizedFragmentDoc}`;
export const SharedSalaryBonusFragmentDoc = /*#__PURE__*/ gql`
    fragment SharedSalary_Bonus on Bonus {
  applyAt
  id
  note
  revoked
  paidOutAt
  allocateCostToProject {
    id
    name
  }
  approval {
    ...Approval
  }
  amount {
    ...NetGross
  }
  ... on LanguageLearningBonus {
    language
    quarterYear {
      quarter
      year
    }
  }
  ... on OtherBonus {
    description
  }
  ... on CostRechargeBonus {
    description
  }
}
    ${ApprovalFragmentDoc}
${NetGrossFragmentDoc}`;
export const SharedSalaryEmploymentContractFragmentDoc = /*#__PURE__*/ gql`
    fragment SharedSalary_EmploymentContract on EmploymentContract {
  id
  at
  name
  entityVersion
  type
  status
  conclusionDate {
    ...Unauthorized
    ... on AccessGranted__LocalDate {
      value
    }
  }
  bonuses {
    ...Unauthorized
    ... on AccessGranted__Bonuses {
      value {
        paidOut {
          ...SharedSalary_Bonus
        }
        future {
          ...SharedSalary_Bonus
        }
      }
    }
  }
  copyrightCosts {
    ...Unauthorized
    ... on AccessGranted__TimeBasedOptClearableBasisPoint {
      value {
        value
      }
    }
  }
  startDate
  terminationDate
  currency {
    ...Unauthorized
    ... on AccessGranted__TimeBasedCurrency {
      value {
        value
      }
    }
  }
  rate {
    ...Unauthorized
    ... on AccessGranted__TimeBasedRate {
      value {
        value {
          settlement
        }
      }
    }
  }
  ppk {
    ...Unauthorized
    ... on AccessGranted__TimeBasedOptClearableBasisPoint {
      value {
        value
      }
    }
  }
  workingTime {
    ...Unauthorized
    ... on AccessGranted__TimeBasedWorkingTime {
      value {
        value {
          ...WorkingTime
        }
      }
    }
  }
  promiseeTransferBankAccount {
    ...Unauthorized
    ... on AccessGranted__BankAccount {
      value {
        ...BankAccount
      }
    }
  }
  promisor {
    value {
      id
      name
    }
  }
  ... on EmploymentContract {
    type
  }
  promisee {
    id
    firstName
    lastName
    avatar
    progressionLevel {
      value
    }
    isStudent {
      ...Unauthorized
      ... on AccessGranted__Boolean {
        value
      }
    }
    directReporting {
      assignedProjects {
        ...Unauthorized
        ... on AccessGranted__ListOfProjectAssignment {
          value {
            user {
              id
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
  promisorTransferBankAccount {
    value {
      ...BankAccount
    }
  }
}
    ${UnauthorizedFragmentDoc}
${SharedSalaryBonusFragmentDoc}
${WorkingTimeFragmentDoc}
${BankAccountFragmentDoc}`;
export const SalesInvoicesInvoiceEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment SalesInvoices_InvoiceEntity on InvoiceEntity {
  name
  taxNumber
  email
  phone
  address {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const SalesInvoicesInvoiceFragmentDoc = /*#__PURE__*/ gql`
    fragment SalesInvoices_Invoice on SalesInvoice {
  id
  kind
  number
  issueDate
  sellDate
  paymentTo
  overdue
  place
  status
  profilePrefix
  price {
    ...NetGross
  }
  currency
  exchangeRate
  priceWithExchangeRateApplied {
    ...NetGross
  }
  fakturowniaUri
  paid
  paidDate
  viewUri
  expectedPayment {
    date
  }
  seller {
    ...SalesInvoices_InvoiceEntity
  }
  sellerCompany {
    id
    name
    logo
  }
  buyer {
    ...SalesInvoices_InvoiceEntity
  }
  buyerCompany {
    id
    name
    logo
  }
  buyerType
  positions {
    name
    quantity
    quantityUnit
    price {
      net
      gross
    }
    totalPrice {
      net
      gross
    }
    description
    vat {
      value
    }
  }
}
    ${NetGrossFragmentDoc}
${SalesInvoicesInvoiceEntityFragmentDoc}`;
export const ApprovalsUserFragmentDoc = /*#__PURE__*/ gql`
    fragment Approvals_User on User {
  id
  firstName
  lastName
  avatar
  directReporting {
    practiceLead {
      value {
        id
      }
    }
    operationalLead {
      value {
        id
      }
    }
    space {
      value {
        id
      }
    }
  }
}
    `;
export const CostInvoiceGroupCompaniesCompanyFragmentDoc = /*#__PURE__*/ gql`
    fragment CostInvoiceGroupCompanies_Company on Company {
  id
  name
  logo
}
    `;
export const TransferAutocompleteTransferFragmentDoc = /*#__PURE__*/ gql`
    fragment TransferAutocomplete_Transfer on BankTransfer {
  id
  bookDate
  operationDate
  title
  amount
  currency
  toName
  fromName
}
    `;
export const UserAutocompleteUserFragmentDoc = /*#__PURE__*/ gql`
    fragment UserAutocomplete_User on User {
  id
  entityVersion
  firstName
  lastName
}
    `;
export const AdditionalCostDrawerBonusFragmentDoc = /*#__PURE__*/ gql`
    fragment AdditionalCostDrawer_Bonus on Bonus {
  applyAt
  id
  note
  revoked
  paidOutAt
  allocateCostToProject {
    id
    name
  }
  approval {
    ...Approval
  }
  amount {
    ...NetGross
  }
  ... on LanguageLearningBonus {
    language
    quarterYear {
      quarter
      year
    }
  }
  ... on OtherBonus {
    description
  }
  ... on CostRechargeBonus {
    description
  }
}
    ${ApprovalFragmentDoc}
${NetGrossFragmentDoc}`;
export const AdminBenefitSectionsBenefitVariantFragmentDoc = /*#__PURE__*/ gql`
    fragment AdminBenefitSections_BenefitVariant on BenefitVariant {
  id
  entityVersion
  productId
  startDate
  endDate
  buyerType
  description
  contractTypes
  description
  promiseeRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  promisorRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  parent {
    id
    entityVersion
    name
    alternativeBenefitsGroupId
    ... on Benefit {
      benefitParent: parent
    }
  }
  additionalPeople {
    ...BenefitAdditionalPeople
  }
}
    ${BenefitVariantRateFragmentDoc}
${BenefitAdditionalPeopleFragmentDoc}`;
export const BenefitSectionsExternalBeneficiaryFragmentDoc = /*#__PURE__*/ gql`
    fragment BenefitSections_ExternalBeneficiary on ExternalBeneficiary {
  id
  firstName
  lastName
  email
  address {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const CopyrightsDrawerWorkTransferFragmentDoc = /*#__PURE__*/ gql`
    fragment CopyrightsDrawer_WorkTransfer on WorkTransferProtocol {
  id
  description
  payload {
    ... on File {
      value {
        downloadUrl
        openUrl
        fileName
      }
    }
  }
  createdBy
  createdAt
  approval {
    ...Approval
  }
}
    ${ApprovalFragmentDoc}`;
export const CopyrightsDrawerSalaryFragmentDoc = /*#__PURE__*/ gql`
    fragment CopyrightsDrawer_Salary on EmploymentContractSalaryDetails {
  contractId
  yearMonth
  workTransferProtocols {
    ...CopyrightsDrawer_WorkTransfer
  }
}
    ${CopyrightsDrawerWorkTransferFragmentDoc}`;
export const CopyrightTrButtonContractFragmentDoc = /*#__PURE__*/ gql`
    fragment CopyrightTRButton_Contract on Contract {
  id
  entityVersion
  ... on EmploymentContract {
    copyrightCosts {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableBasisPoint {
        value {
          value
          history {
            activityId
            applyDate
            value {
              value
            }
          }
          futureUpdates {
            activityId
            applyDate
            value {
              value
            }
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const DirectReportingStructureUserFragmentDoc = /*#__PURE__*/ gql`
    fragment DirectReportingStructure_User on User {
  id
  firstName
  lastName
  email
  avatar
  role {
    value
  }
}
    `;
export const InvoicesDrawerSalaryStateFragmentDoc = /*#__PURE__*/ gql`
    fragment InvoicesDrawer_SalaryState on SalaryState {
  __typename
  ... on PaymentDisbursed {
    transferState {
      __typename
    }
  }
}
    `;
export const InvoicesDrawerInvoiceDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment InvoicesDrawer_InvoiceDetails on InvoiceDetails {
  id
  correct
  number
  userNote
  adminNote
  ksefNumber
  saldeoDocumentUrl
  currency
  grossValue
  file {
    downloadUrl
    openUrl
    fileName
  }
}
    `;
export const InvoicesDrawerSalaryFragmentDoc = /*#__PURE__*/ gql`
    fragment InvoicesDrawer_Salary on B2BContractSalaryDetails {
  contractId
  yearMonth
  salaryState {
    ...InvoicesDrawer_SalaryState
  }
  invoiceDetails {
    ...InvoicesDrawer_InvoiceDetails
  }
}
    ${InvoicesDrawerSalaryStateFragmentDoc}
${InvoicesDrawerInvoiceDetailsFragmentDoc}`;
export const TimeReportDashBoardProviderTimeReportValidationsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportDashBoardProvider_TimeReportValidations on TimeReportValidation {
  ... on IncompleteEntries {
    days
  }
  ... on MissingEntries {
    days
  }
  ... on NegativeFlexTimeBalance {
    minutes
  }
}
    `;
export const TimeReportDashBoardProviderAbsenceTypeDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportDashBoardProvider_AbsenceTypeDetails on KVAbsenceTypeAbsenceTypeDetails {
  key
  value {
    canBeReportedOnHoliday
    applicableFor
    canTakeCustomNumberOfHours
    limit
  }
}
    `;
export const TimeReportDashBoardProviderOnCallFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportDashBoardProvider_OnCall on TimeBasedOptClearableOnCallRate {
  value {
    holiday {
      net
    }
  }
  futureUpdates {
    applyDate
    value {
      value {
        holiday {
          net
        }
      }
    }
  }
  history {
    activityId
    applyDate
    value {
      value {
        holiday {
          net
        }
      }
    }
  }
}
    `;
export const TimeReportDashBoardProviderOvertimeRateFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportDashBoardProvider_OvertimeRate on TimeBasedOptClearableNetGross {
  value {
    net
  }
  futureUpdates {
    applyDate
    value {
      value {
        net
      }
    }
  }
  history {
    applyDate
    value {
      value {
        net
      }
    }
  }
}
    `;
export const TimeReportDashBoardProviderTimeBasedRateFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportDashBoardProvider_TimeBasedRate on TimeBasedRate {
  value {
    settlement
  }
  futureUpdates {
    applyDate
    value {
      settlement
    }
  }
  history {
    applyDate
    value {
      settlement
    }
  }
}
    `;
export const TimeReportEntryModalAnnualLeaveSummaryFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportEntryModal_AnnualLeaveSummary on AnnualLeaveSummary {
  yearlySummary {
    key
    value {
      year
      totalBalance {
        ...AnnualLeaveBalance
      }
      onDemandBalance {
        ...AnnualLeaveBalance
      }
    }
  }
}
    ${AnnualLeaveBalanceFragmentDoc}`;
export const TimeReportFinancesContractFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportFinances_Contract on Contract {
  id
  ... on EmploymentContract {
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          value
        }
      }
    }
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          value {
            ...Rate
          }
        }
      }
    }
    overtimeRate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableNetGross {
        value {
          value {
            ...NetGross
          }
        }
      }
    }
  }
  ... on B2BContract {
    currency {
      ...Unauthorized
      ... on AccessGranted__TimeBasedCurrency {
        value {
          value
        }
      }
    }
    rate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedRate {
        value {
          value {
            ...Rate
          }
        }
      }
    }
    overtimeRate {
      ...Unauthorized
      ... on AccessGranted__TimeBasedOptClearableNetGross {
        value {
          value {
            ...NetGross
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${RateFragmentDoc}
${NetGrossFragmentDoc}`;
export const TimeReportFinancesSalaryDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportFinances_SalaryDetails on ContractSalaryDetailsResponse {
  value {
    contractId
    yearMonth
    transferAmount
    transferDeduction {
      grossValue
      note
    }
    ... on EmploymentContractSalaryDetails {
      accountingData {
        taxPrepayment
        zusContribution
        ppkAmount
      }
    }
  }
}
    `;
export const TimeReportFinancesBenefitValueFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportFinances_BenefitValue on BenefitValue {
  variant {
    id
    productId
    promiseeRate {
      value {
        ...BenefitVariantRate
      }
    }
    promisorRate {
      value {
        ...BenefitVariantRate
      }
    }
    parent {
      id
      name
    }
  }
  refundedValue {
    ...NetGross
  }
  notRefundedValue {
    ...NetGross
  }
  totalValue {
    ...NetGross
  }
}
    ${BenefitVariantRateFragmentDoc}
${NetGrossFragmentDoc}`;
export const TimeReportFinancesIncomeDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportFinances_IncomeDetails on IncomeDetails {
  from
  to
  totalWorkTime
  overtimeWorkTime
  standardWorkTime
  rateDetails {
    ...RateDetails
  }
  remoteWorkReimbursement {
    time
    rate
    totalValue {
      ...NetGross
    }
  }
  totalPayout {
    ...NetGross
  }
  payoutWithoutBenefits {
    ...NetGross
  }
  totalValueStandardTimeIncome {
    ...NetGross
  }
  totalValueOvertimeIncome {
    ...NetGross
  }
  standardTimeIncome {
    ...IncomeRow
  }
  overtimeIncome {
    ...HourlyIncomeRow
  }
  onCallLogs {
    multiplier
    shifts
    dates
    shift
    multiplierRate {
      ...NetGross
    }
    totalValue {
      ...NetGross
    }
  }
  totalValueOnCalls {
    ...NetGross
  }
  bonusesValueByCategory {
    bonusCategory
    amount {
      ...NetGross
    }
  }
  totalValueStandardTimeIncomeIncludingBenefits {
    ...NetGross
  }
  totalValueOvertimeIncomeIncludingBenefits {
    ...NetGross
  }
  totalValueBonuses {
    ...NetGross
  }
  benefitsValue {
    totalValueRefunded {
      ...NetGross
    }
    refunded {
      ...TimeReportFinances_BenefitValue
    }
    totalValueNotRefunded {
      ...NetGross
    }
    notRefunded {
      ...TimeReportFinances_BenefitValue
    }
    totalValueThirdParty {
      ...NetGross
    }
    thirdParty {
      ...TimeReportFinances_BenefitValue
    }
    totalValueAll {
      ...NetGross
    }
    refundedHourlyRate {
      ...NetGross
    }
  }
}
    ${RateDetailsFragmentDoc}
${NetGrossFragmentDoc}
${IncomeRowFragmentDoc}
${HourlyIncomeRowFragmentDoc}
${TimeReportFinancesBenefitValueFragmentDoc}`;
export const TimeReportLeaveAndTrainingAnnualLeaveSummaryFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportLeaveAndTraining_AnnualLeaveSummary on AnnualLeaveSummary {
  yearlySummary {
    key
    value {
      year
      totalBalance {
        ...AnnualLeaveBalance
      }
      balanceThisYear {
        ...AnnualLeaveBalance
      }
      carriedOverEntitlementBalance {
        ...AnnualLeaveBalance
      }
      onDemandBalance {
        ...AnnualLeaveBalance
      }
    }
  }
}
    ${AnnualLeaveBalanceFragmentDoc}`;
export const CentsBalanceFragmentDoc = /*#__PURE__*/ gql`
    fragment CentsBalance on CentsBalance {
  entitlement
  used
  available
}
    `;
export const TimeReportLeaveAndTrainingTrainingPackageFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportLeaveAndTraining_TrainingPackage on TrainingBudgetSummary {
  currency
  yearlySummary {
    key
    value {
      year
      totalBalance {
        ...CentsBalance
      }
      balanceThisYear {
        ...CentsBalance
      }
      carriedOverEntitlementBalance {
        ...CentsBalance
      }
    }
  }
}
    ${CentsBalanceFragmentDoc}`;
export const TimeReportLeaveAndTrainingStatsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportLeaveAndTraining_Stats on TimeReportStats {
  incomeDetails {
    ...Unauthorized
    ... on AccessGranted__ListOfIncomeDetails {
      value {
        from
        to
        bonusesValueByCategory {
          bonusCategory
          amount {
            net
            gross
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}`;
export const ReportedLeaveDaysFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportedLeaveDays on ReportedLeaveDays {
  annual {
    ...AnnualLeaveEntitlementValue
  }
  outOfOffice
  sickLeave
  sickFamilyMemberCare
  paid
  unpaid
  special
  maternity
  paternity
  caregiving
  childCare
  dueToForceMajeure
  parental
}
    ${AnnualLeaveEntitlementValueFragmentDoc}`;
export const TimeReportLeaveAndTrainingTimeReportFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportLeaveAndTraining_TimeReport on TimeReport {
  timeReportStats {
    ...TimeReportLeaveAndTraining_Stats
    ... on EmploymentTimeReportStats {
      reportedLeaveDays {
        ...ReportedLeaveDays
      }
      flexTime {
        balance
        absenceTime
      }
    }
    ... on B2BTimeReportStats {
      reportedDaysOff
    }
  }
}
    ${TimeReportLeaveAndTrainingStatsFragmentDoc}
${ReportedLeaveDaysFragmentDoc}`;
export const TimeReportStatsB2BStatsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportStats_B2BStats on B2BTimeReportStats {
  timeBalanceAtEndOfMonth {
    reportedStandardWorkTime
    currentTimeRequirement
    balance
    currentTimeRequirementWithAbsenceTimeSubtracted
    totalTimeInPeriod
  }
  reportedDaysOff
  overtime
  incomeDetails {
    ...Unauthorized
    ... on AccessGranted__ListOfIncomeDetails {
      value {
        onCallLogs {
          shifts
          multiplier
          dates
          shift
          multiplierRate {
            ...NetGross
          }
          totalValue {
            ...NetGross
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${NetGrossFragmentDoc}`;
export const TimeReportStatsEmploymentStatsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportStats_EmploymentStats on EmploymentTimeReportStats {
  overtime
  timeBalanceAtEndOfMonth {
    reportedStandardWorkTime
    currentTimeRequirement
    balance
    currentTimeRequirementWithAbsenceTimeSubtracted
    totalTimeInPeriod
  }
  reportedLeaveDays {
    ...ReportedLeaveDays
  }
  flexTime {
    balance
    reportedStandardWorkTime
    currentTimeRequirement
    totalTimeInPeriod
    period {
      from
      to
    }
  }
  incomeDetails {
    ...Unauthorized
    ... on AccessGranted__ListOfIncomeDetails {
      value {
        onCallLogs {
          shifts
          multiplier
          dates
          shift
          multiplierRate {
            ...NetGross
          }
          totalValue {
            ...NetGross
          }
        }
      }
    }
  }
}
    ${ReportedLeaveDaysFragmentDoc}
${UnauthorizedFragmentDoc}
${NetGrossFragmentDoc}`;
export const ProjectRoleAssignmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ProjectRoleAssignment on ProjectRoleAssignment {
  project {
    id
    entityVersion
  }
  periods {
    dateRange {
      from
      to
    }
    user {
      id
      email
      avatar
      firstName
      lastName
    }
  }
}
    `;
export const ProjectLeadFragmentDoc = /*#__PURE__*/ gql`
    fragment ProjectLead on Project {
  id
  entityVersion
  lead {
    ...ProjectRoleAssignment
  }
}
    ${ProjectRoleAssignmentFragmentDoc}`;
export const KeyPeopleProjectFragmentDoc = /*#__PURE__*/ gql`
    fragment KeyPeopleProject on Project {
  id
  entityVersion
  statusHistory {
    status
    dateRange {
      from
      to
    }
  }
  lead {
    ...ProjectRoleAssignment
  }
  owner {
    ...ProjectRoleAssignment
  }
  accountManager {
    ...ProjectRoleAssignment
  }
}
    ${ProjectRoleAssignmentFragmentDoc}`;
export const TimeReportValidationFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportValidation on TimeReportValidation {
  ... on IncompleteEntries {
    days
  }
  ... on MissingEntries {
    days
  }
}
    `;
export const AbsenceRecordFragmentDoc = /*#__PURE__*/ gql`
    fragment AbsenceRecord on AbsenceRecord {
  id
  absenceType
  from
  to
  comment
  customDurationPerDay
  isOnDemand
  approval {
    ...Approval
  }
  attachment {
    ...Unauthorized
    ... on AccessGranted__OptionalDownloadableExternallyHostedFileUrl {
      value {
        openUrl
        downloadUrl
        fileName
      }
    }
  }
}
    ${ApprovalFragmentDoc}
${UnauthorizedFragmentDoc}`;
export const NfsErrorFragmentDoc = /*#__PURE__*/ gql`
    fragment NfsError on NfsError {
  error {
    nfsErrorId
    msg
    ... on IncompleteArgumentsError {
      missingFields
    }
    ... on ValidationError {
      fields
    }
    ... on AggregatedValidationErrors {
      errors {
        fields
        desc
      }
    }
    ... on ResourceAlreadyReservedError {
      dates
    }
    ... on NoParkingSpotAvailableError {
      dates
    }
  }
}
    `;
export const WorkRecordFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkRecord on WorkRecord {
  id
  date
  duration
  overtime
  draft
  comment
  remoteWork
  approval {
    ...Approval
  }
  workTag {
    id
    name
  }
  workTime {
    timeFrom
    timeTo
    break
  }
  project {
    id
    name
  }
}
    ${ApprovalFragmentDoc}`;
export const OnCallRecordFragmentDoc = /*#__PURE__*/ gql`
    fragment OnCallRecord on OnCallRecord {
  id
  date
  dayShift
  nightShift
  comment
  project {
    id
    name
  }
}
    `;
export const AdminHighlightFragmentDoc = /*#__PURE__*/ gql`
    fragment admin_Highlight on Highlight {
  id
  ... on TimeBasedHighlight {
    effectiveDate
  }
}
    `;
export const AbstractDrawerFragmentDoc = /*#__PURE__*/ gql`
    fragment AbstractDrawer on AbstractDrawer {
  id
  visible
  ... on AddClientContractDrawer {
    companyId
    companyType
    prefillAs
  }
  ... on AddCompanyDrawer {
    initialData {
      companyType
      name
      taxNumber
    }
    returnData {
      id
      name
      taxNumber
    }
  }
  ... on AddInternalProjectDrawer {
    projectId
  }
  ... on AddPersonDrawer {
    newUserId
  }
  ... on AddProjectDrawer {
    prefillClientContractId
    prefillClientId
    projectId
  }
  ... on AddThirdPersonDrawer {
    requiredUserId
    thirdPersonId
  }
  ... on AllBonusesDrawer {
    requiredContractId
  }
  ... on AnnualLeaveEntitlementDrawer {
    requiredContractId
    requiredUserId
    year
  }
  ... on AnnualLeavePreferencesDrawer {
    requiredContractId
    requiredUserId
  }
  ... on AnnualLeaveSummaryDrawer {
    requiredContractId
    requiredUserId
    year
  }
  ... on AssignBenefitDrawer {
    effectiveDate
    highlight {
      ...admin_Highlight
    }
    requiredContractId
    requiredGroupType
    requiredUserId
  }
  ... on B2BContractDraftDrawer {
    editing
    errors
    requiredUserId
  }
  ... on B2BContractNoteDrawer {
    contractId
    editing
    requiredPromiseeId
  }
  ... on B2BSalaryDetailsDrawer {
    requiredContractId
    requiredMonth
  }
  ... on BenefitNoteDrawer {
    editing
    requiredAssignedVariantId
    requiredContractId
  }
  ... on BonusDrawer {
    requiredContractId
    requiredUserId
    selectedBonusId
  }
  ... on BonusPreviewDrawer {
    requiredBonusType
    requiredContractId
    requiredSelectedBonusId
  }
  ... on BookDeskOnBehalfDrawer {
    prefillDeskId
    prefillFrom
    prefillRoomId
    prefillTo
    requiredOfficeId
  }
  ... on BookParkingOnBehalfDrawer {
    prefillFrom
    prefillParkingSpotId
    prefillTo
    requiredOfficeId
  }
  ... on CompanyBankAccountDrawer {
    editing
    initialValue {
      ...BankAccount
    }
    requiredCompanyTypes
    returnValue {
      ...BankAccount
    }
  }
  ... on CompanyDetailsDrawer {
    activeTab
    requiredCompanyId
  }
  ... on ContractBankAccountDrawer {
    contractId
    requiredIsPromisor
    requiredPromiseeId
  }
  ... on ContractBonusesSettingsDrawer {
    requiredContractId
  }
  ... on ContractDetailsDrawer {
    effectiveDate
    highlight {
      ...admin_Highlight
    }
    requiredContractId
  }
  ... on CopyrightsDrawer {
    showUserPreview
  }
  ... on CostAndRevenueItemDrawer {
    requiredProjectId
    selectedCostAndRevenueItemIndex
  }
  ... on CreateBenefitDrawer {
    newBenefitId
    requiredAlternativeBenefitsGroupId
    requiredGroupType
  }
  ... on CreateVariantDrawer {
    requiredParentId
  }
  ... on DeskAssignmentDrawer {
    requiredDeskId
    requiredOfficeId
  }
  ... on DeskDrawer {
    deskId
    requiredOfficeId
    requiredRoomId
  }
  ... on DirectReportingDrawer {
    effectiveDate
    highlight {
      ...admin_Highlight
    }
    requiredUserId
  }
  ... on EditBenefitDrawer {
    requiredBenefitId
  }
  ... on EditBenefitVariantDrawer {
    effectiveDate
    highlight {
      ...admin_Highlight
    }
    requiredVariantId
  }
  ... on EditBenefitVariantPriceDrawer {
    effectiveDate
    highlight {
      ...admin_Highlight
    }
    requiredVariantId
  }
  ... on EditClientContractDrawer {
    requiredClientContractId
    requiredCompanyId
    requiredCompanyType
  }
  ... on EditDeskRequestDrawer {
    requiredOfficeId
    requiredReservationRequestId
  }
  ... on EditOfficeDrawer {
    requiredOfficeId
  }
  ... on EditOfficeSettingsDrawer {
    requiredOfficeId
  }
  ... on EditParkingRequestDrawer {
    requiredOfficeId
    requiredReservationRequestId
  }
  ... on EditProfileAdditionalDataDrawer {
    requiredUserId
  }
  ... on EditProfileAddressDrawer {
    requiredUserId
  }
  ... on EditProfileBasicInfoDrawer {
    requiredUserId
  }
  ... on EditProjectCrossSellDrawer {
    requiredProjectId
  }
  ... on EditProjectDrawer {
    requiredProjectId
  }
  ... on EditProjectTechStackAndCompetencesDrawer {
    requiredProjectId
  }
  ... on EditSkillsAndCertificatesDrawer {
    requiredUserId
  }
  ... on EditSocialMediaHandlesDrawer {
    requiredUserId
  }
  ... on EditSpaceDrawer {
    initialTab
    requiredSpaceId
  }
  ... on EmployeeDueDatesDrawer {
    requiredUserId
  }
  ... on EmploymentBankAccountDrawer {
    contractId
    editing
    highlight {
      ...admin_Highlight
    }
    requiredPromiseeId
  }
  ... on EmploymentContractDraftDrawer {
    editing
    errors
    requiredEmploymentContractType
    requiredUserId
  }
  ... on EmploymentContractNoteDrawer {
    contractId
    editing
    requiredPromiseeId
  }
  ... on EmploymentSalaryDetailsDrawer {
    requiredContractId
    requiredMonth
  }
  ... on InvoiceTransferLinksDrawer {
    requiredInvoiceId
  }
  ... on ListColumnControllsDrawer {
    available
    defaults
    selected
  }
  ... on ManageKeyPeopleDrawer {
    requiredProjectId
  }
  ... on ManageProjectTimelineDrawer {
    requiredProjectId
  }
  ... on OtherEmployeeInformationDrawer {
    requiredUserId
  }
  ... on ParkingSpotDrawer {
    parkingSpotId
    requiredOfficeId
  }
  ... on PaymentDetailsDraftDrawer {
    editing
    requiredContractType
    requiredUserId
  }
  ... on PaymentDetailsDrawer {
    effectiveDate
    highlight {
      ...admin_Highlight
    }
    requiredContractId
    requiredContractType
    requiredUserId
  }
  ... on PendingCopyrightsDrawer {
    highlightedWorkTransferId
    requiredContractId
    requiredStartDate
    requiredYearMonth
  }
  ... on ProgressionSchemeLevelDrawer {
    level
    requiredSchemeId
  }
  ... on ProjectMembersDrawer {
    clientContractLink
    focusedUserId
    mode
    requiredProjectId
  }
  ... on RateCardDrawer {
    addNewPosition
    editing
    effectiveDate
    highlight {
      ...admin_Highlight
    }
    requiredClientContractId
  }
  ... on RoomDrawer {
    requiredOfficeId
    roomId
  }
  ... on SetFutureEntitlementDrawer {
    initialAbsence
    initialDate
    requiredContractId
    requiredUserId
  }
  ... on SetRateAndProgressionDrawer {
    editing
    effectiveDate
    promotionLevel
    requiredContractId
    requiredUserId
  }
  ... on SubcontractDraftDrawer {
    editing
    errors
    requiredUserId
  }
  ... on SubcontractNoteDrawer {
    contractId
    editing
    requiredPromiseeId
  }
  ... on TaxResidencyCertificatesDrawer {
    requiredCompanyId
  }
  ... on TransferDetailsDrawer {
    requiredDate
    requiredTransferId
  }
  ... on UploadDocumentDrawer {
    documentId
  }
  ... on UserProjectsDrawer {
    requiredUserId
  }
  ... on YearlyCostSummaryDrawer {
    requiredUserId
  }
}
    ${AdminHighlightFragmentDoc}
${BankAccountFragmentDoc}`;
export const ChildLevel3FragmentDoc = /*#__PURE__*/ gql`
    fragment ChildLevel3 on AbstractDrawer {
  ...AbstractDrawer
}
    ${AbstractDrawerFragmentDoc}`;
export const ChildLevel2FragmentDoc = /*#__PURE__*/ gql`
    fragment ChildLevel2 on AbstractDrawer {
  ...AbstractDrawer
  child {
    ...ChildLevel3
  }
}
    ${AbstractDrawerFragmentDoc}
${ChildLevel3FragmentDoc}`;
export const ChildLevel1FragmentDoc = /*#__PURE__*/ gql`
    fragment ChildLevel1 on AbstractDrawer {
  ...AbstractDrawer
  child {
    ...ChildLevel2
  }
}
    ${AbstractDrawerFragmentDoc}
${ChildLevel2FragmentDoc}`;
export const ChildLevel0FragmentDoc = /*#__PURE__*/ gql`
    fragment ChildLevel0 on AbstractDrawer {
  ...AbstractDrawer
  child {
    ...ChildLevel1
  }
}
    ${AbstractDrawerFragmentDoc}
${ChildLevel1FragmentDoc}`;
export const WorkTagFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkTag on WorkTag {
  id
  name
  canBeOvertime
  canHaveProjectSelected
  canHaveRecurringWorkRecords
}
    `;
export const LeaveBalanceFragmentDoc = /*#__PURE__*/ gql`
    fragment LeaveBalance on DaysBalance {
  entitlement
  used
  available
}
    `;
export const AboutClientContractDataDocument = /*#__PURE__*/ gql`
    query AboutClientContractData($clientContractId: ClientContractId!) {
  clientContract(id: $clientContractId) {
    ...NfsError
    ... on ClientContract {
      id
      entityVersion
      name {
        ...Unauthorized
        ... on AccessGranted__String {
          value
        }
      }
      promisor {
        id
        companyType
      }
      contractDurationFrom {
        ...Unauthorized
        ... on AccessGranted__LocalDate {
          value
        }
      }
      contractDurationTo {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
      docUri {
        ...Unauthorized
        ... on AccessGranted__OptionalURI {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useAboutClientContractDataQuery__
 *
 * To run a query within a React component, call `useAboutClientContractDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAboutClientContractDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAboutClientContractDataQuery({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *   },
 * });
 */
export function useAboutClientContractDataQuery(baseOptions: ApolloReact.QueryHookOptions<AboutClientContractDataQuery, AboutClientContractDataQueryVariables> & ({ variables: AboutClientContractDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AboutClientContractDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AboutClientContractDataQuery, AboutClientContractDataQueryVariables>(AboutClientContractDataDocument, parser(options)));
      }
export function useAboutClientContractDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AboutClientContractDataQuery, AboutClientContractDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AboutClientContractDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AboutClientContractDataQuery, AboutClientContractDataQueryVariables>(AboutClientContractDataDocument, options));
        }

export type AboutClientContractDataQueryResult = ApolloReact.QueryResult<AboutClientContractDataQuery, AboutClientContractDataQueryVariables>;
export function refetchAboutClientContractDataQuery(variables: AboutClientContractDataQueryVariables) {
      return { query: AboutClientContractDataDocument, variables: variables }
    }
export const AboutProjectDocument = /*#__PURE__*/ gql`
    query AboutProject($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      id
      entityVersion
      createdAt
      name
      description {
        ...Unauthorized
        ... on AccessGranted__OptionalString {
          value
        }
      }
      areaOfVlEngagement {
        ...Unauthorized
        ... on AccessGranted__OptionalString {
          value
        }
      }
      techStack {
        ...Unauthorized
        ... on AccessGranted__ListOfString {
          value
        }
      }
      competences {
        ...Unauthorized
        ... on AccessGranted__ListOfString {
          value
        }
      }
      costLedgerAccountNumber {
        ...Unauthorized
        ... on AccessGranted__OptionalString {
          value
        }
      }
      revenueLedgerAccountNumber {
        ...Unauthorized
        ... on AccessGranted__OptionalString {
          value
        }
      }
      ...KeyPeopleProject
      ...ProjectCrossSell_Project
      space {
        id
        entityVersion
        name
        owner {
          id
          entityVersion
          firstName
          lastName
        }
      }
      clientContract {
        id
        entityVersion
        name {
          ...Unauthorized
          ... on AccessGranted__String {
            value
          }
        }
        promisor {
          id
          name
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${KeyPeopleProjectFragmentDoc}
${ProjectCrossSellProjectFragmentDoc}`;

/**
 * __useAboutProjectQuery__
 *
 * To run a query within a React component, call `useAboutProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAboutProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAboutProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAboutProjectQuery(baseOptions: ApolloReact.QueryHookOptions<AboutProjectQuery, AboutProjectQueryVariables> & ({ variables: AboutProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AboutProjectDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AboutProjectQuery, AboutProjectQueryVariables>(AboutProjectDocument, parser(options)));
      }
export function useAboutProjectLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AboutProjectQuery, AboutProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AboutProjectDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AboutProjectQuery, AboutProjectQueryVariables>(AboutProjectDocument, options));
        }

export type AboutProjectQueryResult = ApolloReact.QueryResult<AboutProjectQuery, AboutProjectQueryVariables>;
export function refetchAboutProjectQuery(variables: AboutProjectQueryVariables) {
      return { query: AboutProjectDocument, variables: variables }
    }
export const AbsencesListFiltersSpacesDocument = /*#__PURE__*/ gql`
    query AbsencesListFilters_Spaces($first: Int, $after: Cursor) {
  spaces(first: $first, after: $after) {
    ...NfsError
    ... on FSPResponseSpace {
      hasNextPage
      edges {
        cursor
        node {
          entityVersion
          id
          name
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useAbsencesListFiltersSpacesQuery__
 *
 * To run a query within a React component, call `useAbsencesListFiltersSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsencesListFiltersSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsencesListFiltersSpacesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAbsencesListFiltersSpacesQuery(baseOptions?: ApolloReact.QueryHookOptions<AbsencesListFiltersSpacesQuery, AbsencesListFiltersSpacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AbsencesListFiltersSpacesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AbsencesListFiltersSpacesQuery, AbsencesListFiltersSpacesQueryVariables>(AbsencesListFiltersSpacesDocument, parser(options)));
      }
export function useAbsencesListFiltersSpacesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AbsencesListFiltersSpacesQuery, AbsencesListFiltersSpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AbsencesListFiltersSpacesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AbsencesListFiltersSpacesQuery, AbsencesListFiltersSpacesQueryVariables>(AbsencesListFiltersSpacesDocument, options));
        }

export type AbsencesListFiltersSpacesQueryResult = ApolloReact.QueryResult<AbsencesListFiltersSpacesQuery, AbsencesListFiltersSpacesQueryVariables>;
export function refetchAbsencesListFiltersSpacesQuery(variables?: AbsencesListFiltersSpacesQueryVariables) {
      return { query: AbsencesListFiltersSpacesDocument, variables: variables }
    }
export const AbsencesListFiltersProjectsDocument = /*#__PURE__*/ gql`
    query AbsencesListFilters_Projects($first: Int, $after: Cursor) {
  projects(first: $first, after: $after, sort: {by: ClientName}) {
    ...NfsError
    ... on FSPResponseProject {
      hasNextPage
      edges {
        cursor
        node {
          entityVersion
          id
          name
          clientContract {
            id
            promisor {
              id
              name
              logo
            }
            promisee {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useAbsencesListFiltersProjectsQuery__
 *
 * To run a query within a React component, call `useAbsencesListFiltersProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsencesListFiltersProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsencesListFiltersProjectsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAbsencesListFiltersProjectsQuery(baseOptions?: ApolloReact.QueryHookOptions<AbsencesListFiltersProjectsQuery, AbsencesListFiltersProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AbsencesListFiltersProjectsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AbsencesListFiltersProjectsQuery, AbsencesListFiltersProjectsQueryVariables>(AbsencesListFiltersProjectsDocument, parser(options)));
      }
export function useAbsencesListFiltersProjectsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AbsencesListFiltersProjectsQuery, AbsencesListFiltersProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AbsencesListFiltersProjectsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AbsencesListFiltersProjectsQuery, AbsencesListFiltersProjectsQueryVariables>(AbsencesListFiltersProjectsDocument, options));
        }

export type AbsencesListFiltersProjectsQueryResult = ApolloReact.QueryResult<AbsencesListFiltersProjectsQuery, AbsencesListFiltersProjectsQueryVariables>;
export function refetchAbsencesListFiltersProjectsQuery(variables?: AbsencesListFiltersProjectsQueryVariables) {
      return { query: AbsencesListFiltersProjectsDocument, variables: variables }
    }
export const AccessRightsProviderDocument = /*#__PURE__*/ gql`
    query AccessRightsProvider($email: String!, $fullName: String!) {
  whoAmI {
    ...NfsError
    ... on ListOfStringResponse {
      value
    }
  }
  users(filter: {all_search: $email}, first: 1) {
    ...NfsError
    ... on FSPResponseUser {
      edges {
        node {
          id
          entityVersion
          email
        }
      }
    }
  }
  spaces(filter: {hasOwner_like: $fullName}) {
    ...NfsError
    ... on FSPResponseSpace {
      edges {
        node {
          id
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useAccessRightsProviderQuery__
 *
 * To run a query within a React component, call `useAccessRightsProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessRightsProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessRightsProviderQuery({
 *   variables: {
 *      email: // value for 'email'
 *      fullName: // value for 'fullName'
 *   },
 * });
 */
export function useAccessRightsProviderQuery(baseOptions: ApolloReact.QueryHookOptions<AccessRightsProviderQuery, AccessRightsProviderQueryVariables> & ({ variables: AccessRightsProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AccessRightsProviderDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AccessRightsProviderQuery, AccessRightsProviderQueryVariables>(AccessRightsProviderDocument, parser(options)));
      }
export function useAccessRightsProviderLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AccessRightsProviderQuery, AccessRightsProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AccessRightsProviderDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AccessRightsProviderQuery, AccessRightsProviderQueryVariables>(AccessRightsProviderDocument, options));
        }

export type AccessRightsProviderQueryResult = ApolloReact.QueryResult<AccessRightsProviderQuery, AccessRightsProviderQueryVariables>;
export function refetchAccessRightsProviderQuery(variables: AccessRightsProviderQueryVariables) {
      return { query: AccessRightsProviderDocument, variables: variables }
    }
export const AddClientContractDrawerInputDocument = /*#__PURE__*/ gql`
    query AddClientContractDrawer_Input($id: CompanyId!) {
  company(id: $id) {
    ...NfsError
    ... on Company {
      id
      entityVersion
      name
      taxNumber
      euVatType {
        value {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useAddClientContractDrawerInputQuery__
 *
 * To run a query within a React component, call `useAddClientContractDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddClientContractDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddClientContractDrawerInputQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddClientContractDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<AddClientContractDrawerInputQuery, AddClientContractDrawerInputQueryVariables> & ({ variables: AddClientContractDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddClientContractDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AddClientContractDrawerInputQuery, AddClientContractDrawerInputQueryVariables>(AddClientContractDrawerInputDocument, parser(options)));
      }
export function useAddClientContractDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AddClientContractDrawerInputQuery, AddClientContractDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AddClientContractDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AddClientContractDrawerInputQuery, AddClientContractDrawerInputQueryVariables>(AddClientContractDrawerInputDocument, options));
        }

export type AddClientContractDrawerInputQueryResult = ApolloReact.QueryResult<AddClientContractDrawerInputQuery, AddClientContractDrawerInputQueryVariables>;
export function refetchAddClientContractDrawerInputQuery(variables: AddClientContractDrawerInputQueryVariables) {
      return { query: AddClientContractDrawerInputDocument, variables: variables }
    }
export const AddClientContractDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation AddClientContractDrawer_Create($id: ClientContractId!, $name: String!, $promiseeId: CompanyId!, $promisorId: CompanyId!, $contractDurationFrom: LocalDate!, $contractDurationTo: LocalDate, $docUri: URI) {
  createClientContract(
    id: $id
    name: $name
    promiseeId: $promiseeId
    promisorId: $promisorId
    contractDurationFrom: $contractDurationFrom
    contractDurationTo: $contractDurationTo
    docUri: $docUri
  ) {
    ...NfsError
    ... on ClientContract {
      id
      entityVersion
      name {
        ...Unauthorized
        ... on AccessGranted__String {
          value
        }
      }
      contractDurationFrom {
        ...Unauthorized
        ... on AccessGranted__LocalDate {
          value
        }
      }
      contractDurationTo {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
      docUri {
        ...Unauthorized
        ... on AccessGranted__OptionalURI {
          value
        }
      }
      promisor {
        id
        name
      }
      promisee {
        id
        name
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;


/**
 * __useAddClientContractDrawerCreateMutation__
 *
 * To run a mutation, you first call `useAddClientContractDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientContractDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientContractDrawerCreateMutation, { data, loading, error }] = useAddClientContractDrawerCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      promiseeId: // value for 'promiseeId'
 *      promisorId: // value for 'promisorId'
 *      contractDurationFrom: // value for 'contractDurationFrom'
 *      contractDurationTo: // value for 'contractDurationTo'
 *      docUri: // value for 'docUri'
 *   },
 * });
 */
export function useAddClientContractDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<AddClientContractDrawerCreateMutation, AddClientContractDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddClientContractDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AddClientContractDrawerCreateMutation, AddClientContractDrawerCreateMutationVariables>(AddClientContractDrawerCreateDocument, parser(options)));
      }
export type AddClientContractDrawerCreateMutationHookResult = ReturnType<typeof useAddClientContractDrawerCreateMutation>;
export type AddClientContractDrawerCreateMutationResult = ApolloReact.MutationResult<AddClientContractDrawerCreateMutation>;
export type AddClientContractDrawerCreateMutationOptions = Apollo.MutationOptions<AddClientContractDrawerCreateMutation, AddClientContractDrawerCreateMutationVariables>;
export const AddCompanyDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation AddCompanyDrawer_Create($company: CompanyInput!) {
  createCompany(company: $company) {
    ...NfsError
    ... on Company {
      id
      entityVersion
      taxNumber
      name
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAddCompanyDrawerCreateMutation__
 *
 * To run a mutation, you first call `useAddCompanyDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyDrawerCreateMutation, { data, loading, error }] = useAddCompanyDrawerCreateMutation({
 *   variables: {
 *      company: // value for 'company'
 *   },
 * });
 */
export function useAddCompanyDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<AddCompanyDrawerCreateMutation, AddCompanyDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddCompanyDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AddCompanyDrawerCreateMutation, AddCompanyDrawerCreateMutationVariables>(AddCompanyDrawerCreateDocument, parser(options)));
      }
export type AddCompanyDrawerCreateMutationHookResult = ReturnType<typeof useAddCompanyDrawerCreateMutation>;
export type AddCompanyDrawerCreateMutationResult = ApolloReact.MutationResult<AddCompanyDrawerCreateMutation>;
export type AddCompanyDrawerCreateMutationOptions = Apollo.MutationOptions<AddCompanyDrawerCreateMutation, AddCompanyDrawerCreateMutationVariables>;
export const AddCompanyFormRegisterInfoDocument = /*#__PURE__*/ gql`
    query AddCompanyForm_RegisterInfo($name: String, $countryCode: CountryCode, $taxNumber: TaxNumber!) {
  companyInfo(name: $name, countryCode: $countryCode, taxNumber: $taxNumber) {
    ...NfsError
    ... on CompanyInfo {
      baseInfo {
        ...NfsError
        ... on BaseInfo {
          name
          taxNumber
          regon
          registerId
          address {
            ...Address
          }
          mailingAddress {
            ...Address
          }
        }
      }
      euVatType {
        ...NfsError
        ... on VerificationStateEuVatTypeResponse {
          value {
            ... on VerifiedEuVatType {
              result
              when
            }
          }
        }
      }
      polishVat {
        ...NfsError
        ... on PolishVat {
          isPolishVat {
            ... on VerifiedWithDescriptionBooleanVATStatus {
              result
              when
            }
          }
          bankAccounts {
            ...BankAccount
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AddressFragmentDoc}
${BankAccountFragmentDoc}`;

/**
 * __useAddCompanyFormRegisterInfoQuery__
 *
 * To run a query within a React component, call `useAddCompanyFormRegisterInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyFormRegisterInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddCompanyFormRegisterInfoQuery({
 *   variables: {
 *      name: // value for 'name'
 *      countryCode: // value for 'countryCode'
 *      taxNumber: // value for 'taxNumber'
 *   },
 * });
 */
export function useAddCompanyFormRegisterInfoQuery(baseOptions: ApolloReact.QueryHookOptions<AddCompanyFormRegisterInfoQuery, AddCompanyFormRegisterInfoQueryVariables> & ({ variables: AddCompanyFormRegisterInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddCompanyFormRegisterInfoDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AddCompanyFormRegisterInfoQuery, AddCompanyFormRegisterInfoQueryVariables>(AddCompanyFormRegisterInfoDocument, parser(options)));
      }
export function useAddCompanyFormRegisterInfoLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AddCompanyFormRegisterInfoQuery, AddCompanyFormRegisterInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AddCompanyFormRegisterInfoDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AddCompanyFormRegisterInfoQuery, AddCompanyFormRegisterInfoQueryVariables>(AddCompanyFormRegisterInfoDocument, options));
        }

export type AddCompanyFormRegisterInfoQueryResult = ApolloReact.QueryResult<AddCompanyFormRegisterInfoQuery, AddCompanyFormRegisterInfoQueryVariables>;
export function refetchAddCompanyFormRegisterInfoQuery(variables: AddCompanyFormRegisterInfoQueryVariables) {
      return { query: AddCompanyFormRegisterInfoDocument, variables: variables }
    }
export const AddInternalProjectDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation AddInternalProjectDrawer_Create($projectId: ProjectId!, $groupCompanyId: CompanyId!, $startDate: LocalDate!, $projectName: String!, $spaceId: SpaceId, $description: String) {
  createInternalProject(
    id: $projectId
    groupCompanyId: $groupCompanyId
    startDate: $startDate
    name: $projectName
    spaceId: $spaceId
    description: $description
  ) {
    ...NfsError
    ... on Project {
      id
      entityVersion
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAddInternalProjectDrawerCreateMutation__
 *
 * To run a mutation, you first call `useAddInternalProjectDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInternalProjectDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInternalProjectDrawerCreateMutation, { data, loading, error }] = useAddInternalProjectDrawerCreateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      groupCompanyId: // value for 'groupCompanyId'
 *      startDate: // value for 'startDate'
 *      projectName: // value for 'projectName'
 *      spaceId: // value for 'spaceId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAddInternalProjectDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<AddInternalProjectDrawerCreateMutation, AddInternalProjectDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddInternalProjectDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AddInternalProjectDrawerCreateMutation, AddInternalProjectDrawerCreateMutationVariables>(AddInternalProjectDrawerCreateDocument, parser(options)));
      }
export type AddInternalProjectDrawerCreateMutationHookResult = ReturnType<typeof useAddInternalProjectDrawerCreateMutation>;
export type AddInternalProjectDrawerCreateMutationResult = ApolloReact.MutationResult<AddInternalProjectDrawerCreateMutation>;
export type AddInternalProjectDrawerCreateMutationOptions = Apollo.MutationOptions<AddInternalProjectDrawerCreateMutation, AddInternalProjectDrawerCreateMutationVariables>;
export const AddOfficeDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation AddOfficeDrawer_Create($officeId: OfficeId!, $name: String!, $period: LocalDateRangeInput!, $blocked: Boolean) {
  createOffice(
    officeId: $officeId
    name: $name
    physical: true
    period: $period
    blocked: $blocked
  ) {
    ...NfsError
    ... on Office {
      officeId
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAddOfficeDrawerCreateMutation__
 *
 * To run a mutation, you first call `useAddOfficeDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOfficeDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOfficeDrawerCreateMutation, { data, loading, error }] = useAddOfficeDrawerCreateMutation({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      name: // value for 'name'
 *      period: // value for 'period'
 *      blocked: // value for 'blocked'
 *   },
 * });
 */
export function useAddOfficeDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<AddOfficeDrawerCreateMutation, AddOfficeDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddOfficeDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AddOfficeDrawerCreateMutation, AddOfficeDrawerCreateMutationVariables>(AddOfficeDrawerCreateDocument, parser(options)));
      }
export type AddOfficeDrawerCreateMutationHookResult = ReturnType<typeof useAddOfficeDrawerCreateMutation>;
export type AddOfficeDrawerCreateMutationResult = ApolloReact.MutationResult<AddOfficeDrawerCreateMutation>;
export type AddOfficeDrawerCreateMutationOptions = Apollo.MutationOptions<AddOfficeDrawerCreateMutation, AddOfficeDrawerCreateMutationVariables>;
export const AddPersonDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation AddPersonDrawer_Create($user: UserInput!) {
  createUser(user: $user) {
    ...NfsError
    ... on User {
      id
      entityVersion
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAddPersonDrawerCreateMutation__
 *
 * To run a mutation, you first call `useAddPersonDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPersonDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPersonDrawerCreateMutation, { data, loading, error }] = useAddPersonDrawerCreateMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useAddPersonDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<AddPersonDrawerCreateMutation, AddPersonDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddPersonDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AddPersonDrawerCreateMutation, AddPersonDrawerCreateMutationVariables>(AddPersonDrawerCreateDocument, parser(options)));
      }
export type AddPersonDrawerCreateMutationHookResult = ReturnType<typeof useAddPersonDrawerCreateMutation>;
export type AddPersonDrawerCreateMutationResult = ApolloReact.MutationResult<AddPersonDrawerCreateMutation>;
export type AddPersonDrawerCreateMutationOptions = Apollo.MutationOptions<AddPersonDrawerCreateMutation, AddPersonDrawerCreateMutationVariables>;
export const AddProgressionSchemeDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation AddProgressionSchemeDrawer_Create($id: ProgressionSchemeId!, $name: String!, $isEngineering: Boolean!, $yearlyRaise: Cents!) {
  createProgressionScheme(
    id: $id
    name: $name
    isEngineering: $isEngineering
    yearlyRaise: $yearlyRaise
    levels: []
  ) {
    ...NfsError
    ... on ProgressionScheme {
      ...ProgressionSchemes_ProgressionScheme
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionSchemesProgressionSchemeFragmentDoc}`;


/**
 * __useAddProgressionSchemeDrawerCreateMutation__
 *
 * To run a mutation, you first call `useAddProgressionSchemeDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProgressionSchemeDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProgressionSchemeDrawerCreateMutation, { data, loading, error }] = useAddProgressionSchemeDrawerCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      isEngineering: // value for 'isEngineering'
 *      yearlyRaise: // value for 'yearlyRaise'
 *   },
 * });
 */
export function useAddProgressionSchemeDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<AddProgressionSchemeDrawerCreateMutation, AddProgressionSchemeDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddProgressionSchemeDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AddProgressionSchemeDrawerCreateMutation, AddProgressionSchemeDrawerCreateMutationVariables>(AddProgressionSchemeDrawerCreateDocument, parser(options)));
      }
export type AddProgressionSchemeDrawerCreateMutationHookResult = ReturnType<typeof useAddProgressionSchemeDrawerCreateMutation>;
export type AddProgressionSchemeDrawerCreateMutationResult = ApolloReact.MutationResult<AddProgressionSchemeDrawerCreateMutation>;
export type AddProgressionSchemeDrawerCreateMutationOptions = Apollo.MutationOptions<AddProgressionSchemeDrawerCreateMutation, AddProgressionSchemeDrawerCreateMutationVariables>;
export const AddProjectDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation AddProjectDrawer_Create($projectId: ProjectId!, $name: String!, $clientContractId: ClientContractId!, $spaceId: SpaceId, $description: String, $areaOfVlEngagement: String, $statusHistory: [ProjectStatusHistoryEntryInput!]!) {
  createProject(
    id: $projectId
    name: $name
    clientContractId: $clientContractId
    spaceId: $spaceId
    description: $description
    areaOfVlEngagement: $areaOfVlEngagement
    statusHistory: $statusHistory
  ) {
    ...NfsError
    ... on Project {
      id
      entityVersion
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAddProjectDrawerCreateMutation__
 *
 * To run a mutation, you first call `useAddProjectDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectDrawerCreateMutation, { data, loading, error }] = useAddProjectDrawerCreateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      clientContractId: // value for 'clientContractId'
 *      spaceId: // value for 'spaceId'
 *      description: // value for 'description'
 *      areaOfVlEngagement: // value for 'areaOfVlEngagement'
 *      statusHistory: // value for 'statusHistory'
 *   },
 * });
 */
export function useAddProjectDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<AddProjectDrawerCreateMutation, AddProjectDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddProjectDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AddProjectDrawerCreateMutation, AddProjectDrawerCreateMutationVariables>(AddProjectDrawerCreateDocument, parser(options)));
      }
export type AddProjectDrawerCreateMutationHookResult = ReturnType<typeof useAddProjectDrawerCreateMutation>;
export type AddProjectDrawerCreateMutationResult = ApolloReact.MutationResult<AddProjectDrawerCreateMutation>;
export type AddProjectDrawerCreateMutationOptions = Apollo.MutationOptions<AddProjectDrawerCreateMutation, AddProjectDrawerCreateMutationVariables>;
export const AddProjectFormCompanyAutocompleteDocument = /*#__PURE__*/ gql`
    query AddProjectForm_CompanyAutocomplete($after: Cursor, $filter: FilterCompanyInput!, $sort: SortingRequestSortCompanyInput, $first: Int!) {
  companies(first: $first, filter: $filter, sort: $sort, after: $after) {
    ...NfsError
    ... on FSPResponseCompany {
      hasNextPage
      edges {
        cursor
        node {
          ...CompanyAutocomplete_Company
          clientContracts {
            ...Unauthorized
            ... on AccessGranted__ListOfClientContract {
              value {
                id
                entityVersion
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CompanyAutocompleteCompanyFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useAddProjectFormCompanyAutocompleteQuery__
 *
 * To run a query within a React component, call `useAddProjectFormCompanyAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProjectFormCompanyAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProjectFormCompanyAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAddProjectFormCompanyAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<AddProjectFormCompanyAutocompleteQuery, AddProjectFormCompanyAutocompleteQueryVariables> & ({ variables: AddProjectFormCompanyAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddProjectFormCompanyAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AddProjectFormCompanyAutocompleteQuery, AddProjectFormCompanyAutocompleteQueryVariables>(AddProjectFormCompanyAutocompleteDocument, parser(options)));
      }
export function useAddProjectFormCompanyAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AddProjectFormCompanyAutocompleteQuery, AddProjectFormCompanyAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AddProjectFormCompanyAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AddProjectFormCompanyAutocompleteQuery, AddProjectFormCompanyAutocompleteQueryVariables>(AddProjectFormCompanyAutocompleteDocument, options));
        }

export type AddProjectFormCompanyAutocompleteQueryResult = ApolloReact.QueryResult<AddProjectFormCompanyAutocompleteQuery, AddProjectFormCompanyAutocompleteQueryVariables>;
export function refetchAddProjectFormCompanyAutocompleteQuery(variables: AddProjectFormCompanyAutocompleteQueryVariables) {
      return { query: AddProjectFormCompanyAutocompleteDocument, variables: variables }
    }
export const AddProjectFormContractAutocompleteDocument = /*#__PURE__*/ gql`
    query AddProjectForm_ContractAutocomplete($companyId: CompanyId!) {
  company(id: $companyId) {
    ...NfsError
    ... on Company {
      ...CompanyAutocomplete_Company
      clientContracts {
        ...Unauthorized
        ... on AccessGranted__ListOfClientContract {
          value {
            id
            entityVersion
            name {
              ...Unauthorized
              ... on AccessGranted__String {
                value
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CompanyAutocompleteCompanyFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useAddProjectFormContractAutocompleteQuery__
 *
 * To run a query within a React component, call `useAddProjectFormContractAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProjectFormContractAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProjectFormContractAutocompleteQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAddProjectFormContractAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<AddProjectFormContractAutocompleteQuery, AddProjectFormContractAutocompleteQueryVariables> & ({ variables: AddProjectFormContractAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddProjectFormContractAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AddProjectFormContractAutocompleteQuery, AddProjectFormContractAutocompleteQueryVariables>(AddProjectFormContractAutocompleteDocument, parser(options)));
      }
export function useAddProjectFormContractAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AddProjectFormContractAutocompleteQuery, AddProjectFormContractAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AddProjectFormContractAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AddProjectFormContractAutocompleteQuery, AddProjectFormContractAutocompleteQueryVariables>(AddProjectFormContractAutocompleteDocument, options));
        }

export type AddProjectFormContractAutocompleteQueryResult = ApolloReact.QueryResult<AddProjectFormContractAutocompleteQuery, AddProjectFormContractAutocompleteQueryVariables>;
export function refetchAddProjectFormContractAutocompleteQuery(variables: AddProjectFormContractAutocompleteQueryVariables) {
      return { query: AddProjectFormContractAutocompleteDocument, variables: variables }
    }
export const AddSpaceDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation AddSpaceDrawer_Create($spaceId: SpaceId!, $name: String!, $spaceOwner: UserId!) {
  createSpace(id: $spaceId, name: $name, owner: $spaceOwner) {
    ...NfsError
    ... on Space {
      id
      entityVersion
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAddSpaceDrawerCreateMutation__
 *
 * To run a mutation, you first call `useAddSpaceDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSpaceDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSpaceDrawerCreateMutation, { data, loading, error }] = useAddSpaceDrawerCreateMutation({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      name: // value for 'name'
 *      spaceOwner: // value for 'spaceOwner'
 *   },
 * });
 */
export function useAddSpaceDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<AddSpaceDrawerCreateMutation, AddSpaceDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddSpaceDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AddSpaceDrawerCreateMutation, AddSpaceDrawerCreateMutationVariables>(AddSpaceDrawerCreateDocument, parser(options)));
      }
export type AddSpaceDrawerCreateMutationHookResult = ReturnType<typeof useAddSpaceDrawerCreateMutation>;
export type AddSpaceDrawerCreateMutationResult = ApolloReact.MutationResult<AddSpaceDrawerCreateMutation>;
export type AddSpaceDrawerCreateMutationOptions = Apollo.MutationOptions<AddSpaceDrawerCreateMutation, AddSpaceDrawerCreateMutationVariables>;
export const AddThirdPersonDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation AddThirdPersonDrawer_Create($id: ExternalBeneficiaryId!, $employeeId: UserId!, $firstName: String!, $lastName: String!, $email: EmailAddress!, $address: AddressInput!) {
  upsertExternalBeneficiary(
    id: $id
    employeeId: $employeeId
    firstName: $firstName
    lastName: $lastName
    email: $email
    address: $address
  ) {
    ...NfsError
    ... on ExternalBeneficiary {
      id
      firstName
      lastName
      email
      address {
        ...Address
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AddressFragmentDoc}`;


/**
 * __useAddThirdPersonDrawerCreateMutation__
 *
 * To run a mutation, you first call `useAddThirdPersonDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddThirdPersonDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addThirdPersonDrawerCreateMutation, { data, loading, error }] = useAddThirdPersonDrawerCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      employeeId: // value for 'employeeId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useAddThirdPersonDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<AddThirdPersonDrawerCreateMutation, AddThirdPersonDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddThirdPersonDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AddThirdPersonDrawerCreateMutation, AddThirdPersonDrawerCreateMutationVariables>(AddThirdPersonDrawerCreateDocument, parser(options)));
      }
export type AddThirdPersonDrawerCreateMutationHookResult = ReturnType<typeof useAddThirdPersonDrawerCreateMutation>;
export type AddThirdPersonDrawerCreateMutationResult = ApolloReact.MutationResult<AddThirdPersonDrawerCreateMutation>;
export type AddThirdPersonDrawerCreateMutationOptions = Apollo.MutationOptions<AddThirdPersonDrawerCreateMutation, AddThirdPersonDrawerCreateMutationVariables>;
export const AddThirdPersonDrawerLoadDataDocument = /*#__PURE__*/ gql`
    query AddThirdPersonDrawer_LoadData($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      externalBeneficiaries {
        ...Unauthorized
        ... on AccessGranted__ListOfExternalBeneficiary {
          value {
            id
            firstName
            lastName
            email
            address {
              ...Address
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useAddThirdPersonDrawerLoadDataQuery__
 *
 * To run a query within a React component, call `useAddThirdPersonDrawerLoadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddThirdPersonDrawerLoadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddThirdPersonDrawerLoadDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddThirdPersonDrawerLoadDataQuery(baseOptions: ApolloReact.QueryHookOptions<AddThirdPersonDrawerLoadDataQuery, AddThirdPersonDrawerLoadDataQueryVariables> & ({ variables: AddThirdPersonDrawerLoadDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AddThirdPersonDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AddThirdPersonDrawerLoadDataQuery, AddThirdPersonDrawerLoadDataQueryVariables>(AddThirdPersonDrawerLoadDataDocument, parser(options)));
      }
export function useAddThirdPersonDrawerLoadDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AddThirdPersonDrawerLoadDataQuery, AddThirdPersonDrawerLoadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AddThirdPersonDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AddThirdPersonDrawerLoadDataQuery, AddThirdPersonDrawerLoadDataQueryVariables>(AddThirdPersonDrawerLoadDataDocument, options));
        }

export type AddThirdPersonDrawerLoadDataQueryResult = ApolloReact.QueryResult<AddThirdPersonDrawerLoadDataQuery, AddThirdPersonDrawerLoadDataQueryVariables>;
export function refetchAddThirdPersonDrawerLoadDataQuery(variables: AddThirdPersonDrawerLoadDataQueryVariables) {
      return { query: AddThirdPersonDrawerLoadDataDocument, variables: variables }
    }
export const AdditionalCostsDrawerEntityVersionDocument = /*#__PURE__*/ gql`
    query AdditionalCostsDrawer_EntityVersion($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useAdditionalCostsDrawerEntityVersionQuery__
 *
 * To run a query within a React component, call `useAdditionalCostsDrawerEntityVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalCostsDrawerEntityVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalCostsDrawerEntityVersionQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useAdditionalCostsDrawerEntityVersionQuery(baseOptions: ApolloReact.QueryHookOptions<AdditionalCostsDrawerEntityVersionQuery, AdditionalCostsDrawerEntityVersionQueryVariables> & ({ variables: AdditionalCostsDrawerEntityVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdditionalCostsDrawerEntityVersionDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdditionalCostsDrawerEntityVersionQuery, AdditionalCostsDrawerEntityVersionQueryVariables>(AdditionalCostsDrawerEntityVersionDocument, parser(options)));
      }
export function useAdditionalCostsDrawerEntityVersionLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdditionalCostsDrawerEntityVersionQuery, AdditionalCostsDrawerEntityVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdditionalCostsDrawerEntityVersionDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdditionalCostsDrawerEntityVersionQuery, AdditionalCostsDrawerEntityVersionQueryVariables>(AdditionalCostsDrawerEntityVersionDocument, options));
        }

export type AdditionalCostsDrawerEntityVersionQueryResult = ApolloReact.QueryResult<AdditionalCostsDrawerEntityVersionQuery, AdditionalCostsDrawerEntityVersionQueryVariables>;
export function refetchAdditionalCostsDrawerEntityVersionQuery(variables: AdditionalCostsDrawerEntityVersionQueryVariables) {
      return { query: AdditionalCostsDrawerEntityVersionDocument, variables: variables }
    }
export const AllBonusesDrawerDeleteDocument = /*#__PURE__*/ gql`
    mutation AllBonusesDrawer_Delete($contractId: ContractId!, $entityVersion: EntityVersion!, $bonusId: BonusId!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    bonus(id: $bonusId) {
      delete {
        ...NfsError
        ... on UnitResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAllBonusesDrawerDeleteMutation__
 *
 * To run a mutation, you first call `useAllBonusesDrawerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllBonusesDrawerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allBonusesDrawerDeleteMutation, { data, loading, error }] = useAllBonusesDrawerDeleteMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      bonusId: // value for 'bonusId'
 *   },
 * });
 */
export function useAllBonusesDrawerDeleteMutation(baseOptions?: ApolloReact.MutationHookOptions<AllBonusesDrawerDeleteMutation, AllBonusesDrawerDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AllBonusesDrawerDeleteDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AllBonusesDrawerDeleteMutation, AllBonusesDrawerDeleteMutationVariables>(AllBonusesDrawerDeleteDocument, parser(options)));
      }
export type AllBonusesDrawerDeleteMutationHookResult = ReturnType<typeof useAllBonusesDrawerDeleteMutation>;
export type AllBonusesDrawerDeleteMutationResult = ApolloReact.MutationResult<AllBonusesDrawerDeleteMutation>;
export type AllBonusesDrawerDeleteMutationOptions = Apollo.MutationOptions<AllBonusesDrawerDeleteMutation, AllBonusesDrawerDeleteMutationVariables>;
export const AllBonusesDrawerDocument = /*#__PURE__*/ gql`
    query AllBonusesDrawer($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        promisee {
          id
        }
        ... on EmploymentContract {
          currency {
            ...Unauthorized
            ... on AccessGranted__TimeBasedCurrency {
              value {
                ...AllBonusesDrawer_Currency
              }
            }
          }
        }
        ... on B2BContract {
          currency {
            ...Unauthorized
            ... on AccessGranted__TimeBasedCurrency {
              value {
                ...AllBonusesDrawer_Currency
              }
            }
          }
          vat {
            ...Unauthorized
            ... on AccessGranted__TimeBasedVatType {
              value {
                value {
                  ...VatType
                }
              }
            }
          }
        }
        bonuses {
          ...Unauthorized
          ... on AccessGranted__Bonuses {
            value {
              paidOut {
                ...AllBonusesDrawer_Bonus
              }
              future {
                ...AllBonusesDrawer_Bonus
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AllBonusesDrawerCurrencyFragmentDoc}
${VatTypeFragmentDoc}
${AllBonusesDrawerBonusFragmentDoc}`;

/**
 * __useAllBonusesDrawerQuery__
 *
 * To run a query within a React component, call `useAllBonusesDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBonusesDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBonusesDrawerQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useAllBonusesDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<AllBonusesDrawerQuery, AllBonusesDrawerQueryVariables> & ({ variables: AllBonusesDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AllBonusesDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AllBonusesDrawerQuery, AllBonusesDrawerQueryVariables>(AllBonusesDrawerDocument, parser(options)));
      }
export function useAllBonusesDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AllBonusesDrawerQuery, AllBonusesDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AllBonusesDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AllBonusesDrawerQuery, AllBonusesDrawerQueryVariables>(AllBonusesDrawerDocument, options));
        }

export type AllBonusesDrawerQueryResult = ApolloReact.QueryResult<AllBonusesDrawerQuery, AllBonusesDrawerQueryVariables>;
export function refetchAllBonusesDrawerQuery(variables: AllBonusesDrawerQueryVariables) {
      return { query: AllBonusesDrawerDocument, variables: variables }
    }
export const AnnualLeaveDetailsDocument = /*#__PURE__*/ gql`
    query AnnualLeaveDetails($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      isStudent {
        ...Unauthorized
        ... on AccessGranted__Boolean {
          value
        }
      }
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            name
            startDate
            expectedEndDate
            entityVersion
            status
            createdAt
            conclusionDate {
              ...Unauthorized
              ... on AccessGranted__LocalDate {
                value
              }
            }
            terminationDate
            promisee {
              id
              entityVersion
            }
            promisor {
              value {
                id
                entityVersion
                name
              }
            }
            ... on EmploymentContract {
              type
              workingTime {
                ...Unauthorized
                ... on AccessGranted__TimeBasedWorkingTime {
                  value {
                    value {
                      numerator
                      denominator
                    }
                  }
                }
              }
              annualLeaveEntitlement {
                ...Unauthorized
                ... on AccessGranted__OptionalAnnualLeaveEntitlement {
                  value {
                    history {
                      entitlement {
                        ...AnnualLeaveEntitlementValue
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AnnualLeaveEntitlementValueFragmentDoc}`;

/**
 * __useAnnualLeaveDetailsQuery__
 *
 * To run a query within a React component, call `useAnnualLeaveDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnualLeaveDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnualLeaveDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAnnualLeaveDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<AnnualLeaveDetailsQuery, AnnualLeaveDetailsQueryVariables> & ({ variables: AnnualLeaveDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AnnualLeaveDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AnnualLeaveDetailsQuery, AnnualLeaveDetailsQueryVariables>(AnnualLeaveDetailsDocument, parser(options)));
      }
export function useAnnualLeaveDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AnnualLeaveDetailsQuery, AnnualLeaveDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AnnualLeaveDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AnnualLeaveDetailsQuery, AnnualLeaveDetailsQueryVariables>(AnnualLeaveDetailsDocument, options));
        }

export type AnnualLeaveDetailsQueryResult = ApolloReact.QueryResult<AnnualLeaveDetailsQuery, AnnualLeaveDetailsQueryVariables>;
export function refetchAnnualLeaveDetailsQuery(variables: AnnualLeaveDetailsQueryVariables) {
      return { query: AnnualLeaveDetailsDocument, variables: variables }
    }
export const AnnualLeaveEntitlementDocument = /*#__PURE__*/ gql`
    mutation AnnualLeaveEntitlement($contractId: ContractId!, $entityVersion: EntityVersion!, $annualLeaveEntitlement: AnnualLeaveEntitlementInput!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(annualLeaveEntitlement: $annualLeaveEntitlement) {
      ...NfsError
      ... on EmploymentContract {
        id
        entityVersion
        annualLeaveEntitlement {
          ...Unauthorized
          ... on AccessGranted__OptionalAnnualLeaveEntitlement {
            value {
              history {
                dateRange {
                  from
                  to
                }
                entitlement {
                  ...AnnualLeaveEntitlementValue
                }
                entitlementExplanation
                createdAt
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AnnualLeaveEntitlementValueFragmentDoc}`;


/**
 * __useAnnualLeaveEntitlementMutation__
 *
 * To run a mutation, you first call `useAnnualLeaveEntitlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnualLeaveEntitlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [annualLeaveEntitlementMutation, { data, loading, error }] = useAnnualLeaveEntitlementMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      annualLeaveEntitlement: // value for 'annualLeaveEntitlement'
 *   },
 * });
 */
export function useAnnualLeaveEntitlementMutation(baseOptions?: ApolloReact.MutationHookOptions<AnnualLeaveEntitlementMutation, AnnualLeaveEntitlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AnnualLeaveEntitlementDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AnnualLeaveEntitlementMutation, AnnualLeaveEntitlementMutationVariables>(AnnualLeaveEntitlementDocument, parser(options)));
      }
export type AnnualLeaveEntitlementMutationHookResult = ReturnType<typeof useAnnualLeaveEntitlementMutation>;
export type AnnualLeaveEntitlementMutationResult = ApolloReact.MutationResult<AnnualLeaveEntitlementMutation>;
export type AnnualLeaveEntitlementMutationOptions = Apollo.MutationOptions<AnnualLeaveEntitlementMutation, AnnualLeaveEntitlementMutationVariables>;
export const AnnualLeaveEntitlementDrawerSetEntitlementDocument = /*#__PURE__*/ gql`
    mutation AnnualLeaveEntitlementDrawer_SetEntitlement($contractId: ContractId!, $entityVersion: EntityVersion!, $annualLeaveEntitlement: AnnualLeaveEntitlementInput!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(annualLeaveEntitlement: $annualLeaveEntitlement) {
      ...NfsError
      ... on EmploymentContract {
        id
        entityVersion
        annualLeaveEntitlement {
          ...Unauthorized
          ... on AccessGranted__OptionalAnnualLeaveEntitlement {
            value {
              history {
                dateRange {
                  from
                  to
                }
                entitlement {
                  ...AnnualLeaveEntitlementValue
                }
                entitlementExplanation
                createdAt
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AnnualLeaveEntitlementValueFragmentDoc}`;


/**
 * __useAnnualLeaveEntitlementDrawerSetEntitlementMutation__
 *
 * To run a mutation, you first call `useAnnualLeaveEntitlementDrawerSetEntitlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnualLeaveEntitlementDrawerSetEntitlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [annualLeaveEntitlementDrawerSetEntitlementMutation, { data, loading, error }] = useAnnualLeaveEntitlementDrawerSetEntitlementMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      annualLeaveEntitlement: // value for 'annualLeaveEntitlement'
 *   },
 * });
 */
export function useAnnualLeaveEntitlementDrawerSetEntitlementMutation(baseOptions?: ApolloReact.MutationHookOptions<AnnualLeaveEntitlementDrawerSetEntitlementMutation, AnnualLeaveEntitlementDrawerSetEntitlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AnnualLeaveEntitlementDrawerSetEntitlementDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AnnualLeaveEntitlementDrawerSetEntitlementMutation, AnnualLeaveEntitlementDrawerSetEntitlementMutationVariables>(AnnualLeaveEntitlementDrawerSetEntitlementDocument, parser(options)));
      }
export type AnnualLeaveEntitlementDrawerSetEntitlementMutationHookResult = ReturnType<typeof useAnnualLeaveEntitlementDrawerSetEntitlementMutation>;
export type AnnualLeaveEntitlementDrawerSetEntitlementMutationResult = ApolloReact.MutationResult<AnnualLeaveEntitlementDrawerSetEntitlementMutation>;
export type AnnualLeaveEntitlementDrawerSetEntitlementMutationOptions = Apollo.MutationOptions<AnnualLeaveEntitlementDrawerSetEntitlementMutation, AnnualLeaveEntitlementDrawerSetEntitlementMutationVariables>;
export const AnnualLeavePreferencesDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query AnnualLeavePreferencesDrawer_InitialData($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        startDate
        ... on EmploymentContract {
          type
          annualLeaveEntitlement {
            ...Unauthorized
            ... on AccessGranted__OptionalAnnualLeaveEntitlement {
              value {
                withCarryOverToNextYear
                history {
                  dateRange {
                    from
                    to
                  }
                  entitlement {
                    ...AnnualLeaveEntitlementValue
                  }
                  entitlementExplanation
                  createdAt
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AnnualLeaveEntitlementValueFragmentDoc}`;

/**
 * __useAnnualLeavePreferencesDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useAnnualLeavePreferencesDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnualLeavePreferencesDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnualLeavePreferencesDrawerInitialDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useAnnualLeavePreferencesDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<AnnualLeavePreferencesDrawerInitialDataQuery, AnnualLeavePreferencesDrawerInitialDataQueryVariables> & ({ variables: AnnualLeavePreferencesDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AnnualLeavePreferencesDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AnnualLeavePreferencesDrawerInitialDataQuery, AnnualLeavePreferencesDrawerInitialDataQueryVariables>(AnnualLeavePreferencesDrawerInitialDataDocument, parser(options)));
      }
export function useAnnualLeavePreferencesDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AnnualLeavePreferencesDrawerInitialDataQuery, AnnualLeavePreferencesDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AnnualLeavePreferencesDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AnnualLeavePreferencesDrawerInitialDataQuery, AnnualLeavePreferencesDrawerInitialDataQueryVariables>(AnnualLeavePreferencesDrawerInitialDataDocument, options));
        }

export type AnnualLeavePreferencesDrawerInitialDataQueryResult = ApolloReact.QueryResult<AnnualLeavePreferencesDrawerInitialDataQuery, AnnualLeavePreferencesDrawerInitialDataQueryVariables>;
export function refetchAnnualLeavePreferencesDrawerInitialDataQuery(variables: AnnualLeavePreferencesDrawerInitialDataQueryVariables) {
      return { query: AnnualLeavePreferencesDrawerInitialDataDocument, variables: variables }
    }
export const AnnualLeavePreferencesDrawerUpdatePreferencesDocument = /*#__PURE__*/ gql`
    mutation AnnualLeavePreferencesDrawer_UpdatePreferences($contractId: ContractId!, $entityVersion: EntityVersion!, $annualLeaveEntitlement: AnnualLeaveEntitlementInput!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(annualLeaveEntitlement: $annualLeaveEntitlement) {
      ...NfsError
      ... on EmploymentContract {
        id
        entityVersion
        annualLeaveEntitlement {
          ...Unauthorized
          ... on AccessGranted__OptionalAnnualLeaveEntitlement {
            value {
              withCarryOverToNextYear
              history {
                dateRange {
                  from
                  to
                }
                entitlement {
                  ...AnnualLeaveEntitlementValue
                }
                entitlementExplanation
                createdAt
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AnnualLeaveEntitlementValueFragmentDoc}`;


/**
 * __useAnnualLeavePreferencesDrawerUpdatePreferencesMutation__
 *
 * To run a mutation, you first call `useAnnualLeavePreferencesDrawerUpdatePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnualLeavePreferencesDrawerUpdatePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [annualLeavePreferencesDrawerUpdatePreferencesMutation, { data, loading, error }] = useAnnualLeavePreferencesDrawerUpdatePreferencesMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      annualLeaveEntitlement: // value for 'annualLeaveEntitlement'
 *   },
 * });
 */
export function useAnnualLeavePreferencesDrawerUpdatePreferencesMutation(baseOptions?: ApolloReact.MutationHookOptions<AnnualLeavePreferencesDrawerUpdatePreferencesMutation, AnnualLeavePreferencesDrawerUpdatePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AnnualLeavePreferencesDrawerUpdatePreferencesDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AnnualLeavePreferencesDrawerUpdatePreferencesMutation, AnnualLeavePreferencesDrawerUpdatePreferencesMutationVariables>(AnnualLeavePreferencesDrawerUpdatePreferencesDocument, parser(options)));
      }
export type AnnualLeavePreferencesDrawerUpdatePreferencesMutationHookResult = ReturnType<typeof useAnnualLeavePreferencesDrawerUpdatePreferencesMutation>;
export type AnnualLeavePreferencesDrawerUpdatePreferencesMutationResult = ApolloReact.MutationResult<AnnualLeavePreferencesDrawerUpdatePreferencesMutation>;
export type AnnualLeavePreferencesDrawerUpdatePreferencesMutationOptions = Apollo.MutationOptions<AnnualLeavePreferencesDrawerUpdatePreferencesMutation, AnnualLeavePreferencesDrawerUpdatePreferencesMutationVariables>;
export const AnnualLeaveSummaryDocument = /*#__PURE__*/ gql`
    query AnnualLeaveSummary($contractId: ContractId!, $year: Year!) {
  annualLeaveSummary(contractId: $contractId, year: $year) {
    ...NfsError
    ... on AnnualLeaveSummary {
      ...AnnualLeaveSummary_History
    }
  }
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        startDate
        terminationDate
        entityVersion
        ... on EmploymentContract {
          type
          workingTime {
            ...Unauthorized
            ... on AccessGranted__TimeBasedWorkingTime {
              value {
                value {
                  numerator
                  denominator
                }
              }
            }
          }
          annualLeaveEntitlement {
            ...Unauthorized
            ... on AccessGranted__OptionalAnnualLeaveEntitlement {
              value {
                withCarryOverToNextYear
                history {
                  dateRange {
                    from
                    to
                  }
                  entitlement {
                    ...AnnualLeaveEntitlementValue
                  }
                  entitlementExplanation
                  createdAt
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AnnualLeaveSummaryHistoryFragmentDoc}
${UnauthorizedFragmentDoc}
${AnnualLeaveEntitlementValueFragmentDoc}`;

/**
 * __useAnnualLeaveSummaryQuery__
 *
 * To run a query within a React component, call `useAnnualLeaveSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnualLeaveSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnualLeaveSummaryQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useAnnualLeaveSummaryQuery(baseOptions: ApolloReact.QueryHookOptions<AnnualLeaveSummaryQuery, AnnualLeaveSummaryQueryVariables> & ({ variables: AnnualLeaveSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AnnualLeaveSummaryDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AnnualLeaveSummaryQuery, AnnualLeaveSummaryQueryVariables>(AnnualLeaveSummaryDocument, parser(options)));
      }
export function useAnnualLeaveSummaryLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AnnualLeaveSummaryQuery, AnnualLeaveSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AnnualLeaveSummaryDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AnnualLeaveSummaryQuery, AnnualLeaveSummaryQueryVariables>(AnnualLeaveSummaryDocument, options));
        }

export type AnnualLeaveSummaryQueryResult = ApolloReact.QueryResult<AnnualLeaveSummaryQuery, AnnualLeaveSummaryQueryVariables>;
export function refetchAnnualLeaveSummaryQuery(variables: AnnualLeaveSummaryQueryVariables) {
      return { query: AnnualLeaveSummaryDocument, variables: variables }
    }
export const AnnualLeaveSummaryUpdateYearDocument = /*#__PURE__*/ gql`
    mutation AnnualLeaveSummary_UpdateYear($contractId: ContractId!, $entityVersion: EntityVersion!, $annualLeaveEntitlement: AnnualLeaveEntitlementInput!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(annualLeaveEntitlement: $annualLeaveEntitlement) {
      ...NfsError
      ... on EmploymentContract {
        id
        entityVersion
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAnnualLeaveSummaryUpdateYearMutation__
 *
 * To run a mutation, you first call `useAnnualLeaveSummaryUpdateYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnualLeaveSummaryUpdateYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [annualLeaveSummaryUpdateYearMutation, { data, loading, error }] = useAnnualLeaveSummaryUpdateYearMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      annualLeaveEntitlement: // value for 'annualLeaveEntitlement'
 *   },
 * });
 */
export function useAnnualLeaveSummaryUpdateYearMutation(baseOptions?: ApolloReact.MutationHookOptions<AnnualLeaveSummaryUpdateYearMutation, AnnualLeaveSummaryUpdateYearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AnnualLeaveSummaryUpdateYearDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AnnualLeaveSummaryUpdateYearMutation, AnnualLeaveSummaryUpdateYearMutationVariables>(AnnualLeaveSummaryUpdateYearDocument, parser(options)));
      }
export type AnnualLeaveSummaryUpdateYearMutationHookResult = ReturnType<typeof useAnnualLeaveSummaryUpdateYearMutation>;
export type AnnualLeaveSummaryUpdateYearMutationResult = ApolloReact.MutationResult<AnnualLeaveSummaryUpdateYearMutation>;
export type AnnualLeaveSummaryUpdateYearMutationOptions = Apollo.MutationOptions<AnnualLeaveSummaryUpdateYearMutation, AnnualLeaveSummaryUpdateYearMutationVariables>;
export const AnnualLeaveSummaryDrawerDocument = /*#__PURE__*/ gql`
    query AnnualLeaveSummaryDrawer($contractId: ContractId!, $year: Year!) {
  annualLeaveSummary(contractId: $contractId, year: $year) {
    ...NfsError
    ... on AnnualLeaveSummary {
      yearlySummary {
        key
        value {
          year
          totalBalance {
            ...AnnualLeaveBalance
          }
          balanceThisYear {
            ...AnnualLeaveBalance
          }
          carriedOverEntitlementBalance {
            ...AnnualLeaveBalance
          }
        }
      }
    }
  }
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        startDate
        ... on EmploymentContract {
          type
          workingTime {
            ...Unauthorized
            ... on AccessGranted__TimeBasedWorkingTime {
              value {
                value {
                  numerator
                  denominator
                }
              }
            }
          }
          annualLeaveEntitlement {
            ...Unauthorized
            ... on AccessGranted__OptionalAnnualLeaveEntitlement {
              value {
                withCarryOverToNextYear
                history {
                  dateRange {
                    from
                    to
                  }
                  entitlement {
                    ...AnnualLeaveEntitlementValue
                  }
                  entitlementExplanation
                  createdAt
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AnnualLeaveBalanceFragmentDoc}
${UnauthorizedFragmentDoc}
${AnnualLeaveEntitlementValueFragmentDoc}`;

/**
 * __useAnnualLeaveSummaryDrawerQuery__
 *
 * To run a query within a React component, call `useAnnualLeaveSummaryDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnualLeaveSummaryDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnualLeaveSummaryDrawerQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useAnnualLeaveSummaryDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<AnnualLeaveSummaryDrawerQuery, AnnualLeaveSummaryDrawerQueryVariables> & ({ variables: AnnualLeaveSummaryDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AnnualLeaveSummaryDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AnnualLeaveSummaryDrawerQuery, AnnualLeaveSummaryDrawerQueryVariables>(AnnualLeaveSummaryDrawerDocument, parser(options)));
      }
export function useAnnualLeaveSummaryDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AnnualLeaveSummaryDrawerQuery, AnnualLeaveSummaryDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AnnualLeaveSummaryDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AnnualLeaveSummaryDrawerQuery, AnnualLeaveSummaryDrawerQueryVariables>(AnnualLeaveSummaryDrawerDocument, options));
        }

export type AnnualLeaveSummaryDrawerQueryResult = ApolloReact.QueryResult<AnnualLeaveSummaryDrawerQuery, AnnualLeaveSummaryDrawerQueryVariables>;
export function refetchAnnualLeaveSummaryDrawerQuery(variables: AnnualLeaveSummaryDrawerQueryVariables) {
      return { query: AnnualLeaveSummaryDrawerDocument, variables: variables }
    }
export const ApproveAndSendRaiseModalGmailConnectionDocument = /*#__PURE__*/ gql`
    query ApproveAndSendRaiseModal_GmailConnection {
  gmailConnection {
    ...NfsError
    ... on GmailConnection {
      adminId
      connectedEmail
      aliases
      selectedAlias
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useApproveAndSendRaiseModalGmailConnectionQuery__
 *
 * To run a query within a React component, call `useApproveAndSendRaiseModalGmailConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useApproveAndSendRaiseModalGmailConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApproveAndSendRaiseModalGmailConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useApproveAndSendRaiseModalGmailConnectionQuery(baseOptions?: ApolloReact.QueryHookOptions<ApproveAndSendRaiseModalGmailConnectionQuery, ApproveAndSendRaiseModalGmailConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ApproveAndSendRaiseModalGmailConnectionDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ApproveAndSendRaiseModalGmailConnectionQuery, ApproveAndSendRaiseModalGmailConnectionQueryVariables>(ApproveAndSendRaiseModalGmailConnectionDocument, parser(options)));
      }
export function useApproveAndSendRaiseModalGmailConnectionLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ApproveAndSendRaiseModalGmailConnectionQuery, ApproveAndSendRaiseModalGmailConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ApproveAndSendRaiseModalGmailConnectionDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ApproveAndSendRaiseModalGmailConnectionQuery, ApproveAndSendRaiseModalGmailConnectionQueryVariables>(ApproveAndSendRaiseModalGmailConnectionDocument, options));
        }

export type ApproveAndSendRaiseModalGmailConnectionQueryResult = ApolloReact.QueryResult<ApproveAndSendRaiseModalGmailConnectionQuery, ApproveAndSendRaiseModalGmailConnectionQueryVariables>;
export function refetchApproveAndSendRaiseModalGmailConnectionQuery(variables?: ApproveAndSendRaiseModalGmailConnectionQueryVariables) {
      return { query: ApproveAndSendRaiseModalGmailConnectionDocument, variables: variables }
    }
export const ApproveAndSendRaiseModalApplyRaiseDocument = /*#__PURE__*/ gql`
    mutation ApproveAndSendRaiseModal_ApplyRaise($contractId: ContractId!, $effectiveFrom: YearMonth!, $entityVersion: EntityVersion!, $to: [EmailAddress!]!, $cc: [EmailAddress!]!, $subject: String!, $body: String!, $from: EmailAddress) {
  applyRaiseAndSendEmail(
    contractId: $contractId
    effectiveFrom: $effectiveFrom
    entityVersion: $entityVersion
    email: {to: $to, cc: $cc, subject: $subject, body: $body, from: $from}
  ) {
    ...NfsError
    ... on ApplyRaiseResult {
      contractId
      newHourlyRate
      effectiveFrom
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useApproveAndSendRaiseModalApplyRaiseMutation__
 *
 * To run a mutation, you first call `useApproveAndSendRaiseModalApplyRaiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAndSendRaiseModalApplyRaiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAndSendRaiseModalApplyRaiseMutation, { data, loading, error }] = useApproveAndSendRaiseModalApplyRaiseMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      effectiveFrom: // value for 'effectiveFrom'
 *      entityVersion: // value for 'entityVersion'
 *      to: // value for 'to'
 *      cc: // value for 'cc'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useApproveAndSendRaiseModalApplyRaiseMutation(baseOptions?: ApolloReact.MutationHookOptions<ApproveAndSendRaiseModalApplyRaiseMutation, ApproveAndSendRaiseModalApplyRaiseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ApproveAndSendRaiseModalApplyRaiseDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ApproveAndSendRaiseModalApplyRaiseMutation, ApproveAndSendRaiseModalApplyRaiseMutationVariables>(ApproveAndSendRaiseModalApplyRaiseDocument, parser(options)));
      }
export type ApproveAndSendRaiseModalApplyRaiseMutationHookResult = ReturnType<typeof useApproveAndSendRaiseModalApplyRaiseMutation>;
export type ApproveAndSendRaiseModalApplyRaiseMutationResult = ApolloReact.MutationResult<ApproveAndSendRaiseModalApplyRaiseMutation>;
export type ApproveAndSendRaiseModalApplyRaiseMutationOptions = Apollo.MutationOptions<ApproveAndSendRaiseModalApplyRaiseMutation, ApproveAndSendRaiseModalApplyRaiseMutationVariables>;
export const ArchiveProgressionSchemeModalArchiveDocument = /*#__PURE__*/ gql`
    mutation ArchiveProgressionSchemeModal_Archive($progressionSchemeId: ProgressionSchemeId!) {
  archiveProgressionScheme(progressionSchemeId: $progressionSchemeId) {
    ...NfsError
    ... on ProgressionScheme {
      ...ProgressionSchemes_ProgressionScheme
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionSchemesProgressionSchemeFragmentDoc}`;


/**
 * __useArchiveProgressionSchemeModalArchiveMutation__
 *
 * To run a mutation, you first call `useArchiveProgressionSchemeModalArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProgressionSchemeModalArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProgressionSchemeModalArchiveMutation, { data, loading, error }] = useArchiveProgressionSchemeModalArchiveMutation({
 *   variables: {
 *      progressionSchemeId: // value for 'progressionSchemeId'
 *   },
 * });
 */
export function useArchiveProgressionSchemeModalArchiveMutation(baseOptions?: ApolloReact.MutationHookOptions<ArchiveProgressionSchemeModalArchiveMutation, ArchiveProgressionSchemeModalArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ArchiveProgressionSchemeModalArchiveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ArchiveProgressionSchemeModalArchiveMutation, ArchiveProgressionSchemeModalArchiveMutationVariables>(ArchiveProgressionSchemeModalArchiveDocument, parser(options)));
      }
export type ArchiveProgressionSchemeModalArchiveMutationHookResult = ReturnType<typeof useArchiveProgressionSchemeModalArchiveMutation>;
export type ArchiveProgressionSchemeModalArchiveMutationResult = ApolloReact.MutationResult<ArchiveProgressionSchemeModalArchiveMutation>;
export type ArchiveProgressionSchemeModalArchiveMutationOptions = Apollo.MutationOptions<ArchiveProgressionSchemeModalArchiveMutation, ArchiveProgressionSchemeModalArchiveMutationVariables>;
export const AssignBenefitDrawerLoadDataDocument = /*#__PURE__*/ gql`
    query AssignBenefitDrawer_LoadData($contractId: ContractId!, $userId: UserId!, $at: OffsetDateTime, $groupType: BenefitGroupType) {
  contract(contractId: $contractId, at: $at) {
    ...NfsError
    ... on ContractResponse {
      value {
        ...AssignBenefitDrawer_Contract
        at
        startDate
        assignedVariants(activeOnly: false) {
          ...Unauthorized
          ... on AccessGranted__ListOfAssignedVariant {
            value {
              at
              ...AssignBenefitDrawer_AssignedVariant
            }
          }
        }
      }
    }
  }
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      externalBeneficiaries {
        ...Unauthorized
        ... on AccessGranted__ListOfExternalBeneficiary {
          value {
            id
            firstName
            lastName
            email
            address {
              ...Address
            }
          }
        }
      }
    }
  }
  benefits(groupType: $groupType, sortBy: NumberOfAssignments) {
    ...NfsError
    ... on ListOfBenefitGroupResponse {
      value {
        groupType
        benefits {
          manyOf {
            alternativeBenefitsGroupId
            oneOf {
              id
              name
              entityVersion
              startDate
              endDate
              variants {
                ...AssignBenefitDrawer_BenefitVariant
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AssignBenefitDrawerContractFragmentDoc}
${UnauthorizedFragmentDoc}
${AssignBenefitDrawerAssignedVariantFragmentDoc}
${AddressFragmentDoc}
${AssignBenefitDrawerBenefitVariantFragmentDoc}`;

/**
 * __useAssignBenefitDrawerLoadDataQuery__
 *
 * To run a query within a React component, call `useAssignBenefitDrawerLoadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignBenefitDrawerLoadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignBenefitDrawerLoadDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      userId: // value for 'userId'
 *      at: // value for 'at'
 *      groupType: // value for 'groupType'
 *   },
 * });
 */
export function useAssignBenefitDrawerLoadDataQuery(baseOptions: ApolloReact.QueryHookOptions<AssignBenefitDrawerLoadDataQuery, AssignBenefitDrawerLoadDataQueryVariables> & ({ variables: AssignBenefitDrawerLoadDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AssignBenefitDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AssignBenefitDrawerLoadDataQuery, AssignBenefitDrawerLoadDataQueryVariables>(AssignBenefitDrawerLoadDataDocument, parser(options)));
      }
export function useAssignBenefitDrawerLoadDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AssignBenefitDrawerLoadDataQuery, AssignBenefitDrawerLoadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AssignBenefitDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AssignBenefitDrawerLoadDataQuery, AssignBenefitDrawerLoadDataQueryVariables>(AssignBenefitDrawerLoadDataDocument, options));
        }

export type AssignBenefitDrawerLoadDataQueryResult = ApolloReact.QueryResult<AssignBenefitDrawerLoadDataQuery, AssignBenefitDrawerLoadDataQueryVariables>;
export function refetchAssignBenefitDrawerLoadDataQuery(variables: AssignBenefitDrawerLoadDataQueryVariables) {
      return { query: AssignBenefitDrawerLoadDataDocument, variables: variables }
    }
export const AssignBenefitDrawerAssignVariantsDocument = /*#__PURE__*/ gql`
    mutation AssignBenefitDrawer_AssignVariants($contractId: ContractId!, $effectiveFrom: Date!, $benefitVariants: [AssignVariantInput!]!, $groupType: BenefitGroupType!, $entityVersion: EntityVersion!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    assignVariants(
      at: $effectiveFrom
      variants: $benefitVariants
      groupType: $groupType
    ) {
      ...NfsError
      ... on ListOfAssignedVariantResponse {
        value {
          id
          variant {
            value {
              id
              entityVersion
            }
          }
          buyerType {
            value
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAssignBenefitDrawerAssignVariantsMutation__
 *
 * To run a mutation, you first call `useAssignBenefitDrawerAssignVariantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignBenefitDrawerAssignVariantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignBenefitDrawerAssignVariantsMutation, { data, loading, error }] = useAssignBenefitDrawerAssignVariantsMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      effectiveFrom: // value for 'effectiveFrom'
 *      benefitVariants: // value for 'benefitVariants'
 *      groupType: // value for 'groupType'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useAssignBenefitDrawerAssignVariantsMutation(baseOptions?: ApolloReact.MutationHookOptions<AssignBenefitDrawerAssignVariantsMutation, AssignBenefitDrawerAssignVariantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AssignBenefitDrawerAssignVariantsDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AssignBenefitDrawerAssignVariantsMutation, AssignBenefitDrawerAssignVariantsMutationVariables>(AssignBenefitDrawerAssignVariantsDocument, parser(options)));
      }
export type AssignBenefitDrawerAssignVariantsMutationHookResult = ReturnType<typeof useAssignBenefitDrawerAssignVariantsMutation>;
export type AssignBenefitDrawerAssignVariantsMutationResult = ApolloReact.MutationResult<AssignBenefitDrawerAssignVariantsMutation>;
export type AssignBenefitDrawerAssignVariantsMutationOptions = Apollo.MutationOptions<AssignBenefitDrawerAssignVariantsMutation, AssignBenefitDrawerAssignVariantsMutationVariables>;
export const B2BContractDraftDrawerInputDocument = /*#__PURE__*/ gql`
    query B2BContractDraftDrawer_Input($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...B2BContractDraftDrawer_User
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            ...B2BContractDraftDrawer_Draft
          }
        }
      }
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            startDate
            promisor {
              value {
                id
              }
            }
            ... on B2BContract {
              type
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${B2BContractDraftDrawerUserFragmentDoc}
${UnauthorizedFragmentDoc}
${B2BContractDraftDrawerDraftFragmentDoc}`;

/**
 * __useB2BContractDraftDrawerInputQuery__
 *
 * To run a query within a React component, call `useB2BContractDraftDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useB2BContractDraftDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useB2BContractDraftDrawerInputQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useB2BContractDraftDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<B2BContractDraftDrawerInputQuery, B2BContractDraftDrawerInputQueryVariables> & ({ variables: B2BContractDraftDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BContractDraftDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<B2BContractDraftDrawerInputQuery, B2BContractDraftDrawerInputQueryVariables>(B2BContractDraftDrawerInputDocument, parser(options)));
      }
export function useB2BContractDraftDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<B2BContractDraftDrawerInputQuery, B2BContractDraftDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(B2BContractDraftDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<B2BContractDraftDrawerInputQuery, B2BContractDraftDrawerInputQueryVariables>(B2BContractDraftDrawerInputDocument, options));
        }

export type B2BContractDraftDrawerInputQueryResult = ApolloReact.QueryResult<B2BContractDraftDrawerInputQuery, B2BContractDraftDrawerInputQueryVariables>;
export function refetchB2BContractDraftDrawerInputQuery(variables: B2BContractDraftDrawerInputQueryVariables) {
      return { query: B2BContractDraftDrawerInputDocument, variables: variables }
    }
export const B2BContractDraftDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation B2BContractDraftDrawer_Create($userId: UserId!, $userEntityVersion: EntityVersion!, $contractId: ContractId!, $name: String!, $startDate: LocalDate, $expectedEndDate: LocalDate, $holidayCalendarId: HolidayCalendarId, $scopeOfWork: String, $position: String, $promiseeCompanyId: CompanyId, $promisorId: CompanyId!) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    createB2bContractDraft(
      contractId: $contractId
      name: $name
      startDate: $startDate
      expectedEndDate: $expectedEndDate
      holidayCalendarId: $holidayCalendarId
      scopeOfWork: $scopeOfWork
      position: $position
      promiseeCompanyId: $promiseeCompanyId
      promisorId: $promisorId
    ) {
      ...NfsError
      ... on B2BContractDraft {
        ...B2BContractDraftDrawer_Draft
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${B2BContractDraftDrawerDraftFragmentDoc}`;


/**
 * __useB2BContractDraftDrawerCreateMutation__
 *
 * To run a mutation, you first call `useB2BContractDraftDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useB2BContractDraftDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [b2BContractDraftDrawerCreateMutation, { data, loading, error }] = useB2BContractDraftDrawerCreateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      contractId: // value for 'contractId'
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *      expectedEndDate: // value for 'expectedEndDate'
 *      holidayCalendarId: // value for 'holidayCalendarId'
 *      scopeOfWork: // value for 'scopeOfWork'
 *      position: // value for 'position'
 *      promiseeCompanyId: // value for 'promiseeCompanyId'
 *      promisorId: // value for 'promisorId'
 *   },
 * });
 */
export function useB2BContractDraftDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<B2BContractDraftDrawerCreateMutation, B2BContractDraftDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BContractDraftDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<B2BContractDraftDrawerCreateMutation, B2BContractDraftDrawerCreateMutationVariables>(B2BContractDraftDrawerCreateDocument, parser(options)));
      }
export type B2BContractDraftDrawerCreateMutationHookResult = ReturnType<typeof useB2BContractDraftDrawerCreateMutation>;
export type B2BContractDraftDrawerCreateMutationResult = ApolloReact.MutationResult<B2BContractDraftDrawerCreateMutation>;
export type B2BContractDraftDrawerCreateMutationOptions = Apollo.MutationOptions<B2BContractDraftDrawerCreateMutation, B2BContractDraftDrawerCreateMutationVariables>;
export const B2BContractDraftDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation B2BContractDraftDrawer_Update($userId: UserId!, $userEntityVersion: EntityVersion!, $entityVersion: EntityVersion!, $name: String!, $startDate: ClearableLocalDateInput, $expectedEndDate: ClearableLocalDateInput, $holidayCalendarId: ClearableHolidayCalendarIdInput, $scopeOfWork: ClearableStringInput, $position: ClearableStringInput, $promiseeCompanyId: ClearableCompanyIdInput, $promisorId: CompanyId!) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateB2bDraft(
        name: $name
        startDate: $startDate
        expectedEndDate: $expectedEndDate
        holidayCalendarId: $holidayCalendarId
        scopeOfWork: $scopeOfWork
        position: $position
        promiseeCompanyId: $promiseeCompanyId
        promisorId: $promisorId
      ) {
        ...NfsError
        ... on B2BContractDraft {
          ...B2BContractDraftDrawer_Draft
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${B2BContractDraftDrawerDraftFragmentDoc}`;


/**
 * __useB2BContractDraftDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useB2BContractDraftDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useB2BContractDraftDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [b2BContractDraftDrawerUpdateMutation, { data, loading, error }] = useB2BContractDraftDrawerUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      entityVersion: // value for 'entityVersion'
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *      expectedEndDate: // value for 'expectedEndDate'
 *      holidayCalendarId: // value for 'holidayCalendarId'
 *      scopeOfWork: // value for 'scopeOfWork'
 *      position: // value for 'position'
 *      promiseeCompanyId: // value for 'promiseeCompanyId'
 *      promisorId: // value for 'promisorId'
 *   },
 * });
 */
export function useB2BContractDraftDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<B2BContractDraftDrawerUpdateMutation, B2BContractDraftDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BContractDraftDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<B2BContractDraftDrawerUpdateMutation, B2BContractDraftDrawerUpdateMutationVariables>(B2BContractDraftDrawerUpdateDocument, parser(options)));
      }
export type B2BContractDraftDrawerUpdateMutationHookResult = ReturnType<typeof useB2BContractDraftDrawerUpdateMutation>;
export type B2BContractDraftDrawerUpdateMutationResult = ApolloReact.MutationResult<B2BContractDraftDrawerUpdateMutation>;
export type B2BContractDraftDrawerUpdateMutationOptions = Apollo.MutationOptions<B2BContractDraftDrawerUpdateMutation, B2BContractDraftDrawerUpdateMutationVariables>;
export const B2BContractDraftDrawerUpdateUserDocument = /*#__PURE__*/ gql`
    mutation B2BContractDraftDrawer_UpdateUser($userId: UserId!, $userEntityVersion: EntityVersion!, $pesel: ClearablePESELInput, $birthDate: ClearableLocalDateInput, $emergencyContact: ClearableStringInput) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    updateUser(
      pesel: $pesel
      birthDate: $birthDate
      emergencyContact: $emergencyContact
    ) {
      ...NfsError
      ... on User {
        ...B2BContractDraftDrawer_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${B2BContractDraftDrawerUserFragmentDoc}`;


/**
 * __useB2BContractDraftDrawerUpdateUserMutation__
 *
 * To run a mutation, you first call `useB2BContractDraftDrawerUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useB2BContractDraftDrawerUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [b2BContractDraftDrawerUpdateUserMutation, { data, loading, error }] = useB2BContractDraftDrawerUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      pesel: // value for 'pesel'
 *      birthDate: // value for 'birthDate'
 *      emergencyContact: // value for 'emergencyContact'
 *   },
 * });
 */
export function useB2BContractDraftDrawerUpdateUserMutation(baseOptions?: ApolloReact.MutationHookOptions<B2BContractDraftDrawerUpdateUserMutation, B2BContractDraftDrawerUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BContractDraftDrawerUpdateUserDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<B2BContractDraftDrawerUpdateUserMutation, B2BContractDraftDrawerUpdateUserMutationVariables>(B2BContractDraftDrawerUpdateUserDocument, parser(options)));
      }
export type B2BContractDraftDrawerUpdateUserMutationHookResult = ReturnType<typeof useB2BContractDraftDrawerUpdateUserMutation>;
export type B2BContractDraftDrawerUpdateUserMutationResult = ApolloReact.MutationResult<B2BContractDraftDrawerUpdateUserMutation>;
export type B2BContractDraftDrawerUpdateUserMutationOptions = Apollo.MutationOptions<B2BContractDraftDrawerUpdateUserMutation, B2BContractDraftDrawerUpdateUserMutationVariables>;
export const B2BSalariesDetailsDrawerDocument = /*#__PURE__*/ gql`
    query B2BSalariesDetailsDrawer($contractId: ContractId!, $month: YearMonth!, $monthStart: LocalDate!, $monthEnd: LocalDate!) {
  timeReport(contractId: $contractId, from: $monthStart, to: $monthEnd) {
    ...NfsError
    ... on TimeReport {
      timeReportStats {
        timeBalanceAtEndOfMonth {
          reportedStandardWorkTime
          currentTimeRequirement
        }
        overtime
        ... on B2BTimeReportStats {
          reportedDaysOff
        }
      }
    }
  }
  contractSalaryDetails(contractId: $contractId, date: $month) {
    ...NfsError
    ... on ContractSalaryDetailsResponse {
      value {
        contractId
        yearMonth
        entityVersion
        transferTitle
        absenceDays
        workTotalTime
        requiredWorkedTime
        transferAmount
        isTimeReportCompleted
        isTimeReportApprovalRequired
        totalPayout {
          ...NetGross
        }
        transferDeduction {
          grossValue
          note
        }
        flag
        note
        ... on B2BContractSalaryDetails {
          adjustGrossValue
          luminisServicesValue {
            gross
          }
          contract {
            id
            entityVersion
            at
            status
            name
            bonuses {
              ...Unauthorized
              ... on AccessGranted__Bonuses {
                value {
                  paidOut {
                    ...SharedSalary_Bonus
                  }
                  future {
                    ...SharedSalary_Bonus
                  }
                }
              }
            }
            conclusionDate {
              ...Unauthorized
              ... on AccessGranted__LocalDate {
                value
              }
            }
            startDate
            terminationDate
            currency {
              ...Unauthorized
              ... on AccessGranted__TimeBasedCurrency {
                value {
                  value
                }
              }
            }
            separatePaymentForBenefits {
              ...Unauthorized
              ... on AccessGranted__TimeBasedBoolean {
                value {
                  value
                }
              }
            }
            vat {
              ...Unauthorized
              ... on AccessGranted__TimeBasedVatType {
                value {
                  value {
                    ...VatType
                  }
                }
              }
            }
            promisee {
              id
              firstName
              lastName
              avatar
              directReporting {
                assignedProjects {
                  ...Unauthorized
                  ... on AccessGranted__ListOfProjectAssignment {
                    value {
                      user {
                        id
                      }
                      project {
                        id
                        name
                      }
                    }
                  }
                }
              }
            }
            type
            promiseeCompany {
              ...Unauthorized
              ... on AccessGranted__Company {
                value {
                  id
                  entityVersion
                  name
                  isPolishVat {
                    value {
                      value
                      state {
                        ... on VerifiedWithDescriptionBooleanVATStatus {
                          when
                          result
                        }
                      }
                    }
                  }
                  bankAccounts {
                    ...BankAccount
                  }
                }
              }
            }
            promiseeCompanyTransferBankAccount {
              ...Unauthorized
              ... on AccessGranted__OptionalBankAccount {
                value {
                  ...BankAccount
                }
              }
            }
            rate {
              ...Unauthorized
              ... on AccessGranted__TimeBasedRate {
                value {
                  value {
                    ...Rate
                  }
                }
              }
            }
            promisor {
              value {
                id
                name
              }
            }
            promisorTransferBankAccount {
              value {
                ...BankAccount
              }
            }
          }
          whiteListVerificationState {
            ... on VerifiedBankAccountStatus {
              result
              when
            }
          }
          invoiceDetails {
            ...B2BSalariesDetailsDrawer_InvoiceDetails
          }
        }
        salaryState {
          ...SalaryState
        }
      }
    }
  }
  contractSalaryDetailsAdditionalData(contractId: $contractId, date: $month) {
    ...NfsError
    ... on ContractSalaryDetailsAdditionalData {
      contractId
      yearMonth
      timeReportValidations {
        ...TimeReportValidation
      }
      incomeDetails {
        ...B2BSalariesDetailsDrawer_IncomeDetails
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${NetGrossFragmentDoc}
${UnauthorizedFragmentDoc}
${SharedSalaryBonusFragmentDoc}
${VatTypeFragmentDoc}
${BankAccountFragmentDoc}
${RateFragmentDoc}
${B2BSalariesDetailsDrawerInvoiceDetailsFragmentDoc}
${SalaryStateFragmentDoc}
${TimeReportValidationFragmentDoc}
${B2BSalariesDetailsDrawerIncomeDetailsFragmentDoc}`;

/**
 * __useB2BSalariesDetailsDrawerQuery__
 *
 * To run a query within a React component, call `useB2BSalariesDetailsDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useB2BSalariesDetailsDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useB2BSalariesDetailsDrawerQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      monthStart: // value for 'monthStart'
 *      monthEnd: // value for 'monthEnd'
 *   },
 * });
 */
export function useB2BSalariesDetailsDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<B2BSalariesDetailsDrawerQuery, B2BSalariesDetailsDrawerQueryVariables> & ({ variables: B2BSalariesDetailsDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BSalariesDetailsDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<B2BSalariesDetailsDrawerQuery, B2BSalariesDetailsDrawerQueryVariables>(B2BSalariesDetailsDrawerDocument, parser(options)));
      }
export function useB2BSalariesDetailsDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<B2BSalariesDetailsDrawerQuery, B2BSalariesDetailsDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(B2BSalariesDetailsDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<B2BSalariesDetailsDrawerQuery, B2BSalariesDetailsDrawerQueryVariables>(B2BSalariesDetailsDrawerDocument, options));
        }

export type B2BSalariesDetailsDrawerQueryResult = ApolloReact.QueryResult<B2BSalariesDetailsDrawerQuery, B2BSalariesDetailsDrawerQueryVariables>;
export function refetchB2BSalariesDetailsDrawerQuery(variables: B2BSalariesDetailsDrawerQueryVariables) {
      return { query: B2BSalariesDetailsDrawerDocument, variables: variables }
    }
export const B2BSalariesDetailsDrawerRefetchSalaryStateDocument = /*#__PURE__*/ gql`
    query B2BSalariesDetailsDrawer_RefetchSalaryState($contractId: ContractId!, $month: YearMonth!) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    ...NfsError
    ... on ContractSalaryDetailsResponse {
      value {
        contractId
        yearMonth
        salaryState {
          ...SalaryState
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalaryStateFragmentDoc}`;

/**
 * __useB2BSalariesDetailsDrawerRefetchSalaryStateQuery__
 *
 * To run a query within a React component, call `useB2BSalariesDetailsDrawerRefetchSalaryStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useB2BSalariesDetailsDrawerRefetchSalaryStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useB2BSalariesDetailsDrawerRefetchSalaryStateQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useB2BSalariesDetailsDrawerRefetchSalaryStateQuery(baseOptions: ApolloReact.QueryHookOptions<B2BSalariesDetailsDrawerRefetchSalaryStateQuery, B2BSalariesDetailsDrawerRefetchSalaryStateQueryVariables> & ({ variables: B2BSalariesDetailsDrawerRefetchSalaryStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BSalariesDetailsDrawerRefetchSalaryStateDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<B2BSalariesDetailsDrawerRefetchSalaryStateQuery, B2BSalariesDetailsDrawerRefetchSalaryStateQueryVariables>(B2BSalariesDetailsDrawerRefetchSalaryStateDocument, parser(options)));
      }
export function useB2BSalariesDetailsDrawerRefetchSalaryStateLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<B2BSalariesDetailsDrawerRefetchSalaryStateQuery, B2BSalariesDetailsDrawerRefetchSalaryStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(B2BSalariesDetailsDrawerRefetchSalaryStateDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<B2BSalariesDetailsDrawerRefetchSalaryStateQuery, B2BSalariesDetailsDrawerRefetchSalaryStateQueryVariables>(B2BSalariesDetailsDrawerRefetchSalaryStateDocument, options));
        }

export type B2BSalariesDetailsDrawerRefetchSalaryStateQueryResult = ApolloReact.QueryResult<B2BSalariesDetailsDrawerRefetchSalaryStateQuery, B2BSalariesDetailsDrawerRefetchSalaryStateQueryVariables>;
export function refetchB2BSalariesDetailsDrawerRefetchSalaryStateQuery(variables: B2BSalariesDetailsDrawerRefetchSalaryStateQueryVariables) {
      return { query: B2BSalariesDetailsDrawerRefetchSalaryStateDocument, variables: variables }
    }
export const B2BSalariesDetailsDrawerUpdateTransferDeductionDocument = /*#__PURE__*/ gql`
    mutation B2BSalariesDetailsDrawer_UpdateTransferDeduction($contractId: ContractId!, $month: YearMonth!, $entityVersion: EntityVersion!, $transferDeduction: ClearableTransferDeductionInput!) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    update(transferDeduction: $transferDeduction, entityVersion: $entityVersion) {
      ...NfsError
      ... on ContractSalaryDetailsResponse {
        value {
          contractId
          yearMonth
          transferAmount
          transferDeduction {
            grossValue
            note
          }
          salaryState {
            ...SalaryState
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalaryStateFragmentDoc}`;


/**
 * __useB2BSalariesDetailsDrawerUpdateTransferDeductionMutation__
 *
 * To run a mutation, you first call `useB2BSalariesDetailsDrawerUpdateTransferDeductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useB2BSalariesDetailsDrawerUpdateTransferDeductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [b2BSalariesDetailsDrawerUpdateTransferDeductionMutation, { data, loading, error }] = useB2BSalariesDetailsDrawerUpdateTransferDeductionMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      entityVersion: // value for 'entityVersion'
 *      transferDeduction: // value for 'transferDeduction'
 *   },
 * });
 */
export function useB2BSalariesDetailsDrawerUpdateTransferDeductionMutation(baseOptions?: ApolloReact.MutationHookOptions<B2BSalariesDetailsDrawerUpdateTransferDeductionMutation, B2BSalariesDetailsDrawerUpdateTransferDeductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BSalariesDetailsDrawerUpdateTransferDeductionDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<B2BSalariesDetailsDrawerUpdateTransferDeductionMutation, B2BSalariesDetailsDrawerUpdateTransferDeductionMutationVariables>(B2BSalariesDetailsDrawerUpdateTransferDeductionDocument, parser(options)));
      }
export type B2BSalariesDetailsDrawerUpdateTransferDeductionMutationHookResult = ReturnType<typeof useB2BSalariesDetailsDrawerUpdateTransferDeductionMutation>;
export type B2BSalariesDetailsDrawerUpdateTransferDeductionMutationResult = ApolloReact.MutationResult<B2BSalariesDetailsDrawerUpdateTransferDeductionMutation>;
export type B2BSalariesDetailsDrawerUpdateTransferDeductionMutationOptions = Apollo.MutationOptions<B2BSalariesDetailsDrawerUpdateTransferDeductionMutation, B2BSalariesDetailsDrawerUpdateTransferDeductionMutationVariables>;
export const B2BSalariesDetailsDrawerUpdateAdjustGrossValueDocument = /*#__PURE__*/ gql`
    mutation B2BSalariesDetailsDrawer_UpdateAdjustGrossValue($contractId: ContractId!, $month: YearMonth!, $entityVersion: EntityVersion!, $adjustGrossValue: ClearableGrossAdjustmentInput!) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    update(adjustGrossValue: $adjustGrossValue, entityVersion: $entityVersion) {
      ...NfsError
      ... on ContractSalaryDetailsResponse {
        value {
          contractId
          yearMonth
          entityVersion
          transferAmount
          totalPayout {
            ...NetGross
          }
          ... on B2BContractSalaryDetails {
            adjustGrossValue
          }
          salaryState {
            ...SalaryState
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${NetGrossFragmentDoc}
${SalaryStateFragmentDoc}`;


/**
 * __useB2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation__
 *
 * To run a mutation, you first call `useB2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useB2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [b2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation, { data, loading, error }] = useB2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      entityVersion: // value for 'entityVersion'
 *      adjustGrossValue: // value for 'adjustGrossValue'
 *   },
 * });
 */
export function useB2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation(baseOptions?: ApolloReact.MutationHookOptions<B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation, B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BSalariesDetailsDrawerUpdateAdjustGrossValueDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation, B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutationVariables>(B2BSalariesDetailsDrawerUpdateAdjustGrossValueDocument, parser(options)));
      }
export type B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutationHookResult = ReturnType<typeof useB2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation>;
export type B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutationResult = ApolloReact.MutationResult<B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation>;
export type B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutationOptions = Apollo.MutationOptions<B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation, B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutationVariables>;
export const B2BSalariesDetailsDrawerUpdateInvoiceDocument = /*#__PURE__*/ gql`
    mutation B2BSalariesDetailsDrawer_UpdateInvoice($contractId: ContractId!, $month: YearMonth!, $invoiceDetailsId: InvoiceDetailsId!, $invoiceDetails: UpdateInvoiceDetailsInput!) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    invoiceDetails {
      update(invoiceDetailsId: $invoiceDetailsId, invoiceDetails: $invoiceDetails) {
        ...NfsError
        ... on InvoiceDetails {
          ...InvoicesDrawer_InvoiceDetails
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${InvoicesDrawerInvoiceDetailsFragmentDoc}`;


/**
 * __useB2BSalariesDetailsDrawerUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useB2BSalariesDetailsDrawerUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useB2BSalariesDetailsDrawerUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [b2BSalariesDetailsDrawerUpdateInvoiceMutation, { data, loading, error }] = useB2BSalariesDetailsDrawerUpdateInvoiceMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      invoiceDetailsId: // value for 'invoiceDetailsId'
 *      invoiceDetails: // value for 'invoiceDetails'
 *   },
 * });
 */
export function useB2BSalariesDetailsDrawerUpdateInvoiceMutation(baseOptions?: ApolloReact.MutationHookOptions<B2BSalariesDetailsDrawerUpdateInvoiceMutation, B2BSalariesDetailsDrawerUpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BSalariesDetailsDrawerUpdateInvoiceDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<B2BSalariesDetailsDrawerUpdateInvoiceMutation, B2BSalariesDetailsDrawerUpdateInvoiceMutationVariables>(B2BSalariesDetailsDrawerUpdateInvoiceDocument, parser(options)));
      }
export type B2BSalariesDetailsDrawerUpdateInvoiceMutationHookResult = ReturnType<typeof useB2BSalariesDetailsDrawerUpdateInvoiceMutation>;
export type B2BSalariesDetailsDrawerUpdateInvoiceMutationResult = ApolloReact.MutationResult<B2BSalariesDetailsDrawerUpdateInvoiceMutation>;
export type B2BSalariesDetailsDrawerUpdateInvoiceMutationOptions = Apollo.MutationOptions<B2BSalariesDetailsDrawerUpdateInvoiceMutation, B2BSalariesDetailsDrawerUpdateInvoiceMutationVariables>;
export const B2BSalariesDetailsDrawerCreateInvoiceDocument = /*#__PURE__*/ gql`
    mutation B2BSalariesDetailsDrawer_CreateInvoice($contractId: ContractId!, $month: YearMonth!, $invoiceDetails: CreateInvoiceDetailsInput!) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    invoiceDetails {
      create(invoiceDetails: $invoiceDetails) {
        ...NfsError
        ... on InvoiceDetails {
          ...InvoicesDrawer_InvoiceDetails
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${InvoicesDrawerInvoiceDetailsFragmentDoc}`;


/**
 * __useB2BSalariesDetailsDrawerCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useB2BSalariesDetailsDrawerCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useB2BSalariesDetailsDrawerCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [b2BSalariesDetailsDrawerCreateInvoiceMutation, { data, loading, error }] = useB2BSalariesDetailsDrawerCreateInvoiceMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      invoiceDetails: // value for 'invoiceDetails'
 *   },
 * });
 */
export function useB2BSalariesDetailsDrawerCreateInvoiceMutation(baseOptions?: ApolloReact.MutationHookOptions<B2BSalariesDetailsDrawerCreateInvoiceMutation, B2BSalariesDetailsDrawerCreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BSalariesDetailsDrawerCreateInvoiceDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<B2BSalariesDetailsDrawerCreateInvoiceMutation, B2BSalariesDetailsDrawerCreateInvoiceMutationVariables>(B2BSalariesDetailsDrawerCreateInvoiceDocument, parser(options)));
      }
export type B2BSalariesDetailsDrawerCreateInvoiceMutationHookResult = ReturnType<typeof useB2BSalariesDetailsDrawerCreateInvoiceMutation>;
export type B2BSalariesDetailsDrawerCreateInvoiceMutationResult = ApolloReact.MutationResult<B2BSalariesDetailsDrawerCreateInvoiceMutation>;
export type B2BSalariesDetailsDrawerCreateInvoiceMutationOptions = Apollo.MutationOptions<B2BSalariesDetailsDrawerCreateInvoiceMutation, B2BSalariesDetailsDrawerCreateInvoiceMutationVariables>;
export const B2BSalariesDetailsDrawerRemoveInvoiceDocument = /*#__PURE__*/ gql`
    mutation B2BSalariesDetailsDrawer_RemoveInvoice($contractId: ContractId!, $month: YearMonth!, $invoiceDetailsId: InvoiceDetailsId!) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    invoiceDetails {
      remove(invoiceDetailsId: $invoiceDetailsId) {
        ...NfsError
        ... on BooleanResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useB2BSalariesDetailsDrawerRemoveInvoiceMutation__
 *
 * To run a mutation, you first call `useB2BSalariesDetailsDrawerRemoveInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useB2BSalariesDetailsDrawerRemoveInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [b2BSalariesDetailsDrawerRemoveInvoiceMutation, { data, loading, error }] = useB2BSalariesDetailsDrawerRemoveInvoiceMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      invoiceDetailsId: // value for 'invoiceDetailsId'
 *   },
 * });
 */
export function useB2BSalariesDetailsDrawerRemoveInvoiceMutation(baseOptions?: ApolloReact.MutationHookOptions<B2BSalariesDetailsDrawerRemoveInvoiceMutation, B2BSalariesDetailsDrawerRemoveInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BSalariesDetailsDrawerRemoveInvoiceDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<B2BSalariesDetailsDrawerRemoveInvoiceMutation, B2BSalariesDetailsDrawerRemoveInvoiceMutationVariables>(B2BSalariesDetailsDrawerRemoveInvoiceDocument, parser(options)));
      }
export type B2BSalariesDetailsDrawerRemoveInvoiceMutationHookResult = ReturnType<typeof useB2BSalariesDetailsDrawerRemoveInvoiceMutation>;
export type B2BSalariesDetailsDrawerRemoveInvoiceMutationResult = ApolloReact.MutationResult<B2BSalariesDetailsDrawerRemoveInvoiceMutation>;
export type B2BSalariesDetailsDrawerRemoveInvoiceMutationOptions = Apollo.MutationOptions<B2BSalariesDetailsDrawerRemoveInvoiceMutation, B2BSalariesDetailsDrawerRemoveInvoiceMutationVariables>;
export const B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentDocument = /*#__PURE__*/ gql`
    mutation B2BSalariesDetailsDrawer_CreateInvoiceFromSaldeoDocument($contractId: ContractId!, $month: YearMonth!, $invoiceDetailsId: InvoiceDetailsId!, $saldeoDocumentId: SaldeoDocumentIdInput!, $adminNote: String) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    invoiceDetails {
      createFromSaldeoDocument(
        id: $invoiceDetailsId
        saldeoDocumentId: $saldeoDocumentId
        adminNote: $adminNote
      ) {
        ...NfsError
        ... on InvoiceDetails {
          ...InvoicesDrawer_InvoiceDetails
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${InvoicesDrawerInvoiceDetailsFragmentDoc}`;


/**
 * __useB2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation__
 *
 * To run a mutation, you first call `useB2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useB2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [b2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation, { data, loading, error }] = useB2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      invoiceDetailsId: // value for 'invoiceDetailsId'
 *      saldeoDocumentId: // value for 'saldeoDocumentId'
 *      adminNote: // value for 'adminNote'
 *   },
 * });
 */
export function useB2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation(baseOptions?: ApolloReact.MutationHookOptions<B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation, B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation, B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutationVariables>(B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentDocument, parser(options)));
      }
export type B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutationHookResult = ReturnType<typeof useB2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation>;
export type B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutationResult = ApolloReact.MutationResult<B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation>;
export type B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutationOptions = Apollo.MutationOptions<B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation, B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutationVariables>;
export const B2BSalariesListItemMarkAsDisbursedDocument = /*#__PURE__*/ gql`
    mutation B2BSalariesListItem_MarkAsDisbursed($yearMonth: YearMonth!, $filter: FilterContractSalaryDetailsInput!) {
  markPaymentAsDisbursed(yearMonth: $yearMonth, filter: $filter) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      ...B2BSalariesListItem_SalaryStateChange
    }
  }
}
    ${NfsErrorFragmentDoc}
${B2BSalariesListItemSalaryStateChangeFragmentDoc}`;


/**
 * __useB2BSalariesListItemMarkAsDisbursedMutation__
 *
 * To run a mutation, you first call `useB2BSalariesListItemMarkAsDisbursedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useB2BSalariesListItemMarkAsDisbursedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [b2BSalariesListItemMarkAsDisbursedMutation, { data, loading, error }] = useB2BSalariesListItemMarkAsDisbursedMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useB2BSalariesListItemMarkAsDisbursedMutation(baseOptions?: ApolloReact.MutationHookOptions<B2BSalariesListItemMarkAsDisbursedMutation, B2BSalariesListItemMarkAsDisbursedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BSalariesListItemMarkAsDisbursedDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<B2BSalariesListItemMarkAsDisbursedMutation, B2BSalariesListItemMarkAsDisbursedMutationVariables>(B2BSalariesListItemMarkAsDisbursedDocument, parser(options)));
      }
export type B2BSalariesListItemMarkAsDisbursedMutationHookResult = ReturnType<typeof useB2BSalariesListItemMarkAsDisbursedMutation>;
export type B2BSalariesListItemMarkAsDisbursedMutationResult = ApolloReact.MutationResult<B2BSalariesListItemMarkAsDisbursedMutation>;
export type B2BSalariesListItemMarkAsDisbursedMutationOptions = Apollo.MutationOptions<B2BSalariesListItemMarkAsDisbursedMutation, B2BSalariesListItemMarkAsDisbursedMutationVariables>;
export const B2BSalariesListItemUnmarkAsDisbursedDocument = /*#__PURE__*/ gql`
    mutation B2BSalariesListItem_UnmarkAsDisbursed($yearMonth: YearMonth!, $filter: FilterContractSalaryDetailsInput!) {
  unmarkPaymentAsDisbursed(yearMonth: $yearMonth, filter: $filter) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      ...B2BSalariesListItem_SalaryStateChange
    }
  }
}
    ${NfsErrorFragmentDoc}
${B2BSalariesListItemSalaryStateChangeFragmentDoc}`;


/**
 * __useB2BSalariesListItemUnmarkAsDisbursedMutation__
 *
 * To run a mutation, you first call `useB2BSalariesListItemUnmarkAsDisbursedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useB2BSalariesListItemUnmarkAsDisbursedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [b2BSalariesListItemUnmarkAsDisbursedMutation, { data, loading, error }] = useB2BSalariesListItemUnmarkAsDisbursedMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useB2BSalariesListItemUnmarkAsDisbursedMutation(baseOptions?: ApolloReact.MutationHookOptions<B2BSalariesListItemUnmarkAsDisbursedMutation, B2BSalariesListItemUnmarkAsDisbursedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(B2BSalariesListItemUnmarkAsDisbursedDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<B2BSalariesListItemUnmarkAsDisbursedMutation, B2BSalariesListItemUnmarkAsDisbursedMutationVariables>(B2BSalariesListItemUnmarkAsDisbursedDocument, parser(options)));
      }
export type B2BSalariesListItemUnmarkAsDisbursedMutationHookResult = ReturnType<typeof useB2BSalariesListItemUnmarkAsDisbursedMutation>;
export type B2BSalariesListItemUnmarkAsDisbursedMutationResult = ApolloReact.MutationResult<B2BSalariesListItemUnmarkAsDisbursedMutation>;
export type B2BSalariesListItemUnmarkAsDisbursedMutationOptions = Apollo.MutationOptions<B2BSalariesListItemUnmarkAsDisbursedMutation, B2BSalariesListItemUnmarkAsDisbursedMutationVariables>;
export const BankTransfersImportDocument = /*#__PURE__*/ gql`
    mutation BankTransfersImport($file: Upload!, $operationCompanyName: String!, $maybeRestrictedType: BankTransferType) {
  importTransfers_from_xml_camt053(
    file: $file
    operationCompanyName: $operationCompanyName
    maybeRestrictedType: $maybeRestrictedType
  ) {
    ...NfsError
    ...BankTransfersImportModal_ImportResult
  }
}
    ${NfsErrorFragmentDoc}
${BankTransfersImportModalImportResultFragmentDoc}`;


/**
 * __useBankTransfersImportMutation__
 *
 * To run a mutation, you first call `useBankTransfersImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankTransfersImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankTransfersImportMutation, { data, loading, error }] = useBankTransfersImportMutation({
 *   variables: {
 *      file: // value for 'file'
 *      operationCompanyName: // value for 'operationCompanyName'
 *      maybeRestrictedType: // value for 'maybeRestrictedType'
 *   },
 * });
 */
export function useBankTransfersImportMutation(baseOptions?: ApolloReact.MutationHookOptions<BankTransfersImportMutation, BankTransfersImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BankTransfersImportDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BankTransfersImportMutation, BankTransfersImportMutationVariables>(BankTransfersImportDocument, parser(options)));
      }
export type BankTransfersImportMutationHookResult = ReturnType<typeof useBankTransfersImportMutation>;
export type BankTransfersImportMutationResult = ApolloReact.MutationResult<BankTransfersImportMutation>;
export type BankTransfersImportMutationOptions = Apollo.MutationOptions<BankTransfersImportMutation, BankTransfersImportMutationVariables>;
export const BankTransfersImportOfxDocument = /*#__PURE__*/ gql`
    mutation BankTransfersImportOfx($file: Upload!, $operationCompanyName: String!, $maybeRestrictedType: BankTransferType) {
  importTransfers_from_xml_ofx(
    file: $file
    operationCompanyName: $operationCompanyName
    maybeRestrictedType: $maybeRestrictedType
  ) {
    ...NfsError
    ...BankTransfersImportModal_ImportResult
  }
}
    ${NfsErrorFragmentDoc}
${BankTransfersImportModalImportResultFragmentDoc}`;


/**
 * __useBankTransfersImportOfxMutation__
 *
 * To run a mutation, you first call `useBankTransfersImportOfxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankTransfersImportOfxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankTransfersImportOfxMutation, { data, loading, error }] = useBankTransfersImportOfxMutation({
 *   variables: {
 *      file: // value for 'file'
 *      operationCompanyName: // value for 'operationCompanyName'
 *      maybeRestrictedType: // value for 'maybeRestrictedType'
 *   },
 * });
 */
export function useBankTransfersImportOfxMutation(baseOptions?: ApolloReact.MutationHookOptions<BankTransfersImportOfxMutation, BankTransfersImportOfxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BankTransfersImportOfxDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BankTransfersImportOfxMutation, BankTransfersImportOfxMutationVariables>(BankTransfersImportOfxDocument, parser(options)));
      }
export type BankTransfersImportOfxMutationHookResult = ReturnType<typeof useBankTransfersImportOfxMutation>;
export type BankTransfersImportOfxMutationResult = ApolloReact.MutationResult<BankTransfersImportOfxMutation>;
export type BankTransfersImportOfxMutationOptions = Apollo.MutationOptions<BankTransfersImportOfxMutation, BankTransfersImportOfxMutationVariables>;
export const BankTransfersListFiltersDocument = /*#__PURE__*/ gql`
    query BankTransfersListFilters($first: Int, $after: Cursor) {
  companies(first: $first, after: $after) {
    ...NfsError
    ... on FSPResponseCompany {
      edges {
        node {
          id
          entityVersion
          name
        }
        cursor
      }
      hasNextPage
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useBankTransfersListFiltersQuery__
 *
 * To run a query within a React component, call `useBankTransfersListFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankTransfersListFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankTransfersListFiltersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBankTransfersListFiltersQuery(baseOptions?: ApolloReact.QueryHookOptions<BankTransfersListFiltersQuery, BankTransfersListFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BankTransfersListFiltersDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BankTransfersListFiltersQuery, BankTransfersListFiltersQueryVariables>(BankTransfersListFiltersDocument, parser(options)));
      }
export function useBankTransfersListFiltersLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BankTransfersListFiltersQuery, BankTransfersListFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BankTransfersListFiltersDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BankTransfersListFiltersQuery, BankTransfersListFiltersQueryVariables>(BankTransfersListFiltersDocument, options));
        }

export type BankTransfersListFiltersQueryResult = ApolloReact.QueryResult<BankTransfersListFiltersQuery, BankTransfersListFiltersQueryVariables>;
export function refetchBankTransfersListFiltersQuery(variables?: BankTransfersListFiltersQueryVariables) {
      return { query: BankTransfersListFiltersDocument, variables: variables }
    }
export const BasicFinancialReportDrawerDocument = /*#__PURE__*/ gql`
    query BasicFinancialReportDrawer {
  basicFinancialReport {
    ...NfsError
    ... on ListOfBfrFileUrlResponse {
      value {
        fileDescription
        url {
          url
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useBasicFinancialReportDrawerQuery__
 *
 * To run a query within a React component, call `useBasicFinancialReportDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicFinancialReportDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicFinancialReportDrawerQuery({
 *   variables: {
 *   },
 * });
 */
export function useBasicFinancialReportDrawerQuery(baseOptions?: ApolloReact.QueryHookOptions<BasicFinancialReportDrawerQuery, BasicFinancialReportDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BasicFinancialReportDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BasicFinancialReportDrawerQuery, BasicFinancialReportDrawerQueryVariables>(BasicFinancialReportDrawerDocument, parser(options)));
      }
export function useBasicFinancialReportDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BasicFinancialReportDrawerQuery, BasicFinancialReportDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BasicFinancialReportDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BasicFinancialReportDrawerQuery, BasicFinancialReportDrawerQueryVariables>(BasicFinancialReportDrawerDocument, options));
        }

export type BasicFinancialReportDrawerQueryResult = ApolloReact.QueryResult<BasicFinancialReportDrawerQuery, BasicFinancialReportDrawerQueryVariables>;
export function refetchBasicFinancialReportDrawerQuery(variables?: BasicFinancialReportDrawerQueryVariables) {
      return { query: BasicFinancialReportDrawerDocument, variables: variables }
    }
export const BasicFinancialReportDrawerRegenerateDocument = /*#__PURE__*/ gql`
    mutation BasicFinancialReportDrawer_Regenerate {
  triggerBasicFinancialReportBackgroundRegeneration {
    ...NfsError
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useBasicFinancialReportDrawerRegenerateMutation__
 *
 * To run a mutation, you first call `useBasicFinancialReportDrawerRegenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBasicFinancialReportDrawerRegenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [basicFinancialReportDrawerRegenerateMutation, { data, loading, error }] = useBasicFinancialReportDrawerRegenerateMutation({
 *   variables: {
 *   },
 * });
 */
export function useBasicFinancialReportDrawerRegenerateMutation(baseOptions?: ApolloReact.MutationHookOptions<BasicFinancialReportDrawerRegenerateMutation, BasicFinancialReportDrawerRegenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BasicFinancialReportDrawerRegenerateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BasicFinancialReportDrawerRegenerateMutation, BasicFinancialReportDrawerRegenerateMutationVariables>(BasicFinancialReportDrawerRegenerateDocument, parser(options)));
      }
export type BasicFinancialReportDrawerRegenerateMutationHookResult = ReturnType<typeof useBasicFinancialReportDrawerRegenerateMutation>;
export type BasicFinancialReportDrawerRegenerateMutationResult = ApolloReact.MutationResult<BasicFinancialReportDrawerRegenerateMutation>;
export type BasicFinancialReportDrawerRegenerateMutationOptions = Apollo.MutationOptions<BasicFinancialReportDrawerRegenerateMutation, BasicFinancialReportDrawerRegenerateMutationVariables>;
export const BasicFinancialReportDrawerExportStatusDocument = /*#__PURE__*/ gql`
    subscription BasicFinancialReportDrawer_ExportStatus {
  basicFinancialReportExportStatus {
    __typename
    ... on BfrExportRunning {
      startedAt
      phase
      percentDone
      users {
        processed
        total
      }
    }
    ... on BfrExportCompleted {
      finishedAt
    }
    ... on BfrExportFailed {
      failedAt
      error {
        msg
        nfsErrorId
      }
    }
    ... on BfrExportInterrupted {
      interruptedAt
    }
  }
}
    `;

/**
 * __useBasicFinancialReportDrawerExportStatusSubscription__
 *
 * To run a query within a React component, call `useBasicFinancialReportDrawerExportStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBasicFinancialReportDrawerExportStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicFinancialReportDrawerExportStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function useBasicFinancialReportDrawerExportStatusSubscription(baseOptions?: ApolloReact.SubscriptionHookOptions<BasicFinancialReportDrawerExportStatusSubscription, BasicFinancialReportDrawerExportStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BasicFinancialReportDrawerExportStatusDocument, scalarPaths, scalarParsers), []);

    return ApolloReact.useSubscription<BasicFinancialReportDrawerExportStatusSubscription, BasicFinancialReportDrawerExportStatusSubscriptionVariables>(BasicFinancialReportDrawerExportStatusDocument, parser(options));
      }
export type BasicFinancialReportDrawerExportStatusSubscriptionHookResult = ReturnType<typeof useBasicFinancialReportDrawerExportStatusSubscription>;
export type BasicFinancialReportDrawerExportStatusSubscriptionResult = ApolloReact.SubscriptionResult<BasicFinancialReportDrawerExportStatusSubscription>;
export const BenefitInvoicesReportDrawerGenerateDocument = /*#__PURE__*/ gql`
    mutation BenefitInvoicesReportDrawer_Generate($yearMonth: YearMonth!) {
  generateBenefitInvoiceDocument(yearMonth: $yearMonth) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useBenefitInvoicesReportDrawerGenerateMutation__
 *
 * To run a mutation, you first call `useBenefitInvoicesReportDrawerGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenefitInvoicesReportDrawerGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benefitInvoicesReportDrawerGenerateMutation, { data, loading, error }] = useBenefitInvoicesReportDrawerGenerateMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *   },
 * });
 */
export function useBenefitInvoicesReportDrawerGenerateMutation(baseOptions?: ApolloReact.MutationHookOptions<BenefitInvoicesReportDrawerGenerateMutation, BenefitInvoicesReportDrawerGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BenefitInvoicesReportDrawerGenerateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BenefitInvoicesReportDrawerGenerateMutation, BenefitInvoicesReportDrawerGenerateMutationVariables>(BenefitInvoicesReportDrawerGenerateDocument, parser(options)));
      }
export type BenefitInvoicesReportDrawerGenerateMutationHookResult = ReturnType<typeof useBenefitInvoicesReportDrawerGenerateMutation>;
export type BenefitInvoicesReportDrawerGenerateMutationResult = ApolloReact.MutationResult<BenefitInvoicesReportDrawerGenerateMutation>;
export type BenefitInvoicesReportDrawerGenerateMutationOptions = Apollo.MutationOptions<BenefitInvoicesReportDrawerGenerateMutation, BenefitInvoicesReportDrawerGenerateMutationVariables>;
export const BenefitInvoicesReportDrawerGoogleDocDocument = /*#__PURE__*/ gql`
    query BenefitInvoicesReportDrawer_GoogleDoc($yearMonth: YearMonth!) {
  benefitInvoiceDocument(yearMonth: $yearMonth) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useBenefitInvoicesReportDrawerGoogleDocQuery__
 *
 * To run a query within a React component, call `useBenefitInvoicesReportDrawerGoogleDocQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitInvoicesReportDrawerGoogleDocQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitInvoicesReportDrawerGoogleDocQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *   },
 * });
 */
export function useBenefitInvoicesReportDrawerGoogleDocQuery(baseOptions: ApolloReact.QueryHookOptions<BenefitInvoicesReportDrawerGoogleDocQuery, BenefitInvoicesReportDrawerGoogleDocQueryVariables> & ({ variables: BenefitInvoicesReportDrawerGoogleDocQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BenefitInvoicesReportDrawerGoogleDocDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BenefitInvoicesReportDrawerGoogleDocQuery, BenefitInvoicesReportDrawerGoogleDocQueryVariables>(BenefitInvoicesReportDrawerGoogleDocDocument, parser(options)));
      }
export function useBenefitInvoicesReportDrawerGoogleDocLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BenefitInvoicesReportDrawerGoogleDocQuery, BenefitInvoicesReportDrawerGoogleDocQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BenefitInvoicesReportDrawerGoogleDocDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BenefitInvoicesReportDrawerGoogleDocQuery, BenefitInvoicesReportDrawerGoogleDocQueryVariables>(BenefitInvoicesReportDrawerGoogleDocDocument, options));
        }

export type BenefitInvoicesReportDrawerGoogleDocQueryResult = ApolloReact.QueryResult<BenefitInvoicesReportDrawerGoogleDocQuery, BenefitInvoicesReportDrawerGoogleDocQueryVariables>;
export function refetchBenefitInvoicesReportDrawerGoogleDocQuery(variables: BenefitInvoicesReportDrawerGoogleDocQueryVariables) {
      return { query: BenefitInvoicesReportDrawerGoogleDocDocument, variables: variables }
    }
export const BenefitNoteDrawerContractDocument = /*#__PURE__*/ gql`
    query BenefitNoteDrawer_Contract($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        assignedVariants(activeOnly: false) {
          ...Unauthorized
          ... on AccessGranted__ListOfAssignedVariant {
            value {
              id
              note
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useBenefitNoteDrawerContractQuery__
 *
 * To run a query within a React component, call `useBenefitNoteDrawerContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitNoteDrawerContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitNoteDrawerContractQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useBenefitNoteDrawerContractQuery(baseOptions: ApolloReact.QueryHookOptions<BenefitNoteDrawerContractQuery, BenefitNoteDrawerContractQueryVariables> & ({ variables: BenefitNoteDrawerContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BenefitNoteDrawerContractDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BenefitNoteDrawerContractQuery, BenefitNoteDrawerContractQueryVariables>(BenefitNoteDrawerContractDocument, parser(options)));
      }
export function useBenefitNoteDrawerContractLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BenefitNoteDrawerContractQuery, BenefitNoteDrawerContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BenefitNoteDrawerContractDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BenefitNoteDrawerContractQuery, BenefitNoteDrawerContractQueryVariables>(BenefitNoteDrawerContractDocument, options));
        }

export type BenefitNoteDrawerContractQueryResult = ApolloReact.QueryResult<BenefitNoteDrawerContractQuery, BenefitNoteDrawerContractQueryVariables>;
export function refetchBenefitNoteDrawerContractQuery(variables: BenefitNoteDrawerContractQueryVariables) {
      return { query: BenefitNoteDrawerContractDocument, variables: variables }
    }
export const BenefitNoteDrawerUpdateNoteDocument = /*#__PURE__*/ gql`
    mutation BenefitNoteDrawer_UpdateNote($contractId: ContractId!, $entityVersion: EntityVersion!, $assignedVariant: AssignedVariantId!, $note: String!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateBenefitVariantNote(assignedVariant: $assignedVariant, note: $note) {
      ...NfsError
      ... on AssignedVariant {
        id
        note
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useBenefitNoteDrawerUpdateNoteMutation__
 *
 * To run a mutation, you first call `useBenefitNoteDrawerUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenefitNoteDrawerUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benefitNoteDrawerUpdateNoteMutation, { data, loading, error }] = useBenefitNoteDrawerUpdateNoteMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      assignedVariant: // value for 'assignedVariant'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useBenefitNoteDrawerUpdateNoteMutation(baseOptions?: ApolloReact.MutationHookOptions<BenefitNoteDrawerUpdateNoteMutation, BenefitNoteDrawerUpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BenefitNoteDrawerUpdateNoteDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BenefitNoteDrawerUpdateNoteMutation, BenefitNoteDrawerUpdateNoteMutationVariables>(BenefitNoteDrawerUpdateNoteDocument, parser(options)));
      }
export type BenefitNoteDrawerUpdateNoteMutationHookResult = ReturnType<typeof useBenefitNoteDrawerUpdateNoteMutation>;
export type BenefitNoteDrawerUpdateNoteMutationResult = ApolloReact.MutationResult<BenefitNoteDrawerUpdateNoteMutation>;
export type BenefitNoteDrawerUpdateNoteMutationOptions = Apollo.MutationOptions<BenefitNoteDrawerUpdateNoteMutation, BenefitNoteDrawerUpdateNoteMutationVariables>;
export const BenefitsAssignmentsDocument = /*#__PURE__*/ gql`
    query BenefitsAssignments($after: Cursor, $filter: FilterAssignedVariantInput, $sort: SortingRequestSortAssignedVariantInput, $first: Int) {
  assignedVariants(first: $first, after: $after, sort: $sort, filter: $filter) {
    ...NfsError
    ... on FSPResponseAssignedVariant {
      edges {
        cursor
        node {
          ...BenefitsAssignments_AssignedVariant
        }
      }
      hasNextPage
      totalCount
      filteredCount
    }
  }
}
    ${NfsErrorFragmentDoc}
${BenefitsAssignmentsAssignedVariantFragmentDoc}`;

/**
 * __useBenefitsAssignmentsQuery__
 *
 * To run a query within a React component, call `useBenefitsAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsAssignmentsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useBenefitsAssignmentsQuery(baseOptions?: ApolloReact.QueryHookOptions<BenefitsAssignmentsQuery, BenefitsAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BenefitsAssignmentsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BenefitsAssignmentsQuery, BenefitsAssignmentsQueryVariables>(BenefitsAssignmentsDocument, parser(options)));
      }
export function useBenefitsAssignmentsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BenefitsAssignmentsQuery, BenefitsAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BenefitsAssignmentsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BenefitsAssignmentsQuery, BenefitsAssignmentsQueryVariables>(BenefitsAssignmentsDocument, options));
        }

export type BenefitsAssignmentsQueryResult = ApolloReact.QueryResult<BenefitsAssignmentsQuery, BenefitsAssignmentsQueryVariables>;
export function refetchBenefitsAssignmentsQuery(variables?: BenefitsAssignmentsQueryVariables) {
      return { query: BenefitsAssignmentsDocument, variables: variables }
    }
export const BenefitsProductsDocument = /*#__PURE__*/ gql`
    query BenefitsProducts($filter: BenefitVariantFilterInput) {
  benefits(filter: $filter) {
    ...NfsError
    ... on ListOfBenefitGroupResponse {
      value {
        groupType
        benefits {
          manyOf {
            alternativeBenefitsGroupId
            oneOf {
              ...BenefitsProducts_BenefitCommon
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BenefitsProductsBenefitCommonFragmentDoc}`;

/**
 * __useBenefitsProductsQuery__
 *
 * To run a query within a React component, call `useBenefitsProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBenefitsProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBenefitsProductsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBenefitsProductsQuery(baseOptions?: ApolloReact.QueryHookOptions<BenefitsProductsQuery, BenefitsProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BenefitsProductsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BenefitsProductsQuery, BenefitsProductsQueryVariables>(BenefitsProductsDocument, parser(options)));
      }
export function useBenefitsProductsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BenefitsProductsQuery, BenefitsProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BenefitsProductsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BenefitsProductsQuery, BenefitsProductsQueryVariables>(BenefitsProductsDocument, options));
        }

export type BenefitsProductsQueryResult = ApolloReact.QueryResult<BenefitsProductsQuery, BenefitsProductsQueryVariables>;
export function refetchBenefitsProductsQuery(variables?: BenefitsProductsQueryVariables) {
      return { query: BenefitsProductsDocument, variables: variables }
    }
export const BlockOfficeModalBlockDocument = /*#__PURE__*/ gql`
    mutation BlockOfficeModal_Block($officeId: OfficeId!, $entityVersion: EntityVersion!) {
  blockOffice(officeId: $officeId, entityVersion: $entityVersion) {
    ...NfsError
    ... on OfficeSettings {
      ...BlockOfficeModal_OfficeSettings
    }
  }
}
    ${NfsErrorFragmentDoc}
${BlockOfficeModalOfficeSettingsFragmentDoc}`;


/**
 * __useBlockOfficeModalBlockMutation__
 *
 * To run a mutation, you first call `useBlockOfficeModalBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockOfficeModalBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockOfficeModalBlockMutation, { data, loading, error }] = useBlockOfficeModalBlockMutation({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useBlockOfficeModalBlockMutation(baseOptions?: ApolloReact.MutationHookOptions<BlockOfficeModalBlockMutation, BlockOfficeModalBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BlockOfficeModalBlockDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BlockOfficeModalBlockMutation, BlockOfficeModalBlockMutationVariables>(BlockOfficeModalBlockDocument, parser(options)));
      }
export type BlockOfficeModalBlockMutationHookResult = ReturnType<typeof useBlockOfficeModalBlockMutation>;
export type BlockOfficeModalBlockMutationResult = ApolloReact.MutationResult<BlockOfficeModalBlockMutation>;
export type BlockOfficeModalBlockMutationOptions = Apollo.MutationOptions<BlockOfficeModalBlockMutation, BlockOfficeModalBlockMutationVariables>;
export const BlockOfficeModalUnblockDocument = /*#__PURE__*/ gql`
    mutation BlockOfficeModal_Unblock($officeId: OfficeId!, $entityVersion: EntityVersion!) {
  unblockOffice(officeId: $officeId, entityVersion: $entityVersion) {
    ...NfsError
    ... on OfficeSettings {
      ...BlockOfficeModal_OfficeSettings
    }
  }
}
    ${NfsErrorFragmentDoc}
${BlockOfficeModalOfficeSettingsFragmentDoc}`;


/**
 * __useBlockOfficeModalUnblockMutation__
 *
 * To run a mutation, you first call `useBlockOfficeModalUnblockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockOfficeModalUnblockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockOfficeModalUnblockMutation, { data, loading, error }] = useBlockOfficeModalUnblockMutation({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useBlockOfficeModalUnblockMutation(baseOptions?: ApolloReact.MutationHookOptions<BlockOfficeModalUnblockMutation, BlockOfficeModalUnblockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BlockOfficeModalUnblockDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BlockOfficeModalUnblockMutation, BlockOfficeModalUnblockMutationVariables>(BlockOfficeModalUnblockDocument, parser(options)));
      }
export type BlockOfficeModalUnblockMutationHookResult = ReturnType<typeof useBlockOfficeModalUnblockMutation>;
export type BlockOfficeModalUnblockMutationResult = ApolloReact.MutationResult<BlockOfficeModalUnblockMutation>;
export type BlockOfficeModalUnblockMutationOptions = Apollo.MutationOptions<BlockOfficeModalUnblockMutation, BlockOfficeModalUnblockMutationVariables>;
export const BonusDrawerInputDocument = /*#__PURE__*/ gql`
    query BonusDrawer_Input($contractId: ContractId!, $userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      directReporting {
        assignedProjects(status_oneOf: [Live], orderByFirstPositionStartDate: Desc) {
          ...Unauthorized
          ... on AccessGranted__ListOfProjectAssignment {
            value {
              user {
                id
              }
              project {
                id
                name
              }
            }
          }
        }
      }
    }
  }
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        terminationDate
        startDate
        ... on EmploymentContract {
          enableTrainingPackage {
            ...Unauthorized
            ... on AccessGranted__Boolean {
              value
            }
          }
          currency {
            ...Unauthorized
            ... on AccessGranted__TimeBasedCurrency {
              value {
                ...BonusDrawer_Currency
              }
            }
          }
          rate {
            ...Unauthorized
            ... on AccessGranted__TimeBasedRate {
              value {
                value {
                  ...Rate
                }
              }
            }
          }
        }
        ... on B2BContract {
          enableTrainingPackage {
            ...Unauthorized
            ... on AccessGranted__Boolean {
              value
            }
          }
          vat {
            ...Unauthorized
            ... on AccessGranted__TimeBasedVatType {
              value {
                value {
                  ...VatType
                }
              }
            }
          }
          currency {
            ...Unauthorized
            ... on AccessGranted__TimeBasedCurrency {
              value {
                ...BonusDrawer_Currency
              }
            }
          }
          rate {
            ...Unauthorized
            ... on AccessGranted__TimeBasedRate {
              value {
                value {
                  ...Rate
                }
              }
            }
          }
        }
        bonuses {
          ...Unauthorized
          ... on AccessGranted__Bonuses {
            value {
              paidOut {
                ...BonusDrawer_Bonus
              }
              future {
                ...BonusDrawer_Bonus
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${BonusDrawerCurrencyFragmentDoc}
${RateFragmentDoc}
${VatTypeFragmentDoc}
${BonusDrawerBonusFragmentDoc}`;

/**
 * __useBonusDrawerInputQuery__
 *
 * To run a query within a React component, call `useBonusDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useBonusDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBonusDrawerInputQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBonusDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<BonusDrawerInputQuery, BonusDrawerInputQueryVariables> & ({ variables: BonusDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BonusDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BonusDrawerInputQuery, BonusDrawerInputQueryVariables>(BonusDrawerInputDocument, parser(options)));
      }
export function useBonusDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BonusDrawerInputQuery, BonusDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BonusDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BonusDrawerInputQuery, BonusDrawerInputQueryVariables>(BonusDrawerInputDocument, options));
        }

export type BonusDrawerInputQueryResult = ApolloReact.QueryResult<BonusDrawerInputQuery, BonusDrawerInputQueryVariables>;
export function refetchBonusDrawerInputQuery(variables: BonusDrawerInputQueryVariables) {
      return { query: BonusDrawerInputDocument, variables: variables }
    }
export const BonusDrawerManageBonusDocument = /*#__PURE__*/ gql`
    mutation BonusDrawer_ManageBonus($contractId: ContractId!, $entityVersion: EntityVersion!, $input: BonusInput!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    upsertBonus(input: $input) {
      ...NfsError
      ... on BonusResponse {
        value {
          ...BonusDrawer_Bonus
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BonusDrawerBonusFragmentDoc}`;


/**
 * __useBonusDrawerManageBonusMutation__
 *
 * To run a mutation, you first call `useBonusDrawerManageBonusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBonusDrawerManageBonusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bonusDrawerManageBonusMutation, { data, loading, error }] = useBonusDrawerManageBonusMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBonusDrawerManageBonusMutation(baseOptions?: ApolloReact.MutationHookOptions<BonusDrawerManageBonusMutation, BonusDrawerManageBonusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BonusDrawerManageBonusDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BonusDrawerManageBonusMutation, BonusDrawerManageBonusMutationVariables>(BonusDrawerManageBonusDocument, parser(options)));
      }
export type BonusDrawerManageBonusMutationHookResult = ReturnType<typeof useBonusDrawerManageBonusMutation>;
export type BonusDrawerManageBonusMutationResult = ApolloReact.MutationResult<BonusDrawerManageBonusMutation>;
export type BonusDrawerManageBonusMutationOptions = Apollo.MutationOptions<BonusDrawerManageBonusMutation, BonusDrawerManageBonusMutationVariables>;
export const BonusDrawerRejectDocument = /*#__PURE__*/ gql`
    mutation BonusDrawer_Reject($contractId: ContractId!, $entityVersion: EntityVersion!, $id: BonusId!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    bonus(id: $id) {
      reject {
        ...NfsError
        ... on BonusResponse {
          value {
            ...AdditionalCostDrawer_Bonus
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AdditionalCostDrawerBonusFragmentDoc}`;


/**
 * __useBonusDrawerRejectMutation__
 *
 * To run a mutation, you first call `useBonusDrawerRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBonusDrawerRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bonusDrawerRejectMutation, { data, loading, error }] = useBonusDrawerRejectMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBonusDrawerRejectMutation(baseOptions?: ApolloReact.MutationHookOptions<BonusDrawerRejectMutation, BonusDrawerRejectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BonusDrawerRejectDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BonusDrawerRejectMutation, BonusDrawerRejectMutationVariables>(BonusDrawerRejectDocument, parser(options)));
      }
export type BonusDrawerRejectMutationHookResult = ReturnType<typeof useBonusDrawerRejectMutation>;
export type BonusDrawerRejectMutationResult = ApolloReact.MutationResult<BonusDrawerRejectMutation>;
export type BonusDrawerRejectMutationOptions = Apollo.MutationOptions<BonusDrawerRejectMutation, BonusDrawerRejectMutationVariables>;
export const BonusDrawerApproveDocument = /*#__PURE__*/ gql`
    mutation BonusDrawer_Approve($contractId: ContractId!, $entityVersion: EntityVersion!, $id: BonusId!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    bonus(id: $id) {
      approve {
        ...NfsError
        ... on BonusResponse {
          value {
            ...AdditionalCostDrawer_Bonus
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AdditionalCostDrawerBonusFragmentDoc}`;


/**
 * __useBonusDrawerApproveMutation__
 *
 * To run a mutation, you first call `useBonusDrawerApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBonusDrawerApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bonusDrawerApproveMutation, { data, loading, error }] = useBonusDrawerApproveMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBonusDrawerApproveMutation(baseOptions?: ApolloReact.MutationHookOptions<BonusDrawerApproveMutation, BonusDrawerApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BonusDrawerApproveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BonusDrawerApproveMutation, BonusDrawerApproveMutationVariables>(BonusDrawerApproveDocument, parser(options)));
      }
export type BonusDrawerApproveMutationHookResult = ReturnType<typeof useBonusDrawerApproveMutation>;
export type BonusDrawerApproveMutationResult = ApolloReact.MutationResult<BonusDrawerApproveMutation>;
export type BonusDrawerApproveMutationOptions = Apollo.MutationOptions<BonusDrawerApproveMutation, BonusDrawerApproveMutationVariables>;
export const BonusFormReferredUserInfoDocument = /*#__PURE__*/ gql`
    query BonusForm_ReferredUserInfo($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            entityVersion
            name
            startDate
            status
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useBonusFormReferredUserInfoQuery__
 *
 * To run a query within a React component, call `useBonusFormReferredUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBonusFormReferredUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBonusFormReferredUserInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBonusFormReferredUserInfoQuery(baseOptions: ApolloReact.QueryHookOptions<BonusFormReferredUserInfoQuery, BonusFormReferredUserInfoQueryVariables> & ({ variables: BonusFormReferredUserInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BonusFormReferredUserInfoDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BonusFormReferredUserInfoQuery, BonusFormReferredUserInfoQueryVariables>(BonusFormReferredUserInfoDocument, parser(options)));
      }
export function useBonusFormReferredUserInfoLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BonusFormReferredUserInfoQuery, BonusFormReferredUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BonusFormReferredUserInfoDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BonusFormReferredUserInfoQuery, BonusFormReferredUserInfoQueryVariables>(BonusFormReferredUserInfoDocument, options));
        }

export type BonusFormReferredUserInfoQueryResult = ApolloReact.QueryResult<BonusFormReferredUserInfoQuery, BonusFormReferredUserInfoQueryVariables>;
export function refetchBonusFormReferredUserInfoQuery(variables: BonusFormReferredUserInfoQueryVariables) {
      return { query: BonusFormReferredUserInfoDocument, variables: variables }
    }
export const BonusFormUserAutocompleteDocument = /*#__PURE__*/ gql`
    query BonusForm_UserAutocomplete($filter: FilterUserInput!, $sort: SortingRequestSortUserInput, $first: Int!, $after: Cursor) {
  users(filter: $filter, sort: $sort, first: $first, after: $after) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      edges {
        cursor
        node {
          ...UserAutocomplete_User
          avatar
          email
          progressionLevel {
            value
          }
          contracts {
            ...Unauthorized
            ... on AccessGranted__ListOfContract {
              value {
                id
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserAutocompleteUserFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useBonusFormUserAutocompleteQuery__
 *
 * To run a query within a React component, call `useBonusFormUserAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useBonusFormUserAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBonusFormUserAutocompleteQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBonusFormUserAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<BonusFormUserAutocompleteQuery, BonusFormUserAutocompleteQueryVariables> & ({ variables: BonusFormUserAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BonusFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BonusFormUserAutocompleteQuery, BonusFormUserAutocompleteQueryVariables>(BonusFormUserAutocompleteDocument, parser(options)));
      }
export function useBonusFormUserAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BonusFormUserAutocompleteQuery, BonusFormUserAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BonusFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BonusFormUserAutocompleteQuery, BonusFormUserAutocompleteQueryVariables>(BonusFormUserAutocompleteDocument, options));
        }

export type BonusFormUserAutocompleteQueryResult = ApolloReact.QueryResult<BonusFormUserAutocompleteQuery, BonusFormUserAutocompleteQueryVariables>;
export function refetchBonusFormUserAutocompleteQuery(variables: BonusFormUserAutocompleteQueryVariables) {
      return { query: BonusFormUserAutocompleteDocument, variables: variables }
    }
export const BonusFormTrainingPackageBudgetDocument = /*#__PURE__*/ gql`
    query BonusForm_TrainingPackageBudget($contractId: ContractId!, $year: Year!) {
  trainingBudgetSummary(contractId: $contractId, year: $year) {
    ...NfsError
    ... on TrainingBudgetSummary {
      yearlySummary {
        key
        value {
          year
          totalBalance {
            ...CentsBalance
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CentsBalanceFragmentDoc}`;

/**
 * __useBonusFormTrainingPackageBudgetQuery__
 *
 * To run a query within a React component, call `useBonusFormTrainingPackageBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBonusFormTrainingPackageBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBonusFormTrainingPackageBudgetQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useBonusFormTrainingPackageBudgetQuery(baseOptions: ApolloReact.QueryHookOptions<BonusFormTrainingPackageBudgetQuery, BonusFormTrainingPackageBudgetQueryVariables> & ({ variables: BonusFormTrainingPackageBudgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BonusFormTrainingPackageBudgetDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BonusFormTrainingPackageBudgetQuery, BonusFormTrainingPackageBudgetQueryVariables>(BonusFormTrainingPackageBudgetDocument, parser(options)));
      }
export function useBonusFormTrainingPackageBudgetLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BonusFormTrainingPackageBudgetQuery, BonusFormTrainingPackageBudgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BonusFormTrainingPackageBudgetDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BonusFormTrainingPackageBudgetQuery, BonusFormTrainingPackageBudgetQueryVariables>(BonusFormTrainingPackageBudgetDocument, options));
        }

export type BonusFormTrainingPackageBudgetQueryResult = ApolloReact.QueryResult<BonusFormTrainingPackageBudgetQuery, BonusFormTrainingPackageBudgetQueryVariables>;
export function refetchBonusFormTrainingPackageBudgetQuery(variables: BonusFormTrainingPackageBudgetQueryVariables) {
      return { query: BonusFormTrainingPackageBudgetDocument, variables: variables }
    }
export const BonusPreviewInitialDataDocument = /*#__PURE__*/ gql`
    query BonusPreview_InitialData($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        name
        status
        startDate
        ... on EmploymentContract {
          currency {
            ...Unauthorized
            ... on AccessGranted__TimeBasedCurrency {
              value {
                ...BonusPreview_Currency
              }
            }
          }
        }
        ... on B2BContract {
          vat {
            ...Unauthorized
            ... on AccessGranted__TimeBasedVatType {
              value {
                value {
                  ...VatType
                }
              }
            }
          }
          currency {
            ...Unauthorized
            ... on AccessGranted__TimeBasedCurrency {
              value {
                ...BonusPreview_Currency
              }
            }
          }
        }
        bonuses {
          ...Unauthorized
          ... on AccessGranted__Bonuses {
            value {
              paidOut {
                ...BonusPreview_Bonus
              }
              future {
                ...BonusPreview_Bonus
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${BonusPreviewCurrencyFragmentDoc}
${VatTypeFragmentDoc}
${BonusPreviewBonusFragmentDoc}`;

/**
 * __useBonusPreviewInitialDataQuery__
 *
 * To run a query within a React component, call `useBonusPreviewInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBonusPreviewInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBonusPreviewInitialDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useBonusPreviewInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<BonusPreviewInitialDataQuery, BonusPreviewInitialDataQueryVariables> & ({ variables: BonusPreviewInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BonusPreviewInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BonusPreviewInitialDataQuery, BonusPreviewInitialDataQueryVariables>(BonusPreviewInitialDataDocument, parser(options)));
      }
export function useBonusPreviewInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BonusPreviewInitialDataQuery, BonusPreviewInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BonusPreviewInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BonusPreviewInitialDataQuery, BonusPreviewInitialDataQueryVariables>(BonusPreviewInitialDataDocument, options));
        }

export type BonusPreviewInitialDataQueryResult = ApolloReact.QueryResult<BonusPreviewInitialDataQuery, BonusPreviewInitialDataQueryVariables>;
export function refetchBonusPreviewInitialDataQuery(variables: BonusPreviewInitialDataQueryVariables) {
      return { query: BonusPreviewInitialDataDocument, variables: variables }
    }
export const BookDeskOnBehalfDrawerInputDocument = /*#__PURE__*/ gql`
    query BookDeskOnBehalfDrawer_Input($officeId: OfficeId!, $range: ClosedEndLocalDateRangeInput!) {
  office(officeId: $officeId) {
    ...NfsError
    ... on Office {
      officeId
      name
      validFrom
      validTo
    }
  }
  officeCatalogue(officeId: $officeId) {
    ...NfsError
    ... on OfficeCatalogue {
      rooms {
        id
        name
        blocked
        desks {
          id
          name
          monitors
          standing
          blocked
        }
      }
    }
  }
  officeAvailability(officeId: $officeId, range: $range) {
    ...NfsError
    ... on OfficeAvailability {
      desks {
        resourceId
        takenDates
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useBookDeskOnBehalfDrawerInputQuery__
 *
 * To run a query within a React component, call `useBookDeskOnBehalfDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookDeskOnBehalfDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookDeskOnBehalfDrawerInputQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useBookDeskOnBehalfDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<BookDeskOnBehalfDrawerInputQuery, BookDeskOnBehalfDrawerInputQueryVariables> & ({ variables: BookDeskOnBehalfDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BookDeskOnBehalfDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BookDeskOnBehalfDrawerInputQuery, BookDeskOnBehalfDrawerInputQueryVariables>(BookDeskOnBehalfDrawerInputDocument, parser(options)));
      }
export function useBookDeskOnBehalfDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BookDeskOnBehalfDrawerInputQuery, BookDeskOnBehalfDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BookDeskOnBehalfDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BookDeskOnBehalfDrawerInputQuery, BookDeskOnBehalfDrawerInputQueryVariables>(BookDeskOnBehalfDrawerInputDocument, options));
        }

export type BookDeskOnBehalfDrawerInputQueryResult = ApolloReact.QueryResult<BookDeskOnBehalfDrawerInputQuery, BookDeskOnBehalfDrawerInputQueryVariables>;
export function refetchBookDeskOnBehalfDrawerInputQuery(variables: BookDeskOnBehalfDrawerInputQueryVariables) {
      return { query: BookDeskOnBehalfDrawerInputDocument, variables: variables }
    }
export const BookDeskOnBehalfDrawerReserveDocument = /*#__PURE__*/ gql`
    mutation BookDeskOnBehalfDrawer_Reserve($userId: UserId!, $input: ReserveDesksInput!) {
  reserveDesksOnBehalf(userId: $userId, input: $input) {
    ...NfsError
    ... on ReservationRequest {
      requestId
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useBookDeskOnBehalfDrawerReserveMutation__
 *
 * To run a mutation, you first call `useBookDeskOnBehalfDrawerReserveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookDeskOnBehalfDrawerReserveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookDeskOnBehalfDrawerReserveMutation, { data, loading, error }] = useBookDeskOnBehalfDrawerReserveMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookDeskOnBehalfDrawerReserveMutation(baseOptions?: ApolloReact.MutationHookOptions<BookDeskOnBehalfDrawerReserveMutation, BookDeskOnBehalfDrawerReserveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BookDeskOnBehalfDrawerReserveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BookDeskOnBehalfDrawerReserveMutation, BookDeskOnBehalfDrawerReserveMutationVariables>(BookDeskOnBehalfDrawerReserveDocument, parser(options)));
      }
export type BookDeskOnBehalfDrawerReserveMutationHookResult = ReturnType<typeof useBookDeskOnBehalfDrawerReserveMutation>;
export type BookDeskOnBehalfDrawerReserveMutationResult = ApolloReact.MutationResult<BookDeskOnBehalfDrawerReserveMutation>;
export type BookDeskOnBehalfDrawerReserveMutationOptions = Apollo.MutationOptions<BookDeskOnBehalfDrawerReserveMutation, BookDeskOnBehalfDrawerReserveMutationVariables>;
export const BookDeskOnBehalfFormUserAutocompleteDocument = /*#__PURE__*/ gql`
    query BookDeskOnBehalfForm_UserAutocomplete($after: Cursor, $filter: FilterUserInput!, $sort: SortingRequestSortUserInput, $first: Int!) {
  users(after: $after, filter: $filter, sort: $sort, first: $first) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      edges {
        cursor
        node {
          ...UserAutocomplete_User
          avatar
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserAutocompleteUserFragmentDoc}`;

/**
 * __useBookDeskOnBehalfFormUserAutocompleteQuery__
 *
 * To run a query within a React component, call `useBookDeskOnBehalfFormUserAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookDeskOnBehalfFormUserAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookDeskOnBehalfFormUserAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useBookDeskOnBehalfFormUserAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<BookDeskOnBehalfFormUserAutocompleteQuery, BookDeskOnBehalfFormUserAutocompleteQueryVariables> & ({ variables: BookDeskOnBehalfFormUserAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BookDeskOnBehalfFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BookDeskOnBehalfFormUserAutocompleteQuery, BookDeskOnBehalfFormUserAutocompleteQueryVariables>(BookDeskOnBehalfFormUserAutocompleteDocument, parser(options)));
      }
export function useBookDeskOnBehalfFormUserAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BookDeskOnBehalfFormUserAutocompleteQuery, BookDeskOnBehalfFormUserAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BookDeskOnBehalfFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BookDeskOnBehalfFormUserAutocompleteQuery, BookDeskOnBehalfFormUserAutocompleteQueryVariables>(BookDeskOnBehalfFormUserAutocompleteDocument, options));
        }

export type BookDeskOnBehalfFormUserAutocompleteQueryResult = ApolloReact.QueryResult<BookDeskOnBehalfFormUserAutocompleteQuery, BookDeskOnBehalfFormUserAutocompleteQueryVariables>;
export function refetchBookDeskOnBehalfFormUserAutocompleteQuery(variables: BookDeskOnBehalfFormUserAutocompleteQueryVariables) {
      return { query: BookDeskOnBehalfFormUserAutocompleteDocument, variables: variables }
    }
export const BookParkingOnBehalfDrawerInputDocument = /*#__PURE__*/ gql`
    query BookParkingOnBehalfDrawer_Input($officeId: OfficeId!, $range: ClosedEndLocalDateRangeInput!) {
  office(officeId: $officeId) {
    ...NfsError
    ... on Office {
      officeId
      name
      validFrom
      validTo
    }
  }
  officeSettings(officeId: $officeId) {
    ...NfsError
    ... on OfficeSettings {
      office {
        officeId
      }
      parkingInformation
    }
  }
  officeCatalogue(officeId: $officeId) {
    ...NfsError
    ... on OfficeCatalogue {
      parkingSpots {
        id
        number
        name
        guest
        blocked
      }
    }
  }
  officeAvailability(officeId: $officeId, range: $range) {
    ...NfsError
    ... on OfficeAvailability {
      parkingSpots {
        resourceId
        takenDates
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useBookParkingOnBehalfDrawerInputQuery__
 *
 * To run a query within a React component, call `useBookParkingOnBehalfDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookParkingOnBehalfDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookParkingOnBehalfDrawerInputQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useBookParkingOnBehalfDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<BookParkingOnBehalfDrawerInputQuery, BookParkingOnBehalfDrawerInputQueryVariables> & ({ variables: BookParkingOnBehalfDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BookParkingOnBehalfDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BookParkingOnBehalfDrawerInputQuery, BookParkingOnBehalfDrawerInputQueryVariables>(BookParkingOnBehalfDrawerInputDocument, parser(options)));
      }
export function useBookParkingOnBehalfDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BookParkingOnBehalfDrawerInputQuery, BookParkingOnBehalfDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BookParkingOnBehalfDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BookParkingOnBehalfDrawerInputQuery, BookParkingOnBehalfDrawerInputQueryVariables>(BookParkingOnBehalfDrawerInputDocument, options));
        }

export type BookParkingOnBehalfDrawerInputQueryResult = ApolloReact.QueryResult<BookParkingOnBehalfDrawerInputQuery, BookParkingOnBehalfDrawerInputQueryVariables>;
export function refetchBookParkingOnBehalfDrawerInputQuery(variables: BookParkingOnBehalfDrawerInputQueryVariables) {
      return { query: BookParkingOnBehalfDrawerInputDocument, variables: variables }
    }
export const BookParkingOnBehalfDrawerReserveDocument = /*#__PURE__*/ gql`
    mutation BookParkingOnBehalfDrawer_Reserve($userId: UserId!, $input: ReserveParkingInput!) {
  reserveParkingOnBehalf(userId: $userId, input: $input) {
    ...NfsError
    ... on ReservationRequest {
      requestId
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useBookParkingOnBehalfDrawerReserveMutation__
 *
 * To run a mutation, you first call `useBookParkingOnBehalfDrawerReserveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookParkingOnBehalfDrawerReserveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookParkingOnBehalfDrawerReserveMutation, { data, loading, error }] = useBookParkingOnBehalfDrawerReserveMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookParkingOnBehalfDrawerReserveMutation(baseOptions?: ApolloReact.MutationHookOptions<BookParkingOnBehalfDrawerReserveMutation, BookParkingOnBehalfDrawerReserveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BookParkingOnBehalfDrawerReserveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BookParkingOnBehalfDrawerReserveMutation, BookParkingOnBehalfDrawerReserveMutationVariables>(BookParkingOnBehalfDrawerReserveDocument, parser(options)));
      }
export type BookParkingOnBehalfDrawerReserveMutationHookResult = ReturnType<typeof useBookParkingOnBehalfDrawerReserveMutation>;
export type BookParkingOnBehalfDrawerReserveMutationResult = ApolloReact.MutationResult<BookParkingOnBehalfDrawerReserveMutation>;
export type BookParkingOnBehalfDrawerReserveMutationOptions = Apollo.MutationOptions<BookParkingOnBehalfDrawerReserveMutation, BookParkingOnBehalfDrawerReserveMutationVariables>;
export const BookParkingOnBehalfFormUserAutocompleteDocument = /*#__PURE__*/ gql`
    query BookParkingOnBehalfForm_UserAutocomplete($after: Cursor, $filter: FilterUserInput!, $sort: SortingRequestSortUserInput, $first: Int!) {
  users(after: $after, filter: $filter, sort: $sort, first: $first) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      edges {
        cursor
        node {
          ...UserAutocomplete_User
          avatar
          plateNumber {
            ...Unauthorized
            ... on AccessGranted__OptionalString {
              value
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserAutocompleteUserFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useBookParkingOnBehalfFormUserAutocompleteQuery__
 *
 * To run a query within a React component, call `useBookParkingOnBehalfFormUserAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookParkingOnBehalfFormUserAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookParkingOnBehalfFormUserAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useBookParkingOnBehalfFormUserAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<BookParkingOnBehalfFormUserAutocompleteQuery, BookParkingOnBehalfFormUserAutocompleteQueryVariables> & ({ variables: BookParkingOnBehalfFormUserAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BookParkingOnBehalfFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BookParkingOnBehalfFormUserAutocompleteQuery, BookParkingOnBehalfFormUserAutocompleteQueryVariables>(BookParkingOnBehalfFormUserAutocompleteDocument, parser(options)));
      }
export function useBookParkingOnBehalfFormUserAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BookParkingOnBehalfFormUserAutocompleteQuery, BookParkingOnBehalfFormUserAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BookParkingOnBehalfFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BookParkingOnBehalfFormUserAutocompleteQuery, BookParkingOnBehalfFormUserAutocompleteQueryVariables>(BookParkingOnBehalfFormUserAutocompleteDocument, options));
        }

export type BookParkingOnBehalfFormUserAutocompleteQueryResult = ApolloReact.QueryResult<BookParkingOnBehalfFormUserAutocompleteQuery, BookParkingOnBehalfFormUserAutocompleteQueryVariables>;
export function refetchBookParkingOnBehalfFormUserAutocompleteQuery(variables: BookParkingOnBehalfFormUserAutocompleteQueryVariables) {
      return { query: BookParkingOnBehalfFormUserAutocompleteDocument, variables: variables }
    }
export const CancelOfficeBookingModalCancelDocument = /*#__PURE__*/ gql`
    mutation CancelOfficeBookingModal_Cancel($requestId: ReservationRequestId!) {
  cancelOfficeReservation(requestId: $requestId) {
    ...NfsError
    ... on ReservationRequest {
      requestId
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCancelOfficeBookingModalCancelMutation__
 *
 * To run a mutation, you first call `useCancelOfficeBookingModalCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOfficeBookingModalCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOfficeBookingModalCancelMutation, { data, loading, error }] = useCancelOfficeBookingModalCancelMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useCancelOfficeBookingModalCancelMutation(baseOptions?: ApolloReact.MutationHookOptions<CancelOfficeBookingModalCancelMutation, CancelOfficeBookingModalCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CancelOfficeBookingModalCancelDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CancelOfficeBookingModalCancelMutation, CancelOfficeBookingModalCancelMutationVariables>(CancelOfficeBookingModalCancelDocument, parser(options)));
      }
export type CancelOfficeBookingModalCancelMutationHookResult = ReturnType<typeof useCancelOfficeBookingModalCancelMutation>;
export type CancelOfficeBookingModalCancelMutationResult = ApolloReact.MutationResult<CancelOfficeBookingModalCancelMutation>;
export type CancelOfficeBookingModalCancelMutationOptions = Apollo.MutationOptions<CancelOfficeBookingModalCancelMutation, CancelOfficeBookingModalCancelMutationVariables>;
export const CatalogueActionModalBlockRoomDocument = /*#__PURE__*/ gql`
    mutation CatalogueActionModal_BlockRoom($roomId: RoomId!) {
  blockRoom(roomId: $roomId) {
    ...NfsError
    ... on Room {
      id
      blocked
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCatalogueActionModalBlockRoomMutation__
 *
 * To run a mutation, you first call `useCatalogueActionModalBlockRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCatalogueActionModalBlockRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [catalogueActionModalBlockRoomMutation, { data, loading, error }] = useCatalogueActionModalBlockRoomMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useCatalogueActionModalBlockRoomMutation(baseOptions?: ApolloReact.MutationHookOptions<CatalogueActionModalBlockRoomMutation, CatalogueActionModalBlockRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CatalogueActionModalBlockRoomDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CatalogueActionModalBlockRoomMutation, CatalogueActionModalBlockRoomMutationVariables>(CatalogueActionModalBlockRoomDocument, parser(options)));
      }
export type CatalogueActionModalBlockRoomMutationHookResult = ReturnType<typeof useCatalogueActionModalBlockRoomMutation>;
export type CatalogueActionModalBlockRoomMutationResult = ApolloReact.MutationResult<CatalogueActionModalBlockRoomMutation>;
export type CatalogueActionModalBlockRoomMutationOptions = Apollo.MutationOptions<CatalogueActionModalBlockRoomMutation, CatalogueActionModalBlockRoomMutationVariables>;
export const CatalogueActionModalUnblockRoomDocument = /*#__PURE__*/ gql`
    mutation CatalogueActionModal_UnblockRoom($roomId: RoomId!) {
  unblockRoom(roomId: $roomId) {
    ...NfsError
    ... on Room {
      id
      blocked
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCatalogueActionModalUnblockRoomMutation__
 *
 * To run a mutation, you first call `useCatalogueActionModalUnblockRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCatalogueActionModalUnblockRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [catalogueActionModalUnblockRoomMutation, { data, loading, error }] = useCatalogueActionModalUnblockRoomMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useCatalogueActionModalUnblockRoomMutation(baseOptions?: ApolloReact.MutationHookOptions<CatalogueActionModalUnblockRoomMutation, CatalogueActionModalUnblockRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CatalogueActionModalUnblockRoomDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CatalogueActionModalUnblockRoomMutation, CatalogueActionModalUnblockRoomMutationVariables>(CatalogueActionModalUnblockRoomDocument, parser(options)));
      }
export type CatalogueActionModalUnblockRoomMutationHookResult = ReturnType<typeof useCatalogueActionModalUnblockRoomMutation>;
export type CatalogueActionModalUnblockRoomMutationResult = ApolloReact.MutationResult<CatalogueActionModalUnblockRoomMutation>;
export type CatalogueActionModalUnblockRoomMutationOptions = Apollo.MutationOptions<CatalogueActionModalUnblockRoomMutation, CatalogueActionModalUnblockRoomMutationVariables>;
export const CatalogueActionModalDeleteRoomDocument = /*#__PURE__*/ gql`
    mutation CatalogueActionModal_DeleteRoom($roomId: RoomId!) {
  deleteRoom(roomId: $roomId) {
    ...NfsError
    ... on BooleanResponse {
      value
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCatalogueActionModalDeleteRoomMutation__
 *
 * To run a mutation, you first call `useCatalogueActionModalDeleteRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCatalogueActionModalDeleteRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [catalogueActionModalDeleteRoomMutation, { data, loading, error }] = useCatalogueActionModalDeleteRoomMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useCatalogueActionModalDeleteRoomMutation(baseOptions?: ApolloReact.MutationHookOptions<CatalogueActionModalDeleteRoomMutation, CatalogueActionModalDeleteRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CatalogueActionModalDeleteRoomDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CatalogueActionModalDeleteRoomMutation, CatalogueActionModalDeleteRoomMutationVariables>(CatalogueActionModalDeleteRoomDocument, parser(options)));
      }
export type CatalogueActionModalDeleteRoomMutationHookResult = ReturnType<typeof useCatalogueActionModalDeleteRoomMutation>;
export type CatalogueActionModalDeleteRoomMutationResult = ApolloReact.MutationResult<CatalogueActionModalDeleteRoomMutation>;
export type CatalogueActionModalDeleteRoomMutationOptions = Apollo.MutationOptions<CatalogueActionModalDeleteRoomMutation, CatalogueActionModalDeleteRoomMutationVariables>;
export const CatalogueActionModalBlockDeskDocument = /*#__PURE__*/ gql`
    mutation CatalogueActionModal_BlockDesk($deskId: DeskId!) {
  blockDesk(deskId: $deskId) {
    ...NfsError
    ... on Desk {
      id
      blocked
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCatalogueActionModalBlockDeskMutation__
 *
 * To run a mutation, you first call `useCatalogueActionModalBlockDeskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCatalogueActionModalBlockDeskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [catalogueActionModalBlockDeskMutation, { data, loading, error }] = useCatalogueActionModalBlockDeskMutation({
 *   variables: {
 *      deskId: // value for 'deskId'
 *   },
 * });
 */
export function useCatalogueActionModalBlockDeskMutation(baseOptions?: ApolloReact.MutationHookOptions<CatalogueActionModalBlockDeskMutation, CatalogueActionModalBlockDeskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CatalogueActionModalBlockDeskDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CatalogueActionModalBlockDeskMutation, CatalogueActionModalBlockDeskMutationVariables>(CatalogueActionModalBlockDeskDocument, parser(options)));
      }
export type CatalogueActionModalBlockDeskMutationHookResult = ReturnType<typeof useCatalogueActionModalBlockDeskMutation>;
export type CatalogueActionModalBlockDeskMutationResult = ApolloReact.MutationResult<CatalogueActionModalBlockDeskMutation>;
export type CatalogueActionModalBlockDeskMutationOptions = Apollo.MutationOptions<CatalogueActionModalBlockDeskMutation, CatalogueActionModalBlockDeskMutationVariables>;
export const CatalogueActionModalUnblockDeskDocument = /*#__PURE__*/ gql`
    mutation CatalogueActionModal_UnblockDesk($deskId: DeskId!) {
  unblockDesk(deskId: $deskId) {
    ...NfsError
    ... on Desk {
      id
      blocked
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCatalogueActionModalUnblockDeskMutation__
 *
 * To run a mutation, you first call `useCatalogueActionModalUnblockDeskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCatalogueActionModalUnblockDeskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [catalogueActionModalUnblockDeskMutation, { data, loading, error }] = useCatalogueActionModalUnblockDeskMutation({
 *   variables: {
 *      deskId: // value for 'deskId'
 *   },
 * });
 */
export function useCatalogueActionModalUnblockDeskMutation(baseOptions?: ApolloReact.MutationHookOptions<CatalogueActionModalUnblockDeskMutation, CatalogueActionModalUnblockDeskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CatalogueActionModalUnblockDeskDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CatalogueActionModalUnblockDeskMutation, CatalogueActionModalUnblockDeskMutationVariables>(CatalogueActionModalUnblockDeskDocument, parser(options)));
      }
export type CatalogueActionModalUnblockDeskMutationHookResult = ReturnType<typeof useCatalogueActionModalUnblockDeskMutation>;
export type CatalogueActionModalUnblockDeskMutationResult = ApolloReact.MutationResult<CatalogueActionModalUnblockDeskMutation>;
export type CatalogueActionModalUnblockDeskMutationOptions = Apollo.MutationOptions<CatalogueActionModalUnblockDeskMutation, CatalogueActionModalUnblockDeskMutationVariables>;
export const CatalogueActionModalDeleteDeskDocument = /*#__PURE__*/ gql`
    mutation CatalogueActionModal_DeleteDesk($deskId: DeskId!) {
  deleteDesk(deskId: $deskId) {
    ...NfsError
    ... on BooleanResponse {
      value
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCatalogueActionModalDeleteDeskMutation__
 *
 * To run a mutation, you first call `useCatalogueActionModalDeleteDeskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCatalogueActionModalDeleteDeskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [catalogueActionModalDeleteDeskMutation, { data, loading, error }] = useCatalogueActionModalDeleteDeskMutation({
 *   variables: {
 *      deskId: // value for 'deskId'
 *   },
 * });
 */
export function useCatalogueActionModalDeleteDeskMutation(baseOptions?: ApolloReact.MutationHookOptions<CatalogueActionModalDeleteDeskMutation, CatalogueActionModalDeleteDeskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CatalogueActionModalDeleteDeskDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CatalogueActionModalDeleteDeskMutation, CatalogueActionModalDeleteDeskMutationVariables>(CatalogueActionModalDeleteDeskDocument, parser(options)));
      }
export type CatalogueActionModalDeleteDeskMutationHookResult = ReturnType<typeof useCatalogueActionModalDeleteDeskMutation>;
export type CatalogueActionModalDeleteDeskMutationResult = ApolloReact.MutationResult<CatalogueActionModalDeleteDeskMutation>;
export type CatalogueActionModalDeleteDeskMutationOptions = Apollo.MutationOptions<CatalogueActionModalDeleteDeskMutation, CatalogueActionModalDeleteDeskMutationVariables>;
export const CatalogueActionModalBlockParkingSpotDocument = /*#__PURE__*/ gql`
    mutation CatalogueActionModal_BlockParkingSpot($parkingSpotId: ParkingSpotId!) {
  blockParkingSpot(parkingSpotId: $parkingSpotId) {
    ...NfsError
    ... on ParkingSpot {
      id
      blocked
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCatalogueActionModalBlockParkingSpotMutation__
 *
 * To run a mutation, you first call `useCatalogueActionModalBlockParkingSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCatalogueActionModalBlockParkingSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [catalogueActionModalBlockParkingSpotMutation, { data, loading, error }] = useCatalogueActionModalBlockParkingSpotMutation({
 *   variables: {
 *      parkingSpotId: // value for 'parkingSpotId'
 *   },
 * });
 */
export function useCatalogueActionModalBlockParkingSpotMutation(baseOptions?: ApolloReact.MutationHookOptions<CatalogueActionModalBlockParkingSpotMutation, CatalogueActionModalBlockParkingSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CatalogueActionModalBlockParkingSpotDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CatalogueActionModalBlockParkingSpotMutation, CatalogueActionModalBlockParkingSpotMutationVariables>(CatalogueActionModalBlockParkingSpotDocument, parser(options)));
      }
export type CatalogueActionModalBlockParkingSpotMutationHookResult = ReturnType<typeof useCatalogueActionModalBlockParkingSpotMutation>;
export type CatalogueActionModalBlockParkingSpotMutationResult = ApolloReact.MutationResult<CatalogueActionModalBlockParkingSpotMutation>;
export type CatalogueActionModalBlockParkingSpotMutationOptions = Apollo.MutationOptions<CatalogueActionModalBlockParkingSpotMutation, CatalogueActionModalBlockParkingSpotMutationVariables>;
export const CatalogueActionModalUnblockParkingSpotDocument = /*#__PURE__*/ gql`
    mutation CatalogueActionModal_UnblockParkingSpot($parkingSpotId: ParkingSpotId!) {
  unblockParkingSpot(parkingSpotId: $parkingSpotId) {
    ...NfsError
    ... on ParkingSpot {
      id
      blocked
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCatalogueActionModalUnblockParkingSpotMutation__
 *
 * To run a mutation, you first call `useCatalogueActionModalUnblockParkingSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCatalogueActionModalUnblockParkingSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [catalogueActionModalUnblockParkingSpotMutation, { data, loading, error }] = useCatalogueActionModalUnblockParkingSpotMutation({
 *   variables: {
 *      parkingSpotId: // value for 'parkingSpotId'
 *   },
 * });
 */
export function useCatalogueActionModalUnblockParkingSpotMutation(baseOptions?: ApolloReact.MutationHookOptions<CatalogueActionModalUnblockParkingSpotMutation, CatalogueActionModalUnblockParkingSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CatalogueActionModalUnblockParkingSpotDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CatalogueActionModalUnblockParkingSpotMutation, CatalogueActionModalUnblockParkingSpotMutationVariables>(CatalogueActionModalUnblockParkingSpotDocument, parser(options)));
      }
export type CatalogueActionModalUnblockParkingSpotMutationHookResult = ReturnType<typeof useCatalogueActionModalUnblockParkingSpotMutation>;
export type CatalogueActionModalUnblockParkingSpotMutationResult = ApolloReact.MutationResult<CatalogueActionModalUnblockParkingSpotMutation>;
export type CatalogueActionModalUnblockParkingSpotMutationOptions = Apollo.MutationOptions<CatalogueActionModalUnblockParkingSpotMutation, CatalogueActionModalUnblockParkingSpotMutationVariables>;
export const CatalogueActionModalDeleteParkingSpotDocument = /*#__PURE__*/ gql`
    mutation CatalogueActionModal_DeleteParkingSpot($parkingSpotId: ParkingSpotId!) {
  deleteParkingSpot(parkingSpotId: $parkingSpotId) {
    ...NfsError
    ... on BooleanResponse {
      value
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCatalogueActionModalDeleteParkingSpotMutation__
 *
 * To run a mutation, you first call `useCatalogueActionModalDeleteParkingSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCatalogueActionModalDeleteParkingSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [catalogueActionModalDeleteParkingSpotMutation, { data, loading, error }] = useCatalogueActionModalDeleteParkingSpotMutation({
 *   variables: {
 *      parkingSpotId: // value for 'parkingSpotId'
 *   },
 * });
 */
export function useCatalogueActionModalDeleteParkingSpotMutation(baseOptions?: ApolloReact.MutationHookOptions<CatalogueActionModalDeleteParkingSpotMutation, CatalogueActionModalDeleteParkingSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CatalogueActionModalDeleteParkingSpotDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CatalogueActionModalDeleteParkingSpotMutation, CatalogueActionModalDeleteParkingSpotMutationVariables>(CatalogueActionModalDeleteParkingSpotDocument, parser(options)));
      }
export type CatalogueActionModalDeleteParkingSpotMutationHookResult = ReturnType<typeof useCatalogueActionModalDeleteParkingSpotMutation>;
export type CatalogueActionModalDeleteParkingSpotMutationResult = ApolloReact.MutationResult<CatalogueActionModalDeleteParkingSpotMutation>;
export type CatalogueActionModalDeleteParkingSpotMutationOptions = Apollo.MutationOptions<CatalogueActionModalDeleteParkingSpotMutation, CatalogueActionModalDeleteParkingSpotMutationVariables>;
export const ClientContractDetailsDocument = /*#__PURE__*/ gql`
    query ClientContractDetails($clientContractId: ClientContractId!) {
  clientContract(id: $clientContractId) {
    ...NfsError
    ... on ClientContract {
      ...ClientContractDetails_FutureUpdates
      contractDurationFrom {
        ...Unauthorized
        ... on AccessGranted__LocalDate {
          value
        }
      }
      promisee {
        id
        entityVersion
        name
        logo
        taxNumber
        address {
          ...Address
        }
        mailingAddress {
          ...Address
        }
      }
      promisor {
        id
        entityVersion
        name
        logo
        taxNumber
        companyType
        sectors {
          ...Unauthorized
          ... on AccessGranted__ListOfString {
            value
          }
        }
        isPolishVat {
          value {
            value
          }
        }
        euVatType {
          value {
            value
          }
        }
        address {
          ...Address
        }
        mailingAddress {
          ...Address
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ClientContractDetailsFutureUpdatesFragmentDoc}
${UnauthorizedFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useClientContractDetailsQuery__
 *
 * To run a query within a React component, call `useClientContractDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientContractDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientContractDetailsQuery({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *   },
 * });
 */
export function useClientContractDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<ClientContractDetailsQuery, ClientContractDetailsQueryVariables> & ({ variables: ClientContractDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ClientContractDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ClientContractDetailsQuery, ClientContractDetailsQueryVariables>(ClientContractDetailsDocument, parser(options)));
      }
export function useClientContractDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ClientContractDetailsQuery, ClientContractDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ClientContractDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ClientContractDetailsQuery, ClientContractDetailsQueryVariables>(ClientContractDetailsDocument, options));
        }

export type ClientContractDetailsQueryResult = ApolloReact.QueryResult<ClientContractDetailsQuery, ClientContractDetailsQueryVariables>;
export function refetchClientContractDetailsQuery(variables: ClientContractDetailsQueryVariables) {
      return { query: ClientContractDetailsDocument, variables: variables }
    }
export const ClientContractDetailsCancelActivitiesDocument = /*#__PURE__*/ gql`
    mutation ClientContractDetails_CancelActivities($clientContractId: ClientContractId!, $entityVersion: EntityVersion!, $date: LocalDate!) {
  clientContract(id: $clientContractId, entityVersion: $entityVersion) {
    cancelActivities(date: $date) {
      ...NfsError
      ... on ClientContract {
        ...ClientContractDetails_FutureUpdates
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ClientContractDetailsFutureUpdatesFragmentDoc}`;


/**
 * __useClientContractDetailsCancelActivitiesMutation__
 *
 * To run a mutation, you first call `useClientContractDetailsCancelActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientContractDetailsCancelActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientContractDetailsCancelActivitiesMutation, { data, loading, error }] = useClientContractDetailsCancelActivitiesMutation({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *      entityVersion: // value for 'entityVersion'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useClientContractDetailsCancelActivitiesMutation(baseOptions?: ApolloReact.MutationHookOptions<ClientContractDetailsCancelActivitiesMutation, ClientContractDetailsCancelActivitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ClientContractDetailsCancelActivitiesDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ClientContractDetailsCancelActivitiesMutation, ClientContractDetailsCancelActivitiesMutationVariables>(ClientContractDetailsCancelActivitiesDocument, parser(options)));
      }
export type ClientContractDetailsCancelActivitiesMutationHookResult = ReturnType<typeof useClientContractDetailsCancelActivitiesMutation>;
export type ClientContractDetailsCancelActivitiesMutationResult = ApolloReact.MutationResult<ClientContractDetailsCancelActivitiesMutation>;
export type ClientContractDetailsCancelActivitiesMutationOptions = Apollo.MutationOptions<ClientContractDetailsCancelActivitiesMutation, ClientContractDetailsCancelActivitiesMutationVariables>;
export const ClientContractsListFiltersClientsDocument = /*#__PURE__*/ gql`
    query ClientContractsListFilters_Clients($first: Int, $after: Cursor) {
  companies(
    first: $first
    after: $after
    filter: {companyType_oneOf: [Client, Group]}
  ) {
    ...NfsError
    ... on FSPResponseCompany {
      hasNextPage
      edges {
        cursor
        node {
          entityVersion
          id
          name
          logo
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useClientContractsListFiltersClientsQuery__
 *
 * To run a query within a React component, call `useClientContractsListFiltersClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientContractsListFiltersClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientContractsListFiltersClientsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useClientContractsListFiltersClientsQuery(baseOptions?: ApolloReact.QueryHookOptions<ClientContractsListFiltersClientsQuery, ClientContractsListFiltersClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ClientContractsListFiltersClientsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ClientContractsListFiltersClientsQuery, ClientContractsListFiltersClientsQueryVariables>(ClientContractsListFiltersClientsDocument, parser(options)));
      }
export function useClientContractsListFiltersClientsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ClientContractsListFiltersClientsQuery, ClientContractsListFiltersClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ClientContractsListFiltersClientsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ClientContractsListFiltersClientsQuery, ClientContractsListFiltersClientsQueryVariables>(ClientContractsListFiltersClientsDocument, options));
        }

export type ClientContractsListFiltersClientsQueryResult = ApolloReact.QueryResult<ClientContractsListFiltersClientsQuery, ClientContractsListFiltersClientsQueryVariables>;
export function refetchClientContractsListFiltersClientsQuery(variables?: ClientContractsListFiltersClientsQueryVariables) {
      return { query: ClientContractsListFiltersClientsDocument, variables: variables }
    }
export const ClientContractsListFiltersSuppliersDocument = /*#__PURE__*/ gql`
    query ClientContractsListFilters_Suppliers($first: Int, $after: Cursor) {
  companies(first: $first, after: $after, filter: {companyType_oneOf: [Group]}) {
    ...NfsError
    ... on FSPResponseCompany {
      hasNextPage
      edges {
        cursor
        node {
          entityVersion
          id
          name
          logo
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useClientContractsListFiltersSuppliersQuery__
 *
 * To run a query within a React component, call `useClientContractsListFiltersSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientContractsListFiltersSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientContractsListFiltersSuppliersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useClientContractsListFiltersSuppliersQuery(baseOptions?: ApolloReact.QueryHookOptions<ClientContractsListFiltersSuppliersQuery, ClientContractsListFiltersSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ClientContractsListFiltersSuppliersDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ClientContractsListFiltersSuppliersQuery, ClientContractsListFiltersSuppliersQueryVariables>(ClientContractsListFiltersSuppliersDocument, parser(options)));
      }
export function useClientContractsListFiltersSuppliersLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ClientContractsListFiltersSuppliersQuery, ClientContractsListFiltersSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ClientContractsListFiltersSuppliersDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ClientContractsListFiltersSuppliersQuery, ClientContractsListFiltersSuppliersQueryVariables>(ClientContractsListFiltersSuppliersDocument, options));
        }

export type ClientContractsListFiltersSuppliersQueryResult = ApolloReact.QueryResult<ClientContractsListFiltersSuppliersQuery, ClientContractsListFiltersSuppliersQueryVariables>;
export function refetchClientContractsListFiltersSuppliersQuery(variables?: ClientContractsListFiltersSuppliersQueryVariables) {
      return { query: ClientContractsListFiltersSuppliersDocument, variables: variables }
    }
export const ClientInvoicingReportDrawerGenerateDocument = /*#__PURE__*/ gql`
    mutation ClientInvoicingReportDrawer_Generate($clientContractId: ClientContractId!, $period: ClosedEndLocalDateRangeInput!) {
  generateExportForInvoicingClients(
    clientContractId: $clientContractId
    period: $period
  ) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useClientInvoicingReportDrawerGenerateMutation__
 *
 * To run a mutation, you first call `useClientInvoicingReportDrawerGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientInvoicingReportDrawerGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientInvoicingReportDrawerGenerateMutation, { data, loading, error }] = useClientInvoicingReportDrawerGenerateMutation({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useClientInvoicingReportDrawerGenerateMutation(baseOptions?: ApolloReact.MutationHookOptions<ClientInvoicingReportDrawerGenerateMutation, ClientInvoicingReportDrawerGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ClientInvoicingReportDrawerGenerateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ClientInvoicingReportDrawerGenerateMutation, ClientInvoicingReportDrawerGenerateMutationVariables>(ClientInvoicingReportDrawerGenerateDocument, parser(options)));
      }
export type ClientInvoicingReportDrawerGenerateMutationHookResult = ReturnType<typeof useClientInvoicingReportDrawerGenerateMutation>;
export type ClientInvoicingReportDrawerGenerateMutationResult = ApolloReact.MutationResult<ClientInvoicingReportDrawerGenerateMutation>;
export type ClientInvoicingReportDrawerGenerateMutationOptions = Apollo.MutationOptions<ClientInvoicingReportDrawerGenerateMutation, ClientInvoicingReportDrawerGenerateMutationVariables>;
export const ClientInvoicingReportDrawerGoogleDocDocument = /*#__PURE__*/ gql`
    query ClientInvoicingReportDrawer_GoogleDoc($clientContractId: ClientContractId!, $period: ClosedEndLocalDateRangeInput!) {
  exportForInvoicingClients(clientContractId: $clientContractId, period: $period) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useClientInvoicingReportDrawerGoogleDocQuery__
 *
 * To run a query within a React component, call `useClientInvoicingReportDrawerGoogleDocQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientInvoicingReportDrawerGoogleDocQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientInvoicingReportDrawerGoogleDocQuery({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useClientInvoicingReportDrawerGoogleDocQuery(baseOptions: ApolloReact.QueryHookOptions<ClientInvoicingReportDrawerGoogleDocQuery, ClientInvoicingReportDrawerGoogleDocQueryVariables> & ({ variables: ClientInvoicingReportDrawerGoogleDocQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ClientInvoicingReportDrawerGoogleDocDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ClientInvoicingReportDrawerGoogleDocQuery, ClientInvoicingReportDrawerGoogleDocQueryVariables>(ClientInvoicingReportDrawerGoogleDocDocument, parser(options)));
      }
export function useClientInvoicingReportDrawerGoogleDocLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ClientInvoicingReportDrawerGoogleDocQuery, ClientInvoicingReportDrawerGoogleDocQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ClientInvoicingReportDrawerGoogleDocDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ClientInvoicingReportDrawerGoogleDocQuery, ClientInvoicingReportDrawerGoogleDocQueryVariables>(ClientInvoicingReportDrawerGoogleDocDocument, options));
        }

export type ClientInvoicingReportDrawerGoogleDocQueryResult = ApolloReact.QueryResult<ClientInvoicingReportDrawerGoogleDocQuery, ClientInvoicingReportDrawerGoogleDocQueryVariables>;
export function refetchClientInvoicingReportDrawerGoogleDocQuery(variables: ClientInvoicingReportDrawerGoogleDocQueryVariables) {
      return { query: ClientInvoicingReportDrawerGoogleDocDocument, variables: variables }
    }
export const ClientInvoicingReportFormReportingPeriodsDocument = /*#__PURE__*/ gql`
    query ClientInvoicingReportForm_ReportingPeriods($clientContractId: ClientContractId!) {
  reportingPeriods(clientContractId: $clientContractId) {
    ...NfsError
    ... on ListOfReportingPeriodResponse {
      value {
        id
        from
        to
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useClientInvoicingReportFormReportingPeriodsQuery__
 *
 * To run a query within a React component, call `useClientInvoicingReportFormReportingPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientInvoicingReportFormReportingPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientInvoicingReportFormReportingPeriodsQuery({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *   },
 * });
 */
export function useClientInvoicingReportFormReportingPeriodsQuery(baseOptions: ApolloReact.QueryHookOptions<ClientInvoicingReportFormReportingPeriodsQuery, ClientInvoicingReportFormReportingPeriodsQueryVariables> & ({ variables: ClientInvoicingReportFormReportingPeriodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ClientInvoicingReportFormReportingPeriodsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ClientInvoicingReportFormReportingPeriodsQuery, ClientInvoicingReportFormReportingPeriodsQueryVariables>(ClientInvoicingReportFormReportingPeriodsDocument, parser(options)));
      }
export function useClientInvoicingReportFormReportingPeriodsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ClientInvoicingReportFormReportingPeriodsQuery, ClientInvoicingReportFormReportingPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ClientInvoicingReportFormReportingPeriodsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ClientInvoicingReportFormReportingPeriodsQuery, ClientInvoicingReportFormReportingPeriodsQueryVariables>(ClientInvoicingReportFormReportingPeriodsDocument, options));
        }

export type ClientInvoicingReportFormReportingPeriodsQueryResult = ApolloReact.QueryResult<ClientInvoicingReportFormReportingPeriodsQuery, ClientInvoicingReportFormReportingPeriodsQueryVariables>;
export function refetchClientInvoicingReportFormReportingPeriodsQuery(variables: ClientInvoicingReportFormReportingPeriodsQueryVariables) {
      return { query: ClientInvoicingReportFormReportingPeriodsDocument, variables: variables }
    }
export const CompanyBankAccountsDataDocument = /*#__PURE__*/ gql`
    query CompanyBankAccounts_Data($companyId: CompanyId!) {
  company(id: $companyId) {
    ...NfsError
    ... on Company {
      id
      entityVersion
      companyType
      countryOfRegistration
      bankAccounts {
        ...BankAccount
      }
      defaultBankAccount {
        ...BankAccount
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankAccountFragmentDoc}`;

/**
 * __useCompanyBankAccountsDataQuery__
 *
 * To run a query within a React component, call `useCompanyBankAccountsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyBankAccountsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyBankAccountsDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyBankAccountsDataQuery(baseOptions: ApolloReact.QueryHookOptions<CompanyBankAccountsDataQuery, CompanyBankAccountsDataQueryVariables> & ({ variables: CompanyBankAccountsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyBankAccountsDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CompanyBankAccountsDataQuery, CompanyBankAccountsDataQueryVariables>(CompanyBankAccountsDataDocument, parser(options)));
      }
export function useCompanyBankAccountsDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CompanyBankAccountsDataQuery, CompanyBankAccountsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CompanyBankAccountsDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CompanyBankAccountsDataQuery, CompanyBankAccountsDataQueryVariables>(CompanyBankAccountsDataDocument, options));
        }

export type CompanyBankAccountsDataQueryResult = ApolloReact.QueryResult<CompanyBankAccountsDataQuery, CompanyBankAccountsDataQueryVariables>;
export function refetchCompanyBankAccountsDataQuery(variables: CompanyBankAccountsDataQueryVariables) {
      return { query: CompanyBankAccountsDataDocument, variables: variables }
    }
export const CompanyDetailsDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query CompanyDetailsDrawer_InitialData($companyId: CompanyId!) {
  company(id: $companyId) {
    ...NfsError
    ... on Company {
      id
      entityVersion
      companyType
      sectors {
        ...Unauthorized
        ... on AccessGranted__ListOfString {
          value
        }
      }
      countryOfRegistration
      taxNumber
      name
      address {
        ...Address
      }
      mailingAddress {
        ...Address
      }
      regon
      registerId
      logo
      ...CompanyDetailsDrawer_Vats
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AddressFragmentDoc}
${CompanyDetailsDrawerVatsFragmentDoc}`;

/**
 * __useCompanyDetailsDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useCompanyDetailsDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailsDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDetailsDrawerInitialDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyDetailsDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<CompanyDetailsDrawerInitialDataQuery, CompanyDetailsDrawerInitialDataQueryVariables> & ({ variables: CompanyDetailsDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyDetailsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CompanyDetailsDrawerInitialDataQuery, CompanyDetailsDrawerInitialDataQueryVariables>(CompanyDetailsDrawerInitialDataDocument, parser(options)));
      }
export function useCompanyDetailsDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CompanyDetailsDrawerInitialDataQuery, CompanyDetailsDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CompanyDetailsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CompanyDetailsDrawerInitialDataQuery, CompanyDetailsDrawerInitialDataQueryVariables>(CompanyDetailsDrawerInitialDataDocument, options));
        }

export type CompanyDetailsDrawerInitialDataQueryResult = ApolloReact.QueryResult<CompanyDetailsDrawerInitialDataQuery, CompanyDetailsDrawerInitialDataQueryVariables>;
export function refetchCompanyDetailsDrawerInitialDataQuery(variables: CompanyDetailsDrawerInitialDataQueryVariables) {
      return { query: CompanyDetailsDrawerInitialDataDocument, variables: variables }
    }
export const CompanyDetailsDrawerUploadLogoDocument = /*#__PURE__*/ gql`
    mutation CompanyDetailsDrawer_UploadLogo($companyId: CompanyId!, $entityVersion: EntityVersion!, $file: Upload!) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    uploadLogo(file: $file) {
      ...NfsError
      ... on Company {
        id
        entityVersion
        logo
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCompanyDetailsDrawerUploadLogoMutation__
 *
 * To run a mutation, you first call `useCompanyDetailsDrawerUploadLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailsDrawerUploadLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDetailsDrawerUploadLogoMutation, { data, loading, error }] = useCompanyDetailsDrawerUploadLogoMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCompanyDetailsDrawerUploadLogoMutation(baseOptions?: ApolloReact.MutationHookOptions<CompanyDetailsDrawerUploadLogoMutation, CompanyDetailsDrawerUploadLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyDetailsDrawerUploadLogoDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CompanyDetailsDrawerUploadLogoMutation, CompanyDetailsDrawerUploadLogoMutationVariables>(CompanyDetailsDrawerUploadLogoDocument, parser(options)));
      }
export type CompanyDetailsDrawerUploadLogoMutationHookResult = ReturnType<typeof useCompanyDetailsDrawerUploadLogoMutation>;
export type CompanyDetailsDrawerUploadLogoMutationResult = ApolloReact.MutationResult<CompanyDetailsDrawerUploadLogoMutation>;
export type CompanyDetailsDrawerUploadLogoMutationOptions = Apollo.MutationOptions<CompanyDetailsDrawerUploadLogoMutation, CompanyDetailsDrawerUploadLogoMutationVariables>;
export const CompanyDetailsDrawerDeleteLogoDocument = /*#__PURE__*/ gql`
    mutation CompanyDetailsDrawer_DeleteLogo($companyId: CompanyId!, $entityVersion: EntityVersion!) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    deleteLogo {
      ...NfsError
      ... on Company {
        id
        entityVersion
        logo
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCompanyDetailsDrawerDeleteLogoMutation__
 *
 * To run a mutation, you first call `useCompanyDetailsDrawerDeleteLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailsDrawerDeleteLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDetailsDrawerDeleteLogoMutation, { data, loading, error }] = useCompanyDetailsDrawerDeleteLogoMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useCompanyDetailsDrawerDeleteLogoMutation(baseOptions?: ApolloReact.MutationHookOptions<CompanyDetailsDrawerDeleteLogoMutation, CompanyDetailsDrawerDeleteLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyDetailsDrawerDeleteLogoDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CompanyDetailsDrawerDeleteLogoMutation, CompanyDetailsDrawerDeleteLogoMutationVariables>(CompanyDetailsDrawerDeleteLogoDocument, parser(options)));
      }
export type CompanyDetailsDrawerDeleteLogoMutationHookResult = ReturnType<typeof useCompanyDetailsDrawerDeleteLogoMutation>;
export type CompanyDetailsDrawerDeleteLogoMutationResult = ApolloReact.MutationResult<CompanyDetailsDrawerDeleteLogoMutation>;
export type CompanyDetailsDrawerDeleteLogoMutationOptions = Apollo.MutationOptions<CompanyDetailsDrawerDeleteLogoMutation, CompanyDetailsDrawerDeleteLogoMutationVariables>;
export const CompanyDetailsDrawerRegisterDetailsDocument = /*#__PURE__*/ gql`
    mutation CompanyDetailsDrawer_RegisterDetails($id: CompanyId!, $entityVersion: EntityVersion!, $name: String, $countryOfRegistration: CountryCode, $address: ClearableAddressInput, $mailingAddress: ClearableAddressInput) {
  company(companyId: $id, companyVersion: $entityVersion) {
    updateCompany(
      name: $name
      countryOfRegistration: $countryOfRegistration
      address: $address
      mailingAddress: $mailingAddress
    ) {
      ...NfsError
      ... on Company {
        id
        entityVersion
        name
        countryOfRegistration
        address {
          ...Address
        }
        mailingAddress {
          ...Address
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AddressFragmentDoc}`;


/**
 * __useCompanyDetailsDrawerRegisterDetailsMutation__
 *
 * To run a mutation, you first call `useCompanyDetailsDrawerRegisterDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailsDrawerRegisterDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDetailsDrawerRegisterDetailsMutation, { data, loading, error }] = useCompanyDetailsDrawerRegisterDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityVersion: // value for 'entityVersion'
 *      name: // value for 'name'
 *      countryOfRegistration: // value for 'countryOfRegistration'
 *      address: // value for 'address'
 *      mailingAddress: // value for 'mailingAddress'
 *   },
 * });
 */
export function useCompanyDetailsDrawerRegisterDetailsMutation(baseOptions?: ApolloReact.MutationHookOptions<CompanyDetailsDrawerRegisterDetailsMutation, CompanyDetailsDrawerRegisterDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyDetailsDrawerRegisterDetailsDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CompanyDetailsDrawerRegisterDetailsMutation, CompanyDetailsDrawerRegisterDetailsMutationVariables>(CompanyDetailsDrawerRegisterDetailsDocument, parser(options)));
      }
export type CompanyDetailsDrawerRegisterDetailsMutationHookResult = ReturnType<typeof useCompanyDetailsDrawerRegisterDetailsMutation>;
export type CompanyDetailsDrawerRegisterDetailsMutationResult = ApolloReact.MutationResult<CompanyDetailsDrawerRegisterDetailsMutation>;
export type CompanyDetailsDrawerRegisterDetailsMutationOptions = Apollo.MutationOptions<CompanyDetailsDrawerRegisterDetailsMutation, CompanyDetailsDrawerRegisterDetailsMutationVariables>;
export const CompanyDetailsDrawerVatTaxDocument = /*#__PURE__*/ gql`
    mutation CompanyDetailsDrawer_VatTax($companyId: CompanyId!, $entityVersion: EntityVersion!, $euVatType: TimeBasedValueEuVatTypeInput, $isPolishVat: TimeBasedValueBooleanInput, $isOtherVatType: TimeBasedValueBooleanInput) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    updateCompany(
      euVatType: $euVatType
      isPolishVat: $isPolishVat
      isOtherVatType: $isOtherVatType
    ) {
      ...NfsError
      ... on Company {
        ...CompanyDetailsDrawer_Vats
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CompanyDetailsDrawerVatsFragmentDoc}`;


/**
 * __useCompanyDetailsDrawerVatTaxMutation__
 *
 * To run a mutation, you first call `useCompanyDetailsDrawerVatTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailsDrawerVatTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDetailsDrawerVatTaxMutation, { data, loading, error }] = useCompanyDetailsDrawerVatTaxMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *      euVatType: // value for 'euVatType'
 *      isPolishVat: // value for 'isPolishVat'
 *      isOtherVatType: // value for 'isOtherVatType'
 *   },
 * });
 */
export function useCompanyDetailsDrawerVatTaxMutation(baseOptions?: ApolloReact.MutationHookOptions<CompanyDetailsDrawerVatTaxMutation, CompanyDetailsDrawerVatTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyDetailsDrawerVatTaxDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CompanyDetailsDrawerVatTaxMutation, CompanyDetailsDrawerVatTaxMutationVariables>(CompanyDetailsDrawerVatTaxDocument, parser(options)));
      }
export type CompanyDetailsDrawerVatTaxMutationHookResult = ReturnType<typeof useCompanyDetailsDrawerVatTaxMutation>;
export type CompanyDetailsDrawerVatTaxMutationResult = ApolloReact.MutationResult<CompanyDetailsDrawerVatTaxMutation>;
export type CompanyDetailsDrawerVatTaxMutationOptions = Apollo.MutationOptions<CompanyDetailsDrawerVatTaxMutation, CompanyDetailsDrawerVatTaxMutationVariables>;
export const CompanyDetailsDrawerCompanyTypeDocument = /*#__PURE__*/ gql`
    mutation CompanyDetailsDrawer_CompanyType($companyId: CompanyId!, $entityVersion: EntityVersion!, $companyType: [CompanyType!]!, $sectors: [String!]) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    updateCompany(companyType: $companyType, sectors: $sectors) {
      ...NfsError
      ... on Company {
        id
        entityVersion
        companyType
        sectors {
          ...Unauthorized
          ... on AccessGranted__ListOfString {
            value
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;


/**
 * __useCompanyDetailsDrawerCompanyTypeMutation__
 *
 * To run a mutation, you first call `useCompanyDetailsDrawerCompanyTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailsDrawerCompanyTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDetailsDrawerCompanyTypeMutation, { data, loading, error }] = useCompanyDetailsDrawerCompanyTypeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *      companyType: // value for 'companyType'
 *      sectors: // value for 'sectors'
 *   },
 * });
 */
export function useCompanyDetailsDrawerCompanyTypeMutation(baseOptions?: ApolloReact.MutationHookOptions<CompanyDetailsDrawerCompanyTypeMutation, CompanyDetailsDrawerCompanyTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyDetailsDrawerCompanyTypeDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CompanyDetailsDrawerCompanyTypeMutation, CompanyDetailsDrawerCompanyTypeMutationVariables>(CompanyDetailsDrawerCompanyTypeDocument, parser(options)));
      }
export type CompanyDetailsDrawerCompanyTypeMutationHookResult = ReturnType<typeof useCompanyDetailsDrawerCompanyTypeMutation>;
export type CompanyDetailsDrawerCompanyTypeMutationResult = ApolloReact.MutationResult<CompanyDetailsDrawerCompanyTypeMutation>;
export type CompanyDetailsDrawerCompanyTypeMutationOptions = Apollo.MutationOptions<CompanyDetailsDrawerCompanyTypeMutation, CompanyDetailsDrawerCompanyTypeMutationVariables>;
export const CompanyEditBankAccountsFormUpdateDocument = /*#__PURE__*/ gql`
    mutation CompanyEditBankAccountsForm_Update($companyId: CompanyId!, $entityVersion: EntityVersion!, $bankAccount: BankAccountInput!, $setAsDefault: Boolean) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    upsertBankAccount(bankAccount: $bankAccount, setAsDefault: $setAsDefault) {
      ...NfsError
      ... on BankAccountResponse {
        company {
          id
          entityVersion
          defaultBankAccount {
            accountNumber {
              ...BankAccountNumber
            }
          }
        }
        bankAccount {
          ...BankAccount
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankAccountNumberFragmentDoc}
${BankAccountFragmentDoc}`;


/**
 * __useCompanyEditBankAccountsFormUpdateMutation__
 *
 * To run a mutation, you first call `useCompanyEditBankAccountsFormUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyEditBankAccountsFormUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyEditBankAccountsFormUpdateMutation, { data, loading, error }] = useCompanyEditBankAccountsFormUpdateMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *      bankAccount: // value for 'bankAccount'
 *      setAsDefault: // value for 'setAsDefault'
 *   },
 * });
 */
export function useCompanyEditBankAccountsFormUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<CompanyEditBankAccountsFormUpdateMutation, CompanyEditBankAccountsFormUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyEditBankAccountsFormUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CompanyEditBankAccountsFormUpdateMutation, CompanyEditBankAccountsFormUpdateMutationVariables>(CompanyEditBankAccountsFormUpdateDocument, parser(options)));
      }
export type CompanyEditBankAccountsFormUpdateMutationHookResult = ReturnType<typeof useCompanyEditBankAccountsFormUpdateMutation>;
export type CompanyEditBankAccountsFormUpdateMutationResult = ApolloReact.MutationResult<CompanyEditBankAccountsFormUpdateMutation>;
export type CompanyEditBankAccountsFormUpdateMutationOptions = Apollo.MutationOptions<CompanyEditBankAccountsFormUpdateMutation, CompanyEditBankAccountsFormUpdateMutationVariables>;
export const CompanyEditBankAccountsFormDeleteDocument = /*#__PURE__*/ gql`
    mutation CompanyEditBankAccountsForm_Delete($companyId: CompanyId!, $entityVersion: EntityVersion!, $bankAccountNumber: BankAccountNumberInput!) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    deleteBankAccount(bankAccountNumber: $bankAccountNumber) {
      ...NfsError
      ... on BankAccountResponse {
        company {
          id
          entityVersion
        }
        bankAccount {
          ...BankAccount
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankAccountFragmentDoc}`;


/**
 * __useCompanyEditBankAccountsFormDeleteMutation__
 *
 * To run a mutation, you first call `useCompanyEditBankAccountsFormDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyEditBankAccountsFormDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyEditBankAccountsFormDeleteMutation, { data, loading, error }] = useCompanyEditBankAccountsFormDeleteMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *      bankAccountNumber: // value for 'bankAccountNumber'
 *   },
 * });
 */
export function useCompanyEditBankAccountsFormDeleteMutation(baseOptions?: ApolloReact.MutationHookOptions<CompanyEditBankAccountsFormDeleteMutation, CompanyEditBankAccountsFormDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyEditBankAccountsFormDeleteDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CompanyEditBankAccountsFormDeleteMutation, CompanyEditBankAccountsFormDeleteMutationVariables>(CompanyEditBankAccountsFormDeleteDocument, parser(options)));
      }
export type CompanyEditBankAccountsFormDeleteMutationHookResult = ReturnType<typeof useCompanyEditBankAccountsFormDeleteMutation>;
export type CompanyEditBankAccountsFormDeleteMutationResult = ApolloReact.MutationResult<CompanyEditBankAccountsFormDeleteMutation>;
export type CompanyEditBankAccountsFormDeleteMutationOptions = Apollo.MutationOptions<CompanyEditBankAccountsFormDeleteMutation, CompanyEditBankAccountsFormDeleteMutationVariables>;
export const CompanyEditBankAccountsFormCheckWhiteListDocument = /*#__PURE__*/ gql`
    mutation CompanyEditBankAccountsForm_CheckWhiteList($companyId: CompanyId!, $entityVersion: EntityVersion!) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    refreshAllBankAccounts {
      ...NfsError
      ... on Company {
        id
        entityVersion
        bankAccounts {
          ...BankAccount
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankAccountFragmentDoc}`;


/**
 * __useCompanyEditBankAccountsFormCheckWhiteListMutation__
 *
 * To run a mutation, you first call `useCompanyEditBankAccountsFormCheckWhiteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyEditBankAccountsFormCheckWhiteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyEditBankAccountsFormCheckWhiteListMutation, { data, loading, error }] = useCompanyEditBankAccountsFormCheckWhiteListMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useCompanyEditBankAccountsFormCheckWhiteListMutation(baseOptions?: ApolloReact.MutationHookOptions<CompanyEditBankAccountsFormCheckWhiteListMutation, CompanyEditBankAccountsFormCheckWhiteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyEditBankAccountsFormCheckWhiteListDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CompanyEditBankAccountsFormCheckWhiteListMutation, CompanyEditBankAccountsFormCheckWhiteListMutationVariables>(CompanyEditBankAccountsFormCheckWhiteListDocument, parser(options)));
      }
export type CompanyEditBankAccountsFormCheckWhiteListMutationHookResult = ReturnType<typeof useCompanyEditBankAccountsFormCheckWhiteListMutation>;
export type CompanyEditBankAccountsFormCheckWhiteListMutationResult = ApolloReact.MutationResult<CompanyEditBankAccountsFormCheckWhiteListMutation>;
export type CompanyEditBankAccountsFormCheckWhiteListMutationOptions = Apollo.MutationOptions<CompanyEditBankAccountsFormCheckWhiteListMutation, CompanyEditBankAccountsFormCheckWhiteListMutationVariables>;
export const CompanyEditBankAccountsFormRefreshStatusesDocument = /*#__PURE__*/ gql`
    mutation CompanyEditBankAccountsForm_RefreshStatuses($companyId: CompanyId!, $entityVersion: EntityVersion!, $bankAccountNumbers: [BankAccountNumberInput!]!) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    refreshBankAccounts(bankAccountNumbers: $bankAccountNumbers) {
      ...NfsError
      ... on BankAccountsResponse {
        bankAccounts {
          ...BankAccount
        }
        company {
          id
          entityVersion
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankAccountFragmentDoc}`;


/**
 * __useCompanyEditBankAccountsFormRefreshStatusesMutation__
 *
 * To run a mutation, you first call `useCompanyEditBankAccountsFormRefreshStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyEditBankAccountsFormRefreshStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyEditBankAccountsFormRefreshStatusesMutation, { data, loading, error }] = useCompanyEditBankAccountsFormRefreshStatusesMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *      bankAccountNumbers: // value for 'bankAccountNumbers'
 *   },
 * });
 */
export function useCompanyEditBankAccountsFormRefreshStatusesMutation(baseOptions?: ApolloReact.MutationHookOptions<CompanyEditBankAccountsFormRefreshStatusesMutation, CompanyEditBankAccountsFormRefreshStatusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyEditBankAccountsFormRefreshStatusesDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CompanyEditBankAccountsFormRefreshStatusesMutation, CompanyEditBankAccountsFormRefreshStatusesMutationVariables>(CompanyEditBankAccountsFormRefreshStatusesDocument, parser(options)));
      }
export type CompanyEditBankAccountsFormRefreshStatusesMutationHookResult = ReturnType<typeof useCompanyEditBankAccountsFormRefreshStatusesMutation>;
export type CompanyEditBankAccountsFormRefreshStatusesMutationResult = ApolloReact.MutationResult<CompanyEditBankAccountsFormRefreshStatusesMutation>;
export type CompanyEditBankAccountsFormRefreshStatusesMutationOptions = Apollo.MutationOptions<CompanyEditBankAccountsFormRefreshStatusesMutation, CompanyEditBankAccountsFormRefreshStatusesMutationVariables>;
export const CompanyGeneralInfoDataDocument = /*#__PURE__*/ gql`
    query CompanyGeneralInfo_Data($companyId: CompanyId!) {
  company(id: $companyId) {
    ...NfsError
    ... on Company {
      id
      entityVersion
      companyType
      sectors {
        ...Unauthorized
        ... on AccessGranted__ListOfString {
          value
        }
      }
      countryOfRegistration
      taxNumber
      name
      address {
        ...Address
      }
      mailingAddress {
        ...Address
      }
      regon
      registerId
      isPolishVat {
        value {
          value
          state {
            ... on VerifiedWithDescriptionBooleanVATStatus {
              result
              when
            }
          }
        }
      }
      euVatType {
        value {
          value
          state {
            ... on VerifiedEuVatType {
              result
              when
            }
          }
        }
      }
      isOtherVatType {
        value
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useCompanyGeneralInfoDataQuery__
 *
 * To run a query within a React component, call `useCompanyGeneralInfoDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyGeneralInfoDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyGeneralInfoDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyGeneralInfoDataQuery(baseOptions: ApolloReact.QueryHookOptions<CompanyGeneralInfoDataQuery, CompanyGeneralInfoDataQueryVariables> & ({ variables: CompanyGeneralInfoDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyGeneralInfoDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CompanyGeneralInfoDataQuery, CompanyGeneralInfoDataQueryVariables>(CompanyGeneralInfoDataDocument, parser(options)));
      }
export function useCompanyGeneralInfoDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CompanyGeneralInfoDataQuery, CompanyGeneralInfoDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CompanyGeneralInfoDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CompanyGeneralInfoDataQuery, CompanyGeneralInfoDataQueryVariables>(CompanyGeneralInfoDataDocument, options));
        }

export type CompanyGeneralInfoDataQueryResult = ApolloReact.QueryResult<CompanyGeneralInfoDataQuery, CompanyGeneralInfoDataQueryVariables>;
export function refetchCompanyGeneralInfoDataQuery(variables: CompanyGeneralInfoDataQueryVariables) {
      return { query: CompanyGeneralInfoDataDocument, variables: variables }
    }
export const CompanyRegisterDetailsFormRegisterDataDocument = /*#__PURE__*/ gql`
    query CompanyRegisterDetailsForm_RegisterData($name: String, $countryCode: CountryCode, $taxNumber: TaxNumber!) {
  companyInfo(name: $name, countryCode: $countryCode, taxNumber: $taxNumber) {
    ...NfsError
    ... on CompanyInfo {
      baseInfo {
        ...NfsError
        ... on BaseInfo {
          name
          taxNumber
          regon
          registerId
          address {
            ...Address
          }
          mailingAddress {
            ...Address
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useCompanyRegisterDetailsFormRegisterDataQuery__
 *
 * To run a query within a React component, call `useCompanyRegisterDetailsFormRegisterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyRegisterDetailsFormRegisterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyRegisterDetailsFormRegisterDataQuery({
 *   variables: {
 *      name: // value for 'name'
 *      countryCode: // value for 'countryCode'
 *      taxNumber: // value for 'taxNumber'
 *   },
 * });
 */
export function useCompanyRegisterDetailsFormRegisterDataQuery(baseOptions: ApolloReact.QueryHookOptions<CompanyRegisterDetailsFormRegisterDataQuery, CompanyRegisterDetailsFormRegisterDataQueryVariables> & ({ variables: CompanyRegisterDetailsFormRegisterDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyRegisterDetailsFormRegisterDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CompanyRegisterDetailsFormRegisterDataQuery, CompanyRegisterDetailsFormRegisterDataQueryVariables>(CompanyRegisterDetailsFormRegisterDataDocument, parser(options)));
      }
export function useCompanyRegisterDetailsFormRegisterDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CompanyRegisterDetailsFormRegisterDataQuery, CompanyRegisterDetailsFormRegisterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CompanyRegisterDetailsFormRegisterDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CompanyRegisterDetailsFormRegisterDataQuery, CompanyRegisterDetailsFormRegisterDataQueryVariables>(CompanyRegisterDetailsFormRegisterDataDocument, options));
        }

export type CompanyRegisterDetailsFormRegisterDataQueryResult = ApolloReact.QueryResult<CompanyRegisterDetailsFormRegisterDataQuery, CompanyRegisterDetailsFormRegisterDataQueryVariables>;
export function refetchCompanyRegisterDetailsFormRegisterDataQuery(variables: CompanyRegisterDetailsFormRegisterDataQueryVariables) {
      return { query: CompanyRegisterDetailsFormRegisterDataDocument, variables: variables }
    }
export const CompanyVatFormVerifyPolishVatsDocument = /*#__PURE__*/ gql`
    mutation CompanyVatForm_VerifyPolishVats($companyId: CompanyId!, $entityVersion: EntityVersion!) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    verifyPolishVat {
      ...NfsError
      ... on Company {
        ...CompanyDetailsDrawer_Company
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CompanyDetailsDrawerCompanyFragmentDoc}`;


/**
 * __useCompanyVatFormVerifyPolishVatsMutation__
 *
 * To run a mutation, you first call `useCompanyVatFormVerifyPolishVatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyVatFormVerifyPolishVatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyVatFormVerifyPolishVatsMutation, { data, loading, error }] = useCompanyVatFormVerifyPolishVatsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useCompanyVatFormVerifyPolishVatsMutation(baseOptions?: ApolloReact.MutationHookOptions<CompanyVatFormVerifyPolishVatsMutation, CompanyVatFormVerifyPolishVatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyVatFormVerifyPolishVatsDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CompanyVatFormVerifyPolishVatsMutation, CompanyVatFormVerifyPolishVatsMutationVariables>(CompanyVatFormVerifyPolishVatsDocument, parser(options)));
      }
export type CompanyVatFormVerifyPolishVatsMutationHookResult = ReturnType<typeof useCompanyVatFormVerifyPolishVatsMutation>;
export type CompanyVatFormVerifyPolishVatsMutationResult = ApolloReact.MutationResult<CompanyVatFormVerifyPolishVatsMutation>;
export type CompanyVatFormVerifyPolishVatsMutationOptions = Apollo.MutationOptions<CompanyVatFormVerifyPolishVatsMutation, CompanyVatFormVerifyPolishVatsMutationVariables>;
export const CompanyVatFormVerifyEuVatDocument = /*#__PURE__*/ gql`
    mutation CompanyVatForm_VerifyEuVat($companyId: CompanyId!, $entityVersion: EntityVersion!) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    verifyEuVat {
      ...NfsError
      ... on Company {
        ...CompanyDetailsDrawer_Company
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CompanyDetailsDrawerCompanyFragmentDoc}`;


/**
 * __useCompanyVatFormVerifyEuVatMutation__
 *
 * To run a mutation, you first call `useCompanyVatFormVerifyEuVatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyVatFormVerifyEuVatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyVatFormVerifyEuVatMutation, { data, loading, error }] = useCompanyVatFormVerifyEuVatMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useCompanyVatFormVerifyEuVatMutation(baseOptions?: ApolloReact.MutationHookOptions<CompanyVatFormVerifyEuVatMutation, CompanyVatFormVerifyEuVatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyVatFormVerifyEuVatDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CompanyVatFormVerifyEuVatMutation, CompanyVatFormVerifyEuVatMutationVariables>(CompanyVatFormVerifyEuVatDocument, parser(options)));
      }
export type CompanyVatFormVerifyEuVatMutationHookResult = ReturnType<typeof useCompanyVatFormVerifyEuVatMutation>;
export type CompanyVatFormVerifyEuVatMutationResult = ApolloReact.MutationResult<CompanyVatFormVerifyEuVatMutation>;
export type CompanyVatFormVerifyEuVatMutationOptions = Apollo.MutationOptions<CompanyVatFormVerifyEuVatMutation, CompanyVatFormVerifyEuVatMutationVariables>;
export const ContractAnnouncementsExtendEndDateEmploymentDocument = /*#__PURE__*/ gql`
    mutation ContractAnnouncements_ExtendEndDateEmployment($contractId: ContractId!, $entityVersion: EntityVersion!, $expectedEndDate: ClearableLocalDateInput) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(expectedEndDate: $expectedEndDate) {
      ...NfsError
      ... on EmploymentContract {
        id
        entityVersion
        expectedEndDate
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useContractAnnouncementsExtendEndDateEmploymentMutation__
 *
 * To run a mutation, you first call `useContractAnnouncementsExtendEndDateEmploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractAnnouncementsExtendEndDateEmploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractAnnouncementsExtendEndDateEmploymentMutation, { data, loading, error }] = useContractAnnouncementsExtendEndDateEmploymentMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      expectedEndDate: // value for 'expectedEndDate'
 *   },
 * });
 */
export function useContractAnnouncementsExtendEndDateEmploymentMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractAnnouncementsExtendEndDateEmploymentMutation, ContractAnnouncementsExtendEndDateEmploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractAnnouncementsExtendEndDateEmploymentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractAnnouncementsExtendEndDateEmploymentMutation, ContractAnnouncementsExtendEndDateEmploymentMutationVariables>(ContractAnnouncementsExtendEndDateEmploymentDocument, parser(options)));
      }
export type ContractAnnouncementsExtendEndDateEmploymentMutationHookResult = ReturnType<typeof useContractAnnouncementsExtendEndDateEmploymentMutation>;
export type ContractAnnouncementsExtendEndDateEmploymentMutationResult = ApolloReact.MutationResult<ContractAnnouncementsExtendEndDateEmploymentMutation>;
export type ContractAnnouncementsExtendEndDateEmploymentMutationOptions = Apollo.MutationOptions<ContractAnnouncementsExtendEndDateEmploymentMutation, ContractAnnouncementsExtendEndDateEmploymentMutationVariables>;
export const ContractAnnouncementsExtendEndDateB2BDocument = /*#__PURE__*/ gql`
    mutation ContractAnnouncements_ExtendEndDateB2B($contractId: ContractId!, $entityVersion: EntityVersion!, $expectedEndDate: ClearableLocalDateInput) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateB2BContract(expectedEndDate: $expectedEndDate) {
      ...NfsError
      ... on B2BContract {
        id
        entityVersion
        expectedEndDate
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useContractAnnouncementsExtendEndDateB2BMutation__
 *
 * To run a mutation, you first call `useContractAnnouncementsExtendEndDateB2BMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractAnnouncementsExtendEndDateB2BMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractAnnouncementsExtendEndDateB2BMutation, { data, loading, error }] = useContractAnnouncementsExtendEndDateB2BMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      expectedEndDate: // value for 'expectedEndDate'
 *   },
 * });
 */
export function useContractAnnouncementsExtendEndDateB2BMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractAnnouncementsExtendEndDateB2BMutation, ContractAnnouncementsExtendEndDateB2BMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractAnnouncementsExtendEndDateB2BDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractAnnouncementsExtendEndDateB2BMutation, ContractAnnouncementsExtendEndDateB2BMutationVariables>(ContractAnnouncementsExtendEndDateB2BDocument, parser(options)));
      }
export type ContractAnnouncementsExtendEndDateB2BMutationHookResult = ReturnType<typeof useContractAnnouncementsExtendEndDateB2BMutation>;
export type ContractAnnouncementsExtendEndDateB2BMutationResult = ApolloReact.MutationResult<ContractAnnouncementsExtendEndDateB2BMutation>;
export type ContractAnnouncementsExtendEndDateB2BMutationOptions = Apollo.MutationOptions<ContractAnnouncementsExtendEndDateB2BMutation, ContractAnnouncementsExtendEndDateB2BMutationVariables>;
export const ContractBankAccountDocument = /*#__PURE__*/ gql`
    query ContractBankAccount($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        terminationDate
        promisorTransferBankAccount {
          value {
            ...BankAccount
          }
        }
        promisee {
          id
          entityVersion
        }
        promisor {
          value {
            id
            entityVersion
            companyType
            defaultBankAccount {
              accountNumber {
                ...BankAccountNumber
              }
            }
            bankAccounts {
              accountNumber {
                ...BankAccountNumber
              }
            }
            address {
              ...Address
            }
          }
        }
        ... on B2BContract {
          promiseeCompany {
            ...Unauthorized
            ... on AccessGranted__Company {
              value {
                id
                entityVersion
                companyType
                defaultBankAccount {
                  accountNumber {
                    ...BankAccountNumber
                  }
                }
                bankAccounts {
                  ...BankAccount
                }
                address {
                  ...Address
                }
              }
            }
          }
          promiseeCompanyTransferBankAccount {
            ...Unauthorized
            ... on AccessGranted__OptionalBankAccount {
              value {
                ...BankAccount
              }
            }
          }
        }
        ... on EmploymentContract {
          promiseeTransferBankAccount {
            ...Unauthorized
            ... on AccessGranted__BankAccount {
              value {
                ...BankAccount
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankAccountFragmentDoc}
${BankAccountNumberFragmentDoc}
${AddressFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useContractBankAccountQuery__
 *
 * To run a query within a React component, call `useContractBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractBankAccountQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractBankAccountQuery(baseOptions: ApolloReact.QueryHookOptions<ContractBankAccountQuery, ContractBankAccountQueryVariables> & ({ variables: ContractBankAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractBankAccountQuery, ContractBankAccountQueryVariables>(ContractBankAccountDocument, parser(options)));
      }
export function useContractBankAccountLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractBankAccountQuery, ContractBankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractBankAccountDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractBankAccountQuery, ContractBankAccountQueryVariables>(ContractBankAccountDocument, options));
        }

export type ContractBankAccountQueryResult = ApolloReact.QueryResult<ContractBankAccountQuery, ContractBankAccountQueryVariables>;
export function refetchContractBankAccountQuery(variables: ContractBankAccountQueryVariables) {
      return { query: ContractBankAccountDocument, variables: variables }
    }
export const ContractBankAccountDrawerContractInputPromisorDocument = /*#__PURE__*/ gql`
    query ContractBankAccountDrawer_ContractInputPromisor($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        ...ContractBankAccountDrawer_ContractFieldsPromisor
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractBankAccountDrawerContractFieldsPromisorFragmentDoc}`;

/**
 * __useContractBankAccountDrawerContractInputPromisorQuery__
 *
 * To run a query within a React component, call `useContractBankAccountDrawerContractInputPromisorQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountDrawerContractInputPromisorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractBankAccountDrawerContractInputPromisorQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractBankAccountDrawerContractInputPromisorQuery(baseOptions: ApolloReact.QueryHookOptions<ContractBankAccountDrawerContractInputPromisorQuery, ContractBankAccountDrawerContractInputPromisorQueryVariables> & ({ variables: ContractBankAccountDrawerContractInputPromisorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerContractInputPromisorDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractBankAccountDrawerContractInputPromisorQuery, ContractBankAccountDrawerContractInputPromisorQueryVariables>(ContractBankAccountDrawerContractInputPromisorDocument, parser(options)));
      }
export function useContractBankAccountDrawerContractInputPromisorLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractBankAccountDrawerContractInputPromisorQuery, ContractBankAccountDrawerContractInputPromisorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerContractInputPromisorDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractBankAccountDrawerContractInputPromisorQuery, ContractBankAccountDrawerContractInputPromisorQueryVariables>(ContractBankAccountDrawerContractInputPromisorDocument, options));
        }

export type ContractBankAccountDrawerContractInputPromisorQueryResult = ApolloReact.QueryResult<ContractBankAccountDrawerContractInputPromisorQuery, ContractBankAccountDrawerContractInputPromisorQueryVariables>;
export function refetchContractBankAccountDrawerContractInputPromisorQuery(variables: ContractBankAccountDrawerContractInputPromisorQueryVariables) {
      return { query: ContractBankAccountDrawerContractInputPromisorDocument, variables: variables }
    }
export const ContractBankAccountDrawerContractInputPromiseeDocument = /*#__PURE__*/ gql`
    query ContractBankAccountDrawer_ContractInputPromisee($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        ...ContractBankAccountDrawer_ContractFieldsPromisee
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractBankAccountDrawerContractFieldsPromiseeFragmentDoc}`;

/**
 * __useContractBankAccountDrawerContractInputPromiseeQuery__
 *
 * To run a query within a React component, call `useContractBankAccountDrawerContractInputPromiseeQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountDrawerContractInputPromiseeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractBankAccountDrawerContractInputPromiseeQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractBankAccountDrawerContractInputPromiseeQuery(baseOptions: ApolloReact.QueryHookOptions<ContractBankAccountDrawerContractInputPromiseeQuery, ContractBankAccountDrawerContractInputPromiseeQueryVariables> & ({ variables: ContractBankAccountDrawerContractInputPromiseeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerContractInputPromiseeDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractBankAccountDrawerContractInputPromiseeQuery, ContractBankAccountDrawerContractInputPromiseeQueryVariables>(ContractBankAccountDrawerContractInputPromiseeDocument, parser(options)));
      }
export function useContractBankAccountDrawerContractInputPromiseeLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractBankAccountDrawerContractInputPromiseeQuery, ContractBankAccountDrawerContractInputPromiseeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerContractInputPromiseeDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractBankAccountDrawerContractInputPromiseeQuery, ContractBankAccountDrawerContractInputPromiseeQueryVariables>(ContractBankAccountDrawerContractInputPromiseeDocument, options));
        }

export type ContractBankAccountDrawerContractInputPromiseeQueryResult = ApolloReact.QueryResult<ContractBankAccountDrawerContractInputPromiseeQuery, ContractBankAccountDrawerContractInputPromiseeQueryVariables>;
export function refetchContractBankAccountDrawerContractInputPromiseeQuery(variables: ContractBankAccountDrawerContractInputPromiseeQueryVariables) {
      return { query: ContractBankAccountDrawerContractInputPromiseeDocument, variables: variables }
    }
export const ContractBankAccountDrawerDraftInputPromisorDocument = /*#__PURE__*/ gql`
    query ContractBankAccountDrawer_DraftInputPromisor($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            ...ContractBankAccountDrawer_DraftContractFieldsPromisor
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${ContractBankAccountDrawerDraftContractFieldsPromisorFragmentDoc}`;

/**
 * __useContractBankAccountDrawerDraftInputPromisorQuery__
 *
 * To run a query within a React component, call `useContractBankAccountDrawerDraftInputPromisorQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountDrawerDraftInputPromisorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractBankAccountDrawerDraftInputPromisorQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useContractBankAccountDrawerDraftInputPromisorQuery(baseOptions: ApolloReact.QueryHookOptions<ContractBankAccountDrawerDraftInputPromisorQuery, ContractBankAccountDrawerDraftInputPromisorQueryVariables> & ({ variables: ContractBankAccountDrawerDraftInputPromisorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerDraftInputPromisorDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractBankAccountDrawerDraftInputPromisorQuery, ContractBankAccountDrawerDraftInputPromisorQueryVariables>(ContractBankAccountDrawerDraftInputPromisorDocument, parser(options)));
      }
export function useContractBankAccountDrawerDraftInputPromisorLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractBankAccountDrawerDraftInputPromisorQuery, ContractBankAccountDrawerDraftInputPromisorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerDraftInputPromisorDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractBankAccountDrawerDraftInputPromisorQuery, ContractBankAccountDrawerDraftInputPromisorQueryVariables>(ContractBankAccountDrawerDraftInputPromisorDocument, options));
        }

export type ContractBankAccountDrawerDraftInputPromisorQueryResult = ApolloReact.QueryResult<ContractBankAccountDrawerDraftInputPromisorQuery, ContractBankAccountDrawerDraftInputPromisorQueryVariables>;
export function refetchContractBankAccountDrawerDraftInputPromisorQuery(variables: ContractBankAccountDrawerDraftInputPromisorQueryVariables) {
      return { query: ContractBankAccountDrawerDraftInputPromisorDocument, variables: variables }
    }
export const ContractBankAccountDrawerDraftInputPromiseeDocument = /*#__PURE__*/ gql`
    query ContractBankAccountDrawer_DraftInputPromisee($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            ...ContractBankAccountDrawer_DraftContractFieldsPromisee
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${ContractBankAccountDrawerDraftContractFieldsPromiseeFragmentDoc}`;

/**
 * __useContractBankAccountDrawerDraftInputPromiseeQuery__
 *
 * To run a query within a React component, call `useContractBankAccountDrawerDraftInputPromiseeQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountDrawerDraftInputPromiseeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractBankAccountDrawerDraftInputPromiseeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useContractBankAccountDrawerDraftInputPromiseeQuery(baseOptions: ApolloReact.QueryHookOptions<ContractBankAccountDrawerDraftInputPromiseeQuery, ContractBankAccountDrawerDraftInputPromiseeQueryVariables> & ({ variables: ContractBankAccountDrawerDraftInputPromiseeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerDraftInputPromiseeDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractBankAccountDrawerDraftInputPromiseeQuery, ContractBankAccountDrawerDraftInputPromiseeQueryVariables>(ContractBankAccountDrawerDraftInputPromiseeDocument, parser(options)));
      }
export function useContractBankAccountDrawerDraftInputPromiseeLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractBankAccountDrawerDraftInputPromiseeQuery, ContractBankAccountDrawerDraftInputPromiseeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerDraftInputPromiseeDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractBankAccountDrawerDraftInputPromiseeQuery, ContractBankAccountDrawerDraftInputPromiseeQueryVariables>(ContractBankAccountDrawerDraftInputPromiseeDocument, options));
        }

export type ContractBankAccountDrawerDraftInputPromiseeQueryResult = ApolloReact.QueryResult<ContractBankAccountDrawerDraftInputPromiseeQuery, ContractBankAccountDrawerDraftInputPromiseeQueryVariables>;
export function refetchContractBankAccountDrawerDraftInputPromiseeQuery(variables: ContractBankAccountDrawerDraftInputPromiseeQueryVariables) {
      return { query: ContractBankAccountDrawerDraftInputPromiseeDocument, variables: variables }
    }
export const ContractBankAccountDrawerUpdateB2BDraftPromisorDocument = /*#__PURE__*/ gql`
    mutation ContractBankAccountDrawer_UpdateB2BDraftPromisor($userId: UserId!, $userEntityVersion: EntityVersion!, $entityVersion: EntityVersion!, $overwrittenPromisorTransferBankAccountNumber: ClearableBankAccountNumberInput!) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateB2bDraft(
        overwrittenPromisorTransferBankAccountNumber: $overwrittenPromisorTransferBankAccountNumber
      ) {
        ...NfsError
        ... on B2BContractDraft {
          ...ContractBankAccountDrawer_DraftContractFieldsPromisor
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractBankAccountDrawerDraftContractFieldsPromisorFragmentDoc}`;


/**
 * __useContractBankAccountDrawerUpdateB2BDraftPromisorMutation__
 *
 * To run a mutation, you first call `useContractBankAccountDrawerUpdateB2BDraftPromisorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountDrawerUpdateB2BDraftPromisorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBankAccountDrawerUpdateB2BDraftPromisorMutation, { data, loading, error }] = useContractBankAccountDrawerUpdateB2BDraftPromisorMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      entityVersion: // value for 'entityVersion'
 *      overwrittenPromisorTransferBankAccountNumber: // value for 'overwrittenPromisorTransferBankAccountNumber'
 *   },
 * });
 */
export function useContractBankAccountDrawerUpdateB2BDraftPromisorMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBankAccountDrawerUpdateB2BDraftPromisorMutation, ContractBankAccountDrawerUpdateB2BDraftPromisorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerUpdateB2BDraftPromisorDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBankAccountDrawerUpdateB2BDraftPromisorMutation, ContractBankAccountDrawerUpdateB2BDraftPromisorMutationVariables>(ContractBankAccountDrawerUpdateB2BDraftPromisorDocument, parser(options)));
      }
export type ContractBankAccountDrawerUpdateB2BDraftPromisorMutationHookResult = ReturnType<typeof useContractBankAccountDrawerUpdateB2BDraftPromisorMutation>;
export type ContractBankAccountDrawerUpdateB2BDraftPromisorMutationResult = ApolloReact.MutationResult<ContractBankAccountDrawerUpdateB2BDraftPromisorMutation>;
export type ContractBankAccountDrawerUpdateB2BDraftPromisorMutationOptions = Apollo.MutationOptions<ContractBankAccountDrawerUpdateB2BDraftPromisorMutation, ContractBankAccountDrawerUpdateB2BDraftPromisorMutationVariables>;
export const ContractBankAccountDrawerUpdateEmploymentDraftPromisorDocument = /*#__PURE__*/ gql`
    mutation ContractBankAccountDrawer_UpdateEmploymentDraftPromisor($userId: UserId!, $userEntityVersion: EntityVersion!, $entityVersion: EntityVersion!, $overwrittenPromisorTransferBankAccountNumber: ClearableBankAccountNumberInput!) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateEmploymentDraft(
        overwrittenPromisorTransferBankAccountNumber: $overwrittenPromisorTransferBankAccountNumber
      ) {
        ...NfsError
        ... on EmploymentContractDraft {
          ...ContractBankAccountDrawer_DraftContractFieldsPromisor
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractBankAccountDrawerDraftContractFieldsPromisorFragmentDoc}`;


/**
 * __useContractBankAccountDrawerUpdateEmploymentDraftPromisorMutation__
 *
 * To run a mutation, you first call `useContractBankAccountDrawerUpdateEmploymentDraftPromisorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountDrawerUpdateEmploymentDraftPromisorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBankAccountDrawerUpdateEmploymentDraftPromisorMutation, { data, loading, error }] = useContractBankAccountDrawerUpdateEmploymentDraftPromisorMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      entityVersion: // value for 'entityVersion'
 *      overwrittenPromisorTransferBankAccountNumber: // value for 'overwrittenPromisorTransferBankAccountNumber'
 *   },
 * });
 */
export function useContractBankAccountDrawerUpdateEmploymentDraftPromisorMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutation, ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerUpdateEmploymentDraftPromisorDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutation, ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutationVariables>(ContractBankAccountDrawerUpdateEmploymentDraftPromisorDocument, parser(options)));
      }
export type ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutationHookResult = ReturnType<typeof useContractBankAccountDrawerUpdateEmploymentDraftPromisorMutation>;
export type ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutationResult = ApolloReact.MutationResult<ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutation>;
export type ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutationOptions = Apollo.MutationOptions<ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutation, ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutationVariables>;
export const ContractBankAccountDrawerUpdateB2BDraftPromiseeDocument = /*#__PURE__*/ gql`
    mutation ContractBankAccountDrawer_UpdateB2BDraftPromisee($userId: UserId!, $userEntityVersion: EntityVersion!, $entityVersion: EntityVersion!, $promiseeCompanyTransferBankAccountNumber: ClearableBankAccountNumberInput!) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateB2bDraft(
        promiseeCompanyTransferBankAccountNumber: $promiseeCompanyTransferBankAccountNumber
      ) {
        ...NfsError
        ... on B2BContractDraft {
          ...ContractBankAccountDrawer_DraftContractFieldsPromisee
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractBankAccountDrawerDraftContractFieldsPromiseeFragmentDoc}`;


/**
 * __useContractBankAccountDrawerUpdateB2BDraftPromiseeMutation__
 *
 * To run a mutation, you first call `useContractBankAccountDrawerUpdateB2BDraftPromiseeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountDrawerUpdateB2BDraftPromiseeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBankAccountDrawerUpdateB2BDraftPromiseeMutation, { data, loading, error }] = useContractBankAccountDrawerUpdateB2BDraftPromiseeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      entityVersion: // value for 'entityVersion'
 *      promiseeCompanyTransferBankAccountNumber: // value for 'promiseeCompanyTransferBankAccountNumber'
 *   },
 * });
 */
export function useContractBankAccountDrawerUpdateB2BDraftPromiseeMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBankAccountDrawerUpdateB2BDraftPromiseeMutation, ContractBankAccountDrawerUpdateB2BDraftPromiseeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerUpdateB2BDraftPromiseeDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBankAccountDrawerUpdateB2BDraftPromiseeMutation, ContractBankAccountDrawerUpdateB2BDraftPromiseeMutationVariables>(ContractBankAccountDrawerUpdateB2BDraftPromiseeDocument, parser(options)));
      }
export type ContractBankAccountDrawerUpdateB2BDraftPromiseeMutationHookResult = ReturnType<typeof useContractBankAccountDrawerUpdateB2BDraftPromiseeMutation>;
export type ContractBankAccountDrawerUpdateB2BDraftPromiseeMutationResult = ApolloReact.MutationResult<ContractBankAccountDrawerUpdateB2BDraftPromiseeMutation>;
export type ContractBankAccountDrawerUpdateB2BDraftPromiseeMutationOptions = Apollo.MutationOptions<ContractBankAccountDrawerUpdateB2BDraftPromiseeMutation, ContractBankAccountDrawerUpdateB2BDraftPromiseeMutationVariables>;
export const ContractBankAccountDrawerUpdateB2BContractPromisorDocument = /*#__PURE__*/ gql`
    mutation ContractBankAccountDrawer_UpdateB2BContractPromisor($contractId: ContractId!, $entityVersion: EntityVersion!, $promisorBankAccountNumber: ClearableBankAccountNumberInput) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateB2BContract(
      overwrittenPromisorTransferBankAccountNumber: $promisorBankAccountNumber
    ) {
      ...NfsError
      ... on B2BContract {
        ...ContractBankAccountDrawer_ContractFieldsPromisor
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractBankAccountDrawerContractFieldsPromisorFragmentDoc}`;


/**
 * __useContractBankAccountDrawerUpdateB2BContractPromisorMutation__
 *
 * To run a mutation, you first call `useContractBankAccountDrawerUpdateB2BContractPromisorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountDrawerUpdateB2BContractPromisorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBankAccountDrawerUpdateB2BContractPromisorMutation, { data, loading, error }] = useContractBankAccountDrawerUpdateB2BContractPromisorMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      promisorBankAccountNumber: // value for 'promisorBankAccountNumber'
 *   },
 * });
 */
export function useContractBankAccountDrawerUpdateB2BContractPromisorMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBankAccountDrawerUpdateB2BContractPromisorMutation, ContractBankAccountDrawerUpdateB2BContractPromisorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerUpdateB2BContractPromisorDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBankAccountDrawerUpdateB2BContractPromisorMutation, ContractBankAccountDrawerUpdateB2BContractPromisorMutationVariables>(ContractBankAccountDrawerUpdateB2BContractPromisorDocument, parser(options)));
      }
export type ContractBankAccountDrawerUpdateB2BContractPromisorMutationHookResult = ReturnType<typeof useContractBankAccountDrawerUpdateB2BContractPromisorMutation>;
export type ContractBankAccountDrawerUpdateB2BContractPromisorMutationResult = ApolloReact.MutationResult<ContractBankAccountDrawerUpdateB2BContractPromisorMutation>;
export type ContractBankAccountDrawerUpdateB2BContractPromisorMutationOptions = Apollo.MutationOptions<ContractBankAccountDrawerUpdateB2BContractPromisorMutation, ContractBankAccountDrawerUpdateB2BContractPromisorMutationVariables>;
export const ContractBankAccountDrawerUpdateEmploymentContractPromisorDocument = /*#__PURE__*/ gql`
    mutation ContractBankAccountDrawer_UpdateEmploymentContractPromisor($contractId: ContractId!, $entityVersion: EntityVersion!, $promisorBankAccountNumber: ClearableBankAccountNumberInput) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(
      overwrittenPromisorTransferBankAccountNumber: $promisorBankAccountNumber
    ) {
      ...NfsError
      ... on EmploymentContract {
        ...ContractBankAccountDrawer_ContractFieldsPromisor
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractBankAccountDrawerContractFieldsPromisorFragmentDoc}`;


/**
 * __useContractBankAccountDrawerUpdateEmploymentContractPromisorMutation__
 *
 * To run a mutation, you first call `useContractBankAccountDrawerUpdateEmploymentContractPromisorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountDrawerUpdateEmploymentContractPromisorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBankAccountDrawerUpdateEmploymentContractPromisorMutation, { data, loading, error }] = useContractBankAccountDrawerUpdateEmploymentContractPromisorMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      promisorBankAccountNumber: // value for 'promisorBankAccountNumber'
 *   },
 * });
 */
export function useContractBankAccountDrawerUpdateEmploymentContractPromisorMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBankAccountDrawerUpdateEmploymentContractPromisorMutation, ContractBankAccountDrawerUpdateEmploymentContractPromisorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerUpdateEmploymentContractPromisorDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBankAccountDrawerUpdateEmploymentContractPromisorMutation, ContractBankAccountDrawerUpdateEmploymentContractPromisorMutationVariables>(ContractBankAccountDrawerUpdateEmploymentContractPromisorDocument, parser(options)));
      }
export type ContractBankAccountDrawerUpdateEmploymentContractPromisorMutationHookResult = ReturnType<typeof useContractBankAccountDrawerUpdateEmploymentContractPromisorMutation>;
export type ContractBankAccountDrawerUpdateEmploymentContractPromisorMutationResult = ApolloReact.MutationResult<ContractBankAccountDrawerUpdateEmploymentContractPromisorMutation>;
export type ContractBankAccountDrawerUpdateEmploymentContractPromisorMutationOptions = Apollo.MutationOptions<ContractBankAccountDrawerUpdateEmploymentContractPromisorMutation, ContractBankAccountDrawerUpdateEmploymentContractPromisorMutationVariables>;
export const ContractBankAccountDrawerUpdateB2BContractPromiseeDocument = /*#__PURE__*/ gql`
    mutation ContractBankAccountDrawer_UpdateB2BContractPromisee($contractId: ContractId!, $entityVersion: EntityVersion!, $promiseeCompanyTransferBankAccountNumber: BankAccountNumberInput) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateB2BContract(
      promiseeCompanyTransferBankAccountNumber: $promiseeCompanyTransferBankAccountNumber
    ) {
      ...NfsError
      ... on B2BContract {
        ...ContractBankAccountDrawer_ContractFieldsPromisee
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractBankAccountDrawerContractFieldsPromiseeFragmentDoc}`;


/**
 * __useContractBankAccountDrawerUpdateB2BContractPromiseeMutation__
 *
 * To run a mutation, you first call `useContractBankAccountDrawerUpdateB2BContractPromiseeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountDrawerUpdateB2BContractPromiseeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBankAccountDrawerUpdateB2BContractPromiseeMutation, { data, loading, error }] = useContractBankAccountDrawerUpdateB2BContractPromiseeMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      promiseeCompanyTransferBankAccountNumber: // value for 'promiseeCompanyTransferBankAccountNumber'
 *   },
 * });
 */
export function useContractBankAccountDrawerUpdateB2BContractPromiseeMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBankAccountDrawerUpdateB2BContractPromiseeMutation, ContractBankAccountDrawerUpdateB2BContractPromiseeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountDrawerUpdateB2BContractPromiseeDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBankAccountDrawerUpdateB2BContractPromiseeMutation, ContractBankAccountDrawerUpdateB2BContractPromiseeMutationVariables>(ContractBankAccountDrawerUpdateB2BContractPromiseeDocument, parser(options)));
      }
export type ContractBankAccountDrawerUpdateB2BContractPromiseeMutationHookResult = ReturnType<typeof useContractBankAccountDrawerUpdateB2BContractPromiseeMutation>;
export type ContractBankAccountDrawerUpdateB2BContractPromiseeMutationResult = ApolloReact.MutationResult<ContractBankAccountDrawerUpdateB2BContractPromiseeMutation>;
export type ContractBankAccountDrawerUpdateB2BContractPromiseeMutationOptions = Apollo.MutationOptions<ContractBankAccountDrawerUpdateB2BContractPromiseeMutation, ContractBankAccountDrawerUpdateB2BContractPromiseeMutationVariables>;
export const ContractBankAccountFormRefreshWhiteListDocument = /*#__PURE__*/ gql`
    mutation ContractBankAccountForm_RefreshWhiteList($companyId: CompanyId!, $entityVersion: EntityVersion!, $bankAccountNumber: BankAccountNumberInput!) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    refreshBankAccounts(bankAccountNumbers: [$bankAccountNumber]) {
      ...NfsError
      ... on BankAccountsResponse {
        bankAccounts {
          ...BankAccount
        }
        company {
          id
          entityVersion
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankAccountFragmentDoc}`;


/**
 * __useContractBankAccountFormRefreshWhiteListMutation__
 *
 * To run a mutation, you first call `useContractBankAccountFormRefreshWhiteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountFormRefreshWhiteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBankAccountFormRefreshWhiteListMutation, { data, loading, error }] = useContractBankAccountFormRefreshWhiteListMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *      bankAccountNumber: // value for 'bankAccountNumber'
 *   },
 * });
 */
export function useContractBankAccountFormRefreshWhiteListMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBankAccountFormRefreshWhiteListMutation, ContractBankAccountFormRefreshWhiteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountFormRefreshWhiteListDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBankAccountFormRefreshWhiteListMutation, ContractBankAccountFormRefreshWhiteListMutationVariables>(ContractBankAccountFormRefreshWhiteListDocument, parser(options)));
      }
export type ContractBankAccountFormRefreshWhiteListMutationHookResult = ReturnType<typeof useContractBankAccountFormRefreshWhiteListMutation>;
export type ContractBankAccountFormRefreshWhiteListMutationResult = ApolloReact.MutationResult<ContractBankAccountFormRefreshWhiteListMutation>;
export type ContractBankAccountFormRefreshWhiteListMutationOptions = Apollo.MutationOptions<ContractBankAccountFormRefreshWhiteListMutation, ContractBankAccountFormRefreshWhiteListMutationVariables>;
export const ContractBankAccountSectionRefreshWhiteListDocument = /*#__PURE__*/ gql`
    mutation ContractBankAccountSection_RefreshWhiteList($companyId: CompanyId!, $entityVersion: EntityVersion!, $bankAccountNumber: BankAccountNumberInput!) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    refreshBankAccounts(bankAccountNumbers: [$bankAccountNumber]) {
      ...NfsError
      ... on BankAccountsResponse {
        company {
          id
          entityVersion
          bankAccounts {
            ...BankAccount
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankAccountFragmentDoc}`;


/**
 * __useContractBankAccountSectionRefreshWhiteListMutation__
 *
 * To run a mutation, you first call `useContractBankAccountSectionRefreshWhiteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBankAccountSectionRefreshWhiteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBankAccountSectionRefreshWhiteListMutation, { data, loading, error }] = useContractBankAccountSectionRefreshWhiteListMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *      bankAccountNumber: // value for 'bankAccountNumber'
 *   },
 * });
 */
export function useContractBankAccountSectionRefreshWhiteListMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBankAccountSectionRefreshWhiteListMutation, ContractBankAccountSectionRefreshWhiteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBankAccountSectionRefreshWhiteListDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBankAccountSectionRefreshWhiteListMutation, ContractBankAccountSectionRefreshWhiteListMutationVariables>(ContractBankAccountSectionRefreshWhiteListDocument, parser(options)));
      }
export type ContractBankAccountSectionRefreshWhiteListMutationHookResult = ReturnType<typeof useContractBankAccountSectionRefreshWhiteListMutation>;
export type ContractBankAccountSectionRefreshWhiteListMutationResult = ApolloReact.MutationResult<ContractBankAccountSectionRefreshWhiteListMutation>;
export type ContractBankAccountSectionRefreshWhiteListMutationOptions = Apollo.MutationOptions<ContractBankAccountSectionRefreshWhiteListMutation, ContractBankAccountSectionRefreshWhiteListMutationVariables>;
export const ContractBenefitsDiscardPlannedChangeDocument = /*#__PURE__*/ gql`
    mutation ContractBenefits_DiscardPlannedChange($contractId: ContractId!, $entityVersion: EntityVersion!, $groupType: BenefitGroupType!, $at: Date!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    cancelVariantAssignments(groupType: $groupType, at: $at) {
      ...NfsError
      ... on ListOfAssignedVariantResponse {
        value {
          id
          at
          active {
            value
            futureUpdates {
              value
              applyDate
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useContractBenefitsDiscardPlannedChangeMutation__
 *
 * To run a mutation, you first call `useContractBenefitsDiscardPlannedChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBenefitsDiscardPlannedChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBenefitsDiscardPlannedChangeMutation, { data, loading, error }] = useContractBenefitsDiscardPlannedChangeMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      groupType: // value for 'groupType'
 *      at: // value for 'at'
 *   },
 * });
 */
export function useContractBenefitsDiscardPlannedChangeMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBenefitsDiscardPlannedChangeMutation, ContractBenefitsDiscardPlannedChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBenefitsDiscardPlannedChangeDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBenefitsDiscardPlannedChangeMutation, ContractBenefitsDiscardPlannedChangeMutationVariables>(ContractBenefitsDiscardPlannedChangeDocument, parser(options)));
      }
export type ContractBenefitsDiscardPlannedChangeMutationHookResult = ReturnType<typeof useContractBenefitsDiscardPlannedChangeMutation>;
export type ContractBenefitsDiscardPlannedChangeMutationResult = ApolloReact.MutationResult<ContractBenefitsDiscardPlannedChangeMutation>;
export type ContractBenefitsDiscardPlannedChangeMutationOptions = Apollo.MutationOptions<ContractBenefitsDiscardPlannedChangeMutation, ContractBenefitsDiscardPlannedChangeMutationVariables>;
export const ContractBenefitsDocument = /*#__PURE__*/ gql`
    query ContractBenefits($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        startDate
        terminationDate
        promisee {
          id
          firstName
          lastName
        }
        ... on B2BContract {
          currency {
            ...Unauthorized
            ... on AccessGranted__TimeBasedCurrency {
              value {
                ...ContractBenefits_Currency
              }
            }
          }
        }
        ... on EmploymentContract {
          currency {
            ...Unauthorized
            ... on AccessGranted__TimeBasedCurrency {
              value {
                ...ContractBenefits_Currency
              }
            }
          }
        }
        assignedVariants(activeOnly: false) {
          ...Unauthorized
          ... on AccessGranted__ListOfAssignedVariant {
            value {
              id
              active {
                history {
                  value
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${ContractBenefitsCurrencyFragmentDoc}`;

/**
 * __useContractBenefitsQuery__
 *
 * To run a query within a React component, call `useContractBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractBenefitsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractBenefitsQuery(baseOptions: ApolloReact.QueryHookOptions<ContractBenefitsQuery, ContractBenefitsQueryVariables> & ({ variables: ContractBenefitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBenefitsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractBenefitsQuery, ContractBenefitsQueryVariables>(ContractBenefitsDocument, parser(options)));
      }
export function useContractBenefitsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractBenefitsQuery, ContractBenefitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractBenefitsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractBenefitsQuery, ContractBenefitsQueryVariables>(ContractBenefitsDocument, options));
        }

export type ContractBenefitsQueryResult = ApolloReact.QueryResult<ContractBenefitsQuery, ContractBenefitsQueryVariables>;
export function refetchContractBenefitsQuery(variables: ContractBenefitsQueryVariables) {
      return { query: ContractBenefitsDocument, variables: variables }
    }
export const ContractBonusesDeleteDocument = /*#__PURE__*/ gql`
    mutation ContractBonuses_Delete($contractId: ContractId!, $entityVersion: EntityVersion!, $bonusId: BonusId!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    bonus(id: $bonusId) {
      delete {
        ...NfsError
        ... on UnitResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useContractBonusesDeleteMutation__
 *
 * To run a mutation, you first call `useContractBonusesDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBonusesDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBonusesDeleteMutation, { data, loading, error }] = useContractBonusesDeleteMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      bonusId: // value for 'bonusId'
 *   },
 * });
 */
export function useContractBonusesDeleteMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBonusesDeleteMutation, ContractBonusesDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBonusesDeleteDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBonusesDeleteMutation, ContractBonusesDeleteMutationVariables>(ContractBonusesDeleteDocument, parser(options)));
      }
export type ContractBonusesDeleteMutationHookResult = ReturnType<typeof useContractBonusesDeleteMutation>;
export type ContractBonusesDeleteMutationResult = ApolloReact.MutationResult<ContractBonusesDeleteMutation>;
export type ContractBonusesDeleteMutationOptions = Apollo.MutationOptions<ContractBonusesDeleteMutation, ContractBonusesDeleteMutationVariables>;
export const ContractBonusesDocument = /*#__PURE__*/ gql`
    query ContractBonuses($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        terminationDate
        startDate
        promisee {
          id
        }
        ... on B2BContract {
          currency {
            ...Unauthorized
            ... on AccessGranted__TimeBasedCurrency {
              value {
                ...ContractBonuses_Currency
              }
            }
          }
          vat {
            ...Unauthorized
            ... on AccessGranted__TimeBasedVatType {
              value {
                value {
                  ...VatType
                }
              }
            }
          }
        }
        ... on EmploymentContract {
          currency {
            ...Unauthorized
            ... on AccessGranted__TimeBasedCurrency {
              value {
                ...ContractBonuses_Currency
              }
            }
          }
        }
        bonuses {
          ...Unauthorized
          ... on AccessGranted__Bonuses {
            value {
              paidOut {
                ...ContractBonuses_Bonus
              }
              future {
                ...ContractBonuses_Bonus
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${ContractBonusesCurrencyFragmentDoc}
${VatTypeFragmentDoc}
${ContractBonusesBonusFragmentDoc}`;

/**
 * __useContractBonusesQuery__
 *
 * To run a query within a React component, call `useContractBonusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractBonusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractBonusesQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractBonusesQuery(baseOptions: ApolloReact.QueryHookOptions<ContractBonusesQuery, ContractBonusesQueryVariables> & ({ variables: ContractBonusesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBonusesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractBonusesQuery, ContractBonusesQueryVariables>(ContractBonusesDocument, parser(options)));
      }
export function useContractBonusesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractBonusesQuery, ContractBonusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractBonusesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractBonusesQuery, ContractBonusesQueryVariables>(ContractBonusesDocument, options));
        }

export type ContractBonusesQueryResult = ApolloReact.QueryResult<ContractBonusesQuery, ContractBonusesQueryVariables>;
export function refetchContractBonusesQuery(variables: ContractBonusesQueryVariables) {
      return { query: ContractBonusesDocument, variables: variables }
    }
export const ContractBonusesSettingsDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query ContractBonusesSettingsDrawer_InitialData($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        ... on B2BContract {
          enableTrainingPackage {
            ...Unauthorized
            ... on AccessGranted__Boolean {
              value
            }
          }
        }
        ... on EmploymentContract {
          enableTrainingPackage {
            ...Unauthorized
            ... on AccessGranted__Boolean {
              value
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useContractBonusesSettingsDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useContractBonusesSettingsDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractBonusesSettingsDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractBonusesSettingsDrawerInitialDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractBonusesSettingsDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<ContractBonusesSettingsDrawerInitialDataQuery, ContractBonusesSettingsDrawerInitialDataQueryVariables> & ({ variables: ContractBonusesSettingsDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBonusesSettingsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractBonusesSettingsDrawerInitialDataQuery, ContractBonusesSettingsDrawerInitialDataQueryVariables>(ContractBonusesSettingsDrawerInitialDataDocument, parser(options)));
      }
export function useContractBonusesSettingsDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractBonusesSettingsDrawerInitialDataQuery, ContractBonusesSettingsDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractBonusesSettingsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractBonusesSettingsDrawerInitialDataQuery, ContractBonusesSettingsDrawerInitialDataQueryVariables>(ContractBonusesSettingsDrawerInitialDataDocument, options));
        }

export type ContractBonusesSettingsDrawerInitialDataQueryResult = ApolloReact.QueryResult<ContractBonusesSettingsDrawerInitialDataQuery, ContractBonusesSettingsDrawerInitialDataQueryVariables>;
export function refetchContractBonusesSettingsDrawerInitialDataQuery(variables: ContractBonusesSettingsDrawerInitialDataQueryVariables) {
      return { query: ContractBonusesSettingsDrawerInitialDataDocument, variables: variables }
    }
export const ContractBonusesSettingsDrawerUpdateB2BContractDocument = /*#__PURE__*/ gql`
    mutation ContractBonusesSettingsDrawer_UpdateB2BContract($contractId: ContractId!, $entityVersion: EntityVersion!, $enableTrainingPackage: Boolean) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateB2BContract(enableTrainingPackage: $enableTrainingPackage) {
      ...NfsError
      ... on B2BContract {
        id
        entityVersion
        enableTrainingPackage {
          ...Unauthorized
          ... on AccessGranted__Boolean {
            value
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;


/**
 * __useContractBonusesSettingsDrawerUpdateB2BContractMutation__
 *
 * To run a mutation, you first call `useContractBonusesSettingsDrawerUpdateB2BContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBonusesSettingsDrawerUpdateB2BContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBonusesSettingsDrawerUpdateB2BContractMutation, { data, loading, error }] = useContractBonusesSettingsDrawerUpdateB2BContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      enableTrainingPackage: // value for 'enableTrainingPackage'
 *   },
 * });
 */
export function useContractBonusesSettingsDrawerUpdateB2BContractMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBonusesSettingsDrawerUpdateB2BContractMutation, ContractBonusesSettingsDrawerUpdateB2BContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBonusesSettingsDrawerUpdateB2BContractDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBonusesSettingsDrawerUpdateB2BContractMutation, ContractBonusesSettingsDrawerUpdateB2BContractMutationVariables>(ContractBonusesSettingsDrawerUpdateB2BContractDocument, parser(options)));
      }
export type ContractBonusesSettingsDrawerUpdateB2BContractMutationHookResult = ReturnType<typeof useContractBonusesSettingsDrawerUpdateB2BContractMutation>;
export type ContractBonusesSettingsDrawerUpdateB2BContractMutationResult = ApolloReact.MutationResult<ContractBonusesSettingsDrawerUpdateB2BContractMutation>;
export type ContractBonusesSettingsDrawerUpdateB2BContractMutationOptions = Apollo.MutationOptions<ContractBonusesSettingsDrawerUpdateB2BContractMutation, ContractBonusesSettingsDrawerUpdateB2BContractMutationVariables>;
export const ContractBonusesSettingsDrawerUpdateEmploymentContractDocument = /*#__PURE__*/ gql`
    mutation ContractBonusesSettingsDrawer_UpdateEmploymentContract($contractId: ContractId!, $entityVersion: EntityVersion!, $enableTrainingPackage: Boolean) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(enableTrainingPackage: $enableTrainingPackage) {
      ...NfsError
      ... on EmploymentContract {
        id
        entityVersion
        enableTrainingPackage {
          ...Unauthorized
          ... on AccessGranted__Boolean {
            value
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;


/**
 * __useContractBonusesSettingsDrawerUpdateEmploymentContractMutation__
 *
 * To run a mutation, you first call `useContractBonusesSettingsDrawerUpdateEmploymentContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractBonusesSettingsDrawerUpdateEmploymentContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractBonusesSettingsDrawerUpdateEmploymentContractMutation, { data, loading, error }] = useContractBonusesSettingsDrawerUpdateEmploymentContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      enableTrainingPackage: // value for 'enableTrainingPackage'
 *   },
 * });
 */
export function useContractBonusesSettingsDrawerUpdateEmploymentContractMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractBonusesSettingsDrawerUpdateEmploymentContractMutation, ContractBonusesSettingsDrawerUpdateEmploymentContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractBonusesSettingsDrawerUpdateEmploymentContractDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractBonusesSettingsDrawerUpdateEmploymentContractMutation, ContractBonusesSettingsDrawerUpdateEmploymentContractMutationVariables>(ContractBonusesSettingsDrawerUpdateEmploymentContractDocument, parser(options)));
      }
export type ContractBonusesSettingsDrawerUpdateEmploymentContractMutationHookResult = ReturnType<typeof useContractBonusesSettingsDrawerUpdateEmploymentContractMutation>;
export type ContractBonusesSettingsDrawerUpdateEmploymentContractMutationResult = ApolloReact.MutationResult<ContractBonusesSettingsDrawerUpdateEmploymentContractMutation>;
export type ContractBonusesSettingsDrawerUpdateEmploymentContractMutationOptions = Apollo.MutationOptions<ContractBonusesSettingsDrawerUpdateEmploymentContractMutation, ContractBonusesSettingsDrawerUpdateEmploymentContractMutationVariables>;
export const ContractDetailsDocument = /*#__PURE__*/ gql`
    query ContractDetails($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        startDate
        terminationDate
        expectedEndDate
        status
        name
        notes {
          ...Unauthorized
          ... on AccessGranted__OptionalString {
            value
          }
        }
        promisee {
          ...ContractDetails_User
        }
        promisor {
          value {
            ...ContractDetails_Company
            mailingAddress {
              ...Address
            }
          }
        }
        ... on B2BContract {
          b2bContractType: type
          conclusionDatePromiseeCompanySnapshot {
            ...Unauthorized
            ... on AccessGranted__Company {
              value {
                ...ContractDetails_Company
                mailingAddress {
                  ...Address
                }
                at
              }
            }
          }
          promiseeCompany {
            ...Unauthorized
            ... on AccessGranted__Company {
              value {
                ...ContractDetails_Company
                mailingAddress {
                  ...Address
                }
              }
            }
          }
          promisorRepresentative {
            ...Unauthorized
            ... on AccessGranted__String {
              value
            }
          }
          conclusionDatePromiseeSnapshot {
            ...ContractDetails_User
            at
          }
          conclusionDatePromisorSnapshot {
            ...ContractDetails_Company
            mailingAddress {
              ...Address
            }
            at
          }
          rate {
            ...Unauthorized
          }
          bonuses {
            ...Unauthorized
          }
        }
        ... on EmploymentContract {
          type
          promisorRepresentative {
            ...Unauthorized
            ... on AccessGranted__String {
              value
            }
          }
          conclusionDatePromiseeSnapshot {
            ...ContractDetails_User
            at
          }
          conclusionDatePromisorSnapshot {
            ...ContractDetails_Company
            mailingAddress {
              ...Address
            }
            at
          }
          rate {
            ...Unauthorized
          }
          bonuses {
            ...Unauthorized
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${ContractDetailsUserFragmentDoc}
${ContractDetailsCompanyFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useContractDetailsQuery__
 *
 * To run a query within a React component, call `useContractDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDetailsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<ContractDetailsQuery, ContractDetailsQueryVariables> & ({ variables: ContractDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractDetailsQuery, ContractDetailsQueryVariables>(ContractDetailsDocument, parser(options)));
      }
export function useContractDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractDetailsQuery, ContractDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractDetailsQuery, ContractDetailsQueryVariables>(ContractDetailsDocument, options));
        }

export type ContractDetailsQueryResult = ApolloReact.QueryResult<ContractDetailsQuery, ContractDetailsQueryVariables>;
export function refetchContractDetailsQuery(variables: ContractDetailsQueryVariables) {
      return { query: ContractDetailsDocument, variables: variables }
    }
export const ContractDetailsDrawerLoadDataDocument = /*#__PURE__*/ gql`
    query ContractDetailsDrawer_LoadData($contractId: ContractId!, $year: Year!, $at: OffsetDateTime) {
  contract(contractId: $contractId, at: $at) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        at
        promisor {
          value {
            id
            name
          }
        }
        ...ContractDetailsDrawer_Contract
      }
    }
  }
  paidLeaveBalanceYearlySummary(contractId: $contractId, year: $year) {
    ...NfsError
    ... on DaysBalance {
      used
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractDetailsDrawerContractFragmentDoc}`;

/**
 * __useContractDetailsDrawerLoadDataQuery__
 *
 * To run a query within a React component, call `useContractDetailsDrawerLoadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDetailsDrawerLoadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDetailsDrawerLoadDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      year: // value for 'year'
 *      at: // value for 'at'
 *   },
 * });
 */
export function useContractDetailsDrawerLoadDataQuery(baseOptions: ApolloReact.QueryHookOptions<ContractDetailsDrawerLoadDataQuery, ContractDetailsDrawerLoadDataQueryVariables> & ({ variables: ContractDetailsDrawerLoadDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractDetailsDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractDetailsDrawerLoadDataQuery, ContractDetailsDrawerLoadDataQueryVariables>(ContractDetailsDrawerLoadDataDocument, parser(options)));
      }
export function useContractDetailsDrawerLoadDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractDetailsDrawerLoadDataQuery, ContractDetailsDrawerLoadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractDetailsDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractDetailsDrawerLoadDataQuery, ContractDetailsDrawerLoadDataQueryVariables>(ContractDetailsDrawerLoadDataDocument, options));
        }

export type ContractDetailsDrawerLoadDataQueryResult = ApolloReact.QueryResult<ContractDetailsDrawerLoadDataQuery, ContractDetailsDrawerLoadDataQueryVariables>;
export function refetchContractDetailsDrawerLoadDataQuery(variables: ContractDetailsDrawerLoadDataQueryVariables) {
      return { query: ContractDetailsDrawerLoadDataDocument, variables: variables }
    }
export const ContractDetailsDrawerUpdateEmploymentDocument = /*#__PURE__*/ gql`
    mutation ContractDetailsDrawer_UpdateEmployment($contractId: ContractId!, $entityVersion: EntityVersion!, $position: TimeBasedValueClearableStringInput!, $scopeOfWork: TimeBasedValueStringInput, $annualLeaveEntitlement: AnnualLeaveEntitlementInput, $paidLeaveEntitlement: TimeBasedValueClearableDaysInput) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(
      position: $position
      scopeOfWork: $scopeOfWork
      annualLeaveEntitlement: $annualLeaveEntitlement
      paidLeaveEntitlement: $paidLeaveEntitlement
    ) {
      ...NfsError
      ... on EmploymentContract {
        ...ContractDetailsDrawer_Contract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractDetailsDrawerContractFragmentDoc}`;


/**
 * __useContractDetailsDrawerUpdateEmploymentMutation__
 *
 * To run a mutation, you first call `useContractDetailsDrawerUpdateEmploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractDetailsDrawerUpdateEmploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractDetailsDrawerUpdateEmploymentMutation, { data, loading, error }] = useContractDetailsDrawerUpdateEmploymentMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      position: // value for 'position'
 *      scopeOfWork: // value for 'scopeOfWork'
 *      annualLeaveEntitlement: // value for 'annualLeaveEntitlement'
 *      paidLeaveEntitlement: // value for 'paidLeaveEntitlement'
 *   },
 * });
 */
export function useContractDetailsDrawerUpdateEmploymentMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractDetailsDrawerUpdateEmploymentMutation, ContractDetailsDrawerUpdateEmploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractDetailsDrawerUpdateEmploymentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractDetailsDrawerUpdateEmploymentMutation, ContractDetailsDrawerUpdateEmploymentMutationVariables>(ContractDetailsDrawerUpdateEmploymentDocument, parser(options)));
      }
export type ContractDetailsDrawerUpdateEmploymentMutationHookResult = ReturnType<typeof useContractDetailsDrawerUpdateEmploymentMutation>;
export type ContractDetailsDrawerUpdateEmploymentMutationResult = ApolloReact.MutationResult<ContractDetailsDrawerUpdateEmploymentMutation>;
export type ContractDetailsDrawerUpdateEmploymentMutationOptions = Apollo.MutationOptions<ContractDetailsDrawerUpdateEmploymentMutation, ContractDetailsDrawerUpdateEmploymentMutationVariables>;
export const ContractDetailsDrawerUpdateB2BDocument = /*#__PURE__*/ gql`
    mutation ContractDetailsDrawer_UpdateB2B($contractId: ContractId!, $entityVersion: EntityVersion!, $position: TimeBasedValueClearableStringInput!, $scopeOfWork: TimeBasedValueStringInput) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateB2BContract(position: $position, scopeOfWork: $scopeOfWork) {
      ...NfsError
      ... on B2BContract {
        ...ContractDetailsDrawer_Contract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractDetailsDrawerContractFragmentDoc}`;


/**
 * __useContractDetailsDrawerUpdateB2BMutation__
 *
 * To run a mutation, you first call `useContractDetailsDrawerUpdateB2BMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractDetailsDrawerUpdateB2BMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractDetailsDrawerUpdateB2BMutation, { data, loading, error }] = useContractDetailsDrawerUpdateB2BMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      position: // value for 'position'
 *      scopeOfWork: // value for 'scopeOfWork'
 *   },
 * });
 */
export function useContractDetailsDrawerUpdateB2BMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractDetailsDrawerUpdateB2BMutation, ContractDetailsDrawerUpdateB2BMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractDetailsDrawerUpdateB2BDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractDetailsDrawerUpdateB2BMutation, ContractDetailsDrawerUpdateB2BMutationVariables>(ContractDetailsDrawerUpdateB2BDocument, parser(options)));
      }
export type ContractDetailsDrawerUpdateB2BMutationHookResult = ReturnType<typeof useContractDetailsDrawerUpdateB2BMutation>;
export type ContractDetailsDrawerUpdateB2BMutationResult = ApolloReact.MutationResult<ContractDetailsDrawerUpdateB2BMutation>;
export type ContractDetailsDrawerUpdateB2BMutationOptions = Apollo.MutationOptions<ContractDetailsDrawerUpdateB2BMutation, ContractDetailsDrawerUpdateB2BMutationVariables>;
export const ContractDetailsSectionDocument = /*#__PURE__*/ gql`
    query ContractDetailsSection($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        ...ContractDetailsSection_Contract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractDetailsSectionContractFragmentDoc}`;

/**
 * __useContractDetailsSectionQuery__
 *
 * To run a query within a React component, call `useContractDetailsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDetailsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDetailsSectionQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractDetailsSectionQuery(baseOptions: ApolloReact.QueryHookOptions<ContractDetailsSectionQuery, ContractDetailsSectionQueryVariables> & ({ variables: ContractDetailsSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractDetailsSectionDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractDetailsSectionQuery, ContractDetailsSectionQueryVariables>(ContractDetailsSectionDocument, parser(options)));
      }
export function useContractDetailsSectionLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractDetailsSectionQuery, ContractDetailsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractDetailsSectionDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractDetailsSectionQuery, ContractDetailsSectionQueryVariables>(ContractDetailsSectionDocument, options));
        }

export type ContractDetailsSectionQueryResult = ApolloReact.QueryResult<ContractDetailsSectionQuery, ContractDetailsSectionQueryVariables>;
export function refetchContractDetailsSectionQuery(variables: ContractDetailsSectionQueryVariables) {
      return { query: ContractDetailsSectionDocument, variables: variables }
    }
export const ContractDetailsSectionDiscardActivitiesDocument = /*#__PURE__*/ gql`
    mutation ContractDetailsSection_DiscardActivities($contractId: ContractId!, $activityIds: [ActivityId!]!, $entityVersion: EntityVersion!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    cancelActivities(activityIds: $activityIds) {
      ...NfsError
      ... on ContractResponse {
        value {
          ...ContractDetailsSection_Contract
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractDetailsSectionContractFragmentDoc}`;


/**
 * __useContractDetailsSectionDiscardActivitiesMutation__
 *
 * To run a mutation, you first call `useContractDetailsSectionDiscardActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractDetailsSectionDiscardActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractDetailsSectionDiscardActivitiesMutation, { data, loading, error }] = useContractDetailsSectionDiscardActivitiesMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      activityIds: // value for 'activityIds'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useContractDetailsSectionDiscardActivitiesMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractDetailsSectionDiscardActivitiesMutation, ContractDetailsSectionDiscardActivitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractDetailsSectionDiscardActivitiesDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractDetailsSectionDiscardActivitiesMutation, ContractDetailsSectionDiscardActivitiesMutationVariables>(ContractDetailsSectionDiscardActivitiesDocument, parser(options)));
      }
export type ContractDetailsSectionDiscardActivitiesMutationHookResult = ReturnType<typeof useContractDetailsSectionDiscardActivitiesMutation>;
export type ContractDetailsSectionDiscardActivitiesMutationResult = ApolloReact.MutationResult<ContractDetailsSectionDiscardActivitiesMutation>;
export type ContractDetailsSectionDiscardActivitiesMutationOptions = Apollo.MutationOptions<ContractDetailsSectionDiscardActivitiesMutation, ContractDetailsSectionDiscardActivitiesMutationVariables>;
export const ContractDraftActionButtonValidateDocument = /*#__PURE__*/ gql`
    query ContractDraftActionButton_Validate($userId: UserId!) {
  validateContractDraft(userId: $userId) {
    ...NfsError
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useContractDraftActionButtonValidateQuery__
 *
 * To run a query within a React component, call `useContractDraftActionButtonValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDraftActionButtonValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDraftActionButtonValidateQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useContractDraftActionButtonValidateQuery(baseOptions: ApolloReact.QueryHookOptions<ContractDraftActionButtonValidateQuery, ContractDraftActionButtonValidateQueryVariables> & ({ variables: ContractDraftActionButtonValidateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractDraftActionButtonValidateDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractDraftActionButtonValidateQuery, ContractDraftActionButtonValidateQueryVariables>(ContractDraftActionButtonValidateDocument, parser(options)));
      }
export function useContractDraftActionButtonValidateLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractDraftActionButtonValidateQuery, ContractDraftActionButtonValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractDraftActionButtonValidateDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractDraftActionButtonValidateQuery, ContractDraftActionButtonValidateQueryVariables>(ContractDraftActionButtonValidateDocument, options));
        }

export type ContractDraftActionButtonValidateQueryResult = ApolloReact.QueryResult<ContractDraftActionButtonValidateQuery, ContractDraftActionButtonValidateQueryVariables>;
export function refetchContractDraftActionButtonValidateQuery(variables: ContractDraftActionButtonValidateQueryVariables) {
      return { query: ContractDraftActionButtonValidateDocument, variables: variables }
    }
export const ContractDraftDetailsDocument = /*#__PURE__*/ gql`
    query ContractDraftDetails($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            id
            entityVersion
            name
            notes
            ... on EmploymentContractDraft {
              currency
              scopeOfWork
              position
              paidLeaveEntitlement
              rate {
                ...Rate
              }
              overtimeRate {
                ...NetGross
              }
              onCall {
                night {
                  ...NetGross
                }
                holiday {
                  ...NetGross
                }
                weekend {
                  ...NetGross
                }
              }
            }
            ... on B2BContractDraft {
              currency
              scopeOfWork
              position
              vat {
                ...VatType
              }
              rate {
                ...Rate
              }
              overtimeRate {
                ...NetGross
              }
              onCall {
                night {
                  ...NetGross
                }
                holiday {
                  ...NetGross
                }
                weekend {
                  ...NetGross
                }
              }
              separatePaymentForBenefits
            }
            promisee {
              id
              entityVersion
              firstName
              lastName
              pesel {
                ...Unauthorized
                ... on AccessGranted__OptionalPESEL {
                  value
                }
              }
              idType {
                ...Unauthorized
                ... on AccessGranted__OptionalIDType {
                  value
                }
              }
              idNumber {
                ...Unauthorized
                ... on AccessGranted__OptionalString {
                  value
                }
              }
              address {
                ...Unauthorized
                ... on AccessGranted__OptionalAddress {
                  value {
                    ...Address
                  }
                }
              }
              mailingAddress {
                ...Unauthorized
                ... on AccessGranted__OptionalAddress {
                  value {
                    ...Address
                  }
                }
              }
            }
            promisor {
              companyType
              bankAccounts {
                accountNumber {
                  ...BankAccountNumber
                }
              }
              ...ContractDraftDetails_Company
            }
            promisorTransferBankAccount {
              value {
                ...BankAccount
              }
            }
            ... on B2BContractDraft {
              b2bContractType: type
              promiseeCompany {
                ...ContractDraftDetails_Company
                companyType
                address {
                  ...Address
                }
                mailingAddress {
                  ...Address
                }
              }
              promiseeCompanyTransferBankAccount {
                ...BankAccount
              }
            }
            ... on EmploymentContractDraft {
              type
              ppk
              copyrightCosts
              taxDeductibleCosts
              paidLeaveEntitlement
              applyRemoteWorkReimbursement
              workingTime {
                ...WorkingTime
              }
              promiseeTransferBankAccount {
                ...BankAccount
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${RateFragmentDoc}
${NetGrossFragmentDoc}
${VatTypeFragmentDoc}
${AddressFragmentDoc}
${BankAccountNumberFragmentDoc}
${ContractDraftDetailsCompanyFragmentDoc}
${BankAccountFragmentDoc}
${WorkingTimeFragmentDoc}`;

/**
 * __useContractDraftDetailsQuery__
 *
 * To run a query within a React component, call `useContractDraftDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDraftDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDraftDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useContractDraftDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<ContractDraftDetailsQuery, ContractDraftDetailsQueryVariables> & ({ variables: ContractDraftDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractDraftDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractDraftDetailsQuery, ContractDraftDetailsQueryVariables>(ContractDraftDetailsDocument, parser(options)));
      }
export function useContractDraftDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractDraftDetailsQuery, ContractDraftDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractDraftDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractDraftDetailsQuery, ContractDraftDetailsQueryVariables>(ContractDraftDetailsDocument, options));
        }

export type ContractDraftDetailsQueryResult = ApolloReact.QueryResult<ContractDraftDetailsQuery, ContractDraftDetailsQueryVariables>;
export function refetchContractDraftDetailsQuery(variables: ContractDraftDetailsQueryVariables) {
      return { query: ContractDraftDetailsDocument, variables: variables }
    }
export const ContractListFiltersPromisorsDocument = /*#__PURE__*/ gql`
    query ContractListFilters_Promisors($first: Int, $after: Cursor) {
  companies(first: $first, after: $after, filter: {companyType_oneOf: [Group]}) {
    ...NfsError
    ... on FSPResponseCompany {
      edges {
        node {
          id
          entityVersion
          name
          logo
        }
        cursor
      }
      hasNextPage
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useContractListFiltersPromisorsQuery__
 *
 * To run a query within a React component, call `useContractListFiltersPromisorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractListFiltersPromisorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractListFiltersPromisorsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useContractListFiltersPromisorsQuery(baseOptions?: ApolloReact.QueryHookOptions<ContractListFiltersPromisorsQuery, ContractListFiltersPromisorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractListFiltersPromisorsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractListFiltersPromisorsQuery, ContractListFiltersPromisorsQueryVariables>(ContractListFiltersPromisorsDocument, parser(options)));
      }
export function useContractListFiltersPromisorsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractListFiltersPromisorsQuery, ContractListFiltersPromisorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractListFiltersPromisorsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractListFiltersPromisorsQuery, ContractListFiltersPromisorsQueryVariables>(ContractListFiltersPromisorsDocument, options));
        }

export type ContractListFiltersPromisorsQueryResult = ApolloReact.QueryResult<ContractListFiltersPromisorsQuery, ContractListFiltersPromisorsQueryVariables>;
export function refetchContractListFiltersPromisorsQuery(variables?: ContractListFiltersPromisorsQueryVariables) {
      return { query: ContractListFiltersPromisorsDocument, variables: variables }
    }
export const ContractNoteDrawerDraftInputDocument = /*#__PURE__*/ gql`
    query ContractNoteDrawer_DraftInput($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            id
            entityVersion
            notes
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useContractNoteDrawerDraftInputQuery__
 *
 * To run a query within a React component, call `useContractNoteDrawerDraftInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractNoteDrawerDraftInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractNoteDrawerDraftInputQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useContractNoteDrawerDraftInputQuery(baseOptions: ApolloReact.QueryHookOptions<ContractNoteDrawerDraftInputQuery, ContractNoteDrawerDraftInputQueryVariables> & ({ variables: ContractNoteDrawerDraftInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractNoteDrawerDraftInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractNoteDrawerDraftInputQuery, ContractNoteDrawerDraftInputQueryVariables>(ContractNoteDrawerDraftInputDocument, parser(options)));
      }
export function useContractNoteDrawerDraftInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractNoteDrawerDraftInputQuery, ContractNoteDrawerDraftInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractNoteDrawerDraftInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractNoteDrawerDraftInputQuery, ContractNoteDrawerDraftInputQueryVariables>(ContractNoteDrawerDraftInputDocument, options));
        }

export type ContractNoteDrawerDraftInputQueryResult = ApolloReact.QueryResult<ContractNoteDrawerDraftInputQuery, ContractNoteDrawerDraftInputQueryVariables>;
export function refetchContractNoteDrawerDraftInputQuery(variables: ContractNoteDrawerDraftInputQueryVariables) {
      return { query: ContractNoteDrawerDraftInputDocument, variables: variables }
    }
export const ContractNoteDrawerContractInputDocument = /*#__PURE__*/ gql`
    query ContractNoteDrawer_ContractInput($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        notes {
          ...Unauthorized
          ... on AccessGranted__OptionalString {
            value
          }
        }
        promisee {
          id
          entityVersion
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useContractNoteDrawerContractInputQuery__
 *
 * To run a query within a React component, call `useContractNoteDrawerContractInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractNoteDrawerContractInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractNoteDrawerContractInputQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractNoteDrawerContractInputQuery(baseOptions: ApolloReact.QueryHookOptions<ContractNoteDrawerContractInputQuery, ContractNoteDrawerContractInputQueryVariables> & ({ variables: ContractNoteDrawerContractInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractNoteDrawerContractInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractNoteDrawerContractInputQuery, ContractNoteDrawerContractInputQueryVariables>(ContractNoteDrawerContractInputDocument, parser(options)));
      }
export function useContractNoteDrawerContractInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractNoteDrawerContractInputQuery, ContractNoteDrawerContractInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractNoteDrawerContractInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractNoteDrawerContractInputQuery, ContractNoteDrawerContractInputQueryVariables>(ContractNoteDrawerContractInputDocument, options));
        }

export type ContractNoteDrawerContractInputQueryResult = ApolloReact.QueryResult<ContractNoteDrawerContractInputQuery, ContractNoteDrawerContractInputQueryVariables>;
export function refetchContractNoteDrawerContractInputQuery(variables: ContractNoteDrawerContractInputQueryVariables) {
      return { query: ContractNoteDrawerContractInputDocument, variables: variables }
    }
export const ContractNoteDrawerUpdateB2BContractDocument = /*#__PURE__*/ gql`
    mutation ContractNoteDrawer_UpdateB2BContract($contractId: ContractId!, $entityVersion: EntityVersion!, $notes: ClearableStringInput) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateB2BContract(notes: $notes) {
      ...NfsError
      ... on B2BContract {
        id
        entityVersion
        notes {
          ...Unauthorized
          ... on AccessGranted__OptionalString {
            value
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;


/**
 * __useContractNoteDrawerUpdateB2BContractMutation__
 *
 * To run a mutation, you first call `useContractNoteDrawerUpdateB2BContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractNoteDrawerUpdateB2BContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractNoteDrawerUpdateB2BContractMutation, { data, loading, error }] = useContractNoteDrawerUpdateB2BContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useContractNoteDrawerUpdateB2BContractMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractNoteDrawerUpdateB2BContractMutation, ContractNoteDrawerUpdateB2BContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractNoteDrawerUpdateB2BContractDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractNoteDrawerUpdateB2BContractMutation, ContractNoteDrawerUpdateB2BContractMutationVariables>(ContractNoteDrawerUpdateB2BContractDocument, parser(options)));
      }
export type ContractNoteDrawerUpdateB2BContractMutationHookResult = ReturnType<typeof useContractNoteDrawerUpdateB2BContractMutation>;
export type ContractNoteDrawerUpdateB2BContractMutationResult = ApolloReact.MutationResult<ContractNoteDrawerUpdateB2BContractMutation>;
export type ContractNoteDrawerUpdateB2BContractMutationOptions = Apollo.MutationOptions<ContractNoteDrawerUpdateB2BContractMutation, ContractNoteDrawerUpdateB2BContractMutationVariables>;
export const ContractNoteDrawerUpdateEmploymentContractDocument = /*#__PURE__*/ gql`
    mutation ContractNoteDrawer_UpdateEmploymentContract($contractId: ContractId!, $entityVersion: EntityVersion!, $notes: ClearableStringInput) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(notes: $notes) {
      ...NfsError
      ... on EmploymentContract {
        id
        entityVersion
        notes {
          ...Unauthorized
          ... on AccessGranted__OptionalString {
            value
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;


/**
 * __useContractNoteDrawerUpdateEmploymentContractMutation__
 *
 * To run a mutation, you first call `useContractNoteDrawerUpdateEmploymentContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractNoteDrawerUpdateEmploymentContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractNoteDrawerUpdateEmploymentContractMutation, { data, loading, error }] = useContractNoteDrawerUpdateEmploymentContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useContractNoteDrawerUpdateEmploymentContractMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractNoteDrawerUpdateEmploymentContractMutation, ContractNoteDrawerUpdateEmploymentContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractNoteDrawerUpdateEmploymentContractDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractNoteDrawerUpdateEmploymentContractMutation, ContractNoteDrawerUpdateEmploymentContractMutationVariables>(ContractNoteDrawerUpdateEmploymentContractDocument, parser(options)));
      }
export type ContractNoteDrawerUpdateEmploymentContractMutationHookResult = ReturnType<typeof useContractNoteDrawerUpdateEmploymentContractMutation>;
export type ContractNoteDrawerUpdateEmploymentContractMutationResult = ApolloReact.MutationResult<ContractNoteDrawerUpdateEmploymentContractMutation>;
export type ContractNoteDrawerUpdateEmploymentContractMutationOptions = Apollo.MutationOptions<ContractNoteDrawerUpdateEmploymentContractMutation, ContractNoteDrawerUpdateEmploymentContractMutationVariables>;
export const ContractNoteDrawerUpdateSubcontractDocument = /*#__PURE__*/ gql`
    mutation ContractNoteDrawer_UpdateSubcontract($contractId: ContractId!, $entityVersion: EntityVersion!, $notes: ClearableStringInput) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateSubcontract(notes: $notes) {
      ...NfsError
      ... on Subcontract {
        id
        entityVersion
        notes {
          ...Unauthorized
          ... on AccessGranted__OptionalString {
            value
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;


/**
 * __useContractNoteDrawerUpdateSubcontractMutation__
 *
 * To run a mutation, you first call `useContractNoteDrawerUpdateSubcontractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractNoteDrawerUpdateSubcontractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractNoteDrawerUpdateSubcontractMutation, { data, loading, error }] = useContractNoteDrawerUpdateSubcontractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useContractNoteDrawerUpdateSubcontractMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractNoteDrawerUpdateSubcontractMutation, ContractNoteDrawerUpdateSubcontractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractNoteDrawerUpdateSubcontractDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractNoteDrawerUpdateSubcontractMutation, ContractNoteDrawerUpdateSubcontractMutationVariables>(ContractNoteDrawerUpdateSubcontractDocument, parser(options)));
      }
export type ContractNoteDrawerUpdateSubcontractMutationHookResult = ReturnType<typeof useContractNoteDrawerUpdateSubcontractMutation>;
export type ContractNoteDrawerUpdateSubcontractMutationResult = ApolloReact.MutationResult<ContractNoteDrawerUpdateSubcontractMutation>;
export type ContractNoteDrawerUpdateSubcontractMutationOptions = Apollo.MutationOptions<ContractNoteDrawerUpdateSubcontractMutation, ContractNoteDrawerUpdateSubcontractMutationVariables>;
export const ContractNoteDrawerUpdateB2BDraftDocument = /*#__PURE__*/ gql`
    mutation ContractNoteDrawer_UpdateB2BDraft($userId: UserId!, $entityVersion: EntityVersion!, $userEntityVersion: EntityVersion!, $notes: ClearableStringInput) {
  user(userId: $userId, entityVersion: $entityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateB2bDraft(notes: $notes) {
        ...NfsError
        ... on B2BContractDraft {
          id
          entityVersion
          notes
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useContractNoteDrawerUpdateB2BDraftMutation__
 *
 * To run a mutation, you first call `useContractNoteDrawerUpdateB2BDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractNoteDrawerUpdateB2BDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractNoteDrawerUpdateB2BDraftMutation, { data, loading, error }] = useContractNoteDrawerUpdateB2BDraftMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useContractNoteDrawerUpdateB2BDraftMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractNoteDrawerUpdateB2BDraftMutation, ContractNoteDrawerUpdateB2BDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractNoteDrawerUpdateB2BDraftDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractNoteDrawerUpdateB2BDraftMutation, ContractNoteDrawerUpdateB2BDraftMutationVariables>(ContractNoteDrawerUpdateB2BDraftDocument, parser(options)));
      }
export type ContractNoteDrawerUpdateB2BDraftMutationHookResult = ReturnType<typeof useContractNoteDrawerUpdateB2BDraftMutation>;
export type ContractNoteDrawerUpdateB2BDraftMutationResult = ApolloReact.MutationResult<ContractNoteDrawerUpdateB2BDraftMutation>;
export type ContractNoteDrawerUpdateB2BDraftMutationOptions = Apollo.MutationOptions<ContractNoteDrawerUpdateB2BDraftMutation, ContractNoteDrawerUpdateB2BDraftMutationVariables>;
export const ContractNoteDrawerUpdateEmploymentDraftDocument = /*#__PURE__*/ gql`
    mutation ContractNoteDrawer_UpdateEmploymentDraft($userId: UserId!, $entityVersion: EntityVersion!, $userEntityVersion: EntityVersion!, $notes: ClearableStringInput) {
  user(userId: $userId, entityVersion: $entityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateEmploymentDraft(notes: $notes) {
        ...NfsError
        ... on EmploymentContractDraft {
          id
          entityVersion
          notes
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useContractNoteDrawerUpdateEmploymentDraftMutation__
 *
 * To run a mutation, you first call `useContractNoteDrawerUpdateEmploymentDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractNoteDrawerUpdateEmploymentDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractNoteDrawerUpdateEmploymentDraftMutation, { data, loading, error }] = useContractNoteDrawerUpdateEmploymentDraftMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useContractNoteDrawerUpdateEmploymentDraftMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractNoteDrawerUpdateEmploymentDraftMutation, ContractNoteDrawerUpdateEmploymentDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractNoteDrawerUpdateEmploymentDraftDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractNoteDrawerUpdateEmploymentDraftMutation, ContractNoteDrawerUpdateEmploymentDraftMutationVariables>(ContractNoteDrawerUpdateEmploymentDraftDocument, parser(options)));
      }
export type ContractNoteDrawerUpdateEmploymentDraftMutationHookResult = ReturnType<typeof useContractNoteDrawerUpdateEmploymentDraftMutation>;
export type ContractNoteDrawerUpdateEmploymentDraftMutationResult = ApolloReact.MutationResult<ContractNoteDrawerUpdateEmploymentDraftMutation>;
export type ContractNoteDrawerUpdateEmploymentDraftMutationOptions = Apollo.MutationOptions<ContractNoteDrawerUpdateEmploymentDraftMutation, ContractNoteDrawerUpdateEmploymentDraftMutationVariables>;
export const ContractNoteDrawerUpdateSubcontractDraftDocument = /*#__PURE__*/ gql`
    mutation ContractNoteDrawer_UpdateSubcontractDraft($userId: UserId!, $entityVersion: EntityVersion!, $userEntityVersion: EntityVersion!, $notes: ClearableStringInput) {
  user(userId: $userId, entityVersion: $entityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateSubcontractDraft(notes: $notes) {
        ...NfsError
        ... on SubcontractDraft {
          id
          entityVersion
          notes
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useContractNoteDrawerUpdateSubcontractDraftMutation__
 *
 * To run a mutation, you first call `useContractNoteDrawerUpdateSubcontractDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractNoteDrawerUpdateSubcontractDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractNoteDrawerUpdateSubcontractDraftMutation, { data, loading, error }] = useContractNoteDrawerUpdateSubcontractDraftMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useContractNoteDrawerUpdateSubcontractDraftMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractNoteDrawerUpdateSubcontractDraftMutation, ContractNoteDrawerUpdateSubcontractDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractNoteDrawerUpdateSubcontractDraftDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractNoteDrawerUpdateSubcontractDraftMutation, ContractNoteDrawerUpdateSubcontractDraftMutationVariables>(ContractNoteDrawerUpdateSubcontractDraftDocument, parser(options)));
      }
export type ContractNoteDrawerUpdateSubcontractDraftMutationHookResult = ReturnType<typeof useContractNoteDrawerUpdateSubcontractDraftMutation>;
export type ContractNoteDrawerUpdateSubcontractDraftMutationResult = ApolloReact.MutationResult<ContractNoteDrawerUpdateSubcontractDraftMutation>;
export type ContractNoteDrawerUpdateSubcontractDraftMutationOptions = Apollo.MutationOptions<ContractNoteDrawerUpdateSubcontractDraftMutation, ContractNoteDrawerUpdateSubcontractDraftMutationVariables>;
export const ContractPaymentDetailsDocument = /*#__PURE__*/ gql`
    query ContractPaymentDetails($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        ...ContractPaymentDetails_FutureUpdates
        promisee {
          id
          entityVersion
        }
        ... on B2BContract {
          b2bContractType: type
          vat {
            ...Unauthorized
            ... on AccessGranted__TimeBasedVatType {
              value {
                value {
                  ...VatType
                }
              }
            }
          }
        }
        ... on EmploymentContract {
          type
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractPaymentDetailsFutureUpdatesFragmentDoc}
${UnauthorizedFragmentDoc}
${VatTypeFragmentDoc}`;

/**
 * __useContractPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useContractPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractPaymentDetailsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useContractPaymentDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<ContractPaymentDetailsQuery, ContractPaymentDetailsQueryVariables> & ({ variables: ContractPaymentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractPaymentDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractPaymentDetailsQuery, ContractPaymentDetailsQueryVariables>(ContractPaymentDetailsDocument, parser(options)));
      }
export function useContractPaymentDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractPaymentDetailsQuery, ContractPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractPaymentDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractPaymentDetailsQuery, ContractPaymentDetailsQueryVariables>(ContractPaymentDetailsDocument, options));
        }

export type ContractPaymentDetailsQueryResult = ApolloReact.QueryResult<ContractPaymentDetailsQuery, ContractPaymentDetailsQueryVariables>;
export function refetchContractPaymentDetailsQuery(variables: ContractPaymentDetailsQueryVariables) {
      return { query: ContractPaymentDetailsDocument, variables: variables }
    }
export const ContractPaymentDetailsDiscardActivitiesDocument = /*#__PURE__*/ gql`
    mutation ContractPaymentDetails_DiscardActivities($contractId: ContractId!, $entityVersion: EntityVersion!, $activityIds: [ActivityId!]!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    cancelActivities(activityIds: $activityIds) {
      ...NfsError
      ... on ContractResponse {
        value {
          ...ContractPaymentDetails_FutureUpdates
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ContractPaymentDetailsFutureUpdatesFragmentDoc}`;


/**
 * __useContractPaymentDetailsDiscardActivitiesMutation__
 *
 * To run a mutation, you first call `useContractPaymentDetailsDiscardActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractPaymentDetailsDiscardActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractPaymentDetailsDiscardActivitiesMutation, { data, loading, error }] = useContractPaymentDetailsDiscardActivitiesMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      activityIds: // value for 'activityIds'
 *   },
 * });
 */
export function useContractPaymentDetailsDiscardActivitiesMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractPaymentDetailsDiscardActivitiesMutation, ContractPaymentDetailsDiscardActivitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractPaymentDetailsDiscardActivitiesDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractPaymentDetailsDiscardActivitiesMutation, ContractPaymentDetailsDiscardActivitiesMutationVariables>(ContractPaymentDetailsDiscardActivitiesDocument, parser(options)));
      }
export type ContractPaymentDetailsDiscardActivitiesMutationHookResult = ReturnType<typeof useContractPaymentDetailsDiscardActivitiesMutation>;
export type ContractPaymentDetailsDiscardActivitiesMutationResult = ApolloReact.MutationResult<ContractPaymentDetailsDiscardActivitiesMutation>;
export type ContractPaymentDetailsDiscardActivitiesMutationOptions = Apollo.MutationOptions<ContractPaymentDetailsDiscardActivitiesMutation, ContractPaymentDetailsDiscardActivitiesMutationVariables>;
export const ContractsAndBenefitsDocument = /*#__PURE__*/ gql`
    query ContractsAndBenefits($userId: UserId!) {
  benefits {
    ...NfsError
    ... on ListOfBenefitGroupResponse {
      value {
        benefits {
          manyOf {
            alternativeBenefitsGroupId
            oneOf {
              id
            }
          }
        }
      }
    }
  }
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      firstName
      lastName
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            id
            entityVersion
            name
            startDate
            expectedEndDate
            notes
            promisee {
              id
              entityVersion
            }
            promisor {
              id
              entityVersion
              name
              logo
            }
            ... on B2BContractDraft {
              conclusionDate
              b2bContractType: type
              promisorRepresentative
              documentTemplate
              conclusionLocation
            }
            ... on EmploymentContractDraft {
              type
              conclusionDate
              promisorRepresentative
              documentTemplate
              conclusionLocation
            }
            ... on SubcontractDraft {
              clientContract {
                id
                name {
                  ...Unauthorized
                  ... on AccessGranted__String {
                    value
                  }
                }
                promisee {
                  id
                  name
                }
              }
            }
          }
        }
      }
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            entityVersion
            status
            name
            notes {
              ...Unauthorized
              ... on AccessGranted__OptionalString {
                value
              }
            }
            createdAt
            startDate
            conclusionDate {
              ...Unauthorized
              ... on AccessGranted__LocalDate {
                value
              }
            }
            expectedEndDate
            terminationDate
            promisee {
              id
              entityVersion
            }
            promisor {
              value {
                id
                entityVersion
                name
                logo
              }
            }
            ... on B2BContract {
              b2bContractType: type
              fileUri {
                ...Unauthorized
                ... on AccessGranted__OptionalURI {
                  value
                }
              }
            }
            ... on EmploymentContract {
              type
              fileUri {
                ...Unauthorized
                ... on AccessGranted__OptionalURI {
                  value
                }
              }
            }
            ... on Subcontract {
              id
              clientContract {
                ...Unauthorized
                ... on AccessGranted__ClientContract {
                  value {
                    id
                    promisee {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useContractsAndBenefitsQuery__
 *
 * To run a query within a React component, call `useContractsAndBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsAndBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsAndBenefitsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useContractsAndBenefitsQuery(baseOptions: ApolloReact.QueryHookOptions<ContractsAndBenefitsQuery, ContractsAndBenefitsQueryVariables> & ({ variables: ContractsAndBenefitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractsAndBenefitsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractsAndBenefitsQuery, ContractsAndBenefitsQueryVariables>(ContractsAndBenefitsDocument, parser(options)));
      }
export function useContractsAndBenefitsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractsAndBenefitsQuery, ContractsAndBenefitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractsAndBenefitsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractsAndBenefitsQuery, ContractsAndBenefitsQueryVariables>(ContractsAndBenefitsDocument, options));
        }

export type ContractsAndBenefitsQueryResult = ApolloReact.QueryResult<ContractsAndBenefitsQuery, ContractsAndBenefitsQueryVariables>;
export function refetchContractsAndBenefitsQuery(variables: ContractsAndBenefitsQueryVariables) {
      return { query: ContractsAndBenefitsDocument, variables: variables }
    }
export const ContractsAndBenefitsDeleteDraftDocument = /*#__PURE__*/ gql`
    mutation ContractsAndBenefits_DeleteDraft($userId: UserId!, $userEntityVersion: EntityVersion!, $entityVersion: EntityVersion!) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      delete {
        ...NfsError
        ... on BooleanResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useContractsAndBenefitsDeleteDraftMutation__
 *
 * To run a mutation, you first call `useContractsAndBenefitsDeleteDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractsAndBenefitsDeleteDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractsAndBenefitsDeleteDraftMutation, { data, loading, error }] = useContractsAndBenefitsDeleteDraftMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useContractsAndBenefitsDeleteDraftMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractsAndBenefitsDeleteDraftMutation, ContractsAndBenefitsDeleteDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractsAndBenefitsDeleteDraftDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractsAndBenefitsDeleteDraftMutation, ContractsAndBenefitsDeleteDraftMutationVariables>(ContractsAndBenefitsDeleteDraftDocument, parser(options)));
      }
export type ContractsAndBenefitsDeleteDraftMutationHookResult = ReturnType<typeof useContractsAndBenefitsDeleteDraftMutation>;
export type ContractsAndBenefitsDeleteDraftMutationResult = ApolloReact.MutationResult<ContractsAndBenefitsDeleteDraftMutation>;
export type ContractsAndBenefitsDeleteDraftMutationOptions = Apollo.MutationOptions<ContractsAndBenefitsDeleteDraftMutation, ContractsAndBenefitsDeleteDraftMutationVariables>;
export const ContractsAndBenefitsConcludeDraftDocument = /*#__PURE__*/ gql`
    mutation ContractsAndBenefits_ConcludeDraft($userId: UserId!, $entityVersion: EntityVersion!, $userEntityVersion: EntityVersion!, $date: LocalDate!, $conclusionLocation: String!, $promisorRepresentative: String!, $documentTemplate: ContractDocumentTemplate) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      conclude(
        conclusionDate: $date
        conclusionLocation: $conclusionLocation
        promisorRepresentative: $promisorRepresentative
        documentTemplate: $documentTemplate
      ) {
        ...NfsError
        ... on ContractResponse {
          value {
            id
            entityVersion
            ... on EmploymentContract {
              fileUri {
                ...Unauthorized
                ... on AccessGranted__OptionalURI {
                  value
                }
              }
            }
            ... on B2BContract {
              fileUri {
                ...Unauthorized
                ... on AccessGranted__OptionalURI {
                  value
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;


/**
 * __useContractsAndBenefitsConcludeDraftMutation__
 *
 * To run a mutation, you first call `useContractsAndBenefitsConcludeDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractsAndBenefitsConcludeDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractsAndBenefitsConcludeDraftMutation, { data, loading, error }] = useContractsAndBenefitsConcludeDraftMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      date: // value for 'date'
 *      conclusionLocation: // value for 'conclusionLocation'
 *      promisorRepresentative: // value for 'promisorRepresentative'
 *      documentTemplate: // value for 'documentTemplate'
 *   },
 * });
 */
export function useContractsAndBenefitsConcludeDraftMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractsAndBenefitsConcludeDraftMutation, ContractsAndBenefitsConcludeDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractsAndBenefitsConcludeDraftDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractsAndBenefitsConcludeDraftMutation, ContractsAndBenefitsConcludeDraftMutationVariables>(ContractsAndBenefitsConcludeDraftDocument, parser(options)));
      }
export type ContractsAndBenefitsConcludeDraftMutationHookResult = ReturnType<typeof useContractsAndBenefitsConcludeDraftMutation>;
export type ContractsAndBenefitsConcludeDraftMutationResult = ApolloReact.MutationResult<ContractsAndBenefitsConcludeDraftMutation>;
export type ContractsAndBenefitsConcludeDraftMutationOptions = Apollo.MutationOptions<ContractsAndBenefitsConcludeDraftMutation, ContractsAndBenefitsConcludeDraftMutationVariables>;
export const ContractsAndBenefitsConcludeSubcontractDraftDocument = /*#__PURE__*/ gql`
    mutation ContractsAndBenefits_ConcludeSubcontractDraft($userId: UserId!, $entityVersion: EntityVersion!, $userEntityVersion: EntityVersion!, $date: LocalDate!) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      concludeSubcontract(conclusionDate: $date) {
        ...NfsError
        ... on ContractResponse {
          value {
            id
            entityVersion
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useContractsAndBenefitsConcludeSubcontractDraftMutation__
 *
 * To run a mutation, you first call `useContractsAndBenefitsConcludeSubcontractDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractsAndBenefitsConcludeSubcontractDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractsAndBenefitsConcludeSubcontractDraftMutation, { data, loading, error }] = useContractsAndBenefitsConcludeSubcontractDraftMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useContractsAndBenefitsConcludeSubcontractDraftMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractsAndBenefitsConcludeSubcontractDraftMutation, ContractsAndBenefitsConcludeSubcontractDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractsAndBenefitsConcludeSubcontractDraftDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractsAndBenefitsConcludeSubcontractDraftMutation, ContractsAndBenefitsConcludeSubcontractDraftMutationVariables>(ContractsAndBenefitsConcludeSubcontractDraftDocument, parser(options)));
      }
export type ContractsAndBenefitsConcludeSubcontractDraftMutationHookResult = ReturnType<typeof useContractsAndBenefitsConcludeSubcontractDraftMutation>;
export type ContractsAndBenefitsConcludeSubcontractDraftMutationResult = ApolloReact.MutationResult<ContractsAndBenefitsConcludeSubcontractDraftMutation>;
export type ContractsAndBenefitsConcludeSubcontractDraftMutationOptions = Apollo.MutationOptions<ContractsAndBenefitsConcludeSubcontractDraftMutation, ContractsAndBenefitsConcludeSubcontractDraftMutationVariables>;
export const ContractsAndBenefitsDraftPreviewDocument = /*#__PURE__*/ gql`
    mutation ContractsAndBenefits_DraftPreview($userId: UserId!, $entityVersion: EntityVersion!, $userEntityVersion: EntityVersion!, $date: LocalDate, $conclusionLocation: String, $promisorRepresentative: String, $documentTemplate: ContractDocumentTemplate!) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      generateContractDraftPreview(
        conclusionDate: $date
        conclusionLocation: $conclusionLocation
        promisorRepresentative: $promisorRepresentative
        documentTemplate: $documentTemplate
      ) {
        ...NfsError
        ... on DraftPreviewResponse {
          fileUrl {
            url
          }
          draft {
            ... on EmploymentContractDraft {
              id
              entityVersion
              conclusionDate
              conclusionLocation
              promisorRepresentative
              documentTemplate
            }
            ... on B2BContractDraft {
              id
              entityVersion
              conclusionDate
              conclusionLocation
              promisorRepresentative
              documentTemplate
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useContractsAndBenefitsDraftPreviewMutation__
 *
 * To run a mutation, you first call `useContractsAndBenefitsDraftPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractsAndBenefitsDraftPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractsAndBenefitsDraftPreviewMutation, { data, loading, error }] = useContractsAndBenefitsDraftPreviewMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      date: // value for 'date'
 *      conclusionLocation: // value for 'conclusionLocation'
 *      promisorRepresentative: // value for 'promisorRepresentative'
 *      documentTemplate: // value for 'documentTemplate'
 *   },
 * });
 */
export function useContractsAndBenefitsDraftPreviewMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractsAndBenefitsDraftPreviewMutation, ContractsAndBenefitsDraftPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractsAndBenefitsDraftPreviewDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractsAndBenefitsDraftPreviewMutation, ContractsAndBenefitsDraftPreviewMutationVariables>(ContractsAndBenefitsDraftPreviewDocument, parser(options)));
      }
export type ContractsAndBenefitsDraftPreviewMutationHookResult = ReturnType<typeof useContractsAndBenefitsDraftPreviewMutation>;
export type ContractsAndBenefitsDraftPreviewMutationResult = ApolloReact.MutationResult<ContractsAndBenefitsDraftPreviewMutation>;
export type ContractsAndBenefitsDraftPreviewMutationOptions = Apollo.MutationOptions<ContractsAndBenefitsDraftPreviewMutation, ContractsAndBenefitsDraftPreviewMutationVariables>;
export const ContractsAndBenefitsRegenerateFileDocument = /*#__PURE__*/ gql`
    mutation ContractsAndBenefits_RegenerateFile($contractId: ContractId!, $entityVersion: EntityVersion!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    regenerateContractGoogleDoc {
      ...NfsError
      ... on URIResponse {
        value
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useContractsAndBenefitsRegenerateFileMutation__
 *
 * To run a mutation, you first call `useContractsAndBenefitsRegenerateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractsAndBenefitsRegenerateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractsAndBenefitsRegenerateFileMutation, { data, loading, error }] = useContractsAndBenefitsRegenerateFileMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useContractsAndBenefitsRegenerateFileMutation(baseOptions?: ApolloReact.MutationHookOptions<ContractsAndBenefitsRegenerateFileMutation, ContractsAndBenefitsRegenerateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractsAndBenefitsRegenerateFileDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ContractsAndBenefitsRegenerateFileMutation, ContractsAndBenefitsRegenerateFileMutationVariables>(ContractsAndBenefitsRegenerateFileDocument, parser(options)));
      }
export type ContractsAndBenefitsRegenerateFileMutationHookResult = ReturnType<typeof useContractsAndBenefitsRegenerateFileMutation>;
export type ContractsAndBenefitsRegenerateFileMutationResult = ApolloReact.MutationResult<ContractsAndBenefitsRegenerateFileMutation>;
export type ContractsAndBenefitsRegenerateFileMutationOptions = Apollo.MutationOptions<ContractsAndBenefitsRegenerateFileMutation, ContractsAndBenefitsRegenerateFileMutationVariables>;
export const CostAndRevenueItemDrawerInputDocument = /*#__PURE__*/ gql`
    query CostAndRevenueItemDrawer_Input($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      ...CostAndRevenueItemDrawer_Project
    }
  }
}
    ${NfsErrorFragmentDoc}
${CostAndRevenueItemDrawerProjectFragmentDoc}`;

/**
 * __useCostAndRevenueItemDrawerInputQuery__
 *
 * To run a query within a React component, call `useCostAndRevenueItemDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostAndRevenueItemDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostAndRevenueItemDrawerInputQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCostAndRevenueItemDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<CostAndRevenueItemDrawerInputQuery, CostAndRevenueItemDrawerInputQueryVariables> & ({ variables: CostAndRevenueItemDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CostAndRevenueItemDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CostAndRevenueItemDrawerInputQuery, CostAndRevenueItemDrawerInputQueryVariables>(CostAndRevenueItemDrawerInputDocument, parser(options)));
      }
export function useCostAndRevenueItemDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CostAndRevenueItemDrawerInputQuery, CostAndRevenueItemDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CostAndRevenueItemDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CostAndRevenueItemDrawerInputQuery, CostAndRevenueItemDrawerInputQueryVariables>(CostAndRevenueItemDrawerInputDocument, options));
        }

export type CostAndRevenueItemDrawerInputQueryResult = ApolloReact.QueryResult<CostAndRevenueItemDrawerInputQuery, CostAndRevenueItemDrawerInputQueryVariables>;
export function refetchCostAndRevenueItemDrawerInputQuery(variables: CostAndRevenueItemDrawerInputQueryVariables) {
      return { query: CostAndRevenueItemDrawerInputDocument, variables: variables }
    }
export const CostAndRevenueItemDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation CostAndRevenueItemDrawer_Update($projectId: ProjectId!, $entityVersion: EntityVersion!, $costAndRevenueItems: [CostAndRevenueItemInput!]) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    update(costAndRevenueItems: $costAndRevenueItems) {
      ...NfsError
      ... on Project {
        ...CostAndRevenueItemDrawer_Project
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CostAndRevenueItemDrawerProjectFragmentDoc}`;


/**
 * __useCostAndRevenueItemDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useCostAndRevenueItemDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCostAndRevenueItemDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [costAndRevenueItemDrawerUpdateMutation, { data, loading, error }] = useCostAndRevenueItemDrawerUpdateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      costAndRevenueItems: // value for 'costAndRevenueItems'
 *   },
 * });
 */
export function useCostAndRevenueItemDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<CostAndRevenueItemDrawerUpdateMutation, CostAndRevenueItemDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CostAndRevenueItemDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CostAndRevenueItemDrawerUpdateMutation, CostAndRevenueItemDrawerUpdateMutationVariables>(CostAndRevenueItemDrawerUpdateDocument, parser(options)));
      }
export type CostAndRevenueItemDrawerUpdateMutationHookResult = ReturnType<typeof useCostAndRevenueItemDrawerUpdateMutation>;
export type CostAndRevenueItemDrawerUpdateMutationResult = ApolloReact.MutationResult<CostAndRevenueItemDrawerUpdateMutation>;
export type CostAndRevenueItemDrawerUpdateMutationOptions = Apollo.MutationOptions<CostAndRevenueItemDrawerUpdateMutation, CostAndRevenueItemDrawerUpdateMutationVariables>;
export const CostSummariesDrawerDocument = /*#__PURE__*/ gql`
    query CostSummariesDrawer($filter: FilterContractInput!, $range: ClosedEndMonthRangeInput!) {
  contractsCostsSummary(filter: $filter, range: $range) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useCostSummariesDrawerQuery__
 *
 * To run a query within a React component, call `useCostSummariesDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostSummariesDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostSummariesDrawerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useCostSummariesDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<CostSummariesDrawerQuery, CostSummariesDrawerQueryVariables> & ({ variables: CostSummariesDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CostSummariesDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CostSummariesDrawerQuery, CostSummariesDrawerQueryVariables>(CostSummariesDrawerDocument, parser(options)));
      }
export function useCostSummariesDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CostSummariesDrawerQuery, CostSummariesDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CostSummariesDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CostSummariesDrawerQuery, CostSummariesDrawerQueryVariables>(CostSummariesDrawerDocument, options));
        }

export type CostSummariesDrawerQueryResult = ApolloReact.QueryResult<CostSummariesDrawerQuery, CostSummariesDrawerQueryVariables>;
export function refetchCostSummariesDrawerQuery(variables: CostSummariesDrawerQueryVariables) {
      return { query: CostSummariesDrawerDocument, variables: variables }
    }
export const CreateBenefitDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation CreateBenefitDrawer_Create($id: BenefitId!, $groupType: BenefitGroupType!, $alternativeBenefitsGroupId: AlternativeBenefitsGroupId!, $name: String!, $startDate: LocalDate!, $endDate: LocalDate) {
  createBenefit(
    id: $id
    groupType: $groupType
    alternativeBenefitsGroupId: $alternativeBenefitsGroupId
    name: $name
    startDate: $startDate
    endDate: $endDate
  ) {
    ...NfsError
    ... on Benefit {
      id
      entityVersion
      name
      startDate
      endDate
      parent
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useCreateBenefitDrawerCreateMutation__
 *
 * To run a mutation, you first call `useCreateBenefitDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBenefitDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBenefitDrawerCreateMutation, { data, loading, error }] = useCreateBenefitDrawerCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      groupType: // value for 'groupType'
 *      alternativeBenefitsGroupId: // value for 'alternativeBenefitsGroupId'
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreateBenefitDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<CreateBenefitDrawerCreateMutation, CreateBenefitDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CreateBenefitDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CreateBenefitDrawerCreateMutation, CreateBenefitDrawerCreateMutationVariables>(CreateBenefitDrawerCreateDocument, parser(options)));
      }
export type CreateBenefitDrawerCreateMutationHookResult = ReturnType<typeof useCreateBenefitDrawerCreateMutation>;
export type CreateBenefitDrawerCreateMutationResult = ApolloReact.MutationResult<CreateBenefitDrawerCreateMutation>;
export type CreateBenefitDrawerCreateMutationOptions = Apollo.MutationOptions<CreateBenefitDrawerCreateMutation, CreateBenefitDrawerCreateMutationVariables>;
export const CreateVariantDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query CreateVariantDrawer_InitialData($id: BenefitId!) {
  benefit(id: $id) {
    ...NfsError
    ... on Benefit {
      id
      entityVersion
      name
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useCreateVariantDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useCreateVariantDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateVariantDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateVariantDrawerInitialDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateVariantDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<CreateVariantDrawerInitialDataQuery, CreateVariantDrawerInitialDataQueryVariables> & ({ variables: CreateVariantDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CreateVariantDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CreateVariantDrawerInitialDataQuery, CreateVariantDrawerInitialDataQueryVariables>(CreateVariantDrawerInitialDataDocument, parser(options)));
      }
export function useCreateVariantDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CreateVariantDrawerInitialDataQuery, CreateVariantDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CreateVariantDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CreateVariantDrawerInitialDataQuery, CreateVariantDrawerInitialDataQueryVariables>(CreateVariantDrawerInitialDataDocument, options));
        }

export type CreateVariantDrawerInitialDataQueryResult = ApolloReact.QueryResult<CreateVariantDrawerInitialDataQuery, CreateVariantDrawerInitialDataQueryVariables>;
export function refetchCreateVariantDrawerInitialDataQuery(variables: CreateVariantDrawerInitialDataQueryVariables) {
      return { query: CreateVariantDrawerInitialDataDocument, variables: variables }
    }
export const CreateVariantDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation CreateVariantDrawer_Create($id: BenefitVariantId!, $parentId: BenefitId!, $parentEntityVersion: EntityVersion!, $productId: BenefitVariantProductId!, $productName: String!, $startDate: LocalDate!, $endDate: LocalDate, $contractTypes: [ContractType!]!, $promiseeRate: BenefitVariantRateInput, $promisorRate: BenefitVariantRateInput, $additionalPeople: BenefitAdditionalPeopleInput, $meansOfProduction: Boolean!, $buyerType: BenefitBuyerType!, $invoiceCategory: BenefitInvoiceCategory!, $description: String, $computationBias: MoneyComputationBias!) {
  benefit(id: $parentId, entityVersion: $parentEntityVersion) {
    createBenefitVariant(
      id: $id
      productId: $productId
      productName: $productName
      parentId: $parentId
      contractTypes: $contractTypes
      promiseeRate: $promiseeRate
      promisorRate: $promisorRate
      additionalPeople: $additionalPeople
      meansOfProduction: $meansOfProduction
      buyerType: $buyerType
      invoiceCategory: $invoiceCategory
      startDate: $startDate
      endDate: $endDate
      description: $description
      computationBias: $computationBias
    ) {
      ...NfsError
      ... on BenefitVariant {
        id
        entityVersion
        parent {
          id
        }
        productId
        productName
        contractTypes
        promiseeRate {
          value {
            ...BenefitVariantRate
          }
        }
        promisorRate {
          value {
            ...BenefitVariantRate
          }
        }
        additionalPeople {
          ...BenefitAdditionalPeople
        }
        meansOfProduction
        buyerType
        invoiceCategory
        startDate
        endDate
        description
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BenefitVariantRateFragmentDoc}
${BenefitAdditionalPeopleFragmentDoc}`;


/**
 * __useCreateVariantDrawerCreateMutation__
 *
 * To run a mutation, you first call `useCreateVariantDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVariantDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVariantDrawerCreateMutation, { data, loading, error }] = useCreateVariantDrawerCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      parentId: // value for 'parentId'
 *      parentEntityVersion: // value for 'parentEntityVersion'
 *      productId: // value for 'productId'
 *      productName: // value for 'productName'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      contractTypes: // value for 'contractTypes'
 *      promiseeRate: // value for 'promiseeRate'
 *      promisorRate: // value for 'promisorRate'
 *      additionalPeople: // value for 'additionalPeople'
 *      meansOfProduction: // value for 'meansOfProduction'
 *      buyerType: // value for 'buyerType'
 *      invoiceCategory: // value for 'invoiceCategory'
 *      description: // value for 'description'
 *      computationBias: // value for 'computationBias'
 *   },
 * });
 */
export function useCreateVariantDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<CreateVariantDrawerCreateMutation, CreateVariantDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CreateVariantDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<CreateVariantDrawerCreateMutation, CreateVariantDrawerCreateMutationVariables>(CreateVariantDrawerCreateDocument, parser(options)));
      }
export type CreateVariantDrawerCreateMutationHookResult = ReturnType<typeof useCreateVariantDrawerCreateMutation>;
export type CreateVariantDrawerCreateMutationResult = ApolloReact.MutationResult<CreateVariantDrawerCreateMutation>;
export type CreateVariantDrawerCreateMutationOptions = Apollo.MutationOptions<CreateVariantDrawerCreateMutation, CreateVariantDrawerCreateMutationVariables>;
export const DeskAssignmentDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query DeskAssignmentDrawer_InitialData($officeId: OfficeId!) {
  officeCatalogue(officeId: $officeId) {
    ...NfsError
    ... on OfficeCatalogue {
      rooms {
        id
        name
        restrictedToSpaceId
        desks {
          id
          name
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useDeskAssignmentDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useDeskAssignmentDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeskAssignmentDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeskAssignmentDrawerInitialDataQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useDeskAssignmentDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<DeskAssignmentDrawerInitialDataQuery, DeskAssignmentDrawerInitialDataQueryVariables> & ({ variables: DeskAssignmentDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DeskAssignmentDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<DeskAssignmentDrawerInitialDataQuery, DeskAssignmentDrawerInitialDataQueryVariables>(DeskAssignmentDrawerInitialDataDocument, parser(options)));
      }
export function useDeskAssignmentDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<DeskAssignmentDrawerInitialDataQuery, DeskAssignmentDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(DeskAssignmentDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<DeskAssignmentDrawerInitialDataQuery, DeskAssignmentDrawerInitialDataQueryVariables>(DeskAssignmentDrawerInitialDataDocument, options));
        }

export type DeskAssignmentDrawerInitialDataQueryResult = ApolloReact.QueryResult<DeskAssignmentDrawerInitialDataQuery, DeskAssignmentDrawerInitialDataQueryVariables>;
export function refetchDeskAssignmentDrawerInitialDataQuery(variables: DeskAssignmentDrawerInitialDataQueryVariables) {
      return { query: DeskAssignmentDrawerInitialDataDocument, variables: variables }
    }
export const DeskAssignmentDrawerAssignmentsDocument = /*#__PURE__*/ gql`
    query DeskAssignmentDrawer_Assignments($officeId: OfficeId!) {
  deskAssignments(officeId: $officeId) {
    ...NfsError
    ... on ListOfDeskAssignmentResponse {
      value {
        ...DeskAssignmentDrawer_Assignment
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${DeskAssignmentDrawerAssignmentFragmentDoc}`;

/**
 * __useDeskAssignmentDrawerAssignmentsQuery__
 *
 * To run a query within a React component, call `useDeskAssignmentDrawerAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeskAssignmentDrawerAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeskAssignmentDrawerAssignmentsQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useDeskAssignmentDrawerAssignmentsQuery(baseOptions: ApolloReact.QueryHookOptions<DeskAssignmentDrawerAssignmentsQuery, DeskAssignmentDrawerAssignmentsQueryVariables> & ({ variables: DeskAssignmentDrawerAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DeskAssignmentDrawerAssignmentsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<DeskAssignmentDrawerAssignmentsQuery, DeskAssignmentDrawerAssignmentsQueryVariables>(DeskAssignmentDrawerAssignmentsDocument, parser(options)));
      }
export function useDeskAssignmentDrawerAssignmentsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<DeskAssignmentDrawerAssignmentsQuery, DeskAssignmentDrawerAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(DeskAssignmentDrawerAssignmentsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<DeskAssignmentDrawerAssignmentsQuery, DeskAssignmentDrawerAssignmentsQueryVariables>(DeskAssignmentDrawerAssignmentsDocument, options));
        }

export type DeskAssignmentDrawerAssignmentsQueryResult = ApolloReact.QueryResult<DeskAssignmentDrawerAssignmentsQuery, DeskAssignmentDrawerAssignmentsQueryVariables>;
export function refetchDeskAssignmentDrawerAssignmentsQuery(variables: DeskAssignmentDrawerAssignmentsQueryVariables) {
      return { query: DeskAssignmentDrawerAssignmentsDocument, variables: variables }
    }
export const DeskAssignmentDrawerAssignDocument = /*#__PURE__*/ gql`
    mutation DeskAssignmentDrawer_Assign($deskId: DeskId!, $userId: UserId!, $period: LocalDateRangeInput!) {
  assignDesk(deskId: $deskId, userId: $userId, period: $period) {
    ...NfsError
    ... on DeskAssignment {
      id
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useDeskAssignmentDrawerAssignMutation__
 *
 * To run a mutation, you first call `useDeskAssignmentDrawerAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeskAssignmentDrawerAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deskAssignmentDrawerAssignMutation, { data, loading, error }] = useDeskAssignmentDrawerAssignMutation({
 *   variables: {
 *      deskId: // value for 'deskId'
 *      userId: // value for 'userId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useDeskAssignmentDrawerAssignMutation(baseOptions?: ApolloReact.MutationHookOptions<DeskAssignmentDrawerAssignMutation, DeskAssignmentDrawerAssignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DeskAssignmentDrawerAssignDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<DeskAssignmentDrawerAssignMutation, DeskAssignmentDrawerAssignMutationVariables>(DeskAssignmentDrawerAssignDocument, parser(options)));
      }
export type DeskAssignmentDrawerAssignMutationHookResult = ReturnType<typeof useDeskAssignmentDrawerAssignMutation>;
export type DeskAssignmentDrawerAssignMutationResult = ApolloReact.MutationResult<DeskAssignmentDrawerAssignMutation>;
export type DeskAssignmentDrawerAssignMutationOptions = Apollo.MutationOptions<DeskAssignmentDrawerAssignMutation, DeskAssignmentDrawerAssignMutationVariables>;
export const DeskAssignmentDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation DeskAssignmentDrawer_Update($assignmentId: DeskAssignmentId!, $period: LocalDateRangeInput!) {
  updateDeskAssignment(assignmentId: $assignmentId, period: $period) {
    ...NfsError
    ... on DeskAssignment {
      id
      from
      to
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useDeskAssignmentDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useDeskAssignmentDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeskAssignmentDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deskAssignmentDrawerUpdateMutation, { data, loading, error }] = useDeskAssignmentDrawerUpdateMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useDeskAssignmentDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<DeskAssignmentDrawerUpdateMutation, DeskAssignmentDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DeskAssignmentDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<DeskAssignmentDrawerUpdateMutation, DeskAssignmentDrawerUpdateMutationVariables>(DeskAssignmentDrawerUpdateDocument, parser(options)));
      }
export type DeskAssignmentDrawerUpdateMutationHookResult = ReturnType<typeof useDeskAssignmentDrawerUpdateMutation>;
export type DeskAssignmentDrawerUpdateMutationResult = ApolloReact.MutationResult<DeskAssignmentDrawerUpdateMutation>;
export type DeskAssignmentDrawerUpdateMutationOptions = Apollo.MutationOptions<DeskAssignmentDrawerUpdateMutation, DeskAssignmentDrawerUpdateMutationVariables>;
export const DeskAssignmentDrawerDeleteDocument = /*#__PURE__*/ gql`
    mutation DeskAssignmentDrawer_Delete($assignmentId: DeskAssignmentId!) {
  deleteDeskAssignment(assignmentId: $assignmentId) {
    ...NfsError
    ... on DeskAssignment {
      id
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useDeskAssignmentDrawerDeleteMutation__
 *
 * To run a mutation, you first call `useDeskAssignmentDrawerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeskAssignmentDrawerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deskAssignmentDrawerDeleteMutation, { data, loading, error }] = useDeskAssignmentDrawerDeleteMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useDeskAssignmentDrawerDeleteMutation(baseOptions?: ApolloReact.MutationHookOptions<DeskAssignmentDrawerDeleteMutation, DeskAssignmentDrawerDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DeskAssignmentDrawerDeleteDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<DeskAssignmentDrawerDeleteMutation, DeskAssignmentDrawerDeleteMutationVariables>(DeskAssignmentDrawerDeleteDocument, parser(options)));
      }
export type DeskAssignmentDrawerDeleteMutationHookResult = ReturnType<typeof useDeskAssignmentDrawerDeleteMutation>;
export type DeskAssignmentDrawerDeleteMutationResult = ApolloReact.MutationResult<DeskAssignmentDrawerDeleteMutation>;
export type DeskAssignmentDrawerDeleteMutationOptions = Apollo.MutationOptions<DeskAssignmentDrawerDeleteMutation, DeskAssignmentDrawerDeleteMutationVariables>;
export const DeskAssignmentFormUserAutocompleteDocument = /*#__PURE__*/ gql`
    query DeskAssignmentForm_UserAutocomplete($after: Cursor, $filter: FilterUserInput!, $sort: SortingRequestSortUserInput, $first: Int!) {
  users(after: $after, filter: $filter, sort: $sort, first: $first) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      edges {
        cursor
        node {
          ...UserAutocomplete_User
          avatar
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserAutocompleteUserFragmentDoc}`;

/**
 * __useDeskAssignmentFormUserAutocompleteQuery__
 *
 * To run a query within a React component, call `useDeskAssignmentFormUserAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeskAssignmentFormUserAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeskAssignmentFormUserAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useDeskAssignmentFormUserAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<DeskAssignmentFormUserAutocompleteQuery, DeskAssignmentFormUserAutocompleteQueryVariables> & ({ variables: DeskAssignmentFormUserAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DeskAssignmentFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<DeskAssignmentFormUserAutocompleteQuery, DeskAssignmentFormUserAutocompleteQueryVariables>(DeskAssignmentFormUserAutocompleteDocument, parser(options)));
      }
export function useDeskAssignmentFormUserAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<DeskAssignmentFormUserAutocompleteQuery, DeskAssignmentFormUserAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(DeskAssignmentFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<DeskAssignmentFormUserAutocompleteQuery, DeskAssignmentFormUserAutocompleteQueryVariables>(DeskAssignmentFormUserAutocompleteDocument, options));
        }

export type DeskAssignmentFormUserAutocompleteQueryResult = ApolloReact.QueryResult<DeskAssignmentFormUserAutocompleteQuery, DeskAssignmentFormUserAutocompleteQueryVariables>;
export function refetchDeskAssignmentFormUserAutocompleteQuery(variables: DeskAssignmentFormUserAutocompleteQueryVariables) {
      return { query: DeskAssignmentFormUserAutocompleteDocument, variables: variables }
    }
export const DeskAssignmentFormBookingsDocument = /*#__PURE__*/ gql`
    query DeskAssignmentForm_Bookings($officeId: OfficeId!, $from: LocalDate!, $to: LocalDate, $first: Int!) {
  officeReservations(
    filter: {officeId_eq: $officeId, resourceKind_eq: Desk, date_gte: $from, date_lte: $to}
    first: $first
  ) {
    ...NfsError
    ... on FSPResponseOfficeReservation {
      edges {
        node {
          id
          requestId
          resource {
            id
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useDeskAssignmentFormBookingsQuery__
 *
 * To run a query within a React component, call `useDeskAssignmentFormBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeskAssignmentFormBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeskAssignmentFormBookingsQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useDeskAssignmentFormBookingsQuery(baseOptions: ApolloReact.QueryHookOptions<DeskAssignmentFormBookingsQuery, DeskAssignmentFormBookingsQueryVariables> & ({ variables: DeskAssignmentFormBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DeskAssignmentFormBookingsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<DeskAssignmentFormBookingsQuery, DeskAssignmentFormBookingsQueryVariables>(DeskAssignmentFormBookingsDocument, parser(options)));
      }
export function useDeskAssignmentFormBookingsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<DeskAssignmentFormBookingsQuery, DeskAssignmentFormBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(DeskAssignmentFormBookingsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<DeskAssignmentFormBookingsQuery, DeskAssignmentFormBookingsQueryVariables>(DeskAssignmentFormBookingsDocument, options));
        }

export type DeskAssignmentFormBookingsQueryResult = ApolloReact.QueryResult<DeskAssignmentFormBookingsQuery, DeskAssignmentFormBookingsQueryVariables>;
export function refetchDeskAssignmentFormBookingsQuery(variables: DeskAssignmentFormBookingsQueryVariables) {
      return { query: DeskAssignmentFormBookingsDocument, variables: variables }
    }
export const DeskDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query DeskDrawer_InitialData($officeId: OfficeId!) {
  officeCatalogue(officeId: $officeId) {
    ...NfsError
    ... on OfficeCatalogue {
      rooms {
        id
        desks {
          ...DeskDrawer_Desk
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${DeskDrawerDeskFragmentDoc}`;

/**
 * __useDeskDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useDeskDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeskDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeskDrawerInitialDataQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useDeskDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<DeskDrawerInitialDataQuery, DeskDrawerInitialDataQueryVariables> & ({ variables: DeskDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DeskDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<DeskDrawerInitialDataQuery, DeskDrawerInitialDataQueryVariables>(DeskDrawerInitialDataDocument, parser(options)));
      }
export function useDeskDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<DeskDrawerInitialDataQuery, DeskDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(DeskDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<DeskDrawerInitialDataQuery, DeskDrawerInitialDataQueryVariables>(DeskDrawerInitialDataDocument, options));
        }

export type DeskDrawerInitialDataQueryResult = ApolloReact.QueryResult<DeskDrawerInitialDataQuery, DeskDrawerInitialDataQueryVariables>;
export function refetchDeskDrawerInitialDataQuery(variables: DeskDrawerInitialDataQueryVariables) {
      return { query: DeskDrawerInitialDataDocument, variables: variables }
    }
export const DeskDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation DeskDrawer_Create($id: DeskId!, $roomId: RoomId!, $name: String!, $monitors: Int!, $standing: Boolean!, $pedestalNumber: String, $blocked: Boolean) {
  createDesk(
    id: $id
    roomId: $roomId
    name: $name
    monitors: $monitors
    standing: $standing
    pedestalNumber: $pedestalNumber
    blocked: $blocked
  ) {
    ...NfsError
    ... on Desk {
      ...OfficeCatalogue_Desk
    }
  }
}
    ${NfsErrorFragmentDoc}
${OfficeCatalogueDeskFragmentDoc}`;


/**
 * __useDeskDrawerCreateMutation__
 *
 * To run a mutation, you first call `useDeskDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeskDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deskDrawerCreateMutation, { data, loading, error }] = useDeskDrawerCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      roomId: // value for 'roomId'
 *      name: // value for 'name'
 *      monitors: // value for 'monitors'
 *      standing: // value for 'standing'
 *      pedestalNumber: // value for 'pedestalNumber'
 *      blocked: // value for 'blocked'
 *   },
 * });
 */
export function useDeskDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<DeskDrawerCreateMutation, DeskDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DeskDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<DeskDrawerCreateMutation, DeskDrawerCreateMutationVariables>(DeskDrawerCreateDocument, parser(options)));
      }
export type DeskDrawerCreateMutationHookResult = ReturnType<typeof useDeskDrawerCreateMutation>;
export type DeskDrawerCreateMutationResult = ApolloReact.MutationResult<DeskDrawerCreateMutation>;
export type DeskDrawerCreateMutationOptions = Apollo.MutationOptions<DeskDrawerCreateMutation, DeskDrawerCreateMutationVariables>;
export const DeskDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation DeskDrawer_Update($deskId: DeskId!, $desk: UpdateDeskInput!) {
  updateDesk(deskId: $deskId, desk: $desk) {
    ...NfsError
    ... on Desk {
      ...DeskDrawer_Desk
    }
  }
}
    ${NfsErrorFragmentDoc}
${DeskDrawerDeskFragmentDoc}`;


/**
 * __useDeskDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useDeskDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeskDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deskDrawerUpdateMutation, { data, loading, error }] = useDeskDrawerUpdateMutation({
 *   variables: {
 *      deskId: // value for 'deskId'
 *      desk: // value for 'desk'
 *   },
 * });
 */
export function useDeskDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<DeskDrawerUpdateMutation, DeskDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DeskDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<DeskDrawerUpdateMutation, DeskDrawerUpdateMutationVariables>(DeskDrawerUpdateDocument, parser(options)));
      }
export type DeskDrawerUpdateMutationHookResult = ReturnType<typeof useDeskDrawerUpdateMutation>;
export type DeskDrawerUpdateMutationResult = ApolloReact.MutationResult<DeskDrawerUpdateMutation>;
export type DeskDrawerUpdateMutationOptions = Apollo.MutationOptions<DeskDrawerUpdateMutation, DeskDrawerUpdateMutationVariables>;
export const DirectReportingDiscardDocument = /*#__PURE__*/ gql`
    mutation DirectReporting_Discard($activityIds: [ActivityId!]!, $userId: UserId!, $entityVersion: EntityVersion!) {
  user(userId: $userId, entityVersion: $entityVersion) {
    cancelActivities(activityIds: $activityIds) {
      ...NfsError
      ... on User {
        id
        entityVersion
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useDirectReportingDiscardMutation__
 *
 * To run a mutation, you first call `useDirectReportingDiscardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectReportingDiscardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directReportingDiscardMutation, { data, loading, error }] = useDirectReportingDiscardMutation({
 *   variables: {
 *      activityIds: // value for 'activityIds'
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useDirectReportingDiscardMutation(baseOptions?: ApolloReact.MutationHookOptions<DirectReportingDiscardMutation, DirectReportingDiscardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DirectReportingDiscardDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<DirectReportingDiscardMutation, DirectReportingDiscardMutationVariables>(DirectReportingDiscardDocument, parser(options)));
      }
export type DirectReportingDiscardMutationHookResult = ReturnType<typeof useDirectReportingDiscardMutation>;
export type DirectReportingDiscardMutationResult = ApolloReact.MutationResult<DirectReportingDiscardMutation>;
export type DirectReportingDiscardMutationOptions = Apollo.MutationOptions<DirectReportingDiscardMutation, DirectReportingDiscardMutationVariables>;
export const DirectReportingDrawerLoadDataDocument = /*#__PURE__*/ gql`
    query DirectReportingDrawer_LoadData($userId: UserId!, $at: OffsetDateTime) {
  user(id: $userId, at: $at) {
    ...NfsError
    ... on User {
      at
      ...DirectReportingDrawer_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${DirectReportingDrawerUserFragmentDoc}`;

/**
 * __useDirectReportingDrawerLoadDataQuery__
 *
 * To run a query within a React component, call `useDirectReportingDrawerLoadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectReportingDrawerLoadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectReportingDrawerLoadDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      at: // value for 'at'
 *   },
 * });
 */
export function useDirectReportingDrawerLoadDataQuery(baseOptions: ApolloReact.QueryHookOptions<DirectReportingDrawerLoadDataQuery, DirectReportingDrawerLoadDataQueryVariables> & ({ variables: DirectReportingDrawerLoadDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DirectReportingDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<DirectReportingDrawerLoadDataQuery, DirectReportingDrawerLoadDataQueryVariables>(DirectReportingDrawerLoadDataDocument, parser(options)));
      }
export function useDirectReportingDrawerLoadDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<DirectReportingDrawerLoadDataQuery, DirectReportingDrawerLoadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(DirectReportingDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<DirectReportingDrawerLoadDataQuery, DirectReportingDrawerLoadDataQueryVariables>(DirectReportingDrawerLoadDataDocument, options));
        }

export type DirectReportingDrawerLoadDataQueryResult = ApolloReact.QueryResult<DirectReportingDrawerLoadDataQuery, DirectReportingDrawerLoadDataQueryVariables>;
export function refetchDirectReportingDrawerLoadDataQuery(variables: DirectReportingDrawerLoadDataQueryVariables) {
      return { query: DirectReportingDrawerLoadDataDocument, variables: variables }
    }
export const DirectReportingDrawerUpdateUserDocument = /*#__PURE__*/ gql`
    mutation DirectReportingDrawer_UpdateUser($userId: UserId!, $entityVersion: EntityVersion!, $space: TimeBasedValueSpaceIdInput!, $primaryProjectId: TimeBasedValueClearableUserIdInput!, $practiceLead: TimeBasedValueClearableUserIdInput!, $operationalLead: TimeBasedValueClearableUserIdInput!, $role: TimeBasedValueCompanyRoleInput!) {
  user(userId: $userId, entityVersion: $entityVersion) {
    updateUser(
      space: $space
      primaryProjectId: $primaryProjectId
      practiceLead: $practiceLead
      operationalLead: $operationalLead
      role: $role
    ) {
      ...NfsError
      ... on User {
        ...DirectReportingDrawer_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${DirectReportingDrawerUserFragmentDoc}`;


/**
 * __useDirectReportingDrawerUpdateUserMutation__
 *
 * To run a mutation, you first call `useDirectReportingDrawerUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectReportingDrawerUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directReportingDrawerUpdateUserMutation, { data, loading, error }] = useDirectReportingDrawerUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      space: // value for 'space'
 *      primaryProjectId: // value for 'primaryProjectId'
 *      practiceLead: // value for 'practiceLead'
 *      operationalLead: // value for 'operationalLead'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useDirectReportingDrawerUpdateUserMutation(baseOptions?: ApolloReact.MutationHookOptions<DirectReportingDrawerUpdateUserMutation, DirectReportingDrawerUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DirectReportingDrawerUpdateUserDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<DirectReportingDrawerUpdateUserMutation, DirectReportingDrawerUpdateUserMutationVariables>(DirectReportingDrawerUpdateUserDocument, parser(options)));
      }
export type DirectReportingDrawerUpdateUserMutationHookResult = ReturnType<typeof useDirectReportingDrawerUpdateUserMutation>;
export type DirectReportingDrawerUpdateUserMutationResult = ApolloReact.MutationResult<DirectReportingDrawerUpdateUserMutation>;
export type DirectReportingDrawerUpdateUserMutationOptions = Apollo.MutationOptions<DirectReportingDrawerUpdateUserMutation, DirectReportingDrawerUpdateUserMutationVariables>;
export const DirectReportingDrawerPartialUpdateUserDocument = /*#__PURE__*/ gql`
    mutation DirectReportingDrawer_PartialUpdateUser($userId: UserId!, $entityVersion: EntityVersion!, $space: TimeBasedValueSpaceIdInput!, $primaryProjectId: TimeBasedValueClearableUserIdInput!, $practiceLead: TimeBasedValueClearableUserIdInput!, $operationalLead: TimeBasedValueClearableUserIdInput!) {
  user(userId: $userId, entityVersion: $entityVersion) {
    updateUserInvocingTeamScope(
      space: $space
      primaryProjectId: $primaryProjectId
      practiceLead: $practiceLead
      operationalLead: $operationalLead
    ) {
      ...NfsError
      ... on User {
        ...DirectReportingDrawer_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${DirectReportingDrawerUserFragmentDoc}`;


/**
 * __useDirectReportingDrawerPartialUpdateUserMutation__
 *
 * To run a mutation, you first call `useDirectReportingDrawerPartialUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectReportingDrawerPartialUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directReportingDrawerPartialUpdateUserMutation, { data, loading, error }] = useDirectReportingDrawerPartialUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      space: // value for 'space'
 *      primaryProjectId: // value for 'primaryProjectId'
 *      practiceLead: // value for 'practiceLead'
 *      operationalLead: // value for 'operationalLead'
 *   },
 * });
 */
export function useDirectReportingDrawerPartialUpdateUserMutation(baseOptions?: ApolloReact.MutationHookOptions<DirectReportingDrawerPartialUpdateUserMutation, DirectReportingDrawerPartialUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DirectReportingDrawerPartialUpdateUserDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<DirectReportingDrawerPartialUpdateUserMutation, DirectReportingDrawerPartialUpdateUserMutationVariables>(DirectReportingDrawerPartialUpdateUserDocument, parser(options)));
      }
export type DirectReportingDrawerPartialUpdateUserMutationHookResult = ReturnType<typeof useDirectReportingDrawerPartialUpdateUserMutation>;
export type DirectReportingDrawerPartialUpdateUserMutationResult = ApolloReact.MutationResult<DirectReportingDrawerPartialUpdateUserMutation>;
export type DirectReportingDrawerPartialUpdateUserMutationOptions = Apollo.MutationOptions<DirectReportingDrawerPartialUpdateUserMutation, DirectReportingDrawerPartialUpdateUserMutationVariables>;
export const DirectReportingDrawerUserAutocompleteDocument = /*#__PURE__*/ gql`
    query DirectReportingDrawer_UserAutocomplete($after: Cursor, $filter: FilterUserInput!, $sort: SortingRequestSortUserInput, $first: Int!) {
  users(filter: $filter, sort: $sort, first: $first, after: $after) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      edges {
        cursor
        node {
          ...UserAutocomplete_User
          avatar
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserAutocompleteUserFragmentDoc}`;

/**
 * __useDirectReportingDrawerUserAutocompleteQuery__
 *
 * To run a query within a React component, call `useDirectReportingDrawerUserAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectReportingDrawerUserAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectReportingDrawerUserAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useDirectReportingDrawerUserAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<DirectReportingDrawerUserAutocompleteQuery, DirectReportingDrawerUserAutocompleteQueryVariables> & ({ variables: DirectReportingDrawerUserAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DirectReportingDrawerUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<DirectReportingDrawerUserAutocompleteQuery, DirectReportingDrawerUserAutocompleteQueryVariables>(DirectReportingDrawerUserAutocompleteDocument, parser(options)));
      }
export function useDirectReportingDrawerUserAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<DirectReportingDrawerUserAutocompleteQuery, DirectReportingDrawerUserAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(DirectReportingDrawerUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<DirectReportingDrawerUserAutocompleteQuery, DirectReportingDrawerUserAutocompleteQueryVariables>(DirectReportingDrawerUserAutocompleteDocument, options));
        }

export type DirectReportingDrawerUserAutocompleteQueryResult = ApolloReact.QueryResult<DirectReportingDrawerUserAutocompleteQuery, DirectReportingDrawerUserAutocompleteQueryVariables>;
export function refetchDirectReportingDrawerUserAutocompleteQuery(variables: DirectReportingDrawerUserAutocompleteQueryVariables) {
      return { query: DirectReportingDrawerUserAutocompleteDocument, variables: variables }
    }
export const EditBenefitDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditBenefitDrawer_Update($id: BenefitId!, $entityVersion: EntityVersion!, $name: String!) {
  benefit(id: $id, entityVersion: $entityVersion) {
    update(name: $name) {
      ...NfsError
      ... on BenefitCommonResponse {
        value {
          id
          entityVersion
          name
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditBenefitDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditBenefitDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBenefitDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBenefitDrawerUpdateMutation, { data, loading, error }] = useEditBenefitDrawerUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityVersion: // value for 'entityVersion'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditBenefitDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditBenefitDrawerUpdateMutation, EditBenefitDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditBenefitDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditBenefitDrawerUpdateMutation, EditBenefitDrawerUpdateMutationVariables>(EditBenefitDrawerUpdateDocument, parser(options)));
      }
export type EditBenefitDrawerUpdateMutationHookResult = ReturnType<typeof useEditBenefitDrawerUpdateMutation>;
export type EditBenefitDrawerUpdateMutationResult = ApolloReact.MutationResult<EditBenefitDrawerUpdateMutation>;
export type EditBenefitDrawerUpdateMutationOptions = Apollo.MutationOptions<EditBenefitDrawerUpdateMutation, EditBenefitDrawerUpdateMutationVariables>;
export const EditBenefitDrawerTerminateDocument = /*#__PURE__*/ gql`
    mutation EditBenefitDrawer_Terminate($id: BenefitId!, $entityVersion: EntityVersion!, $endDate: LocalDate!) {
  benefit(id: $id, entityVersion: $entityVersion) {
    terminate(terminationDate: $endDate) {
      ...NfsError
      ... on BenefitCommonResponse {
        value {
          id
          entityVersion
          name
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditBenefitDrawerTerminateMutation__
 *
 * To run a mutation, you first call `useEditBenefitDrawerTerminateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBenefitDrawerTerminateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBenefitDrawerTerminateMutation, { data, loading, error }] = useEditBenefitDrawerTerminateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityVersion: // value for 'entityVersion'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useEditBenefitDrawerTerminateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditBenefitDrawerTerminateMutation, EditBenefitDrawerTerminateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditBenefitDrawerTerminateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditBenefitDrawerTerminateMutation, EditBenefitDrawerTerminateMutationVariables>(EditBenefitDrawerTerminateDocument, parser(options)));
      }
export type EditBenefitDrawerTerminateMutationHookResult = ReturnType<typeof useEditBenefitDrawerTerminateMutation>;
export type EditBenefitDrawerTerminateMutationResult = ApolloReact.MutationResult<EditBenefitDrawerTerminateMutation>;
export type EditBenefitDrawerTerminateMutationOptions = Apollo.MutationOptions<EditBenefitDrawerTerminateMutation, EditBenefitDrawerTerminateMutationVariables>;
export const EditBenefitDrawerBenefitInitialDataDocument = /*#__PURE__*/ gql`
    query EditBenefitDrawer_BenefitInitialData($id: BenefitId!) {
  benefit(id: $id) {
    ...NfsError
    ... on Benefit {
      id
      entityVersion
      name
      startDate
      endDate
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useEditBenefitDrawerBenefitInitialDataQuery__
 *
 * To run a query within a React component, call `useEditBenefitDrawerBenefitInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditBenefitDrawerBenefitInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditBenefitDrawerBenefitInitialDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditBenefitDrawerBenefitInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<EditBenefitDrawerBenefitInitialDataQuery, EditBenefitDrawerBenefitInitialDataQueryVariables> & ({ variables: EditBenefitDrawerBenefitInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditBenefitDrawerBenefitInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditBenefitDrawerBenefitInitialDataQuery, EditBenefitDrawerBenefitInitialDataQueryVariables>(EditBenefitDrawerBenefitInitialDataDocument, parser(options)));
      }
export function useEditBenefitDrawerBenefitInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditBenefitDrawerBenefitInitialDataQuery, EditBenefitDrawerBenefitInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditBenefitDrawerBenefitInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditBenefitDrawerBenefitInitialDataQuery, EditBenefitDrawerBenefitInitialDataQueryVariables>(EditBenefitDrawerBenefitInitialDataDocument, options));
        }

export type EditBenefitDrawerBenefitInitialDataQueryResult = ApolloReact.QueryResult<EditBenefitDrawerBenefitInitialDataQuery, EditBenefitDrawerBenefitInitialDataQueryVariables>;
export function refetchEditBenefitDrawerBenefitInitialDataQuery(variables: EditBenefitDrawerBenefitInitialDataQueryVariables) {
      return { query: EditBenefitDrawerBenefitInitialDataDocument, variables: variables }
    }
export const EditBenefitVariantPriceDrawerLoadDataDocument = /*#__PURE__*/ gql`
    query EditBenefitVariantPriceDrawer_LoadData($benefitVariantId: BenefitVariantId!, $at: OffsetDateTime) {
  benefitVariant(id: $benefitVariantId, at: $at) {
    ...NfsError
    ... on BenefitVariant {
      ...EditBenefitVariantPriceDrawer_BenefitVariant
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditBenefitVariantPriceDrawerBenefitVariantFragmentDoc}`;

/**
 * __useEditBenefitVariantPriceDrawerLoadDataQuery__
 *
 * To run a query within a React component, call `useEditBenefitVariantPriceDrawerLoadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditBenefitVariantPriceDrawerLoadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditBenefitVariantPriceDrawerLoadDataQuery({
 *   variables: {
 *      benefitVariantId: // value for 'benefitVariantId'
 *      at: // value for 'at'
 *   },
 * });
 */
export function useEditBenefitVariantPriceDrawerLoadDataQuery(baseOptions: ApolloReact.QueryHookOptions<EditBenefitVariantPriceDrawerLoadDataQuery, EditBenefitVariantPriceDrawerLoadDataQueryVariables> & ({ variables: EditBenefitVariantPriceDrawerLoadDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditBenefitVariantPriceDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditBenefitVariantPriceDrawerLoadDataQuery, EditBenefitVariantPriceDrawerLoadDataQueryVariables>(EditBenefitVariantPriceDrawerLoadDataDocument, parser(options)));
      }
export function useEditBenefitVariantPriceDrawerLoadDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditBenefitVariantPriceDrawerLoadDataQuery, EditBenefitVariantPriceDrawerLoadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditBenefitVariantPriceDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditBenefitVariantPriceDrawerLoadDataQuery, EditBenefitVariantPriceDrawerLoadDataQueryVariables>(EditBenefitVariantPriceDrawerLoadDataDocument, options));
        }

export type EditBenefitVariantPriceDrawerLoadDataQueryResult = ApolloReact.QueryResult<EditBenefitVariantPriceDrawerLoadDataQuery, EditBenefitVariantPriceDrawerLoadDataQueryVariables>;
export function refetchEditBenefitVariantPriceDrawerLoadDataQuery(variables: EditBenefitVariantPriceDrawerLoadDataQueryVariables) {
      return { query: EditBenefitVariantPriceDrawerLoadDataDocument, variables: variables }
    }
export const EditBenefitVariantPriceDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditBenefitVariantPriceDrawer_Update($benefitVariantId: BenefitVariantId!, $entityVersion: EntityVersion!, $promiseeRate: TimeBasedValueClearableBenefitVariantRateInput, $promisorRate: TimeBasedValueClearableBenefitVariantRateInput) {
  benefitVariant(id: $benefitVariantId, entityVersion: $entityVersion) {
    update(promiseeRate: $promiseeRate, promisorRate: $promisorRate) {
      ...NfsError
      ... on BenefitVariant {
        ...EditBenefitVariantPriceDrawer_BenefitVariant
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditBenefitVariantPriceDrawerBenefitVariantFragmentDoc}`;


/**
 * __useEditBenefitVariantPriceDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditBenefitVariantPriceDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBenefitVariantPriceDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBenefitVariantPriceDrawerUpdateMutation, { data, loading, error }] = useEditBenefitVariantPriceDrawerUpdateMutation({
 *   variables: {
 *      benefitVariantId: // value for 'benefitVariantId'
 *      entityVersion: // value for 'entityVersion'
 *      promiseeRate: // value for 'promiseeRate'
 *      promisorRate: // value for 'promisorRate'
 *   },
 * });
 */
export function useEditBenefitVariantPriceDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditBenefitVariantPriceDrawerUpdateMutation, EditBenefitVariantPriceDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditBenefitVariantPriceDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditBenefitVariantPriceDrawerUpdateMutation, EditBenefitVariantPriceDrawerUpdateMutationVariables>(EditBenefitVariantPriceDrawerUpdateDocument, parser(options)));
      }
export type EditBenefitVariantPriceDrawerUpdateMutationHookResult = ReturnType<typeof useEditBenefitVariantPriceDrawerUpdateMutation>;
export type EditBenefitVariantPriceDrawerUpdateMutationResult = ApolloReact.MutationResult<EditBenefitVariantPriceDrawerUpdateMutation>;
export type EditBenefitVariantPriceDrawerUpdateMutationOptions = Apollo.MutationOptions<EditBenefitVariantPriceDrawerUpdateMutation, EditBenefitVariantPriceDrawerUpdateMutationVariables>;
export const EditClientContractDrawerInputDocument = /*#__PURE__*/ gql`
    query EditClientContractDrawer_Input($id: ClientContractId!) {
  clientContract(id: $id) {
    ...NfsError
    ... on ClientContract {
      ...EditClientContractDrawer_Contract
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditClientContractDrawerContractFragmentDoc}`;

/**
 * __useEditClientContractDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditClientContractDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditClientContractDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditClientContractDrawerInputQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditClientContractDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<EditClientContractDrawerInputQuery, EditClientContractDrawerInputQueryVariables> & ({ variables: EditClientContractDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditClientContractDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditClientContractDrawerInputQuery, EditClientContractDrawerInputQueryVariables>(EditClientContractDrawerInputDocument, parser(options)));
      }
export function useEditClientContractDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditClientContractDrawerInputQuery, EditClientContractDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditClientContractDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditClientContractDrawerInputQuery, EditClientContractDrawerInputQueryVariables>(EditClientContractDrawerInputDocument, options));
        }

export type EditClientContractDrawerInputQueryResult = ApolloReact.QueryResult<EditClientContractDrawerInputQuery, EditClientContractDrawerInputQueryVariables>;
export function refetchEditClientContractDrawerInputQuery(variables: EditClientContractDrawerInputQueryVariables) {
      return { query: EditClientContractDrawerInputDocument, variables: variables }
    }
export const EditClientContractDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditClientContractDrawer_Update($id: ClientContractId!, $entityVersion: EntityVersion!, $name: String, $contractDurationFrom: LocalDate, $contractDurationTo: ClearableLocalDateInput, $docUri: ClearableURIInput) {
  clientContract(id: $id, entityVersion: $entityVersion) {
    update(
      name: $name
      contractDurationFrom: $contractDurationFrom
      contractDurationTo: $contractDurationTo
      docUri: $docUri
    ) {
      ...NfsError
      ... on ClientContract {
        ...EditClientContractDrawer_Contract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditClientContractDrawerContractFragmentDoc}`;


/**
 * __useEditClientContractDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditClientContractDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditClientContractDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editClientContractDrawerUpdateMutation, { data, loading, error }] = useEditClientContractDrawerUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityVersion: // value for 'entityVersion'
 *      name: // value for 'name'
 *      contractDurationFrom: // value for 'contractDurationFrom'
 *      contractDurationTo: // value for 'contractDurationTo'
 *      docUri: // value for 'docUri'
 *   },
 * });
 */
export function useEditClientContractDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditClientContractDrawerUpdateMutation, EditClientContractDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditClientContractDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditClientContractDrawerUpdateMutation, EditClientContractDrawerUpdateMutationVariables>(EditClientContractDrawerUpdateDocument, parser(options)));
      }
export type EditClientContractDrawerUpdateMutationHookResult = ReturnType<typeof useEditClientContractDrawerUpdateMutation>;
export type EditClientContractDrawerUpdateMutationResult = ApolloReact.MutationResult<EditClientContractDrawerUpdateMutation>;
export type EditClientContractDrawerUpdateMutationOptions = Apollo.MutationOptions<EditClientContractDrawerUpdateMutation, EditClientContractDrawerUpdateMutationVariables>;
export const EditDeskRequestDrawerInputDocument = /*#__PURE__*/ gql`
    query EditDeskRequestDrawer_Input($requestId: ReservationRequestId!, $officeId: OfficeId!, $first: Int!, $range: ClosedEndLocalDateRangeInput!) {
  officeReservation(requestId: $requestId) {
    ...NfsError
    ... on ReservationRequest {
      requestId
      notes
      guestEmails
      range {
        from
        to
      }
      resources {
        id
      }
      user {
        id
        firstName
        lastName
      }
      office {
        officeId
        name
        validFrom
        validTo
      }
    }
  }
  officeReservations(filter: {requestId_eq: $requestId}, first: $first) {
    ...NfsError
    ... on FSPResponseOfficeReservation {
      edges {
        node {
          id
          date
          resource {
            id
          }
        }
      }
    }
  }
  officeCatalogue(officeId: $officeId) {
    ...NfsError
    ... on OfficeCatalogue {
      rooms {
        id
        name
        blocked
        desks {
          id
          name
          monitors
          standing
          blocked
        }
      }
    }
  }
  officeAvailability(officeId: $officeId, range: $range) {
    ...NfsError
    ... on OfficeAvailability {
      desks {
        resourceId
        takenDates
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useEditDeskRequestDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditDeskRequestDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditDeskRequestDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditDeskRequestDrawerInputQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      officeId: // value for 'officeId'
 *      first: // value for 'first'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useEditDeskRequestDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<EditDeskRequestDrawerInputQuery, EditDeskRequestDrawerInputQueryVariables> & ({ variables: EditDeskRequestDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditDeskRequestDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditDeskRequestDrawerInputQuery, EditDeskRequestDrawerInputQueryVariables>(EditDeskRequestDrawerInputDocument, parser(options)));
      }
export function useEditDeskRequestDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditDeskRequestDrawerInputQuery, EditDeskRequestDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditDeskRequestDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditDeskRequestDrawerInputQuery, EditDeskRequestDrawerInputQueryVariables>(EditDeskRequestDrawerInputDocument, options));
        }

export type EditDeskRequestDrawerInputQueryResult = ApolloReact.QueryResult<EditDeskRequestDrawerInputQuery, EditDeskRequestDrawerInputQueryVariables>;
export function refetchEditDeskRequestDrawerInputQuery(variables: EditDeskRequestDrawerInputQueryVariables) {
      return { query: EditDeskRequestDrawerInputDocument, variables: variables }
    }
export const EditDeskRequestDrawerUpdateAndApproveDocument = /*#__PURE__*/ gql`
    mutation EditDeskRequestDrawer_UpdateAndApprove($requestId: ReservationRequestId!, $input: UpdateDeskRequestInput!) {
  updateDeskRequest(requestId: $requestId, input: $input, approve: true) {
    ...NfsError
    ... on ReservationRequest {
      requestId
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditDeskRequestDrawerUpdateAndApproveMutation__
 *
 * To run a mutation, you first call `useEditDeskRequestDrawerUpdateAndApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeskRequestDrawerUpdateAndApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeskRequestDrawerUpdateAndApproveMutation, { data, loading, error }] = useEditDeskRequestDrawerUpdateAndApproveMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDeskRequestDrawerUpdateAndApproveMutation(baseOptions?: ApolloReact.MutationHookOptions<EditDeskRequestDrawerUpdateAndApproveMutation, EditDeskRequestDrawerUpdateAndApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditDeskRequestDrawerUpdateAndApproveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditDeskRequestDrawerUpdateAndApproveMutation, EditDeskRequestDrawerUpdateAndApproveMutationVariables>(EditDeskRequestDrawerUpdateAndApproveDocument, parser(options)));
      }
export type EditDeskRequestDrawerUpdateAndApproveMutationHookResult = ReturnType<typeof useEditDeskRequestDrawerUpdateAndApproveMutation>;
export type EditDeskRequestDrawerUpdateAndApproveMutationResult = ApolloReact.MutationResult<EditDeskRequestDrawerUpdateAndApproveMutation>;
export type EditDeskRequestDrawerUpdateAndApproveMutationOptions = Apollo.MutationOptions<EditDeskRequestDrawerUpdateAndApproveMutation, EditDeskRequestDrawerUpdateAndApproveMutationVariables>;
export const EditOfficeDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query EditOfficeDrawer_InitialData($officeId: OfficeId!) {
  office(officeId: $officeId) {
    ...NfsError
    ... on Office {
      ...EditOfficeDrawer_Office
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditOfficeDrawerOfficeFragmentDoc}`;

/**
 * __useEditOfficeDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useEditOfficeDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditOfficeDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditOfficeDrawerInitialDataQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useEditOfficeDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<EditOfficeDrawerInitialDataQuery, EditOfficeDrawerInitialDataQueryVariables> & ({ variables: EditOfficeDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditOfficeDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditOfficeDrawerInitialDataQuery, EditOfficeDrawerInitialDataQueryVariables>(EditOfficeDrawerInitialDataDocument, parser(options)));
      }
export function useEditOfficeDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditOfficeDrawerInitialDataQuery, EditOfficeDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditOfficeDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditOfficeDrawerInitialDataQuery, EditOfficeDrawerInitialDataQueryVariables>(EditOfficeDrawerInitialDataDocument, options));
        }

export type EditOfficeDrawerInitialDataQueryResult = ApolloReact.QueryResult<EditOfficeDrawerInitialDataQuery, EditOfficeDrawerInitialDataQueryVariables>;
export function refetchEditOfficeDrawerInitialDataQuery(variables: EditOfficeDrawerInitialDataQueryVariables) {
      return { query: EditOfficeDrawerInitialDataDocument, variables: variables }
    }
export const EditOfficeDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditOfficeDrawer_Update($officeId: OfficeId!, $name: String!, $period: LocalDateRangeInput!, $entityVersion: EntityVersion!) {
  updateOffice(
    officeId: $officeId
    name: $name
    period: $period
    entityVersion: $entityVersion
  ) {
    ...NfsError
    ... on Office {
      ...EditOfficeDrawer_Office
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditOfficeDrawerOfficeFragmentDoc}`;


/**
 * __useEditOfficeDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditOfficeDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOfficeDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOfficeDrawerUpdateMutation, { data, loading, error }] = useEditOfficeDrawerUpdateMutation({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      name: // value for 'name'
 *      period: // value for 'period'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useEditOfficeDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditOfficeDrawerUpdateMutation, EditOfficeDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditOfficeDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditOfficeDrawerUpdateMutation, EditOfficeDrawerUpdateMutationVariables>(EditOfficeDrawerUpdateDocument, parser(options)));
      }
export type EditOfficeDrawerUpdateMutationHookResult = ReturnType<typeof useEditOfficeDrawerUpdateMutation>;
export type EditOfficeDrawerUpdateMutationResult = ApolloReact.MutationResult<EditOfficeDrawerUpdateMutation>;
export type EditOfficeDrawerUpdateMutationOptions = Apollo.MutationOptions<EditOfficeDrawerUpdateMutation, EditOfficeDrawerUpdateMutationVariables>;
export const EditOfficeDrawerUploadAvatarDocument = /*#__PURE__*/ gql`
    mutation EditOfficeDrawer_UploadAvatar($officeId: OfficeId!, $file: Upload!, $entityVersion: EntityVersion!) {
  uploadOfficeAvatar(
    officeId: $officeId
    file: $file
    entityVersion: $entityVersion
  ) {
    ...NfsError
    ... on Office {
      officeId
      avatar
      entityVersion
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditOfficeDrawerUploadAvatarMutation__
 *
 * To run a mutation, you first call `useEditOfficeDrawerUploadAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOfficeDrawerUploadAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOfficeDrawerUploadAvatarMutation, { data, loading, error }] = useEditOfficeDrawerUploadAvatarMutation({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      file: // value for 'file'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useEditOfficeDrawerUploadAvatarMutation(baseOptions?: ApolloReact.MutationHookOptions<EditOfficeDrawerUploadAvatarMutation, EditOfficeDrawerUploadAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditOfficeDrawerUploadAvatarDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditOfficeDrawerUploadAvatarMutation, EditOfficeDrawerUploadAvatarMutationVariables>(EditOfficeDrawerUploadAvatarDocument, parser(options)));
      }
export type EditOfficeDrawerUploadAvatarMutationHookResult = ReturnType<typeof useEditOfficeDrawerUploadAvatarMutation>;
export type EditOfficeDrawerUploadAvatarMutationResult = ApolloReact.MutationResult<EditOfficeDrawerUploadAvatarMutation>;
export type EditOfficeDrawerUploadAvatarMutationOptions = Apollo.MutationOptions<EditOfficeDrawerUploadAvatarMutation, EditOfficeDrawerUploadAvatarMutationVariables>;
export const EditOfficeDrawerDeleteAvatarDocument = /*#__PURE__*/ gql`
    mutation EditOfficeDrawer_DeleteAvatar($officeId: OfficeId!, $entityVersion: EntityVersion!) {
  deleteOfficeAvatar(officeId: $officeId, entityVersion: $entityVersion) {
    ...NfsError
    ... on Office {
      officeId
      avatar
      entityVersion
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditOfficeDrawerDeleteAvatarMutation__
 *
 * To run a mutation, you first call `useEditOfficeDrawerDeleteAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOfficeDrawerDeleteAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOfficeDrawerDeleteAvatarMutation, { data, loading, error }] = useEditOfficeDrawerDeleteAvatarMutation({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useEditOfficeDrawerDeleteAvatarMutation(baseOptions?: ApolloReact.MutationHookOptions<EditOfficeDrawerDeleteAvatarMutation, EditOfficeDrawerDeleteAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditOfficeDrawerDeleteAvatarDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditOfficeDrawerDeleteAvatarMutation, EditOfficeDrawerDeleteAvatarMutationVariables>(EditOfficeDrawerDeleteAvatarDocument, parser(options)));
      }
export type EditOfficeDrawerDeleteAvatarMutationHookResult = ReturnType<typeof useEditOfficeDrawerDeleteAvatarMutation>;
export type EditOfficeDrawerDeleteAvatarMutationResult = ApolloReact.MutationResult<EditOfficeDrawerDeleteAvatarMutation>;
export type EditOfficeDrawerDeleteAvatarMutationOptions = Apollo.MutationOptions<EditOfficeDrawerDeleteAvatarMutation, EditOfficeDrawerDeleteAvatarMutationVariables>;
export const EditOfficeSettingsDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query EditOfficeSettingsDrawer_InitialData($officeId: OfficeId!) {
  officeSettings(officeId: $officeId) {
    ...NfsError
    ... on OfficeSettings {
      ...EditOfficeSettingsDrawer_OfficeSettings
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditOfficeSettingsDrawerOfficeSettingsFragmentDoc}`;

/**
 * __useEditOfficeSettingsDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useEditOfficeSettingsDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditOfficeSettingsDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditOfficeSettingsDrawerInitialDataQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useEditOfficeSettingsDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<EditOfficeSettingsDrawerInitialDataQuery, EditOfficeSettingsDrawerInitialDataQueryVariables> & ({ variables: EditOfficeSettingsDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditOfficeSettingsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditOfficeSettingsDrawerInitialDataQuery, EditOfficeSettingsDrawerInitialDataQueryVariables>(EditOfficeSettingsDrawerInitialDataDocument, parser(options)));
      }
export function useEditOfficeSettingsDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditOfficeSettingsDrawerInitialDataQuery, EditOfficeSettingsDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditOfficeSettingsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditOfficeSettingsDrawerInitialDataQuery, EditOfficeSettingsDrawerInitialDataQueryVariables>(EditOfficeSettingsDrawerInitialDataDocument, options));
        }

export type EditOfficeSettingsDrawerInitialDataQueryResult = ApolloReact.QueryResult<EditOfficeSettingsDrawerInitialDataQuery, EditOfficeSettingsDrawerInitialDataQueryVariables>;
export function refetchEditOfficeSettingsDrawerInitialDataQuery(variables: EditOfficeSettingsDrawerInitialDataQueryVariables) {
      return { query: EditOfficeSettingsDrawerInitialDataDocument, variables: variables }
    }
export const EditOfficeSettingsDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditOfficeSettingsDrawer_Update($officeId: OfficeId!, $settings: UpdateOfficeSettingsInput!, $entityVersion: EntityVersion!) {
  updateOfficeSettings(
    officeId: $officeId
    settings: $settings
    entityVersion: $entityVersion
  ) {
    ...NfsError
    ... on OfficeSettings {
      ...EditOfficeSettingsDrawer_OfficeSettings
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditOfficeSettingsDrawerOfficeSettingsFragmentDoc}`;


/**
 * __useEditOfficeSettingsDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditOfficeSettingsDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOfficeSettingsDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOfficeSettingsDrawerUpdateMutation, { data, loading, error }] = useEditOfficeSettingsDrawerUpdateMutation({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      settings: // value for 'settings'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useEditOfficeSettingsDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditOfficeSettingsDrawerUpdateMutation, EditOfficeSettingsDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditOfficeSettingsDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditOfficeSettingsDrawerUpdateMutation, EditOfficeSettingsDrawerUpdateMutationVariables>(EditOfficeSettingsDrawerUpdateDocument, parser(options)));
      }
export type EditOfficeSettingsDrawerUpdateMutationHookResult = ReturnType<typeof useEditOfficeSettingsDrawerUpdateMutation>;
export type EditOfficeSettingsDrawerUpdateMutationResult = ApolloReact.MutationResult<EditOfficeSettingsDrawerUpdateMutation>;
export type EditOfficeSettingsDrawerUpdateMutationOptions = Apollo.MutationOptions<EditOfficeSettingsDrawerUpdateMutation, EditOfficeSettingsDrawerUpdateMutationVariables>;
export const EditParkingRequestDrawerInputDocument = /*#__PURE__*/ gql`
    query EditParkingRequestDrawer_Input($requestId: ReservationRequestId!, $officeId: OfficeId!, $first: Int!, $range: ClosedEndLocalDateRangeInput!) {
  officeReservation(requestId: $requestId) {
    ...NfsError
    ... on ReservationRequest {
      requestId
      notes
      guestEmails
      plateNumber
      range {
        from
        to
      }
      resources {
        id
      }
      user {
        id
        firstName
        lastName
      }
      office {
        officeId
        name
        validFrom
        validTo
      }
    }
  }
  officeReservations(filter: {requestId_eq: $requestId}, first: $first) {
    ...NfsError
    ... on FSPResponseOfficeReservation {
      edges {
        node {
          id
          date
          resource {
            id
          }
        }
      }
    }
  }
  officeCatalogue(officeId: $officeId) {
    ...NfsError
    ... on OfficeCatalogue {
      parkingSpots {
        id
        number
        name
        guest
        blocked
      }
    }
  }
  officeAvailability(officeId: $officeId, range: $range) {
    ...NfsError
    ... on OfficeAvailability {
      parkingSpots {
        resourceId
        takenDates
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useEditParkingRequestDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditParkingRequestDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditParkingRequestDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditParkingRequestDrawerInputQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      officeId: // value for 'officeId'
 *      first: // value for 'first'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useEditParkingRequestDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<EditParkingRequestDrawerInputQuery, EditParkingRequestDrawerInputQueryVariables> & ({ variables: EditParkingRequestDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditParkingRequestDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditParkingRequestDrawerInputQuery, EditParkingRequestDrawerInputQueryVariables>(EditParkingRequestDrawerInputDocument, parser(options)));
      }
export function useEditParkingRequestDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditParkingRequestDrawerInputQuery, EditParkingRequestDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditParkingRequestDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditParkingRequestDrawerInputQuery, EditParkingRequestDrawerInputQueryVariables>(EditParkingRequestDrawerInputDocument, options));
        }

export type EditParkingRequestDrawerInputQueryResult = ApolloReact.QueryResult<EditParkingRequestDrawerInputQuery, EditParkingRequestDrawerInputQueryVariables>;
export function refetchEditParkingRequestDrawerInputQuery(variables: EditParkingRequestDrawerInputQueryVariables) {
      return { query: EditParkingRequestDrawerInputDocument, variables: variables }
    }
export const EditParkingRequestDrawerUpdateAndApproveDocument = /*#__PURE__*/ gql`
    mutation EditParkingRequestDrawer_UpdateAndApprove($requestId: ReservationRequestId!, $input: UpdateParkingRequestInput!) {
  updateParkingRequest(requestId: $requestId, input: $input, approve: true) {
    ...NfsError
    ... on ReservationRequest {
      requestId
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditParkingRequestDrawerUpdateAndApproveMutation__
 *
 * To run a mutation, you first call `useEditParkingRequestDrawerUpdateAndApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditParkingRequestDrawerUpdateAndApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editParkingRequestDrawerUpdateAndApproveMutation, { data, loading, error }] = useEditParkingRequestDrawerUpdateAndApproveMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditParkingRequestDrawerUpdateAndApproveMutation(baseOptions?: ApolloReact.MutationHookOptions<EditParkingRequestDrawerUpdateAndApproveMutation, EditParkingRequestDrawerUpdateAndApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditParkingRequestDrawerUpdateAndApproveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditParkingRequestDrawerUpdateAndApproveMutation, EditParkingRequestDrawerUpdateAndApproveMutationVariables>(EditParkingRequestDrawerUpdateAndApproveDocument, parser(options)));
      }
export type EditParkingRequestDrawerUpdateAndApproveMutationHookResult = ReturnType<typeof useEditParkingRequestDrawerUpdateAndApproveMutation>;
export type EditParkingRequestDrawerUpdateAndApproveMutationResult = ApolloReact.MutationResult<EditParkingRequestDrawerUpdateAndApproveMutation>;
export type EditParkingRequestDrawerUpdateAndApproveMutationOptions = Apollo.MutationOptions<EditParkingRequestDrawerUpdateAndApproveMutation, EditParkingRequestDrawerUpdateAndApproveMutationVariables>;
export const EditProfileAdditionalDataDrawerInputDocument = /*#__PURE__*/ gql`
    query EditProfileAdditionalDataDrawer_Input($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...EditProfileAdditionalDataDrawer_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProfileAdditionalDataDrawerUserFragmentDoc}`;

/**
 * __useEditProfileAdditionalDataDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditProfileAdditionalDataDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProfileAdditionalDataDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProfileAdditionalDataDrawerInputQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEditProfileAdditionalDataDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<EditProfileAdditionalDataDrawerInputQuery, EditProfileAdditionalDataDrawerInputQueryVariables> & ({ variables: EditProfileAdditionalDataDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProfileAdditionalDataDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditProfileAdditionalDataDrawerInputQuery, EditProfileAdditionalDataDrawerInputQueryVariables>(EditProfileAdditionalDataDrawerInputDocument, parser(options)));
      }
export function useEditProfileAdditionalDataDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditProfileAdditionalDataDrawerInputQuery, EditProfileAdditionalDataDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditProfileAdditionalDataDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditProfileAdditionalDataDrawerInputQuery, EditProfileAdditionalDataDrawerInputQueryVariables>(EditProfileAdditionalDataDrawerInputDocument, options));
        }

export type EditProfileAdditionalDataDrawerInputQueryResult = ApolloReact.QueryResult<EditProfileAdditionalDataDrawerInputQuery, EditProfileAdditionalDataDrawerInputQueryVariables>;
export function refetchEditProfileAdditionalDataDrawerInputQuery(variables: EditProfileAdditionalDataDrawerInputQueryVariables) {
      return { query: EditProfileAdditionalDataDrawerInputDocument, variables: variables }
    }
export const EditProfileAdditionalDataDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditProfileAdditionalDataDrawer_Update($userId: UserId!, $entityVersion: EntityVersion!, $idType: ClearableIDTypeInput, $idNumber: ClearableStringInput, $pesel: ClearablePESELInput, $citizenship: ClearableCountryCodeInput, $birthDate: ClearableLocalDateInput, $nextMedicalExaminationDate: ClearableLocalDateInput, $revenueAdministrationOffice: ClearableRevenueAdministrationOfficeIdInput, $passportExpirationDate: ClearableLocalDateInput, $nextOhsTrainingDate: ClearableLocalDateInput) {
  user(userId: $userId, entityVersion: $entityVersion) {
    updateUser(
      idType: $idType
      idNumber: $idNumber
      pesel: $pesel
      citizenship: $citizenship
      birthDate: $birthDate
      nextMedicalExaminationDate: $nextMedicalExaminationDate
      revenueAdministrationOffice: $revenueAdministrationOffice
      passportExpirationDate: $passportExpirationDate
      nextOhsTrainingDate: $nextOhsTrainingDate
    ) {
      ...NfsError
      ... on User {
        ...EditProfileAdditionalDataDrawer_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProfileAdditionalDataDrawerUserFragmentDoc}`;


/**
 * __useEditProfileAdditionalDataDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditProfileAdditionalDataDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProfileAdditionalDataDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProfileAdditionalDataDrawerUpdateMutation, { data, loading, error }] = useEditProfileAdditionalDataDrawerUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      idType: // value for 'idType'
 *      idNumber: // value for 'idNumber'
 *      pesel: // value for 'pesel'
 *      citizenship: // value for 'citizenship'
 *      birthDate: // value for 'birthDate'
 *      nextMedicalExaminationDate: // value for 'nextMedicalExaminationDate'
 *      revenueAdministrationOffice: // value for 'revenueAdministrationOffice'
 *      passportExpirationDate: // value for 'passportExpirationDate'
 *      nextOhsTrainingDate: // value for 'nextOhsTrainingDate'
 *   },
 * });
 */
export function useEditProfileAdditionalDataDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditProfileAdditionalDataDrawerUpdateMutation, EditProfileAdditionalDataDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProfileAdditionalDataDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditProfileAdditionalDataDrawerUpdateMutation, EditProfileAdditionalDataDrawerUpdateMutationVariables>(EditProfileAdditionalDataDrawerUpdateDocument, parser(options)));
      }
export type EditProfileAdditionalDataDrawerUpdateMutationHookResult = ReturnType<typeof useEditProfileAdditionalDataDrawerUpdateMutation>;
export type EditProfileAdditionalDataDrawerUpdateMutationResult = ApolloReact.MutationResult<EditProfileAdditionalDataDrawerUpdateMutation>;
export type EditProfileAdditionalDataDrawerUpdateMutationOptions = Apollo.MutationOptions<EditProfileAdditionalDataDrawerUpdateMutation, EditProfileAdditionalDataDrawerUpdateMutationVariables>;
export const EditProfileAddressDrawerInputDocument = /*#__PURE__*/ gql`
    query EditProfileAddressDrawer_Input($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...EditProfileAddressDrawer_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProfileAddressDrawerUserFragmentDoc}`;

/**
 * __useEditProfileAddressDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditProfileAddressDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProfileAddressDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProfileAddressDrawerInputQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEditProfileAddressDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<EditProfileAddressDrawerInputQuery, EditProfileAddressDrawerInputQueryVariables> & ({ variables: EditProfileAddressDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProfileAddressDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditProfileAddressDrawerInputQuery, EditProfileAddressDrawerInputQueryVariables>(EditProfileAddressDrawerInputDocument, parser(options)));
      }
export function useEditProfileAddressDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditProfileAddressDrawerInputQuery, EditProfileAddressDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditProfileAddressDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditProfileAddressDrawerInputQuery, EditProfileAddressDrawerInputQueryVariables>(EditProfileAddressDrawerInputDocument, options));
        }

export type EditProfileAddressDrawerInputQueryResult = ApolloReact.QueryResult<EditProfileAddressDrawerInputQuery, EditProfileAddressDrawerInputQueryVariables>;
export function refetchEditProfileAddressDrawerInputQuery(variables: EditProfileAddressDrawerInputQueryVariables) {
      return { query: EditProfileAddressDrawerInputDocument, variables: variables }
    }
export const EditProfileAddressDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditProfileAddressDrawer_Update($userId: UserId!, $entityVersion: EntityVersion!, $contactEmail: ClearableEmailAddressInput, $phoneNumber: ClearablePhoneNumberInput, $address: ClearableAddressInput, $mailingAddress: ClearableAddressInput, $paczkomat: ClearableStringInput, $plateNumber: ClearableStringInput, $emergencyContact: ClearableStringInput) {
  user(userId: $userId, entityVersion: $entityVersion) {
    updateUser(
      contactEmail: $contactEmail
      phoneNumber: $phoneNumber
      address: $address
      mailingAddress: $mailingAddress
      paczkomat: $paczkomat
      plateNumber: $plateNumber
      emergencyContact: $emergencyContact
    ) {
      ...NfsError
      ... on User {
        ...EditProfileAddressDrawer_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProfileAddressDrawerUserFragmentDoc}`;


/**
 * __useEditProfileAddressDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditProfileAddressDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProfileAddressDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProfileAddressDrawerUpdateMutation, { data, loading, error }] = useEditProfileAddressDrawerUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      contactEmail: // value for 'contactEmail'
 *      phoneNumber: // value for 'phoneNumber'
 *      address: // value for 'address'
 *      mailingAddress: // value for 'mailingAddress'
 *      paczkomat: // value for 'paczkomat'
 *      plateNumber: // value for 'plateNumber'
 *      emergencyContact: // value for 'emergencyContact'
 *   },
 * });
 */
export function useEditProfileAddressDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditProfileAddressDrawerUpdateMutation, EditProfileAddressDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProfileAddressDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditProfileAddressDrawerUpdateMutation, EditProfileAddressDrawerUpdateMutationVariables>(EditProfileAddressDrawerUpdateDocument, parser(options)));
      }
export type EditProfileAddressDrawerUpdateMutationHookResult = ReturnType<typeof useEditProfileAddressDrawerUpdateMutation>;
export type EditProfileAddressDrawerUpdateMutationResult = ApolloReact.MutationResult<EditProfileAddressDrawerUpdateMutation>;
export type EditProfileAddressDrawerUpdateMutationOptions = Apollo.MutationOptions<EditProfileAddressDrawerUpdateMutation, EditProfileAddressDrawerUpdateMutationVariables>;
export const EditProfileBasicInfoDrawerInputDocument = /*#__PURE__*/ gql`
    query EditProfileBasicInfoDrawer_Input($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...EditProfileBasicInfoDrawer_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProfileBasicInfoDrawerUserFragmentDoc}`;

/**
 * __useEditProfileBasicInfoDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditProfileBasicInfoDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProfileBasicInfoDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProfileBasicInfoDrawerInputQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEditProfileBasicInfoDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<EditProfileBasicInfoDrawerInputQuery, EditProfileBasicInfoDrawerInputQueryVariables> & ({ variables: EditProfileBasicInfoDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProfileBasicInfoDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditProfileBasicInfoDrawerInputQuery, EditProfileBasicInfoDrawerInputQueryVariables>(EditProfileBasicInfoDrawerInputDocument, parser(options)));
      }
export function useEditProfileBasicInfoDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditProfileBasicInfoDrawerInputQuery, EditProfileBasicInfoDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditProfileBasicInfoDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditProfileBasicInfoDrawerInputQuery, EditProfileBasicInfoDrawerInputQueryVariables>(EditProfileBasicInfoDrawerInputDocument, options));
        }

export type EditProfileBasicInfoDrawerInputQueryResult = ApolloReact.QueryResult<EditProfileBasicInfoDrawerInputQuery, EditProfileBasicInfoDrawerInputQueryVariables>;
export function refetchEditProfileBasicInfoDrawerInputQuery(variables: EditProfileBasicInfoDrawerInputQueryVariables) {
      return { query: EditProfileBasicInfoDrawerInputDocument, variables: variables }
    }
export const EditProfileBasicInfoDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditProfileBasicInfoDrawer_Update($userId: UserId!, $entityVersion: EntityVersion!, $middleName: ClearableStringInput, $familyName: ClearableStringInput, $space: TimeBasedValueSpaceIdInput, $area: ClearableStringInput, $progressionLevel: TimeBasedValueClearableProgressionLevelInput, $officeId: ClearableOfficeIdInput, $personalDataProcessingAuthorization: ClearableURIInput, $documentsDirectory: URI, $consentedForUseOfImage: Boolean, $isStudent: Boolean, $isStudentRevisionDate: ClearableLocalDateInput) {
  user(userId: $userId, entityVersion: $entityVersion) {
    updateUser(
      middleName: $middleName
      familyName: $familyName
      space: $space
      areaOfExpertise: $area
      progressionLevel: $progressionLevel
      officeId: $officeId
      personalDataProcessingAuthorization: $personalDataProcessingAuthorization
      documentsDirectory: $documentsDirectory
      consentedForUseOfImage: $consentedForUseOfImage
      isStudent: $isStudent
      isStudentRevisionDate: $isStudentRevisionDate
    ) {
      ...NfsError
      ... on User {
        ...EditProfileBasicInfoDrawer_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProfileBasicInfoDrawerUserFragmentDoc}`;


/**
 * __useEditProfileBasicInfoDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditProfileBasicInfoDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProfileBasicInfoDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProfileBasicInfoDrawerUpdateMutation, { data, loading, error }] = useEditProfileBasicInfoDrawerUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      middleName: // value for 'middleName'
 *      familyName: // value for 'familyName'
 *      space: // value for 'space'
 *      area: // value for 'area'
 *      progressionLevel: // value for 'progressionLevel'
 *      officeId: // value for 'officeId'
 *      personalDataProcessingAuthorization: // value for 'personalDataProcessingAuthorization'
 *      documentsDirectory: // value for 'documentsDirectory'
 *      consentedForUseOfImage: // value for 'consentedForUseOfImage'
 *      isStudent: // value for 'isStudent'
 *      isStudentRevisionDate: // value for 'isStudentRevisionDate'
 *   },
 * });
 */
export function useEditProfileBasicInfoDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditProfileBasicInfoDrawerUpdateMutation, EditProfileBasicInfoDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProfileBasicInfoDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditProfileBasicInfoDrawerUpdateMutation, EditProfileBasicInfoDrawerUpdateMutationVariables>(EditProfileBasicInfoDrawerUpdateDocument, parser(options)));
      }
export type EditProfileBasicInfoDrawerUpdateMutationHookResult = ReturnType<typeof useEditProfileBasicInfoDrawerUpdateMutation>;
export type EditProfileBasicInfoDrawerUpdateMutationResult = ApolloReact.MutationResult<EditProfileBasicInfoDrawerUpdateMutation>;
export type EditProfileBasicInfoDrawerUpdateMutationOptions = Apollo.MutationOptions<EditProfileBasicInfoDrawerUpdateMutation, EditProfileBasicInfoDrawerUpdateMutationVariables>;
export const EditProfileBasicInfoFormOfficeAutocompleteDocument = /*#__PURE__*/ gql`
    query EditProfileBasicInfoForm_OfficeAutocomplete {
  offices {
    ...NfsError
    ... on ListOfOfficeResponse {
      value {
        officeId
        name
        validFrom
        validTo
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useEditProfileBasicInfoFormOfficeAutocompleteQuery__
 *
 * To run a query within a React component, call `useEditProfileBasicInfoFormOfficeAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProfileBasicInfoFormOfficeAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProfileBasicInfoFormOfficeAutocompleteQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditProfileBasicInfoFormOfficeAutocompleteQuery(baseOptions?: ApolloReact.QueryHookOptions<EditProfileBasicInfoFormOfficeAutocompleteQuery, EditProfileBasicInfoFormOfficeAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProfileBasicInfoFormOfficeAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditProfileBasicInfoFormOfficeAutocompleteQuery, EditProfileBasicInfoFormOfficeAutocompleteQueryVariables>(EditProfileBasicInfoFormOfficeAutocompleteDocument, parser(options)));
      }
export function useEditProfileBasicInfoFormOfficeAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditProfileBasicInfoFormOfficeAutocompleteQuery, EditProfileBasicInfoFormOfficeAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditProfileBasicInfoFormOfficeAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditProfileBasicInfoFormOfficeAutocompleteQuery, EditProfileBasicInfoFormOfficeAutocompleteQueryVariables>(EditProfileBasicInfoFormOfficeAutocompleteDocument, options));
        }

export type EditProfileBasicInfoFormOfficeAutocompleteQueryResult = ApolloReact.QueryResult<EditProfileBasicInfoFormOfficeAutocompleteQuery, EditProfileBasicInfoFormOfficeAutocompleteQueryVariables>;
export function refetchEditProfileBasicInfoFormOfficeAutocompleteQuery(variables?: EditProfileBasicInfoFormOfficeAutocompleteQueryVariables) {
      return { query: EditProfileBasicInfoFormOfficeAutocompleteDocument, variables: variables }
    }
export const EditProjectCrossSellDrawerInputDocument = /*#__PURE__*/ gql`
    query EditProjectCrossSellDrawer_Input($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      ...EditProjectCrossSellDrawer_Project
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProjectCrossSellDrawerProjectFragmentDoc}`;

/**
 * __useEditProjectCrossSellDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditProjectCrossSellDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProjectCrossSellDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProjectCrossSellDrawerInputQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useEditProjectCrossSellDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<EditProjectCrossSellDrawerInputQuery, EditProjectCrossSellDrawerInputQueryVariables> & ({ variables: EditProjectCrossSellDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProjectCrossSellDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditProjectCrossSellDrawerInputQuery, EditProjectCrossSellDrawerInputQueryVariables>(EditProjectCrossSellDrawerInputDocument, parser(options)));
      }
export function useEditProjectCrossSellDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditProjectCrossSellDrawerInputQuery, EditProjectCrossSellDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditProjectCrossSellDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditProjectCrossSellDrawerInputQuery, EditProjectCrossSellDrawerInputQueryVariables>(EditProjectCrossSellDrawerInputDocument, options));
        }

export type EditProjectCrossSellDrawerInputQueryResult = ApolloReact.QueryResult<EditProjectCrossSellDrawerInputQuery, EditProjectCrossSellDrawerInputQueryVariables>;
export function refetchEditProjectCrossSellDrawerInputQuery(variables: EditProjectCrossSellDrawerInputQueryVariables) {
      return { query: EditProjectCrossSellDrawerInputDocument, variables: variables }
    }
export const EditProjectCrossSellDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditProjectCrossSellDrawer_Update($projectId: ProjectId!, $entityVersion: EntityVersion!, $crossSell: ClearableCrossSellInput) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    update(crossSell: $crossSell) {
      ...NfsError
      ... on Project {
        ...EditProjectCrossSellDrawer_Project
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProjectCrossSellDrawerProjectFragmentDoc}`;


/**
 * __useEditProjectCrossSellDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditProjectCrossSellDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectCrossSellDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectCrossSellDrawerUpdateMutation, { data, loading, error }] = useEditProjectCrossSellDrawerUpdateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      crossSell: // value for 'crossSell'
 *   },
 * });
 */
export function useEditProjectCrossSellDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditProjectCrossSellDrawerUpdateMutation, EditProjectCrossSellDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProjectCrossSellDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditProjectCrossSellDrawerUpdateMutation, EditProjectCrossSellDrawerUpdateMutationVariables>(EditProjectCrossSellDrawerUpdateDocument, parser(options)));
      }
export type EditProjectCrossSellDrawerUpdateMutationHookResult = ReturnType<typeof useEditProjectCrossSellDrawerUpdateMutation>;
export type EditProjectCrossSellDrawerUpdateMutationResult = ApolloReact.MutationResult<EditProjectCrossSellDrawerUpdateMutation>;
export type EditProjectCrossSellDrawerUpdateMutationOptions = Apollo.MutationOptions<EditProjectCrossSellDrawerUpdateMutation, EditProjectCrossSellDrawerUpdateMutationVariables>;
export const EditProjectDrawerInputDocument = /*#__PURE__*/ gql`
    query EditProjectDrawer_Input($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      ...EditProjectDrawer_Project
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProjectDrawerProjectFragmentDoc}`;

/**
 * __useEditProjectDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditProjectDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProjectDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProjectDrawerInputQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useEditProjectDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<EditProjectDrawerInputQuery, EditProjectDrawerInputQueryVariables> & ({ variables: EditProjectDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProjectDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditProjectDrawerInputQuery, EditProjectDrawerInputQueryVariables>(EditProjectDrawerInputDocument, parser(options)));
      }
export function useEditProjectDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditProjectDrawerInputQuery, EditProjectDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditProjectDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditProjectDrawerInputQuery, EditProjectDrawerInputQueryVariables>(EditProjectDrawerInputDocument, options));
        }

export type EditProjectDrawerInputQueryResult = ApolloReact.QueryResult<EditProjectDrawerInputQuery, EditProjectDrawerInputQueryVariables>;
export function refetchEditProjectDrawerInputQuery(variables: EditProjectDrawerInputQueryVariables) {
      return { query: EditProjectDrawerInputDocument, variables: variables }
    }
export const EditProjectDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditProjectDrawer_Update($projectId: ProjectId!, $entityVersion: EntityVersion!, $name: String, $spaceId: ClearableSpaceIdInput, $description: ClearableStringInput, $areaOfVlEngagement: ClearableStringInput, $costLedgerAccountNumber: ClearableStringInput, $revenueLedgerAccountNumber: ClearableStringInput) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    update(
      name: $name
      spaceId: $spaceId
      description: $description
      areaOfVlEngagement: $areaOfVlEngagement
      costLedgerAccountNumber: $costLedgerAccountNumber
      revenueLedgerAccountNumber: $revenueLedgerAccountNumber
    ) {
      ...NfsError
      ... on Project {
        ...EditProjectDrawer_Project
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProjectDrawerProjectFragmentDoc}`;


/**
 * __useEditProjectDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditProjectDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectDrawerUpdateMutation, { data, loading, error }] = useEditProjectDrawerUpdateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      name: // value for 'name'
 *      spaceId: // value for 'spaceId'
 *      description: // value for 'description'
 *      areaOfVlEngagement: // value for 'areaOfVlEngagement'
 *      costLedgerAccountNumber: // value for 'costLedgerAccountNumber'
 *      revenueLedgerAccountNumber: // value for 'revenueLedgerAccountNumber'
 *   },
 * });
 */
export function useEditProjectDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditProjectDrawerUpdateMutation, EditProjectDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProjectDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditProjectDrawerUpdateMutation, EditProjectDrawerUpdateMutationVariables>(EditProjectDrawerUpdateDocument, parser(options)));
      }
export type EditProjectDrawerUpdateMutationHookResult = ReturnType<typeof useEditProjectDrawerUpdateMutation>;
export type EditProjectDrawerUpdateMutationResult = ApolloReact.MutationResult<EditProjectDrawerUpdateMutation>;
export type EditProjectDrawerUpdateMutationOptions = Apollo.MutationOptions<EditProjectDrawerUpdateMutation, EditProjectDrawerUpdateMutationVariables>;
export const EditProjectTechStackAndCompetencesDrawerInputDocument = /*#__PURE__*/ gql`
    query EditProjectTechStackAndCompetencesDrawer_Input($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      ...EditProjectTechStackAndCompetencesDrawer_Project
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProjectTechStackAndCompetencesDrawerProjectFragmentDoc}`;

/**
 * __useEditProjectTechStackAndCompetencesDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditProjectTechStackAndCompetencesDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProjectTechStackAndCompetencesDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProjectTechStackAndCompetencesDrawerInputQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useEditProjectTechStackAndCompetencesDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<EditProjectTechStackAndCompetencesDrawerInputQuery, EditProjectTechStackAndCompetencesDrawerInputQueryVariables> & ({ variables: EditProjectTechStackAndCompetencesDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProjectTechStackAndCompetencesDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditProjectTechStackAndCompetencesDrawerInputQuery, EditProjectTechStackAndCompetencesDrawerInputQueryVariables>(EditProjectTechStackAndCompetencesDrawerInputDocument, parser(options)));
      }
export function useEditProjectTechStackAndCompetencesDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditProjectTechStackAndCompetencesDrawerInputQuery, EditProjectTechStackAndCompetencesDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditProjectTechStackAndCompetencesDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditProjectTechStackAndCompetencesDrawerInputQuery, EditProjectTechStackAndCompetencesDrawerInputQueryVariables>(EditProjectTechStackAndCompetencesDrawerInputDocument, options));
        }

export type EditProjectTechStackAndCompetencesDrawerInputQueryResult = ApolloReact.QueryResult<EditProjectTechStackAndCompetencesDrawerInputQuery, EditProjectTechStackAndCompetencesDrawerInputQueryVariables>;
export function refetchEditProjectTechStackAndCompetencesDrawerInputQuery(variables: EditProjectTechStackAndCompetencesDrawerInputQueryVariables) {
      return { query: EditProjectTechStackAndCompetencesDrawerInputDocument, variables: variables }
    }
export const EditProjectTechStackAndCompetencesDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditProjectTechStackAndCompetencesDrawer_Update($projectId: ProjectId!, $entityVersion: EntityVersion!, $techStack: [String!], $competences: [String!]) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    update(techStack: $techStack, competences: $competences) {
      ...NfsError
      ... on Project {
        ...EditProjectTechStackAndCompetencesDrawer_Project
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditProjectTechStackAndCompetencesDrawerProjectFragmentDoc}`;


/**
 * __useEditProjectTechStackAndCompetencesDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditProjectTechStackAndCompetencesDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectTechStackAndCompetencesDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectTechStackAndCompetencesDrawerUpdateMutation, { data, loading, error }] = useEditProjectTechStackAndCompetencesDrawerUpdateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      techStack: // value for 'techStack'
 *      competences: // value for 'competences'
 *   },
 * });
 */
export function useEditProjectTechStackAndCompetencesDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditProjectTechStackAndCompetencesDrawerUpdateMutation, EditProjectTechStackAndCompetencesDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProjectTechStackAndCompetencesDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditProjectTechStackAndCompetencesDrawerUpdateMutation, EditProjectTechStackAndCompetencesDrawerUpdateMutationVariables>(EditProjectTechStackAndCompetencesDrawerUpdateDocument, parser(options)));
      }
export type EditProjectTechStackAndCompetencesDrawerUpdateMutationHookResult = ReturnType<typeof useEditProjectTechStackAndCompetencesDrawerUpdateMutation>;
export type EditProjectTechStackAndCompetencesDrawerUpdateMutationResult = ApolloReact.MutationResult<EditProjectTechStackAndCompetencesDrawerUpdateMutation>;
export type EditProjectTechStackAndCompetencesDrawerUpdateMutationOptions = Apollo.MutationOptions<EditProjectTechStackAndCompetencesDrawerUpdateMutation, EditProjectTechStackAndCompetencesDrawerUpdateMutationVariables>;
export const EditSkillsAndCertificatesDrawerDocument = /*#__PURE__*/ gql`
    query EditSkillsAndCertificatesDrawer($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...EditSkillsAndCertificatesDrawer_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditSkillsAndCertificatesDrawerUserFragmentDoc}`;

/**
 * __useEditSkillsAndCertificatesDrawerQuery__
 *
 * To run a query within a React component, call `useEditSkillsAndCertificatesDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSkillsAndCertificatesDrawerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<EditSkillsAndCertificatesDrawerQuery, EditSkillsAndCertificatesDrawerQueryVariables> & ({ variables: EditSkillsAndCertificatesDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditSkillsAndCertificatesDrawerQuery, EditSkillsAndCertificatesDrawerQueryVariables>(EditSkillsAndCertificatesDrawerDocument, parser(options)));
      }
export function useEditSkillsAndCertificatesDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditSkillsAndCertificatesDrawerQuery, EditSkillsAndCertificatesDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditSkillsAndCertificatesDrawerQuery, EditSkillsAndCertificatesDrawerQueryVariables>(EditSkillsAndCertificatesDrawerDocument, options));
        }

export type EditSkillsAndCertificatesDrawerQueryResult = ApolloReact.QueryResult<EditSkillsAndCertificatesDrawerQuery, EditSkillsAndCertificatesDrawerQueryVariables>;
export function refetchEditSkillsAndCertificatesDrawerQuery(variables: EditSkillsAndCertificatesDrawerQueryVariables) {
      return { query: EditSkillsAndCertificatesDrawerDocument, variables: variables }
    }
export const EditSkillsAndCertificatesDrawerUpdateSkillsDocument = /*#__PURE__*/ gql`
    mutation EditSkillsAndCertificatesDrawer_UpdateSkills($userId: UserId!, $entityVersion: EntityVersion!, $skills: [String!]) {
  user(userId: $userId, entityVersion: $entityVersion) {
    updateUser(skillsAndCompetences: $skills) {
      ...NfsError
      ... on User {
        ...EditSkillsAndCertificatesDrawer_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditSkillsAndCertificatesDrawerUserFragmentDoc}`;


/**
 * __useEditSkillsAndCertificatesDrawerUpdateSkillsMutation__
 *
 * To run a mutation, you first call `useEditSkillsAndCertificatesDrawerUpdateSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerUpdateSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillsAndCertificatesDrawerUpdateSkillsMutation, { data, loading, error }] = useEditSkillsAndCertificatesDrawerUpdateSkillsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      skills: // value for 'skills'
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerUpdateSkillsMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSkillsAndCertificatesDrawerUpdateSkillsMutation, EditSkillsAndCertificatesDrawerUpdateSkillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerUpdateSkillsDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSkillsAndCertificatesDrawerUpdateSkillsMutation, EditSkillsAndCertificatesDrawerUpdateSkillsMutationVariables>(EditSkillsAndCertificatesDrawerUpdateSkillsDocument, parser(options)));
      }
export type EditSkillsAndCertificatesDrawerUpdateSkillsMutationHookResult = ReturnType<typeof useEditSkillsAndCertificatesDrawerUpdateSkillsMutation>;
export type EditSkillsAndCertificatesDrawerUpdateSkillsMutationResult = ApolloReact.MutationResult<EditSkillsAndCertificatesDrawerUpdateSkillsMutation>;
export type EditSkillsAndCertificatesDrawerUpdateSkillsMutationOptions = Apollo.MutationOptions<EditSkillsAndCertificatesDrawerUpdateSkillsMutation, EditSkillsAndCertificatesDrawerUpdateSkillsMutationVariables>;
export const EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesDocument = /*#__PURE__*/ gql`
    mutation EditSkillsAndCertificatesDrawer_UpdateDeclaredNoCertificates($userId: UserId!, $entityVersion: EntityVersion!, $declaredNoCertificates: Boolean!) {
  user(userId: $userId, entityVersion: $entityVersion) {
    updateUser(declaredNoCertificates: $declaredNoCertificates) {
      ...NfsError
      ... on User {
        id
        entityVersion
        declaredNoCertificates
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation__
 *
 * To run a mutation, you first call `useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation, { data, loading, error }] = useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      declaredNoCertificates: // value for 'declaredNoCertificates'
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation, EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation, EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationVariables>(EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesDocument, parser(options)));
      }
export type EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationHookResult = ReturnType<typeof useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation>;
export type EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationResult = ApolloReact.MutationResult<EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation>;
export type EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationOptions = Apollo.MutationOptions<EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation, EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationVariables>;
export const EditSkillsAndCertificatesDrawerCreateCertificateDocument = /*#__PURE__*/ gql`
    mutation EditSkillsAndCertificatesDrawer_CreateCertificate($id: CertificateId!, $userId: UserId!, $name: String!, $issueDate: LocalDate, $expirationDate: LocalDate, $file: Upload) {
  createCertificate(
    id: $id
    userId: $userId
    name: $name
    issueDate: $issueDate
    expirationDate: $expirationDate
    file: $file
  ) {
    ...NfsError
    ... on Certificate {
      id
      name
      issueDate
      expirationDate
      file {
        downloadUrl
        fileName
        openUrl
      }
      userId
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditSkillsAndCertificatesDrawerCreateCertificateMutation__
 *
 * To run a mutation, you first call `useEditSkillsAndCertificatesDrawerCreateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerCreateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillsAndCertificatesDrawerCreateCertificateMutation, { data, loading, error }] = useEditSkillsAndCertificatesDrawerCreateCertificateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      issueDate: // value for 'issueDate'
 *      expirationDate: // value for 'expirationDate'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerCreateCertificateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSkillsAndCertificatesDrawerCreateCertificateMutation, EditSkillsAndCertificatesDrawerCreateCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerCreateCertificateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSkillsAndCertificatesDrawerCreateCertificateMutation, EditSkillsAndCertificatesDrawerCreateCertificateMutationVariables>(EditSkillsAndCertificatesDrawerCreateCertificateDocument, parser(options)));
      }
export type EditSkillsAndCertificatesDrawerCreateCertificateMutationHookResult = ReturnType<typeof useEditSkillsAndCertificatesDrawerCreateCertificateMutation>;
export type EditSkillsAndCertificatesDrawerCreateCertificateMutationResult = ApolloReact.MutationResult<EditSkillsAndCertificatesDrawerCreateCertificateMutation>;
export type EditSkillsAndCertificatesDrawerCreateCertificateMutationOptions = Apollo.MutationOptions<EditSkillsAndCertificatesDrawerCreateCertificateMutation, EditSkillsAndCertificatesDrawerCreateCertificateMutationVariables>;
export const EditSkillsAndCertificatesDrawerUpdateCertificateDocument = /*#__PURE__*/ gql`
    mutation EditSkillsAndCertificatesDrawer_UpdateCertificate($certificateId: CertificateId!, $certificate: UpdateCertificateInput!) {
  updateCertificate(certificateId: $certificateId, certificate: $certificate) {
    ...NfsError
    ... on Certificate {
      id
      name
      issueDate
      expirationDate
      file {
        downloadUrl
        fileName
        openUrl
      }
      userId
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditSkillsAndCertificatesDrawerUpdateCertificateMutation__
 *
 * To run a mutation, you first call `useEditSkillsAndCertificatesDrawerUpdateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerUpdateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillsAndCertificatesDrawerUpdateCertificateMutation, { data, loading, error }] = useEditSkillsAndCertificatesDrawerUpdateCertificateMutation({
 *   variables: {
 *      certificateId: // value for 'certificateId'
 *      certificate: // value for 'certificate'
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerUpdateCertificateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSkillsAndCertificatesDrawerUpdateCertificateMutation, EditSkillsAndCertificatesDrawerUpdateCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerUpdateCertificateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSkillsAndCertificatesDrawerUpdateCertificateMutation, EditSkillsAndCertificatesDrawerUpdateCertificateMutationVariables>(EditSkillsAndCertificatesDrawerUpdateCertificateDocument, parser(options)));
      }
export type EditSkillsAndCertificatesDrawerUpdateCertificateMutationHookResult = ReturnType<typeof useEditSkillsAndCertificatesDrawerUpdateCertificateMutation>;
export type EditSkillsAndCertificatesDrawerUpdateCertificateMutationResult = ApolloReact.MutationResult<EditSkillsAndCertificatesDrawerUpdateCertificateMutation>;
export type EditSkillsAndCertificatesDrawerUpdateCertificateMutationOptions = Apollo.MutationOptions<EditSkillsAndCertificatesDrawerUpdateCertificateMutation, EditSkillsAndCertificatesDrawerUpdateCertificateMutationVariables>;
export const EditSkillsAndCertificatesDrawerDeleteCertificateDocument = /*#__PURE__*/ gql`
    mutation EditSkillsAndCertificatesDrawer_DeleteCertificate($certificateId: CertificateId!) {
  deleteCertificate(certificateId: $certificateId) {
    ...NfsError
    ... on BooleanResponse {
      value
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditSkillsAndCertificatesDrawerDeleteCertificateMutation__
 *
 * To run a mutation, you first call `useEditSkillsAndCertificatesDrawerDeleteCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerDeleteCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillsAndCertificatesDrawerDeleteCertificateMutation, { data, loading, error }] = useEditSkillsAndCertificatesDrawerDeleteCertificateMutation({
 *   variables: {
 *      certificateId: // value for 'certificateId'
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerDeleteCertificateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSkillsAndCertificatesDrawerDeleteCertificateMutation, EditSkillsAndCertificatesDrawerDeleteCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerDeleteCertificateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSkillsAndCertificatesDrawerDeleteCertificateMutation, EditSkillsAndCertificatesDrawerDeleteCertificateMutationVariables>(EditSkillsAndCertificatesDrawerDeleteCertificateDocument, parser(options)));
      }
export type EditSkillsAndCertificatesDrawerDeleteCertificateMutationHookResult = ReturnType<typeof useEditSkillsAndCertificatesDrawerDeleteCertificateMutation>;
export type EditSkillsAndCertificatesDrawerDeleteCertificateMutationResult = ApolloReact.MutationResult<EditSkillsAndCertificatesDrawerDeleteCertificateMutation>;
export type EditSkillsAndCertificatesDrawerDeleteCertificateMutationOptions = Apollo.MutationOptions<EditSkillsAndCertificatesDrawerDeleteCertificateMutation, EditSkillsAndCertificatesDrawerDeleteCertificateMutationVariables>;
export const EditSocialMediaHandlesDrawerDocument = /*#__PURE__*/ gql`
    query EditSocialMediaHandlesDrawer($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...EditSocialMediaHandlesDrawer_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditSocialMediaHandlesDrawerUserFragmentDoc}`;

/**
 * __useEditSocialMediaHandlesDrawerQuery__
 *
 * To run a query within a React component, call `useEditSocialMediaHandlesDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSocialMediaHandlesDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSocialMediaHandlesDrawerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEditSocialMediaHandlesDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<EditSocialMediaHandlesDrawerQuery, EditSocialMediaHandlesDrawerQueryVariables> & ({ variables: EditSocialMediaHandlesDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSocialMediaHandlesDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditSocialMediaHandlesDrawerQuery, EditSocialMediaHandlesDrawerQueryVariables>(EditSocialMediaHandlesDrawerDocument, parser(options)));
      }
export function useEditSocialMediaHandlesDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditSocialMediaHandlesDrawerQuery, EditSocialMediaHandlesDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditSocialMediaHandlesDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditSocialMediaHandlesDrawerQuery, EditSocialMediaHandlesDrawerQueryVariables>(EditSocialMediaHandlesDrawerDocument, options));
        }

export type EditSocialMediaHandlesDrawerQueryResult = ApolloReact.QueryResult<EditSocialMediaHandlesDrawerQuery, EditSocialMediaHandlesDrawerQueryVariables>;
export function refetchEditSocialMediaHandlesDrawerQuery(variables: EditSocialMediaHandlesDrawerQueryVariables) {
      return { query: EditSocialMediaHandlesDrawerDocument, variables: variables }
    }
export const EditSocialMediaHandlesDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditSocialMediaHandlesDrawer_Update($userId: UserId!, $entityVersion: EntityVersion!, $socialMediaHandles: [SocialMediaHandleInput!]) {
  user(userId: $userId, entityVersion: $entityVersion) {
    updateUser(socialMediaHandles: $socialMediaHandles) {
      ...NfsError
      ... on User {
        ...EditSocialMediaHandlesDrawer_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditSocialMediaHandlesDrawerUserFragmentDoc}`;


/**
 * __useEditSocialMediaHandlesDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditSocialMediaHandlesDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSocialMediaHandlesDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSocialMediaHandlesDrawerUpdateMutation, { data, loading, error }] = useEditSocialMediaHandlesDrawerUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      socialMediaHandles: // value for 'socialMediaHandles'
 *   },
 * });
 */
export function useEditSocialMediaHandlesDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSocialMediaHandlesDrawerUpdateMutation, EditSocialMediaHandlesDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSocialMediaHandlesDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSocialMediaHandlesDrawerUpdateMutation, EditSocialMediaHandlesDrawerUpdateMutationVariables>(EditSocialMediaHandlesDrawerUpdateDocument, parser(options)));
      }
export type EditSocialMediaHandlesDrawerUpdateMutationHookResult = ReturnType<typeof useEditSocialMediaHandlesDrawerUpdateMutation>;
export type EditSocialMediaHandlesDrawerUpdateMutationResult = ApolloReact.MutationResult<EditSocialMediaHandlesDrawerUpdateMutation>;
export type EditSocialMediaHandlesDrawerUpdateMutationOptions = Apollo.MutationOptions<EditSocialMediaHandlesDrawerUpdateMutation, EditSocialMediaHandlesDrawerUpdateMutationVariables>;
export const EditSpaceDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query EditSpaceDrawer_InitialData($spaceId: SpaceId!) {
  space(spaceId: $spaceId) {
    ...NfsError
    ... on Space {
      ...EditSpaceDrawer_Space
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditSpaceDrawerSpaceFragmentDoc}`;

/**
 * __useEditSpaceDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useEditSpaceDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSpaceDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSpaceDrawerInitialDataQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *   },
 * });
 */
export function useEditSpaceDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<EditSpaceDrawerInitialDataQuery, EditSpaceDrawerInitialDataQueryVariables> & ({ variables: EditSpaceDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSpaceDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditSpaceDrawerInitialDataQuery, EditSpaceDrawerInitialDataQueryVariables>(EditSpaceDrawerInitialDataDocument, parser(options)));
      }
export function useEditSpaceDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditSpaceDrawerInitialDataQuery, EditSpaceDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditSpaceDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditSpaceDrawerInitialDataQuery, EditSpaceDrawerInitialDataQueryVariables>(EditSpaceDrawerInitialDataDocument, options));
        }

export type EditSpaceDrawerInitialDataQueryResult = ApolloReact.QueryResult<EditSpaceDrawerInitialDataQuery, EditSpaceDrawerInitialDataQueryVariables>;
export function refetchEditSpaceDrawerInitialDataQuery(variables: EditSpaceDrawerInitialDataQueryVariables) {
      return { query: EditSpaceDrawerInitialDataDocument, variables: variables }
    }
export const EditSpaceDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditSpaceDrawer_Update($spaceId: SpaceId!, $entityVersion: EntityVersion!, $name: String, $owner: UserId, $directors: [UserId!]) {
  space(spaceId: $spaceId, entityVersion: $entityVersion) {
    updateSpace(name: $name, owner: $owner, directors: $directors) {
      ...NfsError
      ... on Space {
        ...EditSpaceDrawer_Space
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditSpaceDrawerSpaceFragmentDoc}`;


/**
 * __useEditSpaceDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditSpaceDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSpaceDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSpaceDrawerUpdateMutation, { data, loading, error }] = useEditSpaceDrawerUpdateMutation({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      entityVersion: // value for 'entityVersion'
 *      name: // value for 'name'
 *      owner: // value for 'owner'
 *      directors: // value for 'directors'
 *   },
 * });
 */
export function useEditSpaceDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSpaceDrawerUpdateMutation, EditSpaceDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSpaceDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSpaceDrawerUpdateMutation, EditSpaceDrawerUpdateMutationVariables>(EditSpaceDrawerUpdateDocument, parser(options)));
      }
export type EditSpaceDrawerUpdateMutationHookResult = ReturnType<typeof useEditSpaceDrawerUpdateMutation>;
export type EditSpaceDrawerUpdateMutationResult = ApolloReact.MutationResult<EditSpaceDrawerUpdateMutation>;
export type EditSpaceDrawerUpdateMutationOptions = Apollo.MutationOptions<EditSpaceDrawerUpdateMutation, EditSpaceDrawerUpdateMutationVariables>;
export const EditVariantDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditVariantDrawer_Update($id: BenefitVariantId!, $entityVersion: EntityVersion!, $productId: BenefitVariantProductId!, $productName: String!, $promiseeRate: TimeBasedValueClearableBenefitVariantRateInput, $promisorRate: TimeBasedValueClearableBenefitVariantRateInput, $additionalPeople: ClearableBenefitAdditionalPeopleInput, $meansOfProduction: Boolean, $buyerType: BenefitBuyerType, $invoiceCategory: BenefitInvoiceCategory, $description: ClearableStringInput) {
  benefitVariant(id: $id, entityVersion: $entityVersion) {
    update(
      productId: $productId
      productName: $productName
      promiseeRate: $promiseeRate
      promisorRate: $promisorRate
      additionalPeople: $additionalPeople
      meansOfProduction: $meansOfProduction
      buyerType: $buyerType
      invoiceCategory: $invoiceCategory
      description: $description
    ) {
      ...NfsError
      ... on BenefitVariant {
        ...EditVariantDrawer_BenefitVariant
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditVariantDrawerBenefitVariantFragmentDoc}`;


/**
 * __useEditVariantDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditVariantDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVariantDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVariantDrawerUpdateMutation, { data, loading, error }] = useEditVariantDrawerUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityVersion: // value for 'entityVersion'
 *      productId: // value for 'productId'
 *      productName: // value for 'productName'
 *      promiseeRate: // value for 'promiseeRate'
 *      promisorRate: // value for 'promisorRate'
 *      additionalPeople: // value for 'additionalPeople'
 *      meansOfProduction: // value for 'meansOfProduction'
 *      buyerType: // value for 'buyerType'
 *      invoiceCategory: // value for 'invoiceCategory'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useEditVariantDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditVariantDrawerUpdateMutation, EditVariantDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditVariantDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditVariantDrawerUpdateMutation, EditVariantDrawerUpdateMutationVariables>(EditVariantDrawerUpdateDocument, parser(options)));
      }
export type EditVariantDrawerUpdateMutationHookResult = ReturnType<typeof useEditVariantDrawerUpdateMutation>;
export type EditVariantDrawerUpdateMutationResult = ApolloReact.MutationResult<EditVariantDrawerUpdateMutation>;
export type EditVariantDrawerUpdateMutationOptions = Apollo.MutationOptions<EditVariantDrawerUpdateMutation, EditVariantDrawerUpdateMutationVariables>;
export const EditVariantDrawerTerminateDocument = /*#__PURE__*/ gql`
    mutation EditVariantDrawer_Terminate($id: BenefitVariantId!, $entityVersion: EntityVersion!, $endDate: LocalDate!) {
  benefitVariant(id: $id, entityVersion: $entityVersion) {
    terminate(terminationDate: $endDate) {
      ...NfsError
      ... on BenefitVariant {
        ...EditVariantDrawer_BenefitVariant
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditVariantDrawerBenefitVariantFragmentDoc}`;


/**
 * __useEditVariantDrawerTerminateMutation__
 *
 * To run a mutation, you first call `useEditVariantDrawerTerminateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVariantDrawerTerminateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVariantDrawerTerminateMutation, { data, loading, error }] = useEditVariantDrawerTerminateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityVersion: // value for 'entityVersion'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useEditVariantDrawerTerminateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditVariantDrawerTerminateMutation, EditVariantDrawerTerminateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditVariantDrawerTerminateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditVariantDrawerTerminateMutation, EditVariantDrawerTerminateMutationVariables>(EditVariantDrawerTerminateDocument, parser(options)));
      }
export type EditVariantDrawerTerminateMutationHookResult = ReturnType<typeof useEditVariantDrawerTerminateMutation>;
export type EditVariantDrawerTerminateMutationResult = ApolloReact.MutationResult<EditVariantDrawerTerminateMutation>;
export type EditVariantDrawerTerminateMutationOptions = Apollo.MutationOptions<EditVariantDrawerTerminateMutation, EditVariantDrawerTerminateMutationVariables>;
export const EditVariantDrawerLoadDataDocument = /*#__PURE__*/ gql`
    query EditVariantDrawer_LoadData($id: BenefitVariantId!, $at: OffsetDateTime) {
  benefitVariant(id: $id, at: $at) {
    ...NfsError
    ... on BenefitVariant {
      at
      ...EditVariantDrawer_BenefitVariant
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditVariantDrawerBenefitVariantFragmentDoc}`;

/**
 * __useEditVariantDrawerLoadDataQuery__
 *
 * To run a query within a React component, call `useEditVariantDrawerLoadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditVariantDrawerLoadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditVariantDrawerLoadDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      at: // value for 'at'
 *   },
 * });
 */
export function useEditVariantDrawerLoadDataQuery(baseOptions: ApolloReact.QueryHookOptions<EditVariantDrawerLoadDataQuery, EditVariantDrawerLoadDataQueryVariables> & ({ variables: EditVariantDrawerLoadDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditVariantDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditVariantDrawerLoadDataQuery, EditVariantDrawerLoadDataQueryVariables>(EditVariantDrawerLoadDataDocument, parser(options)));
      }
export function useEditVariantDrawerLoadDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditVariantDrawerLoadDataQuery, EditVariantDrawerLoadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditVariantDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditVariantDrawerLoadDataQuery, EditVariantDrawerLoadDataQueryVariables>(EditVariantDrawerLoadDataDocument, options));
        }

export type EditVariantDrawerLoadDataQueryResult = ApolloReact.QueryResult<EditVariantDrawerLoadDataQuery, EditVariantDrawerLoadDataQueryVariables>;
export function refetchEditVariantDrawerLoadDataQuery(variables: EditVariantDrawerLoadDataQueryVariables) {
      return { query: EditVariantDrawerLoadDataDocument, variables: variables }
    }
export const EmployeeDueDatesDrawerDocument = /*#__PURE__*/ gql`
    query EmployeeDueDatesDrawer($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...EmployeeDueDatesDrawer_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmployeeDueDatesDrawerUserFragmentDoc}`;

/**
 * __useEmployeeDueDatesDrawerQuery__
 *
 * To run a query within a React component, call `useEmployeeDueDatesDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDueDatesDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeDueDatesDrawerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEmployeeDueDatesDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<EmployeeDueDatesDrawerQuery, EmployeeDueDatesDrawerQueryVariables> & ({ variables: EmployeeDueDatesDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmployeeDueDatesDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EmployeeDueDatesDrawerQuery, EmployeeDueDatesDrawerQueryVariables>(EmployeeDueDatesDrawerDocument, parser(options)));
      }
export function useEmployeeDueDatesDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EmployeeDueDatesDrawerQuery, EmployeeDueDatesDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EmployeeDueDatesDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EmployeeDueDatesDrawerQuery, EmployeeDueDatesDrawerQueryVariables>(EmployeeDueDatesDrawerDocument, options));
        }

export type EmployeeDueDatesDrawerQueryResult = ApolloReact.QueryResult<EmployeeDueDatesDrawerQuery, EmployeeDueDatesDrawerQueryVariables>;
export function refetchEmployeeDueDatesDrawerQuery(variables: EmployeeDueDatesDrawerQueryVariables) {
      return { query: EmployeeDueDatesDrawerDocument, variables: variables }
    }
export const EmployeeDueDatesDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EmployeeDueDatesDrawer_Update($userId: UserId!, $entityVersion: EntityVersion!, $isStudentRevisionDate: ClearableLocalDateInput!, $nextMedicalExaminationDate: ClearableLocalDateInput!, $nextOhsTrainingDate: ClearableLocalDateInput!, $isStudent: Boolean!) {
  user(userId: $userId, entityVersion: $entityVersion) {
    updateUser(
      isStudentRevisionDate: $isStudentRevisionDate
      nextMedicalExaminationDate: $nextMedicalExaminationDate
      nextOhsTrainingDate: $nextOhsTrainingDate
      isStudent: $isStudent
    ) {
      ...NfsError
      ... on User {
        ...EmployeeDueDatesDrawer_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmployeeDueDatesDrawerUserFragmentDoc}`;


/**
 * __useEmployeeDueDatesDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEmployeeDueDatesDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDueDatesDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeDueDatesDrawerUpdateMutation, { data, loading, error }] = useEmployeeDueDatesDrawerUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      isStudentRevisionDate: // value for 'isStudentRevisionDate'
 *      nextMedicalExaminationDate: // value for 'nextMedicalExaminationDate'
 *      nextOhsTrainingDate: // value for 'nextOhsTrainingDate'
 *      isStudent: // value for 'isStudent'
 *   },
 * });
 */
export function useEmployeeDueDatesDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EmployeeDueDatesDrawerUpdateMutation, EmployeeDueDatesDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmployeeDueDatesDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmployeeDueDatesDrawerUpdateMutation, EmployeeDueDatesDrawerUpdateMutationVariables>(EmployeeDueDatesDrawerUpdateDocument, parser(options)));
      }
export type EmployeeDueDatesDrawerUpdateMutationHookResult = ReturnType<typeof useEmployeeDueDatesDrawerUpdateMutation>;
export type EmployeeDueDatesDrawerUpdateMutationResult = ApolloReact.MutationResult<EmployeeDueDatesDrawerUpdateMutation>;
export type EmployeeDueDatesDrawerUpdateMutationOptions = Apollo.MutationOptions<EmployeeDueDatesDrawerUpdateMutation, EmployeeDueDatesDrawerUpdateMutationVariables>;
export const EmploymentBankAccountDrawerContractInputDocument = /*#__PURE__*/ gql`
    query EmploymentBankAccountDrawer_ContractInput($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        promisee {
          id
          entityVersion
        }
        ... on EmploymentContract {
          promiseeTransferBankAccount {
            ...Unauthorized
            ... on AccessGranted__BankAccount {
              value {
                ...BankAccount
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${BankAccountFragmentDoc}`;

/**
 * __useEmploymentBankAccountDrawerContractInputQuery__
 *
 * To run a query within a React component, call `useEmploymentBankAccountDrawerContractInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmploymentBankAccountDrawerContractInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmploymentBankAccountDrawerContractInputQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useEmploymentBankAccountDrawerContractInputQuery(baseOptions: ApolloReact.QueryHookOptions<EmploymentBankAccountDrawerContractInputQuery, EmploymentBankAccountDrawerContractInputQueryVariables> & ({ variables: EmploymentBankAccountDrawerContractInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentBankAccountDrawerContractInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EmploymentBankAccountDrawerContractInputQuery, EmploymentBankAccountDrawerContractInputQueryVariables>(EmploymentBankAccountDrawerContractInputDocument, parser(options)));
      }
export function useEmploymentBankAccountDrawerContractInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EmploymentBankAccountDrawerContractInputQuery, EmploymentBankAccountDrawerContractInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EmploymentBankAccountDrawerContractInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EmploymentBankAccountDrawerContractInputQuery, EmploymentBankAccountDrawerContractInputQueryVariables>(EmploymentBankAccountDrawerContractInputDocument, options));
        }

export type EmploymentBankAccountDrawerContractInputQueryResult = ApolloReact.QueryResult<EmploymentBankAccountDrawerContractInputQuery, EmploymentBankAccountDrawerContractInputQueryVariables>;
export function refetchEmploymentBankAccountDrawerContractInputQuery(variables: EmploymentBankAccountDrawerContractInputQueryVariables) {
      return { query: EmploymentBankAccountDrawerContractInputDocument, variables: variables }
    }
export const EmploymentBankAccountDrawerDraftInputDocument = /*#__PURE__*/ gql`
    query EmploymentBankAccountDrawer_DraftInput($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            entityVersion
            promisee {
              id
              entityVersion
            }
            ... on EmploymentContractDraft {
              promiseeTransferBankAccount {
                ...BankAccount
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${BankAccountFragmentDoc}`;

/**
 * __useEmploymentBankAccountDrawerDraftInputQuery__
 *
 * To run a query within a React component, call `useEmploymentBankAccountDrawerDraftInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmploymentBankAccountDrawerDraftInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmploymentBankAccountDrawerDraftInputQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEmploymentBankAccountDrawerDraftInputQuery(baseOptions: ApolloReact.QueryHookOptions<EmploymentBankAccountDrawerDraftInputQuery, EmploymentBankAccountDrawerDraftInputQueryVariables> & ({ variables: EmploymentBankAccountDrawerDraftInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentBankAccountDrawerDraftInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EmploymentBankAccountDrawerDraftInputQuery, EmploymentBankAccountDrawerDraftInputQueryVariables>(EmploymentBankAccountDrawerDraftInputDocument, parser(options)));
      }
export function useEmploymentBankAccountDrawerDraftInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EmploymentBankAccountDrawerDraftInputQuery, EmploymentBankAccountDrawerDraftInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EmploymentBankAccountDrawerDraftInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EmploymentBankAccountDrawerDraftInputQuery, EmploymentBankAccountDrawerDraftInputQueryVariables>(EmploymentBankAccountDrawerDraftInputDocument, options));
        }

export type EmploymentBankAccountDrawerDraftInputQueryResult = ApolloReact.QueryResult<EmploymentBankAccountDrawerDraftInputQuery, EmploymentBankAccountDrawerDraftInputQueryVariables>;
export function refetchEmploymentBankAccountDrawerDraftInputQuery(variables: EmploymentBankAccountDrawerDraftInputQueryVariables) {
      return { query: EmploymentBankAccountDrawerDraftInputDocument, variables: variables }
    }
export const EmploymentBankAccountDrawerUpdateEmploymentDraftDocument = /*#__PURE__*/ gql`
    mutation EmploymentBankAccountDrawer_UpdateEmploymentDraft($userId: UserId!, $userEntityVersion: EntityVersion!, $entityVersion: EntityVersion!, $promiseeTransferBankAccount: ClearableBankAccountInput!) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateEmploymentDraft(promiseeTransferBankAccount: $promiseeTransferBankAccount) {
        ...NfsError
        ... on EmploymentContractDraft {
          id
          entityVersion
          promiseeTransferBankAccount {
            ...BankAccount
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankAccountFragmentDoc}`;


/**
 * __useEmploymentBankAccountDrawerUpdateEmploymentDraftMutation__
 *
 * To run a mutation, you first call `useEmploymentBankAccountDrawerUpdateEmploymentDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentBankAccountDrawerUpdateEmploymentDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentBankAccountDrawerUpdateEmploymentDraftMutation, { data, loading, error }] = useEmploymentBankAccountDrawerUpdateEmploymentDraftMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      entityVersion: // value for 'entityVersion'
 *      promiseeTransferBankAccount: // value for 'promiseeTransferBankAccount'
 *   },
 * });
 */
export function useEmploymentBankAccountDrawerUpdateEmploymentDraftMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentBankAccountDrawerUpdateEmploymentDraftMutation, EmploymentBankAccountDrawerUpdateEmploymentDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentBankAccountDrawerUpdateEmploymentDraftDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentBankAccountDrawerUpdateEmploymentDraftMutation, EmploymentBankAccountDrawerUpdateEmploymentDraftMutationVariables>(EmploymentBankAccountDrawerUpdateEmploymentDraftDocument, parser(options)));
      }
export type EmploymentBankAccountDrawerUpdateEmploymentDraftMutationHookResult = ReturnType<typeof useEmploymentBankAccountDrawerUpdateEmploymentDraftMutation>;
export type EmploymentBankAccountDrawerUpdateEmploymentDraftMutationResult = ApolloReact.MutationResult<EmploymentBankAccountDrawerUpdateEmploymentDraftMutation>;
export type EmploymentBankAccountDrawerUpdateEmploymentDraftMutationOptions = Apollo.MutationOptions<EmploymentBankAccountDrawerUpdateEmploymentDraftMutation, EmploymentBankAccountDrawerUpdateEmploymentDraftMutationVariables>;
export const EmploymentBankAccountDrawerUpdateContractDocument = /*#__PURE__*/ gql`
    mutation EmploymentBankAccountDrawer_UpdateContract($contractId: ContractId!, $entityVersion: EntityVersion!, $promiseeTransferBankAccount: BankAccountInput) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(
      promiseeTransferBankAccount: $promiseeTransferBankAccount
    ) {
      ...NfsError
      ... on EmploymentContract {
        id
        entityVersion
        promiseeTransferBankAccount {
          ...Unauthorized
          ... on AccessGranted__BankAccount {
            value {
              ...BankAccount
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${BankAccountFragmentDoc}`;


/**
 * __useEmploymentBankAccountDrawerUpdateContractMutation__
 *
 * To run a mutation, you first call `useEmploymentBankAccountDrawerUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentBankAccountDrawerUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentBankAccountDrawerUpdateContractMutation, { data, loading, error }] = useEmploymentBankAccountDrawerUpdateContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      promiseeTransferBankAccount: // value for 'promiseeTransferBankAccount'
 *   },
 * });
 */
export function useEmploymentBankAccountDrawerUpdateContractMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentBankAccountDrawerUpdateContractMutation, EmploymentBankAccountDrawerUpdateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentBankAccountDrawerUpdateContractDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentBankAccountDrawerUpdateContractMutation, EmploymentBankAccountDrawerUpdateContractMutationVariables>(EmploymentBankAccountDrawerUpdateContractDocument, parser(options)));
      }
export type EmploymentBankAccountDrawerUpdateContractMutationHookResult = ReturnType<typeof useEmploymentBankAccountDrawerUpdateContractMutation>;
export type EmploymentBankAccountDrawerUpdateContractMutationResult = ApolloReact.MutationResult<EmploymentBankAccountDrawerUpdateContractMutation>;
export type EmploymentBankAccountDrawerUpdateContractMutationOptions = Apollo.MutationOptions<EmploymentBankAccountDrawerUpdateContractMutation, EmploymentBankAccountDrawerUpdateContractMutationVariables>;
export const EmploymentContractDraftDrawerInputDocument = /*#__PURE__*/ gql`
    query EmploymentContractDraftDrawer_Input($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...EmploymentContractDraftDrawer_User
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            ...EmploymentContractDraftDrawer_Draft
          }
        }
      }
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            startDate
            promisor {
              value {
                id
              }
            }
            ... on EmploymentContract {
              type
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmploymentContractDraftDrawerUserFragmentDoc}
${UnauthorizedFragmentDoc}
${EmploymentContractDraftDrawerDraftFragmentDoc}`;

/**
 * __useEmploymentContractDraftDrawerInputQuery__
 *
 * To run a query within a React component, call `useEmploymentContractDraftDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmploymentContractDraftDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmploymentContractDraftDrawerInputQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEmploymentContractDraftDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<EmploymentContractDraftDrawerInputQuery, EmploymentContractDraftDrawerInputQueryVariables> & ({ variables: EmploymentContractDraftDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentContractDraftDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EmploymentContractDraftDrawerInputQuery, EmploymentContractDraftDrawerInputQueryVariables>(EmploymentContractDraftDrawerInputDocument, parser(options)));
      }
export function useEmploymentContractDraftDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EmploymentContractDraftDrawerInputQuery, EmploymentContractDraftDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EmploymentContractDraftDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EmploymentContractDraftDrawerInputQuery, EmploymentContractDraftDrawerInputQueryVariables>(EmploymentContractDraftDrawerInputDocument, options));
        }

export type EmploymentContractDraftDrawerInputQueryResult = ApolloReact.QueryResult<EmploymentContractDraftDrawerInputQuery, EmploymentContractDraftDrawerInputQueryVariables>;
export function refetchEmploymentContractDraftDrawerInputQuery(variables: EmploymentContractDraftDrawerInputQueryVariables) {
      return { query: EmploymentContractDraftDrawerInputDocument, variables: variables }
    }
export const EmploymentContractDraftDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation EmploymentContractDraftDrawer_Create($userId: UserId!, $userEntityVersion: EntityVersion!, $contractId: ContractId!, $type: EmploymentContractType!, $promisorId: CompanyId!, $name: String!, $startDate: LocalDate, $expectedEndDate: LocalDate, $holidayCalendarId: HolidayCalendarId, $scopeOfWork: String, $position: String, $paidLeaveEntitlement: Days) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    createEmploymentContractDraft(
      contractId: $contractId
      promisorId: $promisorId
      type: $type
      name: $name
      startDate: $startDate
      expectedEndDate: $expectedEndDate
      holidayCalendarId: $holidayCalendarId
      scopeOfWork: $scopeOfWork
      position: $position
      paidLeaveEntitlement: $paidLeaveEntitlement
    ) {
      ...NfsError
      ... on EmploymentContractDraft {
        ...EmploymentContractDraftDrawer_Draft
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmploymentContractDraftDrawerDraftFragmentDoc}`;


/**
 * __useEmploymentContractDraftDrawerCreateMutation__
 *
 * To run a mutation, you first call `useEmploymentContractDraftDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentContractDraftDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentContractDraftDrawerCreateMutation, { data, loading, error }] = useEmploymentContractDraftDrawerCreateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      contractId: // value for 'contractId'
 *      type: // value for 'type'
 *      promisorId: // value for 'promisorId'
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *      expectedEndDate: // value for 'expectedEndDate'
 *      holidayCalendarId: // value for 'holidayCalendarId'
 *      scopeOfWork: // value for 'scopeOfWork'
 *      position: // value for 'position'
 *      paidLeaveEntitlement: // value for 'paidLeaveEntitlement'
 *   },
 * });
 */
export function useEmploymentContractDraftDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentContractDraftDrawerCreateMutation, EmploymentContractDraftDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentContractDraftDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentContractDraftDrawerCreateMutation, EmploymentContractDraftDrawerCreateMutationVariables>(EmploymentContractDraftDrawerCreateDocument, parser(options)));
      }
export type EmploymentContractDraftDrawerCreateMutationHookResult = ReturnType<typeof useEmploymentContractDraftDrawerCreateMutation>;
export type EmploymentContractDraftDrawerCreateMutationResult = ApolloReact.MutationResult<EmploymentContractDraftDrawerCreateMutation>;
export type EmploymentContractDraftDrawerCreateMutationOptions = Apollo.MutationOptions<EmploymentContractDraftDrawerCreateMutation, EmploymentContractDraftDrawerCreateMutationVariables>;
export const EmploymentContractDraftDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EmploymentContractDraftDrawer_Update($userId: UserId!, $userEntityVersion: EntityVersion!, $entityVersion: EntityVersion!, $startDate: ClearableLocalDateInput, $expectedEndDate: ClearableLocalDateInput, $holidayCalendarId: ClearableHolidayCalendarIdInput, $scopeOfWork: ClearableStringInput, $position: ClearableStringInput, $paidLeaveEntitlement: ClearableDaysInput, $promisorId: CompanyId!) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateEmploymentDraft(
        startDate: $startDate
        expectedEndDate: $expectedEndDate
        holidayCalendarId: $holidayCalendarId
        scopeOfWork: $scopeOfWork
        position: $position
        paidLeaveEntitlement: $paidLeaveEntitlement
        promisorId: $promisorId
      ) {
        ...NfsError
        ... on EmploymentContractDraft {
          ...EmploymentContractDraftDrawer_Draft
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmploymentContractDraftDrawerDraftFragmentDoc}`;


/**
 * __useEmploymentContractDraftDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEmploymentContractDraftDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentContractDraftDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentContractDraftDrawerUpdateMutation, { data, loading, error }] = useEmploymentContractDraftDrawerUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      entityVersion: // value for 'entityVersion'
 *      startDate: // value for 'startDate'
 *      expectedEndDate: // value for 'expectedEndDate'
 *      holidayCalendarId: // value for 'holidayCalendarId'
 *      scopeOfWork: // value for 'scopeOfWork'
 *      position: // value for 'position'
 *      paidLeaveEntitlement: // value for 'paidLeaveEntitlement'
 *      promisorId: // value for 'promisorId'
 *   },
 * });
 */
export function useEmploymentContractDraftDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentContractDraftDrawerUpdateMutation, EmploymentContractDraftDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentContractDraftDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentContractDraftDrawerUpdateMutation, EmploymentContractDraftDrawerUpdateMutationVariables>(EmploymentContractDraftDrawerUpdateDocument, parser(options)));
      }
export type EmploymentContractDraftDrawerUpdateMutationHookResult = ReturnType<typeof useEmploymentContractDraftDrawerUpdateMutation>;
export type EmploymentContractDraftDrawerUpdateMutationResult = ApolloReact.MutationResult<EmploymentContractDraftDrawerUpdateMutation>;
export type EmploymentContractDraftDrawerUpdateMutationOptions = Apollo.MutationOptions<EmploymentContractDraftDrawerUpdateMutation, EmploymentContractDraftDrawerUpdateMutationVariables>;
export const EmploymentContractDraftDrawerUpdateUserDocument = /*#__PURE__*/ gql`
    mutation EmploymentContractDraftDrawer_UpdateUser($userId: UserId!, $userEntityVersion: EntityVersion!, $pesel: ClearablePESELInput, $birthDate: ClearableLocalDateInput, $address: ClearableAddressInput, $mailingAddress: ClearableAddressInput, $idType: ClearableIDTypeInput, $idNumber: ClearableStringInput, $isStudent: Boolean!, $isStudentRevisionDate: ClearableLocalDateInput, $nextMedicalExaminationDate: ClearableLocalDateInput, $emergencyContact: ClearableStringInput) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    updateUser(
      pesel: $pesel
      birthDate: $birthDate
      address: $address
      mailingAddress: $mailingAddress
      idType: $idType
      idNumber: $idNumber
      isStudent: $isStudent
      isStudentRevisionDate: $isStudentRevisionDate
      nextMedicalExaminationDate: $nextMedicalExaminationDate
      emergencyContact: $emergencyContact
    ) {
      ...NfsError
      ... on User {
        ...EmploymentContractDraftDrawer_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmploymentContractDraftDrawerUserFragmentDoc}`;


/**
 * __useEmploymentContractDraftDrawerUpdateUserMutation__
 *
 * To run a mutation, you first call `useEmploymentContractDraftDrawerUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentContractDraftDrawerUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentContractDraftDrawerUpdateUserMutation, { data, loading, error }] = useEmploymentContractDraftDrawerUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      pesel: // value for 'pesel'
 *      birthDate: // value for 'birthDate'
 *      address: // value for 'address'
 *      mailingAddress: // value for 'mailingAddress'
 *      idType: // value for 'idType'
 *      idNumber: // value for 'idNumber'
 *      isStudent: // value for 'isStudent'
 *      isStudentRevisionDate: // value for 'isStudentRevisionDate'
 *      nextMedicalExaminationDate: // value for 'nextMedicalExaminationDate'
 *      emergencyContact: // value for 'emergencyContact'
 *   },
 * });
 */
export function useEmploymentContractDraftDrawerUpdateUserMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentContractDraftDrawerUpdateUserMutation, EmploymentContractDraftDrawerUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentContractDraftDrawerUpdateUserDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentContractDraftDrawerUpdateUserMutation, EmploymentContractDraftDrawerUpdateUserMutationVariables>(EmploymentContractDraftDrawerUpdateUserDocument, parser(options)));
      }
export type EmploymentContractDraftDrawerUpdateUserMutationHookResult = ReturnType<typeof useEmploymentContractDraftDrawerUpdateUserMutation>;
export type EmploymentContractDraftDrawerUpdateUserMutationResult = ApolloReact.MutationResult<EmploymentContractDraftDrawerUpdateUserMutation>;
export type EmploymentContractDraftDrawerUpdateUserMutationOptions = Apollo.MutationOptions<EmploymentContractDraftDrawerUpdateUserMutation, EmploymentContractDraftDrawerUpdateUserMutationVariables>;
export const EmploymentSalariesListItemMarkAsDisbursedDocument = /*#__PURE__*/ gql`
    mutation EmploymentSalariesListItem_MarkAsDisbursed($yearMonth: YearMonth!, $filter: FilterContractSalaryDetailsInput!) {
  markPaymentAsDisbursed(yearMonth: $yearMonth, filter: $filter) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      ...EmploymentSalariesListItem_SalaryStateChange
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmploymentSalariesListItemSalaryStateChangeFragmentDoc}`;


/**
 * __useEmploymentSalariesListItemMarkAsDisbursedMutation__
 *
 * To run a mutation, you first call `useEmploymentSalariesListItemMarkAsDisbursedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentSalariesListItemMarkAsDisbursedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentSalariesListItemMarkAsDisbursedMutation, { data, loading, error }] = useEmploymentSalariesListItemMarkAsDisbursedMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmploymentSalariesListItemMarkAsDisbursedMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentSalariesListItemMarkAsDisbursedMutation, EmploymentSalariesListItemMarkAsDisbursedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentSalariesListItemMarkAsDisbursedDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentSalariesListItemMarkAsDisbursedMutation, EmploymentSalariesListItemMarkAsDisbursedMutationVariables>(EmploymentSalariesListItemMarkAsDisbursedDocument, parser(options)));
      }
export type EmploymentSalariesListItemMarkAsDisbursedMutationHookResult = ReturnType<typeof useEmploymentSalariesListItemMarkAsDisbursedMutation>;
export type EmploymentSalariesListItemMarkAsDisbursedMutationResult = ApolloReact.MutationResult<EmploymentSalariesListItemMarkAsDisbursedMutation>;
export type EmploymentSalariesListItemMarkAsDisbursedMutationOptions = Apollo.MutationOptions<EmploymentSalariesListItemMarkAsDisbursedMutation, EmploymentSalariesListItemMarkAsDisbursedMutationVariables>;
export const EmploymentSalariesListItemUnmarkAsDisbursedDocument = /*#__PURE__*/ gql`
    mutation EmploymentSalariesListItem_UnmarkAsDisbursed($yearMonth: YearMonth!, $filter: FilterContractSalaryDetailsInput!) {
  unmarkPaymentAsDisbursed(yearMonth: $yearMonth, filter: $filter) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      ...EmploymentSalariesListItem_SalaryStateChange
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmploymentSalariesListItemSalaryStateChangeFragmentDoc}`;


/**
 * __useEmploymentSalariesListItemUnmarkAsDisbursedMutation__
 *
 * To run a mutation, you first call `useEmploymentSalariesListItemUnmarkAsDisbursedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentSalariesListItemUnmarkAsDisbursedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentSalariesListItemUnmarkAsDisbursedMutation, { data, loading, error }] = useEmploymentSalariesListItemUnmarkAsDisbursedMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmploymentSalariesListItemUnmarkAsDisbursedMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentSalariesListItemUnmarkAsDisbursedMutation, EmploymentSalariesListItemUnmarkAsDisbursedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentSalariesListItemUnmarkAsDisbursedDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentSalariesListItemUnmarkAsDisbursedMutation, EmploymentSalariesListItemUnmarkAsDisbursedMutationVariables>(EmploymentSalariesListItemUnmarkAsDisbursedDocument, parser(options)));
      }
export type EmploymentSalariesListItemUnmarkAsDisbursedMutationHookResult = ReturnType<typeof useEmploymentSalariesListItemUnmarkAsDisbursedMutation>;
export type EmploymentSalariesListItemUnmarkAsDisbursedMutationResult = ApolloReact.MutationResult<EmploymentSalariesListItemUnmarkAsDisbursedMutation>;
export type EmploymentSalariesListItemUnmarkAsDisbursedMutationOptions = Apollo.MutationOptions<EmploymentSalariesListItemUnmarkAsDisbursedMutation, EmploymentSalariesListItemUnmarkAsDisbursedMutationVariables>;
export const EmploymentSalaryDetailsDrawerDocument = /*#__PURE__*/ gql`
    query EmploymentSalaryDetailsDrawer($contractId: ContractId!, $month: YearMonth!, $monthStart: LocalDate!, $monthEnd: LocalDate!) {
  timeReport(contractId: $contractId, from: $monthStart, to: $monthEnd) {
    ...NfsError
    ... on TimeReport {
      timeReportRecords {
        work {
          id
          date
          overtime
          duration
          workTime {
            timeFrom
            timeTo
            break
          }
        }
        absence {
          id
          from
          to
          absenceType
          customDurationPerDay
        }
      }
      timeReportStats {
        timeBalanceAtEndOfMonth {
          reportedStandardWorkTime
          currentTimeRequirement
        }
        overtime
        incomeDetails {
          ...Unauthorized
          ... on AccessGranted__ListOfIncomeDetails {
            value {
              ...EmploymentSalaryIncomeDetails
            }
          }
        }
        ... on EmploymentTimeReportStats {
          flexTime {
            balance
            period {
              from
              to
            }
          }
          reportedLeaveDays {
            ...ReportedLeaveDays
          }
        }
      }
    }
  }
  contractSalaryDetails(contractId: $contractId, date: $month) {
    ...NfsError
    ... on ContractSalaryDetailsResponse {
      value {
        contractId
        yearMonth
        entityVersion
        transferTitle
        transferAmount
        totalPayout {
          gross
        }
        transferDeduction {
          grossValue
          note
        }
        note
        flag
        ... on EmploymentContractSalaryDetails {
          contractId
          yearMonth
          contract {
            ...SharedSalary_EmploymentContract
          }
          accountingData {
            ...EmploymentSalaryDetailsDrawer_AccountingData
          }
          workTransferProtocols {
            ...EmploymentSalaryDetailsDrawer_WorkTransfer
          }
        }
        salaryState {
          ...SalaryState
        }
      }
    }
  }
  contractSalaryDetailsAdditionalData(contractId: $contractId, date: $month) {
    ...NfsError
    ... on ContractSalaryDetailsAdditionalData {
      contractId
      yearMonth
      timeReportValidations {
        ...TimeReportValidation
      }
      incomeDetails {
        ...EmploymentSalaryIncomeDetails
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${EmploymentSalaryIncomeDetailsFragmentDoc}
${ReportedLeaveDaysFragmentDoc}
${SharedSalaryEmploymentContractFragmentDoc}
${EmploymentSalaryDetailsDrawerAccountingDataFragmentDoc}
${EmploymentSalaryDetailsDrawerWorkTransferFragmentDoc}
${SalaryStateFragmentDoc}
${TimeReportValidationFragmentDoc}`;

/**
 * __useEmploymentSalaryDetailsDrawerQuery__
 *
 * To run a query within a React component, call `useEmploymentSalaryDetailsDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmploymentSalaryDetailsDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmploymentSalaryDetailsDrawerQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      monthStart: // value for 'monthStart'
 *      monthEnd: // value for 'monthEnd'
 *   },
 * });
 */
export function useEmploymentSalaryDetailsDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<EmploymentSalaryDetailsDrawerQuery, EmploymentSalaryDetailsDrawerQueryVariables> & ({ variables: EmploymentSalaryDetailsDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentSalaryDetailsDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EmploymentSalaryDetailsDrawerQuery, EmploymentSalaryDetailsDrawerQueryVariables>(EmploymentSalaryDetailsDrawerDocument, parser(options)));
      }
export function useEmploymentSalaryDetailsDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EmploymentSalaryDetailsDrawerQuery, EmploymentSalaryDetailsDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EmploymentSalaryDetailsDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EmploymentSalaryDetailsDrawerQuery, EmploymentSalaryDetailsDrawerQueryVariables>(EmploymentSalaryDetailsDrawerDocument, options));
        }

export type EmploymentSalaryDetailsDrawerQueryResult = ApolloReact.QueryResult<EmploymentSalaryDetailsDrawerQuery, EmploymentSalaryDetailsDrawerQueryVariables>;
export function refetchEmploymentSalaryDetailsDrawerQuery(variables: EmploymentSalaryDetailsDrawerQueryVariables) {
      return { query: EmploymentSalaryDetailsDrawerDocument, variables: variables }
    }
export const EmploymentSalaryDetailsDrawerRefetchSalaryStateDocument = /*#__PURE__*/ gql`
    query EmploymentSalaryDetailsDrawer_RefetchSalaryState($contractId: ContractId!, $month: YearMonth!) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    ...NfsError
    ... on ContractSalaryDetailsResponse {
      value {
        contractId
        yearMonth
        salaryState {
          ...SalaryState
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalaryStateFragmentDoc}`;

/**
 * __useEmploymentSalaryDetailsDrawerRefetchSalaryStateQuery__
 *
 * To run a query within a React component, call `useEmploymentSalaryDetailsDrawerRefetchSalaryStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmploymentSalaryDetailsDrawerRefetchSalaryStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmploymentSalaryDetailsDrawerRefetchSalaryStateQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useEmploymentSalaryDetailsDrawerRefetchSalaryStateQuery(baseOptions: ApolloReact.QueryHookOptions<EmploymentSalaryDetailsDrawerRefetchSalaryStateQuery, EmploymentSalaryDetailsDrawerRefetchSalaryStateQueryVariables> & ({ variables: EmploymentSalaryDetailsDrawerRefetchSalaryStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentSalaryDetailsDrawerRefetchSalaryStateDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EmploymentSalaryDetailsDrawerRefetchSalaryStateQuery, EmploymentSalaryDetailsDrawerRefetchSalaryStateQueryVariables>(EmploymentSalaryDetailsDrawerRefetchSalaryStateDocument, parser(options)));
      }
export function useEmploymentSalaryDetailsDrawerRefetchSalaryStateLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EmploymentSalaryDetailsDrawerRefetchSalaryStateQuery, EmploymentSalaryDetailsDrawerRefetchSalaryStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EmploymentSalaryDetailsDrawerRefetchSalaryStateDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EmploymentSalaryDetailsDrawerRefetchSalaryStateQuery, EmploymentSalaryDetailsDrawerRefetchSalaryStateQueryVariables>(EmploymentSalaryDetailsDrawerRefetchSalaryStateDocument, options));
        }

export type EmploymentSalaryDetailsDrawerRefetchSalaryStateQueryResult = ApolloReact.QueryResult<EmploymentSalaryDetailsDrawerRefetchSalaryStateQuery, EmploymentSalaryDetailsDrawerRefetchSalaryStateQueryVariables>;
export function refetchEmploymentSalaryDetailsDrawerRefetchSalaryStateQuery(variables: EmploymentSalaryDetailsDrawerRefetchSalaryStateQueryVariables) {
      return { query: EmploymentSalaryDetailsDrawerRefetchSalaryStateDocument, variables: variables }
    }
export const EmploymentSalaryDetailsDrawerUpdateTransferDeductionDocument = /*#__PURE__*/ gql`
    mutation EmploymentSalaryDetailsDrawer_UpdateTransferDeduction($contractId: ContractId!, $month: YearMonth!, $entityVersion: EntityVersion!, $transferDeduction: ClearableTransferDeductionInput!) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    update(transferDeduction: $transferDeduction, entityVersion: $entityVersion) {
      ...NfsError
      ... on ContractSalaryDetailsResponse {
        value {
          contractId
          yearMonth
          transferAmount
          transferDeduction {
            grossValue
            note
          }
          ... on EmploymentContractSalaryDetails {
            accountingData {
              ...EmploymentSalaryDetailsDrawer_AccountingData
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmploymentSalaryDetailsDrawerAccountingDataFragmentDoc}`;


/**
 * __useEmploymentSalaryDetailsDrawerUpdateTransferDeductionMutation__
 *
 * To run a mutation, you first call `useEmploymentSalaryDetailsDrawerUpdateTransferDeductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentSalaryDetailsDrawerUpdateTransferDeductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentSalaryDetailsDrawerUpdateTransferDeductionMutation, { data, loading, error }] = useEmploymentSalaryDetailsDrawerUpdateTransferDeductionMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      entityVersion: // value for 'entityVersion'
 *      transferDeduction: // value for 'transferDeduction'
 *   },
 * });
 */
export function useEmploymentSalaryDetailsDrawerUpdateTransferDeductionMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutation, EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentSalaryDetailsDrawerUpdateTransferDeductionDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutation, EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutationVariables>(EmploymentSalaryDetailsDrawerUpdateTransferDeductionDocument, parser(options)));
      }
export type EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutationHookResult = ReturnType<typeof useEmploymentSalaryDetailsDrawerUpdateTransferDeductionMutation>;
export type EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutationResult = ApolloReact.MutationResult<EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutation>;
export type EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutationOptions = Apollo.MutationOptions<EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutation, EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutationVariables>;
export const EmploymentSalaryDetailsDrawerUpdateAccountingDataDocument = /*#__PURE__*/ gql`
    mutation EmploymentSalaryDetailsDrawer_UpdateAccountingData($contractId: ContractId!, $month: YearMonth!, $entityVersion: EntityVersion!, $accountingData: ClearableAccountingDataInput!) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    update(accountingDataInput: $accountingData, entityVersion: $entityVersion) {
      ...NfsError
      ... on ContractSalaryDetailsResponse {
        value {
          contractId
          yearMonth
          transferAmount
          entityVersion
          salaryState {
            ...SalaryState
          }
          ... on EmploymentContractSalaryDetails {
            accountingData {
              ...EmploymentSalaryDetailsDrawer_AccountingData
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalaryStateFragmentDoc}
${EmploymentSalaryDetailsDrawerAccountingDataFragmentDoc}`;


/**
 * __useEmploymentSalaryDetailsDrawerUpdateAccountingDataMutation__
 *
 * To run a mutation, you first call `useEmploymentSalaryDetailsDrawerUpdateAccountingDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentSalaryDetailsDrawerUpdateAccountingDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentSalaryDetailsDrawerUpdateAccountingDataMutation, { data, loading, error }] = useEmploymentSalaryDetailsDrawerUpdateAccountingDataMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      entityVersion: // value for 'entityVersion'
 *      accountingData: // value for 'accountingData'
 *   },
 * });
 */
export function useEmploymentSalaryDetailsDrawerUpdateAccountingDataMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentSalaryDetailsDrawerUpdateAccountingDataMutation, EmploymentSalaryDetailsDrawerUpdateAccountingDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentSalaryDetailsDrawerUpdateAccountingDataDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentSalaryDetailsDrawerUpdateAccountingDataMutation, EmploymentSalaryDetailsDrawerUpdateAccountingDataMutationVariables>(EmploymentSalaryDetailsDrawerUpdateAccountingDataDocument, parser(options)));
      }
export type EmploymentSalaryDetailsDrawerUpdateAccountingDataMutationHookResult = ReturnType<typeof useEmploymentSalaryDetailsDrawerUpdateAccountingDataMutation>;
export type EmploymentSalaryDetailsDrawerUpdateAccountingDataMutationResult = ApolloReact.MutationResult<EmploymentSalaryDetailsDrawerUpdateAccountingDataMutation>;
export type EmploymentSalaryDetailsDrawerUpdateAccountingDataMutationOptions = Apollo.MutationOptions<EmploymentSalaryDetailsDrawerUpdateAccountingDataMutation, EmploymentSalaryDetailsDrawerUpdateAccountingDataMutationVariables>;
export const EmploymentSalaryDetailsDrawerUpdateWorkTransferDocument = /*#__PURE__*/ gql`
    mutation EmploymentSalaryDetailsDrawer_UpdateWorkTransfer($id: WorkTransferProtocolId!, $description: ClearableStringInput, $payload: Upload, $contractId: ContractId!, $yearMonth: YearMonth!, $approved: Boolean) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      update(
        id: $id
        description: $description
        payload: $payload
        approved: $approved
      ) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...EmploymentSalaryDetailsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmploymentSalaryDetailsDrawerWorkTransferFragmentDoc}`;


/**
 * __useEmploymentSalaryDetailsDrawerUpdateWorkTransferMutation__
 *
 * To run a mutation, you first call `useEmploymentSalaryDetailsDrawerUpdateWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentSalaryDetailsDrawerUpdateWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentSalaryDetailsDrawerUpdateWorkTransferMutation, { data, loading, error }] = useEmploymentSalaryDetailsDrawerUpdateWorkTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      payload: // value for 'payload'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useEmploymentSalaryDetailsDrawerUpdateWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentSalaryDetailsDrawerUpdateWorkTransferMutation, EmploymentSalaryDetailsDrawerUpdateWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentSalaryDetailsDrawerUpdateWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentSalaryDetailsDrawerUpdateWorkTransferMutation, EmploymentSalaryDetailsDrawerUpdateWorkTransferMutationVariables>(EmploymentSalaryDetailsDrawerUpdateWorkTransferDocument, parser(options)));
      }
export type EmploymentSalaryDetailsDrawerUpdateWorkTransferMutationHookResult = ReturnType<typeof useEmploymentSalaryDetailsDrawerUpdateWorkTransferMutation>;
export type EmploymentSalaryDetailsDrawerUpdateWorkTransferMutationResult = ApolloReact.MutationResult<EmploymentSalaryDetailsDrawerUpdateWorkTransferMutation>;
export type EmploymentSalaryDetailsDrawerUpdateWorkTransferMutationOptions = Apollo.MutationOptions<EmploymentSalaryDetailsDrawerUpdateWorkTransferMutation, EmploymentSalaryDetailsDrawerUpdateWorkTransferMutationVariables>;
export const EmploymentSalaryDetailsDrawerCreateWorkTransferDocument = /*#__PURE__*/ gql`
    mutation EmploymentSalaryDetailsDrawer_CreateWorkTransfer($contractSalaryDetailsId: ContractSalaryDetailsIdInput!, $id: WorkTransferProtocolId!, $description: String, $payload: Upload!, $contractId: ContractId!, $yearMonth: YearMonth!, $approved: Boolean) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      create(
        contractSalaryDetailsId: $contractSalaryDetailsId
        id: $id
        description: $description
        payload: $payload
        approved: $approved
      ) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...EmploymentSalaryDetailsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmploymentSalaryDetailsDrawerWorkTransferFragmentDoc}`;


/**
 * __useEmploymentSalaryDetailsDrawerCreateWorkTransferMutation__
 *
 * To run a mutation, you first call `useEmploymentSalaryDetailsDrawerCreateWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentSalaryDetailsDrawerCreateWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentSalaryDetailsDrawerCreateWorkTransferMutation, { data, loading, error }] = useEmploymentSalaryDetailsDrawerCreateWorkTransferMutation({
 *   variables: {
 *      contractSalaryDetailsId: // value for 'contractSalaryDetailsId'
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      payload: // value for 'payload'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useEmploymentSalaryDetailsDrawerCreateWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentSalaryDetailsDrawerCreateWorkTransferMutation, EmploymentSalaryDetailsDrawerCreateWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentSalaryDetailsDrawerCreateWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentSalaryDetailsDrawerCreateWorkTransferMutation, EmploymentSalaryDetailsDrawerCreateWorkTransferMutationVariables>(EmploymentSalaryDetailsDrawerCreateWorkTransferDocument, parser(options)));
      }
export type EmploymentSalaryDetailsDrawerCreateWorkTransferMutationHookResult = ReturnType<typeof useEmploymentSalaryDetailsDrawerCreateWorkTransferMutation>;
export type EmploymentSalaryDetailsDrawerCreateWorkTransferMutationResult = ApolloReact.MutationResult<EmploymentSalaryDetailsDrawerCreateWorkTransferMutation>;
export type EmploymentSalaryDetailsDrawerCreateWorkTransferMutationOptions = Apollo.MutationOptions<EmploymentSalaryDetailsDrawerCreateWorkTransferMutation, EmploymentSalaryDetailsDrawerCreateWorkTransferMutationVariables>;
export const EmploymentSalaryDetailsDrawerRemoveWorkTransferDocument = /*#__PURE__*/ gql`
    mutation EmploymentSalaryDetailsDrawer_RemoveWorkTransfer($id: WorkTransferProtocolId!, $contractId: ContractId!, $yearMonth: YearMonth!) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      remove(id: $id) {
        ...NfsError
        ... on BooleanResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEmploymentSalaryDetailsDrawerRemoveWorkTransferMutation__
 *
 * To run a mutation, you first call `useEmploymentSalaryDetailsDrawerRemoveWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentSalaryDetailsDrawerRemoveWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentSalaryDetailsDrawerRemoveWorkTransferMutation, { data, loading, error }] = useEmploymentSalaryDetailsDrawerRemoveWorkTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *   },
 * });
 */
export function useEmploymentSalaryDetailsDrawerRemoveWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentSalaryDetailsDrawerRemoveWorkTransferMutation, EmploymentSalaryDetailsDrawerRemoveWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentSalaryDetailsDrawerRemoveWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentSalaryDetailsDrawerRemoveWorkTransferMutation, EmploymentSalaryDetailsDrawerRemoveWorkTransferMutationVariables>(EmploymentSalaryDetailsDrawerRemoveWorkTransferDocument, parser(options)));
      }
export type EmploymentSalaryDetailsDrawerRemoveWorkTransferMutationHookResult = ReturnType<typeof useEmploymentSalaryDetailsDrawerRemoveWorkTransferMutation>;
export type EmploymentSalaryDetailsDrawerRemoveWorkTransferMutationResult = ApolloReact.MutationResult<EmploymentSalaryDetailsDrawerRemoveWorkTransferMutation>;
export type EmploymentSalaryDetailsDrawerRemoveWorkTransferMutationOptions = Apollo.MutationOptions<EmploymentSalaryDetailsDrawerRemoveWorkTransferMutation, EmploymentSalaryDetailsDrawerRemoveWorkTransferMutationVariables>;
export const EmploymentSalaryDetailsDrawerMarkNoWorkDocument = /*#__PURE__*/ gql`
    mutation EmploymentSalaryDetailsDrawer_MarkNoWork($contractSalaryDetailsId: ContractSalaryDetailsIdInput!, $contractId: ContractId!, $yearMonth: YearMonth!) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      markNoWorkToBeTransferedThisMonth(
        contractSalaryDetailsId: $contractSalaryDetailsId
      ) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...EmploymentSalaryDetailsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${EmploymentSalaryDetailsDrawerWorkTransferFragmentDoc}`;


/**
 * __useEmploymentSalaryDetailsDrawerMarkNoWorkMutation__
 *
 * To run a mutation, you first call `useEmploymentSalaryDetailsDrawerMarkNoWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmploymentSalaryDetailsDrawerMarkNoWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employmentSalaryDetailsDrawerMarkNoWorkMutation, { data, loading, error }] = useEmploymentSalaryDetailsDrawerMarkNoWorkMutation({
 *   variables: {
 *      contractSalaryDetailsId: // value for 'contractSalaryDetailsId'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *   },
 * });
 */
export function useEmploymentSalaryDetailsDrawerMarkNoWorkMutation(baseOptions?: ApolloReact.MutationHookOptions<EmploymentSalaryDetailsDrawerMarkNoWorkMutation, EmploymentSalaryDetailsDrawerMarkNoWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EmploymentSalaryDetailsDrawerMarkNoWorkDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EmploymentSalaryDetailsDrawerMarkNoWorkMutation, EmploymentSalaryDetailsDrawerMarkNoWorkMutationVariables>(EmploymentSalaryDetailsDrawerMarkNoWorkDocument, parser(options)));
      }
export type EmploymentSalaryDetailsDrawerMarkNoWorkMutationHookResult = ReturnType<typeof useEmploymentSalaryDetailsDrawerMarkNoWorkMutation>;
export type EmploymentSalaryDetailsDrawerMarkNoWorkMutationResult = ApolloReact.MutationResult<EmploymentSalaryDetailsDrawerMarkNoWorkMutation>;
export type EmploymentSalaryDetailsDrawerMarkNoWorkMutationOptions = Apollo.MutationOptions<EmploymentSalaryDetailsDrawerMarkNoWorkMutation, EmploymentSalaryDetailsDrawerMarkNoWorkMutationVariables>;
export const ExtendLeadPeriodModalUpsertLeadAssignmentDocument = /*#__PURE__*/ gql`
    mutation ExtendLeadPeriodModal_UpsertLeadAssignment($projectId: ProjectId!, $entityVersion: EntityVersion!, $periods: [ProjectRoleAssignmentPeriodInput!]!) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    projectAssignments {
      upsertLeadAssignment(periods: $periods) {
        ...NfsError
        ... on ProjectRoleAssignment {
          project {
            ...ProjectLead
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectLeadFragmentDoc}`;


/**
 * __useExtendLeadPeriodModalUpsertLeadAssignmentMutation__
 *
 * To run a mutation, you first call `useExtendLeadPeriodModalUpsertLeadAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendLeadPeriodModalUpsertLeadAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendLeadPeriodModalUpsertLeadAssignmentMutation, { data, loading, error }] = useExtendLeadPeriodModalUpsertLeadAssignmentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      periods: // value for 'periods'
 *   },
 * });
 */
export function useExtendLeadPeriodModalUpsertLeadAssignmentMutation(baseOptions?: ApolloReact.MutationHookOptions<ExtendLeadPeriodModalUpsertLeadAssignmentMutation, ExtendLeadPeriodModalUpsertLeadAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ExtendLeadPeriodModalUpsertLeadAssignmentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ExtendLeadPeriodModalUpsertLeadAssignmentMutation, ExtendLeadPeriodModalUpsertLeadAssignmentMutationVariables>(ExtendLeadPeriodModalUpsertLeadAssignmentDocument, parser(options)));
      }
export type ExtendLeadPeriodModalUpsertLeadAssignmentMutationHookResult = ReturnType<typeof useExtendLeadPeriodModalUpsertLeadAssignmentMutation>;
export type ExtendLeadPeriodModalUpsertLeadAssignmentMutationResult = ApolloReact.MutationResult<ExtendLeadPeriodModalUpsertLeadAssignmentMutation>;
export type ExtendLeadPeriodModalUpsertLeadAssignmentMutationOptions = Apollo.MutationOptions<ExtendLeadPeriodModalUpsertLeadAssignmentMutation, ExtendLeadPeriodModalUpsertLeadAssignmentMutationVariables>;
export const FriendsAndFamilyDocument = /*#__PURE__*/ gql`
    query FriendsAndFamily($userId: UserId!) {
  benefits {
    ...NfsError
    ... on ListOfBenefitGroupResponse {
      value {
        benefits {
          manyOf {
            alternativeBenefitsGroupId
            oneOf {
              id
            }
          }
        }
      }
    }
  }
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      createdAt
      firstName
      lastName
      externalBeneficiaries {
        ...Unauthorized
        ... on AccessGranted__ListOfExternalBeneficiary {
          value {
            id
            firstName
            lastName
            email
            address {
              ...Address
            }
            assignedVariants {
              id
              note
              active {
                value
                futureUpdates {
                  activityId
                  applyDate
                  value
                }
                history {
                  activityId
                  applyDate
                  value
                }
              }
              buyerType {
                value
                futureUpdates {
                  activityId
                  applyDate
                  value
                }
                history {
                  activityId
                  applyDate
                  value
                }
              }
              externalBeneficiaries {
                value {
                  ...ExternalBeneficiary
                }
                futureUpdates {
                  activityId
                  applyDate
                  value {
                    ...ExternalBeneficiary
                  }
                }
                history {
                  activityId
                  applyDate
                  value {
                    ...ExternalBeneficiary
                  }
                }
              }
              invoiceTo {
                value {
                  ...ExternalBeneficiary
                }
                futureUpdates {
                  activityId
                  applyDate
                  value {
                    value {
                      ...ExternalBeneficiary
                    }
                  }
                }
                history {
                  activityId
                  applyDate
                  value {
                    value {
                      ...ExternalBeneficiary
                    }
                  }
                }
              }
              variant {
                value {
                  ...FriendsAndFamily_BenefitVariant
                }
                futureUpdates {
                  activityId
                  applyDate
                  value {
                    ...FriendsAndFamily_BenefitVariant
                  }
                }
                history {
                  activityId
                  applyDate
                  value {
                    ...FriendsAndFamily_BenefitVariant
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AddressFragmentDoc}
${ExternalBeneficiaryFragmentDoc}
${FriendsAndFamilyBenefitVariantFragmentDoc}`;

/**
 * __useFriendsAndFamilyQuery__
 *
 * To run a query within a React component, call `useFriendsAndFamilyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendsAndFamilyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendsAndFamilyQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFriendsAndFamilyQuery(baseOptions: ApolloReact.QueryHookOptions<FriendsAndFamilyQuery, FriendsAndFamilyQueryVariables> & ({ variables: FriendsAndFamilyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(FriendsAndFamilyDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<FriendsAndFamilyQuery, FriendsAndFamilyQueryVariables>(FriendsAndFamilyDocument, parser(options)));
      }
export function useFriendsAndFamilyLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<FriendsAndFamilyQuery, FriendsAndFamilyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(FriendsAndFamilyDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<FriendsAndFamilyQuery, FriendsAndFamilyQueryVariables>(FriendsAndFamilyDocument, options));
        }

export type FriendsAndFamilyQueryResult = ApolloReact.QueryResult<FriendsAndFamilyQuery, FriendsAndFamilyQueryVariables>;
export function refetchFriendsAndFamilyQuery(variables: FriendsAndFamilyQueryVariables) {
      return { query: FriendsAndFamilyDocument, variables: variables }
    }
export const InvoiceTransferLinksDrawerDetailsDocument = /*#__PURE__*/ gql`
    query InvoiceTransferLinksDrawer_Details($invoiceId: SalesInvoiceId!) {
  salesInvoiceDetails(invoiceId: $invoiceId) {
    ...NfsError
    ... on SalesInvoiceDetails {
      correctedBy {
        ...SalesInvoices_Invoice
      }
      invoice {
        ...SalesInvoices_Invoice
      }
      connectedTransfers {
        ...InvoiceTransferLinksDrawer_PaymentConnection
      }
      correctsInvoice {
        id
        number
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalesInvoicesInvoiceFragmentDoc}
${InvoiceTransferLinksDrawerPaymentConnectionFragmentDoc}`;

/**
 * __useInvoiceTransferLinksDrawerDetailsQuery__
 *
 * To run a query within a React component, call `useInvoiceTransferLinksDrawerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTransferLinksDrawerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTransferLinksDrawerDetailsQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceTransferLinksDrawerDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<InvoiceTransferLinksDrawerDetailsQuery, InvoiceTransferLinksDrawerDetailsQueryVariables> & ({ variables: InvoiceTransferLinksDrawerDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(InvoiceTransferLinksDrawerDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<InvoiceTransferLinksDrawerDetailsQuery, InvoiceTransferLinksDrawerDetailsQueryVariables>(InvoiceTransferLinksDrawerDetailsDocument, parser(options)));
      }
export function useInvoiceTransferLinksDrawerDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<InvoiceTransferLinksDrawerDetailsQuery, InvoiceTransferLinksDrawerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(InvoiceTransferLinksDrawerDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<InvoiceTransferLinksDrawerDetailsQuery, InvoiceTransferLinksDrawerDetailsQueryVariables>(InvoiceTransferLinksDrawerDetailsDocument, options));
        }

export type InvoiceTransferLinksDrawerDetailsQueryResult = ApolloReact.QueryResult<InvoiceTransferLinksDrawerDetailsQuery, InvoiceTransferLinksDrawerDetailsQueryVariables>;
export function refetchInvoiceTransferLinksDrawerDetailsQuery(variables: InvoiceTransferLinksDrawerDetailsQueryVariables) {
      return { query: InvoiceTransferLinksDrawerDetailsDocument, variables: variables }
    }
export const InvoiceTransferLinksDrawerCreateConnectionDocument = /*#__PURE__*/ gql`
    mutation InvoiceTransferLinksDrawer_CreateConnection($transferId: BankTransferId!, $invoiceId: SalesInvoiceId!) {
  createPaymentConnection(transferId: $transferId, invoiceId: $invoiceId) {
    ...NfsError
    ... on PaymentConnection {
      ...InvoiceTransferLinksDrawer_PaymentConnection
    }
  }
}
    ${NfsErrorFragmentDoc}
${InvoiceTransferLinksDrawerPaymentConnectionFragmentDoc}`;


/**
 * __useInvoiceTransferLinksDrawerCreateConnectionMutation__
 *
 * To run a mutation, you first call `useInvoiceTransferLinksDrawerCreateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTransferLinksDrawerCreateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceTransferLinksDrawerCreateConnectionMutation, { data, loading, error }] = useInvoiceTransferLinksDrawerCreateConnectionMutation({
 *   variables: {
 *      transferId: // value for 'transferId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceTransferLinksDrawerCreateConnectionMutation(baseOptions?: ApolloReact.MutationHookOptions<InvoiceTransferLinksDrawerCreateConnectionMutation, InvoiceTransferLinksDrawerCreateConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(InvoiceTransferLinksDrawerCreateConnectionDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<InvoiceTransferLinksDrawerCreateConnectionMutation, InvoiceTransferLinksDrawerCreateConnectionMutationVariables>(InvoiceTransferLinksDrawerCreateConnectionDocument, parser(options)));
      }
export type InvoiceTransferLinksDrawerCreateConnectionMutationHookResult = ReturnType<typeof useInvoiceTransferLinksDrawerCreateConnectionMutation>;
export type InvoiceTransferLinksDrawerCreateConnectionMutationResult = ApolloReact.MutationResult<InvoiceTransferLinksDrawerCreateConnectionMutation>;
export type InvoiceTransferLinksDrawerCreateConnectionMutationOptions = Apollo.MutationOptions<InvoiceTransferLinksDrawerCreateConnectionMutation, InvoiceTransferLinksDrawerCreateConnectionMutationVariables>;
export const InvoiceTransferLinksDrawerDeleteConnectionDocument = /*#__PURE__*/ gql`
    mutation InvoiceTransferLinksDrawer_DeleteConnection($transferId: BankTransferId!, $invoiceId: SalesInvoiceId!) {
  deletePaymentConnection(transferId: $transferId, invoiceId: $invoiceId) {
    ...NfsError
    ... on BankIncomeTransfer {
      ...BankTransfers_BankTransfer
      discrepancy
      connectedPayments {
        ...TransferDetailsDrawer_PaymentConnection
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankTransfersBankTransferFragmentDoc}
${TransferDetailsDrawerPaymentConnectionFragmentDoc}`;


/**
 * __useInvoiceTransferLinksDrawerDeleteConnectionMutation__
 *
 * To run a mutation, you first call `useInvoiceTransferLinksDrawerDeleteConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTransferLinksDrawerDeleteConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceTransferLinksDrawerDeleteConnectionMutation, { data, loading, error }] = useInvoiceTransferLinksDrawerDeleteConnectionMutation({
 *   variables: {
 *      transferId: // value for 'transferId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceTransferLinksDrawerDeleteConnectionMutation(baseOptions?: ApolloReact.MutationHookOptions<InvoiceTransferLinksDrawerDeleteConnectionMutation, InvoiceTransferLinksDrawerDeleteConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(InvoiceTransferLinksDrawerDeleteConnectionDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<InvoiceTransferLinksDrawerDeleteConnectionMutation, InvoiceTransferLinksDrawerDeleteConnectionMutationVariables>(InvoiceTransferLinksDrawerDeleteConnectionDocument, parser(options)));
      }
export type InvoiceTransferLinksDrawerDeleteConnectionMutationHookResult = ReturnType<typeof useInvoiceTransferLinksDrawerDeleteConnectionMutation>;
export type InvoiceTransferLinksDrawerDeleteConnectionMutationResult = ApolloReact.MutationResult<InvoiceTransferLinksDrawerDeleteConnectionMutation>;
export type InvoiceTransferLinksDrawerDeleteConnectionMutationOptions = Apollo.MutationOptions<InvoiceTransferLinksDrawerDeleteConnectionMutation, InvoiceTransferLinksDrawerDeleteConnectionMutationVariables>;
export const KeyPeopleUserAutocompleteDocument = /*#__PURE__*/ gql`
    query KeyPeople_UserAutocomplete($after: Cursor, $filter: FilterUserInput!, $sort: SortingRequestSortUserInput, $first: Int!) {
  users(after: $after, filter: $filter, sort: $sort, first: $first) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      edges {
        cursor
        node {
          ...UserAutocomplete_User
          avatar
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserAutocompleteUserFragmentDoc}`;

/**
 * __useKeyPeopleUserAutocompleteQuery__
 *
 * To run a query within a React component, call `useKeyPeopleUserAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyPeopleUserAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyPeopleUserAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useKeyPeopleUserAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<KeyPeopleUserAutocompleteQuery, KeyPeopleUserAutocompleteQueryVariables> & ({ variables: KeyPeopleUserAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(KeyPeopleUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<KeyPeopleUserAutocompleteQuery, KeyPeopleUserAutocompleteQueryVariables>(KeyPeopleUserAutocompleteDocument, parser(options)));
      }
export function useKeyPeopleUserAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<KeyPeopleUserAutocompleteQuery, KeyPeopleUserAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(KeyPeopleUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<KeyPeopleUserAutocompleteQuery, KeyPeopleUserAutocompleteQueryVariables>(KeyPeopleUserAutocompleteDocument, options));
        }

export type KeyPeopleUserAutocompleteQueryResult = ApolloReact.QueryResult<KeyPeopleUserAutocompleteQuery, KeyPeopleUserAutocompleteQueryVariables>;
export function refetchKeyPeopleUserAutocompleteQuery(variables: KeyPeopleUserAutocompleteQueryVariables) {
      return { query: KeyPeopleUserAutocompleteDocument, variables: variables }
    }
export const KeyPeopleUserMembershipDocument = /*#__PURE__*/ gql`
    query KeyPeople_UserMembership($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      firstName
      lastName
      avatar
      directReporting {
        assignedProjects {
          ...Unauthorized
          ... on AccessGranted__ListOfProjectAssignment {
            value {
              project {
                id
              }
              periods {
                dateRange {
                  from
                  to
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useKeyPeopleUserMembershipQuery__
 *
 * To run a query within a React component, call `useKeyPeopleUserMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyPeopleUserMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyPeopleUserMembershipQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useKeyPeopleUserMembershipQuery(baseOptions: ApolloReact.QueryHookOptions<KeyPeopleUserMembershipQuery, KeyPeopleUserMembershipQueryVariables> & ({ variables: KeyPeopleUserMembershipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(KeyPeopleUserMembershipDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<KeyPeopleUserMembershipQuery, KeyPeopleUserMembershipQueryVariables>(KeyPeopleUserMembershipDocument, parser(options)));
      }
export function useKeyPeopleUserMembershipLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<KeyPeopleUserMembershipQuery, KeyPeopleUserMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(KeyPeopleUserMembershipDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<KeyPeopleUserMembershipQuery, KeyPeopleUserMembershipQueryVariables>(KeyPeopleUserMembershipDocument, options));
        }

export type KeyPeopleUserMembershipQueryResult = ApolloReact.QueryResult<KeyPeopleUserMembershipQuery, KeyPeopleUserMembershipQueryVariables>;
export function refetchKeyPeopleUserMembershipQuery(variables: KeyPeopleUserMembershipQueryVariables) {
      return { query: KeyPeopleUserMembershipDocument, variables: variables }
    }
export const KeyPeopleUpsertLeadAssignmentDocument = /*#__PURE__*/ gql`
    mutation KeyPeople_UpsertLeadAssignment($projectId: ProjectId!, $entityVersion: EntityVersion!, $periods: [ProjectRoleAssignmentPeriodInput!]!) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    projectAssignments {
      upsertLeadAssignment(periods: $periods) {
        ...NfsError
        ... on ProjectRoleAssignment {
          ...ProjectRoleAssignment
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectRoleAssignmentFragmentDoc}`;


/**
 * __useKeyPeopleUpsertLeadAssignmentMutation__
 *
 * To run a mutation, you first call `useKeyPeopleUpsertLeadAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeyPeopleUpsertLeadAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keyPeopleUpsertLeadAssignmentMutation, { data, loading, error }] = useKeyPeopleUpsertLeadAssignmentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      periods: // value for 'periods'
 *   },
 * });
 */
export function useKeyPeopleUpsertLeadAssignmentMutation(baseOptions?: ApolloReact.MutationHookOptions<KeyPeopleUpsertLeadAssignmentMutation, KeyPeopleUpsertLeadAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(KeyPeopleUpsertLeadAssignmentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<KeyPeopleUpsertLeadAssignmentMutation, KeyPeopleUpsertLeadAssignmentMutationVariables>(KeyPeopleUpsertLeadAssignmentDocument, parser(options)));
      }
export type KeyPeopleUpsertLeadAssignmentMutationHookResult = ReturnType<typeof useKeyPeopleUpsertLeadAssignmentMutation>;
export type KeyPeopleUpsertLeadAssignmentMutationResult = ApolloReact.MutationResult<KeyPeopleUpsertLeadAssignmentMutation>;
export type KeyPeopleUpsertLeadAssignmentMutationOptions = Apollo.MutationOptions<KeyPeopleUpsertLeadAssignmentMutation, KeyPeopleUpsertLeadAssignmentMutationVariables>;
export const KeyPeopleUpsertOwnerAssignmentDocument = /*#__PURE__*/ gql`
    mutation KeyPeople_UpsertOwnerAssignment($projectId: ProjectId!, $entityVersion: EntityVersion!, $periods: [ProjectRoleAssignmentPeriodInput!]!) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    projectAssignments {
      upsertOwnerAssignment(periods: $periods) {
        ...NfsError
        ... on ProjectRoleAssignment {
          ...ProjectRoleAssignment
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectRoleAssignmentFragmentDoc}`;


/**
 * __useKeyPeopleUpsertOwnerAssignmentMutation__
 *
 * To run a mutation, you first call `useKeyPeopleUpsertOwnerAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeyPeopleUpsertOwnerAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keyPeopleUpsertOwnerAssignmentMutation, { data, loading, error }] = useKeyPeopleUpsertOwnerAssignmentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      periods: // value for 'periods'
 *   },
 * });
 */
export function useKeyPeopleUpsertOwnerAssignmentMutation(baseOptions?: ApolloReact.MutationHookOptions<KeyPeopleUpsertOwnerAssignmentMutation, KeyPeopleUpsertOwnerAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(KeyPeopleUpsertOwnerAssignmentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<KeyPeopleUpsertOwnerAssignmentMutation, KeyPeopleUpsertOwnerAssignmentMutationVariables>(KeyPeopleUpsertOwnerAssignmentDocument, parser(options)));
      }
export type KeyPeopleUpsertOwnerAssignmentMutationHookResult = ReturnType<typeof useKeyPeopleUpsertOwnerAssignmentMutation>;
export type KeyPeopleUpsertOwnerAssignmentMutationResult = ApolloReact.MutationResult<KeyPeopleUpsertOwnerAssignmentMutation>;
export type KeyPeopleUpsertOwnerAssignmentMutationOptions = Apollo.MutationOptions<KeyPeopleUpsertOwnerAssignmentMutation, KeyPeopleUpsertOwnerAssignmentMutationVariables>;
export const KeyPeopleUpsertAccountManagerAssignmentDocument = /*#__PURE__*/ gql`
    mutation KeyPeople_UpsertAccountManagerAssignment($projectId: ProjectId!, $entityVersion: EntityVersion!, $periods: [ProjectRoleAssignmentPeriodInput!]!) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    projectAssignments {
      upsertAccountManagerAssignment(periods: $periods) {
        ...NfsError
        ... on ProjectRoleAssignment {
          ...ProjectRoleAssignment
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectRoleAssignmentFragmentDoc}`;


/**
 * __useKeyPeopleUpsertAccountManagerAssignmentMutation__
 *
 * To run a mutation, you first call `useKeyPeopleUpsertAccountManagerAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeyPeopleUpsertAccountManagerAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keyPeopleUpsertAccountManagerAssignmentMutation, { data, loading, error }] = useKeyPeopleUpsertAccountManagerAssignmentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      periods: // value for 'periods'
 *   },
 * });
 */
export function useKeyPeopleUpsertAccountManagerAssignmentMutation(baseOptions?: ApolloReact.MutationHookOptions<KeyPeopleUpsertAccountManagerAssignmentMutation, KeyPeopleUpsertAccountManagerAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(KeyPeopleUpsertAccountManagerAssignmentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<KeyPeopleUpsertAccountManagerAssignmentMutation, KeyPeopleUpsertAccountManagerAssignmentMutationVariables>(KeyPeopleUpsertAccountManagerAssignmentDocument, parser(options)));
      }
export type KeyPeopleUpsertAccountManagerAssignmentMutationHookResult = ReturnType<typeof useKeyPeopleUpsertAccountManagerAssignmentMutation>;
export type KeyPeopleUpsertAccountManagerAssignmentMutationResult = ApolloReact.MutationResult<KeyPeopleUpsertAccountManagerAssignmentMutation>;
export type KeyPeopleUpsertAccountManagerAssignmentMutationOptions = Apollo.MutationOptions<KeyPeopleUpsertAccountManagerAssignmentMutation, KeyPeopleUpsertAccountManagerAssignmentMutationVariables>;
export const ManageKeyPeopleDrawerDataDocument = /*#__PURE__*/ gql`
    query ManageKeyPeopleDrawer_Data($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      ...KeyPeopleProject
      assignedUsers {
        project {
          id
        }
        user {
          id
          entityVersion
          avatar
          firstName
          lastName
        }
        periods {
          dateRange {
            from
            to
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${KeyPeopleProjectFragmentDoc}`;

/**
 * __useManageKeyPeopleDrawerDataQuery__
 *
 * To run a query within a React component, call `useManageKeyPeopleDrawerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageKeyPeopleDrawerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageKeyPeopleDrawerDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useManageKeyPeopleDrawerDataQuery(baseOptions: ApolloReact.QueryHookOptions<ManageKeyPeopleDrawerDataQuery, ManageKeyPeopleDrawerDataQueryVariables> & ({ variables: ManageKeyPeopleDrawerDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ManageKeyPeopleDrawerDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ManageKeyPeopleDrawerDataQuery, ManageKeyPeopleDrawerDataQueryVariables>(ManageKeyPeopleDrawerDataDocument, parser(options)));
      }
export function useManageKeyPeopleDrawerDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ManageKeyPeopleDrawerDataQuery, ManageKeyPeopleDrawerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ManageKeyPeopleDrawerDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ManageKeyPeopleDrawerDataQuery, ManageKeyPeopleDrawerDataQueryVariables>(ManageKeyPeopleDrawerDataDocument, options));
        }

export type ManageKeyPeopleDrawerDataQueryResult = ApolloReact.QueryResult<ManageKeyPeopleDrawerDataQuery, ManageKeyPeopleDrawerDataQueryVariables>;
export function refetchManageKeyPeopleDrawerDataQuery(variables: ManageKeyPeopleDrawerDataQueryVariables) {
      return { query: ManageKeyPeopleDrawerDataDocument, variables: variables }
    }
export const ManageProjectTimelineDrawerDataDocument = /*#__PURE__*/ gql`
    query ManageProjectTimelineDrawer_Data($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      ...ManageProjectTimelineDrawer_Project
    }
  }
}
    ${NfsErrorFragmentDoc}
${ManageProjectTimelineDrawerProjectFragmentDoc}`;

/**
 * __useManageProjectTimelineDrawerDataQuery__
 *
 * To run a query within a React component, call `useManageProjectTimelineDrawerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageProjectTimelineDrawerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageProjectTimelineDrawerDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useManageProjectTimelineDrawerDataQuery(baseOptions: ApolloReact.QueryHookOptions<ManageProjectTimelineDrawerDataQuery, ManageProjectTimelineDrawerDataQueryVariables> & ({ variables: ManageProjectTimelineDrawerDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ManageProjectTimelineDrawerDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ManageProjectTimelineDrawerDataQuery, ManageProjectTimelineDrawerDataQueryVariables>(ManageProjectTimelineDrawerDataDocument, parser(options)));
      }
export function useManageProjectTimelineDrawerDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ManageProjectTimelineDrawerDataQuery, ManageProjectTimelineDrawerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ManageProjectTimelineDrawerDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ManageProjectTimelineDrawerDataQuery, ManageProjectTimelineDrawerDataQueryVariables>(ManageProjectTimelineDrawerDataDocument, options));
        }

export type ManageProjectTimelineDrawerDataQueryResult = ApolloReact.QueryResult<ManageProjectTimelineDrawerDataQuery, ManageProjectTimelineDrawerDataQueryVariables>;
export function refetchManageProjectTimelineDrawerDataQuery(variables: ManageProjectTimelineDrawerDataQueryVariables) {
      return { query: ManageProjectTimelineDrawerDataDocument, variables: variables }
    }
export const ManageProjectTimelineDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation ManageProjectTimelineDrawer_Update($projectId: ProjectId!, $entityVersion: EntityVersion!, $statusHistory: [ProjectStatusHistoryEntryInput!]!) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    update(statusHistory: $statusHistory) {
      ...NfsError
      ... on Project {
        ...ManageProjectTimelineDrawer_Project
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ManageProjectTimelineDrawerProjectFragmentDoc}`;


/**
 * __useManageProjectTimelineDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useManageProjectTimelineDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageProjectTimelineDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageProjectTimelineDrawerUpdateMutation, { data, loading, error }] = useManageProjectTimelineDrawerUpdateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      statusHistory: // value for 'statusHistory'
 *   },
 * });
 */
export function useManageProjectTimelineDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<ManageProjectTimelineDrawerUpdateMutation, ManageProjectTimelineDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ManageProjectTimelineDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ManageProjectTimelineDrawerUpdateMutation, ManageProjectTimelineDrawerUpdateMutationVariables>(ManageProjectTimelineDrawerUpdateDocument, parser(options)));
      }
export type ManageProjectTimelineDrawerUpdateMutationHookResult = ReturnType<typeof useManageProjectTimelineDrawerUpdateMutation>;
export type ManageProjectTimelineDrawerUpdateMutationResult = ApolloReact.MutationResult<ManageProjectTimelineDrawerUpdateMutation>;
export type ManageProjectTimelineDrawerUpdateMutationOptions = Apollo.MutationOptions<ManageProjectTimelineDrawerUpdateMutation, ManageProjectTimelineDrawerUpdateMutationVariables>;
export const OfficeCatalogueDocument = /*#__PURE__*/ gql`
    query OfficeCatalogue($officeId: OfficeId!) {
  officeCatalogue(officeId: $officeId) {
    ...NfsError
    ... on OfficeCatalogue {
      rooms {
        ...OfficeCatalogue_Room
      }
      parkingSpots {
        ...OfficeCatalogue_ParkingSpot
      }
    }
  }
  deskAssignments(officeId: $officeId) {
    ...NfsError
    ... on ListOfDeskAssignmentResponse {
      value {
        ...OfficeCatalogue_DeskAssignment
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${OfficeCatalogueRoomFragmentDoc}
${OfficeCatalogueParkingSpotFragmentDoc}
${OfficeCatalogueDeskAssignmentFragmentDoc}`;

/**
 * __useOfficeCatalogueQuery__
 *
 * To run a query within a React component, call `useOfficeCatalogueQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeCatalogueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeCatalogueQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useOfficeCatalogueQuery(baseOptions: ApolloReact.QueryHookOptions<OfficeCatalogueQuery, OfficeCatalogueQueryVariables> & ({ variables: OfficeCatalogueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeCatalogueDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<OfficeCatalogueQuery, OfficeCatalogueQueryVariables>(OfficeCatalogueDocument, parser(options)));
      }
export function useOfficeCatalogueLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<OfficeCatalogueQuery, OfficeCatalogueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(OfficeCatalogueDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<OfficeCatalogueQuery, OfficeCatalogueQueryVariables>(OfficeCatalogueDocument, options));
        }

export type OfficeCatalogueQueryResult = ApolloReact.QueryResult<OfficeCatalogueQuery, OfficeCatalogueQueryVariables>;
export function refetchOfficeCatalogueQuery(variables: OfficeCatalogueQueryVariables) {
      return { query: OfficeCatalogueDocument, variables: variables }
    }
export const OfficeReservationRequestListItemApproveDocument = /*#__PURE__*/ gql`
    mutation OfficeReservationRequestListItem_Approve($requestId: ReservationRequestId!) {
  approveOfficeReservation(requestId: $requestId) {
    ...NfsError
    ... on ReservationRequest {
      requestId
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useOfficeReservationRequestListItemApproveMutation__
 *
 * To run a mutation, you first call `useOfficeReservationRequestListItemApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfficeReservationRequestListItemApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [officeReservationRequestListItemApproveMutation, { data, loading, error }] = useOfficeReservationRequestListItemApproveMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useOfficeReservationRequestListItemApproveMutation(baseOptions?: ApolloReact.MutationHookOptions<OfficeReservationRequestListItemApproveMutation, OfficeReservationRequestListItemApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeReservationRequestListItemApproveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<OfficeReservationRequestListItemApproveMutation, OfficeReservationRequestListItemApproveMutationVariables>(OfficeReservationRequestListItemApproveDocument, parser(options)));
      }
export type OfficeReservationRequestListItemApproveMutationHookResult = ReturnType<typeof useOfficeReservationRequestListItemApproveMutation>;
export type OfficeReservationRequestListItemApproveMutationResult = ApolloReact.MutationResult<OfficeReservationRequestListItemApproveMutation>;
export type OfficeReservationRequestListItemApproveMutationOptions = Apollo.MutationOptions<OfficeReservationRequestListItemApproveMutation, OfficeReservationRequestListItemApproveMutationVariables>;
export const OfficeReservationsListFiltersOfficesDocument = /*#__PURE__*/ gql`
    query OfficeReservationsListFilters_Offices {
  offices {
    ...NfsError
    ... on ListOfOfficeResponse {
      value {
        officeId
        name
        physical
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useOfficeReservationsListFiltersOfficesQuery__
 *
 * To run a query within a React component, call `useOfficeReservationsListFiltersOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeReservationsListFiltersOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeReservationsListFiltersOfficesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfficeReservationsListFiltersOfficesQuery(baseOptions?: ApolloReact.QueryHookOptions<OfficeReservationsListFiltersOfficesQuery, OfficeReservationsListFiltersOfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeReservationsListFiltersOfficesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<OfficeReservationsListFiltersOfficesQuery, OfficeReservationsListFiltersOfficesQueryVariables>(OfficeReservationsListFiltersOfficesDocument, parser(options)));
      }
export function useOfficeReservationsListFiltersOfficesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<OfficeReservationsListFiltersOfficesQuery, OfficeReservationsListFiltersOfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(OfficeReservationsListFiltersOfficesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<OfficeReservationsListFiltersOfficesQuery, OfficeReservationsListFiltersOfficesQueryVariables>(OfficeReservationsListFiltersOfficesDocument, options));
        }

export type OfficeReservationsListFiltersOfficesQueryResult = ApolloReact.QueryResult<OfficeReservationsListFiltersOfficesQuery, OfficeReservationsListFiltersOfficesQueryVariables>;
export function refetchOfficeReservationsListFiltersOfficesQuery(variables?: OfficeReservationsListFiltersOfficesQueryVariables) {
      return { query: OfficeReservationsListFiltersOfficesDocument, variables: variables }
    }
export const OfficeSettingsDocument = /*#__PURE__*/ gql`
    query OfficeSettings($officeId: OfficeId!) {
  officeSettings(officeId: $officeId) {
    ...NfsError
    ... on OfficeSettings {
      office {
        officeId
      }
      receptionEmails
      parkingInformation
      floorMap {
        ...OfficeSettings_MapFile
      }
      parkingMap {
        ...OfficeSettings_MapFile
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${OfficeSettingsMapFileFragmentDoc}`;

/**
 * __useOfficeSettingsQuery__
 *
 * To run a query within a React component, call `useOfficeSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeSettingsQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useOfficeSettingsQuery(baseOptions: ApolloReact.QueryHookOptions<OfficeSettingsQuery, OfficeSettingsQueryVariables> & ({ variables: OfficeSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeSettingsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<OfficeSettingsQuery, OfficeSettingsQueryVariables>(OfficeSettingsDocument, parser(options)));
      }
export function useOfficeSettingsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<OfficeSettingsQuery, OfficeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(OfficeSettingsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<OfficeSettingsQuery, OfficeSettingsQueryVariables>(OfficeSettingsDocument, options));
        }

export type OfficeSettingsQueryResult = ApolloReact.QueryResult<OfficeSettingsQuery, OfficeSettingsQueryVariables>;
export function refetchOfficeSettingsQuery(variables: OfficeSettingsQueryVariables) {
      return { query: OfficeSettingsDocument, variables: variables }
    }
export const OfficeSpotsDocument = /*#__PURE__*/ gql`
    query OfficeSpots($officeId: OfficeId!) {
  office(officeId: $officeId) {
    ...NfsError
    ... on Office {
      officeId
      name
      validFrom
      validTo
      blocked
    }
  }
  officeSettings(officeId: $officeId) {
    ...NfsError
    ... on OfficeSettings {
      office {
        officeId
      }
      floorMap {
        fileName
        downloadUrl
      }
      parkingMap {
        fileName
        downloadUrl
      }
    }
  }
  officeReservationSettings {
    ...NfsError
    ... on OfficeReservationSettings {
      deskMaxAdvanceDays
      parkingMaxAdvanceDays
    }
  }
  officeCatalogue(officeId: $officeId) {
    ...NfsError
    ... on OfficeCatalogue {
      rooms {
        id
        name
        securityZone
        blocked
        desks {
          id
          name
          monitors
          standing
          blocked
        }
      }
      parkingSpots {
        id
        number
        name
        guest
        blocked
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useOfficeSpotsQuery__
 *
 * To run a query within a React component, call `useOfficeSpotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeSpotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeSpotsQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useOfficeSpotsQuery(baseOptions: ApolloReact.QueryHookOptions<OfficeSpotsQuery, OfficeSpotsQueryVariables> & ({ variables: OfficeSpotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeSpotsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<OfficeSpotsQuery, OfficeSpotsQueryVariables>(OfficeSpotsDocument, parser(options)));
      }
export function useOfficeSpotsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<OfficeSpotsQuery, OfficeSpotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(OfficeSpotsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<OfficeSpotsQuery, OfficeSpotsQueryVariables>(OfficeSpotsDocument, options));
        }

export type OfficeSpotsQueryResult = ApolloReact.QueryResult<OfficeSpotsQuery, OfficeSpotsQueryVariables>;
export function refetchOfficeSpotsQuery(variables: OfficeSpotsQueryVariables) {
      return { query: OfficeSpotsDocument, variables: variables }
    }
export const OfficeSpotsBookingsDocument = /*#__PURE__*/ gql`
    query OfficeSpots_Bookings($officeId: OfficeId!, $from: LocalDate!, $to: LocalDate!, $first: Int!) {
  officeReservations(
    filter: {officeId_eq: $officeId, date_gte: $from, date_lte: $to}
    first: $first
  ) {
    ...NfsError
    ... on FSPResponseOfficeReservation {
      edges {
        node {
          ...OfficeSpots_Reservation
        }
      }
    }
  }
  deskAssignments(officeId: $officeId) {
    ...NfsError
    ... on ListOfDeskAssignmentResponse {
      value {
        id
        from
        to
        desk {
          id
          name
        }
        user {
          ...OfficeSpots_User
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${OfficeSpotsReservationFragmentDoc}
${OfficeSpotsUserFragmentDoc}`;

/**
 * __useOfficeSpotsBookingsQuery__
 *
 * To run a query within a React component, call `useOfficeSpotsBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeSpotsBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeSpotsBookingsQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useOfficeSpotsBookingsQuery(baseOptions: ApolloReact.QueryHookOptions<OfficeSpotsBookingsQuery, OfficeSpotsBookingsQueryVariables> & ({ variables: OfficeSpotsBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeSpotsBookingsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<OfficeSpotsBookingsQuery, OfficeSpotsBookingsQueryVariables>(OfficeSpotsBookingsDocument, parser(options)));
      }
export function useOfficeSpotsBookingsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<OfficeSpotsBookingsQuery, OfficeSpotsBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(OfficeSpotsBookingsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<OfficeSpotsBookingsQuery, OfficeSpotsBookingsQueryVariables>(OfficeSpotsBookingsDocument, options));
        }

export type OfficeSpotsBookingsQueryResult = ApolloReact.QueryResult<OfficeSpotsBookingsQuery, OfficeSpotsBookingsQueryVariables>;
export function refetchOfficeSpotsBookingsQuery(variables: OfficeSpotsBookingsQueryVariables) {
      return { query: OfficeSpotsBookingsDocument, variables: variables }
    }
export const OrderPayrollTransfersModalOrderDocument = /*#__PURE__*/ gql`
    mutation OrderPayrollTransfersModal_Order($yearMonth: YearMonth!, $filter: FilterContractSalaryDetailsInput!) {
  orderPayrollTransfers(yearMonth: $yearMonth, filter: $filter) {
    ...NfsError
    ... on PayrollTransfersOrderView {
      ...PayrollTransfersOrderResultModal_Result
    }
  }
}
    ${NfsErrorFragmentDoc}
${PayrollTransfersOrderResultModalResultFragmentDoc}`;


/**
 * __useOrderPayrollTransfersModalOrderMutation__
 *
 * To run a mutation, you first call `useOrderPayrollTransfersModalOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderPayrollTransfersModalOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderPayrollTransfersModalOrderMutation, { data, loading, error }] = useOrderPayrollTransfersModalOrderMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrderPayrollTransfersModalOrderMutation(baseOptions?: ApolloReact.MutationHookOptions<OrderPayrollTransfersModalOrderMutation, OrderPayrollTransfersModalOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OrderPayrollTransfersModalOrderDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<OrderPayrollTransfersModalOrderMutation, OrderPayrollTransfersModalOrderMutationVariables>(OrderPayrollTransfersModalOrderDocument, parser(options)));
      }
export type OrderPayrollTransfersModalOrderMutationHookResult = ReturnType<typeof useOrderPayrollTransfersModalOrderMutation>;
export type OrderPayrollTransfersModalOrderMutationResult = ApolloReact.MutationResult<OrderPayrollTransfersModalOrderMutation>;
export type OrderPayrollTransfersModalOrderMutationOptions = Apollo.MutationOptions<OrderPayrollTransfersModalOrderMutation, OrderPayrollTransfersModalOrderMutationVariables>;
export const OtherEmployeeInformationDrawerDocument = /*#__PURE__*/ gql`
    query OtherEmployeeInformationDrawer($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...OtherEmployeeInformation_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${OtherEmployeeInformationUserFragmentDoc}`;

/**
 * __useOtherEmployeeInformationDrawerQuery__
 *
 * To run a query within a React component, call `useOtherEmployeeInformationDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtherEmployeeInformationDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtherEmployeeInformationDrawerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOtherEmployeeInformationDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<OtherEmployeeInformationDrawerQuery, OtherEmployeeInformationDrawerQueryVariables> & ({ variables: OtherEmployeeInformationDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OtherEmployeeInformationDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<OtherEmployeeInformationDrawerQuery, OtherEmployeeInformationDrawerQueryVariables>(OtherEmployeeInformationDrawerDocument, parser(options)));
      }
export function useOtherEmployeeInformationDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<OtherEmployeeInformationDrawerQuery, OtherEmployeeInformationDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(OtherEmployeeInformationDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<OtherEmployeeInformationDrawerQuery, OtherEmployeeInformationDrawerQueryVariables>(OtherEmployeeInformationDrawerDocument, options));
        }

export type OtherEmployeeInformationDrawerQueryResult = ApolloReact.QueryResult<OtherEmployeeInformationDrawerQuery, OtherEmployeeInformationDrawerQueryVariables>;
export function refetchOtherEmployeeInformationDrawerQuery(variables: OtherEmployeeInformationDrawerQueryVariables) {
      return { query: OtherEmployeeInformationDrawerDocument, variables: variables }
    }
export const OtherEmployeeInformationDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation OtherEmployeeInformationDrawer_Update($userId: UserId!, $entityVersion: EntityVersion!, $personalDataProcessingAuthorization: ClearableURIInput, $consentedForUseOfImage: Boolean!, $documentsDirectory: URI) {
  user(userId: $userId, entityVersion: $entityVersion) {
    updateUser(
      personalDataProcessingAuthorization: $personalDataProcessingAuthorization
      consentedForUseOfImage: $consentedForUseOfImage
      documentsDirectory: $documentsDirectory
    ) {
      ...NfsError
      ... on User {
        ...OtherEmployeeInformation_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${OtherEmployeeInformationUserFragmentDoc}`;


/**
 * __useOtherEmployeeInformationDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useOtherEmployeeInformationDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOtherEmployeeInformationDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [otherEmployeeInformationDrawerUpdateMutation, { data, loading, error }] = useOtherEmployeeInformationDrawerUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      personalDataProcessingAuthorization: // value for 'personalDataProcessingAuthorization'
 *      consentedForUseOfImage: // value for 'consentedForUseOfImage'
 *      documentsDirectory: // value for 'documentsDirectory'
 *   },
 * });
 */
export function useOtherEmployeeInformationDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<OtherEmployeeInformationDrawerUpdateMutation, OtherEmployeeInformationDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OtherEmployeeInformationDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<OtherEmployeeInformationDrawerUpdateMutation, OtherEmployeeInformationDrawerUpdateMutationVariables>(OtherEmployeeInformationDrawerUpdateDocument, parser(options)));
      }
export type OtherEmployeeInformationDrawerUpdateMutationHookResult = ReturnType<typeof useOtherEmployeeInformationDrawerUpdateMutation>;
export type OtherEmployeeInformationDrawerUpdateMutationResult = ApolloReact.MutationResult<OtherEmployeeInformationDrawerUpdateMutation>;
export type OtherEmployeeInformationDrawerUpdateMutationOptions = Apollo.MutationOptions<OtherEmployeeInformationDrawerUpdateMutation, OtherEmployeeInformationDrawerUpdateMutationVariables>;
export const ParkingSpotDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query ParkingSpotDrawer_InitialData($officeId: OfficeId!) {
  officeCatalogue(officeId: $officeId) {
    ...NfsError
    ... on OfficeCatalogue {
      parkingSpots {
        ...ParkingSpotDrawer_ParkingSpot
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ParkingSpotDrawerParkingSpotFragmentDoc}`;

/**
 * __useParkingSpotDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useParkingSpotDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useParkingSpotDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParkingSpotDrawerInitialDataQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useParkingSpotDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<ParkingSpotDrawerInitialDataQuery, ParkingSpotDrawerInitialDataQueryVariables> & ({ variables: ParkingSpotDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ParkingSpotDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ParkingSpotDrawerInitialDataQuery, ParkingSpotDrawerInitialDataQueryVariables>(ParkingSpotDrawerInitialDataDocument, parser(options)));
      }
export function useParkingSpotDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ParkingSpotDrawerInitialDataQuery, ParkingSpotDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ParkingSpotDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ParkingSpotDrawerInitialDataQuery, ParkingSpotDrawerInitialDataQueryVariables>(ParkingSpotDrawerInitialDataDocument, options));
        }

export type ParkingSpotDrawerInitialDataQueryResult = ApolloReact.QueryResult<ParkingSpotDrawerInitialDataQuery, ParkingSpotDrawerInitialDataQueryVariables>;
export function refetchParkingSpotDrawerInitialDataQuery(variables: ParkingSpotDrawerInitialDataQueryVariables) {
      return { query: ParkingSpotDrawerInitialDataDocument, variables: variables }
    }
export const ParkingSpotDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation ParkingSpotDrawer_Create($id: ParkingSpotId!, $officeId: OfficeId!, $number: String!, $name: String!, $guest: Boolean!, $blocked: Boolean) {
  createParkingSpot(
    id: $id
    officeId: $officeId
    number: $number
    name: $name
    guest: $guest
    blocked: $blocked
  ) {
    ...NfsError
    ... on ParkingSpot {
      ...OfficeCatalogue_ParkingSpot
    }
  }
}
    ${NfsErrorFragmentDoc}
${OfficeCatalogueParkingSpotFragmentDoc}`;


/**
 * __useParkingSpotDrawerCreateMutation__
 *
 * To run a mutation, you first call `useParkingSpotDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParkingSpotDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parkingSpotDrawerCreateMutation, { data, loading, error }] = useParkingSpotDrawerCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      officeId: // value for 'officeId'
 *      number: // value for 'number'
 *      name: // value for 'name'
 *      guest: // value for 'guest'
 *      blocked: // value for 'blocked'
 *   },
 * });
 */
export function useParkingSpotDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<ParkingSpotDrawerCreateMutation, ParkingSpotDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ParkingSpotDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ParkingSpotDrawerCreateMutation, ParkingSpotDrawerCreateMutationVariables>(ParkingSpotDrawerCreateDocument, parser(options)));
      }
export type ParkingSpotDrawerCreateMutationHookResult = ReturnType<typeof useParkingSpotDrawerCreateMutation>;
export type ParkingSpotDrawerCreateMutationResult = ApolloReact.MutationResult<ParkingSpotDrawerCreateMutation>;
export type ParkingSpotDrawerCreateMutationOptions = Apollo.MutationOptions<ParkingSpotDrawerCreateMutation, ParkingSpotDrawerCreateMutationVariables>;
export const ParkingSpotDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation ParkingSpotDrawer_Update($parkingSpotId: ParkingSpotId!, $parkingSpot: UpdateParkingSpotInput!) {
  updateParkingSpot(parkingSpotId: $parkingSpotId, parkingSpot: $parkingSpot) {
    ...NfsError
    ... on ParkingSpot {
      ...ParkingSpotDrawer_ParkingSpot
    }
  }
}
    ${NfsErrorFragmentDoc}
${ParkingSpotDrawerParkingSpotFragmentDoc}`;


/**
 * __useParkingSpotDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useParkingSpotDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParkingSpotDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parkingSpotDrawerUpdateMutation, { data, loading, error }] = useParkingSpotDrawerUpdateMutation({
 *   variables: {
 *      parkingSpotId: // value for 'parkingSpotId'
 *      parkingSpot: // value for 'parkingSpot'
 *   },
 * });
 */
export function useParkingSpotDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<ParkingSpotDrawerUpdateMutation, ParkingSpotDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ParkingSpotDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ParkingSpotDrawerUpdateMutation, ParkingSpotDrawerUpdateMutationVariables>(ParkingSpotDrawerUpdateDocument, parser(options)));
      }
export type ParkingSpotDrawerUpdateMutationHookResult = ReturnType<typeof useParkingSpotDrawerUpdateMutation>;
export type ParkingSpotDrawerUpdateMutationResult = ApolloReact.MutationResult<ParkingSpotDrawerUpdateMutation>;
export type ParkingSpotDrawerUpdateMutationOptions = Apollo.MutationOptions<ParkingSpotDrawerUpdateMutation, ParkingSpotDrawerUpdateMutationVariables>;
export const PaymentDetailsDraftDrawerInputDocument = /*#__PURE__*/ gql`
    query PaymentDetailsDraftDrawer_Input($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            ...PaymentDetailsDraftDrawer_ContractDraft
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${PaymentDetailsDraftDrawerContractDraftFragmentDoc}`;

/**
 * __usePaymentDetailsDraftDrawerInputQuery__
 *
 * To run a query within a React component, call `usePaymentDetailsDraftDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailsDraftDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentDetailsDraftDrawerInputQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePaymentDetailsDraftDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<PaymentDetailsDraftDrawerInputQuery, PaymentDetailsDraftDrawerInputQueryVariables> & ({ variables: PaymentDetailsDraftDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PaymentDetailsDraftDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PaymentDetailsDraftDrawerInputQuery, PaymentDetailsDraftDrawerInputQueryVariables>(PaymentDetailsDraftDrawerInputDocument, parser(options)));
      }
export function usePaymentDetailsDraftDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PaymentDetailsDraftDrawerInputQuery, PaymentDetailsDraftDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PaymentDetailsDraftDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PaymentDetailsDraftDrawerInputQuery, PaymentDetailsDraftDrawerInputQueryVariables>(PaymentDetailsDraftDrawerInputDocument, options));
        }

export type PaymentDetailsDraftDrawerInputQueryResult = ApolloReact.QueryResult<PaymentDetailsDraftDrawerInputQuery, PaymentDetailsDraftDrawerInputQueryVariables>;
export function refetchPaymentDetailsDraftDrawerInputQuery(variables: PaymentDetailsDraftDrawerInputQueryVariables) {
      return { query: PaymentDetailsDraftDrawerInputDocument, variables: variables }
    }
export const PaymentDetailsDraftDrawerUpdateEmploymentDraftDocument = /*#__PURE__*/ gql`
    mutation PaymentDetailsDraftDrawer_UpdateEmploymentDraft($userId: UserId!, $entityVersion: EntityVersion!, $userEntityVersion: EntityVersion!, $rate: ClearableNetRateInput, $overtimeRate: ClearableCentsInput, $onCall: ClearableNetOnCallRateInput, $ppk: ClearableBasisPointInput, $copyrightCosts: ClearableBasisPointInput, $taxDeductibleCosts: ClearableDeductibleCostsTypeInput, $workingTime: ClearableWorkingTimeInput, $applyRemoteWorkReimbursement: Boolean, $currency: ClearableCurrencyInput) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateEmploymentDraft(
        rate: $rate
        overtimeRate: $overtimeRate
        onCall: $onCall
        ppk: $ppk
        copyrightCosts: $copyrightCosts
        taxDeductibleCosts: $taxDeductibleCosts
        workingTime: $workingTime
        applyRemoteWorkReimbursement: $applyRemoteWorkReimbursement
        currency: $currency
      ) {
        ...NfsError
        ... on EmploymentContractDraft {
          ...PaymentDetailsDraftDrawer_ContractDraft
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${PaymentDetailsDraftDrawerContractDraftFragmentDoc}`;


/**
 * __usePaymentDetailsDraftDrawerUpdateEmploymentDraftMutation__
 *
 * To run a mutation, you first call `usePaymentDetailsDraftDrawerUpdateEmploymentDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailsDraftDrawerUpdateEmploymentDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentDetailsDraftDrawerUpdateEmploymentDraftMutation, { data, loading, error }] = usePaymentDetailsDraftDrawerUpdateEmploymentDraftMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      rate: // value for 'rate'
 *      overtimeRate: // value for 'overtimeRate'
 *      onCall: // value for 'onCall'
 *      ppk: // value for 'ppk'
 *      copyrightCosts: // value for 'copyrightCosts'
 *      taxDeductibleCosts: // value for 'taxDeductibleCosts'
 *      workingTime: // value for 'workingTime'
 *      applyRemoteWorkReimbursement: // value for 'applyRemoteWorkReimbursement'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function usePaymentDetailsDraftDrawerUpdateEmploymentDraftMutation(baseOptions?: ApolloReact.MutationHookOptions<PaymentDetailsDraftDrawerUpdateEmploymentDraftMutation, PaymentDetailsDraftDrawerUpdateEmploymentDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PaymentDetailsDraftDrawerUpdateEmploymentDraftDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<PaymentDetailsDraftDrawerUpdateEmploymentDraftMutation, PaymentDetailsDraftDrawerUpdateEmploymentDraftMutationVariables>(PaymentDetailsDraftDrawerUpdateEmploymentDraftDocument, parser(options)));
      }
export type PaymentDetailsDraftDrawerUpdateEmploymentDraftMutationHookResult = ReturnType<typeof usePaymentDetailsDraftDrawerUpdateEmploymentDraftMutation>;
export type PaymentDetailsDraftDrawerUpdateEmploymentDraftMutationResult = ApolloReact.MutationResult<PaymentDetailsDraftDrawerUpdateEmploymentDraftMutation>;
export type PaymentDetailsDraftDrawerUpdateEmploymentDraftMutationOptions = Apollo.MutationOptions<PaymentDetailsDraftDrawerUpdateEmploymentDraftMutation, PaymentDetailsDraftDrawerUpdateEmploymentDraftMutationVariables>;
export const PaymentDetailsDraftDrawerUpdateB2BDraftDocument = /*#__PURE__*/ gql`
    mutation PaymentDetailsDraftDrawer_UpdateB2BDraft($userId: UserId!, $entityVersion: EntityVersion!, $userEntityVersion: EntityVersion!, $rate: ClearableNetRateInput, $overtimeRate: ClearableCentsInput, $onCall: ClearableNetOnCallRateInput, $vat: ClearableVatTypeInput, $currency: ClearableCurrencyInput, $separatePaymentForBenefits: Boolean!) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateB2bDraft(
        rate: $rate
        overtimeRate: $overtimeRate
        onCall: $onCall
        vat: $vat
        currency: $currency
        separatePaymentForBenefits: $separatePaymentForBenefits
      ) {
        ...NfsError
        ... on B2BContractDraft {
          ...PaymentDetailsDraftDrawer_ContractDraft
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${PaymentDetailsDraftDrawerContractDraftFragmentDoc}`;


/**
 * __usePaymentDetailsDraftDrawerUpdateB2BDraftMutation__
 *
 * To run a mutation, you first call `usePaymentDetailsDraftDrawerUpdateB2BDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailsDraftDrawerUpdateB2BDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentDetailsDraftDrawerUpdateB2BDraftMutation, { data, loading, error }] = usePaymentDetailsDraftDrawerUpdateB2BDraftMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      rate: // value for 'rate'
 *      overtimeRate: // value for 'overtimeRate'
 *      onCall: // value for 'onCall'
 *      vat: // value for 'vat'
 *      currency: // value for 'currency'
 *      separatePaymentForBenefits: // value for 'separatePaymentForBenefits'
 *   },
 * });
 */
export function usePaymentDetailsDraftDrawerUpdateB2BDraftMutation(baseOptions?: ApolloReact.MutationHookOptions<PaymentDetailsDraftDrawerUpdateB2BDraftMutation, PaymentDetailsDraftDrawerUpdateB2BDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PaymentDetailsDraftDrawerUpdateB2BDraftDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<PaymentDetailsDraftDrawerUpdateB2BDraftMutation, PaymentDetailsDraftDrawerUpdateB2BDraftMutationVariables>(PaymentDetailsDraftDrawerUpdateB2BDraftDocument, parser(options)));
      }
export type PaymentDetailsDraftDrawerUpdateB2BDraftMutationHookResult = ReturnType<typeof usePaymentDetailsDraftDrawerUpdateB2BDraftMutation>;
export type PaymentDetailsDraftDrawerUpdateB2BDraftMutationResult = ApolloReact.MutationResult<PaymentDetailsDraftDrawerUpdateB2BDraftMutation>;
export type PaymentDetailsDraftDrawerUpdateB2BDraftMutationOptions = Apollo.MutationOptions<PaymentDetailsDraftDrawerUpdateB2BDraftMutation, PaymentDetailsDraftDrawerUpdateB2BDraftMutationVariables>;
export const PaymentDetailsDrawerLoadDataDocument = /*#__PURE__*/ gql`
    query PaymentDetailsDrawer_LoadData($contractId: ContractId!, $at: OffsetDateTime) {
  contract(contractId: $contractId, at: $at) {
    ...NfsError
    ... on ContractResponse {
      value {
        terminationDate
        at
        ...PaymentDetailsDrawer_Contract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${PaymentDetailsDrawerContractFragmentDoc}`;

/**
 * __usePaymentDetailsDrawerLoadDataQuery__
 *
 * To run a query within a React component, call `usePaymentDetailsDrawerLoadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailsDrawerLoadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentDetailsDrawerLoadDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      at: // value for 'at'
 *   },
 * });
 */
export function usePaymentDetailsDrawerLoadDataQuery(baseOptions: ApolloReact.QueryHookOptions<PaymentDetailsDrawerLoadDataQuery, PaymentDetailsDrawerLoadDataQueryVariables> & ({ variables: PaymentDetailsDrawerLoadDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PaymentDetailsDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PaymentDetailsDrawerLoadDataQuery, PaymentDetailsDrawerLoadDataQueryVariables>(PaymentDetailsDrawerLoadDataDocument, parser(options)));
      }
export function usePaymentDetailsDrawerLoadDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PaymentDetailsDrawerLoadDataQuery, PaymentDetailsDrawerLoadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PaymentDetailsDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PaymentDetailsDrawerLoadDataQuery, PaymentDetailsDrawerLoadDataQueryVariables>(PaymentDetailsDrawerLoadDataDocument, options));
        }

export type PaymentDetailsDrawerLoadDataQueryResult = ApolloReact.QueryResult<PaymentDetailsDrawerLoadDataQuery, PaymentDetailsDrawerLoadDataQueryVariables>;
export function refetchPaymentDetailsDrawerLoadDataQuery(variables: PaymentDetailsDrawerLoadDataQueryVariables) {
      return { query: PaymentDetailsDrawerLoadDataDocument, variables: variables }
    }
export const PaymentDetailsDrawerUpdateB2BContractDocument = /*#__PURE__*/ gql`
    mutation PaymentDetailsDrawer_UpdateB2BContract($contractId: ContractId!, $entityVersion: EntityVersion!, $overtimeRate: TimeBasedValueClearableCentsInput!, $onCall: TimeBasedValueClearableNetOnCallRateInput!, $vat: TimeBasedValueVatTypeInput, $separatePaymentForBenefits: TimeBasedValueBooleanInput!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateB2BContract(
      overtimeRate: $overtimeRate
      onCall: $onCall
      vat: $vat
      separatePaymentForBenefits: $separatePaymentForBenefits
    ) {
      ...NfsError
      ... on B2BContract {
        ...PaymentDetailsDrawer_Contract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${PaymentDetailsDrawerContractFragmentDoc}`;


/**
 * __usePaymentDetailsDrawerUpdateB2BContractMutation__
 *
 * To run a mutation, you first call `usePaymentDetailsDrawerUpdateB2BContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailsDrawerUpdateB2BContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentDetailsDrawerUpdateB2BContractMutation, { data, loading, error }] = usePaymentDetailsDrawerUpdateB2BContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      overtimeRate: // value for 'overtimeRate'
 *      onCall: // value for 'onCall'
 *      vat: // value for 'vat'
 *      separatePaymentForBenefits: // value for 'separatePaymentForBenefits'
 *   },
 * });
 */
export function usePaymentDetailsDrawerUpdateB2BContractMutation(baseOptions?: ApolloReact.MutationHookOptions<PaymentDetailsDrawerUpdateB2BContractMutation, PaymentDetailsDrawerUpdateB2BContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PaymentDetailsDrawerUpdateB2BContractDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<PaymentDetailsDrawerUpdateB2BContractMutation, PaymentDetailsDrawerUpdateB2BContractMutationVariables>(PaymentDetailsDrawerUpdateB2BContractDocument, parser(options)));
      }
export type PaymentDetailsDrawerUpdateB2BContractMutationHookResult = ReturnType<typeof usePaymentDetailsDrawerUpdateB2BContractMutation>;
export type PaymentDetailsDrawerUpdateB2BContractMutationResult = ApolloReact.MutationResult<PaymentDetailsDrawerUpdateB2BContractMutation>;
export type PaymentDetailsDrawerUpdateB2BContractMutationOptions = Apollo.MutationOptions<PaymentDetailsDrawerUpdateB2BContractMutation, PaymentDetailsDrawerUpdateB2BContractMutationVariables>;
export const PaymentDetailsDrawerUpdateEmploymentContractDocument = /*#__PURE__*/ gql`
    mutation PaymentDetailsDrawer_UpdateEmploymentContract($contractId: ContractId!, $entityVersion: EntityVersion!, $overtimeRate: TimeBasedValueClearableCentsInput!, $onCall: TimeBasedValueClearableNetOnCallRateInput!, $ppk: TimeBasedValueClearableBasisPointInput!, $copyrightCosts: TimeBasedValueClearableBasisPointInput!, $workingTime: TimeBasedValueWorkingTimeInput, $taxDeductibleCosts: TimeBasedValueClearableDeductibleCostsTypeInput!, $applyRemoteWorkReimbursement: TimeBasedValueBooleanInput!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(
      overtimeRate: $overtimeRate
      onCall: $onCall
      ppk: $ppk
      copyrightCosts: $copyrightCosts
      workingTime: $workingTime
      taxDeductibleCosts: $taxDeductibleCosts
      applyRemoteWorkReimbursement: $applyRemoteWorkReimbursement
    ) {
      ...NfsError
      ... on EmploymentContract {
        ...PaymentDetailsDrawer_Contract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${PaymentDetailsDrawerContractFragmentDoc}`;


/**
 * __usePaymentDetailsDrawerUpdateEmploymentContractMutation__
 *
 * To run a mutation, you first call `usePaymentDetailsDrawerUpdateEmploymentContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailsDrawerUpdateEmploymentContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentDetailsDrawerUpdateEmploymentContractMutation, { data, loading, error }] = usePaymentDetailsDrawerUpdateEmploymentContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      overtimeRate: // value for 'overtimeRate'
 *      onCall: // value for 'onCall'
 *      ppk: // value for 'ppk'
 *      copyrightCosts: // value for 'copyrightCosts'
 *      workingTime: // value for 'workingTime'
 *      taxDeductibleCosts: // value for 'taxDeductibleCosts'
 *      applyRemoteWorkReimbursement: // value for 'applyRemoteWorkReimbursement'
 *   },
 * });
 */
export function usePaymentDetailsDrawerUpdateEmploymentContractMutation(baseOptions?: ApolloReact.MutationHookOptions<PaymentDetailsDrawerUpdateEmploymentContractMutation, PaymentDetailsDrawerUpdateEmploymentContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PaymentDetailsDrawerUpdateEmploymentContractDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<PaymentDetailsDrawerUpdateEmploymentContractMutation, PaymentDetailsDrawerUpdateEmploymentContractMutationVariables>(PaymentDetailsDrawerUpdateEmploymentContractDocument, parser(options)));
      }
export type PaymentDetailsDrawerUpdateEmploymentContractMutationHookResult = ReturnType<typeof usePaymentDetailsDrawerUpdateEmploymentContractMutation>;
export type PaymentDetailsDrawerUpdateEmploymentContractMutationResult = ApolloReact.MutationResult<PaymentDetailsDrawerUpdateEmploymentContractMutation>;
export type PaymentDetailsDrawerUpdateEmploymentContractMutationOptions = Apollo.MutationOptions<PaymentDetailsDrawerUpdateEmploymentContractMutation, PaymentDetailsDrawerUpdateEmploymentContractMutationVariables>;
export const PendingCopyrightsDrawerCopyrightsDocument = /*#__PURE__*/ gql`
    query PendingCopyrightsDrawer_Copyrights($contractId: ContractId!, $from: YearMonth!, $to: YearMonth!) {
  contractSalaryDetailsInRange(contractId: $contractId, from: $from, to: $to) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      value {
        ... on EmploymentContractSalaryDetails {
          ...PendingCopyrightsDrawer_Salary
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${PendingCopyrightsDrawerSalaryFragmentDoc}`;

/**
 * __usePendingCopyrightsDrawerCopyrightsQuery__
 *
 * To run a query within a React component, call `usePendingCopyrightsDrawerCopyrightsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingCopyrightsDrawerCopyrightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingCopyrightsDrawerCopyrightsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function usePendingCopyrightsDrawerCopyrightsQuery(baseOptions: ApolloReact.QueryHookOptions<PendingCopyrightsDrawerCopyrightsQuery, PendingCopyrightsDrawerCopyrightsQueryVariables> & ({ variables: PendingCopyrightsDrawerCopyrightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PendingCopyrightsDrawerCopyrightsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PendingCopyrightsDrawerCopyrightsQuery, PendingCopyrightsDrawerCopyrightsQueryVariables>(PendingCopyrightsDrawerCopyrightsDocument, parser(options)));
      }
export function usePendingCopyrightsDrawerCopyrightsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PendingCopyrightsDrawerCopyrightsQuery, PendingCopyrightsDrawerCopyrightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PendingCopyrightsDrawerCopyrightsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PendingCopyrightsDrawerCopyrightsQuery, PendingCopyrightsDrawerCopyrightsQueryVariables>(PendingCopyrightsDrawerCopyrightsDocument, options));
        }

export type PendingCopyrightsDrawerCopyrightsQueryResult = ApolloReact.QueryResult<PendingCopyrightsDrawerCopyrightsQuery, PendingCopyrightsDrawerCopyrightsQueryVariables>;
export function refetchPendingCopyrightsDrawerCopyrightsQuery(variables: PendingCopyrightsDrawerCopyrightsQueryVariables) {
      return { query: PendingCopyrightsDrawerCopyrightsDocument, variables: variables }
    }
export const PendingCopyrightsDrawerUpdateWorkTransferDocument = /*#__PURE__*/ gql`
    mutation PendingCopyrightsDrawer_UpdateWorkTransfer($id: WorkTransferProtocolId!, $description: ClearableStringInput, $payload: Upload, $contractId: ContractId!, $yearMonth: YearMonth!, $approved: Boolean) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      update(
        id: $id
        description: $description
        payload: $payload
        approved: $approved
      ) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...CopyrightsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightsDrawerWorkTransferFragmentDoc}`;


/**
 * __usePendingCopyrightsDrawerUpdateWorkTransferMutation__
 *
 * To run a mutation, you first call `usePendingCopyrightsDrawerUpdateWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendingCopyrightsDrawerUpdateWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendingCopyrightsDrawerUpdateWorkTransferMutation, { data, loading, error }] = usePendingCopyrightsDrawerUpdateWorkTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      payload: // value for 'payload'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function usePendingCopyrightsDrawerUpdateWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<PendingCopyrightsDrawerUpdateWorkTransferMutation, PendingCopyrightsDrawerUpdateWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PendingCopyrightsDrawerUpdateWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<PendingCopyrightsDrawerUpdateWorkTransferMutation, PendingCopyrightsDrawerUpdateWorkTransferMutationVariables>(PendingCopyrightsDrawerUpdateWorkTransferDocument, parser(options)));
      }
export type PendingCopyrightsDrawerUpdateWorkTransferMutationHookResult = ReturnType<typeof usePendingCopyrightsDrawerUpdateWorkTransferMutation>;
export type PendingCopyrightsDrawerUpdateWorkTransferMutationResult = ApolloReact.MutationResult<PendingCopyrightsDrawerUpdateWorkTransferMutation>;
export type PendingCopyrightsDrawerUpdateWorkTransferMutationOptions = Apollo.MutationOptions<PendingCopyrightsDrawerUpdateWorkTransferMutation, PendingCopyrightsDrawerUpdateWorkTransferMutationVariables>;
export const PendingCopyrightsDrawerCreateWorkTransferDocument = /*#__PURE__*/ gql`
    mutation PendingCopyrightsDrawer_CreateWorkTransfer($contractSalaryDetailsId: ContractSalaryDetailsIdInput!, $id: WorkTransferProtocolId!, $description: String, $payload: Upload!, $contractId: ContractId!, $yearMonth: YearMonth!, $approved: Boolean) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      create(
        contractSalaryDetailsId: $contractSalaryDetailsId
        id: $id
        description: $description
        payload: $payload
        approved: $approved
      ) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...CopyrightsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightsDrawerWorkTransferFragmentDoc}`;


/**
 * __usePendingCopyrightsDrawerCreateWorkTransferMutation__
 *
 * To run a mutation, you first call `usePendingCopyrightsDrawerCreateWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendingCopyrightsDrawerCreateWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendingCopyrightsDrawerCreateWorkTransferMutation, { data, loading, error }] = usePendingCopyrightsDrawerCreateWorkTransferMutation({
 *   variables: {
 *      contractSalaryDetailsId: // value for 'contractSalaryDetailsId'
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      payload: // value for 'payload'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function usePendingCopyrightsDrawerCreateWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<PendingCopyrightsDrawerCreateWorkTransferMutation, PendingCopyrightsDrawerCreateWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PendingCopyrightsDrawerCreateWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<PendingCopyrightsDrawerCreateWorkTransferMutation, PendingCopyrightsDrawerCreateWorkTransferMutationVariables>(PendingCopyrightsDrawerCreateWorkTransferDocument, parser(options)));
      }
export type PendingCopyrightsDrawerCreateWorkTransferMutationHookResult = ReturnType<typeof usePendingCopyrightsDrawerCreateWorkTransferMutation>;
export type PendingCopyrightsDrawerCreateWorkTransferMutationResult = ApolloReact.MutationResult<PendingCopyrightsDrawerCreateWorkTransferMutation>;
export type PendingCopyrightsDrawerCreateWorkTransferMutationOptions = Apollo.MutationOptions<PendingCopyrightsDrawerCreateWorkTransferMutation, PendingCopyrightsDrawerCreateWorkTransferMutationVariables>;
export const PendingCopyrightsDrawerRemoveWorkTransferDocument = /*#__PURE__*/ gql`
    mutation PendingCopyrightsDrawer_RemoveWorkTransfer($id: WorkTransferProtocolId!, $contractId: ContractId!, $yearMonth: YearMonth!) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      remove(id: $id) {
        ...NfsError
        ... on BooleanResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __usePendingCopyrightsDrawerRemoveWorkTransferMutation__
 *
 * To run a mutation, you first call `usePendingCopyrightsDrawerRemoveWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendingCopyrightsDrawerRemoveWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendingCopyrightsDrawerRemoveWorkTransferMutation, { data, loading, error }] = usePendingCopyrightsDrawerRemoveWorkTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *   },
 * });
 */
export function usePendingCopyrightsDrawerRemoveWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<PendingCopyrightsDrawerRemoveWorkTransferMutation, PendingCopyrightsDrawerRemoveWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PendingCopyrightsDrawerRemoveWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<PendingCopyrightsDrawerRemoveWorkTransferMutation, PendingCopyrightsDrawerRemoveWorkTransferMutationVariables>(PendingCopyrightsDrawerRemoveWorkTransferDocument, parser(options)));
      }
export type PendingCopyrightsDrawerRemoveWorkTransferMutationHookResult = ReturnType<typeof usePendingCopyrightsDrawerRemoveWorkTransferMutation>;
export type PendingCopyrightsDrawerRemoveWorkTransferMutationResult = ApolloReact.MutationResult<PendingCopyrightsDrawerRemoveWorkTransferMutation>;
export type PendingCopyrightsDrawerRemoveWorkTransferMutationOptions = Apollo.MutationOptions<PendingCopyrightsDrawerRemoveWorkTransferMutation, PendingCopyrightsDrawerRemoveWorkTransferMutationVariables>;
export const PendingCopyrightsDrawerMarkNoWorkDocument = /*#__PURE__*/ gql`
    mutation PendingCopyrightsDrawer_MarkNoWork($contractSalaryDetailsId: ContractSalaryDetailsIdInput!, $contractId: ContractId!, $yearMonth: YearMonth!) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      markNoWorkToBeTransferedThisMonth(
        contractSalaryDetailsId: $contractSalaryDetailsId
      ) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...CopyrightsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightsDrawerWorkTransferFragmentDoc}`;


/**
 * __usePendingCopyrightsDrawerMarkNoWorkMutation__
 *
 * To run a mutation, you first call `usePendingCopyrightsDrawerMarkNoWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendingCopyrightsDrawerMarkNoWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendingCopyrightsDrawerMarkNoWorkMutation, { data, loading, error }] = usePendingCopyrightsDrawerMarkNoWorkMutation({
 *   variables: {
 *      contractSalaryDetailsId: // value for 'contractSalaryDetailsId'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *   },
 * });
 */
export function usePendingCopyrightsDrawerMarkNoWorkMutation(baseOptions?: ApolloReact.MutationHookOptions<PendingCopyrightsDrawerMarkNoWorkMutation, PendingCopyrightsDrawerMarkNoWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PendingCopyrightsDrawerMarkNoWorkDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<PendingCopyrightsDrawerMarkNoWorkMutation, PendingCopyrightsDrawerMarkNoWorkMutationVariables>(PendingCopyrightsDrawerMarkNoWorkDocument, parser(options)));
      }
export type PendingCopyrightsDrawerMarkNoWorkMutationHookResult = ReturnType<typeof usePendingCopyrightsDrawerMarkNoWorkMutation>;
export type PendingCopyrightsDrawerMarkNoWorkMutationResult = ApolloReact.MutationResult<PendingCopyrightsDrawerMarkNoWorkMutation>;
export type PendingCopyrightsDrawerMarkNoWorkMutationOptions = Apollo.MutationOptions<PendingCopyrightsDrawerMarkNoWorkMutation, PendingCopyrightsDrawerMarkNoWorkMutationVariables>;
export const PeopleListFiltersOfficesDocument = /*#__PURE__*/ gql`
    query PeopleListFilters_Offices {
  offices {
    ...NfsError
    ... on ListOfOfficeResponse {
      value {
        officeId
        name
        validFrom
        validTo
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __usePeopleListFiltersOfficesQuery__
 *
 * To run a query within a React component, call `usePeopleListFiltersOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleListFiltersOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleListFiltersOfficesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePeopleListFiltersOfficesQuery(baseOptions?: ApolloReact.QueryHookOptions<PeopleListFiltersOfficesQuery, PeopleListFiltersOfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PeopleListFiltersOfficesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PeopleListFiltersOfficesQuery, PeopleListFiltersOfficesQueryVariables>(PeopleListFiltersOfficesDocument, parser(options)));
      }
export function usePeopleListFiltersOfficesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PeopleListFiltersOfficesQuery, PeopleListFiltersOfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PeopleListFiltersOfficesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PeopleListFiltersOfficesQuery, PeopleListFiltersOfficesQueryVariables>(PeopleListFiltersOfficesDocument, options));
        }

export type PeopleListFiltersOfficesQueryResult = ApolloReact.QueryResult<PeopleListFiltersOfficesQuery, PeopleListFiltersOfficesQueryVariables>;
export function refetchPeopleListFiltersOfficesQuery(variables?: PeopleListFiltersOfficesQueryVariables) {
      return { query: PeopleListFiltersOfficesDocument, variables: variables }
    }
export const PeopleListFiltersSpacesDocument = /*#__PURE__*/ gql`
    query PeopleListFilters_Spaces($first: Int, $after: Cursor) {
  spaces(first: $first, after: $after) {
    ...NfsError
    ... on FSPResponseSpace {
      hasNextPage
      edges {
        cursor
        node {
          entityVersion
          id
          name
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __usePeopleListFiltersSpacesQuery__
 *
 * To run a query within a React component, call `usePeopleListFiltersSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleListFiltersSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleListFiltersSpacesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePeopleListFiltersSpacesQuery(baseOptions?: ApolloReact.QueryHookOptions<PeopleListFiltersSpacesQuery, PeopleListFiltersSpacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PeopleListFiltersSpacesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PeopleListFiltersSpacesQuery, PeopleListFiltersSpacesQueryVariables>(PeopleListFiltersSpacesDocument, parser(options)));
      }
export function usePeopleListFiltersSpacesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PeopleListFiltersSpacesQuery, PeopleListFiltersSpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PeopleListFiltersSpacesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PeopleListFiltersSpacesQuery, PeopleListFiltersSpacesQueryVariables>(PeopleListFiltersSpacesDocument, options));
        }

export type PeopleListFiltersSpacesQueryResult = ApolloReact.QueryResult<PeopleListFiltersSpacesQuery, PeopleListFiltersSpacesQueryVariables>;
export function refetchPeopleListFiltersSpacesQuery(variables?: PeopleListFiltersSpacesQueryVariables) {
      return { query: PeopleListFiltersSpacesDocument, variables: variables }
    }
export const PeopleListFiltersProjectsDocument = /*#__PURE__*/ gql`
    query PeopleListFilters_Projects($first: Int, $after: Cursor) {
  projects(first: $first, after: $after, sort: {by: ClientName}) {
    ...NfsError
    ... on FSPResponseProject {
      hasNextPage
      edges {
        cursor
        node {
          entityVersion
          id
          name
          clientContract {
            id
            promisor {
              id
              name
              logo
            }
            promisee {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __usePeopleListFiltersProjectsQuery__
 *
 * To run a query within a React component, call `usePeopleListFiltersProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleListFiltersProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleListFiltersProjectsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePeopleListFiltersProjectsQuery(baseOptions?: ApolloReact.QueryHookOptions<PeopleListFiltersProjectsQuery, PeopleListFiltersProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PeopleListFiltersProjectsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PeopleListFiltersProjectsQuery, PeopleListFiltersProjectsQueryVariables>(PeopleListFiltersProjectsDocument, parser(options)));
      }
export function usePeopleListFiltersProjectsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PeopleListFiltersProjectsQuery, PeopleListFiltersProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PeopleListFiltersProjectsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PeopleListFiltersProjectsQuery, PeopleListFiltersProjectsQueryVariables>(PeopleListFiltersProjectsDocument, options));
        }

export type PeopleListFiltersProjectsQueryResult = ApolloReact.QueryResult<PeopleListFiltersProjectsQuery, PeopleListFiltersProjectsQueryVariables>;
export function refetchPeopleListFiltersProjectsQuery(variables?: PeopleListFiltersProjectsQueryVariables) {
      return { query: PeopleListFiltersProjectsDocument, variables: variables }
    }
export const PeopleListReportDrawerMainDocument = /*#__PURE__*/ gql`
    query PeopleListReportDrawer_Main {
  hrSummaryReportMainDocument {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
  hrSummaryReportLimitedDocument {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __usePeopleListReportDrawerMainQuery__
 *
 * To run a query within a React component, call `usePeopleListReportDrawerMainQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleListReportDrawerMainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleListReportDrawerMainQuery({
 *   variables: {
 *   },
 * });
 */
export function usePeopleListReportDrawerMainQuery(baseOptions?: ApolloReact.QueryHookOptions<PeopleListReportDrawerMainQuery, PeopleListReportDrawerMainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PeopleListReportDrawerMainDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PeopleListReportDrawerMainQuery, PeopleListReportDrawerMainQueryVariables>(PeopleListReportDrawerMainDocument, parser(options)));
      }
export function usePeopleListReportDrawerMainLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PeopleListReportDrawerMainQuery, PeopleListReportDrawerMainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PeopleListReportDrawerMainDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PeopleListReportDrawerMainQuery, PeopleListReportDrawerMainQueryVariables>(PeopleListReportDrawerMainDocument, options));
        }

export type PeopleListReportDrawerMainQueryResult = ApolloReact.QueryResult<PeopleListReportDrawerMainQuery, PeopleListReportDrawerMainQueryVariables>;
export function refetchPeopleListReportDrawerMainQuery(variables?: PeopleListReportDrawerMainQueryVariables) {
      return { query: PeopleListReportDrawerMainDocument, variables: variables }
    }
export const PeopleListReportDrawerLimitedDocument = /*#__PURE__*/ gql`
    query PeopleListReportDrawer_Limited {
  hrSummaryReportLimitedDocument {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __usePeopleListReportDrawerLimitedQuery__
 *
 * To run a query within a React component, call `usePeopleListReportDrawerLimitedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleListReportDrawerLimitedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleListReportDrawerLimitedQuery({
 *   variables: {
 *   },
 * });
 */
export function usePeopleListReportDrawerLimitedQuery(baseOptions?: ApolloReact.QueryHookOptions<PeopleListReportDrawerLimitedQuery, PeopleListReportDrawerLimitedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PeopleListReportDrawerLimitedDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PeopleListReportDrawerLimitedQuery, PeopleListReportDrawerLimitedQueryVariables>(PeopleListReportDrawerLimitedDocument, parser(options)));
      }
export function usePeopleListReportDrawerLimitedLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PeopleListReportDrawerLimitedQuery, PeopleListReportDrawerLimitedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PeopleListReportDrawerLimitedDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PeopleListReportDrawerLimitedQuery, PeopleListReportDrawerLimitedQueryVariables>(PeopleListReportDrawerLimitedDocument, options));
        }

export type PeopleListReportDrawerLimitedQueryResult = ApolloReact.QueryResult<PeopleListReportDrawerLimitedQuery, PeopleListReportDrawerLimitedQueryVariables>;
export function refetchPeopleListReportDrawerLimitedQuery(variables?: PeopleListReportDrawerLimitedQueryVariables) {
      return { query: PeopleListReportDrawerLimitedDocument, variables: variables }
    }
export const PeopleListReportDrawerRegenerateDocument = /*#__PURE__*/ gql`
    mutation PeopleListReportDrawer_Regenerate {
  triggerHrSummaryReportBackgroundRegeneration {
    ...NfsError
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __usePeopleListReportDrawerRegenerateMutation__
 *
 * To run a mutation, you first call `usePeopleListReportDrawerRegenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePeopleListReportDrawerRegenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [peopleListReportDrawerRegenerateMutation, { data, loading, error }] = usePeopleListReportDrawerRegenerateMutation({
 *   variables: {
 *   },
 * });
 */
export function usePeopleListReportDrawerRegenerateMutation(baseOptions?: ApolloReact.MutationHookOptions<PeopleListReportDrawerRegenerateMutation, PeopleListReportDrawerRegenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PeopleListReportDrawerRegenerateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<PeopleListReportDrawerRegenerateMutation, PeopleListReportDrawerRegenerateMutationVariables>(PeopleListReportDrawerRegenerateDocument, parser(options)));
      }
export type PeopleListReportDrawerRegenerateMutationHookResult = ReturnType<typeof usePeopleListReportDrawerRegenerateMutation>;
export type PeopleListReportDrawerRegenerateMutationResult = ApolloReact.MutationResult<PeopleListReportDrawerRegenerateMutation>;
export type PeopleListReportDrawerRegenerateMutationOptions = Apollo.MutationOptions<PeopleListReportDrawerRegenerateMutation, PeopleListReportDrawerRegenerateMutationVariables>;
export const PositionDetailsModalDocument = /*#__PURE__*/ gql`
    query PositionDetailsModal($clientContractId: ClientContractId!) {
  clientContract(id: $clientContractId) {
    ...NfsError
    ... on ClientContract {
      ...ClientContractDetails_FutureUpdates
      contractDurationFrom {
        ...Unauthorized
        ... on AccessGranted__LocalDate {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ClientContractDetailsFutureUpdatesFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __usePositionDetailsModalQuery__
 *
 * To run a query within a React component, call `usePositionDetailsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionDetailsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionDetailsModalQuery({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *   },
 * });
 */
export function usePositionDetailsModalQuery(baseOptions: ApolloReact.QueryHookOptions<PositionDetailsModalQuery, PositionDetailsModalQueryVariables> & ({ variables: PositionDetailsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PositionDetailsModalDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PositionDetailsModalQuery, PositionDetailsModalQueryVariables>(PositionDetailsModalDocument, parser(options)));
      }
export function usePositionDetailsModalLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PositionDetailsModalQuery, PositionDetailsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PositionDetailsModalDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PositionDetailsModalQuery, PositionDetailsModalQueryVariables>(PositionDetailsModalDocument, options));
        }

export type PositionDetailsModalQueryResult = ApolloReact.QueryResult<PositionDetailsModalQuery, PositionDetailsModalQueryVariables>;
export function refetchPositionDetailsModalQuery(variables: PositionDetailsModalQueryVariables) {
      return { query: PositionDetailsModalDocument, variables: variables }
    }
export const ProfileUserDocument = /*#__PURE__*/ gql`
    query Profile_User($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      createdAt
      firstName
      middleName
      lastName
      email
      personalDataProcessingAuthorization {
        ...Unauthorized
        ... on AccessGranted__PersonalDataProcessingAuthorization {
          value {
            isAuthorized
            document {
              ...Unauthorized
              ... on AccessGranted__OptionalURI {
                value
              }
            }
          }
        }
      }
      idType {
        ...Unauthorized
        ... on AccessGranted__OptionalIDType {
          value
        }
      }
      idNumber {
        ...Unauthorized
        ... on AccessGranted__OptionalString {
          value
        }
      }
      pesel {
        ...Unauthorized
        ... on AccessGranted__OptionalPESEL {
          value
        }
      }
      citizenship {
        ...Unauthorized
        ... on AccessGranted__OptionalCountryCode {
          value
        }
      }
      birthDate {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
      nextMedicalExaminationDate {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
      nextOhsTrainingDate {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
      isStudent {
        ...Unauthorized
        ... on AccessGranted__Boolean {
          value
        }
      }
      isStudentRevisionDate {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
      emergencyContact {
        ...Unauthorized
        ... on AccessGranted__OptionalString {
          value
        }
      }
      revenueAdministrationOffice {
        ...Unauthorized
        ... on AccessGranted__OptionalRevenueAdministrationOffice {
          value {
            id
            officeName
          }
        }
      }
      directReporting {
        space {
          value {
            ...Profile_Space
          }
          futureUpdates {
            applyDate
            activityId
            value {
              ...Profile_Space
            }
          }
          history {
            applyDate
            activityId
            value {
              ...Profile_Space
            }
          }
        }
      }
      contactEmail {
        ...Unauthorized
        ... on AccessGranted__OptionalEmailAddress {
          value
        }
      }
      phoneNumber {
        ...Unauthorized
        ... on AccessGranted__OptionalPhoneNumber {
          value
        }
      }
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            ... on B2BContract {
              entityVersion
              status
              startDate
              promiseeCompany {
                ...Unauthorized
                ... on AccessGranted__Company {
                  value {
                    id
                    name
                    taxNumber
                    countryOfRegistration
                    address {
                      country
                    }
                  }
                }
              }
            }
          }
        }
      }
      address {
        ...Unauthorized
        ... on AccessGranted__OptionalAddress {
          value {
            ...Address
          }
        }
      }
      mailingAddress {
        ...Unauthorized
        ... on AccessGranted__OptionalAddress {
          value {
            ...Address
          }
        }
      }
      progressionLevel {
        value
        history {
          applyDate
          activityId
          value {
            value
          }
        }
        futureUpdates {
          activityId
          applyDate
          value {
            value
          }
        }
      }
      office {
        officeId
        name
      }
      paczkomat {
        ...Unauthorized
        ... on AccessGranted__OptionalString {
          value
        }
      }
      plateNumber {
        ...Unauthorized
        ... on AccessGranted__OptionalString {
          value
        }
      }
      passportExpirationDate {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
      consentedForUseOfImage
      documentsDirectory {
        ...Unauthorized
        ... on AccessGranted__OptionalURI {
          value
        }
      }
      personalDataProcessingAuthorization {
        ...Unauthorized
        ... on AccessGranted__PersonalDataProcessingAuthorization {
          value {
            isAuthorized
            document {
              ...Unauthorized
              ... on AccessGranted__OptionalURI {
                value
              }
            }
          }
        }
      }
      socialMediaHandles {
        ...Unauthorized
        ... on AccessGranted__ListOfSocialMediaHandle {
          value {
            platform
            handle
          }
        }
      }
      skillsAndCompetences
      declaredNoCertificates
      certificates {
        ...Unauthorized
        ... on AccessGranted__ListOfCertificate {
          value {
            id
            name
            issueDate
            expirationDate
            file {
              downloadUrl
              fileName
              openUrl
            }
          }
        }
      }
      areaOfExpertise
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${ProfileSpaceFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useProfileUserQuery__
 *
 * To run a query within a React component, call `useProfileUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProfileUserQuery(baseOptions: ApolloReact.QueryHookOptions<ProfileUserQuery, ProfileUserQueryVariables> & ({ variables: ProfileUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProfileUserDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProfileUserQuery, ProfileUserQueryVariables>(ProfileUserDocument, parser(options)));
      }
export function useProfileUserLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProfileUserQuery, ProfileUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProfileUserDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProfileUserQuery, ProfileUserQueryVariables>(ProfileUserDocument, options));
        }

export type ProfileUserQueryResult = ApolloReact.QueryResult<ProfileUserQuery, ProfileUserQueryVariables>;
export function refetchProfileUserQuery(variables: ProfileUserQueryVariables) {
      return { query: ProfileUserDocument, variables: variables }
    }
export const ProgressionDetailsDocument = /*#__PURE__*/ gql`
    query ProgressionDetails($contractId: ContractId!, $userId: UserId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        ...ProgressionDetails_Contract
      }
    }
  }
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...ProgressionDetails_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionDetailsContractFragmentDoc}
${ProgressionDetailsUserFragmentDoc}`;

/**
 * __useProgressionDetailsQuery__
 *
 * To run a query within a React component, call `useProgressionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgressionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgressionDetailsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProgressionDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<ProgressionDetailsQuery, ProgressionDetailsQueryVariables> & ({ variables: ProgressionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProgressionDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProgressionDetailsQuery, ProgressionDetailsQueryVariables>(ProgressionDetailsDocument, parser(options)));
      }
export function useProgressionDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProgressionDetailsQuery, ProgressionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProgressionDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProgressionDetailsQuery, ProgressionDetailsQueryVariables>(ProgressionDetailsDocument, options));
        }

export type ProgressionDetailsQueryResult = ApolloReact.QueryResult<ProgressionDetailsQuery, ProgressionDetailsQueryVariables>;
export function refetchProgressionDetailsQuery(variables: ProgressionDetailsQueryVariables) {
      return { query: ProgressionDetailsDocument, variables: variables }
    }
export const ProgressionDetailsDiscardActivitiesDocument = /*#__PURE__*/ gql`
    mutation ProgressionDetails_DiscardActivities($userActivityIds: [ActivityId!]!, $contractActivityIds: [ActivityId!]!, $contractId: ContractId!, $contractEntityVersion: EntityVersion!, $userId: UserId!, $userEntityVersion: EntityVersion!) {
  contract(contractId: $contractId, entityVersion: $contractEntityVersion) {
    cancelActivities(activityIds: $contractActivityIds) {
      ...NfsError
      ... on ContractResponse {
        value {
          ...ProgressionDetails_Contract
        }
      }
    }
  }
  user(userId: $userId, entityVersion: $userEntityVersion) {
    cancelActivities(activityIds: $userActivityIds) {
      ...NfsError
      ... on User {
        ...ProgressionDetails_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionDetailsContractFragmentDoc}
${ProgressionDetailsUserFragmentDoc}`;


/**
 * __useProgressionDetailsDiscardActivitiesMutation__
 *
 * To run a mutation, you first call `useProgressionDetailsDiscardActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgressionDetailsDiscardActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [progressionDetailsDiscardActivitiesMutation, { data, loading, error }] = useProgressionDetailsDiscardActivitiesMutation({
 *   variables: {
 *      userActivityIds: // value for 'userActivityIds'
 *      contractActivityIds: // value for 'contractActivityIds'
 *      contractId: // value for 'contractId'
 *      contractEntityVersion: // value for 'contractEntityVersion'
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *   },
 * });
 */
export function useProgressionDetailsDiscardActivitiesMutation(baseOptions?: ApolloReact.MutationHookOptions<ProgressionDetailsDiscardActivitiesMutation, ProgressionDetailsDiscardActivitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProgressionDetailsDiscardActivitiesDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ProgressionDetailsDiscardActivitiesMutation, ProgressionDetailsDiscardActivitiesMutationVariables>(ProgressionDetailsDiscardActivitiesDocument, parser(options)));
      }
export type ProgressionDetailsDiscardActivitiesMutationHookResult = ReturnType<typeof useProgressionDetailsDiscardActivitiesMutation>;
export type ProgressionDetailsDiscardActivitiesMutationResult = ApolloReact.MutationResult<ProgressionDetailsDiscardActivitiesMutation>;
export type ProgressionDetailsDiscardActivitiesMutationOptions = Apollo.MutationOptions<ProgressionDetailsDiscardActivitiesMutation, ProgressionDetailsDiscardActivitiesMutationVariables>;
export const ProgressionSchemeLevelDrawerLoadDataDocument = /*#__PURE__*/ gql`
    query ProgressionSchemeLevelDrawer_LoadData($schemeId: ProgressionSchemeId!) {
  progressionScheme(progressionSchemeId: $schemeId) {
    ...NfsError
    ... on ProgressionScheme {
      ...ProgressionSchemes_ProgressionScheme
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionSchemesProgressionSchemeFragmentDoc}`;

/**
 * __useProgressionSchemeLevelDrawerLoadDataQuery__
 *
 * To run a query within a React component, call `useProgressionSchemeLevelDrawerLoadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgressionSchemeLevelDrawerLoadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgressionSchemeLevelDrawerLoadDataQuery({
 *   variables: {
 *      schemeId: // value for 'schemeId'
 *   },
 * });
 */
export function useProgressionSchemeLevelDrawerLoadDataQuery(baseOptions: ApolloReact.QueryHookOptions<ProgressionSchemeLevelDrawerLoadDataQuery, ProgressionSchemeLevelDrawerLoadDataQueryVariables> & ({ variables: ProgressionSchemeLevelDrawerLoadDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProgressionSchemeLevelDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProgressionSchemeLevelDrawerLoadDataQuery, ProgressionSchemeLevelDrawerLoadDataQueryVariables>(ProgressionSchemeLevelDrawerLoadDataDocument, parser(options)));
      }
export function useProgressionSchemeLevelDrawerLoadDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProgressionSchemeLevelDrawerLoadDataQuery, ProgressionSchemeLevelDrawerLoadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProgressionSchemeLevelDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProgressionSchemeLevelDrawerLoadDataQuery, ProgressionSchemeLevelDrawerLoadDataQueryVariables>(ProgressionSchemeLevelDrawerLoadDataDocument, options));
        }

export type ProgressionSchemeLevelDrawerLoadDataQueryResult = ApolloReact.QueryResult<ProgressionSchemeLevelDrawerLoadDataQuery, ProgressionSchemeLevelDrawerLoadDataQueryVariables>;
export function refetchProgressionSchemeLevelDrawerLoadDataQuery(variables: ProgressionSchemeLevelDrawerLoadDataQueryVariables) {
      return { query: ProgressionSchemeLevelDrawerLoadDataDocument, variables: variables }
    }
export const ProgressionSchemeLevelDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation ProgressionSchemeLevelDrawer_Update($id: ProgressionSchemeId!, $levels: [ProgressionSchemeLevelInput!]) {
  updateProgressionScheme(id: $id, levels: $levels) {
    ...NfsError
    ... on ProgressionScheme {
      ...ProgressionSchemes_ProgressionScheme
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionSchemesProgressionSchemeFragmentDoc}`;


/**
 * __useProgressionSchemeLevelDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useProgressionSchemeLevelDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgressionSchemeLevelDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [progressionSchemeLevelDrawerUpdateMutation, { data, loading, error }] = useProgressionSchemeLevelDrawerUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      levels: // value for 'levels'
 *   },
 * });
 */
export function useProgressionSchemeLevelDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<ProgressionSchemeLevelDrawerUpdateMutation, ProgressionSchemeLevelDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProgressionSchemeLevelDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ProgressionSchemeLevelDrawerUpdateMutation, ProgressionSchemeLevelDrawerUpdateMutationVariables>(ProgressionSchemeLevelDrawerUpdateDocument, parser(options)));
      }
export type ProgressionSchemeLevelDrawerUpdateMutationHookResult = ReturnType<typeof useProgressionSchemeLevelDrawerUpdateMutation>;
export type ProgressionSchemeLevelDrawerUpdateMutationResult = ApolloReact.MutationResult<ProgressionSchemeLevelDrawerUpdateMutation>;
export type ProgressionSchemeLevelDrawerUpdateMutationOptions = Apollo.MutationOptions<ProgressionSchemeLevelDrawerUpdateMutation, ProgressionSchemeLevelDrawerUpdateMutationVariables>;
export const ProgressionSchemeLevelsUpdateDocument = /*#__PURE__*/ gql`
    mutation ProgressionSchemeLevels_Update($id: ProgressionSchemeId!, $levels: [ProgressionSchemeLevelInput!]) {
  updateProgressionScheme(id: $id, levels: $levels) {
    ...NfsError
    ... on ProgressionScheme {
      ...ProgressionSchemes_ProgressionScheme
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionSchemesProgressionSchemeFragmentDoc}`;


/**
 * __useProgressionSchemeLevelsUpdateMutation__
 *
 * To run a mutation, you first call `useProgressionSchemeLevelsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgressionSchemeLevelsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [progressionSchemeLevelsUpdateMutation, { data, loading, error }] = useProgressionSchemeLevelsUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      levels: // value for 'levels'
 *   },
 * });
 */
export function useProgressionSchemeLevelsUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<ProgressionSchemeLevelsUpdateMutation, ProgressionSchemeLevelsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProgressionSchemeLevelsUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ProgressionSchemeLevelsUpdateMutation, ProgressionSchemeLevelsUpdateMutationVariables>(ProgressionSchemeLevelsUpdateDocument, parser(options)));
      }
export type ProgressionSchemeLevelsUpdateMutationHookResult = ReturnType<typeof useProgressionSchemeLevelsUpdateMutation>;
export type ProgressionSchemeLevelsUpdateMutationResult = ApolloReact.MutationResult<ProgressionSchemeLevelsUpdateMutation>;
export type ProgressionSchemeLevelsUpdateMutationOptions = Apollo.MutationOptions<ProgressionSchemeLevelsUpdateMutation, ProgressionSchemeLevelsUpdateMutationVariables>;
export const ProjectBillablesReportDrawerGenerateDocument = /*#__PURE__*/ gql`
    mutation ProjectBillablesReportDrawer_Generate($projectId: ProjectId!) {
  generateProjectBillablesDocument(projectId: $projectId) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useProjectBillablesReportDrawerGenerateMutation__
 *
 * To run a mutation, you first call `useProjectBillablesReportDrawerGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectBillablesReportDrawerGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectBillablesReportDrawerGenerateMutation, { data, loading, error }] = useProjectBillablesReportDrawerGenerateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectBillablesReportDrawerGenerateMutation(baseOptions?: ApolloReact.MutationHookOptions<ProjectBillablesReportDrawerGenerateMutation, ProjectBillablesReportDrawerGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectBillablesReportDrawerGenerateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ProjectBillablesReportDrawerGenerateMutation, ProjectBillablesReportDrawerGenerateMutationVariables>(ProjectBillablesReportDrawerGenerateDocument, parser(options)));
      }
export type ProjectBillablesReportDrawerGenerateMutationHookResult = ReturnType<typeof useProjectBillablesReportDrawerGenerateMutation>;
export type ProjectBillablesReportDrawerGenerateMutationResult = ApolloReact.MutationResult<ProjectBillablesReportDrawerGenerateMutation>;
export type ProjectBillablesReportDrawerGenerateMutationOptions = Apollo.MutationOptions<ProjectBillablesReportDrawerGenerateMutation, ProjectBillablesReportDrawerGenerateMutationVariables>;
export const ProjectBillablesReportDrawerGoogleDocDocument = /*#__PURE__*/ gql`
    query ProjectBillablesReportDrawer_GoogleDoc($projectId: ProjectId!) {
  projectBillablesDocument(projectId: $projectId) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useProjectBillablesReportDrawerGoogleDocQuery__
 *
 * To run a query within a React component, call `useProjectBillablesReportDrawerGoogleDocQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBillablesReportDrawerGoogleDocQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBillablesReportDrawerGoogleDocQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectBillablesReportDrawerGoogleDocQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectBillablesReportDrawerGoogleDocQuery, ProjectBillablesReportDrawerGoogleDocQueryVariables> & ({ variables: ProjectBillablesReportDrawerGoogleDocQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectBillablesReportDrawerGoogleDocDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectBillablesReportDrawerGoogleDocQuery, ProjectBillablesReportDrawerGoogleDocQueryVariables>(ProjectBillablesReportDrawerGoogleDocDocument, parser(options)));
      }
export function useProjectBillablesReportDrawerGoogleDocLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectBillablesReportDrawerGoogleDocQuery, ProjectBillablesReportDrawerGoogleDocQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectBillablesReportDrawerGoogleDocDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectBillablesReportDrawerGoogleDocQuery, ProjectBillablesReportDrawerGoogleDocQueryVariables>(ProjectBillablesReportDrawerGoogleDocDocument, options));
        }

export type ProjectBillablesReportDrawerGoogleDocQueryResult = ApolloReact.QueryResult<ProjectBillablesReportDrawerGoogleDocQuery, ProjectBillablesReportDrawerGoogleDocQueryVariables>;
export function refetchProjectBillablesReportDrawerGoogleDocQuery(variables: ProjectBillablesReportDrawerGoogleDocQueryVariables) {
      return { query: ProjectBillablesReportDrawerGoogleDocDocument, variables: variables }
    }
export const ProjectCostAndRevenueItemsDocument = /*#__PURE__*/ gql`
    query ProjectCostAndRevenueItems($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      ...ProjectCostAndRevenueItems_Project
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectCostAndRevenueItemsProjectFragmentDoc}`;

/**
 * __useProjectCostAndRevenueItemsQuery__
 *
 * To run a query within a React component, call `useProjectCostAndRevenueItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCostAndRevenueItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCostAndRevenueItemsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectCostAndRevenueItemsQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectCostAndRevenueItemsQuery, ProjectCostAndRevenueItemsQueryVariables> & ({ variables: ProjectCostAndRevenueItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectCostAndRevenueItemsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectCostAndRevenueItemsQuery, ProjectCostAndRevenueItemsQueryVariables>(ProjectCostAndRevenueItemsDocument, parser(options)));
      }
export function useProjectCostAndRevenueItemsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectCostAndRevenueItemsQuery, ProjectCostAndRevenueItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectCostAndRevenueItemsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectCostAndRevenueItemsQuery, ProjectCostAndRevenueItemsQueryVariables>(ProjectCostAndRevenueItemsDocument, options));
        }

export type ProjectCostAndRevenueItemsQueryResult = ApolloReact.QueryResult<ProjectCostAndRevenueItemsQuery, ProjectCostAndRevenueItemsQueryVariables>;
export function refetchProjectCostAndRevenueItemsQuery(variables: ProjectCostAndRevenueItemsQueryVariables) {
      return { query: ProjectCostAndRevenueItemsDocument, variables: variables }
    }
export const ProjectCostAndRevenueItemsUpdateDocument = /*#__PURE__*/ gql`
    mutation ProjectCostAndRevenueItems_Update($projectId: ProjectId!, $entityVersion: EntityVersion!, $costAndRevenueItems: [CostAndRevenueItemInput!]) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    update(costAndRevenueItems: $costAndRevenueItems) {
      ...NfsError
      ... on Project {
        ...ProjectCostAndRevenueItems_Project
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectCostAndRevenueItemsProjectFragmentDoc}`;


/**
 * __useProjectCostAndRevenueItemsUpdateMutation__
 *
 * To run a mutation, you first call `useProjectCostAndRevenueItemsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCostAndRevenueItemsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCostAndRevenueItemsUpdateMutation, { data, loading, error }] = useProjectCostAndRevenueItemsUpdateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      costAndRevenueItems: // value for 'costAndRevenueItems'
 *   },
 * });
 */
export function useProjectCostAndRevenueItemsUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<ProjectCostAndRevenueItemsUpdateMutation, ProjectCostAndRevenueItemsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectCostAndRevenueItemsUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ProjectCostAndRevenueItemsUpdateMutation, ProjectCostAndRevenueItemsUpdateMutationVariables>(ProjectCostAndRevenueItemsUpdateDocument, parser(options)));
      }
export type ProjectCostAndRevenueItemsUpdateMutationHookResult = ReturnType<typeof useProjectCostAndRevenueItemsUpdateMutation>;
export type ProjectCostAndRevenueItemsUpdateMutationResult = ApolloReact.MutationResult<ProjectCostAndRevenueItemsUpdateMutation>;
export type ProjectCostAndRevenueItemsUpdateMutationOptions = Apollo.MutationOptions<ProjectCostAndRevenueItemsUpdateMutation, ProjectCostAndRevenueItemsUpdateMutationVariables>;
export const ProjectCrossSellClearDocument = /*#__PURE__*/ gql`
    mutation ProjectCrossSell_Clear($projectId: ProjectId!, $entityVersion: EntityVersion!) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    update(crossSell: {value: null}) {
      ...NfsError
      ... on Project {
        ...ProjectCrossSell_Project
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectCrossSellProjectFragmentDoc}`;


/**
 * __useProjectCrossSellClearMutation__
 *
 * To run a mutation, you first call `useProjectCrossSellClearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCrossSellClearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCrossSellClearMutation, { data, loading, error }] = useProjectCrossSellClearMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *   },
 * });
 */
export function useProjectCrossSellClearMutation(baseOptions?: ApolloReact.MutationHookOptions<ProjectCrossSellClearMutation, ProjectCrossSellClearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectCrossSellClearDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ProjectCrossSellClearMutation, ProjectCrossSellClearMutationVariables>(ProjectCrossSellClearDocument, parser(options)));
      }
export type ProjectCrossSellClearMutationHookResult = ReturnType<typeof useProjectCrossSellClearMutation>;
export type ProjectCrossSellClearMutationResult = ApolloReact.MutationResult<ProjectCrossSellClearMutation>;
export type ProjectCrossSellClearMutationOptions = Apollo.MutationOptions<ProjectCrossSellClearMutation, ProjectCrossSellClearMutationVariables>;
export const ProjectLeaderFormUserAutocompleteDocument = /*#__PURE__*/ gql`
    query ProjectLeaderForm_UserAutocomplete($after: Cursor, $filter: FilterUserInput!, $sort: SortingRequestSortUserInput, $first: Int!) {
  users(filter: $filter, sort: $sort, first: $first, after: $after) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      edges {
        cursor
        node {
          ...UserAutocomplete_User
          avatar
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserAutocompleteUserFragmentDoc}`;

/**
 * __useProjectLeaderFormUserAutocompleteQuery__
 *
 * To run a query within a React component, call `useProjectLeaderFormUserAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectLeaderFormUserAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectLeaderFormUserAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useProjectLeaderFormUserAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectLeaderFormUserAutocompleteQuery, ProjectLeaderFormUserAutocompleteQueryVariables> & ({ variables: ProjectLeaderFormUserAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectLeaderFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectLeaderFormUserAutocompleteQuery, ProjectLeaderFormUserAutocompleteQueryVariables>(ProjectLeaderFormUserAutocompleteDocument, parser(options)));
      }
export function useProjectLeaderFormUserAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectLeaderFormUserAutocompleteQuery, ProjectLeaderFormUserAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectLeaderFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectLeaderFormUserAutocompleteQuery, ProjectLeaderFormUserAutocompleteQueryVariables>(ProjectLeaderFormUserAutocompleteDocument, options));
        }

export type ProjectLeaderFormUserAutocompleteQueryResult = ApolloReact.QueryResult<ProjectLeaderFormUserAutocompleteQuery, ProjectLeaderFormUserAutocompleteQueryVariables>;
export function refetchProjectLeaderFormUserAutocompleteQuery(variables: ProjectLeaderFormUserAutocompleteQueryVariables) {
      return { query: ProjectLeaderFormUserAutocompleteDocument, variables: variables }
    }
export const ProjectLeaderFormAdditionalInfoDocument = /*#__PURE__*/ gql`
    query ProjectLeaderForm_AdditionalInfo($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      directReporting {
        assignedProjects {
          ...Unauthorized
          ... on AccessGranted__ListOfProjectAssignment {
            value {
              project {
                id
                entityVersion
              }
              user {
                id
                entityVersion
              }
              periods {
                dateRange {
                  from
                  to
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useProjectLeaderFormAdditionalInfoQuery__
 *
 * To run a query within a React component, call `useProjectLeaderFormAdditionalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectLeaderFormAdditionalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectLeaderFormAdditionalInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProjectLeaderFormAdditionalInfoQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectLeaderFormAdditionalInfoQuery, ProjectLeaderFormAdditionalInfoQueryVariables> & ({ variables: ProjectLeaderFormAdditionalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectLeaderFormAdditionalInfoDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectLeaderFormAdditionalInfoQuery, ProjectLeaderFormAdditionalInfoQueryVariables>(ProjectLeaderFormAdditionalInfoDocument, parser(options)));
      }
export function useProjectLeaderFormAdditionalInfoLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectLeaderFormAdditionalInfoQuery, ProjectLeaderFormAdditionalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectLeaderFormAdditionalInfoDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectLeaderFormAdditionalInfoQuery, ProjectLeaderFormAdditionalInfoQueryVariables>(ProjectLeaderFormAdditionalInfoDocument, options));
        }

export type ProjectLeaderFormAdditionalInfoQueryResult = ApolloReact.QueryResult<ProjectLeaderFormAdditionalInfoQuery, ProjectLeaderFormAdditionalInfoQueryVariables>;
export function refetchProjectLeaderFormAdditionalInfoQuery(variables: ProjectLeaderFormAdditionalInfoQueryVariables) {
      return { query: ProjectLeaderFormAdditionalInfoDocument, variables: variables }
    }
export const ProjectMemberFormUserAutocompleteDocument = /*#__PURE__*/ gql`
    query ProjectMemberForm_UserAutocomplete($after: Cursor, $filter: FilterUserInput!, $sort: SortingRequestSortUserInput, $first: Int!) {
  users(filter: $filter, sort: $sort, first: $first, after: $after) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      edges {
        cursor
        node {
          ...UserAutocomplete_User
          avatar
          progressionLevel {
            value
          }
          contracts {
            ...Unauthorized
            ... on AccessGranted__ListOfContract {
              value {
                id
                startDate
                terminationDate
                status
                ... on B2BContract {
                  promisor {
                    value {
                      id
                      name
                    }
                  }
                  promiseeCompany {
                    ...Unauthorized
                    ... on AccessGranted__Company {
                      value {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserAutocompleteUserFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useProjectMemberFormUserAutocompleteQuery__
 *
 * To run a query within a React component, call `useProjectMemberFormUserAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMemberFormUserAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMemberFormUserAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useProjectMemberFormUserAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectMemberFormUserAutocompleteQuery, ProjectMemberFormUserAutocompleteQueryVariables> & ({ variables: ProjectMemberFormUserAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectMemberFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectMemberFormUserAutocompleteQuery, ProjectMemberFormUserAutocompleteQueryVariables>(ProjectMemberFormUserAutocompleteDocument, parser(options)));
      }
export function useProjectMemberFormUserAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectMemberFormUserAutocompleteQuery, ProjectMemberFormUserAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectMemberFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectMemberFormUserAutocompleteQuery, ProjectMemberFormUserAutocompleteQueryVariables>(ProjectMemberFormUserAutocompleteDocument, options));
        }

export type ProjectMemberFormUserAutocompleteQueryResult = ApolloReact.QueryResult<ProjectMemberFormUserAutocompleteQuery, ProjectMemberFormUserAutocompleteQueryVariables>;
export function refetchProjectMemberFormUserAutocompleteQuery(variables: ProjectMemberFormUserAutocompleteQueryVariables) {
      return { query: ProjectMemberFormUserAutocompleteDocument, variables: variables }
    }
export const ProjectMemberFormIntraCompanyContractsDocument = /*#__PURE__*/ gql`
    query ProjectMemberForm_IntraCompanyContracts($promisorId: CompanyId!, $promiseeId: CompanyId!) {
  clientContractsBetweenCompanies(
    promisorId: $promisorId
    promiseeId: $promiseeId
  ) {
    ...NfsError
    ... on ListOfClientContractResponse {
      value {
        ...ProjectMembersDrawer_ClientContract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectMembersDrawerClientContractFragmentDoc}`;

/**
 * __useProjectMemberFormIntraCompanyContractsQuery__
 *
 * To run a query within a React component, call `useProjectMemberFormIntraCompanyContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMemberFormIntraCompanyContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMemberFormIntraCompanyContractsQuery({
 *   variables: {
 *      promisorId: // value for 'promisorId'
 *      promiseeId: // value for 'promiseeId'
 *   },
 * });
 */
export function useProjectMemberFormIntraCompanyContractsQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectMemberFormIntraCompanyContractsQuery, ProjectMemberFormIntraCompanyContractsQueryVariables> & ({ variables: ProjectMemberFormIntraCompanyContractsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectMemberFormIntraCompanyContractsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectMemberFormIntraCompanyContractsQuery, ProjectMemberFormIntraCompanyContractsQueryVariables>(ProjectMemberFormIntraCompanyContractsDocument, parser(options)));
      }
export function useProjectMemberFormIntraCompanyContractsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectMemberFormIntraCompanyContractsQuery, ProjectMemberFormIntraCompanyContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectMemberFormIntraCompanyContractsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectMemberFormIntraCompanyContractsQuery, ProjectMemberFormIntraCompanyContractsQueryVariables>(ProjectMemberFormIntraCompanyContractsDocument, options));
        }

export type ProjectMemberFormIntraCompanyContractsQueryResult = ApolloReact.QueryResult<ProjectMemberFormIntraCompanyContractsQuery, ProjectMemberFormIntraCompanyContractsQueryVariables>;
export function refetchProjectMemberFormIntraCompanyContractsQuery(variables: ProjectMemberFormIntraCompanyContractsQueryVariables) {
      return { query: ProjectMemberFormIntraCompanyContractsDocument, variables: variables }
    }
export const ProjectMemberFormUserDetailsDocument = /*#__PURE__*/ gql`
    query ProjectMemberForm_UserDetails($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      firstName
      lastName
      avatar
      progressionLevel {
        value
      }
      directReporting {
        assignedProjects {
          ...Unauthorized
          ... on AccessGranted__ListOfProjectAssignment {
            value {
              project {
                id
              }
              user {
                id
              }
              periods {
                dateRange {
                  from
                  to
                }
                clientPosition {
                  ...Unauthorized
                  ... on AccessGranted__ClientPosition {
                    value {
                      id
                      name
                    }
                  }
                }
                subcontractPosition {
                  ...Unauthorized
                  ... on AccessGranted__OptionalClientPosition {
                    value {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            status
            startDate
            terminationDate
            promisor {
              value {
                id
                name
              }
            }
            ... on B2BContract {
              promiseeCompany {
                ...Unauthorized
                ... on AccessGranted__Company {
                  value {
                    id
                  }
                }
              }
            }
            ... on Subcontract {
              clientContract {
                ...Unauthorized
                ... on AccessGranted__ClientContract {
                  value {
                    ...ProjectMembersDrawer_ClientContract
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${ProjectMembersDrawerClientContractFragmentDoc}`;

/**
 * __useProjectMemberFormUserDetailsQuery__
 *
 * To run a query within a React component, call `useProjectMemberFormUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMemberFormUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMemberFormUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProjectMemberFormUserDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectMemberFormUserDetailsQuery, ProjectMemberFormUserDetailsQueryVariables> & ({ variables: ProjectMemberFormUserDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectMemberFormUserDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectMemberFormUserDetailsQuery, ProjectMemberFormUserDetailsQueryVariables>(ProjectMemberFormUserDetailsDocument, parser(options)));
      }
export function useProjectMemberFormUserDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectMemberFormUserDetailsQuery, ProjectMemberFormUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectMemberFormUserDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectMemberFormUserDetailsQuery, ProjectMemberFormUserDetailsQueryVariables>(ProjectMemberFormUserDetailsDocument, options));
        }

export type ProjectMemberFormUserDetailsQueryResult = ApolloReact.QueryResult<ProjectMemberFormUserDetailsQuery, ProjectMemberFormUserDetailsQueryVariables>;
export function refetchProjectMemberFormUserDetailsQuery(variables: ProjectMemberFormUserDetailsQueryVariables) {
      return { query: ProjectMemberFormUserDetailsDocument, variables: variables }
    }
export const ProjectMembersDocument = /*#__PURE__*/ gql`
    query ProjectMembers($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      id
      entityVersion
      assignedUsers {
        project {
          id
        }
        user {
          id
          entityVersion
          avatar
          firstName
          lastName
          email
          progressionLevel {
            value
          }
        }
        periods {
          dateRange {
            from
            to
          }
          clientPosition {
            ...Unauthorized
            ... on AccessGranted__ClientPosition {
              value {
                id
                name
                currency {
                  value
                }
                rateNet {
                  value {
                    daily
                  }
                }
              }
            }
          }
          subcontractPosition {
            ...Unauthorized
            ... on AccessGranted__OptionalClientPosition {
              value {
                id
                name
                currency {
                  value
                }
                rateNet {
                  value {
                    daily
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useProjectMembersQuery__
 *
 * To run a query within a React component, call `useProjectMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMembersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectMembersQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables> & ({ variables: ProjectMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectMembersDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectMembersQuery, ProjectMembersQueryVariables>(ProjectMembersDocument, parser(options)));
      }
export function useProjectMembersLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectMembersDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectMembersQuery, ProjectMembersQueryVariables>(ProjectMembersDocument, options));
        }

export type ProjectMembersQueryResult = ApolloReact.QueryResult<ProjectMembersQuery, ProjectMembersQueryVariables>;
export function refetchProjectMembersQuery(variables: ProjectMembersQueryVariables) {
      return { query: ProjectMembersDocument, variables: variables }
    }
export const ProjectMembersDrawerMembersDocument = /*#__PURE__*/ gql`
    query ProjectMembersDrawer_Members($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      id
      entityVersion
      name
      createdAt
      statusHistory {
        status
        dateRange {
          from
          to
        }
      }
      assignedUsers {
        ...ProjectMembersDrawer_ProjectAssignment
      }
      clientContract {
        id
        entityVersion
        contractDurationFrom {
          ...Unauthorized
          ... on AccessGranted__LocalDate {
            value
          }
        }
        contractDurationTo {
          ...Unauthorized
          ... on AccessGranted__OptionalLocalDate {
            value
          }
        }
        name {
          ...Unauthorized
          ... on AccessGranted__String {
            value
          }
        }
        currency {
          ...Unauthorized
          ... on AccessGranted__TimeBasedOptCurrency {
            value {
              value
            }
          }
        }
        vat {
          ...Unauthorized
          ... on AccessGranted__TimeBasedOptClearableBasisPoint {
            value {
              value
            }
          }
        }
        positions {
          ...Unauthorized
          ... on AccessGranted__ListOfClientPosition {
            value {
              id
              name
              active {
                value
                futureUpdates {
                  activityId
                  value
                  applyDate
                }
                history {
                  activityId
                  value
                  applyDate
                }
              }
            }
          }
        }
        promisor {
          id
          name
          entityVersion
        }
        promisee {
          id
          name
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectMembersDrawerProjectAssignmentFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useProjectMembersDrawerMembersQuery__
 *
 * To run a query within a React component, call `useProjectMembersDrawerMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMembersDrawerMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMembersDrawerMembersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectMembersDrawerMembersQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectMembersDrawerMembersQuery, ProjectMembersDrawerMembersQueryVariables> & ({ variables: ProjectMembersDrawerMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectMembersDrawerMembersDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectMembersDrawerMembersQuery, ProjectMembersDrawerMembersQueryVariables>(ProjectMembersDrawerMembersDocument, parser(options)));
      }
export function useProjectMembersDrawerMembersLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectMembersDrawerMembersQuery, ProjectMembersDrawerMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectMembersDrawerMembersDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectMembersDrawerMembersQuery, ProjectMembersDrawerMembersQueryVariables>(ProjectMembersDrawerMembersDocument, options));
        }

export type ProjectMembersDrawerMembersQueryResult = ApolloReact.QueryResult<ProjectMembersDrawerMembersQuery, ProjectMembersDrawerMembersQueryVariables>;
export function refetchProjectMembersDrawerMembersQuery(variables: ProjectMembersDrawerMembersQueryVariables) {
      return { query: ProjectMembersDrawerMembersDocument, variables: variables }
    }
export const ProjectMembersDrawerUpdateAssignmentDocument = /*#__PURE__*/ gql`
    mutation ProjectMembersDrawer_UpdateAssignment($projectId: ProjectId!, $entityVersion: EntityVersion!, $state: CreateProjectAssignmentInput!) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    projectAssignments {
      upsertProjectAssignment(input: $state) {
        ...NfsError
        ... on ProjectAssignment {
          ...ProjectMembersDrawer_ProjectAssignment
          project {
            ...ProjectLead
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectMembersDrawerProjectAssignmentFragmentDoc}
${ProjectLeadFragmentDoc}`;


/**
 * __useProjectMembersDrawerUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useProjectMembersDrawerUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectMembersDrawerUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectMembersDrawerUpdateAssignmentMutation, { data, loading, error }] = useProjectMembersDrawerUpdateAssignmentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useProjectMembersDrawerUpdateAssignmentMutation(baseOptions?: ApolloReact.MutationHookOptions<ProjectMembersDrawerUpdateAssignmentMutation, ProjectMembersDrawerUpdateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectMembersDrawerUpdateAssignmentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ProjectMembersDrawerUpdateAssignmentMutation, ProjectMembersDrawerUpdateAssignmentMutationVariables>(ProjectMembersDrawerUpdateAssignmentDocument, parser(options)));
      }
export type ProjectMembersDrawerUpdateAssignmentMutationHookResult = ReturnType<typeof useProjectMembersDrawerUpdateAssignmentMutation>;
export type ProjectMembersDrawerUpdateAssignmentMutationResult = ApolloReact.MutationResult<ProjectMembersDrawerUpdateAssignmentMutation>;
export type ProjectMembersDrawerUpdateAssignmentMutationOptions = Apollo.MutationOptions<ProjectMembersDrawerUpdateAssignmentMutation, ProjectMembersDrawerUpdateAssignmentMutationVariables>;
export const ProjectMembersDrawerUpdateInternalAssignmentDocument = /*#__PURE__*/ gql`
    mutation ProjectMembersDrawer_UpdateInternalAssignment($projectId: ProjectId!, $entityVersion: EntityVersion!, $state: CreateInternalProjectAssignmentInput!) {
  internalProject(projectId: $projectId, entityVersion: $entityVersion) {
    upsertInternalProjectAssignment(input: $state) {
      ...NfsError
      ... on ProjectAssignment {
        ...ProjectMembersDrawer_ProjectAssignment
        project {
          ...ProjectLead
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectMembersDrawerProjectAssignmentFragmentDoc}
${ProjectLeadFragmentDoc}`;


/**
 * __useProjectMembersDrawerUpdateInternalAssignmentMutation__
 *
 * To run a mutation, you first call `useProjectMembersDrawerUpdateInternalAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectMembersDrawerUpdateInternalAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectMembersDrawerUpdateInternalAssignmentMutation, { data, loading, error }] = useProjectMembersDrawerUpdateInternalAssignmentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useProjectMembersDrawerUpdateInternalAssignmentMutation(baseOptions?: ApolloReact.MutationHookOptions<ProjectMembersDrawerUpdateInternalAssignmentMutation, ProjectMembersDrawerUpdateInternalAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectMembersDrawerUpdateInternalAssignmentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ProjectMembersDrawerUpdateInternalAssignmentMutation, ProjectMembersDrawerUpdateInternalAssignmentMutationVariables>(ProjectMembersDrawerUpdateInternalAssignmentDocument, parser(options)));
      }
export type ProjectMembersDrawerUpdateInternalAssignmentMutationHookResult = ReturnType<typeof useProjectMembersDrawerUpdateInternalAssignmentMutation>;
export type ProjectMembersDrawerUpdateInternalAssignmentMutationResult = ApolloReact.MutationResult<ProjectMembersDrawerUpdateInternalAssignmentMutation>;
export type ProjectMembersDrawerUpdateInternalAssignmentMutationOptions = Apollo.MutationOptions<ProjectMembersDrawerUpdateInternalAssignmentMutation, ProjectMembersDrawerUpdateInternalAssignmentMutationVariables>;
export const ProjectMembersDrawerRemoveAssignmentDocument = /*#__PURE__*/ gql`
    mutation ProjectMembersDrawer_RemoveAssignment($projectId: ProjectId!, $entityVersion: EntityVersion!, $userId: UserId!) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    projectAssignments {
      deleteProjectAssignment(value: $userId) {
        ...NfsError
        ... on UnitResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useProjectMembersDrawerRemoveAssignmentMutation__
 *
 * To run a mutation, you first call `useProjectMembersDrawerRemoveAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectMembersDrawerRemoveAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectMembersDrawerRemoveAssignmentMutation, { data, loading, error }] = useProjectMembersDrawerRemoveAssignmentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProjectMembersDrawerRemoveAssignmentMutation(baseOptions?: ApolloReact.MutationHookOptions<ProjectMembersDrawerRemoveAssignmentMutation, ProjectMembersDrawerRemoveAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectMembersDrawerRemoveAssignmentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ProjectMembersDrawerRemoveAssignmentMutation, ProjectMembersDrawerRemoveAssignmentMutationVariables>(ProjectMembersDrawerRemoveAssignmentDocument, parser(options)));
      }
export type ProjectMembersDrawerRemoveAssignmentMutationHookResult = ReturnType<typeof useProjectMembersDrawerRemoveAssignmentMutation>;
export type ProjectMembersDrawerRemoveAssignmentMutationResult = ApolloReact.MutationResult<ProjectMembersDrawerRemoveAssignmentMutation>;
export type ProjectMembersDrawerRemoveAssignmentMutationOptions = Apollo.MutationOptions<ProjectMembersDrawerRemoveAssignmentMutation, ProjectMembersDrawerRemoveAssignmentMutationVariables>;
export const ProjectsAndActivitiesDocument = /*#__PURE__*/ gql`
    query ProjectsAndActivities($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      createdAt
      firstName
      lastName
      progressionLevel {
        value
      }
      directReporting {
        space {
          value {
            ...ProjectsAndActivities_Space
          }
          history {
            value {
              ...ProjectsAndActivities_Space
            }
            applyDate
            activityId
          }
          futureUpdates {
            value {
              ...ProjectsAndActivities_Space
            }
            applyDate
            activityId
          }
        }
        assignedProjects(orderByFirstPositionStartDate: Desc) {
          ...Unauthorized
          ... on AccessGranted__ListOfProjectAssignment {
            value {
              user {
                id
              }
              project {
                id
                name
                clientContract {
                  id
                  promisor {
                    id
                    name
                  }
                }
                lead {
                  project {
                    id
                  }
                  periods {
                    dateRange {
                      from
                      to
                    }
                    user {
                      id
                      firstName
                      lastName
                      email
                      avatar
                      role {
                        value
                      }
                    }
                  }
                }
              }
              periods {
                dateRange {
                  from
                  to
                }
                clientPosition {
                  ...Unauthorized
                  ... on AccessGranted__ClientPosition {
                    value {
                      ...ProjectsAndActivities_ClientPosition
                    }
                  }
                }
                subcontractPosition {
                  ...Unauthorized
                  ... on AccessGranted__OptionalClientPosition {
                    value {
                      ...ProjectsAndActivities_ClientPosition
                    }
                  }
                }
              }
            }
          }
        }
      }
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            status
            startDate
            ... on Subcontract {
              clientContract {
                ...Unauthorized
                ... on AccessGranted__ClientContract {
                  value {
                    id
                    promisor {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  users(
    filter: {activityStatus_eq: true, lead_oneOf: [$userId]}
    sort: {by: Name, order: Asc}
  ) {
    ...NfsError
    ... on FSPResponseUser {
      edges {
        node {
          id
          entityVersion
          firstName
          lastName
          email
          avatar
          role {
            value
          }
          directReporting {
            operationalLead {
              value {
                id
              }
            }
            practiceLead {
              value {
                id
              }
            }
            space {
              value {
                id
                owner {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectsAndActivitiesSpaceFragmentDoc}
${UnauthorizedFragmentDoc}
${ProjectsAndActivitiesClientPositionFragmentDoc}`;

/**
 * __useProjectsAndActivitiesQuery__
 *
 * To run a query within a React component, call `useProjectsAndActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsAndActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsAndActivitiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProjectsAndActivitiesQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectsAndActivitiesQuery, ProjectsAndActivitiesQueryVariables> & ({ variables: ProjectsAndActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectsAndActivitiesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectsAndActivitiesQuery, ProjectsAndActivitiesQueryVariables>(ProjectsAndActivitiesDocument, parser(options)));
      }
export function useProjectsAndActivitiesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectsAndActivitiesQuery, ProjectsAndActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectsAndActivitiesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectsAndActivitiesQuery, ProjectsAndActivitiesQueryVariables>(ProjectsAndActivitiesDocument, options));
        }

export type ProjectsAndActivitiesQueryResult = ApolloReact.QueryResult<ProjectsAndActivitiesQuery, ProjectsAndActivitiesQueryVariables>;
export function refetchProjectsAndActivitiesQuery(variables: ProjectsAndActivitiesQueryVariables) {
      return { query: ProjectsAndActivitiesDocument, variables: variables }
    }
export const ProjectListFiltersClientsDocument = /*#__PURE__*/ gql`
    query ProjectListFilters_Clients($first: Int, $after: Cursor) {
  companies(first: $first, after: $after, filter: {companyType_oneOf: [Client]}) {
    ...NfsError
    ... on FSPResponseCompany {
      hasNextPage
      edges {
        cursor
        node {
          entityVersion
          id
          name
          logo
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useProjectListFiltersClientsQuery__
 *
 * To run a query within a React component, call `useProjectListFiltersClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectListFiltersClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectListFiltersClientsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProjectListFiltersClientsQuery(baseOptions?: ApolloReact.QueryHookOptions<ProjectListFiltersClientsQuery, ProjectListFiltersClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectListFiltersClientsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectListFiltersClientsQuery, ProjectListFiltersClientsQueryVariables>(ProjectListFiltersClientsDocument, parser(options)));
      }
export function useProjectListFiltersClientsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectListFiltersClientsQuery, ProjectListFiltersClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectListFiltersClientsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectListFiltersClientsQuery, ProjectListFiltersClientsQueryVariables>(ProjectListFiltersClientsDocument, options));
        }

export type ProjectListFiltersClientsQueryResult = ApolloReact.QueryResult<ProjectListFiltersClientsQuery, ProjectListFiltersClientsQueryVariables>;
export function refetchProjectListFiltersClientsQuery(variables?: ProjectListFiltersClientsQueryVariables) {
      return { query: ProjectListFiltersClientsDocument, variables: variables }
    }
export const ProjectListFiltersSpacesDocument = /*#__PURE__*/ gql`
    query ProjectListFilters_Spaces($first: Int, $after: Cursor) {
  spaces(first: $first, after: $after) {
    ...NfsError
    ... on FSPResponseSpace {
      hasNextPage
      edges {
        cursor
        node {
          entityVersion
          id
          name
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useProjectListFiltersSpacesQuery__
 *
 * To run a query within a React component, call `useProjectListFiltersSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectListFiltersSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectListFiltersSpacesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProjectListFiltersSpacesQuery(baseOptions?: ApolloReact.QueryHookOptions<ProjectListFiltersSpacesQuery, ProjectListFiltersSpacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectListFiltersSpacesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectListFiltersSpacesQuery, ProjectListFiltersSpacesQueryVariables>(ProjectListFiltersSpacesDocument, parser(options)));
      }
export function useProjectListFiltersSpacesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectListFiltersSpacesQuery, ProjectListFiltersSpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectListFiltersSpacesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectListFiltersSpacesQuery, ProjectListFiltersSpacesQueryVariables>(ProjectListFiltersSpacesDocument, options));
        }

export type ProjectListFiltersSpacesQueryResult = ApolloReact.QueryResult<ProjectListFiltersSpacesQuery, ProjectListFiltersSpacesQueryVariables>;
export function refetchProjectListFiltersSpacesQuery(variables?: ProjectListFiltersSpacesQueryVariables) {
      return { query: ProjectListFiltersSpacesDocument, variables: variables }
    }
export const RateCardDrawerLoadDataDocument = /*#__PURE__*/ gql`
    query RateCardDrawer_LoadData($id: ClientContractId!, $at: OffsetDateTime) {
  clientContract(id: $id, at: $at) {
    ...NfsError
    ... on ClientContract {
      at
      ...RateCardDrawer_ClientContractTimeBased
    }
  }
  reportingPeriods(clientContractId: $id) {
    ...NfsError
    ... on ListOfReportingPeriodResponse {
      value {
        id
        from
        to
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${RateCardDrawerClientContractTimeBasedFragmentDoc}`;

/**
 * __useRateCardDrawerLoadDataQuery__
 *
 * To run a query within a React component, call `useRateCardDrawerLoadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRateCardDrawerLoadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRateCardDrawerLoadDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      at: // value for 'at'
 *   },
 * });
 */
export function useRateCardDrawerLoadDataQuery(baseOptions: ApolloReact.QueryHookOptions<RateCardDrawerLoadDataQuery, RateCardDrawerLoadDataQueryVariables> & ({ variables: RateCardDrawerLoadDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RateCardDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RateCardDrawerLoadDataQuery, RateCardDrawerLoadDataQueryVariables>(RateCardDrawerLoadDataDocument, parser(options)));
      }
export function useRateCardDrawerLoadDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RateCardDrawerLoadDataQuery, RateCardDrawerLoadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RateCardDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RateCardDrawerLoadDataQuery, RateCardDrawerLoadDataQueryVariables>(RateCardDrawerLoadDataDocument, options));
        }

export type RateCardDrawerLoadDataQueryResult = ApolloReact.QueryResult<RateCardDrawerLoadDataQuery, RateCardDrawerLoadDataQueryVariables>;
export function refetchRateCardDrawerLoadDataQuery(variables: RateCardDrawerLoadDataQueryVariables) {
      return { query: RateCardDrawerLoadDataDocument, variables: variables }
    }
export const RateCardDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation RateCardDrawer_Update($at: Date!, $id: ClientContractId!, $entityVersion: EntityVersion!, $vat: BasisPoint, $currency: Currency!, $positions: [ClientPositionInput!]!) {
  clientContract(id: $id, entityVersion: $entityVersion) {
    setManDayRates(at: $at, vat: $vat, currency: $currency, positions: $positions) {
      ...NfsError
      ... on ClientContract {
        ...RateCardDrawer_ClientContract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${RateCardDrawerClientContractFragmentDoc}`;


/**
 * __useRateCardDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useRateCardDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateCardDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateCardDrawerUpdateMutation, { data, loading, error }] = useRateCardDrawerUpdateMutation({
 *   variables: {
 *      at: // value for 'at'
 *      id: // value for 'id'
 *      entityVersion: // value for 'entityVersion'
 *      vat: // value for 'vat'
 *      currency: // value for 'currency'
 *      positions: // value for 'positions'
 *   },
 * });
 */
export function useRateCardDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<RateCardDrawerUpdateMutation, RateCardDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RateCardDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<RateCardDrawerUpdateMutation, RateCardDrawerUpdateMutationVariables>(RateCardDrawerUpdateDocument, parser(options)));
      }
export type RateCardDrawerUpdateMutationHookResult = ReturnType<typeof useRateCardDrawerUpdateMutation>;
export type RateCardDrawerUpdateMutationResult = ApolloReact.MutationResult<RateCardDrawerUpdateMutation>;
export type RateCardDrawerUpdateMutationOptions = Apollo.MutationOptions<RateCardDrawerUpdateMutation, RateCardDrawerUpdateMutationVariables>;
export const RatesChangesReportDrawerDocument = /*#__PURE__*/ gql`
    query RatesChangesReportDrawer {
  rateChangeEventSummaryReport {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useRatesChangesReportDrawerQuery__
 *
 * To run a query within a React component, call `useRatesChangesReportDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatesChangesReportDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatesChangesReportDrawerQuery({
 *   variables: {
 *   },
 * });
 */
export function useRatesChangesReportDrawerQuery(baseOptions?: ApolloReact.QueryHookOptions<RatesChangesReportDrawerQuery, RatesChangesReportDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RatesChangesReportDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RatesChangesReportDrawerQuery, RatesChangesReportDrawerQueryVariables>(RatesChangesReportDrawerDocument, parser(options)));
      }
export function useRatesChangesReportDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RatesChangesReportDrawerQuery, RatesChangesReportDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RatesChangesReportDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RatesChangesReportDrawerQuery, RatesChangesReportDrawerQueryVariables>(RatesChangesReportDrawerDocument, options));
        }

export type RatesChangesReportDrawerQueryResult = ApolloReact.QueryResult<RatesChangesReportDrawerQuery, RatesChangesReportDrawerQueryVariables>;
export function refetchRatesChangesReportDrawerQuery(variables?: RatesChangesReportDrawerQueryVariables) {
      return { query: RatesChangesReportDrawerDocument, variables: variables }
    }
export const RatesChangesReportDrawerRegenerateDocument = /*#__PURE__*/ gql`
    mutation RatesChangesReportDrawer_Regenerate {
  generateRateChangeEventSummaryReport {
    ...NfsError
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useRatesChangesReportDrawerRegenerateMutation__
 *
 * To run a mutation, you first call `useRatesChangesReportDrawerRegenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRatesChangesReportDrawerRegenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ratesChangesReportDrawerRegenerateMutation, { data, loading, error }] = useRatesChangesReportDrawerRegenerateMutation({
 *   variables: {
 *   },
 * });
 */
export function useRatesChangesReportDrawerRegenerateMutation(baseOptions?: ApolloReact.MutationHookOptions<RatesChangesReportDrawerRegenerateMutation, RatesChangesReportDrawerRegenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RatesChangesReportDrawerRegenerateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<RatesChangesReportDrawerRegenerateMutation, RatesChangesReportDrawerRegenerateMutationVariables>(RatesChangesReportDrawerRegenerateDocument, parser(options)));
      }
export type RatesChangesReportDrawerRegenerateMutationHookResult = ReturnType<typeof useRatesChangesReportDrawerRegenerateMutation>;
export type RatesChangesReportDrawerRegenerateMutationResult = ApolloReact.MutationResult<RatesChangesReportDrawerRegenerateMutation>;
export type RatesChangesReportDrawerRegenerateMutationOptions = Apollo.MutationOptions<RatesChangesReportDrawerRegenerateMutation, RatesChangesReportDrawerRegenerateMutationVariables>;
export const RejectOfficeReservationModalRejectDocument = /*#__PURE__*/ gql`
    mutation RejectOfficeReservationModal_Reject($requestId: ReservationRequestId!, $comment: String) {
  rejectOfficeReservation(requestId: $requestId, comment: $comment) {
    ...NfsError
    ... on ReservationRequest {
      requestId
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useRejectOfficeReservationModalRejectMutation__
 *
 * To run a mutation, you first call `useRejectOfficeReservationModalRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectOfficeReservationModalRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectOfficeReservationModalRejectMutation, { data, loading, error }] = useRejectOfficeReservationModalRejectMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRejectOfficeReservationModalRejectMutation(baseOptions?: ApolloReact.MutationHookOptions<RejectOfficeReservationModalRejectMutation, RejectOfficeReservationModalRejectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RejectOfficeReservationModalRejectDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<RejectOfficeReservationModalRejectMutation, RejectOfficeReservationModalRejectMutationVariables>(RejectOfficeReservationModalRejectDocument, parser(options)));
      }
export type RejectOfficeReservationModalRejectMutationHookResult = ReturnType<typeof useRejectOfficeReservationModalRejectMutation>;
export type RejectOfficeReservationModalRejectMutationResult = ApolloReact.MutationResult<RejectOfficeReservationModalRejectMutation>;
export type RejectOfficeReservationModalRejectMutationOptions = Apollo.MutationOptions<RejectOfficeReservationModalRejectMutation, RejectOfficeReservationModalRejectMutationVariables>;
export const RelatedProjectAssignmentsContractDocument = /*#__PURE__*/ gql`
    query RelatedProjectAssignments_Contract($clientContractId: ClientContractId!) {
  clientContract(id: $clientContractId) {
    ...NfsError
    ... on ClientContract {
      id
      promisor {
        id
      }
      promisee {
        id
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useRelatedProjectAssignmentsContractQuery__
 *
 * To run a query within a React component, call `useRelatedProjectAssignmentsContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedProjectAssignmentsContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedProjectAssignmentsContractQuery({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *   },
 * });
 */
export function useRelatedProjectAssignmentsContractQuery(baseOptions: ApolloReact.QueryHookOptions<RelatedProjectAssignmentsContractQuery, RelatedProjectAssignmentsContractQueryVariables> & ({ variables: RelatedProjectAssignmentsContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RelatedProjectAssignmentsContractDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RelatedProjectAssignmentsContractQuery, RelatedProjectAssignmentsContractQueryVariables>(RelatedProjectAssignmentsContractDocument, parser(options)));
      }
export function useRelatedProjectAssignmentsContractLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RelatedProjectAssignmentsContractQuery, RelatedProjectAssignmentsContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RelatedProjectAssignmentsContractDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RelatedProjectAssignmentsContractQuery, RelatedProjectAssignmentsContractQueryVariables>(RelatedProjectAssignmentsContractDocument, options));
        }

export type RelatedProjectAssignmentsContractQueryResult = ApolloReact.QueryResult<RelatedProjectAssignmentsContractQuery, RelatedProjectAssignmentsContractQueryVariables>;
export function refetchRelatedProjectAssignmentsContractQuery(variables: RelatedProjectAssignmentsContractQueryVariables) {
      return { query: RelatedProjectAssignmentsContractDocument, variables: variables }
    }
export const RelatedProjectAssignmentsDocument = /*#__PURE__*/ gql`
    query RelatedProjectAssignments($client: CompanyId!, $supplier: CompanyId!) {
  resolveSubcontractRelatedProjectAssignments(
    client: $client
    supplier: $supplier
  ) {
    ...NfsError
    ... on ListOfProjectAssignmentResponse {
      value {
        user {
          id
          avatar
          firstName
          lastName
          email
        }
        project {
          id
          entityVersion
          name
        }
        periods {
          dateRange {
            from
            to
          }
          clientPosition {
            ...Unauthorized
            ... on AccessGranted__ClientPosition {
              value {
                id
                name
                currency {
                  value
                }
                rateNet {
                  value {
                    daily
                  }
                }
              }
            }
          }
          subcontractPosition {
            ...Unauthorized
            ... on AccessGranted__OptionalClientPosition {
              value {
                id
                name
                currency {
                  value
                }
                rateNet {
                  value {
                    daily
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useRelatedProjectAssignmentsQuery__
 *
 * To run a query within a React component, call `useRelatedProjectAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedProjectAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedProjectAssignmentsQuery({
 *   variables: {
 *      client: // value for 'client'
 *      supplier: // value for 'supplier'
 *   },
 * });
 */
export function useRelatedProjectAssignmentsQuery(baseOptions: ApolloReact.QueryHookOptions<RelatedProjectAssignmentsQuery, RelatedProjectAssignmentsQueryVariables> & ({ variables: RelatedProjectAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RelatedProjectAssignmentsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RelatedProjectAssignmentsQuery, RelatedProjectAssignmentsQueryVariables>(RelatedProjectAssignmentsDocument, parser(options)));
      }
export function useRelatedProjectAssignmentsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RelatedProjectAssignmentsQuery, RelatedProjectAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RelatedProjectAssignmentsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RelatedProjectAssignmentsQuery, RelatedProjectAssignmentsQueryVariables>(RelatedProjectAssignmentsDocument, options));
        }

export type RelatedProjectAssignmentsQueryResult = ApolloReact.QueryResult<RelatedProjectAssignmentsQuery, RelatedProjectAssignmentsQueryVariables>;
export function refetchRelatedProjectAssignmentsQuery(variables: RelatedProjectAssignmentsQueryVariables) {
      return { query: RelatedProjectAssignmentsDocument, variables: variables }
    }
export const RequestTimeReportFillDocument = /*#__PURE__*/ gql`
    mutation RequestTimeReportFill($filter: FilterContractSalaryDetailsInput!, $yearMonth: YearMonth!, $validUntil: OffsetDateTime!) {
  createTemporaryEditPermissionsForSpaceOwners(
    filter: $filter
    yearMonth: $yearMonth
    validUntil: $validUntil
  ) {
    ...NfsError
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useRequestTimeReportFillMutation__
 *
 * To run a mutation, you first call `useRequestTimeReportFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTimeReportFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTimeReportFillMutation, { data, loading, error }] = useRequestTimeReportFillMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      yearMonth: // value for 'yearMonth'
 *      validUntil: // value for 'validUntil'
 *   },
 * });
 */
export function useRequestTimeReportFillMutation(baseOptions?: ApolloReact.MutationHookOptions<RequestTimeReportFillMutation, RequestTimeReportFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RequestTimeReportFillDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<RequestTimeReportFillMutation, RequestTimeReportFillMutationVariables>(RequestTimeReportFillDocument, parser(options)));
      }
export type RequestTimeReportFillMutationHookResult = ReturnType<typeof useRequestTimeReportFillMutation>;
export type RequestTimeReportFillMutationResult = ApolloReact.MutationResult<RequestTimeReportFillMutation>;
export type RequestTimeReportFillMutationOptions = Apollo.MutationOptions<RequestTimeReportFillMutation, RequestTimeReportFillMutationVariables>;
export const RequestTimeReportFillForUsersDocument = /*#__PURE__*/ gql`
    mutation RequestTimeReportFillForUsers($filter: FilterContractSalaryDetailsInput!, $yearMonth: YearMonth!, $validUntil: OffsetDateTime!) {
  createTemporaryEditPermissionsForUsers(
    filter: $filter
    yearMonth: $yearMonth
    validUntil: $validUntil
  ) {
    ...NfsError
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useRequestTimeReportFillForUsersMutation__
 *
 * To run a mutation, you first call `useRequestTimeReportFillForUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTimeReportFillForUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTimeReportFillForUsersMutation, { data, loading, error }] = useRequestTimeReportFillForUsersMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      yearMonth: // value for 'yearMonth'
 *      validUntil: // value for 'validUntil'
 *   },
 * });
 */
export function useRequestTimeReportFillForUsersMutation(baseOptions?: ApolloReact.MutationHookOptions<RequestTimeReportFillForUsersMutation, RequestTimeReportFillForUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RequestTimeReportFillForUsersDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<RequestTimeReportFillForUsersMutation, RequestTimeReportFillForUsersMutationVariables>(RequestTimeReportFillForUsersDocument, parser(options)));
      }
export type RequestTimeReportFillForUsersMutationHookResult = ReturnType<typeof useRequestTimeReportFillForUsersMutation>;
export type RequestTimeReportFillForUsersMutationResult = ApolloReact.MutationResult<RequestTimeReportFillForUsersMutation>;
export type RequestTimeReportFillForUsersMutationOptions = Apollo.MutationOptions<RequestTimeReportFillForUsersMutation, RequestTimeReportFillForUsersMutationVariables>;
export const RequiredActionsDocument = /*#__PURE__*/ gql`
    query RequiredActions {
  requiredActions {
    ...NfsError
    ... on RequiredActions {
      pendingWorkTransferProtocols
      employeeRemindersNextRevisionDate
    }
  }
  timeReportsRequiringApproval {
    ...NfsError
    ... on TimeReportsRequiringApproval {
      workRecords {
        id
      }
      absenceRecords {
        id
      }
    }
  }
  pendingWorkTransferProtocols(
    sort: {sortBy: EmployeeAndThenYearMonth, sortOrder: Asc}
  ) {
    ...NfsError
    ... on ListOfWorkTransferProtocolResponse {
      value {
        id
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useRequiredActionsQuery__
 *
 * To run a query within a React component, call `useRequiredActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequiredActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequiredActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRequiredActionsQuery(baseOptions?: ApolloReact.QueryHookOptions<RequiredActionsQuery, RequiredActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RequiredActionsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RequiredActionsQuery, RequiredActionsQueryVariables>(RequiredActionsDocument, parser(options)));
      }
export function useRequiredActionsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RequiredActionsQuery, RequiredActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RequiredActionsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RequiredActionsQuery, RequiredActionsQueryVariables>(RequiredActionsDocument, options));
        }

export type RequiredActionsQueryResult = ApolloReact.QueryResult<RequiredActionsQuery, RequiredActionsQueryVariables>;
export function refetchRequiredActionsQuery(variables?: RequiredActionsQueryVariables) {
      return { query: RequiredActionsDocument, variables: variables }
    }
export const RequiredActionsRaisesDocument = /*#__PURE__*/ gql`
    query RequiredActionsRaises {
  raises {
    ...NfsError
    ... on ListOfRaiseProposalResponse {
      value {
        contract {
          id
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useRequiredActionsRaisesQuery__
 *
 * To run a query within a React component, call `useRequiredActionsRaisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequiredActionsRaisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequiredActionsRaisesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRequiredActionsRaisesQuery(baseOptions?: ApolloReact.QueryHookOptions<RequiredActionsRaisesQuery, RequiredActionsRaisesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RequiredActionsRaisesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RequiredActionsRaisesQuery, RequiredActionsRaisesQueryVariables>(RequiredActionsRaisesDocument, parser(options)));
      }
export function useRequiredActionsRaisesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RequiredActionsRaisesQuery, RequiredActionsRaisesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RequiredActionsRaisesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RequiredActionsRaisesQuery, RequiredActionsRaisesQueryVariables>(RequiredActionsRaisesDocument, options));
        }

export type RequiredActionsRaisesQueryResult = ApolloReact.QueryResult<RequiredActionsRaisesQuery, RequiredActionsRaisesQueryVariables>;
export function refetchRequiredActionsRaisesQuery(variables?: RequiredActionsRaisesQueryVariables) {
      return { query: RequiredActionsRaisesDocument, variables: variables }
    }
export const RequiredActionsOfficeReservationsDocument = /*#__PURE__*/ gql`
    query RequiredActionsOfficeReservations {
  pendingOfficeReservationRequests {
    ...NfsError
    ... on IntResponse {
      value
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useRequiredActionsOfficeReservationsQuery__
 *
 * To run a query within a React component, call `useRequiredActionsOfficeReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequiredActionsOfficeReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequiredActionsOfficeReservationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRequiredActionsOfficeReservationsQuery(baseOptions?: ApolloReact.QueryHookOptions<RequiredActionsOfficeReservationsQuery, RequiredActionsOfficeReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RequiredActionsOfficeReservationsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RequiredActionsOfficeReservationsQuery, RequiredActionsOfficeReservationsQueryVariables>(RequiredActionsOfficeReservationsDocument, parser(options)));
      }
export function useRequiredActionsOfficeReservationsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RequiredActionsOfficeReservationsQuery, RequiredActionsOfficeReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RequiredActionsOfficeReservationsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RequiredActionsOfficeReservationsQuery, RequiredActionsOfficeReservationsQueryVariables>(RequiredActionsOfficeReservationsDocument, options));
        }

export type RequiredActionsOfficeReservationsQueryResult = ApolloReact.QueryResult<RequiredActionsOfficeReservationsQuery, RequiredActionsOfficeReservationsQueryVariables>;
export function refetchRequiredActionsOfficeReservationsQuery(variables?: RequiredActionsOfficeReservationsQueryVariables) {
      return { query: RequiredActionsOfficeReservationsDocument, variables: variables }
    }
export const ReservationLimitsDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query ReservationLimitsDrawer_InitialData {
  officeReservationSettings {
    ...NfsError
    ... on OfficeReservationSettings {
      ...ReservationLimitsDrawer_Settings
    }
  }
}
    ${NfsErrorFragmentDoc}
${ReservationLimitsDrawerSettingsFragmentDoc}`;

/**
 * __useReservationLimitsDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useReservationLimitsDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationLimitsDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationLimitsDrawerInitialDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useReservationLimitsDrawerInitialDataQuery(baseOptions?: ApolloReact.QueryHookOptions<ReservationLimitsDrawerInitialDataQuery, ReservationLimitsDrawerInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ReservationLimitsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ReservationLimitsDrawerInitialDataQuery, ReservationLimitsDrawerInitialDataQueryVariables>(ReservationLimitsDrawerInitialDataDocument, parser(options)));
      }
export function useReservationLimitsDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ReservationLimitsDrawerInitialDataQuery, ReservationLimitsDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ReservationLimitsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ReservationLimitsDrawerInitialDataQuery, ReservationLimitsDrawerInitialDataQueryVariables>(ReservationLimitsDrawerInitialDataDocument, options));
        }

export type ReservationLimitsDrawerInitialDataQueryResult = ApolloReact.QueryResult<ReservationLimitsDrawerInitialDataQuery, ReservationLimitsDrawerInitialDataQueryVariables>;
export function refetchReservationLimitsDrawerInitialDataQuery(variables?: ReservationLimitsDrawerInitialDataQueryVariables) {
      return { query: ReservationLimitsDrawerInitialDataDocument, variables: variables }
    }
export const ReservationLimitsDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation ReservationLimitsDrawer_Update($deskMaxDays: Int!, $deskMaxAdvanceDays: Int!, $deskMaxUpcomingDays: Int!, $parkingMaxAdvanceDays: Int!, $parkingMaxDays: Int!, $parkingMaxUpcomingDays: Int!) {
  updateOfficeReservationSettings(
    deskMaxDays: $deskMaxDays
    deskMaxAdvanceDays: $deskMaxAdvanceDays
    deskMaxUpcomingDays: $deskMaxUpcomingDays
    parkingMaxAdvanceDays: $parkingMaxAdvanceDays
    parkingMaxDays: $parkingMaxDays
    parkingMaxUpcomingDays: $parkingMaxUpcomingDays
  ) {
    ...NfsError
    ... on OfficeReservationSettings {
      ...ReservationLimitsDrawer_Settings
    }
  }
}
    ${NfsErrorFragmentDoc}
${ReservationLimitsDrawerSettingsFragmentDoc}`;


/**
 * __useReservationLimitsDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useReservationLimitsDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReservationLimitsDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reservationLimitsDrawerUpdateMutation, { data, loading, error }] = useReservationLimitsDrawerUpdateMutation({
 *   variables: {
 *      deskMaxDays: // value for 'deskMaxDays'
 *      deskMaxAdvanceDays: // value for 'deskMaxAdvanceDays'
 *      deskMaxUpcomingDays: // value for 'deskMaxUpcomingDays'
 *      parkingMaxAdvanceDays: // value for 'parkingMaxAdvanceDays'
 *      parkingMaxDays: // value for 'parkingMaxDays'
 *      parkingMaxUpcomingDays: // value for 'parkingMaxUpcomingDays'
 *   },
 * });
 */
export function useReservationLimitsDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<ReservationLimitsDrawerUpdateMutation, ReservationLimitsDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ReservationLimitsDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ReservationLimitsDrawerUpdateMutation, ReservationLimitsDrawerUpdateMutationVariables>(ReservationLimitsDrawerUpdateDocument, parser(options)));
      }
export type ReservationLimitsDrawerUpdateMutationHookResult = ReturnType<typeof useReservationLimitsDrawerUpdateMutation>;
export type ReservationLimitsDrawerUpdateMutationResult = ApolloReact.MutationResult<ReservationLimitsDrawerUpdateMutation>;
export type ReservationLimitsDrawerUpdateMutationOptions = Apollo.MutationOptions<ReservationLimitsDrawerUpdateMutation, ReservationLimitsDrawerUpdateMutationVariables>;
export const RoomDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query RoomDrawer_InitialData($officeId: OfficeId!) {
  officeCatalogue(officeId: $officeId) {
    ...NfsError
    ... on OfficeCatalogue {
      rooms {
        ...RoomDrawer_Room
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${RoomDrawerRoomFragmentDoc}`;

/**
 * __useRoomDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useRoomDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomDrawerInitialDataQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useRoomDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<RoomDrawerInitialDataQuery, RoomDrawerInitialDataQueryVariables> & ({ variables: RoomDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RoomDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RoomDrawerInitialDataQuery, RoomDrawerInitialDataQueryVariables>(RoomDrawerInitialDataDocument, parser(options)));
      }
export function useRoomDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RoomDrawerInitialDataQuery, RoomDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RoomDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RoomDrawerInitialDataQuery, RoomDrawerInitialDataQueryVariables>(RoomDrawerInitialDataDocument, options));
        }

export type RoomDrawerInitialDataQueryResult = ApolloReact.QueryResult<RoomDrawerInitialDataQuery, RoomDrawerInitialDataQueryVariables>;
export function refetchRoomDrawerInitialDataQuery(variables: RoomDrawerInitialDataQueryVariables) {
      return { query: RoomDrawerInitialDataDocument, variables: variables }
    }
export const RoomDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation RoomDrawer_Create($id: RoomId!, $officeId: OfficeId!, $name: String!, $restrictedToSpaceId: SpaceId, $securityZone: SecurityZone, $blocked: Boolean) {
  createRoom(
    id: $id
    officeId: $officeId
    name: $name
    restrictedToSpaceId: $restrictedToSpaceId
    securityZone: $securityZone
    blocked: $blocked
  ) {
    ...NfsError
    ... on Room {
      ...OfficeCatalogue_Room
    }
  }
}
    ${NfsErrorFragmentDoc}
${OfficeCatalogueRoomFragmentDoc}`;


/**
 * __useRoomDrawerCreateMutation__
 *
 * To run a mutation, you first call `useRoomDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomDrawerCreateMutation, { data, loading, error }] = useRoomDrawerCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      officeId: // value for 'officeId'
 *      name: // value for 'name'
 *      restrictedToSpaceId: // value for 'restrictedToSpaceId'
 *      securityZone: // value for 'securityZone'
 *      blocked: // value for 'blocked'
 *   },
 * });
 */
export function useRoomDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<RoomDrawerCreateMutation, RoomDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RoomDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<RoomDrawerCreateMutation, RoomDrawerCreateMutationVariables>(RoomDrawerCreateDocument, parser(options)));
      }
export type RoomDrawerCreateMutationHookResult = ReturnType<typeof useRoomDrawerCreateMutation>;
export type RoomDrawerCreateMutationResult = ApolloReact.MutationResult<RoomDrawerCreateMutation>;
export type RoomDrawerCreateMutationOptions = Apollo.MutationOptions<RoomDrawerCreateMutation, RoomDrawerCreateMutationVariables>;
export const RoomDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation RoomDrawer_Update($roomId: RoomId!, $room: UpdateRoomInput!) {
  updateRoom(roomId: $roomId, room: $room) {
    ...NfsError
    ... on Room {
      ...RoomDrawer_Room
    }
  }
}
    ${NfsErrorFragmentDoc}
${RoomDrawerRoomFragmentDoc}`;


/**
 * __useRoomDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useRoomDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomDrawerUpdateMutation, { data, loading, error }] = useRoomDrawerUpdateMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      room: // value for 'room'
 *   },
 * });
 */
export function useRoomDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<RoomDrawerUpdateMutation, RoomDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RoomDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<RoomDrawerUpdateMutation, RoomDrawerUpdateMutationVariables>(RoomDrawerUpdateDocument, parser(options)));
      }
export type RoomDrawerUpdateMutationHookResult = ReturnType<typeof useRoomDrawerUpdateMutation>;
export type RoomDrawerUpdateMutationResult = ApolloReact.MutationResult<RoomDrawerUpdateMutation>;
export type RoomDrawerUpdateMutationOptions = Apollo.MutationOptions<RoomDrawerUpdateMutation, RoomDrawerUpdateMutationVariables>;
export const RoomDrawerSetSecurityZoneDocument = /*#__PURE__*/ gql`
    mutation RoomDrawer_SetSecurityZone($roomId: RoomId!, $securityZone: SecurityZone) {
  setRoomSecurityZone(roomId: $roomId, securityZone: $securityZone) {
    ...NfsError
    ... on Room {
      id
      securityZone
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useRoomDrawerSetSecurityZoneMutation__
 *
 * To run a mutation, you first call `useRoomDrawerSetSecurityZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomDrawerSetSecurityZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomDrawerSetSecurityZoneMutation, { data, loading, error }] = useRoomDrawerSetSecurityZoneMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      securityZone: // value for 'securityZone'
 *   },
 * });
 */
export function useRoomDrawerSetSecurityZoneMutation(baseOptions?: ApolloReact.MutationHookOptions<RoomDrawerSetSecurityZoneMutation, RoomDrawerSetSecurityZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RoomDrawerSetSecurityZoneDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<RoomDrawerSetSecurityZoneMutation, RoomDrawerSetSecurityZoneMutationVariables>(RoomDrawerSetSecurityZoneDocument, parser(options)));
      }
export type RoomDrawerSetSecurityZoneMutationHookResult = ReturnType<typeof useRoomDrawerSetSecurityZoneMutation>;
export type RoomDrawerSetSecurityZoneMutationResult = ApolloReact.MutationResult<RoomDrawerSetSecurityZoneMutation>;
export type RoomDrawerSetSecurityZoneMutationOptions = Apollo.MutationOptions<RoomDrawerSetSecurityZoneMutation, RoomDrawerSetSecurityZoneMutationVariables>;
export const SalariesControllsTransfersFileDocument = /*#__PURE__*/ gql`
    query SalariesControlls_TransfersFile($yearMonth: YearMonth!, $filter: FilterContractSalaryDetailsInput!) {
  payrollTransfersDocument(yearMonth: $yearMonth, filter: $filter) {
    ...NfsError
    ... on DownloadableFileUrl {
      ...SalariesControlls_File
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalariesControllsFileFragmentDoc}`;

/**
 * __useSalariesControllsTransfersFileQuery__
 *
 * To run a query within a React component, call `useSalariesControllsTransfersFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalariesControllsTransfersFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalariesControllsTransfersFileQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSalariesControllsTransfersFileQuery(baseOptions: ApolloReact.QueryHookOptions<SalariesControllsTransfersFileQuery, SalariesControllsTransfersFileQueryVariables> & ({ variables: SalariesControllsTransfersFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalariesControllsTransfersFileDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalariesControllsTransfersFileQuery, SalariesControllsTransfersFileQueryVariables>(SalariesControllsTransfersFileDocument, parser(options)));
      }
export function useSalariesControllsTransfersFileLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalariesControllsTransfersFileQuery, SalariesControllsTransfersFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalariesControllsTransfersFileDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalariesControllsTransfersFileQuery, SalariesControllsTransfersFileQueryVariables>(SalariesControllsTransfersFileDocument, options));
        }

export type SalariesControllsTransfersFileQueryResult = ApolloReact.QueryResult<SalariesControllsTransfersFileQuery, SalariesControllsTransfersFileQueryVariables>;
export function refetchSalariesControllsTransfersFileQuery(variables: SalariesControllsTransfersFileQueryVariables) {
      return { query: SalariesControllsTransfersFileDocument, variables: variables }
    }
export const SalariesControllsMarkAsDisbursedDocument = /*#__PURE__*/ gql`
    mutation SalariesControlls_MarkAsDisbursed($yearMonth: YearMonth!, $filter: FilterContractSalaryDetailsInput!) {
  markPaymentAsDisbursed(yearMonth: $yearMonth, filter: $filter) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      ...SalariesControlls_ModifiedEntries
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalariesControllsModifiedEntriesFragmentDoc}`;


/**
 * __useSalariesControllsMarkAsDisbursedMutation__
 *
 * To run a mutation, you first call `useSalariesControllsMarkAsDisbursedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalariesControllsMarkAsDisbursedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salariesControllsMarkAsDisbursedMutation, { data, loading, error }] = useSalariesControllsMarkAsDisbursedMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSalariesControllsMarkAsDisbursedMutation(baseOptions?: ApolloReact.MutationHookOptions<SalariesControllsMarkAsDisbursedMutation, SalariesControllsMarkAsDisbursedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalariesControllsMarkAsDisbursedDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SalariesControllsMarkAsDisbursedMutation, SalariesControllsMarkAsDisbursedMutationVariables>(SalariesControllsMarkAsDisbursedDocument, parser(options)));
      }
export type SalariesControllsMarkAsDisbursedMutationHookResult = ReturnType<typeof useSalariesControllsMarkAsDisbursedMutation>;
export type SalariesControllsMarkAsDisbursedMutationResult = ApolloReact.MutationResult<SalariesControllsMarkAsDisbursedMutation>;
export type SalariesControllsMarkAsDisbursedMutationOptions = Apollo.MutationOptions<SalariesControllsMarkAsDisbursedMutation, SalariesControllsMarkAsDisbursedMutationVariables>;
export const SalariesControllsUnmarkAsDisbursedDocument = /*#__PURE__*/ gql`
    mutation SalariesControlls_UnmarkAsDisbursed($yearMonth: YearMonth!, $filter: FilterContractSalaryDetailsInput!) {
  unmarkPaymentAsDisbursed(yearMonth: $yearMonth, filter: $filter) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      ...SalariesControlls_ModifiedEntries
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalariesControllsModifiedEntriesFragmentDoc}`;


/**
 * __useSalariesControllsUnmarkAsDisbursedMutation__
 *
 * To run a mutation, you first call `useSalariesControllsUnmarkAsDisbursedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalariesControllsUnmarkAsDisbursedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salariesControllsUnmarkAsDisbursedMutation, { data, loading, error }] = useSalariesControllsUnmarkAsDisbursedMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSalariesControllsUnmarkAsDisbursedMutation(baseOptions?: ApolloReact.MutationHookOptions<SalariesControllsUnmarkAsDisbursedMutation, SalariesControllsUnmarkAsDisbursedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalariesControllsUnmarkAsDisbursedDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SalariesControllsUnmarkAsDisbursedMutation, SalariesControllsUnmarkAsDisbursedMutationVariables>(SalariesControllsUnmarkAsDisbursedDocument, parser(options)));
      }
export type SalariesControllsUnmarkAsDisbursedMutationHookResult = ReturnType<typeof useSalariesControllsUnmarkAsDisbursedMutation>;
export type SalariesControllsUnmarkAsDisbursedMutationResult = ApolloReact.MutationResult<SalariesControllsUnmarkAsDisbursedMutation>;
export type SalariesControllsUnmarkAsDisbursedMutationOptions = Apollo.MutationOptions<SalariesControllsUnmarkAsDisbursedMutation, SalariesControllsUnmarkAsDisbursedMutationVariables>;
export const SalariesControllsNonB2BAccountingFileDocument = /*#__PURE__*/ gql`
    query SalariesControlls_NonB2BAccountingFile($yearMonth: YearMonth!, $filter: FilterContractSalaryDetailsInput!) {
  nonB2bPayrollInputsDocument(yearMonth: $yearMonth, filter: $filter) {
    ...NfsError
    ... on DownloadableFileUrl {
      ...SalariesControlls_File
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalariesControllsFileFragmentDoc}`;

/**
 * __useSalariesControllsNonB2BAccountingFileQuery__
 *
 * To run a query within a React component, call `useSalariesControllsNonB2BAccountingFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalariesControllsNonB2BAccountingFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalariesControllsNonB2BAccountingFileQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSalariesControllsNonB2BAccountingFileQuery(baseOptions: ApolloReact.QueryHookOptions<SalariesControllsNonB2BAccountingFileQuery, SalariesControllsNonB2BAccountingFileQueryVariables> & ({ variables: SalariesControllsNonB2BAccountingFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalariesControllsNonB2BAccountingFileDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalariesControllsNonB2BAccountingFileQuery, SalariesControllsNonB2BAccountingFileQueryVariables>(SalariesControllsNonB2BAccountingFileDocument, parser(options)));
      }
export function useSalariesControllsNonB2BAccountingFileLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalariesControllsNonB2BAccountingFileQuery, SalariesControllsNonB2BAccountingFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalariesControllsNonB2BAccountingFileDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalariesControllsNonB2BAccountingFileQuery, SalariesControllsNonB2BAccountingFileQueryVariables>(SalariesControllsNonB2BAccountingFileDocument, options));
        }

export type SalariesControllsNonB2BAccountingFileQueryResult = ApolloReact.QueryResult<SalariesControllsNonB2BAccountingFileQuery, SalariesControllsNonB2BAccountingFileQueryVariables>;
export function refetchSalariesControllsNonB2BAccountingFileQuery(variables: SalariesControllsNonB2BAccountingFileQueryVariables) {
      return { query: SalariesControllsNonB2BAccountingFileDocument, variables: variables }
    }
export const SalariesListItemTimeReportValidationsDocument = /*#__PURE__*/ gql`
    query SalariesListItem_TimeReportValidations($date: YearMonth!, $contractId: ContractId!) {
  contractSalaryDetailsAdditionalData(date: $date, contractId: $contractId) {
    ...NfsError
    ... on ContractSalaryDetailsAdditionalData {
      contractId
      yearMonth
      timeReportValidations {
        ...TimeReportValidation
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${TimeReportValidationFragmentDoc}`;

/**
 * __useSalariesListItemTimeReportValidationsQuery__
 *
 * To run a query within a React component, call `useSalariesListItemTimeReportValidationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalariesListItemTimeReportValidationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalariesListItemTimeReportValidationsQuery({
 *   variables: {
 *      date: // value for 'date'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useSalariesListItemTimeReportValidationsQuery(baseOptions: ApolloReact.QueryHookOptions<SalariesListItemTimeReportValidationsQuery, SalariesListItemTimeReportValidationsQueryVariables> & ({ variables: SalariesListItemTimeReportValidationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalariesListItemTimeReportValidationsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalariesListItemTimeReportValidationsQuery, SalariesListItemTimeReportValidationsQueryVariables>(SalariesListItemTimeReportValidationsDocument, parser(options)));
      }
export function useSalariesListItemTimeReportValidationsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalariesListItemTimeReportValidationsQuery, SalariesListItemTimeReportValidationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalariesListItemTimeReportValidationsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalariesListItemTimeReportValidationsQuery, SalariesListItemTimeReportValidationsQueryVariables>(SalariesListItemTimeReportValidationsDocument, options));
        }

export type SalariesListItemTimeReportValidationsQueryResult = ApolloReact.QueryResult<SalariesListItemTimeReportValidationsQuery, SalariesListItemTimeReportValidationsQueryVariables>;
export function refetchSalariesListItemTimeReportValidationsQuery(variables: SalariesListItemTimeReportValidationsQueryVariables) {
      return { query: SalariesListItemTimeReportValidationsDocument, variables: variables }
    }
export const SalariesSummaryReportDrawerGenerateDocument = /*#__PURE__*/ gql`
    mutation SalariesSummaryReportDrawer_Generate($yearMonth: YearMonth!, $salariesSummaryType: SalariesSummaryType!) {
  generateSalariesSummaryReport(
    yearMonth: $yearMonth
    salariesSummaryType: $salariesSummaryType
  ) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useSalariesSummaryReportDrawerGenerateMutation__
 *
 * To run a mutation, you first call `useSalariesSummaryReportDrawerGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalariesSummaryReportDrawerGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salariesSummaryReportDrawerGenerateMutation, { data, loading, error }] = useSalariesSummaryReportDrawerGenerateMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      salariesSummaryType: // value for 'salariesSummaryType'
 *   },
 * });
 */
export function useSalariesSummaryReportDrawerGenerateMutation(baseOptions?: ApolloReact.MutationHookOptions<SalariesSummaryReportDrawerGenerateMutation, SalariesSummaryReportDrawerGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalariesSummaryReportDrawerGenerateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SalariesSummaryReportDrawerGenerateMutation, SalariesSummaryReportDrawerGenerateMutationVariables>(SalariesSummaryReportDrawerGenerateDocument, parser(options)));
      }
export type SalariesSummaryReportDrawerGenerateMutationHookResult = ReturnType<typeof useSalariesSummaryReportDrawerGenerateMutation>;
export type SalariesSummaryReportDrawerGenerateMutationResult = ApolloReact.MutationResult<SalariesSummaryReportDrawerGenerateMutation>;
export type SalariesSummaryReportDrawerGenerateMutationOptions = Apollo.MutationOptions<SalariesSummaryReportDrawerGenerateMutation, SalariesSummaryReportDrawerGenerateMutationVariables>;
export const SalariesSummaryReportDrawerDocument = /*#__PURE__*/ gql`
    query SalariesSummaryReportDrawer($yearMonth: YearMonth!, $salariesSummaryType: SalariesSummaryType!) {
  salariesSummaryReport(
    yearMonth: $yearMonth
    salariesSummaryType: $salariesSummaryType
  ) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useSalariesSummaryReportDrawerQuery__
 *
 * To run a query within a React component, call `useSalariesSummaryReportDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalariesSummaryReportDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalariesSummaryReportDrawerQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      salariesSummaryType: // value for 'salariesSummaryType'
 *   },
 * });
 */
export function useSalariesSummaryReportDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<SalariesSummaryReportDrawerQuery, SalariesSummaryReportDrawerQueryVariables> & ({ variables: SalariesSummaryReportDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalariesSummaryReportDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalariesSummaryReportDrawerQuery, SalariesSummaryReportDrawerQueryVariables>(SalariesSummaryReportDrawerDocument, parser(options)));
      }
export function useSalariesSummaryReportDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalariesSummaryReportDrawerQuery, SalariesSummaryReportDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalariesSummaryReportDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalariesSummaryReportDrawerQuery, SalariesSummaryReportDrawerQueryVariables>(SalariesSummaryReportDrawerDocument, options));
        }

export type SalariesSummaryReportDrawerQueryResult = ApolloReact.QueryResult<SalariesSummaryReportDrawerQuery, SalariesSummaryReportDrawerQueryVariables>;
export function refetchSalariesSummaryReportDrawerQuery(variables: SalariesSummaryReportDrawerQueryVariables) {
      return { query: SalariesSummaryReportDrawerDocument, variables: variables }
    }
export const SalariesUserSectionUpdateFlagAndNoteDocument = /*#__PURE__*/ gql`
    mutation SalariesUserSection_UpdateFlagAndNote($contractId: ContractId!, $month: YearMonth!, $entityVersion: EntityVersion!, $note: ClearableStringInput, $flag: ClearableContractSalaryDetailsFlagColorInput) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    update(note: $note, flag: $flag, entityVersion: $entityVersion) {
      ...NfsError
      ... on ContractSalaryDetailsResponse {
        value {
          contractId
          yearMonth
          note
          flag
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useSalariesUserSectionUpdateFlagAndNoteMutation__
 *
 * To run a mutation, you first call `useSalariesUserSectionUpdateFlagAndNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalariesUserSectionUpdateFlagAndNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salariesUserSectionUpdateFlagAndNoteMutation, { data, loading, error }] = useSalariesUserSectionUpdateFlagAndNoteMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      entityVersion: // value for 'entityVersion'
 *      note: // value for 'note'
 *      flag: // value for 'flag'
 *   },
 * });
 */
export function useSalariesUserSectionUpdateFlagAndNoteMutation(baseOptions?: ApolloReact.MutationHookOptions<SalariesUserSectionUpdateFlagAndNoteMutation, SalariesUserSectionUpdateFlagAndNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalariesUserSectionUpdateFlagAndNoteDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SalariesUserSectionUpdateFlagAndNoteMutation, SalariesUserSectionUpdateFlagAndNoteMutationVariables>(SalariesUserSectionUpdateFlagAndNoteDocument, parser(options)));
      }
export type SalariesUserSectionUpdateFlagAndNoteMutationHookResult = ReturnType<typeof useSalariesUserSectionUpdateFlagAndNoteMutation>;
export type SalariesUserSectionUpdateFlagAndNoteMutationResult = ApolloReact.MutationResult<SalariesUserSectionUpdateFlagAndNoteMutation>;
export type SalariesUserSectionUpdateFlagAndNoteMutationOptions = Apollo.MutationOptions<SalariesUserSectionUpdateFlagAndNoteMutation, SalariesUserSectionUpdateFlagAndNoteMutationVariables>;
export const SalaryTransferDetailsRefreshWhiteListDocument = /*#__PURE__*/ gql`
    mutation SalaryTransferDetails_RefreshWhiteList($companyId: CompanyId!, $entityVersion: EntityVersion!, $bankAccountNumber: BankAccountNumberInput!) {
  company(companyId: $companyId, companyVersion: $entityVersion) {
    refreshBankAccounts(bankAccountNumbers: [$bankAccountNumber]) {
      ...NfsError
      ... on BankAccountsResponse {
        bankAccounts {
          ...BankAccount
        }
        company {
          id
          entityVersion
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankAccountFragmentDoc}`;


/**
 * __useSalaryTransferDetailsRefreshWhiteListMutation__
 *
 * To run a mutation, you first call `useSalaryTransferDetailsRefreshWhiteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalaryTransferDetailsRefreshWhiteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salaryTransferDetailsRefreshWhiteListMutation, { data, loading, error }] = useSalaryTransferDetailsRefreshWhiteListMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entityVersion: // value for 'entityVersion'
 *      bankAccountNumber: // value for 'bankAccountNumber'
 *   },
 * });
 */
export function useSalaryTransferDetailsRefreshWhiteListMutation(baseOptions?: ApolloReact.MutationHookOptions<SalaryTransferDetailsRefreshWhiteListMutation, SalaryTransferDetailsRefreshWhiteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalaryTransferDetailsRefreshWhiteListDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SalaryTransferDetailsRefreshWhiteListMutation, SalaryTransferDetailsRefreshWhiteListMutationVariables>(SalaryTransferDetailsRefreshWhiteListDocument, parser(options)));
      }
export type SalaryTransferDetailsRefreshWhiteListMutationHookResult = ReturnType<typeof useSalaryTransferDetailsRefreshWhiteListMutation>;
export type SalaryTransferDetailsRefreshWhiteListMutationResult = ApolloReact.MutationResult<SalaryTransferDetailsRefreshWhiteListMutation>;
export type SalaryTransferDetailsRefreshWhiteListMutationOptions = Apollo.MutationOptions<SalaryTransferDetailsRefreshWhiteListMutation, SalaryTransferDetailsRefreshWhiteListMutationVariables>;
export const SalaryTransferDetailsMarkAsDisbursedDocument = /*#__PURE__*/ gql`
    mutation SalaryTransferDetails_MarkAsDisbursed($yearMonth: YearMonth!, $contractId: ContractId!) {
  markPaymentAsDisbursed(
    yearMonth: $yearMonth
    filter: {contractIds_in: [$contractId]}
  ) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      ...SalaryTransferDetails_SalaryStateChange
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalaryTransferDetailsSalaryStateChangeFragmentDoc}`;


/**
 * __useSalaryTransferDetailsMarkAsDisbursedMutation__
 *
 * To run a mutation, you first call `useSalaryTransferDetailsMarkAsDisbursedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalaryTransferDetailsMarkAsDisbursedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salaryTransferDetailsMarkAsDisbursedMutation, { data, loading, error }] = useSalaryTransferDetailsMarkAsDisbursedMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useSalaryTransferDetailsMarkAsDisbursedMutation(baseOptions?: ApolloReact.MutationHookOptions<SalaryTransferDetailsMarkAsDisbursedMutation, SalaryTransferDetailsMarkAsDisbursedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalaryTransferDetailsMarkAsDisbursedDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SalaryTransferDetailsMarkAsDisbursedMutation, SalaryTransferDetailsMarkAsDisbursedMutationVariables>(SalaryTransferDetailsMarkAsDisbursedDocument, parser(options)));
      }
export type SalaryTransferDetailsMarkAsDisbursedMutationHookResult = ReturnType<typeof useSalaryTransferDetailsMarkAsDisbursedMutation>;
export type SalaryTransferDetailsMarkAsDisbursedMutationResult = ApolloReact.MutationResult<SalaryTransferDetailsMarkAsDisbursedMutation>;
export type SalaryTransferDetailsMarkAsDisbursedMutationOptions = Apollo.MutationOptions<SalaryTransferDetailsMarkAsDisbursedMutation, SalaryTransferDetailsMarkAsDisbursedMutationVariables>;
export const SalaryTransferDetailsUnmarkAsDisbursedDocument = /*#__PURE__*/ gql`
    mutation SalaryTransferDetails_UnmarkAsDisbursed($yearMonth: YearMonth!, $contractId: ContractId!) {
  unmarkPaymentAsDisbursed(
    yearMonth: $yearMonth
    filter: {contractIds_in: [$contractId]}
  ) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      ...SalaryTransferDetails_SalaryStateChange
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalaryTransferDetailsSalaryStateChangeFragmentDoc}`;


/**
 * __useSalaryTransferDetailsUnmarkAsDisbursedMutation__
 *
 * To run a mutation, you first call `useSalaryTransferDetailsUnmarkAsDisbursedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalaryTransferDetailsUnmarkAsDisbursedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salaryTransferDetailsUnmarkAsDisbursedMutation, { data, loading, error }] = useSalaryTransferDetailsUnmarkAsDisbursedMutation({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useSalaryTransferDetailsUnmarkAsDisbursedMutation(baseOptions?: ApolloReact.MutationHookOptions<SalaryTransferDetailsUnmarkAsDisbursedMutation, SalaryTransferDetailsUnmarkAsDisbursedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalaryTransferDetailsUnmarkAsDisbursedDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SalaryTransferDetailsUnmarkAsDisbursedMutation, SalaryTransferDetailsUnmarkAsDisbursedMutationVariables>(SalaryTransferDetailsUnmarkAsDisbursedDocument, parser(options)));
      }
export type SalaryTransferDetailsUnmarkAsDisbursedMutationHookResult = ReturnType<typeof useSalaryTransferDetailsUnmarkAsDisbursedMutation>;
export type SalaryTransferDetailsUnmarkAsDisbursedMutationResult = ApolloReact.MutationResult<SalaryTransferDetailsUnmarkAsDisbursedMutation>;
export type SalaryTransferDetailsUnmarkAsDisbursedMutationOptions = Apollo.MutationOptions<SalaryTransferDetailsUnmarkAsDisbursedMutation, SalaryTransferDetailsUnmarkAsDisbursedMutationVariables>;
export const SalaryTransferDetailsTransfersFileDocument = /*#__PURE__*/ gql`
    query SalaryTransferDetails_TransfersFile($yearMonth: YearMonth!, $contractId: ContractId!) {
  payrollTransfersDocument(
    yearMonth: $yearMonth
    filter: {contractIds_in: [$contractId], salaryStateKind_oneOf: [PaymentDisbursed, Ready]}
  ) {
    ...NfsError
    ... on DownloadableFileUrl {
      url
      fileName
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useSalaryTransferDetailsTransfersFileQuery__
 *
 * To run a query within a React component, call `useSalaryTransferDetailsTransfersFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalaryTransferDetailsTransfersFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalaryTransferDetailsTransfersFileQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useSalaryTransferDetailsTransfersFileQuery(baseOptions: ApolloReact.QueryHookOptions<SalaryTransferDetailsTransfersFileQuery, SalaryTransferDetailsTransfersFileQueryVariables> & ({ variables: SalaryTransferDetailsTransfersFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalaryTransferDetailsTransfersFileDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalaryTransferDetailsTransfersFileQuery, SalaryTransferDetailsTransfersFileQueryVariables>(SalaryTransferDetailsTransfersFileDocument, parser(options)));
      }
export function useSalaryTransferDetailsTransfersFileLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalaryTransferDetailsTransfersFileQuery, SalaryTransferDetailsTransfersFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalaryTransferDetailsTransfersFileDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalaryTransferDetailsTransfersFileQuery, SalaryTransferDetailsTransfersFileQueryVariables>(SalaryTransferDetailsTransfersFileDocument, options));
        }

export type SalaryTransferDetailsTransfersFileQueryResult = ApolloReact.QueryResult<SalaryTransferDetailsTransfersFileQuery, SalaryTransferDetailsTransfersFileQueryVariables>;
export function refetchSalaryTransferDetailsTransfersFileQuery(variables: SalaryTransferDetailsTransfersFileQueryVariables) {
      return { query: SalaryTransferDetailsTransfersFileDocument, variables: variables }
    }
export const SalaryTransferTitleFormUpdateTransferTitleDocument = /*#__PURE__*/ gql`
    mutation SalaryTransferTitleForm_UpdateTransferTitle($contractId: ContractId!, $month: YearMonth!, $entityVersion: EntityVersion!, $transferTitle: ClearableStringInput) {
  contractSalaryDetails(contractId: $contractId, date: $month) {
    update(transferTitle: $transferTitle, entityVersion: $entityVersion) {
      ...NfsError
      ... on ContractSalaryDetailsResponse {
        value {
          contractId
          yearMonth
          entityVersion
          transferTitle
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useSalaryTransferTitleFormUpdateTransferTitleMutation__
 *
 * To run a mutation, you first call `useSalaryTransferTitleFormUpdateTransferTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalaryTransferTitleFormUpdateTransferTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salaryTransferTitleFormUpdateTransferTitleMutation, { data, loading, error }] = useSalaryTransferTitleFormUpdateTransferTitleMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      month: // value for 'month'
 *      entityVersion: // value for 'entityVersion'
 *      transferTitle: // value for 'transferTitle'
 *   },
 * });
 */
export function useSalaryTransferTitleFormUpdateTransferTitleMutation(baseOptions?: ApolloReact.MutationHookOptions<SalaryTransferTitleFormUpdateTransferTitleMutation, SalaryTransferTitleFormUpdateTransferTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalaryTransferTitleFormUpdateTransferTitleDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SalaryTransferTitleFormUpdateTransferTitleMutation, SalaryTransferTitleFormUpdateTransferTitleMutationVariables>(SalaryTransferTitleFormUpdateTransferTitleDocument, parser(options)));
      }
export type SalaryTransferTitleFormUpdateTransferTitleMutationHookResult = ReturnType<typeof useSalaryTransferTitleFormUpdateTransferTitleMutation>;
export type SalaryTransferTitleFormUpdateTransferTitleMutationResult = ApolloReact.MutationResult<SalaryTransferTitleFormUpdateTransferTitleMutation>;
export type SalaryTransferTitleFormUpdateTransferTitleMutationOptions = Apollo.MutationOptions<SalaryTransferTitleFormUpdateTransferTitleMutation, SalaryTransferTitleFormUpdateTransferTitleMutationVariables>;
export const SaldeoInvoiceFormCostInvoicesDocument = /*#__PURE__*/ gql`
    query SaldeoInvoiceForm_CostInvoices($yearMonth: YearMonth!, $companyId: CompanyId!) {
  costInvoices(yearMonth: $yearMonth, companyId: $companyId) {
    ...NfsError
    ... on ListOfCostInvoiceResponse {
      value {
        ...SaldeoInvoiceForm_CostInvoice
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SaldeoInvoiceFormCostInvoiceFragmentDoc}`;

/**
 * __useSaldeoInvoiceFormCostInvoicesQuery__
 *
 * To run a query within a React component, call `useSaldeoInvoiceFormCostInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaldeoInvoiceFormCostInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaldeoInvoiceFormCostInvoicesQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSaldeoInvoiceFormCostInvoicesQuery(baseOptions: ApolloReact.QueryHookOptions<SaldeoInvoiceFormCostInvoicesQuery, SaldeoInvoiceFormCostInvoicesQueryVariables> & ({ variables: SaldeoInvoiceFormCostInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SaldeoInvoiceFormCostInvoicesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SaldeoInvoiceFormCostInvoicesQuery, SaldeoInvoiceFormCostInvoicesQueryVariables>(SaldeoInvoiceFormCostInvoicesDocument, parser(options)));
      }
export function useSaldeoInvoiceFormCostInvoicesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SaldeoInvoiceFormCostInvoicesQuery, SaldeoInvoiceFormCostInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SaldeoInvoiceFormCostInvoicesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SaldeoInvoiceFormCostInvoicesQuery, SaldeoInvoiceFormCostInvoicesQueryVariables>(SaldeoInvoiceFormCostInvoicesDocument, options));
        }

export type SaldeoInvoiceFormCostInvoicesQueryResult = ApolloReact.QueryResult<SaldeoInvoiceFormCostInvoicesQuery, SaldeoInvoiceFormCostInvoicesQueryVariables>;
export function refetchSaldeoInvoiceFormCostInvoicesQuery(variables: SaldeoInvoiceFormCostInvoicesQueryVariables) {
      return { query: SaldeoInvoiceFormCostInvoicesDocument, variables: variables }
    }
export const SalesInvoiceDetailsUpdateDetailsDocument = /*#__PURE__*/ gql`
    mutation SalesInvoiceDetails_UpdateDetails($invoiceId: SalesInvoiceId!, $profilePrefix: String!, $paidDate: ClearableLocalDateInput!) {
  salesInvoice(invoiceId: $invoiceId, profilePrefix: $profilePrefix) {
    update(paidDate: $paidDate) {
      ...NfsError
      ... on SalesInvoice {
        id
        paidDate
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useSalesInvoiceDetailsUpdateDetailsMutation__
 *
 * To run a mutation, you first call `useSalesInvoiceDetailsUpdateDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesInvoiceDetailsUpdateDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesInvoiceDetailsUpdateDetailsMutation, { data, loading, error }] = useSalesInvoiceDetailsUpdateDetailsMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      profilePrefix: // value for 'profilePrefix'
 *      paidDate: // value for 'paidDate'
 *   },
 * });
 */
export function useSalesInvoiceDetailsUpdateDetailsMutation(baseOptions?: ApolloReact.MutationHookOptions<SalesInvoiceDetailsUpdateDetailsMutation, SalesInvoiceDetailsUpdateDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalesInvoiceDetailsUpdateDetailsDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SalesInvoiceDetailsUpdateDetailsMutation, SalesInvoiceDetailsUpdateDetailsMutationVariables>(SalesInvoiceDetailsUpdateDetailsDocument, parser(options)));
      }
export type SalesInvoiceDetailsUpdateDetailsMutationHookResult = ReturnType<typeof useSalesInvoiceDetailsUpdateDetailsMutation>;
export type SalesInvoiceDetailsUpdateDetailsMutationResult = ApolloReact.MutationResult<SalesInvoiceDetailsUpdateDetailsMutation>;
export type SalesInvoiceDetailsUpdateDetailsMutationOptions = Apollo.MutationOptions<SalesInvoiceDetailsUpdateDetailsMutation, SalesInvoiceDetailsUpdateDetailsMutationVariables>;
export const SalesInvoicesFiltersSellersDocument = /*#__PURE__*/ gql`
    query SalesInvoicesFilters_Sellers($first: Int, $after: Cursor) {
  companies(
    first: $first
    after: $after
    filter: {companyType_oneOf: [Group]}
    sort: {by: Name, order: Desc}
  ) {
    ...NfsError
    ... on FSPResponseCompany {
      hasNextPage
      edges {
        cursor
        node {
          entityVersion
          id
          name
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useSalesInvoicesFiltersSellersQuery__
 *
 * To run a query within a React component, call `useSalesInvoicesFiltersSellersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesInvoicesFiltersSellersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesInvoicesFiltersSellersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSalesInvoicesFiltersSellersQuery(baseOptions?: ApolloReact.QueryHookOptions<SalesInvoicesFiltersSellersQuery, SalesInvoicesFiltersSellersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalesInvoicesFiltersSellersDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalesInvoicesFiltersSellersQuery, SalesInvoicesFiltersSellersQueryVariables>(SalesInvoicesFiltersSellersDocument, parser(options)));
      }
export function useSalesInvoicesFiltersSellersLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalesInvoicesFiltersSellersQuery, SalesInvoicesFiltersSellersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalesInvoicesFiltersSellersDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalesInvoicesFiltersSellersQuery, SalesInvoicesFiltersSellersQueryVariables>(SalesInvoicesFiltersSellersDocument, options));
        }

export type SalesInvoicesFiltersSellersQueryResult = ApolloReact.QueryResult<SalesInvoicesFiltersSellersQuery, SalesInvoicesFiltersSellersQueryVariables>;
export function refetchSalesInvoicesFiltersSellersQuery(variables?: SalesInvoicesFiltersSellersQueryVariables) {
      return { query: SalesInvoicesFiltersSellersDocument, variables: variables }
    }
export const SaveAsReadyModalInitialDataDocument = /*#__PURE__*/ gql`
    query SaveAsReadyModal_InitialData($userId: UserId!) {
  contractDocumentTemplateDescriptions {
    ...NfsError
    ... on ListOfContractDocumentTemplateDescriptionResponse {
      value {
        template
        name
        contractType
        language
      }
    }
  }
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            id
            entityVersion
            name
            ... on EmploymentContractDraft {
              conclusionDate
              type
              promisorRepresentative
              documentTemplate
              conclusionLocation
            }
            ... on B2BContractDraft {
              conclusionDate
              b2bContractType: type
              promisorRepresentative
              documentTemplate
              conclusionLocation
            }
            ... on SubcontractDraft {
              id
              clientContract {
                id
                name {
                  ...Unauthorized
                  ... on AccessGranted__String {
                    value
                  }
                }
                promisee {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useSaveAsReadyModalInitialDataQuery__
 *
 * To run a query within a React component, call `useSaveAsReadyModalInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveAsReadyModalInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveAsReadyModalInitialDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSaveAsReadyModalInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<SaveAsReadyModalInitialDataQuery, SaveAsReadyModalInitialDataQueryVariables> & ({ variables: SaveAsReadyModalInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SaveAsReadyModalInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SaveAsReadyModalInitialDataQuery, SaveAsReadyModalInitialDataQueryVariables>(SaveAsReadyModalInitialDataDocument, parser(options)));
      }
export function useSaveAsReadyModalInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SaveAsReadyModalInitialDataQuery, SaveAsReadyModalInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SaveAsReadyModalInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SaveAsReadyModalInitialDataQuery, SaveAsReadyModalInitialDataQueryVariables>(SaveAsReadyModalInitialDataDocument, options));
        }

export type SaveAsReadyModalInitialDataQueryResult = ApolloReact.QueryResult<SaveAsReadyModalInitialDataQuery, SaveAsReadyModalInitialDataQueryVariables>;
export function refetchSaveAsReadyModalInitialDataQuery(variables: SaveAsReadyModalInitialDataQueryVariables) {
      return { query: SaveAsReadyModalInitialDataDocument, variables: variables }
    }
export const SetFutureEntitlementDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query SetFutureEntitlementDrawer_InitialData($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        startDate
        terminationDate
        ... on EmploymentContract {
          type
          annualLeaveEntitlement {
            ...Unauthorized
            ... on AccessGranted__OptionalAnnualLeaveEntitlement {
              value {
                withCarryOverToNextYear
                history {
                  dateRange {
                    from
                    to
                  }
                  entitlement {
                    ...AnnualLeaveEntitlementValue
                  }
                  entitlementExplanation
                  createdAt
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AnnualLeaveEntitlementValueFragmentDoc}`;

/**
 * __useSetFutureEntitlementDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useSetFutureEntitlementDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetFutureEntitlementDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetFutureEntitlementDrawerInitialDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useSetFutureEntitlementDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<SetFutureEntitlementDrawerInitialDataQuery, SetFutureEntitlementDrawerInitialDataQueryVariables> & ({ variables: SetFutureEntitlementDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SetFutureEntitlementDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SetFutureEntitlementDrawerInitialDataQuery, SetFutureEntitlementDrawerInitialDataQueryVariables>(SetFutureEntitlementDrawerInitialDataDocument, parser(options)));
      }
export function useSetFutureEntitlementDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SetFutureEntitlementDrawerInitialDataQuery, SetFutureEntitlementDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SetFutureEntitlementDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SetFutureEntitlementDrawerInitialDataQuery, SetFutureEntitlementDrawerInitialDataQueryVariables>(SetFutureEntitlementDrawerInitialDataDocument, options));
        }

export type SetFutureEntitlementDrawerInitialDataQueryResult = ApolloReact.QueryResult<SetFutureEntitlementDrawerInitialDataQuery, SetFutureEntitlementDrawerInitialDataQueryVariables>;
export function refetchSetFutureEntitlementDrawerInitialDataQuery(variables: SetFutureEntitlementDrawerInitialDataQueryVariables) {
      return { query: SetFutureEntitlementDrawerInitialDataDocument, variables: variables }
    }
export const SetFutureEntitlementDrawerSetEntitlementDocument = /*#__PURE__*/ gql`
    mutation SetFutureEntitlementDrawer_SetEntitlement($contractId: ContractId!, $entityVersion: EntityVersion!, $annualLeaveEntitlement: AnnualLeaveEntitlementInput!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    updateEmploymentContract(annualLeaveEntitlement: $annualLeaveEntitlement) {
      ...NfsError
      ... on EmploymentContract {
        id
        entityVersion
        annualLeaveEntitlement {
          ...Unauthorized
          ... on AccessGranted__OptionalAnnualLeaveEntitlement {
            value {
              withCarryOverToNextYear
              history {
                dateRange {
                  from
                  to
                }
                entitlement {
                  ...AnnualLeaveEntitlementValue
                }
                entitlementExplanation
                createdAt
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AnnualLeaveEntitlementValueFragmentDoc}`;


/**
 * __useSetFutureEntitlementDrawerSetEntitlementMutation__
 *
 * To run a mutation, you first call `useSetFutureEntitlementDrawerSetEntitlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFutureEntitlementDrawerSetEntitlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFutureEntitlementDrawerSetEntitlementMutation, { data, loading, error }] = useSetFutureEntitlementDrawerSetEntitlementMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      annualLeaveEntitlement: // value for 'annualLeaveEntitlement'
 *   },
 * });
 */
export function useSetFutureEntitlementDrawerSetEntitlementMutation(baseOptions?: ApolloReact.MutationHookOptions<SetFutureEntitlementDrawerSetEntitlementMutation, SetFutureEntitlementDrawerSetEntitlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SetFutureEntitlementDrawerSetEntitlementDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SetFutureEntitlementDrawerSetEntitlementMutation, SetFutureEntitlementDrawerSetEntitlementMutationVariables>(SetFutureEntitlementDrawerSetEntitlementDocument, parser(options)));
      }
export type SetFutureEntitlementDrawerSetEntitlementMutationHookResult = ReturnType<typeof useSetFutureEntitlementDrawerSetEntitlementMutation>;
export type SetFutureEntitlementDrawerSetEntitlementMutationResult = ApolloReact.MutationResult<SetFutureEntitlementDrawerSetEntitlementMutation>;
export type SetFutureEntitlementDrawerSetEntitlementMutationOptions = Apollo.MutationOptions<SetFutureEntitlementDrawerSetEntitlementMutation, SetFutureEntitlementDrawerSetEntitlementMutationVariables>;
export const SetRateAndProgressionDrawerLoadDataDocument = /*#__PURE__*/ gql`
    query SetRateAndProgressionDrawer_LoadData($contractId: ContractId!, $userId: UserId!, $at: OffsetDateTime) {
  contract(contractId: $contractId, at: $at) {
    ...NfsError
    ... on ContractResponse {
      value {
        terminationDate
        at
        ...SetRateAndProgressionDrawer_Contract
      }
    }
  }
  user(id: $userId, at: $at) {
    ...NfsError
    ... on User {
      id
      at
      entityVersion
      progressionLevel {
        value
        futureUpdates {
          applyDate
          activityId
          value {
            value
          }
        }
        history {
          applyDate
          activityId
        }
      }
    }
  }
  progressionSchemes {
    ...NfsError
    ... on ListOfProgressionSchemeResponse {
      value {
        ...SetRateAndProgressionDrawer_AvailableProgressionScheme
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SetRateAndProgressionDrawerContractFragmentDoc}
${SetRateAndProgressionDrawerAvailableProgressionSchemeFragmentDoc}`;

/**
 * __useSetRateAndProgressionDrawerLoadDataQuery__
 *
 * To run a query within a React component, call `useSetRateAndProgressionDrawerLoadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetRateAndProgressionDrawerLoadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetRateAndProgressionDrawerLoadDataQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      userId: // value for 'userId'
 *      at: // value for 'at'
 *   },
 * });
 */
export function useSetRateAndProgressionDrawerLoadDataQuery(baseOptions: ApolloReact.QueryHookOptions<SetRateAndProgressionDrawerLoadDataQuery, SetRateAndProgressionDrawerLoadDataQueryVariables> & ({ variables: SetRateAndProgressionDrawerLoadDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SetRateAndProgressionDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SetRateAndProgressionDrawerLoadDataQuery, SetRateAndProgressionDrawerLoadDataQueryVariables>(SetRateAndProgressionDrawerLoadDataDocument, parser(options)));
      }
export function useSetRateAndProgressionDrawerLoadDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SetRateAndProgressionDrawerLoadDataQuery, SetRateAndProgressionDrawerLoadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SetRateAndProgressionDrawerLoadDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SetRateAndProgressionDrawerLoadDataQuery, SetRateAndProgressionDrawerLoadDataQueryVariables>(SetRateAndProgressionDrawerLoadDataDocument, options));
        }

export type SetRateAndProgressionDrawerLoadDataQueryResult = ApolloReact.QueryResult<SetRateAndProgressionDrawerLoadDataQuery, SetRateAndProgressionDrawerLoadDataQueryVariables>;
export function refetchSetRateAndProgressionDrawerLoadDataQuery(variables: SetRateAndProgressionDrawerLoadDataQueryVariables) {
      return { query: SetRateAndProgressionDrawerLoadDataDocument, variables: variables }
    }
export const SetRateAndProgressionDrawerGmailConnectionDocument = /*#__PURE__*/ gql`
    query SetRateAndProgressionDrawer_GmailConnection {
  gmailConnection {
    ...NfsError
    ... on GmailConnection {
      adminId
      connectedEmail
      aliases
      selectedAlias
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useSetRateAndProgressionDrawerGmailConnectionQuery__
 *
 * To run a query within a React component, call `useSetRateAndProgressionDrawerGmailConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetRateAndProgressionDrawerGmailConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetRateAndProgressionDrawerGmailConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSetRateAndProgressionDrawerGmailConnectionQuery(baseOptions?: ApolloReact.QueryHookOptions<SetRateAndProgressionDrawerGmailConnectionQuery, SetRateAndProgressionDrawerGmailConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SetRateAndProgressionDrawerGmailConnectionDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SetRateAndProgressionDrawerGmailConnectionQuery, SetRateAndProgressionDrawerGmailConnectionQueryVariables>(SetRateAndProgressionDrawerGmailConnectionDocument, parser(options)));
      }
export function useSetRateAndProgressionDrawerGmailConnectionLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SetRateAndProgressionDrawerGmailConnectionQuery, SetRateAndProgressionDrawerGmailConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SetRateAndProgressionDrawerGmailConnectionDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SetRateAndProgressionDrawerGmailConnectionQuery, SetRateAndProgressionDrawerGmailConnectionQueryVariables>(SetRateAndProgressionDrawerGmailConnectionDocument, options));
        }

export type SetRateAndProgressionDrawerGmailConnectionQueryResult = ApolloReact.QueryResult<SetRateAndProgressionDrawerGmailConnectionQuery, SetRateAndProgressionDrawerGmailConnectionQueryVariables>;
export function refetchSetRateAndProgressionDrawerGmailConnectionQuery(variables?: SetRateAndProgressionDrawerGmailConnectionQueryVariables) {
      return { query: SetRateAndProgressionDrawerGmailConnectionDocument, variables: variables }
    }
export const SetRateAndProgressionDrawerSetB2BRateAndProgressionDocument = /*#__PURE__*/ gql`
    mutation SetRateAndProgressionDrawer_SetB2BRateAndProgression($contractId: ContractId!, $entityVersion: EntityVersion!, $overtimeRate: TimeBasedValueClearableCentsInput!, $rateAmount: TimeBasedValueNetRateInput!, $currency: TimeBasedValueCurrencyInput!, $vat: TimeBasedValueVatTypeInput, $position: TimeBasedValueClearableStringInput!, $progressionSchemeId: TimeBasedValueClearableProgressionSchemeIdInput, $scopeOfWork: TimeBasedValueStringInput, $onCall: TimeBasedValueClearableNetOnCallRateInput!, $userEntityVersion: EntityVersion!, $progressionLevel: TimeBasedValueClearableProgressionLevelInput, $email: EmailInput) {
  setRateAndProgression(
    contractId: $contractId
    contractEntityVersion: $entityVersion
    contract: {b2b: {rate: $rateAmount, currency: $currency, vat: $vat, position: $position, progressionSchemeId: $progressionSchemeId, scopeOfWork: $scopeOfWork, onCall: $onCall, overtimeRate: $overtimeRate}}
    userEntityVersion: $userEntityVersion
    progressionLevel: $progressionLevel
    email: $email
  ) {
    ...NfsError
    ... on SetRateAndProgressionResult {
      ...SetRateAndProgressionDrawer_Result
    }
  }
}
    ${NfsErrorFragmentDoc}
${SetRateAndProgressionDrawerResultFragmentDoc}`;


/**
 * __useSetRateAndProgressionDrawerSetB2BRateAndProgressionMutation__
 *
 * To run a mutation, you first call `useSetRateAndProgressionDrawerSetB2BRateAndProgressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRateAndProgressionDrawerSetB2BRateAndProgressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRateAndProgressionDrawerSetB2BRateAndProgressionMutation, { data, loading, error }] = useSetRateAndProgressionDrawerSetB2BRateAndProgressionMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      overtimeRate: // value for 'overtimeRate'
 *      rateAmount: // value for 'rateAmount'
 *      currency: // value for 'currency'
 *      vat: // value for 'vat'
 *      position: // value for 'position'
 *      progressionSchemeId: // value for 'progressionSchemeId'
 *      scopeOfWork: // value for 'scopeOfWork'
 *      onCall: // value for 'onCall'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      progressionLevel: // value for 'progressionLevel'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSetRateAndProgressionDrawerSetB2BRateAndProgressionMutation(baseOptions?: ApolloReact.MutationHookOptions<SetRateAndProgressionDrawerSetB2BRateAndProgressionMutation, SetRateAndProgressionDrawerSetB2BRateAndProgressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SetRateAndProgressionDrawerSetB2BRateAndProgressionDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SetRateAndProgressionDrawerSetB2BRateAndProgressionMutation, SetRateAndProgressionDrawerSetB2BRateAndProgressionMutationVariables>(SetRateAndProgressionDrawerSetB2BRateAndProgressionDocument, parser(options)));
      }
export type SetRateAndProgressionDrawerSetB2BRateAndProgressionMutationHookResult = ReturnType<typeof useSetRateAndProgressionDrawerSetB2BRateAndProgressionMutation>;
export type SetRateAndProgressionDrawerSetB2BRateAndProgressionMutationResult = ApolloReact.MutationResult<SetRateAndProgressionDrawerSetB2BRateAndProgressionMutation>;
export type SetRateAndProgressionDrawerSetB2BRateAndProgressionMutationOptions = Apollo.MutationOptions<SetRateAndProgressionDrawerSetB2BRateAndProgressionMutation, SetRateAndProgressionDrawerSetB2BRateAndProgressionMutationVariables>;
export const SetRateAndProgressionDrawerSetEmploymentRateAndProgressionDocument = /*#__PURE__*/ gql`
    mutation SetRateAndProgressionDrawer_SetEmploymentRateAndProgression($contractId: ContractId!, $entityVersion: EntityVersion!, $rateAmount: TimeBasedValueNetRateInput!, $overtimeRate: TimeBasedValueClearableCentsInput!, $currency: TimeBasedValueCurrencyInput!, $workingTime: TimeBasedValueWorkingTimeInput, $position: TimeBasedValueClearableStringInput!, $progressionSchemeId: TimeBasedValueClearableProgressionSchemeIdInput, $scopeOfWork: TimeBasedValueStringInput, $onCall: TimeBasedValueClearableNetOnCallRateInput!, $userEntityVersion: EntityVersion!, $progressionLevel: TimeBasedValueClearableProgressionLevelInput, $email: EmailInput) {
  setRateAndProgression(
    contractId: $contractId
    contractEntityVersion: $entityVersion
    contract: {employment: {rate: $rateAmount, currency: $currency, workingTime: $workingTime, position: $position, progressionSchemeId: $progressionSchemeId, scopeOfWork: $scopeOfWork, onCall: $onCall, overtimeRate: $overtimeRate}}
    userEntityVersion: $userEntityVersion
    progressionLevel: $progressionLevel
    email: $email
  ) {
    ...NfsError
    ... on SetRateAndProgressionResult {
      ...SetRateAndProgressionDrawer_Result
    }
  }
}
    ${NfsErrorFragmentDoc}
${SetRateAndProgressionDrawerResultFragmentDoc}`;


/**
 * __useSetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation__
 *
 * To run a mutation, you first call `useSetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation, { data, loading, error }] = useSetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      rateAmount: // value for 'rateAmount'
 *      overtimeRate: // value for 'overtimeRate'
 *      currency: // value for 'currency'
 *      workingTime: // value for 'workingTime'
 *      position: // value for 'position'
 *      progressionSchemeId: // value for 'progressionSchemeId'
 *      scopeOfWork: // value for 'scopeOfWork'
 *      onCall: // value for 'onCall'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      progressionLevel: // value for 'progressionLevel'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation(baseOptions?: ApolloReact.MutationHookOptions<SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation, SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SetRateAndProgressionDrawerSetEmploymentRateAndProgressionDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation, SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutationVariables>(SetRateAndProgressionDrawerSetEmploymentRateAndProgressionDocument, parser(options)));
      }
export type SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutationHookResult = ReturnType<typeof useSetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation>;
export type SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutationResult = ApolloReact.MutationResult<SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation>;
export type SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutationOptions = Apollo.MutationOptions<SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation, SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutationVariables>;
export const SkillsAndCertificatesReportDrawerDocument = /*#__PURE__*/ gql`
    query SkillsAndCertificatesReportDrawer {
  skillsAndCertificatesReport {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useSkillsAndCertificatesReportDrawerQuery__
 *
 * To run a query within a React component, call `useSkillsAndCertificatesReportDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillsAndCertificatesReportDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillsAndCertificatesReportDrawerQuery({
 *   variables: {
 *   },
 * });
 */
export function useSkillsAndCertificatesReportDrawerQuery(baseOptions?: ApolloReact.QueryHookOptions<SkillsAndCertificatesReportDrawerQuery, SkillsAndCertificatesReportDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SkillsAndCertificatesReportDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SkillsAndCertificatesReportDrawerQuery, SkillsAndCertificatesReportDrawerQueryVariables>(SkillsAndCertificatesReportDrawerDocument, parser(options)));
      }
export function useSkillsAndCertificatesReportDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SkillsAndCertificatesReportDrawerQuery, SkillsAndCertificatesReportDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SkillsAndCertificatesReportDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SkillsAndCertificatesReportDrawerQuery, SkillsAndCertificatesReportDrawerQueryVariables>(SkillsAndCertificatesReportDrawerDocument, options));
        }

export type SkillsAndCertificatesReportDrawerQueryResult = ApolloReact.QueryResult<SkillsAndCertificatesReportDrawerQuery, SkillsAndCertificatesReportDrawerQueryVariables>;
export function refetchSkillsAndCertificatesReportDrawerQuery(variables?: SkillsAndCertificatesReportDrawerQueryVariables) {
      return { query: SkillsAndCertificatesReportDrawerDocument, variables: variables }
    }
export const SkillsAndCertificatesReportDrawerRegenerateDocument = /*#__PURE__*/ gql`
    mutation SkillsAndCertificatesReportDrawer_Regenerate {
  generateSkillsAndCertificatesReport {
    ...NfsError
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useSkillsAndCertificatesReportDrawerRegenerateMutation__
 *
 * To run a mutation, you first call `useSkillsAndCertificatesReportDrawerRegenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkillsAndCertificatesReportDrawerRegenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skillsAndCertificatesReportDrawerRegenerateMutation, { data, loading, error }] = useSkillsAndCertificatesReportDrawerRegenerateMutation({
 *   variables: {
 *   },
 * });
 */
export function useSkillsAndCertificatesReportDrawerRegenerateMutation(baseOptions?: ApolloReact.MutationHookOptions<SkillsAndCertificatesReportDrawerRegenerateMutation, SkillsAndCertificatesReportDrawerRegenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SkillsAndCertificatesReportDrawerRegenerateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SkillsAndCertificatesReportDrawerRegenerateMutation, SkillsAndCertificatesReportDrawerRegenerateMutationVariables>(SkillsAndCertificatesReportDrawerRegenerateDocument, parser(options)));
      }
export type SkillsAndCertificatesReportDrawerRegenerateMutationHookResult = ReturnType<typeof useSkillsAndCertificatesReportDrawerRegenerateMutation>;
export type SkillsAndCertificatesReportDrawerRegenerateMutationResult = ApolloReact.MutationResult<SkillsAndCertificatesReportDrawerRegenerateMutation>;
export type SkillsAndCertificatesReportDrawerRegenerateMutationOptions = Apollo.MutationOptions<SkillsAndCertificatesReportDrawerRegenerateMutation, SkillsAndCertificatesReportDrawerRegenerateMutationVariables>;
export const SpaceDirectorsFormUserAutocompleteDocument = /*#__PURE__*/ gql`
    query SpaceDirectorsForm_UserAutocomplete($after: Cursor, $filter: FilterUserInput!, $sort: SortingRequestSortUserInput, $first: Int!) {
  users(filter: $filter, sort: $sort, first: $first, after: $after) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      edges {
        cursor
        node {
          ...UserAutocomplete_User
          avatar
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserAutocompleteUserFragmentDoc}`;

/**
 * __useSpaceDirectorsFormUserAutocompleteQuery__
 *
 * To run a query within a React component, call `useSpaceDirectorsFormUserAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceDirectorsFormUserAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceDirectorsFormUserAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSpaceDirectorsFormUserAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<SpaceDirectorsFormUserAutocompleteQuery, SpaceDirectorsFormUserAutocompleteQueryVariables> & ({ variables: SpaceDirectorsFormUserAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SpaceDirectorsFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SpaceDirectorsFormUserAutocompleteQuery, SpaceDirectorsFormUserAutocompleteQueryVariables>(SpaceDirectorsFormUserAutocompleteDocument, parser(options)));
      }
export function useSpaceDirectorsFormUserAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SpaceDirectorsFormUserAutocompleteQuery, SpaceDirectorsFormUserAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SpaceDirectorsFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SpaceDirectorsFormUserAutocompleteQuery, SpaceDirectorsFormUserAutocompleteQueryVariables>(SpaceDirectorsFormUserAutocompleteDocument, options));
        }

export type SpaceDirectorsFormUserAutocompleteQueryResult = ApolloReact.QueryResult<SpaceDirectorsFormUserAutocompleteQuery, SpaceDirectorsFormUserAutocompleteQueryVariables>;
export function refetchSpaceDirectorsFormUserAutocompleteQuery(variables: SpaceDirectorsFormUserAutocompleteQueryVariables) {
      return { query: SpaceDirectorsFormUserAutocompleteDocument, variables: variables }
    }
export const SpaceFormUserAutocompleteDocument = /*#__PURE__*/ gql`
    query SpaceForm_UserAutocomplete($after: Cursor, $filter: FilterUserInput!, $sort: SortingRequestSortUserInput, $first: Int!) {
  users(filter: $filter, sort: $sort, first: $first, after: $after) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      edges {
        cursor
        node {
          ...UserAutocomplete_User
          avatar
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserAutocompleteUserFragmentDoc}`;

/**
 * __useSpaceFormUserAutocompleteQuery__
 *
 * To run a query within a React component, call `useSpaceFormUserAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceFormUserAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceFormUserAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSpaceFormUserAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<SpaceFormUserAutocompleteQuery, SpaceFormUserAutocompleteQueryVariables> & ({ variables: SpaceFormUserAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SpaceFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SpaceFormUserAutocompleteQuery, SpaceFormUserAutocompleteQueryVariables>(SpaceFormUserAutocompleteDocument, parser(options)));
      }
export function useSpaceFormUserAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SpaceFormUserAutocompleteQuery, SpaceFormUserAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SpaceFormUserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SpaceFormUserAutocompleteQuery, SpaceFormUserAutocompleteQueryVariables>(SpaceFormUserAutocompleteDocument, options));
        }

export type SpaceFormUserAutocompleteQueryResult = ApolloReact.QueryResult<SpaceFormUserAutocompleteQuery, SpaceFormUserAutocompleteQueryVariables>;
export function refetchSpaceFormUserAutocompleteQuery(variables: SpaceFormUserAutocompleteQueryVariables) {
      return { query: SpaceFormUserAutocompleteDocument, variables: variables }
    }
export const SubcontractDetailsContractDocument = /*#__PURE__*/ gql`
    query SubcontractDetails_Contract($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        ... on Subcontract {
          startDate
          terminationDate
          clientContract {
            ...Unauthorized
            ... on AccessGranted__ClientContract {
              value {
                id
                name {
                  ...Unauthorized
                  ... on AccessGranted__String {
                    value
                  }
                }
                contractDurationFrom {
                  ...Unauthorized
                  ... on AccessGranted__LocalDate {
                    value
                  }
                }
                contractDurationTo {
                  ...Unauthorized
                  ... on AccessGranted__OptionalLocalDate {
                    value
                  }
                }
                promisee {
                  id
                  entityVersion
                  name
                  taxNumber
                  companyType
                  address {
                    ...Address
                  }
                  mailingAddress {
                    ...Address
                  }
                }
                promisor {
                  id
                  entityVersion
                  name
                  taxNumber
                  companyType
                  isPolishVat {
                    value {
                      value
                    }
                  }
                  euVatType {
                    value {
                      value
                    }
                  }
                  address {
                    ...Address
                  }
                  mailingAddress {
                    ...Address
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useSubcontractDetailsContractQuery__
 *
 * To run a query within a React component, call `useSubcontractDetailsContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractDetailsContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractDetailsContractQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useSubcontractDetailsContractQuery(baseOptions: ApolloReact.QueryHookOptions<SubcontractDetailsContractQuery, SubcontractDetailsContractQueryVariables> & ({ variables: SubcontractDetailsContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SubcontractDetailsContractDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SubcontractDetailsContractQuery, SubcontractDetailsContractQueryVariables>(SubcontractDetailsContractDocument, parser(options)));
      }
export function useSubcontractDetailsContractLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SubcontractDetailsContractQuery, SubcontractDetailsContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SubcontractDetailsContractDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SubcontractDetailsContractQuery, SubcontractDetailsContractQueryVariables>(SubcontractDetailsContractDocument, options));
        }

export type SubcontractDetailsContractQueryResult = ApolloReact.QueryResult<SubcontractDetailsContractQuery, SubcontractDetailsContractQueryVariables>;
export function refetchSubcontractDetailsContractQuery(variables: SubcontractDetailsContractQueryVariables) {
      return { query: SubcontractDetailsContractDocument, variables: variables }
    }
export const SubcontractDetailsSectionsAssignedProjectsDocument = /*#__PURE__*/ gql`
    query SubcontractDetailsSections_AssignedProjects($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            status
            startDate
            ... on Subcontract {
              clientContract {
                ...Unauthorized
                ... on AccessGranted__ClientContract {
                  value {
                    id
                    promisor {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
      directReporting {
        assignedProjects {
          ...Unauthorized
          ... on AccessGranted__ListOfProjectAssignment {
            value {
              user {
                id
              }
              project {
                id
                name
                clientContract {
                  id
                  promisor {
                    id
                    companyType
                    name
                  }
                  promisee {
                    id
                    companyType
                    name
                  }
                }
              }
              periods {
                dateRange {
                  from
                  to
                }
                clientPosition {
                  ...Unauthorized
                  ... on AccessGranted__ClientPosition {
                    value {
                      ...ProjectsAndActivities_ClientPosition
                    }
                  }
                }
                subcontractPosition {
                  ...Unauthorized
                  ... on AccessGranted__OptionalClientPosition {
                    value {
                      ...ProjectsAndActivities_ClientPosition
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${ProjectsAndActivitiesClientPositionFragmentDoc}`;

/**
 * __useSubcontractDetailsSectionsAssignedProjectsQuery__
 *
 * To run a query within a React component, call `useSubcontractDetailsSectionsAssignedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractDetailsSectionsAssignedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractDetailsSectionsAssignedProjectsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSubcontractDetailsSectionsAssignedProjectsQuery(baseOptions: ApolloReact.QueryHookOptions<SubcontractDetailsSectionsAssignedProjectsQuery, SubcontractDetailsSectionsAssignedProjectsQueryVariables> & ({ variables: SubcontractDetailsSectionsAssignedProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SubcontractDetailsSectionsAssignedProjectsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SubcontractDetailsSectionsAssignedProjectsQuery, SubcontractDetailsSectionsAssignedProjectsQueryVariables>(SubcontractDetailsSectionsAssignedProjectsDocument, parser(options)));
      }
export function useSubcontractDetailsSectionsAssignedProjectsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SubcontractDetailsSectionsAssignedProjectsQuery, SubcontractDetailsSectionsAssignedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SubcontractDetailsSectionsAssignedProjectsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SubcontractDetailsSectionsAssignedProjectsQuery, SubcontractDetailsSectionsAssignedProjectsQueryVariables>(SubcontractDetailsSectionsAssignedProjectsDocument, options));
        }

export type SubcontractDetailsSectionsAssignedProjectsQueryResult = ApolloReact.QueryResult<SubcontractDetailsSectionsAssignedProjectsQuery, SubcontractDetailsSectionsAssignedProjectsQueryVariables>;
export function refetchSubcontractDetailsSectionsAssignedProjectsQuery(variables: SubcontractDetailsSectionsAssignedProjectsQueryVariables) {
      return { query: SubcontractDetailsSectionsAssignedProjectsDocument, variables: variables }
    }
export const SubcontractDraftDetailsDocument = /*#__PURE__*/ gql`
    query SubcontractDraftDetails($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            id
            entityVersion
            ... on SubcontractDraft {
              clientContract {
                id
                name {
                  ...Unauthorized
                  ... on AccessGranted__String {
                    value
                  }
                }
                contractDurationFrom {
                  ...Unauthorized
                  ... on AccessGranted__LocalDate {
                    value
                  }
                }
                contractDurationTo {
                  ...Unauthorized
                  ... on AccessGranted__OptionalLocalDate {
                    value
                  }
                }
                promisee {
                  id
                  entityVersion
                  name
                  taxNumber
                  companyType
                  address {
                    ...Address
                  }
                  mailingAddress {
                    ...Address
                  }
                }
                promisor {
                  id
                  entityVersion
                  name
                  taxNumber
                  companyType
                  isPolishVat {
                    value {
                      value
                    }
                  }
                  euVatType {
                    value {
                      value
                    }
                  }
                  address {
                    ...Address
                  }
                  mailingAddress {
                    ...Address
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useSubcontractDraftDetailsQuery__
 *
 * To run a query within a React component, call `useSubcontractDraftDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractDraftDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractDraftDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSubcontractDraftDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<SubcontractDraftDetailsQuery, SubcontractDraftDetailsQueryVariables> & ({ variables: SubcontractDraftDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SubcontractDraftDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SubcontractDraftDetailsQuery, SubcontractDraftDetailsQueryVariables>(SubcontractDraftDetailsDocument, parser(options)));
      }
export function useSubcontractDraftDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SubcontractDraftDetailsQuery, SubcontractDraftDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SubcontractDraftDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SubcontractDraftDetailsQuery, SubcontractDraftDetailsQueryVariables>(SubcontractDraftDetailsDocument, options));
        }

export type SubcontractDraftDetailsQueryResult = ApolloReact.QueryResult<SubcontractDraftDetailsQuery, SubcontractDraftDetailsQueryVariables>;
export function refetchSubcontractDraftDetailsQuery(variables: SubcontractDraftDetailsQueryVariables) {
      return { query: SubcontractDraftDetailsDocument, variables: variables }
    }
export const SubcontractDraftDrawerInputDocument = /*#__PURE__*/ gql`
    query SubcontractDraftDrawer_Input($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      email
      contractDraft {
        ...Unauthorized
        ... on AccessGranted__OptionalContractDraft {
          value {
            ...SubcontractDraftDrawer_Draft
          }
        }
      }
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            startDate
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${SubcontractDraftDrawerDraftFragmentDoc}`;

/**
 * __useSubcontractDraftDrawerInputQuery__
 *
 * To run a query within a React component, call `useSubcontractDraftDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractDraftDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractDraftDrawerInputQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSubcontractDraftDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<SubcontractDraftDrawerInputQuery, SubcontractDraftDrawerInputQueryVariables> & ({ variables: SubcontractDraftDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SubcontractDraftDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SubcontractDraftDrawerInputQuery, SubcontractDraftDrawerInputQueryVariables>(SubcontractDraftDrawerInputDocument, parser(options)));
      }
export function useSubcontractDraftDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SubcontractDraftDrawerInputQuery, SubcontractDraftDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SubcontractDraftDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SubcontractDraftDrawerInputQuery, SubcontractDraftDrawerInputQueryVariables>(SubcontractDraftDrawerInputDocument, options));
        }

export type SubcontractDraftDrawerInputQueryResult = ApolloReact.QueryResult<SubcontractDraftDrawerInputQuery, SubcontractDraftDrawerInputQueryVariables>;
export function refetchSubcontractDraftDrawerInputQuery(variables: SubcontractDraftDrawerInputQueryVariables) {
      return { query: SubcontractDraftDrawerInputDocument, variables: variables }
    }
export const SubcontractDraftDrawerCreateDocument = /*#__PURE__*/ gql`
    mutation SubcontractDraftDrawer_Create($userId: UserId!, $userEntityVersion: EntityVersion!, $contractId: ContractId!, $name: String!, $startDate: LocalDate, $expectedEndDate: LocalDate, $clientContractId: ClientContractId!, $holidayCalendarId: HolidayCalendarId, $scopeOfWork: String, $position: String) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    createSubcontractDraft(
      contractId: $contractId
      name: $name
      startDate: $startDate
      expectedEndDate: $expectedEndDate
      holidayCalendarId: $holidayCalendarId
      clientContractId: $clientContractId
      scopeOfWork: $scopeOfWork
      position: $position
    ) {
      ...NfsError
      ... on SubcontractDraft {
        ...SubcontractDraftDrawer_Draft
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SubcontractDraftDrawerDraftFragmentDoc}`;


/**
 * __useSubcontractDraftDrawerCreateMutation__
 *
 * To run a mutation, you first call `useSubcontractDraftDrawerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubcontractDraftDrawerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subcontractDraftDrawerCreateMutation, { data, loading, error }] = useSubcontractDraftDrawerCreateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      contractId: // value for 'contractId'
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *      expectedEndDate: // value for 'expectedEndDate'
 *      clientContractId: // value for 'clientContractId'
 *      holidayCalendarId: // value for 'holidayCalendarId'
 *      scopeOfWork: // value for 'scopeOfWork'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useSubcontractDraftDrawerCreateMutation(baseOptions?: ApolloReact.MutationHookOptions<SubcontractDraftDrawerCreateMutation, SubcontractDraftDrawerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SubcontractDraftDrawerCreateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SubcontractDraftDrawerCreateMutation, SubcontractDraftDrawerCreateMutationVariables>(SubcontractDraftDrawerCreateDocument, parser(options)));
      }
export type SubcontractDraftDrawerCreateMutationHookResult = ReturnType<typeof useSubcontractDraftDrawerCreateMutation>;
export type SubcontractDraftDrawerCreateMutationResult = ApolloReact.MutationResult<SubcontractDraftDrawerCreateMutation>;
export type SubcontractDraftDrawerCreateMutationOptions = Apollo.MutationOptions<SubcontractDraftDrawerCreateMutation, SubcontractDraftDrawerCreateMutationVariables>;
export const SubcontractDraftDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation SubcontractDraftDrawer_Update($userId: UserId!, $userEntityVersion: EntityVersion!, $entityVersion: EntityVersion!, $startDate: ClearableLocalDateInput, $expectedEndDate: ClearableLocalDateInput, $holidayCalendarId: ClearableHolidayCalendarIdInput, $scopeOfWork: ClearableStringInput, $position: ClearableStringInput) {
  user(userId: $userId, entityVersion: $userEntityVersion) {
    contractDraft(entityVersion: $entityVersion) {
      updateSubcontractDraft(
        startDate: $startDate
        expectedEndDate: $expectedEndDate
        holidayCalendarId: $holidayCalendarId
        scopeOfWork: $scopeOfWork
        position: $position
      ) {
        ...NfsError
        ... on SubcontractDraft {
          ...SubcontractDraftDrawer_Draft
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SubcontractDraftDrawerDraftFragmentDoc}`;


/**
 * __useSubcontractDraftDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useSubcontractDraftDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubcontractDraftDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subcontractDraftDrawerUpdateMutation, { data, loading, error }] = useSubcontractDraftDrawerUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEntityVersion: // value for 'userEntityVersion'
 *      entityVersion: // value for 'entityVersion'
 *      startDate: // value for 'startDate'
 *      expectedEndDate: // value for 'expectedEndDate'
 *      holidayCalendarId: // value for 'holidayCalendarId'
 *      scopeOfWork: // value for 'scopeOfWork'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useSubcontractDraftDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<SubcontractDraftDrawerUpdateMutation, SubcontractDraftDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SubcontractDraftDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SubcontractDraftDrawerUpdateMutation, SubcontractDraftDrawerUpdateMutationVariables>(SubcontractDraftDrawerUpdateDocument, parser(options)));
      }
export type SubcontractDraftDrawerUpdateMutationHookResult = ReturnType<typeof useSubcontractDraftDrawerUpdateMutation>;
export type SubcontractDraftDrawerUpdateMutationResult = ApolloReact.MutationResult<SubcontractDraftDrawerUpdateMutation>;
export type SubcontractDraftDrawerUpdateMutationOptions = Apollo.MutationOptions<SubcontractDraftDrawerUpdateMutation, SubcontractDraftDrawerUpdateMutationVariables>;
export const SubcontractDraftFormClientContractsDocument = /*#__PURE__*/ gql`
    query SubcontractDraftForm_ClientContracts($first: Int, $after: Cursor, $filter: FilterClientContractInput) {
  clientContracts(first: $first, after: $after, filter: $filter) {
    ...NfsError
    ... on FSPResponseClientContract {
      hasNextPage
      edges {
        cursor
        node {
          id
          name {
            ...Unauthorized
            ... on AccessGranted__String {
              value
            }
          }
          contractDurationFrom {
            ...Unauthorized
            ... on AccessGranted__LocalDate {
              value
            }
          }
          promisor {
            id
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useSubcontractDraftFormClientContractsQuery__
 *
 * To run a query within a React component, call `useSubcontractDraftFormClientContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractDraftFormClientContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractDraftFormClientContractsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSubcontractDraftFormClientContractsQuery(baseOptions?: ApolloReact.QueryHookOptions<SubcontractDraftFormClientContractsQuery, SubcontractDraftFormClientContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SubcontractDraftFormClientContractsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SubcontractDraftFormClientContractsQuery, SubcontractDraftFormClientContractsQueryVariables>(SubcontractDraftFormClientContractsDocument, parser(options)));
      }
export function useSubcontractDraftFormClientContractsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SubcontractDraftFormClientContractsQuery, SubcontractDraftFormClientContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SubcontractDraftFormClientContractsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SubcontractDraftFormClientContractsQuery, SubcontractDraftFormClientContractsQueryVariables>(SubcontractDraftFormClientContractsDocument, options));
        }

export type SubcontractDraftFormClientContractsQueryResult = ApolloReact.QueryResult<SubcontractDraftFormClientContractsQuery, SubcontractDraftFormClientContractsQueryVariables>;
export function refetchSubcontractDraftFormClientContractsQuery(variables?: SubcontractDraftFormClientContractsQueryVariables) {
      return { query: SubcontractDraftFormClientContractsDocument, variables: variables }
    }
export const AdminTaxResidencyCertificatesDrawerDocument = /*#__PURE__*/ gql`
    query Admin_TaxResidencyCertificatesDrawer($companyId: CompanyId!) {
  company(id: $companyId) {
    ...NfsError
    ... on Company {
      id
      entityVersion
      taxResidencyCertificates {
        ...Unauthorized
        ... on AccessGranted__ListOfTaxResidencyCertificate {
          value {
            id
            year
            countryOfResidency
            validFrom
            validTo
            fileUri
            notes
            companyId
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useAdminTaxResidencyCertificatesDrawerQuery__
 *
 * To run a query within a React component, call `useAdminTaxResidencyCertificatesDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTaxResidencyCertificatesDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTaxResidencyCertificatesDrawerQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAdminTaxResidencyCertificatesDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<AdminTaxResidencyCertificatesDrawerQuery, AdminTaxResidencyCertificatesDrawerQueryVariables> & ({ variables: AdminTaxResidencyCertificatesDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTaxResidencyCertificatesDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminTaxResidencyCertificatesDrawerQuery, AdminTaxResidencyCertificatesDrawerQueryVariables>(AdminTaxResidencyCertificatesDrawerDocument, parser(options)));
      }
export function useAdminTaxResidencyCertificatesDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminTaxResidencyCertificatesDrawerQuery, AdminTaxResidencyCertificatesDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminTaxResidencyCertificatesDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminTaxResidencyCertificatesDrawerQuery, AdminTaxResidencyCertificatesDrawerQueryVariables>(AdminTaxResidencyCertificatesDrawerDocument, options));
        }

export type AdminTaxResidencyCertificatesDrawerQueryResult = ApolloReact.QueryResult<AdminTaxResidencyCertificatesDrawerQuery, AdminTaxResidencyCertificatesDrawerQueryVariables>;
export function refetchAdminTaxResidencyCertificatesDrawerQuery(variables: AdminTaxResidencyCertificatesDrawerQueryVariables) {
      return { query: AdminTaxResidencyCertificatesDrawerDocument, variables: variables }
    }
export const AdminTaxResidencyCertificatesDrawerUpsertDocument = /*#__PURE__*/ gql`
    mutation Admin_TaxResidencyCertificatesDrawer_Upsert($certificate: TaxResidencyCertificateInput!) {
  upsertTaxResidencyCertificate(certificate: $certificate) {
    ...NfsError
    ... on TaxResidencyCertificate {
      id
      year
      countryOfResidency
      validFrom
      validTo
      fileUri
      notes
      companyId
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAdminTaxResidencyCertificatesDrawerUpsertMutation__
 *
 * To run a mutation, you first call `useAdminTaxResidencyCertificatesDrawerUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTaxResidencyCertificatesDrawerUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTaxResidencyCertificatesDrawerUpsertMutation, { data, loading, error }] = useAdminTaxResidencyCertificatesDrawerUpsertMutation({
 *   variables: {
 *      certificate: // value for 'certificate'
 *   },
 * });
 */
export function useAdminTaxResidencyCertificatesDrawerUpsertMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminTaxResidencyCertificatesDrawerUpsertMutation, AdminTaxResidencyCertificatesDrawerUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTaxResidencyCertificatesDrawerUpsertDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminTaxResidencyCertificatesDrawerUpsertMutation, AdminTaxResidencyCertificatesDrawerUpsertMutationVariables>(AdminTaxResidencyCertificatesDrawerUpsertDocument, parser(options)));
      }
export type AdminTaxResidencyCertificatesDrawerUpsertMutationHookResult = ReturnType<typeof useAdminTaxResidencyCertificatesDrawerUpsertMutation>;
export type AdminTaxResidencyCertificatesDrawerUpsertMutationResult = ApolloReact.MutationResult<AdminTaxResidencyCertificatesDrawerUpsertMutation>;
export type AdminTaxResidencyCertificatesDrawerUpsertMutationOptions = Apollo.MutationOptions<AdminTaxResidencyCertificatesDrawerUpsertMutation, AdminTaxResidencyCertificatesDrawerUpsertMutationVariables>;
export const AdminTaxResidencyCertificatesDrawerDeleteDocument = /*#__PURE__*/ gql`
    mutation Admin_TaxResidencyCertificatesDrawer_Delete($certId: TaxResidencyCertificateId!) {
  deleteTaxResidencyCertificate(certId: $certId) {
    ...NfsError
    ... on UnitResponse {
      value
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAdminTaxResidencyCertificatesDrawerDeleteMutation__
 *
 * To run a mutation, you first call `useAdminTaxResidencyCertificatesDrawerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTaxResidencyCertificatesDrawerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTaxResidencyCertificatesDrawerDeleteMutation, { data, loading, error }] = useAdminTaxResidencyCertificatesDrawerDeleteMutation({
 *   variables: {
 *      certId: // value for 'certId'
 *   },
 * });
 */
export function useAdminTaxResidencyCertificatesDrawerDeleteMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminTaxResidencyCertificatesDrawerDeleteMutation, AdminTaxResidencyCertificatesDrawerDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTaxResidencyCertificatesDrawerDeleteDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminTaxResidencyCertificatesDrawerDeleteMutation, AdminTaxResidencyCertificatesDrawerDeleteMutationVariables>(AdminTaxResidencyCertificatesDrawerDeleteDocument, parser(options)));
      }
export type AdminTaxResidencyCertificatesDrawerDeleteMutationHookResult = ReturnType<typeof useAdminTaxResidencyCertificatesDrawerDeleteMutation>;
export type AdminTaxResidencyCertificatesDrawerDeleteMutationResult = ApolloReact.MutationResult<AdminTaxResidencyCertificatesDrawerDeleteMutation>;
export type AdminTaxResidencyCertificatesDrawerDeleteMutationOptions = Apollo.MutationOptions<AdminTaxResidencyCertificatesDrawerDeleteMutation, AdminTaxResidencyCertificatesDrawerDeleteMutationVariables>;
export const TerminateContractModalDocument = /*#__PURE__*/ gql`
    mutation TerminateContractModal($contractId: ContractId!, $entityVersion: EntityVersion!, $date: LocalDate!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    terminate(date: $date) {
      ...NfsError
      ... on ContractResponse {
        value {
          id
          entityVersion
          status
          terminationDate
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTerminateContractModalMutation__
 *
 * To run a mutation, you first call `useTerminateContractModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateContractModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateContractModalMutation, { data, loading, error }] = useTerminateContractModalMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTerminateContractModalMutation(baseOptions?: ApolloReact.MutationHookOptions<TerminateContractModalMutation, TerminateContractModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TerminateContractModalDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TerminateContractModalMutation, TerminateContractModalMutationVariables>(TerminateContractModalDocument, parser(options)));
      }
export type TerminateContractModalMutationHookResult = ReturnType<typeof useTerminateContractModalMutation>;
export type TerminateContractModalMutationResult = ApolloReact.MutationResult<TerminateContractModalMutation>;
export type TerminateContractModalMutationOptions = Apollo.MutationOptions<TerminateContractModalMutation, TerminateContractModalMutationVariables>;
export const TerminateContractModalInfoDocument = /*#__PURE__*/ gql`
    query TerminateContractModal_Info($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        startDate
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useTerminateContractModalInfoQuery__
 *
 * To run a query within a React component, call `useTerminateContractModalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerminateContractModalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerminateContractModalInfoQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useTerminateContractModalInfoQuery(baseOptions: ApolloReact.QueryHookOptions<TerminateContractModalInfoQuery, TerminateContractModalInfoQueryVariables> & ({ variables: TerminateContractModalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TerminateContractModalInfoDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TerminateContractModalInfoQuery, TerminateContractModalInfoQueryVariables>(TerminateContractModalInfoDocument, parser(options)));
      }
export function useTerminateContractModalInfoLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TerminateContractModalInfoQuery, TerminateContractModalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TerminateContractModalInfoDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TerminateContractModalInfoQuery, TerminateContractModalInfoQueryVariables>(TerminateContractModalInfoDocument, options));
        }

export type TerminateContractModalInfoQueryResult = ApolloReact.QueryResult<TerminateContractModalInfoQuery, TerminateContractModalInfoQueryVariables>;
export function refetchTerminateContractModalInfoQuery(variables: TerminateContractModalInfoQueryVariables) {
      return { query: TerminateContractModalInfoDocument, variables: variables }
    }
export const TimeReportsReportDrawerGenerateForProjectDocument = /*#__PURE__*/ gql`
    mutation TimeReportsReportDrawer_GenerateForProject($projectId: ProjectId!, $period: ClosedEndLocalDateRangeInput!) {
  generateProjectTimeReport(projectId: $projectId, period: $period) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTimeReportsReportDrawerGenerateForProjectMutation__
 *
 * To run a mutation, you first call `useTimeReportsReportDrawerGenerateForProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportsReportDrawerGenerateForProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportsReportDrawerGenerateForProjectMutation, { data, loading, error }] = useTimeReportsReportDrawerGenerateForProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useTimeReportsReportDrawerGenerateForProjectMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportsReportDrawerGenerateForProjectMutation, TimeReportsReportDrawerGenerateForProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportsReportDrawerGenerateForProjectDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportsReportDrawerGenerateForProjectMutation, TimeReportsReportDrawerGenerateForProjectMutationVariables>(TimeReportsReportDrawerGenerateForProjectDocument, parser(options)));
      }
export type TimeReportsReportDrawerGenerateForProjectMutationHookResult = ReturnType<typeof useTimeReportsReportDrawerGenerateForProjectMutation>;
export type TimeReportsReportDrawerGenerateForProjectMutationResult = ApolloReact.MutationResult<TimeReportsReportDrawerGenerateForProjectMutation>;
export type TimeReportsReportDrawerGenerateForProjectMutationOptions = Apollo.MutationOptions<TimeReportsReportDrawerGenerateForProjectMutation, TimeReportsReportDrawerGenerateForProjectMutationVariables>;
export const TimeReportsReportDrawerGoogleDocForProjectDocument = /*#__PURE__*/ gql`
    query TimeReportsReportDrawer_GoogleDocForProject($projectId: ProjectId!, $period: ClosedEndLocalDateRangeInput!) {
  projectTimeReport(projectId: $projectId, period: $period) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useTimeReportsReportDrawerGoogleDocForProjectQuery__
 *
 * To run a query within a React component, call `useTimeReportsReportDrawerGoogleDocForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportsReportDrawerGoogleDocForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportsReportDrawerGoogleDocForProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useTimeReportsReportDrawerGoogleDocForProjectQuery(baseOptions: ApolloReact.QueryHookOptions<TimeReportsReportDrawerGoogleDocForProjectQuery, TimeReportsReportDrawerGoogleDocForProjectQueryVariables> & ({ variables: TimeReportsReportDrawerGoogleDocForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportsReportDrawerGoogleDocForProjectDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TimeReportsReportDrawerGoogleDocForProjectQuery, TimeReportsReportDrawerGoogleDocForProjectQueryVariables>(TimeReportsReportDrawerGoogleDocForProjectDocument, parser(options)));
      }
export function useTimeReportsReportDrawerGoogleDocForProjectLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TimeReportsReportDrawerGoogleDocForProjectQuery, TimeReportsReportDrawerGoogleDocForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TimeReportsReportDrawerGoogleDocForProjectDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TimeReportsReportDrawerGoogleDocForProjectQuery, TimeReportsReportDrawerGoogleDocForProjectQueryVariables>(TimeReportsReportDrawerGoogleDocForProjectDocument, options));
        }

export type TimeReportsReportDrawerGoogleDocForProjectQueryResult = ApolloReact.QueryResult<TimeReportsReportDrawerGoogleDocForProjectQuery, TimeReportsReportDrawerGoogleDocForProjectQueryVariables>;
export function refetchTimeReportsReportDrawerGoogleDocForProjectQuery(variables: TimeReportsReportDrawerGoogleDocForProjectQueryVariables) {
      return { query: TimeReportsReportDrawerGoogleDocForProjectDocument, variables: variables }
    }
export const TimeReportsReportDrawerGenerateForClientDocument = /*#__PURE__*/ gql`
    mutation TimeReportsReportDrawer_GenerateForClient($clientContractId: ClientContractId!, $period: ClosedEndLocalDateRangeInput!) {
  generateClientTimeReport(clientContractId: $clientContractId, period: $period) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTimeReportsReportDrawerGenerateForClientMutation__
 *
 * To run a mutation, you first call `useTimeReportsReportDrawerGenerateForClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportsReportDrawerGenerateForClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportsReportDrawerGenerateForClientMutation, { data, loading, error }] = useTimeReportsReportDrawerGenerateForClientMutation({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useTimeReportsReportDrawerGenerateForClientMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportsReportDrawerGenerateForClientMutation, TimeReportsReportDrawerGenerateForClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportsReportDrawerGenerateForClientDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportsReportDrawerGenerateForClientMutation, TimeReportsReportDrawerGenerateForClientMutationVariables>(TimeReportsReportDrawerGenerateForClientDocument, parser(options)));
      }
export type TimeReportsReportDrawerGenerateForClientMutationHookResult = ReturnType<typeof useTimeReportsReportDrawerGenerateForClientMutation>;
export type TimeReportsReportDrawerGenerateForClientMutationResult = ApolloReact.MutationResult<TimeReportsReportDrawerGenerateForClientMutation>;
export type TimeReportsReportDrawerGenerateForClientMutationOptions = Apollo.MutationOptions<TimeReportsReportDrawerGenerateForClientMutation, TimeReportsReportDrawerGenerateForClientMutationVariables>;
export const TimeReportsReportDrawerGoogleDocForClientDocument = /*#__PURE__*/ gql`
    query TimeReportsReportDrawer_GoogleDocForClient($clientContractId: ClientContractId!, $period: ClosedEndLocalDateRangeInput!) {
  clientTimeReport(clientContractId: $clientContractId, period: $period) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useTimeReportsReportDrawerGoogleDocForClientQuery__
 *
 * To run a query within a React component, call `useTimeReportsReportDrawerGoogleDocForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportsReportDrawerGoogleDocForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportsReportDrawerGoogleDocForClientQuery({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useTimeReportsReportDrawerGoogleDocForClientQuery(baseOptions: ApolloReact.QueryHookOptions<TimeReportsReportDrawerGoogleDocForClientQuery, TimeReportsReportDrawerGoogleDocForClientQueryVariables> & ({ variables: TimeReportsReportDrawerGoogleDocForClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportsReportDrawerGoogleDocForClientDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TimeReportsReportDrawerGoogleDocForClientQuery, TimeReportsReportDrawerGoogleDocForClientQueryVariables>(TimeReportsReportDrawerGoogleDocForClientDocument, parser(options)));
      }
export function useTimeReportsReportDrawerGoogleDocForClientLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TimeReportsReportDrawerGoogleDocForClientQuery, TimeReportsReportDrawerGoogleDocForClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TimeReportsReportDrawerGoogleDocForClientDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TimeReportsReportDrawerGoogleDocForClientQuery, TimeReportsReportDrawerGoogleDocForClientQueryVariables>(TimeReportsReportDrawerGoogleDocForClientDocument, options));
        }

export type TimeReportsReportDrawerGoogleDocForClientQueryResult = ApolloReact.QueryResult<TimeReportsReportDrawerGoogleDocForClientQuery, TimeReportsReportDrawerGoogleDocForClientQueryVariables>;
export function refetchTimeReportsReportDrawerGoogleDocForClientQuery(variables: TimeReportsReportDrawerGoogleDocForClientQueryVariables) {
      return { query: TimeReportsReportDrawerGoogleDocForClientDocument, variables: variables }
    }
export const TimeReportsReportFormCompanyAutocompleteDocument = /*#__PURE__*/ gql`
    query TimeReportsReportForm_CompanyAutocomplete($allSearch: String, $after: Cursor, $first: Int!) {
  companies(
    first: $first
    after: $after
    filter: {all_search: $allSearch, companyType_oneOf: [Client]}
  ) {
    ...NfsError
    ... on FSPResponseCompany {
      hasNextPage
      edges {
        cursor
        node {
          ...CompanyAutocomplete_Company
          clientContracts {
            ...Unauthorized
            ... on AccessGranted__ListOfClientContract {
              value {
                id
                entityVersion
                name {
                  ...Unauthorized
                  ... on AccessGranted__String {
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CompanyAutocompleteCompanyFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useTimeReportsReportFormCompanyAutocompleteQuery__
 *
 * To run a query within a React component, call `useTimeReportsReportFormCompanyAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportsReportFormCompanyAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportsReportFormCompanyAutocompleteQuery({
 *   variables: {
 *      allSearch: // value for 'allSearch'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useTimeReportsReportFormCompanyAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<TimeReportsReportFormCompanyAutocompleteQuery, TimeReportsReportFormCompanyAutocompleteQueryVariables> & ({ variables: TimeReportsReportFormCompanyAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportsReportFormCompanyAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TimeReportsReportFormCompanyAutocompleteQuery, TimeReportsReportFormCompanyAutocompleteQueryVariables>(TimeReportsReportFormCompanyAutocompleteDocument, parser(options)));
      }
export function useTimeReportsReportFormCompanyAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TimeReportsReportFormCompanyAutocompleteQuery, TimeReportsReportFormCompanyAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TimeReportsReportFormCompanyAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TimeReportsReportFormCompanyAutocompleteQuery, TimeReportsReportFormCompanyAutocompleteQueryVariables>(TimeReportsReportFormCompanyAutocompleteDocument, options));
        }

export type TimeReportsReportFormCompanyAutocompleteQueryResult = ApolloReact.QueryResult<TimeReportsReportFormCompanyAutocompleteQuery, TimeReportsReportFormCompanyAutocompleteQueryVariables>;
export function refetchTimeReportsReportFormCompanyAutocompleteQuery(variables: TimeReportsReportFormCompanyAutocompleteQueryVariables) {
      return { query: TimeReportsReportFormCompanyAutocompleteDocument, variables: variables }
    }
export const TimeReportsReportFormClientInfoDocument = /*#__PURE__*/ gql`
    query TimeReportsReportForm_ClientInfo($companyId: CompanyId!) {
  company(id: $companyId) {
    ...NfsError
    ... on Company {
      id
      entityVersion
      clientContracts {
        ...Unauthorized
        ... on AccessGranted__ListOfClientContract {
          value {
            id
            projects {
              id
              name
              statusHistory {
                status
                dateRange {
                  from
                  to
                }
              }
              assignedUsers {
                user {
                  id
                }
                project {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useTimeReportsReportFormClientInfoQuery__
 *
 * To run a query within a React component, call `useTimeReportsReportFormClientInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportsReportFormClientInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportsReportFormClientInfoQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useTimeReportsReportFormClientInfoQuery(baseOptions: ApolloReact.QueryHookOptions<TimeReportsReportFormClientInfoQuery, TimeReportsReportFormClientInfoQueryVariables> & ({ variables: TimeReportsReportFormClientInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportsReportFormClientInfoDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TimeReportsReportFormClientInfoQuery, TimeReportsReportFormClientInfoQueryVariables>(TimeReportsReportFormClientInfoDocument, parser(options)));
      }
export function useTimeReportsReportFormClientInfoLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TimeReportsReportFormClientInfoQuery, TimeReportsReportFormClientInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TimeReportsReportFormClientInfoDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TimeReportsReportFormClientInfoQuery, TimeReportsReportFormClientInfoQueryVariables>(TimeReportsReportFormClientInfoDocument, options));
        }

export type TimeReportsReportFormClientInfoQueryResult = ApolloReact.QueryResult<TimeReportsReportFormClientInfoQuery, TimeReportsReportFormClientInfoQueryVariables>;
export function refetchTimeReportsReportFormClientInfoQuery(variables: TimeReportsReportFormClientInfoQueryVariables) {
      return { query: TimeReportsReportFormClientInfoDocument, variables: variables }
    }
export const TimeReportsReportFormPeriodsDocument = /*#__PURE__*/ gql`
    query TimeReportsReportForm_Periods($clientContractId: ClientContractId!) {
  reportingPeriods(clientContractId: $clientContractId) {
    ...NfsError
    ... on ListOfReportingPeriodResponse {
      value {
        id
        clientContractId
        from
        to
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useTimeReportsReportFormPeriodsQuery__
 *
 * To run a query within a React component, call `useTimeReportsReportFormPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportsReportFormPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportsReportFormPeriodsQuery({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *   },
 * });
 */
export function useTimeReportsReportFormPeriodsQuery(baseOptions: ApolloReact.QueryHookOptions<TimeReportsReportFormPeriodsQuery, TimeReportsReportFormPeriodsQueryVariables> & ({ variables: TimeReportsReportFormPeriodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportsReportFormPeriodsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TimeReportsReportFormPeriodsQuery, TimeReportsReportFormPeriodsQueryVariables>(TimeReportsReportFormPeriodsDocument, parser(options)));
      }
export function useTimeReportsReportFormPeriodsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TimeReportsReportFormPeriodsQuery, TimeReportsReportFormPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TimeReportsReportFormPeriodsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TimeReportsReportFormPeriodsQuery, TimeReportsReportFormPeriodsQueryVariables>(TimeReportsReportFormPeriodsDocument, options));
        }

export type TimeReportsReportFormPeriodsQueryResult = ApolloReact.QueryResult<TimeReportsReportFormPeriodsQuery, TimeReportsReportFormPeriodsQueryVariables>;
export function refetchTimeReportsReportFormPeriodsQuery(variables: TimeReportsReportFormPeriodsQueryVariables) {
      return { query: TimeReportsReportFormPeriodsDocument, variables: variables }
    }
export const TrainingPackageReportDrawerDocument = /*#__PURE__*/ gql`
    query TrainingPackageReportDrawer {
  trainingBudgetSummaryReport {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useTrainingPackageReportDrawerQuery__
 *
 * To run a query within a React component, call `useTrainingPackageReportDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingPackageReportDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingPackageReportDrawerQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrainingPackageReportDrawerQuery(baseOptions?: ApolloReact.QueryHookOptions<TrainingPackageReportDrawerQuery, TrainingPackageReportDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TrainingPackageReportDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TrainingPackageReportDrawerQuery, TrainingPackageReportDrawerQueryVariables>(TrainingPackageReportDrawerDocument, parser(options)));
      }
export function useTrainingPackageReportDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TrainingPackageReportDrawerQuery, TrainingPackageReportDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TrainingPackageReportDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TrainingPackageReportDrawerQuery, TrainingPackageReportDrawerQueryVariables>(TrainingPackageReportDrawerDocument, options));
        }

export type TrainingPackageReportDrawerQueryResult = ApolloReact.QueryResult<TrainingPackageReportDrawerQuery, TrainingPackageReportDrawerQueryVariables>;
export function refetchTrainingPackageReportDrawerQuery(variables?: TrainingPackageReportDrawerQueryVariables) {
      return { query: TrainingPackageReportDrawerDocument, variables: variables }
    }
export const TrainingPackageReportDrawerRegenerateDocument = /*#__PURE__*/ gql`
    mutation TrainingPackageReportDrawer_Regenerate {
  generateTrainingBudgetSummaryReport {
    ...NfsError
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTrainingPackageReportDrawerRegenerateMutation__
 *
 * To run a mutation, you first call `useTrainingPackageReportDrawerRegenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrainingPackageReportDrawerRegenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trainingPackageReportDrawerRegenerateMutation, { data, loading, error }] = useTrainingPackageReportDrawerRegenerateMutation({
 *   variables: {
 *   },
 * });
 */
export function useTrainingPackageReportDrawerRegenerateMutation(baseOptions?: ApolloReact.MutationHookOptions<TrainingPackageReportDrawerRegenerateMutation, TrainingPackageReportDrawerRegenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TrainingPackageReportDrawerRegenerateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TrainingPackageReportDrawerRegenerateMutation, TrainingPackageReportDrawerRegenerateMutationVariables>(TrainingPackageReportDrawerRegenerateDocument, parser(options)));
      }
export type TrainingPackageReportDrawerRegenerateMutationHookResult = ReturnType<typeof useTrainingPackageReportDrawerRegenerateMutation>;
export type TrainingPackageReportDrawerRegenerateMutationResult = ApolloReact.MutationResult<TrainingPackageReportDrawerRegenerateMutation>;
export type TrainingPackageReportDrawerRegenerateMutationOptions = Apollo.MutationOptions<TrainingPackageReportDrawerRegenerateMutation, TrainingPackageReportDrawerRegenerateMutationVariables>;
export const TransferDetailsDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query TransferDetailsDrawer_InitialData($id: BankTransferId!) {
  bankTransfer(id: $id) {
    ...NfsError
    ... on BankTransferResponse {
      value {
        ...BankTransfers_BankTransfer
        ... on BankIncomeTransfer {
          discrepancy
          connectedPayments {
            ...TransferDetailsDrawer_PaymentConnection
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankTransfersBankTransferFragmentDoc}
${TransferDetailsDrawerPaymentConnectionFragmentDoc}`;

/**
 * __useTransferDetailsDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useTransferDetailsDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferDetailsDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferDetailsDrawerInitialDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransferDetailsDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<TransferDetailsDrawerInitialDataQuery, TransferDetailsDrawerInitialDataQueryVariables> & ({ variables: TransferDetailsDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TransferDetailsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TransferDetailsDrawerInitialDataQuery, TransferDetailsDrawerInitialDataQueryVariables>(TransferDetailsDrawerInitialDataDocument, parser(options)));
      }
export function useTransferDetailsDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TransferDetailsDrawerInitialDataQuery, TransferDetailsDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TransferDetailsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TransferDetailsDrawerInitialDataQuery, TransferDetailsDrawerInitialDataQueryVariables>(TransferDetailsDrawerInitialDataDocument, options));
        }

export type TransferDetailsDrawerInitialDataQueryResult = ApolloReact.QueryResult<TransferDetailsDrawerInitialDataQuery, TransferDetailsDrawerInitialDataQueryVariables>;
export function refetchTransferDetailsDrawerInitialDataQuery(variables: TransferDetailsDrawerInitialDataQueryVariables) {
      return { query: TransferDetailsDrawerInitialDataDocument, variables: variables }
    }
export const TransferDetailsDrawerInvoicesDocument = /*#__PURE__*/ gql`
    query TransferDetailsDrawer_Invoices($range: ClosedEndLocalDateRangeInput!, $allSearch: String) {
  salesInvoices(
    allSearch: $allSearch
    dateRange: $range
    searchDateType: IssueDate
    status_notIn: [PAID]
  ) {
    ...NfsError
    ... on ListOfSalesInvoiceResponse {
      value {
        ...TransferDetailsDrawer_Invoice
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${TransferDetailsDrawerInvoiceFragmentDoc}`;

/**
 * __useTransferDetailsDrawerInvoicesQuery__
 *
 * To run a query within a React component, call `useTransferDetailsDrawerInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferDetailsDrawerInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferDetailsDrawerInvoicesQuery({
 *   variables: {
 *      range: // value for 'range'
 *      allSearch: // value for 'allSearch'
 *   },
 * });
 */
export function useTransferDetailsDrawerInvoicesQuery(baseOptions: ApolloReact.QueryHookOptions<TransferDetailsDrawerInvoicesQuery, TransferDetailsDrawerInvoicesQueryVariables> & ({ variables: TransferDetailsDrawerInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TransferDetailsDrawerInvoicesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TransferDetailsDrawerInvoicesQuery, TransferDetailsDrawerInvoicesQueryVariables>(TransferDetailsDrawerInvoicesDocument, parser(options)));
      }
export function useTransferDetailsDrawerInvoicesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TransferDetailsDrawerInvoicesQuery, TransferDetailsDrawerInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TransferDetailsDrawerInvoicesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TransferDetailsDrawerInvoicesQuery, TransferDetailsDrawerInvoicesQueryVariables>(TransferDetailsDrawerInvoicesDocument, options));
        }

export type TransferDetailsDrawerInvoicesQueryResult = ApolloReact.QueryResult<TransferDetailsDrawerInvoicesQuery, TransferDetailsDrawerInvoicesQueryVariables>;
export function refetchTransferDetailsDrawerInvoicesQuery(variables: TransferDetailsDrawerInvoicesQueryVariables) {
      return { query: TransferDetailsDrawerInvoicesDocument, variables: variables }
    }
export const TransferDetailsDrawerCreateConnectionDocument = /*#__PURE__*/ gql`
    mutation TransferDetailsDrawer_CreateConnection($transferId: BankTransferId!, $invoiceId: SalesInvoiceId!) {
  createPaymentConnection(transferId: $transferId, invoiceId: $invoiceId) {
    ...NfsError
    ... on PaymentConnection {
      ...TransferDetailsDrawer_PaymentConnection
    }
  }
}
    ${NfsErrorFragmentDoc}
${TransferDetailsDrawerPaymentConnectionFragmentDoc}`;


/**
 * __useTransferDetailsDrawerCreateConnectionMutation__
 *
 * To run a mutation, you first call `useTransferDetailsDrawerCreateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferDetailsDrawerCreateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferDetailsDrawerCreateConnectionMutation, { data, loading, error }] = useTransferDetailsDrawerCreateConnectionMutation({
 *   variables: {
 *      transferId: // value for 'transferId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useTransferDetailsDrawerCreateConnectionMutation(baseOptions?: ApolloReact.MutationHookOptions<TransferDetailsDrawerCreateConnectionMutation, TransferDetailsDrawerCreateConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TransferDetailsDrawerCreateConnectionDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TransferDetailsDrawerCreateConnectionMutation, TransferDetailsDrawerCreateConnectionMutationVariables>(TransferDetailsDrawerCreateConnectionDocument, parser(options)));
      }
export type TransferDetailsDrawerCreateConnectionMutationHookResult = ReturnType<typeof useTransferDetailsDrawerCreateConnectionMutation>;
export type TransferDetailsDrawerCreateConnectionMutationResult = ApolloReact.MutationResult<TransferDetailsDrawerCreateConnectionMutation>;
export type TransferDetailsDrawerCreateConnectionMutationOptions = Apollo.MutationOptions<TransferDetailsDrawerCreateConnectionMutation, TransferDetailsDrawerCreateConnectionMutationVariables>;
export const TransferDetailsDrawerDeleteConnectionDocument = /*#__PURE__*/ gql`
    mutation TransferDetailsDrawer_DeleteConnection($transferId: BankTransferId!, $invoiceId: SalesInvoiceId!) {
  deletePaymentConnection(transferId: $transferId, invoiceId: $invoiceId) {
    ...NfsError
    ... on BankIncomeTransfer {
      ...BankTransfers_BankTransfer
      discrepancy
      connectedPayments {
        ...TransferDetailsDrawer_PaymentConnection
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankTransfersBankTransferFragmentDoc}
${TransferDetailsDrawerPaymentConnectionFragmentDoc}`;


/**
 * __useTransferDetailsDrawerDeleteConnectionMutation__
 *
 * To run a mutation, you first call `useTransferDetailsDrawerDeleteConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferDetailsDrawerDeleteConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferDetailsDrawerDeleteConnectionMutation, { data, loading, error }] = useTransferDetailsDrawerDeleteConnectionMutation({
 *   variables: {
 *      transferId: // value for 'transferId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useTransferDetailsDrawerDeleteConnectionMutation(baseOptions?: ApolloReact.MutationHookOptions<TransferDetailsDrawerDeleteConnectionMutation, TransferDetailsDrawerDeleteConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TransferDetailsDrawerDeleteConnectionDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TransferDetailsDrawerDeleteConnectionMutation, TransferDetailsDrawerDeleteConnectionMutationVariables>(TransferDetailsDrawerDeleteConnectionDocument, parser(options)));
      }
export type TransferDetailsDrawerDeleteConnectionMutationHookResult = ReturnType<typeof useTransferDetailsDrawerDeleteConnectionMutation>;
export type TransferDetailsDrawerDeleteConnectionMutationResult = ApolloReact.MutationResult<TransferDetailsDrawerDeleteConnectionMutation>;
export type TransferDetailsDrawerDeleteConnectionMutationOptions = Apollo.MutationOptions<TransferDetailsDrawerDeleteConnectionMutation, TransferDetailsDrawerDeleteConnectionMutationVariables>;
export const TransferDetailsDrawerUpdateTransferDocument = /*#__PURE__*/ gql`
    mutation TransferDetailsDrawer_UpdateTransfer($transferId: BankTransferId!, $status: BankTransferStatus, $note: ClearableStringInput, $title: String, $amount: Cents, $currency: Currency, $fromName: String, $toName: String) {
  bankTransfer(id: $transferId) {
    update(
      status: $status
      note: $note
      title: $title
      amount: $amount
      currency: $currency
      fromName: $fromName
      toName: $toName
    ) {
      ...NfsError
      ... on BankTransferResponse {
        value {
          ...BankTransfers_BankTransfer
          ... on BankIncomeTransfer {
            discrepancy
            connectedPayments {
              ...TransferDetailsDrawer_PaymentConnection
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankTransfersBankTransferFragmentDoc}
${TransferDetailsDrawerPaymentConnectionFragmentDoc}`;


/**
 * __useTransferDetailsDrawerUpdateTransferMutation__
 *
 * To run a mutation, you first call `useTransferDetailsDrawerUpdateTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferDetailsDrawerUpdateTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferDetailsDrawerUpdateTransferMutation, { data, loading, error }] = useTransferDetailsDrawerUpdateTransferMutation({
 *   variables: {
 *      transferId: // value for 'transferId'
 *      status: // value for 'status'
 *      note: // value for 'note'
 *      title: // value for 'title'
 *      amount: // value for 'amount'
 *      currency: // value for 'currency'
 *      fromName: // value for 'fromName'
 *      toName: // value for 'toName'
 *   },
 * });
 */
export function useTransferDetailsDrawerUpdateTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<TransferDetailsDrawerUpdateTransferMutation, TransferDetailsDrawerUpdateTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TransferDetailsDrawerUpdateTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TransferDetailsDrawerUpdateTransferMutation, TransferDetailsDrawerUpdateTransferMutationVariables>(TransferDetailsDrawerUpdateTransferDocument, parser(options)));
      }
export type TransferDetailsDrawerUpdateTransferMutationHookResult = ReturnType<typeof useTransferDetailsDrawerUpdateTransferMutation>;
export type TransferDetailsDrawerUpdateTransferMutationResult = ApolloReact.MutationResult<TransferDetailsDrawerUpdateTransferMutation>;
export type TransferDetailsDrawerUpdateTransferMutationOptions = Apollo.MutationOptions<TransferDetailsDrawerUpdateTransferMutation, TransferDetailsDrawerUpdateTransferMutationVariables>;
export const TransferListExportDrawerGenerateDocument = /*#__PURE__*/ gql`
    mutation TransferListExportDrawer_Generate($filter: FilterBankTransferInput!) {
  exportTransfers(filter: $filter) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTransferListExportDrawerGenerateMutation__
 *
 * To run a mutation, you first call `useTransferListExportDrawerGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferListExportDrawerGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferListExportDrawerGenerateMutation, { data, loading, error }] = useTransferListExportDrawerGenerateMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTransferListExportDrawerGenerateMutation(baseOptions?: ApolloReact.MutationHookOptions<TransferListExportDrawerGenerateMutation, TransferListExportDrawerGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TransferListExportDrawerGenerateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TransferListExportDrawerGenerateMutation, TransferListExportDrawerGenerateMutationVariables>(TransferListExportDrawerGenerateDocument, parser(options)));
      }
export type TransferListExportDrawerGenerateMutationHookResult = ReturnType<typeof useTransferListExportDrawerGenerateMutation>;
export type TransferListExportDrawerGenerateMutationResult = ApolloReact.MutationResult<TransferListExportDrawerGenerateMutation>;
export type TransferListExportDrawerGenerateMutationOptions = Apollo.MutationOptions<TransferListExportDrawerGenerateMutation, TransferListExportDrawerGenerateMutationVariables>;
export const TransfersSummaryModalDocument = /*#__PURE__*/ gql`
    query TransfersSummaryModal($yearMonth: YearMonth!, $filter: FilterContractSalaryDetailsInput!) {
  contractSalarySummariesWithFilter(yearMonth: $yearMonth, filter: $filter) {
    ...NfsError
    ... on ListOfTransfersSummariesResponse {
      value {
        yearMonth
        b2b {
          totalCount
          paymentDisbursedState {
            ...TransfersSummaryModal_B2BTransfersSummary
          }
          readyState {
            ...TransfersSummaryModal_B2BTransfersSummary
          }
          incompleteDataState {
            transfersSummary {
              ...TransfersSummaryModal_B2BTransfersSummary
            }
          }
        }
        employment {
          totalCount
          paymentDisbursedState {
            ...TransfersSummaryModal_EmploymentTransfersSummary
          }
          readyState {
            ...TransfersSummaryModal_EmploymentTransfersSummary
          }
          incompleteDataState {
            transfersSummary {
              ...TransfersSummaryModal_EmploymentTransfersSummary
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${TransfersSummaryModalB2BTransfersSummaryFragmentDoc}
${TransfersSummaryModalEmploymentTransfersSummaryFragmentDoc}`;

/**
 * __useTransfersSummaryModalQuery__
 *
 * To run a query within a React component, call `useTransfersSummaryModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransfersSummaryModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransfersSummaryModalQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTransfersSummaryModalQuery(baseOptions: ApolloReact.QueryHookOptions<TransfersSummaryModalQuery, TransfersSummaryModalQueryVariables> & ({ variables: TransfersSummaryModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TransfersSummaryModalDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TransfersSummaryModalQuery, TransfersSummaryModalQueryVariables>(TransfersSummaryModalDocument, parser(options)));
      }
export function useTransfersSummaryModalLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TransfersSummaryModalQuery, TransfersSummaryModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TransfersSummaryModalDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TransfersSummaryModalQuery, TransfersSummaryModalQueryVariables>(TransfersSummaryModalDocument, options));
        }

export type TransfersSummaryModalQueryResult = ApolloReact.QueryResult<TransfersSummaryModalQuery, TransfersSummaryModalQueryVariables>;
export function refetchTransfersSummaryModalQuery(variables: TransfersSummaryModalQueryVariables) {
      return { query: TransfersSummaryModalDocument, variables: variables }
    }
export const UopHolidaysReportDrawerGenerateDocument = /*#__PURE__*/ gql`
    mutation UopHolidaysReportDrawer_Generate($year: Year!) {
  generateHolidaySummaryDocument(year: $year) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useUopHolidaysReportDrawerGenerateMutation__
 *
 * To run a mutation, you first call `useUopHolidaysReportDrawerGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUopHolidaysReportDrawerGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uopHolidaysReportDrawerGenerateMutation, { data, loading, error }] = useUopHolidaysReportDrawerGenerateMutation({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useUopHolidaysReportDrawerGenerateMutation(baseOptions?: ApolloReact.MutationHookOptions<UopHolidaysReportDrawerGenerateMutation, UopHolidaysReportDrawerGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UopHolidaysReportDrawerGenerateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UopHolidaysReportDrawerGenerateMutation, UopHolidaysReportDrawerGenerateMutationVariables>(UopHolidaysReportDrawerGenerateDocument, parser(options)));
      }
export type UopHolidaysReportDrawerGenerateMutationHookResult = ReturnType<typeof useUopHolidaysReportDrawerGenerateMutation>;
export type UopHolidaysReportDrawerGenerateMutationResult = ApolloReact.MutationResult<UopHolidaysReportDrawerGenerateMutation>;
export type UopHolidaysReportDrawerGenerateMutationOptions = Apollo.MutationOptions<UopHolidaysReportDrawerGenerateMutation, UopHolidaysReportDrawerGenerateMutationVariables>;
export const UopHolidaysReportDrawerGoogleDocDocument = /*#__PURE__*/ gql`
    query UopHolidaysReportDrawer_GoogleDoc($year: Year!) {
  holidaySummaryDocument(year: $year) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useUopHolidaysReportDrawerGoogleDocQuery__
 *
 * To run a query within a React component, call `useUopHolidaysReportDrawerGoogleDocQuery` and pass it any options that fit your needs.
 * When your component renders, `useUopHolidaysReportDrawerGoogleDocQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUopHolidaysReportDrawerGoogleDocQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useUopHolidaysReportDrawerGoogleDocQuery(baseOptions: ApolloReact.QueryHookOptions<UopHolidaysReportDrawerGoogleDocQuery, UopHolidaysReportDrawerGoogleDocQueryVariables> & ({ variables: UopHolidaysReportDrawerGoogleDocQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UopHolidaysReportDrawerGoogleDocDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UopHolidaysReportDrawerGoogleDocQuery, UopHolidaysReportDrawerGoogleDocQueryVariables>(UopHolidaysReportDrawerGoogleDocDocument, parser(options)));
      }
export function useUopHolidaysReportDrawerGoogleDocLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UopHolidaysReportDrawerGoogleDocQuery, UopHolidaysReportDrawerGoogleDocQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UopHolidaysReportDrawerGoogleDocDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UopHolidaysReportDrawerGoogleDocQuery, UopHolidaysReportDrawerGoogleDocQueryVariables>(UopHolidaysReportDrawerGoogleDocDocument, options));
        }

export type UopHolidaysReportDrawerGoogleDocQueryResult = ApolloReact.QueryResult<UopHolidaysReportDrawerGoogleDocQuery, UopHolidaysReportDrawerGoogleDocQueryVariables>;
export function refetchUopHolidaysReportDrawerGoogleDocQuery(variables: UopHolidaysReportDrawerGoogleDocQueryVariables) {
      return { query: UopHolidaysReportDrawerGoogleDocDocument, variables: variables }
    }
export const UserDocumentsDocument = /*#__PURE__*/ gql`
    query UserDocuments($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...UserDocuments_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserDocumentsUserFragmentDoc}`;

/**
 * __useUserDocumentsQuery__
 *
 * To run a query within a React component, call `useUserDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDocumentsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDocumentsQuery(baseOptions: ApolloReact.QueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables> & ({ variables: UserDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserDocumentsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserDocumentsQuery, UserDocumentsQueryVariables>(UserDocumentsDocument, parser(options)));
      }
export function useUserDocumentsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserDocumentsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserDocumentsQuery, UserDocumentsQueryVariables>(UserDocumentsDocument, options));
        }

export type UserDocumentsQueryResult = ApolloReact.QueryResult<UserDocumentsQuery, UserDocumentsQueryVariables>;
export function refetchUserDocumentsQuery(variables: UserDocumentsQueryVariables) {
      return { query: UserDocumentsDocument, variables: variables }
    }
export const UserDocumentsUpdateUserDocument = /*#__PURE__*/ gql`
    mutation UserDocuments_UpdateUser($userId: UserId!, $entityVersion: EntityVersion!, $documentsDirectory: URI) {
  user(userId: $userId, entityVersion: $entityVersion) {
    updateUser(documentsDirectory: $documentsDirectory) {
      ...NfsError
      ... on User {
        ...UserDocuments_User
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserDocumentsUserFragmentDoc}`;


/**
 * __useUserDocumentsUpdateUserMutation__
 *
 * To run a mutation, you first call `useUserDocumentsUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDocumentsUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDocumentsUpdateUserMutation, { data, loading, error }] = useUserDocumentsUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityVersion: // value for 'entityVersion'
 *      documentsDirectory: // value for 'documentsDirectory'
 *   },
 * });
 */
export function useUserDocumentsUpdateUserMutation(baseOptions?: ApolloReact.MutationHookOptions<UserDocumentsUpdateUserMutation, UserDocumentsUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserDocumentsUpdateUserDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserDocumentsUpdateUserMutation, UserDocumentsUpdateUserMutationVariables>(UserDocumentsUpdateUserDocument, parser(options)));
      }
export type UserDocumentsUpdateUserMutationHookResult = ReturnType<typeof useUserDocumentsUpdateUserMutation>;
export type UserDocumentsUpdateUserMutationResult = ApolloReact.MutationResult<UserDocumentsUpdateUserMutation>;
export type UserDocumentsUpdateUserMutationOptions = Apollo.MutationOptions<UserDocumentsUpdateUserMutation, UserDocumentsUpdateUserMutationVariables>;
export const UserProgressionProgressionDocument = /*#__PURE__*/ gql`
    query UserProgression_Progression($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...ProgressionDetails_User
      firstName
      lastName
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            ...ProgressionDetails_Contract
            createdAt
            name
            notes {
              ...Unauthorized
              ... on AccessGranted__OptionalString {
                value
              }
            }
            ... on B2BContract {
              b2bContractType: type
            }
            ... on Subcontract {
              clientContract {
                ...Unauthorized
                ... on AccessGranted__ClientContract {
                  value {
                    id
                    promisee {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionDetailsUserFragmentDoc}
${UnauthorizedFragmentDoc}
${ProgressionDetailsContractFragmentDoc}`;

/**
 * __useUserProgressionProgressionQuery__
 *
 * To run a query within a React component, call `useUserProgressionProgressionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProgressionProgressionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProgressionProgressionQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProgressionProgressionQuery(baseOptions: ApolloReact.QueryHookOptions<UserProgressionProgressionQuery, UserProgressionProgressionQueryVariables> & ({ variables: UserProgressionProgressionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserProgressionProgressionDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserProgressionProgressionQuery, UserProgressionProgressionQueryVariables>(UserProgressionProgressionDocument, parser(options)));
      }
export function useUserProgressionProgressionLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserProgressionProgressionQuery, UserProgressionProgressionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserProgressionProgressionDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserProgressionProgressionQuery, UserProgressionProgressionQueryVariables>(UserProgressionProgressionDocument, options));
        }

export type UserProgressionProgressionQueryResult = ApolloReact.QueryResult<UserProgressionProgressionQuery, UserProgressionProgressionQueryVariables>;
export function refetchUserProgressionProgressionQuery(variables: UserProgressionProgressionQueryVariables) {
      return { query: UserProgressionProgressionDocument, variables: variables }
    }
export const UserProjectFormProjectInfoDocument = /*#__PURE__*/ gql`
    query UserProjectForm_ProjectInfo($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      id
      name
      entityVersion
      statusHistory {
        status
        dateRange {
          from
          to
        }
      }
      clientContract {
        ...UserProjectForm_ClientContract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserProjectFormClientContractFragmentDoc}`;

/**
 * __useUserProjectFormProjectInfoQuery__
 *
 * To run a query within a React component, call `useUserProjectFormProjectInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectFormProjectInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectFormProjectInfoQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUserProjectFormProjectInfoQuery(baseOptions: ApolloReact.QueryHookOptions<UserProjectFormProjectInfoQuery, UserProjectFormProjectInfoQueryVariables> & ({ variables: UserProjectFormProjectInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserProjectFormProjectInfoDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserProjectFormProjectInfoQuery, UserProjectFormProjectInfoQueryVariables>(UserProjectFormProjectInfoDocument, parser(options)));
      }
export function useUserProjectFormProjectInfoLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserProjectFormProjectInfoQuery, UserProjectFormProjectInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserProjectFormProjectInfoDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserProjectFormProjectInfoQuery, UserProjectFormProjectInfoQueryVariables>(UserProjectFormProjectInfoDocument, options));
        }

export type UserProjectFormProjectInfoQueryResult = ApolloReact.QueryResult<UserProjectFormProjectInfoQuery, UserProjectFormProjectInfoQueryVariables>;
export function refetchUserProjectFormProjectInfoQuery(variables: UserProjectFormProjectInfoQueryVariables) {
      return { query: UserProjectFormProjectInfoDocument, variables: variables }
    }
export const UserProjectFormIntraCompanyContractsDocument = /*#__PURE__*/ gql`
    query UserProjectForm_IntraCompanyContracts($promisorId: CompanyId!, $promiseeId: CompanyId!) {
  clientContractsBetweenCompanies(
    promisorId: $promisorId
    promiseeId: $promiseeId
  ) {
    ...NfsError
    ... on ListOfClientContractResponse {
      value {
        ...ProjectMembersDrawer_ClientContract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProjectMembersDrawerClientContractFragmentDoc}`;

/**
 * __useUserProjectFormIntraCompanyContractsQuery__
 *
 * To run a query within a React component, call `useUserProjectFormIntraCompanyContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectFormIntraCompanyContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectFormIntraCompanyContractsQuery({
 *   variables: {
 *      promisorId: // value for 'promisorId'
 *      promiseeId: // value for 'promiseeId'
 *   },
 * });
 */
export function useUserProjectFormIntraCompanyContractsQuery(baseOptions: ApolloReact.QueryHookOptions<UserProjectFormIntraCompanyContractsQuery, UserProjectFormIntraCompanyContractsQueryVariables> & ({ variables: UserProjectFormIntraCompanyContractsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserProjectFormIntraCompanyContractsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserProjectFormIntraCompanyContractsQuery, UserProjectFormIntraCompanyContractsQueryVariables>(UserProjectFormIntraCompanyContractsDocument, parser(options)));
      }
export function useUserProjectFormIntraCompanyContractsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserProjectFormIntraCompanyContractsQuery, UserProjectFormIntraCompanyContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserProjectFormIntraCompanyContractsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserProjectFormIntraCompanyContractsQuery, UserProjectFormIntraCompanyContractsQueryVariables>(UserProjectFormIntraCompanyContractsDocument, options));
        }

export type UserProjectFormIntraCompanyContractsQueryResult = ApolloReact.QueryResult<UserProjectFormIntraCompanyContractsQuery, UserProjectFormIntraCompanyContractsQueryVariables>;
export function refetchUserProjectFormIntraCompanyContractsQuery(variables: UserProjectFormIntraCompanyContractsQueryVariables) {
      return { query: UserProjectFormIntraCompanyContractsDocument, variables: variables }
    }
export const UserProjectsDrawerInitialDataDocument = /*#__PURE__*/ gql`
    query UserProjectsDrawer_InitialData($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      progressionLevel {
        value
      }
      directReporting {
        assignedProjects {
          ...Unauthorized
          ... on AccessGranted__ListOfProjectAssignment {
            value {
              ...UserProjectsDrawer_ProjectAssignment
            }
          }
        }
      }
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            status
            startDate
            terminationDate
            promisor {
              value {
                id
                name
              }
            }
            ... on Subcontract {
              clientContract {
                ...Unauthorized
                ... on AccessGranted__ClientContract {
                  value {
                    id
                    positions {
                      ...Unauthorized
                      ... on AccessGranted__ListOfClientPosition {
                        value {
                          id
                          name
                          active {
                            value
                            futureUpdates {
                              activityId
                              value
                              applyDate
                            }
                            history {
                              activityId
                              value
                              applyDate
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${UserProjectsDrawerProjectAssignmentFragmentDoc}`;

/**
 * __useUserProjectsDrawerInitialDataQuery__
 *
 * To run a query within a React component, call `useUserProjectsDrawerInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectsDrawerInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectsDrawerInitialDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProjectsDrawerInitialDataQuery(baseOptions: ApolloReact.QueryHookOptions<UserProjectsDrawerInitialDataQuery, UserProjectsDrawerInitialDataQueryVariables> & ({ variables: UserProjectsDrawerInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserProjectsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserProjectsDrawerInitialDataQuery, UserProjectsDrawerInitialDataQueryVariables>(UserProjectsDrawerInitialDataDocument, parser(options)));
      }
export function useUserProjectsDrawerInitialDataLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserProjectsDrawerInitialDataQuery, UserProjectsDrawerInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserProjectsDrawerInitialDataDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserProjectsDrawerInitialDataQuery, UserProjectsDrawerInitialDataQueryVariables>(UserProjectsDrawerInitialDataDocument, options));
        }

export type UserProjectsDrawerInitialDataQueryResult = ApolloReact.QueryResult<UserProjectsDrawerInitialDataQuery, UserProjectsDrawerInitialDataQueryVariables>;
export function refetchUserProjectsDrawerInitialDataQuery(variables: UserProjectsDrawerInitialDataQueryVariables) {
      return { query: UserProjectsDrawerInitialDataDocument, variables: variables }
    }
export const UserProjectDrawerUpdateAssignmentDocument = /*#__PURE__*/ gql`
    mutation UserProjectDrawer_UpdateAssignment($projectId: ProjectId!, $entityVersion: EntityVersion!, $state: CreateProjectAssignmentInput!) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    projectAssignments {
      upsertProjectAssignment(input: $state) {
        ...NfsError
        ... on ProjectAssignment {
          ...UserProjectsDrawer_ProjectAssignment_Update
          project {
            ...ProjectLead
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserProjectsDrawerProjectAssignmentUpdateFragmentDoc}
${ProjectLeadFragmentDoc}`;


/**
 * __useUserProjectDrawerUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useUserProjectDrawerUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProjectDrawerUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProjectDrawerUpdateAssignmentMutation, { data, loading, error }] = useUserProjectDrawerUpdateAssignmentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUserProjectDrawerUpdateAssignmentMutation(baseOptions?: ApolloReact.MutationHookOptions<UserProjectDrawerUpdateAssignmentMutation, UserProjectDrawerUpdateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserProjectDrawerUpdateAssignmentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserProjectDrawerUpdateAssignmentMutation, UserProjectDrawerUpdateAssignmentMutationVariables>(UserProjectDrawerUpdateAssignmentDocument, parser(options)));
      }
export type UserProjectDrawerUpdateAssignmentMutationHookResult = ReturnType<typeof useUserProjectDrawerUpdateAssignmentMutation>;
export type UserProjectDrawerUpdateAssignmentMutationResult = ApolloReact.MutationResult<UserProjectDrawerUpdateAssignmentMutation>;
export type UserProjectDrawerUpdateAssignmentMutationOptions = Apollo.MutationOptions<UserProjectDrawerUpdateAssignmentMutation, UserProjectDrawerUpdateAssignmentMutationVariables>;
export const UserProjectDrawerUpdateInternalAssignmentDocument = /*#__PURE__*/ gql`
    mutation UserProjectDrawer_UpdateInternalAssignment($projectId: ProjectId!, $entityVersion: EntityVersion!, $state: CreateInternalProjectAssignmentInput!) {
  internalProject(projectId: $projectId, entityVersion: $entityVersion) {
    upsertInternalProjectAssignment(input: $state) {
      ...NfsError
      ... on ProjectAssignment {
        ...UserProjectsDrawer_ProjectAssignment
        project {
          ...ProjectLead
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserProjectsDrawerProjectAssignmentFragmentDoc}
${ProjectLeadFragmentDoc}`;


/**
 * __useUserProjectDrawerUpdateInternalAssignmentMutation__
 *
 * To run a mutation, you first call `useUserProjectDrawerUpdateInternalAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProjectDrawerUpdateInternalAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProjectDrawerUpdateInternalAssignmentMutation, { data, loading, error }] = useUserProjectDrawerUpdateInternalAssignmentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUserProjectDrawerUpdateInternalAssignmentMutation(baseOptions?: ApolloReact.MutationHookOptions<UserProjectDrawerUpdateInternalAssignmentMutation, UserProjectDrawerUpdateInternalAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserProjectDrawerUpdateInternalAssignmentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserProjectDrawerUpdateInternalAssignmentMutation, UserProjectDrawerUpdateInternalAssignmentMutationVariables>(UserProjectDrawerUpdateInternalAssignmentDocument, parser(options)));
      }
export type UserProjectDrawerUpdateInternalAssignmentMutationHookResult = ReturnType<typeof useUserProjectDrawerUpdateInternalAssignmentMutation>;
export type UserProjectDrawerUpdateInternalAssignmentMutationResult = ApolloReact.MutationResult<UserProjectDrawerUpdateInternalAssignmentMutation>;
export type UserProjectDrawerUpdateInternalAssignmentMutationOptions = Apollo.MutationOptions<UserProjectDrawerUpdateInternalAssignmentMutation, UserProjectDrawerUpdateInternalAssignmentMutationVariables>;
export const UserProjectsDrawerRemoveAssignmentDocument = /*#__PURE__*/ gql`
    mutation UserProjectsDrawer_RemoveAssignment($projectId: ProjectId!, $entityVersion: EntityVersion!, $userId: UserId!) {
  project(projectId: $projectId, entityVersion: $entityVersion) {
    projectAssignments {
      deleteProjectAssignment(value: $userId) {
        ...NfsError
        ... on UnitResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useUserProjectsDrawerRemoveAssignmentMutation__
 *
 * To run a mutation, you first call `useUserProjectsDrawerRemoveAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProjectsDrawerRemoveAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProjectsDrawerRemoveAssignmentMutation, { data, loading, error }] = useUserProjectsDrawerRemoveAssignmentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityVersion: // value for 'entityVersion'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProjectsDrawerRemoveAssignmentMutation(baseOptions?: ApolloReact.MutationHookOptions<UserProjectsDrawerRemoveAssignmentMutation, UserProjectsDrawerRemoveAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserProjectsDrawerRemoveAssignmentDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserProjectsDrawerRemoveAssignmentMutation, UserProjectsDrawerRemoveAssignmentMutationVariables>(UserProjectsDrawerRemoveAssignmentDocument, parser(options)));
      }
export type UserProjectsDrawerRemoveAssignmentMutationHookResult = ReturnType<typeof useUserProjectsDrawerRemoveAssignmentMutation>;
export type UserProjectsDrawerRemoveAssignmentMutationResult = ApolloReact.MutationResult<UserProjectsDrawerRemoveAssignmentMutation>;
export type UserProjectsDrawerRemoveAssignmentMutationOptions = Apollo.MutationOptions<UserProjectsDrawerRemoveAssignmentMutation, UserProjectsDrawerRemoveAssignmentMutationVariables>;
export const UserTimeReportDetailsGenerateRaportDocument = /*#__PURE__*/ gql`
    query UserTimeReportDetails_GenerateRaport($month: YearMonth!, $contractId: ContractId!) {
  timeReportFile(yearMonth: $month, contractId: $contractId) {
    ...NfsError
    ... on DownloadableFileUrl {
      url
      fileName
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useUserTimeReportDetailsGenerateRaportQuery__
 *
 * To run a query within a React component, call `useUserTimeReportDetailsGenerateRaportQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportDetailsGenerateRaportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTimeReportDetailsGenerateRaportQuery({
 *   variables: {
 *      month: // value for 'month'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useUserTimeReportDetailsGenerateRaportQuery(baseOptions: ApolloReact.QueryHookOptions<UserTimeReportDetailsGenerateRaportQuery, UserTimeReportDetailsGenerateRaportQueryVariables> & ({ variables: UserTimeReportDetailsGenerateRaportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportDetailsGenerateRaportDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserTimeReportDetailsGenerateRaportQuery, UserTimeReportDetailsGenerateRaportQueryVariables>(UserTimeReportDetailsGenerateRaportDocument, parser(options)));
      }
export function useUserTimeReportDetailsGenerateRaportLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserTimeReportDetailsGenerateRaportQuery, UserTimeReportDetailsGenerateRaportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserTimeReportDetailsGenerateRaportDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserTimeReportDetailsGenerateRaportQuery, UserTimeReportDetailsGenerateRaportQueryVariables>(UserTimeReportDetailsGenerateRaportDocument, options));
        }

export type UserTimeReportDetailsGenerateRaportQueryResult = ApolloReact.QueryResult<UserTimeReportDetailsGenerateRaportQuery, UserTimeReportDetailsGenerateRaportQueryVariables>;
export function refetchUserTimeReportDetailsGenerateRaportQuery(variables: UserTimeReportDetailsGenerateRaportQueryVariables) {
      return { query: UserTimeReportDetailsGenerateRaportDocument, variables: variables }
    }
export const UserTimeReportDetailsApproveLeaveDocument = /*#__PURE__*/ gql`
    mutation UserTimeReportDetails_ApproveLeave($entryId: AbsenceRecordId!) {
  reporting {
    absenceRecord {
      approve(id: $entryId) {
        ...NfsError
        ... on AbsenceRecord {
          ...AbsenceRecord
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AbsenceRecordFragmentDoc}`;


/**
 * __useUserTimeReportDetailsApproveLeaveMutation__
 *
 * To run a mutation, you first call `useUserTimeReportDetailsApproveLeaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportDetailsApproveLeaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userTimeReportDetailsApproveLeaveMutation, { data, loading, error }] = useUserTimeReportDetailsApproveLeaveMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useUserTimeReportDetailsApproveLeaveMutation(baseOptions?: ApolloReact.MutationHookOptions<UserTimeReportDetailsApproveLeaveMutation, UserTimeReportDetailsApproveLeaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportDetailsApproveLeaveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserTimeReportDetailsApproveLeaveMutation, UserTimeReportDetailsApproveLeaveMutationVariables>(UserTimeReportDetailsApproveLeaveDocument, parser(options)));
      }
export type UserTimeReportDetailsApproveLeaveMutationHookResult = ReturnType<typeof useUserTimeReportDetailsApproveLeaveMutation>;
export type UserTimeReportDetailsApproveLeaveMutationResult = ApolloReact.MutationResult<UserTimeReportDetailsApproveLeaveMutation>;
export type UserTimeReportDetailsApproveLeaveMutationOptions = Apollo.MutationOptions<UserTimeReportDetailsApproveLeaveMutation, UserTimeReportDetailsApproveLeaveMutationVariables>;
export const UserTimeReportDetailsRejectLeaveDocument = /*#__PURE__*/ gql`
    mutation UserTimeReportDetails_RejectLeave($entryId: AbsenceRecordId!) {
  reporting {
    absenceRecord {
      reject(id: $entryId) {
        ...NfsError
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useUserTimeReportDetailsRejectLeaveMutation__
 *
 * To run a mutation, you first call `useUserTimeReportDetailsRejectLeaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportDetailsRejectLeaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userTimeReportDetailsRejectLeaveMutation, { data, loading, error }] = useUserTimeReportDetailsRejectLeaveMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useUserTimeReportDetailsRejectLeaveMutation(baseOptions?: ApolloReact.MutationHookOptions<UserTimeReportDetailsRejectLeaveMutation, UserTimeReportDetailsRejectLeaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportDetailsRejectLeaveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserTimeReportDetailsRejectLeaveMutation, UserTimeReportDetailsRejectLeaveMutationVariables>(UserTimeReportDetailsRejectLeaveDocument, parser(options)));
      }
export type UserTimeReportDetailsRejectLeaveMutationHookResult = ReturnType<typeof useUserTimeReportDetailsRejectLeaveMutation>;
export type UserTimeReportDetailsRejectLeaveMutationResult = ApolloReact.MutationResult<UserTimeReportDetailsRejectLeaveMutation>;
export type UserTimeReportDetailsRejectLeaveMutationOptions = Apollo.MutationOptions<UserTimeReportDetailsRejectLeaveMutation, UserTimeReportDetailsRejectLeaveMutationVariables>;
export const UserTimeReportDetailsApproveOvertimeDocument = /*#__PURE__*/ gql`
    mutation UserTimeReportDetails_ApproveOvertime($entryId: WorkRecordId!) {
  reporting {
    workRecord {
      approve(id: $entryId) {
        ...NfsError
        ... on WorkRecord {
          ...WorkRecord
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${WorkRecordFragmentDoc}`;


/**
 * __useUserTimeReportDetailsApproveOvertimeMutation__
 *
 * To run a mutation, you first call `useUserTimeReportDetailsApproveOvertimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportDetailsApproveOvertimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userTimeReportDetailsApproveOvertimeMutation, { data, loading, error }] = useUserTimeReportDetailsApproveOvertimeMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useUserTimeReportDetailsApproveOvertimeMutation(baseOptions?: ApolloReact.MutationHookOptions<UserTimeReportDetailsApproveOvertimeMutation, UserTimeReportDetailsApproveOvertimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportDetailsApproveOvertimeDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserTimeReportDetailsApproveOvertimeMutation, UserTimeReportDetailsApproveOvertimeMutationVariables>(UserTimeReportDetailsApproveOvertimeDocument, parser(options)));
      }
export type UserTimeReportDetailsApproveOvertimeMutationHookResult = ReturnType<typeof useUserTimeReportDetailsApproveOvertimeMutation>;
export type UserTimeReportDetailsApproveOvertimeMutationResult = ApolloReact.MutationResult<UserTimeReportDetailsApproveOvertimeMutation>;
export type UserTimeReportDetailsApproveOvertimeMutationOptions = Apollo.MutationOptions<UserTimeReportDetailsApproveOvertimeMutation, UserTimeReportDetailsApproveOvertimeMutationVariables>;
export const UserTimeReportDetailsRejectOvertimeDocument = /*#__PURE__*/ gql`
    mutation UserTimeReportDetails_RejectOvertime($entryId: WorkRecordId!) {
  reporting {
    workRecord {
      reject(id: $entryId) {
        ...NfsError
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useUserTimeReportDetailsRejectOvertimeMutation__
 *
 * To run a mutation, you first call `useUserTimeReportDetailsRejectOvertimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportDetailsRejectOvertimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userTimeReportDetailsRejectOvertimeMutation, { data, loading, error }] = useUserTimeReportDetailsRejectOvertimeMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useUserTimeReportDetailsRejectOvertimeMutation(baseOptions?: ApolloReact.MutationHookOptions<UserTimeReportDetailsRejectOvertimeMutation, UserTimeReportDetailsRejectOvertimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportDetailsRejectOvertimeDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserTimeReportDetailsRejectOvertimeMutation, UserTimeReportDetailsRejectOvertimeMutationVariables>(UserTimeReportDetailsRejectOvertimeDocument, parser(options)));
      }
export type UserTimeReportDetailsRejectOvertimeMutationHookResult = ReturnType<typeof useUserTimeReportDetailsRejectOvertimeMutation>;
export type UserTimeReportDetailsRejectOvertimeMutationResult = ApolloReact.MutationResult<UserTimeReportDetailsRejectOvertimeMutation>;
export type UserTimeReportDetailsRejectOvertimeMutationOptions = Apollo.MutationOptions<UserTimeReportDetailsRejectOvertimeMutation, UserTimeReportDetailsRejectOvertimeMutationVariables>;
export const UserTimeReportsContractsDocument = /*#__PURE__*/ gql`
    query UserTimeReports_Contracts($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      firstName
      lastName
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            createdAt
            startDate
            expectedEndDate
            terminationDate
            status
            name
            ... on B2BContract {
              b2bContractType: type
              vat {
                ...Unauthorized
                ... on AccessGranted__TimeBasedVatType {
                  value {
                    value {
                      ...VatType
                    }
                  }
                }
              }
              currency {
                ...Unauthorized
                ... on AccessGranted__TimeBasedCurrency {
                  value {
                    value
                  }
                }
              }
            }
            ... on EmploymentContract {
              type
              currency {
                ...Unauthorized
                ... on AccessGranted__TimeBasedCurrency {
                  value {
                    value
                  }
                }
              }
            }
            ... on Subcontract {
              clientContract {
                ...Unauthorized
                ... on AccessGranted__ClientContract {
                  value {
                    id
                    promisee {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
      directReporting {
        space {
          value {
            id
            owner {
              id
              firstName
              lastName
              email
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${VatTypeFragmentDoc}`;

/**
 * __useUserTimeReportsContractsQuery__
 *
 * To run a query within a React component, call `useUserTimeReportsContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportsContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTimeReportsContractsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserTimeReportsContractsQuery(baseOptions: ApolloReact.QueryHookOptions<UserTimeReportsContractsQuery, UserTimeReportsContractsQueryVariables> & ({ variables: UserTimeReportsContractsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportsContractsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserTimeReportsContractsQuery, UserTimeReportsContractsQueryVariables>(UserTimeReportsContractsDocument, parser(options)));
      }
export function useUserTimeReportsContractsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserTimeReportsContractsQuery, UserTimeReportsContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserTimeReportsContractsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserTimeReportsContractsQuery, UserTimeReportsContractsQueryVariables>(UserTimeReportsContractsDocument, options));
        }

export type UserTimeReportsContractsQueryResult = ApolloReact.QueryResult<UserTimeReportsContractsQuery, UserTimeReportsContractsQueryVariables>;
export function refetchUserTimeReportsContractsQuery(variables: UserTimeReportsContractsQueryVariables) {
      return { query: UserTimeReportsContractsDocument, variables: variables }
    }
export const YearlyCostSummaryDrawerInputDocument = /*#__PURE__*/ gql`
    query YearlyCostSummaryDrawer_Input($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            entityVersion
            startDate
            terminationDate
            name
            status
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useYearlyCostSummaryDrawerInputQuery__
 *
 * To run a query within a React component, call `useYearlyCostSummaryDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useYearlyCostSummaryDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYearlyCostSummaryDrawerInputQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useYearlyCostSummaryDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<YearlyCostSummaryDrawerInputQuery, YearlyCostSummaryDrawerInputQueryVariables> & ({ variables: YearlyCostSummaryDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(YearlyCostSummaryDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<YearlyCostSummaryDrawerInputQuery, YearlyCostSummaryDrawerInputQueryVariables>(YearlyCostSummaryDrawerInputDocument, parser(options)));
      }
export function useYearlyCostSummaryDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<YearlyCostSummaryDrawerInputQuery, YearlyCostSummaryDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(YearlyCostSummaryDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<YearlyCostSummaryDrawerInputQuery, YearlyCostSummaryDrawerInputQueryVariables>(YearlyCostSummaryDrawerInputDocument, options));
        }

export type YearlyCostSummaryDrawerInputQueryResult = ApolloReact.QueryResult<YearlyCostSummaryDrawerInputQuery, YearlyCostSummaryDrawerInputQueryVariables>;
export function refetchYearlyCostSummaryDrawerInputQuery(variables: YearlyCostSummaryDrawerInputQueryVariables) {
      return { query: YearlyCostSummaryDrawerInputDocument, variables: variables }
    }
export const YearlyCostSummaryDrawerLoadReportDocument = /*#__PURE__*/ gql`
    query YearlyCostSummaryDrawer_LoadReport($contractId: ContractId!, $range: ClosedEndMonthRangeInput!) {
  contractsCostsSummary(filter: {contractId_oneOf: [$contractId]}, range: $range) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useYearlyCostSummaryDrawerLoadReportQuery__
 *
 * To run a query within a React component, call `useYearlyCostSummaryDrawerLoadReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useYearlyCostSummaryDrawerLoadReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYearlyCostSummaryDrawerLoadReportQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useYearlyCostSummaryDrawerLoadReportQuery(baseOptions: ApolloReact.QueryHookOptions<YearlyCostSummaryDrawerLoadReportQuery, YearlyCostSummaryDrawerLoadReportQueryVariables> & ({ variables: YearlyCostSummaryDrawerLoadReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(YearlyCostSummaryDrawerLoadReportDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<YearlyCostSummaryDrawerLoadReportQuery, YearlyCostSummaryDrawerLoadReportQueryVariables>(YearlyCostSummaryDrawerLoadReportDocument, parser(options)));
      }
export function useYearlyCostSummaryDrawerLoadReportLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<YearlyCostSummaryDrawerLoadReportQuery, YearlyCostSummaryDrawerLoadReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(YearlyCostSummaryDrawerLoadReportDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<YearlyCostSummaryDrawerLoadReportQuery, YearlyCostSummaryDrawerLoadReportQueryVariables>(YearlyCostSummaryDrawerLoadReportDocument, options));
        }

export type YearlyCostSummaryDrawerLoadReportQueryResult = ApolloReact.QueryResult<YearlyCostSummaryDrawerLoadReportQuery, YearlyCostSummaryDrawerLoadReportQueryVariables>;
export function refetchYearlyCostSummaryDrawerLoadReportQuery(variables: YearlyCostSummaryDrawerLoadReportQueryVariables) {
      return { query: YearlyCostSummaryDrawerLoadReportDocument, variables: variables }
    }
export const AbsencesDocument = /*#__PURE__*/ gql`
    query Absences($first: Int, $after: Cursor, $filter: FilterUserInput, $sort: SortingRequestSortUserInput, $from: YearMonth!, $to: YearMonth!) {
  users(first: $first, after: $after, filter: $filter, sort: $sort) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      totalCount
      filteredCount
      edges {
        cursor
        node {
          id
          entityVersion
          firstName
          lastName
          avatar
          email
          contracts {
            ...Unauthorized
            ... on AccessGranted__ListOfContract {
              value {
                id
                status
                holidayCalendar {
                  id
                  calendarDays {
                    date
                    dayType
                  }
                }
                ... on EmploymentContract {
                  type
                }
                ... on B2BContract {
                  b2bContractType: type
                }
                ... on Subcontract {
                  b2bContractType: type
                }
              }
            }
          }
          timeReports {
            ...Unauthorized
            ... on AccessGranted__TimeReports {
              value {
                absenceRecords(from: $from, to: $to) {
                  ...AbsenceRecord
                  contractId
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AbsenceRecordFragmentDoc}`;

/**
 * __useAbsencesQuery__
 *
 * To run a query within a React component, call `useAbsencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsencesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useAbsencesQuery(baseOptions: ApolloReact.QueryHookOptions<AbsencesQuery, AbsencesQueryVariables> & ({ variables: AbsencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AbsencesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AbsencesQuery, AbsencesQueryVariables>(AbsencesDocument, parser(options)));
      }
export function useAbsencesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AbsencesQuery, AbsencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AbsencesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AbsencesQuery, AbsencesQueryVariables>(AbsencesDocument, options));
        }

export type AbsencesQueryResult = ApolloReact.QueryResult<AbsencesQuery, AbsencesQueryVariables>;
export function refetchAbsencesQuery(variables: AbsencesQueryVariables) {
      return { query: AbsencesDocument, variables: variables }
    }
export const AbsencesInfoDocument = /*#__PURE__*/ gql`
    query Absences_Info {
  absenceTypeDetails {
    key
    value {
      canBeReportedOnHoliday
      applicableFor
      canTakeCustomNumberOfHours
      limit
    }
  }
}
    `;

/**
 * __useAbsencesInfoQuery__
 *
 * To run a query within a React component, call `useAbsencesInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsencesInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsencesInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useAbsencesInfoQuery(baseOptions?: ApolloReact.QueryHookOptions<AbsencesInfoQuery, AbsencesInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AbsencesInfoDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AbsencesInfoQuery, AbsencesInfoQueryVariables>(AbsencesInfoDocument, parser(options)));
      }
export function useAbsencesInfoLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AbsencesInfoQuery, AbsencesInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AbsencesInfoDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AbsencesInfoQuery, AbsencesInfoQueryVariables>(AbsencesInfoDocument, options));
        }

export type AbsencesInfoQueryResult = ApolloReact.QueryResult<AbsencesInfoQuery, AbsencesInfoQueryVariables>;
export function refetchAbsencesInfoQuery(variables?: AbsencesInfoQueryVariables) {
      return { query: AbsencesInfoDocument, variables: variables }
    }
export const ApiTokensDocument = /*#__PURE__*/ gql`
    query ApiTokens {
  apiTokens {
    ...NfsError
    ... on ListOfApiTokenResponse {
      value {
        name
        claims
        description
        createdAt
        validUntil
        ticketUrl
        lastUsedAt
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useApiTokensQuery__
 *
 * To run a query within a React component, call `useApiTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiTokensQuery(baseOptions?: ApolloReact.QueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ApiTokensDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, parser(options)));
      }
export function useApiTokensLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ApiTokensDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, options));
        }

export type ApiTokensQueryResult = ApolloReact.QueryResult<ApiTokensQuery, ApiTokensQueryVariables>;
export function refetchApiTokensQuery(variables?: ApiTokensQueryVariables) {
      return { query: ApiTokensDocument, variables: variables }
    }
export const BankTransfersDocument = /*#__PURE__*/ gql`
    query BankTransfers($after: Cursor, $filter: FilterBankTransferInput, $sort: SortingRequestSortBankTransferInput, $first: Int) {
  bankTransfers(first: $first, after: $after, sort: $sort, filter: $filter) {
    ...NfsError
    ... on FSPResponseBankTransfer {
      hasNextPage
      totalCount
      filteredCount
      edges {
        cursor
        node {
          ... on BankIncomeTransfer {
            ...BankTransfers_BankTransfer
            discrepancy
            connectedPayments {
              transfer {
                id
                status
              }
              invoice {
                id
                number
              }
              tpe
            }
          }
          ... on BankOutcomeTransfer {
            ...BankTransfers_BankTransfer
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankTransfersBankTransferFragmentDoc}`;

/**
 * __useBankTransfersQuery__
 *
 * To run a query within a React component, call `useBankTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankTransfersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useBankTransfersQuery(baseOptions?: ApolloReact.QueryHookOptions<BankTransfersQuery, BankTransfersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BankTransfersDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BankTransfersQuery, BankTransfersQueryVariables>(BankTransfersDocument, parser(options)));
      }
export function useBankTransfersLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BankTransfersQuery, BankTransfersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BankTransfersDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BankTransfersQuery, BankTransfersQueryVariables>(BankTransfersDocument, options));
        }

export type BankTransfersQueryResult = ApolloReact.QueryResult<BankTransfersQuery, BankTransfersQueryVariables>;
export function refetchBankTransfersQuery(variables?: BankTransfersQueryVariables) {
      return { query: BankTransfersDocument, variables: variables }
    }
export const BankTransfersFetchIngDocument = /*#__PURE__*/ gql`
    mutation BankTransfersFetchIng {
  triggerIngTransfersMonitoring {
    ...NfsError
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useBankTransfersFetchIngMutation__
 *
 * To run a mutation, you first call `useBankTransfersFetchIngMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankTransfersFetchIngMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankTransfersFetchIngMutation, { data, loading, error }] = useBankTransfersFetchIngMutation({
 *   variables: {
 *   },
 * });
 */
export function useBankTransfersFetchIngMutation(baseOptions?: ApolloReact.MutationHookOptions<BankTransfersFetchIngMutation, BankTransfersFetchIngMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BankTransfersFetchIngDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BankTransfersFetchIngMutation, BankTransfersFetchIngMutationVariables>(BankTransfersFetchIngDocument, parser(options)));
      }
export type BankTransfersFetchIngMutationHookResult = ReturnType<typeof useBankTransfersFetchIngMutation>;
export type BankTransfersFetchIngMutationResult = ApolloReact.MutationResult<BankTransfersFetchIngMutation>;
export type BankTransfersFetchIngMutationOptions = Apollo.MutationOptions<BankTransfersFetchIngMutation, BankTransfersFetchIngMutationVariables>;
export const ClientContractProfileDocument = /*#__PURE__*/ gql`
    query ClientContractProfile($clientContractId: ClientContractId!) {
  clientContract(id: $clientContractId) {
    ...NfsError
    ... on ClientContract {
      id
      entityVersion
      createdAt
      name {
        ...Unauthorized
        ... on AccessGranted__String {
          value
        }
      }
      promisor {
        id
        name
        logo
        companyType
      }
      promisee {
        id
        name
        logo
        companyType
      }
      contractDurationFrom {
        ...Unauthorized
        ... on AccessGranted__LocalDate {
          value
        }
      }
      contractDurationTo {
        ...Unauthorized
        ... on AccessGranted__OptionalLocalDate {
          value
        }
      }
      docUri {
        ...Unauthorized
        ... on AccessGranted__OptionalURI {
          value
        }
      }
      vat {
        ...Unauthorized
        ... on AccessGranted__TimeBasedOptClearableBasisPoint {
          value {
            value
          }
        }
      }
      currency {
        ...Unauthorized
        ... on AccessGranted__TimeBasedOptCurrency {
          value {
            value
          }
        }
      }
      projects {
        id
        name
        statusHistory {
          status
          dateRange {
            from
            to
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useClientContractProfileQuery__
 *
 * To run a query within a React component, call `useClientContractProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientContractProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientContractProfileQuery({
 *   variables: {
 *      clientContractId: // value for 'clientContractId'
 *   },
 * });
 */
export function useClientContractProfileQuery(baseOptions: ApolloReact.QueryHookOptions<ClientContractProfileQuery, ClientContractProfileQueryVariables> & ({ variables: ClientContractProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ClientContractProfileDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ClientContractProfileQuery, ClientContractProfileQueryVariables>(ClientContractProfileDocument, parser(options)));
      }
export function useClientContractProfileLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ClientContractProfileQuery, ClientContractProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ClientContractProfileDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ClientContractProfileQuery, ClientContractProfileQueryVariables>(ClientContractProfileDocument, options));
        }

export type ClientContractProfileQueryResult = ApolloReact.QueryResult<ClientContractProfileQuery, ClientContractProfileQueryVariables>;
export function refetchClientContractProfileQuery(variables: ClientContractProfileQueryVariables) {
      return { query: ClientContractProfileDocument, variables: variables }
    }
export const ClientContractsPageDocument = /*#__PURE__*/ gql`
    query ClientContractsPage($first: Int, $after: Cursor, $filter: FilterClientContractInput, $sort: SortingRequestSortClientContractInput) {
  clientContracts(first: $first, after: $after, filter: $filter, sort: $sort) {
    ...NfsError
    ... on FSPResponseClientContract {
      hasNextPage
      totalCount
      filteredCount
      edges {
        cursor
        node {
          id
          entityVersion
          createdAt
          name {
            ...Unauthorized
            ... on AccessGranted__String {
              value
            }
          }
          promisor {
            id
            name
            logo
            taxNumber
            address {
              ...Address
            }
          }
          promisee {
            id
            name
            logo
            taxNumber
            address {
              ...Address
            }
          }
          contractDurationFrom {
            ...Unauthorized
            ... on AccessGranted__LocalDate {
              value
            }
          }
          contractDurationTo {
            ...Unauthorized
            ... on AccessGranted__OptionalLocalDate {
              value
            }
          }
          currency {
            ...Unauthorized
            ... on AccessGranted__TimeBasedOptCurrency {
              value {
                value
              }
            }
          }
          projects {
            id
            name
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useClientContractsPageQuery__
 *
 * To run a query within a React component, call `useClientContractsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientContractsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientContractsPageQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useClientContractsPageQuery(baseOptions?: ApolloReact.QueryHookOptions<ClientContractsPageQuery, ClientContractsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ClientContractsPageDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ClientContractsPageQuery, ClientContractsPageQueryVariables>(ClientContractsPageDocument, parser(options)));
      }
export function useClientContractsPageLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ClientContractsPageQuery, ClientContractsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ClientContractsPageDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ClientContractsPageQuery, ClientContractsPageQueryVariables>(ClientContractsPageDocument, options));
        }

export type ClientContractsPageQueryResult = ApolloReact.QueryResult<ClientContractsPageQuery, ClientContractsPageQueryVariables>;
export function refetchClientContractsPageQuery(variables?: ClientContractsPageQueryVariables) {
      return { query: ClientContractsPageDocument, variables: variables }
    }
export const CompaniesDocument = /*#__PURE__*/ gql`
    query Companies($first: Int, $after: Cursor, $filter: FilterCompanyInput, $sort: SortingRequestSortCompanyInput) {
  companies(first: $first, after: $after, filter: $filter, sort: $sort) {
    ...NfsError
    ... on FSPResponseCompany {
      hasNextPage
      totalCount
      filteredCount
      edges {
        cursor
        node {
          id
          entityVersion
          name
          logo
          createdAt
          companyType
          sectors {
            ...Unauthorized
            ... on AccessGranted__ListOfString {
              value
            }
          }
          euVatType {
            value {
              value
            }
          }
          isPolishVat {
            value {
              value
            }
          }
          taxNumber
          regon
          registerId
          address {
            ...Address
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions?: ApolloReact.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompaniesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, parser(options)));
      }
export function useCompaniesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CompaniesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options));
        }

export type CompaniesQueryResult = ApolloReact.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export function refetchCompaniesQuery(variables?: CompaniesQueryVariables) {
      return { query: CompaniesDocument, variables: variables }
    }
export const CompanyDetailsDocument = /*#__PURE__*/ gql`
    query CompanyDetails($companyId: CompanyId!) {
  company(id: $companyId) {
    ...NfsError
    ... on Company {
      id
      entityVersion
      name
      logo
      companyType
      address {
        ...Address
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useCompanyDetailsQuery__
 *
 * To run a query within a React component, call `useCompanyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDetailsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<CompanyDetailsQuery, CompanyDetailsQueryVariables> & ({ variables: CompanyDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CompanyDetailsQuery, CompanyDetailsQueryVariables>(CompanyDetailsDocument, parser(options)));
      }
export function useCompanyDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CompanyDetailsQuery, CompanyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CompanyDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CompanyDetailsQuery, CompanyDetailsQueryVariables>(CompanyDetailsDocument, options));
        }

export type CompanyDetailsQueryResult = ApolloReact.QueryResult<CompanyDetailsQuery, CompanyDetailsQueryVariables>;
export function refetchCompanyDetailsQuery(variables: CompanyDetailsQueryVariables) {
      return { query: CompanyDetailsDocument, variables: variables }
    }
export const ContractsDraftsDocument = /*#__PURE__*/ gql`
    query Contracts_Drafts {
  contractDrafts {
    ...NfsError
    ... on ListOfContractDraftResponse {
      value {
        id
        entityVersion
        name
        startDate
        expectedEndDate
        promisor {
          id
          name
          logo
        }
        promisee {
          id
          entityVersion
          firstName
          lastName
          email
          avatar
          progressionLevel {
            value
          }
        }
        ... on EmploymentContractDraft {
          type
        }
        ... on B2BContractDraft {
          b2bContractType: type
          promiseeCompany {
            id
            entityVersion
            name
            address {
              ...Address
            }
          }
        }
        ... on SubcontractDraft {
          id
          clientContract {
            id
            name {
              ...Unauthorized
              ... on AccessGranted__String {
                value
              }
            }
            promisee {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AddressFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useContractsDraftsQuery__
 *
 * To run a query within a React component, call `useContractsDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsDraftsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContractsDraftsQuery(baseOptions?: ApolloReact.QueryHookOptions<ContractsDraftsQuery, ContractsDraftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractsDraftsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractsDraftsQuery, ContractsDraftsQueryVariables>(ContractsDraftsDocument, parser(options)));
      }
export function useContractsDraftsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractsDraftsQuery, ContractsDraftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractsDraftsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractsDraftsQuery, ContractsDraftsQueryVariables>(ContractsDraftsDocument, options));
        }

export type ContractsDraftsQueryResult = ApolloReact.QueryResult<ContractsDraftsQuery, ContractsDraftsQueryVariables>;
export function refetchContractsDraftsQuery(variables?: ContractsDraftsQueryVariables) {
      return { query: ContractsDraftsDocument, variables: variables }
    }
export const ContractsDocument = /*#__PURE__*/ gql`
    query Contracts($after: Cursor, $filter: FilterContractInput, $sort: SortingRequestSortContractInput, $first: Int) {
  contracts(first: $first, after: $after, sort: $sort, filter: $filter) {
    ...NfsError
    ... on FSPResponseContract {
      edges {
        node {
          id
          entityVersion
          name
          conclusionDate {
            ...Unauthorized
            ... on AccessGranted__LocalDate {
              value
            }
          }
          terminationDate
          startDate
          status
          expectedEndDate
          promisor {
            value {
              id
              entityVersion
              name
              logo
            }
          }
          promisee {
            id
            entityVersion
            firstName
            lastName
            email
            avatar
            progressionLevel {
              value
            }
          }
          ... on EmploymentContract {
            type
            position {
              value
            }
          }
          ... on B2BContract {
            b2bContractType: type
            position {
              value
            }
            promiseeCompany {
              ...Unauthorized
              ... on AccessGranted__Company {
                value {
                  id
                  entityVersion
                  name
                  logo
                  address {
                    ...Address
                  }
                }
              }
            }
          }
          ... on Subcontract {
            id
            clientContract {
              ...Unauthorized
              ... on AccessGranted__ClientContract {
                value {
                  id
                  name {
                    ...Unauthorized
                    ... on AccessGranted__String {
                      value
                    }
                  }
                  promisee {
                    id
                    name
                  }
                }
              }
            }
          }
        }
        cursor
      }
      hasNextPage
      totalCount
      filteredCount
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useContractsQuery__
 *
 * To run a query within a React component, call `useContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useContractsQuery(baseOptions?: ApolloReact.QueryHookOptions<ContractsQuery, ContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ContractsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ContractsQuery, ContractsQueryVariables>(ContractsDocument, parser(options)));
      }
export function useContractsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ContractsQuery, ContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ContractsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ContractsQuery, ContractsQueryVariables>(ContractsDocument, options));
        }

export type ContractsQueryResult = ApolloReact.QueryResult<ContractsQuery, ContractsQueryVariables>;
export function refetchContractsQuery(variables?: ContractsQueryVariables) {
      return { query: ContractsDocument, variables: variables }
    }
export const CopyrightsDocument = /*#__PURE__*/ gql`
    query Copyrights($sortBy: SortWorkTransferProtocolsInput!) {
  pendingWorkTransferProtocols(sort: $sortBy) {
    ...NfsError
    ... on ListOfWorkTransferProtocolResponse {
      value {
        id
        description
        payload {
          ... on File {
            value {
              downloadUrl
              openUrl
              fileName
            }
          }
        }
        approval {
          ...Approval
        }
        createdBy
        createdAt
        contractSalaryDetails {
          yearMonth
          contractId
          ... on EmploymentContractSalaryDetails {
            contract {
              id
              entityVersion
              startDate
              promisee {
                id
                entityVersion
                email
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ApprovalFragmentDoc}`;

/**
 * __useCopyrightsQuery__
 *
 * To run a query within a React component, call `useCopyrightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyrightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyrightsQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useCopyrightsQuery(baseOptions: ApolloReact.QueryHookOptions<CopyrightsQuery, CopyrightsQueryVariables> & ({ variables: CopyrightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CopyrightsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CopyrightsQuery, CopyrightsQueryVariables>(CopyrightsDocument, parser(options)));
      }
export function useCopyrightsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CopyrightsQuery, CopyrightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CopyrightsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CopyrightsQuery, CopyrightsQueryVariables>(CopyrightsDocument, options));
        }

export type CopyrightsQueryResult = ApolloReact.QueryResult<CopyrightsQuery, CopyrightsQueryVariables>;
export function refetchCopyrightsQuery(variables: CopyrightsQueryVariables) {
      return { query: CopyrightsDocument, variables: variables }
    }
export const CopyrightsAnnualSummaryDocument = /*#__PURE__*/ gql`
    query CopyrightsAnnualSummary($after: Cursor, $sort: SortingRequestSortContractInput, $filter: FilterContractInput!, $first: Int, $year: Year!) {
  contracts(first: $first, after: $after, sort: $sort, filter: $filter) {
    ...NfsError
    ... on FSPResponseContract {
      edges {
        cursor
        node {
          ... on EmploymentContract {
            id
            entityVersion
            conclusionDate {
              ...Unauthorized
              ... on AccessGranted__LocalDate {
                value
              }
            }
            name
            startDate
            status
            terminationDate
            createdAt
            expectedEndDate
            type
            promisee {
              id
              firstName
              lastName
              avatar
            }
            workTransferProtocols(year: $year) {
              ... on AccessGranted__ListOfWorkTransferProtocol {
                value {
                  id
                  contractId
                  yearMonth
                  approval {
                    ...Approval
                  }
                  payload {
                    ... on NoWorkToBeTransferedThisMonth {
                      __typename
                    }
                  }
                }
              }
            }
          }
        }
      }
      hasNextPage
      totalCount
      filteredCount
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${ApprovalFragmentDoc}`;

/**
 * __useCopyrightsAnnualSummaryQuery__
 *
 * To run a query within a React component, call `useCopyrightsAnnualSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyrightsAnnualSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyrightsAnnualSummaryQuery({
 *   variables: {
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useCopyrightsAnnualSummaryQuery(baseOptions: ApolloReact.QueryHookOptions<CopyrightsAnnualSummaryQuery, CopyrightsAnnualSummaryQueryVariables> & ({ variables: CopyrightsAnnualSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CopyrightsAnnualSummaryDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CopyrightsAnnualSummaryQuery, CopyrightsAnnualSummaryQueryVariables>(CopyrightsAnnualSummaryDocument, parser(options)));
      }
export function useCopyrightsAnnualSummaryLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CopyrightsAnnualSummaryQuery, CopyrightsAnnualSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CopyrightsAnnualSummaryDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CopyrightsAnnualSummaryQuery, CopyrightsAnnualSummaryQueryVariables>(CopyrightsAnnualSummaryDocument, options));
        }

export type CopyrightsAnnualSummaryQueryResult = ApolloReact.QueryResult<CopyrightsAnnualSummaryQuery, CopyrightsAnnualSummaryQueryVariables>;
export function refetchCopyrightsAnnualSummaryQuery(variables: CopyrightsAnnualSummaryQueryVariables) {
      return { query: CopyrightsAnnualSummaryDocument, variables: variables }
    }
export const CostInvoiceDetailsDocument = /*#__PURE__*/ gql`
    query CostInvoiceDetails($saldeoDocumentId: SaldeoDocumentIdInput!) {
  costInvoice(saldeoDocumentId: $saldeoDocumentId) {
    ...NfsError
    ... on CostInvoice {
      ...CostInvoiceDetails_CostInvoice
    }
  }
}
    ${NfsErrorFragmentDoc}
${CostInvoiceDetailsCostInvoiceFragmentDoc}`;

/**
 * __useCostInvoiceDetailsQuery__
 *
 * To run a query within a React component, call `useCostInvoiceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostInvoiceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostInvoiceDetailsQuery({
 *   variables: {
 *      saldeoDocumentId: // value for 'saldeoDocumentId'
 *   },
 * });
 */
export function useCostInvoiceDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<CostInvoiceDetailsQuery, CostInvoiceDetailsQueryVariables> & ({ variables: CostInvoiceDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CostInvoiceDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CostInvoiceDetailsQuery, CostInvoiceDetailsQueryVariables>(CostInvoiceDetailsDocument, parser(options)));
      }
export function useCostInvoiceDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CostInvoiceDetailsQuery, CostInvoiceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CostInvoiceDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CostInvoiceDetailsQuery, CostInvoiceDetailsQueryVariables>(CostInvoiceDetailsDocument, options));
        }

export type CostInvoiceDetailsQueryResult = ApolloReact.QueryResult<CostInvoiceDetailsQuery, CostInvoiceDetailsQueryVariables>;
export function refetchCostInvoiceDetailsQuery(variables: CostInvoiceDetailsQueryVariables) {
      return { query: CostInvoiceDetailsDocument, variables: variables }
    }
export const CostInvoicesDocument = /*#__PURE__*/ gql`
    query CostInvoices($yearMonth: YearMonth!, $companyId: CompanyId!) {
  costInvoices(yearMonth: $yearMonth, companyId: $companyId) {
    ...NfsError
    ... on ListOfCostInvoiceResponse {
      value {
        ...CostInvoices_CostInvoice
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CostInvoicesCostInvoiceFragmentDoc}`;

/**
 * __useCostInvoicesQuery__
 *
 * To run a query within a React component, call `useCostInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostInvoicesQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCostInvoicesQuery(baseOptions: ApolloReact.QueryHookOptions<CostInvoicesQuery, CostInvoicesQueryVariables> & ({ variables: CostInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CostInvoicesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CostInvoicesQuery, CostInvoicesQueryVariables>(CostInvoicesDocument, parser(options)));
      }
export function useCostInvoicesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CostInvoicesQuery, CostInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CostInvoicesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CostInvoicesQuery, CostInvoicesQueryVariables>(CostInvoicesDocument, options));
        }

export type CostInvoicesQueryResult = ApolloReact.QueryResult<CostInvoicesQuery, CostInvoicesQueryVariables>;
export function refetchCostInvoicesQuery(variables: CostInvoicesQueryVariables) {
      return { query: CostInvoicesDocument, variables: variables }
    }
export const ReportsEmployeeDueDatesDocument = /*#__PURE__*/ gql`
    query ReportsEmployeeDueDates($first: Int, $after: Cursor, $sort: SortingRequestSortUserInput, $filter: FilterUserInput) {
  users(first: $first, after: $after, sort: $sort, filter: $filter) {
    ...NfsError
    ... on FSPResponseUser {
      ...ReportsEmployeeDueDates_Person
    }
  }
}
    ${NfsErrorFragmentDoc}
${ReportsEmployeeDueDatesPersonFragmentDoc}`;

/**
 * __useReportsEmployeeDueDatesQuery__
 *
 * To run a query within a React component, call `useReportsEmployeeDueDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsEmployeeDueDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsEmployeeDueDatesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportsEmployeeDueDatesQuery(baseOptions?: ApolloReact.QueryHookOptions<ReportsEmployeeDueDatesQuery, ReportsEmployeeDueDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ReportsEmployeeDueDatesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ReportsEmployeeDueDatesQuery, ReportsEmployeeDueDatesQueryVariables>(ReportsEmployeeDueDatesDocument, parser(options)));
      }
export function useReportsEmployeeDueDatesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ReportsEmployeeDueDatesQuery, ReportsEmployeeDueDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ReportsEmployeeDueDatesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ReportsEmployeeDueDatesQuery, ReportsEmployeeDueDatesQueryVariables>(ReportsEmployeeDueDatesDocument, options));
        }

export type ReportsEmployeeDueDatesQueryResult = ApolloReact.QueryResult<ReportsEmployeeDueDatesQuery, ReportsEmployeeDueDatesQueryVariables>;
export function refetchReportsEmployeeDueDatesQuery(variables?: ReportsEmployeeDueDatesQueryVariables) {
      return { query: ReportsEmployeeDueDatesDocument, variables: variables }
    }
export const OfficeDetailsDocument = /*#__PURE__*/ gql`
    query OfficeDetails($officeId: OfficeId!) {
  office(officeId: $officeId) {
    ...NfsError
    ... on Office {
      officeId
      name
      validFrom
      validTo
      blocked
      avatar
      entityVersion
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useOfficeDetailsQuery__
 *
 * To run a query within a React component, call `useOfficeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeDetailsQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useOfficeDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<OfficeDetailsQuery, OfficeDetailsQueryVariables> & ({ variables: OfficeDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<OfficeDetailsQuery, OfficeDetailsQueryVariables>(OfficeDetailsDocument, parser(options)));
      }
export function useOfficeDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<OfficeDetailsQuery, OfficeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(OfficeDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<OfficeDetailsQuery, OfficeDetailsQueryVariables>(OfficeDetailsDocument, options));
        }

export type OfficeDetailsQueryResult = ApolloReact.QueryResult<OfficeDetailsQuery, OfficeDetailsQueryVariables>;
export function refetchOfficeDetailsQuery(variables: OfficeDetailsQueryVariables) {
      return { query: OfficeDetailsDocument, variables: variables }
    }
export const OfficeReservationsDocument = /*#__PURE__*/ gql`
    query OfficeReservations($filter: FilterOfficeReservationInput!, $first: Int!) {
  officeReservations(filter: $filter, first: $first, sort: {by: Date, order: Asc}) {
    ...NfsError
    ... on FSPResponseOfficeReservation {
      edges {
        node {
          ...OfficeReservationsRow
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${OfficeReservationsRowFragmentDoc}`;

/**
 * __useOfficeReservationsQuery__
 *
 * To run a query within a React component, call `useOfficeReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeReservationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useOfficeReservationsQuery(baseOptions: ApolloReact.QueryHookOptions<OfficeReservationsQuery, OfficeReservationsQueryVariables> & ({ variables: OfficeReservationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeReservationsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<OfficeReservationsQuery, OfficeReservationsQueryVariables>(OfficeReservationsDocument, parser(options)));
      }
export function useOfficeReservationsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<OfficeReservationsQuery, OfficeReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(OfficeReservationsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<OfficeReservationsQuery, OfficeReservationsQueryVariables>(OfficeReservationsDocument, options));
        }

export type OfficeReservationsQueryResult = ApolloReact.QueryResult<OfficeReservationsQuery, OfficeReservationsQueryVariables>;
export function refetchOfficeReservationsQuery(variables: OfficeReservationsQueryVariables) {
      return { query: OfficeReservationsDocument, variables: variables }
    }
export const OfficeReservationsApproveManyDocument = /*#__PURE__*/ gql`
    mutation OfficeReservations_ApproveMany($requestIds: [ReservationRequestId!]!) {
  approveOfficeReservations(requestIds: $requestIds) {
    ...NfsError
    ... on ListOfReservationRequestResponse {
      value {
        requestId
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useOfficeReservationsApproveManyMutation__
 *
 * To run a mutation, you first call `useOfficeReservationsApproveManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfficeReservationsApproveManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [officeReservationsApproveManyMutation, { data, loading, error }] = useOfficeReservationsApproveManyMutation({
 *   variables: {
 *      requestIds: // value for 'requestIds'
 *   },
 * });
 */
export function useOfficeReservationsApproveManyMutation(baseOptions?: ApolloReact.MutationHookOptions<OfficeReservationsApproveManyMutation, OfficeReservationsApproveManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeReservationsApproveManyDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<OfficeReservationsApproveManyMutation, OfficeReservationsApproveManyMutationVariables>(OfficeReservationsApproveManyDocument, parser(options)));
      }
export type OfficeReservationsApproveManyMutationHookResult = ReturnType<typeof useOfficeReservationsApproveManyMutation>;
export type OfficeReservationsApproveManyMutationResult = ApolloReact.MutationResult<OfficeReservationsApproveManyMutation>;
export type OfficeReservationsApproveManyMutationOptions = Apollo.MutationOptions<OfficeReservationsApproveManyMutation, OfficeReservationsApproveManyMutationVariables>;
export const OfficesDocument = /*#__PURE__*/ gql`
    query Offices {
  offices {
    ...NfsError
    ... on ListOfOfficeResponse {
      value {
        ...Offices_Office
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${OfficesOfficeFragmentDoc}`;

/**
 * __useOfficesQuery__
 *
 * To run a query within a React component, call `useOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfficesQuery(baseOptions?: ApolloReact.QueryHookOptions<OfficesQuery, OfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<OfficesQuery, OfficesQueryVariables>(OfficesDocument, parser(options)));
      }
export function useOfficesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<OfficesQuery, OfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(OfficesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<OfficesQuery, OfficesQueryVariables>(OfficesDocument, options));
        }

export type OfficesQueryResult = ApolloReact.QueryResult<OfficesQuery, OfficesQueryVariables>;
export function refetchOfficesQuery(variables?: OfficesQueryVariables) {
      return { query: OfficesDocument, variables: variables }
    }
export const PeopleDocument = /*#__PURE__*/ gql`
    query People($first: Int, $after: Cursor, $filter: FilterUserInput, $sort: SortingRequestSortUserInput) {
  users(first: $first, after: $after, filter: $filter, sort: $sort) {
    ...NfsError
    ... on FSPResponseUser {
      ...People_Person
    }
  }
}
    ${NfsErrorFragmentDoc}
${PeoplePersonFragmentDoc}`;

/**
 * __usePeopleQuery__
 *
 * To run a query within a React component, call `usePeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePeopleQuery(baseOptions?: ApolloReact.QueryHookOptions<PeopleQuery, PeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PeopleDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PeopleQuery, PeopleQueryVariables>(PeopleDocument, parser(options)));
      }
export function usePeopleLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PeopleQuery, PeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PeopleDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PeopleQuery, PeopleQueryVariables>(PeopleDocument, options));
        }

export type PeopleQueryResult = ApolloReact.QueryResult<PeopleQuery, PeopleQueryVariables>;
export function refetchPeopleQuery(variables?: PeopleQueryVariables) {
      return { query: PeopleDocument, variables: variables }
    }
export const PersonDetailsDocument = /*#__PURE__*/ gql`
    query PersonDetails($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      entityVersion
      firstName
      lastName
      avatar
      email
      socialMediaHandles {
        ...Unauthorized
        ... on AccessGranted__ListOfSocialMediaHandle {
          value {
            platform
            handle
          }
        }
      }
      progressionLevel {
        value
      }
      directReporting {
        assignedProjects {
          ...Unauthorized
        }
      }
      documentsDirectory {
        ...Unauthorized
        ... on AccessGranted__OptionalURI {
          value
        }
      }
      contractDraft {
        ...Unauthorized
      }
      contracts {
        ...Unauthorized
        ... on AccessGranted__ListOfContract {
          value {
            id
            ... on EmploymentContract {
              type
              annualLeaveEntitlement {
                ...Unauthorized
                ... on AccessGranted__OptionalAnnualLeaveEntitlement {
                  value {
                    withCarryOverToNextYear
                  }
                }
              }
              currency {
                ...Unauthorized
                ... on AccessGranted__TimeBasedCurrency {
                  value {
                    value
                  }
                }
              }
            }
            ... on B2BContract {
              currency {
                ...Unauthorized
                ... on AccessGranted__TimeBasedCurrency {
                  value {
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __usePersonDetailsQuery__
 *
 * To run a query within a React component, call `usePersonDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePersonDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<PersonDetailsQuery, PersonDetailsQueryVariables> & ({ variables: PersonDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PersonDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PersonDetailsQuery, PersonDetailsQueryVariables>(PersonDetailsDocument, parser(options)));
      }
export function usePersonDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PersonDetailsQuery, PersonDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PersonDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PersonDetailsQuery, PersonDetailsQueryVariables>(PersonDetailsDocument, options));
        }

export type PersonDetailsQueryResult = ApolloReact.QueryResult<PersonDetailsQuery, PersonDetailsQueryVariables>;
export function refetchPersonDetailsQuery(variables: PersonDetailsQueryVariables) {
      return { query: PersonDetailsDocument, variables: variables }
    }
export const PersonDetailsTrDocument = /*#__PURE__*/ gql`
    query PersonDetails_Tr($contractId: ContractId!) {
  timeReport(from: "2017-01-01", to: "2017-01-02", contractId: $contractId) {
    ...NfsError
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __usePersonDetailsTrQuery__
 *
 * To run a query within a React component, call `usePersonDetailsTrQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonDetailsTrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonDetailsTrQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function usePersonDetailsTrQuery(baseOptions: ApolloReact.QueryHookOptions<PersonDetailsTrQuery, PersonDetailsTrQueryVariables> & ({ variables: PersonDetailsTrQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PersonDetailsTrDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PersonDetailsTrQuery, PersonDetailsTrQueryVariables>(PersonDetailsTrDocument, parser(options)));
      }
export function usePersonDetailsTrLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PersonDetailsTrQuery, PersonDetailsTrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PersonDetailsTrDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PersonDetailsTrQuery, PersonDetailsTrQueryVariables>(PersonDetailsTrDocument, options));
        }

export type PersonDetailsTrQueryResult = ApolloReact.QueryResult<PersonDetailsTrQuery, PersonDetailsTrQueryVariables>;
export function refetchPersonDetailsTrQuery(variables: PersonDetailsTrQueryVariables) {
      return { query: PersonDetailsTrDocument, variables: variables }
    }
export const ProgressionSchemeDetailsDocument = /*#__PURE__*/ gql`
    query ProgressionSchemeDetails($schemeId: ProgressionSchemeId!) {
  progressionScheme(progressionSchemeId: $schemeId) {
    ...NfsError
    ... on ProgressionScheme {
      ...ProgressionSchemes_ProgressionScheme
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionSchemesProgressionSchemeFragmentDoc}`;

/**
 * __useProgressionSchemeDetailsQuery__
 *
 * To run a query within a React component, call `useProgressionSchemeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgressionSchemeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgressionSchemeDetailsQuery({
 *   variables: {
 *      schemeId: // value for 'schemeId'
 *   },
 * });
 */
export function useProgressionSchemeDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<ProgressionSchemeDetailsQuery, ProgressionSchemeDetailsQueryVariables> & ({ variables: ProgressionSchemeDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProgressionSchemeDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProgressionSchemeDetailsQuery, ProgressionSchemeDetailsQueryVariables>(ProgressionSchemeDetailsDocument, parser(options)));
      }
export function useProgressionSchemeDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProgressionSchemeDetailsQuery, ProgressionSchemeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProgressionSchemeDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProgressionSchemeDetailsQuery, ProgressionSchemeDetailsQueryVariables>(ProgressionSchemeDetailsDocument, options));
        }

export type ProgressionSchemeDetailsQueryResult = ApolloReact.QueryResult<ProgressionSchemeDetailsQuery, ProgressionSchemeDetailsQueryVariables>;
export function refetchProgressionSchemeDetailsQuery(variables: ProgressionSchemeDetailsQueryVariables) {
      return { query: ProgressionSchemeDetailsDocument, variables: variables }
    }
export const ProgressionSchemesDocument = /*#__PURE__*/ gql`
    query ProgressionSchemes {
  progressionSchemes(includeArchived: true) {
    ...NfsError
    ... on ListOfProgressionSchemeResponse {
      value {
        ...ProgressionSchemes_ProgressionScheme
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionSchemesProgressionSchemeFragmentDoc}`;

/**
 * __useProgressionSchemesQuery__
 *
 * To run a query within a React component, call `useProgressionSchemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgressionSchemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgressionSchemesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgressionSchemesQuery(baseOptions?: ApolloReact.QueryHookOptions<ProgressionSchemesQuery, ProgressionSchemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProgressionSchemesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProgressionSchemesQuery, ProgressionSchemesQueryVariables>(ProgressionSchemesDocument, parser(options)));
      }
export function useProgressionSchemesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProgressionSchemesQuery, ProgressionSchemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProgressionSchemesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProgressionSchemesQuery, ProgressionSchemesQueryVariables>(ProgressionSchemesDocument, options));
        }

export type ProgressionSchemesQueryResult = ApolloReact.QueryResult<ProgressionSchemesQuery, ProgressionSchemesQueryVariables>;
export function refetchProgressionSchemesQuery(variables?: ProgressionSchemesQueryVariables) {
      return { query: ProgressionSchemesDocument, variables: variables }
    }
export const ProjectDetailsDocument = /*#__PURE__*/ gql`
    query ProjectDetails($projectId: ProjectId!) {
  project(projectId: $projectId) {
    ...NfsError
    ... on Project {
      id
      entityVersion
      createdAt
      name
      statusHistory {
        status
        dateRange {
          from
          to
        }
      }
      clientContract {
        id
        entityVersion
        promisee {
          id
          entityVersion
        }
      }
      lead {
        project {
          id
        }
        periods {
          dateRange {
            from
            to
          }
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useProjectDetailsQuery__
 *
 * To run a query within a React component, call `useProjectDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDetailsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables> & ({ variables: ProjectDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectDetailsQuery, ProjectDetailsQueryVariables>(ProjectDetailsDocument, parser(options)));
      }
export function useProjectDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectDetailsQuery, ProjectDetailsQueryVariables>(ProjectDetailsDocument, options));
        }

export type ProjectDetailsQueryResult = ApolloReact.QueryResult<ProjectDetailsQuery, ProjectDetailsQueryVariables>;
export function refetchProjectDetailsQuery(variables: ProjectDetailsQueryVariables) {
      return { query: ProjectDetailsDocument, variables: variables }
    }
export const ProjectUtilizationDocument = /*#__PURE__*/ gql`
    query ProjectUtilization($yearMonth: YearMonth!, $fullTimeThresholdMinutes: Int!, $halfTimeThresholdMinutes: Int!) {
  projectUtilization(
    yearMonth: $yearMonth
    fullTimeThresholdMinutes: $fullTimeThresholdMinutes
    halfTimeThresholdMinutes: $halfTimeThresholdMinutes
  ) {
    ...NfsError
    ... on ListOfProjectUtilizationResponse {
      value {
        client {
          id
          name
          logo
        }
        project {
          id
          name
          clientContract {
            id
            promisor {
              id
            }
          }
          space {
            id
            name
          }
        }
        mandays
        fullTimeEquivalent
        teamMembers {
          id
          firstName
          lastName
          avatar
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useProjectUtilizationQuery__
 *
 * To run a query within a React component, call `useProjectUtilizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectUtilizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectUtilizationQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      fullTimeThresholdMinutes: // value for 'fullTimeThresholdMinutes'
 *      halfTimeThresholdMinutes: // value for 'halfTimeThresholdMinutes'
 *   },
 * });
 */
export function useProjectUtilizationQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectUtilizationQuery, ProjectUtilizationQueryVariables> & ({ variables: ProjectUtilizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectUtilizationDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectUtilizationQuery, ProjectUtilizationQueryVariables>(ProjectUtilizationDocument, parser(options)));
      }
export function useProjectUtilizationLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectUtilizationQuery, ProjectUtilizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectUtilizationDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectUtilizationQuery, ProjectUtilizationQueryVariables>(ProjectUtilizationDocument, options));
        }

export type ProjectUtilizationQueryResult = ApolloReact.QueryResult<ProjectUtilizationQuery, ProjectUtilizationQueryVariables>;
export function refetchProjectUtilizationQuery(variables: ProjectUtilizationQueryVariables) {
      return { query: ProjectUtilizationDocument, variables: variables }
    }
export const ProjectsDocument = /*#__PURE__*/ gql`
    query Projects($first: Int, $after: Cursor, $filter: FilterProjectInput, $sort: SortingRequestSortProjectInput) {
  projects(first: $first, after: $after, filter: $filter, sort: $sort) {
    ...NfsError
    ... on FSPResponseProject {
      totalCount
      filteredCount
      hasNextPage
      edges {
        cursor
        node {
          id
          entityVersion
          createdAt
          name
          techStack {
            ...Unauthorized
            ... on AccessGranted__ListOfString {
              value
            }
          }
          competences {
            ...Unauthorized
            ... on AccessGranted__ListOfString {
              value
            }
          }
          description {
            ...Unauthorized
            ... on AccessGranted__OptionalString {
              value
            }
          }
          areaOfVlEngagement {
            ...Unauthorized
            ... on AccessGranted__OptionalString {
              value
            }
          }
          costLedgerAccountNumber {
            ...Unauthorized
            ... on AccessGranted__OptionalString {
              value
            }
          }
          revenueLedgerAccountNumber {
            ...Unauthorized
            ... on AccessGranted__OptionalString {
              value
            }
          }
          statusHistory {
            status
            dateRange {
              from
              to
            }
          }
          lead {
            ...ProjectRoleAssignment
          }
          owner {
            ...ProjectRoleAssignment
          }
          accountManager {
            ...ProjectRoleAssignment
          }
          crossSell {
            ...Unauthorized
            ... on AccessGranted__OptionalCrossSell {
              value {
                ...CrossSell
              }
            }
          }
          assignedUsers(status_oneOf: [Live, Planned]) {
            project {
              id
            }
            user {
              id
              entityVersion
              avatar
              firstName
              lastName
              contracts {
                ...Unauthorized
                ... on AccessGranted__ListOfContract {
                  value {
                    id
                    status
                  }
                }
              }
            }
          }
          space {
            id
            entityVersion
            name
            owner {
              id
              entityVersion
              firstName
              lastName
            }
          }
          clientContract {
            id
            entityVersion
            promisee {
              id
              entityVersion
              name
              logo
              taxNumber
            }
            promisor {
              id
              name
              logo
              taxNumber
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${ProjectRoleAssignmentFragmentDoc}
${CrossSellFragmentDoc}`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions?: ApolloReact.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, parser(options)));
      }
export function useProjectsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options));
        }

export type ProjectsQueryResult = ApolloReact.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export function refetchProjectsQuery(variables?: ProjectsQueryVariables) {
      return { query: ProjectsDocument, variables: variables }
    }
export const RaisesDocument = /*#__PURE__*/ gql`
    query Raises {
  raises {
    ...NfsError
    ... on ListOfRaiseProposalResponse {
      value {
        ...Raises_RaiseProposal
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${RaisesRaiseProposalFragmentDoc}`;

/**
 * __useRaisesQuery__
 *
 * To run a query within a React component, call `useRaisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRaisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRaisesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRaisesQuery(baseOptions?: ApolloReact.QueryHookOptions<RaisesQuery, RaisesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RaisesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RaisesQuery, RaisesQueryVariables>(RaisesDocument, parser(options)));
      }
export function useRaisesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RaisesQuery, RaisesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RaisesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RaisesQuery, RaisesQueryVariables>(RaisesDocument, options));
        }

export type RaisesQueryResult = ApolloReact.QueryResult<RaisesQuery, RaisesQueryVariables>;
export function refetchRaisesQuery(variables?: RaisesQueryVariables) {
      return { query: RaisesDocument, variables: variables }
    }
export const SalariesDocument = /*#__PURE__*/ gql`
    query Salaries($from: YearMonth!, $to: YearMonth!) {
  contractSalarySummariesInRange(from: $from, to: $to) {
    ...NfsError
    ... on ListOfTransfersSummariesResponse {
      value {
        yearMonth
        b2b {
          byPromisor {
            promisorId
            totalCount
            paymentDisbursedState {
              contractCount
              totalTransferAmount {
                ...CentsWithCurrency
              }
            }
            readyState {
              contractCount
              totalTransferAmount {
                ...CentsWithCurrency
              }
            }
            incompleteDataState {
              transfersSummary {
                contractCount
              }
              stateDescriptions {
                ...IncompleteDataDescription
              }
            }
          }
        }
        employment {
          totalCount
          paymentDisbursedState {
            contractCount
            totalSalary {
              ...CentsWithCurrency
            }
          }
          readyState {
            contractCount
            totalSalary {
              ...CentsWithCurrency
            }
          }
          incompleteDataState {
            transfersSummary {
              contractCount
            }
            stateDescriptions {
              ...IncompleteDataDescription
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CentsWithCurrencyFragmentDoc}
${IncompleteDataDescriptionFragmentDoc}`;

/**
 * __useSalariesQuery__
 *
 * To run a query within a React component, call `useSalariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalariesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSalariesQuery(baseOptions: ApolloReact.QueryHookOptions<SalariesQuery, SalariesQueryVariables> & ({ variables: SalariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalariesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalariesQuery, SalariesQueryVariables>(SalariesDocument, parser(options)));
      }
export function useSalariesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalariesQuery, SalariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalariesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalariesQuery, SalariesQueryVariables>(SalariesDocument, options));
        }

export type SalariesQueryResult = ApolloReact.QueryResult<SalariesQuery, SalariesQueryVariables>;
export function refetchSalariesQuery(variables: SalariesQueryVariables) {
      return { query: SalariesDocument, variables: variables }
    }
export const SalariesDetailsB2BDocument = /*#__PURE__*/ gql`
    query SalariesDetailsB2B($first: Int, $after: Cursor, $filter: FilterContractSalaryDetailsInput, $sort: SortingRequestSortContractSalaryDetailsInput, $yearMonth: YearMonth!) {
  contractsB2BSalaryDetails(
    yearMonth: $yearMonth
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    ...NfsError
    ... on FSPResponseB2BContractSalaryDetails {
      hasNextPage
      totalCount
      filteredCount
      edges {
        cursor
        node {
          contractId
          yearMonth
          absenceDays
          workTotalTime
          requiredWorkedTime
          transferAmount
          isTimeReportCompleted
          isTimeReportApprovalRequired
          totalPayout {
            ...NetGross
          }
          flag
          note
          salaryState {
            ...SalaryState
          }
          contract {
            id
            at
            name
            entityVersion
            type
            currency {
              ...Unauthorized
              ... on AccessGranted__TimeBasedCurrency {
                value {
                  value
                }
              }
            }
            promisee {
              id
              firstName
              lastName
              avatar
              progressionLevel {
                value
              }
            }
            promiseeCompany {
              ...Unauthorized
              ... on AccessGranted__Company {
                value {
                  id
                  name
                }
              }
            }
            promisorTransferBankAccount {
              value {
                ...BankAccount
              }
            }
            promisor {
              value {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${NetGrossFragmentDoc}
${SalaryStateFragmentDoc}
${UnauthorizedFragmentDoc}
${BankAccountFragmentDoc}`;

/**
 * __useSalariesDetailsB2BQuery__
 *
 * To run a query within a React component, call `useSalariesDetailsB2BQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalariesDetailsB2BQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalariesDetailsB2BQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      yearMonth: // value for 'yearMonth'
 *   },
 * });
 */
export function useSalariesDetailsB2BQuery(baseOptions: ApolloReact.QueryHookOptions<SalariesDetailsB2BQuery, SalariesDetailsB2BQueryVariables> & ({ variables: SalariesDetailsB2BQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalariesDetailsB2BDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalariesDetailsB2BQuery, SalariesDetailsB2BQueryVariables>(SalariesDetailsB2BDocument, parser(options)));
      }
export function useSalariesDetailsB2BLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalariesDetailsB2BQuery, SalariesDetailsB2BQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalariesDetailsB2BDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalariesDetailsB2BQuery, SalariesDetailsB2BQueryVariables>(SalariesDetailsB2BDocument, options));
        }

export type SalariesDetailsB2BQueryResult = ApolloReact.QueryResult<SalariesDetailsB2BQuery, SalariesDetailsB2BQueryVariables>;
export function refetchSalariesDetailsB2BQuery(variables: SalariesDetailsB2BQueryVariables) {
      return { query: SalariesDetailsB2BDocument, variables: variables }
    }
export const SalariesDetailsEmploymentDocument = /*#__PURE__*/ gql`
    query SalariesDetailsEmployment($first: Int, $after: Cursor, $filter: FilterContractSalaryDetailsInput, $sort: SortingRequestSortContractSalaryDetailsInput, $yearMonth: YearMonth!) {
  contractsEmploymentSalaryDetails(
    yearMonth: $yearMonth
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    ...NfsError
    ... on FSPResponseEmploymentContractSalaryDetails {
      hasNextPage
      totalCount
      filteredCount
      edges {
        cursor
        node {
          contractId
          yearMonth
          absenceDays
          workTotalTime
          requiredWorkedTime
          transferAmount
          isTimeReportCompleted
          isTimeReportApprovalRequired
          totalPayout {
            ...NetGross
          }
          flag
          note
          contract {
            ...SharedSalary_EmploymentContract
          }
          salaryState {
            ...SalaryState
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${NetGrossFragmentDoc}
${SharedSalaryEmploymentContractFragmentDoc}
${SalaryStateFragmentDoc}`;

/**
 * __useSalariesDetailsEmploymentQuery__
 *
 * To run a query within a React component, call `useSalariesDetailsEmploymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalariesDetailsEmploymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalariesDetailsEmploymentQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      yearMonth: // value for 'yearMonth'
 *   },
 * });
 */
export function useSalariesDetailsEmploymentQuery(baseOptions: ApolloReact.QueryHookOptions<SalariesDetailsEmploymentQuery, SalariesDetailsEmploymentQueryVariables> & ({ variables: SalariesDetailsEmploymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalariesDetailsEmploymentDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalariesDetailsEmploymentQuery, SalariesDetailsEmploymentQueryVariables>(SalariesDetailsEmploymentDocument, parser(options)));
      }
export function useSalariesDetailsEmploymentLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalariesDetailsEmploymentQuery, SalariesDetailsEmploymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalariesDetailsEmploymentDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalariesDetailsEmploymentQuery, SalariesDetailsEmploymentQueryVariables>(SalariesDetailsEmploymentDocument, options));
        }

export type SalariesDetailsEmploymentQueryResult = ApolloReact.QueryResult<SalariesDetailsEmploymentQuery, SalariesDetailsEmploymentQueryVariables>;
export function refetchSalariesDetailsEmploymentQuery(variables: SalariesDetailsEmploymentQueryVariables) {
      return { query: SalariesDetailsEmploymentDocument, variables: variables }
    }
export const SalesInvoiceDetailsDocument = /*#__PURE__*/ gql`
    query SalesInvoiceDetails($invoiceId: SalesInvoiceId!) {
  salesInvoiceDetails(invoiceId: $invoiceId) {
    ...NfsError
    ... on SalesInvoiceDetails {
      correctedBy {
        ...SalesInvoices_Invoice
      }
      invoice {
        ...SalesInvoices_Invoice
      }
      connectedPayments {
        description
        paidDate
        value
        currency
        name
        externalPayment {
          fromName
          toName
          fromAccountNumber {
            ...BankAccountNumber
          }
          toAccountNumber {
            ...BankAccountNumber
          }
          ... on BankIncomeTransfer {
            toAccount {
              ...BankAccount
            }
          }
        }
      }
      connectedTransfers {
        transfer {
          id
        }
        invoice {
          id
        }
        tpe
      }
      correctsInvoice {
        id
        number
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalesInvoicesInvoiceFragmentDoc}
${BankAccountNumberFragmentDoc}
${BankAccountFragmentDoc}`;

/**
 * __useSalesInvoiceDetailsQuery__
 *
 * To run a query within a React component, call `useSalesInvoiceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesInvoiceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesInvoiceDetailsQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useSalesInvoiceDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<SalesInvoiceDetailsQuery, SalesInvoiceDetailsQueryVariables> & ({ variables: SalesInvoiceDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalesInvoiceDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalesInvoiceDetailsQuery, SalesInvoiceDetailsQueryVariables>(SalesInvoiceDetailsDocument, parser(options)));
      }
export function useSalesInvoiceDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalesInvoiceDetailsQuery, SalesInvoiceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalesInvoiceDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalesInvoiceDetailsQuery, SalesInvoiceDetailsQueryVariables>(SalesInvoiceDetailsDocument, options));
        }

export type SalesInvoiceDetailsQueryResult = ApolloReact.QueryResult<SalesInvoiceDetailsQuery, SalesInvoiceDetailsQueryVariables>;
export function refetchSalesInvoiceDetailsQuery(variables: SalesInvoiceDetailsQueryVariables) {
      return { query: SalesInvoiceDetailsDocument, variables: variables }
    }
export const SalesInvoicesDocument = /*#__PURE__*/ gql`
    query SalesInvoices($dateRange: ClosedEndLocalDateRangeInput!, $searchDateType: SearchDateType!, $allSearch: String, $buyerType_oneOf: [BuyerType!], $buyerCompany_oneOf: [CompanyId!], $buyerName_oneOf: [String!], $clientIsWithinGroup_eq: Boolean, $sellerCompany_oneOf: [CompanyId!], $status_oneOf: [SalesInvoiceStatus!], $kind_oneOf: [InvoiceKind!], $currency_oneOf: [Currency!], $overdue_eq: Boolean, $expectedPaymentDate_inRange: ClosedEndLocalDateRangeInput, $issueDate_inRange: ClosedEndLocalDateRangeInput, $paymentTo_inRange: ClosedEndLocalDateRangeInput, $sellDate_inRange: ClosedEndLocalDateRangeInput, $paidDate_inRange: ClosedEndLocalDateRangeInput) {
  salesInvoices(
    dateRange: $dateRange
    searchDateType: $searchDateType
    allSearch: $allSearch
    buyerType_oneOf: $buyerType_oneOf
    buyerCompany_oneOf: $buyerCompany_oneOf
    buyerName_oneOf: $buyerName_oneOf
    clientIsWithinGroup_eq: $clientIsWithinGroup_eq
    sellerCompany_oneOf: $sellerCompany_oneOf
    status_oneOf: $status_oneOf
    kind_oneOf: $kind_oneOf
    currency_oneOf: $currency_oneOf
    overdue_eq: $overdue_eq
    expectedPaymentDate_inRange: $expectedPaymentDate_inRange
    issueDate_inRange: $issueDate_inRange
    paymentTo_inRange: $paymentTo_inRange
    sellDate_inRange: $sellDate_inRange
    paidDate_inRange: $paidDate_inRange
  ) {
    ...NfsError
    ... on ListOfSalesInvoiceResponse {
      value {
        ...SalesInvoices_Invoice
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalesInvoicesInvoiceFragmentDoc}`;

/**
 * __useSalesInvoicesQuery__
 *
 * To run a query within a React component, call `useSalesInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesInvoicesQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      searchDateType: // value for 'searchDateType'
 *      allSearch: // value for 'allSearch'
 *      buyerType_oneOf: // value for 'buyerType_oneOf'
 *      buyerCompany_oneOf: // value for 'buyerCompany_oneOf'
 *      buyerName_oneOf: // value for 'buyerName_oneOf'
 *      clientIsWithinGroup_eq: // value for 'clientIsWithinGroup_eq'
 *      sellerCompany_oneOf: // value for 'sellerCompany_oneOf'
 *      status_oneOf: // value for 'status_oneOf'
 *      kind_oneOf: // value for 'kind_oneOf'
 *      currency_oneOf: // value for 'currency_oneOf'
 *      overdue_eq: // value for 'overdue_eq'
 *      expectedPaymentDate_inRange: // value for 'expectedPaymentDate_inRange'
 *      issueDate_inRange: // value for 'issueDate_inRange'
 *      paymentTo_inRange: // value for 'paymentTo_inRange'
 *      sellDate_inRange: // value for 'sellDate_inRange'
 *      paidDate_inRange: // value for 'paidDate_inRange'
 *   },
 * });
 */
export function useSalesInvoicesQuery(baseOptions: ApolloReact.QueryHookOptions<SalesInvoicesQuery, SalesInvoicesQueryVariables> & ({ variables: SalesInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalesInvoicesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalesInvoicesQuery, SalesInvoicesQueryVariables>(SalesInvoicesDocument, parser(options)));
      }
export function useSalesInvoicesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalesInvoicesQuery, SalesInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalesInvoicesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalesInvoicesQuery, SalesInvoicesQueryVariables>(SalesInvoicesDocument, options));
        }

export type SalesInvoicesQueryResult = ApolloReact.QueryResult<SalesInvoicesQuery, SalesInvoicesQueryVariables>;
export function refetchSalesInvoicesQuery(variables: SalesInvoicesQueryVariables) {
      return { query: SalesInvoicesDocument, variables: variables }
    }
export const SalesInvoicesFakturowniaProfilesDocument = /*#__PURE__*/ gql`
    query SalesInvoices_FakturowniaProfiles {
  fakturowniaProfiles {
    ...NfsError
    ... on ListOfFakturowniaProfileResponse {
      value {
        id
        url
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useSalesInvoicesFakturowniaProfilesQuery__
 *
 * To run a query within a React component, call `useSalesInvoicesFakturowniaProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesInvoicesFakturowniaProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesInvoicesFakturowniaProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesInvoicesFakturowniaProfilesQuery(baseOptions?: ApolloReact.QueryHookOptions<SalesInvoicesFakturowniaProfilesQuery, SalesInvoicesFakturowniaProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalesInvoicesFakturowniaProfilesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SalesInvoicesFakturowniaProfilesQuery, SalesInvoicesFakturowniaProfilesQueryVariables>(SalesInvoicesFakturowniaProfilesDocument, parser(options)));
      }
export function useSalesInvoicesFakturowniaProfilesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SalesInvoicesFakturowniaProfilesQuery, SalesInvoicesFakturowniaProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SalesInvoicesFakturowniaProfilesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SalesInvoicesFakturowniaProfilesQuery, SalesInvoicesFakturowniaProfilesQueryVariables>(SalesInvoicesFakturowniaProfilesDocument, options));
        }

export type SalesInvoicesFakturowniaProfilesQueryResult = ApolloReact.QueryResult<SalesInvoicesFakturowniaProfilesQuery, SalesInvoicesFakturowniaProfilesQueryVariables>;
export function refetchSalesInvoicesFakturowniaProfilesQuery(variables?: SalesInvoicesFakturowniaProfilesQueryVariables) {
      return { query: SalesInvoicesFakturowniaProfilesDocument, variables: variables }
    }
export const SalesInvoicesExportDocument = /*#__PURE__*/ gql`
    mutation SalesInvoices_Export($dateRange: ClosedEndLocalDateRangeInput!, $searchDateType: SearchDateType!, $allSearch: String, $buyerType_oneOf: [BuyerType!], $buyerCompany_oneOf: [CompanyId!], $buyerName_oneOf: [String!], $clientIsWithinGroup_eq: Boolean, $sellerCompany_oneOf: [CompanyId!], $status_oneOf: [SalesInvoiceStatus!], $status_notIn: [SalesInvoiceStatus!], $kind_oneOf: [InvoiceKind!], $currency_oneOf: [Currency!], $overdue_eq: Boolean, $expectedPaymentDate_inRange: ClosedEndLocalDateRangeInput, $issueDate_inRange: ClosedEndLocalDateRangeInput, $paymentTo_inRange: ClosedEndLocalDateRangeInput, $sellDate_inRange: ClosedEndLocalDateRangeInput, $paidDate_inRange: ClosedEndLocalDateRangeInput) {
  exportSalesInvoices(
    dateRange: $dateRange
    searchDateType: $searchDateType
    allSearch: $allSearch
    buyerType_oneOf: $buyerType_oneOf
    buyerCompany_oneOf: $buyerCompany_oneOf
    buyerName_oneOf: $buyerName_oneOf
    clientIsWithinGroup_eq: $clientIsWithinGroup_eq
    sellerCompany_oneOf: $sellerCompany_oneOf
    status_oneOf: $status_oneOf
    status_notIn: $status_notIn
    kind_oneOf: $kind_oneOf
    currency_oneOf: $currency_oneOf
    overdue_eq: $overdue_eq
    expectedPaymentDate_inRange: $expectedPaymentDate_inRange
    issueDate_inRange: $issueDate_inRange
    paymentTo_inRange: $paymentTo_inRange
    sellDate_inRange: $sellDate_inRange
    paidDate_inRange: $paidDate_inRange
  ) {
    ...NfsError
    ... on GoogleSpreadsheetUrl {
      url
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useSalesInvoicesExportMutation__
 *
 * To run a mutation, you first call `useSalesInvoicesExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesInvoicesExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesInvoicesExportMutation, { data, loading, error }] = useSalesInvoicesExportMutation({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      searchDateType: // value for 'searchDateType'
 *      allSearch: // value for 'allSearch'
 *      buyerType_oneOf: // value for 'buyerType_oneOf'
 *      buyerCompany_oneOf: // value for 'buyerCompany_oneOf'
 *      buyerName_oneOf: // value for 'buyerName_oneOf'
 *      clientIsWithinGroup_eq: // value for 'clientIsWithinGroup_eq'
 *      sellerCompany_oneOf: // value for 'sellerCompany_oneOf'
 *      status_oneOf: // value for 'status_oneOf'
 *      status_notIn: // value for 'status_notIn'
 *      kind_oneOf: // value for 'kind_oneOf'
 *      currency_oneOf: // value for 'currency_oneOf'
 *      overdue_eq: // value for 'overdue_eq'
 *      expectedPaymentDate_inRange: // value for 'expectedPaymentDate_inRange'
 *      issueDate_inRange: // value for 'issueDate_inRange'
 *      paymentTo_inRange: // value for 'paymentTo_inRange'
 *      sellDate_inRange: // value for 'sellDate_inRange'
 *      paidDate_inRange: // value for 'paidDate_inRange'
 *   },
 * });
 */
export function useSalesInvoicesExportMutation(baseOptions?: ApolloReact.MutationHookOptions<SalesInvoicesExportMutation, SalesInvoicesExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SalesInvoicesExportDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SalesInvoicesExportMutation, SalesInvoicesExportMutationVariables>(SalesInvoicesExportDocument, parser(options)));
      }
export type SalesInvoicesExportMutationHookResult = ReturnType<typeof useSalesInvoicesExportMutation>;
export type SalesInvoicesExportMutationResult = ApolloReact.MutationResult<SalesInvoicesExportMutation>;
export type SalesInvoicesExportMutationOptions = Apollo.MutationOptions<SalesInvoicesExportMutation, SalesInvoicesExportMutationVariables>;
export const GmailConnectionDocument = /*#__PURE__*/ gql`
    query GmailConnection {
  gmailConnection {
    ...NfsError
    ... on GmailConnection {
      adminId
      connectedEmail
      createdAt
      aliases
      selectedAlias
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useGmailConnectionQuery__
 *
 * To run a query within a React component, call `useGmailConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGmailConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGmailConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGmailConnectionQuery(baseOptions?: ApolloReact.QueryHookOptions<GmailConnectionQuery, GmailConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(GmailConnectionDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<GmailConnectionQuery, GmailConnectionQueryVariables>(GmailConnectionDocument, parser(options)));
      }
export function useGmailConnectionLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<GmailConnectionQuery, GmailConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(GmailConnectionDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<GmailConnectionQuery, GmailConnectionQueryVariables>(GmailConnectionDocument, options));
        }

export type GmailConnectionQueryResult = ApolloReact.QueryResult<GmailConnectionQuery, GmailConnectionQueryVariables>;
export function refetchGmailConnectionQuery(variables?: GmailConnectionQueryVariables) {
      return { query: GmailConnectionDocument, variables: variables }
    }
export const GmailAuthUrlDocument = /*#__PURE__*/ gql`
    query GmailAuthUrl {
  gmailAuthUrl {
    ...NfsError
    ... on URIResponse {
      value
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useGmailAuthUrlQuery__
 *
 * To run a query within a React component, call `useGmailAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGmailAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGmailAuthUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGmailAuthUrlQuery(baseOptions?: ApolloReact.QueryHookOptions<GmailAuthUrlQuery, GmailAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(GmailAuthUrlDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<GmailAuthUrlQuery, GmailAuthUrlQueryVariables>(GmailAuthUrlDocument, parser(options)));
      }
export function useGmailAuthUrlLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<GmailAuthUrlQuery, GmailAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(GmailAuthUrlDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<GmailAuthUrlQuery, GmailAuthUrlQueryVariables>(GmailAuthUrlDocument, options));
        }

export type GmailAuthUrlQueryResult = ApolloReact.QueryResult<GmailAuthUrlQuery, GmailAuthUrlQueryVariables>;
export function refetchGmailAuthUrlQuery(variables?: GmailAuthUrlQueryVariables) {
      return { query: GmailAuthUrlDocument, variables: variables }
    }
export const ConnectGmailAccountDocument = /*#__PURE__*/ gql`
    mutation ConnectGmailAccount($code: String!) {
  connectGmailAccount(code: $code) {
    ...NfsError
    ... on GmailConnection {
      adminId
      connectedEmail
      createdAt
      aliases
      selectedAlias
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useConnectGmailAccountMutation__
 *
 * To run a mutation, you first call `useConnectGmailAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectGmailAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectGmailAccountMutation, { data, loading, error }] = useConnectGmailAccountMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConnectGmailAccountMutation(baseOptions?: ApolloReact.MutationHookOptions<ConnectGmailAccountMutation, ConnectGmailAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ConnectGmailAccountDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ConnectGmailAccountMutation, ConnectGmailAccountMutationVariables>(ConnectGmailAccountDocument, parser(options)));
      }
export type ConnectGmailAccountMutationHookResult = ReturnType<typeof useConnectGmailAccountMutation>;
export type ConnectGmailAccountMutationResult = ApolloReact.MutationResult<ConnectGmailAccountMutation>;
export type ConnectGmailAccountMutationOptions = Apollo.MutationOptions<ConnectGmailAccountMutation, ConnectGmailAccountMutationVariables>;
export const DisconnectGmailAccountDocument = /*#__PURE__*/ gql`
    mutation DisconnectGmailAccount {
  disconnectGmailAccount {
    ...NfsError
    ... on UnitResponse {
      value
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useDisconnectGmailAccountMutation__
 *
 * To run a mutation, you first call `useDisconnectGmailAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectGmailAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectGmailAccountMutation, { data, loading, error }] = useDisconnectGmailAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectGmailAccountMutation(baseOptions?: ApolloReact.MutationHookOptions<DisconnectGmailAccountMutation, DisconnectGmailAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DisconnectGmailAccountDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<DisconnectGmailAccountMutation, DisconnectGmailAccountMutationVariables>(DisconnectGmailAccountDocument, parser(options)));
      }
export type DisconnectGmailAccountMutationHookResult = ReturnType<typeof useDisconnectGmailAccountMutation>;
export type DisconnectGmailAccountMutationResult = ApolloReact.MutationResult<DisconnectGmailAccountMutation>;
export type DisconnectGmailAccountMutationOptions = Apollo.MutationOptions<DisconnectGmailAccountMutation, DisconnectGmailAccountMutationVariables>;
export const SelectGmailAliasDocument = /*#__PURE__*/ gql`
    mutation SelectGmailAlias($alias: EmailAddress!) {
  selectGmailAlias(alias: $alias) {
    ...NfsError
    ... on GmailConnection {
      adminId
      connectedEmail
      createdAt
      aliases
      selectedAlias
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useSelectGmailAliasMutation__
 *
 * To run a mutation, you first call `useSelectGmailAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectGmailAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectGmailAliasMutation, { data, loading, error }] = useSelectGmailAliasMutation({
 *   variables: {
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useSelectGmailAliasMutation(baseOptions?: ApolloReact.MutationHookOptions<SelectGmailAliasMutation, SelectGmailAliasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SelectGmailAliasDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<SelectGmailAliasMutation, SelectGmailAliasMutationVariables>(SelectGmailAliasDocument, parser(options)));
      }
export type SelectGmailAliasMutationHookResult = ReturnType<typeof useSelectGmailAliasMutation>;
export type SelectGmailAliasMutationResult = ApolloReact.MutationResult<SelectGmailAliasMutation>;
export type SelectGmailAliasMutationOptions = Apollo.MutationOptions<SelectGmailAliasMutation, SelectGmailAliasMutationVariables>;
export const RefreshGmailAliasesDocument = /*#__PURE__*/ gql`
    mutation RefreshGmailAliases {
  refreshGmailAliases {
    ...NfsError
    ... on GmailConnection {
      adminId
      connectedEmail
      createdAt
      aliases
      selectedAlias
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useRefreshGmailAliasesMutation__
 *
 * To run a mutation, you first call `useRefreshGmailAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshGmailAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshGmailAliasesMutation, { data, loading, error }] = useRefreshGmailAliasesMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshGmailAliasesMutation(baseOptions?: ApolloReact.MutationHookOptions<RefreshGmailAliasesMutation, RefreshGmailAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RefreshGmailAliasesDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<RefreshGmailAliasesMutation, RefreshGmailAliasesMutationVariables>(RefreshGmailAliasesDocument, parser(options)));
      }
export type RefreshGmailAliasesMutationHookResult = ReturnType<typeof useRefreshGmailAliasesMutation>;
export type RefreshGmailAliasesMutationResult = ApolloReact.MutationResult<RefreshGmailAliasesMutation>;
export type RefreshGmailAliasesMutationOptions = Apollo.MutationOptions<RefreshGmailAliasesMutation, RefreshGmailAliasesMutationVariables>;
export const SpaceDetailsDocument = /*#__PURE__*/ gql`
    query SpaceDetails($spaceId: SpaceId!, $first: Int, $after: Cursor, $filter: FilterUserInput, $sort: SortingRequestSortUserInput) {
  space(spaceId: $spaceId) {
    ...NfsError
    ... on Space {
      id
      entityVersion
      name
      owner {
        id
        entityVersion
        firstName
        lastName
        avatar
      }
      directors {
        id
        entityVersion
        firstName
        lastName
        avatar
      }
      members(first: $first, after: $after, filter: $filter, sort: $sort) {
        filteredCount
        hasNextPage
        edges {
          cursor
          node {
            id
            entityVersion
            firstName
            lastName
            avatar
            email
            skillsAndCompetences
            areaOfExpertise
            certificates {
              ...Unauthorized
              ... on AccessGranted__ListOfCertificate {
                value {
                  id
                  name
                }
              }
            }
            progressionLevel {
              value
            }
            role {
              value
            }
            contracts {
              ...Unauthorized
              ... on AccessGranted__ListOfContract {
                value {
                  id
                  status
                  ... on EmploymentContract {
                    type
                    position {
                      value
                    }
                  }
                  ... on B2BContract {
                    position {
                      value
                    }
                  }
                }
              }
            }
            newestRateChangeDate {
              ...Unauthorized
              ... on AccessGranted__OptionalOffsetDateTime {
                value
              }
            }
            directReporting {
              practiceLead {
                value {
                  id
                  firstName
                  lastName
                  email
                  avatar
                }
              }
              operationalLead {
                value {
                  id
                  firstName
                  lastName
                  email
                  avatar
                }
              }
              assignedProjects(status_oneOf: [Live, Planned]) {
                ...Unauthorized
                ... on AccessGranted__ListOfProjectAssignment {
                  value {
                    user {
                      id
                    }
                    project {
                      id
                      entityVersion
                      name
                      clientContract {
                        id
                        promisor {
                          id
                          name
                        }
                      }
                    }
                  }
                }
              }
              space {
                value {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useSpaceDetailsQuery__
 *
 * To run a query within a React component, call `useSpaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceDetailsQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSpaceDetailsQuery(baseOptions: ApolloReact.QueryHookOptions<SpaceDetailsQuery, SpaceDetailsQueryVariables> & ({ variables: SpaceDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SpaceDetailsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SpaceDetailsQuery, SpaceDetailsQueryVariables>(SpaceDetailsDocument, parser(options)));
      }
export function useSpaceDetailsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SpaceDetailsQuery, SpaceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SpaceDetailsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SpaceDetailsQuery, SpaceDetailsQueryVariables>(SpaceDetailsDocument, options));
        }

export type SpaceDetailsQueryResult = ApolloReact.QueryResult<SpaceDetailsQuery, SpaceDetailsQueryVariables>;
export function refetchSpaceDetailsQuery(variables: SpaceDetailsQueryVariables) {
      return { query: SpaceDetailsDocument, variables: variables }
    }
export const SpacesDocument = /*#__PURE__*/ gql`
    query Spaces($first: Int, $after: Cursor, $filter: FilterSpaceInput, $members: Int!) {
  spaces(first: $first, after: $after, filter: $filter) {
    ...NfsError
    ... on FSPResponseSpace {
      totalCount
      filteredCount
      hasNextPage
      edges {
        cursor
        node {
          id
          entityVersion
          name
          owner {
            id
            entityVersion
            avatar
            firstName
            lastName
          }
          directors {
            id
            entityVersion
            firstName
            lastName
          }
          members(first: $members, filter: {activityStatus_eq: true}) {
            filteredCount
            edges {
              node {
                id
                entityVersion
                avatar
                firstName
                lastName
                contracts {
                  ...Unauthorized
                  ... on AccessGranted__ListOfContract {
                    value {
                      id
                      status
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useSpacesQuery__
 *
 * To run a query within a React component, call `useSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpacesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      members: // value for 'members'
 *   },
 * });
 */
export function useSpacesQuery(baseOptions: ApolloReact.QueryHookOptions<SpacesQuery, SpacesQueryVariables> & ({ variables: SpacesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SpacesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SpacesQuery, SpacesQueryVariables>(SpacesDocument, parser(options)));
      }
export function useSpacesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SpacesQuery, SpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SpacesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SpacesQuery, SpacesQueryVariables>(SpacesDocument, options));
        }

export type SpacesQueryResult = ApolloReact.QueryResult<SpacesQuery, SpacesQueryVariables>;
export function refetchSpacesQuery(variables: SpacesQueryVariables) {
      return { query: SpacesDocument, variables: variables }
    }
export const PeopleCalendarDocument = /*#__PURE__*/ gql`
    query PeopleCalendar($first: Int, $after: Cursor, $filter: FilterUserInput, $sort: SortingRequestSortUserInput, $from: LocalDate!, $to: LocalDate!) {
  users(first: $first, after: $after, filter: $filter, sort: $sort) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      totalCount
      filteredCount
      edges {
        cursor
        node {
          id
          entityVersion
          firstName
          lastName
          avatar
          email
          contracts {
            ...Unauthorized
            ... on AccessGranted__ListOfContract {
              value {
                id
                status
                holidayCalendar {
                  id
                  calendarDays {
                    date
                  }
                }
                ... on EmploymentContract {
                  type
                }
                ... on B2BContract {
                  b2bContractType: type
                }
                ... on Subcontract {
                  b2bContractType: type
                }
              }
            }
          }
          timeReports {
            ...Unauthorized
            ... on AccessGranted__TimeReports {
              value {
                records(from: $from, to: $to) {
                  absence {
                    ...AbsenceRecord
                    contractId
                  }
                  work {
                    id
                    contractId
                    date
                    duration
                    overtime
                    remoteWork
                    comment
                    workTag {
                      id
                      name
                    }
                    project {
                      id
                      name
                    }
                  }
                  onCall {
                    id
                    contractId
                    date
                    dayShift
                    nightShift
                    comment
                    project {
                      id
                      name
                    }
                  }
                  workTags {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${AbsenceRecordFragmentDoc}`;

/**
 * __usePeopleCalendarQuery__
 *
 * To run a query within a React component, call `usePeopleCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleCalendarQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function usePeopleCalendarQuery(baseOptions: ApolloReact.QueryHookOptions<PeopleCalendarQuery, PeopleCalendarQueryVariables> & ({ variables: PeopleCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(PeopleCalendarDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<PeopleCalendarQuery, PeopleCalendarQueryVariables>(PeopleCalendarDocument, parser(options)));
      }
export function usePeopleCalendarLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<PeopleCalendarQuery, PeopleCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(PeopleCalendarDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<PeopleCalendarQuery, PeopleCalendarQueryVariables>(PeopleCalendarDocument, options));
        }

export type PeopleCalendarQueryResult = ApolloReact.QueryResult<PeopleCalendarQuery, PeopleCalendarQueryVariables>;
export function refetchPeopleCalendarQuery(variables: PeopleCalendarQueryVariables) {
      return { query: PeopleCalendarDocument, variables: variables }
    }
export const ApprovalsApproveLeaveDocument = /*#__PURE__*/ gql`
    mutation Approvals_ApproveLeave($entryId: AbsenceRecordId!) {
  reporting {
    absenceRecord {
      approve(id: $entryId) {
        ...NfsError
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useApprovalsApproveLeaveMutation__
 *
 * To run a mutation, you first call `useApprovalsApproveLeaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalsApproveLeaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalsApproveLeaveMutation, { data, loading, error }] = useApprovalsApproveLeaveMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useApprovalsApproveLeaveMutation(baseOptions?: ApolloReact.MutationHookOptions<ApprovalsApproveLeaveMutation, ApprovalsApproveLeaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ApprovalsApproveLeaveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ApprovalsApproveLeaveMutation, ApprovalsApproveLeaveMutationVariables>(ApprovalsApproveLeaveDocument, parser(options)));
      }
export type ApprovalsApproveLeaveMutationHookResult = ReturnType<typeof useApprovalsApproveLeaveMutation>;
export type ApprovalsApproveLeaveMutationResult = ApolloReact.MutationResult<ApprovalsApproveLeaveMutation>;
export type ApprovalsApproveLeaveMutationOptions = Apollo.MutationOptions<ApprovalsApproveLeaveMutation, ApprovalsApproveLeaveMutationVariables>;
export const ApprovalsRejectLeaveDocument = /*#__PURE__*/ gql`
    mutation Approvals_RejectLeave($entryId: AbsenceRecordId!) {
  reporting {
    absenceRecord {
      reject(id: $entryId) {
        ...NfsError
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useApprovalsRejectLeaveMutation__
 *
 * To run a mutation, you first call `useApprovalsRejectLeaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalsRejectLeaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalsRejectLeaveMutation, { data, loading, error }] = useApprovalsRejectLeaveMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useApprovalsRejectLeaveMutation(baseOptions?: ApolloReact.MutationHookOptions<ApprovalsRejectLeaveMutation, ApprovalsRejectLeaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ApprovalsRejectLeaveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ApprovalsRejectLeaveMutation, ApprovalsRejectLeaveMutationVariables>(ApprovalsRejectLeaveDocument, parser(options)));
      }
export type ApprovalsRejectLeaveMutationHookResult = ReturnType<typeof useApprovalsRejectLeaveMutation>;
export type ApprovalsRejectLeaveMutationResult = ApolloReact.MutationResult<ApprovalsRejectLeaveMutation>;
export type ApprovalsRejectLeaveMutationOptions = Apollo.MutationOptions<ApprovalsRejectLeaveMutation, ApprovalsRejectLeaveMutationVariables>;
export const ApprovalsApproveOvertimeDocument = /*#__PURE__*/ gql`
    mutation Approvals_ApproveOvertime($entryId: WorkRecordId!) {
  reporting {
    workRecord {
      approve(id: $entryId) {
        ...NfsError
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useApprovalsApproveOvertimeMutation__
 *
 * To run a mutation, you first call `useApprovalsApproveOvertimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalsApproveOvertimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalsApproveOvertimeMutation, { data, loading, error }] = useApprovalsApproveOvertimeMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useApprovalsApproveOvertimeMutation(baseOptions?: ApolloReact.MutationHookOptions<ApprovalsApproveOvertimeMutation, ApprovalsApproveOvertimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ApprovalsApproveOvertimeDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ApprovalsApproveOvertimeMutation, ApprovalsApproveOvertimeMutationVariables>(ApprovalsApproveOvertimeDocument, parser(options)));
      }
export type ApprovalsApproveOvertimeMutationHookResult = ReturnType<typeof useApprovalsApproveOvertimeMutation>;
export type ApprovalsApproveOvertimeMutationResult = ApolloReact.MutationResult<ApprovalsApproveOvertimeMutation>;
export type ApprovalsApproveOvertimeMutationOptions = Apollo.MutationOptions<ApprovalsApproveOvertimeMutation, ApprovalsApproveOvertimeMutationVariables>;
export const ApprovalsRejectOvertimeDocument = /*#__PURE__*/ gql`
    mutation Approvals_RejectOvertime($entryId: WorkRecordId!) {
  reporting {
    workRecord {
      reject(id: $entryId) {
        ...NfsError
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useApprovalsRejectOvertimeMutation__
 *
 * To run a mutation, you first call `useApprovalsRejectOvertimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalsRejectOvertimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalsRejectOvertimeMutation, { data, loading, error }] = useApprovalsRejectOvertimeMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useApprovalsRejectOvertimeMutation(baseOptions?: ApolloReact.MutationHookOptions<ApprovalsRejectOvertimeMutation, ApprovalsRejectOvertimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ApprovalsRejectOvertimeDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<ApprovalsRejectOvertimeMutation, ApprovalsRejectOvertimeMutationVariables>(ApprovalsRejectOvertimeDocument, parser(options)));
      }
export type ApprovalsRejectOvertimeMutationHookResult = ReturnType<typeof useApprovalsRejectOvertimeMutation>;
export type ApprovalsRejectOvertimeMutationResult = ApolloReact.MutationResult<ApprovalsRejectOvertimeMutation>;
export type ApprovalsRejectOvertimeMutationOptions = Apollo.MutationOptions<ApprovalsRejectOvertimeMutation, ApprovalsRejectOvertimeMutationVariables>;
export const ApprovalsDocument = /*#__PURE__*/ gql`
    query Approvals {
  timeReportsRequiringApproval {
    ...NfsError
    ... on TimeReportsRequiringApproval {
      workRecords {
        id
        date
        overtime
        duration
        comment
        contract {
          id
        }
        user {
          ...Approvals_User
        }
        approval {
          ...Approval
        }
      }
      absenceRecords {
        id
        absenceType
        from
        to
        isOnDemand
        comment
        attachment {
          ...Unauthorized
          ... on AccessGranted__OptionalDownloadableExternallyHostedFileUrl {
            value {
              fileName
              downloadUrl
              openUrl
            }
          }
        }
        contract {
          id
        }
        user {
          ...Approvals_User
        }
        approval {
          ...Approval
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ApprovalsUserFragmentDoc}
${ApprovalFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useApprovalsQuery__
 *
 * To run a query within a React component, call `useApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useApprovalsQuery(baseOptions?: ApolloReact.QueryHookOptions<ApprovalsQuery, ApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ApprovalsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ApprovalsQuery, ApprovalsQueryVariables>(ApprovalsDocument, parser(options)));
      }
export function useApprovalsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ApprovalsQuery, ApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ApprovalsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ApprovalsQuery, ApprovalsQueryVariables>(ApprovalsDocument, options));
        }

export type ApprovalsQueryResult = ApolloReact.QueryResult<ApprovalsQuery, ApprovalsQueryVariables>;
export function refetchApprovalsQuery(variables?: ApprovalsQueryVariables) {
      return { query: ApprovalsDocument, variables: variables }
    }
export const ClientContractAutocompleteDocument = /*#__PURE__*/ gql`
    query ClientContractAutocomplete($first: Int!, $after: Cursor, $filter: FilterClientContractInput) {
  clientContracts(first: $first, after: $after, filter: $filter) {
    ...NfsError
    ... on FSPResponseClientContract {
      totalCount
      filteredCount
      hasNextPage
      edges {
        cursor
        node {
          id
          name {
            ...Unauthorized
            ... on AccessGranted__String {
              value
            }
          }
          contractDurationFrom {
            ...Unauthorized
            ... on AccessGranted__LocalDate {
              value
            }
          }
          contractDurationTo {
            ...Unauthorized
            ... on AccessGranted__OptionalLocalDate {
              value
            }
          }
          promisor {
            id
            name
            logo
            companyType
          }
          promisee {
            id
            name
            logo
            companyType
          }
          projects {
            id
            assignedUsers {
              user {
                id
              }
              project {
                id
              }
            }
          }
          positions {
            ...Unauthorized
            ... on AccessGranted__ListOfClientPosition {
              value {
                id
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useClientContractAutocompleteQuery__
 *
 * To run a query within a React component, call `useClientContractAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientContractAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientContractAutocompleteQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useClientContractAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<ClientContractAutocompleteQuery, ClientContractAutocompleteQueryVariables> & ({ variables: ClientContractAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ClientContractAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ClientContractAutocompleteQuery, ClientContractAutocompleteQueryVariables>(ClientContractAutocompleteDocument, parser(options)));
      }
export function useClientContractAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ClientContractAutocompleteQuery, ClientContractAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ClientContractAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ClientContractAutocompleteQuery, ClientContractAutocompleteQueryVariables>(ClientContractAutocompleteDocument, options));
        }

export type ClientContractAutocompleteQueryResult = ApolloReact.QueryResult<ClientContractAutocompleteQuery, ClientContractAutocompleteQueryVariables>;
export function refetchClientContractAutocompleteQuery(variables: ClientContractAutocompleteQueryVariables) {
      return { query: ClientContractAutocompleteDocument, variables: variables }
    }
export const CompanyAutocompleteDocument = /*#__PURE__*/ gql`
    query CompanyAutocomplete($filter: FilterCompanyInput!, $after: Cursor, $sort: SortingRequestSortCompanyInput, $first: Int!) {
  companies(first: $first, after: $after, filter: $filter, sort: $sort) {
    ...NfsError
    ... on FSPResponseCompany {
      hasNextPage
      edges {
        cursor
        node {
          ...CompanyAutocomplete_Company
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CompanyAutocompleteCompanyFragmentDoc}`;

/**
 * __useCompanyAutocompleteQuery__
 *
 * To run a query within a React component, call `useCompanyAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAutocompleteQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCompanyAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables> & ({ variables: CompanyAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CompanyAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables>(CompanyAutocompleteDocument, parser(options)));
      }
export function useCompanyAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CompanyAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables>(CompanyAutocompleteDocument, options));
        }

export type CompanyAutocompleteQueryResult = ApolloReact.QueryResult<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables>;
export function refetchCompanyAutocompleteQuery(variables: CompanyAutocompleteQueryVariables) {
      return { query: CompanyAutocompleteDocument, variables: variables }
    }
export const CostInvoiceGroupCompaniesDocument = /*#__PURE__*/ gql`
    query CostInvoiceGroupCompanies($first: Int) {
  companies(
    first: $first
    filter: {companyType_oneOf: [Group]}
    sort: {by: Name, order: Desc}
  ) {
    ...NfsError
    ... on FSPResponseCompany {
      edges {
        node {
          ...CostInvoiceGroupCompanies_Company
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CostInvoiceGroupCompaniesCompanyFragmentDoc}`;

/**
 * __useCostInvoiceGroupCompaniesQuery__
 *
 * To run a query within a React component, call `useCostInvoiceGroupCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostInvoiceGroupCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostInvoiceGroupCompaniesQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCostInvoiceGroupCompaniesQuery(baseOptions?: ApolloReact.QueryHookOptions<CostInvoiceGroupCompaniesQuery, CostInvoiceGroupCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CostInvoiceGroupCompaniesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CostInvoiceGroupCompaniesQuery, CostInvoiceGroupCompaniesQueryVariables>(CostInvoiceGroupCompaniesDocument, parser(options)));
      }
export function useCostInvoiceGroupCompaniesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CostInvoiceGroupCompaniesQuery, CostInvoiceGroupCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CostInvoiceGroupCompaniesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CostInvoiceGroupCompaniesQuery, CostInvoiceGroupCompaniesQueryVariables>(CostInvoiceGroupCompaniesDocument, options));
        }

export type CostInvoiceGroupCompaniesQueryResult = ApolloReact.QueryResult<CostInvoiceGroupCompaniesQuery, CostInvoiceGroupCompaniesQueryVariables>;
export function refetchCostInvoiceGroupCompaniesQuery(variables?: CostInvoiceGroupCompaniesQueryVariables) {
      return { query: CostInvoiceGroupCompaniesDocument, variables: variables }
    }
export const GroupCompanyBankAccountsDocument = /*#__PURE__*/ gql`
    query GroupCompanyBankAccounts($first: Int, $after: Cursor) {
  companies(first: $first, after: $after, filter: {companyType_oneOf: [Group]}) {
    ...NfsError
    ... on FSPResponseCompany {
      hasNextPage
      edges {
        cursor
        node {
          entityVersion
          id
          name
          bankAccounts {
            accountNumber {
              ...BankAccountNumber
            }
            currency
            description
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BankAccountNumberFragmentDoc}`;

/**
 * __useGroupCompanyBankAccountsQuery__
 *
 * To run a query within a React component, call `useGroupCompanyBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupCompanyBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupCompanyBankAccountsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGroupCompanyBankAccountsQuery(baseOptions?: ApolloReact.QueryHookOptions<GroupCompanyBankAccountsQuery, GroupCompanyBankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(GroupCompanyBankAccountsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<GroupCompanyBankAccountsQuery, GroupCompanyBankAccountsQueryVariables>(GroupCompanyBankAccountsDocument, parser(options)));
      }
export function useGroupCompanyBankAccountsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<GroupCompanyBankAccountsQuery, GroupCompanyBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(GroupCompanyBankAccountsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<GroupCompanyBankAccountsQuery, GroupCompanyBankAccountsQueryVariables>(GroupCompanyBankAccountsDocument, options));
        }

export type GroupCompanyBankAccountsQueryResult = ApolloReact.QueryResult<GroupCompanyBankAccountsQuery, GroupCompanyBankAccountsQueryVariables>;
export function refetchGroupCompanyBankAccountsQuery(variables?: GroupCompanyBankAccountsQueryVariables) {
      return { query: GroupCompanyBankAccountsDocument, variables: variables }
    }
export const ProjectAutocompleteDocument = /*#__PURE__*/ gql`
    query ProjectAutocomplete($allSearch: String, $after: Cursor, $first: Int!) {
  projects(
    after: $after
    filter: {name_like: $allSearch, status_notIn: [Closed]}
    first: $first
  ) {
    ...NfsError
    ... on FSPResponseProject {
      hasNextPage
      edges {
        cursor
        node {
          id
          name
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useProjectAutocompleteQuery__
 *
 * To run a query within a React component, call `useProjectAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAutocompleteQuery({
 *   variables: {
 *      allSearch: // value for 'allSearch'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useProjectAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<ProjectAutocompleteQuery, ProjectAutocompleteQueryVariables> & ({ variables: ProjectAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectAutocompleteQuery, ProjectAutocompleteQueryVariables>(ProjectAutocompleteDocument, parser(options)));
      }
export function useProjectAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectAutocompleteQuery, ProjectAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectAutocompleteQuery, ProjectAutocompleteQueryVariables>(ProjectAutocompleteDocument, options));
        }

export type ProjectAutocompleteQueryResult = ApolloReact.QueryResult<ProjectAutocompleteQuery, ProjectAutocompleteQueryVariables>;
export function refetchProjectAutocompleteQuery(variables: ProjectAutocompleteQueryVariables) {
      return { query: ProjectAutocompleteDocument, variables: variables }
    }
export const RevenueAdministrationOfficeAutocompleteDocument = /*#__PURE__*/ gql`
    query RevenueAdministrationOfficeAutocomplete($first: Int, $after: Cursor, $allSearch: String) {
  revenueAdministrationOffices(
    first: $first
    after: $after
    filter: {searchPrefix: $allSearch}
  ) {
    ...NfsError
    ... on FSPResponseRevenueAdministrationOffice {
      hasNextPage
      edges {
        cursor
        node {
          id
          officeName
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useRevenueAdministrationOfficeAutocompleteQuery__
 *
 * To run a query within a React component, call `useRevenueAdministrationOfficeAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevenueAdministrationOfficeAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevenueAdministrationOfficeAutocompleteQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      allSearch: // value for 'allSearch'
 *   },
 * });
 */
export function useRevenueAdministrationOfficeAutocompleteQuery(baseOptions?: ApolloReact.QueryHookOptions<RevenueAdministrationOfficeAutocompleteQuery, RevenueAdministrationOfficeAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RevenueAdministrationOfficeAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RevenueAdministrationOfficeAutocompleteQuery, RevenueAdministrationOfficeAutocompleteQueryVariables>(RevenueAdministrationOfficeAutocompleteDocument, parser(options)));
      }
export function useRevenueAdministrationOfficeAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RevenueAdministrationOfficeAutocompleteQuery, RevenueAdministrationOfficeAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RevenueAdministrationOfficeAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RevenueAdministrationOfficeAutocompleteQuery, RevenueAdministrationOfficeAutocompleteQueryVariables>(RevenueAdministrationOfficeAutocompleteDocument, options));
        }

export type RevenueAdministrationOfficeAutocompleteQueryResult = ApolloReact.QueryResult<RevenueAdministrationOfficeAutocompleteQuery, RevenueAdministrationOfficeAutocompleteQueryVariables>;
export function refetchRevenueAdministrationOfficeAutocompleteQuery(variables?: RevenueAdministrationOfficeAutocompleteQueryVariables) {
      return { query: RevenueAdministrationOfficeAutocompleteDocument, variables: variables }
    }
export const SpacesAutocompleteDocument = /*#__PURE__*/ gql`
    query SpacesAutocomplete($allSearch: String, $after: Cursor, $first: Int!) {
  spaces(filter: {all_search: $allSearch}, after: $after, first: $first) {
    ...NfsError
    ... on FSPResponseSpace {
      hasNextPage
      edges {
        cursor
        node {
          id
          entityVersion
          name
          owner {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useSpacesAutocompleteQuery__
 *
 * To run a query within a React component, call `useSpacesAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpacesAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpacesAutocompleteQuery({
 *   variables: {
 *      allSearch: // value for 'allSearch'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSpacesAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<SpacesAutocompleteQuery, SpacesAutocompleteQueryVariables> & ({ variables: SpacesAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SpacesAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SpacesAutocompleteQuery, SpacesAutocompleteQueryVariables>(SpacesAutocompleteDocument, parser(options)));
      }
export function useSpacesAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SpacesAutocompleteQuery, SpacesAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SpacesAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SpacesAutocompleteQuery, SpacesAutocompleteQueryVariables>(SpacesAutocompleteDocument, options));
        }

export type SpacesAutocompleteQueryResult = ApolloReact.QueryResult<SpacesAutocompleteQuery, SpacesAutocompleteQueryVariables>;
export function refetchSpacesAutocompleteQuery(variables: SpacesAutocompleteQueryVariables) {
      return { query: SpacesAutocompleteDocument, variables: variables }
    }
export const TransferAutocompleteDocument = /*#__PURE__*/ gql`
    query TransferAutocomplete($filter: FilterBankTransferInput!, $sort: SortingRequestSortBankTransferInput, $first: Int!, $after: Cursor) {
  bankTransfers(first: $first, filter: $filter, sort: $sort, after: $after) {
    ...NfsError
    ... on FSPResponseBankTransfer {
      hasNextPage
      edges {
        cursor
        node {
          ...TransferAutocomplete_Transfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${TransferAutocompleteTransferFragmentDoc}`;

/**
 * __useTransferAutocompleteQuery__
 *
 * To run a query within a React component, call `useTransferAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferAutocompleteQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTransferAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<TransferAutocompleteQuery, TransferAutocompleteQueryVariables> & ({ variables: TransferAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TransferAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TransferAutocompleteQuery, TransferAutocompleteQueryVariables>(TransferAutocompleteDocument, parser(options)));
      }
export function useTransferAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TransferAutocompleteQuery, TransferAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TransferAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TransferAutocompleteQuery, TransferAutocompleteQueryVariables>(TransferAutocompleteDocument, options));
        }

export type TransferAutocompleteQueryResult = ApolloReact.QueryResult<TransferAutocompleteQuery, TransferAutocompleteQueryVariables>;
export function refetchTransferAutocompleteQuery(variables: TransferAutocompleteQueryVariables) {
      return { query: TransferAutocompleteDocument, variables: variables }
    }
export const UserAutocompleteDocument = /*#__PURE__*/ gql`
    query UserAutocomplete($after: Cursor, $filter: FilterUserInput!, $sort: SortingRequestSortUserInput, $first: Int!) {
  users(after: $after, filter: $filter, sort: $sort, first: $first) {
    ...NfsError
    ... on FSPResponseUser {
      hasNextPage
      edges {
        cursor
        node {
          ...UserAutocomplete_User
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserAutocompleteUserFragmentDoc}`;

/**
 * __useUserAutocompleteQuery__
 *
 * To run a query within a React component, call `useUserAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useUserAutocompleteQuery(baseOptions: ApolloReact.QueryHookOptions<UserAutocompleteQuery, UserAutocompleteQueryVariables> & ({ variables: UserAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserAutocompleteQuery, UserAutocompleteQueryVariables>(UserAutocompleteDocument, parser(options)));
      }
export function useUserAutocompleteLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserAutocompleteQuery, UserAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserAutocompleteDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserAutocompleteQuery, UserAutocompleteQueryVariables>(UserAutocompleteDocument, options));
        }

export type UserAutocompleteQueryResult = ApolloReact.QueryResult<UserAutocompleteQuery, UserAutocompleteQueryVariables>;
export function refetchUserAutocompleteQuery(variables: UserAutocompleteQueryVariables) {
      return { query: UserAutocompleteDocument, variables: variables }
    }
export const DrawerDocument = /*#__PURE__*/ gql`
    query Drawer($id: ID!) {
  drawer(id: $id) @client {
    ...ChildLevel0
  }
}
    ${ChildLevel0FragmentDoc}`;

/**
 * __useDrawerQuery__
 *
 * To run a query within a React component, call `useDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrawerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<DrawerQuery, DrawerQueryVariables> & ({ variables: DrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<DrawerQuery, DrawerQueryVariables>(DrawerDocument, parser(options)));
      }
export function useDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<DrawerQuery, DrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(DrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<DrawerQuery, DrawerQueryVariables>(DrawerDocument, options));
        }

export type DrawerQueryResult = ApolloReact.QueryResult<DrawerQuery, DrawerQueryVariables>;
export function refetchDrawerQuery(variables: DrawerQueryVariables) {
      return { query: DrawerDocument, variables: variables }
    }
export const RootDrawerDocument = /*#__PURE__*/ gql`
    query RootDrawer {
  rootDrawer @client {
    ...ChildLevel0
  }
}
    ${ChildLevel0FragmentDoc}`;

/**
 * __useRootDrawerQuery__
 *
 * To run a query within a React component, call `useRootDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootDrawerQuery({
 *   variables: {
 *   },
 * });
 */
export function useRootDrawerQuery(baseOptions?: ApolloReact.QueryHookOptions<RootDrawerQuery, RootDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RootDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RootDrawerQuery, RootDrawerQueryVariables>(RootDrawerDocument, parser(options)));
      }
export function useRootDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RootDrawerQuery, RootDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RootDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RootDrawerQuery, RootDrawerQueryVariables>(RootDrawerDocument, options));
        }

export type RootDrawerQueryResult = ApolloReact.QueryResult<RootDrawerQuery, RootDrawerQueryVariables>;
export function refetchRootDrawerQuery(variables?: RootDrawerQueryVariables) {
      return { query: RootDrawerDocument, variables: variables }
    }
export const TopDrawerDocument = /*#__PURE__*/ gql`
    query TopDrawer {
  topDrawer @client {
    ...ChildLevel0
  }
}
    ${ChildLevel0FragmentDoc}`;

/**
 * __useTopDrawerQuery__
 *
 * To run a query within a React component, call `useTopDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopDrawerQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopDrawerQuery(baseOptions?: ApolloReact.QueryHookOptions<TopDrawerQuery, TopDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TopDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TopDrawerQuery, TopDrawerQueryVariables>(TopDrawerDocument, parser(options)));
      }
export function useTopDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TopDrawerQuery, TopDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TopDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TopDrawerQuery, TopDrawerQueryVariables>(TopDrawerDocument, options));
        }

export type TopDrawerQueryResult = ApolloReact.QueryResult<TopDrawerQuery, TopDrawerQueryVariables>;
export function refetchTopDrawerQuery(variables?: TopDrawerQueryVariables) {
      return { query: TopDrawerDocument, variables: variables }
    }
export const AdminAdditionalCostsDrawerDocument = /*#__PURE__*/ gql`
    query Admin_AdditionalCostsDrawer($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ... on ContractResponse {
      value {
        id
        bonuses {
          ...Unauthorized
          ... on AccessGranted__Bonuses {
            value {
              paidOut {
                ...AdditionalCostDrawer_Bonus
              }
              future {
                ...AdditionalCostDrawer_Bonus
              }
            }
          }
        }
      }
    }
  }
}
    ${UnauthorizedFragmentDoc}
${AdditionalCostDrawerBonusFragmentDoc}`;

/**
 * __useAdminAdditionalCostsDrawerQuery__
 *
 * To run a query within a React component, call `useAdminAdditionalCostsDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAdditionalCostsDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAdditionalCostsDrawerQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useAdminAdditionalCostsDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<AdminAdditionalCostsDrawerQuery, AdminAdditionalCostsDrawerQueryVariables> & ({ variables: AdminAdditionalCostsDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminAdditionalCostsDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminAdditionalCostsDrawerQuery, AdminAdditionalCostsDrawerQueryVariables>(AdminAdditionalCostsDrawerDocument, parser(options)));
      }
export function useAdminAdditionalCostsDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminAdditionalCostsDrawerQuery, AdminAdditionalCostsDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminAdditionalCostsDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminAdditionalCostsDrawerQuery, AdminAdditionalCostsDrawerQueryVariables>(AdminAdditionalCostsDrawerDocument, options));
        }

export type AdminAdditionalCostsDrawerQueryResult = ApolloReact.QueryResult<AdminAdditionalCostsDrawerQuery, AdminAdditionalCostsDrawerQueryVariables>;
export function refetchAdminAdditionalCostsDrawerQuery(variables: AdminAdditionalCostsDrawerQueryVariables) {
      return { query: AdminAdditionalCostsDrawerDocument, variables: variables }
    }
export const AdminAdditionalCostDrawerUpsertBonusDocument = /*#__PURE__*/ gql`
    mutation Admin_AdditionalCostDrawer_UpsertBonus($contractId: ContractId!, $entityVersion: EntityVersion!, $input: BonusInput!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    upsertBonus(input: $input) {
      ...NfsError
      ... on BonusResponse {
        value {
          ...AdditionalCostDrawer_Bonus
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AdditionalCostDrawerBonusFragmentDoc}`;


/**
 * __useAdminAdditionalCostDrawerUpsertBonusMutation__
 *
 * To run a mutation, you first call `useAdminAdditionalCostDrawerUpsertBonusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAdditionalCostDrawerUpsertBonusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAdditionalCostDrawerUpsertBonusMutation, { data, loading, error }] = useAdminAdditionalCostDrawerUpsertBonusMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminAdditionalCostDrawerUpsertBonusMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminAdditionalCostDrawerUpsertBonusMutation, AdminAdditionalCostDrawerUpsertBonusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminAdditionalCostDrawerUpsertBonusDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminAdditionalCostDrawerUpsertBonusMutation, AdminAdditionalCostDrawerUpsertBonusMutationVariables>(AdminAdditionalCostDrawerUpsertBonusDocument, parser(options)));
      }
export type AdminAdditionalCostDrawerUpsertBonusMutationHookResult = ReturnType<typeof useAdminAdditionalCostDrawerUpsertBonusMutation>;
export type AdminAdditionalCostDrawerUpsertBonusMutationResult = ApolloReact.MutationResult<AdminAdditionalCostDrawerUpsertBonusMutation>;
export type AdminAdditionalCostDrawerUpsertBonusMutationOptions = Apollo.MutationOptions<AdminAdditionalCostDrawerUpsertBonusMutation, AdminAdditionalCostDrawerUpsertBonusMutationVariables>;
export const AdminAdditionalCostDrawerDeleteDocument = /*#__PURE__*/ gql`
    mutation Admin_AdditionalCostDrawer_Delete($contractId: ContractId!, $entityVersion: EntityVersion!, $id: BonusId!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    bonus(id: $id) {
      delete {
        ...NfsError
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAdminAdditionalCostDrawerDeleteMutation__
 *
 * To run a mutation, you first call `useAdminAdditionalCostDrawerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAdditionalCostDrawerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAdditionalCostDrawerDeleteMutation, { data, loading, error }] = useAdminAdditionalCostDrawerDeleteMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminAdditionalCostDrawerDeleteMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminAdditionalCostDrawerDeleteMutation, AdminAdditionalCostDrawerDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminAdditionalCostDrawerDeleteDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminAdditionalCostDrawerDeleteMutation, AdminAdditionalCostDrawerDeleteMutationVariables>(AdminAdditionalCostDrawerDeleteDocument, parser(options)));
      }
export type AdminAdditionalCostDrawerDeleteMutationHookResult = ReturnType<typeof useAdminAdditionalCostDrawerDeleteMutation>;
export type AdminAdditionalCostDrawerDeleteMutationResult = ApolloReact.MutationResult<AdminAdditionalCostDrawerDeleteMutation>;
export type AdminAdditionalCostDrawerDeleteMutationOptions = Apollo.MutationOptions<AdminAdditionalCostDrawerDeleteMutation, AdminAdditionalCostDrawerDeleteMutationVariables>;
export const AdminAdditionalCostDrawerRejectDocument = /*#__PURE__*/ gql`
    mutation Admin_AdditionalCostDrawer_Reject($contractId: ContractId!, $entityVersion: EntityVersion!, $id: BonusId!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    bonus(id: $id) {
      reject {
        ...NfsError
        ... on BonusResponse {
          value {
            ...AdditionalCostDrawer_Bonus
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AdditionalCostDrawerBonusFragmentDoc}`;


/**
 * __useAdminAdditionalCostDrawerRejectMutation__
 *
 * To run a mutation, you first call `useAdminAdditionalCostDrawerRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAdditionalCostDrawerRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAdditionalCostDrawerRejectMutation, { data, loading, error }] = useAdminAdditionalCostDrawerRejectMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminAdditionalCostDrawerRejectMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminAdditionalCostDrawerRejectMutation, AdminAdditionalCostDrawerRejectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminAdditionalCostDrawerRejectDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminAdditionalCostDrawerRejectMutation, AdminAdditionalCostDrawerRejectMutationVariables>(AdminAdditionalCostDrawerRejectDocument, parser(options)));
      }
export type AdminAdditionalCostDrawerRejectMutationHookResult = ReturnType<typeof useAdminAdditionalCostDrawerRejectMutation>;
export type AdminAdditionalCostDrawerRejectMutationResult = ApolloReact.MutationResult<AdminAdditionalCostDrawerRejectMutation>;
export type AdminAdditionalCostDrawerRejectMutationOptions = Apollo.MutationOptions<AdminAdditionalCostDrawerRejectMutation, AdminAdditionalCostDrawerRejectMutationVariables>;
export const AdminAdditonalCostDrawerApproveMultipleDocument = /*#__PURE__*/ gql`
    mutation Admin_AdditonalCostDrawer_ApproveMultiple($contractId: ContractId!, $entityVersion: EntityVersion!, $ids: [BonusId!]!) {
  contract(contractId: $contractId, entityVersion: $entityVersion) {
    approveBonuses(bonusIds: $ids) {
      ...NfsError
      ... on ContractSalaryDetailsResponse {
        value {
          contractId
          yearMonth
          entityVersion
          salaryState {
            ...SalaryState
          }
          ... on B2BContractSalaryDetails {
            contract {
              id
              at
              bonuses {
                ...Unauthorized
                ... on AccessGranted__Bonuses {
                  value {
                    paidOut {
                      ...AdditionalCostDrawer_Bonus
                    }
                    future {
                      ...AdditionalCostDrawer_Bonus
                    }
                  }
                }
              }
            }
          }
          ... on EmploymentContractSalaryDetails {
            contract {
              id
              at
              bonuses {
                ...Unauthorized
                ... on AccessGranted__Bonuses {
                  value {
                    paidOut {
                      ...AdditionalCostDrawer_Bonus
                    }
                    future {
                      ...AdditionalCostDrawer_Bonus
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${SalaryStateFragmentDoc}
${UnauthorizedFragmentDoc}
${AdditionalCostDrawerBonusFragmentDoc}`;


/**
 * __useAdminAdditonalCostDrawerApproveMultipleMutation__
 *
 * To run a mutation, you first call `useAdminAdditonalCostDrawerApproveMultipleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAdditonalCostDrawerApproveMultipleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAdditonalCostDrawerApproveMultipleMutation, { data, loading, error }] = useAdminAdditonalCostDrawerApproveMultipleMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      entityVersion: // value for 'entityVersion'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAdminAdditonalCostDrawerApproveMultipleMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminAdditonalCostDrawerApproveMultipleMutation, AdminAdditonalCostDrawerApproveMultipleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminAdditonalCostDrawerApproveMultipleDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminAdditonalCostDrawerApproveMultipleMutation, AdminAdditonalCostDrawerApproveMultipleMutationVariables>(AdminAdditonalCostDrawerApproveMultipleDocument, parser(options)));
      }
export type AdminAdditonalCostDrawerApproveMultipleMutationHookResult = ReturnType<typeof useAdminAdditonalCostDrawerApproveMultipleMutation>;
export type AdminAdditonalCostDrawerApproveMultipleMutationResult = ApolloReact.MutationResult<AdminAdditonalCostDrawerApproveMultipleMutation>;
export type AdminAdditonalCostDrawerApproveMultipleMutationOptions = Apollo.MutationOptions<AdminAdditonalCostDrawerApproveMultipleMutation, AdminAdditonalCostDrawerApproveMultipleMutationVariables>;
export const AdminBenefitSectionsAssignedBenefitVariantsDocument = /*#__PURE__*/ gql`
    query AdminBenefitSections_AssignedBenefitVariants($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        entityVersion
        conclusionDate {
          ...Unauthorized
          ... on AccessGranted__LocalDate {
            value
          }
        }
        startDate
        terminationDate
        assignedVariants(activeOnly: false) {
          ...Unauthorized
          ... on AccessGranted__ListOfAssignedVariant {
            value {
              id
              note
              buyerType {
                value
                futureUpdates {
                  applyDate
                  activityId
                  value
                }
                history {
                  applyDate
                }
              }
              invoiceTo {
                value {
                  ...ExternalBeneficiary
                }
                futureUpdates {
                  applyDate
                  activityId
                  value {
                    value {
                      ...ExternalBeneficiary
                    }
                  }
                }
                history {
                  applyDate
                  activityId
                  value {
                    value {
                      ...ExternalBeneficiary
                    }
                  }
                }
              }
              externalBeneficiaries {
                value {
                  ...ExternalBeneficiary
                }
                futureUpdates {
                  applyDate
                  activityId
                  value {
                    ...ExternalBeneficiary
                  }
                }
                history {
                  applyDate
                  activityId
                  value {
                    ...ExternalBeneficiary
                  }
                }
              }
              active {
                value
                futureUpdates {
                  applyDate
                  activityId
                  value
                }
                history {
                  applyDate
                  activityId
                  value
                }
              }
              variant {
                value {
                  ...AdminBenefitSections_BenefitVariant
                }
                futureUpdates {
                  applyDate
                  activityId
                  value {
                    ...AdminBenefitSections_BenefitVariant
                  }
                }
                history {
                  applyDate
                  activityId
                  value {
                    ...AdminBenefitSections_BenefitVariant
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${ExternalBeneficiaryFragmentDoc}
${AdminBenefitSectionsBenefitVariantFragmentDoc}`;

/**
 * __useAdminBenefitSectionsAssignedBenefitVariantsQuery__
 *
 * To run a query within a React component, call `useAdminBenefitSectionsAssignedBenefitVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBenefitSectionsAssignedBenefitVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBenefitSectionsAssignedBenefitVariantsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useAdminBenefitSectionsAssignedBenefitVariantsQuery(baseOptions: ApolloReact.QueryHookOptions<AdminBenefitSectionsAssignedBenefitVariantsQuery, AdminBenefitSectionsAssignedBenefitVariantsQueryVariables> & ({ variables: AdminBenefitSectionsAssignedBenefitVariantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminBenefitSectionsAssignedBenefitVariantsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminBenefitSectionsAssignedBenefitVariantsQuery, AdminBenefitSectionsAssignedBenefitVariantsQueryVariables>(AdminBenefitSectionsAssignedBenefitVariantsDocument, parser(options)));
      }
export function useAdminBenefitSectionsAssignedBenefitVariantsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminBenefitSectionsAssignedBenefitVariantsQuery, AdminBenefitSectionsAssignedBenefitVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminBenefitSectionsAssignedBenefitVariantsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminBenefitSectionsAssignedBenefitVariantsQuery, AdminBenefitSectionsAssignedBenefitVariantsQueryVariables>(AdminBenefitSectionsAssignedBenefitVariantsDocument, options));
        }

export type AdminBenefitSectionsAssignedBenefitVariantsQueryResult = ApolloReact.QueryResult<AdminBenefitSectionsAssignedBenefitVariantsQuery, AdminBenefitSectionsAssignedBenefitVariantsQueryVariables>;
export function refetchAdminBenefitSectionsAssignedBenefitVariantsQuery(variables: AdminBenefitSectionsAssignedBenefitVariantsQueryVariables) {
      return { query: AdminBenefitSectionsAssignedBenefitVariantsDocument, variables: variables }
    }
export const AdminCopyrightsDrawerUpdateWorkTransferDocument = /*#__PURE__*/ gql`
    mutation Admin_CopyrightsDrawer_UpdateWorkTransfer($id: WorkTransferProtocolId!, $description: ClearableStringInput, $payload: Upload, $contractId: ContractId!, $yearMonth: YearMonth!, $approved: Boolean) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      update(
        id: $id
        description: $description
        payload: $payload
        approved: $approved
      ) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...CopyrightsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightsDrawerWorkTransferFragmentDoc}`;


/**
 * __useAdminCopyrightsDrawerUpdateWorkTransferMutation__
 *
 * To run a mutation, you first call `useAdminCopyrightsDrawerUpdateWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCopyrightsDrawerUpdateWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCopyrightsDrawerUpdateWorkTransferMutation, { data, loading, error }] = useAdminCopyrightsDrawerUpdateWorkTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      payload: // value for 'payload'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useAdminCopyrightsDrawerUpdateWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminCopyrightsDrawerUpdateWorkTransferMutation, AdminCopyrightsDrawerUpdateWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminCopyrightsDrawerUpdateWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminCopyrightsDrawerUpdateWorkTransferMutation, AdminCopyrightsDrawerUpdateWorkTransferMutationVariables>(AdminCopyrightsDrawerUpdateWorkTransferDocument, parser(options)));
      }
export type AdminCopyrightsDrawerUpdateWorkTransferMutationHookResult = ReturnType<typeof useAdminCopyrightsDrawerUpdateWorkTransferMutation>;
export type AdminCopyrightsDrawerUpdateWorkTransferMutationResult = ApolloReact.MutationResult<AdminCopyrightsDrawerUpdateWorkTransferMutation>;
export type AdminCopyrightsDrawerUpdateWorkTransferMutationOptions = Apollo.MutationOptions<AdminCopyrightsDrawerUpdateWorkTransferMutation, AdminCopyrightsDrawerUpdateWorkTransferMutationVariables>;
export const AdminCopyrightsDrawerCreateWorkTransferDocument = /*#__PURE__*/ gql`
    mutation Admin_CopyrightsDrawer_CreateWorkTransfer($contractSalaryDetailsId: ContractSalaryDetailsIdInput!, $id: WorkTransferProtocolId!, $description: String, $payload: Upload!, $contractId: ContractId!, $yearMonth: YearMonth!, $approved: Boolean) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      create(
        contractSalaryDetailsId: $contractSalaryDetailsId
        id: $id
        description: $description
        payload: $payload
        approved: $approved
      ) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...CopyrightsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightsDrawerWorkTransferFragmentDoc}`;


/**
 * __useAdminCopyrightsDrawerCreateWorkTransferMutation__
 *
 * To run a mutation, you first call `useAdminCopyrightsDrawerCreateWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCopyrightsDrawerCreateWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCopyrightsDrawerCreateWorkTransferMutation, { data, loading, error }] = useAdminCopyrightsDrawerCreateWorkTransferMutation({
 *   variables: {
 *      contractSalaryDetailsId: // value for 'contractSalaryDetailsId'
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      payload: // value for 'payload'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useAdminCopyrightsDrawerCreateWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminCopyrightsDrawerCreateWorkTransferMutation, AdminCopyrightsDrawerCreateWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminCopyrightsDrawerCreateWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminCopyrightsDrawerCreateWorkTransferMutation, AdminCopyrightsDrawerCreateWorkTransferMutationVariables>(AdminCopyrightsDrawerCreateWorkTransferDocument, parser(options)));
      }
export type AdminCopyrightsDrawerCreateWorkTransferMutationHookResult = ReturnType<typeof useAdminCopyrightsDrawerCreateWorkTransferMutation>;
export type AdminCopyrightsDrawerCreateWorkTransferMutationResult = ApolloReact.MutationResult<AdminCopyrightsDrawerCreateWorkTransferMutation>;
export type AdminCopyrightsDrawerCreateWorkTransferMutationOptions = Apollo.MutationOptions<AdminCopyrightsDrawerCreateWorkTransferMutation, AdminCopyrightsDrawerCreateWorkTransferMutationVariables>;
export const AdminCopyrightsDrawerRemoveWorkTransferDocument = /*#__PURE__*/ gql`
    mutation Admin_CopyrightsDrawer_RemoveWorkTransfer($id: WorkTransferProtocolId!, $contractId: ContractId!, $yearMonth: YearMonth!) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      remove(id: $id) {
        ...NfsError
        ... on BooleanResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAdminCopyrightsDrawerRemoveWorkTransferMutation__
 *
 * To run a mutation, you first call `useAdminCopyrightsDrawerRemoveWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCopyrightsDrawerRemoveWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCopyrightsDrawerRemoveWorkTransferMutation, { data, loading, error }] = useAdminCopyrightsDrawerRemoveWorkTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *   },
 * });
 */
export function useAdminCopyrightsDrawerRemoveWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminCopyrightsDrawerRemoveWorkTransferMutation, AdminCopyrightsDrawerRemoveWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminCopyrightsDrawerRemoveWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminCopyrightsDrawerRemoveWorkTransferMutation, AdminCopyrightsDrawerRemoveWorkTransferMutationVariables>(AdminCopyrightsDrawerRemoveWorkTransferDocument, parser(options)));
      }
export type AdminCopyrightsDrawerRemoveWorkTransferMutationHookResult = ReturnType<typeof useAdminCopyrightsDrawerRemoveWorkTransferMutation>;
export type AdminCopyrightsDrawerRemoveWorkTransferMutationResult = ApolloReact.MutationResult<AdminCopyrightsDrawerRemoveWorkTransferMutation>;
export type AdminCopyrightsDrawerRemoveWorkTransferMutationOptions = Apollo.MutationOptions<AdminCopyrightsDrawerRemoveWorkTransferMutation, AdminCopyrightsDrawerRemoveWorkTransferMutationVariables>;
export const AdminCopyrightsDrawerMarkNoWorkDocument = /*#__PURE__*/ gql`
    mutation Admin_CopyrightsDrawer_MarkNoWork($contractSalaryDetailsId: ContractSalaryDetailsIdInput!, $contractId: ContractId!, $yearMonth: YearMonth!) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    workTransferProtocol {
      markNoWorkToBeTransferedThisMonth(
        contractSalaryDetailsId: $contractSalaryDetailsId
      ) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...CopyrightsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightsDrawerWorkTransferFragmentDoc}`;


/**
 * __useAdminCopyrightsDrawerMarkNoWorkMutation__
 *
 * To run a mutation, you first call `useAdminCopyrightsDrawerMarkNoWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCopyrightsDrawerMarkNoWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCopyrightsDrawerMarkNoWorkMutation, { data, loading, error }] = useAdminCopyrightsDrawerMarkNoWorkMutation({
 *   variables: {
 *      contractSalaryDetailsId: // value for 'contractSalaryDetailsId'
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *   },
 * });
 */
export function useAdminCopyrightsDrawerMarkNoWorkMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminCopyrightsDrawerMarkNoWorkMutation, AdminCopyrightsDrawerMarkNoWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminCopyrightsDrawerMarkNoWorkDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminCopyrightsDrawerMarkNoWorkMutation, AdminCopyrightsDrawerMarkNoWorkMutationVariables>(AdminCopyrightsDrawerMarkNoWorkDocument, parser(options)));
      }
export type AdminCopyrightsDrawerMarkNoWorkMutationHookResult = ReturnType<typeof useAdminCopyrightsDrawerMarkNoWorkMutation>;
export type AdminCopyrightsDrawerMarkNoWorkMutationResult = ApolloReact.MutationResult<AdminCopyrightsDrawerMarkNoWorkMutation>;
export type AdminCopyrightsDrawerMarkNoWorkMutationOptions = Apollo.MutationOptions<AdminCopyrightsDrawerMarkNoWorkMutation, AdminCopyrightsDrawerMarkNoWorkMutationVariables>;
export const CopyrightsDrawerCopyrightsDocument = /*#__PURE__*/ gql`
    query CopyrightsDrawer_Copyrights($contractId: ContractId!, $from: YearMonth!, $to: YearMonth!) {
  contractSalaryDetailsInRange(contractId: $contractId, from: $from, to: $to) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      value {
        ... on EmploymentContractSalaryDetails {
          ...CopyrightsDrawer_Salary
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightsDrawerSalaryFragmentDoc}`;

/**
 * __useCopyrightsDrawerCopyrightsQuery__
 *
 * To run a query within a React component, call `useCopyrightsDrawerCopyrightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyrightsDrawerCopyrightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyrightsDrawerCopyrightsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCopyrightsDrawerCopyrightsQuery(baseOptions: ApolloReact.QueryHookOptions<CopyrightsDrawerCopyrightsQuery, CopyrightsDrawerCopyrightsQueryVariables> & ({ variables: CopyrightsDrawerCopyrightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CopyrightsDrawerCopyrightsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CopyrightsDrawerCopyrightsQuery, CopyrightsDrawerCopyrightsQueryVariables>(CopyrightsDrawerCopyrightsDocument, parser(options)));
      }
export function useCopyrightsDrawerCopyrightsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CopyrightsDrawerCopyrightsQuery, CopyrightsDrawerCopyrightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CopyrightsDrawerCopyrightsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CopyrightsDrawerCopyrightsQuery, CopyrightsDrawerCopyrightsQueryVariables>(CopyrightsDrawerCopyrightsDocument, options));
        }

export type CopyrightsDrawerCopyrightsQueryResult = ApolloReact.QueryResult<CopyrightsDrawerCopyrightsQuery, CopyrightsDrawerCopyrightsQueryVariables>;
export function refetchCopyrightsDrawerCopyrightsQuery(variables: CopyrightsDrawerCopyrightsQueryVariables) {
      return { query: CopyrightsDrawerCopyrightsDocument, variables: variables }
    }
export const CopyrightsTrButtonDocument = /*#__PURE__*/ gql`
    query CopyrightsTRButton($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        ...CopyrightTRButton_Contract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightTrButtonContractFragmentDoc}`;

/**
 * __useCopyrightsTrButtonQuery__
 *
 * To run a query within a React component, call `useCopyrightsTrButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyrightsTrButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyrightsTrButtonQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useCopyrightsTrButtonQuery(baseOptions: ApolloReact.QueryHookOptions<CopyrightsTrButtonQuery, CopyrightsTrButtonQueryVariables> & ({ variables: CopyrightsTrButtonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CopyrightsTrButtonDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CopyrightsTrButtonQuery, CopyrightsTrButtonQueryVariables>(CopyrightsTrButtonDocument, parser(options)));
      }
export function useCopyrightsTrButtonLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CopyrightsTrButtonQuery, CopyrightsTrButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CopyrightsTrButtonDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CopyrightsTrButtonQuery, CopyrightsTrButtonQueryVariables>(CopyrightsTrButtonDocument, options));
        }

export type CopyrightsTrButtonQueryResult = ApolloReact.QueryResult<CopyrightsTrButtonQuery, CopyrightsTrButtonQueryVariables>;
export function refetchCopyrightsTrButtonQuery(variables: CopyrightsTrButtonQueryVariables) {
      return { query: CopyrightsTrButtonDocument, variables: variables }
    }
export const AdminDirectReportingStructureDocument = /*#__PURE__*/ gql`
    query Admin_DirectReportingStructure($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      ...DirectReportingStructure_User
      role {
        value
        futureUpdates {
          activityId
          applyDate
          value
        }
        history {
          activityId
          applyDate
          value
        }
      }
      directReporting {
        primaryProjectId {
          value
          futureUpdates {
            activityId
            applyDate
            value {
              value
            }
          }
          history {
            activityId
            applyDate
            value {
              value
            }
          }
        }
        assignedProjects {
          ...Unauthorized
          ... on AccessGranted__ListOfProjectAssignment {
            value {
              user {
                id
              }
              project {
                id
                name
                lead {
                  project {
                    id
                  }
                  periods {
                    dateRange {
                      from
                      to
                    }
                    user {
                      ...DirectReportingStructure_User
                    }
                  }
                }
              }
            }
          }
        }
        activeProjects: assignedProjects(status_oneOf: [Live]) {
          ...Unauthorized
          ... on AccessGranted__ListOfProjectAssignment {
            value {
              user {
                id
              }
              project {
                id
                name
              }
            }
          }
        }
        practiceLead {
          value {
            ...DirectReportingStructure_User
          }
          futureUpdates {
            activityId
            applyDate
            value {
              value {
                ...DirectReportingStructure_User
              }
            }
          }
          history {
            activityId
            applyDate
            value {
              value {
                ...DirectReportingStructure_User
              }
            }
          }
        }
        operationalLead {
          value {
            ...DirectReportingStructure_User
          }
          futureUpdates {
            activityId
            applyDate
            value {
              value {
                ...DirectReportingStructure_User
              }
            }
          }
          history {
            activityId
            applyDate
            value {
              value {
                ...DirectReportingStructure_User
              }
            }
          }
        }
        space {
          value {
            id
            name
            owner {
              ...DirectReportingStructure_User
            }
          }
          futureUpdates {
            activityId
            applyDate
            value {
              id
              name
              owner {
                ...DirectReportingStructure_User
              }
            }
          }
          history {
            activityId
            applyDate
            value {
              id
              name
              owner {
                ...DirectReportingStructure_User
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${DirectReportingStructureUserFragmentDoc}
${UnauthorizedFragmentDoc}`;

/**
 * __useAdminDirectReportingStructureQuery__
 *
 * To run a query within a React component, call `useAdminDirectReportingStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDirectReportingStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDirectReportingStructureQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminDirectReportingStructureQuery(baseOptions: ApolloReact.QueryHookOptions<AdminDirectReportingStructureQuery, AdminDirectReportingStructureQueryVariables> & ({ variables: AdminDirectReportingStructureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminDirectReportingStructureDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminDirectReportingStructureQuery, AdminDirectReportingStructureQueryVariables>(AdminDirectReportingStructureDocument, parser(options)));
      }
export function useAdminDirectReportingStructureLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminDirectReportingStructureQuery, AdminDirectReportingStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminDirectReportingStructureDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminDirectReportingStructureQuery, AdminDirectReportingStructureQueryVariables>(AdminDirectReportingStructureDocument, options));
        }

export type AdminDirectReportingStructureQueryResult = ApolloReact.QueryResult<AdminDirectReportingStructureQuery, AdminDirectReportingStructureQueryVariables>;
export function refetchAdminDirectReportingStructureQuery(variables: AdminDirectReportingStructureQueryVariables) {
      return { query: AdminDirectReportingStructureDocument, variables: variables }
    }
export const AdminInvoicesDrawerUpdateInvoiceDocument = /*#__PURE__*/ gql`
    mutation Admin_InvoicesDrawer_UpdateInvoice($contractId: ContractId!, $yearMonth: YearMonth!, $invoiceDetailsId: InvoiceDetailsId!, $invoiceDetails: UpdateInvoiceDetailsInput!) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    invoiceDetails {
      update(invoiceDetailsId: $invoiceDetailsId, invoiceDetails: $invoiceDetails) {
        ...NfsError
        ... on InvoiceDetails {
          ...InvoicesDrawer_InvoiceDetails
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${InvoicesDrawerInvoiceDetailsFragmentDoc}`;


/**
 * __useAdminInvoicesDrawerUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useAdminInvoicesDrawerUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInvoicesDrawerUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInvoicesDrawerUpdateInvoiceMutation, { data, loading, error }] = useAdminInvoicesDrawerUpdateInvoiceMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *      invoiceDetailsId: // value for 'invoiceDetailsId'
 *      invoiceDetails: // value for 'invoiceDetails'
 *   },
 * });
 */
export function useAdminInvoicesDrawerUpdateInvoiceMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminInvoicesDrawerUpdateInvoiceMutation, AdminInvoicesDrawerUpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminInvoicesDrawerUpdateInvoiceDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminInvoicesDrawerUpdateInvoiceMutation, AdminInvoicesDrawerUpdateInvoiceMutationVariables>(AdminInvoicesDrawerUpdateInvoiceDocument, parser(options)));
      }
export type AdminInvoicesDrawerUpdateInvoiceMutationHookResult = ReturnType<typeof useAdminInvoicesDrawerUpdateInvoiceMutation>;
export type AdminInvoicesDrawerUpdateInvoiceMutationResult = ApolloReact.MutationResult<AdminInvoicesDrawerUpdateInvoiceMutation>;
export type AdminInvoicesDrawerUpdateInvoiceMutationOptions = Apollo.MutationOptions<AdminInvoicesDrawerUpdateInvoiceMutation, AdminInvoicesDrawerUpdateInvoiceMutationVariables>;
export const AdminInvoicesDrawerCreateInvoiceDocument = /*#__PURE__*/ gql`
    mutation Admin_InvoicesDrawer_CreateInvoice($contractId: ContractId!, $yearMonth: YearMonth!, $invoiceDetails: CreateInvoiceDetailsInput!) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    invoiceDetails {
      create(invoiceDetails: $invoiceDetails) {
        ...NfsError
        ... on InvoiceDetails {
          ...InvoicesDrawer_InvoiceDetails
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${InvoicesDrawerInvoiceDetailsFragmentDoc}`;


/**
 * __useAdminInvoicesDrawerCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useAdminInvoicesDrawerCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInvoicesDrawerCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInvoicesDrawerCreateInvoiceMutation, { data, loading, error }] = useAdminInvoicesDrawerCreateInvoiceMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *      invoiceDetails: // value for 'invoiceDetails'
 *   },
 * });
 */
export function useAdminInvoicesDrawerCreateInvoiceMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminInvoicesDrawerCreateInvoiceMutation, AdminInvoicesDrawerCreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminInvoicesDrawerCreateInvoiceDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminInvoicesDrawerCreateInvoiceMutation, AdminInvoicesDrawerCreateInvoiceMutationVariables>(AdminInvoicesDrawerCreateInvoiceDocument, parser(options)));
      }
export type AdminInvoicesDrawerCreateInvoiceMutationHookResult = ReturnType<typeof useAdminInvoicesDrawerCreateInvoiceMutation>;
export type AdminInvoicesDrawerCreateInvoiceMutationResult = ApolloReact.MutationResult<AdminInvoicesDrawerCreateInvoiceMutation>;
export type AdminInvoicesDrawerCreateInvoiceMutationOptions = Apollo.MutationOptions<AdminInvoicesDrawerCreateInvoiceMutation, AdminInvoicesDrawerCreateInvoiceMutationVariables>;
export const AdminInvoicesDrawerRemoveInvoiceDocument = /*#__PURE__*/ gql`
    mutation Admin_InvoicesDrawer_RemoveInvoice($contractId: ContractId!, $yearMonth: YearMonth!, $invoiceDetailsId: InvoiceDetailsId!) {
  contractSalaryDetails(contractId: $contractId, date: $yearMonth) {
    invoiceDetails {
      remove(invoiceDetailsId: $invoiceDetailsId) {
        ...NfsError
        ... on BooleanResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useAdminInvoicesDrawerRemoveInvoiceMutation__
 *
 * To run a mutation, you first call `useAdminInvoicesDrawerRemoveInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInvoicesDrawerRemoveInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInvoicesDrawerRemoveInvoiceMutation, { data, loading, error }] = useAdminInvoicesDrawerRemoveInvoiceMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *      invoiceDetailsId: // value for 'invoiceDetailsId'
 *   },
 * });
 */
export function useAdminInvoicesDrawerRemoveInvoiceMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminInvoicesDrawerRemoveInvoiceMutation, AdminInvoicesDrawerRemoveInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminInvoicesDrawerRemoveInvoiceDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminInvoicesDrawerRemoveInvoiceMutation, AdminInvoicesDrawerRemoveInvoiceMutationVariables>(AdminInvoicesDrawerRemoveInvoiceDocument, parser(options)));
      }
export type AdminInvoicesDrawerRemoveInvoiceMutationHookResult = ReturnType<typeof useAdminInvoicesDrawerRemoveInvoiceMutation>;
export type AdminInvoicesDrawerRemoveInvoiceMutationResult = ApolloReact.MutationResult<AdminInvoicesDrawerRemoveInvoiceMutation>;
export type AdminInvoicesDrawerRemoveInvoiceMutationOptions = Apollo.MutationOptions<AdminInvoicesDrawerRemoveInvoiceMutation, AdminInvoicesDrawerRemoveInvoiceMutationVariables>;
export const InvoicesDrawerInvoicesDocument = /*#__PURE__*/ gql`
    query InvoicesDrawer_Invoices($contractId: ContractId!, $from: YearMonth!, $to: YearMonth!) {
  contractSalaryDetailsInRange(contractId: $contractId, from: $from, to: $to) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      value {
        ... on B2BContractSalaryDetails {
          ...InvoicesDrawer_Salary
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${InvoicesDrawerSalaryFragmentDoc}`;

/**
 * __useInvoicesDrawerInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesDrawerInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesDrawerInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesDrawerInvoicesQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useInvoicesDrawerInvoicesQuery(baseOptions: ApolloReact.QueryHookOptions<InvoicesDrawerInvoicesQuery, InvoicesDrawerInvoicesQueryVariables> & ({ variables: InvoicesDrawerInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(InvoicesDrawerInvoicesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<InvoicesDrawerInvoicesQuery, InvoicesDrawerInvoicesQueryVariables>(InvoicesDrawerInvoicesDocument, parser(options)));
      }
export function useInvoicesDrawerInvoicesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<InvoicesDrawerInvoicesQuery, InvoicesDrawerInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(InvoicesDrawerInvoicesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<InvoicesDrawerInvoicesQuery, InvoicesDrawerInvoicesQueryVariables>(InvoicesDrawerInvoicesDocument, options));
        }

export type InvoicesDrawerInvoicesQueryResult = ApolloReact.QueryResult<InvoicesDrawerInvoicesQuery, InvoicesDrawerInvoicesQueryVariables>;
export function refetchInvoicesDrawerInvoicesQuery(variables: InvoicesDrawerInvoicesQueryVariables) {
      return { query: InvoicesDrawerInvoicesDocument, variables: variables }
    }
export const AdminProjectsColorsProviderAllProjectsDocument = /*#__PURE__*/ gql`
    query Admin_ProjectsColorsProvider_AllProjects($userId: UserId!) {
  getUserProjects(userId: $userId) {
    ...NfsError
    ... on ListOfProjectIdResponse {
      value
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useAdminProjectsColorsProviderAllProjectsQuery__
 *
 * To run a query within a React component, call `useAdminProjectsColorsProviderAllProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProjectsColorsProviderAllProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProjectsColorsProviderAllProjectsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminProjectsColorsProviderAllProjectsQuery(baseOptions: ApolloReact.QueryHookOptions<AdminProjectsColorsProviderAllProjectsQuery, AdminProjectsColorsProviderAllProjectsQueryVariables> & ({ variables: AdminProjectsColorsProviderAllProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminProjectsColorsProviderAllProjectsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminProjectsColorsProviderAllProjectsQuery, AdminProjectsColorsProviderAllProjectsQueryVariables>(AdminProjectsColorsProviderAllProjectsDocument, parser(options)));
      }
export function useAdminProjectsColorsProviderAllProjectsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminProjectsColorsProviderAllProjectsQuery, AdminProjectsColorsProviderAllProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminProjectsColorsProviderAllProjectsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminProjectsColorsProviderAllProjectsQuery, AdminProjectsColorsProviderAllProjectsQueryVariables>(AdminProjectsColorsProviderAllProjectsDocument, options));
        }

export type AdminProjectsColorsProviderAllProjectsQueryResult = ApolloReact.QueryResult<AdminProjectsColorsProviderAllProjectsQuery, AdminProjectsColorsProviderAllProjectsQueryVariables>;
export function refetchAdminProjectsColorsProviderAllProjectsQuery(variables: AdminProjectsColorsProviderAllProjectsQueryVariables) {
      return { query: AdminProjectsColorsProviderAllProjectsDocument, variables: variables }
    }
export const AdminTimeReportBlockedMessageSpaceOwnerDocument = /*#__PURE__*/ gql`
    query Admin_TimeReportBlockedMessage_SpaceOwner($userId: UserId!) {
  user(id: $userId) {
    ...NfsError
    ... on User {
      id
      directReporting {
        space {
          value {
            id
            owner {
              id
              avatar
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useAdminTimeReportBlockedMessageSpaceOwnerQuery__
 *
 * To run a query within a React component, call `useAdminTimeReportBlockedMessageSpaceOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTimeReportBlockedMessageSpaceOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTimeReportBlockedMessageSpaceOwnerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminTimeReportBlockedMessageSpaceOwnerQuery(baseOptions: ApolloReact.QueryHookOptions<AdminTimeReportBlockedMessageSpaceOwnerQuery, AdminTimeReportBlockedMessageSpaceOwnerQueryVariables> & ({ variables: AdminTimeReportBlockedMessageSpaceOwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTimeReportBlockedMessageSpaceOwnerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminTimeReportBlockedMessageSpaceOwnerQuery, AdminTimeReportBlockedMessageSpaceOwnerQueryVariables>(AdminTimeReportBlockedMessageSpaceOwnerDocument, parser(options)));
      }
export function useAdminTimeReportBlockedMessageSpaceOwnerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminTimeReportBlockedMessageSpaceOwnerQuery, AdminTimeReportBlockedMessageSpaceOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminTimeReportBlockedMessageSpaceOwnerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminTimeReportBlockedMessageSpaceOwnerQuery, AdminTimeReportBlockedMessageSpaceOwnerQueryVariables>(AdminTimeReportBlockedMessageSpaceOwnerDocument, options));
        }

export type AdminTimeReportBlockedMessageSpaceOwnerQueryResult = ApolloReact.QueryResult<AdminTimeReportBlockedMessageSpaceOwnerQuery, AdminTimeReportBlockedMessageSpaceOwnerQueryVariables>;
export function refetchAdminTimeReportBlockedMessageSpaceOwnerQuery(variables: AdminTimeReportBlockedMessageSpaceOwnerQueryVariables) {
      return { query: AdminTimeReportBlockedMessageSpaceOwnerDocument, variables: variables }
    }
export const TimeReportBulkEditToolbarDeleteSelectedDocument = /*#__PURE__*/ gql`
    mutation TimeReportBulkEditToolbar_DeleteSelected($workRecordIds: [WorkRecordId!]!, $onCallRecordIds: [OnCallRecordId!]!, $absenceRecordIds: [AbsenceRecordId!]!) {
  reporting {
    deleteTimeReports(
      workRecordIds: $workRecordIds
      onCallRecordIds: $onCallRecordIds
      absenceRecordIds: $absenceRecordIds
    ) {
      ...NfsError
      ... on UnitResponse {
        value
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTimeReportBulkEditToolbarDeleteSelectedMutation__
 *
 * To run a mutation, you first call `useTimeReportBulkEditToolbarDeleteSelectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportBulkEditToolbarDeleteSelectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportBulkEditToolbarDeleteSelectedMutation, { data, loading, error }] = useTimeReportBulkEditToolbarDeleteSelectedMutation({
 *   variables: {
 *      workRecordIds: // value for 'workRecordIds'
 *      onCallRecordIds: // value for 'onCallRecordIds'
 *      absenceRecordIds: // value for 'absenceRecordIds'
 *   },
 * });
 */
export function useTimeReportBulkEditToolbarDeleteSelectedMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportBulkEditToolbarDeleteSelectedMutation, TimeReportBulkEditToolbarDeleteSelectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportBulkEditToolbarDeleteSelectedDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportBulkEditToolbarDeleteSelectedMutation, TimeReportBulkEditToolbarDeleteSelectedMutationVariables>(TimeReportBulkEditToolbarDeleteSelectedDocument, parser(options)));
      }
export type TimeReportBulkEditToolbarDeleteSelectedMutationHookResult = ReturnType<typeof useTimeReportBulkEditToolbarDeleteSelectedMutation>;
export type TimeReportBulkEditToolbarDeleteSelectedMutationResult = ApolloReact.MutationResult<TimeReportBulkEditToolbarDeleteSelectedMutation>;
export type TimeReportBulkEditToolbarDeleteSelectedMutationOptions = Apollo.MutationOptions<TimeReportBulkEditToolbarDeleteSelectedMutation, TimeReportBulkEditToolbarDeleteSelectedMutationVariables>;
export const AdminTimeReportDashboardProviderContractInfoDocument = /*#__PURE__*/ gql`
    query Admin_TimeReportDashboardProvider_ContractInfo($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        name
        createdAt
        status
        startDate
        expectedEndDate
        terminationDate
        holidayCalendar {
          calendarDays {
            date
            dayType
          }
        }
        ... on B2BContract {
          b2bContractType: type
          enableTrainingPackage {
            ...Unauthorized
            ... on AccessGranted__Boolean {
              value
            }
          }
          overtimeRate {
            ...Unauthorized
            ... on AccessGranted__TimeBasedOptClearableNetGross {
              value {
                ...TimeReportDashBoardProvider_OvertimeRate
              }
            }
          }
          onCall {
            ...Unauthorized
            ... on AccessGranted__TimeBasedOptClearableOnCallRate {
              value {
                ...TimeReportDashBoardProvider_OnCall
              }
            }
          }
          rate {
            ...Unauthorized
            ... on AccessGranted__TimeBasedRate {
              value {
                ...TimeReportDashBoardProvider_TimeBasedRate
              }
            }
          }
        }
        ... on EmploymentContract {
          type
          enableTrainingPackage {
            ...Unauthorized
            ... on AccessGranted__Boolean {
              value
            }
          }
          overtimeRate {
            ...Unauthorized
            ... on AccessGranted__TimeBasedOptClearableNetGross {
              value {
                ...TimeReportDashBoardProvider_OvertimeRate
              }
            }
          }
          onCall {
            ...Unauthorized
            ... on AccessGranted__TimeBasedOptClearableOnCallRate {
              value {
                ...TimeReportDashBoardProvider_OnCall
              }
            }
          }
          rate {
            ...Unauthorized
            ... on AccessGranted__TimeBasedRate {
              value {
                ...TimeReportDashBoardProvider_TimeBasedRate
              }
            }
          }
          workingTime {
            ...Unauthorized
            ... on AccessGranted__TimeBasedWorkingTime {
              value {
                value {
                  ...WorkingTime
                }
                futureUpdates {
                  activityId
                  applyDate
                  value {
                    ...WorkingTime
                  }
                }
                history {
                  activityId
                  applyDate
                  value {
                    ...WorkingTime
                  }
                }
              }
            }
          }
        }
        promisee {
          id
          firstName
          lastName
          avatar
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UnauthorizedFragmentDoc}
${TimeReportDashBoardProviderOvertimeRateFragmentDoc}
${TimeReportDashBoardProviderOnCallFragmentDoc}
${TimeReportDashBoardProviderTimeBasedRateFragmentDoc}
${WorkingTimeFragmentDoc}`;

/**
 * __useAdminTimeReportDashboardProviderContractInfoQuery__
 *
 * To run a query within a React component, call `useAdminTimeReportDashboardProviderContractInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTimeReportDashboardProviderContractInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTimeReportDashboardProviderContractInfoQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useAdminTimeReportDashboardProviderContractInfoQuery(baseOptions: ApolloReact.QueryHookOptions<AdminTimeReportDashboardProviderContractInfoQuery, AdminTimeReportDashboardProviderContractInfoQueryVariables> & ({ variables: AdminTimeReportDashboardProviderContractInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTimeReportDashboardProviderContractInfoDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminTimeReportDashboardProviderContractInfoQuery, AdminTimeReportDashboardProviderContractInfoQueryVariables>(AdminTimeReportDashboardProviderContractInfoDocument, parser(options)));
      }
export function useAdminTimeReportDashboardProviderContractInfoLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminTimeReportDashboardProviderContractInfoQuery, AdminTimeReportDashboardProviderContractInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminTimeReportDashboardProviderContractInfoDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminTimeReportDashboardProviderContractInfoQuery, AdminTimeReportDashboardProviderContractInfoQueryVariables>(AdminTimeReportDashboardProviderContractInfoDocument, options));
        }

export type AdminTimeReportDashboardProviderContractInfoQueryResult = ApolloReact.QueryResult<AdminTimeReportDashboardProviderContractInfoQuery, AdminTimeReportDashboardProviderContractInfoQueryVariables>;
export function refetchAdminTimeReportDashboardProviderContractInfoQuery(variables: AdminTimeReportDashboardProviderContractInfoQueryVariables) {
      return { query: AdminTimeReportDashboardProviderContractInfoDocument, variables: variables }
    }
export const AdminTimeReportDashboardProviderDocument = /*#__PURE__*/ gql`
    query Admin_TimeReportDashboardProvider($dashboardFrom: LocalDate!, $dashboardTo: LocalDate!, $projectsFrom: OffsetDateTime!, $projectsTo: OffsetDateTime!, $contractId: ContractId!) {
  timeReport(from: $dashboardFrom, to: $dashboardTo, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      timeReportStats {
        ... on EmploymentTimeReportStats {
          flexTime {
            period {
              from
              to
            }
          }
        }
      }
      timeReportRecords {
        workTags {
          ...WorkTag
        }
        work {
          ...WorkRecord
        }
        absence {
          ...AbsenceRecord
        }
        onCall {
          ...OnCallRecord
        }
      }
    }
  }
  assignedProjects(from: $projectsFrom, to: $projectsTo, contractId: $contractId) {
    ...NfsError
    ... on ListOfAssignedProjectResponse {
      value {
        projectId
        projectName
        assignmentPeriods {
          from
          to
        }
        reportingPeriods {
          from
          to
        }
      }
    }
  }
  absenceTypeDetails {
    ...TimeReportDashBoardProvider_AbsenceTypeDetails
  }
}
    ${NfsErrorFragmentDoc}
${WorkTagFragmentDoc}
${WorkRecordFragmentDoc}
${AbsenceRecordFragmentDoc}
${OnCallRecordFragmentDoc}
${TimeReportDashBoardProviderAbsenceTypeDetailsFragmentDoc}`;

/**
 * __useAdminTimeReportDashboardProviderQuery__
 *
 * To run a query within a React component, call `useAdminTimeReportDashboardProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTimeReportDashboardProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTimeReportDashboardProviderQuery({
 *   variables: {
 *      dashboardFrom: // value for 'dashboardFrom'
 *      dashboardTo: // value for 'dashboardTo'
 *      projectsFrom: // value for 'projectsFrom'
 *      projectsTo: // value for 'projectsTo'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useAdminTimeReportDashboardProviderQuery(baseOptions: ApolloReact.QueryHookOptions<AdminTimeReportDashboardProviderQuery, AdminTimeReportDashboardProviderQueryVariables> & ({ variables: AdminTimeReportDashboardProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTimeReportDashboardProviderDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminTimeReportDashboardProviderQuery, AdminTimeReportDashboardProviderQueryVariables>(AdminTimeReportDashboardProviderDocument, parser(options)));
      }
export function useAdminTimeReportDashboardProviderLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminTimeReportDashboardProviderQuery, AdminTimeReportDashboardProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminTimeReportDashboardProviderDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminTimeReportDashboardProviderQuery, AdminTimeReportDashboardProviderQueryVariables>(AdminTimeReportDashboardProviderDocument, options));
        }

export type AdminTimeReportDashboardProviderQueryResult = ApolloReact.QueryResult<AdminTimeReportDashboardProviderQuery, AdminTimeReportDashboardProviderQueryVariables>;
export function refetchAdminTimeReportDashboardProviderQuery(variables: AdminTimeReportDashboardProviderQueryVariables) {
      return { query: AdminTimeReportDashboardProviderDocument, variables: variables }
    }
export const TimeReportDashboardProviderValidationsDocument = /*#__PURE__*/ gql`
    query TimeReportDashboardProvider_Validations($contractId: ContractId!, $date: YearMonth!) {
  timeReportValidations(contractId: $contractId, date: $date) {
    ...NfsError
    ... on ListOfTimeReportValidationResponse {
      value {
        ...TimeReportDashBoardProvider_TimeReportValidations
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${TimeReportDashBoardProviderTimeReportValidationsFragmentDoc}`;

/**
 * __useTimeReportDashboardProviderValidationsQuery__
 *
 * To run a query within a React component, call `useTimeReportDashboardProviderValidationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportDashboardProviderValidationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportDashboardProviderValidationsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTimeReportDashboardProviderValidationsQuery(baseOptions: ApolloReact.QueryHookOptions<TimeReportDashboardProviderValidationsQuery, TimeReportDashboardProviderValidationsQueryVariables> & ({ variables: TimeReportDashboardProviderValidationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportDashboardProviderValidationsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TimeReportDashboardProviderValidationsQuery, TimeReportDashboardProviderValidationsQueryVariables>(TimeReportDashboardProviderValidationsDocument, parser(options)));
      }
export function useTimeReportDashboardProviderValidationsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TimeReportDashboardProviderValidationsQuery, TimeReportDashboardProviderValidationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TimeReportDashboardProviderValidationsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TimeReportDashboardProviderValidationsQuery, TimeReportDashboardProviderValidationsQueryVariables>(TimeReportDashboardProviderValidationsDocument, options));
        }

export type TimeReportDashboardProviderValidationsQueryResult = ApolloReact.QueryResult<TimeReportDashboardProviderValidationsQuery, TimeReportDashboardProviderValidationsQueryVariables>;
export function refetchTimeReportDashboardProviderValidationsQuery(variables: TimeReportDashboardProviderValidationsQueryVariables) {
      return { query: TimeReportDashboardProviderValidationsDocument, variables: variables }
    }
export const AdminTimeReportEntryModalLimitsDocument = /*#__PURE__*/ gql`
    query Admin_TimeReportEntryModal_Limits($year: Year!, $from: LocalDate!, $to: LocalDate!, $userId: UserId!, $contractId: ContractId!, $hasAnnualLeave: Boolean!) {
  remainingWorkTagReportingLimit(year: $year, userId: $userId) {
    ...NfsError
    ... on ListOfKVWorkTagIdMinutesResponse {
      value {
        key
        value
      }
    }
  }
  paidLeaveBalanceYearlySummary(contractId: $contractId, year: $year) {
    ...NfsError
    ...LeaveBalance
  }
  annualLeaveSummary(contractId: $contractId, year: $year) @include(if: $hasAnnualLeave) {
    ...NfsError
    ...TimeReportEntryModal_AnnualLeaveSummary
  }
  timeReport(from: $from, to: $to, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      timeReportStats {
        ... on EmploymentTimeReportStats {
          reportedLeaveDays {
            ...ReportedLeaveDays
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${LeaveBalanceFragmentDoc}
${TimeReportEntryModalAnnualLeaveSummaryFragmentDoc}
${ReportedLeaveDaysFragmentDoc}`;

/**
 * __useAdminTimeReportEntryModalLimitsQuery__
 *
 * To run a query within a React component, call `useAdminTimeReportEntryModalLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTimeReportEntryModalLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTimeReportEntryModalLimitsQuery({
 *   variables: {
 *      year: // value for 'year'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      userId: // value for 'userId'
 *      contractId: // value for 'contractId'
 *      hasAnnualLeave: // value for 'hasAnnualLeave'
 *   },
 * });
 */
export function useAdminTimeReportEntryModalLimitsQuery(baseOptions: ApolloReact.QueryHookOptions<AdminTimeReportEntryModalLimitsQuery, AdminTimeReportEntryModalLimitsQueryVariables> & ({ variables: AdminTimeReportEntryModalLimitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTimeReportEntryModalLimitsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminTimeReportEntryModalLimitsQuery, AdminTimeReportEntryModalLimitsQueryVariables>(AdminTimeReportEntryModalLimitsDocument, parser(options)));
      }
export function useAdminTimeReportEntryModalLimitsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminTimeReportEntryModalLimitsQuery, AdminTimeReportEntryModalLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminTimeReportEntryModalLimitsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminTimeReportEntryModalLimitsQuery, AdminTimeReportEntryModalLimitsQueryVariables>(AdminTimeReportEntryModalLimitsDocument, options));
        }

export type AdminTimeReportEntryModalLimitsQueryResult = ApolloReact.QueryResult<AdminTimeReportEntryModalLimitsQuery, AdminTimeReportEntryModalLimitsQueryVariables>;
export function refetchAdminTimeReportEntryModalLimitsQuery(variables: AdminTimeReportEntryModalLimitsQueryVariables) {
      return { query: AdminTimeReportEntryModalLimitsDocument, variables: variables }
    }
export const AdminTimeReportEntryModalCreateSingularAbsenceRecordDocument = /*#__PURE__*/ gql`
    mutation Admin_TimeReportEntryModal_CreateSingularAbsenceRecord($absenceRecord: CreateAbsenceRecordInput!, $attachment: Upload!) {
  adminCreate: reporting {
    absenceRecord {
      create(absenceRecord: $absenceRecord, attachment: $attachment) {
        ...NfsError
        ... on AbsenceRecord {
          ...AbsenceRecord
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AbsenceRecordFragmentDoc}`;


/**
 * __useAdminTimeReportEntryModalCreateSingularAbsenceRecordMutation__
 *
 * To run a mutation, you first call `useAdminTimeReportEntryModalCreateSingularAbsenceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTimeReportEntryModalCreateSingularAbsenceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTimeReportEntryModalCreateSingularAbsenceRecordMutation, { data, loading, error }] = useAdminTimeReportEntryModalCreateSingularAbsenceRecordMutation({
 *   variables: {
 *      absenceRecord: // value for 'absenceRecord'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useAdminTimeReportEntryModalCreateSingularAbsenceRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminTimeReportEntryModalCreateSingularAbsenceRecordMutation, AdminTimeReportEntryModalCreateSingularAbsenceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTimeReportEntryModalCreateSingularAbsenceRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminTimeReportEntryModalCreateSingularAbsenceRecordMutation, AdminTimeReportEntryModalCreateSingularAbsenceRecordMutationVariables>(AdminTimeReportEntryModalCreateSingularAbsenceRecordDocument, parser(options)));
      }
export type AdminTimeReportEntryModalCreateSingularAbsenceRecordMutationHookResult = ReturnType<typeof useAdminTimeReportEntryModalCreateSingularAbsenceRecordMutation>;
export type AdminTimeReportEntryModalCreateSingularAbsenceRecordMutationResult = ApolloReact.MutationResult<AdminTimeReportEntryModalCreateSingularAbsenceRecordMutation>;
export type AdminTimeReportEntryModalCreateSingularAbsenceRecordMutationOptions = Apollo.MutationOptions<AdminTimeReportEntryModalCreateSingularAbsenceRecordMutation, AdminTimeReportEntryModalCreateSingularAbsenceRecordMutationVariables>;
export const AdminTimeReportEntryModalUpdateAbsenceRecordDocument = /*#__PURE__*/ gql`
    mutation Admin_TimeReportEntryModal_UpdateAbsenceRecord($id: AbsenceRecordId!, $absenceType: AbsenceTypeInput, $dateFrom: LocalDate, $dateTo: LocalDate, $comment: ClearableStringInput, $customDurationPerDay: ClearableMinutesInput, $isOnDemand: Boolean, $attachment: ClearableUploadInput) {
  adminUpdate: reporting {
    absenceRecord {
      update(
        id: $id
        absenceType: $absenceType
        dateFrom: $dateFrom
        dateTo: $dateTo
        comment: $comment
        customDurationPerDay: $customDurationPerDay
        isOnDemand: $isOnDemand
        attachment: $attachment
      ) {
        ...NfsError
        ... on AbsenceRecord {
          ...AbsenceRecord
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AbsenceRecordFragmentDoc}`;


/**
 * __useAdminTimeReportEntryModalUpdateAbsenceRecordMutation__
 *
 * To run a mutation, you first call `useAdminTimeReportEntryModalUpdateAbsenceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTimeReportEntryModalUpdateAbsenceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTimeReportEntryModalUpdateAbsenceRecordMutation, { data, loading, error }] = useAdminTimeReportEntryModalUpdateAbsenceRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      absenceType: // value for 'absenceType'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      comment: // value for 'comment'
 *      customDurationPerDay: // value for 'customDurationPerDay'
 *      isOnDemand: // value for 'isOnDemand'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useAdminTimeReportEntryModalUpdateAbsenceRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminTimeReportEntryModalUpdateAbsenceRecordMutation, AdminTimeReportEntryModalUpdateAbsenceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTimeReportEntryModalUpdateAbsenceRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminTimeReportEntryModalUpdateAbsenceRecordMutation, AdminTimeReportEntryModalUpdateAbsenceRecordMutationVariables>(AdminTimeReportEntryModalUpdateAbsenceRecordDocument, parser(options)));
      }
export type AdminTimeReportEntryModalUpdateAbsenceRecordMutationHookResult = ReturnType<typeof useAdminTimeReportEntryModalUpdateAbsenceRecordMutation>;
export type AdminTimeReportEntryModalUpdateAbsenceRecordMutationResult = ApolloReact.MutationResult<AdminTimeReportEntryModalUpdateAbsenceRecordMutation>;
export type AdminTimeReportEntryModalUpdateAbsenceRecordMutationOptions = Apollo.MutationOptions<AdminTimeReportEntryModalUpdateAbsenceRecordMutation, AdminTimeReportEntryModalUpdateAbsenceRecordMutationVariables>;
export const AdminTimeReportEntryModalCreateAbsenceRecordDocument = /*#__PURE__*/ gql`
    mutation Admin_TimeReportEntryModal_CreateAbsenceRecord($absenceRecords: [CreateAbsenceRecordInput!]!) {
  adminCreate: reporting {
    absenceRecord {
      createMany(value: $absenceRecords) {
        ...NfsError
        ... on ListOfAbsenceRecordResponse {
          value {
            ...AbsenceRecord
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AbsenceRecordFragmentDoc}`;


/**
 * __useAdminTimeReportEntryModalCreateAbsenceRecordMutation__
 *
 * To run a mutation, you first call `useAdminTimeReportEntryModalCreateAbsenceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTimeReportEntryModalCreateAbsenceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTimeReportEntryModalCreateAbsenceRecordMutation, { data, loading, error }] = useAdminTimeReportEntryModalCreateAbsenceRecordMutation({
 *   variables: {
 *      absenceRecords: // value for 'absenceRecords'
 *   },
 * });
 */
export function useAdminTimeReportEntryModalCreateAbsenceRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<AdminTimeReportEntryModalCreateAbsenceRecordMutation, AdminTimeReportEntryModalCreateAbsenceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTimeReportEntryModalCreateAbsenceRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<AdminTimeReportEntryModalCreateAbsenceRecordMutation, AdminTimeReportEntryModalCreateAbsenceRecordMutationVariables>(AdminTimeReportEntryModalCreateAbsenceRecordDocument, parser(options)));
      }
export type AdminTimeReportEntryModalCreateAbsenceRecordMutationHookResult = ReturnType<typeof useAdminTimeReportEntryModalCreateAbsenceRecordMutation>;
export type AdminTimeReportEntryModalCreateAbsenceRecordMutationResult = ApolloReact.MutationResult<AdminTimeReportEntryModalCreateAbsenceRecordMutation>;
export type AdminTimeReportEntryModalCreateAbsenceRecordMutationOptions = Apollo.MutationOptions<AdminTimeReportEntryModalCreateAbsenceRecordMutation, AdminTimeReportEntryModalCreateAbsenceRecordMutationVariables>;
export const TimeReportEntryModalCreateWorkRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_CreateWorkRecord($workRecords: [CreateWorkRecordInput!]!) {
  reporting {
    workRecord {
      createMany(value: $workRecords) {
        ...NfsError
        ... on ListOfWorkRecordResponse {
          value {
            ...WorkRecord
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${WorkRecordFragmentDoc}`;


/**
 * __useTimeReportEntryModalCreateWorkRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalCreateWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalCreateWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalCreateWorkRecordMutation, { data, loading, error }] = useTimeReportEntryModalCreateWorkRecordMutation({
 *   variables: {
 *      workRecords: // value for 'workRecords'
 *   },
 * });
 */
export function useTimeReportEntryModalCreateWorkRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalCreateWorkRecordMutation, TimeReportEntryModalCreateWorkRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalCreateWorkRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalCreateWorkRecordMutation, TimeReportEntryModalCreateWorkRecordMutationVariables>(TimeReportEntryModalCreateWorkRecordDocument, parser(options)));
      }
export type TimeReportEntryModalCreateWorkRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalCreateWorkRecordMutation>;
export type TimeReportEntryModalCreateWorkRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalCreateWorkRecordMutation>;
export type TimeReportEntryModalCreateWorkRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalCreateWorkRecordMutation, TimeReportEntryModalCreateWorkRecordMutationVariables>;
export const TimeReportEntryModalUpdateWorkRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_UpdateWorkRecord($workRecordId: WorkRecordId!, $projectId: ClearableProjectIdInput, $workTagId: WorkTagId, $date: LocalDate!, $duration: ClearableMinutesInput, $workTime: ClearableWorkTimeInput, $overtime: Boolean!, $comment: ClearableStringInput, $remoteWork: Boolean!) {
  reporting {
    workRecord {
      update(
        id: $workRecordId
        projectId: $projectId
        workTagId: $workTagId
        date: $date
        duration: $duration
        workTime: $workTime
        overtime: $overtime
        comment: $comment
        remoteWork: $remoteWork
      ) {
        ...NfsError
        ... on WorkRecord {
          ...WorkRecord
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${WorkRecordFragmentDoc}`;


/**
 * __useTimeReportEntryModalUpdateWorkRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalUpdateWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalUpdateWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalUpdateWorkRecordMutation, { data, loading, error }] = useTimeReportEntryModalUpdateWorkRecordMutation({
 *   variables: {
 *      workRecordId: // value for 'workRecordId'
 *      projectId: // value for 'projectId'
 *      workTagId: // value for 'workTagId'
 *      date: // value for 'date'
 *      duration: // value for 'duration'
 *      workTime: // value for 'workTime'
 *      overtime: // value for 'overtime'
 *      comment: // value for 'comment'
 *      remoteWork: // value for 'remoteWork'
 *   },
 * });
 */
export function useTimeReportEntryModalUpdateWorkRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalUpdateWorkRecordMutation, TimeReportEntryModalUpdateWorkRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalUpdateWorkRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalUpdateWorkRecordMutation, TimeReportEntryModalUpdateWorkRecordMutationVariables>(TimeReportEntryModalUpdateWorkRecordDocument, parser(options)));
      }
export type TimeReportEntryModalUpdateWorkRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalUpdateWorkRecordMutation>;
export type TimeReportEntryModalUpdateWorkRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalUpdateWorkRecordMutation>;
export type TimeReportEntryModalUpdateWorkRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalUpdateWorkRecordMutation, TimeReportEntryModalUpdateWorkRecordMutationVariables>;
export const TimeReportEntryModalDeleteWorkRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_DeleteWorkRecord($workRecordId: WorkRecordId!) {
  reporting {
    deleteTimeReports(
      workRecordIds: [$workRecordId]
      onCallRecordIds: []
      absenceRecordIds: []
    ) {
      ...NfsError
      ... on UnitResponse {
        value
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTimeReportEntryModalDeleteWorkRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalDeleteWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalDeleteWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalDeleteWorkRecordMutation, { data, loading, error }] = useTimeReportEntryModalDeleteWorkRecordMutation({
 *   variables: {
 *      workRecordId: // value for 'workRecordId'
 *   },
 * });
 */
export function useTimeReportEntryModalDeleteWorkRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalDeleteWorkRecordMutation, TimeReportEntryModalDeleteWorkRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalDeleteWorkRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalDeleteWorkRecordMutation, TimeReportEntryModalDeleteWorkRecordMutationVariables>(TimeReportEntryModalDeleteWorkRecordDocument, parser(options)));
      }
export type TimeReportEntryModalDeleteWorkRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalDeleteWorkRecordMutation>;
export type TimeReportEntryModalDeleteWorkRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalDeleteWorkRecordMutation>;
export type TimeReportEntryModalDeleteWorkRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalDeleteWorkRecordMutation, TimeReportEntryModalDeleteWorkRecordMutationVariables>;
export const TimeReportEntryModalCreateOnCallRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_CreateOnCallRecord($onCallRecords: [CreateOnCallRecordInput!]!) {
  reporting {
    oncallRecord {
      createMany(value: $onCallRecords) {
        ...NfsError
        ... on ListOfOnCallRecordResponse {
          value {
            ...OnCallRecord
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${OnCallRecordFragmentDoc}`;


/**
 * __useTimeReportEntryModalCreateOnCallRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalCreateOnCallRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalCreateOnCallRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalCreateOnCallRecordMutation, { data, loading, error }] = useTimeReportEntryModalCreateOnCallRecordMutation({
 *   variables: {
 *      onCallRecords: // value for 'onCallRecords'
 *   },
 * });
 */
export function useTimeReportEntryModalCreateOnCallRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalCreateOnCallRecordMutation, TimeReportEntryModalCreateOnCallRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalCreateOnCallRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalCreateOnCallRecordMutation, TimeReportEntryModalCreateOnCallRecordMutationVariables>(TimeReportEntryModalCreateOnCallRecordDocument, parser(options)));
      }
export type TimeReportEntryModalCreateOnCallRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalCreateOnCallRecordMutation>;
export type TimeReportEntryModalCreateOnCallRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalCreateOnCallRecordMutation>;
export type TimeReportEntryModalCreateOnCallRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalCreateOnCallRecordMutation, TimeReportEntryModalCreateOnCallRecordMutationVariables>;
export const TimeReportEntryModalUpdateOnCallRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_UpdateOnCallRecord($onCallRecordId: OnCallRecordId!, $projectId: ProjectId!, $date: LocalDate!, $dayShift: Boolean!, $nightShift: Boolean!, $comment: ClearableStringInput) {
  reporting {
    oncallRecord {
      update(
        id: $onCallRecordId
        projectId: $projectId
        date: $date
        dayShift: $dayShift
        nightShift: $nightShift
        comment: $comment
      ) {
        ...NfsError
        ... on OnCallRecord {
          ...OnCallRecord
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${OnCallRecordFragmentDoc}`;


/**
 * __useTimeReportEntryModalUpdateOnCallRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalUpdateOnCallRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalUpdateOnCallRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalUpdateOnCallRecordMutation, { data, loading, error }] = useTimeReportEntryModalUpdateOnCallRecordMutation({
 *   variables: {
 *      onCallRecordId: // value for 'onCallRecordId'
 *      projectId: // value for 'projectId'
 *      date: // value for 'date'
 *      dayShift: // value for 'dayShift'
 *      nightShift: // value for 'nightShift'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useTimeReportEntryModalUpdateOnCallRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalUpdateOnCallRecordMutation, TimeReportEntryModalUpdateOnCallRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalUpdateOnCallRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalUpdateOnCallRecordMutation, TimeReportEntryModalUpdateOnCallRecordMutationVariables>(TimeReportEntryModalUpdateOnCallRecordDocument, parser(options)));
      }
export type TimeReportEntryModalUpdateOnCallRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalUpdateOnCallRecordMutation>;
export type TimeReportEntryModalUpdateOnCallRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalUpdateOnCallRecordMutation>;
export type TimeReportEntryModalUpdateOnCallRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalUpdateOnCallRecordMutation, TimeReportEntryModalUpdateOnCallRecordMutationVariables>;
export const TimeReportEntryModalDeleteOnCallRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_DeleteOnCallRecord($onCallRecordId: OnCallRecordId!) {
  reporting {
    deleteTimeReports(
      workRecordIds: []
      onCallRecordIds: [$onCallRecordId]
      absenceRecordIds: []
    ) {
      ...NfsError
      ... on UnitResponse {
        value
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTimeReportEntryModalDeleteOnCallRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalDeleteOnCallRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalDeleteOnCallRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalDeleteOnCallRecordMutation, { data, loading, error }] = useTimeReportEntryModalDeleteOnCallRecordMutation({
 *   variables: {
 *      onCallRecordId: // value for 'onCallRecordId'
 *   },
 * });
 */
export function useTimeReportEntryModalDeleteOnCallRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalDeleteOnCallRecordMutation, TimeReportEntryModalDeleteOnCallRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalDeleteOnCallRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalDeleteOnCallRecordMutation, TimeReportEntryModalDeleteOnCallRecordMutationVariables>(TimeReportEntryModalDeleteOnCallRecordDocument, parser(options)));
      }
export type TimeReportEntryModalDeleteOnCallRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalDeleteOnCallRecordMutation>;
export type TimeReportEntryModalDeleteOnCallRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalDeleteOnCallRecordMutation>;
export type TimeReportEntryModalDeleteOnCallRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalDeleteOnCallRecordMutation, TimeReportEntryModalDeleteOnCallRecordMutationVariables>;
export const TimeReportEntryModalDeleteAbsenceRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_DeleteAbsenceRecord($absenceRecordId: AbsenceRecordId!) {
  reporting {
    deleteTimeReports(
      workRecordIds: []
      onCallRecordIds: []
      absenceRecordIds: [$absenceRecordId]
    ) {
      ...NfsError
      ... on UnitResponse {
        value
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTimeReportEntryModalDeleteAbsenceRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalDeleteAbsenceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalDeleteAbsenceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalDeleteAbsenceRecordMutation, { data, loading, error }] = useTimeReportEntryModalDeleteAbsenceRecordMutation({
 *   variables: {
 *      absenceRecordId: // value for 'absenceRecordId'
 *   },
 * });
 */
export function useTimeReportEntryModalDeleteAbsenceRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalDeleteAbsenceRecordMutation, TimeReportEntryModalDeleteAbsenceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalDeleteAbsenceRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalDeleteAbsenceRecordMutation, TimeReportEntryModalDeleteAbsenceRecordMutationVariables>(TimeReportEntryModalDeleteAbsenceRecordDocument, parser(options)));
      }
export type TimeReportEntryModalDeleteAbsenceRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalDeleteAbsenceRecordMutation>;
export type TimeReportEntryModalDeleteAbsenceRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalDeleteAbsenceRecordMutation>;
export type TimeReportEntryModalDeleteAbsenceRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalDeleteAbsenceRecordMutation, TimeReportEntryModalDeleteAbsenceRecordMutationVariables>;
export const AdminTimeReportFinancesDocument = /*#__PURE__*/ gql`
    query Admin_TimeReportFinances($contractId: ContractId!, $from: LocalDate!, $to: LocalDate!, $month: YearMonth!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        ...TimeReportFinances_Contract
      }
    }
  }
  contractSalaryDetails(date: $month, contractId: $contractId) {
    ...NfsError
    ... on ContractSalaryDetailsResponse {
      ...TimeReportFinances_SalaryDetails
    }
  }
  timeReport(from: $from, to: $to, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      timeReportStats {
        incomeDetails {
          ...Unauthorized
          ... on AccessGranted__ListOfIncomeDetails {
            value {
              ...TimeReportFinances_IncomeDetails
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${TimeReportFinancesContractFragmentDoc}
${TimeReportFinancesSalaryDetailsFragmentDoc}
${UnauthorizedFragmentDoc}
${TimeReportFinancesIncomeDetailsFragmentDoc}`;

/**
 * __useAdminTimeReportFinancesQuery__
 *
 * To run a query within a React component, call `useAdminTimeReportFinancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTimeReportFinancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTimeReportFinancesQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useAdminTimeReportFinancesQuery(baseOptions: ApolloReact.QueryHookOptions<AdminTimeReportFinancesQuery, AdminTimeReportFinancesQueryVariables> & ({ variables: AdminTimeReportFinancesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTimeReportFinancesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminTimeReportFinancesQuery, AdminTimeReportFinancesQueryVariables>(AdminTimeReportFinancesDocument, parser(options)));
      }
export function useAdminTimeReportFinancesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminTimeReportFinancesQuery, AdminTimeReportFinancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminTimeReportFinancesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminTimeReportFinancesQuery, AdminTimeReportFinancesQueryVariables>(AdminTimeReportFinancesDocument, options));
        }

export type AdminTimeReportFinancesQueryResult = ApolloReact.QueryResult<AdminTimeReportFinancesQuery, AdminTimeReportFinancesQueryVariables>;
export function refetchAdminTimeReportFinancesQuery(variables: AdminTimeReportFinancesQueryVariables) {
      return { query: AdminTimeReportFinancesDocument, variables: variables }
    }
export const AdminTimeReportLeaveAndTrainingDocument = /*#__PURE__*/ gql`
    query Admin_TimeReportLeaveAndTraining($contractId: ContractId!, $userId: UserId!, $year: Year!, $from: LocalDate!, $to: LocalDate!) {
  annualLeaveSummary(contractId: $contractId, year: $year) {
    ...NfsError
    ... on AnnualLeaveSummary {
      ...TimeReportLeaveAndTraining_AnnualLeaveSummary
    }
  }
  paidLeaveBalanceYearlySummary(contractId: $contractId, year: $year) {
    ...NfsError
    ...LeaveBalance
  }
  remainingWorkTagReportingLimit(year: $year, userId: $userId) {
    ...NfsError
    ... on ListOfKVWorkTagIdMinutesResponse {
      value {
        key
        value
      }
    }
  }
  timeReport(from: $from, to: $to, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      ...TimeReportLeaveAndTraining_TimeReport
    }
  }
  trainingBudgetSummary(contractId: $contractId, year: $year) {
    ...NfsError
    ... on TrainingBudgetSummary {
      ...TimeReportLeaveAndTraining_TrainingPackage
    }
  }
}
    ${NfsErrorFragmentDoc}
${TimeReportLeaveAndTrainingAnnualLeaveSummaryFragmentDoc}
${LeaveBalanceFragmentDoc}
${TimeReportLeaveAndTrainingTimeReportFragmentDoc}
${TimeReportLeaveAndTrainingTrainingPackageFragmentDoc}`;

/**
 * __useAdminTimeReportLeaveAndTrainingQuery__
 *
 * To run a query within a React component, call `useAdminTimeReportLeaveAndTrainingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTimeReportLeaveAndTrainingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTimeReportLeaveAndTrainingQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      userId: // value for 'userId'
 *      year: // value for 'year'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useAdminTimeReportLeaveAndTrainingQuery(baseOptions: ApolloReact.QueryHookOptions<AdminTimeReportLeaveAndTrainingQuery, AdminTimeReportLeaveAndTrainingQueryVariables> & ({ variables: AdminTimeReportLeaveAndTrainingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTimeReportLeaveAndTrainingDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminTimeReportLeaveAndTrainingQuery, AdminTimeReportLeaveAndTrainingQueryVariables>(AdminTimeReportLeaveAndTrainingDocument, parser(options)));
      }
export function useAdminTimeReportLeaveAndTrainingLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminTimeReportLeaveAndTrainingQuery, AdminTimeReportLeaveAndTrainingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminTimeReportLeaveAndTrainingDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminTimeReportLeaveAndTrainingQuery, AdminTimeReportLeaveAndTrainingQueryVariables>(AdminTimeReportLeaveAndTrainingDocument, options));
        }

export type AdminTimeReportLeaveAndTrainingQueryResult = ApolloReact.QueryResult<AdminTimeReportLeaveAndTrainingQuery, AdminTimeReportLeaveAndTrainingQueryVariables>;
export function refetchAdminTimeReportLeaveAndTrainingQuery(variables: AdminTimeReportLeaveAndTrainingQueryVariables) {
      return { query: AdminTimeReportLeaveAndTrainingDocument, variables: variables }
    }
export const AdminTimeReportOnCallDetailsModalDocument = /*#__PURE__*/ gql`
    query Admin_TimeReportOnCallDetailsModal {
  onCallMultipliers {
    ...NfsError
    ... on OnCallMultipliers {
      weekdays {
        day {
          saturday
          sunday
        }
        night {
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          sunday
        }
      }
      holidays {
        beforeHolidayNight
        holidayDay
        holidayNight
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useAdminTimeReportOnCallDetailsModalQuery__
 *
 * To run a query within a React component, call `useAdminTimeReportOnCallDetailsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTimeReportOnCallDetailsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTimeReportOnCallDetailsModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminTimeReportOnCallDetailsModalQuery(baseOptions?: ApolloReact.QueryHookOptions<AdminTimeReportOnCallDetailsModalQuery, AdminTimeReportOnCallDetailsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTimeReportOnCallDetailsModalDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminTimeReportOnCallDetailsModalQuery, AdminTimeReportOnCallDetailsModalQueryVariables>(AdminTimeReportOnCallDetailsModalDocument, parser(options)));
      }
export function useAdminTimeReportOnCallDetailsModalLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminTimeReportOnCallDetailsModalQuery, AdminTimeReportOnCallDetailsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminTimeReportOnCallDetailsModalDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminTimeReportOnCallDetailsModalQuery, AdminTimeReportOnCallDetailsModalQueryVariables>(AdminTimeReportOnCallDetailsModalDocument, options));
        }

export type AdminTimeReportOnCallDetailsModalQueryResult = ApolloReact.QueryResult<AdminTimeReportOnCallDetailsModalQuery, AdminTimeReportOnCallDetailsModalQueryVariables>;
export function refetchAdminTimeReportOnCallDetailsModalQuery(variables?: AdminTimeReportOnCallDetailsModalQueryVariables) {
      return { query: AdminTimeReportOnCallDetailsModalDocument, variables: variables }
    }
export const AdminTimeReportStatsDocument = /*#__PURE__*/ gql`
    query Admin_TimeReportStats($from: LocalDate!, $to: LocalDate!, $year: Year!, $contractId: ContractId!, $hasAnnualLeave: Boolean!) {
  annualLeaveSummary(contractId: $contractId, year: $year) @include(if: $hasAnnualLeave) {
    ...NfsError
    ... on AnnualLeaveSummary {
      yearlySummary {
        key
        value {
          year
          totalBalance {
            ...AnnualLeaveBalance
          }
        }
      }
    }
  }
  timeReport(from: $from, to: $to, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      timeReportStats {
        ... on EmploymentTimeReportStats {
          ...TimeReportStats_EmploymentStats
        }
        ... on B2BTimeReportStats {
          ...TimeReportStats_B2BStats
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AnnualLeaveBalanceFragmentDoc}
${TimeReportStatsEmploymentStatsFragmentDoc}
${TimeReportStatsB2BStatsFragmentDoc}`;

/**
 * __useAdminTimeReportStatsQuery__
 *
 * To run a query within a React component, call `useAdminTimeReportStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTimeReportStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTimeReportStatsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      year: // value for 'year'
 *      contractId: // value for 'contractId'
 *      hasAnnualLeave: // value for 'hasAnnualLeave'
 *   },
 * });
 */
export function useAdminTimeReportStatsQuery(baseOptions: ApolloReact.QueryHookOptions<AdminTimeReportStatsQuery, AdminTimeReportStatsQueryVariables> & ({ variables: AdminTimeReportStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminTimeReportStatsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminTimeReportStatsQuery, AdminTimeReportStatsQueryVariables>(AdminTimeReportStatsDocument, parser(options)));
      }
export function useAdminTimeReportStatsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminTimeReportStatsQuery, AdminTimeReportStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminTimeReportStatsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminTimeReportStatsQuery, AdminTimeReportStatsQueryVariables>(AdminTimeReportStatsDocument, options));
        }

export type AdminTimeReportStatsQueryResult = ApolloReact.QueryResult<AdminTimeReportStatsQuery, AdminTimeReportStatsQueryVariables>;
export function refetchAdminTimeReportStatsQuery(variables: AdminTimeReportStatsQueryVariables) {
      return { query: AdminTimeReportStatsDocument, variables: variables }
    }
export const TimeReportWorkTimeInsightsDocument = /*#__PURE__*/ gql`
    query TimeReport_WorkTimeInsights($from: LocalDate!, $to: LocalDate!, $contractId: ContractId!) {
  timeReport(from: $from, to: $to, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      timeReportRecords {
        work {
          id
          duration
          remoteWork
          overtime
          workTag {
            id
            name
          }
          project {
            id
            name
          }
        }
        onCall {
          id
        }
      }
      timeReportStats {
        currentTimeBalance {
          currentTimeRequirement
          balance
          reportedStandardWorkTime
          absenceTime
        }
        ... on EmploymentTimeReportStats {
          ...TimeReportStats_EmploymentStats
        }
        ... on B2BTimeReportStats {
          ...TimeReportStats_B2BStats
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${TimeReportStatsEmploymentStatsFragmentDoc}
${TimeReportStatsB2BStatsFragmentDoc}`;

/**
 * __useTimeReportWorkTimeInsightsQuery__
 *
 * To run a query within a React component, call `useTimeReportWorkTimeInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportWorkTimeInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportWorkTimeInsightsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useTimeReportWorkTimeInsightsQuery(baseOptions: ApolloReact.QueryHookOptions<TimeReportWorkTimeInsightsQuery, TimeReportWorkTimeInsightsQueryVariables> & ({ variables: TimeReportWorkTimeInsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportWorkTimeInsightsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TimeReportWorkTimeInsightsQuery, TimeReportWorkTimeInsightsQueryVariables>(TimeReportWorkTimeInsightsDocument, parser(options)));
      }
export function useTimeReportWorkTimeInsightsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TimeReportWorkTimeInsightsQuery, TimeReportWorkTimeInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TimeReportWorkTimeInsightsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TimeReportWorkTimeInsightsQuery, TimeReportWorkTimeInsightsQueryVariables>(TimeReportWorkTimeInsightsDocument, options));
        }

export type TimeReportWorkTimeInsightsQueryResult = ApolloReact.QueryResult<TimeReportWorkTimeInsightsQuery, TimeReportWorkTimeInsightsQueryVariables>;
export function refetchTimeReportWorkTimeInsightsQuery(variables: TimeReportWorkTimeInsightsQueryVariables) {
      return { query: TimeReportWorkTimeInsightsDocument, variables: variables }
    }
export const AdminPreviousMonthSalaryStateDocument = /*#__PURE__*/ gql`
    query Admin_PreviousMonthSalaryState($contractId: ContractId!, $date: YearMonth!) {
  contractSalaryDetails(contractId: $contractId, date: $date) {
    ...NfsError
    ... on ContractSalaryDetailsResponse {
      value {
        contractId
        yearMonth
        salaryState {
          __typename
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useAdminPreviousMonthSalaryStateQuery__
 *
 * To run a query within a React component, call `useAdminPreviousMonthSalaryStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPreviousMonthSalaryStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPreviousMonthSalaryStateQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAdminPreviousMonthSalaryStateQuery(baseOptions: ApolloReact.QueryHookOptions<AdminPreviousMonthSalaryStateQuery, AdminPreviousMonthSalaryStateQueryVariables> & ({ variables: AdminPreviousMonthSalaryStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AdminPreviousMonthSalaryStateDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AdminPreviousMonthSalaryStateQuery, AdminPreviousMonthSalaryStateQueryVariables>(AdminPreviousMonthSalaryStateDocument, parser(options)));
      }
export function useAdminPreviousMonthSalaryStateLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AdminPreviousMonthSalaryStateQuery, AdminPreviousMonthSalaryStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AdminPreviousMonthSalaryStateDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AdminPreviousMonthSalaryStateQuery, AdminPreviousMonthSalaryStateQueryVariables>(AdminPreviousMonthSalaryStateDocument, options));
        }

export type AdminPreviousMonthSalaryStateQueryResult = ApolloReact.QueryResult<AdminPreviousMonthSalaryStateQuery, AdminPreviousMonthSalaryStateQueryVariables>;
export function refetchAdminPreviousMonthSalaryStateQuery(variables: AdminPreviousMonthSalaryStateQueryVariables) {
      return { query: AdminPreviousMonthSalaryStateDocument, variables: variables }
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AbsenceRecordId: { input: string; output: string; }
  ActivityId: { input: string; output: string; }
  AdminId: { input: string; output: string; }
  AlternativeBenefitsGroupId: { input: string; output: string; }
  AssignedVariantId: { input: string; output: string; }
  BankTransferId: { input: string; output: string; }
  /** 1/100 of a Percent; e.g. 2300 BasisPoint is 23% */
  BasisPoint: { input: number; output: number; }
  BenefitId: { input: string; output: string; }
  BenefitVariantId: { input: string; output: string; }
  BenefitVariantProductId: { input: string; output: string; }
  Bic: { input: string; output: string; }
  BigDecimal: { input: number; output: number; }
  BonusId: { input: string; output: string; }
  Cents: { input: number; output: number; }
  CertificateId: { input: string; output: string; }
  ClientContractId: { input: string; output: string; }
  ClientPositionId: { input: string; output: string; }
  CompanyId: { input: string; output: string; }
  ContractId: { input: string; output: string; }
  /** Country code consisting of 2 uppercase letters; e.g. PL/US/UK */
  CountryCode: { input: string; output: string; }
  /** Currency code consisting of 3 uppercase letters; e.g. PLN/USD/EUR */
  Currency: { input: string; output: string; }
  Cursor: { input: string; output: string; }
  /** ISO-8601 date format interpreted as midnight at the timezone that is configured as local for the system. */
  Date: { input: Date; output: Date; }
  Days: { input: number; output: number; }
  DeskAssignmentId: { input: string; output: string; }
  DeskId: { input: string; output: string; }
  EmailAddress: { input: string; output: string; }
  EntityVersion: { input: number; output: number; }
  ExternalBeneficiaryId: { input: string; output: string; }
  Hours: { input: any; output: any; }
  InvoiceDetailsId: { input: string; output: string; }
  InvoiceNumber: { input: string; output: string; }
  /** A date without a time-zone in the ISO-8601 calendar system using the format 1970-01-01 */
  LocalDate: { input: Date; output: Date; }
  /** A time without a time-zone in the ISO-8601 calendar system using the format 00:00:00 */
  LocalTime: { input: Date; output: Date; }
  Minutes: { input: number; output: number; }
  NfsErrorId: { input: string; output: string; }
  OfficeId: { input: string; output: string; }
  OfficeReservationId: { input: string; output: string; }
  /** A date-time with an offset from UTC/Greenwich in the ISO-8601 calendar system using the format 1970-01-01T00:00:00Z */
  OffsetDateTime: { input: Date; output: Date; }
  OnCallRecordId: { input: string; output: string; }
  PESEL: { input: string; output: string; }
  ParkingSpotId: { input: string; output: string; }
  /** A percentage; e.g. 45 is 45% */
  Percentage: { input: number; output: number; }
  PhoneNumber: { input: string; output: string; }
  ProgressionSchemeId: { input: string; output: string; }
  ProjectId: { input: string; output: string; }
  REGON: { input: string; output: string; }
  RegisterId: { input: string; output: string; }
  ReportingPeriodId: { input: string; output: string; }
  ReservationRequestId: { input: string; output: string; }
  RevenueAdministrationOfficeId: { input: number; output: number; }
  RoomId: { input: string; output: string; }
  SalesInvoiceId: { input: number; output: number; }
  SpaceId: { input: string; output: string; }
  TaxNumber: { input: string; output: string; }
  TaxResidencyCertificateId: { input: string; output: string; }
  URI: { input: string; output: string; }
  Unit: { input: Record<never, never>; output: Record<never, never>; }
  Upload: { input: FileList[number]; output: FileList[number]; }
  UserId: { input: string; output: string; }
  /** "VatNotApplicable" | "ExemptFromVAT" | 800 | 2300 | <<basis point>> */
  VatTypeInput: { input: "VatNotApplicable" | "ExemptFromVAT" | number; output: "VatNotApplicable" | "ExemptFromVAT" | number; }
  WorkDays: { input: number; output: number; }
  WorkHours: { input: number; output: number; }
  WorkRecordId: { input: string; output: string; }
  WorkTagId: { input: string; output: string; }
  WorkTransferProtocolId: { input: string; output: string; }
  Year: { input: number; output: number; }
  /** ISO-8601 date with only year and month */
  YearMonth: { input: Date; output: Date; }
};

export type AbsenceRecord = {
  readonly __typename?: 'AbsenceRecord';
  readonly absenceType: AbsenceType;
  readonly approval: Approval;
  readonly attachment: OptionalDownloadableExternallyHostedFileUrlOrUnauthorized;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly contract: Contract;
  readonly contractId: Scalars['ContractId']['output'];
  readonly customDurationPerDay?: Maybe<Scalars['Minutes']['output']>;
  readonly from: Scalars['LocalDate']['output'];
  readonly id: Scalars['AbsenceRecordId']['output'];
  readonly isOnDemand?: Maybe<Scalars['Boolean']['output']>;
  readonly to: Scalars['LocalDate']['output'];
  readonly user: User;
  readonly userId: Scalars['UserId']['output'];
};

export type AbsenceRecordApi = {
  readonly __typename?: 'AbsenceRecordApi';
  /** @allowedIfAnyOf(roles: [FinancialTeam, Lead, SpaceDirector]) */
  readonly approve: AbsenceRecordOrNfsError;
  readonly create: AbsenceRecordOrNfsError;
  readonly createMany: ListOfAbsenceRecordResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, Lead, SpaceDirector]) */
  readonly reject: UnitResponseOrNfsError;
  readonly update: AbsenceRecordOrNfsError;
};


export type AbsenceRecordApiApproveArgs = {
  id: Scalars['AbsenceRecordId']['input'];
};


export type AbsenceRecordApiCreateArgs = {
  absenceRecord: CreateAbsenceRecordInput;
  attachment?: InputMaybe<Scalars['Upload']['input']>;
};


export type AbsenceRecordApiCreateManyArgs = {
  value: ReadonlyArray<CreateAbsenceRecordInput>;
};


export type AbsenceRecordApiRejectArgs = {
  id: Scalars['AbsenceRecordId']['input'];
};


export type AbsenceRecordApiUpdateArgs = {
  absenceType?: InputMaybe<AbsenceTypeInput>;
  attachment?: InputMaybe<ClearableUploadInput>;
  comment?: InputMaybe<ClearableStringInput>;
  customDurationPerDay?: InputMaybe<ClearableMinutesInput>;
  dateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  dateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  id: Scalars['AbsenceRecordId']['input'];
  isOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AbsenceRecordOrNfsError = AbsenceRecord | NfsError;

export const AbsenceType = {
  ANNUALLEAVE: 'AnnualLeave',
  CAREGIVINGLEAVE: 'CaregivingLeave',
  CHILDCARELEAVE: 'ChildCareLeave',
  DUETOFORCEMAJEURELEAVE: 'DueToForceMajeureLeave',
  FLEXTIMELEAVE: 'FlextimeLeave',
  MATERNITYLEAVE: 'MaternityLeave',
  OUTOFOFFICE: 'OutOfOffice',
  PAIDLEAVE: 'PaidLeave',
  PARENTALLEAVE: 'ParentalLeave',
  PATERNITYLEAVE: 'PaternityLeave',
  SICKFAMILYMEMBERCARELEAVE: 'SickFamilyMemberCareLeave',
  SICKLEAVE: 'SickLeave',
  SPECIALLEAVE: 'SpecialLeave',
  UNPAIDLEAVE: 'UnpaidLeave'
} as const;

export type AbsenceType = typeof AbsenceType[keyof typeof AbsenceType];
export type AbsenceTypeDetails = {
  readonly __typename?: 'AbsenceTypeDetails';
  readonly applicableFor: ReadonlyArray<ContractType>;
  readonly canBeReportedOnHoliday: Scalars['Boolean']['output'];
  readonly canTakeCustomNumberOfHours: Scalars['Boolean']['output'];
  readonly limit?: Maybe<Scalars['WorkDays']['output']>;
};

export const AbsenceTypeInput = {
  ANNUALLEAVE: 'AnnualLeave',
  CAREGIVINGLEAVE: 'CaregivingLeave',
  CHILDCARELEAVE: 'ChildCareLeave',
  DUETOFORCEMAJEURELEAVE: 'DueToForceMajeureLeave',
  FLEXTIMELEAVE: 'FlextimeLeave',
  MATERNITYLEAVE: 'MaternityLeave',
  OUTOFOFFICE: 'OutOfOffice',
  PAIDLEAVE: 'PaidLeave',
  PARENTALLEAVE: 'ParentalLeave',
  PATERNITYLEAVE: 'PaternityLeave',
  SICKFAMILYMEMBERCARELEAVE: 'SickFamilyMemberCareLeave',
  SICKLEAVE: 'SickLeave',
  SPECIALLEAVE: 'SpecialLeave',
  UNPAIDLEAVE: 'UnpaidLeave'
} as const;

export type AbsenceTypeInput = typeof AbsenceTypeInput[keyof typeof AbsenceTypeInput];
export type AbstractDrawer = {
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type AccessGrantedBankAccount = {
  readonly __typename?: 'AccessGranted__BankAccount';
  readonly value: BankAccount;
};

export type AccessGrantedBonuses = {
  readonly __typename?: 'AccessGranted__Bonuses';
  readonly value: Bonuses;
};

export type AccessGrantedBoolean = {
  readonly __typename?: 'AccessGranted__Boolean';
  readonly value: Scalars['Boolean']['output'];
};

export type AccessGrantedClientContract = {
  readonly __typename?: 'AccessGranted__ClientContract';
  readonly value: ClientContract;
};

export type AccessGrantedClientPosition = {
  readonly __typename?: 'AccessGranted__ClientPosition';
  readonly value: ClientPosition;
};

export type AccessGrantedCompany = {
  readonly __typename?: 'AccessGranted__Company';
  readonly value: Company;
};

export type AccessGrantedListOfAssignedVariant = {
  readonly __typename?: 'AccessGranted__ListOfAssignedVariant';
  readonly value: ReadonlyArray<AssignedVariant>;
};

export type AccessGrantedListOfCertificate = {
  readonly __typename?: 'AccessGranted__ListOfCertificate';
  readonly value: ReadonlyArray<Certificate>;
};

export type AccessGrantedListOfClientContract = {
  readonly __typename?: 'AccessGranted__ListOfClientContract';
  readonly value: ReadonlyArray<ClientContract>;
};

export type AccessGrantedListOfClientPosition = {
  readonly __typename?: 'AccessGranted__ListOfClientPosition';
  readonly value: ReadonlyArray<ClientPosition>;
};

export type AccessGrantedListOfContract = {
  readonly __typename?: 'AccessGranted__ListOfContract';
  readonly value: ReadonlyArray<Contract>;
};

export type AccessGrantedListOfCostAndRevenueItem = {
  readonly __typename?: 'AccessGranted__ListOfCostAndRevenueItem';
  readonly value: ReadonlyArray<CostAndRevenueItem>;
};

export type AccessGrantedListOfExternalBeneficiary = {
  readonly __typename?: 'AccessGranted__ListOfExternalBeneficiary';
  readonly value: ReadonlyArray<ExternalBeneficiary>;
};

export type AccessGrantedListOfIncomeDetails = {
  readonly __typename?: 'AccessGranted__ListOfIncomeDetails';
  readonly value: ReadonlyArray<IncomeDetails>;
};

export type AccessGrantedListOfProjectAssignment = {
  readonly __typename?: 'AccessGranted__ListOfProjectAssignment';
  readonly value: ReadonlyArray<ProjectAssignment>;
};

export type AccessGrantedListOfSocialMediaHandle = {
  readonly __typename?: 'AccessGranted__ListOfSocialMediaHandle';
  readonly value: ReadonlyArray<SocialMediaHandle>;
};

export type AccessGrantedListOfString = {
  readonly __typename?: 'AccessGranted__ListOfString';
  readonly value: ReadonlyArray<Scalars['String']['output']>;
};

export type AccessGrantedListOfTaxResidencyCertificate = {
  readonly __typename?: 'AccessGranted__ListOfTaxResidencyCertificate';
  readonly value: ReadonlyArray<TaxResidencyCertificate>;
};

export type AccessGrantedListOfWorkTransferProtocol = {
  readonly __typename?: 'AccessGranted__ListOfWorkTransferProtocol';
  readonly value: ReadonlyArray<WorkTransferProtocol>;
};

export type AccessGrantedLocalDate = {
  readonly __typename?: 'AccessGranted__LocalDate';
  readonly value: Scalars['LocalDate']['output'];
};

export type AccessGrantedOptionalAddress = {
  readonly __typename?: 'AccessGranted__OptionalAddress';
  readonly value?: Maybe<Address>;
};

export type AccessGrantedOptionalAnnualLeaveEntitlement = {
  readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement';
  readonly value?: Maybe<AnnualLeaveEntitlement>;
};

export type AccessGrantedOptionalBankAccount = {
  readonly __typename?: 'AccessGranted__OptionalBankAccount';
  readonly value?: Maybe<BankAccount>;
};

export type AccessGrantedOptionalClientPosition = {
  readonly __typename?: 'AccessGranted__OptionalClientPosition';
  readonly value?: Maybe<ClientPosition>;
};

export type AccessGrantedOptionalContractDraft = {
  readonly __typename?: 'AccessGranted__OptionalContractDraft';
  readonly value?: Maybe<ContractDraft>;
};

export type AccessGrantedOptionalCountryCode = {
  readonly __typename?: 'AccessGranted__OptionalCountryCode';
  readonly value?: Maybe<Scalars['CountryCode']['output']>;
};

export type AccessGrantedOptionalCrossSell = {
  readonly __typename?: 'AccessGranted__OptionalCrossSell';
  readonly value?: Maybe<CrossSell>;
};

export type AccessGrantedOptionalDownloadableExternallyHostedFileUrl = {
  readonly __typename?: 'AccessGranted__OptionalDownloadableExternallyHostedFileUrl';
  readonly value?: Maybe<DownloadableExternallyHostedFileUrl>;
};

export type AccessGrantedOptionalEmailAddress = {
  readonly __typename?: 'AccessGranted__OptionalEmailAddress';
  readonly value?: Maybe<Scalars['EmailAddress']['output']>;
};

export type AccessGrantedOptionalIdType = {
  readonly __typename?: 'AccessGranted__OptionalIDType';
  readonly value?: Maybe<IdType>;
};

export type AccessGrantedOptionalLocalDate = {
  readonly __typename?: 'AccessGranted__OptionalLocalDate';
  readonly value?: Maybe<Scalars['LocalDate']['output']>;
};

export type AccessGrantedOptionalOffsetDateTime = {
  readonly __typename?: 'AccessGranted__OptionalOffsetDateTime';
  readonly value?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type AccessGrantedOptionalPesel = {
  readonly __typename?: 'AccessGranted__OptionalPESEL';
  readonly value?: Maybe<Scalars['PESEL']['output']>;
};

export type AccessGrantedOptionalPhoneNumber = {
  readonly __typename?: 'AccessGranted__OptionalPhoneNumber';
  readonly value?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type AccessGrantedOptionalRevenueAdministrationOffice = {
  readonly __typename?: 'AccessGranted__OptionalRevenueAdministrationOffice';
  readonly value?: Maybe<RevenueAdministrationOffice>;
};

export type AccessGrantedOptionalString = {
  readonly __typename?: 'AccessGranted__OptionalString';
  readonly value?: Maybe<Scalars['String']['output']>;
};

export type AccessGrantedOptionalUri = {
  readonly __typename?: 'AccessGranted__OptionalURI';
  readonly value?: Maybe<Scalars['URI']['output']>;
};

export type AccessGrantedPersonalDataProcessingAuthorization = {
  readonly __typename?: 'AccessGranted__PersonalDataProcessingAuthorization';
  readonly value: PersonalDataProcessingAuthorization;
};

export type AccessGrantedString = {
  readonly __typename?: 'AccessGranted__String';
  readonly value: Scalars['String']['output'];
};

export type AccessGrantedTimeBasedBoolean = {
  readonly __typename?: 'AccessGranted__TimeBasedBoolean';
  readonly value: TimeBasedBoolean;
};

export type AccessGrantedTimeBasedCurrency = {
  readonly __typename?: 'AccessGranted__TimeBasedCurrency';
  readonly value: TimeBasedCurrency;
};

export type AccessGrantedTimeBasedOptClearableBasisPoint = {
  readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint';
  readonly value: TimeBasedOptClearableBasisPoint;
};

export type AccessGrantedTimeBasedOptClearableDays = {
  readonly __typename?: 'AccessGranted__TimeBasedOptClearableDays';
  readonly value: TimeBasedOptClearableDays;
};

export type AccessGrantedTimeBasedOptClearableDeductibleCostsType = {
  readonly __typename?: 'AccessGranted__TimeBasedOptClearableDeductibleCostsType';
  readonly value: TimeBasedOptClearableDeductibleCostsType;
};

export type AccessGrantedTimeBasedOptClearableNetGross = {
  readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross';
  readonly value: TimeBasedOptClearableNetGross;
};

export type AccessGrantedTimeBasedOptClearableOnCallRate = {
  readonly __typename?: 'AccessGranted__TimeBasedOptClearableOnCallRate';
  readonly value: TimeBasedOptClearableOnCallRate;
};

export type AccessGrantedTimeBasedOptClearableProgressionScheme = {
  readonly __typename?: 'AccessGranted__TimeBasedOptClearableProgressionScheme';
  readonly value: TimeBasedOptClearableProgressionScheme;
};

export type AccessGrantedTimeBasedOptCurrency = {
  readonly __typename?: 'AccessGranted__TimeBasedOptCurrency';
  readonly value: TimeBasedOptCurrency;
};

export type AccessGrantedTimeBasedRate = {
  readonly __typename?: 'AccessGranted__TimeBasedRate';
  readonly value: TimeBasedRate;
};

export type AccessGrantedTimeBasedString = {
  readonly __typename?: 'AccessGranted__TimeBasedString';
  readonly value: TimeBasedString;
};

export type AccessGrantedTimeBasedVatType = {
  readonly __typename?: 'AccessGranted__TimeBasedVatType';
  readonly value: TimeBasedVatType;
};

export type AccessGrantedTimeBasedWorkingTime = {
  readonly __typename?: 'AccessGranted__TimeBasedWorkingTime';
  readonly value: TimeBasedWorkingTime;
};

export type AccessGrantedTimeReports = {
  readonly __typename?: 'AccessGranted__TimeReports';
  readonly value: TimeReports;
};

export type AccountingData = {
  readonly __typename?: 'AccountingData';
  readonly maternityLeaveAllowance?: Maybe<Scalars['Cents']['output']>;
  readonly overtimePayout?: Maybe<Scalars['Cents']['output']>;
  readonly paternityLeaveAllowance?: Maybe<Scalars['Cents']['output']>;
  readonly ppkAmount?: Maybe<Scalars['Cents']['output']>;
  readonly ppkDetails?: Maybe<PpkDetails>;
  readonly sicknessBenefit?: Maybe<Scalars['Cents']['output']>;
  readonly taxPrepayment: Scalars['Cents']['output'];
  readonly taxRefund?: Maybe<Scalars['Cents']['output']>;
  readonly transferAmount: Scalars['Cents']['output'];
  readonly zusContribution: Scalars['Cents']['output'];
  readonly zusContributionDetails?: Maybe<ZusContributionDetails>;
};

export type AccountingDataInput = {
  readonly maternityLeaveAllowance?: InputMaybe<Scalars['Cents']['input']>;
  readonly overtimePayout?: InputMaybe<Scalars['Cents']['input']>;
  readonly paternityLeaveAllowance?: InputMaybe<Scalars['Cents']['input']>;
  readonly ppkDetails?: InputMaybe<PpkDetailsInput>;
  readonly sicknessBenefit?: InputMaybe<Scalars['Cents']['input']>;
  readonly taxPrepayment: Scalars['Cents']['input'];
  readonly taxRefund?: InputMaybe<Scalars['Cents']['input']>;
  readonly transferAmount: Scalars['Cents']['input'];
  readonly zusContributionDetails: ZusContributionDetailsInput;
};

export type AccountingDataMissing = {
  readonly __typename?: 'AccountingDataMissing';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type ActiveReportingRangeError = UserError & {
  readonly __typename?: 'ActiveReportingRangeError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type AddClientContractDrawer = AbstractDrawer & {
  readonly __typename?: 'AddClientContractDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly companyId?: Maybe<Scalars['CompanyId']['output']>;
  readonly companyType?: Maybe<ReadonlyArray<CompanyType>>;
  readonly id: Scalars['ID']['output'];
  readonly prefillAs?: Maybe<AddClientContractDrawerPrefillAs>;
  readonly visible: Scalars['Boolean']['output'];
};

export const AddClientContractDrawerPrefillAs = {
  CLIENT: 'CLIENT',
  SUPPLIER: 'SUPPLIER'
} as const;

export type AddClientContractDrawerPrefillAs = typeof AddClientContractDrawerPrefillAs[keyof typeof AddClientContractDrawerPrefillAs];
export type AddCompanyDrawer = AbstractDrawer & {
  readonly __typename?: 'AddCompanyDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly initialData?: Maybe<AddCompanyDrawerInitialData>;
  readonly returnData?: Maybe<AddCompanyDrawerReturnData>;
  readonly visible: Scalars['Boolean']['output'];
};

export type AddCompanyDrawerInitialData = {
  readonly __typename?: 'AddCompanyDrawerInitialData';
  readonly companyType?: Maybe<CompanyType>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly taxNumber?: Maybe<Scalars['String']['output']>;
};

export type AddCompanyDrawerReturnData = {
  readonly __typename?: 'AddCompanyDrawerReturnData';
  readonly id: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly taxNumber?: Maybe<Scalars['String']['output']>;
};

export type AddInternalProjectDrawer = AbstractDrawer & {
  readonly __typename?: 'AddInternalProjectDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly projectId?: Maybe<Scalars['ProjectId']['output']>;
  readonly visible: Scalars['Boolean']['output'];
};

export type AddOfficeDrawer = AbstractDrawer & {
  readonly __typename?: 'AddOfficeDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type AddPersonDrawer = AbstractDrawer & {
  readonly __typename?: 'AddPersonDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly newUserId?: Maybe<Scalars['UserId']['output']>;
  readonly visible: Scalars['Boolean']['output'];
};

export type AddProgressionSchemeDrawer = AbstractDrawer & {
  readonly __typename?: 'AddProgressionSchemeDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type AddProjectDrawer = AbstractDrawer & {
  readonly __typename?: 'AddProjectDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly prefillClientContractId?: Maybe<Scalars['ClientContractId']['output']>;
  readonly prefillClientId?: Maybe<Scalars['CompanyId']['output']>;
  readonly projectId?: Maybe<Scalars['ProjectId']['output']>;
  readonly visible: Scalars['Boolean']['output'];
};

export type AddSpaceDrawer = AbstractDrawer & {
  readonly __typename?: 'AddSpaceDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type AddThirdPersonDrawer = AbstractDrawer & {
  readonly __typename?: 'AddThirdPersonDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly thirdPersonId?: Maybe<Scalars['ExternalBeneficiaryId']['output']>;
  readonly visible: Scalars['Boolean']['output'];
};

export type AdditionalCostsDrawer = AbstractDrawer & {
  readonly __typename?: 'AdditionalCostsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export const AdditionalPeopleNumber = {
  FOUR: 'Four',
  MORE: 'More',
  ONE: 'One',
  THREE: 'Three',
  TWO: 'Two'
} as const;

export type AdditionalPeopleNumber = typeof AdditionalPeopleNumber[keyof typeof AdditionalPeopleNumber];
export type Address = {
  readonly __typename?: 'Address';
  readonly city: Scalars['String']['output'];
  readonly country: Scalars['CountryCode']['output'];
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  readonly region?: Maybe<Scalars['String']['output']>;
  /** format `street_name building_number[/flat_number]` where street_name = city if street_name empty */
  readonly streetLine: Scalars['String']['output'];
};

export type AddressInput = {
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['CountryCode']['input'];
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  readonly region?: InputMaybe<Scalars['String']['input']>;
  /** format `street_name building_number[/flat_number]` where street_name = city if street_name empty */
  readonly streetLine: Scalars['String']['input'];
};

export type Admin = {
  readonly __typename?: 'Admin';
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['AdminId']['output'];
  readonly lastName: Scalars['String']['output'];
};

export type AdminOrNfsError = Admin | NfsError;

export type AggregatedValidationErrors = UserError & {
  readonly __typename?: 'AggregatedValidationErrors';
  readonly errors: ReadonlyArray<ValidationError>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type AllBonusesDrawer = AbstractDrawer & {
  readonly __typename?: 'AllBonusesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

/** only single benefit from the group can be chosen */
export type AlternativeBenefits = {
  readonly __typename?: 'AlternativeBenefits';
  readonly alternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['output'];
  readonly oneOf: ReadonlyArray<Benefit>;
};

/** only single sub-benefit from the group can be chosen */
export type AlternativeSubBenefits = {
  readonly __typename?: 'AlternativeSubBenefits';
  readonly alternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['output'];
  readonly oneOf: ReadonlyArray<SubBenefit>;
};

export type AnnualLeaveBalance = {
  readonly __typename?: 'AnnualLeaveBalance';
  readonly available: AnnualLeaveEntitlementValue;
  readonly entitlement: AnnualLeaveEntitlementValue;
  readonly used: AnnualLeaveEntitlementValue;
};

export type AnnualLeaveEntitlement = {
  readonly __typename?: 'AnnualLeaveEntitlement';
  readonly history: ReadonlyArray<AnnualLeaveEntitlementPeriod>;
  readonly withCarryOverToNextYear: Scalars['Boolean']['output'];
};

export type AnnualLeaveEntitlementDrawer = AbstractDrawer & {
  readonly __typename?: 'AnnualLeaveEntitlementDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
  readonly year: Scalars['Date']['output'];
};

export type AnnualLeaveEntitlementInput = {
  readonly history: ReadonlyArray<AnnualLeaveEntitlementPeriodInput>;
  readonly withCarryOverToNextYear: Scalars['Boolean']['input'];
};

export type AnnualLeaveEntitlementPeriod = {
  readonly __typename?: 'AnnualLeaveEntitlementPeriod';
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly dateRange: LocalDateRange;
  readonly entitlement: AnnualLeaveEntitlementValue;
  readonly entitlementExplanation: Scalars['String']['output'];
};

export type AnnualLeaveEntitlementPeriodInput = {
  readonly entitlement: AnnualLeaveEntitlementValueInput;
  readonly entitlementExplanation: Scalars['String']['input'];
  readonly from: Scalars['LocalDate']['input'];
  readonly to?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type AnnualLeaveEntitlementValue = {
  readonly __typename?: 'AnnualLeaveEntitlementValue';
  readonly days: Scalars['Days']['output'];
  readonly minutes: Scalars['Minutes']['output'];
};

export type AnnualLeaveEntitlementValueInput = {
  readonly days: Scalars['Days']['input'];
  readonly minutes: Scalars['Minutes']['input'];
};

export type AnnualLeavePreferencesDrawer = AbstractDrawer & {
  readonly __typename?: 'AnnualLeavePreferencesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type AnnualLeaveSummary = {
  readonly __typename?: 'AnnualLeaveSummary';
  readonly yearlySummary: ReadonlyArray<KvYearAnnualLeaveYearSummary>;
};

export type AnnualLeaveSummaryDrawer = AbstractDrawer & {
  readonly __typename?: 'AnnualLeaveSummaryDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
  readonly year: Scalars['Date']['output'];
};

export type AnnualLeaveSummaryOrNfsError = AnnualLeaveSummary | NfsError;

export type AnnualLeaveYearSummary = {
  readonly __typename?: 'AnnualLeaveYearSummary';
  readonly balanceThisYear: AnnualLeaveBalance;
  readonly carriedOverEntitlementBalance?: Maybe<AnnualLeaveBalance>;
  readonly onDemandBalance: AnnualLeaveBalance;
  readonly totalBalance: AnnualLeaveBalance;
  readonly year: Scalars['Year']['output'];
};

export type ApiToken = {
  readonly __typename?: 'ApiToken';
  readonly claims: ReadonlyArray<Scalars['String']['output']>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly lastUsedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly name: Scalars['String']['output'];
  readonly ticketUrl?: Maybe<Scalars['String']['output']>;
  readonly validUntil: Scalars['OffsetDateTime']['output'];
};

export type ApplyRaiseResult = {
  readonly __typename?: 'ApplyRaiseResult';
  readonly contractId: Scalars['ContractId']['output'];
  readonly effectiveFrom: Scalars['LocalDate']['output'];
  readonly newHourlyRate: Scalars['Cents']['output'];
};

export type ApplyRaiseResultOrNfsError = ApplyRaiseResult | NfsError;

export type AppreciationBonus = Bonus & {
  readonly __typename?: 'AppreciationBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type Approval = Approved | NotRequired | PendingApproval;

export type Approved = {
  readonly __typename?: 'Approved';
  readonly at: Scalars['OffsetDateTime']['output'];
  readonly by: Admin;
};

export type AssignBenefitDrawer = AbstractDrawer & {
  readonly __typename?: 'AssignBenefitDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly effectiveDate?: Maybe<Scalars['Date']['output']>;
  readonly highlight?: Maybe<TimeBasedHighlight>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredGroupType: BenefitGroupType;
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type AssignVariantInput = {
  readonly buyerType: BenefitBuyerType;
  readonly externalBeneficiaries: ReadonlyArray<Scalars['ExternalBeneficiaryId']['input']>;
  readonly id: Scalars['AssignedVariantId']['input'];
  readonly invoiceTo?: InputMaybe<Scalars['ExternalBeneficiaryId']['input']>;
  readonly variantId: Scalars['BenefitVariantId']['input'];
};

export type AssignedProject = {
  readonly __typename?: 'AssignedProject';
  readonly activeReportingRange?: Maybe<ClosedEndLocalDateRange>;
  readonly assignmentPeriods: ReadonlyArray<LocalDateRange>;
  readonly projectId: Scalars['ProjectId']['output'];
  readonly projectLead?: Maybe<Person>;
  readonly projectName: Scalars['String']['output'];
  readonly reportingPeriods: ReadonlyArray<ClosedEndLocalDateRange>;
};

export type AssignedVariant = {
  readonly __typename?: 'AssignedVariant';
  readonly active: TimeBasedBoolean;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly buyerType: TimeBasedBenefitBuyerType;
  readonly contract: Contract;
  readonly externalBeneficiaries: TimeBasedListOfExternalBeneficiary;
  readonly id: Scalars['AssignedVariantId']['output'];
  readonly invoiceTo: TimeBasedOptClearableExternalBeneficiary;
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly user: User;
  readonly variant: TimeBasedBenefitVariant;
};

export type AssignedVariantOrNfsError = AssignedVariant | NfsError;

export type B2BContract = Contract & {
  readonly __typename?: 'B2BContract';
  readonly assignedVariants: ListOfAssignedVariantOrUnauthorized;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly bonuses: BonusesOrUnauthorized;
  readonly conclusionDate: LocalDateOrUnauthorized;
  readonly conclusionDatePromiseeCompanySnapshot: CompanyOrUnauthorized;
  readonly conclusionDatePromiseeSnapshot: User;
  readonly conclusionDatePromisorSnapshot: Company;
  readonly conclusionLocation: StringOrUnauthorized;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly currency: TimeBasedCurrencyOrUnauthorized;
  /** We do not have related data (time reports etc.) before this date in the system */
  readonly dataInSystemSince: Scalars['LocalDate']['output'];
  readonly enableTrainingPackage: BooleanOrUnauthorized;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  /** It just an information. Should not be used for business logic as contract may be extended or terminated earlier */
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly fileUri: OptionalUriOrUnauthorized;
  readonly holidayCalendar: HolidayCalendar;
  readonly id: Scalars['ContractId']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes: OptionalStringOrUnauthorized;
  readonly onCall: TimeBasedOptClearableOnCallRateOrUnauthorized;
  readonly overtimeRate: TimeBasedOptClearableNetGrossOrUnauthorized;
  readonly position: TimeBasedOptClearableString;
  readonly progressionScheme: TimeBasedOptClearableProgressionSchemeOrUnauthorized;
  readonly promisee: User;
  readonly promiseeCompany: CompanyOrUnauthorized;
  readonly promiseeCompanyTransferBankAccount: OptionalBankAccountOrUnauthorized;
  readonly promiseeId: Scalars['UserId']['output'];
  readonly promisor: TimeBasedCompany;
  readonly promisorId: Scalars['CompanyId']['output'];
  readonly promisorRepresentative: StringOrUnauthorized;
  readonly promisorTransferBankAccount: PromisorTransferBankAccount;
  readonly rate: TimeBasedRateOrUnauthorized;
  readonly scopeOfWork: TimeBasedStringOrUnauthorized;
  readonly separatePaymentForBenefits: TimeBasedBooleanOrUnauthorized;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly status: ContractStatus;
  /** Non-empty value indicates actual (or effective) termination date */
  readonly terminationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly type: B2BContractType;
  readonly vat: TimeBasedVatTypeOrUnauthorized;
  readonly workingTime: TimeBasedWorkingTimeOrUnauthorized;
};


export type B2BContractAssignedVariantsArgs = {
  activeOnly: Scalars['Boolean']['input'];
};

export type B2BContractDraft = ContractDraft & {
  readonly __typename?: 'B2BContractDraft';
  readonly conclusionDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly conclusionLocation?: Maybe<Scalars['String']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly currency?: Maybe<Scalars['Currency']['output']>;
  readonly documentTemplate?: Maybe<ContractDocumentTemplate>;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly holidayCalendar?: Maybe<HolidayCalendar>;
  readonly id: Scalars['UserId']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly onCall?: Maybe<OnCallRate>;
  readonly overtimeRate?: Maybe<NetGross>;
  readonly position?: Maybe<Scalars['String']['output']>;
  readonly promisee: User;
  readonly promiseeCompany?: Maybe<Company>;
  readonly promiseeCompanyTransferBankAccount?: Maybe<BankAccount>;
  readonly promisor: Company;
  readonly promisorRepresentative?: Maybe<Scalars['String']['output']>;
  readonly promisorTransferBankAccount: PromisorTransferBankAccount;
  readonly rate?: Maybe<Rate>;
  readonly scopeOfWork?: Maybe<Scalars['String']['output']>;
  readonly separatePaymentForBenefits: Scalars['Boolean']['output'];
  readonly startDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly type: B2BContractType;
  readonly vat?: Maybe<VatType>;
};

export type B2BContractDraftDrawer = AbstractDrawer & {
  readonly __typename?: 'B2BContractDraftDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly editing: Scalars['Boolean']['output'];
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type B2BContractDraftOrNfsError = B2BContractDraft | NfsError;

export type B2BContractNoteDrawer = AbstractDrawer & {
  readonly __typename?: 'B2BContractNoteDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly contractId?: Maybe<Scalars['ContractId']['output']>;
  readonly editing: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly requiredPromiseeId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type B2BContractOrNfsError = B2BContract | NfsError;

export type B2BContractSalaryDetails = ContractSalaryDetails & {
  readonly __typename?: 'B2BContractSalaryDetails';
  readonly absenceDays: Scalars['Days']['output'];
  readonly adjustGrossValue?: Maybe<GrossAdjustment>;
  readonly contract: B2BContract;
  readonly contractId: Scalars['ContractId']['output'];
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly flag?: Maybe<ContractSalaryDetailsFlagColor>;
  readonly invoiceDetails: ReadonlyArray<InvoiceDetails>;
  readonly isBonusApprovalRequired: Scalars['Boolean']['output'];
  readonly isTimeReportApprovalRequired: Scalars['Boolean']['output'];
  readonly isTimeReportCompleted: Scalars['Boolean']['output'];
  readonly luminisServicesValue?: Maybe<NetGross>;
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly requiredWorkedTime: Scalars['Minutes']['output'];
  readonly salaryState: SalaryState;
  readonly shouldCheckIfBenefitInvoicePaymentIsRequired: Scalars['Boolean']['output'];
  readonly totalPayout?: Maybe<NetGross>;
  readonly transferAmount?: Maybe<Scalars['Cents']['output']>;
  readonly transferDeduction?: Maybe<TransferDeduction>;
  readonly transferTitle: Scalars['String']['output'];
  readonly whiteListVerificationState: VerificationStateBankAccountStatus;
  readonly workTotalTime: Scalars['Minutes']['output'];
  readonly yearMonth: Scalars['YearMonth']['output'];
};

export const B2BContractType = {
  B2B: 'B2B',
  SUBCONTRACT: 'Subcontract'
} as const;

export type B2BContractType = typeof B2BContractType[keyof typeof B2BContractType];
export type B2BContractUpdateInput = {
  readonly conclusionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly currency?: InputMaybe<TimeBasedValueCurrencyInput>;
  readonly enableTrainingPackage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<ClearableStringInput>;
  readonly onCall?: InputMaybe<TimeBasedValueClearableNetOnCallRateInput>;
  readonly overtimeRate?: InputMaybe<TimeBasedValueClearableCentsInput>;
  readonly overwrittenPromisorTransferBankAccountNumber?: InputMaybe<ClearableBankAccountNumberInput>;
  readonly position?: InputMaybe<TimeBasedValueClearableStringInput>;
  readonly progressionSchemeId?: InputMaybe<TimeBasedValueClearableProgressionSchemeIdInput>;
  readonly promiseeCompanyTransferBankAccountNumber?: InputMaybe<BankAccountNumberInput>;
  readonly promisorId?: InputMaybe<TimeBasedValueCompanyIdInput>;
  readonly rate?: InputMaybe<TimeBasedValueNetRateInput>;
  readonly scopeOfWork?: InputMaybe<TimeBasedValueStringInput>;
  readonly separatePaymentForBenefits?: InputMaybe<TimeBasedValueBooleanInput>;
  readonly startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly vat?: InputMaybe<TimeBasedValueVatTypeInput>;
};

export type B2BIncompleteDataStateSummary = {
  readonly __typename?: 'B2BIncompleteDataStateSummary';
  readonly stateDescriptions: ReadonlyArray<IncompleteDataDescription>;
  readonly transfersSummary: B2BTransfersSummary;
};

export type B2BPromisorTransfersSummaries = {
  readonly __typename?: 'B2BPromisorTransfersSummaries';
  readonly incompleteDataState: B2BIncompleteDataStateSummary;
  readonly paymentDisbursedState: B2BTransfersSummary;
  readonly promisorId: Scalars['CompanyId']['output'];
  readonly readyState: B2BTransfersSummary;
  readonly totalCount: Scalars['Int']['output'];
};

export type B2BSalaryDetailsDrawer = AbstractDrawer & {
  readonly __typename?: 'B2BSalaryDetailsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredMonth: Scalars['YearMonth']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

/** payout = gross value with following components: hourly rate * hours + overtime + on calls + bonuses + cost of refunded benefits */
export type B2BTimeReportStats = TimeReportStats & {
  readonly __typename?: 'B2BTimeReportStats';
  readonly currentTimeBalance: TimeBalance;
  readonly incomeDetails: ListOfIncomeDetailsOrUnauthorized;
  readonly overtime: Scalars['Minutes']['output'];
  readonly reportedDaysOff: Scalars['Days']['output'];
  readonly timeBalanceAtEndOfMonth: TimeBalance;
};

export type B2BTransfersSummaries = {
  readonly __typename?: 'B2BTransfersSummaries';
  readonly byPromisor: ReadonlyArray<B2BPromisorTransfersSummaries>;
  readonly incompleteDataState: B2BIncompleteDataStateSummary;
  readonly paymentDisbursedState: B2BTransfersSummary;
  readonly readyState: B2BTransfersSummary;
  readonly totalCount: Scalars['Int']['output'];
};

export type B2BTransfersSummary = {
  readonly __typename?: 'B2BTransfersSummary';
  readonly contractCount: Scalars['Int']['output'];
  readonly grossSalariesByCurrency: ReadonlyArray<CurrencyConversion>;
  readonly netSalariesByCurrency: ReadonlyArray<CurrencyConversion>;
  readonly taxByCurrency: ReadonlyArray<CurrencyConversion>;
  readonly totalGrossSalary: CentsWithCurrency;
  readonly totalNetSalary: CentsWithCurrency;
  readonly totalTax: CentsWithCurrency;
  readonly totalTransferAmount: CentsWithCurrency;
  readonly transferAmountsByCurrency: ReadonlyArray<CurrencyConversion>;
};

export type BankAccount = {
  readonly __typename?: 'BankAccount';
  readonly accountNumber: BankAccountNumber;
  readonly bic?: Maybe<Scalars['Bic']['output']>;
  readonly currency?: Maybe<Scalars['Currency']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly monitorTransfers: Scalars['Boolean']['output'];
  readonly verificationState: VerificationStateBankAccountStatus;
};

export type BankAccountInput = {
  readonly bankAccountNumber: BankAccountNumberInput;
  readonly bic?: InputMaybe<Scalars['Bic']['input']>;
  readonly currency?: InputMaybe<Scalars['Currency']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly monitorTransfers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BankAccountNumber = {
  readonly value: Scalars['String']['output'];
};

export type BankAccountNumberInput = {
  readonly bankAccountNumber: Scalars['String']['input'];
  readonly bankAccountNumberType: BankAccountNumberType;
};

export const BankAccountNumberType = {
  IBANTYPE: 'IbanType',
  OTHERTYPE: 'OtherType'
} as const;

export type BankAccountNumberType = typeof BankAccountNumberType[keyof typeof BankAccountNumberType];
export type BankAccountResponse = {
  readonly __typename?: 'BankAccountResponse';
  readonly bankAccount: BankAccount;
  readonly company: Company;
};

export type BankAccountResponseOrNfsError = BankAccountResponse | NfsError;

export const BankAccountStatus = {
  INVALID: 'Invalid',
  NOTAPPLICABLE: 'NotApplicable',
  VALID: 'Valid'
} as const;

export type BankAccountStatus = typeof BankAccountStatus[keyof typeof BankAccountStatus];
export type BankAccountOrUnauthorized = AccessGrantedBankAccount | Unauthorized;

export type BankAccountsResponse = {
  readonly __typename?: 'BankAccountsResponse';
  readonly bankAccounts: ReadonlyArray<BankAccount>;
  readonly company: Company;
};

export type BankAccountsResponseOrNfsError = BankAccountsResponse | NfsError;

export type BankIncomeTransfer = BankTransfer & {
  readonly __typename?: 'BankIncomeTransfer';
  readonly amount: Scalars['Cents']['output'];
  readonly bookDate: Scalars['LocalDate']['output'];
  readonly connectedPayments: ReadonlyArray<PaymentConnection>;
  readonly currency: Scalars['Currency']['output'];
  readonly discrepancy: Scalars['Cents']['output'];
  readonly fromAccountNumber: BankAccountNumber;
  readonly fromName: Scalars['String']['output'];
  readonly id: Scalars['BankTransferId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly operationDate: Scalars['LocalDate']['output'];
  readonly source: BankTransferSource;
  readonly status: BankTransferStatus;
  readonly title: Scalars['String']['output'];
  readonly toAccount?: Maybe<BankAccount>;
  readonly toAccountNumber: BankAccountNumber;
  readonly toName: Scalars['String']['output'];
};

export type BankIncomeTransferOrNfsError = BankIncomeTransfer | NfsError;

export type BankOutcomeTransfer = BankTransfer & {
  readonly __typename?: 'BankOutcomeTransfer';
  readonly amount: Scalars['Cents']['output'];
  readonly bookDate: Scalars['LocalDate']['output'];
  readonly currency: Scalars['Currency']['output'];
  readonly fromAccountNumber: BankAccountNumber;
  readonly fromName: Scalars['String']['output'];
  readonly id: Scalars['BankTransferId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly operationDate: Scalars['LocalDate']['output'];
  readonly source: BankTransferSource;
  readonly status: BankTransferStatus;
  readonly title: Scalars['String']['output'];
  readonly toAccountNumber: BankAccountNumber;
  readonly toName: Scalars['String']['output'];
};

export type BankTransfer = {
  readonly amount: Scalars['Cents']['output'];
  readonly bookDate: Scalars['LocalDate']['output'];
  readonly currency: Scalars['Currency']['output'];
  readonly fromAccountNumber: BankAccountNumber;
  readonly fromName: Scalars['String']['output'];
  readonly id: Scalars['BankTransferId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly operationDate: Scalars['LocalDate']['output'];
  readonly source: BankTransferSource;
  readonly status: BankTransferStatus;
  readonly title: Scalars['String']['output'];
  readonly toAccountNumber: BankAccountNumber;
  readonly toName: Scalars['String']['output'];
};

export type BankTransferMutation = {
  readonly __typename?: 'BankTransferMutation';
  readonly update: BankTransferResponseOrNfsError;
};


export type BankTransferMutationUpdateArgs = {
  amount?: InputMaybe<Scalars['Cents']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<ClearableStringInput>;
  status?: InputMaybe<BankTransferStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  toName?: InputMaybe<Scalars['String']['input']>;
};

export type BankTransferResponse = {
  readonly __typename?: 'BankTransferResponse';
  readonly value: BankTransfer;
};

export type BankTransferResponseOrNfsError = BankTransferResponse | NfsError;

export const BankTransferSource = {
  ING: 'ING',
  MANUAL_IMPORT_FROM_FILE: 'MANUAL_IMPORT_FROM_FILE'
} as const;

export type BankTransferSource = typeof BankTransferSource[keyof typeof BankTransferSource];
export const BankTransferStatus = {
  PENDING: 'PENDING',
  SETTLED: 'SETTLED'
} as const;

export type BankTransferStatus = typeof BankTransferStatus[keyof typeof BankTransferStatus];
export const BankTransferType = {
  INCOME: 'INCOME',
  OUTCOME: 'OUTCOME'
} as const;

export type BankTransferType = typeof BankTransferType[keyof typeof BankTransferType];
export type BaseInfo = {
  readonly __typename?: 'BaseInfo';
  readonly address?: Maybe<Address>;
  readonly mailingAddress?: Maybe<Address>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly registerId?: Maybe<Scalars['RegisterId']['output']>;
  readonly regon?: Maybe<Scalars['REGON']['output']>;
  readonly taxNumber?: Maybe<Scalars['TaxNumber']['output']>;
};

export type BaseInfoOrNfsError = BaseInfo | NfsError;

export type BasicFinancialReportDrawer = AbstractDrawer & {
  readonly __typename?: 'BasicFinancialReportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type BasicFinancialReportPartSubscriptions = {
  readonly __typename?: 'BasicFinancialReportPartSubscriptions';
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam]) */
  readonly basicFinancialReportExportStatus?: Maybe<BfrExportStatus>;
};

export type Benefit = BenefitCommon & {
  readonly __typename?: 'Benefit';
  readonly alternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['output'];
  readonly endDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly id: Scalars['BenefitId']['output'];
  readonly name: Scalars['String']['output'];
  readonly parent: BenefitGroupType;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly subBenefits: ConjunctiveSubBenefits;
  readonly variants: ReadonlyArray<BenefitVariant>;
};

export type BenefitAdditionalAdults = {
  readonly __typename?: 'BenefitAdditionalAdults';
  readonly adults: AdditionalPeopleNumber;
};

export type BenefitAdditionalFamily = {
  readonly __typename?: 'BenefitAdditionalFamily';
  readonly adults: AdditionalPeopleNumber;
  readonly kids: AdditionalPeopleNumber;
};

export type BenefitAdditionalKids = {
  readonly __typename?: 'BenefitAdditionalKids';
  readonly kids: AdditionalPeopleNumber;
};

export type BenefitAdditionalPeople = BenefitAdditionalAdults | BenefitAdditionalFamily | BenefitAdditionalKids;

export type BenefitAdditionalPeopleInput = {
  readonly adults?: InputMaybe<AdditionalPeopleNumber>;
  readonly kids?: InputMaybe<AdditionalPeopleNumber>;
};

export const BenefitBillingPeriod = {
  HOURLY: 'Hourly',
  MONTHLY: 'Monthly'
} as const;

export type BenefitBillingPeriod = typeof BenefitBillingPeriod[keyof typeof BenefitBillingPeriod];
export const BenefitBuyerType = {
  PROMISEE: 'Promisee',
  PROMISOR: 'Promisor',
  THIRDPARTY: 'ThirdParty'
} as const;

export type BenefitBuyerType = typeof BenefitBuyerType[keyof typeof BenefitBuyerType];
export type BenefitCommon = {
  readonly alternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['output'];
  readonly endDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly id: Scalars['BenefitId']['output'];
  readonly name: Scalars['String']['output'];
  readonly startDate: Scalars['LocalDate']['output'];
  readonly variants: ReadonlyArray<BenefitVariant>;
};

export type BenefitCommonResponse = {
  readonly __typename?: 'BenefitCommonResponse';
  readonly value: BenefitCommon;
};

export type BenefitCommonResponseOrNfsError = BenefitCommonResponse | NfsError;

export type BenefitGroup = {
  readonly __typename?: 'BenefitGroup';
  readonly benefits: ConjunctiveBenefits;
  readonly groupType: BenefitGroupType;
};

export const BenefitGroupType = {
  HEALTH: 'Health',
  OFFICE: 'Office',
  SPORT: 'Sport'
} as const;

export type BenefitGroupType = typeof BenefitGroupType[keyof typeof BenefitGroupType];
export const BenefitInvoiceCategory = {
  BUYERSBENEFIT: 'BuyersBenefit',
  BUYERSCOST: 'BuyersCost'
} as const;

export type BenefitInvoiceCategory = typeof BenefitInvoiceCategory[keyof typeof BenefitInvoiceCategory];
export type BenefitInvoicesReportDrawer = AbstractDrawer & {
  readonly __typename?: 'BenefitInvoicesReportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type BenefitMutation = {
  readonly __typename?: 'BenefitMutation';
  readonly createBenefitVariant: BenefitVariantOrNfsError;
  readonly createSubBenefit: SubBenefitOrNfsError;
  readonly terminate: BenefitCommonResponseOrNfsError;
  readonly update: BenefitCommonResponseOrNfsError;
};


export type BenefitMutationCreateBenefitVariantArgs = {
  additionalPeople?: InputMaybe<BenefitAdditionalPeopleInput>;
  buyerType: BenefitBuyerType;
  computationBias: MoneyComputationBias;
  contractTypes: ReadonlyArray<ContractType>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id: Scalars['BenefitVariantId']['input'];
  invoiceCategory: BenefitInvoiceCategory;
  meansOfProduction: Scalars['Boolean']['input'];
  parentId: Scalars['BenefitId']['input'];
  productId: Scalars['BenefitVariantProductId']['input'];
  productName: Scalars['String']['input'];
  promiseeRate?: InputMaybe<BenefitVariantRateInput>;
  promisorRate?: InputMaybe<BenefitVariantRateInput>;
  startDate: Scalars['LocalDate']['input'];
};


export type BenefitMutationCreateSubBenefitArgs = {
  alternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id: Scalars['BenefitId']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['LocalDate']['input'];
};


export type BenefitMutationTerminateArgs = {
  terminationDate: Scalars['LocalDate']['input'];
};


export type BenefitMutationUpdateArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BenefitNoteDrawer = AbstractDrawer & {
  readonly __typename?: 'BenefitNoteDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly editing: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly requiredAssignedVariantId: Scalars['AssignedVariantId']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type BenefitOrNfsError = Benefit | NfsError;

export const BenefitSortBy = {
  NAME: 'Name',
  NUMBEROFASSIGNMENTS: 'NumberOfAssignments',
  STARTDATE: 'StartDate'
} as const;

export type BenefitSortBy = typeof BenefitSortBy[keyof typeof BenefitSortBy];
export type BenefitValue = {
  readonly __typename?: 'BenefitValue';
  readonly notRefundedValue?: Maybe<NetGross>;
  readonly refundedValue?: Maybe<NetGross>;
  readonly totalValue: NetGross;
  readonly variant: BenefitVariant;
};

export type BenefitVariant = {
  readonly __typename?: 'BenefitVariant';
  readonly additionalPeople?: Maybe<BenefitAdditionalPeople>;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly buyerType: BenefitBuyerType;
  readonly contractTypes: ReadonlyArray<ContractType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly id: Scalars['BenefitVariantId']['output'];
  readonly invoiceCategory: BenefitInvoiceCategory;
  readonly meansOfProduction: Scalars['Boolean']['output'];
  readonly parent: BenefitCommon;
  readonly productId: Scalars['BenefitVariantProductId']['output'];
  readonly productName: Scalars['String']['output'];
  readonly promiseeRate: TimeBasedOptClearableBenefitVariantRate;
  readonly promisorRate: TimeBasedOptClearableBenefitVariantRate;
  readonly startDate: Scalars['LocalDate']['output'];
};

export type BenefitVariantFilterInput = {
  readonly contractType_oneOf: ReadonlyArray<ContractType>;
};

export type BenefitVariantMutation = {
  readonly __typename?: 'BenefitVariantMutation';
  readonly terminate: BenefitVariantOrNfsError;
  readonly update: BenefitVariantOrNfsError;
};


export type BenefitVariantMutationTerminateArgs = {
  terminationDate: Scalars['LocalDate']['input'];
};


export type BenefitVariantMutationUpdateArgs = {
  additionalPeople?: InputMaybe<ClearableBenefitAdditionalPeopleInput>;
  buyerType?: InputMaybe<BenefitBuyerType>;
  description?: InputMaybe<ClearableStringInput>;
  invoiceCategory?: InputMaybe<BenefitInvoiceCategory>;
  meansOfProduction?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['BenefitVariantProductId']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  promiseeRate?: InputMaybe<TimeBasedValueClearableBenefitVariantRateInput>;
  promisorRate?: InputMaybe<TimeBasedValueClearableBenefitVariantRateInput>;
};

export type BenefitVariantOrNfsError = BenefitVariant | NfsError;

export type BenefitVariantRate = {
  readonly __typename?: 'BenefitVariantRate';
  readonly netGross: NetGross;
  readonly period: BenefitBillingPeriod;
  readonly vat: VatType;
};

export type BenefitVariantRateInput = {
  readonly net: Scalars['Cents']['input'];
  readonly period: BenefitBillingPeriod;
  readonly vat: Scalars['VatTypeInput']['input'];
};

export type BenefitsValue = {
  readonly __typename?: 'BenefitsValue';
  readonly all: ReadonlyArray<BenefitValue>;
  readonly meansOfProduction: ReadonlyArray<BenefitValue>;
  readonly notRefunded: ReadonlyArray<BenefitValue>;
  readonly refunded: ReadonlyArray<BenefitValue>;
  readonly refundedHourlyRate: NetGross;
  readonly thirdParty: ReadonlyArray<BenefitValue>;
  readonly totalValueAll: NetGross;
  readonly totalValueMeansOfProduction: NetGross;
  readonly totalValueNotRefunded: NetGross;
  readonly totalValueRefunded: NetGross;
  readonly totalValueThirdParty: NetGross;
};

export type BfrExportCompleted = {
  readonly __typename?: 'BfrExportCompleted';
  readonly finishedAt: Scalars['OffsetDateTime']['output'];
  readonly startedAt: Scalars['OffsetDateTime']['output'];
};

export type BfrExportFailed = {
  readonly __typename?: 'BfrExportFailed';
  readonly error: UserError;
  readonly failedAt: Scalars['OffsetDateTime']['output'];
  readonly startedAt: Scalars['OffsetDateTime']['output'];
};

export type BfrExportIdle = {
  readonly __typename?: 'BfrExportIdle';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type BfrExportInterrupted = {
  readonly __typename?: 'BfrExportInterrupted';
  readonly interruptedAt: Scalars['OffsetDateTime']['output'];
  readonly startedAt: Scalars['OffsetDateTime']['output'];
};

export const BfrExportPhase = {
  CLEARINGSHEETS: 'ClearingSheets',
  FETCHINGCOSTANDREVENUEITEMS: 'FetchingCostAndRevenueItems',
  MEASURINGSHEETS: 'MeasuringSheets',
  UPLOADINGCLIENTRATES: 'UploadingClientRates',
  UPLOADINGCOSTANDREVENUEITEMS: 'UploadingCostAndRevenueItems',
  UPLOADINGHEADERS: 'UploadingHeaders',
  UPLOADINGTIMESHEETS: 'UploadingTimesheets'
} as const;

export type BfrExportPhase = typeof BfrExportPhase[keyof typeof BfrExportPhase];
export type BfrExportRunning = {
  readonly __typename?: 'BfrExportRunning';
  readonly percentDone: Scalars['Percentage']['output'];
  readonly phase: BfrExportPhase;
  readonly startedAt: Scalars['OffsetDateTime']['output'];
  readonly users?: Maybe<BfrExportUserProgress>;
};

export type BfrExportStatus = BfrExportCompleted | BfrExportFailed | BfrExportIdle | BfrExportInterrupted | BfrExportRunning;

export type BfrExportStatusResponse = {
  readonly __typename?: 'BfrExportStatusResponse';
  readonly value: BfrExportStatus;
};

export type BfrExportStatusResponseOrNfsError = BfrExportStatusResponse | NfsError;

export type BfrExportUserProgress = {
  readonly __typename?: 'BfrExportUserProgress';
  readonly processed: Scalars['Int']['output'];
  readonly total: Scalars['Int']['output'];
};

export type BfrFileUrl = {
  readonly __typename?: 'BfrFileUrl';
  readonly fileDescription: Scalars['String']['output'];
  readonly url: GoogleSpreadsheetUrl;
};

export type Bonus = {
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type BonusCategoryAmount = {
  readonly __typename?: 'BonusCategoryAmount';
  readonly amount: NetGross;
  readonly bonusCategory: BonusType;
};

export type BonusDrawer = AbstractDrawer & {
  readonly __typename?: 'BonusDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly selectedBonusId?: Maybe<Scalars['BonusId']['output']>;
  readonly visible: Scalars['Boolean']['output'];
};

export type BonusInput = {
  readonly appreciation?: InputMaybe<CreateAppreciationBonusInput>;
  readonly businessTravel?: InputMaybe<CreateBusinessTravelBonusInput>;
  readonly clientReferral?: InputMaybe<CreateClientReferralBonusInput>;
  readonly conference?: InputMaybe<CreateConferenceBonusInput>;
  readonly costRecharge?: InputMaybe<CreateCostRechargeBonusInput>;
  readonly employeeReferral?: InputMaybe<CreateEmployeeReferralBonusInput>;
  readonly languageLearning?: InputMaybe<CreateLanguageLearningBonusInput>;
  readonly other?: InputMaybe<CreateOtherBonusInput>;
  readonly remoteWorkEquipment?: InputMaybe<CreateRemoteWorkEquipmentBonusInput>;
  readonly salesCommissions?: InputMaybe<CreateSalesCommissionsBonusInput>;
  readonly severancePay?: InputMaybe<CreateSeverancePayBonusInput>;
  readonly shareholderDividend?: InputMaybe<CreateShareholderDividendBonusInput>;
  readonly trainingPackage?: InputMaybe<CreateTrainingPackageBonusInput>;
  readonly trainingPackageExternalDeductionValue?: InputMaybe<CreateTrainingPackageExternalDeductionValueInput>;
};

export type BonusMutation = {
  readonly __typename?: 'BonusMutation';
  readonly approve: BonusResponseOrNfsError;
  readonly delete: UnitResponseOrNfsError;
  readonly reject: BonusResponseOrNfsError;
};

export type BonusPreviewDrawer = AbstractDrawer & {
  readonly __typename?: 'BonusPreviewDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredBonusType: BonusType;
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredSelectedBonusId: Scalars['BonusId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type BonusRequiresApproval = {
  readonly __typename?: 'BonusRequiresApproval';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type BonusResponse = {
  readonly __typename?: 'BonusResponse';
  readonly value: Bonus;
};

export type BonusResponseOrNfsError = BonusResponse | NfsError;

export const BonusRevocationReason = {
  APPROVALREJECTED: 'ApprovalRejected',
  CONTRACTTERMINATED: 'ContractTerminated',
  REFERREDEMPLOYEECONTRACTDURATIONTOOSHORT: 'ReferredEmployeeContractDurationTooShort'
} as const;

export type BonusRevocationReason = typeof BonusRevocationReason[keyof typeof BonusRevocationReason];
export const BonusType = {
  APPRECIATION: 'Appreciation',
  BUSINESSTRAVEL: 'BusinessTravel',
  CLIENTREFERRAL: 'ClientReferral',
  CONFERENCE: 'Conference',
  COSTRECHARGE: 'CostRecharge',
  EMPLOYEEREFERRAL: 'EmployeeReferral',
  LANGUAGELEARNING: 'LanguageLearning',
  OTHER: 'Other',
  REMOTEWORKEQUIPMENT: 'RemoteWorkEquipment',
  SALESCOMMISSIONS: 'SalesCommissions',
  SEVERANCEPAY: 'SeverancePay',
  SHAREHOLDERDIVIDEND: 'ShareholderDividend',
  TRAININGPACKAGE: 'TrainingPackage',
  TRAININGPACKAGEEXTERNALDEDUCTIONVALUE: 'TrainingPackageExternalDeductionValue'
} as const;

export type BonusType = typeof BonusType[keyof typeof BonusType];
export type Bonuses = {
  readonly __typename?: 'Bonuses';
  readonly future: ReadonlyArray<Bonus>;
  readonly paidOut: ReadonlyArray<Bonus>;
};

export type BonusesOrUnauthorized = AccessGrantedBonuses | Unauthorized;

export type BookDeskOnBehalfDrawer = AbstractDrawer & {
  readonly __typename?: 'BookDeskOnBehalfDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly prefillDeskId?: Maybe<Scalars['DeskId']['output']>;
  readonly prefillFrom?: Maybe<Scalars['LocalDate']['output']>;
  readonly prefillRoomId?: Maybe<Scalars['RoomId']['output']>;
  readonly prefillTo?: Maybe<Scalars['LocalDate']['output']>;
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type BookParkingOnBehalfDrawer = AbstractDrawer & {
  readonly __typename?: 'BookParkingOnBehalfDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly prefillFrom?: Maybe<Scalars['LocalDate']['output']>;
  readonly prefillParkingSpotId?: Maybe<Scalars['ParkingSpotId']['output']>;
  readonly prefillTo?: Maybe<Scalars['LocalDate']['output']>;
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type BooleanResponse = {
  readonly __typename?: 'BooleanResponse';
  readonly value: Scalars['Boolean']['output'];
};

export type BooleanResponseOrNfsError = BooleanResponse | NfsError;

export type BooleanOrUnauthorized = AccessGrantedBoolean | Unauthorized;

export type BusinessTravelBonus = Bonus & {
  readonly __typename?: 'BusinessTravelBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export const BuyerType = {
  B2BCONTRACTOR: 'B2BContractor',
  CLIENTCOMPANY: 'ClientCompany',
  GROUPCOMPANY: 'GroupCompany',
  THIRDPARTY: 'ThirdParty'
} as const;

export type BuyerType = typeof BuyerType[keyof typeof BuyerType];
export type ByAdmin = {
  readonly __typename?: 'ByAdmin';
  readonly adminId: Scalars['AdminId']['output'];
};

export type ByUser = {
  readonly __typename?: 'ByUser';
  readonly userId: Scalars['UserId']['output'];
};

export type CalendarDay = {
  readonly __typename?: 'CalendarDay';
  readonly date: Scalars['LocalDate']['output'];
  readonly dayType: CalendarDayType;
};

export const CalendarDayType = {
  FREEDAYFOROTHERDAY: 'FreeDayForOtherDay',
  HOLIDAY: 'Holiday'
} as const;

export type CalendarDayType = typeof CalendarDayType[keyof typeof CalendarDayType];
export type CentsBalance = {
  readonly __typename?: 'CentsBalance';
  readonly available: Scalars['Cents']['output'];
  readonly entitlement: Scalars['Cents']['output'];
  readonly used: Scalars['Cents']['output'];
};

export type CentsWithCurrency = {
  readonly __typename?: 'CentsWithCurrency';
  readonly amount: Scalars['Cents']['output'];
  readonly currency: Scalars['Currency']['output'];
};

export type CentsWithCurrencyInput = {
  readonly amount: Scalars['Cents']['input'];
  readonly currency: Scalars['Currency']['input'];
};

export type Certificate = {
  readonly __typename?: 'Certificate';
  readonly expirationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly file?: Maybe<DownloadableExternallyHostedFileUrl>;
  readonly id: Scalars['CertificateId']['output'];
  readonly issueDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly name: Scalars['String']['output'];
  readonly userId: Scalars['UserId']['output'];
};

export type CertificateOrNfsError = Certificate | NfsError;

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableAccountingDataInput = {
  readonly value?: InputMaybe<AccountingDataInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableAddressInput = {
  readonly value?: InputMaybe<AddressInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableBankAccountInput = {
  readonly value?: InputMaybe<BankAccountInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableBankAccountNumberInput = {
  readonly value?: InputMaybe<BankAccountNumberInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableBasisPoint = {
  readonly __typename?: 'ClearableBasisPoint';
  readonly value?: Maybe<Scalars['BasisPoint']['output']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableBasisPointInput = {
  readonly value?: InputMaybe<Scalars['BasisPoint']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableBenefitAdditionalPeopleInput = {
  readonly value?: InputMaybe<BenefitAdditionalPeopleInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableBenefitVariantRate = {
  readonly __typename?: 'ClearableBenefitVariantRate';
  readonly value?: Maybe<BenefitVariantRate>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableBenefitVariantRateInput = {
  readonly value?: InputMaybe<BenefitVariantRateInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableBooleanInput = {
  readonly value?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableCentsInput = {
  readonly value?: InputMaybe<Scalars['Cents']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableCompanyIdInput = {
  readonly value?: InputMaybe<Scalars['CompanyId']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableContractSalaryDetailsFlagColorInput = {
  readonly value?: InputMaybe<ContractSalaryDetailsFlagColor>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableCountryCodeInput = {
  readonly value?: InputMaybe<Scalars['CountryCode']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableCrossSellInput = {
  readonly value?: InputMaybe<CrossSellInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableCurrencyInput = {
  readonly value?: InputMaybe<Scalars['Currency']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableDailyAndHourlyRateNet = {
  readonly __typename?: 'ClearableDailyAndHourlyRateNet';
  readonly value?: Maybe<DailyAndHourlyRateNet>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableDays = {
  readonly __typename?: 'ClearableDays';
  readonly value?: Maybe<Scalars['Days']['output']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableDaysInput = {
  readonly value?: InputMaybe<Scalars['Days']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableDeductibleCostsType = {
  readonly __typename?: 'ClearableDeductibleCostsType';
  readonly value?: Maybe<DeductibleCostsType>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableDeductibleCostsTypeInput = {
  readonly value?: InputMaybe<DeductibleCostsType>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableEmailAddressInput = {
  readonly value?: InputMaybe<Scalars['EmailAddress']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableExternalBeneficiary = {
  readonly __typename?: 'ClearableExternalBeneficiary';
  readonly value?: Maybe<ExternalBeneficiary>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableGrossAdjustmentInput = {
  readonly value?: InputMaybe<GrossAdjustment>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableHolidayCalendarIdInput = {
  readonly value?: InputMaybe<HolidayCalendarId>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableIdTypeInput = {
  readonly value?: InputMaybe<IdType>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableInvoiceNumberInput = {
  readonly value?: InputMaybe<Scalars['InvoiceNumber']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableLocalDateInput = {
  readonly value?: InputMaybe<Scalars['LocalDate']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableMinutesInput = {
  readonly value?: InputMaybe<Scalars['Minutes']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableNetGross = {
  readonly __typename?: 'ClearableNetGross';
  readonly value?: Maybe<NetGross>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableNetOnCallRate = {
  readonly __typename?: 'ClearableNetOnCallRate';
  readonly value?: Maybe<NetOnCallRate>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableNetOnCallRateInput = {
  readonly value?: InputMaybe<NetOnCallRateInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableNetRateInput = {
  readonly value?: InputMaybe<NetRateInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableOfficeIdInput = {
  readonly value?: InputMaybe<Scalars['OfficeId']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableOnCallRate = {
  readonly __typename?: 'ClearableOnCallRate';
  readonly value?: Maybe<OnCallRate>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearablePeselInput = {
  readonly value?: InputMaybe<Scalars['PESEL']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearablePhoneNumberInput = {
  readonly value?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableProgressionLevel = {
  readonly __typename?: 'ClearableProgressionLevel';
  readonly value?: Maybe<ProgressionLevel>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableProgressionLevelInput = {
  readonly value?: InputMaybe<ProgressionLevel>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableProgressionScheme = {
  readonly __typename?: 'ClearableProgressionScheme';
  readonly value?: Maybe<ProgressionScheme>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableProgressionSchemeIdInput = {
  readonly value?: InputMaybe<Scalars['ProgressionSchemeId']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableProjectId = {
  readonly __typename?: 'ClearableProjectId';
  readonly value?: Maybe<Scalars['ProjectId']['output']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableProjectIdInput = {
  readonly value?: InputMaybe<Scalars['ProjectId']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableRevenueAdministrationOfficeIdInput = {
  readonly value?: InputMaybe<Scalars['RevenueAdministrationOfficeId']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableSpaceIdInput = {
  readonly value?: InputMaybe<Scalars['SpaceId']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableString = {
  readonly __typename?: 'ClearableString';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableStringInput = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableTransferDeductionInput = {
  readonly value?: InputMaybe<TransferDeductionInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableUriInput = {
  readonly value?: InputMaybe<Scalars['URI']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableUploadInput = {
  readonly value?: InputMaybe<Scalars['Upload']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableUser = {
  readonly __typename?: 'ClearableUser';
  readonly value?: Maybe<User>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableUserIdInput = {
  readonly value?: InputMaybe<Scalars['UserId']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableVatTypeInput = {
  readonly value?: InputMaybe<Scalars['VatTypeInput']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableWorkTimeInput = {
  readonly value?: InputMaybe<WorkTimeInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableWorkingTimeInput = {
  readonly value?: InputMaybe<WorkingTimeInput>;
};

export type ClientContract = {
  readonly __typename?: 'ClientContract';
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly contractDurationFrom: LocalDateOrUnauthorized;
  readonly contractDurationTo: OptionalLocalDateOrUnauthorized;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly currency: TimeBasedOptCurrencyOrUnauthorized;
  readonly docUri: OptionalUriOrUnauthorized;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly id: Scalars['ClientContractId']['output'];
  readonly name: StringOrUnauthorized;
  readonly positions: ListOfClientPositionOrUnauthorized;
  readonly projects: ReadonlyArray<Project>;
  /** Group */
  readonly promisee: Company;
  /** Client */
  readonly promisor?: Maybe<Company>;
  readonly vat: TimeBasedOptClearableBasisPointOrUnauthorized;
};

export type ClientContractMutation = {
  readonly __typename?: 'ClientContractMutation';
  readonly cancelActivities: ClientContractOrNfsError;
  readonly clientPositions: ClientPositionMutation;
  /**
   * Atomically set a client contract's commercial terms, effective from a chosen date.
   *
   * Updates the contract's VAT and settlement currency and replaces its full set of billable positions
   * (man-day rates) in a single transaction, then returns the contract as it stands after the change.
   *
   * **Positions are a full replacement, not a delta.** `positions` is diffed by id against the positions in
   * force at `at`:
   *   - a listed id that is new → the position is created and activated at `at`;
   *   - a listed id that already exists → it is updated, and reactivated if it was inactive;
   *   - an existing id that is *omitted* → it is **deactivated** (fails with IllegalPositionRemovalError if it
   *     still has active or scheduled users).
   *
   * **`at` is constrained.** It must fall within the contract duration *and* land on either the start of the
   * reporting period covering it (a calendar-month start, e.g. `2026-03-01`, unless the client uses custom
   * periods) or the contract start date. Any other date fails with a ValidationError on `at`.
   *
   * **Timing follows the time-based model.** A future `at` schedules the change without altering today's
   * values; a past `at` is a correction that recomputes every later state.
   *
   * Concurrency is guarded by the parent clientContract field's entityVersion (stale → EntityVersionMismatched).
   * Requires the FinancialTeam or InvoicingTeam role.
   */
  readonly setManDayRates: ClientContractOrNfsError;
  readonly setNewOnCallRatesForEveryPosition: ClientContractOrNfsError;
  readonly update: ClientContractOrNfsError;
};


export type ClientContractMutationCancelActivitiesArgs = {
  date: Scalars['LocalDate']['input'];
};


export type ClientContractMutationSetManDayRatesArgs = {
  at: Scalars['Date']['input'];
  currency: Scalars['Currency']['input'];
  positions: ReadonlyArray<ClientPositionInput>;
  vat?: InputMaybe<Scalars['BasisPoint']['input']>;
};


export type ClientContractMutationSetNewOnCallRatesForEveryPositionArgs = {
  applyDate: Scalars['Date']['input'];
  value: NetOnCallRateInput;
};


export type ClientContractMutationUpdateArgs = {
  contractDurationFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  contractDurationTo?: InputMaybe<ClearableLocalDateInput>;
  docUri?: InputMaybe<ClearableUriInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ClientContractOrNfsError = ClientContract | NfsError;

export type ClientContractOrUnauthorized = AccessGrantedClientContract | Unauthorized;

export type ClientInvoicingReportDrawer = AbstractDrawer & {
  readonly __typename?: 'ClientInvoicingReportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type ClientPosition = {
  readonly __typename?: 'ClientPosition';
  readonly active: TimeBasedBoolean;
  readonly assignments: ReadonlyArray<ProjectAssignment>;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly currency: TimeBasedCurrency;
  readonly id: Scalars['ClientPositionId']['output'];
  readonly name: Scalars['String']['output'];
  readonly onCallRates: TimeBasedOptClearableNetOnCallRate;
  readonly overtimeNet: TimeBasedOptClearableDailyAndHourlyRateNet;
  readonly rateNet: TimeBasedDailyAndHourlyRateNet;
  readonly serviceLine: TimeBasedOptClearableString;
};

/** A single billable position (man-day rate) within a ManDayRatesInput. */
export type ClientPositionInput = {
  /** Position settlement currency as a 3-letter ISO code, independent of the contract currency. */
  readonly currency: Scalars['Currency']['input'];
  /** Position identifier. Drives the create/update/deactivate diff — an id omitted from the `positions` list deactivates that position. */
  readonly id: Scalars['ClientPositionId']['input'];
  /** Display name of the position. */
  readonly name: Scalars['String']['input'];
  /** Net on-call rates (night / weekend / holiday) in cents. Pass null to clear them. */
  readonly onCallRates?: InputMaybe<NetOnCallRateInput>;
  /** Net overtime rate in cents. Pass null to clear it. */
  readonly overtimeNet?: InputMaybe<Scalars['Cents']['input']>;
  /** Net man-day rate in cents. Exposed on the position as a daily + hourly pair derived from its settlement (Daily by default, so daily equals this value). */
  readonly rateNet: Scalars['Cents']['input'];
  /** Optional service line label. Pass null to clear it. */
  readonly serviceLine?: InputMaybe<Scalars['String']['input']>;
};

export type ClientPositionMutation = {
  readonly __typename?: 'ClientPositionMutation';
  readonly cancelPositionActivities: ClientPositionOrNfsError;
  readonly cancelPositionActivity: ClientPositionOrNfsError;
};


export type ClientPositionMutationCancelPositionActivitiesArgs = {
  activityIds: ReadonlyArray<Scalars['ActivityId']['input']>;
  positionId: Scalars['ClientPositionId']['input'];
};


export type ClientPositionMutationCancelPositionActivityArgs = {
  activityId: Scalars['ActivityId']['input'];
  positionId: Scalars['ClientPositionId']['input'];
};

export type ClientPositionOrNfsError = ClientPosition | NfsError;

export type ClientPositionOrUnauthorized = AccessGrantedClientPosition | Unauthorized;

export type ClientReferralBonus = Bonus & {
  readonly __typename?: 'ClientReferralBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type ClosedEndLocalDateRange = {
  readonly __typename?: 'ClosedEndLocalDateRange';
  readonly from: Scalars['LocalDate']['output'];
  readonly to: Scalars['LocalDate']['output'];
};

export type ClosedEndLocalDateRangeInput = {
  readonly from: Scalars['LocalDate']['input'];
  readonly to: Scalars['LocalDate']['input'];
};

export type ClosedEndLocalDateRangeOrNfsError = ClosedEndLocalDateRange | NfsError;

export type ClosedEndMonthRange = {
  readonly __typename?: 'ClosedEndMonthRange';
  readonly from: Scalars['YearMonth']['output'];
  readonly to: Scalars['YearMonth']['output'];
};

export type ClosedEndMonthRangeInput = {
  readonly from: Scalars['YearMonth']['input'];
  readonly to: Scalars['YearMonth']['input'];
};

/**
 * euVatType: e.g. FR, DE, ... - EU tax payer, will be validated
 * isPolishVat: polish VAT payer, will be validated
 * isOtherVatType:
 *    if false => not a VAT payer outside EU (e.g. EU vat payer or US company - there is no VAT in the USA)
 *    if true => mark as a VAT payer outside EU (e.g. in the UK) - it cannot be validated
 */
export type Company = {
  readonly __typename?: 'Company';
  readonly address?: Maybe<Address>;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly bankAccounts: ReadonlyArray<BankAccount>;
  readonly clientContracts: ListOfClientContractOrUnauthorized;
  readonly companyType: ReadonlyArray<CompanyType>;
  readonly countryOfRegistration: Scalars['CountryCode']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly defaultBankAccount?: Maybe<BankAccount>;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly euVatType: TimeBasedValueWithVerificationEuVatType;
  readonly id: Scalars['CompanyId']['output'];
  readonly isOtherVatType: TimeBasedBoolean;
  readonly isPolishVat: TimeBasedValueWithDescriptionAndVerificationBooleanVatStatus;
  readonly logo?: Maybe<Scalars['URI']['output']>;
  readonly mailingAddress?: Maybe<Address>;
  readonly name: Scalars['String']['output'];
  readonly promiseeSideContracts: ListOfClientContractOrUnauthorized;
  readonly registerId?: Maybe<Scalars['RegisterId']['output']>;
  readonly regon?: Maybe<Scalars['REGON']['output']>;
  readonly sectors: ListOfStringOrUnauthorized;
  readonly taxNumber?: Maybe<Scalars['TaxNumber']['output']>;
  readonly taxResidencyCertificates: ListOfTaxResidencyCertificateOrUnauthorized;
};

export type CompanyBankAccountDrawer = AbstractDrawer & {
  readonly __typename?: 'CompanyBankAccountDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly editing: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly initialValue?: Maybe<BankAccount>;
  readonly requiredCompanyTypes: ReadonlyArray<CompanyType>;
  readonly returnValue?: Maybe<BankAccount>;
  readonly visible: Scalars['Boolean']['output'];
};

export type CompanyDetailsDrawer = AbstractDrawer & {
  readonly __typename?: 'CompanyDetailsDrawer';
  readonly activeTab?: Maybe<CompanyDetailsDrawerTabs>;
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredCompanyId: Scalars['CompanyId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export const CompanyDetailsDrawerTabs = {
  COMPANY_TYPE: 'COMPANY_TYPE',
  LOGO: 'LOGO',
  REGISTER_INFO: 'REGISTER_INFO',
  VAT_TAX: 'VAT_TAX'
} as const;

export type CompanyDetailsDrawerTabs = typeof CompanyDetailsDrawerTabs[keyof typeof CompanyDetailsDrawerTabs];
export type CompanyInfo = {
  readonly __typename?: 'CompanyInfo';
  readonly baseInfo: BaseInfoOrNfsError;
  /** Value NotVerified means that it's not verified or that we were unable to fetch information from government. */
  readonly euVatType: VerificationStateEuVatTypeResponseOrNfsError;
  /** Value not NotVerified means that it's not verified or we were unable to fetch information from government. */
  readonly polishVat: PolishVatOrNfsError;
};

export type CompanyInfoOrNfsError = CompanyInfo | NfsError;

export type CompanyInput = {
  readonly address?: InputMaybe<AddressInput>;
  readonly bankAccounts: ReadonlyArray<BankAccountInput>;
  readonly companyType: ReadonlyArray<CompanyType>;
  readonly countryOfRegistration: Scalars['CountryCode']['input'];
  readonly defaultBankAccountNumber?: InputMaybe<BankAccountNumberInput>;
  readonly euVatType: EuVatType;
  readonly id: Scalars['CompanyId']['input'];
  readonly isOtherVatType: Scalars['Boolean']['input'];
  readonly isPolishVat: Scalars['Boolean']['input'];
  readonly mailingAddress?: InputMaybe<AddressInput>;
  readonly name: Scalars['String']['input'];
  readonly registerId?: InputMaybe<Scalars['RegisterId']['input']>;
  readonly regon?: InputMaybe<Scalars['REGON']['input']>;
  readonly sectors?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly taxNumber?: InputMaybe<Scalars['TaxNumber']['input']>;
  readonly verifyEuVatType?: InputMaybe<Scalars['Boolean']['input']>;
  readonly verifyPolishVat?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyMutation = {
  readonly __typename?: 'CompanyMutation';
  readonly cancelActivities: CompanyOrNfsError;
  readonly cancelActivity: CompanyOrNfsError;
  readonly deleteBankAccount: BankAccountResponseOrNfsError;
  readonly deleteLogo: CompanyOrNfsError;
  readonly refreshAllBankAccounts: CompanyOrNfsError;
  readonly refreshBankAccounts: BankAccountsResponseOrNfsError;
  /** taxNumber/regon/registerId cannot be updated after initialization */
  readonly updateCompany: CompanyOrNfsError;
  readonly uploadLogo: CompanyOrNfsError;
  readonly upsertBankAccount: BankAccountResponseOrNfsError;
  readonly verifyEuVat: CompanyOrNfsError;
  readonly verifyPolishVat: CompanyOrNfsError;
  readonly verifyVat: CompanyOrNfsError;
};


export type CompanyMutationCancelActivitiesArgs = {
  activityIds: ReadonlyArray<Scalars['ActivityId']['input']>;
};


export type CompanyMutationCancelActivityArgs = {
  activityId: Scalars['ActivityId']['input'];
};


export type CompanyMutationDeleteBankAccountArgs = {
  bankAccountNumber: BankAccountNumberInput;
};


export type CompanyMutationRefreshBankAccountsArgs = {
  bankAccountNumbers: ReadonlyArray<BankAccountNumberInput>;
};


export type CompanyMutationUpdateCompanyArgs = {
  address?: InputMaybe<ClearableAddressInput>;
  companyType?: InputMaybe<ReadonlyArray<CompanyType>>;
  countryOfRegistration?: InputMaybe<Scalars['CountryCode']['input']>;
  defaultBankAccountNumber?: InputMaybe<ClearableBankAccountNumberInput>;
  euVatType?: InputMaybe<TimeBasedValueEuVatTypeInput>;
  isOtherVatType?: InputMaybe<TimeBasedValueBooleanInput>;
  isPolishVat?: InputMaybe<TimeBasedValueBooleanInput>;
  mailingAddress?: InputMaybe<ClearableAddressInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  registerId?: InputMaybe<Scalars['RegisterId']['input']>;
  regon?: InputMaybe<Scalars['REGON']['input']>;
  sectors?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  taxNumber?: InputMaybe<Scalars['TaxNumber']['input']>;
};


export type CompanyMutationUploadLogoArgs = {
  file: Scalars['Upload']['input'];
};


export type CompanyMutationUpsertBankAccountArgs = {
  bankAccount: BankAccountInput;
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyOrNfsError = Company | NfsError;

export const CompanyRole = {
  CHIEFOFFICER: 'ChiefOfficer',
  DIRECTOR: 'Director',
  HEAD: 'Head',
  LEAD: 'Lead',
  MANAGER: 'Manager',
  PERSONNEL: 'Personnel'
} as const;

export type CompanyRole = typeof CompanyRole[keyof typeof CompanyRole];
export const CompanyType = {
  B2B: 'B2B',
  CAPITALGROUP: 'CapitalGroup',
  CLIENT: 'Client',
  GROUP: 'Group',
  SUPPLIER: 'Supplier'
} as const;

export type CompanyType = typeof CompanyType[keyof typeof CompanyType];
export type CompanyOrUnauthorized = AccessGrantedCompany | Unauthorized;

export type ConferenceBonus = Bonus & {
  readonly __typename?: 'ConferenceBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

/** many benefits from the group can be chosen */
export type ConjunctiveBenefits = {
  readonly __typename?: 'ConjunctiveBenefits';
  readonly manyOf: ReadonlyArray<AlternativeBenefits>;
};

/** many sub-benefits from the group can be chosen */
export type ConjunctiveSubBenefits = {
  readonly __typename?: 'ConjunctiveSubBenefits';
  readonly manyOf: ReadonlyArray<AlternativeSubBenefits>;
};

export type Contract = {
  readonly assignedVariants: ListOfAssignedVariantOrUnauthorized;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly bonuses: BonusesOrUnauthorized;
  readonly conclusionDate: LocalDateOrUnauthorized;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  /** We do not have related data (time reports etc.) before this date in the system */
  readonly dataInSystemSince: Scalars['LocalDate']['output'];
  readonly entityVersion: Scalars['EntityVersion']['output'];
  /** It just an information. Should not be used for business logic as contract may be extended or terminated earlier */
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly holidayCalendar: HolidayCalendar;
  readonly id: Scalars['ContractId']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes: OptionalStringOrUnauthorized;
  readonly promisee: User;
  readonly promiseeId: Scalars['UserId']['output'];
  readonly promisor: TimeBasedCompany;
  readonly promisorId: Scalars['CompanyId']['output'];
  readonly promisorTransferBankAccount: PromisorTransferBankAccount;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly status: ContractStatus;
  /** Non-empty value indicates actual (or effective) termination date */
  readonly terminationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly workingTime: TimeBasedWorkingTimeOrUnauthorized;
};


export type ContractAssignedVariantsArgs = {
  activeOnly: Scalars['Boolean']['input'];
};

export type ContractBankAccountDrawer = AbstractDrawer & {
  readonly __typename?: 'ContractBankAccountDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly contractId?: Maybe<Scalars['ContractId']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly requiredIsPromisor: Scalars['Boolean']['output'];
  readonly requiredPromiseeId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type ContractBonusesSettingsDrawer = AbstractDrawer & {
  readonly __typename?: 'ContractBonusesSettingsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type ContractDetailsDrawer = AbstractDrawer & {
  readonly __typename?: 'ContractDetailsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly effectiveDate?: Maybe<Scalars['Date']['output']>;
  readonly highlight?: Maybe<TimeBasedHighlight>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export const ContractDocumentTemplate = {
  B2BDEV_VL_EN: 'B2BDev_VL_EN',
  B2BDEV_VL_PL: 'B2BDev_VL_PL',
  B2BMARKETINGSERVICE_VL_PL: 'B2BMarketingService_VL_PL',
  B2BMARKETING_PL: 'B2BMarketing_PL',
  B2BPRODUCTMANAGER_PL: 'B2BProductManager_PL',
  B2BPRODUCTMARKETINGMANAGER_PL: 'B2BProductMarketingManager_PL',
  B2BSALES_PL: 'B2BSales_PL',
  B2BTECHPROGRAMMANAGER_VL_PL: 'B2BTechProgramManager_VL_PL',
  B2B_VL_EN: 'B2B_VL_EN',
  B2B_VL_PL: 'B2B_VL_PL',
  UZDEV_PL: 'UZDev_PL',
  UZ_PL: 'UZ_PL',
  UODDEV_PL: 'UoDDev_PL',
  UOPCOPYRIGHT_PL: 'UoPCopyright_PL',
  UOPCOPYRIGHT_REMOTE_PL: 'UoPCopyright_Remote_PL',
  UOP_BILINGUAL_EN: 'UoP_Bilingual_EN',
  UOP_PL: 'UoP_PL'
} as const;

export type ContractDocumentTemplate = typeof ContractDocumentTemplate[keyof typeof ContractDocumentTemplate];
export type ContractDocumentTemplateDescription = {
  readonly __typename?: 'ContractDocumentTemplateDescription';
  readonly contractType: FilterContractType;
  readonly language: ContractDocumentTemplateLanguage;
  readonly name: Scalars['String']['output'];
  readonly template: ContractDocumentTemplate;
};

export const ContractDocumentTemplateLanguage = {
  EN: 'EN',
  PL: 'PL'
} as const;

export type ContractDocumentTemplateLanguage = typeof ContractDocumentTemplateLanguage[keyof typeof ContractDocumentTemplateLanguage];
export type ContractDraft = {
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly holidayCalendar?: Maybe<HolidayCalendar>;
  readonly id: Scalars['UserId']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly promisee: User;
  readonly promisor: Company;
  readonly promisorTransferBankAccount: PromisorTransferBankAccount;
  readonly startDate?: Maybe<Scalars['LocalDate']['output']>;
};

/** @allowedIfAnyOf(roles: [FinancialTeam]) */
export type ContractDraftMutation = {
  readonly __typename?: 'ContractDraftMutation';
  readonly conclude: ContractResponseOrNfsError;
  readonly concludeSubcontract: ContractResponseOrNfsError;
  readonly delete: BooleanResponseOrNfsError;
  readonly generateContractDraftPreview: DraftPreviewResponseOrNfsError;
  readonly updateB2bDraft: B2BContractDraftOrNfsError;
  readonly updateEmploymentDraft: EmploymentContractDraftOrNfsError;
  readonly updateSubcontractDraft: SubcontractDraftOrNfsError;
};


/** @allowedIfAnyOf(roles: [FinancialTeam]) */
export type ContractDraftMutationConcludeArgs = {
  conclusionDate: Scalars['LocalDate']['input'];
  conclusionLocation: Scalars['String']['input'];
  documentTemplate?: InputMaybe<ContractDocumentTemplate>;
  promisorRepresentative: Scalars['String']['input'];
};


/** @allowedIfAnyOf(roles: [FinancialTeam]) */
export type ContractDraftMutationConcludeSubcontractArgs = {
  conclusionDate: Scalars['LocalDate']['input'];
};


/** @allowedIfAnyOf(roles: [FinancialTeam]) */
export type ContractDraftMutationGenerateContractDraftPreviewArgs = {
  conclusionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  conclusionLocation?: InputMaybe<Scalars['String']['input']>;
  documentTemplate: ContractDocumentTemplate;
  promisorRepresentative?: InputMaybe<Scalars['String']['input']>;
};


/** @allowedIfAnyOf(roles: [FinancialTeam]) */
export type ContractDraftMutationUpdateB2bDraftArgs = {
  currency?: InputMaybe<ClearableCurrencyInput>;
  expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
  holidayCalendarId?: InputMaybe<ClearableHolidayCalendarIdInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<ClearableStringInput>;
  onCall?: InputMaybe<ClearableNetOnCallRateInput>;
  overtimeRate?: InputMaybe<ClearableCentsInput>;
  overwrittenPromisorTransferBankAccountNumber?: InputMaybe<ClearableBankAccountNumberInput>;
  position?: InputMaybe<ClearableStringInput>;
  promiseeCompanyId?: InputMaybe<ClearableCompanyIdInput>;
  promiseeCompanyTransferBankAccountNumber?: InputMaybe<ClearableBankAccountNumberInput>;
  promisorId?: InputMaybe<Scalars['CompanyId']['input']>;
  rate?: InputMaybe<ClearableNetRateInput>;
  scopeOfWork?: InputMaybe<ClearableStringInput>;
  separatePaymentForBenefits?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<ClearableLocalDateInput>;
  vat?: InputMaybe<ClearableVatTypeInput>;
};


/** @allowedIfAnyOf(roles: [FinancialTeam]) */
export type ContractDraftMutationUpdateEmploymentDraftArgs = {
  applyRemoteWorkReimbursement?: InputMaybe<Scalars['Boolean']['input']>;
  copyrightCosts?: InputMaybe<ClearableBasisPointInput>;
  currency?: InputMaybe<ClearableCurrencyInput>;
  expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
  holidayCalendarId?: InputMaybe<ClearableHolidayCalendarIdInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<ClearableStringInput>;
  onCall?: InputMaybe<ClearableNetOnCallRateInput>;
  overtimeRate?: InputMaybe<ClearableCentsInput>;
  overwrittenPromisorTransferBankAccountNumber?: InputMaybe<ClearableBankAccountNumberInput>;
  paidLeaveEntitlement?: InputMaybe<ClearableDaysInput>;
  position?: InputMaybe<ClearableStringInput>;
  ppk?: InputMaybe<ClearableBasisPointInput>;
  promiseeTransferBankAccount?: InputMaybe<ClearableBankAccountInput>;
  promisorId?: InputMaybe<Scalars['CompanyId']['input']>;
  rate?: InputMaybe<ClearableNetRateInput>;
  scopeOfWork?: InputMaybe<ClearableStringInput>;
  startDate?: InputMaybe<ClearableLocalDateInput>;
  taxDeductibleCosts?: InputMaybe<ClearableDeductibleCostsTypeInput>;
  workingTime?: InputMaybe<ClearableWorkingTimeInput>;
};


/** @allowedIfAnyOf(roles: [FinancialTeam]) */
export type ContractDraftMutationUpdateSubcontractDraftArgs = {
  clientContractId?: InputMaybe<Scalars['ClientContractId']['input']>;
  expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
  holidayCalendarId?: InputMaybe<ClearableHolidayCalendarIdInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<ClearableStringInput>;
  position?: InputMaybe<ClearableStringInput>;
  scopeOfWork?: InputMaybe<ClearableStringInput>;
  startDate?: InputMaybe<ClearableLocalDateInput>;
};

export type ContractDraftResponse = {
  readonly __typename?: 'ContractDraftResponse';
  readonly value: ContractDraft;
};

export type ContractDraftResponseOrNfsError = ContractDraftResponse | NfsError;

export type ContractMutation = {
  readonly __typename?: 'ContractMutation';
  readonly approveBonuses: ContractSalaryDetailsResponseOrNfsError;
  readonly assignVariants: ListOfAssignedVariantResponseOrNfsError;
  readonly bonus: BonusMutation;
  readonly cancelActivities: ContractResponseOrNfsError;
  readonly cancelActivity: ContractResponseOrNfsError;
  readonly cancelVariantAssignments: ListOfAssignedVariantResponseOrNfsError;
  readonly regenerateContractGoogleDoc: UriResponseOrNfsError;
  readonly terminate: ContractResponseOrNfsError;
  readonly updateB2BContract: B2BContractOrNfsError;
  readonly updateBenefitVariantNote: AssignedVariantOrNfsError;
  readonly updateEmploymentContract: EmploymentContractOrNfsError;
  readonly updateSubcontract: SubcontractOrNfsError;
  readonly upsertBonus: BonusResponseOrNfsError;
};


export type ContractMutationApproveBonusesArgs = {
  bonusIds: ReadonlyArray<Scalars['BonusId']['input']>;
};


export type ContractMutationAssignVariantsArgs = {
  at: Scalars['Date']['input'];
  groupType: BenefitGroupType;
  variants: ReadonlyArray<AssignVariantInput>;
};


export type ContractMutationBonusArgs = {
  id: Scalars['BonusId']['input'];
};


export type ContractMutationCancelActivitiesArgs = {
  activityIds: ReadonlyArray<Scalars['ActivityId']['input']>;
};


export type ContractMutationCancelActivityArgs = {
  activityId: Scalars['ActivityId']['input'];
};


export type ContractMutationCancelVariantAssignmentsArgs = {
  at: Scalars['Date']['input'];
  groupType: BenefitGroupType;
};


export type ContractMutationTerminateArgs = {
  date: Scalars['LocalDate']['input'];
};


export type ContractMutationUpdateB2BContractArgs = {
  conclusionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  currency?: InputMaybe<TimeBasedValueCurrencyInput>;
  enableTrainingPackage?: InputMaybe<Scalars['Boolean']['input']>;
  expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<ClearableStringInput>;
  onCall?: InputMaybe<TimeBasedValueClearableNetOnCallRateInput>;
  overtimeRate?: InputMaybe<TimeBasedValueClearableCentsInput>;
  overwrittenPromisorTransferBankAccountNumber?: InputMaybe<ClearableBankAccountNumberInput>;
  position?: InputMaybe<TimeBasedValueClearableStringInput>;
  progressionSchemeId?: InputMaybe<TimeBasedValueClearableProgressionSchemeIdInput>;
  promiseeCompanyTransferBankAccountNumber?: InputMaybe<BankAccountNumberInput>;
  promisorId?: InputMaybe<TimeBasedValueCompanyIdInput>;
  rate?: InputMaybe<TimeBasedValueNetRateInput>;
  scopeOfWork?: InputMaybe<TimeBasedValueStringInput>;
  separatePaymentForBenefits?: InputMaybe<TimeBasedValueBooleanInput>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  vat?: InputMaybe<TimeBasedValueVatTypeInput>;
};


export type ContractMutationUpdateBenefitVariantNoteArgs = {
  assignedVariant: Scalars['AssignedVariantId']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type ContractMutationUpdateEmploymentContractArgs = {
  annualLeaveEntitlement?: InputMaybe<AnnualLeaveEntitlementInput>;
  applyRemoteWorkReimbursement?: InputMaybe<TimeBasedValueBooleanInput>;
  conclusionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  copyrightCosts?: InputMaybe<TimeBasedValueClearableBasisPointInput>;
  currency?: InputMaybe<TimeBasedValueCurrencyInput>;
  enableTrainingPackage?: InputMaybe<Scalars['Boolean']['input']>;
  expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<ClearableStringInput>;
  onCall?: InputMaybe<TimeBasedValueClearableNetOnCallRateInput>;
  overtimeRate?: InputMaybe<TimeBasedValueClearableCentsInput>;
  overwrittenPromisorTransferBankAccountNumber?: InputMaybe<ClearableBankAccountNumberInput>;
  paidLeaveEntitlement?: InputMaybe<TimeBasedValueClearableDaysInput>;
  position?: InputMaybe<TimeBasedValueClearableStringInput>;
  ppk?: InputMaybe<TimeBasedValueClearableBasisPointInput>;
  progressionSchemeId?: InputMaybe<TimeBasedValueClearableProgressionSchemeIdInput>;
  promiseeTransferBankAccount?: InputMaybe<BankAccountInput>;
  promisorId?: InputMaybe<TimeBasedValueCompanyIdInput>;
  rate?: InputMaybe<TimeBasedValueNetRateInput>;
  scopeOfWork?: InputMaybe<TimeBasedValueStringInput>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  taxDeductibleCosts?: InputMaybe<TimeBasedValueClearableDeductibleCostsTypeInput>;
  workingTime?: InputMaybe<TimeBasedValueWorkingTimeInput>;
};


export type ContractMutationUpdateSubcontractArgs = {
  conclusionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<ClearableStringInput>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type ContractMutationUpsertBonusArgs = {
  input: BonusInput;
};

export type ContractResponse = {
  readonly __typename?: 'ContractResponse';
  readonly value: Contract;
};

export type ContractResponseOrNfsError = ContractResponse | NfsError;

export type ContractSalaryDetails = {
  readonly absenceDays: Scalars['Days']['output'];
  readonly contractId: Scalars['ContractId']['output'];
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly flag?: Maybe<ContractSalaryDetailsFlagColor>;
  readonly isBonusApprovalRequired: Scalars['Boolean']['output'];
  readonly isTimeReportApprovalRequired: Scalars['Boolean']['output'];
  readonly isTimeReportCompleted: Scalars['Boolean']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly requiredWorkedTime: Scalars['Minutes']['output'];
  readonly salaryState: SalaryState;
  readonly shouldCheckIfBenefitInvoicePaymentIsRequired: Scalars['Boolean']['output'];
  readonly totalPayout?: Maybe<NetGross>;
  readonly transferAmount?: Maybe<Scalars['Cents']['output']>;
  readonly transferDeduction?: Maybe<TransferDeduction>;
  readonly transferTitle: Scalars['String']['output'];
  readonly workTotalTime: Scalars['Minutes']['output'];
  readonly yearMonth: Scalars['YearMonth']['output'];
};

export type ContractSalaryDetailsAdditionalData = {
  readonly __typename?: 'ContractSalaryDetailsAdditionalData';
  readonly contractId: Scalars['ContractId']['output'];
  readonly incomeDetails: IncomeDetails;
  readonly timeReportValidations: ReadonlyArray<TimeReportValidation>;
  readonly yearMonth: Scalars['YearMonth']['output'];
};

export type ContractSalaryDetailsAdditionalDataOrNfsError = ContractSalaryDetailsAdditionalData | NfsError;

export const ContractSalaryDetailsFlagColor = {
  BLACK: 'Black',
  BLUE: 'Blue',
  GREEN: 'Green',
  GREY: 'Grey',
  MAGENTA: 'Magenta',
  ORANGE: 'Orange',
  PURPLE: 'Purple',
  RED: 'Red',
  TEAL: 'Teal',
  YELLOW: 'Yellow'
} as const;

export type ContractSalaryDetailsFlagColor = typeof ContractSalaryDetailsFlagColor[keyof typeof ContractSalaryDetailsFlagColor];
export type ContractSalaryDetailsId = {
  readonly __typename?: 'ContractSalaryDetailsId';
  readonly contractId: Scalars['ContractId']['output'];
  readonly yearMonth: Scalars['YearMonth']['output'];
};

export type ContractSalaryDetailsIdInput = {
  readonly contractId: Scalars['ContractId']['input'];
  readonly yearMonth: Scalars['YearMonth']['input'];
};

export type ContractSalaryDetailsMutation = {
  readonly __typename?: 'ContractSalaryDetailsMutation';
  readonly invoiceDetails: InvoiceDetailsOperations;
  readonly update: ContractSalaryDetailsResponseOrNfsError;
  readonly workTransferProtocol: WorkTransferProtocolOperations;
};


export type ContractSalaryDetailsMutationUpdateArgs = {
  accountingDataInput?: InputMaybe<ClearableAccountingDataInput>;
  adjustGrossValue?: InputMaybe<ClearableGrossAdjustmentInput>;
  entityVersion: Scalars['EntityVersion']['input'];
  flag?: InputMaybe<ClearableContractSalaryDetailsFlagColorInput>;
  note?: InputMaybe<ClearableStringInput>;
  transferDeduction?: InputMaybe<ClearableTransferDeductionInput>;
  transferTitle?: InputMaybe<ClearableStringInput>;
};

export type ContractSalaryDetailsResponse = {
  readonly __typename?: 'ContractSalaryDetailsResponse';
  readonly value: ContractSalaryDetails;
};

export type ContractSalaryDetailsResponseOrNfsError = ContractSalaryDetailsResponse | NfsError;

export const ContractStatus = {
  ACTIVE: 'Active',
  CONCLUDED: 'Concluded',
  TERMINATED: 'Terminated'
} as const;

export type ContractStatus = typeof ContractStatus[keyof typeof ContractStatus];
export const ContractType = {
  B2B: 'B2B',
  MANAGEMENT: 'Management',
  SUBCONTRACT: 'Subcontract',
  UZ: 'UZ',
  UOD: 'UoD',
  UOP: 'UoP'
} as const;

export type ContractType = typeof ContractType[keyof typeof ContractType];
export const ContractsCount = {
  MULTIPLE: 'Multiple',
  ONE: 'One',
  ZERO: 'Zero'
} as const;

export type ContractsCount = typeof ContractsCount[keyof typeof ContractsCount];
export type CopyrightsDrawer = AbstractDrawer & {
  readonly __typename?: 'CopyrightsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly showUserPreview?: Maybe<Scalars['Boolean']['output']>;
  readonly visible: Scalars['Boolean']['output'];
};

export type CostAndRevenueItem = {
  readonly __typename?: 'CostAndRevenueItem';
  readonly date: Scalars['LocalDate']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly netValue: CentsWithCurrency;
  readonly serviceLine?: Maybe<Scalars['String']['output']>;
  readonly tpe: CostAndRevenueItemType;
};

export type CostAndRevenueItemDrawer = AbstractDrawer & {
  readonly __typename?: 'CostAndRevenueItemDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredProjectId: Scalars['ProjectId']['output'];
  readonly selectedCostAndRevenueItemIndex?: Maybe<Scalars['Int']['output']>;
  readonly visible: Scalars['Boolean']['output'];
};

export type CostAndRevenueItemInput = {
  readonly date: Scalars['LocalDate']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly netValue: CentsWithCurrencyInput;
  readonly serviceLine?: InputMaybe<Scalars['String']['input']>;
  readonly tpe: CostAndRevenueItemType;
};

export const CostAndRevenueItemType = {
  COST: 'Cost',
  REVENUE: 'Revenue'
} as const;

export type CostAndRevenueItemType = typeof CostAndRevenueItemType[keyof typeof CostAndRevenueItemType];
export type CostInvoice = {
  readonly __typename?: 'CostInvoice';
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly contractor: CostInvoiceContractor;
  readonly currency: Scalars['Currency']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly grossValue: Scalars['Cents']['output'];
  readonly isCorrective: Scalars['Boolean']['output'];
  readonly issueDate: Scalars['LocalDate']['output'];
  readonly ksefNumber?: Maybe<Scalars['String']['output']>;
  readonly ksefPreviewSource?: Maybe<Scalars['String']['output']>;
  readonly number: Scalars['InvoiceNumber']['output'];
  readonly paymentDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly previewUrls: ReadonlyArray<Scalars['String']['output']>;
  readonly saldeoDocumentId: SaldeoDocumentId;
  readonly saldeoDocumentUrl?: Maybe<Scalars['String']['output']>;
  readonly saleDate: Scalars['LocalDate']['output'];
};

export type CostInvoiceContractor = {
  readonly __typename?: 'CostInvoiceContractor';
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly taxNumber?: Maybe<Scalars['TaxNumber']['output']>;
};

export type CostInvoiceOrNfsError = CostInvoice | NfsError;

export type CostRechargeBonus = Bonus & {
  readonly __typename?: 'CostRechargeBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type CostSummariesDrawer = AbstractDrawer & {
  readonly __typename?: 'CostSummariesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type CreateAbsenceRecordInput = {
  readonly absenceType: AbsenceTypeInput;
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly contractId: Scalars['ContractId']['input'];
  readonly customDurationPerDay?: InputMaybe<Scalars['Minutes']['input']>;
  readonly from: Scalars['LocalDate']['input'];
  readonly id: Scalars['AbsenceRecordId']['input'];
  readonly isOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
  readonly to: Scalars['LocalDate']['input'];
};

export type CreateAppreciationBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateBenefitDrawer = AbstractDrawer & {
  readonly __typename?: 'CreateBenefitDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly newBenefitId?: Maybe<Scalars['BenefitId']['output']>;
  readonly requiredAlternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['output'];
  readonly requiredGroupType: BenefitGroupType;
  readonly visible: Scalars['Boolean']['output'];
};

export type CreateBusinessTravelBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateClientReferralBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateConferenceBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateCostRechargeBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly description: Scalars['String']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmployeeReferralBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly referredEmployeeContractId: Scalars['ContractId']['input'];
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateInternalProjectAssignmentInput = {
  readonly periods: ReadonlyArray<InternalProjectAssignmentPeriodInput>;
  readonly userId: Scalars['UserId']['input'];
};

export type CreateInvoiceDetailsInput = {
  readonly adminNote?: InputMaybe<Scalars['String']['input']>;
  readonly correct?: InputMaybe<Scalars['Boolean']['input']>;
  readonly file?: InputMaybe<Scalars['Upload']['input']>;
  readonly id: Scalars['InvoiceDetailsId']['input'];
  readonly number?: InputMaybe<Scalars['InvoiceNumber']['input']>;
};

export type CreateLanguageLearningBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly language: Language;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly quarterYear: QuarterYearInput;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateOnCallRecordInput = {
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly contractId: Scalars['ContractId']['input'];
  readonly date: Scalars['LocalDate']['input'];
  readonly dayShift: Scalars['Boolean']['input'];
  readonly id: Scalars['OnCallRecordId']['input'];
  readonly nightShift: Scalars['Boolean']['input'];
  readonly projectId: Scalars['ProjectId']['input'];
};

export type CreateOtherBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly description: Scalars['String']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateProjectAssignmentInput = {
  readonly periods: ReadonlyArray<ProjectAssignmentPeriodInput>;
  readonly userId: Scalars['UserId']['input'];
};

export type CreateRemoteWorkEquipmentBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateSalesCommissionsBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateSeverancePayBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateShareholderDividendBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateTrainingPackageBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateTrainingPackageExternalDeductionValueInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly taxation?: InputMaybe<TaxationInput>;
};

export type CreateVariantDrawer = AbstractDrawer & {
  readonly __typename?: 'CreateVariantDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredParentId: Scalars['BenefitId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type CreateWorkRecordInput = {
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly contractId: Scalars['ContractId']['input'];
  readonly date: Scalars['LocalDate']['input'];
  readonly duration?: InputMaybe<Scalars['Minutes']['input']>;
  readonly id: Scalars['WorkRecordId']['input'];
  readonly overtime: Scalars['Boolean']['input'];
  readonly projectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly remoteWork: Scalars['Boolean']['input'];
  readonly workTagId: Scalars['WorkTagId']['input'];
  readonly workTime?: InputMaybe<WorkTimeInput>;
};

export type CreatedBy = ByAdmin | ByUser;

export type CrossSell = {
  readonly __typename?: 'CrossSell';
  readonly client?: Maybe<Company>;
  readonly description: Scalars['String']['output'];
  readonly project?: Maybe<Project>;
  readonly space?: Maybe<Space>;
};

export type CrossSellInput = {
  readonly client?: InputMaybe<Scalars['CompanyId']['input']>;
  readonly description: Scalars['String']['input'];
  readonly project?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly space?: InputMaybe<Scalars['SpaceId']['input']>;
};

/** Represents value of assets in two currencies, e.g. contract in USD (original currency) included to income summary in PLN (target currency) */
export type CurrencyConversion = {
  readonly __typename?: 'CurrencyConversion';
  readonly originalCurrency: CentsWithCurrency;
  readonly targetCurrency: CentsWithCurrency;
};

export type DailyAndHourlyRateNet = {
  readonly __typename?: 'DailyAndHourlyRateNet';
  readonly daily: Scalars['Cents']['output'];
  readonly hourly: Scalars['Cents']['output'];
};

export type DailyIncomeRow = {
  readonly __typename?: 'DailyIncomeRow';
  readonly rateAmount: NetGross;
  readonly value: NetGross;
  readonly workDays: Scalars['WorkDays']['output'];
};

export type DaysBalance = {
  readonly __typename?: 'DaysBalance';
  readonly available: Scalars['Days']['output'];
  readonly entitlement: Scalars['Days']['output'];
  readonly used: Scalars['Days']['output'];
};

export type DaysBalanceOrNfsError = DaysBalance | NfsError;

export const DeductibleCostsType = {
  COPYRIGHT: 'Copyright',
  NORMAL: 'Normal',
  RAISED: 'Raised'
} as const;

export type DeductibleCostsType = typeof DeductibleCostsType[keyof typeof DeductibleCostsType];
export type DirectContractUpdateOneOfInput = {
  readonly b2b?: InputMaybe<B2BContractUpdateInput>;
  readonly employment?: InputMaybe<EmploymentContractUpdateInput>;
};

export type Desk = {
  readonly __typename?: 'Desk';
  readonly blocked: Scalars['Boolean']['output'];
  readonly id: Scalars['DeskId']['output'];
  readonly monitors: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly pedestalNumber?: Maybe<Scalars['String']['output']>;
  readonly roomId: Scalars['RoomId']['output'];
  readonly standing: Scalars['Boolean']['output'];
};

export type DeskAssignment = {
  readonly __typename?: 'DeskAssignment';
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly createdBy: Scalars['AdminId']['output'];
  readonly desk: ReservedResource;
  readonly from: Scalars['LocalDate']['output'];
  readonly id: Scalars['DeskAssignmentId']['output'];
  readonly to?: Maybe<Scalars['LocalDate']['output']>;
  readonly user: User;
};

export type DeskAssignmentDrawer = AbstractDrawer & {
  readonly __typename?: 'DeskAssignmentDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredDeskId: Scalars['DeskId']['output'];
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type DeskAssignmentOrNfsError = DeskAssignment | NfsError;

export type DeskDrawer = AbstractDrawer & {
  readonly __typename?: 'DeskDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly deskId?: Maybe<Scalars['DeskId']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly requiredRoomId: Scalars['RoomId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type DeskOrNfsError = Desk | NfsError;

export type DirectReporting = {
  readonly __typename?: 'DirectReporting';
  readonly assignedProjects: ListOfProjectAssignmentOrUnauthorized;
  readonly operationalLead: TimeBasedOptClearableUser;
  readonly practiceLead: TimeBasedOptClearableUser;
  readonly primaryProjectId: TimeBasedOptClearableProjectId;
  readonly space: TimeBasedSpace;
};


export type DirectReportingAssignedProjectsArgs = {
  orderByFirstPositionStartDate?: InputMaybe<SortOrder>;
  status_oneOf?: InputMaybe<ReadonlyArray<ProjectAssignmentStatus>>;
};

export type DirectReportingDrawer = AbstractDrawer & {
  readonly __typename?: 'DirectReportingDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly effectiveDate?: Maybe<Scalars['Date']['output']>;
  readonly highlight?: Maybe<TimeBasedHighlight>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type DownloadableExternallyHostedFileUrl = {
  readonly __typename?: 'DownloadableExternallyHostedFileUrl';
  readonly downloadUrl: Scalars['URI']['output'];
  readonly fileName: Scalars['String']['output'];
  readonly openUrl: Scalars['URI']['output'];
};

export type DownloadableFileUrl = {
  readonly __typename?: 'DownloadableFileUrl';
  readonly fileName: Scalars['String']['output'];
  readonly url: Scalars['URI']['output'];
};

export type DownloadableFileUrlOrNfsError = DownloadableFileUrl | NfsError;

export type DraftPreviewResponse = {
  readonly __typename?: 'DraftPreviewResponse';
  readonly draft: ContractDraft;
  readonly fileUrl: GoogleDocUrl;
};

export type DraftPreviewResponseOrNfsError = DraftPreviewResponse | NfsError;

export type DuplicatedEntityError = UserError & {
  readonly __typename?: 'DuplicatedEntityError';
  readonly desc?: Maybe<Scalars['String']['output']>;
  readonly itemId: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly typeName: Scalars['String']['output'];
};

export type EdgeAssignedVariant = {
  readonly __typename?: 'EdgeAssignedVariant';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: AssignedVariant;
};

export type EdgeB2BContractSalaryDetails = {
  readonly __typename?: 'EdgeB2BContractSalaryDetails';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: B2BContractSalaryDetails;
};

export type EdgeBankTransfer = {
  readonly __typename?: 'EdgeBankTransfer';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: BankTransfer;
};

export type EdgeClientContract = {
  readonly __typename?: 'EdgeClientContract';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: ClientContract;
};

export type EdgeCompany = {
  readonly __typename?: 'EdgeCompany';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: Company;
};

export type EdgeContract = {
  readonly __typename?: 'EdgeContract';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: Contract;
};

export type EdgeContractDraft = {
  readonly __typename?: 'EdgeContractDraft';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: ContractDraft;
};

export type EdgeEmploymentContractSalaryDetails = {
  readonly __typename?: 'EdgeEmploymentContractSalaryDetails';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: EmploymentContractSalaryDetails;
};

export type EdgeOfficeReservation = {
  readonly __typename?: 'EdgeOfficeReservation';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: OfficeReservation;
};

export type EdgeProject = {
  readonly __typename?: 'EdgeProject';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: Project;
};

export type EdgeRevenueAdministrationOffice = {
  readonly __typename?: 'EdgeRevenueAdministrationOffice';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: RevenueAdministrationOffice;
};

export type EdgeSpace = {
  readonly __typename?: 'EdgeSpace';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: Space;
};

export type EdgeUser = {
  readonly __typename?: 'EdgeUser';
  readonly cursor: Scalars['Cursor']['output'];
  readonly node: User;
};

export type EditBenefitDrawer = AbstractDrawer & {
  readonly __typename?: 'EditBenefitDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredBenefitId: Scalars['BenefitId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditBenefitVariantDrawer = AbstractDrawer & {
  readonly __typename?: 'EditBenefitVariantDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly effectiveDate?: Maybe<Scalars['Date']['output']>;
  readonly highlight?: Maybe<TimeBasedHighlight>;
  readonly id: Scalars['ID']['output'];
  readonly requiredVariantId: Scalars['BenefitId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditBenefitVariantPriceDrawer = AbstractDrawer & {
  readonly __typename?: 'EditBenefitVariantPriceDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly effectiveDate?: Maybe<Scalars['Date']['output']>;
  readonly highlight?: Maybe<TimeBasedHighlight>;
  readonly id: Scalars['ID']['output'];
  readonly requiredVariantId: Scalars['BenefitId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditClientContractDrawer = AbstractDrawer & {
  readonly __typename?: 'EditClientContractDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredClientContractId: Scalars['ClientContractId']['output'];
  readonly requiredCompanyId: Scalars['CompanyId']['output'];
  readonly requiredCompanyType: ReadonlyArray<CompanyType>;
  readonly visible: Scalars['Boolean']['output'];
};

export type EditDeskRequestDrawer = AbstractDrawer & {
  readonly __typename?: 'EditDeskRequestDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly requiredReservationRequestId: Scalars['ReservationRequestId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditOfficeDrawer = AbstractDrawer & {
  readonly __typename?: 'EditOfficeDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditOfficeSettingsDrawer = AbstractDrawer & {
  readonly __typename?: 'EditOfficeSettingsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditParkingRequestDrawer = AbstractDrawer & {
  readonly __typename?: 'EditParkingRequestDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly requiredReservationRequestId: Scalars['ReservationRequestId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditProfileAdditionalDataDrawer = AbstractDrawer & {
  readonly __typename?: 'EditProfileAdditionalDataDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditProfileAddressDrawer = AbstractDrawer & {
  readonly __typename?: 'EditProfileAddressDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditProfileBasicInfoDrawer = AbstractDrawer & {
  readonly __typename?: 'EditProfileBasicInfoDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditProjectCrossSellDrawer = AbstractDrawer & {
  readonly __typename?: 'EditProjectCrossSellDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredProjectId: Scalars['ProjectId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditProjectDrawer = AbstractDrawer & {
  readonly __typename?: 'EditProjectDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredProjectId: Scalars['ProjectId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditProjectTechStackAndCompetencesDrawer = AbstractDrawer & {
  readonly __typename?: 'EditProjectTechStackAndCompetencesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredProjectId: Scalars['ProjectId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditSkillsAndCertificatesDrawer = AbstractDrawer & {
  readonly __typename?: 'EditSkillsAndCertificatesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditSocialMediaHandlesDrawer = AbstractDrawer & {
  readonly __typename?: 'EditSocialMediaHandlesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditSpaceDrawer = AbstractDrawer & {
  readonly __typename?: 'EditSpaceDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly initialTab?: Maybe<EditSpaceDrawerTabs>;
  readonly requiredSpaceId: Scalars['SpaceId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export const EditSpaceDrawerTabs = {
  DETAILS: 'DETAILS',
  DIRECTORS: 'DIRECTORS'
} as const;

export type EditSpaceDrawerTabs = typeof EditSpaceDrawerTabs[keyof typeof EditSpaceDrawerTabs];
export type EmailInput = {
  readonly body: Scalars['String']['input'];
  readonly cc: ReadonlyArray<Scalars['EmailAddress']['input']>;
  readonly from?: InputMaybe<Scalars['EmailAddress']['input']>;
  readonly subject: Scalars['String']['input'];
  readonly to: ReadonlyArray<Scalars['EmailAddress']['input']>;
};

export type EmployeeDueDatesDrawer = AbstractDrawer & {
  readonly __typename?: 'EmployeeDueDatesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EmployeeReferralBonus = Bonus & {
  readonly __typename?: 'EmployeeReferralBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly referredEmployeeContract: Contract;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type EmploymentBankAccountDrawer = AbstractDrawer & {
  readonly __typename?: 'EmploymentBankAccountDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly contractId?: Maybe<Scalars['ContractId']['output']>;
  readonly editing: Scalars['Boolean']['output'];
  readonly highlight?: Maybe<TimeBasedHighlight>;
  readonly id: Scalars['ID']['output'];
  readonly requiredPromiseeId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EmploymentContract = Contract & {
  readonly __typename?: 'EmploymentContract';
  readonly annualLeaveEntitlement: OptionalAnnualLeaveEntitlementOrUnauthorized;
  readonly applyRemoteWorkReimbursement: TimeBasedBooleanOrUnauthorized;
  readonly assignedVariants: ListOfAssignedVariantOrUnauthorized;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly bonuses: BonusesOrUnauthorized;
  readonly conclusionDate: LocalDateOrUnauthorized;
  readonly conclusionDatePromiseeSnapshot: User;
  readonly conclusionDatePromisorSnapshot: Company;
  readonly conclusionLocation: StringOrUnauthorized;
  readonly copyrightCosts: TimeBasedOptClearableBasisPointOrUnauthorized;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly currency: TimeBasedCurrencyOrUnauthorized;
  /** We do not have related data (time reports etc.) before this date in the system */
  readonly dataInSystemSince: Scalars['LocalDate']['output'];
  readonly enableTrainingPackage: BooleanOrUnauthorized;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  /** It just an information. Should not be used for business logic as contract may be extended or terminated earlier */
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly fileUri: OptionalUriOrUnauthorized;
  readonly holidayCalendar: HolidayCalendar;
  readonly id: Scalars['ContractId']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes: OptionalStringOrUnauthorized;
  readonly onCall: TimeBasedOptClearableOnCallRateOrUnauthorized;
  readonly overtimeRate: TimeBasedOptClearableNetGrossOrUnauthorized;
  readonly paidLeaveEntitlement: TimeBasedOptClearableDaysOrUnauthorized;
  readonly position: TimeBasedOptClearableString;
  readonly ppk: TimeBasedOptClearableBasisPointOrUnauthorized;
  readonly progressionScheme: TimeBasedOptClearableProgressionSchemeOrUnauthorized;
  readonly promisee: User;
  readonly promiseeId: Scalars['UserId']['output'];
  readonly promiseeTransferBankAccount: BankAccountOrUnauthorized;
  readonly promisor: TimeBasedCompany;
  readonly promisorId: Scalars['CompanyId']['output'];
  readonly promisorRepresentative: StringOrUnauthorized;
  readonly promisorTransferBankAccount: PromisorTransferBankAccount;
  readonly rate: TimeBasedRateOrUnauthorized;
  readonly scopeOfWork: TimeBasedStringOrUnauthorized;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly status: ContractStatus;
  readonly taxDeductibleCosts: TimeBasedOptClearableDeductibleCostsTypeOrUnauthorized;
  /** Non-empty value indicates actual (or effective) termination date */
  readonly terminationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly type: EmploymentContractType;
  readonly workTransferProtocols: ListOfWorkTransferProtocolOrUnauthorized;
  readonly workingTime: TimeBasedWorkingTimeOrUnauthorized;
};


export type EmploymentContractAssignedVariantsArgs = {
  activeOnly: Scalars['Boolean']['input'];
};


export type EmploymentContractWorkTransferProtocolsArgs = {
  year: Scalars['Year']['input'];
};

export type EmploymentContractDraft = ContractDraft & {
  readonly __typename?: 'EmploymentContractDraft';
  readonly applyRemoteWorkReimbursement: Scalars['Boolean']['output'];
  readonly conclusionDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly conclusionLocation?: Maybe<Scalars['String']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly copyrightCosts?: Maybe<Scalars['BasisPoint']['output']>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly currency?: Maybe<Scalars['Currency']['output']>;
  readonly documentTemplate?: Maybe<ContractDocumentTemplate>;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly holidayCalendar?: Maybe<HolidayCalendar>;
  readonly id: Scalars['UserId']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly onCall?: Maybe<OnCallRate>;
  readonly overtimeRate?: Maybe<NetGross>;
  readonly paidLeaveEntitlement?: Maybe<Scalars['Days']['output']>;
  readonly position?: Maybe<Scalars['String']['output']>;
  readonly ppk?: Maybe<Scalars['BasisPoint']['output']>;
  readonly promisee: User;
  readonly promiseeTransferBankAccount?: Maybe<BankAccount>;
  readonly promisor: Company;
  readonly promisorRepresentative?: Maybe<Scalars['String']['output']>;
  readonly promisorTransferBankAccount: PromisorTransferBankAccount;
  readonly rate?: Maybe<Rate>;
  readonly scopeOfWork?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly taxDeductibleCosts?: Maybe<DeductibleCostsType>;
  readonly type: EmploymentContractType;
  readonly workingTime?: Maybe<WorkingTime>;
};

export type EmploymentContractDraftDrawer = AbstractDrawer & {
  readonly __typename?: 'EmploymentContractDraftDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly editing: Scalars['Boolean']['output'];
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly requiredEmploymentContractType: EmploymentContractType;
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EmploymentContractDraftOrNfsError = EmploymentContractDraft | NfsError;

export type EmploymentContractNoteDrawer = AbstractDrawer & {
  readonly __typename?: 'EmploymentContractNoteDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly contractId?: Maybe<Scalars['ContractId']['output']>;
  readonly editing: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly requiredPromiseeId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EmploymentContractOrNfsError = EmploymentContract | NfsError;

export type EmploymentContractSalaryDetails = ContractSalaryDetails & {
  readonly __typename?: 'EmploymentContractSalaryDetails';
  readonly absenceDays: Scalars['Days']['output'];
  readonly accountingData?: Maybe<AccountingData>;
  readonly contract: EmploymentContract;
  readonly contractId: Scalars['ContractId']['output'];
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly flag?: Maybe<ContractSalaryDetailsFlagColor>;
  readonly isBonusApprovalRequired: Scalars['Boolean']['output'];
  readonly isTimeReportApprovalRequired: Scalars['Boolean']['output'];
  readonly isTimeReportCompleted: Scalars['Boolean']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly requiredWorkedTime: Scalars['Minutes']['output'];
  readonly salaryState: SalaryState;
  readonly shouldCheckIfBenefitInvoicePaymentIsRequired: Scalars['Boolean']['output'];
  readonly totalPayout?: Maybe<NetGross>;
  readonly transferAmount?: Maybe<Scalars['Cents']['output']>;
  readonly transferDeduction?: Maybe<TransferDeduction>;
  readonly transferTitle: Scalars['String']['output'];
  readonly workTotalTime: Scalars['Minutes']['output'];
  readonly workTransferProtocols: ReadonlyArray<WorkTransferProtocol>;
  readonly yearMonth: Scalars['YearMonth']['output'];
};

export const EmploymentContractType = {
  MANAGEMENT: 'Management',
  UZ: 'UZ',
  UOD: 'UoD',
  UOP: 'UoP'
} as const;

export type EmploymentContractType = typeof EmploymentContractType[keyof typeof EmploymentContractType];
export type EmploymentContractUpdateInput = {
  readonly annualLeaveEntitlement?: InputMaybe<AnnualLeaveEntitlementInput>;
  readonly applyRemoteWorkReimbursement?: InputMaybe<TimeBasedValueBooleanInput>;
  readonly conclusionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly copyrightCosts?: InputMaybe<TimeBasedValueClearableBasisPointInput>;
  readonly currency?: InputMaybe<TimeBasedValueCurrencyInput>;
  readonly enableTrainingPackage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<ClearableStringInput>;
  readonly onCall?: InputMaybe<TimeBasedValueClearableNetOnCallRateInput>;
  readonly overtimeRate?: InputMaybe<TimeBasedValueClearableCentsInput>;
  readonly overwrittenPromisorTransferBankAccountNumber?: InputMaybe<ClearableBankAccountNumberInput>;
  readonly paidLeaveEntitlement?: InputMaybe<TimeBasedValueClearableDaysInput>;
  readonly position?: InputMaybe<TimeBasedValueClearableStringInput>;
  readonly ppk?: InputMaybe<TimeBasedValueClearableBasisPointInput>;
  readonly progressionSchemeId?: InputMaybe<TimeBasedValueClearableProgressionSchemeIdInput>;
  readonly promiseeTransferBankAccount?: InputMaybe<BankAccountInput>;
  readonly promisorId?: InputMaybe<TimeBasedValueCompanyIdInput>;
  readonly rate?: InputMaybe<TimeBasedValueNetRateInput>;
  readonly scopeOfWork?: InputMaybe<TimeBasedValueStringInput>;
  readonly startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly taxDeductibleCosts?: InputMaybe<TimeBasedValueClearableDeductibleCostsTypeInput>;
  readonly workingTime?: InputMaybe<TimeBasedValueWorkingTimeInput>;
};

export type EmploymentIncompleteDataStateSummary = {
  readonly __typename?: 'EmploymentIncompleteDataStateSummary';
  readonly stateDescriptions: ReadonlyArray<IncompleteDataDescription>;
  readonly transfersSummary: EmploymentTransfersSummary;
};

export type EmploymentPromisorTransfersSummaries = {
  readonly __typename?: 'EmploymentPromisorTransfersSummaries';
  readonly incompleteDataState: EmploymentIncompleteDataStateSummary;
  readonly paymentDisbursedState: EmploymentTransfersSummary;
  readonly promisorId: Scalars['CompanyId']['output'];
  readonly readyState: EmploymentTransfersSummary;
  readonly totalCount: Scalars['Int']['output'];
};

export type EmploymentSalaryDetailsDrawer = AbstractDrawer & {
  readonly __typename?: 'EmploymentSalaryDetailsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredMonth: Scalars['YearMonth']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

/** payout = gross value with following components: hourly rate * hours/monthly rate + overtime + on calls + bonuses */
export type EmploymentTimeReportStats = TimeReportStats & {
  readonly __typename?: 'EmploymentTimeReportStats';
  readonly currentTimeBalance: TimeBalance;
  /** calculate only when from-to is included in exactly one flex period and contract type is UoP */
  readonly flexTime?: Maybe<TimeBalance>;
  readonly incomeDetails: ListOfIncomeDetailsOrUnauthorized;
  readonly overtime: Scalars['Minutes']['output'];
  readonly reportedLeaveDays: ReportedLeaveDays;
  readonly timeBalanceAtEndOfMonth: TimeBalance;
};

export type EmploymentTransfersSummaries = {
  readonly __typename?: 'EmploymentTransfersSummaries';
  readonly byPromisor: ReadonlyArray<EmploymentPromisorTransfersSummaries>;
  readonly incompleteDataState: EmploymentIncompleteDataStateSummary;
  readonly paymentDisbursedState: EmploymentTransfersSummary;
  readonly readyState: EmploymentTransfersSummary;
  readonly totalCount: Scalars['Int']['output'];
};

export type EmploymentTransfersSummary = {
  readonly __typename?: 'EmploymentTransfersSummary';
  readonly contractCount: Scalars['Int']['output'];
  readonly ppkAmountsByCurrency: ReadonlyArray<CurrencyConversion>;
  readonly salariesByCurrency: ReadonlyArray<CurrencyConversion>;
  readonly taxPrepaymentsByCurrency: ReadonlyArray<CurrencyConversion>;
  readonly taxRefundsByCurrency: ReadonlyArray<CurrencyConversion>;
  readonly totalPpkAmount: CentsWithCurrency;
  readonly totalSalary: CentsWithCurrency;
  readonly totalTaxPrepayment: CentsWithCurrency;
  readonly totalTaxRefund: CentsWithCurrency;
  readonly totalTransferAmount: CentsWithCurrency;
  readonly totalZusContribution: CentsWithCurrency;
  readonly transferAmountsByCurrency: ReadonlyArray<CurrencyConversion>;
  readonly zusContributionsByCurrency: ReadonlyArray<CurrencyConversion>;
};

export type EmptyRequestInputError = UserError & {
  readonly __typename?: 'EmptyRequestInputError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type EntitiesNotFoundError = UserError & {
  readonly __typename?: 'EntitiesNotFoundError';
  readonly items: ReadonlyArray<Scalars['String']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly typeName?: Maybe<Scalars['String']['output']>;
};

export type EntityNotFoundError = UserError & {
  readonly __typename?: 'EntityNotFoundError';
  readonly item?: Maybe<Scalars['String']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly typeName?: Maybe<Scalars['String']['output']>;
};

export type EntityVersionMismatched = UserError & {
  readonly __typename?: 'EntityVersionMismatched';
  readonly currentVersion: Scalars['EntityVersion']['output'];
  readonly entityId: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly receivedVersion: Scalars['EntityVersion']['output'];
};

export const EuVatType = {
  AT: 'AT',
  BE: 'BE',
  BG: 'BG',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DK: 'DK',
  EE: 'EE',
  EL: 'EL',
  ES: 'ES',
  FI: 'FI',
  FR: 'FR',
  HR: 'HR',
  HU: 'HU',
  IE: 'IE',
  IT: 'IT',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  MT: 'MT',
  NL: 'NL',
  NO_EUVAT: 'NO_EUVAT',
  PL: 'PL',
  PT: 'PT',
  RO: 'RO',
  SE: 'SE',
  SI: 'SI',
  SK: 'SK',
  XI: 'XI'
} as const;

export type EuVatType = typeof EuVatType[keyof typeof EuVatType];
export type ExpectedPayment = {
  readonly __typename?: 'ExpectedPayment';
  readonly date: Scalars['LocalDate']['output'];
  readonly value: Scalars['Cents']['output'];
};

export type ExternalBeneficiary = {
  readonly __typename?: 'ExternalBeneficiary';
  readonly address: Address;
  readonly assignedVariants: ReadonlyArray<AssignedVariant>;
  readonly email: Scalars['EmailAddress']['output'];
  readonly employeeId: Scalars['UserId']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ExternalBeneficiaryId']['output'];
  readonly lastName: Scalars['String']['output'];
};

export type ExternalBeneficiaryOrNfsError = ExternalBeneficiary | NfsError;

export type FspResponseAssignedVariant = {
  readonly __typename?: 'FSPResponseAssignedVariant';
  readonly edges: ReadonlyArray<EdgeAssignedVariant>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseAssignedVariantOrNfsError = FspResponseAssignedVariant | NfsError;

export type FspResponseB2BContractSalaryDetails = {
  readonly __typename?: 'FSPResponseB2BContractSalaryDetails';
  readonly edges: ReadonlyArray<EdgeB2BContractSalaryDetails>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseB2BContractSalaryDetailsOrNfsError = FspResponseB2BContractSalaryDetails | NfsError;

export type FspResponseBankTransfer = {
  readonly __typename?: 'FSPResponseBankTransfer';
  readonly edges: ReadonlyArray<EdgeBankTransfer>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseBankTransferOrNfsError = FspResponseBankTransfer | NfsError;

export type FspResponseClientContract = {
  readonly __typename?: 'FSPResponseClientContract';
  readonly edges: ReadonlyArray<EdgeClientContract>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseClientContractOrNfsError = FspResponseClientContract | NfsError;

export type FspResponseCompany = {
  readonly __typename?: 'FSPResponseCompany';
  readonly edges: ReadonlyArray<EdgeCompany>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseCompanyOrNfsError = FspResponseCompany | NfsError;

export type FspResponseContract = {
  readonly __typename?: 'FSPResponseContract';
  readonly edges: ReadonlyArray<EdgeContract>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseContractDraft = {
  readonly __typename?: 'FSPResponseContractDraft';
  readonly edges: ReadonlyArray<EdgeContractDraft>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseContractDraftOrNfsError = FspResponseContractDraft | NfsError;

export type FspResponseContractOrNfsError = FspResponseContract | NfsError;

export type FspResponseEmploymentContractSalaryDetails = {
  readonly __typename?: 'FSPResponseEmploymentContractSalaryDetails';
  readonly edges: ReadonlyArray<EdgeEmploymentContractSalaryDetails>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseEmploymentContractSalaryDetailsOrNfsError = FspResponseEmploymentContractSalaryDetails | NfsError;

export type FspResponseOfficeReservation = {
  readonly __typename?: 'FSPResponseOfficeReservation';
  readonly edges: ReadonlyArray<EdgeOfficeReservation>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseOfficeReservationOrNfsError = FspResponseOfficeReservation | NfsError;

export type FspResponseProject = {
  readonly __typename?: 'FSPResponseProject';
  readonly edges: ReadonlyArray<EdgeProject>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseProjectOrNfsError = FspResponseProject | NfsError;

export type FspResponseRevenueAdministrationOffice = {
  readonly __typename?: 'FSPResponseRevenueAdministrationOffice';
  readonly edges: ReadonlyArray<EdgeRevenueAdministrationOffice>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseRevenueAdministrationOfficeOrNfsError = FspResponseRevenueAdministrationOffice | NfsError;

export type FspResponseSpace = {
  readonly __typename?: 'FSPResponseSpace';
  readonly edges: ReadonlyArray<EdgeSpace>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseSpaceOrNfsError = FspResponseSpace | NfsError;

export type FspResponseUser = {
  readonly __typename?: 'FSPResponseUser';
  readonly edges: ReadonlyArray<EdgeUser>;
  readonly filteredCount: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type FspResponseUserOrNfsError = FspResponseUser | NfsError;

export type FakturowniaProfile = {
  readonly __typename?: 'FakturowniaProfile';
  readonly id: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

export type File = {
  readonly __typename?: 'File';
  readonly value: DownloadableExternallyHostedFileUrl;
};

export type FilterAssignedVariantInput = {
  readonly active_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly all_search?: InputMaybe<Scalars['String']['input']>;
  readonly benefitId_oneOf?: InputMaybe<ReadonlyArray<Scalars['BenefitId']['input']>>;
  readonly buyerType_oneOf?: InputMaybe<ReadonlyArray<BenefitBuyerType>>;
  readonly contractId_oneOf?: InputMaybe<ReadonlyArray<Scalars['ContractId']['input']>>;
  readonly createdAt_gt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  readonly createdAt_lt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  readonly userId_oneOf?: InputMaybe<ReadonlyArray<Scalars['UserId']['input']>>;
  readonly variantId_oneOf?: InputMaybe<ReadonlyArray<Scalars['BenefitVariantId']['input']>>;
};

export type FilterBankTransferInput = {
  readonly allSearch?: InputMaybe<Scalars['String']['input']>;
  readonly amount_gte?: InputMaybe<Scalars['Cents']['input']>;
  readonly amount_lte?: InputMaybe<Scalars['Cents']['input']>;
  readonly bookDate_inDateRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  readonly createdAt_gte?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  readonly currency_in?: InputMaybe<ReadonlyArray<Scalars['Currency']['input']>>;
  readonly fromAccountNumber_in?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly fromName_like?: InputMaybe<Scalars['String']['input']>;
  readonly fromName_notLike?: InputMaybe<Scalars['String']['input']>;
  readonly operationDate_inDateRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  readonly status_eq?: InputMaybe<BankTransferStatus>;
  readonly title_like?: InputMaybe<Scalars['String']['input']>;
  readonly toAccountNumber_in?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly toName_like?: InputMaybe<Scalars['String']['input']>;
  readonly toName_notLike?: InputMaybe<Scalars['String']['input']>;
  readonly type_eq?: InputMaybe<BankTransferType>;
};

export type FilterClientContractInput = {
  readonly active_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly all_search?: InputMaybe<Scalars['String']['input']>;
  readonly contractDurationFrom_inRange?: InputMaybe<LocalDateRangeInput>;
  readonly currency_oneOf?: InputMaybe<ReadonlyArray<Scalars['Currency']['input']>>;
  readonly name_like?: InputMaybe<Scalars['String']['input']>;
  readonly promiseeId_oneOf?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']>>;
  readonly promisorId_oneOf?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']>>;
};

export type FilterCompanyInput = {
  readonly addressCountry_eq?: InputMaybe<Scalars['CountryCode']['input']>;
  readonly all_search?: InputMaybe<Scalars['String']['input']>;
  readonly companyType_notIn?: InputMaybe<ReadonlyArray<CompanyType>>;
  readonly companyType_oneOf?: InputMaybe<ReadonlyArray<CompanyType>>;
  readonly createdAt_gt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  readonly createdAt_lt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  readonly isPolishVat_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name_like?: InputMaybe<Scalars['String']['input']>;
  readonly registerId_startsWith?: InputMaybe<Scalars['String']['input']>;
  readonly regon_startsWith?: InputMaybe<Scalars['String']['input']>;
  readonly sectors_oneOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly taxNumber_startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type FilterContractInput = {
  readonly all_search?: InputMaybe<Scalars['String']['input']>;
  readonly conclusionDate_gt?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly conclusionDate_lt?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly contractHasCopyrightCosts_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contractId_oneOf?: InputMaybe<ReadonlyArray<Scalars['ContractId']['input']>>;
  readonly contractType_oneOf?: InputMaybe<ReadonlyArray<FilterContractType>>;
  readonly createdAt_gt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  readonly createdAt_lt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  readonly expectedEndDate_gt?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly expectedEndDate_lt?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly promiseeId_notIn?: InputMaybe<ReadonlyArray<Scalars['UserId']['input']>>;
  readonly promisorId_eq?: InputMaybe<Scalars['CompanyId']['input']>;
  readonly startDate_gt?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly startDate_lt?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly status_oneOf?: InputMaybe<ReadonlyArray<ContractStatus>>;
  readonly terminationDate_gt?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly terminationDate_lt?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type FilterContractSalaryDetailsInput = {
  readonly all_search?: InputMaybe<Scalars['String']['input']>;
  readonly contractHasCopyrightCosts_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contractIds_in?: InputMaybe<ReadonlyArray<Scalars['ContractId']['input']>>;
  readonly contractIds_notIn?: InputMaybe<ReadonlyArray<Scalars['ContractId']['input']>>;
  readonly contractType_oneOf?: InputMaybe<ReadonlyArray<ContractType>>;
  readonly flagColor_oneOf?: InputMaybe<ReadonlyArray<ContractSalaryDetailsFlagColor>>;
  readonly invoiceDeliveryType_eq?: InputMaybe<InvoiceDeliveryType>;
  readonly invoiceStatus_oneOf?: InputMaybe<ReadonlyArray<InvoiceStatus>>;
  readonly isBonusApprovalRequired_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isTimeReportApprovalRequired_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isTimeReportCompleted_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isTransferExecuted_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly promisorId_notIn?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']>>;
  readonly promisorId_oneOf?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']>>;
  readonly salaryStateKind_oneOf?: InputMaybe<ReadonlyArray<SalaryStateKind>>;
  readonly sender_oneOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly shouldCheckIfBenefitInvoicePaymentIsRequired_eq?: InputMaybe<Scalars['Boolean']['input']>;
};

export const FilterContractType = {
  B2B: 'B2B',
  MANAGEMENT: 'Management',
  SUBCONTRACT: 'Subcontract',
  UZ: 'UZ',
  UOD: 'UoD',
  UOP: 'UoP'
} as const;

export type FilterContractType = typeof FilterContractType[keyof typeof FilterContractType];
export type FilterOfficeReservationInput = {
  readonly date_gte?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly date_lte?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly officeId_eq?: InputMaybe<Scalars['OfficeId']['input']>;
  readonly pending_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly requestId_eq?: InputMaybe<Scalars['ReservationRequestId']['input']>;
  readonly resourceKind_eq?: InputMaybe<ResourceKind>;
  readonly userId_eq?: InputMaybe<Scalars['UserId']['input']>;
};

export type FilterProjectInput = {
  readonly all_search?: InputMaybe<Scalars['String']['input']>;
  readonly clientContractId_eq?: InputMaybe<Scalars['ClientContractId']['input']>;
  readonly clientId_eq?: InputMaybe<Scalars['CompanyId']['input']>;
  readonly competences_allOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly competences_oneOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly createdAt_gt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  readonly createdAt_lt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  readonly hasNoTeamMembers_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly member_like?: InputMaybe<Scalars['String']['input']>;
  readonly name_like?: InputMaybe<Scalars['String']['input']>;
  readonly spaceId_eq?: InputMaybe<Scalars['SpaceId']['input']>;
  readonly spaceId_oneOf?: InputMaybe<ReadonlyArray<Scalars['SpaceId']['input']>>;
  readonly status_notIn?: InputMaybe<ReadonlyArray<ProjectStatus>>;
  readonly status_oneOf?: InputMaybe<ReadonlyArray<ProjectStatus>>;
  readonly techStack_allOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly techStack_oneOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type FilterRevenueAdministrationOfficesInput = {
  readonly city?: InputMaybe<Scalars['String']['input']>;
  readonly searchPrefix?: InputMaybe<Scalars['String']['input']>;
  readonly voivodeship?: InputMaybe<Scalars['String']['input']>;
};

export type FilterSpaceInput = {
  readonly all_search?: InputMaybe<Scalars['String']['input']>;
  readonly hasMember_like?: InputMaybe<Scalars['String']['input']>;
  readonly hasOwner_like?: InputMaybe<Scalars['String']['input']>;
  readonly name_like?: InputMaybe<Scalars['String']['input']>;
  readonly spaceOwnerId_eq?: InputMaybe<Scalars['UserId']['input']>;
};

export type FilterUserInput = {
  readonly activityStatus_eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly all_search?: InputMaybe<Scalars['String']['input']>;
  readonly areaOfExpertise_oneOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly certificate_oneOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly certificates_allOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly createdAt_gt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  readonly createdAt_lt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  readonly hasContractOfType_oneOf?: InputMaybe<ReadonlyArray<ContractType>>;
  readonly hasContracts?: InputMaybe<ContractsCount>;
  readonly haveReportedWorkOnNoProject_in?: InputMaybe<Scalars['YearMonth']['input']>;
  readonly idType_eq?: InputMaybe<IdType>;
  readonly lead_oneOf?: InputMaybe<ReadonlyArray<Scalars['UserId']['input']>>;
  readonly office_oneOf?: InputMaybe<ReadonlyArray<Scalars['OfficeId']['input']>>;
  readonly operationalLead_oneOf?: InputMaybe<ReadonlyArray<Scalars['UserId']['input']>>;
  readonly position_oneOf?: InputMaybe<ReadonlyArray<Scalars['ClientPositionId']['input']>>;
  readonly practiceLead_oneOf?: InputMaybe<ReadonlyArray<Scalars['UserId']['input']>>;
  readonly progressionLevel_oneOf?: InputMaybe<ReadonlyArray<ProgressionLevel>>;
  readonly project_oneOf?: InputMaybe<ReadonlyArray<Scalars['ProjectId']['input']>>;
  readonly role_notIn?: InputMaybe<ReadonlyArray<CompanyRole>>;
  readonly role_oneOf?: InputMaybe<ReadonlyArray<CompanyRole>>;
  readonly skillsAndCompetences_allOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly skillsAndCompetences_oneOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly space_oneOf?: InputMaybe<ReadonlyArray<Scalars['SpaceId']['input']>>;
  readonly userId_oneOf?: InputMaybe<ReadonlyArray<Scalars['UserId']['input']>>;
};

export type ForeignKeyConstraintError = UserError & {
  readonly __typename?: 'ForeignKeyConstraintError';
  readonly dependentType: Scalars['String']['output'];
  readonly itemId: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly typeName: Scalars['String']['output'];
};

export type GmailConnection = {
  readonly __typename?: 'GmailConnection';
  readonly adminId: Scalars['AdminId']['output'];
  readonly aliases: ReadonlyArray<Scalars['EmailAddress']['output']>;
  readonly connectedEmail: Scalars['EmailAddress']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly selectedAlias?: Maybe<Scalars['EmailAddress']['output']>;
};

export type GmailConnectionOrNfsError = GmailConnection | NfsError;

export type GoogleDocUrl = {
  readonly __typename?: 'GoogleDocUrl';
  readonly url: Scalars['String']['output'];
};

export type GoogleSpreadsheetUrl = {
  readonly __typename?: 'GoogleSpreadsheetUrl';
  readonly url: Scalars['String']['output'];
};

export type GoogleSpreadsheetUrlOrNfsError = GoogleSpreadsheetUrl | NfsError;

export const GrossAdjustment = {
  MINUSONECENT: 'MinusOneCent',
  PLUSONECENT: 'PlusOneCent'
} as const;

export type GrossAdjustment = typeof GrossAdjustment[keyof typeof GrossAdjustment];
export type Highlight = {
  readonly id?: Maybe<Scalars['ID']['output']>;
};

export type HolidayCalendar = {
  readonly __typename?: 'HolidayCalendar';
  readonly calendarDays: ReadonlyArray<CalendarDay>;
  readonly id: HolidayCalendarId;
};

export const HolidayCalendarId = {
  CH_BERN: 'CH_BERN',
  CH_ZURYCH: 'CH_ZURYCH',
  DE_BW: 'DE_BW',
  DE_HE: 'DE_HE',
  PL: 'PL',
  SE: 'SE',
  UK_ENG: 'UK_ENG'
} as const;

export type HolidayCalendarId = typeof HolidayCalendarId[keyof typeof HolidayCalendarId];
export type HolidayMultipliers = {
  readonly __typename?: 'HolidayMultipliers';
  readonly beforeHolidayNight: OnCallMultiplier;
  readonly holidayDay: OnCallMultiplier;
  readonly holidayNight: OnCallMultiplier;
};

export type HolidaySummaryFileUrl = {
  readonly __typename?: 'HolidaySummaryFileUrl';
  readonly url: GoogleSpreadsheetUrl;
  readonly year: Scalars['Year']['output'];
};

export type HourlyIncomeRow = {
  readonly __typename?: 'HourlyIncomeRow';
  readonly rateAmount: NetGross;
  readonly rateIncreaseDueToRefundedBenefits?: Maybe<NetGross>;
  readonly valueIncludingRateIncrease: NetGross;
  readonly valueWithoutRateIncrease: NetGross;
  readonly workHours: Scalars['WorkHours']['output'];
};

export const IdType = {
  IDCARD: 'IDCard',
  PASSPORT: 'Passport'
} as const;

export type IdType = typeof IdType[keyof typeof IdType];
export type Iban = BankAccountNumber & {
  readonly __typename?: 'Iban';
  readonly value: Scalars['String']['output'];
};

export type IllegalPositionRemovalError = UserError & {
  readonly __typename?: 'IllegalPositionRemovalError';
  readonly activeAssignments: ReadonlyArray<ProjectAssignmentId>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type IncomeDetails = {
  readonly __typename?: 'IncomeDetails';
  readonly benefitsValue: BenefitsValue;
  readonly bonuses: ReadonlyArray<Bonus>;
  readonly bonusesValueByCategory: ReadonlyArray<BonusCategoryAmount>;
  readonly from: Scalars['LocalDate']['output'];
  readonly onCallLogs: ReadonlyArray<OnCallLog>;
  readonly overtimeIncome: ReadonlyArray<HourlyIncomeRow>;
  readonly overtimeWorkTime: Scalars['Minutes']['output'];
  readonly paidLeaveIncome: ReadonlyArray<IncomeRow>;
  readonly payoutWithoutBenefits: NetGross;
  readonly rateDetails?: Maybe<RateDetails>;
  readonly remoteWorkReimbursement?: Maybe<RemoteWorkReimbursement>;
  readonly standardTimeIncome: ReadonlyArray<IncomeRow>;
  readonly standardWorkTime: Scalars['Minutes']['output'];
  readonly to: Scalars['LocalDate']['output'];
  readonly totalPayout: NetGross;
  readonly totalValueBonuses: NetGross;
  readonly totalValueOnCalls: NetGross;
  readonly totalValueOvertimeIncome: NetGross;
  readonly totalValueOvertimeIncomeIncludingBenefits: NetGross;
  readonly totalValuePaidLeaveIncome: NetGross;
  readonly totalValuePaidLeaveIncomeIncludingBenefits: NetGross;
  readonly totalValueStandardTimeIncome: NetGross;
  readonly totalValueStandardTimeIncomeIncludingBenefits: NetGross;
  readonly totalWorkTime: Scalars['Minutes']['output'];
};

export type IncomeRow = DailyIncomeRow | HourlyIncomeRow | MonthlyIncomeRow;

export type IncompleteArgumentError = UserError & {
  readonly __typename?: 'IncompleteArgumentError';
  readonly missingField: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type IncompleteArgumentsError = UserError & {
  readonly __typename?: 'IncompleteArgumentsError';
  readonly missingFields: ReadonlyArray<Scalars['String']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type IncompleteData = {
  readonly __typename?: 'IncompleteData';
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly description: ReadonlyArray<IncompleteDataDescription>;
};

export type IncompleteDataDescription = AccountingDataMissing | BonusRequiresApproval | InvoiceFileMissing | InvoiceMissing | InvoiceUnchecked | NoBankAccount | TimeReportIncomplete | TimeReportRequiresApproval | WhiteListInvalid;

export type IncompleteEntries = {
  readonly __typename?: 'IncompleteEntries';
  readonly days: ReadonlyArray<Scalars['LocalDate']['output']>;
};

export type IntResponse = {
  readonly __typename?: 'IntResponse';
  readonly value: Scalars['Int']['output'];
};

export type IntResponseOrNfsError = IntResponse | NfsError;

export type InternalNfsError = UserError & {
  readonly __typename?: 'InternalNfsError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InternalProjectAssignmentPeriodInput = {
  readonly from: Scalars['LocalDate']['input'];
  readonly positionName: Scalars['String']['input'];
  readonly subcontractPositionId?: InputMaybe<Scalars['ClientPositionId']['input']>;
  readonly to?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type InternalProjectMutations = {
  readonly __typename?: 'InternalProjectMutations';
  readonly upsertInternalProjectAssignment: ProjectAssignmentOrNfsError;
};


export type InternalProjectMutationsUpsertInternalProjectAssignmentArgs = {
  input: CreateInternalProjectAssignmentInput;
};

export type InvalidApiTokenError = UserError & {
  readonly __typename?: 'InvalidApiTokenError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidArgument = {
  readonly __typename?: 'InvalidArgument';
  readonly arg: Scalars['String']['output'];
  readonly desc: Scalars['String']['output'];
};

export type InvalidArgumentsError = UserError & {
  readonly __typename?: 'InvalidArgumentsError';
  readonly invalidArguments: ReadonlyArray<InvalidArgument>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidCompanyTypeError = UserError & {
  readonly __typename?: 'InvalidCompanyTypeError';
  readonly companyId: Scalars['CompanyId']['output'];
  readonly expectedType: CompanyType;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidContentTypeError = UserError & {
  readonly __typename?: 'InvalidContentTypeError';
  readonly expectedType: Scalars['String']['output'];
  readonly fileName: Scalars['String']['output'];
  readonly fileType: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidCursorError = UserError & {
  readonly __typename?: 'InvalidCursorError';
  readonly cursor: Scalars['Cursor']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidEmailAddress = UserError & {
  readonly __typename?: 'InvalidEmailAddress';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidStateError = UserError & {
  readonly __typename?: 'InvalidStateError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvoiceAlreadyAcceptedError = UserError & {
  readonly __typename?: 'InvoiceAlreadyAcceptedError';
  readonly id: Scalars['InvoiceDetailsId']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvoiceConnectedPayment = {
  readonly __typename?: 'InvoiceConnectedPayment';
  readonly currency: Scalars['Currency']['output'];
  readonly description: Scalars['String']['output'];
  readonly externalPayment?: Maybe<BankIncomeTransfer>;
  readonly name: Scalars['String']['output'];
  readonly paidDate: Scalars['OffsetDateTime']['output'];
  readonly value: Scalars['Cents']['output'];
};

export const InvoiceDeliveryType = {
  BOTHKSEFANDDOCUPLOADEDVIANFS: 'BothKSEFandDocUploadedViaNFS',
  KSEF: 'KSEF',
  UPLOADEDDOCVIANFS: 'UploadedDocViaNFS'
} as const;

export type InvoiceDeliveryType = typeof InvoiceDeliveryType[keyof typeof InvoiceDeliveryType];
export type InvoiceDetails = {
  readonly __typename?: 'InvoiceDetails';
  readonly adminNote?: Maybe<Scalars['String']['output']>;
  readonly correct?: Maybe<Scalars['Boolean']['output']>;
  readonly currency?: Maybe<Scalars['Currency']['output']>;
  readonly file?: Maybe<DownloadableExternallyHostedFileUrl>;
  readonly grossValue?: Maybe<Scalars['Cents']['output']>;
  readonly id: Scalars['InvoiceDetailsId']['output'];
  readonly ksefNumber?: Maybe<Scalars['String']['output']>;
  readonly number?: Maybe<Scalars['InvoiceNumber']['output']>;
  readonly saldeoDocumentUrl?: Maybe<Scalars['String']['output']>;
  readonly userNote?: Maybe<Scalars['String']['output']>;
};

export type InvoiceDetailsOperations = {
  readonly __typename?: 'InvoiceDetailsOperations';
  readonly create: InvoiceDetailsOrNfsError;
  readonly createFromSaldeoDocument: InvoiceDetailsOrNfsError;
  readonly remove: BooleanResponseOrNfsError;
  readonly update: InvoiceDetailsOrNfsError;
};


export type InvoiceDetailsOperationsCreateArgs = {
  invoiceDetails: CreateInvoiceDetailsInput;
};


export type InvoiceDetailsOperationsCreateFromSaldeoDocumentArgs = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['InvoiceDetailsId']['input'];
  saldeoDocumentId: SaldeoDocumentIdInput;
};


export type InvoiceDetailsOperationsRemoveArgs = {
  invoiceDetailsId: Scalars['InvoiceDetailsId']['input'];
};


export type InvoiceDetailsOperationsUpdateArgs = {
  invoiceDetails: UpdateInvoiceDetailsInput;
  invoiceDetailsId: Scalars['InvoiceDetailsId']['input'];
};

export type InvoiceDetailsOrNfsError = InvoiceDetails | NfsError;

export type InvoiceEntity = {
  readonly __typename?: 'InvoiceEntity';
  readonly address: Address;
  readonly email?: Maybe<Scalars['EmailAddress']['output']>;
  readonly name: Scalars['String']['output'];
  readonly phone?: Maybe<Scalars['PhoneNumber']['output']>;
  readonly taxNumber?: Maybe<Scalars['TaxNumber']['output']>;
};

export type InvoiceFileMissing = {
  readonly __typename?: 'InvoiceFileMissing';
  readonly invoiceDetailsId: Scalars['InvoiceDetailsId']['output'];
};

export type InvoiceImportedFromSaldeoError = UserError & {
  readonly __typename?: 'InvoiceImportedFromSaldeoError';
  readonly id: Scalars['InvoiceDetailsId']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export const InvoiceKind = {
  ACCOUNTING_NOTE: 'ACCOUNTING_NOTE',
  ADVANCE: 'ADVANCE',
  BILL: 'BILL',
  CANCELED: 'CANCELED',
  CLIENT_ORDER: 'CLIENT_ORDER',
  CORRECTION: 'CORRECTION',
  CORRECTION_NOTE: 'CORRECTION_NOTE',
  DW: 'DW',
  ESTIMATE: 'ESTIMATE',
  EXPORT_PRODUCTS: 'EXPORT_PRODUCTS',
  FINAL: 'FINAL',
  IMPORT_PRODUCTS: 'IMPORT_PRODUCTS',
  IMPORT_SERVICE: 'IMPORT_SERVICE',
  IMPORT_SERVICE_EU: 'IMPORT_SERVICE_EU',
  INVOICE_OTHER: 'INVOICE_OTHER',
  KP: 'KP',
  KW: 'KW',
  PROFORMA: 'PROFORMA',
  RECEIPT: 'RECEIPT',
  VAT: 'VAT',
  VAT_MARGIN: 'VAT_MARGIN',
  VAT_MP: 'VAT_MP',
  VAT_RR: 'VAT_RR',
  WDT: 'WDT',
  WNT: 'WNT'
} as const;

export type InvoiceKind = typeof InvoiceKind[keyof typeof InvoiceKind];
export type InvoiceMissing = {
  readonly __typename?: 'InvoiceMissing';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type InvoicePosition = {
  readonly __typename?: 'InvoicePosition';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly price: NetGross;
  readonly quantity: Scalars['BigDecimal']['output'];
  readonly quantityUnit: Scalars['String']['output'];
  readonly totalPrice: NetGross;
  readonly vat?: Maybe<VatApplied>;
};

export const InvoiceStatus = {
  CORRECT: 'Correct',
  INCORRECT: 'Incorrect',
  NOTDELIVERED: 'NotDelivered',
  TOBECHECKED: 'ToBeChecked'
} as const;

export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];
export type InvoiceTransferLinksDrawer = AbstractDrawer & {
  readonly __typename?: 'InvoiceTransferLinksDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredInvoiceId: Scalars['SalesInvoiceId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type InvoiceUnchecked = {
  readonly __typename?: 'InvoiceUnchecked';
  readonly invoiceDetailsId: Scalars['InvoiceDetailsId']['output'];
};

export type InvoicesDrawer = AbstractDrawer & {
  readonly __typename?: 'InvoicesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

/** A key-value pair of AbsenceType and AbsenceTypeDetails */
export type KvAbsenceTypeAbsenceTypeDetails = {
  readonly __typename?: 'KVAbsenceTypeAbsenceTypeDetails';
  /** Key */
  readonly key: AbsenceType;
  /** Value */
  readonly value: AbsenceTypeDetails;
};

/** A key-value pair of WorkTagId and Minutes */
export type KvWorkTagIdMinutes = {
  readonly __typename?: 'KVWorkTagIdMinutes';
  /** Key */
  readonly key: Scalars['WorkTagId']['output'];
  /** Value */
  readonly value?: Maybe<Scalars['Minutes']['output']>;
};

/** A key-value pair of Year and AnnualLeaveYearSummary */
export type KvYearAnnualLeaveYearSummary = {
  readonly __typename?: 'KVYearAnnualLeaveYearSummary';
  /** Key */
  readonly key: Scalars['Year']['output'];
  /** Value */
  readonly value: AnnualLeaveYearSummary;
};

/** A key-value pair of Year and TrainingBudgetYearSummary */
export type KvYearTrainingBudgetYearSummary = {
  readonly __typename?: 'KVYearTrainingBudgetYearSummary';
  /** Key */
  readonly key: Scalars['Year']['output'];
  /** Value */
  readonly value: TrainingBudgetYearSummary;
};

export const Language = {
  ENGLISH: 'English',
  OTHER: 'Other'
} as const;

export type Language = typeof Language[keyof typeof Language];
export type LanguageLearningBonus = Bonus & {
  readonly __typename?: 'LanguageLearningBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly language: Language;
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly quarterYear: QuarterYear;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type LeaveEntitlementExceededError = UserError & {
  readonly __typename?: 'LeaveEntitlementExceededError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type ListColumnControllsDrawer = AbstractDrawer & {
  readonly __typename?: 'ListColumnControllsDrawer';
  readonly available: ReadonlyArray<Scalars['String']['output']>;
  readonly child?: Maybe<AbstractDrawer>;
  readonly defaults: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly selected: ReadonlyArray<Scalars['String']['output']>;
  readonly visible: Scalars['Boolean']['output'];
};

export type ListOfAbsenceRecordResponse = {
  readonly __typename?: 'ListOfAbsenceRecordResponse';
  readonly value: ReadonlyArray<AbsenceRecord>;
};

export type ListOfAbsenceRecordResponseOrNfsError = ListOfAbsenceRecordResponse | NfsError;

export type ListOfAdminResponse = {
  readonly __typename?: 'ListOfAdminResponse';
  readonly value: ReadonlyArray<Admin>;
};

export type ListOfAdminResponseOrNfsError = ListOfAdminResponse | NfsError;

export type ListOfApiTokenResponse = {
  readonly __typename?: 'ListOfApiTokenResponse';
  readonly value: ReadonlyArray<ApiToken>;
};

export type ListOfApiTokenResponseOrNfsError = ListOfApiTokenResponse | NfsError;

export type ListOfAssignedProjectResponse = {
  readonly __typename?: 'ListOfAssignedProjectResponse';
  readonly value: ReadonlyArray<AssignedProject>;
};

export type ListOfAssignedProjectResponseOrNfsError = ListOfAssignedProjectResponse | NfsError;

export type ListOfAssignedVariantResponse = {
  readonly __typename?: 'ListOfAssignedVariantResponse';
  readonly value: ReadonlyArray<AssignedVariant>;
};

export type ListOfAssignedVariantResponseOrNfsError = ListOfAssignedVariantResponse | NfsError;

export type ListOfAssignedVariantOrUnauthorized = AccessGrantedListOfAssignedVariant | Unauthorized;

export type ListOfBankTransferResponse = {
  readonly __typename?: 'ListOfBankTransferResponse';
  readonly value: ReadonlyArray<BankTransfer>;
};

export type ListOfBankTransferResponseOrNfsError = ListOfBankTransferResponse | NfsError;

export type ListOfBenefitGroupResponse = {
  readonly __typename?: 'ListOfBenefitGroupResponse';
  readonly value: ReadonlyArray<BenefitGroup>;
};

export type ListOfBenefitGroupResponseOrNfsError = ListOfBenefitGroupResponse | NfsError;

export type ListOfBfrFileUrlResponse = {
  readonly __typename?: 'ListOfBfrFileUrlResponse';
  readonly value: ReadonlyArray<BfrFileUrl>;
};

export type ListOfBfrFileUrlResponseOrNfsError = ListOfBfrFileUrlResponse | NfsError;

export type ListOfCertificateOrUnauthorized = AccessGrantedListOfCertificate | Unauthorized;

export type ListOfClientContractResponse = {
  readonly __typename?: 'ListOfClientContractResponse';
  readonly value: ReadonlyArray<ClientContract>;
};

export type ListOfClientContractResponseOrNfsError = ListOfClientContractResponse | NfsError;

export type ListOfClientContractOrUnauthorized = AccessGrantedListOfClientContract | Unauthorized;

export type ListOfClientPositionOrUnauthorized = AccessGrantedListOfClientPosition | Unauthorized;

export type ListOfContractDocumentTemplateDescriptionResponse = {
  readonly __typename?: 'ListOfContractDocumentTemplateDescriptionResponse';
  readonly value: ReadonlyArray<ContractDocumentTemplateDescription>;
};

export type ListOfContractDocumentTemplateDescriptionResponseOrNfsError = ListOfContractDocumentTemplateDescriptionResponse | NfsError;

export type ListOfContractDraftResponse = {
  readonly __typename?: 'ListOfContractDraftResponse';
  readonly value: ReadonlyArray<ContractDraft>;
};

export type ListOfContractDraftResponseOrNfsError = ListOfContractDraftResponse | NfsError;

export type ListOfContractSalaryDetailsResponse = {
  readonly __typename?: 'ListOfContractSalaryDetailsResponse';
  readonly value: ReadonlyArray<ContractSalaryDetails>;
};

export type ListOfContractSalaryDetailsResponseOrNfsError = ListOfContractSalaryDetailsResponse | NfsError;

export type ListOfContractOrUnauthorized = AccessGrantedListOfContract | Unauthorized;

export type ListOfCostAndRevenueItemOrUnauthorized = AccessGrantedListOfCostAndRevenueItem | Unauthorized;

export type ListOfCostInvoiceResponse = {
  readonly __typename?: 'ListOfCostInvoiceResponse';
  readonly value: ReadonlyArray<CostInvoice>;
};

export type ListOfCostInvoiceResponseOrNfsError = ListOfCostInvoiceResponse | NfsError;

export type ListOfDeskAssignmentResponse = {
  readonly __typename?: 'ListOfDeskAssignmentResponse';
  readonly value: ReadonlyArray<DeskAssignment>;
};

export type ListOfDeskAssignmentResponseOrNfsError = ListOfDeskAssignmentResponse | NfsError;

export type ListOfExternalBeneficiaryOrUnauthorized = AccessGrantedListOfExternalBeneficiary | Unauthorized;

export type ListOfFakturowniaProfileResponse = {
  readonly __typename?: 'ListOfFakturowniaProfileResponse';
  readonly value: ReadonlyArray<FakturowniaProfile>;
};

export type ListOfFakturowniaProfileResponseOrNfsError = ListOfFakturowniaProfileResponse | NfsError;

export type ListOfHolidaySummaryFileUrlResponse = {
  readonly __typename?: 'ListOfHolidaySummaryFileUrlResponse';
  readonly value: ReadonlyArray<HolidaySummaryFileUrl>;
};

export type ListOfHolidaySummaryFileUrlResponseOrNfsError = ListOfHolidaySummaryFileUrlResponse | NfsError;

export type ListOfIncomeDetailsOrUnauthorized = AccessGrantedListOfIncomeDetails | Unauthorized;

export type ListOfKvWorkTagIdMinutesResponse = {
  readonly __typename?: 'ListOfKVWorkTagIdMinutesResponse';
  readonly value: ReadonlyArray<KvWorkTagIdMinutes>;
};

export type ListOfKvWorkTagIdMinutesResponseOrNfsError = ListOfKvWorkTagIdMinutesResponse | NfsError;

export type ListOfOfficeResponse = {
  readonly __typename?: 'ListOfOfficeResponse';
  readonly value: ReadonlyArray<Office>;
};

export type ListOfOfficeResponseOrNfsError = ListOfOfficeResponse | NfsError;

export type ListOfOnCallRecordResponse = {
  readonly __typename?: 'ListOfOnCallRecordResponse';
  readonly value: ReadonlyArray<OnCallRecord>;
};

export type ListOfOnCallRecordResponseOrNfsError = ListOfOnCallRecordResponse | NfsError;

export type ListOfProgressionSchemeResponse = {
  readonly __typename?: 'ListOfProgressionSchemeResponse';
  readonly value: ReadonlyArray<ProgressionScheme>;
};

export type ListOfProgressionSchemeResponseOrNfsError = ListOfProgressionSchemeResponse | NfsError;

export type ListOfProjectAssignmentResponse = {
  readonly __typename?: 'ListOfProjectAssignmentResponse';
  readonly value: ReadonlyArray<ProjectAssignment>;
};

export type ListOfProjectAssignmentResponseOrNfsError = ListOfProjectAssignmentResponse | NfsError;

export type ListOfProjectAssignmentOrUnauthorized = AccessGrantedListOfProjectAssignment | Unauthorized;

export type ListOfProjectIdResponse = {
  readonly __typename?: 'ListOfProjectIdResponse';
  readonly value: ReadonlyArray<Scalars['ProjectId']['output']>;
};

export type ListOfProjectIdResponseOrNfsError = ListOfProjectIdResponse | NfsError;

export type ListOfProjectUtilizationResponse = {
  readonly __typename?: 'ListOfProjectUtilizationResponse';
  readonly value: ReadonlyArray<ProjectUtilization>;
};

export type ListOfProjectUtilizationResponseOrNfsError = ListOfProjectUtilizationResponse | NfsError;

export type ListOfRaiseProposalResponse = {
  readonly __typename?: 'ListOfRaiseProposalResponse';
  readonly value: ReadonlyArray<RaiseProposal>;
};

export type ListOfRaiseProposalResponseOrNfsError = ListOfRaiseProposalResponse | NfsError;

export type ListOfReportingPeriodResponse = {
  readonly __typename?: 'ListOfReportingPeriodResponse';
  readonly value: ReadonlyArray<ReportingPeriod>;
};

export type ListOfReportingPeriodResponseOrNfsError = ListOfReportingPeriodResponse | NfsError;

export type ListOfReservationRequestResponse = {
  readonly __typename?: 'ListOfReservationRequestResponse';
  readonly value: ReadonlyArray<ReservationRequest>;
};

export type ListOfReservationRequestResponseOrNfsError = ListOfReservationRequestResponse | NfsError;

export type ListOfSalesInvoiceResponse = {
  readonly __typename?: 'ListOfSalesInvoiceResponse';
  readonly value: ReadonlyArray<SalesInvoice>;
};

export type ListOfSalesInvoiceResponseOrNfsError = ListOfSalesInvoiceResponse | NfsError;

export type ListOfSocialMediaHandleOrUnauthorized = AccessGrantedListOfSocialMediaHandle | Unauthorized;

export type ListOfStringResponse = {
  readonly __typename?: 'ListOfStringResponse';
  readonly value: ReadonlyArray<Scalars['String']['output']>;
};

export type ListOfStringResponseOrNfsError = ListOfStringResponse | NfsError;

export type ListOfStringOrUnauthorized = AccessGrantedListOfString | Unauthorized;

export type ListOfTaxResidencyCertificateOrUnauthorized = AccessGrantedListOfTaxResidencyCertificate | Unauthorized;

export type ListOfTimeReportValidationResponse = {
  readonly __typename?: 'ListOfTimeReportValidationResponse';
  readonly value: ReadonlyArray<TimeReportValidation>;
};

export type ListOfTimeReportValidationResponseOrNfsError = ListOfTimeReportValidationResponse | NfsError;

export type ListOfTransfersSummariesResponse = {
  readonly __typename?: 'ListOfTransfersSummariesResponse';
  readonly value: ReadonlyArray<TransfersSummaries>;
};

export type ListOfTransfersSummariesResponseOrNfsError = ListOfTransfersSummariesResponse | NfsError;

export type ListOfWorkRecordResponse = {
  readonly __typename?: 'ListOfWorkRecordResponse';
  readonly value: ReadonlyArray<WorkRecord>;
};

export type ListOfWorkRecordResponseOrNfsError = ListOfWorkRecordResponse | NfsError;

export type ListOfWorkTransferProtocolResponse = {
  readonly __typename?: 'ListOfWorkTransferProtocolResponse';
  readonly value: ReadonlyArray<WorkTransferProtocol>;
};

export type ListOfWorkTransferProtocolResponseOrNfsError = ListOfWorkTransferProtocolResponse | NfsError;

export type ListOfWorkTransferProtocolOrUnauthorized = AccessGrantedListOfWorkTransferProtocol | Unauthorized;

export type LocalDateRange = {
  readonly __typename?: 'LocalDateRange';
  readonly from: Scalars['LocalDate']['output'];
  readonly to?: Maybe<Scalars['LocalDate']['output']>;
};

export type LocalDateRangeInput = {
  readonly from: Scalars['LocalDate']['input'];
  readonly toOpt?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type LocalDateOrUnauthorized = AccessGrantedLocalDate | Unauthorized;

export type ManageKeyPeopleDrawer = AbstractDrawer & {
  readonly __typename?: 'ManageKeyPeopleDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredProjectId: Scalars['ProjectId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type ManageProjectTimelineDrawer = AbstractDrawer & {
  readonly __typename?: 'ManageProjectTimelineDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredProjectId: Scalars['ProjectId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type MissingEntries = {
  readonly __typename?: 'MissingEntries';
  readonly days: ReadonlyArray<Scalars['LocalDate']['output']>;
};

export type MissingFileMetadataError = UserError & {
  readonly __typename?: 'MissingFileMetadataError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export const MoneyComputationBias = {
  GROSS: 'Gross',
  NET: 'Net'
} as const;

export type MoneyComputationBias = typeof MoneyComputationBias[keyof typeof MoneyComputationBias];
export type MonthlyIncomeRow = {
  readonly __typename?: 'MonthlyIncomeRow';
  readonly rateAmount: NetGross;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly applyRaiseAndSendEmail: ApplyRaiseResultOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly approveOfficeReservation: ReservationRequestOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly approveOfficeReservations: ListOfReservationRequestResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly archiveProgressionScheme: ProgressionSchemeOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly assignDesk: DeskAssignmentOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly bankTransfer: BankTransferMutation;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly benefit: BenefitMutation;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly benefitVariant: BenefitVariantMutation;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly blockDesk: DeskOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly blockOffice: OfficeSettingsOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly blockParkingSpot: ParkingSpotOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly blockRoom: RoomOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly cancelOfficeReservation: ReservationRequestOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly clientContract: ClientContractMutation;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly company: CompanyMutation;
  /** Exchanges a Google OAuth code and connects the resulting Gmail account to the calling admin */
  readonly connectGmailAccount: GmailConnectionOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly contract: ContractMutation;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly contractSalaryDetails: ContractSalaryDetailsMutation;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly createBenefit: BenefitOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly createCertificate: CertificateOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly createClientContract: ClientContractOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly createCompany: CompanyOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly createDesk: DeskOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly createInternalProject: ProjectOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly createOffice: OfficeOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly createParkingSpot: ParkingSpotOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly createPaymentConnection: PaymentConnectionOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly createProgressionScheme: ProgressionSchemeOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly createProject: ProjectOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly createRoom: RoomOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly createSpace: SpaceOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly createTemporaryEditPermissionsForSpaceOwners: UnitResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly createTemporaryEditPermissionsForUsers: UnitResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly createUser: UserOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly deleteCertificate: BooleanResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly deleteDesk: BooleanResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly deleteDeskAssignment: DeskAssignmentOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly deleteOfficeAvatar: OfficeOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly deleteParkingSpot: BooleanResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly deletePaymentConnection: BankIncomeTransferOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly deleteRoom: BooleanResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly deleteTaxResidencyCertificate: UnitResponseOrNfsError;
  /** Revokes and removes the calling admin's own connected Gmail account */
  readonly disconnectGmailAccount: UnitResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly exportSalesInvoices: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly exportTransfers: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly generateBenefitInvoiceDocument: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly generateClientTimeReport: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly generateExportForInvoicingClients: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly generateHolidaySummaryDocument: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly generateProjectBillablesDocument: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly generateProjectTimeReport: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly generateRateChangeEventSummaryReport: UnitResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly generateSalariesSummaryReport: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam]) */
  readonly generateSkillsAndCertificatesReport: UnitResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly generateTrainingBudgetSummaryReport: UnitResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly importTransfers_from_xml_camt053: ListOfBankTransferResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly importTransfers_from_xml_ofx: ListOfBankTransferResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly internalProject: InternalProjectMutations;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly markPaymentAsDisbursed: ListOfContractSalaryDetailsResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly orderPayrollTransfers: PayrollTransfersOrderViewOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly project: ProjectMutation;
  readonly refreshCompaniesLogos: UnitResponseOrNfsError;
  /** Refreshes contract salary details and other stats for all contracts active in the specified month */
  readonly refreshContractMonthlyStates: UnitResponseOrNfsError;
  /** Refreshes contract salary details and other stats for all contracts active in the specified range */
  readonly refreshContractMonthlyStatesInRange: UnitResponseOrNfsError;
  /** Re-fetches the connected Gmail account's aliases from Google, since they're otherwise cached at connect time */
  readonly refreshGmailAliases: GmailConnectionOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly rejectOfficeReservation: ReservationRequestOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly reporting: ReportingApi;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly reportingPeriod: ReportingPeriodMutation;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly reserveDesksOnBehalf: ReservationRequestOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly reserveParkingOnBehalf: ReservationRequestOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly salesInvoice: SalesInvoiceMutation;
  /** Chooses which of the connected Gmail account's aliases to send email from */
  readonly selectGmailAlias: GmailConnectionOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly sendSlackNotification: UnitResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly setRateAndProgression: SetRateAndProgressionResultOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam, SecurityTeam]) */
  readonly setRoomSecurityZone: RoomOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly space: SpaceMutation;
  readonly triggerApproachingDeadlineReminderBackgroundNotifications: UnitResponseOrNfsError;
  readonly triggerBasicFinancialReportBackgroundRegeneration: UnitResponseOrNfsError;
  readonly triggerHrSummaryReportBackgroundRegeneration: UnitResponseOrNfsError;
  readonly triggerIngTransfersMonitoring: UnitResponseOrNfsError;
  readonly triggerMissingTimeReportsBackgroundNotifications: UnitResponseOrNfsError;
  readonly triggerSaldeoInvoiceImport: UnitResponseOrNfsError;
  readonly triggerVatDataBackgroundRefresh: UnitResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly unblockDesk: DeskOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly unblockOffice: OfficeSettingsOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly unblockParkingSpot: ParkingSpotOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly unblockRoom: RoomOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly unmarkPaymentAsDisbursed: ListOfContractSalaryDetailsResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly updateCertificate: CertificateOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly updateDesk: DeskOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly updateDeskAssignment: DeskAssignmentOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly updateDeskRequest: ReservationRequestOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly updateOffice: OfficeOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly updateOfficeReservationSettings: OfficeReservationSettingsOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly updateOfficeSettings: OfficeSettingsOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly updateParkingRequest: ReservationRequestOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly updateParkingSpot: ParkingSpotOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly updateProgressionScheme: ProgressionSchemeOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly updateRoom: RoomOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam]) */
  readonly uploadOfficeAvatar: OfficeOrNfsError;
  readonly upsertExternalBeneficiary: ExternalBeneficiaryOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly upsertTaxResidencyCertificate: TaxResidencyCertificateOrNfsError;
  readonly user: UserMutation;
};


export type MutationApplyRaiseAndSendEmailArgs = {
  contractId: Scalars['ContractId']['input'];
  effectiveFrom: Scalars['YearMonth']['input'];
  email: EmailInput;
  entityVersion: Scalars['EntityVersion']['input'];
};


export type MutationApproveOfficeReservationArgs = {
  requestId: Scalars['ReservationRequestId']['input'];
};


export type MutationApproveOfficeReservationsArgs = {
  requestIds: ReadonlyArray<Scalars['ReservationRequestId']['input']>;
};


export type MutationArchiveProgressionSchemeArgs = {
  progressionSchemeId: Scalars['ProgressionSchemeId']['input'];
};


export type MutationAssignDeskArgs = {
  deskId: Scalars['DeskId']['input'];
  period: LocalDateRangeInput;
  userId: Scalars['UserId']['input'];
};


export type MutationBankTransferArgs = {
  id: Scalars['BankTransferId']['input'];
};


export type MutationBenefitArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  id: Scalars['BenefitId']['input'];
};


export type MutationBenefitVariantArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  id: Scalars['BenefitVariantId']['input'];
};


export type MutationBlockDeskArgs = {
  deskId: Scalars['DeskId']['input'];
};


export type MutationBlockOfficeArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  officeId: Scalars['OfficeId']['input'];
};


export type MutationBlockParkingSpotArgs = {
  parkingSpotId: Scalars['ParkingSpotId']['input'];
};


export type MutationBlockRoomArgs = {
  roomId: Scalars['RoomId']['input'];
};


export type MutationCancelOfficeReservationArgs = {
  requestId: Scalars['ReservationRequestId']['input'];
};


export type MutationClientContractArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  id: Scalars['ClientContractId']['input'];
};


export type MutationCompanyArgs = {
  companyId: Scalars['CompanyId']['input'];
  companyVersion: Scalars['EntityVersion']['input'];
};


export type MutationConnectGmailAccountArgs = {
  code: Scalars['String']['input'];
};


export type MutationContractArgs = {
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
};


export type MutationContractSalaryDetailsArgs = {
  contractId: Scalars['ContractId']['input'];
  date: Scalars['YearMonth']['input'];
};


export type MutationCreateBenefitArgs = {
  alternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  groupType: BenefitGroupType;
  id: Scalars['BenefitId']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['LocalDate']['input'];
};


export type MutationCreateCertificateArgs = {
  expirationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['CertificateId']['input'];
  issueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  name: Scalars['String']['input'];
  userId: Scalars['UserId']['input'];
};


export type MutationCreateClientContractArgs = {
  contractDurationFrom: Scalars['LocalDate']['input'];
  contractDurationTo?: InputMaybe<Scalars['LocalDate']['input']>;
  docUri?: InputMaybe<Scalars['URI']['input']>;
  id: Scalars['ClientContractId']['input'];
  name: Scalars['String']['input'];
  promiseeId: Scalars['CompanyId']['input'];
  promisorId: Scalars['CompanyId']['input'];
};


export type MutationCreateCompanyArgs = {
  company: CompanyInput;
};


export type MutationCreateDeskArgs = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['DeskId']['input'];
  monitors: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  pedestalNumber?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['RoomId']['input'];
  standing: Scalars['Boolean']['input'];
};


export type MutationCreateInternalProjectArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupCompanyId: Scalars['CompanyId']['input'];
  id: Scalars['ProjectId']['input'];
  name: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['SpaceId']['input']>;
  startDate: Scalars['LocalDate']['input'];
};


export type MutationCreateOfficeArgs = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  officeId: Scalars['OfficeId']['input'];
  period: LocalDateRangeInput;
  physical: Scalars['Boolean']['input'];
};


export type MutationCreateParkingSpotArgs = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  guest: Scalars['Boolean']['input'];
  id: Scalars['ParkingSpotId']['input'];
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  officeId: Scalars['OfficeId']['input'];
};


export type MutationCreatePaymentConnectionArgs = {
  invoiceId: Scalars['SalesInvoiceId']['input'];
  transferId: Scalars['BankTransferId']['input'];
};


export type MutationCreateProgressionSchemeArgs = {
  id: Scalars['ProgressionSchemeId']['input'];
  isEngineering: Scalars['Boolean']['input'];
  levels: ReadonlyArray<ProgressionSchemeLevelInput>;
  name: Scalars['String']['input'];
  yearlyRaise: Scalars['Cents']['input'];
};


export type MutationCreateProjectArgs = {
  areaOfVlEngagement?: InputMaybe<Scalars['String']['input']>;
  clientContractId: Scalars['ClientContractId']['input'];
  competences?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  costAndRevenueItems?: InputMaybe<ReadonlyArray<CostAndRevenueItemInput>>;
  costLedgerAccountNumber?: InputMaybe<Scalars['String']['input']>;
  crossSell?: InputMaybe<CrossSellInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ProjectId']['input'];
  name: Scalars['String']['input'];
  revenueLedgerAccountNumber?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['SpaceId']['input']>;
  statusHistory: ReadonlyArray<ProjectStatusHistoryEntryInput>;
  techStack?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};


export type MutationCreateRoomArgs = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['RoomId']['input'];
  name: Scalars['String']['input'];
  officeId: Scalars['OfficeId']['input'];
  restrictedToSpaceId?: InputMaybe<Scalars['SpaceId']['input']>;
  securityZone?: InputMaybe<SecurityZone>;
};


export type MutationCreateSpaceArgs = {
  directors?: InputMaybe<ReadonlyArray<Scalars['UserId']['input']>>;
  id: Scalars['SpaceId']['input'];
  name: Scalars['String']['input'];
  owner: Scalars['UserId']['input'];
};


export type MutationCreateTemporaryEditPermissionsForSpaceOwnersArgs = {
  filter: FilterContractSalaryDetailsInput;
  validUntil: Scalars['OffsetDateTime']['input'];
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationCreateTemporaryEditPermissionsForUsersArgs = {
  filter: FilterContractSalaryDetailsInput;
  validUntil: Scalars['OffsetDateTime']['input'];
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationCreateUserArgs = {
  user: UserInput;
};


export type MutationDeleteCertificateArgs = {
  certificateId: Scalars['CertificateId']['input'];
};


export type MutationDeleteDeskArgs = {
  deskId: Scalars['DeskId']['input'];
};


export type MutationDeleteDeskAssignmentArgs = {
  assignmentId: Scalars['DeskAssignmentId']['input'];
};


export type MutationDeleteOfficeAvatarArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  officeId: Scalars['OfficeId']['input'];
};


export type MutationDeleteParkingSpotArgs = {
  parkingSpotId: Scalars['ParkingSpotId']['input'];
};


export type MutationDeletePaymentConnectionArgs = {
  invoiceId: Scalars['SalesInvoiceId']['input'];
  transferId: Scalars['BankTransferId']['input'];
};


export type MutationDeleteRoomArgs = {
  roomId: Scalars['RoomId']['input'];
};


export type MutationDeleteTaxResidencyCertificateArgs = {
  certId: Scalars['TaxResidencyCertificateId']['input'];
};


export type MutationExportSalesInvoicesArgs = {
  allSearch?: InputMaybe<Scalars['String']['input']>;
  buyerCompany_oneOf?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']>>;
  buyerName_oneOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  buyerType_oneOf?: InputMaybe<ReadonlyArray<BuyerType>>;
  clientIsWithinGroup_eq?: InputMaybe<Scalars['Boolean']['input']>;
  currency_oneOf?: InputMaybe<ReadonlyArray<Scalars['Currency']['input']>>;
  dateRange: ClosedEndLocalDateRangeInput;
  expectedPaymentDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  issueDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  kind_oneOf?: InputMaybe<ReadonlyArray<InvoiceKind>>;
  overdue_eq?: InputMaybe<Scalars['Boolean']['input']>;
  paidDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  paymentTo_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  searchDateType: SearchDateType;
  sellDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  sellerCompany_oneOf?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']>>;
  status_notIn?: InputMaybe<ReadonlyArray<SalesInvoiceStatus>>;
  status_oneOf?: InputMaybe<ReadonlyArray<SalesInvoiceStatus>>;
};


export type MutationExportTransfersArgs = {
  filter: FilterBankTransferInput;
};


export type MutationGenerateBenefitInvoiceDocumentArgs = {
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationGenerateClientTimeReportArgs = {
  clientContractId: Scalars['ClientContractId']['input'];
  period: ClosedEndLocalDateRangeInput;
};


export type MutationGenerateExportForInvoicingClientsArgs = {
  clientContractId: Scalars['ClientContractId']['input'];
  period: ClosedEndLocalDateRangeInput;
};


export type MutationGenerateHolidaySummaryDocumentArgs = {
  year: Scalars['Year']['input'];
};


export type MutationGenerateProjectBillablesDocumentArgs = {
  projectId: Scalars['ProjectId']['input'];
};


export type MutationGenerateProjectTimeReportArgs = {
  period: ClosedEndLocalDateRangeInput;
  projectId: Scalars['ProjectId']['input'];
};


export type MutationGenerateSalariesSummaryReportArgs = {
  salariesSummaryType: SalariesSummaryType;
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationImportTransfersFromXmlCamt053Args = {
  file: Scalars['Upload']['input'];
  maybeRestrictedType?: InputMaybe<BankTransferType>;
  operationCompanyName: Scalars['String']['input'];
};


export type MutationImportTransfersFromXmlOfxArgs = {
  file: Scalars['Upload']['input'];
  maybeRestrictedType?: InputMaybe<BankTransferType>;
  operationCompanyName: Scalars['String']['input'];
};


export type MutationInternalProjectArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  projectId: Scalars['ProjectId']['input'];
};


export type MutationMarkPaymentAsDisbursedArgs = {
  filter: FilterContractSalaryDetailsInput;
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationOrderPayrollTransfersArgs = {
  filter: FilterContractSalaryDetailsInput;
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationProjectArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  projectId: Scalars['ProjectId']['input'];
};


export type MutationRefreshCompaniesLogosArgs = {
  ids: ReadonlyArray<Scalars['CompanyId']['input']>;
};


export type MutationRefreshContractMonthlyStatesArgs = {
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationRefreshContractMonthlyStatesInRangeArgs = {
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
};


export type MutationRejectOfficeReservationArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['ReservationRequestId']['input'];
};


export type MutationReserveDesksOnBehalfArgs = {
  input: ReserveDesksInput;
  userId: Scalars['UserId']['input'];
};


export type MutationReserveParkingOnBehalfArgs = {
  input: ReserveParkingInput;
  userId: Scalars['UserId']['input'];
};


export type MutationSalesInvoiceArgs = {
  invoiceId: Scalars['SalesInvoiceId']['input'];
  profilePrefix: Scalars['String']['input'];
};


export type MutationSelectGmailAliasArgs = {
  alias: Scalars['EmailAddress']['input'];
};


export type MutationSendSlackNotificationArgs = {
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
  to: ReadonlyArray<Scalars['EmailAddress']['input']>;
};


export type MutationSetRateAndProgressionArgs = {
  contract: DirectContractUpdateOneOfInput;
  contractEntityVersion: Scalars['EntityVersion']['input'];
  contractId: Scalars['ContractId']['input'];
  email?: InputMaybe<EmailInput>;
  progressionLevel?: InputMaybe<TimeBasedValueClearableProgressionLevelInput>;
  userEntityVersion: Scalars['EntityVersion']['input'];
};


export type MutationSetRoomSecurityZoneArgs = {
  roomId: Scalars['RoomId']['input'];
  securityZone?: InputMaybe<SecurityZone>;
};


export type MutationSpaceArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  spaceId: Scalars['SpaceId']['input'];
};


export type MutationTriggerApproachingDeadlineReminderBackgroundNotificationsArgs = {
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationTriggerMissingTimeReportsBackgroundNotificationsArgs = {
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationUnblockDeskArgs = {
  deskId: Scalars['DeskId']['input'];
};


export type MutationUnblockOfficeArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  officeId: Scalars['OfficeId']['input'];
};


export type MutationUnblockParkingSpotArgs = {
  parkingSpotId: Scalars['ParkingSpotId']['input'];
};


export type MutationUnblockRoomArgs = {
  roomId: Scalars['RoomId']['input'];
};


export type MutationUnmarkPaymentAsDisbursedArgs = {
  filter: FilterContractSalaryDetailsInput;
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationUpdateCertificateArgs = {
  certificate: UpdateCertificateInput;
  certificateId: Scalars['CertificateId']['input'];
};


export type MutationUpdateDeskArgs = {
  desk: UpdateDeskInput;
  deskId: Scalars['DeskId']['input'];
};


export type MutationUpdateDeskAssignmentArgs = {
  assignmentId: Scalars['DeskAssignmentId']['input'];
  period: LocalDateRangeInput;
};


export type MutationUpdateDeskRequestArgs = {
  approve: Scalars['Boolean']['input'];
  input: UpdateDeskRequestInput;
  requestId: Scalars['ReservationRequestId']['input'];
};


export type MutationUpdateOfficeArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  name: Scalars['String']['input'];
  officeId: Scalars['OfficeId']['input'];
  period: LocalDateRangeInput;
};


export type MutationUpdateOfficeReservationSettingsArgs = {
  deskMaxAdvanceDays?: InputMaybe<Scalars['Int']['input']>;
  deskMaxDays?: InputMaybe<Scalars['Int']['input']>;
  deskMaxUpcomingDays?: InputMaybe<Scalars['Int']['input']>;
  parkingMaxAdvanceDays?: InputMaybe<Scalars['Int']['input']>;
  parkingMaxDays?: InputMaybe<Scalars['Int']['input']>;
  parkingMaxUpcomingDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateOfficeSettingsArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  officeId: Scalars['OfficeId']['input'];
  settings: UpdateOfficeSettingsInput;
};


export type MutationUpdateParkingRequestArgs = {
  approve: Scalars['Boolean']['input'];
  input: UpdateParkingRequestInput;
  requestId: Scalars['ReservationRequestId']['input'];
};


export type MutationUpdateParkingSpotArgs = {
  parkingSpot: UpdateParkingSpotInput;
  parkingSpotId: Scalars['ParkingSpotId']['input'];
};


export type MutationUpdateProgressionSchemeArgs = {
  id: Scalars['ProgressionSchemeId']['input'];
  isEngineering?: InputMaybe<Scalars['Boolean']['input']>;
  levels?: InputMaybe<ReadonlyArray<ProgressionSchemeLevelInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  yearlyRaise?: InputMaybe<Scalars['Cents']['input']>;
};


export type MutationUpdateRoomArgs = {
  room: UpdateRoomInput;
  roomId: Scalars['RoomId']['input'];
};


export type MutationUploadOfficeAvatarArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  file: Scalars['Upload']['input'];
  officeId: Scalars['OfficeId']['input'];
};


export type MutationUpsertExternalBeneficiaryArgs = {
  address: AddressInput;
  email: Scalars['EmailAddress']['input'];
  employeeId: Scalars['UserId']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['ExternalBeneficiaryId']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationUpsertTaxResidencyCertificateArgs = {
  certificate: TaxResidencyCertificateInput;
};


export type MutationUserArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
  userId: Scalars['UserId']['input'];
};

export type NbpBaseCurrencyError = UserError & {
  readonly __typename?: 'NBPBaseCurrencyError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type NegativeFlexTimeBalance = {
  readonly __typename?: 'NegativeFlexTimeBalance';
  readonly minutes: Scalars['Minutes']['output'];
};

export type NetGross = {
  readonly __typename?: 'NetGross';
  readonly gross: Scalars['Cents']['output'];
  readonly net: Scalars['Cents']['output'];
};

/** At least one field must be defined, the second one could be inferred */
export type NetGrossInput = {
  readonly gross?: InputMaybe<Scalars['Cents']['input']>;
  readonly net?: InputMaybe<Scalars['Cents']['input']>;
};

export type NetOnCallRate = {
  readonly __typename?: 'NetOnCallRate';
  readonly holiday: Scalars['Cents']['output'];
  readonly night: Scalars['Cents']['output'];
  readonly weekend: Scalars['Cents']['output'];
};

export type NetOnCallRateInput = {
  readonly holiday: Scalars['Cents']['input'];
  readonly night: Scalars['Cents']['input'];
  readonly weekend: Scalars['Cents']['input'];
};

export type NetRateInput = {
  readonly net: Scalars['Cents']['input'];
  readonly settlement: Settlement;
};

export type NfsError = {
  readonly __typename?: 'NfsError';
  readonly error: UserError;
};

export type NoBankAccount = {
  readonly __typename?: 'NoBankAccount';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type NoParkingSpotAvailableError = UserError & {
  readonly __typename?: 'NoParkingSpotAvailableError';
  readonly dates: ReadonlyArray<Scalars['LocalDate']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type NoWorkToBeTransferedThisMonth = {
  readonly __typename?: 'NoWorkToBeTransferedThisMonth';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type NotRequired = {
  readonly __typename?: 'NotRequired';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type NotVerifiedBankAccountStatus = {
  readonly __typename?: 'NotVerifiedBankAccountStatus';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type NotVerifiedBooleanVatStatus = {
  readonly __typename?: 'NotVerifiedBooleanVATStatus';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type NotVerifiedEuVatType = {
  readonly __typename?: 'NotVerifiedEuVatType';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type Office = {
  readonly __typename?: 'Office';
  readonly avatar?: Maybe<Scalars['URI']['output']>;
  readonly blocked: Scalars['Boolean']['output'];
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly name: Scalars['String']['output'];
  readonly officeId: Scalars['OfficeId']['output'];
  readonly physical: Scalars['Boolean']['output'];
  readonly validFrom: Scalars['LocalDate']['output'];
  readonly validTo?: Maybe<Scalars['LocalDate']['output']>;
};

export type OfficeAvailability = {
  readonly __typename?: 'OfficeAvailability';
  readonly desks: ReadonlyArray<ResourceAvailability>;
  readonly parkingSpots: ReadonlyArray<ResourceAvailability>;
};

export type OfficeAvailabilityOrNfsError = NfsError | OfficeAvailability;

export type OfficeCatalogue = {
  readonly __typename?: 'OfficeCatalogue';
  readonly parkingSpots: ReadonlyArray<ParkingSpot>;
  readonly rooms: ReadonlyArray<Room>;
  readonly settings: OfficeSettings;
};

export type OfficeCatalogueOrNfsError = NfsError | OfficeCatalogue;

export type OfficeOrNfsError = NfsError | Office;

export type OfficeReservation = {
  readonly __typename?: 'OfficeReservation';
  readonly approval: Approval;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly createdBy: CreatedBy;
  readonly date: Scalars['LocalDate']['output'];
  readonly guestEmails: ReadonlyArray<Scalars['EmailAddress']['output']>;
  readonly id: Scalars['OfficeReservationId']['output'];
  readonly kind: ResourceKind;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly office: Office;
  readonly plateNumber?: Maybe<Scalars['String']['output']>;
  readonly requestId: Scalars['ReservationRequestId']['output'];
  readonly resource: ReservedResource;
  readonly user: User;
};

export type OfficeReservationSettings = {
  readonly __typename?: 'OfficeReservationSettings';
  readonly deskMaxAdvanceDays: Scalars['Int']['output'];
  readonly deskMaxDays: Scalars['Int']['output'];
  readonly deskMaxUpcomingDays: Scalars['Int']['output'];
  readonly parkingMaxAdvanceDays: Scalars['Int']['output'];
  readonly parkingMaxDays: Scalars['Int']['output'];
  readonly parkingMaxUpcomingDays: Scalars['Int']['output'];
};

export type OfficeReservationSettingsOrNfsError = NfsError | OfficeReservationSettings;

export type OfficeSettings = {
  readonly __typename?: 'OfficeSettings';
  readonly blocked: Scalars['Boolean']['output'];
  readonly floorMap?: Maybe<DownloadableExternallyHostedFileUrl>;
  readonly office: Office;
  readonly parkingInformation?: Maybe<Scalars['String']['output']>;
  readonly parkingMap?: Maybe<DownloadableExternallyHostedFileUrl>;
  readonly receptionEmails: ReadonlyArray<Scalars['EmailAddress']['output']>;
};

export type OfficeSettingsOrNfsError = NfsError | OfficeSettings;

export type OnCallLog = {
  readonly __typename?: 'OnCallLog';
  readonly dates: ReadonlyArray<Scalars['LocalDate']['output']>;
  readonly multiplier: OnCallMultiplier;
  readonly multiplierRate: NetGross;
  readonly shift: Shift;
  readonly shifts: Scalars['Days']['output'];
  readonly totalValue: NetGross;
};

export const OnCallMultiplier = {
  ONE: 'One',
  ONEANDHALF: 'OneAndHalf',
  THREE: 'Three'
} as const;

export type OnCallMultiplier = typeof OnCallMultiplier[keyof typeof OnCallMultiplier];
export type OnCallMultipliers = {
  readonly __typename?: 'OnCallMultipliers';
  readonly holidays: HolidayMultipliers;
  readonly weekdays: WeekdayDayAndNightMultipliers;
};

export type OnCallMultipliersOrNfsError = NfsError | OnCallMultipliers;

export type OnCallRate = {
  readonly __typename?: 'OnCallRate';
  readonly holiday: NetGross;
  readonly night: NetGross;
  readonly weekend: NetGross;
};

export type OnCallRecord = {
  readonly __typename?: 'OnCallRecord';
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly contract: Contract;
  readonly contractId: Scalars['ContractId']['output'];
  readonly date: Scalars['LocalDate']['output'];
  readonly dayShift: Scalars['Boolean']['output'];
  readonly id: Scalars['OnCallRecordId']['output'];
  readonly nightShift: Scalars['Boolean']['output'];
  readonly project: Project;
  readonly user: User;
  readonly userId: Scalars['UserId']['output'];
};

export type OnCallRecordApi = {
  readonly __typename?: 'OnCallRecordApi';
  readonly createMany: ListOfOnCallRecordResponseOrNfsError;
  readonly update: OnCallRecordOrNfsError;
};


export type OnCallRecordApiCreateManyArgs = {
  value: ReadonlyArray<CreateOnCallRecordInput>;
};


export type OnCallRecordApiUpdateArgs = {
  comment?: InputMaybe<ClearableStringInput>;
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  dayShift?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['OnCallRecordId']['input'];
  nightShift?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['ProjectId']['input']>;
};

export type OnCallRecordOrNfsError = NfsError | OnCallRecord;

export type OperationAlreadyInProgressError = UserError & {
  readonly __typename?: 'OperationAlreadyInProgressError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type OperationNotAvailableError = UserError & {
  readonly __typename?: 'OperationNotAvailableError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type OptionalAddressOrUnauthorized = AccessGrantedOptionalAddress | Unauthorized;

export type OptionalAnnualLeaveEntitlementOrUnauthorized = AccessGrantedOptionalAnnualLeaveEntitlement | Unauthorized;

export type OptionalBankAccountOrUnauthorized = AccessGrantedOptionalBankAccount | Unauthorized;

export type OptionalClientPositionOrUnauthorized = AccessGrantedOptionalClientPosition | Unauthorized;

export type OptionalContractDraftOrUnauthorized = AccessGrantedOptionalContractDraft | Unauthorized;

export type OptionalCountryCodeOrUnauthorized = AccessGrantedOptionalCountryCode | Unauthorized;

export type OptionalCrossSellOrUnauthorized = AccessGrantedOptionalCrossSell | Unauthorized;

export type OptionalDownloadableExternallyHostedFileUrlOrUnauthorized = AccessGrantedOptionalDownloadableExternallyHostedFileUrl | Unauthorized;

export type OptionalEmailAddressOrUnauthorized = AccessGrantedOptionalEmailAddress | Unauthorized;

export type OptionalIdTypeOrUnauthorized = AccessGrantedOptionalIdType | Unauthorized;

export type OptionalLocalDateOrUnauthorized = AccessGrantedOptionalLocalDate | Unauthorized;

export type OptionalOffsetDateTimeOrUnauthorized = AccessGrantedOptionalOffsetDateTime | Unauthorized;

export type OptionalPeselOrUnauthorized = AccessGrantedOptionalPesel | Unauthorized;

export type OptionalPhoneNumberOrUnauthorized = AccessGrantedOptionalPhoneNumber | Unauthorized;

export type OptionalRevenueAdministrationOfficeOrUnauthorized = AccessGrantedOptionalRevenueAdministrationOffice | Unauthorized;

export type OptionalStringOrUnauthorized = AccessGrantedOptionalString | Unauthorized;

export type OptionalUriOrUnauthorized = AccessGrantedOptionalUri | Unauthorized;

export type OtherBankAccountNumber = BankAccountNumber & {
  readonly __typename?: 'OtherBankAccountNumber';
  readonly value: Scalars['String']['output'];
};

export type OtherBonus = Bonus & {
  readonly __typename?: 'OtherBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type OtherEmployeeInformationDrawer = AbstractDrawer & {
  readonly __typename?: 'OtherEmployeeInformationDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type OtherInvalidRequestError = UserError & {
  readonly __typename?: 'OtherInvalidRequestError';
  readonly key: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type ParkingSpot = {
  readonly __typename?: 'ParkingSpot';
  readonly blocked: Scalars['Boolean']['output'];
  readonly guest: Scalars['Boolean']['output'];
  readonly id: Scalars['ParkingSpotId']['output'];
  readonly name: Scalars['String']['output'];
  readonly number: Scalars['String']['output'];
  readonly officeId: Scalars['OfficeId']['output'];
};

export type ParkingSpotDrawer = AbstractDrawer & {
  readonly __typename?: 'ParkingSpotDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly parkingSpotId?: Maybe<Scalars['ParkingSpotId']['output']>;
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type ParkingSpotOrNfsError = NfsError | ParkingSpot;

export type PaymentConnection = {
  readonly __typename?: 'PaymentConnection';
  readonly invoice: SalesInvoice;
  readonly tpe: PaymentConnectionType;
  readonly transfer: BankIncomeTransfer;
};

export type PaymentConnectionOrNfsError = NfsError | PaymentConnection;

export const PaymentConnectionType = {
  ACCEPTED_AUTOMATICALLY: 'ACCEPTED_AUTOMATICALLY',
  ACCEPTED_MANUALLY: 'ACCEPTED_MANUALLY',
  HEURISTIC_SUGGESTION: 'HEURISTIC_SUGGESTION'
} as const;

export type PaymentConnectionType = typeof PaymentConnectionType[keyof typeof PaymentConnectionType];
export type PaymentCouldNotBeChangedError = UserError & {
  readonly __typename?: 'PaymentCouldNotBeChangedError';
  readonly csdIds: ReadonlyArray<ContractSalaryDetailsId>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type PaymentDetailsDraftDrawer = AbstractDrawer & {
  readonly __typename?: 'PaymentDetailsDraftDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly editing: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly requiredContractType: ContractType;
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type PaymentDetailsDrawer = AbstractDrawer & {
  readonly __typename?: 'PaymentDetailsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly effectiveDate?: Maybe<Scalars['Date']['output']>;
  readonly highlight?: Maybe<TimeBasedHighlight>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredContractType: ContractType;
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type PaymentDisbursed = {
  readonly __typename?: 'PaymentDisbursed';
  readonly disbursedAt: Scalars['OffsetDateTime']['output'];
  readonly transferState: TransferState;
};

export type PayrollTransfersOrderView = {
  readonly __typename?: 'PayrollTransfersOrderView';
  readonly batches: ReadonlyArray<TransferBatchView>;
  readonly count: Scalars['Int']['output'];
  readonly totalCount: Scalars['Int']['output'];
};

export type PayrollTransfersOrderViewOrNfsError = NfsError | PayrollTransfersOrderView;

export type PendingApproval = {
  readonly __typename?: 'PendingApproval';
  readonly isCurrentUserAllowedToApprove: Scalars['Boolean']['output'];
};

export type PendingCopyrightsDrawer = AbstractDrawer & {
  readonly __typename?: 'PendingCopyrightsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly highlightedWorkTransferId?: Maybe<Scalars['WorkTransferProtocolId']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredStartDate: Scalars['LocalDate']['output'];
  readonly requiredYearMonth: Scalars['YearMonth']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type PeopleListReportDrawer = AbstractDrawer & {
  readonly __typename?: 'PeopleListReportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type Person = {
  readonly __typename?: 'Person';
  readonly avatar?: Maybe<Scalars['URI']['output']>;
  readonly email: Scalars['EmailAddress']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly role: CompanyRole;
};

export type PersonalDataProcessingAuthorization = {
  readonly __typename?: 'PersonalDataProcessingAuthorization';
  readonly document: OptionalUriOrUnauthorized;
  readonly isAuthorized: Scalars['Boolean']['output'];
};

export type PersonalDataProcessingAuthorizationOrUnauthorized = AccessGrantedPersonalDataProcessingAuthorization | Unauthorized;

export type PolishVat = {
  readonly __typename?: 'PolishVat';
  readonly bankAccounts: ReadonlyArray<BankAccount>;
  readonly isPolishVat: VerificationStateWithDescriptionBooleanVatStatus;
};

export type PolishVatOrNfsError = NfsError | PolishVat;

export type PositionInactiveError = UserError & {
  readonly __typename?: 'PositionInactiveError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly positionId: Scalars['ClientPositionId']['output'];
};

export type PpkDetails = {
  readonly __typename?: 'PpkDetails';
  readonly employee: Scalars['Cents']['output'];
  readonly employer: Scalars['Cents']['output'];
};

export type PpkDetailsInput = {
  readonly employee: Scalars['Cents']['input'];
  readonly employer: Scalars['Cents']['input'];
};

export const ProgressionLevel = {
  ENGINEERE1: 'EngineerE1',
  ENGINEERE2: 'EngineerE2',
  ENGINEERINTERN: 'EngineerIntern',
  ENGINEERJ1: 'EngineerJ1',
  ENGINEERJ2: 'EngineerJ2',
  ENGINEERJ3: 'EngineerJ3',
  ENGINEERJUNIOR: 'EngineerJunior',
  ENGINEERM1: 'EngineerM1',
  ENGINEERM2: 'EngineerM2',
  ENGINEERM3: 'EngineerM3',
  ENGINEERM4: 'EngineerM4',
  ENGINEERMID: 'EngineerMid',
  ENGINEERPRINCIPAL: 'EngineerPrincipal',
  ENGINEERS1: 'EngineerS1',
  ENGINEERS2: 'EngineerS2',
  ENGINEERS3: 'EngineerS3',
  ENGINEERS4: 'EngineerS4',
  ENGINEERS5: 'EngineerS5',
  ENGINEERSENIOR: 'EngineerSenior',
  ENGINEERSTAFF: 'EngineerStaff',
  NONENGINEERE1: 'NonEngineerE1',
  NONENGINEERE2: 'NonEngineerE2',
  NONENGINEEREXPERT: 'NonEngineerExpert',
  NONENGINEERINTERN: 'NonEngineerIntern',
  NONENGINEERJ1: 'NonEngineerJ1',
  NONENGINEERJ2: 'NonEngineerJ2',
  NONENGINEERJ3: 'NonEngineerJ3',
  NONENGINEERJUNIOR: 'NonEngineerJunior',
  NONENGINEERM1: 'NonEngineerM1',
  NONENGINEERM2: 'NonEngineerM2',
  NONENGINEERM3: 'NonEngineerM3',
  NONENGINEERM4: 'NonEngineerM4',
  NONENGINEERREGULAR: 'NonEngineerRegular',
  NONENGINEERS1: 'NonEngineerS1',
  NONENGINEERS2: 'NonEngineerS2',
  NONENGINEERS3: 'NonEngineerS3',
  NONENGINEERS4: 'NonEngineerS4',
  NONENGINEERSENIOR: 'NonEngineerSenior'
} as const;

export type ProgressionLevel = typeof ProgressionLevel[keyof typeof ProgressionLevel];
export type ProgressionLevelGroupedByCategories = {
  readonly __typename?: 'ProgressionLevelGroupedByCategories';
  readonly all: ReadonlyArray<ProgressionLevel>;
  readonly engineer: ReadonlyArray<ProgressionLevel>;
  readonly nonEngineer: ReadonlyArray<ProgressionLevel>;
  readonly sml: ReadonlyArray<ProgressionLevel>;
  readonly smlEngineer: ReadonlyArray<ProgressionLevel>;
  readonly smlNonEngineer: ReadonlyArray<ProgressionLevel>;
  readonly vl: ReadonlyArray<ProgressionLevel>;
  readonly vlEngineer: ReadonlyArray<ProgressionLevel>;
  readonly vlNonEngineer: ReadonlyArray<ProgressionLevel>;
};

export type ProgressionScheme = {
  readonly __typename?: 'ProgressionScheme';
  readonly archivedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['ProgressionSchemeId']['output'];
  readonly isEngineering: Scalars['Boolean']['output'];
  readonly levels: ReadonlyArray<ProgressionSchemeLevel>;
  readonly name: Scalars['String']['output'];
  readonly yearlyRaise: Scalars['Cents']['output'];
};

export type ProgressionSchemeLevel = {
  readonly __typename?: 'ProgressionSchemeLevel';
  readonly hourlyRate: Scalars['Cents']['output'];
  readonly level: ProgressionLevel;
  readonly noticePeriod?: Maybe<Scalars['Days']['output']>;
  readonly schemeId: Scalars['ProgressionSchemeId']['output'];
  readonly title: Scalars['String']['output'];
};

export type ProgressionSchemeLevelDrawer = AbstractDrawer & {
  readonly __typename?: 'ProgressionSchemeLevelDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly level?: Maybe<ProgressionLevel>;
  readonly requiredSchemeId: Scalars['ProgressionSchemeId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type ProgressionSchemeLevelInput = {
  readonly hourlyRate: Scalars['Cents']['input'];
  readonly level: ProgressionLevel;
  readonly noticePeriod?: InputMaybe<Scalars['Days']['input']>;
  readonly schemeId: Scalars['ProgressionSchemeId']['input'];
  readonly title: Scalars['String']['input'];
};

export type ProgressionSchemeOrNfsError = NfsError | ProgressionScheme;

export type Project = {
  readonly __typename?: 'Project';
  readonly accountManager?: Maybe<ProjectRoleAssignment>;
  readonly areaOfVlEngagement: OptionalStringOrUnauthorized;
  readonly assignedUsers: ReadonlyArray<ProjectAssignment>;
  readonly clientContract: ClientContract;
  readonly competences: ListOfStringOrUnauthorized;
  readonly costAndRevenueItems: ListOfCostAndRevenueItemOrUnauthorized;
  readonly costLedgerAccountNumber: OptionalStringOrUnauthorized;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly crossSell: OptionalCrossSellOrUnauthorized;
  readonly description: OptionalStringOrUnauthorized;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly id: Scalars['ProjectId']['output'];
  readonly lead?: Maybe<ProjectRoleAssignment>;
  readonly name: Scalars['String']['output'];
  readonly owner?: Maybe<ProjectRoleAssignment>;
  readonly profileUri: Scalars['String']['output'];
  readonly revenueLedgerAccountNumber: OptionalStringOrUnauthorized;
  readonly space?: Maybe<Space>;
  readonly statusHistory: ReadonlyArray<ProjectStatusHistoryEntry>;
  readonly techStack: ListOfStringOrUnauthorized;
};


export type ProjectAssignedUsersArgs = {
  orderByFirstPositionStartDate?: InputMaybe<SortOrder>;
  status_oneOf?: InputMaybe<ReadonlyArray<ProjectAssignmentStatus>>;
};

export type ProjectAssignment = {
  readonly __typename?: 'ProjectAssignment';
  readonly periods: ReadonlyArray<ProjectAssignmentPeriod>;
  readonly project: Project;
  readonly user: User;
};

export type ProjectAssignmentId = {
  readonly __typename?: 'ProjectAssignmentId';
  readonly projectId: Scalars['ProjectId']['output'];
  readonly userId: Scalars['UserId']['output'];
};

export type ProjectAssignmentOperations = {
  readonly __typename?: 'ProjectAssignmentOperations';
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly deleteProjectAssignment: UnitResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam, SpaceDirector]) */
  readonly upsertAccountManagerAssignment: ProjectRoleAssignmentOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam, SpaceDirector]) */
  readonly upsertLeadAssignment: ProjectRoleAssignmentOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam, SpaceDirector]) */
  readonly upsertOwnerAssignment: ProjectRoleAssignmentOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam]) */
  readonly upsertProjectAssignment: ProjectAssignmentOrNfsError;
};


export type ProjectAssignmentOperationsDeleteProjectAssignmentArgs = {
  value: Scalars['UserId']['input'];
};


export type ProjectAssignmentOperationsUpsertAccountManagerAssignmentArgs = {
  periods: ReadonlyArray<ProjectRoleAssignmentPeriodInput>;
};


export type ProjectAssignmentOperationsUpsertLeadAssignmentArgs = {
  periods: ReadonlyArray<ProjectRoleAssignmentPeriodInput>;
};


export type ProjectAssignmentOperationsUpsertOwnerAssignmentArgs = {
  periods: ReadonlyArray<ProjectRoleAssignmentPeriodInput>;
};


export type ProjectAssignmentOperationsUpsertProjectAssignmentArgs = {
  input: CreateProjectAssignmentInput;
};

export type ProjectAssignmentOrNfsError = NfsError | ProjectAssignment;

export type ProjectAssignmentPeriod = {
  readonly __typename?: 'ProjectAssignmentPeriod';
  readonly clientPosition: ClientPositionOrUnauthorized;
  readonly dateRange: LocalDateRange;
  readonly subcontractPosition: OptionalClientPositionOrUnauthorized;
};

export type ProjectAssignmentPeriodInput = {
  readonly clientPositionId: Scalars['ClientPositionId']['input'];
  readonly from: Scalars['LocalDate']['input'];
  readonly subcontractPositionId?: InputMaybe<Scalars['ClientPositionId']['input']>;
  readonly to?: InputMaybe<Scalars['LocalDate']['input']>;
};

export const ProjectAssignmentStatus = {
  LIVE: 'Live',
  PLANNED: 'Planned',
  TERMINATED: 'Terminated'
} as const;

export type ProjectAssignmentStatus = typeof ProjectAssignmentStatus[keyof typeof ProjectAssignmentStatus];
export type ProjectBillablesReportDrawer = AbstractDrawer & {
  readonly __typename?: 'ProjectBillablesReportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type ProjectMembersDrawer = AbstractDrawer & {
  readonly __typename?: 'ProjectMembersDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly clientContractLink?: Maybe<Scalars['String']['output']>;
  readonly focusedUserId?: Maybe<Scalars['UserId']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly mode: ProjectMembersDrawerMode;
  readonly requiredProjectId: Scalars['ProjectId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export const ProjectMembersDrawerMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  MANAGE: 'MANAGE'
} as const;

export type ProjectMembersDrawerMode = typeof ProjectMembersDrawerMode[keyof typeof ProjectMembersDrawerMode];
export type ProjectMutation = {
  readonly __typename?: 'ProjectMutation';
  readonly projectAssignments: ProjectAssignmentOperations;
  /** @allowedIfAnyOf(roles: [FinancialTeam, InvoicingTeam, SpaceDirector]) */
  readonly update: ProjectOrNfsError;
};


export type ProjectMutationUpdateArgs = {
  areaOfVlEngagement?: InputMaybe<ClearableStringInput>;
  competences?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  costAndRevenueItems?: InputMaybe<ReadonlyArray<CostAndRevenueItemInput>>;
  costLedgerAccountNumber?: InputMaybe<ClearableStringInput>;
  crossSell?: InputMaybe<ClearableCrossSellInput>;
  description?: InputMaybe<ClearableStringInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  revenueLedgerAccountNumber?: InputMaybe<ClearableStringInput>;
  spaceId?: InputMaybe<ClearableSpaceIdInput>;
  statusHistory?: InputMaybe<ReadonlyArray<ProjectStatusHistoryEntryInput>>;
  techStack?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type ProjectOrNfsError = NfsError | Project;

export type ProjectRoleAssignment = {
  readonly __typename?: 'ProjectRoleAssignment';
  readonly periods: ReadonlyArray<ProjectRoleAssignmentPeriod>;
  readonly project: Project;
};

export type ProjectRoleAssignmentOrNfsError = NfsError | ProjectRoleAssignment;

export type ProjectRoleAssignmentPeriod = {
  readonly __typename?: 'ProjectRoleAssignmentPeriod';
  readonly dateRange: LocalDateRange;
  readonly user: User;
};

export type ProjectRoleAssignmentPeriodInput = {
  readonly from: Scalars['LocalDate']['input'];
  readonly to?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly userId: Scalars['UserId']['input'];
};

export const ProjectStatus = {
  CLOSED: 'Closed',
  LIVE: 'Live',
  ONHOLD: 'OnHold'
} as const;

export type ProjectStatus = typeof ProjectStatus[keyof typeof ProjectStatus];
export type ProjectStatusHistoryEntry = {
  readonly __typename?: 'ProjectStatusHistoryEntry';
  readonly dateRange: LocalDateRange;
  readonly status: ProjectStatus;
};

export type ProjectStatusHistoryEntryInput = {
  readonly dateRange: LocalDateRangeInput;
  readonly status: ProjectStatus;
};

export type ProjectUtilization = {
  readonly __typename?: 'ProjectUtilization';
  readonly client: Company;
  readonly fullTimeEquivalent: Scalars['BigDecimal']['output'];
  readonly mandays: Scalars['WorkDays']['output'];
  readonly project: Project;
  readonly teamMembers: ReadonlyArray<User>;
};

export type PromisorTransferBankAccount = {
  readonly __typename?: 'PromisorTransferBankAccount';
  readonly isOverwritten: Scalars['Boolean']['output'];
  readonly value?: Maybe<BankAccount>;
};

export const Quarter = {
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4'
} as const;

export type Quarter = typeof Quarter[keyof typeof Quarter];
export type QuarterYear = {
  readonly __typename?: 'QuarterYear';
  readonly quarter: Quarter;
  readonly year: Scalars['Year']['output'];
};

export type QuarterYearInput = {
  readonly quarter: Quarter;
  readonly year: Scalars['Year']['input'];
};

export type Query = {
  readonly __typename?: 'Query';
  readonly absenceTypeDetails: ReadonlyArray<KvAbsenceTypeAbsenceTypeDetails>;
  readonly admin: AdminOrNfsError;
  readonly admins: ListOfAdminResponseOrNfsError;
  readonly annualLeaveSummary: AnnualLeaveSummaryOrNfsError;
  /** @allowedIfAnyOf(roles: [SecurityTeam]) */
  readonly apiTokens: ListOfApiTokenResponseOrNfsError;
  readonly assignedProjects: ListOfAssignedProjectResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly assignedVariants: FspResponseAssignedVariantOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly bankTransfer: BankTransferResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly bankTransfers: FspResponseBankTransferOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam]) */
  readonly basicFinancialReport: ListOfBfrFileUrlResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam]) */
  readonly basicFinancialReportExportStatus: BfrExportStatusResponseOrNfsError;
  readonly benefit: BenefitOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly benefitInvoiceDocument: GoogleSpreadsheetUrlOrNfsError;
  readonly benefitVariant: BenefitVariantOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly benefits: ListOfBenefitGroupResponseOrNfsError;
  readonly clientContract: ClientContractOrNfsError;
  readonly clientContracts: FspResponseClientContractOrNfsError;
  readonly clientContractsBetweenCompanies: ListOfClientContractResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly clientTimeReport: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam, OfficeTeam, SpaceDirector]) */
  readonly companies: FspResponseCompanyOrNfsError;
  readonly company: CompanyOrNfsError;
  readonly companyInfo: CompanyInfoOrNfsError;
  readonly contract: ContractResponseOrNfsError;
  readonly contractDocumentTemplateDescriptions: ListOfContractDocumentTemplateDescriptionResponseOrNfsError;
  readonly contractDrafts: ListOfContractDraftResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly contractDraftsFSP: FspResponseContractDraftOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam]) */
  readonly contractSalaryDetails: ContractSalaryDetailsResponseOrNfsError;
  readonly contractSalaryDetailsAdditionalData: ContractSalaryDetailsAdditionalDataOrNfsError;
  readonly contractSalaryDetailsInRange: ListOfContractSalaryDetailsResponseOrNfsError;
  readonly contractSalarySummaries: ListOfTransfersSummariesResponseOrNfsError;
  readonly contractSalarySummariesInRange: ListOfTransfersSummariesResponseOrNfsError;
  readonly contractSalarySummariesWithFilter: ListOfTransfersSummariesResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, Lead, SpaceDirector]) */
  readonly contracts: FspResponseContractOrNfsError;
  readonly contractsB2BSalaryDetails: FspResponseB2BContractSalaryDetailsOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly contractsCostsSummary: GoogleSpreadsheetUrlOrNfsError;
  readonly contractsEmploymentSalaryDetails: FspResponseEmploymentContractSalaryDetailsOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly costInvoice: CostInvoiceOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly costInvoices: ListOfCostInvoiceResponseOrNfsError;
  readonly defaultActiveReportingRange?: Maybe<ClosedEndLocalDateRangeOrNfsError>;
  /** @allowedIfAnyOf(roles: [OfficeTeam, SecurityTeam]) */
  readonly deskAssignments: ListOfDeskAssignmentResponseOrNfsError;
  readonly drawer?: Maybe<AbstractDrawer>;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly exportForInvoicingClients: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly fakturowniaProfiles: ListOfFakturowniaProfileResponseOrNfsError;
  readonly getUserByEmail: UserOrNfsError;
  readonly getUserProjects: ListOfProjectIdResponseOrNfsError;
  /** Google consent URL to start connecting a Gmail account for the calling admin */
  readonly gmailAuthUrl: UriResponseOrNfsError;
  /** The calling admin's own connected Gmail account, if any */
  readonly gmailConnection?: Maybe<GmailConnectionOrNfsError>;
  readonly holidayCalendars: ReadonlyArray<HolidayCalendar>;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly holidaySummaries: ListOfHolidaySummaryFileUrlResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly holidaySummaryDocument: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam, OfficeTeam, PeopleAndTalentAcquisitionTeam]) */
  readonly hrSummaryReportLimitedDocument: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam]) */
  readonly hrSummaryReportMainDocument: GoogleSpreadsheetUrlOrNfsError;
  readonly internalContract: ClientContractOrNfsError;
  readonly nonB2bPayrollInputsDocument: DownloadableFileUrlOrNfsError;
  readonly office: OfficeOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam, SecurityTeam]) */
  readonly officeAvailability: OfficeAvailabilityOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam, SecurityTeam]) */
  readonly officeCatalogue: OfficeCatalogueOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam, SecurityTeam]) */
  readonly officeReservation: ReservationRequestOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam, SecurityTeam]) */
  readonly officeReservationSettings: OfficeReservationSettingsOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam, SecurityTeam]) */
  readonly officeReservations: FspResponseOfficeReservationOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam, SecurityTeam]) */
  readonly officeSettings: OfficeSettingsOrNfsError;
  readonly offices: ListOfOfficeResponseOrNfsError;
  readonly onCallMultipliers: OnCallMultipliersOrNfsError;
  readonly paidLeaveBalanceYearlySummary?: Maybe<DaysBalanceOrNfsError>;
  readonly payrollTransfersDocument: DownloadableFileUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [OfficeTeam, SecurityTeam]) */
  readonly pendingOfficeReservationRequests: IntResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly pendingWorkTransferProtocols: ListOfWorkTransferProtocolResponseOrNfsError;
  readonly progressionLevelGroupedByCategories: ProgressionLevelGroupedByCategories;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly progressionScheme: ProgressionSchemeOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly progressionSchemes: ListOfProgressionSchemeResponseOrNfsError;
  readonly project: ProjectOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly projectBillablesDocument: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly projectTimeReport: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam, SpaceDirector]) */
  readonly projectUtilization: ListOfProjectUtilizationResponseOrNfsError;
  readonly projects: FspResponseProjectOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly raises: ListOfRaiseProposalResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly rateChangeEventSummaryReport: GoogleSpreadsheetUrlOrNfsError;
  readonly remainingWorkTagReportingLimit: ListOfKvWorkTagIdMinutesResponseOrNfsError;
  readonly remoteWorkReimbursementRate?: Maybe<Scalars['Cents']['output']>;
  readonly reportingPeriods: ListOfReportingPeriodResponseOrNfsError;
  readonly requiredActions: RequiredActionsOrNfsError;
  readonly resolveSubcontractRelatedProjectAssignments: ListOfProjectAssignmentResponseOrNfsError;
  readonly revenueAdministrationOffices: FspResponseRevenueAdministrationOfficeOrNfsError;
  readonly rootDrawer?: Maybe<AbstractDrawer>;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly salariesSummaryReport: GoogleSpreadsheetUrlOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly salesInvoiceDetails: SalesInvoiceDetailsOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam]) */
  readonly salesInvoices: ListOfSalesInvoiceResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam]) */
  readonly skillsAndCertificatesReport: GoogleSpreadsheetUrlOrNfsError;
  readonly space: SpaceOrNfsError;
  readonly spaces: FspResponseSpaceOrNfsError;
  readonly subBenefit: SubBenefitOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, InvoicingTeam, Lead, SpaceDirector]) */
  readonly timeReport: TimeReportOrNfsError;
  readonly timeReportFile: DownloadableFileUrlOrNfsError;
  readonly timeReportValidations: ListOfTimeReportValidationResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [ChiefOfficer, FinancialTeam, Lead, SpaceDirector]) */
  readonly timeReportsRequiringApproval: TimeReportsRequiringApprovalOrNfsError;
  readonly topDrawer?: Maybe<AbstractDrawer>;
  readonly trainingBudgetSummary: TrainingBudgetSummaryOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly trainingBudgetSummaryReport: GoogleSpreadsheetUrlOrNfsError;
  readonly user: UserOrNfsError;
  readonly users: FspResponseUserOrNfsError;
  /** Returns contract draft if every field is valid and contract draft can be concluded, otherwise IncompleteArgumentsError is thrown. */
  readonly validateContractDraft: ContractDraftResponseOrNfsError;
  readonly whoAmI: ListOfStringResponseOrNfsError;
};


export type QueryAdminArgs = {
  value: Scalars['AdminId']['input'];
};


export type QueryAnnualLeaveSummaryArgs = {
  contractId: Scalars['ContractId']['input'];
  year: Scalars['Year']['input'];
};


export type QueryAssignedProjectsArgs = {
  contractId: Scalars['ContractId']['input'];
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


export type QueryAssignedVariantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterAssignedVariantInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortAssignedVariantInput>;
};


export type QueryBankTransferArgs = {
  id: Scalars['BankTransferId']['input'];
};


export type QueryBankTransfersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterBankTransferInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortBankTransferInput>;
};


export type QueryBenefitArgs = {
  id: Scalars['BenefitId']['input'];
};


export type QueryBenefitInvoiceDocumentArgs = {
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryBenefitVariantArgs = {
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  id: Scalars['BenefitVariantId']['input'];
};


export type QueryBenefitsArgs = {
  filter?: InputMaybe<BenefitVariantFilterInput>;
  groupType?: InputMaybe<BenefitGroupType>;
  sortBy?: InputMaybe<BenefitSortBy>;
};


export type QueryClientContractArgs = {
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  id: Scalars['ClientContractId']['input'];
};


export type QueryClientContractsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterClientContractInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortClientContractInput>;
};


export type QueryClientContractsBetweenCompaniesArgs = {
  promiseeId: Scalars['CompanyId']['input'];
  promisorId: Scalars['CompanyId']['input'];
};


export type QueryClientTimeReportArgs = {
  clientContractId: Scalars['ClientContractId']['input'];
  period: ClosedEndLocalDateRangeInput;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterCompanyInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortCompanyInput>;
};


export type QueryCompanyArgs = {
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  id: Scalars['CompanyId']['input'];
};


export type QueryCompanyInfoArgs = {
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  taxNumber: Scalars['TaxNumber']['input'];
};


export type QueryContractArgs = {
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  contractId: Scalars['ContractId']['input'];
};


export type QueryContractDraftsFspArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterContractInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortContractInput>;
};


export type QueryContractSalaryDetailsArgs = {
  contractId: Scalars['ContractId']['input'];
  date: Scalars['YearMonth']['input'];
};


export type QueryContractSalaryDetailsAdditionalDataArgs = {
  contractId: Scalars['ContractId']['input'];
  date: Scalars['YearMonth']['input'];
};


export type QueryContractSalaryDetailsInRangeArgs = {
  contractId: Scalars['ContractId']['input'];
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
};


export type QueryContractSalarySummariesArgs = {
  year: Scalars['Year']['input'];
};


export type QueryContractSalarySummariesInRangeArgs = {
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
};


export type QueryContractSalarySummariesWithFilterArgs = {
  filter: FilterContractSalaryDetailsInput;
  yearMonth?: InputMaybe<Scalars['YearMonth']['input']>;
};


export type QueryContractsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterContractInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortContractInput>;
};


export type QueryContractsB2BSalaryDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterContractSalaryDetailsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortContractSalaryDetailsInput>;
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryContractsCostsSummaryArgs = {
  filter: FilterContractInput;
  range: ClosedEndMonthRangeInput;
};


export type QueryContractsEmploymentSalaryDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterContractSalaryDetailsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortContractSalaryDetailsInput>;
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryCostInvoiceArgs = {
  saldeoDocumentId: SaldeoDocumentIdInput;
};


export type QueryCostInvoicesArgs = {
  companyId: Scalars['CompanyId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryDefaultActiveReportingRangeArgs = {
  contractId: Scalars['ContractId']['input'];
};


export type QueryDeskAssignmentsArgs = {
  officeId: Scalars['OfficeId']['input'];
};


export type QueryDrawerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportForInvoicingClientsArgs = {
  clientContractId: Scalars['ClientContractId']['input'];
  period: ClosedEndLocalDateRangeInput;
};


export type QueryGetUserByEmailArgs = {
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  email: Scalars['EmailAddress']['input'];
};


export type QueryGetUserProjectsArgs = {
  userId: Scalars['UserId']['input'];
};


export type QueryHolidaySummaryDocumentArgs = {
  year: Scalars['Year']['input'];
};


export type QueryInternalContractArgs = {
  groupCompanyId: Scalars['CompanyId']['input'];
};


export type QueryNonB2bPayrollInputsDocumentArgs = {
  filter?: InputMaybe<FilterContractSalaryDetailsInput>;
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryOfficeArgs = {
  officeId: Scalars['OfficeId']['input'];
};


export type QueryOfficeAvailabilityArgs = {
  officeId: Scalars['OfficeId']['input'];
  range?: InputMaybe<ClosedEndLocalDateRangeInput>;
};


export type QueryOfficeCatalogueArgs = {
  officeId: Scalars['OfficeId']['input'];
};


export type QueryOfficeReservationArgs = {
  requestId: Scalars['ReservationRequestId']['input'];
};


export type QueryOfficeReservationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterOfficeReservationInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortOfficeReservationInput>;
};


export type QueryOfficeSettingsArgs = {
  officeId: Scalars['OfficeId']['input'];
};


export type QueryPaidLeaveBalanceYearlySummaryArgs = {
  contractId: Scalars['ContractId']['input'];
  year: Scalars['Year']['input'];
};


export type QueryPayrollTransfersDocumentArgs = {
  filter: FilterContractSalaryDetailsInput;
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryPendingWorkTransferProtocolsArgs = {
  sort: SortWorkTransferProtocolsInput;
};


export type QueryProgressionSchemeArgs = {
  progressionSchemeId: Scalars['ProgressionSchemeId']['input'];
};


export type QueryProgressionSchemesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProjectArgs = {
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  projectId: Scalars['ProjectId']['input'];
};


export type QueryProjectBillablesDocumentArgs = {
  projectId: Scalars['ProjectId']['input'];
};


export type QueryProjectTimeReportArgs = {
  period: ClosedEndLocalDateRangeInput;
  projectId: Scalars['ProjectId']['input'];
};


export type QueryProjectUtilizationArgs = {
  fullTimeThresholdMinutes: Scalars['Int']['input'];
  halfTimeThresholdMinutes: Scalars['Int']['input'];
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterProjectInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortProjectInput>;
};


export type QueryRemainingWorkTagReportingLimitArgs = {
  userId: Scalars['UserId']['input'];
  year: Scalars['Year']['input'];
};


export type QueryRemoteWorkReimbursementRateArgs = {
  value: Scalars['YearMonth']['input'];
};


export type QueryReportingPeriodsArgs = {
  clientContractId: Scalars['ClientContractId']['input'];
};


export type QueryResolveSubcontractRelatedProjectAssignmentsArgs = {
  client: Scalars['CompanyId']['input'];
  supplier: Scalars['CompanyId']['input'];
};


export type QueryRevenueAdministrationOfficesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterRevenueAdministrationOfficesInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortRevenueAdministrationOfficesInput>;
};


export type QuerySalariesSummaryReportArgs = {
  salariesSummaryType: SalariesSummaryType;
  yearMonth: Scalars['YearMonth']['input'];
};


export type QuerySalesInvoiceDetailsArgs = {
  invoiceId: Scalars['SalesInvoiceId']['input'];
};


export type QuerySalesInvoicesArgs = {
  allSearch?: InputMaybe<Scalars['String']['input']>;
  buyerCompany_oneOf?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']>>;
  buyerName_oneOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  buyerType_oneOf?: InputMaybe<ReadonlyArray<BuyerType>>;
  clientIsWithinGroup_eq?: InputMaybe<Scalars['Boolean']['input']>;
  currency_oneOf?: InputMaybe<ReadonlyArray<Scalars['Currency']['input']>>;
  dateRange: ClosedEndLocalDateRangeInput;
  expectedPaymentDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  issueDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  kind_oneOf?: InputMaybe<ReadonlyArray<InvoiceKind>>;
  overdue_eq?: InputMaybe<Scalars['Boolean']['input']>;
  paidDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  paymentTo_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  searchDateType: SearchDateType;
  sellDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  sellerCompany_oneOf?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']>>;
  status_notIn?: InputMaybe<ReadonlyArray<SalesInvoiceStatus>>;
  status_oneOf?: InputMaybe<ReadonlyArray<SalesInvoiceStatus>>;
};


export type QuerySpaceArgs = {
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  spaceId: Scalars['SpaceId']['input'];
};


export type QuerySpacesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterSpaceInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortSpaceInput>;
};


export type QuerySubBenefitArgs = {
  id: Scalars['BenefitId']['input'];
};


export type QueryTimeReportArgs = {
  contractId: Scalars['ContractId']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};


export type QueryTimeReportFileArgs = {
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryTimeReportValidationsArgs = {
  contractId: Scalars['ContractId']['input'];
  date: Scalars['YearMonth']['input'];
};


export type QueryTrainingBudgetSummaryArgs = {
  contractId: Scalars['ContractId']['input'];
  year: Scalars['Year']['input'];
};


export type QueryUserArgs = {
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  id: Scalars['UserId']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterUserInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortUserInput>;
};


export type QueryValidateContractDraftArgs = {
  userId: Scalars['UserId']['input'];
};

export type RaiseNoLongerDueError = UserError & {
  readonly __typename?: 'RaiseNoLongerDueError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

/** A contractor due a raise in the evaluated month according to their contract's progression scheme */
export type RaiseProposal = {
  readonly __typename?: 'RaiseProposal';
  readonly contract: Contract;
  readonly currentHourlyRate: Scalars['Cents']['output'];
  readonly hourlyRateIncrease: Scalars['Cents']['output'];
  readonly lastRateChangeDate: Scalars['LocalDate']['output'];
  readonly level: ProgressionLevel;
  readonly nextLevel?: Maybe<ProgressionLevel>;
  readonly progressionScheme: ProgressionScheme;
  readonly proposedHourlyRate: Scalars['Cents']['output'];
  readonly yearsSinceLastRateChange: Scalars['Int']['output'];
};

export type Rate = {
  readonly __typename?: 'Rate';
  readonly amount: NetGross;
  readonly settlement: Settlement;
};

export type RateCardDrawer = AbstractDrawer & {
  readonly __typename?: 'RateCardDrawer';
  readonly addNewPosition?: Maybe<Scalars['Boolean']['output']>;
  readonly child?: Maybe<AbstractDrawer>;
  readonly editing: Scalars['Boolean']['output'];
  readonly effectiveDate?: Maybe<Scalars['Date']['output']>;
  readonly highlight?: Maybe<TimeBasedHighlight>;
  readonly id: Scalars['ID']['output'];
  readonly requiredClientContractId: Scalars['ClientContractId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type RateChangesReportDrawer = AbstractDrawer & {
  readonly __typename?: 'RateChangesReportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type RateDetails = {
  readonly __typename?: 'RateDetails';
  readonly currency: Scalars['Currency']['output'];
  readonly overtimeRate?: Maybe<NetGross>;
  readonly rate: Rate;
  readonly rateIncreaseDueToRefundedBenefits?: Maybe<NetGross>;
  readonly vat?: Maybe<Scalars['BasisPoint']['output']>;
};

export type Ready = {
  readonly __typename?: 'Ready';
  readonly at: Scalars['OffsetDateTime']['output'];
};

export type RemoteWorkEquipmentBonus = Bonus & {
  readonly __typename?: 'RemoteWorkEquipmentBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type RemoteWorkReimbursement = {
  readonly __typename?: 'RemoteWorkReimbursement';
  readonly rate: Scalars['Cents']['output'];
  readonly time: Scalars['Minutes']['output'];
  readonly totalValue: NetGross;
};

export type ReportedLeaveDays = {
  readonly __typename?: 'ReportedLeaveDays';
  readonly annual: AnnualLeaveEntitlementValue;
  readonly caregiving: Scalars['WorkDays']['output'];
  readonly childCare: Scalars['WorkDays']['output'];
  readonly dueToForceMajeure: Scalars['WorkDays']['output'];
  readonly maternity: Scalars['WorkDays']['output'];
  readonly outOfOffice: Scalars['WorkDays']['output'];
  readonly paid: Scalars['WorkDays']['output'];
  readonly parental: Scalars['WorkDays']['output'];
  readonly paternity: Scalars['WorkDays']['output'];
  readonly sickFamilyMemberCare: Scalars['WorkDays']['output'];
  readonly sickLeave: Scalars['WorkDays']['output'];
  readonly special: Scalars['WorkDays']['output'];
  readonly unpaid: Scalars['WorkDays']['output'];
};

export type ReportingApi = {
  readonly __typename?: 'ReportingApi';
  readonly absenceRecord: AbsenceRecordApi;
  readonly deleteTimeReports: UnitResponseOrNfsError;
  readonly oncallRecord: OnCallRecordApi;
  readonly workRecord: WorkRecordApi;
};


export type ReportingApiDeleteTimeReportsArgs = {
  absenceRecordIds: ReadonlyArray<Scalars['AbsenceRecordId']['input']>;
  onCallRecordIds: ReadonlyArray<Scalars['OnCallRecordId']['input']>;
  workRecordIds: ReadonlyArray<Scalars['WorkRecordId']['input']>;
};

export type ReportingPeriod = {
  readonly __typename?: 'ReportingPeriod';
  readonly clientContractId: Scalars['ClientContractId']['output'];
  readonly from: Scalars['LocalDate']['output'];
  readonly id: Scalars['ReportingPeriodId']['output'];
  readonly to: Scalars['LocalDate']['output'];
};

export type ReportingPeriodInput = {
  readonly clientContractId: Scalars['ClientContractId']['input'];
  readonly from: Scalars['LocalDate']['input'];
  readonly id: Scalars['ReportingPeriodId']['input'];
  readonly to: Scalars['LocalDate']['input'];
};

export type ReportingPeriodMutation = {
  readonly __typename?: 'ReportingPeriodMutation';
  readonly createMany: ListOfReportingPeriodResponseOrNfsError;
  readonly deleteMany: UnitResponseOrNfsError;
};


export type ReportingPeriodMutationCreateManyArgs = {
  value: ReadonlyArray<ReportingPeriodInput>;
};


export type ReportingPeriodMutationDeleteManyArgs = {
  value: ReadonlyArray<Scalars['ReportingPeriodId']['input']>;
};

export type RequiredActions = {
  readonly __typename?: 'RequiredActions';
  readonly employeeRemindersNextRevisionDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly pendingWorkTransferProtocols: Scalars['Int']['output'];
};

export type RequiredActionsOrNfsError = NfsError | RequiredActions;

export type ReservationLimitsDrawer = AbstractDrawer & {
  readonly __typename?: 'ReservationLimitsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type ReservationNotPendingError = UserError & {
  readonly __typename?: 'ReservationNotPendingError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly requestId: Scalars['ReservationRequestId']['output'];
};

export type ReservationRequest = {
  readonly __typename?: 'ReservationRequest';
  readonly approval: Approval;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly createdBy: CreatedBy;
  readonly guestEmails: ReadonlyArray<Scalars['EmailAddress']['output']>;
  readonly kind: ResourceKind;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly office: Office;
  readonly plateNumber?: Maybe<Scalars['String']['output']>;
  readonly range: ClosedEndLocalDateRange;
  readonly requestId: Scalars['ReservationRequestId']['output'];
  readonly resources: ReadonlyArray<ReservedResource>;
  readonly user: User;
};

export type ReservationRequestOrNfsError = NfsError | ReservationRequest;

export type ReservationRequestStateError = UserError & {
  readonly __typename?: 'ReservationRequestStateError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly requestId: Scalars['ReservationRequestId']['output'];
};

export type ReserveDesksInput = {
  readonly deskIds: ReadonlyArray<Scalars['DeskId']['input']>;
  readonly guestEmails: ReadonlyArray<Scalars['EmailAddress']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly range: ClosedEndLocalDateRangeInput;
  readonly requestId: Scalars['ReservationRequestId']['input'];
  readonly roomId: Scalars['RoomId']['input'];
};

export type ReserveParkingInput = {
  readonly guestEmails: ReadonlyArray<Scalars['EmailAddress']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly officeId: Scalars['OfficeId']['input'];
  readonly parkingSpotId?: InputMaybe<Scalars['ParkingSpotId']['input']>;
  readonly plateNumber?: InputMaybe<Scalars['String']['input']>;
  readonly range: ClosedEndLocalDateRangeInput;
  readonly requestId: Scalars['ReservationRequestId']['input'];
};

export type ReservedResource = {
  readonly __typename?: 'ReservedResource';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type ResourceAlreadyReservedError = UserError & {
  readonly __typename?: 'ResourceAlreadyReservedError';
  readonly dates: ReadonlyArray<Scalars['LocalDate']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type ResourceAvailability = {
  readonly __typename?: 'ResourceAvailability';
  readonly resourceId: Scalars['ID']['output'];
  readonly takenDates: ReadonlyArray<Scalars['LocalDate']['output']>;
};

export const ResourceKind = {
  DESK: 'Desk',
  PARKINGSPOT: 'ParkingSpot'
} as const;

export type ResourceKind = typeof ResourceKind[keyof typeof ResourceKind];
export type RevenueAdministrationOffice = {
  readonly __typename?: 'RevenueAdministrationOffice';
  readonly city: Scalars['String']['output'];
  readonly country: Scalars['String']['output'];
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly faxNumber?: Maybe<Scalars['String']['output']>;
  readonly flatNumber?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['RevenueAdministrationOfficeId']['output'];
  readonly officeName: Scalars['String']['output'];
  readonly officeType?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly postOffice?: Maybe<Scalars['String']['output']>;
  readonly postcode: Scalars['String']['output'];
  readonly street?: Maybe<Scalars['String']['output']>;
  readonly voivodeship?: Maybe<Scalars['String']['output']>;
  readonly website?: Maybe<Scalars['String']['output']>;
};

export type Room = {
  readonly __typename?: 'Room';
  readonly blocked: Scalars['Boolean']['output'];
  readonly desks: ReadonlyArray<Desk>;
  readonly id: Scalars['RoomId']['output'];
  readonly name: Scalars['String']['output'];
  readonly officeId: Scalars['OfficeId']['output'];
  readonly restrictedToSpace?: Maybe<Space>;
  readonly restrictedToSpaceId?: Maybe<Scalars['SpaceId']['output']>;
  readonly securityZone?: Maybe<SecurityZone>;
};

export type RoomDrawer = AbstractDrawer & {
  readonly __typename?: 'RoomDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly roomId?: Maybe<Scalars['RoomId']['output']>;
  readonly visible: Scalars['Boolean']['output'];
};

export type RoomOrNfsError = NfsError | Room;

export type SalariesSummaryReportDrawer = AbstractDrawer & {
  readonly __typename?: 'SalariesSummaryReportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export const SalariesSummaryType = {
  B2B: 'B2B',
  OTHER: 'Other'
} as const;

export type SalariesSummaryType = typeof SalariesSummaryType[keyof typeof SalariesSummaryType];
export type SalaryState = IncompleteData | PaymentDisbursed | Ready;

export const SalaryStateKind = {
  INCOMPLETEDATA: 'IncompleteData',
  PAYMENTDISBURSED: 'PaymentDisbursed',
  READY: 'Ready'
} as const;

export type SalaryStateKind = typeof SalaryStateKind[keyof typeof SalaryStateKind];
export type SaldeoDocumentId = {
  readonly __typename?: 'SaldeoDocumentId';
  readonly companyProgramId: Scalars['String']['output'];
  readonly documentId: Scalars['Int']['output'];
};

export type SaldeoDocumentIdInput = {
  readonly companyProgramId: Scalars['String']['input'];
  readonly documentId: Scalars['Int']['input'];
};

export type SalesCommissionsBonus = Bonus & {
  readonly __typename?: 'SalesCommissionsBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type SalesInvoice = {
  readonly __typename?: 'SalesInvoice';
  readonly buyer: InvoiceEntity;
  readonly buyerCompany?: Maybe<Company>;
  readonly buyerType: BuyerType;
  readonly currency: Scalars['Currency']['output'];
  readonly exchangeRate?: Maybe<Scalars['BigDecimal']['output']>;
  readonly expectedPayment?: Maybe<ExpectedPayment>;
  readonly fakturowniaUri: Scalars['String']['output'];
  readonly id: Scalars['SalesInvoiceId']['output'];
  readonly issueDate: Scalars['LocalDate']['output'];
  readonly kind: InvoiceKind;
  readonly number: Scalars['String']['output'];
  readonly overdue: Scalars['Boolean']['output'];
  readonly paid: Scalars['Cents']['output'];
  readonly paidDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly paymentTo: Scalars['LocalDate']['output'];
  readonly place: Scalars['String']['output'];
  readonly positions: ReadonlyArray<InvoicePosition>;
  readonly price: NetGross;
  readonly priceWithExchangeRateApplied?: Maybe<NetGross>;
  readonly profilePrefix: Scalars['String']['output'];
  readonly sellDate: Scalars['LocalDate']['output'];
  readonly seller: InvoiceEntity;
  readonly sellerCompany?: Maybe<Company>;
  readonly status: SalesInvoiceStatus;
  readonly viewUri: Scalars['String']['output'];
};

export type SalesInvoiceDetails = {
  readonly __typename?: 'SalesInvoiceDetails';
  /** contains data fetched directly from Fakturownia */
  readonly connectedPayments: ReadonlyArray<InvoiceConnectedPayment>;
  /** contains internal data from NFS, might include suggestions from heuristic matcher */
  readonly connectedTransfers: ReadonlyArray<PaymentConnection>;
  readonly correctedBy?: Maybe<SalesInvoice>;
  readonly correctsInvoice?: Maybe<SalesInvoice>;
  readonly invoice: SalesInvoice;
};

export type SalesInvoiceDetailsOrNfsError = NfsError | SalesInvoiceDetails;

export type SalesInvoiceMutation = {
  readonly __typename?: 'SalesInvoiceMutation';
  readonly update: SalesInvoiceOrNfsError;
};


export type SalesInvoiceMutationUpdateArgs = {
  paidDate?: InputMaybe<ClearableLocalDateInput>;
};

export type SalesInvoiceOrNfsError = NfsError | SalesInvoice;

export const SalesInvoiceStatus = {
  ISSUED: 'ISSUED',
  PAID: 'PAID',
  PARTIAL: 'PARTIAL',
  REJECTED: 'REJECTED',
  SENT: 'SENT'
} as const;

export type SalesInvoiceStatus = typeof SalesInvoiceStatus[keyof typeof SalesInvoiceStatus];
export const SearchDateType = {
  ISSUEDATE: 'IssueDate',
  PAIDDATE: 'PaidDate',
  SELLDATE: 'SellDate'
} as const;

export type SearchDateType = typeof SearchDateType[keyof typeof SearchDateType];
export const SecurityZone = {
  GREEN: 'Green',
  ORANGE: 'Orange',
  RED: 'Red',
  YELLOW: 'Yellow'
} as const;

export type SecurityZone = typeof SecurityZone[keyof typeof SecurityZone];
export type SetFutureEntitlementDrawer = AbstractDrawer & {
  readonly __typename?: 'SetFutureEntitlementDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly initialAbsence: Scalars['Boolean']['output'];
  readonly initialDate?: Maybe<Scalars['Date']['output']>;
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type SetRateAndProgressionDrawer = AbstractDrawer & {
  readonly __typename?: 'SetRateAndProgressionDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly editing: Scalars['Boolean']['output'];
  readonly effectiveDate?: Maybe<Scalars['Date']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly promotionLevel?: Maybe<ProgressionLevel>;
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type SetRateAndProgressionResult = {
  readonly __typename?: 'SetRateAndProgressionResult';
  readonly contract: Contract;
  readonly user: User;
};

export type SetRateAndProgressionResultOrNfsError = NfsError | SetRateAndProgressionResult;

export const Settlement = {
  DAILY: 'Daily',
  HOURLY: 'Hourly',
  MONTHLY: 'Monthly'
} as const;

export type Settlement = typeof Settlement[keyof typeof Settlement];
export type SeverancePayBonus = Bonus & {
  readonly __typename?: 'SeverancePayBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type ShareholderDividendBonus = Bonus & {
  readonly __typename?: 'ShareholderDividendBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export const Shift = {
  DAYSHIFT: 'DayShift',
  NIGHTSHIFT: 'NightShift'
} as const;

export type Shift = typeof Shift[keyof typeof Shift];
export type SkillsAndCertificatesReportDrawer = AbstractDrawer & {
  readonly __typename?: 'SkillsAndCertificatesReportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type SocialMediaHandle = {
  readonly __typename?: 'SocialMediaHandle';
  readonly handle: Scalars['String']['output'];
  readonly platform: Scalars['String']['output'];
};

export type SocialMediaHandleInput = {
  readonly handle: Scalars['String']['input'];
  readonly platform: Scalars['String']['input'];
};

export const SortAssignedVariant = {
  BUYERTYPE: 'BuyerType',
  CREATIONDATE: 'CreationDate',
  USERNAME: 'UserName',
  VARIANTNAME: 'VariantName'
} as const;

export type SortAssignedVariant = typeof SortAssignedVariant[keyof typeof SortAssignedVariant];
export const SortBankTransfer = {
  AMOUNT: 'Amount',
  BOOKDATE: 'BookDate',
  CURRENCY: 'Currency',
  FROMNAME: 'FromName',
  OPERATIONDATE: 'OperationDate'
} as const;

export type SortBankTransfer = typeof SortBankTransfer[keyof typeof SortBankTransfer];
export const SortClientContract = {
  CONTRACTDURATIONFROM: 'ContractDurationFrom',
  CREATEDAT: 'CreatedAt',
  NAME: 'Name'
} as const;

export type SortClientContract = typeof SortClientContract[keyof typeof SortClientContract];
export const SortCompany = {
  CREATIONDATE: 'CreationDate',
  NAME: 'Name',
  REGISTERID: 'RegisterId',
  REGON: 'Regon',
  TAXNUMBER: 'TaxNumber'
} as const;

export type SortCompany = typeof SortCompany[keyof typeof SortCompany];
export const SortContract = {
  CONCLUSIONDATE: 'ConclusionDate',
  CREATIONDATE: 'CreationDate',
  EXPECTEDENDDATE: 'ExpectedEndDate',
  NAME: 'Name',
  STARTDATE: 'StartDate',
  TERMINATIONDATE: 'TerminationDate'
} as const;

export type SortContract = typeof SortContract[keyof typeof SortContract];
export const SortContractSalaryDetails = {
  DISBURSEDAT: 'DisbursedAt',
  REPORTEDHOURS: 'ReportedHours',
  SALARYSTATEKIND: 'SalaryStateKind',
  SURNAME: 'Surname',
  TOTALPAYOUT: 'TotalPayout'
} as const;

export type SortContractSalaryDetails = typeof SortContractSalaryDetails[keyof typeof SortContractSalaryDetails];
export const SortOfficeReservation = {
  CREATEDAT: 'CreatedAt',
  DATE: 'Date'
} as const;

export type SortOfficeReservation = typeof SortOfficeReservation[keyof typeof SortOfficeReservation];
export const SortOrder = {
  ASC: 'Asc',
  DESC: 'Desc'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export const SortProject = {
  CLIENTNAME: 'ClientName',
  CREATIONDATE: 'CreationDate',
  NAME: 'Name',
  STARTDATE: 'StartDate'
} as const;

export type SortProject = typeof SortProject[keyof typeof SortProject];
export const SortRevenueAdministrationOffices = {
  KOD: 'Kod',
  ULICA: 'Ulica'
} as const;

export type SortRevenueAdministrationOffices = typeof SortRevenueAdministrationOffices[keyof typeof SortRevenueAdministrationOffices];
export const SortSpace = {
  NAME: 'Name'
} as const;

export type SortSpace = typeof SortSpace[keyof typeof SortSpace];
export const SortUser = {
  ANYREVISIONDATE: 'AnyRevisionDate',
  CREATIONDATE: 'CreationDate',
  EMAIL: 'Email',
  NAME: 'Name',
  NEWESTRATECHANGEDATE: 'NewestRateChangeDate',
  NEXTMEDICALEXAMINATIONDATE: 'NextMedicalExaminationDate',
  NEXTOHSTRAININGDATE: 'NextOhsTrainingDate',
  STUDENTSTATUSREVISIONDATE: 'StudentStatusRevisionDate',
  SURNAME: 'Surname'
} as const;

export type SortUser = typeof SortUser[keyof typeof SortUser];
export type SortWorkTransferProtocolsInput = {
  readonly sortBy: WorkTransferProtocolSortBy;
  readonly sortOrder: SortOrder;
};

export type SortingRequestSortAssignedVariantInput = {
  readonly by: SortAssignedVariant;
  readonly order?: InputMaybe<SortOrder>;
};

export type SortingRequestSortBankTransferInput = {
  readonly by: SortBankTransfer;
  readonly order?: InputMaybe<SortOrder>;
};

export type SortingRequestSortClientContractInput = {
  readonly by: SortClientContract;
  readonly order?: InputMaybe<SortOrder>;
};

export type SortingRequestSortCompanyInput = {
  readonly by: SortCompany;
  readonly order?: InputMaybe<SortOrder>;
};

export type SortingRequestSortContractInput = {
  readonly by: SortContract;
  readonly order?: InputMaybe<SortOrder>;
};

export type SortingRequestSortContractSalaryDetailsInput = {
  readonly by: SortContractSalaryDetails;
  readonly order?: InputMaybe<SortOrder>;
};

export type SortingRequestSortOfficeReservationInput = {
  readonly by: SortOfficeReservation;
  readonly order?: InputMaybe<SortOrder>;
};

export type SortingRequestSortProjectInput = {
  readonly by: SortProject;
  readonly order?: InputMaybe<SortOrder>;
};

export type SortingRequestSortRevenueAdministrationOfficesInput = {
  readonly by: SortRevenueAdministrationOffices;
  readonly order?: InputMaybe<SortOrder>;
};

export type SortingRequestSortSpaceInput = {
  readonly by: SortSpace;
  readonly order?: InputMaybe<SortOrder>;
};

export type SortingRequestSortUserInput = {
  readonly by: SortUser;
  readonly order?: InputMaybe<SortOrder>;
};

export type Space = {
  readonly __typename?: 'Space';
  readonly directors: ReadonlyArray<User>;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly id: Scalars['SpaceId']['output'];
  readonly members: FspResponseUser;
  readonly name: Scalars['String']['output'];
  readonly owner: User;
};


export type SpaceMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterUserInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortingRequestSortUserInput>;
};

export type SpaceMutation = {
  readonly __typename?: 'SpaceMutation';
  readonly updateSpace: SpaceOrNfsError;
};


export type SpaceMutationUpdateSpaceArgs = {
  directors?: InputMaybe<ReadonlyArray<Scalars['UserId']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['UserId']['input']>;
};

export type SpaceOrNfsError = NfsError | Space;

export type StringOrUnauthorized = AccessGrantedString | Unauthorized;

export type SubBenefit = BenefitCommon & {
  readonly __typename?: 'SubBenefit';
  readonly alternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['output'];
  readonly endDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly id: Scalars['BenefitId']['output'];
  readonly name: Scalars['String']['output'];
  readonly parent: Benefit;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly variants: ReadonlyArray<BenefitVariant>;
};

export type SubBenefitOrNfsError = NfsError | SubBenefit;

export type Subcontract = Contract & {
  readonly __typename?: 'Subcontract';
  readonly assignedVariants: ListOfAssignedVariantOrUnauthorized;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly bonuses: BonusesOrUnauthorized;
  readonly clientContract: ClientContractOrUnauthorized;
  readonly conclusionDate: LocalDateOrUnauthorized;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  /** We do not have related data (time reports etc.) before this date in the system */
  readonly dataInSystemSince: Scalars['LocalDate']['output'];
  readonly entityVersion: Scalars['EntityVersion']['output'];
  /** It just an information. Should not be used for business logic as contract may be extended or terminated earlier */
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly holidayCalendar: HolidayCalendar;
  readonly id: Scalars['ContractId']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes: OptionalStringOrUnauthorized;
  readonly promisee: User;
  readonly promiseeId: Scalars['UserId']['output'];
  readonly promisor: TimeBasedCompany;
  readonly promisorId: Scalars['CompanyId']['output'];
  readonly promisorTransferBankAccount: PromisorTransferBankAccount;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly status: ContractStatus;
  /** Non-empty value indicates actual (or effective) termination date */
  readonly terminationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly type: B2BContractType;
  readonly workingTime: TimeBasedWorkingTimeOrUnauthorized;
};


export type SubcontractAssignedVariantsArgs = {
  activeOnly: Scalars['Boolean']['input'];
};

export type SubcontractDraft = ContractDraft & {
  readonly __typename?: 'SubcontractDraft';
  readonly clientContract: ClientContract;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly holidayCalendar?: Maybe<HolidayCalendar>;
  readonly id: Scalars['UserId']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly promisee: User;
  readonly promisor: Company;
  readonly promisorTransferBankAccount: PromisorTransferBankAccount;
  readonly startDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly type: B2BContractType;
};

export type SubcontractDraftDrawer = AbstractDrawer & {
  readonly __typename?: 'SubcontractDraftDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly editing: Scalars['Boolean']['output'];
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type SubcontractDraftOrNfsError = NfsError | SubcontractDraft;

export type SubcontractNoteDrawer = AbstractDrawer & {
  readonly __typename?: 'SubcontractNoteDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly contractId?: Maybe<Scalars['ContractId']['output']>;
  readonly editing: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly requiredPromiseeId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type SubcontractOrNfsError = NfsError | Subcontract;

export type TaxResidencyCertificate = {
  readonly __typename?: 'TaxResidencyCertificate';
  readonly companyId: Scalars['CompanyId']['output'];
  readonly countryOfResidency?: Maybe<Scalars['CountryCode']['output']>;
  readonly fileUri?: Maybe<Scalars['URI']['output']>;
  readonly id: Scalars['TaxResidencyCertificateId']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly validFrom?: Maybe<Scalars['LocalDate']['output']>;
  readonly validTo?: Maybe<Scalars['LocalDate']['output']>;
  readonly year: Scalars['Year']['output'];
};

export type TaxResidencyCertificateInput = {
  readonly companyId: Scalars['CompanyId']['input'];
  readonly countryOfResidency?: InputMaybe<Scalars['CountryCode']['input']>;
  readonly fileUri?: InputMaybe<Scalars['URI']['input']>;
  readonly id: Scalars['TaxResidencyCertificateId']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly validFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly validTo?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly year: Scalars['Year']['input'];
};

export type TaxResidencyCertificateOrNfsError = NfsError | TaxResidencyCertificate;

export type TaxResidencyCertificatesDrawer = AbstractDrawer & {
  readonly __typename?: 'TaxResidencyCertificatesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredCompanyId: Scalars['CompanyId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type Taxation = {
  readonly __typename?: 'Taxation';
  readonly taxApplicable: Scalars['Boolean']['output'];
  readonly zusApplicable: Scalars['Boolean']['output'];
};

export type TaxationInput = {
  readonly taxApplicable: Scalars['Boolean']['input'];
  readonly zusApplicable: Scalars['Boolean']['input'];
};

export type TimeBalance = {
  readonly __typename?: 'TimeBalance';
  readonly absenceTime: Scalars['Minutes']['output'];
  readonly at: Scalars['LocalDate']['output'];
  readonly balance: Scalars['Minutes']['output'];
  readonly currentTimeRequirement: Scalars['Minutes']['output'];
  readonly currentTimeRequirementWithAbsenceTimeSubtracted: Scalars['Minutes']['output'];
  readonly period: ClosedEndMonthRange;
  readonly reportedStandardWorkTime: Scalars['Minutes']['output'];
  readonly totalTimeInPeriod: Scalars['Minutes']['output'];
};

export type TimeBasedActivityOverlapError = UserError & {
  readonly __typename?: 'TimeBasedActivityOverlapError';
  readonly date: Scalars['OffsetDateTime']['output'];
  readonly entityId: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type TimeBasedBenefitBuyerType = {
  readonly __typename?: 'TimeBasedBenefitBuyerType';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantBenefitBuyerType>;
  readonly history: ReadonlyArray<TimeBasedInstantBenefitBuyerType>;
  readonly value: BenefitBuyerType;
};

export type TimeBasedBenefitVariant = {
  readonly __typename?: 'TimeBasedBenefitVariant';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantBenefitVariant>;
  readonly history: ReadonlyArray<TimeBasedInstantBenefitVariant>;
  readonly value: BenefitVariant;
};

export type TimeBasedBoolean = {
  readonly __typename?: 'TimeBasedBoolean';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantBoolean>;
  readonly history: ReadonlyArray<TimeBasedInstantBoolean>;
  readonly value: Scalars['Boolean']['output'];
};

export type TimeBasedBooleanOrUnauthorized = AccessGrantedTimeBasedBoolean | Unauthorized;

export type TimeBasedCompany = {
  readonly __typename?: 'TimeBasedCompany';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantCompany>;
  readonly history: ReadonlyArray<TimeBasedInstantCompany>;
  readonly value: Company;
};

export type TimeBasedCompanyRole = {
  readonly __typename?: 'TimeBasedCompanyRole';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantCompanyRole>;
  readonly history: ReadonlyArray<TimeBasedInstantCompanyRole>;
  readonly value: CompanyRole;
};

export type TimeBasedCurrency = {
  readonly __typename?: 'TimeBasedCurrency';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantCurrency>;
  readonly history: ReadonlyArray<TimeBasedInstantCurrency>;
  readonly value: Scalars['Currency']['output'];
};

export type TimeBasedCurrencyOrUnauthorized = AccessGrantedTimeBasedCurrency | Unauthorized;

export type TimeBasedDailyAndHourlyRateNet = {
  readonly __typename?: 'TimeBasedDailyAndHourlyRateNet';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantDailyAndHourlyRateNet>;
  readonly history: ReadonlyArray<TimeBasedInstantDailyAndHourlyRateNet>;
  readonly value: DailyAndHourlyRateNet;
};

export type TimeBasedEffectiveFromInPastError = UserError & {
  readonly __typename?: 'TimeBasedEffectiveFromInPastError';
  readonly activityDate: Scalars['OffsetDateTime']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly now: Scalars['OffsetDateTime']['output'];
};

export type TimeBasedHighlight = Highlight & {
  readonly __typename?: 'TimeBasedHighlight';
  readonly effectiveDate: Scalars['Date']['output'];
  readonly id?: Maybe<Scalars['ID']['output']>;
};

export type TimeBasedInstantBenefitBuyerType = {
  readonly __typename?: 'TimeBasedInstantBenefitBuyerType';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: BenefitBuyerType;
};

export type TimeBasedInstantBenefitVariant = {
  readonly __typename?: 'TimeBasedInstantBenefitVariant';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: BenefitVariant;
};

export type TimeBasedInstantBoolean = {
  readonly __typename?: 'TimeBasedInstantBoolean';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: Scalars['Boolean']['output'];
};

export type TimeBasedInstantClearableBasisPoint = {
  readonly __typename?: 'TimeBasedInstantClearableBasisPoint';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableBasisPoint;
};

export type TimeBasedInstantClearableBenefitVariantRate = {
  readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableBenefitVariantRate;
};

export type TimeBasedInstantClearableDailyAndHourlyRateNet = {
  readonly __typename?: 'TimeBasedInstantClearableDailyAndHourlyRateNet';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableDailyAndHourlyRateNet;
};

export type TimeBasedInstantClearableDays = {
  readonly __typename?: 'TimeBasedInstantClearableDays';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableDays;
};

export type TimeBasedInstantClearableDeductibleCostsType = {
  readonly __typename?: 'TimeBasedInstantClearableDeductibleCostsType';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableDeductibleCostsType;
};

export type TimeBasedInstantClearableExternalBeneficiary = {
  readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableExternalBeneficiary;
};

export type TimeBasedInstantClearableNetGross = {
  readonly __typename?: 'TimeBasedInstantClearableNetGross';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableNetGross;
};

export type TimeBasedInstantClearableNetOnCallRate = {
  readonly __typename?: 'TimeBasedInstantClearableNetOnCallRate';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableNetOnCallRate;
};

export type TimeBasedInstantClearableOnCallRate = {
  readonly __typename?: 'TimeBasedInstantClearableOnCallRate';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableOnCallRate;
};

export type TimeBasedInstantClearableProgressionLevel = {
  readonly __typename?: 'TimeBasedInstantClearableProgressionLevel';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableProgressionLevel;
};

export type TimeBasedInstantClearableProgressionScheme = {
  readonly __typename?: 'TimeBasedInstantClearableProgressionScheme';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableProgressionScheme;
};

export type TimeBasedInstantClearableProjectId = {
  readonly __typename?: 'TimeBasedInstantClearableProjectId';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableProjectId;
};

export type TimeBasedInstantClearableString = {
  readonly __typename?: 'TimeBasedInstantClearableString';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableString;
};

export type TimeBasedInstantClearableUser = {
  readonly __typename?: 'TimeBasedInstantClearableUser';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableUser;
};

export type TimeBasedInstantCompany = {
  readonly __typename?: 'TimeBasedInstantCompany';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: Company;
};

export type TimeBasedInstantCompanyRole = {
  readonly __typename?: 'TimeBasedInstantCompanyRole';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: CompanyRole;
};

export type TimeBasedInstantCurrency = {
  readonly __typename?: 'TimeBasedInstantCurrency';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: Scalars['Currency']['output'];
};

export type TimeBasedInstantDailyAndHourlyRateNet = {
  readonly __typename?: 'TimeBasedInstantDailyAndHourlyRateNet';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: DailyAndHourlyRateNet;
};

export type TimeBasedInstantListOfExternalBeneficiary = {
  readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ReadonlyArray<ExternalBeneficiary>;
};

export type TimeBasedInstantRate = {
  readonly __typename?: 'TimeBasedInstantRate';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: Rate;
};

export type TimeBasedInstantSpace = {
  readonly __typename?: 'TimeBasedInstantSpace';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: Space;
};

export type TimeBasedInstantString = {
  readonly __typename?: 'TimeBasedInstantString';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: Scalars['String']['output'];
};

export type TimeBasedInstantValueWithDescriptionAndVerificationBooleanVatStatus = {
  readonly __typename?: 'TimeBasedInstantValueWithDescriptionAndVerificationBooleanVATStatus';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ValueWithDescriptionAndVerificationBooleanVatStatus;
};

export type TimeBasedInstantValueWithVerificationEuVatType = {
  readonly __typename?: 'TimeBasedInstantValueWithVerificationEuVatType';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ValueWithVerificationEuVatType;
};

export type TimeBasedInstantVatType = {
  readonly __typename?: 'TimeBasedInstantVatType';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: VatType;
};

export type TimeBasedInstantWorkingTime = {
  readonly __typename?: 'TimeBasedInstantWorkingTime';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly author?: Maybe<Admin>;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: WorkingTime;
};

export type TimeBasedListOfExternalBeneficiary = {
  readonly __typename?: 'TimeBasedListOfExternalBeneficiary';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantListOfExternalBeneficiary>;
  readonly history: ReadonlyArray<TimeBasedInstantListOfExternalBeneficiary>;
  readonly value: ReadonlyArray<ExternalBeneficiary>;
};

export type TimeBasedOptClearableBasisPoint = {
  readonly __typename?: 'TimeBasedOptClearableBasisPoint';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableBasisPoint>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableBasisPoint>;
  readonly value?: Maybe<Scalars['BasisPoint']['output']>;
};

export type TimeBasedOptClearableBasisPointOrUnauthorized = AccessGrantedTimeBasedOptClearableBasisPoint | Unauthorized;

export type TimeBasedOptClearableBenefitVariantRate = {
  readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableBenefitVariantRate>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableBenefitVariantRate>;
  readonly value?: Maybe<BenefitVariantRate>;
};

export type TimeBasedOptClearableDailyAndHourlyRateNet = {
  readonly __typename?: 'TimeBasedOptClearableDailyAndHourlyRateNet';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableDailyAndHourlyRateNet>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableDailyAndHourlyRateNet>;
  readonly value?: Maybe<DailyAndHourlyRateNet>;
};

export type TimeBasedOptClearableDays = {
  readonly __typename?: 'TimeBasedOptClearableDays';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableDays>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableDays>;
  readonly value?: Maybe<Scalars['Days']['output']>;
};

export type TimeBasedOptClearableDaysOrUnauthorized = AccessGrantedTimeBasedOptClearableDays | Unauthorized;

export type TimeBasedOptClearableDeductibleCostsType = {
  readonly __typename?: 'TimeBasedOptClearableDeductibleCostsType';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableDeductibleCostsType>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableDeductibleCostsType>;
  readonly value?: Maybe<DeductibleCostsType>;
};

export type TimeBasedOptClearableDeductibleCostsTypeOrUnauthorized = AccessGrantedTimeBasedOptClearableDeductibleCostsType | Unauthorized;

export type TimeBasedOptClearableExternalBeneficiary = {
  readonly __typename?: 'TimeBasedOptClearableExternalBeneficiary';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableExternalBeneficiary>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableExternalBeneficiary>;
  readonly value?: Maybe<ExternalBeneficiary>;
};

export type TimeBasedOptClearableNetGross = {
  readonly __typename?: 'TimeBasedOptClearableNetGross';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableNetGross>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableNetGross>;
  readonly value?: Maybe<NetGross>;
};

export type TimeBasedOptClearableNetGrossOrUnauthorized = AccessGrantedTimeBasedOptClearableNetGross | Unauthorized;

export type TimeBasedOptClearableNetOnCallRate = {
  readonly __typename?: 'TimeBasedOptClearableNetOnCallRate';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableNetOnCallRate>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableNetOnCallRate>;
  readonly value?: Maybe<NetOnCallRate>;
};

export type TimeBasedOptClearableOnCallRate = {
  readonly __typename?: 'TimeBasedOptClearableOnCallRate';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableOnCallRate>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableOnCallRate>;
  readonly value?: Maybe<OnCallRate>;
};

export type TimeBasedOptClearableOnCallRateOrUnauthorized = AccessGrantedTimeBasedOptClearableOnCallRate | Unauthorized;

export type TimeBasedOptClearableProgressionLevel = {
  readonly __typename?: 'TimeBasedOptClearableProgressionLevel';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableProgressionLevel>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableProgressionLevel>;
  readonly value?: Maybe<ProgressionLevel>;
};

export type TimeBasedOptClearableProgressionScheme = {
  readonly __typename?: 'TimeBasedOptClearableProgressionScheme';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableProgressionScheme>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableProgressionScheme>;
  readonly value?: Maybe<ProgressionScheme>;
};

export type TimeBasedOptClearableProgressionSchemeOrUnauthorized = AccessGrantedTimeBasedOptClearableProgressionScheme | Unauthorized;

export type TimeBasedOptClearableProjectId = {
  readonly __typename?: 'TimeBasedOptClearableProjectId';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableProjectId>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableProjectId>;
  readonly value?: Maybe<Scalars['ProjectId']['output']>;
};

export type TimeBasedOptClearableString = {
  readonly __typename?: 'TimeBasedOptClearableString';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableString>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableString>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

export type TimeBasedOptClearableUser = {
  readonly __typename?: 'TimeBasedOptClearableUser';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableUser>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableUser>;
  readonly value?: Maybe<User>;
};

export type TimeBasedOptCurrency = {
  readonly __typename?: 'TimeBasedOptCurrency';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantCurrency>;
  readonly history: ReadonlyArray<TimeBasedInstantCurrency>;
  readonly value?: Maybe<Scalars['Currency']['output']>;
};

export type TimeBasedOptCurrencyOrUnauthorized = AccessGrantedTimeBasedOptCurrency | Unauthorized;

export type TimeBasedRate = {
  readonly __typename?: 'TimeBasedRate';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantRate>;
  readonly history: ReadonlyArray<TimeBasedInstantRate>;
  readonly value: Rate;
};

export type TimeBasedRateOrUnauthorized = AccessGrantedTimeBasedRate | Unauthorized;

export type TimeBasedSpace = {
  readonly __typename?: 'TimeBasedSpace';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantSpace>;
  readonly history: ReadonlyArray<TimeBasedInstantSpace>;
  readonly value: Space;
};

export type TimeBasedString = {
  readonly __typename?: 'TimeBasedString';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantString>;
  readonly history: ReadonlyArray<TimeBasedInstantString>;
  readonly value: Scalars['String']['output'];
};

export type TimeBasedStringOrUnauthorized = AccessGrantedTimeBasedString | Unauthorized;

export type TimeBasedValueBooleanInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: Scalars['Boolean']['input'];
};

export type TimeBasedValueClearableBasisPointInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: ClearableBasisPointInput;
};

export type TimeBasedValueClearableBenefitVariantRateInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: ClearableBenefitVariantRateInput;
};

export type TimeBasedValueClearableCentsInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: ClearableCentsInput;
};

export type TimeBasedValueClearableDaysInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: ClearableDaysInput;
};

export type TimeBasedValueClearableDeductibleCostsTypeInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: ClearableDeductibleCostsTypeInput;
};

export type TimeBasedValueClearableNetOnCallRateInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: ClearableNetOnCallRateInput;
};

export type TimeBasedValueClearableProgressionLevelInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: ClearableProgressionLevelInput;
};

export type TimeBasedValueClearableProgressionSchemeIdInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: ClearableProgressionSchemeIdInput;
};

export type TimeBasedValueClearableStringInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: ClearableStringInput;
};

export type TimeBasedValueClearableUserIdInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: ClearableUserIdInput;
};

export type TimeBasedValueCompanyIdInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: Scalars['CompanyId']['input'];
};

export type TimeBasedValueCompanyRoleInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: CompanyRole;
};

export type TimeBasedValueCurrencyInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: Scalars['Currency']['input'];
};

export type TimeBasedValueEuVatTypeInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: EuVatType;
};

export type TimeBasedValueNetRateInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: NetRateInput;
};

export type TimeBasedValueSpaceIdInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: Scalars['SpaceId']['input'];
};

export type TimeBasedValueStringInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: Scalars['String']['input'];
};

export type TimeBasedValueVatTypeInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: Scalars['VatTypeInput']['input'];
};

export type TimeBasedValueWithDescriptionAndVerificationBooleanVatStatus = {
  readonly __typename?: 'TimeBasedValueWithDescriptionAndVerificationBooleanVATStatus';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantValueWithDescriptionAndVerificationBooleanVatStatus>;
  readonly history: ReadonlyArray<TimeBasedInstantValueWithDescriptionAndVerificationBooleanVatStatus>;
  readonly value: ValueWithDescriptionAndVerificationBooleanVatStatus;
};

export type TimeBasedValueWithVerificationEuVatType = {
  readonly __typename?: 'TimeBasedValueWithVerificationEuVatType';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantValueWithVerificationEuVatType>;
  readonly history: ReadonlyArray<TimeBasedInstantValueWithVerificationEuVatType>;
  readonly value: ValueWithVerificationEuVatType;
};

export type TimeBasedValueWorkingTimeInput = {
  readonly applyDate: Scalars['Date']['input'];
  readonly value: WorkingTimeInput;
};

export type TimeBasedVatType = {
  readonly __typename?: 'TimeBasedVatType';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantVatType>;
  readonly history: ReadonlyArray<TimeBasedInstantVatType>;
  readonly value: VatType;
};

export type TimeBasedVatTypeOrUnauthorized = AccessGrantedTimeBasedVatType | Unauthorized;

export type TimeBasedWorkingTime = {
  readonly __typename?: 'TimeBasedWorkingTime';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantWorkingTime>;
  readonly history: ReadonlyArray<TimeBasedInstantWorkingTime>;
  readonly value: WorkingTime;
};

export type TimeBasedWorkingTimeOrUnauthorized = AccessGrantedTimeBasedWorkingTime | Unauthorized;

export type TimeReport = {
  readonly __typename?: 'TimeReport';
  readonly timeReportRecords: TimeReportRecords;
  readonly timeReportStats?: Maybe<TimeReportStats>;
};

export type TimeReportIncomplete = {
  readonly __typename?: 'TimeReportIncomplete';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type TimeReportOrNfsError = NfsError | TimeReport;

export type TimeReportOverlapError = UserError & {
  readonly __typename?: 'TimeReportOverlapError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type TimeReportRecordApprovalNotInPendingStateError = UserError & {
  readonly __typename?: 'TimeReportRecordApprovalNotInPendingStateError';
  readonly id: Scalars['ID']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type TimeReportRecords = {
  readonly __typename?: 'TimeReportRecords';
  readonly absence: ReadonlyArray<AbsenceRecord>;
  readonly onCall: ReadonlyArray<OnCallRecord>;
  readonly work: ReadonlyArray<WorkRecord>;
  readonly workTags: ReadonlyArray<WorkTag>;
};

export type TimeReportRequiresApproval = {
  readonly __typename?: 'TimeReportRequiresApproval';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type TimeReportStats = {
  readonly currentTimeBalance: TimeBalance;
  readonly incomeDetails: ListOfIncomeDetailsOrUnauthorized;
  readonly overtime: Scalars['Minutes']['output'];
  readonly timeBalanceAtEndOfMonth: TimeBalance;
};

export type TimeReportValidation = IncompleteEntries | MissingEntries | NegativeFlexTimeBalance;

export type TimeReports = {
  readonly __typename?: 'TimeReports';
  /** @deprecated use records instead */
  readonly absenceRecords: ReadonlyArray<AbsenceRecord>;
  readonly records: TimeReportRecords;
};


export type TimeReportsAbsenceRecordsArgs = {
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
};


export type TimeReportsRecordsArgs = {
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};

export type TimeReportsReportDrawer = AbstractDrawer & {
  readonly __typename?: 'TimeReportsReportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type TimeReportsRequiringApproval = {
  readonly __typename?: 'TimeReportsRequiringApproval';
  readonly absenceRecords: ReadonlyArray<AbsenceRecord>;
  readonly workRecords: ReadonlyArray<WorkRecord>;
};

export type TimeReportsRequiringApprovalOrNfsError = NfsError | TimeReportsRequiringApproval;

export type TimeReportsOrUnauthorized = AccessGrantedTimeReports | Unauthorized;

export type TrainingBudgetSummary = {
  readonly __typename?: 'TrainingBudgetSummary';
  readonly currency: Scalars['Currency']['output'];
  readonly yearlySummary: ReadonlyArray<KvYearTrainingBudgetYearSummary>;
};

export type TrainingBudgetSummaryOrNfsError = NfsError | TrainingBudgetSummary;

export type TrainingBudgetYearSummary = {
  readonly __typename?: 'TrainingBudgetYearSummary';
  readonly balanceThisYear: CentsBalance;
  readonly carriedOverEntitlementBalance?: Maybe<CentsBalance>;
  readonly totalBalance: CentsBalance;
  readonly year: Scalars['Year']['output'];
};

export type TrainingPackageBonus = Bonus & {
  readonly __typename?: 'TrainingPackageBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type TrainingPackageExternalDeductionValue = Bonus & {
  readonly __typename?: 'TrainingPackageExternalDeductionValue';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly author?: Maybe<Scalars['AdminId']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
  readonly taxation?: Maybe<Taxation>;
};

export type TrainingPackageReportDrawer = AbstractDrawer & {
  readonly __typename?: 'TrainingPackageReportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type TransferBatchView = {
  readonly __typename?: 'TransferBatchView';
  readonly confirmations: ReadonlyArray<TransferConfirmationView>;
  readonly error?: Maybe<Scalars['String']['output']>;
  readonly isDomestic: Scalars['Boolean']['output'];
  readonly outgoingAccount: BankAccountNumber;
  readonly senderName: Scalars['String']['output'];
  readonly totalAmount: CentsWithCurrency;
  readonly transfersCount: Scalars['Int']['output'];
};

export type TransferConfirmationView = {
  readonly __typename?: 'TransferConfirmationView';
  readonly status: Scalars['String']['output'];
  readonly transactionId: Scalars['String']['output'];
};

export type TransferDeduction = {
  readonly __typename?: 'TransferDeduction';
  readonly grossValue: Scalars['Cents']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
};

export type TransferDeductionInput = {
  readonly grossValue: Scalars['Cents']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
};

export type TransferDetailsDrawer = AbstractDrawer & {
  readonly __typename?: 'TransferDetailsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredDate: Scalars['Date']['output'];
  readonly requiredTransferId: Scalars['BankTransferId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type TransferExecuted = {
  readonly __typename?: 'TransferExecuted';
  readonly transfer: BankTransfer;
  readonly transferId: Scalars['BankTransferId']['output'];
};

export type TransferListExportDrawer = AbstractDrawer & {
  readonly __typename?: 'TransferListExportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type TransferOrdered = {
  readonly __typename?: 'TransferOrdered';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type TransferState = TransferExecuted | TransferOrdered;

export type TransfersSummaries = {
  readonly __typename?: 'TransfersSummaries';
  readonly b2b: B2BTransfersSummaries;
  readonly employment: EmploymentTransfersSummaries;
  readonly yearMonth: Scalars['YearMonth']['output'];
};

export type UriResponse = {
  readonly __typename?: 'URIResponse';
  readonly value: Scalars['URI']['output'];
};

export type UriResponseOrNfsError = NfsError | UriResponse;

export type Unauthorized = {
  readonly __typename?: 'Unauthorized';
  readonly reason: Scalars['String']['output'];
};

export type UnauthorizedOperationError = UserError & {
  readonly __typename?: 'UnauthorizedOperationError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type UnitResponse = {
  readonly __typename?: 'UnitResponse';
  readonly value: Scalars['Unit']['output'];
};

export type UnitResponseOrNfsError = NfsError | UnitResponse;

export type UnknownContentTypeError = UserError & {
  readonly __typename?: 'UnknownContentTypeError';
  readonly fileName: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type UopHolidaysReportDrawer = AbstractDrawer & {
  readonly __typename?: 'UopHolidaysReportDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type UpdateCertificateInput = {
  readonly expirationDate?: InputMaybe<ClearableLocalDateInput>;
  readonly file?: InputMaybe<ClearableUploadInput>;
  readonly issueDate?: InputMaybe<ClearableLocalDateInput>;
};

export type UpdateDeskInput = {
  readonly monitors?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly pedestalNumber?: InputMaybe<ClearableStringInput>;
  readonly standing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDeskRequestInput = {
  readonly deskIds: ReadonlyArray<Scalars['DeskId']['input']>;
  readonly guestEmails?: InputMaybe<ReadonlyArray<Scalars['EmailAddress']['input']>>;
  readonly notes?: InputMaybe<ClearableStringInput>;
  readonly range: ClosedEndLocalDateRangeInput;
  readonly roomId: Scalars['RoomId']['input'];
};

export type UpdateInvoiceDetailsInput = {
  readonly adminNote?: InputMaybe<ClearableStringInput>;
  readonly correct?: InputMaybe<ClearableBooleanInput>;
  readonly file?: InputMaybe<ClearableUploadInput>;
  readonly number?: InputMaybe<ClearableInvoiceNumberInput>;
};

export type UpdateOfficeSettingsInput = {
  readonly floorMap?: InputMaybe<ClearableUploadInput>;
  readonly parkingInformation?: InputMaybe<ClearableStringInput>;
  readonly parkingMap?: InputMaybe<ClearableUploadInput>;
  readonly receptionEmails?: InputMaybe<ReadonlyArray<Scalars['EmailAddress']['input']>>;
};

export type UpdateParkingRequestInput = {
  readonly guestEmails?: InputMaybe<ReadonlyArray<Scalars['EmailAddress']['input']>>;
  readonly notes?: InputMaybe<ClearableStringInput>;
  readonly parkingSpotId?: InputMaybe<Scalars['ParkingSpotId']['input']>;
  readonly plateNumber?: InputMaybe<ClearableStringInput>;
  readonly range: ClosedEndLocalDateRangeInput;
};

export type UpdateParkingSpotInput = {
  readonly guest?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly number?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoomInput = {
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly restrictedToSpaceId?: InputMaybe<ClearableSpaceIdInput>;
};

export type UploadDocumentDrawer = AbstractDrawer & {
  readonly __typename?: 'UploadDocumentDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly documentId?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type User = {
  readonly __typename?: 'User';
  readonly active: Scalars['Boolean']['output'];
  readonly address: OptionalAddressOrUnauthorized;
  readonly areaOfExpertise?: Maybe<Scalars['String']['output']>;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly avatar?: Maybe<Scalars['URI']['output']>;
  readonly birthDate: OptionalLocalDateOrUnauthorized;
  readonly certificates: ListOfCertificateOrUnauthorized;
  readonly citizenship: OptionalCountryCodeOrUnauthorized;
  readonly consentedForUseOfImage: Scalars['Boolean']['output'];
  readonly contactEmail: OptionalEmailAddressOrUnauthorized;
  readonly contractDraft: OptionalContractDraftOrUnauthorized;
  readonly contracts: ListOfContractOrUnauthorized;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly declaredNoCertificates: Scalars['Boolean']['output'];
  readonly directReporting: DirectReporting;
  readonly documentsDirectory: OptionalUriOrUnauthorized;
  readonly email: Scalars['EmailAddress']['output'];
  readonly emergencyContact: OptionalStringOrUnauthorized;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly externalBeneficiaries: ListOfExternalBeneficiaryOrUnauthorized;
  readonly familyName?: Maybe<Scalars['String']['output']>;
  readonly firstName: Scalars['String']['output'];
  readonly fullName: Scalars['String']['output'];
  readonly id: Scalars['UserId']['output'];
  readonly idNumber: OptionalStringOrUnauthorized;
  readonly idType: OptionalIdTypeOrUnauthorized;
  readonly isStudent: BooleanOrUnauthorized;
  readonly isStudentRevisionDate: OptionalLocalDateOrUnauthorized;
  readonly lastName: Scalars['String']['output'];
  readonly mailingAddress: OptionalAddressOrUnauthorized;
  readonly middleName?: Maybe<Scalars['String']['output']>;
  readonly newestRateChangeDate: OptionalOffsetDateTimeOrUnauthorized;
  readonly nextMedicalExaminationDate: OptionalLocalDateOrUnauthorized;
  readonly nextOhsTrainingDate: OptionalLocalDateOrUnauthorized;
  readonly office?: Maybe<Office>;
  readonly paczkomat: OptionalStringOrUnauthorized;
  readonly passportExpirationDate: OptionalLocalDateOrUnauthorized;
  readonly personalDataProcessingAuthorization: PersonalDataProcessingAuthorizationOrUnauthorized;
  readonly pesel: OptionalPeselOrUnauthorized;
  readonly phoneNumber: OptionalPhoneNumberOrUnauthorized;
  readonly plateNumber: OptionalStringOrUnauthorized;
  readonly profileUri: Scalars['String']['output'];
  readonly progressionLevel: TimeBasedOptClearableProgressionLevel;
  readonly revenueAdministrationOffice: OptionalRevenueAdministrationOfficeOrUnauthorized;
  readonly role: TimeBasedCompanyRole;
  readonly skillsAndCompetences: ReadonlyArray<Scalars['String']['output']>;
  readonly socialMediaHandles: ListOfSocialMediaHandleOrUnauthorized;
  readonly timeReports: TimeReportsOrUnauthorized;
};

export type UserError = {
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type UserFacingAuthzError = UserError & {
  readonly __typename?: 'UserFacingAuthzError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type UserInput = {
  readonly address?: InputMaybe<AddressInput>;
  readonly areaOfExpertise?: InputMaybe<Scalars['String']['input']>;
  readonly birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly citizenship?: InputMaybe<Scalars['CountryCode']['input']>;
  readonly consentedForUseOfImage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contactEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  readonly declaredNoCertificates?: InputMaybe<Scalars['Boolean']['input']>;
  readonly email: Scalars['EmailAddress']['input'];
  readonly emergencyContact?: InputMaybe<Scalars['String']['input']>;
  readonly familyName?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly idNumber?: InputMaybe<Scalars['String']['input']>;
  readonly idType?: InputMaybe<IdType>;
  readonly isStudent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isStudentRevisionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly lastName: Scalars['String']['input'];
  readonly mailingAddress?: InputMaybe<AddressInput>;
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  readonly nextMedicalExaminationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly nextOhsTrainingDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly officeId?: InputMaybe<Scalars['OfficeId']['input']>;
  readonly operationalLeadId?: InputMaybe<Scalars['UserId']['input']>;
  readonly paczkomat?: InputMaybe<Scalars['String']['input']>;
  readonly passportExpirationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly pesel?: InputMaybe<Scalars['PESEL']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  readonly plateNumber?: InputMaybe<Scalars['String']['input']>;
  readonly practiceLeadId?: InputMaybe<Scalars['UserId']['input']>;
  readonly progressionLevel: ProgressionLevel;
  readonly revenueAdministrationOffice?: InputMaybe<Scalars['RevenueAdministrationOfficeId']['input']>;
  readonly role: CompanyRole;
  readonly skillsAndCompetences?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly socialMediaHandles?: InputMaybe<ReadonlyArray<SocialMediaHandleInput>>;
  readonly spaceId: Scalars['SpaceId']['input'];
};

export type UserMutation = {
  readonly __typename?: 'UserMutation';
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly cancelActivities: UserOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly contractDraft: ContractDraftMutation;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly createB2bContractDraft: B2BContractDraftOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly createEmploymentContractDraft: EmploymentContractDraftOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly createSubcontractDraft: SubcontractDraftOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam]) */
  readonly updateUser: UserOrNfsError;
  /** @allowedIfAnyOf(roles: [InvoicingTeam]) */
  readonly updateUserInvocingTeamScope: UserOrNfsError;
};


export type UserMutationCancelActivitiesArgs = {
  activityIds: ReadonlyArray<Scalars['ActivityId']['input']>;
};


export type UserMutationContractDraftArgs = {
  entityVersion: Scalars['EntityVersion']['input'];
};


export type UserMutationCreateB2bContractDraftArgs = {
  contractId: Scalars['ContractId']['input'];
  currency?: InputMaybe<Scalars['Currency']['input']>;
  expectedEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  holidayCalendarId?: InputMaybe<HolidayCalendarId>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  onCall?: InputMaybe<NetOnCallRateInput>;
  overtimeRate?: InputMaybe<Scalars['Cents']['input']>;
  overwrittenPromisorTransferBankAccountNumber?: InputMaybe<BankAccountNumberInput>;
  position?: InputMaybe<Scalars['String']['input']>;
  promiseeCompanyId?: InputMaybe<Scalars['CompanyId']['input']>;
  promiseeCompanyTransferBankAccountNumber?: InputMaybe<BankAccountNumberInput>;
  promisorId: Scalars['CompanyId']['input'];
  rate?: InputMaybe<NetRateInput>;
  scopeOfWork?: InputMaybe<Scalars['String']['input']>;
  separatePaymentForBenefits?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  vat?: InputMaybe<Scalars['VatTypeInput']['input']>;
};


export type UserMutationCreateEmploymentContractDraftArgs = {
  applyRemoteWorkReimbursement?: InputMaybe<Scalars['Boolean']['input']>;
  contractId: Scalars['ContractId']['input'];
  copyrightCosts?: InputMaybe<Scalars['BasisPoint']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  expectedEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  holidayCalendarId?: InputMaybe<HolidayCalendarId>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  onCall?: InputMaybe<NetOnCallRateInput>;
  overtimeRate?: InputMaybe<Scalars['Cents']['input']>;
  overwrittenPromisorTransferBankAccountNumber?: InputMaybe<BankAccountNumberInput>;
  paidLeaveEntitlement?: InputMaybe<Scalars['Days']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  ppk?: InputMaybe<Scalars['BasisPoint']['input']>;
  promiseeTransferBankAccount?: InputMaybe<BankAccountInput>;
  promisorId: Scalars['CompanyId']['input'];
  rate?: InputMaybe<NetRateInput>;
  scopeOfWork?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  taxDeductibleCosts?: InputMaybe<DeductibleCostsType>;
  type: EmploymentContractType;
  workingTime?: InputMaybe<WorkingTimeInput>;
};


export type UserMutationCreateSubcontractDraftArgs = {
  clientContractId: Scalars['ClientContractId']['input'];
  contractId: Scalars['ContractId']['input'];
  expectedEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  holidayCalendarId?: InputMaybe<HolidayCalendarId>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  scopeOfWork?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type UserMutationUpdateUserArgs = {
  address?: InputMaybe<ClearableAddressInput>;
  areaOfExpertise?: InputMaybe<ClearableStringInput>;
  birthDate?: InputMaybe<ClearableLocalDateInput>;
  citizenship?: InputMaybe<ClearableCountryCodeInput>;
  consentedForUseOfImage?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail?: InputMaybe<ClearableEmailAddressInput>;
  declaredNoCertificates?: InputMaybe<Scalars['Boolean']['input']>;
  documentsDirectory?: InputMaybe<Scalars['URI']['input']>;
  emergencyContact?: InputMaybe<ClearableStringInput>;
  familyName?: InputMaybe<ClearableStringInput>;
  idNumber?: InputMaybe<ClearableStringInput>;
  idType?: InputMaybe<ClearableIdTypeInput>;
  isStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentRevisionDate?: InputMaybe<ClearableLocalDateInput>;
  mailingAddress?: InputMaybe<ClearableAddressInput>;
  middleName?: InputMaybe<ClearableStringInput>;
  nextMedicalExaminationDate?: InputMaybe<ClearableLocalDateInput>;
  nextOhsTrainingDate?: InputMaybe<ClearableLocalDateInput>;
  officeId?: InputMaybe<ClearableOfficeIdInput>;
  operationalLead?: InputMaybe<TimeBasedValueClearableUserIdInput>;
  paczkomat?: InputMaybe<ClearableStringInput>;
  passportExpirationDate?: InputMaybe<ClearableLocalDateInput>;
  personalDataProcessingAuthorization?: InputMaybe<ClearableUriInput>;
  pesel?: InputMaybe<ClearablePeselInput>;
  phoneNumber?: InputMaybe<ClearablePhoneNumberInput>;
  plateNumber?: InputMaybe<ClearableStringInput>;
  practiceLead?: InputMaybe<TimeBasedValueClearableUserIdInput>;
  primaryProjectId?: InputMaybe<TimeBasedValueClearableUserIdInput>;
  progressionLevel?: InputMaybe<TimeBasedValueClearableProgressionLevelInput>;
  revenueAdministrationOffice?: InputMaybe<ClearableRevenueAdministrationOfficeIdInput>;
  role?: InputMaybe<TimeBasedValueCompanyRoleInput>;
  skillsAndCompetences?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  socialMediaHandles?: InputMaybe<ReadonlyArray<SocialMediaHandleInput>>;
  space?: InputMaybe<TimeBasedValueSpaceIdInput>;
};


export type UserMutationUpdateUserInvocingTeamScopeArgs = {
  operationalLead?: InputMaybe<TimeBasedValueClearableUserIdInput>;
  practiceLead?: InputMaybe<TimeBasedValueClearableUserIdInput>;
  primaryProjectId?: InputMaybe<TimeBasedValueClearableUserIdInput>;
  space?: InputMaybe<TimeBasedValueSpaceIdInput>;
};

export type UserOrNfsError = NfsError | User;

export type UserProjectsDrawer = AbstractDrawer & {
  readonly __typename?: 'UserProjectsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export const VatStatus = {
  ACTIVE: 'Active',
  EXEMPT: 'Exempt',
  NODATAINREGISTRY: 'NoDataInRegistry',
  NOTREGISTERED: 'NotRegistered'
} as const;

export type VatStatus = typeof VatStatus[keyof typeof VatStatus];
export type ValidationError = UserError & {
  readonly __typename?: 'ValidationError';
  readonly desc: Scalars['String']['output'];
  readonly fields: ReadonlyArray<Scalars['String']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type ValueWithDescriptionAndVerificationBooleanVatStatus = {
  readonly __typename?: 'ValueWithDescriptionAndVerificationBooleanVATStatus';
  readonly state: VerificationStateWithDescriptionBooleanVatStatus;
  readonly value: Scalars['Boolean']['output'];
};

export type ValueWithVerificationEuVatType = {
  readonly __typename?: 'ValueWithVerificationEuVatType';
  readonly state: VerificationStateEuVatType;
  readonly value: EuVatType;
};

export type VatApplied = {
  readonly __typename?: 'VatApplied';
  readonly value: Scalars['BasisPoint']['output'];
};

export type VatNotApplied = {
  readonly __typename?: 'VatNotApplied';
  readonly reason: VatNotAppliedReason;
};

export const VatNotAppliedReason = {
  EXEMPTFROMVAT: 'ExemptFromVAT',
  VATNOTAPPLICABLE: 'VatNotApplicable'
} as const;

export type VatNotAppliedReason = typeof VatNotAppliedReason[keyof typeof VatNotAppliedReason];
export type VatType = VatApplied | VatNotApplied;

export type VerificationStateBankAccountStatus = NotVerifiedBankAccountStatus | VerifiedBankAccountStatus;

export type VerificationStateEuVatType = NotVerifiedEuVatType | VerifiedEuVatType;

export type VerificationStateEuVatTypeResponse = {
  readonly __typename?: 'VerificationStateEuVatTypeResponse';
  readonly value: VerificationStateEuVatType;
};

export type VerificationStateEuVatTypeResponseOrNfsError = NfsError | VerificationStateEuVatTypeResponse;

export type VerificationStateWithDescriptionBooleanVatStatus = NotVerifiedBooleanVatStatus | VerifiedWithDescriptionBooleanVatStatus;

export type VerifiedBankAccountStatus = {
  readonly __typename?: 'VerifiedBankAccountStatus';
  readonly result: BankAccountStatus;
  readonly when: Scalars['OffsetDateTime']['output'];
};

export type VerifiedEuVatType = {
  readonly __typename?: 'VerifiedEuVatType';
  readonly result: EuVatType;
  readonly when: Scalars['OffsetDateTime']['output'];
};

export type VerifiedWithDescriptionBooleanVatStatus = {
  readonly __typename?: 'VerifiedWithDescriptionBooleanVATStatus';
  readonly description: VatStatus;
  readonly result: Scalars['Boolean']['output'];
  readonly when: Scalars['OffsetDateTime']['output'];
};

export type WeekdayDayAndNightMultipliers = {
  readonly __typename?: 'WeekdayDayAndNightMultipliers';
  readonly day: WeekendMultipliers;
  readonly night: WeekdayMultipliers;
};

export type WeekdayMultipliers = {
  readonly __typename?: 'WeekdayMultipliers';
  readonly friday: OnCallMultiplier;
  readonly monday: OnCallMultiplier;
  readonly saturday: OnCallMultiplier;
  readonly sunday: OnCallMultiplier;
  readonly thursday: OnCallMultiplier;
  readonly tuesday: OnCallMultiplier;
  readonly wednesday: OnCallMultiplier;
};

export type WeekendMultipliers = {
  readonly __typename?: 'WeekendMultipliers';
  readonly saturday: OnCallMultiplier;
  readonly sunday: OnCallMultiplier;
};

export type WhiteListInvalid = {
  readonly __typename?: 'WhiteListInvalid';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkRecord = {
  readonly __typename?: 'WorkRecord';
  readonly approval: Approval;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly contract: Contract;
  readonly contractId: Scalars['ContractId']['output'];
  readonly date: Scalars['LocalDate']['output'];
  readonly draft: Scalars['Boolean']['output'];
  readonly duration?: Maybe<Scalars['Minutes']['output']>;
  readonly id: Scalars['WorkRecordId']['output'];
  readonly overtime: Scalars['Boolean']['output'];
  readonly project?: Maybe<Project>;
  readonly remoteWork: Scalars['Boolean']['output'];
  readonly user: User;
  readonly userId: Scalars['UserId']['output'];
  readonly workTag: WorkTag;
  readonly workTime?: Maybe<WorkTime>;
};

export type WorkRecordApi = {
  readonly __typename?: 'WorkRecordApi';
  /** @allowedIfAnyOf(roles: [FinancialTeam, Lead, SpaceDirector]) */
  readonly approve: WorkRecordOrNfsError;
  readonly createMany: ListOfWorkRecordResponseOrNfsError;
  /** @allowedIfAnyOf(roles: [FinancialTeam, Lead, SpaceDirector]) */
  readonly reject: UnitResponseOrNfsError;
  readonly update: WorkRecordOrNfsError;
};


export type WorkRecordApiApproveArgs = {
  id: Scalars['WorkRecordId']['input'];
};


export type WorkRecordApiCreateManyArgs = {
  value: ReadonlyArray<CreateWorkRecordInput>;
};


export type WorkRecordApiRejectArgs = {
  id: Scalars['WorkRecordId']['input'];
};


export type WorkRecordApiUpdateArgs = {
  comment?: InputMaybe<ClearableStringInput>;
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  duration?: InputMaybe<ClearableMinutesInput>;
  id: Scalars['WorkRecordId']['input'];
  overtime?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<ClearableProjectIdInput>;
  remoteWork?: InputMaybe<Scalars['Boolean']['input']>;
  workTagId?: InputMaybe<Scalars['WorkTagId']['input']>;
  workTime?: InputMaybe<ClearableWorkTimeInput>;
};

export type WorkRecordOrNfsError = NfsError | WorkRecord;

export type WorkTag = {
  readonly __typename?: 'WorkTag';
  readonly canBeOvertime: Scalars['Boolean']['output'];
  readonly canHaveProjectSelected: Scalars['Boolean']['output'];
  readonly canHaveRecurringWorkRecords: Scalars['Boolean']['output'];
  readonly id: Scalars['WorkTagId']['output'];
  readonly name: Scalars['String']['output'];
  readonly yearlyHoursLimit?: Maybe<Scalars['Hours']['output']>;
};

export type WorkTime = {
  readonly __typename?: 'WorkTime';
  readonly break?: Maybe<Scalars['Minutes']['output']>;
  readonly timeFrom: Scalars['LocalTime']['output'];
  readonly timeTo?: Maybe<Scalars['LocalTime']['output']>;
};

export type WorkTimeInput = {
  readonly break?: InputMaybe<Scalars['Minutes']['input']>;
  readonly timeFrom: Scalars['LocalTime']['input'];
  readonly timeTo?: InputMaybe<Scalars['LocalTime']['input']>;
};

export type WorkTransferProtocol = {
  readonly __typename?: 'WorkTransferProtocol';
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly contractSalaryDetails: ContractSalaryDetails;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly createdBy: Scalars['EmailAddress']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['WorkTransferProtocolId']['output'];
  readonly payload: WorkTransferProtocolPayload;
  readonly yearMonth: Scalars['YearMonth']['output'];
};

export type WorkTransferProtocolOperations = {
  readonly __typename?: 'WorkTransferProtocolOperations';
  readonly create: WorkTransferProtocolOrNfsError;
  readonly markNoWorkToBeTransferedThisMonth: WorkTransferProtocolOrNfsError;
  readonly remove: BooleanResponseOrNfsError;
  readonly update: WorkTransferProtocolOrNfsError;
};


export type WorkTransferProtocolOperationsCreateArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['WorkTransferProtocolId']['input'];
  payload: Scalars['Upload']['input'];
};


export type WorkTransferProtocolOperationsMarkNoWorkToBeTransferedThisMonthArgs = {
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
};


export type WorkTransferProtocolOperationsRemoveArgs = {
  id: Scalars['WorkTransferProtocolId']['input'];
};


export type WorkTransferProtocolOperationsUpdateArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<ClearableStringInput>;
  id: Scalars['WorkTransferProtocolId']['input'];
  payload?: InputMaybe<Scalars['Upload']['input']>;
};

export type WorkTransferProtocolOrNfsError = NfsError | WorkTransferProtocol;

export type WorkTransferProtocolPayload = File | NoWorkToBeTransferedThisMonth;

export const WorkTransferProtocolSortBy = {
  EMPLOYEEANDTHENYEARMONTH: 'EmployeeAndThenYearMonth',
  YEARMONTHANDTHENEMPLOYEE: 'YearMonthAndThenEmployee'
} as const;

export type WorkTransferProtocolSortBy = typeof WorkTransferProtocolSortBy[keyof typeof WorkTransferProtocolSortBy];
export type WorkingTime = {
  readonly __typename?: 'WorkingTime';
  readonly denominator: Scalars['Int']['output'];
  readonly friday?: Maybe<Scalars['Minutes']['output']>;
  readonly monday?: Maybe<Scalars['Minutes']['output']>;
  readonly numerator: Scalars['Int']['output'];
  readonly saturday?: Maybe<Scalars['Minutes']['output']>;
  readonly thursday?: Maybe<Scalars['Minutes']['output']>;
  readonly tuesday?: Maybe<Scalars['Minutes']['output']>;
  readonly wednesday?: Maybe<Scalars['Minutes']['output']>;
};

export type WorkingTimeInput = {
  readonly denominator: Scalars['Int']['input'];
  readonly friday?: InputMaybe<Scalars['Minutes']['input']>;
  readonly monday?: InputMaybe<Scalars['Minutes']['input']>;
  readonly numerator: Scalars['Int']['input'];
  readonly saturday?: InputMaybe<Scalars['Minutes']['input']>;
  readonly thursday?: InputMaybe<Scalars['Minutes']['input']>;
  readonly tuesday?: InputMaybe<Scalars['Minutes']['input']>;
  readonly wednesday?: InputMaybe<Scalars['Minutes']['input']>;
};

export type YearlyCostSummaryDrawer = AbstractDrawer & {
  readonly __typename?: 'YearlyCostSummaryDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredUserId: Scalars['UserId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type ZusContributionDetails = {
  readonly __typename?: 'ZusContributionDetails';
  readonly employeeSocialContribution: Scalars['Cents']['output'];
  readonly employerSocialContribution: Scalars['Cents']['output'];
  readonly healthInsuranceContribution: Scalars['Cents']['output'];
};

export type ZusContributionDetailsInput = {
  readonly employeeSocialContribution: Scalars['Cents']['input'];
  readonly employerSocialContribution: Scalars['Cents']['input'];
  readonly healthInsuranceContribution: Scalars['Cents']['input'];
};

export type AboutClientContractDataQueryVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
}>;


export type AboutClientContractDataQuery = { readonly __typename?: 'Query', readonly clientContract:
    | { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly name:
        | { readonly __typename?: 'AccessGranted__String', readonly value: string }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly companyType: ReadonlyArray<CompanyType> } | null, readonly contractDurationFrom:
        | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contractDurationTo:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly docUri:
        | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AboutProjectQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type AboutProjectQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly createdAt: Date, readonly name: string, readonly description:
        | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly areaOfVlEngagement:
        | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly techStack:
        | { readonly __typename?: 'AccessGranted__ListOfString', readonly value: ReadonlyArray<string> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly competences:
        | { readonly __typename?: 'AccessGranted__ListOfString', readonly value: ReadonlyArray<string> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly costLedgerAccountNumber:
        | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly revenueLedgerAccountNumber:
        | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly space?: { readonly __typename?: 'Space', readonly id: string, readonly entityVersion: number, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string } } | null, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly name:
          | { readonly __typename?: 'AccessGranted__String', readonly value: string }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string } | null } }
      & KeyPeopleProjectFragment
      & ProjectCrossSellProjectFragment
    )
   };

export type AbsencesListFiltersSpacesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type AbsencesListFiltersSpacesQuery = { readonly __typename?: 'Query', readonly spaces:
    | { readonly __typename?: 'FSPResponseSpace', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeSpace', readonly cursor: string, readonly node: { readonly __typename?: 'Space', readonly entityVersion: number, readonly id: string, readonly name: string } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AbsencesListFiltersProjectsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type AbsencesListFiltersProjectsQuery = { readonly __typename?: 'Query', readonly projects:
    | { readonly __typename?: 'FSPResponseProject', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeProject', readonly cursor: string, readonly node: { readonly __typename?: 'Project', readonly entityVersion: number, readonly id: string, readonly name: string, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AccessRightsProviderQueryVariables = Exact<{
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
}>;


export type AccessRightsProviderQuery = { readonly __typename?: 'Query', readonly whoAmI:
    | { readonly __typename?: 'ListOfStringResponse', readonly value: ReadonlyArray<string> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly node: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly email: string } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly spaces:
    | { readonly __typename?: 'FSPResponseSpace', readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeSpace', readonly node: { readonly __typename?: 'Space', readonly id: string } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AddClientContractDrawerInputQueryVariables = Exact<{
  id: Scalars['CompanyId']['input'];
}>;


export type AddClientContractDrawerInputQuery = { readonly __typename?: 'Query', readonly company:
    | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly taxNumber?: string | null, readonly euVatType: { readonly __typename?: 'TimeBasedValueWithVerificationEuVatType', readonly value: { readonly __typename?: 'ValueWithVerificationEuVatType', readonly value: EuVatType } } }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AddClientContractDrawerCreateMutationVariables = Exact<{
  id: Scalars['ClientContractId']['input'];
  name: Scalars['String']['input'];
  promiseeId: Scalars['CompanyId']['input'];
  promisorId: Scalars['CompanyId']['input'];
  contractDurationFrom: Scalars['LocalDate']['input'];
  contractDurationTo?: InputMaybe<Scalars['LocalDate']['input']>;
  docUri?: InputMaybe<Scalars['URI']['input']>;
}>;


export type AddClientContractDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createClientContract:
    | { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly name:
        | { readonly __typename?: 'AccessGranted__String', readonly value: string }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contractDurationFrom:
        | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contractDurationTo:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly docUri:
        | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string } }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AddCompanyDrawerCreateMutationVariables = Exact<{
  company: CompanyInput;
}>;


export type AddCompanyDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createCompany:
    | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly taxNumber?: string | null, readonly name: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AddCompanyFormRegisterInfoQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  taxNumber: Scalars['TaxNumber']['input'];
}>;


export type AddCompanyFormRegisterInfoQuery = { readonly __typename?: 'Query', readonly companyInfo:
    | { readonly __typename?: 'CompanyInfo', readonly baseInfo:
        | { readonly __typename?: 'BaseInfo', readonly name?: string | null, readonly taxNumber?: string | null, readonly regon?: string | null, readonly registerId?: string | null, readonly address?: (
            { readonly __typename?: 'Address' }
            & AddressFragment
          ) | null, readonly mailingAddress?: (
            { readonly __typename?: 'Address' }
            & AddressFragment
          ) | null }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
      , readonly euVatType:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'VerificationStateEuVatTypeResponse', readonly value:
            | { readonly __typename?: 'NotVerifiedEuVatType' }
            | { readonly __typename?: 'VerifiedEuVatType', readonly result: EuVatType, readonly when: Date }
           }
      , readonly polishVat:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'PolishVat', readonly isPolishVat:
            | { readonly __typename?: 'NotVerifiedBooleanVATStatus' }
            | { readonly __typename?: 'VerifiedWithDescriptionBooleanVATStatus', readonly result: boolean, readonly when: Date }
          , readonly bankAccounts: ReadonlyArray<(
            { readonly __typename?: 'BankAccount' }
            & BankAccountFragment
          )> }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AddInternalProjectDrawerCreateMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  groupCompanyId: Scalars['CompanyId']['input'];
  startDate: Scalars['LocalDate']['input'];
  projectName: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['SpaceId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddInternalProjectDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createInternalProject:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number }
   };

export type AddOfficeDrawerCreateMutationVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  name: Scalars['String']['input'];
  period: LocalDateRangeInput;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddOfficeDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createOffice:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Office', readonly officeId: string }
   };

export type AddPersonDrawerCreateMutationVariables = Exact<{
  user: UserInput;
}>;


export type AddPersonDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createUser:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }
   };

export type AddProgressionSchemeDrawerCreateMutationVariables = Exact<{
  id: Scalars['ProgressionSchemeId']['input'];
  name: Scalars['String']['input'];
  isEngineering: Scalars['Boolean']['input'];
  yearlyRaise: Scalars['Cents']['input'];
}>;


export type AddProgressionSchemeDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createProgressionScheme:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'ProgressionScheme' }
      & ProgressionSchemesProgressionSchemeFragment
    )
   };

export type AddProjectDrawerCreateMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  name: Scalars['String']['input'];
  clientContractId: Scalars['ClientContractId']['input'];
  spaceId?: InputMaybe<Scalars['SpaceId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  areaOfVlEngagement?: InputMaybe<Scalars['String']['input']>;
  statusHistory: ReadonlyArray<ProjectStatusHistoryEntryInput> | ProjectStatusHistoryEntryInput;
}>;


export type AddProjectDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createProject:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number }
   };

export type AddProjectFormCompanyAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter: FilterCompanyInput;
  sort?: InputMaybe<SortingRequestSortCompanyInput>;
  first: Scalars['Int']['input'];
}>;


export type AddProjectFormCompanyAutocompleteQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly cursor: string, readonly node: (
          { readonly __typename?: 'Company', readonly clientContracts:
            | { readonly __typename?: 'AccessGranted__ListOfClientContract', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
          & CompanyAutocompleteCompanyFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AddProjectFormContractAutocompleteQueryVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
}>;


export type AddProjectFormContractAutocompleteQuery = { readonly __typename?: 'Query', readonly company:
    | (
      { readonly __typename?: 'Company', readonly clientContracts:
        | { readonly __typename?: 'AccessGranted__ListOfClientContract', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly name:
              | { readonly __typename?: 'AccessGranted__String', readonly value: string }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
             }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
      & CompanyAutocompleteCompanyFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AddSpaceDrawerCreateMutationVariables = Exact<{
  spaceId: Scalars['SpaceId']['input'];
  name: Scalars['String']['input'];
  spaceOwner: Scalars['UserId']['input'];
}>;


export type AddSpaceDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createSpace:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Space', readonly id: string, readonly entityVersion: number }
   };

export type AddThirdPersonDrawerCreateMutationVariables = Exact<{
  id: Scalars['ExternalBeneficiaryId']['input'];
  employeeId: Scalars['UserId']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['EmailAddress']['input'];
  address: AddressInput;
}>;


export type AddThirdPersonDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly upsertExternalBeneficiary:
    | { readonly __typename?: 'ExternalBeneficiary', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly address: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AddThirdPersonDrawerLoadDataQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type AddThirdPersonDrawerLoadDataQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly externalBeneficiaries:
        | { readonly __typename?: 'AccessGranted__ListOfExternalBeneficiary', readonly value: ReadonlyArray<{ readonly __typename?: 'ExternalBeneficiary', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly address: (
              { readonly __typename?: 'Address' }
              & AddressFragment
            ) }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type AdditionalCostsDrawerEntityVersionQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type AdditionalCostsDrawerEntityVersionQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AllBonusesDrawerBonusAppreciationBonusFragment = { readonly __typename?: 'AppreciationBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusBusinessTravelBonusFragment = { readonly __typename?: 'BusinessTravelBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusClientReferralBonusFragment = { readonly __typename?: 'ClientReferralBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusConferenceBonusFragment = { readonly __typename?: 'ConferenceBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusCostRechargeBonusFragment = { readonly __typename?: 'CostRechargeBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusEmployeeReferralBonusFragment = { readonly __typename?: 'EmployeeReferralBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusLanguageLearningBonusFragment = { readonly __typename?: 'LanguageLearningBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusOtherBonusFragment = { readonly __typename?: 'OtherBonus', readonly description: string, readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusRemoteWorkEquipmentBonusFragment = { readonly __typename?: 'RemoteWorkEquipmentBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusSalesCommissionsBonusFragment = { readonly __typename?: 'SalesCommissionsBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusSeverancePayBonusFragment = { readonly __typename?: 'SeverancePayBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusShareholderDividendBonusFragment = { readonly __typename?: 'ShareholderDividendBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusTrainingPackageBonusFragment = { readonly __typename?: 'TrainingPackageBonus', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusTrainingPackageExternalDeductionValueFragment = { readonly __typename?: 'TrainingPackageExternalDeductionValue', readonly id: string, readonly paidOutAt?: Date | null, readonly createdAt: Date, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AllBonusesDrawerBonusFragment =
  | AllBonusesDrawerBonusAppreciationBonusFragment
  | AllBonusesDrawerBonusBusinessTravelBonusFragment
  | AllBonusesDrawerBonusClientReferralBonusFragment
  | AllBonusesDrawerBonusConferenceBonusFragment
  | AllBonusesDrawerBonusCostRechargeBonusFragment
  | AllBonusesDrawerBonusEmployeeReferralBonusFragment
  | AllBonusesDrawerBonusLanguageLearningBonusFragment
  | AllBonusesDrawerBonusOtherBonusFragment
  | AllBonusesDrawerBonusRemoteWorkEquipmentBonusFragment
  | AllBonusesDrawerBonusSalesCommissionsBonusFragment
  | AllBonusesDrawerBonusSeverancePayBonusFragment
  | AllBonusesDrawerBonusShareholderDividendBonusFragment
  | AllBonusesDrawerBonusTrainingPackageBonusFragment
  | AllBonusesDrawerBonusTrainingPackageExternalDeductionValueFragment
;

export type AllBonusesDrawerCurrencyFragment = { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly value: string }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly value: string }> };

export type AllBonusesDrawerDeleteMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  bonusId: Scalars['BonusId']['input'];
}>;


export type AllBonusesDrawerDeleteMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly bonus: { readonly __typename?: 'BonusMutation', readonly delete:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
       } } };

export type AllBonusesDrawerQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type AllBonusesDrawerQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly currency:
            | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
                { readonly __typename?: 'TimeBasedCurrency' }
                & AllBonusesDrawerCurrencyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly vat:
            | { readonly __typename?: 'AccessGranted__TimeBasedVatType', readonly value: { readonly __typename?: 'TimeBasedVatType', readonly value:
                  | (
                    { readonly __typename?: 'VatApplied' }
                    & VatTypeVatAppliedFragment
                  )
                  | (
                    { readonly __typename?: 'VatNotApplied' }
                    & VatTypeVatNotAppliedFragment
                  )
                 } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: { readonly __typename?: 'User', readonly id: string }, readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AllBonusesDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AllBonusesDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AllBonusesDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AllBonusesDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AllBonusesDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AllBonusesDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AllBonusesDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AllBonusesDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AllBonusesDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AllBonusesDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AllBonusesDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AllBonusesDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AllBonusesDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AllBonusesDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AllBonusesDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AllBonusesDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AllBonusesDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AllBonusesDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AllBonusesDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AllBonusesDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AllBonusesDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AllBonusesDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AllBonusesDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AllBonusesDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AllBonusesDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AllBonusesDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AllBonusesDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AllBonusesDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly currency:
            | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
                { readonly __typename?: 'TimeBasedCurrency' }
                & AllBonusesDrawerCurrencyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: { readonly __typename?: 'User', readonly id: string }, readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AllBonusesDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AllBonusesDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AllBonusesDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AllBonusesDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AllBonusesDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AllBonusesDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AllBonusesDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AllBonusesDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AllBonusesDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AllBonusesDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AllBonusesDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AllBonusesDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AllBonusesDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AllBonusesDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AllBonusesDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AllBonusesDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AllBonusesDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AllBonusesDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AllBonusesDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AllBonusesDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AllBonusesDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AllBonusesDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AllBonusesDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AllBonusesDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AllBonusesDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AllBonusesDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AllBonusesDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AllBonusesDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly promisee: { readonly __typename?: 'User', readonly id: string }, readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AllBonusesDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AllBonusesDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AllBonusesDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AllBonusesDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AllBonusesDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AllBonusesDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AllBonusesDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AllBonusesDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AllBonusesDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AllBonusesDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AllBonusesDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AllBonusesDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AllBonusesDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AllBonusesDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AllBonusesDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AllBonusesDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AllBonusesDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AllBonusesDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AllBonusesDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AllBonusesDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AllBonusesDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AllBonusesDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AllBonusesDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AllBonusesDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AllBonusesDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AllBonusesDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AllBonusesDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AllBonusesDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AnnualLeaveDetailsQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type AnnualLeaveDetailsQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly isStudent:
        | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly name: string, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly entityVersion: number, readonly status: ContractStatus, readonly createdAt: Date, readonly terminationDate?: Date | null, readonly conclusionDate:
                | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string } } }
            | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly name: string, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly entityVersion: number, readonly status: ContractStatus, readonly createdAt: Date, readonly terminationDate?: Date | null, readonly workingTime:
                | { readonly __typename?: 'AccessGranted__TimeBasedWorkingTime', readonly value: { readonly __typename?: 'TimeBasedWorkingTime', readonly value: { readonly __typename?: 'WorkingTime', readonly numerator: number, readonly denominator: number } } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly annualLeaveEntitlement:
                | { readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement', readonly value?: { readonly __typename?: 'AnnualLeaveEntitlement', readonly history: ReadonlyArray<{ readonly __typename?: 'AnnualLeaveEntitlementPeriod', readonly entitlement: (
                        { readonly __typename?: 'AnnualLeaveEntitlementValue' }
                        & AnnualLeaveEntitlementValueFragment
                      ) }> } | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly conclusionDate:
                | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string } } }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly name: string, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly entityVersion: number, readonly status: ContractStatus, readonly createdAt: Date, readonly terminationDate?: Date | null, readonly conclusionDate:
                | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string } } }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type AnnualLeaveEntitlementMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  annualLeaveEntitlement: AnnualLeaveEntitlementInput;
}>;


export type AnnualLeaveEntitlementMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly annualLeaveEntitlement:
          | { readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement', readonly value?: { readonly __typename?: 'AnnualLeaveEntitlement', readonly history: ReadonlyArray<{ readonly __typename?: 'AnnualLeaveEntitlementPeriod', readonly entitlementExplanation: string, readonly createdAt: Date, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly entitlement: (
                  { readonly __typename?: 'AnnualLeaveEntitlementValue' }
                  & AnnualLeaveEntitlementValueFragment
                ) }> } | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type AnnualLeaveEntitlementDrawerSetEntitlementMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  annualLeaveEntitlement: AnnualLeaveEntitlementInput;
}>;


export type AnnualLeaveEntitlementDrawerSetEntitlementMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly annualLeaveEntitlement:
          | { readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement', readonly value?: { readonly __typename?: 'AnnualLeaveEntitlement', readonly history: ReadonlyArray<{ readonly __typename?: 'AnnualLeaveEntitlementPeriod', readonly entitlementExplanation: string, readonly createdAt: Date, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly entitlement: (
                  { readonly __typename?: 'AnnualLeaveEntitlementValue' }
                  & AnnualLeaveEntitlementValueFragment
                ) }> } | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type AnnualLeavePreferencesDrawerInitialDataQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type AnnualLeavePreferencesDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date }
        | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly annualLeaveEntitlement:
            | { readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement', readonly value?: { readonly __typename?: 'AnnualLeaveEntitlement', readonly withCarryOverToNextYear: boolean, readonly history: ReadonlyArray<{ readonly __typename?: 'AnnualLeaveEntitlementPeriod', readonly entitlementExplanation: string, readonly createdAt: Date, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly entitlement: (
                    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
                    & AnnualLeaveEntitlementValueFragment
                  ) }> } | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly startDate: Date }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AnnualLeavePreferencesDrawerUpdatePreferencesMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  annualLeaveEntitlement: AnnualLeaveEntitlementInput;
}>;


export type AnnualLeavePreferencesDrawerUpdatePreferencesMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly annualLeaveEntitlement:
          | { readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement', readonly value?: { readonly __typename?: 'AnnualLeaveEntitlement', readonly withCarryOverToNextYear: boolean, readonly history: ReadonlyArray<{ readonly __typename?: 'AnnualLeaveEntitlementPeriod', readonly entitlementExplanation: string, readonly createdAt: Date, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly entitlement: (
                  { readonly __typename?: 'AnnualLeaveEntitlementValue' }
                  & AnnualLeaveEntitlementValueFragment
                ) }> } | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type AnnualLeaveSummaryHistoryFragment = { readonly __typename?: 'AnnualLeaveSummary', readonly yearlySummary: ReadonlyArray<{ readonly __typename?: 'KVYearAnnualLeaveYearSummary', readonly key: number, readonly value: { readonly __typename?: 'AnnualLeaveYearSummary', readonly year: number, readonly totalBalance: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ), readonly balanceThisYear: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ), readonly carriedOverEntitlementBalance?: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ) | null } }> };

export type AnnualLeaveSummaryQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  year: Scalars['Year']['input'];
}>;


export type AnnualLeaveSummaryQuery = { readonly __typename?: 'Query', readonly annualLeaveSummary:
    | (
      { readonly __typename?: 'AnnualLeaveSummary' }
      & AnnualLeaveSummaryHistoryFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly startDate: Date, readonly terminationDate?: Date | null, readonly entityVersion: number }
        | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly startDate: Date, readonly terminationDate?: Date | null, readonly entityVersion: number, readonly workingTime:
            | { readonly __typename?: 'AccessGranted__TimeBasedWorkingTime', readonly value: { readonly __typename?: 'TimeBasedWorkingTime', readonly value: { readonly __typename?: 'WorkingTime', readonly numerator: number, readonly denominator: number } } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly annualLeaveEntitlement:
            | { readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement', readonly value?: { readonly __typename?: 'AnnualLeaveEntitlement', readonly withCarryOverToNextYear: boolean, readonly history: ReadonlyArray<{ readonly __typename?: 'AnnualLeaveEntitlementPeriod', readonly entitlementExplanation: string, readonly createdAt: Date, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly entitlement: (
                    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
                    & AnnualLeaveEntitlementValueFragment
                  ) }> } | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly startDate: Date, readonly terminationDate?: Date | null, readonly entityVersion: number }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AnnualLeaveSummaryUpdateYearMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  annualLeaveEntitlement: AnnualLeaveEntitlementInput;
}>;


export type AnnualLeaveSummaryUpdateYearMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type AnnualLeaveSummaryDrawerQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  year: Scalars['Year']['input'];
}>;


export type AnnualLeaveSummaryDrawerQuery = { readonly __typename?: 'Query', readonly annualLeaveSummary:
    | { readonly __typename?: 'AnnualLeaveSummary', readonly yearlySummary: ReadonlyArray<{ readonly __typename?: 'KVYearAnnualLeaveYearSummary', readonly key: number, readonly value: { readonly __typename?: 'AnnualLeaveYearSummary', readonly year: number, readonly totalBalance: (
            { readonly __typename?: 'AnnualLeaveBalance' }
            & AnnualLeaveBalanceFragment
          ), readonly balanceThisYear: (
            { readonly __typename?: 'AnnualLeaveBalance' }
            & AnnualLeaveBalanceFragment
          ), readonly carriedOverEntitlementBalance?: (
            { readonly __typename?: 'AnnualLeaveBalance' }
            & AnnualLeaveBalanceFragment
          ) | null } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date }
        | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly workingTime:
            | { readonly __typename?: 'AccessGranted__TimeBasedWorkingTime', readonly value: { readonly __typename?: 'TimeBasedWorkingTime', readonly value: { readonly __typename?: 'WorkingTime', readonly numerator: number, readonly denominator: number } } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly annualLeaveEntitlement:
            | { readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement', readonly value?: { readonly __typename?: 'AnnualLeaveEntitlement', readonly withCarryOverToNextYear: boolean, readonly history: ReadonlyArray<{ readonly __typename?: 'AnnualLeaveEntitlementPeriod', readonly entitlementExplanation: string, readonly createdAt: Date, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly entitlement: (
                    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
                    & AnnualLeaveEntitlementValueFragment
                  ) }> } | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly startDate: Date }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ApproveAndSendRaiseModalGmailConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type ApproveAndSendRaiseModalGmailConnectionQuery = { readonly __typename?: 'Query', readonly gmailConnection?:
    | { readonly __typename?: 'GmailConnection', readonly adminId: string, readonly connectedEmail: string, readonly aliases: ReadonlyArray<string>, readonly selectedAlias?: string | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   | null };

export type ApproveAndSendRaiseModalApplyRaiseMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  effectiveFrom: Scalars['YearMonth']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  to: ReadonlyArray<Scalars['EmailAddress']['input']> | Scalars['EmailAddress']['input'];
  cc: ReadonlyArray<Scalars['EmailAddress']['input']> | Scalars['EmailAddress']['input'];
  subject: Scalars['String']['input'];
  body: Scalars['String']['input'];
  from?: InputMaybe<Scalars['EmailAddress']['input']>;
}>;


export type ApproveAndSendRaiseModalApplyRaiseMutation = { readonly __typename?: 'Mutation', readonly applyRaiseAndSendEmail:
    | { readonly __typename?: 'ApplyRaiseResult', readonly contractId: string, readonly newHourlyRate: number, readonly effectiveFrom: Date }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ArchiveProgressionSchemeModalArchiveMutationVariables = Exact<{
  progressionSchemeId: Scalars['ProgressionSchemeId']['input'];
}>;


export type ArchiveProgressionSchemeModalArchiveMutation = { readonly __typename?: 'Mutation', readonly archiveProgressionScheme:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'ProgressionScheme' }
      & ProgressionSchemesProgressionSchemeFragment
    )
   };

export type AssignBenefitDrawerBenefitVariantFragment = { readonly __typename?: 'BenefitVariant', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly endDate?: Date | null, readonly productId: string, readonly buyerType: BenefitBuyerType, readonly contractTypes: ReadonlyArray<ContractType>, readonly description?: string | null, readonly parent:
    | { readonly __typename?: 'Benefit', readonly id: string, readonly entityVersion: number, readonly alternativeBenefitsGroupId: string, readonly name: string, readonly benefitParent: BenefitGroupType }
    | { readonly __typename?: 'SubBenefit', readonly id: string, readonly entityVersion: number, readonly alternativeBenefitsGroupId: string, readonly name: string }
  , readonly additionalPeople?:
    | (
      { readonly __typename?: 'BenefitAdditionalAdults' }
      & BenefitAdditionalPeopleBenefitAdditionalAdultsFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalFamily' }
      & BenefitAdditionalPeopleBenefitAdditionalFamilyFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalKids' }
      & BenefitAdditionalPeopleBenefitAdditionalKidsFragment
    )
   | null, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: { readonly __typename?: 'BenefitVariantRate', readonly period: BenefitBillingPeriod } | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: { readonly __typename?: 'BenefitVariantRate', readonly period: BenefitBillingPeriod } | null } }> } };

export type AssignBenefitDrawerAssignedVariantFragment = { readonly __typename?: 'AssignedVariant', readonly id: string, readonly variant: { readonly __typename?: 'TimeBasedBenefitVariant', readonly value: (
      { readonly __typename?: 'BenefitVariant' }
      & AssignBenefitDrawerBenefitVariantFragment
    ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly activityId: string, readonly applyDate: Date, readonly value: (
        { readonly __typename?: 'BenefitVariant' }
        & AssignBenefitDrawerBenefitVariantFragment
      ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly activityId: string, readonly applyDate: Date, readonly value: (
        { readonly __typename?: 'BenefitVariant' }
        & AssignBenefitDrawerBenefitVariantFragment
      ) }> }, readonly invoiceTo: { readonly __typename?: 'TimeBasedOptClearableExternalBeneficiary', readonly value?: (
      { readonly __typename?: 'ExternalBeneficiary' }
      & ExternalBeneficiaryFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
          { readonly __typename?: 'ExternalBeneficiary' }
          & ExternalBeneficiaryFragment
        ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
          { readonly __typename?: 'ExternalBeneficiary' }
          & ExternalBeneficiaryFragment
        ) | null } }> }, readonly externalBeneficiaries: { readonly __typename?: 'TimeBasedListOfExternalBeneficiary', readonly value: ReadonlyArray<(
      { readonly __typename?: 'ExternalBeneficiary' }
      & ExternalBeneficiaryFragment
    )>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly activityId: string, readonly applyDate: Date, readonly value: ReadonlyArray<(
        { readonly __typename?: 'ExternalBeneficiary' }
        & ExternalBeneficiaryFragment
      )> }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly activityId: string, readonly applyDate: Date, readonly value: ReadonlyArray<(
        { readonly __typename?: 'ExternalBeneficiary' }
        & ExternalBeneficiaryFragment
      )> }> }, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }> }, readonly buyerType: { readonly __typename?: 'TimeBasedBenefitBuyerType', readonly value: BenefitBuyerType, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly activityId: string, readonly applyDate: Date, readonly value: BenefitBuyerType }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly activityId: string, readonly applyDate: Date, readonly value: BenefitBuyerType }> } };

export type AssignBenefitDrawerRateFragment = { readonly __typename?: 'TimeBasedRate', readonly value: { readonly __typename?: 'Rate', readonly settlement: Settlement }, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'Rate', readonly settlement: Settlement } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'Rate', readonly settlement: Settlement } }> };

export type AssignBenefitDrawerContractB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly b2bContractType: B2BContractType, readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
        { readonly __typename?: 'TimeBasedRate' }
        & AssignBenefitDrawerRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly activityId: string, readonly value: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly activityId: string, readonly value: string }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type AssignBenefitDrawerContractEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly employmentContractType: EmploymentContractType, readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
        { readonly __typename?: 'TimeBasedRate' }
        & AssignBenefitDrawerRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly activityId: string, readonly value: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly activityId: string, readonly value: string }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type AssignBenefitDrawerContractSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date };

export type AssignBenefitDrawerContractFragment =
  | AssignBenefitDrawerContractB2BContractFragment
  | AssignBenefitDrawerContractEmploymentContractFragment
  | AssignBenefitDrawerContractSubcontractFragment
;

export type AssignBenefitsDrawerCurrencyFragment = { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly activityId: string, readonly value: string, readonly applyDate: Date }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly activityId: string, readonly value: string, readonly applyDate: Date }> };

export type AssignBenefitDrawerLoadDataQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  userId: Scalars['UserId']['input'];
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  groupType?: InputMaybe<BenefitGroupType>;
}>;


export type AssignBenefitDrawerLoadDataQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract', readonly at?: Date | null, readonly startDate: Date, readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<(
                { readonly __typename?: 'AssignedVariant', readonly at?: Date | null }
                & AssignBenefitDrawerAssignedVariantFragment
              )> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
          & AssignBenefitDrawerContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract', readonly at?: Date | null, readonly startDate: Date, readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<(
                { readonly __typename?: 'AssignedVariant', readonly at?: Date | null }
                & AssignBenefitDrawerAssignedVariantFragment
              )> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
          & AssignBenefitDrawerContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract', readonly at?: Date | null, readonly startDate: Date, readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<(
                { readonly __typename?: 'AssignedVariant', readonly at?: Date | null }
                & AssignBenefitDrawerAssignedVariantFragment
              )> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
          & AssignBenefitDrawerContractSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly externalBeneficiaries:
        | { readonly __typename?: 'AccessGranted__ListOfExternalBeneficiary', readonly value: ReadonlyArray<{ readonly __typename?: 'ExternalBeneficiary', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly address: (
              { readonly __typename?: 'Address' }
              & AddressFragment
            ) }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
  , readonly benefits:
    | { readonly __typename?: 'ListOfBenefitGroupResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'BenefitGroup', readonly groupType: BenefitGroupType, readonly benefits: { readonly __typename?: 'ConjunctiveBenefits', readonly manyOf: ReadonlyArray<{ readonly __typename?: 'AlternativeBenefits', readonly alternativeBenefitsGroupId: string, readonly oneOf: ReadonlyArray<{ readonly __typename?: 'Benefit', readonly id: string, readonly name: string, readonly entityVersion: number, readonly startDate: Date, readonly endDate?: Date | null, readonly variants: ReadonlyArray<(
                { readonly __typename?: 'BenefitVariant' }
                & AssignBenefitDrawerBenefitVariantFragment
              )> }> }> } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AssignBenefitDrawerAssignVariantsMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  effectiveFrom: Scalars['Date']['input'];
  benefitVariants: ReadonlyArray<AssignVariantInput> | AssignVariantInput;
  groupType: BenefitGroupType;
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type AssignBenefitDrawerAssignVariantsMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly assignVariants:
      | { readonly __typename?: 'ListOfAssignedVariantResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly variant: { readonly __typename?: 'TimeBasedBenefitVariant', readonly value: { readonly __typename?: 'BenefitVariant', readonly id: string, readonly entityVersion: number } }, readonly buyerType: { readonly __typename?: 'TimeBasedBenefitBuyerType', readonly value: BenefitBuyerType } }> }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type B2BContractDraftDrawerDraftB2BContractDraftFragment = { readonly __typename?: 'B2BContractDraft', readonly name: string, readonly scopeOfWork?: string | null, readonly startDate?: Date | null, readonly expectedEndDate?: Date | null, readonly position?: string | null, readonly id: string, readonly entityVersion: number, readonly b2bContractType: B2BContractType, readonly holidayCalendar?: { readonly __typename?: 'HolidayCalendar', readonly id: HolidayCalendarId } | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: (
    { readonly __typename?: 'Company' }
    & CompanyAutocompleteCompanyFragment
  ), readonly promiseeCompany?: (
    { readonly __typename?: 'Company' }
    & CompanyAutocompleteCompanyFragment
  ) | null };

export type B2BContractDraftDrawerDraftEmploymentContractDraftFragment = { readonly __typename?: 'EmploymentContractDraft', readonly id: string, readonly entityVersion: number };

export type B2BContractDraftDrawerDraftSubcontractDraftFragment = { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number };

export type B2BContractDraftDrawerDraftFragment =
  | B2BContractDraftDrawerDraftB2BContractDraftFragment
  | B2BContractDraftDrawerDraftEmploymentContractDraftFragment
  | B2BContractDraftDrawerDraftSubcontractDraftFragment
;

export type B2BContractDraftDrawerUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly email: string, readonly emergencyContact:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly pesel:
    | { readonly __typename?: 'AccessGranted__OptionalPESEL', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly birthDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type B2BContractDraftDrawerInputQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type B2BContractDraftDrawerInputQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User', readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | (
              { readonly __typename?: 'B2BContractDraft' }
              & B2BContractDraftDrawerDraftB2BContractDraftFragment
            )
            | (
              { readonly __typename?: 'EmploymentContractDraft' }
              & B2BContractDraftDrawerDraftEmploymentContractDraftFragment
            )
            | (
              { readonly __typename?: 'SubcontractDraft' }
              & B2BContractDraftDrawerDraftSubcontractDraftFragment
            )
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly type: B2BContractType, readonly id: string, readonly startDate: Date, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string } } }
            | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly startDate: Date, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string } } }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly startDate: Date, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string } } }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
      & B2BContractDraftDrawerUserFragment
    )
   };

export type B2BContractDraftDrawerCreateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  contractId: Scalars['ContractId']['input'];
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  expectedEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  holidayCalendarId?: InputMaybe<HolidayCalendarId>;
  scopeOfWork?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  promiseeCompanyId?: InputMaybe<Scalars['CompanyId']['input']>;
  promisorId: Scalars['CompanyId']['input'];
}>;


export type B2BContractDraftDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly createB2bContractDraft:
      | (
        { readonly __typename?: 'B2BContractDraft' }
        & B2BContractDraftDrawerDraftB2BContractDraftFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type B2BContractDraftDrawerUpdateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  name: Scalars['String']['input'];
  startDate?: InputMaybe<ClearableLocalDateInput>;
  expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
  holidayCalendarId?: InputMaybe<ClearableHolidayCalendarIdInput>;
  scopeOfWork?: InputMaybe<ClearableStringInput>;
  position?: InputMaybe<ClearableStringInput>;
  promiseeCompanyId?: InputMaybe<ClearableCompanyIdInput>;
  promisorId: Scalars['CompanyId']['input'];
}>;


export type B2BContractDraftDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateB2bDraft:
        | (
          { readonly __typename?: 'B2BContractDraft' }
          & B2BContractDraftDrawerDraftB2BContractDraftFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type B2BContractDraftDrawerUpdateUserMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  pesel?: InputMaybe<ClearablePeselInput>;
  birthDate?: InputMaybe<ClearableLocalDateInput>;
  emergencyContact?: InputMaybe<ClearableStringInput>;
}>;


export type B2BContractDraftDrawerUpdateUserMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & B2BContractDraftDrawerUserFragment
      )
     } };

export type B2BSalariesDetailsDrawerInvoiceDetailsFragment = { readonly __typename?: 'InvoiceDetails', readonly id: string, readonly correct?: boolean | null, readonly number?: string | null, readonly userNote?: string | null, readonly adminNote?: string | null, readonly ksefNumber?: string | null, readonly saldeoDocumentUrl?: string | null, readonly currency?: string | null, readonly grossValue?: number | null, readonly file?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly downloadUrl: string, readonly openUrl: string, readonly fileName: string } | null };

export type B2BSalariesDetailsDrawerBenefitValueFragment = { readonly __typename?: 'BenefitValue', readonly variant: { readonly __typename?: 'BenefitVariant', readonly id: string, readonly productId: string, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
        { readonly __typename?: 'BenefitVariantRate' }
        & BenefitVariantRateFragment
      ) | null }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
        { readonly __typename?: 'BenefitVariantRate' }
        & BenefitVariantRateFragment
      ) | null }, readonly parent:
      | { readonly __typename?: 'Benefit', readonly id: string, readonly name: string, readonly alternativeBenefitsGroupId: string }
      | { readonly __typename?: 'SubBenefit', readonly id: string, readonly name: string, readonly alternativeBenefitsGroupId: string }
     }, readonly refundedValue?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly notRefundedValue?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly totalValue: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type B2BSalariesDetailsDrawerIncomeDetailsFragment = { readonly __typename?: 'IncomeDetails', readonly totalWorkTime: number, readonly overtimeWorkTime: number, readonly standardWorkTime: number, readonly rateDetails?: (
    { readonly __typename?: 'RateDetails' }
    & RateDetailsFragment
    & RateDetailsFragment
  ) | null, readonly totalPayout: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueStandardTimeIncome: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueOvertimeIncome: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly standardTimeIncome: ReadonlyArray<
    | (
      { readonly __typename?: 'DailyIncomeRow' }
      & IncomeRowDailyIncomeRowFragment
    )
    | (
      { readonly __typename?: 'HourlyIncomeRow' }
      & IncomeRowHourlyIncomeRowFragment
    )
    | (
      { readonly __typename?: 'MonthlyIncomeRow' }
      & IncomeRowMonthlyIncomeRowFragment
    )
  >, readonly overtimeIncome: ReadonlyArray<(
    { readonly __typename?: 'HourlyIncomeRow' }
    & IncomeRowHourlyIncomeRowFragment
  )>, readonly totalValueOnCalls: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueBonuses: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly bonusesValueByCategory: ReadonlyArray<{ readonly __typename?: 'BonusCategoryAmount', readonly bonusCategory: BonusType, readonly amount: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) }>, readonly totalValueStandardTimeIncomeIncludingBenefits: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueOvertimeIncomeIncludingBenefits: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly onCallLogs: ReadonlyArray<{ readonly __typename?: 'OnCallLog', readonly multiplier: OnCallMultiplier, readonly shifts: number }>, readonly benefitsValue: { readonly __typename?: 'BenefitsValue', readonly totalValueRefunded: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly refunded: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & B2BSalariesDetailsDrawerBenefitValueFragment
    )>, readonly totalValueNotRefunded: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly notRefunded: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & B2BSalariesDetailsDrawerBenefitValueFragment
    )>, readonly totalValueThirdParty: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly thirdParty: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & B2BSalariesDetailsDrawerBenefitValueFragment
    )>, readonly totalValueAll: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) } };

export type B2BSalariesDetailsDrawerQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  monthStart: Scalars['LocalDate']['input'];
  monthEnd: Scalars['LocalDate']['input'];
}>;


export type B2BSalariesDetailsDrawerQuery = { readonly __typename?: 'Query', readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportStats?:
        | { readonly __typename?: 'B2BTimeReportStats', readonly reportedDaysOff: number, readonly overtime: number, readonly timeBalanceAtEndOfMonth: { readonly __typename?: 'TimeBalance', readonly reportedStandardWorkTime: number, readonly currentTimeRequirement: number } }
        | { readonly __typename?: 'EmploymentTimeReportStats', readonly overtime: number, readonly timeBalanceAtEndOfMonth: { readonly __typename?: 'TimeBalance', readonly reportedStandardWorkTime: number, readonly currentTimeRequirement: number } }
       | null }
  , readonly contractSalaryDetails:
    | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
        | { readonly __typename?: 'B2BContractSalaryDetails', readonly adjustGrossValue?: GrossAdjustment | null, readonly contractId: string, readonly yearMonth: Date, readonly entityVersion: number, readonly transferTitle: string, readonly absenceDays: number, readonly workTotalTime: number, readonly requiredWorkedTime: number, readonly transferAmount?: number | null, readonly isTimeReportCompleted: boolean, readonly isTimeReportApprovalRequired: boolean, readonly flag?: ContractSalaryDetailsFlagColor | null, readonly note?: string | null, readonly luminisServicesValue?: { readonly __typename?: 'NetGross', readonly gross: number } | null, readonly contract: { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly at?: Date | null, readonly status: ContractStatus, readonly name: string, readonly startDate: Date, readonly terminationDate?: Date | null, readonly type: B2BContractType, readonly bonuses:
              | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                    | (
                      { readonly __typename?: 'AppreciationBonus' }
                      & SharedSalaryBonusAppreciationBonusFragment
                    )
                    | (
                      { readonly __typename?: 'BusinessTravelBonus' }
                      & SharedSalaryBonusBusinessTravelBonusFragment
                    )
                    | (
                      { readonly __typename?: 'ClientReferralBonus' }
                      & SharedSalaryBonusClientReferralBonusFragment
                    )
                    | (
                      { readonly __typename?: 'ConferenceBonus' }
                      & SharedSalaryBonusConferenceBonusFragment
                    )
                    | (
                      { readonly __typename?: 'CostRechargeBonus' }
                      & SharedSalaryBonusCostRechargeBonusFragment
                    )
                    | (
                      { readonly __typename?: 'EmployeeReferralBonus' }
                      & SharedSalaryBonusEmployeeReferralBonusFragment
                    )
                    | (
                      { readonly __typename?: 'LanguageLearningBonus' }
                      & SharedSalaryBonusLanguageLearningBonusFragment
                    )
                    | (
                      { readonly __typename?: 'OtherBonus' }
                      & SharedSalaryBonusOtherBonusFragment
                    )
                    | (
                      { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                      & SharedSalaryBonusRemoteWorkEquipmentBonusFragment
                    )
                    | (
                      { readonly __typename?: 'SalesCommissionsBonus' }
                      & SharedSalaryBonusSalesCommissionsBonusFragment
                    )
                    | (
                      { readonly __typename?: 'SeverancePayBonus' }
                      & SharedSalaryBonusSeverancePayBonusFragment
                    )
                    | (
                      { readonly __typename?: 'ShareholderDividendBonus' }
                      & SharedSalaryBonusShareholderDividendBonusFragment
                    )
                    | (
                      { readonly __typename?: 'TrainingPackageBonus' }
                      & SharedSalaryBonusTrainingPackageBonusFragment
                    )
                    | (
                      { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                      & SharedSalaryBonusTrainingPackageExternalDeductionValueFragment
                    )
                  >, readonly future: ReadonlyArray<
                    | (
                      { readonly __typename?: 'AppreciationBonus' }
                      & SharedSalaryBonusAppreciationBonusFragment
                    )
                    | (
                      { readonly __typename?: 'BusinessTravelBonus' }
                      & SharedSalaryBonusBusinessTravelBonusFragment
                    )
                    | (
                      { readonly __typename?: 'ClientReferralBonus' }
                      & SharedSalaryBonusClientReferralBonusFragment
                    )
                    | (
                      { readonly __typename?: 'ConferenceBonus' }
                      & SharedSalaryBonusConferenceBonusFragment
                    )
                    | (
                      { readonly __typename?: 'CostRechargeBonus' }
                      & SharedSalaryBonusCostRechargeBonusFragment
                    )
                    | (
                      { readonly __typename?: 'EmployeeReferralBonus' }
                      & SharedSalaryBonusEmployeeReferralBonusFragment
                    )
                    | (
                      { readonly __typename?: 'LanguageLearningBonus' }
                      & SharedSalaryBonusLanguageLearningBonusFragment
                    )
                    | (
                      { readonly __typename?: 'OtherBonus' }
                      & SharedSalaryBonusOtherBonusFragment
                    )
                    | (
                      { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                      & SharedSalaryBonusRemoteWorkEquipmentBonusFragment
                    )
                    | (
                      { readonly __typename?: 'SalesCommissionsBonus' }
                      & SharedSalaryBonusSalesCommissionsBonusFragment
                    )
                    | (
                      { readonly __typename?: 'SeverancePayBonus' }
                      & SharedSalaryBonusSeverancePayBonusFragment
                    )
                    | (
                      { readonly __typename?: 'ShareholderDividendBonus' }
                      & SharedSalaryBonusShareholderDividendBonusFragment
                    )
                    | (
                      { readonly __typename?: 'TrainingPackageBonus' }
                      & SharedSalaryBonusTrainingPackageBonusFragment
                    )
                    | (
                      { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                      & SharedSalaryBonusTrainingPackageExternalDeductionValueFragment
                    )
                  > } }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly conclusionDate:
              | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly currency:
              | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string } }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly separatePaymentForBenefits:
              | { readonly __typename?: 'AccessGranted__TimeBasedBoolean', readonly value: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean } }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly vat:
              | { readonly __typename?: 'AccessGranted__TimeBasedVatType', readonly value: { readonly __typename?: 'TimeBasedVatType', readonly value:
                    | (
                      { readonly __typename?: 'VatApplied' }
                      & VatTypeVatAppliedFragment
                    )
                    | (
                      { readonly __typename?: 'VatNotApplied' }
                      & VatTypeVatNotAppliedFragment
                    )
                   } }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly assignedProjects:
                  | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string } }> }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                 } }, readonly promiseeCompany:
              | { readonly __typename?: 'AccessGranted__Company', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly isPolishVat: { readonly __typename?: 'TimeBasedValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: { readonly __typename?: 'ValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: boolean, readonly state:
                        | { readonly __typename?: 'NotVerifiedBooleanVATStatus' }
                        | { readonly __typename?: 'VerifiedWithDescriptionBooleanVATStatus', readonly when: Date, readonly result: boolean }
                       } }, readonly bankAccounts: ReadonlyArray<(
                    { readonly __typename?: 'BankAccount' }
                    & BankAccountFragment
                  )> } }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly promiseeCompanyTransferBankAccount:
              | { readonly __typename?: 'AccessGranted__OptionalBankAccount', readonly value?: (
                  { readonly __typename?: 'BankAccount' }
                  & BankAccountFragment
                ) | null }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly rate:
              | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: { readonly __typename?: 'TimeBasedRate', readonly value: (
                    { readonly __typename?: 'Rate' }
                    & RateFragment
                  ) } }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } }, readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
                { readonly __typename?: 'BankAccount' }
                & BankAccountFragment
              ) | null } }, readonly whiteListVerificationState:
            | { readonly __typename?: 'NotVerifiedBankAccountStatus' }
            | { readonly __typename?: 'VerifiedBankAccountStatus', readonly result: BankAccountStatus, readonly when: Date }
          , readonly invoiceDetails: ReadonlyArray<(
            { readonly __typename?: 'InvoiceDetails' }
            & B2BSalariesDetailsDrawerInvoiceDetailsFragment
          )>, readonly totalPayout?: (
            { readonly __typename?: 'NetGross' }
            & NetGrossFragment
          ) | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null, readonly salaryState:
            | (
              { readonly __typename?: 'IncompleteData' }
              & SalaryStateIncompleteDataFragment
            )
            | (
              { readonly __typename?: 'PaymentDisbursed' }
              & SalaryStatePaymentDisbursedFragment
            )
            | (
              { readonly __typename?: 'Ready' }
              & SalaryStateReadyFragment
            )
           }
        | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly entityVersion: number, readonly transferTitle: string, readonly absenceDays: number, readonly workTotalTime: number, readonly requiredWorkedTime: number, readonly transferAmount?: number | null, readonly isTimeReportCompleted: boolean, readonly isTimeReportApprovalRequired: boolean, readonly flag?: ContractSalaryDetailsFlagColor | null, readonly note?: string | null, readonly totalPayout?: (
            { readonly __typename?: 'NetGross' }
            & NetGrossFragment
          ) | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null, readonly salaryState:
            | (
              { readonly __typename?: 'IncompleteData' }
              & SalaryStateIncompleteDataFragment
            )
            | (
              { readonly __typename?: 'PaymentDisbursed' }
              & SalaryStatePaymentDisbursedFragment
            )
            | (
              { readonly __typename?: 'Ready' }
              & SalaryStateReadyFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly contractSalaryDetailsAdditionalData:
    | { readonly __typename?: 'ContractSalaryDetailsAdditionalData', readonly contractId: string, readonly yearMonth: Date, readonly timeReportValidations: ReadonlyArray<
        | (
          { readonly __typename?: 'IncompleteEntries' }
          & TimeReportValidationIncompleteEntriesFragment
        )
        | (
          { readonly __typename?: 'MissingEntries' }
          & TimeReportValidationMissingEntriesFragment
        )
        | (
          { readonly __typename?: 'NegativeFlexTimeBalance' }
          & TimeReportValidationNegativeFlexTimeBalanceFragment
        )
      >, readonly incomeDetails: (
        { readonly __typename?: 'IncomeDetails' }
        & B2BSalariesDetailsDrawerIncomeDetailsFragment
      ) }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type B2BSalariesDetailsDrawerRefetchSalaryStateQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
}>;


export type B2BSalariesDetailsDrawerRefetchSalaryStateQuery = { readonly __typename?: 'Query', readonly contractSalaryDetails:
    | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
        | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
            | (
              { readonly __typename?: 'IncompleteData' }
              & SalaryStateIncompleteDataFragment
            )
            | (
              { readonly __typename?: 'PaymentDisbursed' }
              & SalaryStatePaymentDisbursedFragment
            )
            | (
              { readonly __typename?: 'Ready' }
              & SalaryStateReadyFragment
            )
           }
        | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
            | (
              { readonly __typename?: 'IncompleteData' }
              & SalaryStateIncompleteDataFragment
            )
            | (
              { readonly __typename?: 'PaymentDisbursed' }
              & SalaryStatePaymentDisbursedFragment
            )
            | (
              { readonly __typename?: 'Ready' }
              & SalaryStateReadyFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type B2BSalariesDetailsDrawerUpdateTransferDeductionMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  transferDeduction: ClearableTransferDeductionInput;
}>;


export type B2BSalariesDetailsDrawerUpdateTransferDeductionMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly update:
      | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
          | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly transferAmount?: number | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null, readonly salaryState:
              | (
                { readonly __typename?: 'IncompleteData' }
                & SalaryStateIncompleteDataFragment
              )
              | (
                { readonly __typename?: 'PaymentDisbursed' }
                & SalaryStatePaymentDisbursedFragment
              )
              | (
                { readonly __typename?: 'Ready' }
                & SalaryStateReadyFragment
              )
             }
          | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly transferAmount?: number | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null, readonly salaryState:
              | (
                { readonly __typename?: 'IncompleteData' }
                & SalaryStateIncompleteDataFragment
              )
              | (
                { readonly __typename?: 'PaymentDisbursed' }
                & SalaryStatePaymentDisbursedFragment
              )
              | (
                { readonly __typename?: 'Ready' }
                & SalaryStateReadyFragment
              )
             }
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  adjustGrossValue: ClearableGrossAdjustmentInput;
}>;


export type B2BSalariesDetailsDrawerUpdateAdjustGrossValueMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly update:
      | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
          | { readonly __typename?: 'B2BContractSalaryDetails', readonly adjustGrossValue?: GrossAdjustment | null, readonly contractId: string, readonly yearMonth: Date, readonly entityVersion: number, readonly transferAmount?: number | null, readonly totalPayout?: (
              { readonly __typename?: 'NetGross' }
              & NetGrossFragment
            ) | null, readonly salaryState:
              | (
                { readonly __typename?: 'IncompleteData' }
                & SalaryStateIncompleteDataFragment
              )
              | (
                { readonly __typename?: 'PaymentDisbursed' }
                & SalaryStatePaymentDisbursedFragment
              )
              | (
                { readonly __typename?: 'Ready' }
                & SalaryStateReadyFragment
              )
             }
          | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly entityVersion: number, readonly transferAmount?: number | null, readonly totalPayout?: (
              { readonly __typename?: 'NetGross' }
              & NetGrossFragment
            ) | null, readonly salaryState:
              | (
                { readonly __typename?: 'IncompleteData' }
                & SalaryStateIncompleteDataFragment
              )
              | (
                { readonly __typename?: 'PaymentDisbursed' }
                & SalaryStatePaymentDisbursedFragment
              )
              | (
                { readonly __typename?: 'Ready' }
                & SalaryStateReadyFragment
              )
             }
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type B2BSalariesDetailsDrawerUpdateInvoiceMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  invoiceDetailsId: Scalars['InvoiceDetailsId']['input'];
  invoiceDetails: UpdateInvoiceDetailsInput;
}>;


export type B2BSalariesDetailsDrawerUpdateInvoiceMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly invoiceDetails: { readonly __typename?: 'InvoiceDetailsOperations', readonly update:
        | (
          { readonly __typename?: 'InvoiceDetails' }
          & InvoicesDrawerInvoiceDetailsFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type B2BSalariesDetailsDrawerCreateInvoiceMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  invoiceDetails: CreateInvoiceDetailsInput;
}>;


export type B2BSalariesDetailsDrawerCreateInvoiceMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly invoiceDetails: { readonly __typename?: 'InvoiceDetailsOperations', readonly create:
        | (
          { readonly __typename?: 'InvoiceDetails' }
          & InvoicesDrawerInvoiceDetailsFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type B2BSalariesDetailsDrawerRemoveInvoiceMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  invoiceDetailsId: Scalars['InvoiceDetailsId']['input'];
}>;


export type B2BSalariesDetailsDrawerRemoveInvoiceMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly invoiceDetails: { readonly __typename?: 'InvoiceDetailsOperations', readonly remove:
        | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  invoiceDetailsId: Scalars['InvoiceDetailsId']['input'];
  saldeoDocumentId: SaldeoDocumentIdInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type B2BSalariesDetailsDrawerCreateInvoiceFromSaldeoDocumentMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly invoiceDetails: { readonly __typename?: 'InvoiceDetailsOperations', readonly createFromSaldeoDocument:
        | (
          { readonly __typename?: 'InvoiceDetails' }
          & InvoicesDrawerInvoiceDetailsFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type B2BSalariesListItemSalaryStateChangeFragment = { readonly __typename?: 'ListOfContractSalaryDetailsResponse', readonly value: ReadonlyArray<
    | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
        | (
          { readonly __typename?: 'IncompleteData' }
          & SalaryStateIncompleteDataFragment
        )
        | (
          { readonly __typename?: 'PaymentDisbursed' }
          & SalaryStatePaymentDisbursedFragment
        )
        | (
          { readonly __typename?: 'Ready' }
          & SalaryStateReadyFragment
        )
       }
    | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
        | (
          { readonly __typename?: 'IncompleteData' }
          & SalaryStateIncompleteDataFragment
        )
        | (
          { readonly __typename?: 'PaymentDisbursed' }
          & SalaryStatePaymentDisbursedFragment
        )
        | (
          { readonly __typename?: 'Ready' }
          & SalaryStateReadyFragment
        )
       }
  > };

export type B2BSalariesListItemMarkAsDisbursedMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  filter: FilterContractSalaryDetailsInput;
}>;


export type B2BSalariesListItemMarkAsDisbursedMutation = { readonly __typename?: 'Mutation', readonly markPaymentAsDisbursed:
    | (
      { readonly __typename?: 'ListOfContractSalaryDetailsResponse' }
      & B2BSalariesListItemSalaryStateChangeFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type B2BSalariesListItemUnmarkAsDisbursedMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  filter: FilterContractSalaryDetailsInput;
}>;


export type B2BSalariesListItemUnmarkAsDisbursedMutation = { readonly __typename?: 'Mutation', readonly unmarkPaymentAsDisbursed:
    | (
      { readonly __typename?: 'ListOfContractSalaryDetailsResponse' }
      & B2BSalariesListItemSalaryStateChangeFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BankTransfersImportModalImportResultFragment = { readonly __typename?: 'ListOfBankTransferResponse', readonly value: ReadonlyArray<
    | { readonly __typename?: 'BankIncomeTransfer', readonly id: string, readonly amount: number, readonly operationDate: Date, readonly currency: string, readonly fromName: string, readonly toName: string, readonly title: string }
    | { readonly __typename?: 'BankOutcomeTransfer', readonly id: string, readonly amount: number, readonly operationDate: Date, readonly currency: string, readonly fromName: string, readonly toName: string, readonly title: string }
  > };

export type BankTransfersImportMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  operationCompanyName: Scalars['String']['input'];
  maybeRestrictedType?: InputMaybe<BankTransferType>;
}>;


export type BankTransfersImportMutation = { readonly __typename?: 'Mutation', readonly importTransfers_from_xml_camt053:
    | (
      { readonly __typename?: 'ListOfBankTransferResponse' }
      & BankTransfersImportModalImportResultFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BankTransfersImportOfxMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  operationCompanyName: Scalars['String']['input'];
  maybeRestrictedType?: InputMaybe<BankTransferType>;
}>;


export type BankTransfersImportOfxMutation = { readonly __typename?: 'Mutation', readonly importTransfers_from_xml_ofx:
    | (
      { readonly __typename?: 'ListOfBankTransferResponse' }
      & BankTransfersImportModalImportResultFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BankTransfersListFiltersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type BankTransfersListFiltersQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly cursor: string, readonly node: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BasicFinancialReportDrawerQueryVariables = Exact<{ [key: string]: never; }>;


export type BasicFinancialReportDrawerQuery = { readonly __typename?: 'Query', readonly basicFinancialReport:
    | { readonly __typename?: 'ListOfBfrFileUrlResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'BfrFileUrl', readonly fileDescription: string, readonly url: { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BasicFinancialReportDrawerRegenerateMutationVariables = Exact<{ [key: string]: never; }>;


export type BasicFinancialReportDrawerRegenerateMutation = { readonly __typename?: 'Mutation', readonly triggerBasicFinancialReportBackgroundRegeneration:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'UnitResponse' }
   };

export type BasicFinancialReportDrawerExportStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type BasicFinancialReportDrawerExportStatusSubscription = { readonly __typename?: 'BasicFinancialReportPartSubscriptions', readonly basicFinancialReportExportStatus?:
    | { readonly __typename: 'BfrExportCompleted', readonly finishedAt: Date }
    | { readonly __typename: 'BfrExportFailed', readonly failedAt: Date, readonly error:
        | { readonly __typename?: 'ActiveReportingRangeError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'AggregatedValidationErrors', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'DuplicatedEntityError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'EmptyRequestInputError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'EntitiesNotFoundError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'EntityNotFoundError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'EntityVersionMismatched', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'ForeignKeyConstraintError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'IllegalPositionRemovalError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'IncompleteArgumentError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'IncompleteArgumentsError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'InternalNfsError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'InvalidApiTokenError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'InvalidArgumentsError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'InvalidCompanyTypeError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'InvalidContentTypeError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'InvalidCursorError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'InvalidEmailAddress', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'InvalidStateError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'InvoiceAlreadyAcceptedError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'InvoiceImportedFromSaldeoError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'LeaveEntitlementExceededError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'MissingFileMetadataError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'NBPBaseCurrencyError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'NoParkingSpotAvailableError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'OperationAlreadyInProgressError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'OperationNotAvailableError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'OtherInvalidRequestError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'PaymentCouldNotBeChangedError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'PositionInactiveError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'RaiseNoLongerDueError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'ReservationNotPendingError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'ReservationRequestStateError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'ResourceAlreadyReservedError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'TimeBasedActivityOverlapError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'TimeBasedEffectiveFromInPastError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'TimeReportOverlapError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'TimeReportRecordApprovalNotInPendingStateError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'UnauthorizedOperationError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'UnknownContentTypeError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'UserFacingAuthzError', readonly msg: string, readonly nfsErrorId: string }
        | { readonly __typename?: 'ValidationError', readonly msg: string, readonly nfsErrorId: string }
       }
    | { readonly __typename: 'BfrExportIdle' }
    | { readonly __typename: 'BfrExportInterrupted', readonly interruptedAt: Date }
    | { readonly __typename: 'BfrExportRunning', readonly startedAt: Date, readonly phase: BfrExportPhase, readonly percentDone: number, readonly users?: { readonly __typename?: 'BfrExportUserProgress', readonly processed: number, readonly total: number } | null }
   | null };

export type BenefitInvoicesReportDrawerGenerateMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type BenefitInvoicesReportDrawerGenerateMutation = { readonly __typename?: 'Mutation', readonly generateBenefitInvoiceDocument:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BenefitInvoicesReportDrawerGoogleDocQueryVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type BenefitInvoicesReportDrawerGoogleDocQuery = { readonly __typename?: 'Query', readonly benefitInvoiceDocument:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BenefitNoteDrawerContractQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type BenefitNoteDrawerContractQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly note?: string | null }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly note?: string | null }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly note?: string | null }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BenefitNoteDrawerUpdateNoteMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  assignedVariant: Scalars['AssignedVariantId']['input'];
  note: Scalars['String']['input'];
}>;


export type BenefitNoteDrawerUpdateNoteMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateBenefitVariantNote:
      | { readonly __typename?: 'AssignedVariant', readonly id: string, readonly note?: string | null }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type BenefitsAssignmentsAssignedVariantFragment = { readonly __typename?: 'AssignedVariant', readonly id: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly value: boolean }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly value: boolean }> }, readonly buyerType: { readonly __typename?: 'TimeBasedBenefitBuyerType', readonly value: BenefitBuyerType }, readonly variant: { readonly __typename?: 'TimeBasedBenefitVariant', readonly value: { readonly __typename?: 'BenefitVariant', readonly id: string, readonly productId: string, readonly productName: string, readonly parent:
        | { readonly __typename?: 'Benefit', readonly id: string, readonly name: string }
        | { readonly __typename?: 'SubBenefit', readonly id: string, readonly name: string }
       } }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null }, readonly contract:
    | { readonly __typename?: 'B2BContract', readonly id: string, readonly name: string }
    | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly name: string }
    | { readonly __typename?: 'Subcontract', readonly id: string, readonly name: string }
   };

export type BenefitsAssignmentsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterAssignedVariantInput>;
  sort?: InputMaybe<SortingRequestSortAssignedVariantInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BenefitsAssignmentsQuery = { readonly __typename?: 'Query', readonly assignedVariants:
    | { readonly __typename?: 'FSPResponseAssignedVariant', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeAssignedVariant', readonly cursor: string, readonly node: (
          { readonly __typename?: 'AssignedVariant' }
          & BenefitsAssignmentsAssignedVariantFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BenefitsProductsVariantFragment = { readonly __typename?: 'BenefitVariant', readonly id: string, readonly entityVersion: number, readonly productId: string, readonly productName: string, readonly contractTypes: ReadonlyArray<ContractType>, readonly buyerType: BenefitBuyerType, readonly startDate: Date, readonly endDate?: Date | null, readonly description?: string | null, readonly meansOfProduction: boolean, readonly invoiceCategory: BenefitInvoiceCategory, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly additionalPeople?:
    | (
      { readonly __typename?: 'BenefitAdditionalAdults' }
      & BenefitAdditionalPeopleBenefitAdditionalAdultsFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalFamily' }
      & BenefitAdditionalPeopleBenefitAdditionalFamilyFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalKids' }
      & BenefitAdditionalPeopleBenefitAdditionalKidsFragment
    )
   | null };

export type BenefitsProductsBenefitCommonBenefitFragment = { readonly __typename?: 'Benefit', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly endDate?: Date | null, readonly variants: ReadonlyArray<(
    { readonly __typename?: 'BenefitVariant' }
    & BenefitsProductsVariantFragment
  )> };

export type BenefitsProductsBenefitCommonSubBenefitFragment = { readonly __typename?: 'SubBenefit', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly endDate?: Date | null, readonly variants: ReadonlyArray<(
    { readonly __typename?: 'BenefitVariant' }
    & BenefitsProductsVariantFragment
  )> };

export type BenefitsProductsBenefitCommonFragment =
  | BenefitsProductsBenefitCommonBenefitFragment
  | BenefitsProductsBenefitCommonSubBenefitFragment
;

export type BenefitsProductsQueryVariables = Exact<{
  filter?: InputMaybe<BenefitVariantFilterInput>;
}>;


export type BenefitsProductsQuery = { readonly __typename?: 'Query', readonly benefits:
    | { readonly __typename?: 'ListOfBenefitGroupResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'BenefitGroup', readonly groupType: BenefitGroupType, readonly benefits: { readonly __typename?: 'ConjunctiveBenefits', readonly manyOf: ReadonlyArray<{ readonly __typename?: 'AlternativeBenefits', readonly alternativeBenefitsGroupId: string, readonly oneOf: ReadonlyArray<(
              { readonly __typename?: 'Benefit' }
              & BenefitsProductsBenefitCommonBenefitFragment
            )> }> } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BlockOfficeModalOfficeSettingsFragment = { readonly __typename?: 'OfficeSettings', readonly office: { readonly __typename?: 'Office', readonly officeId: string, readonly blocked: boolean, readonly entityVersion: number } };

export type BlockOfficeModalBlockMutationVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type BlockOfficeModalBlockMutation = { readonly __typename?: 'Mutation', readonly blockOffice:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'OfficeSettings' }
      & BlockOfficeModalOfficeSettingsFragment
    )
   };

export type BlockOfficeModalUnblockMutationVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type BlockOfficeModalUnblockMutation = { readonly __typename?: 'Mutation', readonly unblockOffice:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'OfficeSettings' }
      & BlockOfficeModalOfficeSettingsFragment
    )
   };

export type BonusDrawerBonusAppreciationBonusFragment = { readonly __typename?: 'AppreciationBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusBusinessTravelBonusFragment = { readonly __typename?: 'BusinessTravelBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusClientReferralBonusFragment = { readonly __typename?: 'ClientReferralBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusConferenceBonusFragment = { readonly __typename?: 'ConferenceBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusCostRechargeBonusFragment = { readonly __typename?: 'CostRechargeBonus', readonly description: string, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusEmployeeReferralBonusFragment = { readonly __typename?: 'EmployeeReferralBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly referredEmployeeContract:
    | { readonly __typename?: 'B2BContract', readonly id: string, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly contracts:
          | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
              | { readonly __typename?: 'B2BContract', readonly id: string }
              | { readonly __typename?: 'EmploymentContract', readonly id: string }
              | { readonly __typename?: 'Subcontract', readonly id: string }
            > }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
    | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly contracts:
          | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
              | { readonly __typename?: 'B2BContract', readonly id: string }
              | { readonly __typename?: 'EmploymentContract', readonly id: string }
              | { readonly __typename?: 'Subcontract', readonly id: string }
            > }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
    | { readonly __typename?: 'Subcontract', readonly id: string, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly contracts:
          | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
              | { readonly __typename?: 'B2BContract', readonly id: string }
              | { readonly __typename?: 'EmploymentContract', readonly id: string }
              | { readonly __typename?: 'Subcontract', readonly id: string }
            > }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
  , readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusLanguageLearningBonusFragment = { readonly __typename?: 'LanguageLearningBonus', readonly language: Language, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly quarterYear: { readonly __typename?: 'QuarterYear', readonly quarter: Quarter, readonly year: number }, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusOtherBonusFragment = { readonly __typename?: 'OtherBonus', readonly description: string, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusRemoteWorkEquipmentBonusFragment = { readonly __typename?: 'RemoteWorkEquipmentBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusSalesCommissionsBonusFragment = { readonly __typename?: 'SalesCommissionsBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusSeverancePayBonusFragment = { readonly __typename?: 'SeverancePayBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusShareholderDividendBonusFragment = { readonly __typename?: 'ShareholderDividendBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusTrainingPackageBonusFragment = { readonly __typename?: 'TrainingPackageBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusTrainingPackageExternalDeductionValueFragment = { readonly __typename?: 'TrainingPackageExternalDeductionValue', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusDrawerBonusFragment =
  | BonusDrawerBonusAppreciationBonusFragment
  | BonusDrawerBonusBusinessTravelBonusFragment
  | BonusDrawerBonusClientReferralBonusFragment
  | BonusDrawerBonusConferenceBonusFragment
  | BonusDrawerBonusCostRechargeBonusFragment
  | BonusDrawerBonusEmployeeReferralBonusFragment
  | BonusDrawerBonusLanguageLearningBonusFragment
  | BonusDrawerBonusOtherBonusFragment
  | BonusDrawerBonusRemoteWorkEquipmentBonusFragment
  | BonusDrawerBonusSalesCommissionsBonusFragment
  | BonusDrawerBonusSeverancePayBonusFragment
  | BonusDrawerBonusShareholderDividendBonusFragment
  | BonusDrawerBonusTrainingPackageBonusFragment
  | BonusDrawerBonusTrainingPackageExternalDeductionValueFragment
;

export type BonusDrawerCurrencyFragment = { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly value: string, readonly applyDate: Date, readonly activityId: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly value: string, readonly applyDate: Date, readonly activityId: string }> };

export type BonusDrawerInputQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  userId: Scalars['UserId']['input'];
}>;


export type BonusDrawerInputQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly assignedProjects:
          | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string } }> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
  , readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly enableTrainingPackage:
            | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly vat:
            | { readonly __typename?: 'AccessGranted__TimeBasedVatType', readonly value: { readonly __typename?: 'TimeBasedVatType', readonly value:
                  | (
                    { readonly __typename?: 'VatApplied' }
                    & VatTypeVatAppliedFragment
                  )
                  | (
                    { readonly __typename?: 'VatNotApplied' }
                    & VatTypeVatNotAppliedFragment
                  )
                 } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly currency:
            | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
                { readonly __typename?: 'TimeBasedCurrency' }
                & BonusDrawerCurrencyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly rate:
            | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: { readonly __typename?: 'TimeBasedRate', readonly value: (
                  { readonly __typename?: 'Rate' }
                  & RateFragment
                ) } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly enableTrainingPackage:
            | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly currency:
            | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
                { readonly __typename?: 'TimeBasedCurrency' }
                & BonusDrawerCurrencyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly rate:
            | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: { readonly __typename?: 'TimeBasedRate', readonly value: (
                  { readonly __typename?: 'Rate' }
                  & RateFragment
                ) } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BonusDrawerManageBonusMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  input: BonusInput;
}>;


export type BonusDrawerManageBonusMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly upsertBonus:
      | { readonly __typename?: 'BonusResponse', readonly value:
          | (
            { readonly __typename?: 'AppreciationBonus' }
            & BonusDrawerBonusAppreciationBonusFragment
          )
          | (
            { readonly __typename?: 'BusinessTravelBonus' }
            & BonusDrawerBonusBusinessTravelBonusFragment
          )
          | (
            { readonly __typename?: 'ClientReferralBonus' }
            & BonusDrawerBonusClientReferralBonusFragment
          )
          | (
            { readonly __typename?: 'ConferenceBonus' }
            & BonusDrawerBonusConferenceBonusFragment
          )
          | (
            { readonly __typename?: 'CostRechargeBonus' }
            & BonusDrawerBonusCostRechargeBonusFragment
          )
          | (
            { readonly __typename?: 'EmployeeReferralBonus' }
            & BonusDrawerBonusEmployeeReferralBonusFragment
          )
          | (
            { readonly __typename?: 'LanguageLearningBonus' }
            & BonusDrawerBonusLanguageLearningBonusFragment
          )
          | (
            { readonly __typename?: 'OtherBonus' }
            & BonusDrawerBonusOtherBonusFragment
          )
          | (
            { readonly __typename?: 'RemoteWorkEquipmentBonus' }
            & BonusDrawerBonusRemoteWorkEquipmentBonusFragment
          )
          | (
            { readonly __typename?: 'SalesCommissionsBonus' }
            & BonusDrawerBonusSalesCommissionsBonusFragment
          )
          | (
            { readonly __typename?: 'SeverancePayBonus' }
            & BonusDrawerBonusSeverancePayBonusFragment
          )
          | (
            { readonly __typename?: 'ShareholderDividendBonus' }
            & BonusDrawerBonusShareholderDividendBonusFragment
          )
          | (
            { readonly __typename?: 'TrainingPackageBonus' }
            & BonusDrawerBonusTrainingPackageBonusFragment
          )
          | (
            { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
            & BonusDrawerBonusTrainingPackageExternalDeductionValueFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type BonusDrawerRejectMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  id: Scalars['BonusId']['input'];
}>;


export type BonusDrawerRejectMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly bonus: { readonly __typename?: 'BonusMutation', readonly reject:
        | { readonly __typename?: 'BonusResponse', readonly value:
            | (
              { readonly __typename?: 'AppreciationBonus' }
              & AdditionalCostDrawerBonusAppreciationBonusFragment
            )
            | (
              { readonly __typename?: 'BusinessTravelBonus' }
              & AdditionalCostDrawerBonusBusinessTravelBonusFragment
            )
            | (
              { readonly __typename?: 'ClientReferralBonus' }
              & AdditionalCostDrawerBonusClientReferralBonusFragment
            )
            | (
              { readonly __typename?: 'ConferenceBonus' }
              & AdditionalCostDrawerBonusConferenceBonusFragment
            )
            | (
              { readonly __typename?: 'CostRechargeBonus' }
              & AdditionalCostDrawerBonusCostRechargeBonusFragment
            )
            | (
              { readonly __typename?: 'EmployeeReferralBonus' }
              & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
            )
            | (
              { readonly __typename?: 'LanguageLearningBonus' }
              & AdditionalCostDrawerBonusLanguageLearningBonusFragment
            )
            | (
              { readonly __typename?: 'OtherBonus' }
              & AdditionalCostDrawerBonusOtherBonusFragment
            )
            | (
              { readonly __typename?: 'RemoteWorkEquipmentBonus' }
              & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
            )
            | (
              { readonly __typename?: 'SalesCommissionsBonus' }
              & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
            )
            | (
              { readonly __typename?: 'SeverancePayBonus' }
              & AdditionalCostDrawerBonusSeverancePayBonusFragment
            )
            | (
              { readonly __typename?: 'ShareholderDividendBonus' }
              & AdditionalCostDrawerBonusShareholderDividendBonusFragment
            )
            | (
              { readonly __typename?: 'TrainingPackageBonus' }
              & AdditionalCostDrawerBonusTrainingPackageBonusFragment
            )
            | (
              { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
              & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
            )
           }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type BonusDrawerApproveMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  id: Scalars['BonusId']['input'];
}>;


export type BonusDrawerApproveMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly bonus: { readonly __typename?: 'BonusMutation', readonly approve:
        | { readonly __typename?: 'BonusResponse', readonly value:
            | (
              { readonly __typename?: 'AppreciationBonus' }
              & AdditionalCostDrawerBonusAppreciationBonusFragment
            )
            | (
              { readonly __typename?: 'BusinessTravelBonus' }
              & AdditionalCostDrawerBonusBusinessTravelBonusFragment
            )
            | (
              { readonly __typename?: 'ClientReferralBonus' }
              & AdditionalCostDrawerBonusClientReferralBonusFragment
            )
            | (
              { readonly __typename?: 'ConferenceBonus' }
              & AdditionalCostDrawerBonusConferenceBonusFragment
            )
            | (
              { readonly __typename?: 'CostRechargeBonus' }
              & AdditionalCostDrawerBonusCostRechargeBonusFragment
            )
            | (
              { readonly __typename?: 'EmployeeReferralBonus' }
              & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
            )
            | (
              { readonly __typename?: 'LanguageLearningBonus' }
              & AdditionalCostDrawerBonusLanguageLearningBonusFragment
            )
            | (
              { readonly __typename?: 'OtherBonus' }
              & AdditionalCostDrawerBonusOtherBonusFragment
            )
            | (
              { readonly __typename?: 'RemoteWorkEquipmentBonus' }
              & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
            )
            | (
              { readonly __typename?: 'SalesCommissionsBonus' }
              & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
            )
            | (
              { readonly __typename?: 'SeverancePayBonus' }
              & AdditionalCostDrawerBonusSeverancePayBonusFragment
            )
            | (
              { readonly __typename?: 'ShareholderDividendBonus' }
              & AdditionalCostDrawerBonusShareholderDividendBonusFragment
            )
            | (
              { readonly __typename?: 'TrainingPackageBonus' }
              & AdditionalCostDrawerBonusTrainingPackageBonusFragment
            )
            | (
              { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
              & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
            )
           }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type BonusFormReferredUserInfoQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type BonusFormReferredUserInfoQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly status: ContractStatus }
            | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly status: ContractStatus }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly status: ContractStatus }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type BonusFormUserAutocompleteQueryVariables = Exact<{
  filter: FilterUserInput;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type BonusFormUserAutocompleteQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: (
          { readonly __typename?: 'User', readonly avatar?: string | null, readonly email: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly contracts:
            | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
                | { readonly __typename?: 'B2BContract', readonly id: string }
                | { readonly __typename?: 'EmploymentContract', readonly id: string }
                | { readonly __typename?: 'Subcontract', readonly id: string }
              > }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
          & UserAutocompleteUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BonusFormTrainingPackageBudgetQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  year: Scalars['Year']['input'];
}>;


export type BonusFormTrainingPackageBudgetQuery = { readonly __typename?: 'Query', readonly trainingBudgetSummary:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TrainingBudgetSummary', readonly yearlySummary: ReadonlyArray<{ readonly __typename?: 'KVYearTrainingBudgetYearSummary', readonly key: number, readonly value: { readonly __typename?: 'TrainingBudgetYearSummary', readonly year: number, readonly totalBalance: (
            { readonly __typename?: 'CentsBalance' }
            & CentsBalanceFragment
          ) } }> }
   };

export type BonusPreviewCurrencyFragment = { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly value: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly value: string }> };

export type BonusPreviewBonusAppreciationBonusFragment = { readonly __typename?: 'AppreciationBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusBusinessTravelBonusFragment = { readonly __typename?: 'BusinessTravelBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusClientReferralBonusFragment = { readonly __typename?: 'ClientReferralBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusConferenceBonusFragment = { readonly __typename?: 'ConferenceBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusCostRechargeBonusFragment = { readonly __typename?: 'CostRechargeBonus', readonly description: string, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusEmployeeReferralBonusFragment = { readonly __typename?: 'EmployeeReferralBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly referredEmployeeContract:
    | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly status: ContractStatus, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly contracts:
          | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
              | { readonly __typename?: 'B2BContract', readonly id: string }
              | { readonly __typename?: 'EmploymentContract', readonly id: string }
              | { readonly __typename?: 'Subcontract', readonly id: string }
            > }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
    | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly status: ContractStatus, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly contracts:
          | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
              | { readonly __typename?: 'B2BContract', readonly id: string }
              | { readonly __typename?: 'EmploymentContract', readonly id: string }
              | { readonly __typename?: 'Subcontract', readonly id: string }
            > }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
    | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly status: ContractStatus, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly contracts:
          | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
              | { readonly __typename?: 'B2BContract', readonly id: string }
              | { readonly __typename?: 'EmploymentContract', readonly id: string }
              | { readonly __typename?: 'Subcontract', readonly id: string }
            > }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
  , readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusLanguageLearningBonusFragment = { readonly __typename?: 'LanguageLearningBonus', readonly language: Language, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly quarterYear: { readonly __typename?: 'QuarterYear', readonly quarter: Quarter }, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusOtherBonusFragment = { readonly __typename?: 'OtherBonus', readonly description: string, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusRemoteWorkEquipmentBonusFragment = { readonly __typename?: 'RemoteWorkEquipmentBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusSalesCommissionsBonusFragment = { readonly __typename?: 'SalesCommissionsBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusSeverancePayBonusFragment = { readonly __typename?: 'SeverancePayBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusShareholderDividendBonusFragment = { readonly __typename?: 'ShareholderDividendBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusTrainingPackageBonusFragment = { readonly __typename?: 'TrainingPackageBonus', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusTrainingPackageExternalDeductionValueFragment = { readonly __typename?: 'TrainingPackageExternalDeductionValue', readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly taxation?: { readonly __typename?: 'Taxation', readonly taxApplicable: boolean, readonly zusApplicable: boolean } | null };

export type BonusPreviewBonusFragment =
  | BonusPreviewBonusAppreciationBonusFragment
  | BonusPreviewBonusBusinessTravelBonusFragment
  | BonusPreviewBonusClientReferralBonusFragment
  | BonusPreviewBonusConferenceBonusFragment
  | BonusPreviewBonusCostRechargeBonusFragment
  | BonusPreviewBonusEmployeeReferralBonusFragment
  | BonusPreviewBonusLanguageLearningBonusFragment
  | BonusPreviewBonusOtherBonusFragment
  | BonusPreviewBonusRemoteWorkEquipmentBonusFragment
  | BonusPreviewBonusSalesCommissionsBonusFragment
  | BonusPreviewBonusSeverancePayBonusFragment
  | BonusPreviewBonusShareholderDividendBonusFragment
  | BonusPreviewBonusTrainingPackageBonusFragment
  | BonusPreviewBonusTrainingPackageExternalDeductionValueFragment
;

export type BonusPreviewInitialDataQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type BonusPreviewInitialDataQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly status: ContractStatus, readonly startDate: Date, readonly vat:
            | { readonly __typename?: 'AccessGranted__TimeBasedVatType', readonly value: { readonly __typename?: 'TimeBasedVatType', readonly value:
                  | (
                    { readonly __typename?: 'VatApplied' }
                    & VatTypeVatAppliedFragment
                  )
                  | (
                    { readonly __typename?: 'VatNotApplied' }
                    & VatTypeVatNotAppliedFragment
                  )
                 } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly currency:
            | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
                { readonly __typename?: 'TimeBasedCurrency' }
                & BonusPreviewCurrencyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusPreviewBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusPreviewBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusPreviewBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusPreviewBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusPreviewBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusPreviewBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusPreviewBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusPreviewBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusPreviewBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusPreviewBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusPreviewBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusPreviewBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusPreviewBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusPreviewBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusPreviewBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusPreviewBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusPreviewBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusPreviewBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusPreviewBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusPreviewBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusPreviewBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusPreviewBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusPreviewBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusPreviewBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusPreviewBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusPreviewBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusPreviewBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusPreviewBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly status: ContractStatus, readonly startDate: Date, readonly currency:
            | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
                { readonly __typename?: 'TimeBasedCurrency' }
                & BonusPreviewCurrencyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusPreviewBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusPreviewBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusPreviewBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusPreviewBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusPreviewBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusPreviewBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusPreviewBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusPreviewBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusPreviewBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusPreviewBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusPreviewBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusPreviewBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusPreviewBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusPreviewBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusPreviewBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusPreviewBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusPreviewBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusPreviewBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusPreviewBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusPreviewBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusPreviewBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusPreviewBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusPreviewBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusPreviewBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusPreviewBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusPreviewBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusPreviewBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusPreviewBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly status: ContractStatus, readonly startDate: Date, readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusPreviewBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusPreviewBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusPreviewBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusPreviewBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusPreviewBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusPreviewBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusPreviewBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusPreviewBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusPreviewBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusPreviewBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusPreviewBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusPreviewBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusPreviewBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusPreviewBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & BonusPreviewBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & BonusPreviewBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & BonusPreviewBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & BonusPreviewBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & BonusPreviewBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & BonusPreviewBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & BonusPreviewBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & BonusPreviewBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & BonusPreviewBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & BonusPreviewBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & BonusPreviewBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & BonusPreviewBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & BonusPreviewBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & BonusPreviewBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BookDeskOnBehalfDrawerInputQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  range: ClosedEndLocalDateRangeInput;
}>;


export type BookDeskOnBehalfDrawerInputQuery = { readonly __typename?: 'Query', readonly office:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null }
  , readonly officeCatalogue:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeCatalogue', readonly rooms: ReadonlyArray<{ readonly __typename?: 'Room', readonly id: string, readonly name: string, readonly blocked: boolean, readonly desks: ReadonlyArray<{ readonly __typename?: 'Desk', readonly id: string, readonly name: string, readonly monitors: number, readonly standing: boolean, readonly blocked: boolean }> }> }
  , readonly officeAvailability:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeAvailability', readonly desks: ReadonlyArray<{ readonly __typename?: 'ResourceAvailability', readonly resourceId: string, readonly takenDates: ReadonlyArray<Date> }> }
   };

export type BookDeskOnBehalfDrawerReserveMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  input: ReserveDesksInput;
}>;


export type BookDeskOnBehalfDrawerReserveMutation = { readonly __typename?: 'Mutation', readonly reserveDesksOnBehalf:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'ReservationRequest', readonly requestId: string }
   };

export type BookDeskOnBehalfFormUserAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter: FilterUserInput;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  first: Scalars['Int']['input'];
}>;


export type BookDeskOnBehalfFormUserAutocompleteQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: (
          { readonly __typename?: 'User', readonly avatar?: string | null }
          & UserAutocompleteUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BookParkingOnBehalfDrawerInputQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  range: ClosedEndLocalDateRangeInput;
}>;


export type BookParkingOnBehalfDrawerInputQuery = { readonly __typename?: 'Query', readonly office:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null }
  , readonly officeSettings:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeSettings', readonly parkingInformation?: string | null, readonly office: { readonly __typename?: 'Office', readonly officeId: string } }
  , readonly officeCatalogue:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeCatalogue', readonly parkingSpots: ReadonlyArray<{ readonly __typename?: 'ParkingSpot', readonly id: string, readonly number: string, readonly name: string, readonly guest: boolean, readonly blocked: boolean }> }
  , readonly officeAvailability:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeAvailability', readonly parkingSpots: ReadonlyArray<{ readonly __typename?: 'ResourceAvailability', readonly resourceId: string, readonly takenDates: ReadonlyArray<Date> }> }
   };

export type BookParkingOnBehalfDrawerReserveMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  input: ReserveParkingInput;
}>;


export type BookParkingOnBehalfDrawerReserveMutation = { readonly __typename?: 'Mutation', readonly reserveParkingOnBehalf:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'ReservationRequest', readonly requestId: string }
   };

export type BookParkingOnBehalfFormUserAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter: FilterUserInput;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  first: Scalars['Int']['input'];
}>;


export type BookParkingOnBehalfFormUserAutocompleteQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: (
          { readonly __typename?: 'User', readonly avatar?: string | null, readonly plateNumber:
            | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
          & UserAutocompleteUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CancelOfficeBookingModalCancelMutationVariables = Exact<{
  requestId: Scalars['ReservationRequestId']['input'];
}>;


export type CancelOfficeBookingModalCancelMutation = { readonly __typename?: 'Mutation', readonly cancelOfficeReservation:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'ReservationRequest', readonly requestId: string }
   };

export type CatalogueActionModalBlockRoomMutationVariables = Exact<{
  roomId: Scalars['RoomId']['input'];
}>;


export type CatalogueActionModalBlockRoomMutation = { readonly __typename?: 'Mutation', readonly blockRoom:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Room', readonly id: string, readonly blocked: boolean }
   };

export type CatalogueActionModalUnblockRoomMutationVariables = Exact<{
  roomId: Scalars['RoomId']['input'];
}>;


export type CatalogueActionModalUnblockRoomMutation = { readonly __typename?: 'Mutation', readonly unblockRoom:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Room', readonly id: string, readonly blocked: boolean }
   };

export type CatalogueActionModalDeleteRoomMutationVariables = Exact<{
  roomId: Scalars['RoomId']['input'];
}>;


export type CatalogueActionModalDeleteRoomMutation = { readonly __typename?: 'Mutation', readonly deleteRoom:
    | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CatalogueActionModalBlockDeskMutationVariables = Exact<{
  deskId: Scalars['DeskId']['input'];
}>;


export type CatalogueActionModalBlockDeskMutation = { readonly __typename?: 'Mutation', readonly blockDesk:
    | { readonly __typename?: 'Desk', readonly id: string, readonly blocked: boolean }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CatalogueActionModalUnblockDeskMutationVariables = Exact<{
  deskId: Scalars['DeskId']['input'];
}>;


export type CatalogueActionModalUnblockDeskMutation = { readonly __typename?: 'Mutation', readonly unblockDesk:
    | { readonly __typename?: 'Desk', readonly id: string, readonly blocked: boolean }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CatalogueActionModalDeleteDeskMutationVariables = Exact<{
  deskId: Scalars['DeskId']['input'];
}>;


export type CatalogueActionModalDeleteDeskMutation = { readonly __typename?: 'Mutation', readonly deleteDesk:
    | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CatalogueActionModalBlockParkingSpotMutationVariables = Exact<{
  parkingSpotId: Scalars['ParkingSpotId']['input'];
}>;


export type CatalogueActionModalBlockParkingSpotMutation = { readonly __typename?: 'Mutation', readonly blockParkingSpot:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'ParkingSpot', readonly id: string, readonly blocked: boolean }
   };

export type CatalogueActionModalUnblockParkingSpotMutationVariables = Exact<{
  parkingSpotId: Scalars['ParkingSpotId']['input'];
}>;


export type CatalogueActionModalUnblockParkingSpotMutation = { readonly __typename?: 'Mutation', readonly unblockParkingSpot:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'ParkingSpot', readonly id: string, readonly blocked: boolean }
   };

export type CatalogueActionModalDeleteParkingSpotMutationVariables = Exact<{
  parkingSpotId: Scalars['ParkingSpotId']['input'];
}>;


export type CatalogueActionModalDeleteParkingSpotMutation = { readonly __typename?: 'Mutation', readonly deleteParkingSpot:
    | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ClientContractDetailsFutureUpdatesFragment = { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly positions:
    | { readonly __typename?: 'AccessGranted__ListOfClientPosition', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly createdAt: Date, readonly serviceLine: { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }> }, readonly assignments: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly clientPosition:
              | { readonly __typename?: 'AccessGranted__ClientPosition', readonly value: { readonly __typename?: 'ClientPosition', readonly id: string } }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly subcontractPosition:
              | { readonly __typename?: 'AccessGranted__OptionalClientPosition', readonly value?: { readonly __typename?: 'ClientPosition', readonly id: string } | null }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
             }> }>, readonly rateNet: { readonly __typename?: 'TimeBasedDailyAndHourlyRateNet', readonly value: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number }, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantDailyAndHourlyRateNet', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantDailyAndHourlyRateNet', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number } }> }, readonly overtimeNet: { readonly __typename?: 'TimeBasedOptClearableDailyAndHourlyRateNet', readonly value?: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number } | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDailyAndHourlyRateNet', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableDailyAndHourlyRateNet', readonly value?: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number } | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDailyAndHourlyRateNet', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableDailyAndHourlyRateNet', readonly value?: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number } | null } }> }, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly activityId: string, readonly value: boolean }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly activityId: string, readonly value: boolean }> }, readonly currency: { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly value: string, readonly applyDate: Date, readonly activityId: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly value: string, readonly applyDate: Date, readonly activityId: string }> }, readonly onCallRates: { readonly __typename?: 'TimeBasedOptClearableNetOnCallRate', readonly value?: { readonly __typename?: 'NetOnCallRate', readonly night: number, readonly weekend: number, readonly holiday: number } | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetOnCallRate', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableNetOnCallRate', readonly value?: { readonly __typename?: 'NetOnCallRate', readonly night: number, readonly weekend: number, readonly holiday: number } | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetOnCallRate', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableNetOnCallRate', readonly value?: { readonly __typename?: 'NetOnCallRate', readonly night: number, readonly weekend: number, readonly holiday: number } | null } }> } }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly vat:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint', readonly value: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptCurrency', readonly value: { readonly __typename?: 'TimeBasedOptCurrency', readonly value?: string | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly value: string, readonly applyDate: Date, readonly activityId: string }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ClientContractDetailsQueryVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
}>;


export type ClientContractDetailsQuery = { readonly __typename?: 'Query', readonly clientContract:
    | (
      { readonly __typename?: 'ClientContract', readonly contractDurationFrom:
        | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null, readonly taxNumber?: string | null, readonly address?: (
          { readonly __typename?: 'Address' }
          & AddressFragment
        ) | null, readonly mailingAddress?: (
          { readonly __typename?: 'Address' }
          & AddressFragment
        ) | null }, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null, readonly taxNumber?: string | null, readonly companyType: ReadonlyArray<CompanyType>, readonly sectors:
          | { readonly __typename?: 'AccessGranted__ListOfString', readonly value: ReadonlyArray<string> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly isPolishVat: { readonly __typename?: 'TimeBasedValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: { readonly __typename?: 'ValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: boolean } }, readonly euVatType: { readonly __typename?: 'TimeBasedValueWithVerificationEuVatType', readonly value: { readonly __typename?: 'ValueWithVerificationEuVatType', readonly value: EuVatType } }, readonly address?: (
          { readonly __typename?: 'Address' }
          & AddressFragment
        ) | null, readonly mailingAddress?: (
          { readonly __typename?: 'Address' }
          & AddressFragment
        ) | null } | null }
      & ClientContractDetailsFutureUpdatesFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ClientContractDetailsCancelActivitiesMutationVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  date: Scalars['LocalDate']['input'];
}>;


export type ClientContractDetailsCancelActivitiesMutation = { readonly __typename?: 'Mutation', readonly clientContract: { readonly __typename?: 'ClientContractMutation', readonly cancelActivities:
      | (
        { readonly __typename?: 'ClientContract' }
        & ClientContractDetailsFutureUpdatesFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ClientContractsListFiltersClientsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type ClientContractsListFiltersClientsQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly cursor: string, readonly node: { readonly __typename?: 'Company', readonly entityVersion: number, readonly id: string, readonly name: string, readonly logo?: string | null } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ClientContractsListFiltersSuppliersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type ClientContractsListFiltersSuppliersQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly cursor: string, readonly node: { readonly __typename?: 'Company', readonly entityVersion: number, readonly id: string, readonly name: string, readonly logo?: string | null } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ClientInvoicingReportDrawerGenerateMutationVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
  period: ClosedEndLocalDateRangeInput;
}>;


export type ClientInvoicingReportDrawerGenerateMutation = { readonly __typename?: 'Mutation', readonly generateExportForInvoicingClients:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ClientInvoicingReportDrawerGoogleDocQueryVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
  period: ClosedEndLocalDateRangeInput;
}>;


export type ClientInvoicingReportDrawerGoogleDocQuery = { readonly __typename?: 'Query', readonly exportForInvoicingClients:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ClientInvoicingReportFormReportingPeriodsQueryVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
}>;


export type ClientInvoicingReportFormReportingPeriodsQuery = { readonly __typename?: 'Query', readonly reportingPeriods:
    | { readonly __typename?: 'ListOfReportingPeriodResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ReportingPeriod', readonly id: string, readonly from: Date, readonly to: Date }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CompanyBankAccountsDataQueryVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
}>;


export type CompanyBankAccountsDataQuery = { readonly __typename?: 'Query', readonly company:
    | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly companyType: ReadonlyArray<CompanyType>, readonly countryOfRegistration: string, readonly bankAccounts: ReadonlyArray<(
        { readonly __typename?: 'BankAccount' }
        & BankAccountFragment
      )>, readonly defaultBankAccount?: (
        { readonly __typename?: 'BankAccount' }
        & BankAccountFragment
      ) | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CompanyDetailsDrawerVatsFragment = { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly isPolishVat: { readonly __typename?: 'TimeBasedValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: { readonly __typename?: 'ValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: boolean, readonly state:
        | { readonly __typename?: 'NotVerifiedBooleanVATStatus' }
        | { readonly __typename?: 'VerifiedWithDescriptionBooleanVATStatus', readonly result: boolean, readonly when: Date }
       } }, readonly euVatType: { readonly __typename?: 'TimeBasedValueWithVerificationEuVatType', readonly value: { readonly __typename?: 'ValueWithVerificationEuVatType', readonly value: EuVatType, readonly state:
        | { readonly __typename?: 'NotVerifiedEuVatType' }
        | { readonly __typename?: 'VerifiedEuVatType', readonly result: EuVatType, readonly when: Date }
       } }, readonly isOtherVatType: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean } };

export type CompanyDetailsDrawerInitialDataQueryVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
}>;


export type CompanyDetailsDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly company:
    | (
      { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly companyType: ReadonlyArray<CompanyType>, readonly countryOfRegistration: string, readonly taxNumber?: string | null, readonly name: string, readonly regon?: string | null, readonly registerId?: string | null, readonly logo?: string | null, readonly sectors:
        | { readonly __typename?: 'AccessGranted__ListOfString', readonly value: ReadonlyArray<string> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly address?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null, readonly mailingAddress?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null }
      & CompanyDetailsDrawerVatsFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CompanyDetailsDrawerUploadLogoMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  file: Scalars['Upload']['input'];
}>;


export type CompanyDetailsDrawerUploadLogoMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly uploadLogo:
      | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly logo?: string | null }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type CompanyDetailsDrawerDeleteLogoMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type CompanyDetailsDrawerDeleteLogoMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly deleteLogo:
      | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly logo?: string | null }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type CompanyDetailsDrawerRegisterDetailsMutationVariables = Exact<{
  id: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  countryOfRegistration?: InputMaybe<Scalars['CountryCode']['input']>;
  address?: InputMaybe<ClearableAddressInput>;
  mailingAddress?: InputMaybe<ClearableAddressInput>;
}>;


export type CompanyDetailsDrawerRegisterDetailsMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly updateCompany:
      | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly countryOfRegistration: string, readonly address?: (
          { readonly __typename?: 'Address' }
          & AddressFragment
        ) | null, readonly mailingAddress?: (
          { readonly __typename?: 'Address' }
          & AddressFragment
        ) | null }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type CompanyDetailsDrawerVatTaxMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  euVatType?: InputMaybe<TimeBasedValueEuVatTypeInput>;
  isPolishVat?: InputMaybe<TimeBasedValueBooleanInput>;
  isOtherVatType?: InputMaybe<TimeBasedValueBooleanInput>;
}>;


export type CompanyDetailsDrawerVatTaxMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly updateCompany:
      | (
        { readonly __typename?: 'Company' }
        & CompanyDetailsDrawerVatsFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type CompanyDetailsDrawerCompanyTypeMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  companyType: ReadonlyArray<CompanyType> | CompanyType;
  sectors?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CompanyDetailsDrawerCompanyTypeMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly updateCompany:
      | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly companyType: ReadonlyArray<CompanyType>, readonly sectors:
          | { readonly __typename?: 'AccessGranted__ListOfString', readonly value: ReadonlyArray<string> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type CompanyEditBankAccountsFormUpdateMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  bankAccount: BankAccountInput;
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompanyEditBankAccountsFormUpdateMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly upsertBankAccount:
      | { readonly __typename?: 'BankAccountResponse', readonly company: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly defaultBankAccount?: { readonly __typename?: 'BankAccount', readonly accountNumber:
              | (
                { readonly __typename?: 'Iban' }
                & BankAccountNumberIbanFragment
              )
              | (
                { readonly __typename?: 'OtherBankAccountNumber' }
                & BankAccountNumberOtherBankAccountNumberFragment
              )
             } | null }, readonly bankAccount: (
          { readonly __typename?: 'BankAccount' }
          & BankAccountFragment
        ) }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type CompanyEditBankAccountsFormDeleteMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  bankAccountNumber: BankAccountNumberInput;
}>;


export type CompanyEditBankAccountsFormDeleteMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly deleteBankAccount:
      | { readonly __typename?: 'BankAccountResponse', readonly company: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number }, readonly bankAccount: (
          { readonly __typename?: 'BankAccount' }
          & BankAccountFragment
        ) }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type CompanyEditBankAccountsFormCheckWhiteListMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type CompanyEditBankAccountsFormCheckWhiteListMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly refreshAllBankAccounts:
      | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly bankAccounts: ReadonlyArray<(
          { readonly __typename?: 'BankAccount' }
          & BankAccountFragment
        )> }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type CompanyEditBankAccountsFormRefreshStatusesMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  bankAccountNumbers: ReadonlyArray<BankAccountNumberInput> | BankAccountNumberInput;
}>;


export type CompanyEditBankAccountsFormRefreshStatusesMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly refreshBankAccounts:
      | { readonly __typename?: 'BankAccountsResponse', readonly bankAccounts: ReadonlyArray<(
          { readonly __typename?: 'BankAccount' }
          & BankAccountFragment
        )>, readonly company: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number } }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type CompanyGeneralInfoDataQueryVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
}>;


export type CompanyGeneralInfoDataQuery = { readonly __typename?: 'Query', readonly company:
    | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly companyType: ReadonlyArray<CompanyType>, readonly countryOfRegistration: string, readonly taxNumber?: string | null, readonly name: string, readonly regon?: string | null, readonly registerId?: string | null, readonly sectors:
        | { readonly __typename?: 'AccessGranted__ListOfString', readonly value: ReadonlyArray<string> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly address?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null, readonly mailingAddress?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null, readonly isPolishVat: { readonly __typename?: 'TimeBasedValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: { readonly __typename?: 'ValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: boolean, readonly state:
            | { readonly __typename?: 'NotVerifiedBooleanVATStatus' }
            | { readonly __typename?: 'VerifiedWithDescriptionBooleanVATStatus', readonly result: boolean, readonly when: Date }
           } }, readonly euVatType: { readonly __typename?: 'TimeBasedValueWithVerificationEuVatType', readonly value: { readonly __typename?: 'ValueWithVerificationEuVatType', readonly value: EuVatType, readonly state:
            | { readonly __typename?: 'NotVerifiedEuVatType' }
            | { readonly __typename?: 'VerifiedEuVatType', readonly result: EuVatType, readonly when: Date }
           } }, readonly isOtherVatType: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean } }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CompanyRegisterDetailsFormRegisterDataQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['CountryCode']['input']>;
  taxNumber: Scalars['TaxNumber']['input'];
}>;


export type CompanyRegisterDetailsFormRegisterDataQuery = { readonly __typename?: 'Query', readonly companyInfo:
    | { readonly __typename?: 'CompanyInfo', readonly baseInfo:
        | { readonly __typename?: 'BaseInfo', readonly name?: string | null, readonly taxNumber?: string | null, readonly regon?: string | null, readonly registerId?: string | null, readonly address?: (
            { readonly __typename?: 'Address' }
            & AddressFragment
          ) | null, readonly mailingAddress?: (
            { readonly __typename?: 'Address' }
            & AddressFragment
          ) | null }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CompanyDetailsDrawerCompanyFragment = { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly isPolishVat: { readonly __typename?: 'TimeBasedValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: { readonly __typename?: 'ValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: boolean, readonly state:
        | { readonly __typename?: 'NotVerifiedBooleanVATStatus' }
        | { readonly __typename?: 'VerifiedWithDescriptionBooleanVATStatus', readonly result: boolean, readonly when: Date }
       } }, readonly euVatType: { readonly __typename?: 'TimeBasedValueWithVerificationEuVatType', readonly value: { readonly __typename?: 'ValueWithVerificationEuVatType', readonly value: EuVatType, readonly state:
        | { readonly __typename?: 'NotVerifiedEuVatType' }
        | { readonly __typename?: 'VerifiedEuVatType', readonly result: EuVatType, readonly when: Date }
       } } };

export type CompanyVatFormVerifyPolishVatsMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type CompanyVatFormVerifyPolishVatsMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly verifyPolishVat:
      | (
        { readonly __typename?: 'Company' }
        & CompanyDetailsDrawerCompanyFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type CompanyVatFormVerifyEuVatMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type CompanyVatFormVerifyEuVatMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly verifyEuVat:
      | (
        { readonly __typename?: 'Company' }
        & CompanyDetailsDrawerCompanyFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractAnnouncementsExtendEndDateEmploymentMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
}>;


export type ContractAnnouncementsExtendEndDateEmploymentMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly expectedEndDate?: Date | null }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractAnnouncementsExtendEndDateB2BMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
}>;


export type ContractAnnouncementsExtendEndDateB2BMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateB2BContract:
      | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly expectedEndDate?: Date | null }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractBankAccountQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type ContractBankAccountQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly promiseeCompany:
            | { readonly __typename?: 'AccessGranted__Company', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly companyType: ReadonlyArray<CompanyType>, readonly defaultBankAccount?: { readonly __typename?: 'BankAccount', readonly accountNumber:
                    | (
                      { readonly __typename?: 'Iban' }
                      & BankAccountNumberIbanFragment
                    )
                    | (
                      { readonly __typename?: 'OtherBankAccountNumber' }
                      & BankAccountNumberOtherBankAccountNumberFragment
                    )
                   } | null, readonly bankAccounts: ReadonlyArray<(
                  { readonly __typename?: 'BankAccount' }
                  & BankAccountFragment
                )>, readonly address?: (
                  { readonly __typename?: 'Address' }
                  & AddressFragment
                ) | null } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promiseeCompanyTransferBankAccount:
            | { readonly __typename?: 'AccessGranted__OptionalBankAccount', readonly value?: (
                { readonly __typename?: 'BankAccount' }
                & BankAccountFragment
              ) | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
              { readonly __typename?: 'BankAccount' }
              & BankAccountFragment
            ) | null }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly companyType: ReadonlyArray<CompanyType>, readonly defaultBankAccount?: { readonly __typename?: 'BankAccount', readonly accountNumber:
                  | (
                    { readonly __typename?: 'Iban' }
                    & BankAccountNumberIbanFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBankAccountNumber' }
                    & BankAccountNumberOtherBankAccountNumberFragment
                  )
                 } | null, readonly bankAccounts: ReadonlyArray<{ readonly __typename?: 'BankAccount', readonly accountNumber:
                  | (
                    { readonly __typename?: 'Iban' }
                    & BankAccountNumberIbanFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBankAccountNumber' }
                    & BankAccountNumberOtherBankAccountNumberFragment
                  )
                 }>, readonly address?: (
                { readonly __typename?: 'Address' }
                & AddressFragment
              ) | null } } }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly promiseeTransferBankAccount:
            | { readonly __typename?: 'AccessGranted__BankAccount', readonly value: (
                { readonly __typename?: 'BankAccount' }
                & BankAccountFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
              { readonly __typename?: 'BankAccount' }
              & BankAccountFragment
            ) | null }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly companyType: ReadonlyArray<CompanyType>, readonly defaultBankAccount?: { readonly __typename?: 'BankAccount', readonly accountNumber:
                  | (
                    { readonly __typename?: 'Iban' }
                    & BankAccountNumberIbanFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBankAccountNumber' }
                    & BankAccountNumberOtherBankAccountNumberFragment
                  )
                 } | null, readonly bankAccounts: ReadonlyArray<{ readonly __typename?: 'BankAccount', readonly accountNumber:
                  | (
                    { readonly __typename?: 'Iban' }
                    & BankAccountNumberIbanFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBankAccountNumber' }
                    & BankAccountNumberOtherBankAccountNumberFragment
                  )
                 }>, readonly address?: (
                { readonly __typename?: 'Address' }
                & AddressFragment
              ) | null } } }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
              { readonly __typename?: 'BankAccount' }
              & BankAccountFragment
            ) | null }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly companyType: ReadonlyArray<CompanyType>, readonly defaultBankAccount?: { readonly __typename?: 'BankAccount', readonly accountNumber:
                  | (
                    { readonly __typename?: 'Iban' }
                    & BankAccountNumberIbanFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBankAccountNumber' }
                    & BankAccountNumberOtherBankAccountNumberFragment
                  )
                 } | null, readonly bankAccounts: ReadonlyArray<{ readonly __typename?: 'BankAccount', readonly accountNumber:
                  | (
                    { readonly __typename?: 'Iban' }
                    & BankAccountNumberIbanFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBankAccountNumber' }
                    & BankAccountNumberOtherBankAccountNumberFragment
                  )
                 }>, readonly address?: (
                { readonly __typename?: 'Address' }
                & AddressFragment
              ) | null } } }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractBankAccountDrawerCompanyFragment = { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly companyType: ReadonlyArray<CompanyType>, readonly defaultBankAccount?: { readonly __typename?: 'BankAccount', readonly accountNumber:
      | (
        { readonly __typename?: 'Iban' }
        & BankAccountNumberIbanFragment
      )
      | (
        { readonly __typename?: 'OtherBankAccountNumber' }
        & BankAccountNumberOtherBankAccountNumberFragment
      )
     } | null, readonly bankAccounts: ReadonlyArray<(
    { readonly __typename?: 'BankAccount' }
    & BankAccountFragment
  )> };

export type ContractBankAccountDrawerDraftContractFieldsPromiseeB2BContractDraftFragment = { readonly __typename?: 'B2BContractDraft', readonly id: string, readonly entityVersion: number, readonly promiseeCompany?: (
    { readonly __typename?: 'Company' }
    & ContractBankAccountDrawerCompanyFragment
  ) | null, readonly promiseeCompanyTransferBankAccount?: (
    { readonly __typename?: 'BankAccount' }
    & BankAccountFragment
  ) | null };

export type ContractBankAccountDrawerDraftContractFieldsPromiseeEmploymentContractDraftFragment = { readonly __typename?: 'EmploymentContractDraft', readonly id: string, readonly entityVersion: number };

export type ContractBankAccountDrawerDraftContractFieldsPromiseeSubcontractDraftFragment = { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number };

export type ContractBankAccountDrawerDraftContractFieldsPromiseeFragment =
  | ContractBankAccountDrawerDraftContractFieldsPromiseeB2BContractDraftFragment
  | ContractBankAccountDrawerDraftContractFieldsPromiseeEmploymentContractDraftFragment
  | ContractBankAccountDrawerDraftContractFieldsPromiseeSubcontractDraftFragment
;

export type ContractBankAccountDrawerDraftContractFieldsPromisorB2BContractDraftFragment = { readonly __typename?: 'B2BContractDraft', readonly id: string, readonly entityVersion: number, readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
      { readonly __typename?: 'BankAccount' }
      & BankAccountFragment
    ) | null }, readonly promisor: (
    { readonly __typename?: 'Company' }
    & ContractBankAccountDrawerCompanyFragment
  ) };

export type ContractBankAccountDrawerDraftContractFieldsPromisorEmploymentContractDraftFragment = { readonly __typename?: 'EmploymentContractDraft', readonly id: string, readonly entityVersion: number, readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
      { readonly __typename?: 'BankAccount' }
      & BankAccountFragment
    ) | null }, readonly promisor: (
    { readonly __typename?: 'Company' }
    & ContractBankAccountDrawerCompanyFragment
  ) };

export type ContractBankAccountDrawerDraftContractFieldsPromisorSubcontractDraftFragment = { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number, readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
      { readonly __typename?: 'BankAccount' }
      & BankAccountFragment
    ) | null }, readonly promisor: (
    { readonly __typename?: 'Company' }
    & ContractBankAccountDrawerCompanyFragment
  ) };

export type ContractBankAccountDrawerDraftContractFieldsPromisorFragment =
  | ContractBankAccountDrawerDraftContractFieldsPromisorB2BContractDraftFragment
  | ContractBankAccountDrawerDraftContractFieldsPromisorEmploymentContractDraftFragment
  | ContractBankAccountDrawerDraftContractFieldsPromisorSubcontractDraftFragment
;

export type ContractBankAccountDrawerContractFieldsPromisorB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
      { readonly __typename?: 'BankAccount' }
      & BankAccountFragment
    ) | null }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: (
      { readonly __typename?: 'Company' }
      & ContractBankAccountDrawerCompanyFragment
    ) } };

export type ContractBankAccountDrawerContractFieldsPromisorEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
      { readonly __typename?: 'BankAccount' }
      & BankAccountFragment
    ) | null }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: (
      { readonly __typename?: 'Company' }
      & ContractBankAccountDrawerCompanyFragment
    ) } };

export type ContractBankAccountDrawerContractFieldsPromisorSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
      { readonly __typename?: 'BankAccount' }
      & BankAccountFragment
    ) | null }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: (
      { readonly __typename?: 'Company' }
      & ContractBankAccountDrawerCompanyFragment
    ) } };

export type ContractBankAccountDrawerContractFieldsPromisorFragment =
  | ContractBankAccountDrawerContractFieldsPromisorB2BContractFragment
  | ContractBankAccountDrawerContractFieldsPromisorEmploymentContractFragment
  | ContractBankAccountDrawerContractFieldsPromisorSubcontractFragment
;

export type ContractBankAccountDrawerContractFieldsPromiseeB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly promiseeCompany:
    | { readonly __typename?: 'AccessGranted__Company', readonly value: (
        { readonly __typename?: 'Company' }
        & ContractBankAccountDrawerCompanyFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promiseeCompanyTransferBankAccount:
    | { readonly __typename?: 'AccessGranted__OptionalBankAccount', readonly value?: (
        { readonly __typename?: 'BankAccount' }
        & BankAccountFragment
      ) | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type ContractBankAccountDrawerContractFieldsPromiseeEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type ContractBankAccountDrawerContractFieldsPromiseeSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type ContractBankAccountDrawerContractFieldsPromiseeFragment =
  | ContractBankAccountDrawerContractFieldsPromiseeB2BContractFragment
  | ContractBankAccountDrawerContractFieldsPromiseeEmploymentContractFragment
  | ContractBankAccountDrawerContractFieldsPromiseeSubcontractFragment
;

export type ContractBankAccountDrawerContractInputPromisorQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type ContractBankAccountDrawerContractInputPromisorQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract' }
          & ContractBankAccountDrawerContractFieldsPromisorB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract' }
          & ContractBankAccountDrawerContractFieldsPromisorEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract' }
          & ContractBankAccountDrawerContractFieldsPromisorSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractBankAccountDrawerContractInputPromiseeQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type ContractBankAccountDrawerContractInputPromiseeQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract' }
          & ContractBankAccountDrawerContractFieldsPromiseeB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract' }
          & ContractBankAccountDrawerContractFieldsPromiseeEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract' }
          & ContractBankAccountDrawerContractFieldsPromiseeSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractBankAccountDrawerDraftInputPromisorQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type ContractBankAccountDrawerDraftInputPromisorQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | (
              { readonly __typename?: 'B2BContractDraft' }
              & ContractBankAccountDrawerDraftContractFieldsPromisorB2BContractDraftFragment
            )
            | (
              { readonly __typename?: 'EmploymentContractDraft' }
              & ContractBankAccountDrawerDraftContractFieldsPromisorEmploymentContractDraftFragment
            )
            | (
              { readonly __typename?: 'SubcontractDraft' }
              & ContractBankAccountDrawerDraftContractFieldsPromisorSubcontractDraftFragment
            )
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type ContractBankAccountDrawerDraftInputPromiseeQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type ContractBankAccountDrawerDraftInputPromiseeQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | (
              { readonly __typename?: 'B2BContractDraft' }
              & ContractBankAccountDrawerDraftContractFieldsPromiseeB2BContractDraftFragment
            )
            | (
              { readonly __typename?: 'EmploymentContractDraft' }
              & ContractBankAccountDrawerDraftContractFieldsPromiseeEmploymentContractDraftFragment
            )
            | (
              { readonly __typename?: 'SubcontractDraft' }
              & ContractBankAccountDrawerDraftContractFieldsPromiseeSubcontractDraftFragment
            )
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type ContractBankAccountDrawerUpdateB2BDraftPromisorMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  overwrittenPromisorTransferBankAccountNumber: ClearableBankAccountNumberInput;
}>;


export type ContractBankAccountDrawerUpdateB2BDraftPromisorMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateB2bDraft:
        | (
          { readonly __typename?: 'B2BContractDraft' }
          & ContractBankAccountDrawerDraftContractFieldsPromisorB2BContractDraftFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  overwrittenPromisorTransferBankAccountNumber: ClearableBankAccountNumberInput;
}>;


export type ContractBankAccountDrawerUpdateEmploymentDraftPromisorMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateEmploymentDraft:
        | (
          { readonly __typename?: 'EmploymentContractDraft' }
          & ContractBankAccountDrawerDraftContractFieldsPromisorEmploymentContractDraftFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type ContractBankAccountDrawerUpdateB2BDraftPromiseeMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  promiseeCompanyTransferBankAccountNumber: ClearableBankAccountNumberInput;
}>;


export type ContractBankAccountDrawerUpdateB2BDraftPromiseeMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateB2bDraft:
        | (
          { readonly __typename?: 'B2BContractDraft' }
          & ContractBankAccountDrawerDraftContractFieldsPromiseeB2BContractDraftFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type ContractBankAccountDrawerUpdateB2BContractPromisorMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  promisorBankAccountNumber?: InputMaybe<ClearableBankAccountNumberInput>;
}>;


export type ContractBankAccountDrawerUpdateB2BContractPromisorMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateB2BContract:
      | (
        { readonly __typename?: 'B2BContract' }
        & ContractBankAccountDrawerContractFieldsPromisorB2BContractFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractBankAccountDrawerUpdateEmploymentContractPromisorMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  promisorBankAccountNumber?: InputMaybe<ClearableBankAccountNumberInput>;
}>;


export type ContractBankAccountDrawerUpdateEmploymentContractPromisorMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | (
        { readonly __typename?: 'EmploymentContract' }
        & ContractBankAccountDrawerContractFieldsPromisorEmploymentContractFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractBankAccountDrawerUpdateB2BContractPromiseeMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  promiseeCompanyTransferBankAccountNumber?: InputMaybe<BankAccountNumberInput>;
}>;


export type ContractBankAccountDrawerUpdateB2BContractPromiseeMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateB2BContract:
      | (
        { readonly __typename?: 'B2BContract' }
        & ContractBankAccountDrawerContractFieldsPromiseeB2BContractFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractBankAccountFormRefreshWhiteListMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  bankAccountNumber: BankAccountNumberInput;
}>;


export type ContractBankAccountFormRefreshWhiteListMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly refreshBankAccounts:
      | { readonly __typename?: 'BankAccountsResponse', readonly bankAccounts: ReadonlyArray<(
          { readonly __typename?: 'BankAccount' }
          & BankAccountFragment
        )>, readonly company: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number } }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractBankAccountSectionRefreshWhiteListMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  bankAccountNumber: BankAccountNumberInput;
}>;


export type ContractBankAccountSectionRefreshWhiteListMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly refreshBankAccounts:
      | { readonly __typename?: 'BankAccountsResponse', readonly company: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly bankAccounts: ReadonlyArray<(
            { readonly __typename?: 'BankAccount' }
            & BankAccountFragment
          )> } }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractBenefitsCurrencyFragment = { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly activityId: string, readonly value: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly activityId: string, readonly value: string }> };

export type ContractBenefitsDiscardPlannedChangeMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  groupType: BenefitGroupType;
  at: Scalars['Date']['input'];
}>;


export type ContractBenefitsDiscardPlannedChangeMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly cancelVariantAssignments:
      | { readonly __typename?: 'ListOfAssignedVariantResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly at?: Date | null, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly value: boolean, readonly applyDate: Date }> } }> }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractBenefitsQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type ContractBenefitsQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly currency:
            | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
                { readonly __typename?: 'TimeBasedCurrency' }
                & ContractBenefitsCurrencyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string }, readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly value: boolean }> } }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly currency:
            | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
                { readonly __typename?: 'TimeBasedCurrency' }
                & ContractBenefitsCurrencyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string }, readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly value: boolean }> } }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string }, readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly value: boolean }> } }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractBonusesCurrencyFragment = { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly value: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly value: string }> };

export type ContractBonusesBonusAppreciationBonusFragment = { readonly __typename?: 'AppreciationBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusBusinessTravelBonusFragment = { readonly __typename?: 'BusinessTravelBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusClientReferralBonusFragment = { readonly __typename?: 'ClientReferralBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusConferenceBonusFragment = { readonly __typename?: 'ConferenceBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusCostRechargeBonusFragment = { readonly __typename?: 'CostRechargeBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusEmployeeReferralBonusFragment = { readonly __typename?: 'EmployeeReferralBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusLanguageLearningBonusFragment = { readonly __typename?: 'LanguageLearningBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusOtherBonusFragment = { readonly __typename?: 'OtherBonus', readonly description: string, readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusRemoteWorkEquipmentBonusFragment = { readonly __typename?: 'RemoteWorkEquipmentBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusSalesCommissionsBonusFragment = { readonly __typename?: 'SalesCommissionsBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusSeverancePayBonusFragment = { readonly __typename?: 'SeverancePayBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusShareholderDividendBonusFragment = { readonly __typename?: 'ShareholderDividendBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusTrainingPackageBonusFragment = { readonly __typename?: 'TrainingPackageBonus', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusTrainingPackageExternalDeductionValueFragment = { readonly __typename?: 'TrainingPackageExternalDeductionValue', readonly id: string, readonly createdAt: Date, readonly paidOutAt?: Date | null, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly applyAt: Date, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ContractBonusesBonusFragment =
  | ContractBonusesBonusAppreciationBonusFragment
  | ContractBonusesBonusBusinessTravelBonusFragment
  | ContractBonusesBonusClientReferralBonusFragment
  | ContractBonusesBonusConferenceBonusFragment
  | ContractBonusesBonusCostRechargeBonusFragment
  | ContractBonusesBonusEmployeeReferralBonusFragment
  | ContractBonusesBonusLanguageLearningBonusFragment
  | ContractBonusesBonusOtherBonusFragment
  | ContractBonusesBonusRemoteWorkEquipmentBonusFragment
  | ContractBonusesBonusSalesCommissionsBonusFragment
  | ContractBonusesBonusSeverancePayBonusFragment
  | ContractBonusesBonusShareholderDividendBonusFragment
  | ContractBonusesBonusTrainingPackageBonusFragment
  | ContractBonusesBonusTrainingPackageExternalDeductionValueFragment
;

export type ContractBonusesDeleteMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  bonusId: Scalars['BonusId']['input'];
}>;


export type ContractBonusesDeleteMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly bonus: { readonly __typename?: 'BonusMutation', readonly delete:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
       } } };

export type ContractBonusesQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type ContractBonusesQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly currency:
            | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
                { readonly __typename?: 'TimeBasedCurrency' }
                & ContractBonusesCurrencyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly vat:
            | { readonly __typename?: 'AccessGranted__TimeBasedVatType', readonly value: { readonly __typename?: 'TimeBasedVatType', readonly value:
                  | (
                    { readonly __typename?: 'VatApplied' }
                    & VatTypeVatAppliedFragment
                  )
                  | (
                    { readonly __typename?: 'VatNotApplied' }
                    & VatTypeVatNotAppliedFragment
                  )
                 } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: { readonly __typename?: 'User', readonly id: string }, readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & ContractBonusesBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & ContractBonusesBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & ContractBonusesBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & ContractBonusesBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & ContractBonusesBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & ContractBonusesBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & ContractBonusesBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & ContractBonusesBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & ContractBonusesBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & ContractBonusesBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & ContractBonusesBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & ContractBonusesBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & ContractBonusesBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & ContractBonusesBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & ContractBonusesBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & ContractBonusesBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & ContractBonusesBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & ContractBonusesBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & ContractBonusesBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & ContractBonusesBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & ContractBonusesBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & ContractBonusesBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & ContractBonusesBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & ContractBonusesBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & ContractBonusesBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & ContractBonusesBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & ContractBonusesBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & ContractBonusesBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly currency:
            | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
                { readonly __typename?: 'TimeBasedCurrency' }
                & ContractBonusesCurrencyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: { readonly __typename?: 'User', readonly id: string }, readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & ContractBonusesBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & ContractBonusesBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & ContractBonusesBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & ContractBonusesBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & ContractBonusesBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & ContractBonusesBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & ContractBonusesBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & ContractBonusesBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & ContractBonusesBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & ContractBonusesBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & ContractBonusesBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & ContractBonusesBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & ContractBonusesBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & ContractBonusesBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & ContractBonusesBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & ContractBonusesBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & ContractBonusesBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & ContractBonusesBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & ContractBonusesBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & ContractBonusesBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & ContractBonusesBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & ContractBonusesBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & ContractBonusesBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & ContractBonusesBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & ContractBonusesBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & ContractBonusesBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & ContractBonusesBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & ContractBonusesBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly terminationDate?: Date | null, readonly startDate: Date, readonly promisee: { readonly __typename?: 'User', readonly id: string }, readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & ContractBonusesBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & ContractBonusesBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & ContractBonusesBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & ContractBonusesBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & ContractBonusesBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & ContractBonusesBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & ContractBonusesBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & ContractBonusesBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & ContractBonusesBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & ContractBonusesBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & ContractBonusesBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & ContractBonusesBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & ContractBonusesBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & ContractBonusesBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & ContractBonusesBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & ContractBonusesBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & ContractBonusesBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & ContractBonusesBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & ContractBonusesBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & ContractBonusesBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & ContractBonusesBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & ContractBonusesBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & ContractBonusesBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & ContractBonusesBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & ContractBonusesBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & ContractBonusesBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & ContractBonusesBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & ContractBonusesBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractBonusesSettingsDrawerInitialDataQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type ContractBonusesSettingsDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly enableTrainingPackage:
            | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly enableTrainingPackage:
            | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractBonusesSettingsDrawerUpdateB2BContractMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  enableTrainingPackage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContractBonusesSettingsDrawerUpdateB2BContractMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateB2BContract:
      | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly enableTrainingPackage:
          | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractBonusesSettingsDrawerUpdateEmploymentContractMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  enableTrainingPackage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContractBonusesSettingsDrawerUpdateEmploymentContractMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly enableTrainingPackage:
          | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractDetailsCompanyFragment = { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly taxNumber?: string | null, readonly name: string, readonly logo?: string | null, readonly address?: (
    { readonly __typename?: 'Address' }
    & AddressFragment
  ) | null };

export type ContractDetailsUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly pesel:
    | { readonly __typename?: 'AccessGranted__OptionalPESEL', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly idType:
    | { readonly __typename?: 'AccessGranted__OptionalIDType', readonly value?: IdType | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly idNumber:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly address:
    | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly mailingAddress:
    | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ContractDetailsQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type ContractDetailsQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly expectedEndDate?: Date | null, readonly status: ContractStatus, readonly name: string, readonly b2bContractType: B2BContractType, readonly conclusionDatePromiseeCompanySnapshot:
            | { readonly __typename?: 'AccessGranted__Company', readonly value: (
                { readonly __typename?: 'Company', readonly at?: Date | null, readonly mailingAddress?: (
                  { readonly __typename?: 'Address' }
                  & AddressFragment
                ) | null }
                & ContractDetailsCompanyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promiseeCompany:
            | { readonly __typename?: 'AccessGranted__Company', readonly value: (
                { readonly __typename?: 'Company', readonly mailingAddress?: (
                  { readonly __typename?: 'Address' }
                  & AddressFragment
                ) | null }
                & ContractDetailsCompanyFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisorRepresentative:
            | { readonly __typename?: 'AccessGranted__String', readonly value: string }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly conclusionDatePromiseeSnapshot: (
            { readonly __typename?: 'User', readonly at?: Date | null }
            & ContractDetailsUserFragment
          ), readonly conclusionDatePromisorSnapshot: (
            { readonly __typename?: 'Company', readonly at?: Date | null, readonly mailingAddress?: (
              { readonly __typename?: 'Address' }
              & AddressFragment
            ) | null }
            & ContractDetailsCompanyFragment
          ), readonly rate:
            | { readonly __typename?: 'AccessGranted__TimeBasedRate' }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses' }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly notes:
            | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: (
            { readonly __typename?: 'User' }
            & ContractDetailsUserFragment
          ), readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: (
              { readonly __typename?: 'Company', readonly mailingAddress?: (
                { readonly __typename?: 'Address' }
                & AddressFragment
              ) | null }
              & ContractDetailsCompanyFragment
            ) } }
        | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly expectedEndDate?: Date | null, readonly status: ContractStatus, readonly name: string, readonly promisorRepresentative:
            | { readonly __typename?: 'AccessGranted__String', readonly value: string }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly conclusionDatePromiseeSnapshot: (
            { readonly __typename?: 'User', readonly at?: Date | null }
            & ContractDetailsUserFragment
          ), readonly conclusionDatePromisorSnapshot: (
            { readonly __typename?: 'Company', readonly at?: Date | null, readonly mailingAddress?: (
              { readonly __typename?: 'Address' }
              & AddressFragment
            ) | null }
            & ContractDetailsCompanyFragment
          ), readonly rate:
            | { readonly __typename?: 'AccessGranted__TimeBasedRate' }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses' }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly notes:
            | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: (
            { readonly __typename?: 'User' }
            & ContractDetailsUserFragment
          ), readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: (
              { readonly __typename?: 'Company', readonly mailingAddress?: (
                { readonly __typename?: 'Address' }
                & AddressFragment
              ) | null }
              & ContractDetailsCompanyFragment
            ) } }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly expectedEndDate?: Date | null, readonly status: ContractStatus, readonly name: string, readonly notes:
            | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: (
            { readonly __typename?: 'User' }
            & ContractDetailsUserFragment
          ), readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: (
              { readonly __typename?: 'Company', readonly mailingAddress?: (
                { readonly __typename?: 'Address' }
                & AddressFragment
              ) | null }
              & ContractDetailsCompanyFragment
            ) } }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractDetailsDrawerContractB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly position: { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }> }, readonly scopeOfWork:
    | { readonly __typename?: 'AccessGranted__TimeBasedString', readonly value: { readonly __typename?: 'TimeBasedString', readonly value: string, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantString', readonly activityId: string, readonly applyDate: Date, readonly value: string }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantString', readonly activityId: string, readonly applyDate: Date, readonly value: string }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ContractDetailsDrawerContractEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly position: { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }> }, readonly scopeOfWork:
    | { readonly __typename?: 'AccessGranted__TimeBasedString', readonly value: { readonly __typename?: 'TimeBasedString', readonly value: string, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantString', readonly activityId: string, readonly applyDate: Date, readonly value: string }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantString', readonly activityId: string, readonly applyDate: Date, readonly value: string }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly paidLeaveEntitlement:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableDays', readonly value: { readonly __typename?: 'TimeBasedOptClearableDays', readonly value?: number | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDays', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableDays', readonly value?: number | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDays', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableDays', readonly value?: number | null } }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly annualLeaveEntitlement:
    | { readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement', readonly value?: { readonly __typename?: 'AnnualLeaveEntitlement', readonly history: ReadonlyArray<{ readonly __typename?: 'AnnualLeaveEntitlementPeriod', readonly entitlement: (
            { readonly __typename?: 'AnnualLeaveEntitlementValue' }
            & AnnualLeaveEntitlementValueFragment
          ) }> } | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ContractDetailsDrawerContractSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null };

export type ContractDetailsDrawerContractFragment =
  | ContractDetailsDrawerContractB2BContractFragment
  | ContractDetailsDrawerContractEmploymentContractFragment
  | ContractDetailsDrawerContractSubcontractFragment
;

export type ContractDetailsDrawerLoadDataQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  year: Scalars['Year']['input'];
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
}>;


export type ContractDetailsDrawerLoadDataQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly at?: Date | null, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
          & ContractDetailsDrawerContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly at?: Date | null, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
          & ContractDetailsDrawerContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly at?: Date | null, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
          & ContractDetailsDrawerContractSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly paidLeaveBalanceYearlySummary?:
    | { readonly __typename?: 'DaysBalance', readonly used: number }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   | null };

export type ContractDetailsDrawerUpdateEmploymentMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  position: TimeBasedValueClearableStringInput;
  scopeOfWork?: InputMaybe<TimeBasedValueStringInput>;
  annualLeaveEntitlement?: InputMaybe<AnnualLeaveEntitlementInput>;
  paidLeaveEntitlement?: InputMaybe<TimeBasedValueClearableDaysInput>;
}>;


export type ContractDetailsDrawerUpdateEmploymentMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | (
        { readonly __typename?: 'EmploymentContract' }
        & ContractDetailsDrawerContractEmploymentContractFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractDetailsDrawerUpdateB2BMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  position: TimeBasedValueClearableStringInput;
  scopeOfWork?: InputMaybe<TimeBasedValueStringInput>;
}>;


export type ContractDetailsDrawerUpdateB2BMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateB2BContract:
      | (
        { readonly __typename?: 'B2BContract' }
        & ContractDetailsDrawerContractB2BContractFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractDetailsSectionPositionFragment = { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }> };

export type ContractDetailsSectionScopeOfWorkFragment = { readonly __typename?: 'AccessGranted__TimeBasedString', readonly value: { readonly __typename?: 'TimeBasedString', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantString', readonly activityId: string, readonly applyDate: Date, readonly value: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantString', readonly activityId: string, readonly value: string, readonly applyDate: Date }> } };

export type ContractDetailsSectionPaidLeaveFragment = { readonly __typename?: 'AccessGranted__TimeBasedOptClearableDays', readonly value: { readonly __typename?: 'TimeBasedOptClearableDays', readonly value?: number | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDays', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableDays', readonly value?: number | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDays', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableDays', readonly value?: number | null } }> } };

export type ContractDetailsSectionContractB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly position: (
    { readonly __typename?: 'TimeBasedOptClearableString' }
    & ContractDetailsSectionPositionFragment
  ), readonly scopeOfWork:
    | (
      { readonly __typename?: 'AccessGranted__TimeBasedString' }
      & ContractDetailsSectionScopeOfWorkFragment
    )
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ContractDetailsSectionContractEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly position: (
    { readonly __typename?: 'TimeBasedOptClearableString' }
    & ContractDetailsSectionPositionFragment
  ), readonly scopeOfWork:
    | (
      { readonly __typename?: 'AccessGranted__TimeBasedString' }
      & ContractDetailsSectionScopeOfWorkFragment
    )
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly paidLeaveEntitlement:
    | (
      { readonly __typename?: 'AccessGranted__TimeBasedOptClearableDays' }
      & ContractDetailsSectionPaidLeaveFragment
    )
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ContractDetailsSectionContractSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly startDate: Date };

export type ContractDetailsSectionContractFragment =
  | ContractDetailsSectionContractB2BContractFragment
  | ContractDetailsSectionContractEmploymentContractFragment
  | ContractDetailsSectionContractSubcontractFragment
;

export type ContractDetailsSectionQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type ContractDetailsSectionQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract' }
          & ContractDetailsSectionContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract' }
          & ContractDetailsSectionContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract' }
          & ContractDetailsSectionContractSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractDetailsSectionDiscardActivitiesMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  activityIds: ReadonlyArray<Scalars['ActivityId']['input']> | Scalars['ActivityId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type ContractDetailsSectionDiscardActivitiesMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly cancelActivities:
      | { readonly __typename?: 'ContractResponse', readonly value:
          | (
            { readonly __typename?: 'B2BContract' }
            & ContractDetailsSectionContractB2BContractFragment
          )
          | (
            { readonly __typename?: 'EmploymentContract' }
            & ContractDetailsSectionContractEmploymentContractFragment
          )
          | (
            { readonly __typename?: 'Subcontract' }
            & ContractDetailsSectionContractSubcontractFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractDraftActionButtonValidateQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type ContractDraftActionButtonValidateQuery = { readonly __typename?: 'Query', readonly validateContractDraft:
    | { readonly __typename?: 'ContractDraftResponse' }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractDraftDetailsCompanyFragment = { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly taxNumber?: string | null, readonly name: string, readonly defaultBankAccount?: { readonly __typename?: 'BankAccount', readonly accountNumber:
      | (
        { readonly __typename?: 'Iban' }
        & BankAccountNumberIbanFragment
      )
      | (
        { readonly __typename?: 'OtherBankAccountNumber' }
        & BankAccountNumberOtherBankAccountNumberFragment
      )
     } | null, readonly bankAccounts: ReadonlyArray<(
    { readonly __typename?: 'BankAccount' }
    & BankAccountFragment
  )>, readonly address?: (
    { readonly __typename?: 'Address' }
    & AddressFragment
  ) | null, readonly mailingAddress?: (
    { readonly __typename?: 'Address' }
    & AddressFragment
  ) | null };

export type ContractDraftDetailsQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type ContractDraftDetailsQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | { readonly __typename?: 'B2BContractDraft', readonly currency?: string | null, readonly scopeOfWork?: string | null, readonly position?: string | null, readonly separatePaymentForBenefits: boolean, readonly id: string, readonly entityVersion: number, readonly name: string, readonly notes?: string | null, readonly b2bContractType: B2BContractType, readonly vat?:
                | (
                  { readonly __typename?: 'VatApplied' }
                  & VatTypeVatAppliedFragment
                )
                | (
                  { readonly __typename?: 'VatNotApplied' }
                  & VatTypeVatNotAppliedFragment
                )
               | null, readonly rate?: (
                { readonly __typename?: 'Rate' }
                & RateFragment
              ) | null, readonly overtimeRate?: (
                { readonly __typename?: 'NetGross' }
                & NetGrossFragment
              ) | null, readonly onCall?: { readonly __typename?: 'OnCallRate', readonly night: (
                  { readonly __typename?: 'NetGross' }
                  & NetGrossFragment
                ), readonly holiday: (
                  { readonly __typename?: 'NetGross' }
                  & NetGrossFragment
                ), readonly weekend: (
                  { readonly __typename?: 'NetGross' }
                  & NetGrossFragment
                ) } | null, readonly promiseeCompany?: (
                { readonly __typename?: 'Company', readonly companyType: ReadonlyArray<CompanyType>, readonly address?: (
                  { readonly __typename?: 'Address' }
                  & AddressFragment
                ) | null, readonly mailingAddress?: (
                  { readonly __typename?: 'Address' }
                  & AddressFragment
                ) | null }
                & ContractDraftDetailsCompanyFragment
              ) | null, readonly promiseeCompanyTransferBankAccount?: (
                { readonly __typename?: 'BankAccount' }
                & BankAccountFragment
              ) | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly pesel:
                  | { readonly __typename?: 'AccessGranted__OptionalPESEL', readonly value?: string | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly idType:
                  | { readonly __typename?: 'AccessGranted__OptionalIDType', readonly value?: IdType | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly idNumber:
                  | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly address:
                  | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
                      { readonly __typename?: 'Address' }
                      & AddressFragment
                    ) | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly mailingAddress:
                  | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
                      { readonly __typename?: 'Address' }
                      & AddressFragment
                    ) | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                 }, readonly promisor: (
                { readonly __typename?: 'Company', readonly companyType: ReadonlyArray<CompanyType>, readonly bankAccounts: ReadonlyArray<{ readonly __typename?: 'BankAccount', readonly accountNumber:
                    | (
                      { readonly __typename?: 'Iban' }
                      & BankAccountNumberIbanFragment
                    )
                    | (
                      { readonly __typename?: 'OtherBankAccountNumber' }
                      & BankAccountNumberOtherBankAccountNumberFragment
                    )
                   }> }
                & ContractDraftDetailsCompanyFragment
              ), readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
                  { readonly __typename?: 'BankAccount' }
                  & BankAccountFragment
                ) | null } }
            | { readonly __typename?: 'EmploymentContractDraft', readonly currency?: string | null, readonly scopeOfWork?: string | null, readonly position?: string | null, readonly paidLeaveEntitlement?: number | null, readonly type: EmploymentContractType, readonly ppk?: number | null, readonly copyrightCosts?: number | null, readonly taxDeductibleCosts?: DeductibleCostsType | null, readonly applyRemoteWorkReimbursement: boolean, readonly id: string, readonly entityVersion: number, readonly name: string, readonly notes?: string | null, readonly rate?: (
                { readonly __typename?: 'Rate' }
                & RateFragment
              ) | null, readonly overtimeRate?: (
                { readonly __typename?: 'NetGross' }
                & NetGrossFragment
              ) | null, readonly onCall?: { readonly __typename?: 'OnCallRate', readonly night: (
                  { readonly __typename?: 'NetGross' }
                  & NetGrossFragment
                ), readonly holiday: (
                  { readonly __typename?: 'NetGross' }
                  & NetGrossFragment
                ), readonly weekend: (
                  { readonly __typename?: 'NetGross' }
                  & NetGrossFragment
                ) } | null, readonly workingTime?: (
                { readonly __typename?: 'WorkingTime' }
                & WorkingTimeFragment
              ) | null, readonly promiseeTransferBankAccount?: (
                { readonly __typename?: 'BankAccount' }
                & BankAccountFragment
              ) | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly pesel:
                  | { readonly __typename?: 'AccessGranted__OptionalPESEL', readonly value?: string | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly idType:
                  | { readonly __typename?: 'AccessGranted__OptionalIDType', readonly value?: IdType | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly idNumber:
                  | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly address:
                  | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
                      { readonly __typename?: 'Address' }
                      & AddressFragment
                    ) | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly mailingAddress:
                  | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
                      { readonly __typename?: 'Address' }
                      & AddressFragment
                    ) | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                 }, readonly promisor: (
                { readonly __typename?: 'Company', readonly companyType: ReadonlyArray<CompanyType>, readonly bankAccounts: ReadonlyArray<{ readonly __typename?: 'BankAccount', readonly accountNumber:
                    | (
                      { readonly __typename?: 'Iban' }
                      & BankAccountNumberIbanFragment
                    )
                    | (
                      { readonly __typename?: 'OtherBankAccountNumber' }
                      & BankAccountNumberOtherBankAccountNumberFragment
                    )
                   }> }
                & ContractDraftDetailsCompanyFragment
              ), readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
                  { readonly __typename?: 'BankAccount' }
                  & BankAccountFragment
                ) | null } }
            | { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number, readonly name: string, readonly notes?: string | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly pesel:
                  | { readonly __typename?: 'AccessGranted__OptionalPESEL', readonly value?: string | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly idType:
                  | { readonly __typename?: 'AccessGranted__OptionalIDType', readonly value?: IdType | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly idNumber:
                  | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly address:
                  | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
                      { readonly __typename?: 'Address' }
                      & AddressFragment
                    ) | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly mailingAddress:
                  | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
                      { readonly __typename?: 'Address' }
                      & AddressFragment
                    ) | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                 }, readonly promisor: (
                { readonly __typename?: 'Company', readonly companyType: ReadonlyArray<CompanyType>, readonly bankAccounts: ReadonlyArray<{ readonly __typename?: 'BankAccount', readonly accountNumber:
                    | (
                      { readonly __typename?: 'Iban' }
                      & BankAccountNumberIbanFragment
                    )
                    | (
                      { readonly __typename?: 'OtherBankAccountNumber' }
                      & BankAccountNumberOtherBankAccountNumberFragment
                    )
                   }> }
                & ContractDraftDetailsCompanyFragment
              ), readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
                  { readonly __typename?: 'BankAccount' }
                  & BankAccountFragment
                ) | null } }
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type ContractListFiltersPromisorsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type ContractListFiltersPromisorsQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly cursor: string, readonly node: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractNoteDrawerDraftInputQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type ContractNoteDrawerDraftInputQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | { readonly __typename?: 'B2BContractDraft', readonly id: string, readonly entityVersion: number, readonly notes?: string | null }
            | { readonly __typename?: 'EmploymentContractDraft', readonly id: string, readonly entityVersion: number, readonly notes?: string | null }
            | { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number, readonly notes?: string | null }
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type ContractNoteDrawerContractInputQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type ContractNoteDrawerContractInputQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly notes:
            | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly notes:
            | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly notes:
            | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractNoteDrawerUpdateB2BContractMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  notes?: InputMaybe<ClearableStringInput>;
}>;


export type ContractNoteDrawerUpdateB2BContractMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateB2BContract:
      | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly notes:
          | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractNoteDrawerUpdateEmploymentContractMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  notes?: InputMaybe<ClearableStringInput>;
}>;


export type ContractNoteDrawerUpdateEmploymentContractMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly notes:
          | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractNoteDrawerUpdateSubcontractMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  notes?: InputMaybe<ClearableStringInput>;
}>;


export type ContractNoteDrawerUpdateSubcontractMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateSubcontract:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly notes:
          | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }
     } };

export type ContractNoteDrawerUpdateB2BDraftMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  notes?: InputMaybe<ClearableStringInput>;
}>;


export type ContractNoteDrawerUpdateB2BDraftMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateB2bDraft:
        | { readonly __typename?: 'B2BContractDraft', readonly id: string, readonly entityVersion: number, readonly notes?: string | null }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type ContractNoteDrawerUpdateEmploymentDraftMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  notes?: InputMaybe<ClearableStringInput>;
}>;


export type ContractNoteDrawerUpdateEmploymentDraftMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateEmploymentDraft:
        | { readonly __typename?: 'EmploymentContractDraft', readonly id: string, readonly entityVersion: number, readonly notes?: string | null }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type ContractNoteDrawerUpdateSubcontractDraftMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  notes?: InputMaybe<ClearableStringInput>;
}>;


export type ContractNoteDrawerUpdateSubcontractDraftMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateSubcontractDraft:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number, readonly notes?: string | null }
       } } };

export type ContractPaymentDetailsBenefitVariantFragment = { readonly __typename?: 'BenefitVariant', readonly id: string, readonly parent:
    | { readonly __typename?: 'Benefit', readonly id: string, readonly name: string, readonly alternativeBenefitsGroupId: string }
    | { readonly __typename?: 'SubBenefit', readonly id: string, readonly name: string, readonly alternativeBenefitsGroupId: string }
  , readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> } };

export type ContractPaymentDetailsCurrencyFragment = { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly activityId: string, readonly applyDate: Date, readonly value: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly activityId: string, readonly applyDate: Date, readonly value: string }> };

export type ContractPaymentDetailsRateFragment = { readonly __typename?: 'TimeBasedRate', readonly value: (
    { readonly __typename?: 'Rate' }
    & RateFragment
  ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly activityId: string, readonly applyDate: Date, readonly value: (
      { readonly __typename?: 'Rate' }
      & RateFragment
    ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly activityId: string, readonly applyDate: Date, readonly value: (
      { readonly __typename?: 'Rate' }
      & RateFragment
    ) }> };

export type ContractPaymentDetailsOvertimeRateFragment = { readonly __typename?: 'TimeBasedOptClearableNetGross', readonly value?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ) | null } }> };

export type ContractPaymentDetailsOnCallFragment = { readonly __typename?: 'TimeBasedOptClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly night: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly holiday: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly weekend: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly night: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly holiday: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly weekend: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ) } | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly night: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly holiday: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly weekend: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ) } | null } }> };

export type ContractPaymentDetailsFutureUpdatesB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
        { readonly __typename?: 'TimeBasedCurrency' }
        & ContractPaymentDetailsCurrencyFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
        { readonly __typename?: 'TimeBasedRate' }
        & ContractPaymentDetailsRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly overtimeRate:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableNetGross' }
        & ContractPaymentDetailsOvertimeRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly onCall:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableOnCallRate', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
        & ContractPaymentDetailsOnCallFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly separatePaymentForBenefits:
    | { readonly __typename?: 'AccessGranted__TimeBasedBoolean', readonly value: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly vat:
    | { readonly __typename?: 'AccessGranted__TimeBasedVatType', readonly value: { readonly __typename?: 'TimeBasedVatType', readonly value:
          | (
            { readonly __typename?: 'VatApplied' }
            & VatTypeVatAppliedFragment
          )
          | (
            { readonly __typename?: 'VatNotApplied' }
            & VatTypeVatNotAppliedFragment
          )
        , readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantVatType', readonly activityId: string, readonly applyDate: Date, readonly value:
            | (
              { readonly __typename?: 'VatApplied' }
              & VatTypeVatAppliedFragment
            )
            | (
              { readonly __typename?: 'VatNotApplied' }
              & VatTypeVatNotAppliedFragment
            )
           }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly assignedVariants:
    | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }> }, readonly variant: { readonly __typename?: 'TimeBasedBenefitVariant', readonly value: (
            { readonly __typename?: 'BenefitVariant' }
            & ContractPaymentDetailsBenefitVariantFragment
          ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly activityId: string, readonly applyDate: Date, readonly value: (
              { readonly __typename?: 'BenefitVariant' }
              & ContractPaymentDetailsBenefitVariantFragment
            ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly applyDate: Date }> } }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ContractPaymentDetailsFutureUpdatesEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
        { readonly __typename?: 'TimeBasedCurrency' }
        & ContractPaymentDetailsCurrencyFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
        { readonly __typename?: 'TimeBasedRate' }
        & ContractPaymentDetailsRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly overtimeRate:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableNetGross' }
        & ContractPaymentDetailsOvertimeRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly onCall:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableOnCallRate', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
        & ContractPaymentDetailsOnCallFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly ppk:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint', readonly value: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly taxDeductibleCosts:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableDeductibleCostsType', readonly value: { readonly __typename?: 'TimeBasedOptClearableDeductibleCostsType', readonly value?: DeductibleCostsType | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDeductibleCostsType', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableDeductibleCostsType', readonly value?: DeductibleCostsType | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDeductibleCostsType', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableDeductibleCostsType', readonly value?: DeductibleCostsType | null } }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly copyrightCosts:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint', readonly value: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly workingTime:
    | { readonly __typename?: 'AccessGranted__TimeBasedWorkingTime', readonly value: { readonly __typename?: 'TimeBasedWorkingTime', readonly value: (
          { readonly __typename?: 'WorkingTime' }
          & WorkingTimeFragment
        ), readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
            { readonly __typename?: 'WorkingTime' }
            & WorkingTimeFragment
          ) }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
            { readonly __typename?: 'WorkingTime' }
            & WorkingTimeFragment
          ) }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly applyRemoteWorkReimbursement:
    | { readonly __typename?: 'AccessGranted__TimeBasedBoolean', readonly value: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly assignedVariants:
    | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }> }, readonly variant: { readonly __typename?: 'TimeBasedBenefitVariant', readonly value: (
            { readonly __typename?: 'BenefitVariant' }
            & ContractPaymentDetailsBenefitVariantFragment
          ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly activityId: string, readonly applyDate: Date, readonly value: (
              { readonly __typename?: 'BenefitVariant' }
              & ContractPaymentDetailsBenefitVariantFragment
            ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly applyDate: Date }> } }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ContractPaymentDetailsFutureUpdatesSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly assignedVariants:
    | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }> }, readonly variant: { readonly __typename?: 'TimeBasedBenefitVariant', readonly value: (
            { readonly __typename?: 'BenefitVariant' }
            & ContractPaymentDetailsBenefitVariantFragment
          ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly activityId: string, readonly applyDate: Date, readonly value: (
              { readonly __typename?: 'BenefitVariant' }
              & ContractPaymentDetailsBenefitVariantFragment
            ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly applyDate: Date }> } }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ContractPaymentDetailsFutureUpdatesFragment =
  | ContractPaymentDetailsFutureUpdatesB2BContractFragment
  | ContractPaymentDetailsFutureUpdatesEmploymentContractFragment
  | ContractPaymentDetailsFutureUpdatesSubcontractFragment
;

export type ContractPaymentDetailsQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type ContractPaymentDetailsQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract', readonly b2bContractType: B2BContractType, readonly vat:
            | { readonly __typename?: 'AccessGranted__TimeBasedVatType', readonly value: { readonly __typename?: 'TimeBasedVatType', readonly value:
                  | (
                    { readonly __typename?: 'VatApplied' }
                    & VatTypeVatAppliedFragment
                  )
                  | (
                    { readonly __typename?: 'VatNotApplied' }
                    & VatTypeVatNotAppliedFragment
                  )
                 } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
          & ContractPaymentDetailsFutureUpdatesB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
          & ContractPaymentDetailsFutureUpdatesEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract', readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
          & ContractPaymentDetailsFutureUpdatesSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractPaymentDetailsDiscardActivitiesMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  activityIds: ReadonlyArray<Scalars['ActivityId']['input']> | Scalars['ActivityId']['input'];
}>;


export type ContractPaymentDetailsDiscardActivitiesMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly cancelActivities:
      | { readonly __typename?: 'ContractResponse', readonly value:
          | (
            { readonly __typename?: 'B2BContract' }
            & ContractPaymentDetailsFutureUpdatesB2BContractFragment
          )
          | (
            { readonly __typename?: 'EmploymentContract' }
            & ContractPaymentDetailsFutureUpdatesEmploymentContractFragment
          )
          | (
            { readonly __typename?: 'Subcontract' }
            & ContractPaymentDetailsFutureUpdatesSubcontractFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type ContractsAndBenefitsQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type ContractsAndBenefitsQuery = { readonly __typename?: 'Query', readonly benefits:
    | { readonly __typename?: 'ListOfBenefitGroupResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'BenefitGroup', readonly benefits: { readonly __typename?: 'ConjunctiveBenefits', readonly manyOf: ReadonlyArray<{ readonly __typename?: 'AlternativeBenefits', readonly alternativeBenefitsGroupId: string, readonly oneOf: ReadonlyArray<{ readonly __typename?: 'Benefit', readonly id: string }> }> } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | { readonly __typename?: 'B2BContractDraft', readonly conclusionDate?: Date | null, readonly promisorRepresentative?: string | null, readonly documentTemplate?: ContractDocumentTemplate | null, readonly conclusionLocation?: string | null, readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate?: Date | null, readonly expectedEndDate?: Date | null, readonly notes?: string | null, readonly b2bContractType: B2BContractType, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null } }
            | { readonly __typename?: 'EmploymentContractDraft', readonly type: EmploymentContractType, readonly conclusionDate?: Date | null, readonly promisorRepresentative?: string | null, readonly documentTemplate?: ContractDocumentTemplate | null, readonly conclusionLocation?: string | null, readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate?: Date | null, readonly expectedEndDate?: Date | null, readonly notes?: string | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null } }
            | { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate?: Date | null, readonly expectedEndDate?: Date | null, readonly notes?: string | null, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly name:
                  | { readonly __typename?: 'AccessGranted__String', readonly value: string }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string } }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null } }
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly status: ContractStatus, readonly name: string, readonly createdAt: Date, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly b2bContractType: B2BContractType, readonly fileUri:
                | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly notes:
                | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly conclusionDate:
                | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null } } }
            | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly status: ContractStatus, readonly name: string, readonly createdAt: Date, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly fileUri:
                | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly notes:
                | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly conclusionDate:
                | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null } } }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly status: ContractStatus, readonly name: string, readonly createdAt: Date, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly clientContract:
                | { readonly __typename?: 'AccessGranted__ClientContract', readonly value: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly notes:
                | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly conclusionDate:
                | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null } } }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type ContractsAndBenefitsDeleteDraftMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type ContractsAndBenefitsDeleteDraftMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly delete:
        | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type ContractsAndBenefitsConcludeDraftMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  date: Scalars['LocalDate']['input'];
  conclusionLocation: Scalars['String']['input'];
  promisorRepresentative: Scalars['String']['input'];
  documentTemplate?: InputMaybe<ContractDocumentTemplate>;
}>;


export type ContractsAndBenefitsConcludeDraftMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly conclude:
        | { readonly __typename?: 'ContractResponse', readonly value:
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly fileUri:
                | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
            | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly fileUri:
                | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number }
           }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type ContractsAndBenefitsConcludeSubcontractDraftMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  date: Scalars['LocalDate']['input'];
}>;


export type ContractsAndBenefitsConcludeSubcontractDraftMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly concludeSubcontract:
        | { readonly __typename?: 'ContractResponse', readonly value:
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number }
            | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number }
           }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type ContractsAndBenefitsDraftPreviewMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  conclusionLocation?: InputMaybe<Scalars['String']['input']>;
  promisorRepresentative?: InputMaybe<Scalars['String']['input']>;
  documentTemplate: ContractDocumentTemplate;
}>;


export type ContractsAndBenefitsDraftPreviewMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly generateContractDraftPreview:
        | { readonly __typename?: 'DraftPreviewResponse', readonly fileUrl: { readonly __typename?: 'GoogleDocUrl', readonly url: string }, readonly draft:
            | { readonly __typename?: 'B2BContractDraft', readonly id: string, readonly entityVersion: number, readonly conclusionDate?: Date | null, readonly conclusionLocation?: string | null, readonly promisorRepresentative?: string | null, readonly documentTemplate?: ContractDocumentTemplate | null }
            | { readonly __typename?: 'EmploymentContractDraft', readonly id: string, readonly entityVersion: number, readonly conclusionDate?: Date | null, readonly conclusionLocation?: string | null, readonly promisorRepresentative?: string | null, readonly documentTemplate?: ContractDocumentTemplate | null }
            | { readonly __typename?: 'SubcontractDraft' }
           }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type ContractsAndBenefitsRegenerateFileMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type ContractsAndBenefitsRegenerateFileMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly regenerateContractGoogleDoc:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'URIResponse', readonly value: string }
     } };

export type CostAndRevenueItemDrawerProjectFragment = { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly costAndRevenueItems:
    | { readonly __typename?: 'AccessGranted__ListOfCostAndRevenueItem', readonly value: ReadonlyArray<{ readonly __typename?: 'CostAndRevenueItem', readonly tpe: CostAndRevenueItemType, readonly date: Date, readonly description?: string | null, readonly serviceLine?: string | null, readonly netValue: (
          { readonly __typename?: 'CentsWithCurrency' }
          & CentsWithCurrencyFragment
        ) }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type CostAndRevenueItemDrawerInputQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type CostAndRevenueItemDrawerInputQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Project' }
      & CostAndRevenueItemDrawerProjectFragment
    )
   };

export type CostAndRevenueItemDrawerUpdateMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  costAndRevenueItems?: InputMaybe<ReadonlyArray<CostAndRevenueItemInput> | CostAndRevenueItemInput>;
}>;


export type CostAndRevenueItemDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly update:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'Project' }
        & CostAndRevenueItemDrawerProjectFragment
      )
     } };

export type CostSummariesDrawerQueryVariables = Exact<{
  filter: FilterContractInput;
  range: ClosedEndMonthRangeInput;
}>;


export type CostSummariesDrawerQuery = { readonly __typename?: 'Query', readonly contractsCostsSummary:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CreateBenefitDrawerCreateMutationVariables = Exact<{
  id: Scalars['BenefitId']['input'];
  groupType: BenefitGroupType;
  alternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['LocalDate']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
}>;


export type CreateBenefitDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createBenefit:
    | { readonly __typename?: 'Benefit', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly endDate?: Date | null, readonly parent: BenefitGroupType }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CreateVariantDrawerInitialDataQueryVariables = Exact<{
  id: Scalars['BenefitId']['input'];
}>;


export type CreateVariantDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly benefit:
    | { readonly __typename?: 'Benefit', readonly id: string, readonly entityVersion: number, readonly name: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CreateVariantDrawerCreateMutationVariables = Exact<{
  id: Scalars['BenefitVariantId']['input'];
  parentId: Scalars['BenefitId']['input'];
  parentEntityVersion: Scalars['EntityVersion']['input'];
  productId: Scalars['BenefitVariantProductId']['input'];
  productName: Scalars['String']['input'];
  startDate: Scalars['LocalDate']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  contractTypes: ReadonlyArray<ContractType> | ContractType;
  promiseeRate?: InputMaybe<BenefitVariantRateInput>;
  promisorRate?: InputMaybe<BenefitVariantRateInput>;
  additionalPeople?: InputMaybe<BenefitAdditionalPeopleInput>;
  meansOfProduction: Scalars['Boolean']['input'];
  buyerType: BenefitBuyerType;
  invoiceCategory: BenefitInvoiceCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  computationBias: MoneyComputationBias;
}>;


export type CreateVariantDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly benefit: { readonly __typename?: 'BenefitMutation', readonly createBenefitVariant:
      | { readonly __typename?: 'BenefitVariant', readonly id: string, readonly entityVersion: number, readonly productId: string, readonly productName: string, readonly contractTypes: ReadonlyArray<ContractType>, readonly meansOfProduction: boolean, readonly buyerType: BenefitBuyerType, readonly invoiceCategory: BenefitInvoiceCategory, readonly startDate: Date, readonly endDate?: Date | null, readonly description?: string | null, readonly parent:
          | { readonly __typename?: 'Benefit', readonly id: string }
          | { readonly __typename?: 'SubBenefit', readonly id: string }
        , readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
            { readonly __typename?: 'BenefitVariantRate' }
            & BenefitVariantRateFragment
          ) | null }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
            { readonly __typename?: 'BenefitVariantRate' }
            & BenefitVariantRateFragment
          ) | null }, readonly additionalPeople?:
          | (
            { readonly __typename?: 'BenefitAdditionalAdults' }
            & BenefitAdditionalPeopleBenefitAdditionalAdultsFragment
          )
          | (
            { readonly __typename?: 'BenefitAdditionalFamily' }
            & BenefitAdditionalPeopleBenefitAdditionalFamilyFragment
          )
          | (
            { readonly __typename?: 'BenefitAdditionalKids' }
            & BenefitAdditionalPeopleBenefitAdditionalKidsFragment
          )
         | null }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type DeskAssignmentDrawerAssignmentFragment = { readonly __typename?: 'DeskAssignment', readonly id: string, readonly from: Date, readonly to?: Date | null, readonly desk: { readonly __typename?: 'ReservedResource', readonly id: string }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null } };

export type DeskAssignmentDrawerInitialDataQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type DeskAssignmentDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly officeCatalogue:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeCatalogue', readonly rooms: ReadonlyArray<{ readonly __typename?: 'Room', readonly id: string, readonly name: string, readonly restrictedToSpaceId?: string | null, readonly desks: ReadonlyArray<{ readonly __typename?: 'Desk', readonly id: string, readonly name: string }> }> }
   };

export type DeskAssignmentDrawerAssignmentsQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type DeskAssignmentDrawerAssignmentsQuery = { readonly __typename?: 'Query', readonly deskAssignments:
    | { readonly __typename?: 'ListOfDeskAssignmentResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'DeskAssignment' }
        & DeskAssignmentDrawerAssignmentFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DeskAssignmentDrawerAssignMutationVariables = Exact<{
  deskId: Scalars['DeskId']['input'];
  userId: Scalars['UserId']['input'];
  period: LocalDateRangeInput;
}>;


export type DeskAssignmentDrawerAssignMutation = { readonly __typename?: 'Mutation', readonly assignDesk:
    | { readonly __typename?: 'DeskAssignment', readonly id: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DeskAssignmentDrawerUpdateMutationVariables = Exact<{
  assignmentId: Scalars['DeskAssignmentId']['input'];
  period: LocalDateRangeInput;
}>;


export type DeskAssignmentDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateDeskAssignment:
    | { readonly __typename?: 'DeskAssignment', readonly id: string, readonly from: Date, readonly to?: Date | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DeskAssignmentDrawerDeleteMutationVariables = Exact<{
  assignmentId: Scalars['DeskAssignmentId']['input'];
}>;


export type DeskAssignmentDrawerDeleteMutation = { readonly __typename?: 'Mutation', readonly deleteDeskAssignment:
    | { readonly __typename?: 'DeskAssignment', readonly id: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DeskAssignmentFormUserAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter: FilterUserInput;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  first: Scalars['Int']['input'];
}>;


export type DeskAssignmentFormUserAutocompleteQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: (
          { readonly __typename?: 'User', readonly avatar?: string | null }
          & UserAutocompleteUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DeskAssignmentFormBookingsQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  from: Scalars['LocalDate']['input'];
  to?: InputMaybe<Scalars['LocalDate']['input']>;
  first: Scalars['Int']['input'];
}>;


export type DeskAssignmentFormBookingsQuery = { readonly __typename?: 'Query', readonly officeReservations:
    | { readonly __typename?: 'FSPResponseOfficeReservation', readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeOfficeReservation', readonly node: { readonly __typename?: 'OfficeReservation', readonly id: string, readonly requestId: string, readonly resource: { readonly __typename?: 'ReservedResource', readonly id: string } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DeskDrawerDeskFragment = { readonly __typename?: 'Desk', readonly id: string, readonly name: string, readonly monitors: number, readonly standing: boolean, readonly pedestalNumber?: string | null };

export type DeskDrawerInitialDataQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type DeskDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly officeCatalogue:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeCatalogue', readonly rooms: ReadonlyArray<{ readonly __typename?: 'Room', readonly id: string, readonly desks: ReadonlyArray<(
          { readonly __typename?: 'Desk' }
          & DeskDrawerDeskFragment
        )> }> }
   };

export type DeskDrawerCreateMutationVariables = Exact<{
  id: Scalars['DeskId']['input'];
  roomId: Scalars['RoomId']['input'];
  name: Scalars['String']['input'];
  monitors: Scalars['Int']['input'];
  standing: Scalars['Boolean']['input'];
  pedestalNumber?: InputMaybe<Scalars['String']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeskDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createDesk:
    | (
      { readonly __typename?: 'Desk' }
      & OfficeCatalogueDeskFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DeskDrawerUpdateMutationVariables = Exact<{
  deskId: Scalars['DeskId']['input'];
  desk: UpdateDeskInput;
}>;


export type DeskDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateDesk:
    | (
      { readonly __typename?: 'Desk' }
      & DeskDrawerDeskFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DirectReportingDiscardMutationVariables = Exact<{
  activityIds: ReadonlyArray<Scalars['ActivityId']['input']> | Scalars['ActivityId']['input'];
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type DirectReportingDiscardMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly cancelActivities:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }
     } };

export type DirectReportingDrawerSpaceFragment = { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } };

export type DirectReportingDrawerUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly role: { readonly __typename?: 'TimeBasedCompanyRole', readonly value: CompanyRole, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCompanyRole', readonly applyDate: Date, readonly activityId: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCompanyRole', readonly applyDate: Date, readonly activityId: string }> }, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly primaryProjectId: { readonly __typename?: 'TimeBasedOptClearableProjectId', readonly value?: string | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProjectId', readonly applyDate: Date, readonly activityId: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProjectId', readonly applyDate: Date, readonly activityId: string }> }, readonly practiceLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly entityVersion: number, readonly email: string, readonly avatar?: string | null } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableUser', readonly applyDate: Date, readonly activityId: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableUser', readonly applyDate: Date, readonly activityId: string }> }, readonly operationalLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly entityVersion: number, readonly email: string, readonly avatar?: string | null } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableUser', readonly applyDate: Date, readonly activityId: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableUser', readonly applyDate: Date, readonly activityId: string }> }, readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: (
        { readonly __typename?: 'Space' }
        & DirectReportingDrawerSpaceFragment
      ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantSpace', readonly applyDate: Date, readonly activityId: string, readonly value: (
          { readonly __typename?: 'Space' }
          & DirectReportingDrawerSpaceFragment
        ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantSpace', readonly applyDate: Date, readonly activityId: string, readonly value: (
          { readonly __typename?: 'Space' }
          & DirectReportingDrawerSpaceFragment
        ) }> }, readonly assignedProjects:
      | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string } }> }
      | (
        { readonly __typename?: 'Unauthorized' }
        & UnauthorizedFragment
      )
     } };

export type DirectReportingDrawerLoadDataQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
}>;


export type DirectReportingDrawerLoadDataQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User', readonly at?: Date | null }
      & DirectReportingDrawerUserFragment
    )
   };

export type DirectReportingDrawerUpdateUserMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  space: TimeBasedValueSpaceIdInput;
  primaryProjectId: TimeBasedValueClearableUserIdInput;
  practiceLead: TimeBasedValueClearableUserIdInput;
  operationalLead: TimeBasedValueClearableUserIdInput;
  role: TimeBasedValueCompanyRoleInput;
}>;


export type DirectReportingDrawerUpdateUserMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & DirectReportingDrawerUserFragment
      )
     } };

export type DirectReportingDrawerPartialUpdateUserMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  space: TimeBasedValueSpaceIdInput;
  primaryProjectId: TimeBasedValueClearableUserIdInput;
  practiceLead: TimeBasedValueClearableUserIdInput;
  operationalLead: TimeBasedValueClearableUserIdInput;
}>;


export type DirectReportingDrawerPartialUpdateUserMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUserInvocingTeamScope:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & DirectReportingDrawerUserFragment
      )
     } };

export type DirectReportingDrawerUserAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter: FilterUserInput;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  first: Scalars['Int']['input'];
}>;


export type DirectReportingDrawerUserAutocompleteQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: (
          { readonly __typename?: 'User', readonly avatar?: string | null }
          & UserAutocompleteUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EditBenefitDrawerUpdateMutationVariables = Exact<{
  id: Scalars['BenefitId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  name: Scalars['String']['input'];
}>;


export type EditBenefitDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly benefit: { readonly __typename?: 'BenefitMutation', readonly update:
      | { readonly __typename?: 'BenefitCommonResponse', readonly value:
          | { readonly __typename?: 'Benefit', readonly id: string, readonly entityVersion: number, readonly name: string }
          | { readonly __typename?: 'SubBenefit', readonly id: string, readonly entityVersion: number, readonly name: string }
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type EditBenefitDrawerTerminateMutationVariables = Exact<{
  id: Scalars['BenefitId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  endDate: Scalars['LocalDate']['input'];
}>;


export type EditBenefitDrawerTerminateMutation = { readonly __typename?: 'Mutation', readonly benefit: { readonly __typename?: 'BenefitMutation', readonly terminate:
      | { readonly __typename?: 'BenefitCommonResponse', readonly value:
          | { readonly __typename?: 'Benefit', readonly id: string, readonly entityVersion: number, readonly name: string }
          | { readonly __typename?: 'SubBenefit', readonly id: string, readonly entityVersion: number, readonly name: string }
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type EditBenefitDrawerBenefitInitialDataQueryVariables = Exact<{
  id: Scalars['BenefitId']['input'];
}>;


export type EditBenefitDrawerBenefitInitialDataQuery = { readonly __typename?: 'Query', readonly benefit:
    | { readonly __typename?: 'Benefit', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly endDate?: Date | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EditBenefitVariantPriceDrawerBenefitVariantFragment = { readonly __typename?: 'BenefitVariant', readonly id: string, readonly at?: Date | null, readonly entityVersion: number, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> } };

export type EditBenefitVariantPriceDrawerLoadDataQueryVariables = Exact<{
  benefitVariantId: Scalars['BenefitVariantId']['input'];
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
}>;


export type EditBenefitVariantPriceDrawerLoadDataQuery = { readonly __typename?: 'Query', readonly benefitVariant:
    | (
      { readonly __typename?: 'BenefitVariant' }
      & EditBenefitVariantPriceDrawerBenefitVariantFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EditBenefitVariantPriceDrawerUpdateMutationVariables = Exact<{
  benefitVariantId: Scalars['BenefitVariantId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  promiseeRate?: InputMaybe<TimeBasedValueClearableBenefitVariantRateInput>;
  promisorRate?: InputMaybe<TimeBasedValueClearableBenefitVariantRateInput>;
}>;


export type EditBenefitVariantPriceDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly benefitVariant: { readonly __typename?: 'BenefitVariantMutation', readonly update:
      | (
        { readonly __typename?: 'BenefitVariant' }
        & EditBenefitVariantPriceDrawerBenefitVariantFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type EditClientContractDrawerContractFragment = { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly name:
    | { readonly __typename?: 'AccessGranted__String', readonly value: string }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly contractDurationFrom:
    | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly contractDurationTo:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly docUri:
    | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promisor?: (
    { readonly __typename?: 'Company' }
    & CompanyAutocompleteCompanyFragment
  ) | null, readonly promisee: (
    { readonly __typename?: 'Company' }
    & CompanyAutocompleteCompanyFragment
  ) };

export type EditClientContractDrawerInputQueryVariables = Exact<{
  id: Scalars['ClientContractId']['input'];
}>;


export type EditClientContractDrawerInputQuery = { readonly __typename?: 'Query', readonly clientContract:
    | (
      { readonly __typename?: 'ClientContract' }
      & EditClientContractDrawerContractFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EditClientContractDrawerUpdateMutationVariables = Exact<{
  id: Scalars['ClientContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  contractDurationFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  contractDurationTo?: InputMaybe<ClearableLocalDateInput>;
  docUri?: InputMaybe<ClearableUriInput>;
}>;


export type EditClientContractDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly clientContract: { readonly __typename?: 'ClientContractMutation', readonly update:
      | (
        { readonly __typename?: 'ClientContract' }
        & EditClientContractDrawerContractFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type EditDeskRequestDrawerInputQueryVariables = Exact<{
  requestId: Scalars['ReservationRequestId']['input'];
  officeId: Scalars['OfficeId']['input'];
  first: Scalars['Int']['input'];
  range: ClosedEndLocalDateRangeInput;
}>;


export type EditDeskRequestDrawerInputQuery = { readonly __typename?: 'Query', readonly officeReservation:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'ReservationRequest', readonly requestId: string, readonly notes?: string | null, readonly guestEmails: ReadonlyArray<string>, readonly range: { readonly __typename?: 'ClosedEndLocalDateRange', readonly from: Date, readonly to: Date }, readonly resources: ReadonlyArray<{ readonly __typename?: 'ReservedResource', readonly id: string }>, readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string }, readonly office: { readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null } }
  , readonly officeReservations:
    | { readonly __typename?: 'FSPResponseOfficeReservation', readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeOfficeReservation', readonly node: { readonly __typename?: 'OfficeReservation', readonly id: string, readonly date: Date, readonly resource: { readonly __typename?: 'ReservedResource', readonly id: string } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly officeCatalogue:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeCatalogue', readonly rooms: ReadonlyArray<{ readonly __typename?: 'Room', readonly id: string, readonly name: string, readonly blocked: boolean, readonly desks: ReadonlyArray<{ readonly __typename?: 'Desk', readonly id: string, readonly name: string, readonly monitors: number, readonly standing: boolean, readonly blocked: boolean }> }> }
  , readonly officeAvailability:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeAvailability', readonly desks: ReadonlyArray<{ readonly __typename?: 'ResourceAvailability', readonly resourceId: string, readonly takenDates: ReadonlyArray<Date> }> }
   };

export type EditDeskRequestDrawerUpdateAndApproveMutationVariables = Exact<{
  requestId: Scalars['ReservationRequestId']['input'];
  input: UpdateDeskRequestInput;
}>;


export type EditDeskRequestDrawerUpdateAndApproveMutation = { readonly __typename?: 'Mutation', readonly updateDeskRequest:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'ReservationRequest', readonly requestId: string }
   };

export type EditOfficeDrawerOfficeFragment = { readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null, readonly avatar?: string | null, readonly entityVersion: number };

export type EditOfficeDrawerInitialDataQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type EditOfficeDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly office:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Office' }
      & EditOfficeDrawerOfficeFragment
    )
   };

export type EditOfficeDrawerUpdateMutationVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  name: Scalars['String']['input'];
  period: LocalDateRangeInput;
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type EditOfficeDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateOffice:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Office' }
      & EditOfficeDrawerOfficeFragment
    )
   };

export type EditOfficeDrawerUploadAvatarMutationVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  file: Scalars['Upload']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type EditOfficeDrawerUploadAvatarMutation = { readonly __typename?: 'Mutation', readonly uploadOfficeAvatar:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Office', readonly officeId: string, readonly avatar?: string | null, readonly entityVersion: number }
   };

export type EditOfficeDrawerDeleteAvatarMutationVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type EditOfficeDrawerDeleteAvatarMutation = { readonly __typename?: 'Mutation', readonly deleteOfficeAvatar:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Office', readonly officeId: string, readonly avatar?: string | null, readonly entityVersion: number }
   };

export type EditOfficeSettingsDrawerOfficeSettingsFragment = { readonly __typename?: 'OfficeSettings', readonly receptionEmails: ReadonlyArray<string>, readonly parkingInformation?: string | null, readonly office: { readonly __typename?: 'Office', readonly officeId: string, readonly entityVersion: number }, readonly floorMap?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly fileName: string, readonly openUrl: string } | null, readonly parkingMap?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly fileName: string, readonly openUrl: string } | null };

export type EditOfficeSettingsDrawerInitialDataQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type EditOfficeSettingsDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly officeSettings:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'OfficeSettings' }
      & EditOfficeSettingsDrawerOfficeSettingsFragment
    )
   };

export type EditOfficeSettingsDrawerUpdateMutationVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  settings: UpdateOfficeSettingsInput;
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type EditOfficeSettingsDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateOfficeSettings:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'OfficeSettings' }
      & EditOfficeSettingsDrawerOfficeSettingsFragment
    )
   };

export type EditParkingRequestDrawerInputQueryVariables = Exact<{
  requestId: Scalars['ReservationRequestId']['input'];
  officeId: Scalars['OfficeId']['input'];
  first: Scalars['Int']['input'];
  range: ClosedEndLocalDateRangeInput;
}>;


export type EditParkingRequestDrawerInputQuery = { readonly __typename?: 'Query', readonly officeReservation:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'ReservationRequest', readonly requestId: string, readonly notes?: string | null, readonly guestEmails: ReadonlyArray<string>, readonly plateNumber?: string | null, readonly range: { readonly __typename?: 'ClosedEndLocalDateRange', readonly from: Date, readonly to: Date }, readonly resources: ReadonlyArray<{ readonly __typename?: 'ReservedResource', readonly id: string }>, readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string }, readonly office: { readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null } }
  , readonly officeReservations:
    | { readonly __typename?: 'FSPResponseOfficeReservation', readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeOfficeReservation', readonly node: { readonly __typename?: 'OfficeReservation', readonly id: string, readonly date: Date, readonly resource: { readonly __typename?: 'ReservedResource', readonly id: string } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly officeCatalogue:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeCatalogue', readonly parkingSpots: ReadonlyArray<{ readonly __typename?: 'ParkingSpot', readonly id: string, readonly number: string, readonly name: string, readonly guest: boolean, readonly blocked: boolean }> }
  , readonly officeAvailability:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeAvailability', readonly parkingSpots: ReadonlyArray<{ readonly __typename?: 'ResourceAvailability', readonly resourceId: string, readonly takenDates: ReadonlyArray<Date> }> }
   };

export type EditParkingRequestDrawerUpdateAndApproveMutationVariables = Exact<{
  requestId: Scalars['ReservationRequestId']['input'];
  input: UpdateParkingRequestInput;
}>;


export type EditParkingRequestDrawerUpdateAndApproveMutation = { readonly __typename?: 'Mutation', readonly updateParkingRequest:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'ReservationRequest', readonly requestId: string }
   };

export type EditProfileAdditionalDataDrawerUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly idType:
    | { readonly __typename?: 'AccessGranted__OptionalIDType', readonly value?: IdType | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly idNumber:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly pesel:
    | { readonly __typename?: 'AccessGranted__OptionalPESEL', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly citizenship:
    | { readonly __typename?: 'AccessGranted__OptionalCountryCode', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly birthDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly nextMedicalExaminationDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly passportExpirationDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly nextOhsTrainingDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly revenueAdministrationOffice:
    | { readonly __typename?: 'AccessGranted__OptionalRevenueAdministrationOffice', readonly value?: { readonly __typename?: 'RevenueAdministrationOffice', readonly id: number, readonly officeName: string } | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type EditProfileAdditionalDataDrawerInputQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type EditProfileAdditionalDataDrawerInputQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & EditProfileAdditionalDataDrawerUserFragment
    )
   };

export type EditProfileAdditionalDataDrawerUpdateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  idType?: InputMaybe<ClearableIdTypeInput>;
  idNumber?: InputMaybe<ClearableStringInput>;
  pesel?: InputMaybe<ClearablePeselInput>;
  citizenship?: InputMaybe<ClearableCountryCodeInput>;
  birthDate?: InputMaybe<ClearableLocalDateInput>;
  nextMedicalExaminationDate?: InputMaybe<ClearableLocalDateInput>;
  revenueAdministrationOffice?: InputMaybe<ClearableRevenueAdministrationOfficeIdInput>;
  passportExpirationDate?: InputMaybe<ClearableLocalDateInput>;
  nextOhsTrainingDate?: InputMaybe<ClearableLocalDateInput>;
}>;


export type EditProfileAdditionalDataDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & EditProfileAdditionalDataDrawerUserFragment
      )
     } };

export type EditProfileAddressDrawerUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contactEmail:
    | { readonly __typename?: 'AccessGranted__OptionalEmailAddress', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly phoneNumber:
    | { readonly __typename?: 'AccessGranted__OptionalPhoneNumber', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly address:
    | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly mailingAddress:
    | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly paczkomat:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly plateNumber:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly emergencyContact:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type EditProfileAddressDrawerInputQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type EditProfileAddressDrawerInputQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & EditProfileAddressDrawerUserFragment
    )
   };

export type EditProfileAddressDrawerUpdateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  contactEmail?: InputMaybe<ClearableEmailAddressInput>;
  phoneNumber?: InputMaybe<ClearablePhoneNumberInput>;
  address?: InputMaybe<ClearableAddressInput>;
  mailingAddress?: InputMaybe<ClearableAddressInput>;
  paczkomat?: InputMaybe<ClearableStringInput>;
  plateNumber?: InputMaybe<ClearableStringInput>;
  emergencyContact?: InputMaybe<ClearableStringInput>;
}>;


export type EditProfileAddressDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & EditProfileAddressDrawerUserFragment
      )
     } };

export type EditProfileBasicInfoDrawerSpaceFragment = { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } };

export type EditProfileBasicInfoDrawerUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly middleName?: string | null, readonly familyName?: string | null, readonly areaOfExpertise?: string | null, readonly consentedForUseOfImage: boolean, readonly isStudent:
    | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly isStudentRevisionDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly office?: { readonly __typename?: 'Office', readonly officeId: string } | null, readonly documentsDirectory:
    | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly personalDataProcessingAuthorization:
    | { readonly __typename?: 'AccessGranted__PersonalDataProcessingAuthorization', readonly value: { readonly __typename?: 'PersonalDataProcessingAuthorization', readonly isAuthorized: boolean, readonly document:
          | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type EditProfileBasicInfoDrawerInputQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type EditProfileBasicInfoDrawerInputQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & EditProfileBasicInfoDrawerUserFragment
    )
   };

export type EditProfileBasicInfoDrawerUpdateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  middleName?: InputMaybe<ClearableStringInput>;
  familyName?: InputMaybe<ClearableStringInput>;
  space?: InputMaybe<TimeBasedValueSpaceIdInput>;
  area?: InputMaybe<ClearableStringInput>;
  progressionLevel?: InputMaybe<TimeBasedValueClearableProgressionLevelInput>;
  officeId?: InputMaybe<ClearableOfficeIdInput>;
  personalDataProcessingAuthorization?: InputMaybe<ClearableUriInput>;
  documentsDirectory?: InputMaybe<Scalars['URI']['input']>;
  consentedForUseOfImage?: InputMaybe<Scalars['Boolean']['input']>;
  isStudent?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentRevisionDate?: InputMaybe<ClearableLocalDateInput>;
}>;


export type EditProfileBasicInfoDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & EditProfileBasicInfoDrawerUserFragment
      )
     } };

export type EditProfileBasicInfoFormOfficeAutocompleteQueryVariables = Exact<{ [key: string]: never; }>;


export type EditProfileBasicInfoFormOfficeAutocompleteQuery = { readonly __typename?: 'Query', readonly offices:
    | { readonly __typename?: 'ListOfOfficeResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EditProjectCrossSellDrawerProjectFragment = { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly crossSell:
    | { readonly __typename?: 'AccessGranted__OptionalCrossSell', readonly value?: { readonly __typename?: 'CrossSell', readonly description: string, readonly client?: (
          { readonly __typename?: 'Company' }
          & CompanyAutocompleteCompanyFragment
        ) | null, readonly project?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly space?: { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } } | null } | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type EditProjectCrossSellDrawerInputQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type EditProjectCrossSellDrawerInputQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Project' }
      & EditProjectCrossSellDrawerProjectFragment
    )
   };

export type EditProjectCrossSellDrawerUpdateMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  crossSell?: InputMaybe<ClearableCrossSellInput>;
}>;


export type EditProjectCrossSellDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly update:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'Project' }
        & EditProjectCrossSellDrawerProjectFragment
      )
     } };

export type EditProjectDrawerProjectFragment = { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly name: string, readonly description:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly areaOfVlEngagement:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly costLedgerAccountNumber:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly revenueLedgerAccountNumber:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly promisor?: (
      { readonly __typename?: 'Company', readonly clientContracts:
        | { readonly __typename?: 'AccessGranted__ListOfClientContract', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly name:
              | { readonly __typename?: 'AccessGranted__String', readonly value: string }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
             }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
      & CompanyAutocompleteCompanyFragment
    ) | null, readonly promisee: (
      { readonly __typename?: 'Company', readonly clientContracts:
        | { readonly __typename?: 'AccessGranted__ListOfClientContract', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly name:
              | { readonly __typename?: 'AccessGranted__String', readonly value: string }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
             }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
      & CompanyAutocompleteCompanyFragment
    ) }, readonly space?: { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } } | null };

export type EditProjectDrawerInputQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type EditProjectDrawerInputQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Project' }
      & EditProjectDrawerProjectFragment
    )
   };

export type EditProjectDrawerUpdateMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<ClearableSpaceIdInput>;
  description?: InputMaybe<ClearableStringInput>;
  areaOfVlEngagement?: InputMaybe<ClearableStringInput>;
  costLedgerAccountNumber?: InputMaybe<ClearableStringInput>;
  revenueLedgerAccountNumber?: InputMaybe<ClearableStringInput>;
}>;


export type EditProjectDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly update:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'Project' }
        & EditProjectDrawerProjectFragment
      )
     } };

export type EditProjectTechStackAndCompetencesDrawerProjectFragment = { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly techStack:
    | { readonly __typename?: 'AccessGranted__ListOfString', readonly value: ReadonlyArray<string> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly competences:
    | { readonly __typename?: 'AccessGranted__ListOfString', readonly value: ReadonlyArray<string> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type EditProjectTechStackAndCompetencesDrawerInputQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type EditProjectTechStackAndCompetencesDrawerInputQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Project' }
      & EditProjectTechStackAndCompetencesDrawerProjectFragment
    )
   };

export type EditProjectTechStackAndCompetencesDrawerUpdateMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  techStack?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  competences?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EditProjectTechStackAndCompetencesDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly update:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'Project' }
        & EditProjectTechStackAndCompetencesDrawerProjectFragment
      )
     } };

export type EditSkillsAndCertificatesDrawerUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly skillsAndCompetences: ReadonlyArray<string>, readonly declaredNoCertificates: boolean, readonly certificates:
    | { readonly __typename?: 'AccessGranted__ListOfCertificate', readonly value: ReadonlyArray<{ readonly __typename?: 'Certificate', readonly id: string, readonly name: string, readonly issueDate?: Date | null, readonly expirationDate?: Date | null, readonly userId: string, readonly file?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly downloadUrl: string, readonly fileName: string, readonly openUrl: string } | null }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type EditSkillsAndCertificatesDrawerQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type EditSkillsAndCertificatesDrawerQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & EditSkillsAndCertificatesDrawerUserFragment
    )
   };

export type EditSkillsAndCertificatesDrawerUpdateSkillsMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  skills?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EditSkillsAndCertificatesDrawerUpdateSkillsMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & EditSkillsAndCertificatesDrawerUserFragment
      )
     } };

export type EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  declaredNoCertificates: Scalars['Boolean']['input'];
}>;


export type EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly declaredNoCertificates: boolean }
     } };

export type EditSkillsAndCertificatesDrawerCreateCertificateMutationVariables = Exact<{
  id: Scalars['CertificateId']['input'];
  userId: Scalars['UserId']['input'];
  name: Scalars['String']['input'];
  issueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  expirationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type EditSkillsAndCertificatesDrawerCreateCertificateMutation = { readonly __typename?: 'Mutation', readonly createCertificate:
    | { readonly __typename?: 'Certificate', readonly id: string, readonly name: string, readonly issueDate?: Date | null, readonly expirationDate?: Date | null, readonly userId: string, readonly file?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly downloadUrl: string, readonly fileName: string, readonly openUrl: string } | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EditSkillsAndCertificatesDrawerUpdateCertificateMutationVariables = Exact<{
  certificateId: Scalars['CertificateId']['input'];
  certificate: UpdateCertificateInput;
}>;


export type EditSkillsAndCertificatesDrawerUpdateCertificateMutation = { readonly __typename?: 'Mutation', readonly updateCertificate:
    | { readonly __typename?: 'Certificate', readonly id: string, readonly name: string, readonly issueDate?: Date | null, readonly expirationDate?: Date | null, readonly userId: string, readonly file?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly downloadUrl: string, readonly fileName: string, readonly openUrl: string } | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EditSkillsAndCertificatesDrawerDeleteCertificateMutationVariables = Exact<{
  certificateId: Scalars['CertificateId']['input'];
}>;


export type EditSkillsAndCertificatesDrawerDeleteCertificateMutation = { readonly __typename?: 'Mutation', readonly deleteCertificate:
    | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EditSocialMediaHandlesDrawerUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly socialMediaHandles:
    | { readonly __typename?: 'AccessGranted__ListOfSocialMediaHandle', readonly value: ReadonlyArray<{ readonly __typename?: 'SocialMediaHandle', readonly platform: string, readonly handle: string }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type EditSocialMediaHandlesDrawerQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type EditSocialMediaHandlesDrawerQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & EditSocialMediaHandlesDrawerUserFragment
    )
   };

export type EditSocialMediaHandlesDrawerUpdateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  socialMediaHandles?: InputMaybe<ReadonlyArray<SocialMediaHandleInput> | SocialMediaHandleInput>;
}>;


export type EditSocialMediaHandlesDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & EditSocialMediaHandlesDrawerUserFragment
      )
     } };

export type EditSpaceDrawerSpaceFragment = { readonly __typename?: 'Space', readonly id: string, readonly entityVersion: number, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly email: string }, readonly directors: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null }> };

export type EditSpaceDrawerInitialDataQueryVariables = Exact<{
  spaceId: Scalars['SpaceId']['input'];
}>;


export type EditSpaceDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly space:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Space' }
      & EditSpaceDrawerSpaceFragment
    )
   };

export type EditSpaceDrawerUpdateMutationVariables = Exact<{
  spaceId: Scalars['SpaceId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['UserId']['input']>;
  directors?: InputMaybe<ReadonlyArray<Scalars['UserId']['input']> | Scalars['UserId']['input']>;
}>;


export type EditSpaceDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly space: { readonly __typename?: 'SpaceMutation', readonly updateSpace:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'Space' }
        & EditSpaceDrawerSpaceFragment
      )
     } };

export type EditVariantDrawerBenefitVariantFragment = { readonly __typename?: 'BenefitVariant', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly endDate?: Date | null, readonly productId: string, readonly productName: string, readonly meansOfProduction: boolean, readonly buyerType: BenefitBuyerType, readonly invoiceCategory: BenefitInvoiceCategory, readonly description?: string | null, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly additionalPeople?:
    | (
      { readonly __typename?: 'BenefitAdditionalAdults' }
      & BenefitAdditionalPeopleBenefitAdditionalAdultsFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalFamily' }
      & BenefitAdditionalPeopleBenefitAdditionalFamilyFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalKids' }
      & BenefitAdditionalPeopleBenefitAdditionalKidsFragment
    )
   | null };

export type EditVariantDrawerUpdateMutationVariables = Exact<{
  id: Scalars['BenefitVariantId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  productId: Scalars['BenefitVariantProductId']['input'];
  productName: Scalars['String']['input'];
  promiseeRate?: InputMaybe<TimeBasedValueClearableBenefitVariantRateInput>;
  promisorRate?: InputMaybe<TimeBasedValueClearableBenefitVariantRateInput>;
  additionalPeople?: InputMaybe<ClearableBenefitAdditionalPeopleInput>;
  meansOfProduction?: InputMaybe<Scalars['Boolean']['input']>;
  buyerType?: InputMaybe<BenefitBuyerType>;
  invoiceCategory?: InputMaybe<BenefitInvoiceCategory>;
  description?: InputMaybe<ClearableStringInput>;
}>;


export type EditVariantDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly benefitVariant: { readonly __typename?: 'BenefitVariantMutation', readonly update:
      | (
        { readonly __typename?: 'BenefitVariant' }
        & EditVariantDrawerBenefitVariantFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type EditVariantDrawerTerminateMutationVariables = Exact<{
  id: Scalars['BenefitVariantId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  endDate: Scalars['LocalDate']['input'];
}>;


export type EditVariantDrawerTerminateMutation = { readonly __typename?: 'Mutation', readonly benefitVariant: { readonly __typename?: 'BenefitVariantMutation', readonly terminate:
      | (
        { readonly __typename?: 'BenefitVariant' }
        & EditVariantDrawerBenefitVariantFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type EditVariantDrawerLoadDataQueryVariables = Exact<{
  id: Scalars['BenefitVariantId']['input'];
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
}>;


export type EditVariantDrawerLoadDataQuery = { readonly __typename?: 'Query', readonly benefitVariant:
    | (
      { readonly __typename?: 'BenefitVariant', readonly at?: Date | null }
      & EditVariantDrawerBenefitVariantFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EmployeeDueDatesDrawerUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly isStudent:
    | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly nextOhsTrainingDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly isStudentRevisionDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly nextMedicalExaminationDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type EmployeeDueDatesDrawerQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type EmployeeDueDatesDrawerQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & EmployeeDueDatesDrawerUserFragment
    )
   };

export type EmployeeDueDatesDrawerUpdateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  isStudentRevisionDate: ClearableLocalDateInput;
  nextMedicalExaminationDate: ClearableLocalDateInput;
  nextOhsTrainingDate: ClearableLocalDateInput;
  isStudent: Scalars['Boolean']['input'];
}>;


export type EmployeeDueDatesDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & EmployeeDueDatesDrawerUserFragment
      )
     } };

export type EmploymentBankAccountDrawerContractInputQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type EmploymentBankAccountDrawerContractInputQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly promiseeTransferBankAccount:
            | { readonly __typename?: 'AccessGranted__BankAccount', readonly value: (
                { readonly __typename?: 'BankAccount' }
                & BankAccountFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EmploymentBankAccountDrawerDraftInputQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type EmploymentBankAccountDrawerDraftInputQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | { readonly __typename?: 'B2BContractDraft', readonly entityVersion: number, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
            | { readonly __typename?: 'EmploymentContractDraft', readonly entityVersion: number, readonly promiseeTransferBankAccount?: (
                { readonly __typename?: 'BankAccount' }
                & BankAccountFragment
              ) | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
            | { readonly __typename?: 'SubcontractDraft', readonly entityVersion: number, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } }
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type EmploymentBankAccountDrawerUpdateEmploymentDraftMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  promiseeTransferBankAccount: ClearableBankAccountInput;
}>;


export type EmploymentBankAccountDrawerUpdateEmploymentDraftMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateEmploymentDraft:
        | { readonly __typename?: 'EmploymentContractDraft', readonly id: string, readonly entityVersion: number, readonly promiseeTransferBankAccount?: (
            { readonly __typename?: 'BankAccount' }
            & BankAccountFragment
          ) | null }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type EmploymentBankAccountDrawerUpdateContractMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  promiseeTransferBankAccount?: InputMaybe<BankAccountInput>;
}>;


export type EmploymentBankAccountDrawerUpdateContractMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly promiseeTransferBankAccount:
          | { readonly __typename?: 'AccessGranted__BankAccount', readonly value: (
              { readonly __typename?: 'BankAccount' }
              & BankAccountFragment
            ) }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type EmploymentContractDraftDrawerDraftB2BContractDraftFragment = { readonly __typename?: 'B2BContractDraft', readonly id: string, readonly entityVersion: number };

export type EmploymentContractDraftDrawerDraftEmploymentContractDraftFragment = { readonly __typename?: 'EmploymentContractDraft', readonly name: string, readonly type: EmploymentContractType, readonly paidLeaveEntitlement?: number | null, readonly startDate?: Date | null, readonly expectedEndDate?: Date | null, readonly position?: string | null, readonly scopeOfWork?: string | null, readonly id: string, readonly entityVersion: number, readonly holidayCalendar?: { readonly __typename?: 'HolidayCalendar', readonly id: HolidayCalendarId } | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly promisor: (
    { readonly __typename?: 'Company' }
    & CompanyAutocompleteCompanyFragment
  ) };

export type EmploymentContractDraftDrawerDraftSubcontractDraftFragment = { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number };

export type EmploymentContractDraftDrawerDraftFragment =
  | EmploymentContractDraftDrawerDraftB2BContractDraftFragment
  | EmploymentContractDraftDrawerDraftEmploymentContractDraftFragment
  | EmploymentContractDraftDrawerDraftSubcontractDraftFragment
;

export type EmploymentContractDraftDrawerUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly email: string, readonly idType:
    | { readonly __typename?: 'AccessGranted__OptionalIDType', readonly value?: IdType | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly idNumber:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly pesel:
    | { readonly __typename?: 'AccessGranted__OptionalPESEL', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly birthDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly isStudent:
    | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly isStudentRevisionDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly nextMedicalExaminationDate:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly emergencyContact:
    | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly address:
    | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly mailingAddress:
    | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type EmploymentContractDraftDrawerInputQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type EmploymentContractDraftDrawerInputQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User', readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | (
              { readonly __typename?: 'B2BContractDraft' }
              & EmploymentContractDraftDrawerDraftB2BContractDraftFragment
            )
            | (
              { readonly __typename?: 'EmploymentContractDraft' }
              & EmploymentContractDraftDrawerDraftEmploymentContractDraftFragment
            )
            | (
              { readonly __typename?: 'SubcontractDraft' }
              & EmploymentContractDraftDrawerDraftSubcontractDraftFragment
            )
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly startDate: Date, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string } } }
            | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly startDate: Date, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string } } }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly startDate: Date, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string } } }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
      & EmploymentContractDraftDrawerUserFragment
    )
   };

export type EmploymentContractDraftDrawerCreateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  contractId: Scalars['ContractId']['input'];
  type: EmploymentContractType;
  promisorId: Scalars['CompanyId']['input'];
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  expectedEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  holidayCalendarId?: InputMaybe<HolidayCalendarId>;
  scopeOfWork?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  paidLeaveEntitlement?: InputMaybe<Scalars['Days']['input']>;
}>;


export type EmploymentContractDraftDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly createEmploymentContractDraft:
      | (
        { readonly __typename?: 'EmploymentContractDraft' }
        & EmploymentContractDraftDrawerDraftEmploymentContractDraftFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type EmploymentContractDraftDrawerUpdateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  startDate?: InputMaybe<ClearableLocalDateInput>;
  expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
  holidayCalendarId?: InputMaybe<ClearableHolidayCalendarIdInput>;
  scopeOfWork?: InputMaybe<ClearableStringInput>;
  position?: InputMaybe<ClearableStringInput>;
  paidLeaveEntitlement?: InputMaybe<ClearableDaysInput>;
  promisorId: Scalars['CompanyId']['input'];
}>;


export type EmploymentContractDraftDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateEmploymentDraft:
        | (
          { readonly __typename?: 'EmploymentContractDraft' }
          & EmploymentContractDraftDrawerDraftEmploymentContractDraftFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type EmploymentContractDraftDrawerUpdateUserMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  pesel?: InputMaybe<ClearablePeselInput>;
  birthDate?: InputMaybe<ClearableLocalDateInput>;
  address?: InputMaybe<ClearableAddressInput>;
  mailingAddress?: InputMaybe<ClearableAddressInput>;
  idType?: InputMaybe<ClearableIdTypeInput>;
  idNumber?: InputMaybe<ClearableStringInput>;
  isStudent: Scalars['Boolean']['input'];
  isStudentRevisionDate?: InputMaybe<ClearableLocalDateInput>;
  nextMedicalExaminationDate?: InputMaybe<ClearableLocalDateInput>;
  emergencyContact?: InputMaybe<ClearableStringInput>;
}>;


export type EmploymentContractDraftDrawerUpdateUserMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & EmploymentContractDraftDrawerUserFragment
      )
     } };

export type EmploymentSalariesListItemSalaryStateChangeFragment = { readonly __typename?: 'ListOfContractSalaryDetailsResponse', readonly value: ReadonlyArray<
    | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
        | (
          { readonly __typename?: 'IncompleteData' }
          & SalaryStateIncompleteDataFragment
        )
        | (
          { readonly __typename?: 'PaymentDisbursed' }
          & SalaryStatePaymentDisbursedFragment
        )
        | (
          { readonly __typename?: 'Ready' }
          & SalaryStateReadyFragment
        )
       }
    | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
        | (
          { readonly __typename?: 'IncompleteData' }
          & SalaryStateIncompleteDataFragment
        )
        | (
          { readonly __typename?: 'PaymentDisbursed' }
          & SalaryStatePaymentDisbursedFragment
        )
        | (
          { readonly __typename?: 'Ready' }
          & SalaryStateReadyFragment
        )
       }
  > };

export type EmploymentSalariesListItemMarkAsDisbursedMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  filter: FilterContractSalaryDetailsInput;
}>;


export type EmploymentSalariesListItemMarkAsDisbursedMutation = { readonly __typename?: 'Mutation', readonly markPaymentAsDisbursed:
    | (
      { readonly __typename?: 'ListOfContractSalaryDetailsResponse' }
      & EmploymentSalariesListItemSalaryStateChangeFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EmploymentSalariesListItemUnmarkAsDisbursedMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  filter: FilterContractSalaryDetailsInput;
}>;


export type EmploymentSalariesListItemUnmarkAsDisbursedMutation = { readonly __typename?: 'Mutation', readonly unmarkPaymentAsDisbursed:
    | (
      { readonly __typename?: 'ListOfContractSalaryDetailsResponse' }
      & EmploymentSalariesListItemSalaryStateChangeFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EmploymentSalaryDetailsDrawerWorkTransferFragment = { readonly __typename?: 'WorkTransferProtocol', readonly id: string, readonly description?: string | null, readonly payload:
    | { readonly __typename?: 'File', readonly value: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly downloadUrl: string, readonly openUrl: string, readonly fileName: string } }
    | { readonly __typename?: 'NoWorkToBeTransferedThisMonth' }
  , readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
   };

export type EmploymentSalaryDetailsDrawerAccountingDataFragment = { readonly __typename?: 'AccountingData', readonly taxPrepayment: number, readonly taxRefund?: number | null, readonly zusContribution: number, readonly ppkAmount?: number | null, readonly maternityLeaveAllowance?: number | null, readonly paternityLeaveAllowance?: number | null, readonly sicknessBenefit?: number | null, readonly overtimePayout?: number | null, readonly transferAmount: number, readonly zusContributionDetails?: { readonly __typename?: 'ZusContributionDetails', readonly employeeSocialContribution: number, readonly employerSocialContribution: number, readonly healthInsuranceContribution: number } | null, readonly ppkDetails?: { readonly __typename?: 'PpkDetails', readonly employee: number, readonly employer: number } | null };

export type EmploymentSalariesDetailsDrawerBenefitValueFragment = { readonly __typename?: 'BenefitValue', readonly variant: { readonly __typename?: 'BenefitVariant', readonly id: string, readonly productId: string, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
        { readonly __typename?: 'BenefitVariantRate' }
        & BenefitVariantRateFragment
      ) | null }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
        { readonly __typename?: 'BenefitVariantRate' }
        & BenefitVariantRateFragment
      ) | null }, readonly parent:
      | { readonly __typename?: 'Benefit', readonly alternativeBenefitsGroupId: string, readonly id: string, readonly name: string }
      | { readonly __typename?: 'SubBenefit', readonly alternativeBenefitsGroupId: string, readonly id: string, readonly name: string }
     }, readonly refundedValue?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly notRefundedValue?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly totalValue: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type EmploymentSalaryIncomeDetailsFragment = { readonly __typename?: 'IncomeDetails', readonly totalWorkTime: number, readonly overtimeWorkTime: number, readonly standardWorkTime: number, readonly rateDetails?: (
    { readonly __typename?: 'RateDetails' }
    & RateDetailsFragment
  ) | null, readonly remoteWorkReimbursement?: { readonly __typename?: 'RemoteWorkReimbursement', readonly time: number } | null, readonly onCallLogs: ReadonlyArray<{ readonly __typename?: 'OnCallLog', readonly multiplier: OnCallMultiplier, readonly shifts: number }>, readonly totalPayout: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly overtimeIncome: ReadonlyArray<(
    { readonly __typename?: 'HourlyIncomeRow' }
    & HourlyIncomeRowFragment
    & IncomeRowHourlyIncomeRowFragment
  )>, readonly totalValueStandardTimeIncome: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueOvertimeIncome: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly standardTimeIncome: ReadonlyArray<
    | (
      { readonly __typename?: 'DailyIncomeRow' }
      & IncomeRowDailyIncomeRowFragment
    )
    | (
      { readonly __typename?: 'HourlyIncomeRow' }
      & IncomeRowHourlyIncomeRowFragment
    )
    | (
      { readonly __typename?: 'MonthlyIncomeRow' }
      & IncomeRowMonthlyIncomeRowFragment
    )
  >, readonly totalValueOnCalls: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly bonusesValueByCategory: ReadonlyArray<{ readonly __typename?: 'BonusCategoryAmount', readonly bonusCategory: BonusType, readonly amount: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) }>, readonly totalValueStandardTimeIncomeIncludingBenefits: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueOvertimeIncomeIncludingBenefits: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly benefitsValue: { readonly __typename?: 'BenefitsValue', readonly totalValueRefunded: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly refunded: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & EmploymentSalariesDetailsDrawerBenefitValueFragment
    )>, readonly totalValueNotRefunded: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly notRefunded: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & EmploymentSalariesDetailsDrawerBenefitValueFragment
    )>, readonly totalValueThirdParty: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly thirdParty: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & EmploymentSalariesDetailsDrawerBenefitValueFragment
    )>, readonly totalValueMeansOfProduction: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly meansOfProduction: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & EmploymentSalariesDetailsDrawerBenefitValueFragment
    )>, readonly totalValueAll: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) } };

export type EmploymentSalaryDetailsDrawerQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  monthStart: Scalars['LocalDate']['input'];
  monthEnd: Scalars['LocalDate']['input'];
}>;


export type EmploymentSalaryDetailsDrawerQuery = { readonly __typename?: 'Query', readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportRecords: { readonly __typename?: 'TimeReportRecords', readonly work: ReadonlyArray<{ readonly __typename?: 'WorkRecord', readonly id: string, readonly date: Date, readonly overtime: boolean, readonly duration?: number | null, readonly workTime?: { readonly __typename?: 'WorkTime', readonly timeFrom: Date, readonly timeTo?: Date | null, readonly break?: number | null } | null }>, readonly absence: ReadonlyArray<{ readonly __typename?: 'AbsenceRecord', readonly id: string, readonly from: Date, readonly to: Date, readonly absenceType: AbsenceType, readonly customDurationPerDay?: number | null }> }, readonly timeReportStats?:
        | { readonly __typename?: 'B2BTimeReportStats', readonly overtime: number, readonly timeBalanceAtEndOfMonth: { readonly __typename?: 'TimeBalance', readonly reportedStandardWorkTime: number, readonly currentTimeRequirement: number }, readonly incomeDetails:
            | { readonly __typename?: 'AccessGranted__ListOfIncomeDetails', readonly value: ReadonlyArray<(
                { readonly __typename?: 'IncomeDetails' }
                & EmploymentSalaryIncomeDetailsFragment
              )> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'EmploymentTimeReportStats', readonly overtime: number, readonly flexTime?: { readonly __typename?: 'TimeBalance', readonly balance: number, readonly period: { readonly __typename?: 'ClosedEndMonthRange', readonly from: Date, readonly to: Date } } | null, readonly reportedLeaveDays: (
            { readonly __typename?: 'ReportedLeaveDays' }
            & ReportedLeaveDaysFragment
          ), readonly timeBalanceAtEndOfMonth: { readonly __typename?: 'TimeBalance', readonly reportedStandardWorkTime: number, readonly currentTimeRequirement: number }, readonly incomeDetails:
            | { readonly __typename?: 'AccessGranted__ListOfIncomeDetails', readonly value: ReadonlyArray<(
                { readonly __typename?: 'IncomeDetails' }
                & EmploymentSalaryIncomeDetailsFragment
              )> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
       | null }
  , readonly contractSalaryDetails:
    | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
        | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly entityVersion: number, readonly transferTitle: string, readonly transferAmount?: number | null, readonly note?: string | null, readonly flag?: ContractSalaryDetailsFlagColor | null, readonly totalPayout?: { readonly __typename?: 'NetGross', readonly gross: number } | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null, readonly salaryState:
            | (
              { readonly __typename?: 'IncompleteData' }
              & SalaryStateIncompleteDataFragment
            )
            | (
              { readonly __typename?: 'PaymentDisbursed' }
              & SalaryStatePaymentDisbursedFragment
            )
            | (
              { readonly __typename?: 'Ready' }
              & SalaryStateReadyFragment
            )
           }
        | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly entityVersion: number, readonly transferTitle: string, readonly transferAmount?: number | null, readonly note?: string | null, readonly flag?: ContractSalaryDetailsFlagColor | null, readonly contract: (
            { readonly __typename?: 'EmploymentContract' }
            & SharedSalaryEmploymentContractFragment
          ), readonly accountingData?: (
            { readonly __typename?: 'AccountingData' }
            & EmploymentSalaryDetailsDrawerAccountingDataFragment
          ) | null, readonly workTransferProtocols: ReadonlyArray<(
            { readonly __typename?: 'WorkTransferProtocol' }
            & EmploymentSalaryDetailsDrawerWorkTransferFragment
          )>, readonly totalPayout?: { readonly __typename?: 'NetGross', readonly gross: number } | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null, readonly salaryState:
            | (
              { readonly __typename?: 'IncompleteData' }
              & SalaryStateIncompleteDataFragment
            )
            | (
              { readonly __typename?: 'PaymentDisbursed' }
              & SalaryStatePaymentDisbursedFragment
            )
            | (
              { readonly __typename?: 'Ready' }
              & SalaryStateReadyFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly contractSalaryDetailsAdditionalData:
    | { readonly __typename?: 'ContractSalaryDetailsAdditionalData', readonly contractId: string, readonly yearMonth: Date, readonly timeReportValidations: ReadonlyArray<
        | (
          { readonly __typename?: 'IncompleteEntries' }
          & TimeReportValidationIncompleteEntriesFragment
        )
        | (
          { readonly __typename?: 'MissingEntries' }
          & TimeReportValidationMissingEntriesFragment
        )
        | (
          { readonly __typename?: 'NegativeFlexTimeBalance' }
          & TimeReportValidationNegativeFlexTimeBalanceFragment
        )
      >, readonly incomeDetails: (
        { readonly __typename?: 'IncomeDetails' }
        & EmploymentSalaryIncomeDetailsFragment
      ) }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EmploymentSalaryDetailsDrawerRefetchSalaryStateQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
}>;


export type EmploymentSalaryDetailsDrawerRefetchSalaryStateQuery = { readonly __typename?: 'Query', readonly contractSalaryDetails:
    | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
        | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
            | (
              { readonly __typename?: 'IncompleteData' }
              & SalaryStateIncompleteDataFragment
            )
            | (
              { readonly __typename?: 'PaymentDisbursed' }
              & SalaryStatePaymentDisbursedFragment
            )
            | (
              { readonly __typename?: 'Ready' }
              & SalaryStateReadyFragment
            )
           }
        | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
            | (
              { readonly __typename?: 'IncompleteData' }
              & SalaryStateIncompleteDataFragment
            )
            | (
              { readonly __typename?: 'PaymentDisbursed' }
              & SalaryStatePaymentDisbursedFragment
            )
            | (
              { readonly __typename?: 'Ready' }
              & SalaryStateReadyFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  transferDeduction: ClearableTransferDeductionInput;
}>;


export type EmploymentSalaryDetailsDrawerUpdateTransferDeductionMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly update:
      | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
          | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly transferAmount?: number | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null }
          | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly transferAmount?: number | null, readonly accountingData?: (
              { readonly __typename?: 'AccountingData' }
              & EmploymentSalaryDetailsDrawerAccountingDataFragment
            ) | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null }
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type EmploymentSalaryDetailsDrawerUpdateAccountingDataMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  accountingData: ClearableAccountingDataInput;
}>;


export type EmploymentSalaryDetailsDrawerUpdateAccountingDataMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly update:
      | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
          | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly transferAmount?: number | null, readonly entityVersion: number, readonly salaryState:
              | (
                { readonly __typename?: 'IncompleteData' }
                & SalaryStateIncompleteDataFragment
              )
              | (
                { readonly __typename?: 'PaymentDisbursed' }
                & SalaryStatePaymentDisbursedFragment
              )
              | (
                { readonly __typename?: 'Ready' }
                & SalaryStateReadyFragment
              )
             }
          | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly transferAmount?: number | null, readonly entityVersion: number, readonly accountingData?: (
              { readonly __typename?: 'AccountingData' }
              & EmploymentSalaryDetailsDrawerAccountingDataFragment
            ) | null, readonly salaryState:
              | (
                { readonly __typename?: 'IncompleteData' }
                & SalaryStateIncompleteDataFragment
              )
              | (
                { readonly __typename?: 'PaymentDisbursed' }
                & SalaryStatePaymentDisbursedFragment
              )
              | (
                { readonly __typename?: 'Ready' }
                & SalaryStateReadyFragment
              )
             }
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type EmploymentSalaryDetailsDrawerUpdateWorkTransferMutationVariables = Exact<{
  id: Scalars['WorkTransferProtocolId']['input'];
  description?: InputMaybe<ClearableStringInput>;
  payload?: InputMaybe<Scalars['Upload']['input']>;
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
  approved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EmploymentSalaryDetailsDrawerUpdateWorkTransferMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly update:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & EmploymentSalaryDetailsDrawerWorkTransferFragment
        )
       } } };

export type EmploymentSalaryDetailsDrawerCreateWorkTransferMutationVariables = Exact<{
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
  id: Scalars['WorkTransferProtocolId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['Upload']['input'];
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
  approved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EmploymentSalaryDetailsDrawerCreateWorkTransferMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly create:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & EmploymentSalaryDetailsDrawerWorkTransferFragment
        )
       } } };

export type EmploymentSalaryDetailsDrawerRemoveWorkTransferMutationVariables = Exact<{
  id: Scalars['WorkTransferProtocolId']['input'];
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type EmploymentSalaryDetailsDrawerRemoveWorkTransferMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly remove:
        | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type EmploymentSalaryDetailsDrawerMarkNoWorkMutationVariables = Exact<{
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type EmploymentSalaryDetailsDrawerMarkNoWorkMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly markNoWorkToBeTransferedThisMonth:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & EmploymentSalaryDetailsDrawerWorkTransferFragment
        )
       } } };

export type ExtendLeadPeriodModalUpsertLeadAssignmentMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  periods: ReadonlyArray<ProjectRoleAssignmentPeriodInput> | ProjectRoleAssignmentPeriodInput;
}>;


export type ExtendLeadPeriodModalUpsertLeadAssignmentMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly projectAssignments: { readonly __typename?: 'ProjectAssignmentOperations', readonly upsertLeadAssignment:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'ProjectRoleAssignment', readonly project: (
            { readonly __typename?: 'Project' }
            & ProjectLeadFragment
          ) }
       } } };

export type FriendsAndFamilyBenefitVariantFragment = { readonly __typename?: 'BenefitVariant', readonly id: string, readonly productId: string, readonly startDate: Date, readonly endDate?: Date | null, readonly buyerType: BenefitBuyerType, readonly contractTypes: ReadonlyArray<ContractType>, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly parent:
    | { readonly __typename?: 'Benefit', readonly id: string, readonly name: string, readonly alternativeBenefitsGroupId: string, readonly benefitParent: BenefitGroupType }
    | { readonly __typename?: 'SubBenefit', readonly id: string, readonly name: string, readonly alternativeBenefitsGroupId: string }
  , readonly additionalPeople?:
    | (
      { readonly __typename?: 'BenefitAdditionalAdults' }
      & BenefitAdditionalPeopleBenefitAdditionalAdultsFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalFamily' }
      & BenefitAdditionalPeopleBenefitAdditionalFamilyFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalKids' }
      & BenefitAdditionalPeopleBenefitAdditionalKidsFragment
    )
   | null };

export type FriendsAndFamilyQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type FriendsAndFamilyQuery = { readonly __typename?: 'Query', readonly benefits:
    | { readonly __typename?: 'ListOfBenefitGroupResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'BenefitGroup', readonly benefits: { readonly __typename?: 'ConjunctiveBenefits', readonly manyOf: ReadonlyArray<{ readonly __typename?: 'AlternativeBenefits', readonly alternativeBenefitsGroupId: string, readonly oneOf: ReadonlyArray<{ readonly __typename?: 'Benefit', readonly id: string }> }> } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly createdAt: Date, readonly firstName: string, readonly lastName: string, readonly externalBeneficiaries:
        | { readonly __typename?: 'AccessGranted__ListOfExternalBeneficiary', readonly value: ReadonlyArray<{ readonly __typename?: 'ExternalBeneficiary', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly address: (
              { readonly __typename?: 'Address' }
              & AddressFragment
            ), readonly assignedVariants: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly note?: string | null, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }> }, readonly buyerType: { readonly __typename?: 'TimeBasedBenefitBuyerType', readonly value: BenefitBuyerType, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly activityId: string, readonly applyDate: Date, readonly value: BenefitBuyerType }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly activityId: string, readonly applyDate: Date, readonly value: BenefitBuyerType }> }, readonly externalBeneficiaries: { readonly __typename?: 'TimeBasedListOfExternalBeneficiary', readonly value: ReadonlyArray<(
                  { readonly __typename?: 'ExternalBeneficiary' }
                  & ExternalBeneficiaryFragment
                )>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly activityId: string, readonly applyDate: Date, readonly value: ReadonlyArray<(
                    { readonly __typename?: 'ExternalBeneficiary' }
                    & ExternalBeneficiaryFragment
                  )> }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly activityId: string, readonly applyDate: Date, readonly value: ReadonlyArray<(
                    { readonly __typename?: 'ExternalBeneficiary' }
                    & ExternalBeneficiaryFragment
                  )> }> }, readonly invoiceTo: { readonly __typename?: 'TimeBasedOptClearableExternalBeneficiary', readonly value?: (
                  { readonly __typename?: 'ExternalBeneficiary' }
                  & ExternalBeneficiaryFragment
                ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
                      { readonly __typename?: 'ExternalBeneficiary' }
                      & ExternalBeneficiaryFragment
                    ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
                      { readonly __typename?: 'ExternalBeneficiary' }
                      & ExternalBeneficiaryFragment
                    ) | null } }> }, readonly variant: { readonly __typename?: 'TimeBasedBenefitVariant', readonly value: (
                  { readonly __typename?: 'BenefitVariant' }
                  & FriendsAndFamilyBenefitVariantFragment
                ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly activityId: string, readonly applyDate: Date, readonly value: (
                    { readonly __typename?: 'BenefitVariant' }
                    & FriendsAndFamilyBenefitVariantFragment
                  ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly activityId: string, readonly applyDate: Date, readonly value: (
                    { readonly __typename?: 'BenefitVariant' }
                    & FriendsAndFamilyBenefitVariantFragment
                  ) }> } }> }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type InvoiceTransferLinksDraweInvoiceFragment = { readonly __typename?: 'SalesInvoice', readonly id: number, readonly number: string, readonly status: SalesInvoiceStatus };

export type InvoiceTransferLinksDrawerPaymentConnectionFragment = { readonly __typename?: 'PaymentConnection', readonly tpe: PaymentConnectionType, readonly transfer: { readonly __typename?: 'BankIncomeTransfer', readonly id: string, readonly amount: number, readonly currency: string, readonly fromName: string, readonly toName: string, readonly title: string, readonly bookDate: Date, readonly discrepancy: number, readonly status: BankTransferStatus }, readonly invoice: (
    { readonly __typename?: 'SalesInvoice' }
    & InvoiceTransferLinksDraweInvoiceFragment
  ) };

export type InvoiceTransferLinksDrawerDetailsQueryVariables = Exact<{
  invoiceId: Scalars['SalesInvoiceId']['input'];
}>;


export type InvoiceTransferLinksDrawerDetailsQuery = { readonly __typename?: 'Query', readonly salesInvoiceDetails:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'SalesInvoiceDetails', readonly correctedBy?: (
        { readonly __typename?: 'SalesInvoice' }
        & SalesInvoicesInvoiceFragment
      ) | null, readonly invoice: (
        { readonly __typename?: 'SalesInvoice' }
        & SalesInvoicesInvoiceFragment
      ), readonly connectedTransfers: ReadonlyArray<(
        { readonly __typename?: 'PaymentConnection' }
        & InvoiceTransferLinksDrawerPaymentConnectionFragment
      )>, readonly correctsInvoice?: { readonly __typename?: 'SalesInvoice', readonly id: number, readonly number: string } | null }
   };

export type InvoiceTransferLinksDrawerCreateConnectionMutationVariables = Exact<{
  transferId: Scalars['BankTransferId']['input'];
  invoiceId: Scalars['SalesInvoiceId']['input'];
}>;


export type InvoiceTransferLinksDrawerCreateConnectionMutation = { readonly __typename?: 'Mutation', readonly createPaymentConnection:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'PaymentConnection' }
      & InvoiceTransferLinksDrawerPaymentConnectionFragment
    )
   };

export type InvoiceTransferLinksDrawerDeleteConnectionMutationVariables = Exact<{
  transferId: Scalars['BankTransferId']['input'];
  invoiceId: Scalars['SalesInvoiceId']['input'];
}>;


export type InvoiceTransferLinksDrawerDeleteConnectionMutation = { readonly __typename?: 'Mutation', readonly deletePaymentConnection:
    | (
      { readonly __typename?: 'BankIncomeTransfer', readonly discrepancy: number, readonly connectedPayments: ReadonlyArray<(
        { readonly __typename?: 'PaymentConnection' }
        & TransferDetailsDrawerPaymentConnectionFragment
      )> }
      & BankTransfersBankTransferBankIncomeTransferFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type KeyPeopleUserAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter: FilterUserInput;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  first: Scalars['Int']['input'];
}>;


export type KeyPeopleUserAutocompleteQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: (
          { readonly __typename?: 'User', readonly avatar?: string | null }
          & UserAutocompleteUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type KeyPeopleUserMembershipQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type KeyPeopleUserMembershipQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly assignedProjects:
          | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }> }> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
   };

export type KeyPeopleUpsertLeadAssignmentMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  periods: ReadonlyArray<ProjectRoleAssignmentPeriodInput> | ProjectRoleAssignmentPeriodInput;
}>;


export type KeyPeopleUpsertLeadAssignmentMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly projectAssignments: { readonly __typename?: 'ProjectAssignmentOperations', readonly upsertLeadAssignment:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'ProjectRoleAssignment' }
          & ProjectRoleAssignmentFragment
        )
       } } };

export type KeyPeopleUpsertOwnerAssignmentMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  periods: ReadonlyArray<ProjectRoleAssignmentPeriodInput> | ProjectRoleAssignmentPeriodInput;
}>;


export type KeyPeopleUpsertOwnerAssignmentMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly projectAssignments: { readonly __typename?: 'ProjectAssignmentOperations', readonly upsertOwnerAssignment:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'ProjectRoleAssignment' }
          & ProjectRoleAssignmentFragment
        )
       } } };

export type KeyPeopleUpsertAccountManagerAssignmentMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  periods: ReadonlyArray<ProjectRoleAssignmentPeriodInput> | ProjectRoleAssignmentPeriodInput;
}>;


export type KeyPeopleUpsertAccountManagerAssignmentMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly projectAssignments: { readonly __typename?: 'ProjectAssignmentOperations', readonly upsertAccountManagerAssignment:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'ProjectRoleAssignment' }
          & ProjectRoleAssignmentFragment
        )
       } } };

export type ManageKeyPeopleDrawerDataQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type ManageKeyPeopleDrawerDataQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Project', readonly assignedUsers: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly avatar?: string | null, readonly firstName: string, readonly lastName: string }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }> }> }
      & KeyPeopleProjectFragment
    )
   };

export type ManageProjectTimelineDrawerProjectFragment = { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly statusHistory: ReadonlyArray<{ readonly __typename?: 'ProjectStatusHistoryEntry', readonly status: ProjectStatus, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }> };

export type ManageProjectTimelineDrawerDataQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type ManageProjectTimelineDrawerDataQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Project' }
      & ManageProjectTimelineDrawerProjectFragment
    )
   };

export type ManageProjectTimelineDrawerUpdateMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  statusHistory: ReadonlyArray<ProjectStatusHistoryEntryInput> | ProjectStatusHistoryEntryInput;
}>;


export type ManageProjectTimelineDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly update:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'Project' }
        & ManageProjectTimelineDrawerProjectFragment
      )
     } };

export type OfficeCatalogueDeskFragment = { readonly __typename?: 'Desk', readonly id: string, readonly name: string, readonly monitors: number, readonly standing: boolean, readonly pedestalNumber?: string | null, readonly blocked: boolean };

export type OfficeCatalogueRoomFragment = { readonly __typename?: 'Room', readonly id: string, readonly name: string, readonly securityZone?: SecurityZone | null, readonly blocked: boolean, readonly restrictedToSpace?: { readonly __typename?: 'Space', readonly id: string, readonly name: string } | null, readonly desks: ReadonlyArray<(
    { readonly __typename?: 'Desk' }
    & OfficeCatalogueDeskFragment
  )> };

export type OfficeCatalogueParkingSpotFragment = { readonly __typename?: 'ParkingSpot', readonly id: string, readonly number: string, readonly name: string, readonly guest: boolean, readonly blocked: boolean };

export type OfficeCatalogueDeskAssignmentFragment = { readonly __typename?: 'DeskAssignment', readonly id: string, readonly from: Date, readonly to?: Date | null, readonly desk: { readonly __typename?: 'ReservedResource', readonly id: string }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null } };

export type OfficeCatalogueQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type OfficeCatalogueQuery = { readonly __typename?: 'Query', readonly officeCatalogue:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeCatalogue', readonly rooms: ReadonlyArray<(
        { readonly __typename?: 'Room' }
        & OfficeCatalogueRoomFragment
      )>, readonly parkingSpots: ReadonlyArray<(
        { readonly __typename?: 'ParkingSpot' }
        & OfficeCatalogueParkingSpotFragment
      )> }
  , readonly deskAssignments:
    | { readonly __typename?: 'ListOfDeskAssignmentResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'DeskAssignment' }
        & OfficeCatalogueDeskAssignmentFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type OfficeReservationRequestListItemApproveMutationVariables = Exact<{
  requestId: Scalars['ReservationRequestId']['input'];
}>;


export type OfficeReservationRequestListItemApproveMutation = { readonly __typename?: 'Mutation', readonly approveOfficeReservation:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'ReservationRequest', readonly requestId: string }
   };

export type OfficeReservationsListFiltersOfficesQueryVariables = Exact<{ [key: string]: never; }>;


export type OfficeReservationsListFiltersOfficesQuery = { readonly __typename?: 'Query', readonly offices:
    | { readonly __typename?: 'ListOfOfficeResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly physical: boolean }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type OfficeSettingsMapFileFragment = { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly fileName: string, readonly downloadUrl: string };

export type OfficeSettingsQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type OfficeSettingsQuery = { readonly __typename?: 'Query', readonly officeSettings:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeSettings', readonly receptionEmails: ReadonlyArray<string>, readonly parkingInformation?: string | null, readonly office: { readonly __typename?: 'Office', readonly officeId: string }, readonly floorMap?: (
        { readonly __typename?: 'DownloadableExternallyHostedFileUrl' }
        & OfficeSettingsMapFileFragment
      ) | null, readonly parkingMap?: (
        { readonly __typename?: 'DownloadableExternallyHostedFileUrl' }
        & OfficeSettingsMapFileFragment
      ) | null }
   };

export type OfficeSpotsUserFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null };

export type OfficeSpotsReservationFragment = { readonly __typename?: 'OfficeReservation', readonly id: string, readonly requestId: string, readonly date: Date, readonly kind: ResourceKind, readonly plateNumber?: string | null, readonly notes?: string | null, readonly guestEmails: ReadonlyArray<string>, readonly resource: { readonly __typename?: 'ReservedResource', readonly id: string, readonly name: string }, readonly user: (
    { readonly __typename?: 'User' }
    & OfficeSpotsUserFragment
  ), readonly approval:
    | { readonly __typename: 'Approved' }
    | { readonly __typename: 'NotRequired' }
    | { readonly __typename: 'PendingApproval' }
   };

export type OfficeSpotsQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type OfficeSpotsQuery = { readonly __typename?: 'Query', readonly office:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null, readonly blocked: boolean }
  , readonly officeSettings:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeSettings', readonly office: { readonly __typename?: 'Office', readonly officeId: string }, readonly floorMap?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly fileName: string, readonly downloadUrl: string } | null, readonly parkingMap?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly fileName: string, readonly downloadUrl: string } | null }
  , readonly officeReservationSettings:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeReservationSettings', readonly deskMaxAdvanceDays: number, readonly parkingMaxAdvanceDays: number }
  , readonly officeCatalogue:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeCatalogue', readonly rooms: ReadonlyArray<{ readonly __typename?: 'Room', readonly id: string, readonly name: string, readonly securityZone?: SecurityZone | null, readonly blocked: boolean, readonly desks: ReadonlyArray<{ readonly __typename?: 'Desk', readonly id: string, readonly name: string, readonly monitors: number, readonly standing: boolean, readonly blocked: boolean }> }>, readonly parkingSpots: ReadonlyArray<{ readonly __typename?: 'ParkingSpot', readonly id: string, readonly number: string, readonly name: string, readonly guest: boolean, readonly blocked: boolean }> }
   };

export type OfficeSpotsBookingsQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  first: Scalars['Int']['input'];
}>;


export type OfficeSpotsBookingsQuery = { readonly __typename?: 'Query', readonly officeReservations:
    | { readonly __typename?: 'FSPResponseOfficeReservation', readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeOfficeReservation', readonly node: (
          { readonly __typename?: 'OfficeReservation' }
          & OfficeSpotsReservationFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly deskAssignments:
    | { readonly __typename?: 'ListOfDeskAssignmentResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'DeskAssignment', readonly id: string, readonly from: Date, readonly to?: Date | null, readonly desk: { readonly __typename?: 'ReservedResource', readonly id: string, readonly name: string }, readonly user: (
          { readonly __typename?: 'User' }
          & OfficeSpotsUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type OrderPayrollTransfersModalOrderMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  filter: FilterContractSalaryDetailsInput;
}>;


export type OrderPayrollTransfersModalOrderMutation = { readonly __typename?: 'Mutation', readonly orderPayrollTransfers:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'PayrollTransfersOrderView' }
      & PayrollTransfersOrderResultModalResultFragment
    )
   };

export type OtherEmployeeInformationUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly consentedForUseOfImage: boolean, readonly documentsDirectory:
    | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly personalDataProcessingAuthorization:
    | { readonly __typename?: 'AccessGranted__PersonalDataProcessingAuthorization', readonly value: { readonly __typename?: 'PersonalDataProcessingAuthorization', readonly isAuthorized: boolean, readonly document:
          | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type OtherEmployeeInformationDrawerQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type OtherEmployeeInformationDrawerQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & OtherEmployeeInformationUserFragment
    )
   };

export type OtherEmployeeInformationDrawerUpdateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  personalDataProcessingAuthorization?: InputMaybe<ClearableUriInput>;
  consentedForUseOfImage: Scalars['Boolean']['input'];
  documentsDirectory?: InputMaybe<Scalars['URI']['input']>;
}>;


export type OtherEmployeeInformationDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & OtherEmployeeInformationUserFragment
      )
     } };

export type ParkingSpotDrawerParkingSpotFragment = { readonly __typename?: 'ParkingSpot', readonly id: string, readonly number: string, readonly name: string, readonly guest: boolean };

export type ParkingSpotDrawerInitialDataQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type ParkingSpotDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly officeCatalogue:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeCatalogue', readonly parkingSpots: ReadonlyArray<(
        { readonly __typename?: 'ParkingSpot' }
        & ParkingSpotDrawerParkingSpotFragment
      )> }
   };

export type ParkingSpotDrawerCreateMutationVariables = Exact<{
  id: Scalars['ParkingSpotId']['input'];
  officeId: Scalars['OfficeId']['input'];
  number: Scalars['String']['input'];
  name: Scalars['String']['input'];
  guest: Scalars['Boolean']['input'];
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ParkingSpotDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createParkingSpot:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'ParkingSpot' }
      & OfficeCatalogueParkingSpotFragment
    )
   };

export type ParkingSpotDrawerUpdateMutationVariables = Exact<{
  parkingSpotId: Scalars['ParkingSpotId']['input'];
  parkingSpot: UpdateParkingSpotInput;
}>;


export type ParkingSpotDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateParkingSpot:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'ParkingSpot' }
      & ParkingSpotDrawerParkingSpotFragment
    )
   };

export type PaymentDetailsDraftDrawerPromiseeCompanyFragment = { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly isPolishVat: { readonly __typename?: 'TimeBasedValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: { readonly __typename?: 'ValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: boolean } } };

export type PaymentDetailsDraftDrawerOnCallFragment = { readonly __typename?: 'OnCallRate', readonly night: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly holiday: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly weekend: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type PaymentDetailsDraftDrawerContractDraftB2BContractDraftFragment = { readonly __typename?: 'B2BContractDraft', readonly currency?: string | null, readonly separatePaymentForBenefits: boolean, readonly id: string, readonly entityVersion: number, readonly vat?:
    | (
      { readonly __typename?: 'VatApplied' }
      & VatTypeVatAppliedFragment
    )
    | (
      { readonly __typename?: 'VatNotApplied' }
      & VatTypeVatNotAppliedFragment
    )
   | null, readonly promiseeCompany?: (
    { readonly __typename?: 'Company' }
    & PaymentDetailsDraftDrawerPromiseeCompanyFragment
  ) | null, readonly rate?: (
    { readonly __typename?: 'Rate' }
    & RateFragment
  ) | null, readonly overtimeRate?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly onCall?: (
    { readonly __typename?: 'OnCallRate' }
    & PaymentDetailsDraftDrawerOnCallFragment
  ) | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type PaymentDetailsDraftDrawerContractDraftEmploymentContractDraftFragment = { readonly __typename?: 'EmploymentContractDraft', readonly type: EmploymentContractType, readonly ppk?: number | null, readonly copyrightCosts?: number | null, readonly taxDeductibleCosts?: DeductibleCostsType | null, readonly applyRemoteWorkReimbursement: boolean, readonly currency?: string | null, readonly id: string, readonly entityVersion: number, readonly workingTime?: (
    { readonly __typename?: 'WorkingTime' }
    & WorkingTimeFragment
  ) | null, readonly rate?: (
    { readonly __typename?: 'Rate' }
    & RateFragment
  ) | null, readonly overtimeRate?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly onCall?: (
    { readonly __typename?: 'OnCallRate' }
    & PaymentDetailsDraftDrawerOnCallFragment
  ) | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type PaymentDetailsDraftDrawerContractDraftSubcontractDraftFragment = { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type PaymentDetailsDraftDrawerContractDraftFragment =
  | PaymentDetailsDraftDrawerContractDraftB2BContractDraftFragment
  | PaymentDetailsDraftDrawerContractDraftEmploymentContractDraftFragment
  | PaymentDetailsDraftDrawerContractDraftSubcontractDraftFragment
;

export type PaymentDetailsDraftDrawerInputQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type PaymentDetailsDraftDrawerInputQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | (
              { readonly __typename?: 'B2BContractDraft' }
              & PaymentDetailsDraftDrawerContractDraftB2BContractDraftFragment
            )
            | (
              { readonly __typename?: 'EmploymentContractDraft' }
              & PaymentDetailsDraftDrawerContractDraftEmploymentContractDraftFragment
            )
            | (
              { readonly __typename?: 'SubcontractDraft' }
              & PaymentDetailsDraftDrawerContractDraftSubcontractDraftFragment
            )
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type PaymentDetailsDraftDrawerUpdateEmploymentDraftMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  rate?: InputMaybe<ClearableNetRateInput>;
  overtimeRate?: InputMaybe<ClearableCentsInput>;
  onCall?: InputMaybe<ClearableNetOnCallRateInput>;
  ppk?: InputMaybe<ClearableBasisPointInput>;
  copyrightCosts?: InputMaybe<ClearableBasisPointInput>;
  taxDeductibleCosts?: InputMaybe<ClearableDeductibleCostsTypeInput>;
  workingTime?: InputMaybe<ClearableWorkingTimeInput>;
  applyRemoteWorkReimbursement?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<ClearableCurrencyInput>;
}>;


export type PaymentDetailsDraftDrawerUpdateEmploymentDraftMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateEmploymentDraft:
        | (
          { readonly __typename?: 'EmploymentContractDraft' }
          & PaymentDetailsDraftDrawerContractDraftEmploymentContractDraftFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type PaymentDetailsDraftDrawerUpdateB2BDraftMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  rate?: InputMaybe<ClearableNetRateInput>;
  overtimeRate?: InputMaybe<ClearableCentsInput>;
  onCall?: InputMaybe<ClearableNetOnCallRateInput>;
  vat?: InputMaybe<ClearableVatTypeInput>;
  currency?: InputMaybe<ClearableCurrencyInput>;
  separatePaymentForBenefits: Scalars['Boolean']['input'];
}>;


export type PaymentDetailsDraftDrawerUpdateB2BDraftMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateB2bDraft:
        | (
          { readonly __typename?: 'B2BContractDraft' }
          & PaymentDetailsDraftDrawerContractDraftB2BContractDraftFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type PaymentDetailsDrawerPromiseeCompanyFragment = { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly isPolishVat: { readonly __typename?: 'TimeBasedValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: { readonly __typename?: 'ValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: boolean } } };

export type PaymentDetailsDrawerOnCallFragment = { readonly __typename?: 'OnCallRate', readonly night: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly holiday: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly weekend: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type PaymentDetailsDrawerTimeBasedCurrencyFragment = { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly activityId: string, readonly applyDate: Date, readonly value: string }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly activityId: string, readonly applyDate: Date, readonly value: string }> };

export type PaymentDetailsDrawerTimeBasedRateFragment = { readonly __typename?: 'TimeBasedRate', readonly value: (
    { readonly __typename?: 'Rate' }
    & RateFragment
  ), readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly activityId: string, readonly applyDate: Date, readonly value: (
      { readonly __typename?: 'Rate' }
      & RateFragment
    ) }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly activityId: string, readonly applyDate: Date, readonly value: (
      { readonly __typename?: 'Rate' }
      & RateFragment
    ) }> };

export type PaymentDetailsDrawerTimeBasedOvertimeRateFragment = { readonly __typename?: 'TimeBasedOptClearableNetGross', readonly value?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ) | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ) | null } }> };

export type PaymentDetailsDrawerTimeBasedOnCallFragment = { readonly __typename?: 'TimeBasedOptClearableOnCallRate', readonly value?: (
    { readonly __typename?: 'OnCallRate' }
    & PaymentDetailsDrawerOnCallFragment
  ) | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: (
        { readonly __typename?: 'OnCallRate' }
        & PaymentDetailsDrawerOnCallFragment
      ) | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: (
        { readonly __typename?: 'OnCallRate' }
        & PaymentDetailsDrawerOnCallFragment
      ) | null } }> };

export type PaymentDetailsDrawerContractB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
        { readonly __typename?: 'TimeBasedCurrency' }
        & PaymentDetailsDrawerTimeBasedCurrencyFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
        { readonly __typename?: 'TimeBasedRate' }
        & PaymentDetailsDrawerTimeBasedRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly overtimeRate:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableNetGross' }
        & PaymentDetailsDrawerTimeBasedOvertimeRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly onCall:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableOnCallRate', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
        & PaymentDetailsDrawerTimeBasedOnCallFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly separatePaymentForBenefits:
    | { readonly __typename?: 'AccessGranted__TimeBasedBoolean', readonly value: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly vat:
    | { readonly __typename?: 'AccessGranted__TimeBasedVatType', readonly value: { readonly __typename?: 'TimeBasedVatType', readonly value:
          | (
            { readonly __typename?: 'VatApplied' }
            & VatTypeVatAppliedFragment
          )
          | (
            { readonly __typename?: 'VatNotApplied' }
            & VatTypeVatNotAppliedFragment
          )
        , readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantVatType', readonly activityId: string, readonly applyDate: Date, readonly value:
            | (
              { readonly __typename?: 'VatApplied' }
              & VatTypeVatAppliedFragment
            )
            | (
              { readonly __typename?: 'VatNotApplied' }
              & VatTypeVatNotAppliedFragment
            )
           }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantVatType', readonly activityId: string, readonly applyDate: Date, readonly value:
            | (
              { readonly __typename?: 'VatApplied' }
              & VatTypeVatAppliedFragment
            )
            | (
              { readonly __typename?: 'VatNotApplied' }
              & VatTypeVatNotAppliedFragment
            )
           }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promiseeCompany:
    | { readonly __typename?: 'AccessGranted__Company', readonly value: (
        { readonly __typename?: 'Company' }
        & PaymentDetailsDrawerPromiseeCompanyFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type PaymentDetailsDrawerContractEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
        { readonly __typename?: 'TimeBasedCurrency' }
        & PaymentDetailsDrawerTimeBasedCurrencyFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
        { readonly __typename?: 'TimeBasedRate' }
        & PaymentDetailsDrawerTimeBasedRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly overtimeRate:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableNetGross' }
        & PaymentDetailsDrawerTimeBasedOvertimeRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly onCall:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableOnCallRate', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
        & PaymentDetailsDrawerTimeBasedOnCallFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly taxDeductibleCosts:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableDeductibleCostsType', readonly value: { readonly __typename?: 'TimeBasedOptClearableDeductibleCostsType', readonly value?: DeductibleCostsType | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDeductibleCostsType', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableDeductibleCostsType', readonly value?: DeductibleCostsType | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDeductibleCostsType', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableDeductibleCostsType', readonly value?: DeductibleCostsType | null } }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly ppk:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint', readonly value: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly copyrightCosts:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint', readonly value: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly workingTime:
    | { readonly __typename?: 'AccessGranted__TimeBasedWorkingTime', readonly value: { readonly __typename?: 'TimeBasedWorkingTime', readonly value: (
          { readonly __typename?: 'WorkingTime' }
          & WorkingTimeFragment
        ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
            { readonly __typename?: 'WorkingTime' }
            & WorkingTimeFragment
          ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
            { readonly __typename?: 'WorkingTime' }
            & WorkingTimeFragment
          ) }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly applyRemoteWorkReimbursement:
    | { readonly __typename?: 'AccessGranted__TimeBasedBoolean', readonly value: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type PaymentDetailsDrawerContractSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type PaymentDetailsDrawerContractFragment =
  | PaymentDetailsDrawerContractB2BContractFragment
  | PaymentDetailsDrawerContractEmploymentContractFragment
  | PaymentDetailsDrawerContractSubcontractFragment
;

export type PaymentDetailsDrawerLoadDataQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
}>;


export type PaymentDetailsDrawerLoadDataQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract', readonly terminationDate?: Date | null, readonly at?: Date | null }
          & PaymentDetailsDrawerContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract', readonly terminationDate?: Date | null, readonly at?: Date | null }
          & PaymentDetailsDrawerContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract', readonly terminationDate?: Date | null, readonly at?: Date | null }
          & PaymentDetailsDrawerContractSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type PaymentDetailsDrawerUpdateB2BContractMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  overtimeRate: TimeBasedValueClearableCentsInput;
  onCall: TimeBasedValueClearableNetOnCallRateInput;
  vat?: InputMaybe<TimeBasedValueVatTypeInput>;
  separatePaymentForBenefits: TimeBasedValueBooleanInput;
}>;


export type PaymentDetailsDrawerUpdateB2BContractMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateB2BContract:
      | (
        { readonly __typename?: 'B2BContract' }
        & PaymentDetailsDrawerContractB2BContractFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type PaymentDetailsDrawerUpdateEmploymentContractMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  overtimeRate: TimeBasedValueClearableCentsInput;
  onCall: TimeBasedValueClearableNetOnCallRateInput;
  ppk: TimeBasedValueClearableBasisPointInput;
  copyrightCosts: TimeBasedValueClearableBasisPointInput;
  workingTime?: InputMaybe<TimeBasedValueWorkingTimeInput>;
  taxDeductibleCosts: TimeBasedValueClearableDeductibleCostsTypeInput;
  applyRemoteWorkReimbursement: TimeBasedValueBooleanInput;
}>;


export type PaymentDetailsDrawerUpdateEmploymentContractMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | (
        { readonly __typename?: 'EmploymentContract' }
        & PaymentDetailsDrawerContractEmploymentContractFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type PayrollTransfersOrderResultModalResultFragment = { readonly __typename?: 'PayrollTransfersOrderView', readonly count: number, readonly totalCount: number, readonly batches: ReadonlyArray<{ readonly __typename?: 'TransferBatchView', readonly senderName: string, readonly isDomestic: boolean, readonly transfersCount: number, readonly error?: string | null, readonly outgoingAccount:
      | (
        { readonly __typename?: 'Iban' }
        & BankAccountNumberIbanFragment
      )
      | (
        { readonly __typename?: 'OtherBankAccountNumber' }
        & BankAccountNumberOtherBankAccountNumberFragment
      )
    , readonly totalAmount: (
      { readonly __typename?: 'CentsWithCurrency' }
      & CentsWithCurrencyFragment
    ) }> };

export type PendingCopyrightsDrawerWorkTransferFragment = { readonly __typename?: 'WorkTransferProtocol', readonly id: string, readonly description?: string | null, readonly createdBy: string, readonly createdAt: Date, readonly payload:
    | { readonly __typename?: 'File', readonly value: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly downloadUrl: string, readonly openUrl: string, readonly fileName: string } }
    | { readonly __typename?: 'NoWorkToBeTransferedThisMonth' }
  , readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
   };

export type PendingCopyrightsDrawerSalaryFragment = { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly contract: { readonly __typename?: 'EmploymentContract', readonly id: string, readonly startDate: Date, readonly terminationDate?: Date | null, readonly type: EmploymentContractType, readonly name: string, readonly status: ContractStatus, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null }, readonly conclusionDate:
      | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
      | (
        { readonly __typename?: 'Unauthorized' }
        & UnauthorizedFragment
      )
     }, readonly workTransferProtocols: ReadonlyArray<(
    { readonly __typename?: 'WorkTransferProtocol' }
    & PendingCopyrightsDrawerWorkTransferFragment
  )> };

export type PendingCopyrightsDrawerCopyrightsQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
}>;


export type PendingCopyrightsDrawerCopyrightsQuery = { readonly __typename?: 'Query', readonly contractSalaryDetailsInRange:
    | { readonly __typename?: 'ListOfContractSalaryDetailsResponse', readonly value: ReadonlyArray<
        | { readonly __typename?: 'B2BContractSalaryDetails' }
        | (
          { readonly __typename?: 'EmploymentContractSalaryDetails' }
          & PendingCopyrightsDrawerSalaryFragment
        )
      > }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type PendingCopyrightsDrawerUpdateWorkTransferMutationVariables = Exact<{
  id: Scalars['WorkTransferProtocolId']['input'];
  description?: InputMaybe<ClearableStringInput>;
  payload?: InputMaybe<Scalars['Upload']['input']>;
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
  approved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PendingCopyrightsDrawerUpdateWorkTransferMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly update:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & CopyrightsDrawerWorkTransferFragment
        )
       } } };

export type PendingCopyrightsDrawerCreateWorkTransferMutationVariables = Exact<{
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
  id: Scalars['WorkTransferProtocolId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['Upload']['input'];
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
  approved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PendingCopyrightsDrawerCreateWorkTransferMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly create:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & CopyrightsDrawerWorkTransferFragment
        )
       } } };

export type PendingCopyrightsDrawerRemoveWorkTransferMutationVariables = Exact<{
  id: Scalars['WorkTransferProtocolId']['input'];
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type PendingCopyrightsDrawerRemoveWorkTransferMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly remove:
        | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type PendingCopyrightsDrawerMarkNoWorkMutationVariables = Exact<{
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type PendingCopyrightsDrawerMarkNoWorkMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly markNoWorkToBeTransferedThisMonth:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & CopyrightsDrawerWorkTransferFragment
        )
       } } };

export type PeopleListFiltersOfficesQueryVariables = Exact<{ [key: string]: never; }>;


export type PeopleListFiltersOfficesQuery = { readonly __typename?: 'Query', readonly offices:
    | { readonly __typename?: 'ListOfOfficeResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type PeopleListFiltersSpacesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PeopleListFiltersSpacesQuery = { readonly __typename?: 'Query', readonly spaces:
    | { readonly __typename?: 'FSPResponseSpace', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeSpace', readonly cursor: string, readonly node: { readonly __typename?: 'Space', readonly entityVersion: number, readonly id: string, readonly name: string } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type PeopleListFiltersProjectsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PeopleListFiltersProjectsQuery = { readonly __typename?: 'Query', readonly projects:
    | { readonly __typename?: 'FSPResponseProject', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeProject', readonly cursor: string, readonly node: { readonly __typename?: 'Project', readonly entityVersion: number, readonly id: string, readonly name: string, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type PeopleListReportDrawerMainQueryVariables = Exact<{ [key: string]: never; }>;


export type PeopleListReportDrawerMainQuery = { readonly __typename?: 'Query', readonly hrSummaryReportMainDocument:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly hrSummaryReportLimitedDocument:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type PeopleListReportDrawerLimitedQueryVariables = Exact<{ [key: string]: never; }>;


export type PeopleListReportDrawerLimitedQuery = { readonly __typename?: 'Query', readonly hrSummaryReportLimitedDocument:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type PeopleListReportDrawerRegenerateMutationVariables = Exact<{ [key: string]: never; }>;


export type PeopleListReportDrawerRegenerateMutation = { readonly __typename?: 'Mutation', readonly triggerHrSummaryReportBackgroundRegeneration:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'UnitResponse' }
   };

export type PositionDetailsModalQueryVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
}>;


export type PositionDetailsModalQuery = { readonly __typename?: 'Query', readonly clientContract:
    | (
      { readonly __typename?: 'ClientContract', readonly contractDurationFrom:
        | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
      & ClientContractDetailsFutureUpdatesFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ProfileSpaceFragment = { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } };

export type ProfileUserQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type ProfileUserQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly createdAt: Date, readonly firstName: string, readonly middleName?: string | null, readonly lastName: string, readonly email: string, readonly consentedForUseOfImage: boolean, readonly skillsAndCompetences: ReadonlyArray<string>, readonly declaredNoCertificates: boolean, readonly areaOfExpertise?: string | null, readonly personalDataProcessingAuthorization:
        | { readonly __typename?: 'AccessGranted__PersonalDataProcessingAuthorization', readonly value: { readonly __typename?: 'PersonalDataProcessingAuthorization', readonly isAuthorized: boolean, readonly document:
              | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
                & UnauthorizedFragment
                & UnauthorizedFragment
              )
             } }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
          & UnauthorizedFragment
        )
      , readonly idType:
        | { readonly __typename?: 'AccessGranted__OptionalIDType', readonly value?: IdType | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly idNumber:
        | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly pesel:
        | { readonly __typename?: 'AccessGranted__OptionalPESEL', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly citizenship:
        | { readonly __typename?: 'AccessGranted__OptionalCountryCode', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly birthDate:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly nextMedicalExaminationDate:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly nextOhsTrainingDate:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly isStudent:
        | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly isStudentRevisionDate:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly emergencyContact:
        | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly revenueAdministrationOffice:
        | { readonly __typename?: 'AccessGranted__OptionalRevenueAdministrationOffice', readonly value?: { readonly __typename?: 'RevenueAdministrationOffice', readonly id: number, readonly officeName: string } | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly directReporting: { readonly __typename?: 'DirectReporting', readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: (
            { readonly __typename?: 'Space' }
            & ProfileSpaceFragment
          ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantSpace', readonly applyDate: Date, readonly activityId: string, readonly value: (
              { readonly __typename?: 'Space' }
              & ProfileSpaceFragment
            ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantSpace', readonly applyDate: Date, readonly activityId: string, readonly value: (
              { readonly __typename?: 'Space' }
              & ProfileSpaceFragment
            ) }> } }, readonly contactEmail:
        | { readonly __typename?: 'AccessGranted__OptionalEmailAddress', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly phoneNumber:
        | { readonly __typename?: 'AccessGranted__OptionalPhoneNumber', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly entityVersion: number, readonly status: ContractStatus, readonly startDate: Date, readonly id: string, readonly promiseeCompany:
                | { readonly __typename?: 'AccessGranted__Company', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly taxNumber?: string | null, readonly countryOfRegistration: string, readonly address?: { readonly __typename?: 'Address', readonly country: string } | null } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
            | { readonly __typename?: 'EmploymentContract', readonly id: string }
            | { readonly __typename?: 'Subcontract', readonly id: string }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly address:
        | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
            { readonly __typename?: 'Address' }
            & AddressFragment
          ) | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly mailingAddress:
        | { readonly __typename?: 'AccessGranted__OptionalAddress', readonly value?: (
            { readonly __typename?: 'Address' }
            & AddressFragment
          ) | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionLevel', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableProgressionLevel', readonly value?: ProgressionLevel | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionLevel', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableProgressionLevel', readonly value?: ProgressionLevel | null } }> }, readonly office?: { readonly __typename?: 'Office', readonly officeId: string, readonly name: string } | null, readonly paczkomat:
        | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly plateNumber:
        | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly passportExpirationDate:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly documentsDirectory:
        | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly socialMediaHandles:
        | { readonly __typename?: 'AccessGranted__ListOfSocialMediaHandle', readonly value: ReadonlyArray<{ readonly __typename?: 'SocialMediaHandle', readonly platform: string, readonly handle: string }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly certificates:
        | { readonly __typename?: 'AccessGranted__ListOfCertificate', readonly value: ReadonlyArray<{ readonly __typename?: 'Certificate', readonly id: string, readonly name: string, readonly issueDate?: Date | null, readonly expirationDate?: Date | null, readonly file?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly downloadUrl: string, readonly fileName: string, readonly openUrl: string } | null }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type ProgressionDetailsCurrencyFragment = { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly activityId: string, readonly value: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly activityId: string, readonly value: string }> };

export type ProgressionDetailsRateFragment = { readonly __typename?: 'TimeBasedRate', readonly value: (
    { readonly __typename?: 'Rate' }
    & RateFragment
  ), readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly applyDate: Date, readonly activityId: string, readonly value: (
      { readonly __typename?: 'Rate' }
      & RateFragment
    ) }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly applyDate: Date, readonly activityId: string, readonly value: (
      { readonly __typename?: 'Rate' }
      & RateFragment
    ) }> };

export type ProgressionDetailsPositionFragment = { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }> };

export type ProgressionDetailsSchemeLadderFragment = { readonly __typename?: 'ProgressionScheme', readonly archivedAt?: Date | null, readonly levels: ReadonlyArray<{ readonly __typename?: 'ProgressionSchemeLevel', readonly level: ProgressionLevel }> };

export type ProgressionDetailsProgressionSchemeFragment = { readonly __typename?: 'TimeBasedOptClearableProgressionScheme', readonly value?: (
    { readonly __typename?: 'ProgressionScheme', readonly id: string, readonly name: string }
    & ProgressionDetailsSchemeLadderFragment
  ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionScheme', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableProgressionScheme', readonly value?: (
        { readonly __typename?: 'ProgressionScheme', readonly id: string, readonly name: string }
        & ProgressionDetailsSchemeLadderFragment
      ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionScheme', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableProgressionScheme', readonly value?: { readonly __typename?: 'ProgressionScheme', readonly id: string, readonly name: string } | null } }> };

export type ProgressionDetailsOvertimeRateFragment = { readonly __typename?: 'TimeBasedOptClearableNetGross', readonly value?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ) | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ) | null } }> };

export type ProgressionDetailsOnCallsFragment = { readonly __typename?: 'TimeBasedOptClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly night: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly holiday: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly weekend: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly night: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly holiday: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly weekend: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ) } | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly night: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly holiday: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly weekend: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ) } | null } }> };

export type ProgressionDetailsWorkingTimeFragment = { readonly __typename?: 'TimeBasedWorkingTime', readonly value: (
    { readonly __typename?: 'WorkingTime' }
    & WorkingTimeFragment
  ), readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
      { readonly __typename?: 'WorkingTime' }
      & WorkingTimeFragment
    ) }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
      { readonly __typename?: 'WorkingTime' }
      & WorkingTimeFragment
    ) }> };

export type ProgressionDetailsContractB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
        { readonly __typename?: 'TimeBasedCurrency' }
        & ProgressionDetailsCurrencyFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
        { readonly __typename?: 'TimeBasedRate' }
        & ProgressionDetailsRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly overtimeRate:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableNetGross' }
        & ProgressionDetailsOvertimeRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly onCall:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableOnCallRate', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
        & ProgressionDetailsOnCallsFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly position: (
    { readonly __typename?: 'TimeBasedOptClearableString' }
    & ProgressionDetailsPositionFragment
  ), readonly progressionScheme:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableProgressionScheme', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableProgressionScheme' }
        & ProgressionDetailsProgressionSchemeFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promisee: { readonly __typename?: 'User', readonly id: string } };

export type ProgressionDetailsContractEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: (
        { readonly __typename?: 'TimeBasedCurrency' }
        & ProgressionDetailsCurrencyFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
        { readonly __typename?: 'TimeBasedRate' }
        & ProgressionDetailsRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly overtimeRate:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableNetGross' }
        & ProgressionDetailsOvertimeRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly onCall:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableOnCallRate', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
        & ProgressionDetailsOnCallsFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly position: (
    { readonly __typename?: 'TimeBasedOptClearableString' }
    & ProgressionDetailsPositionFragment
  ), readonly progressionScheme:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableProgressionScheme', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableProgressionScheme' }
        & ProgressionDetailsProgressionSchemeFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly workingTime:
    | { readonly __typename?: 'AccessGranted__TimeBasedWorkingTime', readonly value: (
        { readonly __typename?: 'TimeBasedWorkingTime' }
        & ProgressionDetailsWorkingTimeFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promisee: { readonly __typename?: 'User', readonly id: string } };

export type ProgressionDetailsContractSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly promisee: { readonly __typename?: 'User', readonly id: string } };

export type ProgressionDetailsContractFragment =
  | ProgressionDetailsContractB2BContractFragment
  | ProgressionDetailsContractEmploymentContractFragment
  | ProgressionDetailsContractSubcontractFragment
;

export type ProgressionDetailsUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionLevel', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableProgressionLevel', readonly value?: ProgressionLevel | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionLevel', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableProgressionLevel', readonly value?: ProgressionLevel | null } }> } };

export type ProgressionDetailsQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  userId: Scalars['UserId']['input'];
}>;


export type ProgressionDetailsQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract' }
          & ProgressionDetailsContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract' }
          & ProgressionDetailsContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract' }
          & ProgressionDetailsContractSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & ProgressionDetailsUserFragment
    )
   };

export type ProgressionDetailsDiscardActivitiesMutationVariables = Exact<{
  userActivityIds: ReadonlyArray<Scalars['ActivityId']['input']> | Scalars['ActivityId']['input'];
  contractActivityIds: ReadonlyArray<Scalars['ActivityId']['input']> | Scalars['ActivityId']['input'];
  contractId: Scalars['ContractId']['input'];
  contractEntityVersion: Scalars['EntityVersion']['input'];
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
}>;


export type ProgressionDetailsDiscardActivitiesMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly cancelActivities:
      | { readonly __typename?: 'ContractResponse', readonly value:
          | (
            { readonly __typename?: 'B2BContract' }
            & ProgressionDetailsContractB2BContractFragment
          )
          | (
            { readonly __typename?: 'EmploymentContract' }
            & ProgressionDetailsContractEmploymentContractFragment
          )
          | (
            { readonly __typename?: 'Subcontract' }
            & ProgressionDetailsContractSubcontractFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     }, readonly user: { readonly __typename?: 'UserMutation', readonly cancelActivities:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & ProgressionDetailsUserFragment
      )
     } };

export type ProgressionSchemeLevelDrawerLoadDataQueryVariables = Exact<{
  schemeId: Scalars['ProgressionSchemeId']['input'];
}>;


export type ProgressionSchemeLevelDrawerLoadDataQuery = { readonly __typename?: 'Query', readonly progressionScheme:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'ProgressionScheme' }
      & ProgressionSchemesProgressionSchemeFragment
    )
   };

export type ProgressionSchemeLevelDrawerUpdateMutationVariables = Exact<{
  id: Scalars['ProgressionSchemeId']['input'];
  levels?: InputMaybe<ReadonlyArray<ProgressionSchemeLevelInput> | ProgressionSchemeLevelInput>;
}>;


export type ProgressionSchemeLevelDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateProgressionScheme:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'ProgressionScheme' }
      & ProgressionSchemesProgressionSchemeFragment
    )
   };

export type ProgressionSchemeLevelsUpdateMutationVariables = Exact<{
  id: Scalars['ProgressionSchemeId']['input'];
  levels?: InputMaybe<ReadonlyArray<ProgressionSchemeLevelInput> | ProgressionSchemeLevelInput>;
}>;


export type ProgressionSchemeLevelsUpdateMutation = { readonly __typename?: 'Mutation', readonly updateProgressionScheme:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'ProgressionScheme' }
      & ProgressionSchemesProgressionSchemeFragment
    )
   };

export type ProjectBillablesReportDrawerGenerateMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type ProjectBillablesReportDrawerGenerateMutation = { readonly __typename?: 'Mutation', readonly generateProjectBillablesDocument:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ProjectBillablesReportDrawerGoogleDocQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type ProjectBillablesReportDrawerGoogleDocQuery = { readonly __typename?: 'Query', readonly projectBillablesDocument:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ProjectCostAndRevenueItemsProjectFragment = { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly costAndRevenueItems:
    | { readonly __typename?: 'AccessGranted__ListOfCostAndRevenueItem', readonly value: ReadonlyArray<{ readonly __typename?: 'CostAndRevenueItem', readonly tpe: CostAndRevenueItemType, readonly date: Date, readonly description?: string | null, readonly serviceLine?: string | null, readonly netValue: (
          { readonly __typename?: 'CentsWithCurrency' }
          & CentsWithCurrencyFragment
        ) }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ProjectCostAndRevenueItemsQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type ProjectCostAndRevenueItemsQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Project' }
      & ProjectCostAndRevenueItemsProjectFragment
    )
   };

export type ProjectCostAndRevenueItemsUpdateMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  costAndRevenueItems?: InputMaybe<ReadonlyArray<CostAndRevenueItemInput> | CostAndRevenueItemInput>;
}>;


export type ProjectCostAndRevenueItemsUpdateMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly update:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'Project' }
        & ProjectCostAndRevenueItemsProjectFragment
      )
     } };

export type ProjectCrossSellProjectFragment = { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly crossSell:
    | { readonly __typename?: 'AccessGranted__OptionalCrossSell', readonly value?: (
        { readonly __typename?: 'CrossSell' }
        & CrossSellFragment
      ) | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ProjectCrossSellClearMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
}>;


export type ProjectCrossSellClearMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly update:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'Project' }
        & ProjectCrossSellProjectFragment
      )
     } };

export type ProjectLeaderFormUserAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter: FilterUserInput;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  first: Scalars['Int']['input'];
}>;


export type ProjectLeaderFormUserAutocompleteQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: (
          { readonly __typename?: 'User', readonly avatar?: string | null }
          & UserAutocompleteUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ProjectLeaderFormAdditionalInfoQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type ProjectLeaderFormAdditionalInfoQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly assignedProjects:
          | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }> }> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
   };

export type ProjectMembersDrawerClientContractFragment = { readonly __typename?: 'ClientContract', readonly id: string, readonly contractDurationFrom:
    | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly contractDurationTo:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly name:
    | { readonly __typename?: 'AccessGranted__String', readonly value: string }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string }, readonly positions:
    | { readonly __typename?: 'AccessGranted__ListOfClientPosition', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }> } }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ProjectMemberFormUserAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter: FilterUserInput;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  first: Scalars['Int']['input'];
}>;


export type ProjectMemberFormUserAutocompleteQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: (
          { readonly __typename?: 'User', readonly avatar?: string | null, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly contracts:
            | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
                | { readonly __typename?: 'B2BContract', readonly id: string, readonly startDate: Date, readonly terminationDate?: Date | null, readonly status: ContractStatus, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } }, readonly promiseeCompany:
                    | { readonly __typename?: 'AccessGranted__Company', readonly value: { readonly __typename?: 'Company', readonly id: string } }
                    | (
                      { readonly __typename?: 'Unauthorized' }
                      & UnauthorizedFragment
                    )
                   }
                | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly startDate: Date, readonly terminationDate?: Date | null, readonly status: ContractStatus }
                | { readonly __typename?: 'Subcontract', readonly id: string, readonly startDate: Date, readonly terminationDate?: Date | null, readonly status: ContractStatus }
              > }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
          & UserAutocompleteUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ProjectMemberFormIntraCompanyContractsQueryVariables = Exact<{
  promisorId: Scalars['CompanyId']['input'];
  promiseeId: Scalars['CompanyId']['input'];
}>;


export type ProjectMemberFormIntraCompanyContractsQuery = { readonly __typename?: 'Query', readonly clientContractsBetweenCompanies:
    | { readonly __typename?: 'ListOfClientContractResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'ClientContract' }
        & ProjectMembersDrawerClientContractFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ProjectMemberFormUserDetailsQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type ProjectMemberFormUserDetailsQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly assignedProjects:
          | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string }, readonly user: { readonly __typename?: 'User', readonly id: string }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly clientPosition:
                  | { readonly __typename?: 'AccessGranted__ClientPosition', readonly value: { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string } }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly subcontractPosition:
                  | { readonly __typename?: 'AccessGranted__OptionalClientPosition', readonly value?: { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string } | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                 }> }> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }, readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly promiseeCompany:
                | { readonly __typename?: 'AccessGranted__Company', readonly value: { readonly __typename?: 'Company', readonly id: string } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
            | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly clientContract:
                | { readonly __typename?: 'AccessGranted__ClientContract', readonly value: (
                    { readonly __typename?: 'ClientContract' }
                    & ProjectMembersDrawerClientContractFragment
                  ) }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type ProjectMembersQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type ProjectMembersQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly assignedUsers: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly avatar?: string | null, readonly firstName: string, readonly lastName: string, readonly email: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null } }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly clientPosition:
            | { readonly __typename?: 'AccessGranted__ClientPosition', readonly value: { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly currency: { readonly __typename?: 'TimeBasedCurrency', readonly value: string }, readonly rateNet: { readonly __typename?: 'TimeBasedDailyAndHourlyRateNet', readonly value: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number } } } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly subcontractPosition:
            | { readonly __typename?: 'AccessGranted__OptionalClientPosition', readonly value?: { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly currency: { readonly __typename?: 'TimeBasedCurrency', readonly value: string }, readonly rateNet: { readonly __typename?: 'TimeBasedDailyAndHourlyRateNet', readonly value: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number } } } | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }> }> }
   };

export type ProjectMembersAssignmentUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly avatar?: string | null, readonly firstName: string, readonly lastName: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly contracts:
    | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly promiseeCompany:
            | { readonly __typename?: 'AccessGranted__Company', readonly value: { readonly __typename?: 'Company', readonly id: string } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly clientContract:
            | { readonly __typename?: 'AccessGranted__ClientContract', readonly value: { readonly __typename?: 'ClientContract', readonly id: string, readonly positions:
                  | { readonly __typename?: 'AccessGranted__ListOfClientPosition', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }> } }> }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                 } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
      > }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type ProjectMembersDrawerProjectAssignmentFragment = { readonly __typename?: 'ProjectAssignment', readonly user: (
    { readonly __typename?: 'User' }
    & ProjectMembersAssignmentUserFragment
  ), readonly project: { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly clientPosition:
      | { readonly __typename?: 'AccessGranted__ClientPosition', readonly value: { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string } }
      | (
        { readonly __typename?: 'Unauthorized' }
        & UnauthorizedFragment
      )
    , readonly subcontractPosition:
      | { readonly __typename?: 'AccessGranted__OptionalClientPosition', readonly value?: { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string } | null }
      | (
        { readonly __typename?: 'Unauthorized' }
        & UnauthorizedFragment
      )
     }> };

export type ProjectMembersDrawerMembersQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type ProjectMembersDrawerMembersQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly name: string, readonly createdAt: Date, readonly statusHistory: ReadonlyArray<{ readonly __typename?: 'ProjectStatusHistoryEntry', readonly status: ProjectStatus, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }>, readonly assignedUsers: ReadonlyArray<(
        { readonly __typename?: 'ProjectAssignment' }
        & ProjectMembersDrawerProjectAssignmentFragment
      )>, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly contractDurationFrom:
          | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly contractDurationTo:
          | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly name:
          | { readonly __typename?: 'AccessGranted__String', readonly value: string }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly currency:
          | { readonly __typename?: 'AccessGranted__TimeBasedOptCurrency', readonly value: { readonly __typename?: 'TimeBasedOptCurrency', readonly value?: string | null } }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly vat:
          | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint', readonly value: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null } }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly positions:
          | { readonly __typename?: 'AccessGranted__ListOfClientPosition', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }> } }> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly entityVersion: number } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
   };

export type ProjectMembersDrawerUpdateAssignmentMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  state: CreateProjectAssignmentInput;
}>;


export type ProjectMembersDrawerUpdateAssignmentMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly projectAssignments: { readonly __typename?: 'ProjectAssignmentOperations', readonly upsertProjectAssignment:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'ProjectAssignment', readonly project: (
            { readonly __typename?: 'Project' }
            & ProjectLeadFragment
          ) }
          & ProjectMembersDrawerProjectAssignmentFragment
        )
       } } };

export type ProjectMembersDrawerUpdateInternalAssignmentMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  state: CreateInternalProjectAssignmentInput;
}>;


export type ProjectMembersDrawerUpdateInternalAssignmentMutation = { readonly __typename?: 'Mutation', readonly internalProject: { readonly __typename?: 'InternalProjectMutations', readonly upsertInternalProjectAssignment:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'ProjectAssignment', readonly project: (
          { readonly __typename?: 'Project' }
          & ProjectLeadFragment
        ) }
        & ProjectMembersDrawerProjectAssignmentFragment
      )
     } };

export type ProjectMembersDrawerRemoveAssignmentMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  userId: Scalars['UserId']['input'];
}>;


export type ProjectMembersDrawerRemoveAssignmentMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly projectAssignments: { readonly __typename?: 'ProjectAssignmentOperations', readonly deleteProjectAssignment:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
       } } };

export type ProjectsAndActivitiesSpaceFragment = { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } };

export type ProjectsAndActivitiesClientPositionFragment = { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }> }, readonly currency: { readonly __typename?: 'TimeBasedCurrency', readonly value: string }, readonly rateNet: { readonly __typename?: 'TimeBasedDailyAndHourlyRateNet', readonly value: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number }, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantDailyAndHourlyRateNet', readonly applyDate: Date, readonly activityId: string }> }, readonly overtimeNet: { readonly __typename?: 'TimeBasedOptClearableDailyAndHourlyRateNet', readonly value?: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDailyAndHourlyRateNet', readonly applyDate: Date, readonly activityId: string }> }, readonly onCallRates: { readonly __typename?: 'TimeBasedOptClearableNetOnCallRate', readonly value?: { readonly __typename?: 'NetOnCallRate', readonly night: number, readonly weekend: number, readonly holiday: number } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetOnCallRate', readonly applyDate: Date, readonly activityId: string }> } };

export type ProjectsAndActivitiesQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type ProjectsAndActivitiesQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly createdAt: Date, readonly firstName: string, readonly lastName: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: (
            { readonly __typename?: 'Space' }
            & ProjectsAndActivitiesSpaceFragment
          ), readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantSpace', readonly applyDate: Date, readonly activityId: string, readonly value: (
              { readonly __typename?: 'Space' }
              & ProjectsAndActivitiesSpaceFragment
            ) }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantSpace', readonly applyDate: Date, readonly activityId: string, readonly value: (
              { readonly __typename?: 'Space' }
              & ProjectsAndActivitiesSpaceFragment
            ) }> }, readonly assignedProjects:
          | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string } | null }, readonly lead?: { readonly __typename?: 'ProjectRoleAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectRoleAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly role: { readonly __typename?: 'TimeBasedCompanyRole', readonly value: CompanyRole } } }> } | null }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly clientPosition:
                  | { readonly __typename?: 'AccessGranted__ClientPosition', readonly value: (
                      { readonly __typename?: 'ClientPosition' }
                      & ProjectsAndActivitiesClientPositionFragment
                    ) }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly subcontractPosition:
                  | { readonly __typename?: 'AccessGranted__OptionalClientPosition', readonly value?: (
                      { readonly __typename?: 'ClientPosition' }
                      & ProjectsAndActivitiesClientPositionFragment
                    ) | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                 }> }> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }, readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date }
            | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly clientContract:
                | { readonly __typename?: 'AccessGranted__ClientContract', readonly value: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisor?: { readonly __typename?: 'Company', readonly id: string } | null } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
  , readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly node: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly role: { readonly __typename?: 'TimeBasedCompanyRole', readonly value: CompanyRole }, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly operationalLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: { readonly __typename?: 'User', readonly id: string } | null }, readonly practiceLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: { readonly __typename?: 'User', readonly id: string } | null }, readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: { readonly __typename?: 'Space', readonly id: string, readonly owner: { readonly __typename?: 'User', readonly id: string } } } } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ProjectListFiltersClientsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type ProjectListFiltersClientsQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly cursor: string, readonly node: { readonly __typename?: 'Company', readonly entityVersion: number, readonly id: string, readonly name: string, readonly logo?: string | null } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ProjectListFiltersSpacesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type ProjectListFiltersSpacesQuery = { readonly __typename?: 'Query', readonly spaces:
    | { readonly __typename?: 'FSPResponseSpace', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeSpace', readonly cursor: string, readonly node: { readonly __typename?: 'Space', readonly entityVersion: number, readonly id: string, readonly name: string } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type RateCardDrawerClientPositionFragment = { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly createdAt: Date, readonly serviceLine: { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }> }, readonly currency: { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly activityId: string, readonly applyDate: Date, readonly value: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly activityId: string, readonly applyDate: Date, readonly value: string }> }, readonly rateNet: { readonly __typename?: 'TimeBasedDailyAndHourlyRateNet', readonly value: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number }, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantDailyAndHourlyRateNet', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantDailyAndHourlyRateNet', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number } }> }, readonly overtimeNet: { readonly __typename?: 'TimeBasedOptClearableDailyAndHourlyRateNet', readonly value?: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDailyAndHourlyRateNet', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableDailyAndHourlyRateNet', readonly value?: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number } | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableDailyAndHourlyRateNet', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableDailyAndHourlyRateNet', readonly value?: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number, readonly hourly: number } | null } }> }, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly applyDate: Date, readonly value: boolean }> }, readonly onCallRates: { readonly __typename?: 'TimeBasedOptClearableNetOnCallRate', readonly value?: { readonly __typename?: 'NetOnCallRate', readonly night: number, readonly weekend: number, readonly holiday: number } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableNetOnCallRate', readonly value?: { readonly __typename?: 'NetOnCallRate', readonly night: number, readonly weekend: number, readonly holiday: number } | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableNetOnCallRate', readonly value?: { readonly __typename?: 'NetOnCallRate', readonly night: number, readonly weekend: number, readonly holiday: number } | null } }> } };

export type RateCardDrawerClientContractFragment = { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly contractDurationFrom:
    | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly contractDurationTo:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly companyType: ReadonlyArray<CompanyType> } | null, readonly positions:
    | { readonly __typename?: 'AccessGranted__ListOfClientPosition', readonly value: ReadonlyArray<(
        { readonly __typename?: 'ClientPosition' }
        & RateCardDrawerClientPositionFragment
      )> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly vat:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint', readonly value: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptCurrency', readonly value: { readonly __typename?: 'TimeBasedOptCurrency', readonly value?: string | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly activityId: string, readonly applyDate: Date, readonly value: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly activityId: string, readonly applyDate: Date, readonly value: string }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type RateCardDrawerClientContractTimeBasedFragment = (
  { readonly __typename?: 'ClientContract', readonly at?: Date | null, readonly positions:
    | { readonly __typename?: 'AccessGranted__ListOfClientPosition', readonly value: ReadonlyArray<(
        { readonly __typename?: 'ClientPosition', readonly at?: Date | null }
        & RateCardDrawerClientPositionFragment
      )> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   }
  & RateCardDrawerClientContractFragment
);

export type RateCardDrawerLoadDataQueryVariables = Exact<{
  id: Scalars['ClientContractId']['input'];
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
}>;


export type RateCardDrawerLoadDataQuery = { readonly __typename?: 'Query', readonly clientContract:
    | (
      { readonly __typename?: 'ClientContract', readonly at?: Date | null }
      & RateCardDrawerClientContractTimeBasedFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly reportingPeriods:
    | { readonly __typename?: 'ListOfReportingPeriodResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ReportingPeriod', readonly id: string, readonly from: Date, readonly to: Date }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type RateCardDrawerUpdateMutationVariables = Exact<{
  at: Scalars['Date']['input'];
  id: Scalars['ClientContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  vat?: InputMaybe<Scalars['BasisPoint']['input']>;
  currency: Scalars['Currency']['input'];
  positions: ReadonlyArray<ClientPositionInput> | ClientPositionInput;
}>;


export type RateCardDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly clientContract: { readonly __typename?: 'ClientContractMutation', readonly setManDayRates:
      | (
        { readonly __typename?: 'ClientContract' }
        & RateCardDrawerClientContractFragment
      )
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type RatesChangesReportDrawerQueryVariables = Exact<{ [key: string]: never; }>;


export type RatesChangesReportDrawerQuery = { readonly __typename?: 'Query', readonly rateChangeEventSummaryReport:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type RatesChangesReportDrawerRegenerateMutationVariables = Exact<{ [key: string]: never; }>;


export type RatesChangesReportDrawerRegenerateMutation = { readonly __typename?: 'Mutation', readonly generateRateChangeEventSummaryReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'UnitResponse' }
   };

export type RejectOfficeReservationModalRejectMutationVariables = Exact<{
  requestId: Scalars['ReservationRequestId']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectOfficeReservationModalRejectMutation = { readonly __typename?: 'Mutation', readonly rejectOfficeReservation:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'ReservationRequest', readonly requestId: string }
   };

export type RelatedProjectAssignmentsContractQueryVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
}>;


export type RelatedProjectAssignmentsContractQuery = { readonly __typename?: 'Query', readonly clientContract:
    | { readonly __typename?: 'ClientContract', readonly id: string, readonly promisor?: { readonly __typename?: 'Company', readonly id: string } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string } }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type RelatedProjectAssignmentsQueryVariables = Exact<{
  client: Scalars['CompanyId']['input'];
  supplier: Scalars['CompanyId']['input'];
}>;


export type RelatedProjectAssignmentsQuery = { readonly __typename?: 'Query', readonly resolveSubcontractRelatedProjectAssignments:
    | { readonly __typename?: 'ListOfProjectAssignmentResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string, readonly avatar?: string | null, readonly firstName: string, readonly lastName: string, readonly email: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly name: string }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly clientPosition:
            | { readonly __typename?: 'AccessGranted__ClientPosition', readonly value: { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly currency: { readonly __typename?: 'TimeBasedCurrency', readonly value: string }, readonly rateNet: { readonly __typename?: 'TimeBasedDailyAndHourlyRateNet', readonly value: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number } } } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly subcontractPosition:
            | { readonly __typename?: 'AccessGranted__OptionalClientPosition', readonly value?: { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly currency: { readonly __typename?: 'TimeBasedCurrency', readonly value: string }, readonly rateNet: { readonly __typename?: 'TimeBasedDailyAndHourlyRateNet', readonly value: { readonly __typename?: 'DailyAndHourlyRateNet', readonly daily: number } } } | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }> }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type RequestTimeReportFillMutationVariables = Exact<{
  filter: FilterContractSalaryDetailsInput;
  yearMonth: Scalars['YearMonth']['input'];
  validUntil: Scalars['OffsetDateTime']['input'];
}>;


export type RequestTimeReportFillMutation = { readonly __typename?: 'Mutation', readonly createTemporaryEditPermissionsForSpaceOwners:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'UnitResponse' }
   };

export type RequestTimeReportFillForUsersMutationVariables = Exact<{
  filter: FilterContractSalaryDetailsInput;
  yearMonth: Scalars['YearMonth']['input'];
  validUntil: Scalars['OffsetDateTime']['input'];
}>;


export type RequestTimeReportFillForUsersMutation = { readonly __typename?: 'Mutation', readonly createTemporaryEditPermissionsForUsers:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'UnitResponse' }
   };

export type RequiredActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RequiredActionsQuery = { readonly __typename?: 'Query', readonly requiredActions:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'RequiredActions', readonly pendingWorkTransferProtocols: number, readonly employeeRemindersNextRevisionDate?: Date | null }
  , readonly timeReportsRequiringApproval:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReportsRequiringApproval', readonly workRecords: ReadonlyArray<{ readonly __typename?: 'WorkRecord', readonly id: string }>, readonly absenceRecords: ReadonlyArray<{ readonly __typename?: 'AbsenceRecord', readonly id: string }> }
  , readonly pendingWorkTransferProtocols:
    | { readonly __typename?: 'ListOfWorkTransferProtocolResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'WorkTransferProtocol', readonly id: string }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type RequiredActionsRaisesQueryVariables = Exact<{ [key: string]: never; }>;


export type RequiredActionsRaisesQuery = { readonly __typename?: 'Query', readonly raises:
    | { readonly __typename?: 'ListOfRaiseProposalResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'RaiseProposal', readonly contract:
          | { readonly __typename?: 'B2BContract', readonly id: string }
          | { readonly __typename?: 'EmploymentContract', readonly id: string }
          | { readonly __typename?: 'Subcontract', readonly id: string }
         }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type RequiredActionsOfficeReservationsQueryVariables = Exact<{ [key: string]: never; }>;


export type RequiredActionsOfficeReservationsQuery = { readonly __typename?: 'Query', readonly pendingOfficeReservationRequests:
    | { readonly __typename?: 'IntResponse', readonly value: number }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ReservationLimitsDrawerSettingsFragment = { readonly __typename?: 'OfficeReservationSettings', readonly deskMaxDays: number, readonly deskMaxAdvanceDays: number, readonly deskMaxUpcomingDays: number, readonly parkingMaxAdvanceDays: number, readonly parkingMaxDays: number, readonly parkingMaxUpcomingDays: number };

export type ReservationLimitsDrawerInitialDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ReservationLimitsDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly officeReservationSettings:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'OfficeReservationSettings' }
      & ReservationLimitsDrawerSettingsFragment
    )
   };

export type ReservationLimitsDrawerUpdateMutationVariables = Exact<{
  deskMaxDays: Scalars['Int']['input'];
  deskMaxAdvanceDays: Scalars['Int']['input'];
  deskMaxUpcomingDays: Scalars['Int']['input'];
  parkingMaxAdvanceDays: Scalars['Int']['input'];
  parkingMaxDays: Scalars['Int']['input'];
  parkingMaxUpcomingDays: Scalars['Int']['input'];
}>;


export type ReservationLimitsDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateOfficeReservationSettings:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'OfficeReservationSettings' }
      & ReservationLimitsDrawerSettingsFragment
    )
   };

export type RoomDrawerRoomFragment = { readonly __typename?: 'Room', readonly id: string, readonly name: string, readonly securityZone?: SecurityZone | null, readonly restrictedToSpace?: { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } } | null };

export type RoomDrawerInitialDataQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type RoomDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly officeCatalogue:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeCatalogue', readonly rooms: ReadonlyArray<(
        { readonly __typename?: 'Room' }
        & RoomDrawerRoomFragment
      )> }
   };

export type RoomDrawerCreateMutationVariables = Exact<{
  id: Scalars['RoomId']['input'];
  officeId: Scalars['OfficeId']['input'];
  name: Scalars['String']['input'];
  restrictedToSpaceId?: InputMaybe<Scalars['SpaceId']['input']>;
  securityZone?: InputMaybe<SecurityZone>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RoomDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly createRoom:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Room' }
      & OfficeCatalogueRoomFragment
    )
   };

export type RoomDrawerUpdateMutationVariables = Exact<{
  roomId: Scalars['RoomId']['input'];
  room: UpdateRoomInput;
}>;


export type RoomDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateRoom:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'Room' }
      & RoomDrawerRoomFragment
    )
   };

export type RoomDrawerSetSecurityZoneMutationVariables = Exact<{
  roomId: Scalars['RoomId']['input'];
  securityZone?: InputMaybe<SecurityZone>;
}>;


export type RoomDrawerSetSecurityZoneMutation = { readonly __typename?: 'Mutation', readonly setRoomSecurityZone:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Room', readonly id: string, readonly securityZone?: SecurityZone | null }
   };

export type SalariesControllsModifiedEntriesFragment = { readonly __typename?: 'ListOfContractSalaryDetailsResponse', readonly value: ReadonlyArray<
    | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
        | (
          { readonly __typename?: 'IncompleteData' }
          & SalaryStateIncompleteDataFragment
        )
        | (
          { readonly __typename?: 'PaymentDisbursed' }
          & SalaryStatePaymentDisbursedFragment
        )
        | (
          { readonly __typename?: 'Ready' }
          & SalaryStateReadyFragment
        )
       }
    | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
        | (
          { readonly __typename?: 'IncompleteData' }
          & SalaryStateIncompleteDataFragment
        )
        | (
          { readonly __typename?: 'PaymentDisbursed' }
          & SalaryStatePaymentDisbursedFragment
        )
        | (
          { readonly __typename?: 'Ready' }
          & SalaryStateReadyFragment
        )
       }
  > };

export type SalariesControllsFileFragment = { readonly __typename?: 'DownloadableFileUrl', readonly url: string, readonly fileName: string };

export type SalariesControllsTransfersFileQueryVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  filter: FilterContractSalaryDetailsInput;
}>;


export type SalariesControllsTransfersFileQuery = { readonly __typename?: 'Query', readonly payrollTransfersDocument:
    | (
      { readonly __typename?: 'DownloadableFileUrl' }
      & SalariesControllsFileFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalariesControllsMarkAsDisbursedMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  filter: FilterContractSalaryDetailsInput;
}>;


export type SalariesControllsMarkAsDisbursedMutation = { readonly __typename?: 'Mutation', readonly markPaymentAsDisbursed:
    | (
      { readonly __typename?: 'ListOfContractSalaryDetailsResponse' }
      & SalariesControllsModifiedEntriesFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalariesControllsUnmarkAsDisbursedMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  filter: FilterContractSalaryDetailsInput;
}>;


export type SalariesControllsUnmarkAsDisbursedMutation = { readonly __typename?: 'Mutation', readonly unmarkPaymentAsDisbursed:
    | (
      { readonly __typename?: 'ListOfContractSalaryDetailsResponse' }
      & SalariesControllsModifiedEntriesFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalariesControllsNonB2BAccountingFileQueryVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  filter: FilterContractSalaryDetailsInput;
}>;


export type SalariesControllsNonB2BAccountingFileQuery = { readonly __typename?: 'Query', readonly nonB2bPayrollInputsDocument:
    | (
      { readonly __typename?: 'DownloadableFileUrl' }
      & SalariesControllsFileFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalariesListItemTimeReportValidationsQueryVariables = Exact<{
  date: Scalars['YearMonth']['input'];
  contractId: Scalars['ContractId']['input'];
}>;


export type SalariesListItemTimeReportValidationsQuery = { readonly __typename?: 'Query', readonly contractSalaryDetailsAdditionalData:
    | { readonly __typename?: 'ContractSalaryDetailsAdditionalData', readonly contractId: string, readonly yearMonth: Date, readonly timeReportValidations: ReadonlyArray<
        | (
          { readonly __typename?: 'IncompleteEntries' }
          & TimeReportValidationIncompleteEntriesFragment
        )
        | (
          { readonly __typename?: 'MissingEntries' }
          & TimeReportValidationMissingEntriesFragment
        )
        | (
          { readonly __typename?: 'NegativeFlexTimeBalance' }
          & TimeReportValidationNegativeFlexTimeBalanceFragment
        )
      > }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalariesSummaryReportDrawerGenerateMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  salariesSummaryType: SalariesSummaryType;
}>;


export type SalariesSummaryReportDrawerGenerateMutation = { readonly __typename?: 'Mutation', readonly generateSalariesSummaryReport:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalariesSummaryReportDrawerQueryVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  salariesSummaryType: SalariesSummaryType;
}>;


export type SalariesSummaryReportDrawerQuery = { readonly __typename?: 'Query', readonly salariesSummaryReport:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalariesUserSectionUpdateFlagAndNoteMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  note?: InputMaybe<ClearableStringInput>;
  flag?: InputMaybe<ClearableContractSalaryDetailsFlagColorInput>;
}>;


export type SalariesUserSectionUpdateFlagAndNoteMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly update:
      | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
          | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly note?: string | null, readonly flag?: ContractSalaryDetailsFlagColor | null }
          | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly note?: string | null, readonly flag?: ContractSalaryDetailsFlagColor | null }
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type SalaryTransferDetailsSalaryStateChangeFragment = { readonly __typename?: 'ListOfContractSalaryDetailsResponse', readonly value: ReadonlyArray<
    | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
        | (
          { readonly __typename?: 'IncompleteData' }
          & SalaryStateIncompleteDataFragment
        )
        | (
          { readonly __typename?: 'PaymentDisbursed' }
          & SalaryStatePaymentDisbursedFragment
        )
        | (
          { readonly __typename?: 'Ready' }
          & SalaryStateReadyFragment
        )
       }
    | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
        | (
          { readonly __typename?: 'IncompleteData' }
          & SalaryStateIncompleteDataFragment
        )
        | (
          { readonly __typename?: 'PaymentDisbursed' }
          & SalaryStatePaymentDisbursedFragment
        )
        | (
          { readonly __typename?: 'Ready' }
          & SalaryStateReadyFragment
        )
       }
  > };

export type SalaryTransferDetailsRefreshWhiteListMutationVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  bankAccountNumber: BankAccountNumberInput;
}>;


export type SalaryTransferDetailsRefreshWhiteListMutation = { readonly __typename?: 'Mutation', readonly company: { readonly __typename?: 'CompanyMutation', readonly refreshBankAccounts:
      | { readonly __typename?: 'BankAccountsResponse', readonly bankAccounts: ReadonlyArray<(
          { readonly __typename?: 'BankAccount' }
          & BankAccountFragment
        )>, readonly company: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number } }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type SalaryTransferDetailsMarkAsDisbursedMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  contractId: Scalars['ContractId']['input'];
}>;


export type SalaryTransferDetailsMarkAsDisbursedMutation = { readonly __typename?: 'Mutation', readonly markPaymentAsDisbursed:
    | (
      { readonly __typename?: 'ListOfContractSalaryDetailsResponse' }
      & SalaryTransferDetailsSalaryStateChangeFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalaryTransferDetailsUnmarkAsDisbursedMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  contractId: Scalars['ContractId']['input'];
}>;


export type SalaryTransferDetailsUnmarkAsDisbursedMutation = { readonly __typename?: 'Mutation', readonly unmarkPaymentAsDisbursed:
    | (
      { readonly __typename?: 'ListOfContractSalaryDetailsResponse' }
      & SalaryTransferDetailsSalaryStateChangeFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalaryTransferDetailsTransfersFileQueryVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  contractId: Scalars['ContractId']['input'];
}>;


export type SalaryTransferDetailsTransfersFileQuery = { readonly __typename?: 'Query', readonly payrollTransfersDocument:
    | { readonly __typename?: 'DownloadableFileUrl', readonly url: string, readonly fileName: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalaryTransferTitleFormUpdateTransferTitleMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  month: Scalars['YearMonth']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  transferTitle?: InputMaybe<ClearableStringInput>;
}>;


export type SalaryTransferTitleFormUpdateTransferTitleMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly update:
      | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
          | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly entityVersion: number, readonly transferTitle: string }
          | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly entityVersion: number, readonly transferTitle: string }
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type SaldeoInvoiceFormCostInvoiceFragment = { readonly __typename?: 'CostInvoice', readonly number: string, readonly grossValue: number, readonly currency: string, readonly contractor: { readonly __typename?: 'CostInvoiceContractor', readonly name?: string | null }, readonly saldeoDocumentId: { readonly __typename?: 'SaldeoDocumentId', readonly documentId: number, readonly companyProgramId: string } };

export type SaldeoInvoiceFormCostInvoicesQueryVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  companyId: Scalars['CompanyId']['input'];
}>;


export type SaldeoInvoiceFormCostInvoicesQuery = { readonly __typename?: 'Query', readonly costInvoices:
    | { readonly __typename?: 'ListOfCostInvoiceResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'CostInvoice' }
        & SaldeoInvoiceFormCostInvoiceFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalesInvoiceDetailsUpdateDetailsMutationVariables = Exact<{
  invoiceId: Scalars['SalesInvoiceId']['input'];
  profilePrefix: Scalars['String']['input'];
  paidDate: ClearableLocalDateInput;
}>;


export type SalesInvoiceDetailsUpdateDetailsMutation = { readonly __typename?: 'Mutation', readonly salesInvoice: { readonly __typename?: 'SalesInvoiceMutation', readonly update:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'SalesInvoice', readonly id: number, readonly paidDate?: Date | null }
     } };

export type SalesInvoicesFiltersSellersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type SalesInvoicesFiltersSellersQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly cursor: string, readonly node: { readonly __typename?: 'Company', readonly entityVersion: number, readonly id: string, readonly name: string } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SaveAsReadyModalInitialDataQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type SaveAsReadyModalInitialDataQuery = { readonly __typename?: 'Query', readonly contractDocumentTemplateDescriptions:
    | { readonly __typename?: 'ListOfContractDocumentTemplateDescriptionResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ContractDocumentTemplateDescription', readonly template: ContractDocumentTemplate, readonly name: string, readonly contractType: FilterContractType, readonly language: ContractDocumentTemplateLanguage }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | { readonly __typename?: 'B2BContractDraft', readonly conclusionDate?: Date | null, readonly promisorRepresentative?: string | null, readonly documentTemplate?: ContractDocumentTemplate | null, readonly conclusionLocation?: string | null, readonly id: string, readonly entityVersion: number, readonly name: string, readonly b2bContractType: B2BContractType }
            | { readonly __typename?: 'EmploymentContractDraft', readonly conclusionDate?: Date | null, readonly type: EmploymentContractType, readonly promisorRepresentative?: string | null, readonly documentTemplate?: ContractDocumentTemplate | null, readonly conclusionLocation?: string | null, readonly id: string, readonly entityVersion: number, readonly name: string }
            | { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number, readonly name: string, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly name:
                  | { readonly __typename?: 'AccessGranted__String', readonly value: string }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type SetFutureEntitlementDrawerInitialDataQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type SetFutureEntitlementDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null }
        | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly annualLeaveEntitlement:
            | { readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement', readonly value?: { readonly __typename?: 'AnnualLeaveEntitlement', readonly withCarryOverToNextYear: boolean, readonly history: ReadonlyArray<{ readonly __typename?: 'AnnualLeaveEntitlementPeriod', readonly entitlementExplanation: string, readonly createdAt: Date, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly entitlement: (
                    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
                    & AnnualLeaveEntitlementValueFragment
                  ) }> } | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SetFutureEntitlementDrawerSetEntitlementMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  annualLeaveEntitlement: AnnualLeaveEntitlementInput;
}>;


export type SetFutureEntitlementDrawerSetEntitlementMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly updateEmploymentContract:
      | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly annualLeaveEntitlement:
          | { readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement', readonly value?: { readonly __typename?: 'AnnualLeaveEntitlement', readonly withCarryOverToNextYear: boolean, readonly history: ReadonlyArray<{ readonly __typename?: 'AnnualLeaveEntitlementPeriod', readonly entitlementExplanation: string, readonly createdAt: Date, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly entitlement: (
                  { readonly __typename?: 'AnnualLeaveEntitlementValue' }
                  & AnnualLeaveEntitlementValueFragment
                ) }> } | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type SetRateAndProgressionDrawerRateFragment = { readonly __typename?: 'TimeBasedRate', readonly value: (
    { readonly __typename?: 'Rate' }
    & RateFragment
  ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly activityId: string, readonly applyDate: Date, readonly value: (
      { readonly __typename?: 'Rate' }
      & RateFragment
    ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly activityId: string, readonly applyDate: Date }> };

export type SetRateAndProgressionDrawerOvertimeRateFragment = { readonly __typename?: 'TimeBasedOptClearableNetGross', readonly value?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly activityId: string, readonly applyDate: Date }> };

export type SetRateAndProgressionDrawerOnCallFragment = { readonly __typename?: 'TimeBasedOptClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly night: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly holiday: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly weekend: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly night: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly holiday: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly weekend: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ) } | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date }> };

export type SetRateAndProgressionDrawerProgressionSchemeFragment = { readonly __typename?: 'TimeBasedOptClearableProgressionScheme', readonly value?: { readonly __typename?: 'ProgressionScheme', readonly id: string, readonly name: string } | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionScheme', readonly activityId: string, readonly applyDate: Date }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionScheme', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableProgressionScheme', readonly value?: { readonly __typename?: 'ProgressionScheme', readonly id: string } | null } }> };

export type SetRateAndProgressionDrawerAvailableProgressionSchemeFragment = { readonly __typename?: 'ProgressionScheme', readonly id: string, readonly name: string, readonly levels: ReadonlyArray<{ readonly __typename?: 'ProgressionSchemeLevel', readonly level: ProgressionLevel, readonly hourlyRate: number, readonly noticePeriod?: number | null }> };

export type SetRateAndProgressionDrawerPositionFragment = { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }> };

export type SetRateAndProgressionDrawerScopeOfWorkFragment = { readonly __typename?: 'TimeBasedString', readonly value: string, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantString', readonly activityId: string, readonly applyDate: Date }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantString', readonly activityId: string, readonly applyDate: Date, readonly value: string }> };

export type SetRateAndProgressionDrawerWorkingTimeFragment = { readonly __typename?: 'TimeBasedWorkingTime', readonly value: (
    { readonly __typename?: 'WorkingTime' }
    & WorkingTimeFragment
  ), readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
      { readonly __typename?: 'WorkingTime' }
      & WorkingTimeFragment
    ) }> };

export type SetRateAndProgressionDrawerVatFragment = { readonly __typename?: 'TimeBasedVatType', readonly value:
    | (
      { readonly __typename?: 'VatApplied' }
      & VatTypeVatAppliedFragment
    )
    | (
      { readonly __typename?: 'VatNotApplied' }
      & VatTypeVatNotAppliedFragment
    )
  , readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantVatType', readonly activityId: string, readonly applyDate: Date }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantVatType', readonly activityId: string, readonly applyDate: Date, readonly value:
      | (
        { readonly __typename?: 'VatApplied' }
        & VatTypeVatAppliedFragment
      )
      | (
        { readonly __typename?: 'VatNotApplied' }
        & VatTypeVatNotAppliedFragment
      )
     }> };

export type SetRateAndProgressionDrawerContractB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly terminationDate?: Date | null, readonly vat:
    | { readonly __typename?: 'AccessGranted__TimeBasedVatType', readonly value: (
        { readonly __typename?: 'TimeBasedVatType' }
        & SetRateAndProgressionDrawerVatFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly scopeOfWork:
    | { readonly __typename?: 'AccessGranted__TimeBasedString', readonly value: (
        { readonly __typename?: 'TimeBasedString' }
        & SetRateAndProgressionDrawerScopeOfWorkFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly position: (
    { readonly __typename?: 'TimeBasedOptClearableString' }
    & SetRateAndProgressionDrawerPositionFragment
  ), readonly progressionScheme:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableProgressionScheme', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableProgressionScheme' }
        & SetRateAndProgressionDrawerProgressionSchemeFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
        { readonly __typename?: 'TimeBasedRate' }
        & SetRateAndProgressionDrawerRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly overtimeRate:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableNetGross' }
        & SetRateAndProgressionDrawerOvertimeRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly onCall:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableOnCallRate', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
        & ContractPaymentDetailsOnCallFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } };

export type SetRateAndProgressionDrawerContractEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly terminationDate?: Date | null, readonly position: (
    { readonly __typename?: 'TimeBasedOptClearableString' }
    & SetRateAndProgressionDrawerPositionFragment
  ), readonly progressionScheme:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableProgressionScheme', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableProgressionScheme' }
        & SetRateAndProgressionDrawerProgressionSchemeFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly scopeOfWork:
    | { readonly __typename?: 'AccessGranted__TimeBasedString', readonly value: (
        { readonly __typename?: 'TimeBasedString' }
        & SetRateAndProgressionDrawerScopeOfWorkFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly workingTime:
    | { readonly __typename?: 'AccessGranted__TimeBasedWorkingTime', readonly value: (
        { readonly __typename?: 'TimeBasedWorkingTime' }
        & ProgressionDetailsWorkingTimeFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
        { readonly __typename?: 'TimeBasedRate' }
        & SetRateAndProgressionDrawerRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly overtimeRate:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableNetGross' }
        & SetRateAndProgressionDrawerOvertimeRateFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly onCall:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableOnCallRate', readonly value: (
        { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
        & ContractPaymentDetailsOnCallFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } };

export type SetRateAndProgressionDrawerContractSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly terminationDate?: Date | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } };

export type SetRateAndProgressionDrawerContractFragment =
  | SetRateAndProgressionDrawerContractB2BContractFragment
  | SetRateAndProgressionDrawerContractEmploymentContractFragment
  | SetRateAndProgressionDrawerContractSubcontractFragment
;

export type SetRateAndProgressionDrawerLoadDataQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  userId: Scalars['UserId']['input'];
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
}>;


export type SetRateAndProgressionDrawerLoadDataQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract', readonly terminationDate?: Date | null, readonly at?: Date | null }
          & SetRateAndProgressionDrawerContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract', readonly terminationDate?: Date | null, readonly at?: Date | null }
          & SetRateAndProgressionDrawerContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract', readonly terminationDate?: Date | null, readonly at?: Date | null }
          & SetRateAndProgressionDrawerContractSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly at?: Date | null, readonly entityVersion: number, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionLevel', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableProgressionLevel', readonly value?: ProgressionLevel | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionLevel', readonly applyDate: Date, readonly activityId: string }> } }
  , readonly progressionSchemes:
    | { readonly __typename?: 'ListOfProgressionSchemeResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'ProgressionScheme' }
        & SetRateAndProgressionDrawerAvailableProgressionSchemeFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SetRateAndProgressionDrawerGmailConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type SetRateAndProgressionDrawerGmailConnectionQuery = { readonly __typename?: 'Query', readonly gmailConnection?:
    | { readonly __typename?: 'GmailConnection', readonly adminId: string, readonly connectedEmail: string, readonly aliases: ReadonlyArray<string>, readonly selectedAlias?: string | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   | null };

export type SetRateAndProgressionDrawerResultFragment = { readonly __typename?: 'SetRateAndProgressionResult', readonly contract:
    | (
      { readonly __typename?: 'B2BContract' }
      & SetRateAndProgressionDrawerContractB2BContractFragment
    )
    | (
      { readonly __typename?: 'EmploymentContract' }
      & SetRateAndProgressionDrawerContractEmploymentContractFragment
    )
    | { readonly __typename?: 'Subcontract' }
  , readonly user: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionLevel', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableProgressionLevel', readonly value?: ProgressionLevel | null } }> } } };

export type SetRateAndProgressionDrawerSetB2BRateAndProgressionMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  overtimeRate: TimeBasedValueClearableCentsInput;
  rateAmount: TimeBasedValueNetRateInput;
  currency: TimeBasedValueCurrencyInput;
  vat?: InputMaybe<TimeBasedValueVatTypeInput>;
  position: TimeBasedValueClearableStringInput;
  progressionSchemeId?: InputMaybe<TimeBasedValueClearableProgressionSchemeIdInput>;
  scopeOfWork?: InputMaybe<TimeBasedValueStringInput>;
  onCall: TimeBasedValueClearableNetOnCallRateInput;
  userEntityVersion: Scalars['EntityVersion']['input'];
  progressionLevel?: InputMaybe<TimeBasedValueClearableProgressionLevelInput>;
  email?: InputMaybe<EmailInput>;
}>;


export type SetRateAndProgressionDrawerSetB2BRateAndProgressionMutation = { readonly __typename?: 'Mutation', readonly setRateAndProgression:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'SetRateAndProgressionResult' }
      & SetRateAndProgressionDrawerResultFragment
    )
   };

export type SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  rateAmount: TimeBasedValueNetRateInput;
  overtimeRate: TimeBasedValueClearableCentsInput;
  currency: TimeBasedValueCurrencyInput;
  workingTime?: InputMaybe<TimeBasedValueWorkingTimeInput>;
  position: TimeBasedValueClearableStringInput;
  progressionSchemeId?: InputMaybe<TimeBasedValueClearableProgressionSchemeIdInput>;
  scopeOfWork?: InputMaybe<TimeBasedValueStringInput>;
  onCall: TimeBasedValueClearableNetOnCallRateInput;
  userEntityVersion: Scalars['EntityVersion']['input'];
  progressionLevel?: InputMaybe<TimeBasedValueClearableProgressionLevelInput>;
  email?: InputMaybe<EmailInput>;
}>;


export type SetRateAndProgressionDrawerSetEmploymentRateAndProgressionMutation = { readonly __typename?: 'Mutation', readonly setRateAndProgression:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'SetRateAndProgressionResult' }
      & SetRateAndProgressionDrawerResultFragment
    )
   };

export type SkillsAndCertificatesReportDrawerQueryVariables = Exact<{ [key: string]: never; }>;


export type SkillsAndCertificatesReportDrawerQuery = { readonly __typename?: 'Query', readonly skillsAndCertificatesReport:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SkillsAndCertificatesReportDrawerRegenerateMutationVariables = Exact<{ [key: string]: never; }>;


export type SkillsAndCertificatesReportDrawerRegenerateMutation = { readonly __typename?: 'Mutation', readonly generateSkillsAndCertificatesReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'UnitResponse' }
   };

export type SpaceDirectorsFormUserAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter: FilterUserInput;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  first: Scalars['Int']['input'];
}>;


export type SpaceDirectorsFormUserAutocompleteQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: (
          { readonly __typename?: 'User', readonly avatar?: string | null }
          & UserAutocompleteUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SpaceFormUserAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter: FilterUserInput;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  first: Scalars['Int']['input'];
}>;


export type SpaceFormUserAutocompleteQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: (
          { readonly __typename?: 'User', readonly avatar?: string | null }
          & UserAutocompleteUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SubcontractDetailsContractQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type SubcontractDetailsContractQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number }
        | { readonly __typename?: 'Subcontract', readonly startDate: Date, readonly terminationDate?: Date | null, readonly id: string, readonly entityVersion: number, readonly clientContract:
            | { readonly __typename?: 'AccessGranted__ClientContract', readonly value: { readonly __typename?: 'ClientContract', readonly id: string, readonly name:
                  | { readonly __typename?: 'AccessGranted__String', readonly value: string }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly contractDurationFrom:
                  | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly contractDurationTo:
                  | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly taxNumber?: string | null, readonly companyType: ReadonlyArray<CompanyType>, readonly address?: (
                    { readonly __typename?: 'Address' }
                    & AddressFragment
                  ) | null, readonly mailingAddress?: (
                    { readonly __typename?: 'Address' }
                    & AddressFragment
                  ) | null }, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly taxNumber?: string | null, readonly companyType: ReadonlyArray<CompanyType>, readonly isPolishVat: { readonly __typename?: 'TimeBasedValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: { readonly __typename?: 'ValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: boolean } }, readonly euVatType: { readonly __typename?: 'TimeBasedValueWithVerificationEuVatType', readonly value: { readonly __typename?: 'ValueWithVerificationEuVatType', readonly value: EuVatType } }, readonly address?: (
                    { readonly __typename?: 'Address' }
                    & AddressFragment
                  ) | null, readonly mailingAddress?: (
                    { readonly __typename?: 'Address' }
                    & AddressFragment
                  ) | null } | null } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SubcontractDetailsSectionsAssignedProjectsQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type SubcontractDetailsSectionsAssignedProjectsQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date }
            | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly clientContract:
                | { readonly __typename?: 'AccessGranted__ClientContract', readonly value: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string } | null } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly directReporting: { readonly __typename?: 'DirectReporting', readonly assignedProjects:
          | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly companyType: ReadonlyArray<CompanyType>, readonly name: string } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly companyType: ReadonlyArray<CompanyType>, readonly name: string } } }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly clientPosition:
                  | { readonly __typename?: 'AccessGranted__ClientPosition', readonly value: (
                      { readonly __typename?: 'ClientPosition' }
                      & ProjectsAndActivitiesClientPositionFragment
                    ) }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly subcontractPosition:
                  | { readonly __typename?: 'AccessGranted__OptionalClientPosition', readonly value?: (
                      { readonly __typename?: 'ClientPosition' }
                      & ProjectsAndActivitiesClientPositionFragment
                    ) | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                 }> }> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
   };

export type SubcontractDraftDetailsQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type SubcontractDraftDetailsQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | { readonly __typename?: 'B2BContractDraft', readonly id: string, readonly entityVersion: number }
            | { readonly __typename?: 'EmploymentContractDraft', readonly id: string, readonly entityVersion: number }
            | { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly name:
                  | { readonly __typename?: 'AccessGranted__String', readonly value: string }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly contractDurationFrom:
                  | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly contractDurationTo:
                  | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                , readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly taxNumber?: string | null, readonly companyType: ReadonlyArray<CompanyType>, readonly address?: (
                    { readonly __typename?: 'Address' }
                    & AddressFragment
                  ) | null, readonly mailingAddress?: (
                    { readonly __typename?: 'Address' }
                    & AddressFragment
                  ) | null }, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly taxNumber?: string | null, readonly companyType: ReadonlyArray<CompanyType>, readonly isPolishVat: { readonly __typename?: 'TimeBasedValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: { readonly __typename?: 'ValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: boolean } }, readonly euVatType: { readonly __typename?: 'TimeBasedValueWithVerificationEuVatType', readonly value: { readonly __typename?: 'ValueWithVerificationEuVatType', readonly value: EuVatType } }, readonly address?: (
                    { readonly __typename?: 'Address' }
                    & AddressFragment
                  ) | null, readonly mailingAddress?: (
                    { readonly __typename?: 'Address' }
                    & AddressFragment
                  ) | null } | null } }
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type SubcontractDraftDrawerDraftB2BContractDraftFragment = { readonly __typename?: 'B2BContractDraft', readonly id: string, readonly entityVersion: number, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type SubcontractDraftDrawerDraftEmploymentContractDraftFragment = { readonly __typename?: 'EmploymentContractDraft', readonly id: string, readonly entityVersion: number, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type SubcontractDraftDrawerDraftSubcontractDraftFragment = { readonly __typename?: 'SubcontractDraft', readonly name: string, readonly startDate?: Date | null, readonly expectedEndDate?: Date | null, readonly id: string, readonly entityVersion: number, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly name:
      | { readonly __typename?: 'AccessGranted__String', readonly value: string }
      | (
        { readonly __typename?: 'Unauthorized' }
        & UnauthorizedFragment
      )
    , readonly contractDurationFrom:
      | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
      | (
        { readonly __typename?: 'Unauthorized' }
        & UnauthorizedFragment
      )
     }, readonly holidayCalendar?: { readonly __typename?: 'HolidayCalendar', readonly id: HolidayCalendarId } | null, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number } };

export type SubcontractDraftDrawerDraftFragment =
  | SubcontractDraftDrawerDraftB2BContractDraftFragment
  | SubcontractDraftDrawerDraftEmploymentContractDraftFragment
  | SubcontractDraftDrawerDraftSubcontractDraftFragment
;

export type SubcontractDraftDrawerInputQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type SubcontractDraftDrawerInputQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly email: string, readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft', readonly value?:
            | (
              { readonly __typename?: 'B2BContractDraft' }
              & SubcontractDraftDrawerDraftB2BContractDraftFragment
            )
            | (
              { readonly __typename?: 'EmploymentContractDraft' }
              & SubcontractDraftDrawerDraftEmploymentContractDraftFragment
            )
            | (
              { readonly __typename?: 'SubcontractDraft' }
              & SubcontractDraftDrawerDraftSubcontractDraftFragment
            )
           | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly startDate: Date }
            | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly startDate: Date }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly startDate: Date }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type SubcontractDraftDrawerCreateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  contractId: Scalars['ContractId']['input'];
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  expectedEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  clientContractId: Scalars['ClientContractId']['input'];
  holidayCalendarId?: InputMaybe<HolidayCalendarId>;
  scopeOfWork?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubcontractDraftDrawerCreateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly createSubcontractDraft:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'SubcontractDraft' }
        & SubcontractDraftDrawerDraftSubcontractDraftFragment
      )
     } };

export type SubcontractDraftDrawerUpdateMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  userEntityVersion: Scalars['EntityVersion']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  startDate?: InputMaybe<ClearableLocalDateInput>;
  expectedEndDate?: InputMaybe<ClearableLocalDateInput>;
  holidayCalendarId?: InputMaybe<ClearableHolidayCalendarIdInput>;
  scopeOfWork?: InputMaybe<ClearableStringInput>;
  position?: InputMaybe<ClearableStringInput>;
}>;


export type SubcontractDraftDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly contractDraft: { readonly __typename?: 'ContractDraftMutation', readonly updateSubcontractDraft:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'SubcontractDraft' }
          & SubcontractDraftDrawerDraftSubcontractDraftFragment
        )
       } } };

export type SubcontractDraftFormClientContractsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterClientContractInput>;
}>;


export type SubcontractDraftFormClientContractsQuery = { readonly __typename?: 'Query', readonly clientContracts:
    | { readonly __typename?: 'FSPResponseClientContract', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeClientContract', readonly cursor: string, readonly node: { readonly __typename?: 'ClientContract', readonly id: string, readonly name:
            | { readonly __typename?: 'AccessGranted__String', readonly value: string }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly contractDurationFrom:
            | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisor?: { readonly __typename?: 'Company', readonly id: string } | null } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AdminTaxResidencyCertificatesDrawerQueryVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
}>;


export type AdminTaxResidencyCertificatesDrawerQuery = { readonly __typename?: 'Query', readonly company:
    | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly taxResidencyCertificates:
        | { readonly __typename?: 'AccessGranted__ListOfTaxResidencyCertificate', readonly value: ReadonlyArray<{ readonly __typename?: 'TaxResidencyCertificate', readonly id: string, readonly year: number, readonly countryOfResidency?: string | null, readonly validFrom?: Date | null, readonly validTo?: Date | null, readonly fileUri?: string | null, readonly notes?: string | null, readonly companyId: string }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AdminTaxResidencyCertificatesDrawerUpsertMutationVariables = Exact<{
  certificate: TaxResidencyCertificateInput;
}>;


export type AdminTaxResidencyCertificatesDrawerUpsertMutation = { readonly __typename?: 'Mutation', readonly upsertTaxResidencyCertificate:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TaxResidencyCertificate', readonly id: string, readonly year: number, readonly countryOfResidency?: string | null, readonly validFrom?: Date | null, readonly validTo?: Date | null, readonly fileUri?: string | null, readonly notes?: string | null, readonly companyId: string }
   };

export type AdminTaxResidencyCertificatesDrawerDeleteMutationVariables = Exact<{
  certId: Scalars['TaxResidencyCertificateId']['input'];
}>;


export type AdminTaxResidencyCertificatesDrawerDeleteMutation = { readonly __typename?: 'Mutation', readonly deleteTaxResidencyCertificate:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
   };

export type TerminateContractModalMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  date: Scalars['LocalDate']['input'];
}>;


export type TerminateContractModalMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly terminate:
      | { readonly __typename?: 'ContractResponse', readonly value:
          | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly status: ContractStatus, readonly terminationDate?: Date | null }
          | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly status: ContractStatus, readonly terminationDate?: Date | null }
          | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly status: ContractStatus, readonly terminationDate?: Date | null }
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type TerminateContractModalInfoQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type TerminateContractModalInfoQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly startDate: Date }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly startDate: Date }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly startDate: Date }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TimeReportsReportDrawerGenerateForProjectMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  period: ClosedEndLocalDateRangeInput;
}>;


export type TimeReportsReportDrawerGenerateForProjectMutation = { readonly __typename?: 'Mutation', readonly generateProjectTimeReport:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TimeReportsReportDrawerGoogleDocForProjectQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  period: ClosedEndLocalDateRangeInput;
}>;


export type TimeReportsReportDrawerGoogleDocForProjectQuery = { readonly __typename?: 'Query', readonly projectTimeReport:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TimeReportsReportDrawerGenerateForClientMutationVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
  period: ClosedEndLocalDateRangeInput;
}>;


export type TimeReportsReportDrawerGenerateForClientMutation = { readonly __typename?: 'Mutation', readonly generateClientTimeReport:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TimeReportsReportDrawerGoogleDocForClientQueryVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
  period: ClosedEndLocalDateRangeInput;
}>;


export type TimeReportsReportDrawerGoogleDocForClientQuery = { readonly __typename?: 'Query', readonly clientTimeReport:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TimeReportsReportFormCompanyAutocompleteQueryVariables = Exact<{
  allSearch?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first: Scalars['Int']['input'];
}>;


export type TimeReportsReportFormCompanyAutocompleteQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly cursor: string, readonly node: (
          { readonly __typename?: 'Company', readonly clientContracts:
            | { readonly __typename?: 'AccessGranted__ListOfClientContract', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly name:
                  | { readonly __typename?: 'AccessGranted__String', readonly value: string }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                 }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
          & CompanyAutocompleteCompanyFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TimeReportsReportFormClientInfoQueryVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
}>;


export type TimeReportsReportFormClientInfoQuery = { readonly __typename?: 'Query', readonly company:
    | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly clientContracts:
        | { readonly __typename?: 'AccessGranted__ListOfClientContract', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientContract', readonly id: string, readonly projects: ReadonlyArray<{ readonly __typename?: 'Project', readonly id: string, readonly name: string, readonly statusHistory: ReadonlyArray<{ readonly __typename?: 'ProjectStatusHistoryEntry', readonly status: ProjectStatus, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }>, readonly assignedUsers: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string } }> }> }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TimeReportsReportFormPeriodsQueryVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
}>;


export type TimeReportsReportFormPeriodsQuery = { readonly __typename?: 'Query', readonly reportingPeriods:
    | { readonly __typename?: 'ListOfReportingPeriodResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ReportingPeriod', readonly id: string, readonly clientContractId: string, readonly from: Date, readonly to: Date }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TrainingPackageReportDrawerQueryVariables = Exact<{ [key: string]: never; }>;


export type TrainingPackageReportDrawerQuery = { readonly __typename?: 'Query', readonly trainingBudgetSummaryReport:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TrainingPackageReportDrawerRegenerateMutationVariables = Exact<{ [key: string]: never; }>;


export type TrainingPackageReportDrawerRegenerateMutation = { readonly __typename?: 'Mutation', readonly generateTrainingBudgetSummaryReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'UnitResponse' }
   };

export type TransferDetailsDrawerInvoiceFragment = { readonly __typename?: 'SalesInvoice', readonly id: number, readonly number: string, readonly status: SalesInvoiceStatus, readonly currency: string, readonly price: { readonly __typename?: 'NetGross', readonly net: number, readonly gross: number }, readonly buyer: { readonly __typename?: 'InvoiceEntity', readonly name: string, readonly taxNumber?: string | null }, readonly seller: { readonly __typename?: 'InvoiceEntity', readonly name: string, readonly taxNumber?: string | null }, readonly buyerCompany?: { readonly __typename?: 'Company', readonly id: string, readonly name: string } | null, readonly sellerCompany?: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly taxNumber?: string | null } | null };

export type TransferDetailsDrawerPaymentConnectionFragment = { readonly __typename?: 'PaymentConnection', readonly tpe: PaymentConnectionType, readonly transfer: (
    { readonly __typename?: 'BankIncomeTransfer', readonly id: string, readonly discrepancy: number }
    & BankTransfersBankTransferBankIncomeTransferFragment
  ), readonly invoice: (
    { readonly __typename?: 'SalesInvoice' }
    & TransferDetailsDrawerInvoiceFragment
  ) };

export type TransferDetailsDrawerInitialDataQueryVariables = Exact<{
  id: Scalars['BankTransferId']['input'];
}>;


export type TransferDetailsDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly bankTransfer:
    | { readonly __typename?: 'BankTransferResponse', readonly value:
        | (
          { readonly __typename?: 'BankIncomeTransfer', readonly discrepancy: number, readonly connectedPayments: ReadonlyArray<(
            { readonly __typename?: 'PaymentConnection' }
            & TransferDetailsDrawerPaymentConnectionFragment
          )> }
          & BankTransfersBankTransferBankIncomeTransferFragment
        )
        | (
          { readonly __typename?: 'BankOutcomeTransfer' }
          & BankTransfersBankTransferBankOutcomeTransferFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TransferDetailsDrawerInvoicesQueryVariables = Exact<{
  range: ClosedEndLocalDateRangeInput;
  allSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type TransferDetailsDrawerInvoicesQuery = { readonly __typename?: 'Query', readonly salesInvoices:
    | { readonly __typename?: 'ListOfSalesInvoiceResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'SalesInvoice' }
        & TransferDetailsDrawerInvoiceFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TransferDetailsDrawerCreateConnectionMutationVariables = Exact<{
  transferId: Scalars['BankTransferId']['input'];
  invoiceId: Scalars['SalesInvoiceId']['input'];
}>;


export type TransferDetailsDrawerCreateConnectionMutation = { readonly __typename?: 'Mutation', readonly createPaymentConnection:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'PaymentConnection' }
      & TransferDetailsDrawerPaymentConnectionFragment
    )
   };

export type TransferDetailsDrawerDeleteConnectionMutationVariables = Exact<{
  transferId: Scalars['BankTransferId']['input'];
  invoiceId: Scalars['SalesInvoiceId']['input'];
}>;


export type TransferDetailsDrawerDeleteConnectionMutation = { readonly __typename?: 'Mutation', readonly deletePaymentConnection:
    | (
      { readonly __typename?: 'BankIncomeTransfer', readonly discrepancy: number, readonly connectedPayments: ReadonlyArray<(
        { readonly __typename?: 'PaymentConnection' }
        & TransferDetailsDrawerPaymentConnectionFragment
      )> }
      & BankTransfersBankTransferBankIncomeTransferFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TransferDetailsDrawerUpdateTransferMutationVariables = Exact<{
  transferId: Scalars['BankTransferId']['input'];
  status?: InputMaybe<BankTransferStatus>;
  note?: InputMaybe<ClearableStringInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Cents']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  toName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TransferDetailsDrawerUpdateTransferMutation = { readonly __typename?: 'Mutation', readonly bankTransfer: { readonly __typename?: 'BankTransferMutation', readonly update:
      | { readonly __typename?: 'BankTransferResponse', readonly value:
          | (
            { readonly __typename?: 'BankIncomeTransfer', readonly discrepancy: number, readonly connectedPayments: ReadonlyArray<(
              { readonly __typename?: 'PaymentConnection' }
              & TransferDetailsDrawerPaymentConnectionFragment
            )> }
            & BankTransfersBankTransferBankIncomeTransferFragment
          )
          | (
            { readonly __typename?: 'BankOutcomeTransfer' }
            & BankTransfersBankTransferBankOutcomeTransferFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type TransferListExportDrawerGenerateMutationVariables = Exact<{
  filter: FilterBankTransferInput;
}>;


export type TransferListExportDrawerGenerateMutation = { readonly __typename?: 'Mutation', readonly exportTransfers:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TransferSummaryModalCurrencyConversionFragment = { readonly __typename?: 'CurrencyConversion', readonly originalCurrency: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ), readonly targetCurrency: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ) };

export type TransfersSummaryModalEmploymentTransfersSummaryFragment = { readonly __typename?: 'EmploymentTransfersSummary', readonly contractCount: number, readonly totalSalary: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ), readonly salariesByCurrency: ReadonlyArray<(
    { readonly __typename?: 'CurrencyConversion' }
    & TransferSummaryModalCurrencyConversionFragment
  )>, readonly totalTransferAmount: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ), readonly transferAmountsByCurrency: ReadonlyArray<(
    { readonly __typename?: 'CurrencyConversion' }
    & TransferSummaryModalCurrencyConversionFragment
  )>, readonly totalTaxPrepayment: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ), readonly taxPrepaymentsByCurrency: ReadonlyArray<(
    { readonly __typename?: 'CurrencyConversion' }
    & TransferSummaryModalCurrencyConversionFragment
  )>, readonly totalTaxRefund: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ), readonly taxRefundsByCurrency: ReadonlyArray<(
    { readonly __typename?: 'CurrencyConversion' }
    & TransferSummaryModalCurrencyConversionFragment
  )>, readonly totalZusContribution: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ), readonly zusContributionsByCurrency: ReadonlyArray<(
    { readonly __typename?: 'CurrencyConversion' }
    & TransferSummaryModalCurrencyConversionFragment
  )>, readonly totalPpkAmount: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ), readonly ppkAmountsByCurrency: ReadonlyArray<(
    { readonly __typename?: 'CurrencyConversion' }
    & TransferSummaryModalCurrencyConversionFragment
  )> };

export type TransfersSummaryModalB2BTransfersSummaryFragment = { readonly __typename?: 'B2BTransfersSummary', readonly contractCount: number, readonly totalNetSalary: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ), readonly netSalariesByCurrency: ReadonlyArray<(
    { readonly __typename?: 'CurrencyConversion' }
    & TransferSummaryModalCurrencyConversionFragment
  )>, readonly totalGrossSalary: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ), readonly grossSalariesByCurrency: ReadonlyArray<(
    { readonly __typename?: 'CurrencyConversion' }
    & TransferSummaryModalCurrencyConversionFragment
  )>, readonly totalTax: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ), readonly taxByCurrency: ReadonlyArray<(
    { readonly __typename?: 'CurrencyConversion' }
    & TransferSummaryModalCurrencyConversionFragment
  )>, readonly totalTransferAmount: (
    { readonly __typename?: 'CentsWithCurrency' }
    & CentsWithCurrencyFragment
  ), readonly transferAmountsByCurrency: ReadonlyArray<(
    { readonly __typename?: 'CurrencyConversion' }
    & TransferSummaryModalCurrencyConversionFragment
  )> };

export type TransfersSummaryModalQueryVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  filter: FilterContractSalaryDetailsInput;
}>;


export type TransfersSummaryModalQuery = { readonly __typename?: 'Query', readonly contractSalarySummariesWithFilter:
    | { readonly __typename?: 'ListOfTransfersSummariesResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'TransfersSummaries', readonly yearMonth: Date, readonly b2b: { readonly __typename?: 'B2BTransfersSummaries', readonly totalCount: number, readonly paymentDisbursedState: (
            { readonly __typename?: 'B2BTransfersSummary' }
            & TransfersSummaryModalB2BTransfersSummaryFragment
          ), readonly readyState: (
            { readonly __typename?: 'B2BTransfersSummary' }
            & TransfersSummaryModalB2BTransfersSummaryFragment
          ), readonly incompleteDataState: { readonly __typename?: 'B2BIncompleteDataStateSummary', readonly transfersSummary: (
              { readonly __typename?: 'B2BTransfersSummary' }
              & TransfersSummaryModalB2BTransfersSummaryFragment
            ) } }, readonly employment: { readonly __typename?: 'EmploymentTransfersSummaries', readonly totalCount: number, readonly paymentDisbursedState: (
            { readonly __typename?: 'EmploymentTransfersSummary' }
            & TransfersSummaryModalEmploymentTransfersSummaryFragment
          ), readonly readyState: (
            { readonly __typename?: 'EmploymentTransfersSummary' }
            & TransfersSummaryModalEmploymentTransfersSummaryFragment
          ), readonly incompleteDataState: { readonly __typename?: 'EmploymentIncompleteDataStateSummary', readonly transfersSummary: (
              { readonly __typename?: 'EmploymentTransfersSummary' }
              & TransfersSummaryModalEmploymentTransfersSummaryFragment
            ) } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type UopHolidaysReportDrawerGenerateMutationVariables = Exact<{
  year: Scalars['Year']['input'];
}>;


export type UopHolidaysReportDrawerGenerateMutation = { readonly __typename?: 'Mutation', readonly generateHolidaySummaryDocument:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type UopHolidaysReportDrawerGoogleDocQueryVariables = Exact<{
  year: Scalars['Year']['input'];
}>;


export type UopHolidaysReportDrawerGoogleDocQuery = { readonly __typename?: 'Query', readonly holidaySummaryDocument:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type UserDocumentsUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly documentsDirectory:
    | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type UserDocumentsQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type UserDocumentsQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & UserDocumentsUserFragment
    )
   };

export type UserDocumentsUpdateUserMutationVariables = Exact<{
  userId: Scalars['UserId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  documentsDirectory?: InputMaybe<Scalars['URI']['input']>;
}>;


export type UserDocumentsUpdateUserMutation = { readonly __typename?: 'Mutation', readonly user: { readonly __typename?: 'UserMutation', readonly updateUser:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'User' }
        & UserDocumentsUserFragment
      )
     } };

export type UserProgressionProgressionQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type UserProgressionProgressionQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User', readonly firstName: string, readonly lastName: string, readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | (
              { readonly __typename?: 'B2BContract', readonly createdAt: Date, readonly name: string, readonly b2bContractType: B2BContractType, readonly notes:
                | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
              & ProgressionDetailsContractB2BContractFragment
            )
            | (
              { readonly __typename?: 'EmploymentContract', readonly createdAt: Date, readonly name: string, readonly notes:
                | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
              & ProgressionDetailsContractEmploymentContractFragment
            )
            | (
              { readonly __typename?: 'Subcontract', readonly createdAt: Date, readonly name: string, readonly clientContract:
                | { readonly __typename?: 'AccessGranted__ClientContract', readonly value: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly notes:
                | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
              & ProgressionDetailsContractSubcontractFragment
            )
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
      & ProgressionDetailsUserFragment
    )
   };

export type UserProjectFormClientContractFragment = { readonly __typename?: 'ClientContract', readonly id: string, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string }, readonly contractDurationFrom:
    | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly contractDurationTo:
    | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly name:
    | { readonly __typename?: 'AccessGranted__String', readonly value: string }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly positions:
    | { readonly __typename?: 'AccessGranted__ListOfClientPosition', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }> } }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type UserProjectFormProjectInfoQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type UserProjectFormProjectInfoQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Project', readonly id: string, readonly name: string, readonly entityVersion: number, readonly statusHistory: ReadonlyArray<{ readonly __typename?: 'ProjectStatusHistoryEntry', readonly status: ProjectStatus, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }>, readonly clientContract: (
        { readonly __typename?: 'ClientContract' }
        & UserProjectFormClientContractFragment
      ) }
   };

export type UserProjectFormIntraCompanyContractsQueryVariables = Exact<{
  promisorId: Scalars['CompanyId']['input'];
  promiseeId: Scalars['CompanyId']['input'];
}>;


export type UserProjectFormIntraCompanyContractsQuery = { readonly __typename?: 'Query', readonly clientContractsBetweenCompanies:
    | { readonly __typename?: 'ListOfClientContractResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'ClientContract' }
        & ProjectMembersDrawerClientContractFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type UserProjectsDrawerProjectAssignmentFragment = { readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly name: string, readonly statusHistory: ReadonlyArray<{ readonly __typename?: 'ProjectStatusHistoryEntry', readonly status: ProjectStatus, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }>, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly contractDurationFrom:
        | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contractDurationTo:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly name:
        | { readonly __typename?: 'AccessGranted__String', readonly value: string }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string }, readonly positions:
        | { readonly __typename?: 'AccessGranted__ListOfClientPosition', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }> } }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       } }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly clientPosition:
      | { readonly __typename?: 'AccessGranted__ClientPosition', readonly value: { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string } }
      | (
        { readonly __typename?: 'Unauthorized' }
        & UnauthorizedFragment
      )
    , readonly subcontractPosition:
      | { readonly __typename?: 'AccessGranted__OptionalClientPosition', readonly value?: { readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string } | null }
      | (
        { readonly __typename?: 'Unauthorized' }
        & UnauthorizedFragment
      )
     }> };

export type UserProjectsDrawerProjectAssignmentUpdateFragment = (
  { readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly assignedProjects:
        | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<(
            { readonly __typename?: 'ProjectAssignment' }
            & UserProjectsDrawerProjectAssignmentFragment
          )> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       } } }
  & UserProjectsDrawerProjectAssignmentFragment
);

export type UserProjectsDrawerInitialDataQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type UserProjectsDrawerInitialDataQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly assignedProjects:
          | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<(
              { readonly __typename?: 'ProjectAssignment' }
              & UserProjectsDrawerProjectAssignmentFragment
            )> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }, readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
            | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly clientContract:
                | { readonly __typename?: 'AccessGranted__ClientContract', readonly value: { readonly __typename?: 'ClientContract', readonly id: string, readonly positions:
                      | { readonly __typename?: 'AccessGranted__ListOfClientPosition', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientPosition', readonly id: string, readonly name: string, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly activityId: string, readonly value: boolean, readonly applyDate: Date }> } }> }
                      | (
                        { readonly __typename?: 'Unauthorized' }
                        & UnauthorizedFragment
                      )
                     } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type UserProjectDrawerUpdateAssignmentMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  state: CreateProjectAssignmentInput;
}>;


export type UserProjectDrawerUpdateAssignmentMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly projectAssignments: { readonly __typename?: 'ProjectAssignmentOperations', readonly upsertProjectAssignment:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'ProjectAssignment', readonly project: (
            { readonly __typename?: 'Project' }
            & ProjectLeadFragment
          ) }
          & UserProjectsDrawerProjectAssignmentUpdateFragment
        )
       } } };

export type UserProjectDrawerUpdateInternalAssignmentMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  state: CreateInternalProjectAssignmentInput;
}>;


export type UserProjectDrawerUpdateInternalAssignmentMutation = { readonly __typename?: 'Mutation', readonly internalProject: { readonly __typename?: 'InternalProjectMutations', readonly upsertInternalProjectAssignment:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | (
        { readonly __typename?: 'ProjectAssignment', readonly project: (
          { readonly __typename?: 'Project' }
          & ProjectLeadFragment
        ) }
        & UserProjectsDrawerProjectAssignmentFragment
      )
     } };

export type UserProjectsDrawerRemoveAssignmentMutationVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  userId: Scalars['UserId']['input'];
}>;


export type UserProjectsDrawerRemoveAssignmentMutation = { readonly __typename?: 'Mutation', readonly project: { readonly __typename?: 'ProjectMutation', readonly projectAssignments: { readonly __typename?: 'ProjectAssignmentOperations', readonly deleteProjectAssignment:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
       } } };

export type UserTimeReportDetailsGenerateRaportQueryVariables = Exact<{
  month: Scalars['YearMonth']['input'];
  contractId: Scalars['ContractId']['input'];
}>;


export type UserTimeReportDetailsGenerateRaportQuery = { readonly __typename?: 'Query', readonly timeReportFile:
    | { readonly __typename?: 'DownloadableFileUrl', readonly url: string, readonly fileName: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type UserTimeReportDetailsApproveLeaveMutationVariables = Exact<{
  entryId: Scalars['AbsenceRecordId']['input'];
}>;


export type UserTimeReportDetailsApproveLeaveMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly absenceRecord: { readonly __typename?: 'AbsenceRecordApi', readonly approve:
        | (
          { readonly __typename?: 'AbsenceRecord' }
          & AbsenceRecordFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type UserTimeReportDetailsRejectLeaveMutationVariables = Exact<{
  entryId: Scalars['AbsenceRecordId']['input'];
}>;


export type UserTimeReportDetailsRejectLeaveMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly absenceRecord: { readonly __typename?: 'AbsenceRecordApi', readonly reject:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'UnitResponse' }
       } } };

export type UserTimeReportDetailsApproveOvertimeMutationVariables = Exact<{
  entryId: Scalars['WorkRecordId']['input'];
}>;


export type UserTimeReportDetailsApproveOvertimeMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly workRecord: { readonly __typename?: 'WorkRecordApi', readonly approve:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkRecord' }
          & WorkRecordFragment
        )
       } } };

export type UserTimeReportDetailsRejectOvertimeMutationVariables = Exact<{
  entryId: Scalars['WorkRecordId']['input'];
}>;


export type UserTimeReportDetailsRejectOvertimeMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly workRecord: { readonly __typename?: 'WorkRecordApi', readonly reject:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'UnitResponse' }
       } } };

export type UserTimeReportsContractsQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type UserTimeReportsContractsQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly createdAt: Date, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly status: ContractStatus, readonly name: string, readonly b2bContractType: B2BContractType, readonly vat:
                | { readonly __typename?: 'AccessGranted__TimeBasedVatType', readonly value: { readonly __typename?: 'TimeBasedVatType', readonly value:
                      | (
                        { readonly __typename?: 'VatApplied' }
                        & VatTypeVatAppliedFragment
                      )
                      | (
                        { readonly __typename?: 'VatNotApplied' }
                        & VatTypeVatNotAppliedFragment
                      )
                     } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly currency:
                | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
            | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly createdAt: Date, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly status: ContractStatus, readonly name: string, readonly currency:
                | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly createdAt: Date, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly status: ContractStatus, readonly name: string, readonly clientContract:
                | { readonly __typename?: 'AccessGranted__ClientContract', readonly value: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly directReporting: { readonly __typename?: 'DirectReporting', readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: { readonly __typename?: 'Space', readonly id: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string } } } } }
   };

export type YearlyCostSummaryDrawerInputQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type YearlyCostSummaryDrawerInputQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly name: string, readonly status: ContractStatus }
            | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly name: string, readonly status: ContractStatus }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly name: string, readonly status: ContractStatus }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type YearlyCostSummaryDrawerLoadReportQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  range: ClosedEndMonthRangeInput;
}>;


export type YearlyCostSummaryDrawerLoadReportQuery = { readonly __typename?: 'Query', readonly contractsCostsSummary:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AbsencesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterUserInput>;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
}>;


export type AbsencesQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly contracts:
            | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
                | { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus, readonly b2bContractType: B2BContractType, readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly id: HolidayCalendarId, readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date, readonly dayType: CalendarDayType }> } }
                | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly status: ContractStatus, readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly id: HolidayCalendarId, readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date, readonly dayType: CalendarDayType }> } }
                | { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus, readonly b2bContractType: B2BContractType, readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly id: HolidayCalendarId, readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date, readonly dayType: CalendarDayType }> } }
              > }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly timeReports:
            | { readonly __typename?: 'AccessGranted__TimeReports', readonly value: { readonly __typename?: 'TimeReports', readonly absenceRecords: ReadonlyArray<(
                  { readonly __typename?: 'AbsenceRecord', readonly contractId: string }
                  & AbsenceRecordFragment
                )> } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AbsencesInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type AbsencesInfoQuery = { readonly __typename?: 'Query', readonly absenceTypeDetails: ReadonlyArray<{ readonly __typename?: 'KVAbsenceTypeAbsenceTypeDetails', readonly key: AbsenceType, readonly value: { readonly __typename?: 'AbsenceTypeDetails', readonly canBeReportedOnHoliday: boolean, readonly applicableFor: ReadonlyArray<ContractType>, readonly canTakeCustomNumberOfHours: boolean, readonly limit?: number | null } }> };

export type ApiTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiTokensQuery = { readonly __typename?: 'Query', readonly apiTokens:
    | { readonly __typename?: 'ListOfApiTokenResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ApiToken', readonly name: string, readonly claims: ReadonlyArray<string>, readonly description: string, readonly createdAt: Date, readonly validUntil: Date, readonly ticketUrl?: string | null, readonly lastUsedAt?: Date | null }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BankTransfersBankAccountNumberIbanFragment = { readonly __typename?: 'Iban', readonly value: string };

export type BankTransfersBankAccountNumberOtherBankAccountNumberFragment = { readonly __typename?: 'OtherBankAccountNumber', readonly value: string };

export type BankTransfersBankAccountNumberFragment =
  | BankTransfersBankAccountNumberIbanFragment
  | BankTransfersBankAccountNumberOtherBankAccountNumberFragment
;

export type BankTransfersBankTransferBankIncomeTransferFragment = { readonly __typename?: 'BankIncomeTransfer', readonly id: string, readonly bookDate: Date, readonly operationDate: Date, readonly title: string, readonly amount: number, readonly currency: string, readonly status: BankTransferStatus, readonly note?: string | null, readonly toName: string, readonly fromName: string, readonly toAccount?: (
    { readonly __typename?: 'BankAccount' }
    & BankAccountFragment
  ) | null, readonly fromAccountNumber:
    | (
      { readonly __typename?: 'Iban' }
      & BankTransfersBankAccountNumberIbanFragment
    )
    | (
      { readonly __typename?: 'OtherBankAccountNumber' }
      & BankTransfersBankAccountNumberOtherBankAccountNumberFragment
    )
  , readonly toAccountNumber:
    | (
      { readonly __typename?: 'Iban' }
      & BankTransfersBankAccountNumberIbanFragment
    )
    | (
      { readonly __typename?: 'OtherBankAccountNumber' }
      & BankTransfersBankAccountNumberOtherBankAccountNumberFragment
    )
   };

export type BankTransfersBankTransferBankOutcomeTransferFragment = { readonly __typename?: 'BankOutcomeTransfer', readonly id: string, readonly bookDate: Date, readonly operationDate: Date, readonly title: string, readonly amount: number, readonly currency: string, readonly status: BankTransferStatus, readonly note?: string | null, readonly toName: string, readonly fromName: string, readonly fromAccountNumber:
    | (
      { readonly __typename?: 'Iban' }
      & BankTransfersBankAccountNumberIbanFragment
    )
    | (
      { readonly __typename?: 'OtherBankAccountNumber' }
      & BankTransfersBankAccountNumberOtherBankAccountNumberFragment
    )
  , readonly toAccountNumber:
    | (
      { readonly __typename?: 'Iban' }
      & BankTransfersBankAccountNumberIbanFragment
    )
    | (
      { readonly __typename?: 'OtherBankAccountNumber' }
      & BankTransfersBankAccountNumberOtherBankAccountNumberFragment
    )
   };

export type BankTransfersBankTransferFragment =
  | BankTransfersBankTransferBankIncomeTransferFragment
  | BankTransfersBankTransferBankOutcomeTransferFragment
;

export type BankTransfersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterBankTransferInput>;
  sort?: InputMaybe<SortingRequestSortBankTransferInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BankTransfersQuery = { readonly __typename?: 'Query', readonly bankTransfers:
    | { readonly __typename?: 'FSPResponseBankTransfer', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeBankTransfer', readonly cursor: string, readonly node:
          | (
            { readonly __typename?: 'BankIncomeTransfer', readonly discrepancy: number, readonly connectedPayments: ReadonlyArray<{ readonly __typename?: 'PaymentConnection', readonly tpe: PaymentConnectionType, readonly transfer: { readonly __typename?: 'BankIncomeTransfer', readonly id: string, readonly status: BankTransferStatus }, readonly invoice: { readonly __typename?: 'SalesInvoice', readonly id: number, readonly number: string } }> }
            & BankTransfersBankTransferBankIncomeTransferFragment
          )
          | (
            { readonly __typename?: 'BankOutcomeTransfer' }
            & BankTransfersBankTransferBankOutcomeTransferFragment
          )
         }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BankTransfersFetchIngMutationVariables = Exact<{ [key: string]: never; }>;


export type BankTransfersFetchIngMutation = { readonly __typename?: 'Mutation', readonly triggerIngTransfersMonitoring:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'UnitResponse' }
   };

export type ClientContractProfileQueryVariables = Exact<{
  clientContractId: Scalars['ClientContractId']['input'];
}>;


export type ClientContractProfileQuery = { readonly __typename?: 'Query', readonly clientContract:
    | { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly createdAt: Date, readonly name:
        | { readonly __typename?: 'AccessGranted__String', readonly value: string }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null, readonly companyType: ReadonlyArray<CompanyType> } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null, readonly companyType: ReadonlyArray<CompanyType> }, readonly contractDurationFrom:
        | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contractDurationTo:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly docUri:
        | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly vat:
        | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint', readonly value: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null } }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly currency:
        | { readonly __typename?: 'AccessGranted__TimeBasedOptCurrency', readonly value: { readonly __typename?: 'TimeBasedOptCurrency', readonly value?: string | null } }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly projects: ReadonlyArray<{ readonly __typename?: 'Project', readonly id: string, readonly name: string, readonly statusHistory: ReadonlyArray<{ readonly __typename?: 'ProjectStatusHistoryEntry', readonly status: ProjectStatus, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }> }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ClientContractsPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterClientContractInput>;
  sort?: InputMaybe<SortingRequestSortClientContractInput>;
}>;


export type ClientContractsPageQuery = { readonly __typename?: 'Query', readonly clientContracts:
    | { readonly __typename?: 'FSPResponseClientContract', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeClientContract', readonly cursor: string, readonly node: { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly createdAt: Date, readonly name:
            | { readonly __typename?: 'AccessGranted__String', readonly value: string }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null, readonly taxNumber?: string | null, readonly address?: (
              { readonly __typename?: 'Address' }
              & AddressFragment
            ) | null } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null, readonly taxNumber?: string | null, readonly address?: (
              { readonly __typename?: 'Address' }
              & AddressFragment
            ) | null }, readonly contractDurationFrom:
            | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly contractDurationTo:
            | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly currency:
            | { readonly __typename?: 'AccessGranted__TimeBasedOptCurrency', readonly value: { readonly __typename?: 'TimeBasedOptCurrency', readonly value?: string | null } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly projects: ReadonlyArray<{ readonly __typename?: 'Project', readonly id: string, readonly name: string }> } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CompaniesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterCompanyInput>;
  sort?: InputMaybe<SortingRequestSortCompanyInput>;
}>;


export type CompaniesQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly cursor: string, readonly node: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null, readonly createdAt: Date, readonly companyType: ReadonlyArray<CompanyType>, readonly taxNumber?: string | null, readonly regon?: string | null, readonly registerId?: string | null, readonly sectors:
            | { readonly __typename?: 'AccessGranted__ListOfString', readonly value: ReadonlyArray<string> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly euVatType: { readonly __typename?: 'TimeBasedValueWithVerificationEuVatType', readonly value: { readonly __typename?: 'ValueWithVerificationEuVatType', readonly value: EuVatType } }, readonly isPolishVat: { readonly __typename?: 'TimeBasedValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: { readonly __typename?: 'ValueWithDescriptionAndVerificationBooleanVATStatus', readonly value: boolean } }, readonly address?: (
            { readonly __typename?: 'Address' }
            & AddressFragment
          ) | null } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CompanyDetailsQueryVariables = Exact<{
  companyId: Scalars['CompanyId']['input'];
}>;


export type CompanyDetailsQuery = { readonly __typename?: 'Query', readonly company:
    | { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null, readonly companyType: ReadonlyArray<CompanyType>, readonly address?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractsDraftsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContractsDraftsQuery = { readonly __typename?: 'Query', readonly contractDrafts:
    | { readonly __typename?: 'ListOfContractDraftResponse', readonly value: ReadonlyArray<
        | { readonly __typename?: 'B2BContractDraft', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate?: Date | null, readonly expectedEndDate?: Date | null, readonly b2bContractType: B2BContractType, readonly promiseeCompany?: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly address?: (
              { readonly __typename?: 'Address' }
              & AddressFragment
            ) | null } | null, readonly promisor: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null } } }
        | { readonly __typename?: 'EmploymentContractDraft', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate?: Date | null, readonly expectedEndDate?: Date | null, readonly promisor: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null } } }
        | { readonly __typename?: 'SubcontractDraft', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate?: Date | null, readonly expectedEndDate?: Date | null, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly name:
              | { readonly __typename?: 'AccessGranted__String', readonly value: string }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string } }, readonly promisor: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null } } }
      > }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ContractsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterContractInput>;
  sort?: InputMaybe<SortingRequestSortContractInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContractsQuery = { readonly __typename?: 'Query', readonly contracts:
    | { readonly __typename?: 'FSPResponseContract', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeContract', readonly cursor: string, readonly node:
          | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly terminationDate?: Date | null, readonly startDate: Date, readonly status: ContractStatus, readonly expectedEndDate?: Date | null, readonly b2bContractType: B2BContractType, readonly position: { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null }, readonly promiseeCompany:
              | { readonly __typename?: 'AccessGranted__Company', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null, readonly address?: (
                    { readonly __typename?: 'Address' }
                    & AddressFragment
                  ) | null } }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly conclusionDate:
              | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null } }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null } } }
          | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly name: string, readonly terminationDate?: Date | null, readonly startDate: Date, readonly status: ContractStatus, readonly expectedEndDate?: Date | null, readonly position: { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null }, readonly conclusionDate:
              | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null } }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null } } }
          | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly terminationDate?: Date | null, readonly startDate: Date, readonly status: ContractStatus, readonly expectedEndDate?: Date | null, readonly clientContract:
              | { readonly __typename?: 'AccessGranted__ClientContract', readonly value: { readonly __typename?: 'ClientContract', readonly id: string, readonly name:
                    | { readonly __typename?: 'AccessGranted__String', readonly value: string }
                    | (
                      { readonly __typename?: 'Unauthorized' }
                      & UnauthorizedFragment
                    )
                  , readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly conclusionDate:
              | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null } }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null } } }
         }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CopyrightsQueryVariables = Exact<{
  sortBy: SortWorkTransferProtocolsInput;
}>;


export type CopyrightsQuery = { readonly __typename?: 'Query', readonly pendingWorkTransferProtocols:
    | { readonly __typename?: 'ListOfWorkTransferProtocolResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'WorkTransferProtocol', readonly id: string, readonly description?: string | null, readonly createdBy: string, readonly createdAt: Date, readonly payload:
          | { readonly __typename?: 'File', readonly value: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly downloadUrl: string, readonly openUrl: string, readonly fileName: string } }
          | { readonly __typename?: 'NoWorkToBeTransferedThisMonth' }
        , readonly approval:
          | (
            { readonly __typename?: 'Approved' }
            & ApprovalApprovedFragment
          )
          | (
            { readonly __typename?: 'NotRequired' }
            & ApprovalNotRequiredFragment
          )
          | (
            { readonly __typename?: 'PendingApproval' }
            & ApprovalPendingApprovalFragment
          )
        , readonly contractSalaryDetails:
          | { readonly __typename?: 'B2BContractSalaryDetails', readonly yearMonth: Date, readonly contractId: string }
          | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly yearMonth: Date, readonly contractId: string, readonly contract: { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly email: string, readonly firstName: string, readonly lastName: string } } }
         }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CopyrightsAnnualSummaryQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  sort?: InputMaybe<SortingRequestSortContractInput>;
  filter: FilterContractInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Year']['input'];
}>;


export type CopyrightsAnnualSummaryQuery = { readonly __typename?: 'Query', readonly contracts:
    | { readonly __typename?: 'FSPResponseContract', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeContract', readonly cursor: string, readonly node:
          | { readonly __typename?: 'B2BContract' }
          | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly startDate: Date, readonly status: ContractStatus, readonly terminationDate?: Date | null, readonly createdAt: Date, readonly expectedEndDate?: Date | null, readonly type: EmploymentContractType, readonly conclusionDate:
              | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null }, readonly workTransferProtocols:
              | { readonly __typename?: 'AccessGranted__ListOfWorkTransferProtocol', readonly value: ReadonlyArray<{ readonly __typename?: 'WorkTransferProtocol', readonly id: string, readonly contractId: string, readonly yearMonth: Date, readonly approval:
                    | (
                      { readonly __typename?: 'Approved' }
                      & ApprovalApprovedFragment
                    )
                    | (
                      { readonly __typename?: 'NotRequired' }
                      & ApprovalNotRequiredFragment
                    )
                    | (
                      { readonly __typename?: 'PendingApproval' }
                      & ApprovalPendingApprovalFragment
                    )
                  , readonly payload:
                    | { readonly __typename?: 'File' }
                    | { readonly __typename: 'NoWorkToBeTransferedThisMonth' }
                   }> }
              | { readonly __typename?: 'Unauthorized' }
             }
          | { readonly __typename?: 'Subcontract' }
         }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CostInvoiceDetailsCostInvoiceFragment = { readonly __typename?: 'CostInvoice', readonly number: string, readonly issueDate: Date, readonly saleDate: Date, readonly paymentDate?: Date | null, readonly category?: string | null, readonly description?: string | null, readonly grossValue: number, readonly currency: string, readonly ksefNumber?: string | null, readonly ksefPreviewSource?: string | null, readonly isCorrective: boolean, readonly saldeoDocumentUrl?: string | null, readonly previewUrls: ReadonlyArray<string>, readonly contractor: { readonly __typename?: 'CostInvoiceContractor', readonly name?: string | null, readonly taxNumber?: string | null }, readonly saldeoDocumentId: { readonly __typename?: 'SaldeoDocumentId', readonly companyProgramId: string, readonly documentId: number } };

export type CostInvoiceDetailsQueryVariables = Exact<{
  saldeoDocumentId: SaldeoDocumentIdInput;
}>;


export type CostInvoiceDetailsQuery = { readonly __typename?: 'Query', readonly costInvoice:
    | (
      { readonly __typename?: 'CostInvoice' }
      & CostInvoiceDetailsCostInvoiceFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CostInvoicesCostInvoiceFragment = { readonly __typename?: 'CostInvoice', readonly number: string, readonly issueDate: Date, readonly saleDate: Date, readonly paymentDate?: Date | null, readonly category?: string | null, readonly description?: string | null, readonly grossValue: number, readonly currency: string, readonly ksefNumber?: string | null, readonly ksefPreviewSource?: string | null, readonly isCorrective: boolean, readonly saldeoDocumentUrl?: string | null, readonly previewUrls: ReadonlyArray<string>, readonly contractor: { readonly __typename?: 'CostInvoiceContractor', readonly name?: string | null, readonly taxNumber?: string | null }, readonly saldeoDocumentId: { readonly __typename?: 'SaldeoDocumentId', readonly companyProgramId: string, readonly documentId: number } };

export type CostInvoicesQueryVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  companyId: Scalars['CompanyId']['input'];
}>;


export type CostInvoicesQuery = { readonly __typename?: 'Query', readonly costInvoices:
    | { readonly __typename?: 'ListOfCostInvoiceResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'CostInvoice' }
        & CostInvoicesCostInvoiceFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ReportsEmployeeDueDatesPersonFragment = { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly nextOhsTrainingDate:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly isStudentRevisionDate:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly nextMedicalExaminationDate:
        | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       } }> };

export type ReportsEmployeeDueDatesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  filter?: InputMaybe<FilterUserInput>;
}>;


export type ReportsEmployeeDueDatesQuery = { readonly __typename?: 'Query', readonly users:
    | (
      { readonly __typename?: 'FSPResponseUser' }
      & ReportsEmployeeDueDatesPersonFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type OfficeDetailsQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type OfficeDetailsQuery = { readonly __typename?: 'Query', readonly office:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null, readonly blocked: boolean, readonly avatar?: string | null, readonly entityVersion: number }
   };

export type OfficeReservationsRowFragment = { readonly __typename?: 'OfficeReservation', readonly id: string, readonly requestId: string, readonly date: Date, readonly kind: ResourceKind, readonly notes?: string | null, readonly guestEmails: ReadonlyArray<string>, readonly plateNumber?: string | null, readonly createdAt: Date, readonly resource: { readonly __typename?: 'ReservedResource', readonly id: string, readonly name: string }, readonly office: { readonly __typename?: 'Office', readonly officeId: string, readonly name: string }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null } };

export type OfficeReservationsQueryVariables = Exact<{
  filter: FilterOfficeReservationInput;
  first: Scalars['Int']['input'];
}>;


export type OfficeReservationsQuery = { readonly __typename?: 'Query', readonly officeReservations:
    | { readonly __typename?: 'FSPResponseOfficeReservation', readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeOfficeReservation', readonly node: (
          { readonly __typename?: 'OfficeReservation' }
          & OfficeReservationsRowFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type OfficeReservationsApproveManyMutationVariables = Exact<{
  requestIds: ReadonlyArray<Scalars['ReservationRequestId']['input']> | Scalars['ReservationRequestId']['input'];
}>;


export type OfficeReservationsApproveManyMutation = { readonly __typename?: 'Mutation', readonly approveOfficeReservations:
    | { readonly __typename?: 'ListOfReservationRequestResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ReservationRequest', readonly requestId: string }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type OfficesOfficeFragment = { readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly physical: boolean, readonly validFrom: Date, readonly validTo?: Date | null, readonly blocked: boolean, readonly avatar?: string | null };

export type OfficesQueryVariables = Exact<{ [key: string]: never; }>;


export type OfficesQuery = { readonly __typename?: 'Query', readonly offices:
    | { readonly __typename?: 'ListOfOfficeResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'Office' }
        & OfficesOfficeFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type PeoplePersonFragment = { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly skillsAndCompetences: ReadonlyArray<string>, readonly areaOfExpertise?: string | null, readonly certificates:
        | { readonly __typename?: 'AccessGranted__ListOfCertificate', readonly value: ReadonlyArray<{ readonly __typename?: 'Certificate', readonly id: string, readonly name: string }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly role: { readonly __typename?: 'TimeBasedCompanyRole', readonly value: CompanyRole }, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus, readonly position: { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null } }
            | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly status: ContractStatus, readonly position: { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null } }
            | { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly newestRateChangeDate:
        | { readonly __typename?: 'AccessGranted__OptionalOffsetDateTime', readonly value?: Date | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly directReporting: { readonly __typename?: 'DirectReporting', readonly practiceLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null } | null }, readonly operationalLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null } | null }, readonly assignedProjects:
          | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly name: string, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string } | null } } }> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: { readonly __typename?: 'Space', readonly id: string, readonly name: string } } } } }> };

export type PeopleQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterUserInput>;
  sort?: InputMaybe<SortingRequestSortUserInput>;
}>;


export type PeopleQuery = { readonly __typename?: 'Query', readonly users:
    | (
      { readonly __typename?: 'FSPResponseUser' }
      & PeoplePersonFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type PersonDetailsQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type PersonDetailsQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly socialMediaHandles:
        | { readonly __typename?: 'AccessGranted__ListOfSocialMediaHandle', readonly value: ReadonlyArray<{ readonly __typename?: 'SocialMediaHandle', readonly platform: string, readonly handle: string }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly assignedProjects:
          | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment' }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         }, readonly documentsDirectory:
        | { readonly __typename?: 'AccessGranted__OptionalURI', readonly value?: string | null }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contractDraft:
        | { readonly __typename?: 'AccessGranted__OptionalContractDraft' }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
      , readonly contracts:
        | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
            | { readonly __typename?: 'B2BContract', readonly id: string, readonly currency:
                | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
            | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly annualLeaveEntitlement:
                | { readonly __typename?: 'AccessGranted__OptionalAnnualLeaveEntitlement', readonly value?: { readonly __typename?: 'AnnualLeaveEntitlement', readonly withCarryOverToNextYear: boolean } | null }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly currency:
                | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }
            | { readonly __typename?: 'Subcontract', readonly id: string }
          > }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       }
   };

export type PersonDetailsTrQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type PersonDetailsTrQuery = { readonly __typename?: 'Query', readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport' }
   };

export type ProgressionSchemeDetailsQueryVariables = Exact<{
  schemeId: Scalars['ProgressionSchemeId']['input'];
}>;


export type ProgressionSchemeDetailsQuery = { readonly __typename?: 'Query', readonly progressionScheme:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'ProgressionScheme' }
      & ProgressionSchemesProgressionSchemeFragment
    )
   };

export type ProgressionSchemesProgressionSchemeLevelFragment = { readonly __typename?: 'ProgressionSchemeLevel', readonly schemeId: string, readonly level: ProgressionLevel, readonly title: string, readonly hourlyRate: number, readonly noticePeriod?: number | null };

export type ProgressionSchemesProgressionSchemeFragment = { readonly __typename?: 'ProgressionScheme', readonly id: string, readonly name: string, readonly isEngineering: boolean, readonly yearlyRaise: number, readonly createdAt: Date, readonly archivedAt?: Date | null, readonly levels: ReadonlyArray<(
    { readonly __typename?: 'ProgressionSchemeLevel' }
    & ProgressionSchemesProgressionSchemeLevelFragment
  )> };

export type ProgressionSchemesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgressionSchemesQuery = { readonly __typename?: 'Query', readonly progressionSchemes:
    | { readonly __typename?: 'ListOfProgressionSchemeResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'ProgressionScheme' }
        & ProgressionSchemesProgressionSchemeFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ProjectDetailsQueryVariables = Exact<{
  projectId: Scalars['ProjectId']['input'];
}>;


export type ProjectDetailsQuery = { readonly __typename?: 'Query', readonly project:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly createdAt: Date, readonly name: string, readonly statusHistory: ReadonlyArray<{ readonly __typename?: 'ProjectStatusHistoryEntry', readonly status: ProjectStatus, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }>, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number } }, readonly lead?: { readonly __typename?: 'ProjectRoleAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectRoleAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } }> } | null }
   };

export type ProjectUtilizationQueryVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  fullTimeThresholdMinutes: Scalars['Int']['input'];
  halfTimeThresholdMinutes: Scalars['Int']['input'];
}>;


export type ProjectUtilizationQuery = { readonly __typename?: 'Query', readonly projectUtilization:
    | { readonly __typename?: 'ListOfProjectUtilizationResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectUtilization', readonly mandays: number, readonly fullTimeEquivalent: number, readonly client: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisor?: { readonly __typename?: 'Company', readonly id: string } | null }, readonly space?: { readonly __typename?: 'Space', readonly id: string, readonly name: string } | null }, readonly teamMembers: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null }> }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ProjectsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterProjectInput>;
  sort?: InputMaybe<SortingRequestSortProjectInput>;
}>;


export type ProjectsQuery = { readonly __typename?: 'Query', readonly projects:
    | { readonly __typename?: 'FSPResponseProject', readonly totalCount: number, readonly filteredCount: number, readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeProject', readonly cursor: string, readonly node: { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly createdAt: Date, readonly name: string, readonly techStack:
            | { readonly __typename?: 'AccessGranted__ListOfString', readonly value: ReadonlyArray<string> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly competences:
            | { readonly __typename?: 'AccessGranted__ListOfString', readonly value: ReadonlyArray<string> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly description:
            | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly areaOfVlEngagement:
            | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly costLedgerAccountNumber:
            | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly revenueLedgerAccountNumber:
            | { readonly __typename?: 'AccessGranted__OptionalString', readonly value?: string | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly statusHistory: ReadonlyArray<{ readonly __typename?: 'ProjectStatusHistoryEntry', readonly status: ProjectStatus, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }>, readonly lead?: (
            { readonly __typename?: 'ProjectRoleAssignment' }
            & ProjectRoleAssignmentFragment
          ) | null, readonly owner?: (
            { readonly __typename?: 'ProjectRoleAssignment' }
            & ProjectRoleAssignmentFragment
          ) | null, readonly accountManager?: (
            { readonly __typename?: 'ProjectRoleAssignment' }
            & ProjectRoleAssignmentFragment
          ) | null, readonly crossSell:
            | { readonly __typename?: 'AccessGranted__OptionalCrossSell', readonly value?: (
                { readonly __typename?: 'CrossSell' }
                & CrossSellFragment
              ) | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly assignedUsers: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly avatar?: string | null, readonly firstName: string, readonly lastName: string, readonly contracts:
                | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
                    | { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus }
                    | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly status: ContractStatus }
                    | { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus }
                  > }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               } }>, readonly space?: { readonly __typename?: 'Space', readonly id: string, readonly entityVersion: number, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string } } | null, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly entityVersion: number, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null, readonly taxNumber?: string | null }, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null, readonly taxNumber?: string | null } | null } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type RaisesRaiseProposalFragment = { readonly __typename?: 'RaiseProposal', readonly level: ProgressionLevel, readonly currentHourlyRate: number, readonly proposedHourlyRate: number, readonly hourlyRateIncrease: number, readonly lastRateChangeDate: Date, readonly contract:
    | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly contactEmail:
          | { readonly __typename?: 'AccessGranted__OptionalEmailAddress', readonly value?: string | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
    | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly entityVersion: number, readonly name: string, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly contactEmail:
          | { readonly __typename?: 'AccessGranted__OptionalEmailAddress', readonly value?: string | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
    | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly name: string, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly contactEmail:
          | { readonly __typename?: 'AccessGranted__OptionalEmailAddress', readonly value?: string | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
         } }
  , readonly progressionScheme: { readonly __typename?: 'ProgressionScheme', readonly id: string, readonly name: string } };

export type RaisesQueryVariables = Exact<{ [key: string]: never; }>;


export type RaisesQuery = { readonly __typename?: 'Query', readonly raises:
    | { readonly __typename?: 'ListOfRaiseProposalResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'RaiseProposal' }
        & RaisesRaiseProposalFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalariesQueryVariables = Exact<{
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
}>;


export type SalariesQuery = { readonly __typename?: 'Query', readonly contractSalarySummariesInRange:
    | { readonly __typename?: 'ListOfTransfersSummariesResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'TransfersSummaries', readonly yearMonth: Date, readonly b2b: { readonly __typename?: 'B2BTransfersSummaries', readonly byPromisor: ReadonlyArray<{ readonly __typename?: 'B2BPromisorTransfersSummaries', readonly promisorId: string, readonly totalCount: number, readonly paymentDisbursedState: { readonly __typename?: 'B2BTransfersSummary', readonly contractCount: number, readonly totalTransferAmount: (
                { readonly __typename?: 'CentsWithCurrency' }
                & CentsWithCurrencyFragment
              ) }, readonly readyState: { readonly __typename?: 'B2BTransfersSummary', readonly contractCount: number, readonly totalTransferAmount: (
                { readonly __typename?: 'CentsWithCurrency' }
                & CentsWithCurrencyFragment
              ) }, readonly incompleteDataState: { readonly __typename?: 'B2BIncompleteDataStateSummary', readonly transfersSummary: { readonly __typename?: 'B2BTransfersSummary', readonly contractCount: number }, readonly stateDescriptions: ReadonlyArray<
                | (
                  { readonly __typename?: 'AccountingDataMissing' }
                  & IncompleteDataDescriptionAccountingDataMissingFragment
                )
                | (
                  { readonly __typename?: 'BonusRequiresApproval' }
                  & IncompleteDataDescriptionBonusRequiresApprovalFragment
                )
                | (
                  { readonly __typename?: 'InvoiceFileMissing' }
                  & IncompleteDataDescriptionInvoiceFileMissingFragment
                )
                | (
                  { readonly __typename?: 'InvoiceMissing' }
                  & IncompleteDataDescriptionInvoiceMissingFragment
                )
                | (
                  { readonly __typename?: 'InvoiceUnchecked' }
                  & IncompleteDataDescriptionInvoiceUncheckedFragment
                )
                | (
                  { readonly __typename?: 'NoBankAccount' }
                  & IncompleteDataDescriptionNoBankAccountFragment
                )
                | (
                  { readonly __typename?: 'TimeReportIncomplete' }
                  & IncompleteDataDescriptionTimeReportIncompleteFragment
                )
                | (
                  { readonly __typename?: 'TimeReportRequiresApproval' }
                  & IncompleteDataDescriptionTimeReportRequiresApprovalFragment
                )
                | (
                  { readonly __typename?: 'WhiteListInvalid' }
                  & IncompleteDataDescriptionWhiteListInvalidFragment
                )
              > } }> }, readonly employment: { readonly __typename?: 'EmploymentTransfersSummaries', readonly totalCount: number, readonly paymentDisbursedState: { readonly __typename?: 'EmploymentTransfersSummary', readonly contractCount: number, readonly totalSalary: (
              { readonly __typename?: 'CentsWithCurrency' }
              & CentsWithCurrencyFragment
            ) }, readonly readyState: { readonly __typename?: 'EmploymentTransfersSummary', readonly contractCount: number, readonly totalSalary: (
              { readonly __typename?: 'CentsWithCurrency' }
              & CentsWithCurrencyFragment
            ) }, readonly incompleteDataState: { readonly __typename?: 'EmploymentIncompleteDataStateSummary', readonly transfersSummary: { readonly __typename?: 'EmploymentTransfersSummary', readonly contractCount: number }, readonly stateDescriptions: ReadonlyArray<
              | (
                { readonly __typename?: 'AccountingDataMissing' }
                & IncompleteDataDescriptionAccountingDataMissingFragment
              )
              | (
                { readonly __typename?: 'BonusRequiresApproval' }
                & IncompleteDataDescriptionBonusRequiresApprovalFragment
              )
              | (
                { readonly __typename?: 'InvoiceFileMissing' }
                & IncompleteDataDescriptionInvoiceFileMissingFragment
              )
              | (
                { readonly __typename?: 'InvoiceMissing' }
                & IncompleteDataDescriptionInvoiceMissingFragment
              )
              | (
                { readonly __typename?: 'InvoiceUnchecked' }
                & IncompleteDataDescriptionInvoiceUncheckedFragment
              )
              | (
                { readonly __typename?: 'NoBankAccount' }
                & IncompleteDataDescriptionNoBankAccountFragment
              )
              | (
                { readonly __typename?: 'TimeReportIncomplete' }
                & IncompleteDataDescriptionTimeReportIncompleteFragment
              )
              | (
                { readonly __typename?: 'TimeReportRequiresApproval' }
                & IncompleteDataDescriptionTimeReportRequiresApprovalFragment
              )
              | (
                { readonly __typename?: 'WhiteListInvalid' }
                & IncompleteDataDescriptionWhiteListInvalidFragment
              )
            > } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalariesDetailsB2BQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterContractSalaryDetailsInput>;
  sort?: InputMaybe<SortingRequestSortContractSalaryDetailsInput>;
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type SalariesDetailsB2BQuery = { readonly __typename?: 'Query', readonly contractsB2BSalaryDetails:
    | { readonly __typename?: 'FSPResponseB2BContractSalaryDetails', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeB2BContractSalaryDetails', readonly cursor: string, readonly node: { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly absenceDays: number, readonly workTotalTime: number, readonly requiredWorkedTime: number, readonly transferAmount?: number | null, readonly isTimeReportCompleted: boolean, readonly isTimeReportApprovalRequired: boolean, readonly flag?: ContractSalaryDetailsFlagColor | null, readonly note?: string | null, readonly totalPayout?: (
            { readonly __typename?: 'NetGross' }
            & NetGrossFragment
          ) | null, readonly salaryState:
            | (
              { readonly __typename?: 'IncompleteData' }
              & SalaryStateIncompleteDataFragment
            )
            | (
              { readonly __typename?: 'PaymentDisbursed' }
              & SalaryStatePaymentDisbursedFragment
            )
            | (
              { readonly __typename?: 'Ready' }
              & SalaryStateReadyFragment
            )
          , readonly contract: { readonly __typename?: 'B2BContract', readonly id: string, readonly at?: Date | null, readonly name: string, readonly entityVersion: number, readonly type: B2BContractType, readonly currency:
              | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string } }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null } }, readonly promiseeCompany:
              | { readonly __typename?: 'AccessGranted__Company', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
                { readonly __typename?: 'BankAccount' }
                & BankAccountFragment
              ) | null }, readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } } } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SharedSalaryBonusAppreciationBonusFragment = { readonly __typename?: 'AppreciationBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusBusinessTravelBonusFragment = { readonly __typename?: 'BusinessTravelBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusClientReferralBonusFragment = { readonly __typename?: 'ClientReferralBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusConferenceBonusFragment = { readonly __typename?: 'ConferenceBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusCostRechargeBonusFragment = { readonly __typename?: 'CostRechargeBonus', readonly description: string, readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusEmployeeReferralBonusFragment = { readonly __typename?: 'EmployeeReferralBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusLanguageLearningBonusFragment = { readonly __typename?: 'LanguageLearningBonus', readonly language: Language, readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly quarterYear: { readonly __typename?: 'QuarterYear', readonly quarter: Quarter, readonly year: number }, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusOtherBonusFragment = { readonly __typename?: 'OtherBonus', readonly description: string, readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusRemoteWorkEquipmentBonusFragment = { readonly __typename?: 'RemoteWorkEquipmentBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusSalesCommissionsBonusFragment = { readonly __typename?: 'SalesCommissionsBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusSeverancePayBonusFragment = { readonly __typename?: 'SeverancePayBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusShareholderDividendBonusFragment = { readonly __typename?: 'ShareholderDividendBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusTrainingPackageBonusFragment = { readonly __typename?: 'TrainingPackageBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusTrainingPackageExternalDeductionValueFragment = { readonly __typename?: 'TrainingPackageExternalDeductionValue', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type SharedSalaryBonusFragment =
  | SharedSalaryBonusAppreciationBonusFragment
  | SharedSalaryBonusBusinessTravelBonusFragment
  | SharedSalaryBonusClientReferralBonusFragment
  | SharedSalaryBonusConferenceBonusFragment
  | SharedSalaryBonusCostRechargeBonusFragment
  | SharedSalaryBonusEmployeeReferralBonusFragment
  | SharedSalaryBonusLanguageLearningBonusFragment
  | SharedSalaryBonusOtherBonusFragment
  | SharedSalaryBonusRemoteWorkEquipmentBonusFragment
  | SharedSalaryBonusSalesCommissionsBonusFragment
  | SharedSalaryBonusSeverancePayBonusFragment
  | SharedSalaryBonusShareholderDividendBonusFragment
  | SharedSalaryBonusTrainingPackageBonusFragment
  | SharedSalaryBonusTrainingPackageExternalDeductionValueFragment
;

export type SharedSalaryEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly at?: Date | null, readonly name: string, readonly entityVersion: number, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly conclusionDate:
    | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly bonuses:
    | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
          | (
            { readonly __typename?: 'AppreciationBonus' }
            & SharedSalaryBonusAppreciationBonusFragment
          )
          | (
            { readonly __typename?: 'BusinessTravelBonus' }
            & SharedSalaryBonusBusinessTravelBonusFragment
          )
          | (
            { readonly __typename?: 'ClientReferralBonus' }
            & SharedSalaryBonusClientReferralBonusFragment
          )
          | (
            { readonly __typename?: 'ConferenceBonus' }
            & SharedSalaryBonusConferenceBonusFragment
          )
          | (
            { readonly __typename?: 'CostRechargeBonus' }
            & SharedSalaryBonusCostRechargeBonusFragment
          )
          | (
            { readonly __typename?: 'EmployeeReferralBonus' }
            & SharedSalaryBonusEmployeeReferralBonusFragment
          )
          | (
            { readonly __typename?: 'LanguageLearningBonus' }
            & SharedSalaryBonusLanguageLearningBonusFragment
          )
          | (
            { readonly __typename?: 'OtherBonus' }
            & SharedSalaryBonusOtherBonusFragment
          )
          | (
            { readonly __typename?: 'RemoteWorkEquipmentBonus' }
            & SharedSalaryBonusRemoteWorkEquipmentBonusFragment
          )
          | (
            { readonly __typename?: 'SalesCommissionsBonus' }
            & SharedSalaryBonusSalesCommissionsBonusFragment
          )
          | (
            { readonly __typename?: 'SeverancePayBonus' }
            & SharedSalaryBonusSeverancePayBonusFragment
          )
          | (
            { readonly __typename?: 'ShareholderDividendBonus' }
            & SharedSalaryBonusShareholderDividendBonusFragment
          )
          | (
            { readonly __typename?: 'TrainingPackageBonus' }
            & SharedSalaryBonusTrainingPackageBonusFragment
          )
          | (
            { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
            & SharedSalaryBonusTrainingPackageExternalDeductionValueFragment
          )
        >, readonly future: ReadonlyArray<
          | (
            { readonly __typename?: 'AppreciationBonus' }
            & SharedSalaryBonusAppreciationBonusFragment
          )
          | (
            { readonly __typename?: 'BusinessTravelBonus' }
            & SharedSalaryBonusBusinessTravelBonusFragment
          )
          | (
            { readonly __typename?: 'ClientReferralBonus' }
            & SharedSalaryBonusClientReferralBonusFragment
          )
          | (
            { readonly __typename?: 'ConferenceBonus' }
            & SharedSalaryBonusConferenceBonusFragment
          )
          | (
            { readonly __typename?: 'CostRechargeBonus' }
            & SharedSalaryBonusCostRechargeBonusFragment
          )
          | (
            { readonly __typename?: 'EmployeeReferralBonus' }
            & SharedSalaryBonusEmployeeReferralBonusFragment
          )
          | (
            { readonly __typename?: 'LanguageLearningBonus' }
            & SharedSalaryBonusLanguageLearningBonusFragment
          )
          | (
            { readonly __typename?: 'OtherBonus' }
            & SharedSalaryBonusOtherBonusFragment
          )
          | (
            { readonly __typename?: 'RemoteWorkEquipmentBonus' }
            & SharedSalaryBonusRemoteWorkEquipmentBonusFragment
          )
          | (
            { readonly __typename?: 'SalesCommissionsBonus' }
            & SharedSalaryBonusSalesCommissionsBonusFragment
          )
          | (
            { readonly __typename?: 'SeverancePayBonus' }
            & SharedSalaryBonusSeverancePayBonusFragment
          )
          | (
            { readonly __typename?: 'ShareholderDividendBonus' }
            & SharedSalaryBonusShareholderDividendBonusFragment
          )
          | (
            { readonly __typename?: 'TrainingPackageBonus' }
            & SharedSalaryBonusTrainingPackageBonusFragment
          )
          | (
            { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
            & SharedSalaryBonusTrainingPackageExternalDeductionValueFragment
          )
        > } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly copyrightCosts:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint', readonly value: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: { readonly __typename?: 'TimeBasedRate', readonly value: { readonly __typename?: 'Rate', readonly settlement: Settlement } } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly ppk:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint', readonly value: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly workingTime:
    | { readonly __typename?: 'AccessGranted__TimeBasedWorkingTime', readonly value: { readonly __typename?: 'TimeBasedWorkingTime', readonly value: (
          { readonly __typename?: 'WorkingTime' }
          & WorkingTimeFragment
        ) } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promiseeTransferBankAccount:
    | { readonly __typename?: 'AccessGranted__BankAccount', readonly value: (
        { readonly __typename?: 'BankAccount' }
        & BankAccountFragment
      ) }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly promisor: { readonly __typename?: 'TimeBasedCompany', readonly value: { readonly __typename?: 'Company', readonly id: string, readonly name: string } }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly isStudent:
      | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
      | (
        { readonly __typename?: 'Unauthorized' }
        & UnauthorizedFragment
      )
    , readonly directReporting: { readonly __typename?: 'DirectReporting', readonly assignedProjects:
        | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string } }> }
        | (
          { readonly __typename?: 'Unauthorized' }
          & UnauthorizedFragment
        )
       } }, readonly promisorTransferBankAccount: { readonly __typename?: 'PromisorTransferBankAccount', readonly value?: (
      { readonly __typename?: 'BankAccount' }
      & BankAccountFragment
    ) | null } };

export type SalariesDetailsEmploymentQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterContractSalaryDetailsInput>;
  sort?: InputMaybe<SortingRequestSortContractSalaryDetailsInput>;
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type SalariesDetailsEmploymentQuery = { readonly __typename?: 'Query', readonly contractsEmploymentSalaryDetails:
    | { readonly __typename?: 'FSPResponseEmploymentContractSalaryDetails', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeEmploymentContractSalaryDetails', readonly cursor: string, readonly node: { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly absenceDays: number, readonly workTotalTime: number, readonly requiredWorkedTime: number, readonly transferAmount?: number | null, readonly isTimeReportCompleted: boolean, readonly isTimeReportApprovalRequired: boolean, readonly flag?: ContractSalaryDetailsFlagColor | null, readonly note?: string | null, readonly totalPayout?: (
            { readonly __typename?: 'NetGross' }
            & NetGrossFragment
          ) | null, readonly contract: (
            { readonly __typename?: 'EmploymentContract' }
            & SharedSalaryEmploymentContractFragment
          ), readonly salaryState:
            | (
              { readonly __typename?: 'IncompleteData' }
              & SalaryStateIncompleteDataFragment
            )
            | (
              { readonly __typename?: 'PaymentDisbursed' }
              & SalaryStatePaymentDisbursedFragment
            )
            | (
              { readonly __typename?: 'Ready' }
              & SalaryStateReadyFragment
            )
           } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalesInvoiceDetailsQueryVariables = Exact<{
  invoiceId: Scalars['SalesInvoiceId']['input'];
}>;


export type SalesInvoiceDetailsQuery = { readonly __typename?: 'Query', readonly salesInvoiceDetails:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'SalesInvoiceDetails', readonly correctedBy?: (
        { readonly __typename?: 'SalesInvoice' }
        & SalesInvoicesInvoiceFragment
      ) | null, readonly invoice: (
        { readonly __typename?: 'SalesInvoice' }
        & SalesInvoicesInvoiceFragment
      ), readonly connectedPayments: ReadonlyArray<{ readonly __typename?: 'InvoiceConnectedPayment', readonly description: string, readonly paidDate: Date, readonly value: number, readonly currency: string, readonly name: string, readonly externalPayment?: { readonly __typename?: 'BankIncomeTransfer', readonly fromName: string, readonly toName: string, readonly toAccount?: (
            { readonly __typename?: 'BankAccount' }
            & BankAccountFragment
          ) | null, readonly fromAccountNumber:
            | (
              { readonly __typename?: 'Iban' }
              & BankAccountNumberIbanFragment
            )
            | (
              { readonly __typename?: 'OtherBankAccountNumber' }
              & BankAccountNumberOtherBankAccountNumberFragment
            )
          , readonly toAccountNumber:
            | (
              { readonly __typename?: 'Iban' }
              & BankAccountNumberIbanFragment
            )
            | (
              { readonly __typename?: 'OtherBankAccountNumber' }
              & BankAccountNumberOtherBankAccountNumberFragment
            )
           } | null }>, readonly connectedTransfers: ReadonlyArray<{ readonly __typename?: 'PaymentConnection', readonly tpe: PaymentConnectionType, readonly transfer: { readonly __typename?: 'BankIncomeTransfer', readonly id: string }, readonly invoice: { readonly __typename?: 'SalesInvoice', readonly id: number } }>, readonly correctsInvoice?: { readonly __typename?: 'SalesInvoice', readonly id: number, readonly number: string } | null }
   };

export type SalesInvoicesInvoiceEntityFragment = { readonly __typename?: 'InvoiceEntity', readonly name: string, readonly taxNumber?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly address: (
    { readonly __typename?: 'Address' }
    & AddressFragment
  ) };

export type SalesInvoicesInvoiceFragment = { readonly __typename?: 'SalesInvoice', readonly id: number, readonly kind: InvoiceKind, readonly number: string, readonly issueDate: Date, readonly sellDate: Date, readonly paymentTo: Date, readonly overdue: boolean, readonly place: string, readonly status: SalesInvoiceStatus, readonly profilePrefix: string, readonly currency: string, readonly exchangeRate?: number | null, readonly fakturowniaUri: string, readonly paid: number, readonly paidDate?: Date | null, readonly viewUri: string, readonly buyerType: BuyerType, readonly price: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly priceWithExchangeRateApplied?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly expectedPayment?: { readonly __typename?: 'ExpectedPayment', readonly date: Date } | null, readonly seller: (
    { readonly __typename?: 'InvoiceEntity' }
    & SalesInvoicesInvoiceEntityFragment
  ), readonly sellerCompany?: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly buyer: (
    { readonly __typename?: 'InvoiceEntity' }
    & SalesInvoicesInvoiceEntityFragment
  ), readonly buyerCompany?: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null } | null, readonly positions: ReadonlyArray<{ readonly __typename?: 'InvoicePosition', readonly name: string, readonly quantity: number, readonly quantityUnit: string, readonly description?: string | null, readonly price: { readonly __typename?: 'NetGross', readonly net: number, readonly gross: number }, readonly totalPrice: { readonly __typename?: 'NetGross', readonly net: number, readonly gross: number }, readonly vat?: { readonly __typename?: 'VatApplied', readonly value: number } | null }> };

export type SalesInvoicesQueryVariables = Exact<{
  dateRange: ClosedEndLocalDateRangeInput;
  searchDateType: SearchDateType;
  allSearch?: InputMaybe<Scalars['String']['input']>;
  buyerType_oneOf?: InputMaybe<ReadonlyArray<BuyerType> | BuyerType>;
  buyerCompany_oneOf?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']> | Scalars['CompanyId']['input']>;
  buyerName_oneOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  clientIsWithinGroup_eq?: InputMaybe<Scalars['Boolean']['input']>;
  sellerCompany_oneOf?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']> | Scalars['CompanyId']['input']>;
  status_oneOf?: InputMaybe<ReadonlyArray<SalesInvoiceStatus> | SalesInvoiceStatus>;
  kind_oneOf?: InputMaybe<ReadonlyArray<InvoiceKind> | InvoiceKind>;
  currency_oneOf?: InputMaybe<ReadonlyArray<Scalars['Currency']['input']> | Scalars['Currency']['input']>;
  overdue_eq?: InputMaybe<Scalars['Boolean']['input']>;
  expectedPaymentDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  issueDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  paymentTo_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  sellDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  paidDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
}>;


export type SalesInvoicesQuery = { readonly __typename?: 'Query', readonly salesInvoices:
    | { readonly __typename?: 'ListOfSalesInvoiceResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'SalesInvoice' }
        & SalesInvoicesInvoiceFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalesInvoicesFakturowniaProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesInvoicesFakturowniaProfilesQuery = { readonly __typename?: 'Query', readonly fakturowniaProfiles:
    | { readonly __typename?: 'ListOfFakturowniaProfileResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'FakturowniaProfile', readonly id: string, readonly url: string }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SalesInvoicesExportMutationVariables = Exact<{
  dateRange: ClosedEndLocalDateRangeInput;
  searchDateType: SearchDateType;
  allSearch?: InputMaybe<Scalars['String']['input']>;
  buyerType_oneOf?: InputMaybe<ReadonlyArray<BuyerType> | BuyerType>;
  buyerCompany_oneOf?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']> | Scalars['CompanyId']['input']>;
  buyerName_oneOf?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  clientIsWithinGroup_eq?: InputMaybe<Scalars['Boolean']['input']>;
  sellerCompany_oneOf?: InputMaybe<ReadonlyArray<Scalars['CompanyId']['input']> | Scalars['CompanyId']['input']>;
  status_oneOf?: InputMaybe<ReadonlyArray<SalesInvoiceStatus> | SalesInvoiceStatus>;
  status_notIn?: InputMaybe<ReadonlyArray<SalesInvoiceStatus> | SalesInvoiceStatus>;
  kind_oneOf?: InputMaybe<ReadonlyArray<InvoiceKind> | InvoiceKind>;
  currency_oneOf?: InputMaybe<ReadonlyArray<Scalars['Currency']['input']> | Scalars['Currency']['input']>;
  overdue_eq?: InputMaybe<Scalars['Boolean']['input']>;
  expectedPaymentDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  issueDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  paymentTo_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  sellDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
  paidDate_inRange?: InputMaybe<ClosedEndLocalDateRangeInput>;
}>;


export type SalesInvoicesExportMutation = { readonly __typename?: 'Mutation', readonly exportSalesInvoices:
    | { readonly __typename?: 'GoogleSpreadsheetUrl', readonly url: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type GmailConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GmailConnectionQuery = { readonly __typename?: 'Query', readonly gmailConnection?:
    | { readonly __typename?: 'GmailConnection', readonly adminId: string, readonly connectedEmail: string, readonly createdAt: Date, readonly aliases: ReadonlyArray<string>, readonly selectedAlias?: string | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   | null };

export type GmailAuthUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GmailAuthUrlQuery = { readonly __typename?: 'Query', readonly gmailAuthUrl:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'URIResponse', readonly value: string }
   };

export type ConnectGmailAccountMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ConnectGmailAccountMutation = { readonly __typename?: 'Mutation', readonly connectGmailAccount:
    | { readonly __typename?: 'GmailConnection', readonly adminId: string, readonly connectedEmail: string, readonly createdAt: Date, readonly aliases: ReadonlyArray<string>, readonly selectedAlias?: string | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DisconnectGmailAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectGmailAccountMutation = { readonly __typename?: 'Mutation', readonly disconnectGmailAccount:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
   };

export type SelectGmailAliasMutationVariables = Exact<{
  alias: Scalars['EmailAddress']['input'];
}>;


export type SelectGmailAliasMutation = { readonly __typename?: 'Mutation', readonly selectGmailAlias:
    | { readonly __typename?: 'GmailConnection', readonly adminId: string, readonly connectedEmail: string, readonly createdAt: Date, readonly aliases: ReadonlyArray<string>, readonly selectedAlias?: string | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type RefreshGmailAliasesMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshGmailAliasesMutation = { readonly __typename?: 'Mutation', readonly refreshGmailAliases:
    | { readonly __typename?: 'GmailConnection', readonly adminId: string, readonly connectedEmail: string, readonly createdAt: Date, readonly aliases: ReadonlyArray<string>, readonly selectedAlias?: string | null }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SpaceDetailsQueryVariables = Exact<{
  spaceId: Scalars['SpaceId']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterUserInput>;
  sort?: InputMaybe<SortingRequestSortUserInput>;
}>;


export type SpaceDetailsQuery = { readonly __typename?: 'Query', readonly space:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'Space', readonly id: string, readonly entityVersion: number, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null }, readonly directors: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null }>, readonly members: { readonly __typename?: 'FSPResponseUser', readonly filteredCount: number, readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly skillsAndCompetences: ReadonlyArray<string>, readonly areaOfExpertise?: string | null, readonly certificates:
              | { readonly __typename?: 'AccessGranted__ListOfCertificate', readonly value: ReadonlyArray<{ readonly __typename?: 'Certificate', readonly id: string, readonly name: string }> }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null }, readonly role: { readonly __typename?: 'TimeBasedCompanyRole', readonly value: CompanyRole }, readonly contracts:
              | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
                  | { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus, readonly position: { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null } }
                  | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly status: ContractStatus, readonly position: { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null } }
                  | { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus }
                > }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly newestRateChangeDate:
              | { readonly __typename?: 'AccessGranted__OptionalOffsetDateTime', readonly value?: Date | null }
              | (
                { readonly __typename?: 'Unauthorized' }
                & UnauthorizedFragment
              )
            , readonly directReporting: { readonly __typename?: 'DirectReporting', readonly practiceLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null } | null }, readonly operationalLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null } | null }, readonly assignedProjects:
                | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly name: string, readonly clientContract: { readonly __typename?: 'ClientContract', readonly id: string, readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string } | null } } }> }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
              , readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: { readonly __typename?: 'Space', readonly id: string, readonly name: string } } } } }> } }
   };

export type SpacesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterSpaceInput>;
  members: Scalars['Int']['input'];
}>;


export type SpacesQuery = { readonly __typename?: 'Query', readonly spaces:
    | { readonly __typename?: 'FSPResponseSpace', readonly totalCount: number, readonly filteredCount: number, readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeSpace', readonly cursor: string, readonly node: { readonly __typename?: 'Space', readonly id: string, readonly entityVersion: number, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly avatar?: string | null, readonly firstName: string, readonly lastName: string }, readonly directors: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string }>, readonly members: { readonly __typename?: 'FSPResponseUser', readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly node: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly avatar?: string | null, readonly firstName: string, readonly lastName: string, readonly contracts:
                  | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
                      | { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus }
                      | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly status: ContractStatus }
                      | { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus }
                    > }
                  | (
                    { readonly __typename?: 'Unauthorized' }
                    & UnauthorizedFragment
                  )
                 } }> } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type PeopleCalendarQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterUserInput>;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
}>;


export type PeopleCalendarQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly totalCount: number, readonly filteredCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string, readonly contracts:
            | { readonly __typename?: 'AccessGranted__ListOfContract', readonly value: ReadonlyArray<
                | { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus, readonly b2bContractType: B2BContractType, readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly id: HolidayCalendarId, readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date }> } }
                | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly status: ContractStatus, readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly id: HolidayCalendarId, readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date }> } }
                | { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus, readonly b2bContractType: B2BContractType, readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly id: HolidayCalendarId, readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date }> } }
              > }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly timeReports:
            | { readonly __typename?: 'AccessGranted__TimeReports', readonly value: { readonly __typename?: 'TimeReports', readonly records: { readonly __typename?: 'TimeReportRecords', readonly absence: ReadonlyArray<(
                    { readonly __typename?: 'AbsenceRecord', readonly contractId: string }
                    & AbsenceRecordFragment
                  )>, readonly work: ReadonlyArray<{ readonly __typename?: 'WorkRecord', readonly id: string, readonly contractId: string, readonly date: Date, readonly duration?: number | null, readonly overtime: boolean, readonly remoteWork: boolean, readonly comment?: string | null, readonly workTag: { readonly __typename?: 'WorkTag', readonly id: string, readonly name: string }, readonly project?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null }>, readonly onCall: ReadonlyArray<{ readonly __typename?: 'OnCallRecord', readonly id: string, readonly contractId: string, readonly date: Date, readonly dayShift: boolean, readonly nightShift: boolean, readonly comment?: string | null, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string } }>, readonly workTags: ReadonlyArray<{ readonly __typename?: 'WorkTag', readonly id: string, readonly name: string }> } } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ApprovalsApproveLeaveMutationVariables = Exact<{
  entryId: Scalars['AbsenceRecordId']['input'];
}>;


export type ApprovalsApproveLeaveMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly absenceRecord: { readonly __typename?: 'AbsenceRecordApi', readonly approve:
        | { readonly __typename?: 'AbsenceRecord' }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type ApprovalsRejectLeaveMutationVariables = Exact<{
  entryId: Scalars['AbsenceRecordId']['input'];
}>;


export type ApprovalsRejectLeaveMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly absenceRecord: { readonly __typename?: 'AbsenceRecordApi', readonly reject:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'UnitResponse' }
       } } };

export type ApprovalsApproveOvertimeMutationVariables = Exact<{
  entryId: Scalars['WorkRecordId']['input'];
}>;


export type ApprovalsApproveOvertimeMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly workRecord: { readonly __typename?: 'WorkRecordApi', readonly approve:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'WorkRecord' }
       } } };

export type ApprovalsRejectOvertimeMutationVariables = Exact<{
  entryId: Scalars['WorkRecordId']['input'];
}>;


export type ApprovalsRejectOvertimeMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly workRecord: { readonly __typename?: 'WorkRecordApi', readonly reject:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'UnitResponse' }
       } } };

export type ApprovalsUserFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly practiceLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: { readonly __typename?: 'User', readonly id: string } | null }, readonly operationalLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: { readonly __typename?: 'User', readonly id: string } | null }, readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: { readonly __typename?: 'Space', readonly id: string } } } };

export type ApprovalsQueryVariables = Exact<{ [key: string]: never; }>;


export type ApprovalsQuery = { readonly __typename?: 'Query', readonly timeReportsRequiringApproval:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReportsRequiringApproval', readonly workRecords: ReadonlyArray<{ readonly __typename?: 'WorkRecord', readonly id: string, readonly date: Date, readonly overtime: boolean, readonly duration?: number | null, readonly comment?: string | null, readonly contract:
          | { readonly __typename?: 'B2BContract', readonly id: string }
          | { readonly __typename?: 'EmploymentContract', readonly id: string }
          | { readonly __typename?: 'Subcontract', readonly id: string }
        , readonly user: (
          { readonly __typename?: 'User' }
          & ApprovalsUserFragment
        ), readonly approval:
          | (
            { readonly __typename?: 'Approved' }
            & ApprovalApprovedFragment
          )
          | (
            { readonly __typename?: 'NotRequired' }
            & ApprovalNotRequiredFragment
          )
          | (
            { readonly __typename?: 'PendingApproval' }
            & ApprovalPendingApprovalFragment
          )
         }>, readonly absenceRecords: ReadonlyArray<{ readonly __typename?: 'AbsenceRecord', readonly id: string, readonly absenceType: AbsenceType, readonly from: Date, readonly to: Date, readonly isOnDemand?: boolean | null, readonly comment?: string | null, readonly attachment:
          | { readonly __typename?: 'AccessGranted__OptionalDownloadableExternallyHostedFileUrl', readonly value?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly fileName: string, readonly downloadUrl: string, readonly openUrl: string } | null }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly contract:
          | { readonly __typename?: 'B2BContract', readonly id: string }
          | { readonly __typename?: 'EmploymentContract', readonly id: string }
          | { readonly __typename?: 'Subcontract', readonly id: string }
        , readonly user: (
          { readonly __typename?: 'User' }
          & ApprovalsUserFragment
        ), readonly approval:
          | (
            { readonly __typename?: 'Approved' }
            & ApprovalApprovedFragment
          )
          | (
            { readonly __typename?: 'NotRequired' }
            & ApprovalNotRequiredFragment
          )
          | (
            { readonly __typename?: 'PendingApproval' }
            & ApprovalPendingApprovalFragment
          )
         }> }
   };

export type ClientContractAutocompleteQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FilterClientContractInput>;
}>;


export type ClientContractAutocompleteQuery = { readonly __typename?: 'Query', readonly clientContracts:
    | { readonly __typename?: 'FSPResponseClientContract', readonly totalCount: number, readonly filteredCount: number, readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeClientContract', readonly cursor: string, readonly node: { readonly __typename?: 'ClientContract', readonly id: string, readonly name:
            | { readonly __typename?: 'AccessGranted__String', readonly value: string }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly contractDurationFrom:
            | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly contractDurationTo:
            | { readonly __typename?: 'AccessGranted__OptionalLocalDate', readonly value?: Date | null }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly promisor?: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null, readonly companyType: ReadonlyArray<CompanyType> } | null, readonly promisee: { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null, readonly companyType: ReadonlyArray<CompanyType> }, readonly projects: ReadonlyArray<{ readonly __typename?: 'Project', readonly id: string, readonly assignedUsers: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string } }> }>, readonly positions:
            | { readonly __typename?: 'AccessGranted__ListOfClientPosition', readonly value: ReadonlyArray<{ readonly __typename?: 'ClientPosition', readonly id: string }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CompanyAutocompleteCompanyFragment = { readonly __typename?: 'Company', readonly id: string, readonly entityVersion: number, readonly name: string, readonly logo?: string | null, readonly taxNumber?: string | null, readonly euVatType: { readonly __typename?: 'TimeBasedValueWithVerificationEuVatType', readonly value: { readonly __typename?: 'ValueWithVerificationEuVatType', readonly value: EuVatType } } };

export type CompanyAutocompleteQueryVariables = Exact<{
  filter: FilterCompanyInput;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  sort?: InputMaybe<SortingRequestSortCompanyInput>;
  first: Scalars['Int']['input'];
}>;


export type CompanyAutocompleteQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly cursor: string, readonly node: (
          { readonly __typename?: 'Company' }
          & CompanyAutocompleteCompanyFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CostInvoiceGroupCompaniesCompanyFragment = { readonly __typename?: 'Company', readonly id: string, readonly name: string, readonly logo?: string | null };

export type CostInvoiceGroupCompaniesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CostInvoiceGroupCompaniesQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly node: (
          { readonly __typename?: 'Company' }
          & CostInvoiceGroupCompaniesCompanyFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type GroupCompanyBankAccountsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GroupCompanyBankAccountsQuery = { readonly __typename?: 'Query', readonly companies:
    | { readonly __typename?: 'FSPResponseCompany', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeCompany', readonly cursor: string, readonly node: { readonly __typename?: 'Company', readonly entityVersion: number, readonly id: string, readonly name: string, readonly bankAccounts: ReadonlyArray<{ readonly __typename?: 'BankAccount', readonly currency?: string | null, readonly description?: string | null, readonly accountNumber:
              | (
                { readonly __typename?: 'Iban' }
                & BankAccountNumberIbanFragment
              )
              | (
                { readonly __typename?: 'OtherBankAccountNumber' }
                & BankAccountNumberOtherBankAccountNumberFragment
              )
             }> } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type ProjectAutocompleteQueryVariables = Exact<{
  allSearch?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first: Scalars['Int']['input'];
}>;


export type ProjectAutocompleteQuery = { readonly __typename?: 'Query', readonly projects:
    | { readonly __typename?: 'FSPResponseProject', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeProject', readonly cursor: string, readonly node: { readonly __typename?: 'Project', readonly id: string, readonly name: string } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type RevenueAdministrationOfficeAutocompleteQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  allSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type RevenueAdministrationOfficeAutocompleteQuery = { readonly __typename?: 'Query', readonly revenueAdministrationOffices:
    | { readonly __typename?: 'FSPResponseRevenueAdministrationOffice', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeRevenueAdministrationOffice', readonly cursor: string, readonly node: { readonly __typename?: 'RevenueAdministrationOffice', readonly id: number, readonly officeName: string } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type SpacesAutocompleteQueryVariables = Exact<{
  allSearch?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first: Scalars['Int']['input'];
}>;


export type SpacesAutocompleteQuery = { readonly __typename?: 'Query', readonly spaces:
    | { readonly __typename?: 'FSPResponseSpace', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeSpace', readonly cursor: string, readonly node: { readonly __typename?: 'Space', readonly id: string, readonly entityVersion: number, readonly name: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type TransferAutocompleteTransferBankIncomeTransferFragment = { readonly __typename?: 'BankIncomeTransfer', readonly id: string, readonly bookDate: Date, readonly operationDate: Date, readonly title: string, readonly amount: number, readonly currency: string, readonly toName: string, readonly fromName: string };

export type TransferAutocompleteTransferBankOutcomeTransferFragment = { readonly __typename?: 'BankOutcomeTransfer', readonly id: string, readonly bookDate: Date, readonly operationDate: Date, readonly title: string, readonly amount: number, readonly currency: string, readonly toName: string, readonly fromName: string };

export type TransferAutocompleteTransferFragment =
  | TransferAutocompleteTransferBankIncomeTransferFragment
  | TransferAutocompleteTransferBankOutcomeTransferFragment
;

export type TransferAutocompleteQueryVariables = Exact<{
  filter: FilterBankTransferInput;
  sort?: InputMaybe<SortingRequestSortBankTransferInput>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type TransferAutocompleteQuery = { readonly __typename?: 'Query', readonly bankTransfers:
    | { readonly __typename?: 'FSPResponseBankTransfer', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeBankTransfer', readonly cursor: string, readonly node:
          | (
            { readonly __typename?: 'BankIncomeTransfer' }
            & TransferAutocompleteTransferBankIncomeTransferFragment
          )
          | (
            { readonly __typename?: 'BankOutcomeTransfer' }
            & TransferAutocompleteTransferBankOutcomeTransferFragment
          )
         }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type UserAutocompleteUserFragment = { readonly __typename?: 'User', readonly id: string, readonly entityVersion: number, readonly firstName: string, readonly lastName: string };

export type UserAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter: FilterUserInput;
  sort?: InputMaybe<SortingRequestSortUserInput>;
  first: Scalars['Int']['input'];
}>;


export type UserAutocompleteQuery = { readonly __typename?: 'Query', readonly users:
    | { readonly __typename?: 'FSPResponseUser', readonly hasNextPage: boolean, readonly edges: ReadonlyArray<{ readonly __typename?: 'EdgeUser', readonly cursor: string, readonly node: (
          { readonly __typename?: 'User' }
          & UserAutocompleteUserFragment
        ) }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DrawerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DrawerQuery = { readonly __typename?: 'Query', readonly drawer?:
    | (
      { readonly __typename?: 'AddClientContractDrawer' }
      & ChildLevel0AddClientContractDrawerFragment
    )
    | (
      { readonly __typename?: 'AddCompanyDrawer' }
      & ChildLevel0AddCompanyDrawerFragment
    )
    | (
      { readonly __typename?: 'AddInternalProjectDrawer' }
      & ChildLevel0AddInternalProjectDrawerFragment
    )
    | (
      { readonly __typename?: 'AddOfficeDrawer' }
      & ChildLevel0AddOfficeDrawerFragment
    )
    | (
      { readonly __typename?: 'AddPersonDrawer' }
      & ChildLevel0AddPersonDrawerFragment
    )
    | (
      { readonly __typename?: 'AddProgressionSchemeDrawer' }
      & ChildLevel0AddProgressionSchemeDrawerFragment
    )
    | (
      { readonly __typename?: 'AddProjectDrawer' }
      & ChildLevel0AddProjectDrawerFragment
    )
    | (
      { readonly __typename?: 'AddSpaceDrawer' }
      & ChildLevel0AddSpaceDrawerFragment
    )
    | (
      { readonly __typename?: 'AddThirdPersonDrawer' }
      & ChildLevel0AddThirdPersonDrawerFragment
    )
    | (
      { readonly __typename?: 'AdditionalCostsDrawer' }
      & ChildLevel0AdditionalCostsDrawerFragment
    )
    | (
      { readonly __typename?: 'AllBonusesDrawer' }
      & ChildLevel0AllBonusesDrawerFragment
    )
    | (
      { readonly __typename?: 'AnnualLeaveEntitlementDrawer' }
      & ChildLevel0AnnualLeaveEntitlementDrawerFragment
    )
    | (
      { readonly __typename?: 'AnnualLeavePreferencesDrawer' }
      & ChildLevel0AnnualLeavePreferencesDrawerFragment
    )
    | (
      { readonly __typename?: 'AnnualLeaveSummaryDrawer' }
      & ChildLevel0AnnualLeaveSummaryDrawerFragment
    )
    | (
      { readonly __typename?: 'AssignBenefitDrawer' }
      & ChildLevel0AssignBenefitDrawerFragment
    )
    | (
      { readonly __typename?: 'B2BContractDraftDrawer' }
      & ChildLevel0B2BContractDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'B2BContractNoteDrawer' }
      & ChildLevel0B2BContractNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'B2BSalaryDetailsDrawer' }
      & ChildLevel0B2BSalaryDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'BasicFinancialReportDrawer' }
      & ChildLevel0BasicFinancialReportDrawerFragment
    )
    | (
      { readonly __typename?: 'BenefitInvoicesReportDrawer' }
      & ChildLevel0BenefitInvoicesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'BenefitNoteDrawer' }
      & ChildLevel0BenefitNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'BonusDrawer' }
      & ChildLevel0BonusDrawerFragment
    )
    | (
      { readonly __typename?: 'BonusPreviewDrawer' }
      & ChildLevel0BonusPreviewDrawerFragment
    )
    | (
      { readonly __typename?: 'BookDeskOnBehalfDrawer' }
      & ChildLevel0BookDeskOnBehalfDrawerFragment
    )
    | (
      { readonly __typename?: 'BookParkingOnBehalfDrawer' }
      & ChildLevel0BookParkingOnBehalfDrawerFragment
    )
    | (
      { readonly __typename?: 'ClientInvoicingReportDrawer' }
      & ChildLevel0ClientInvoicingReportDrawerFragment
    )
    | (
      { readonly __typename?: 'CompanyBankAccountDrawer' }
      & ChildLevel0CompanyBankAccountDrawerFragment
    )
    | (
      { readonly __typename?: 'CompanyDetailsDrawer' }
      & ChildLevel0CompanyDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'ContractBankAccountDrawer' }
      & ChildLevel0ContractBankAccountDrawerFragment
    )
    | (
      { readonly __typename?: 'ContractBonusesSettingsDrawer' }
      & ChildLevel0ContractBonusesSettingsDrawerFragment
    )
    | (
      { readonly __typename?: 'ContractDetailsDrawer' }
      & ChildLevel0ContractDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'CopyrightsDrawer' }
      & ChildLevel0CopyrightsDrawerFragment
    )
    | (
      { readonly __typename?: 'CostAndRevenueItemDrawer' }
      & ChildLevel0CostAndRevenueItemDrawerFragment
    )
    | (
      { readonly __typename?: 'CostSummariesDrawer' }
      & ChildLevel0CostSummariesDrawerFragment
    )
    | (
      { readonly __typename?: 'CreateBenefitDrawer' }
      & ChildLevel0CreateBenefitDrawerFragment
    )
    | (
      { readonly __typename?: 'CreateVariantDrawer' }
      & ChildLevel0CreateVariantDrawerFragment
    )
    | (
      { readonly __typename?: 'DeskAssignmentDrawer' }
      & ChildLevel0DeskAssignmentDrawerFragment
    )
    | (
      { readonly __typename?: 'DeskDrawer' }
      & ChildLevel0DeskDrawerFragment
    )
    | (
      { readonly __typename?: 'DirectReportingDrawer' }
      & ChildLevel0DirectReportingDrawerFragment
    )
    | (
      { readonly __typename?: 'EditBenefitDrawer' }
      & ChildLevel0EditBenefitDrawerFragment
    )
    | (
      { readonly __typename?: 'EditBenefitVariantDrawer' }
      & ChildLevel0EditBenefitVariantDrawerFragment
    )
    | (
      { readonly __typename?: 'EditBenefitVariantPriceDrawer' }
      & ChildLevel0EditBenefitVariantPriceDrawerFragment
    )
    | (
      { readonly __typename?: 'EditClientContractDrawer' }
      & ChildLevel0EditClientContractDrawerFragment
    )
    | (
      { readonly __typename?: 'EditDeskRequestDrawer' }
      & ChildLevel0EditDeskRequestDrawerFragment
    )
    | (
      { readonly __typename?: 'EditOfficeDrawer' }
      & ChildLevel0EditOfficeDrawerFragment
    )
    | (
      { readonly __typename?: 'EditOfficeSettingsDrawer' }
      & ChildLevel0EditOfficeSettingsDrawerFragment
    )
    | (
      { readonly __typename?: 'EditParkingRequestDrawer' }
      & ChildLevel0EditParkingRequestDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileAdditionalDataDrawer' }
      & ChildLevel0EditProfileAdditionalDataDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileAddressDrawer' }
      & ChildLevel0EditProfileAddressDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileBasicInfoDrawer' }
      & ChildLevel0EditProfileBasicInfoDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProjectCrossSellDrawer' }
      & ChildLevel0EditProjectCrossSellDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProjectDrawer' }
      & ChildLevel0EditProjectDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProjectTechStackAndCompetencesDrawer' }
      & ChildLevel0EditProjectTechStackAndCompetencesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSkillsAndCertificatesDrawer' }
      & ChildLevel0EditSkillsAndCertificatesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSocialMediaHandlesDrawer' }
      & ChildLevel0EditSocialMediaHandlesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSpaceDrawer' }
      & ChildLevel0EditSpaceDrawerFragment
    )
    | (
      { readonly __typename?: 'EmployeeDueDatesDrawer' }
      & ChildLevel0EmployeeDueDatesDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentBankAccountDrawer' }
      & ChildLevel0EmploymentBankAccountDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentContractDraftDrawer' }
      & ChildLevel0EmploymentContractDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentContractNoteDrawer' }
      & ChildLevel0EmploymentContractNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentSalaryDetailsDrawer' }
      & ChildLevel0EmploymentSalaryDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'InvoiceTransferLinksDrawer' }
      & ChildLevel0InvoiceTransferLinksDrawerFragment
    )
    | (
      { readonly __typename?: 'InvoicesDrawer' }
      & ChildLevel0InvoicesDrawerFragment
    )
    | (
      { readonly __typename?: 'ListColumnControllsDrawer' }
      & ChildLevel0ListColumnControllsDrawerFragment
    )
    | (
      { readonly __typename?: 'ManageKeyPeopleDrawer' }
      & ChildLevel0ManageKeyPeopleDrawerFragment
    )
    | (
      { readonly __typename?: 'ManageProjectTimelineDrawer' }
      & ChildLevel0ManageProjectTimelineDrawerFragment
    )
    | (
      { readonly __typename?: 'OtherEmployeeInformationDrawer' }
      & ChildLevel0OtherEmployeeInformationDrawerFragment
    )
    | (
      { readonly __typename?: 'ParkingSpotDrawer' }
      & ChildLevel0ParkingSpotDrawerFragment
    )
    | (
      { readonly __typename?: 'PaymentDetailsDraftDrawer' }
      & ChildLevel0PaymentDetailsDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'PaymentDetailsDrawer' }
      & ChildLevel0PaymentDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'PendingCopyrightsDrawer' }
      & ChildLevel0PendingCopyrightsDrawerFragment
    )
    | (
      { readonly __typename?: 'PeopleListReportDrawer' }
      & ChildLevel0PeopleListReportDrawerFragment
    )
    | (
      { readonly __typename?: 'ProgressionSchemeLevelDrawer' }
      & ChildLevel0ProgressionSchemeLevelDrawerFragment
    )
    | (
      { readonly __typename?: 'ProjectBillablesReportDrawer' }
      & ChildLevel0ProjectBillablesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'ProjectMembersDrawer' }
      & ChildLevel0ProjectMembersDrawerFragment
    )
    | (
      { readonly __typename?: 'RateCardDrawer' }
      & ChildLevel0RateCardDrawerFragment
    )
    | (
      { readonly __typename?: 'RateChangesReportDrawer' }
      & ChildLevel0RateChangesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'ReservationLimitsDrawer' }
      & ChildLevel0ReservationLimitsDrawerFragment
    )
    | (
      { readonly __typename?: 'RoomDrawer' }
      & ChildLevel0RoomDrawerFragment
    )
    | (
      { readonly __typename?: 'SalariesSummaryReportDrawer' }
      & ChildLevel0SalariesSummaryReportDrawerFragment
    )
    | (
      { readonly __typename?: 'SetFutureEntitlementDrawer' }
      & ChildLevel0SetFutureEntitlementDrawerFragment
    )
    | (
      { readonly __typename?: 'SetRateAndProgressionDrawer' }
      & ChildLevel0SetRateAndProgressionDrawerFragment
    )
    | (
      { readonly __typename?: 'SkillsAndCertificatesReportDrawer' }
      & ChildLevel0SkillsAndCertificatesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'SubcontractDraftDrawer' }
      & ChildLevel0SubcontractDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'SubcontractNoteDrawer' }
      & ChildLevel0SubcontractNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'TaxResidencyCertificatesDrawer' }
      & ChildLevel0TaxResidencyCertificatesDrawerFragment
    )
    | (
      { readonly __typename?: 'TimeReportsReportDrawer' }
      & ChildLevel0TimeReportsReportDrawerFragment
    )
    | (
      { readonly __typename?: 'TrainingPackageReportDrawer' }
      & ChildLevel0TrainingPackageReportDrawerFragment
    )
    | (
      { readonly __typename?: 'TransferDetailsDrawer' }
      & ChildLevel0TransferDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'TransferListExportDrawer' }
      & ChildLevel0TransferListExportDrawerFragment
    )
    | (
      { readonly __typename?: 'UopHolidaysReportDrawer' }
      & ChildLevel0UopHolidaysReportDrawerFragment
    )
    | (
      { readonly __typename?: 'UploadDocumentDrawer' }
      & ChildLevel0UploadDocumentDrawerFragment
    )
    | (
      { readonly __typename?: 'UserProjectsDrawer' }
      & ChildLevel0UserProjectsDrawerFragment
    )
    | (
      { readonly __typename?: 'YearlyCostSummaryDrawer' }
      & ChildLevel0YearlyCostSummaryDrawerFragment
    )
   | null };

export type AdminHighlightFragment = { readonly __typename?: 'TimeBasedHighlight', readonly effectiveDate: Date, readonly id?: string | null };

export type AbstractDrawerAddClientContractDrawerFragment = { readonly __typename?: 'AddClientContractDrawer', readonly companyId?: string | null, readonly companyType?: ReadonlyArray<CompanyType> | null, readonly prefillAs?: AddClientContractDrawerPrefillAs | null, readonly id: string, readonly visible: boolean };

export type AbstractDrawerAddCompanyDrawerFragment = { readonly __typename?: 'AddCompanyDrawer', readonly id: string, readonly visible: boolean, readonly initialData?: { readonly __typename?: 'AddCompanyDrawerInitialData', readonly companyType?: CompanyType | null, readonly name?: string | null, readonly taxNumber?: string | null } | null, readonly returnData?: { readonly __typename?: 'AddCompanyDrawerReturnData', readonly id: string, readonly name: string, readonly taxNumber?: string | null } | null };

export type AbstractDrawerAddInternalProjectDrawerFragment = { readonly __typename?: 'AddInternalProjectDrawer', readonly projectId?: string | null, readonly id: string, readonly visible: boolean };

export type AbstractDrawerAddOfficeDrawerFragment = { readonly __typename?: 'AddOfficeDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerAddPersonDrawerFragment = { readonly __typename?: 'AddPersonDrawer', readonly newUserId?: string | null, readonly id: string, readonly visible: boolean };

export type AbstractDrawerAddProgressionSchemeDrawerFragment = { readonly __typename?: 'AddProgressionSchemeDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerAddProjectDrawerFragment = { readonly __typename?: 'AddProjectDrawer', readonly prefillClientContractId?: string | null, readonly prefillClientId?: string | null, readonly projectId?: string | null, readonly id: string, readonly visible: boolean };

export type AbstractDrawerAddSpaceDrawerFragment = { readonly __typename?: 'AddSpaceDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerAddThirdPersonDrawerFragment = { readonly __typename?: 'AddThirdPersonDrawer', readonly requiredUserId: string, readonly thirdPersonId?: string | null, readonly id: string, readonly visible: boolean };

export type AbstractDrawerAdditionalCostsDrawerFragment = { readonly __typename?: 'AdditionalCostsDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerAllBonusesDrawerFragment = { readonly __typename?: 'AllBonusesDrawer', readonly requiredContractId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerAnnualLeaveEntitlementDrawerFragment = { readonly __typename?: 'AnnualLeaveEntitlementDrawer', readonly requiredContractId: string, readonly requiredUserId: string, readonly year: Date, readonly id: string, readonly visible: boolean };

export type AbstractDrawerAnnualLeavePreferencesDrawerFragment = { readonly __typename?: 'AnnualLeavePreferencesDrawer', readonly requiredContractId: string, readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerAnnualLeaveSummaryDrawerFragment = { readonly __typename?: 'AnnualLeaveSummaryDrawer', readonly requiredContractId: string, readonly requiredUserId: string, readonly year: Date, readonly id: string, readonly visible: boolean };

export type AbstractDrawerAssignBenefitDrawerFragment = { readonly __typename?: 'AssignBenefitDrawer', readonly effectiveDate?: Date | null, readonly requiredContractId: string, readonly requiredGroupType: BenefitGroupType, readonly requiredUserId: string, readonly id: string, readonly visible: boolean, readonly highlight?: (
    { readonly __typename?: 'TimeBasedHighlight' }
    & AdminHighlightFragment
  ) | null };

export type AbstractDrawerB2BContractDraftDrawerFragment = { readonly __typename?: 'B2BContractDraftDrawer', readonly editing: boolean, readonly errors: ReadonlyArray<string>, readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerB2BContractNoteDrawerFragment = { readonly __typename?: 'B2BContractNoteDrawer', readonly contractId?: string | null, readonly editing: boolean, readonly requiredPromiseeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerB2BSalaryDetailsDrawerFragment = { readonly __typename?: 'B2BSalaryDetailsDrawer', readonly requiredContractId: string, readonly requiredMonth: Date, readonly id: string, readonly visible: boolean };

export type AbstractDrawerBasicFinancialReportDrawerFragment = { readonly __typename?: 'BasicFinancialReportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerBenefitInvoicesReportDrawerFragment = { readonly __typename?: 'BenefitInvoicesReportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerBenefitNoteDrawerFragment = { readonly __typename?: 'BenefitNoteDrawer', readonly editing: boolean, readonly requiredAssignedVariantId: string, readonly requiredContractId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerBonusDrawerFragment = { readonly __typename?: 'BonusDrawer', readonly requiredContractId: string, readonly requiredUserId: string, readonly selectedBonusId?: string | null, readonly id: string, readonly visible: boolean };

export type AbstractDrawerBonusPreviewDrawerFragment = { readonly __typename?: 'BonusPreviewDrawer', readonly requiredBonusType: BonusType, readonly requiredContractId: string, readonly requiredSelectedBonusId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerBookDeskOnBehalfDrawerFragment = { readonly __typename?: 'BookDeskOnBehalfDrawer', readonly prefillDeskId?: string | null, readonly prefillFrom?: Date | null, readonly prefillRoomId?: string | null, readonly prefillTo?: Date | null, readonly requiredOfficeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerBookParkingOnBehalfDrawerFragment = { readonly __typename?: 'BookParkingOnBehalfDrawer', readonly prefillFrom?: Date | null, readonly prefillParkingSpotId?: string | null, readonly prefillTo?: Date | null, readonly requiredOfficeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerClientInvoicingReportDrawerFragment = { readonly __typename?: 'ClientInvoicingReportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerCompanyBankAccountDrawerFragment = { readonly __typename?: 'CompanyBankAccountDrawer', readonly editing: boolean, readonly requiredCompanyTypes: ReadonlyArray<CompanyType>, readonly id: string, readonly visible: boolean, readonly initialValue?: (
    { readonly __typename?: 'BankAccount' }
    & BankAccountFragment
  ) | null, readonly returnValue?: (
    { readonly __typename?: 'BankAccount' }
    & BankAccountFragment
  ) | null };

export type AbstractDrawerCompanyDetailsDrawerFragment = { readonly __typename?: 'CompanyDetailsDrawer', readonly activeTab?: CompanyDetailsDrawerTabs | null, readonly requiredCompanyId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerContractBankAccountDrawerFragment = { readonly __typename?: 'ContractBankAccountDrawer', readonly contractId?: string | null, readonly requiredIsPromisor: boolean, readonly requiredPromiseeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerContractBonusesSettingsDrawerFragment = { readonly __typename?: 'ContractBonusesSettingsDrawer', readonly requiredContractId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerContractDetailsDrawerFragment = { readonly __typename?: 'ContractDetailsDrawer', readonly effectiveDate?: Date | null, readonly requiredContractId: string, readonly id: string, readonly visible: boolean, readonly highlight?: (
    { readonly __typename?: 'TimeBasedHighlight' }
    & AdminHighlightFragment
  ) | null };

export type AbstractDrawerCopyrightsDrawerFragment = { readonly __typename?: 'CopyrightsDrawer', readonly showUserPreview?: boolean | null, readonly id: string, readonly visible: boolean };

export type AbstractDrawerCostAndRevenueItemDrawerFragment = { readonly __typename?: 'CostAndRevenueItemDrawer', readonly requiredProjectId: string, readonly selectedCostAndRevenueItemIndex?: number | null, readonly id: string, readonly visible: boolean };

export type AbstractDrawerCostSummariesDrawerFragment = { readonly __typename?: 'CostSummariesDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerCreateBenefitDrawerFragment = { readonly __typename?: 'CreateBenefitDrawer', readonly newBenefitId?: string | null, readonly requiredAlternativeBenefitsGroupId: string, readonly requiredGroupType: BenefitGroupType, readonly id: string, readonly visible: boolean };

export type AbstractDrawerCreateVariantDrawerFragment = { readonly __typename?: 'CreateVariantDrawer', readonly requiredParentId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerDeskAssignmentDrawerFragment = { readonly __typename?: 'DeskAssignmentDrawer', readonly requiredDeskId: string, readonly requiredOfficeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerDeskDrawerFragment = { readonly __typename?: 'DeskDrawer', readonly deskId?: string | null, readonly requiredOfficeId: string, readonly requiredRoomId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerDirectReportingDrawerFragment = { readonly __typename?: 'DirectReportingDrawer', readonly effectiveDate?: Date | null, readonly requiredUserId: string, readonly id: string, readonly visible: boolean, readonly highlight?: (
    { readonly __typename?: 'TimeBasedHighlight' }
    & AdminHighlightFragment
  ) | null };

export type AbstractDrawerEditBenefitDrawerFragment = { readonly __typename?: 'EditBenefitDrawer', readonly requiredBenefitId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditBenefitVariantDrawerFragment = { readonly __typename?: 'EditBenefitVariantDrawer', readonly effectiveDate?: Date | null, readonly requiredVariantId: string, readonly id: string, readonly visible: boolean, readonly highlight?: (
    { readonly __typename?: 'TimeBasedHighlight' }
    & AdminHighlightFragment
  ) | null };

export type AbstractDrawerEditBenefitVariantPriceDrawerFragment = { readonly __typename?: 'EditBenefitVariantPriceDrawer', readonly effectiveDate?: Date | null, readonly requiredVariantId: string, readonly id: string, readonly visible: boolean, readonly highlight?: (
    { readonly __typename?: 'TimeBasedHighlight' }
    & AdminHighlightFragment
  ) | null };

export type AbstractDrawerEditClientContractDrawerFragment = { readonly __typename?: 'EditClientContractDrawer', readonly requiredClientContractId: string, readonly requiredCompanyId: string, readonly requiredCompanyType: ReadonlyArray<CompanyType>, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditDeskRequestDrawerFragment = { readonly __typename?: 'EditDeskRequestDrawer', readonly requiredOfficeId: string, readonly requiredReservationRequestId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditOfficeDrawerFragment = { readonly __typename?: 'EditOfficeDrawer', readonly requiredOfficeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditOfficeSettingsDrawerFragment = { readonly __typename?: 'EditOfficeSettingsDrawer', readonly requiredOfficeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditParkingRequestDrawerFragment = { readonly __typename?: 'EditParkingRequestDrawer', readonly requiredOfficeId: string, readonly requiredReservationRequestId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditProfileAdditionalDataDrawerFragment = { readonly __typename?: 'EditProfileAdditionalDataDrawer', readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditProfileAddressDrawerFragment = { readonly __typename?: 'EditProfileAddressDrawer', readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditProfileBasicInfoDrawerFragment = { readonly __typename?: 'EditProfileBasicInfoDrawer', readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditProjectCrossSellDrawerFragment = { readonly __typename?: 'EditProjectCrossSellDrawer', readonly requiredProjectId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditProjectDrawerFragment = { readonly __typename?: 'EditProjectDrawer', readonly requiredProjectId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditProjectTechStackAndCompetencesDrawerFragment = { readonly __typename?: 'EditProjectTechStackAndCompetencesDrawer', readonly requiredProjectId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditSkillsAndCertificatesDrawerFragment = { readonly __typename?: 'EditSkillsAndCertificatesDrawer', readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditSocialMediaHandlesDrawerFragment = { readonly __typename?: 'EditSocialMediaHandlesDrawer', readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditSpaceDrawerFragment = { readonly __typename?: 'EditSpaceDrawer', readonly initialTab?: EditSpaceDrawerTabs | null, readonly requiredSpaceId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEmployeeDueDatesDrawerFragment = { readonly __typename?: 'EmployeeDueDatesDrawer', readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEmploymentBankAccountDrawerFragment = { readonly __typename?: 'EmploymentBankAccountDrawer', readonly contractId?: string | null, readonly editing: boolean, readonly requiredPromiseeId: string, readonly id: string, readonly visible: boolean, readonly highlight?: (
    { readonly __typename?: 'TimeBasedHighlight' }
    & AdminHighlightFragment
  ) | null };

export type AbstractDrawerEmploymentContractDraftDrawerFragment = { readonly __typename?: 'EmploymentContractDraftDrawer', readonly editing: boolean, readonly errors: ReadonlyArray<string>, readonly requiredEmploymentContractType: EmploymentContractType, readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEmploymentContractNoteDrawerFragment = { readonly __typename?: 'EmploymentContractNoteDrawer', readonly contractId?: string | null, readonly editing: boolean, readonly requiredPromiseeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerEmploymentSalaryDetailsDrawerFragment = { readonly __typename?: 'EmploymentSalaryDetailsDrawer', readonly requiredContractId: string, readonly requiredMonth: Date, readonly id: string, readonly visible: boolean };

export type AbstractDrawerInvoiceTransferLinksDrawerFragment = { readonly __typename?: 'InvoiceTransferLinksDrawer', readonly requiredInvoiceId: number, readonly id: string, readonly visible: boolean };

export type AbstractDrawerInvoicesDrawerFragment = { readonly __typename?: 'InvoicesDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerListColumnControllsDrawerFragment = { readonly __typename?: 'ListColumnControllsDrawer', readonly available: ReadonlyArray<string>, readonly defaults: ReadonlyArray<string>, readonly selected: ReadonlyArray<string>, readonly id: string, readonly visible: boolean };

export type AbstractDrawerManageKeyPeopleDrawerFragment = { readonly __typename?: 'ManageKeyPeopleDrawer', readonly requiredProjectId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerManageProjectTimelineDrawerFragment = { readonly __typename?: 'ManageProjectTimelineDrawer', readonly requiredProjectId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerOtherEmployeeInformationDrawerFragment = { readonly __typename?: 'OtherEmployeeInformationDrawer', readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerParkingSpotDrawerFragment = { readonly __typename?: 'ParkingSpotDrawer', readonly parkingSpotId?: string | null, readonly requiredOfficeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerPaymentDetailsDraftDrawerFragment = { readonly __typename?: 'PaymentDetailsDraftDrawer', readonly editing: boolean, readonly requiredContractType: ContractType, readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerPaymentDetailsDrawerFragment = { readonly __typename?: 'PaymentDetailsDrawer', readonly effectiveDate?: Date | null, readonly requiredContractId: string, readonly requiredContractType: ContractType, readonly requiredUserId: string, readonly id: string, readonly visible: boolean, readonly highlight?: (
    { readonly __typename?: 'TimeBasedHighlight' }
    & AdminHighlightFragment
  ) | null };

export type AbstractDrawerPendingCopyrightsDrawerFragment = { readonly __typename?: 'PendingCopyrightsDrawer', readonly highlightedWorkTransferId?: string | null, readonly requiredContractId: string, readonly requiredStartDate: Date, readonly requiredYearMonth: Date, readonly id: string, readonly visible: boolean };

export type AbstractDrawerPeopleListReportDrawerFragment = { readonly __typename?: 'PeopleListReportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerProgressionSchemeLevelDrawerFragment = { readonly __typename?: 'ProgressionSchemeLevelDrawer', readonly level?: ProgressionLevel | null, readonly requiredSchemeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerProjectBillablesReportDrawerFragment = { readonly __typename?: 'ProjectBillablesReportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerProjectMembersDrawerFragment = { readonly __typename?: 'ProjectMembersDrawer', readonly clientContractLink?: string | null, readonly focusedUserId?: string | null, readonly mode: ProjectMembersDrawerMode, readonly requiredProjectId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerRateCardDrawerFragment = { readonly __typename?: 'RateCardDrawer', readonly addNewPosition?: boolean | null, readonly editing: boolean, readonly effectiveDate?: Date | null, readonly requiredClientContractId: string, readonly id: string, readonly visible: boolean, readonly highlight?: (
    { readonly __typename?: 'TimeBasedHighlight' }
    & AdminHighlightFragment
  ) | null };

export type AbstractDrawerRateChangesReportDrawerFragment = { readonly __typename?: 'RateChangesReportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerReservationLimitsDrawerFragment = { readonly __typename?: 'ReservationLimitsDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerRoomDrawerFragment = { readonly __typename?: 'RoomDrawer', readonly requiredOfficeId: string, readonly roomId?: string | null, readonly id: string, readonly visible: boolean };

export type AbstractDrawerSalariesSummaryReportDrawerFragment = { readonly __typename?: 'SalariesSummaryReportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerSetFutureEntitlementDrawerFragment = { readonly __typename?: 'SetFutureEntitlementDrawer', readonly initialAbsence: boolean, readonly initialDate?: Date | null, readonly requiredContractId: string, readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerSetRateAndProgressionDrawerFragment = { readonly __typename?: 'SetRateAndProgressionDrawer', readonly editing: boolean, readonly effectiveDate?: Date | null, readonly promotionLevel?: ProgressionLevel | null, readonly requiredContractId: string, readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerSkillsAndCertificatesReportDrawerFragment = { readonly __typename?: 'SkillsAndCertificatesReportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerSubcontractDraftDrawerFragment = { readonly __typename?: 'SubcontractDraftDrawer', readonly editing: boolean, readonly errors: ReadonlyArray<string>, readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerSubcontractNoteDrawerFragment = { readonly __typename?: 'SubcontractNoteDrawer', readonly contractId?: string | null, readonly editing: boolean, readonly requiredPromiseeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerTaxResidencyCertificatesDrawerFragment = { readonly __typename?: 'TaxResidencyCertificatesDrawer', readonly requiredCompanyId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerTimeReportsReportDrawerFragment = { readonly __typename?: 'TimeReportsReportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerTrainingPackageReportDrawerFragment = { readonly __typename?: 'TrainingPackageReportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerTransferDetailsDrawerFragment = { readonly __typename?: 'TransferDetailsDrawer', readonly requiredDate: Date, readonly requiredTransferId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerTransferListExportDrawerFragment = { readonly __typename?: 'TransferListExportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerUopHolidaysReportDrawerFragment = { readonly __typename?: 'UopHolidaysReportDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerUploadDocumentDrawerFragment = { readonly __typename?: 'UploadDocumentDrawer', readonly documentId?: string | null, readonly id: string, readonly visible: boolean };

export type AbstractDrawerUserProjectsDrawerFragment = { readonly __typename?: 'UserProjectsDrawer', readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerYearlyCostSummaryDrawerFragment = { readonly __typename?: 'YearlyCostSummaryDrawer', readonly requiredUserId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerFragment =
  | AbstractDrawerAddClientContractDrawerFragment
  | AbstractDrawerAddCompanyDrawerFragment
  | AbstractDrawerAddInternalProjectDrawerFragment
  | AbstractDrawerAddOfficeDrawerFragment
  | AbstractDrawerAddPersonDrawerFragment
  | AbstractDrawerAddProgressionSchemeDrawerFragment
  | AbstractDrawerAddProjectDrawerFragment
  | AbstractDrawerAddSpaceDrawerFragment
  | AbstractDrawerAddThirdPersonDrawerFragment
  | AbstractDrawerAdditionalCostsDrawerFragment
  | AbstractDrawerAllBonusesDrawerFragment
  | AbstractDrawerAnnualLeaveEntitlementDrawerFragment
  | AbstractDrawerAnnualLeavePreferencesDrawerFragment
  | AbstractDrawerAnnualLeaveSummaryDrawerFragment
  | AbstractDrawerAssignBenefitDrawerFragment
  | AbstractDrawerB2BContractDraftDrawerFragment
  | AbstractDrawerB2BContractNoteDrawerFragment
  | AbstractDrawerB2BSalaryDetailsDrawerFragment
  | AbstractDrawerBasicFinancialReportDrawerFragment
  | AbstractDrawerBenefitInvoicesReportDrawerFragment
  | AbstractDrawerBenefitNoteDrawerFragment
  | AbstractDrawerBonusDrawerFragment
  | AbstractDrawerBonusPreviewDrawerFragment
  | AbstractDrawerBookDeskOnBehalfDrawerFragment
  | AbstractDrawerBookParkingOnBehalfDrawerFragment
  | AbstractDrawerClientInvoicingReportDrawerFragment
  | AbstractDrawerCompanyBankAccountDrawerFragment
  | AbstractDrawerCompanyDetailsDrawerFragment
  | AbstractDrawerContractBankAccountDrawerFragment
  | AbstractDrawerContractBonusesSettingsDrawerFragment
  | AbstractDrawerContractDetailsDrawerFragment
  | AbstractDrawerCopyrightsDrawerFragment
  | AbstractDrawerCostAndRevenueItemDrawerFragment
  | AbstractDrawerCostSummariesDrawerFragment
  | AbstractDrawerCreateBenefitDrawerFragment
  | AbstractDrawerCreateVariantDrawerFragment
  | AbstractDrawerDeskAssignmentDrawerFragment
  | AbstractDrawerDeskDrawerFragment
  | AbstractDrawerDirectReportingDrawerFragment
  | AbstractDrawerEditBenefitDrawerFragment
  | AbstractDrawerEditBenefitVariantDrawerFragment
  | AbstractDrawerEditBenefitVariantPriceDrawerFragment
  | AbstractDrawerEditClientContractDrawerFragment
  | AbstractDrawerEditDeskRequestDrawerFragment
  | AbstractDrawerEditOfficeDrawerFragment
  | AbstractDrawerEditOfficeSettingsDrawerFragment
  | AbstractDrawerEditParkingRequestDrawerFragment
  | AbstractDrawerEditProfileAdditionalDataDrawerFragment
  | AbstractDrawerEditProfileAddressDrawerFragment
  | AbstractDrawerEditProfileBasicInfoDrawerFragment
  | AbstractDrawerEditProjectCrossSellDrawerFragment
  | AbstractDrawerEditProjectDrawerFragment
  | AbstractDrawerEditProjectTechStackAndCompetencesDrawerFragment
  | AbstractDrawerEditSkillsAndCertificatesDrawerFragment
  | AbstractDrawerEditSocialMediaHandlesDrawerFragment
  | AbstractDrawerEditSpaceDrawerFragment
  | AbstractDrawerEmployeeDueDatesDrawerFragment
  | AbstractDrawerEmploymentBankAccountDrawerFragment
  | AbstractDrawerEmploymentContractDraftDrawerFragment
  | AbstractDrawerEmploymentContractNoteDrawerFragment
  | AbstractDrawerEmploymentSalaryDetailsDrawerFragment
  | AbstractDrawerInvoiceTransferLinksDrawerFragment
  | AbstractDrawerInvoicesDrawerFragment
  | AbstractDrawerListColumnControllsDrawerFragment
  | AbstractDrawerManageKeyPeopleDrawerFragment
  | AbstractDrawerManageProjectTimelineDrawerFragment
  | AbstractDrawerOtherEmployeeInformationDrawerFragment
  | AbstractDrawerParkingSpotDrawerFragment
  | AbstractDrawerPaymentDetailsDraftDrawerFragment
  | AbstractDrawerPaymentDetailsDrawerFragment
  | AbstractDrawerPendingCopyrightsDrawerFragment
  | AbstractDrawerPeopleListReportDrawerFragment
  | AbstractDrawerProgressionSchemeLevelDrawerFragment
  | AbstractDrawerProjectBillablesReportDrawerFragment
  | AbstractDrawerProjectMembersDrawerFragment
  | AbstractDrawerRateCardDrawerFragment
  | AbstractDrawerRateChangesReportDrawerFragment
  | AbstractDrawerReservationLimitsDrawerFragment
  | AbstractDrawerRoomDrawerFragment
  | AbstractDrawerSalariesSummaryReportDrawerFragment
  | AbstractDrawerSetFutureEntitlementDrawerFragment
  | AbstractDrawerSetRateAndProgressionDrawerFragment
  | AbstractDrawerSkillsAndCertificatesReportDrawerFragment
  | AbstractDrawerSubcontractDraftDrawerFragment
  | AbstractDrawerSubcontractNoteDrawerFragment
  | AbstractDrawerTaxResidencyCertificatesDrawerFragment
  | AbstractDrawerTimeReportsReportDrawerFragment
  | AbstractDrawerTrainingPackageReportDrawerFragment
  | AbstractDrawerTransferDetailsDrawerFragment
  | AbstractDrawerTransferListExportDrawerFragment
  | AbstractDrawerUopHolidaysReportDrawerFragment
  | AbstractDrawerUploadDocumentDrawerFragment
  | AbstractDrawerUserProjectsDrawerFragment
  | AbstractDrawerYearlyCostSummaryDrawerFragment
;

export type RootDrawerQueryVariables = Exact<{ [key: string]: never; }>;


export type RootDrawerQuery = { readonly __typename?: 'Query', readonly rootDrawer?:
    | (
      { readonly __typename?: 'AddClientContractDrawer' }
      & ChildLevel0AddClientContractDrawerFragment
    )
    | (
      { readonly __typename?: 'AddCompanyDrawer' }
      & ChildLevel0AddCompanyDrawerFragment
    )
    | (
      { readonly __typename?: 'AddInternalProjectDrawer' }
      & ChildLevel0AddInternalProjectDrawerFragment
    )
    | (
      { readonly __typename?: 'AddOfficeDrawer' }
      & ChildLevel0AddOfficeDrawerFragment
    )
    | (
      { readonly __typename?: 'AddPersonDrawer' }
      & ChildLevel0AddPersonDrawerFragment
    )
    | (
      { readonly __typename?: 'AddProgressionSchemeDrawer' }
      & ChildLevel0AddProgressionSchemeDrawerFragment
    )
    | (
      { readonly __typename?: 'AddProjectDrawer' }
      & ChildLevel0AddProjectDrawerFragment
    )
    | (
      { readonly __typename?: 'AddSpaceDrawer' }
      & ChildLevel0AddSpaceDrawerFragment
    )
    | (
      { readonly __typename?: 'AddThirdPersonDrawer' }
      & ChildLevel0AddThirdPersonDrawerFragment
    )
    | (
      { readonly __typename?: 'AdditionalCostsDrawer' }
      & ChildLevel0AdditionalCostsDrawerFragment
    )
    | (
      { readonly __typename?: 'AllBonusesDrawer' }
      & ChildLevel0AllBonusesDrawerFragment
    )
    | (
      { readonly __typename?: 'AnnualLeaveEntitlementDrawer' }
      & ChildLevel0AnnualLeaveEntitlementDrawerFragment
    )
    | (
      { readonly __typename?: 'AnnualLeavePreferencesDrawer' }
      & ChildLevel0AnnualLeavePreferencesDrawerFragment
    )
    | (
      { readonly __typename?: 'AnnualLeaveSummaryDrawer' }
      & ChildLevel0AnnualLeaveSummaryDrawerFragment
    )
    | (
      { readonly __typename?: 'AssignBenefitDrawer' }
      & ChildLevel0AssignBenefitDrawerFragment
    )
    | (
      { readonly __typename?: 'B2BContractDraftDrawer' }
      & ChildLevel0B2BContractDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'B2BContractNoteDrawer' }
      & ChildLevel0B2BContractNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'B2BSalaryDetailsDrawer' }
      & ChildLevel0B2BSalaryDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'BasicFinancialReportDrawer' }
      & ChildLevel0BasicFinancialReportDrawerFragment
    )
    | (
      { readonly __typename?: 'BenefitInvoicesReportDrawer' }
      & ChildLevel0BenefitInvoicesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'BenefitNoteDrawer' }
      & ChildLevel0BenefitNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'BonusDrawer' }
      & ChildLevel0BonusDrawerFragment
    )
    | (
      { readonly __typename?: 'BonusPreviewDrawer' }
      & ChildLevel0BonusPreviewDrawerFragment
    )
    | (
      { readonly __typename?: 'BookDeskOnBehalfDrawer' }
      & ChildLevel0BookDeskOnBehalfDrawerFragment
    )
    | (
      { readonly __typename?: 'BookParkingOnBehalfDrawer' }
      & ChildLevel0BookParkingOnBehalfDrawerFragment
    )
    | (
      { readonly __typename?: 'ClientInvoicingReportDrawer' }
      & ChildLevel0ClientInvoicingReportDrawerFragment
    )
    | (
      { readonly __typename?: 'CompanyBankAccountDrawer' }
      & ChildLevel0CompanyBankAccountDrawerFragment
    )
    | (
      { readonly __typename?: 'CompanyDetailsDrawer' }
      & ChildLevel0CompanyDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'ContractBankAccountDrawer' }
      & ChildLevel0ContractBankAccountDrawerFragment
    )
    | (
      { readonly __typename?: 'ContractBonusesSettingsDrawer' }
      & ChildLevel0ContractBonusesSettingsDrawerFragment
    )
    | (
      { readonly __typename?: 'ContractDetailsDrawer' }
      & ChildLevel0ContractDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'CopyrightsDrawer' }
      & ChildLevel0CopyrightsDrawerFragment
    )
    | (
      { readonly __typename?: 'CostAndRevenueItemDrawer' }
      & ChildLevel0CostAndRevenueItemDrawerFragment
    )
    | (
      { readonly __typename?: 'CostSummariesDrawer' }
      & ChildLevel0CostSummariesDrawerFragment
    )
    | (
      { readonly __typename?: 'CreateBenefitDrawer' }
      & ChildLevel0CreateBenefitDrawerFragment
    )
    | (
      { readonly __typename?: 'CreateVariantDrawer' }
      & ChildLevel0CreateVariantDrawerFragment
    )
    | (
      { readonly __typename?: 'DeskAssignmentDrawer' }
      & ChildLevel0DeskAssignmentDrawerFragment
    )
    | (
      { readonly __typename?: 'DeskDrawer' }
      & ChildLevel0DeskDrawerFragment
    )
    | (
      { readonly __typename?: 'DirectReportingDrawer' }
      & ChildLevel0DirectReportingDrawerFragment
    )
    | (
      { readonly __typename?: 'EditBenefitDrawer' }
      & ChildLevel0EditBenefitDrawerFragment
    )
    | (
      { readonly __typename?: 'EditBenefitVariantDrawer' }
      & ChildLevel0EditBenefitVariantDrawerFragment
    )
    | (
      { readonly __typename?: 'EditBenefitVariantPriceDrawer' }
      & ChildLevel0EditBenefitVariantPriceDrawerFragment
    )
    | (
      { readonly __typename?: 'EditClientContractDrawer' }
      & ChildLevel0EditClientContractDrawerFragment
    )
    | (
      { readonly __typename?: 'EditDeskRequestDrawer' }
      & ChildLevel0EditDeskRequestDrawerFragment
    )
    | (
      { readonly __typename?: 'EditOfficeDrawer' }
      & ChildLevel0EditOfficeDrawerFragment
    )
    | (
      { readonly __typename?: 'EditOfficeSettingsDrawer' }
      & ChildLevel0EditOfficeSettingsDrawerFragment
    )
    | (
      { readonly __typename?: 'EditParkingRequestDrawer' }
      & ChildLevel0EditParkingRequestDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileAdditionalDataDrawer' }
      & ChildLevel0EditProfileAdditionalDataDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileAddressDrawer' }
      & ChildLevel0EditProfileAddressDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileBasicInfoDrawer' }
      & ChildLevel0EditProfileBasicInfoDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProjectCrossSellDrawer' }
      & ChildLevel0EditProjectCrossSellDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProjectDrawer' }
      & ChildLevel0EditProjectDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProjectTechStackAndCompetencesDrawer' }
      & ChildLevel0EditProjectTechStackAndCompetencesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSkillsAndCertificatesDrawer' }
      & ChildLevel0EditSkillsAndCertificatesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSocialMediaHandlesDrawer' }
      & ChildLevel0EditSocialMediaHandlesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSpaceDrawer' }
      & ChildLevel0EditSpaceDrawerFragment
    )
    | (
      { readonly __typename?: 'EmployeeDueDatesDrawer' }
      & ChildLevel0EmployeeDueDatesDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentBankAccountDrawer' }
      & ChildLevel0EmploymentBankAccountDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentContractDraftDrawer' }
      & ChildLevel0EmploymentContractDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentContractNoteDrawer' }
      & ChildLevel0EmploymentContractNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentSalaryDetailsDrawer' }
      & ChildLevel0EmploymentSalaryDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'InvoiceTransferLinksDrawer' }
      & ChildLevel0InvoiceTransferLinksDrawerFragment
    )
    | (
      { readonly __typename?: 'InvoicesDrawer' }
      & ChildLevel0InvoicesDrawerFragment
    )
    | (
      { readonly __typename?: 'ListColumnControllsDrawer' }
      & ChildLevel0ListColumnControllsDrawerFragment
    )
    | (
      { readonly __typename?: 'ManageKeyPeopleDrawer' }
      & ChildLevel0ManageKeyPeopleDrawerFragment
    )
    | (
      { readonly __typename?: 'ManageProjectTimelineDrawer' }
      & ChildLevel0ManageProjectTimelineDrawerFragment
    )
    | (
      { readonly __typename?: 'OtherEmployeeInformationDrawer' }
      & ChildLevel0OtherEmployeeInformationDrawerFragment
    )
    | (
      { readonly __typename?: 'ParkingSpotDrawer' }
      & ChildLevel0ParkingSpotDrawerFragment
    )
    | (
      { readonly __typename?: 'PaymentDetailsDraftDrawer' }
      & ChildLevel0PaymentDetailsDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'PaymentDetailsDrawer' }
      & ChildLevel0PaymentDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'PendingCopyrightsDrawer' }
      & ChildLevel0PendingCopyrightsDrawerFragment
    )
    | (
      { readonly __typename?: 'PeopleListReportDrawer' }
      & ChildLevel0PeopleListReportDrawerFragment
    )
    | (
      { readonly __typename?: 'ProgressionSchemeLevelDrawer' }
      & ChildLevel0ProgressionSchemeLevelDrawerFragment
    )
    | (
      { readonly __typename?: 'ProjectBillablesReportDrawer' }
      & ChildLevel0ProjectBillablesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'ProjectMembersDrawer' }
      & ChildLevel0ProjectMembersDrawerFragment
    )
    | (
      { readonly __typename?: 'RateCardDrawer' }
      & ChildLevel0RateCardDrawerFragment
    )
    | (
      { readonly __typename?: 'RateChangesReportDrawer' }
      & ChildLevel0RateChangesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'ReservationLimitsDrawer' }
      & ChildLevel0ReservationLimitsDrawerFragment
    )
    | (
      { readonly __typename?: 'RoomDrawer' }
      & ChildLevel0RoomDrawerFragment
    )
    | (
      { readonly __typename?: 'SalariesSummaryReportDrawer' }
      & ChildLevel0SalariesSummaryReportDrawerFragment
    )
    | (
      { readonly __typename?: 'SetFutureEntitlementDrawer' }
      & ChildLevel0SetFutureEntitlementDrawerFragment
    )
    | (
      { readonly __typename?: 'SetRateAndProgressionDrawer' }
      & ChildLevel0SetRateAndProgressionDrawerFragment
    )
    | (
      { readonly __typename?: 'SkillsAndCertificatesReportDrawer' }
      & ChildLevel0SkillsAndCertificatesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'SubcontractDraftDrawer' }
      & ChildLevel0SubcontractDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'SubcontractNoteDrawer' }
      & ChildLevel0SubcontractNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'TaxResidencyCertificatesDrawer' }
      & ChildLevel0TaxResidencyCertificatesDrawerFragment
    )
    | (
      { readonly __typename?: 'TimeReportsReportDrawer' }
      & ChildLevel0TimeReportsReportDrawerFragment
    )
    | (
      { readonly __typename?: 'TrainingPackageReportDrawer' }
      & ChildLevel0TrainingPackageReportDrawerFragment
    )
    | (
      { readonly __typename?: 'TransferDetailsDrawer' }
      & ChildLevel0TransferDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'TransferListExportDrawer' }
      & ChildLevel0TransferListExportDrawerFragment
    )
    | (
      { readonly __typename?: 'UopHolidaysReportDrawer' }
      & ChildLevel0UopHolidaysReportDrawerFragment
    )
    | (
      { readonly __typename?: 'UploadDocumentDrawer' }
      & ChildLevel0UploadDocumentDrawerFragment
    )
    | (
      { readonly __typename?: 'UserProjectsDrawer' }
      & ChildLevel0UserProjectsDrawerFragment
    )
    | (
      { readonly __typename?: 'YearlyCostSummaryDrawer' }
      & ChildLevel0YearlyCostSummaryDrawerFragment
    )
   | null };

export type TopDrawerQueryVariables = Exact<{ [key: string]: never; }>;


export type TopDrawerQuery = { readonly __typename?: 'Query', readonly topDrawer?:
    | (
      { readonly __typename?: 'AddClientContractDrawer' }
      & ChildLevel0AddClientContractDrawerFragment
    )
    | (
      { readonly __typename?: 'AddCompanyDrawer' }
      & ChildLevel0AddCompanyDrawerFragment
    )
    | (
      { readonly __typename?: 'AddInternalProjectDrawer' }
      & ChildLevel0AddInternalProjectDrawerFragment
    )
    | (
      { readonly __typename?: 'AddOfficeDrawer' }
      & ChildLevel0AddOfficeDrawerFragment
    )
    | (
      { readonly __typename?: 'AddPersonDrawer' }
      & ChildLevel0AddPersonDrawerFragment
    )
    | (
      { readonly __typename?: 'AddProgressionSchemeDrawer' }
      & ChildLevel0AddProgressionSchemeDrawerFragment
    )
    | (
      { readonly __typename?: 'AddProjectDrawer' }
      & ChildLevel0AddProjectDrawerFragment
    )
    | (
      { readonly __typename?: 'AddSpaceDrawer' }
      & ChildLevel0AddSpaceDrawerFragment
    )
    | (
      { readonly __typename?: 'AddThirdPersonDrawer' }
      & ChildLevel0AddThirdPersonDrawerFragment
    )
    | (
      { readonly __typename?: 'AdditionalCostsDrawer' }
      & ChildLevel0AdditionalCostsDrawerFragment
    )
    | (
      { readonly __typename?: 'AllBonusesDrawer' }
      & ChildLevel0AllBonusesDrawerFragment
    )
    | (
      { readonly __typename?: 'AnnualLeaveEntitlementDrawer' }
      & ChildLevel0AnnualLeaveEntitlementDrawerFragment
    )
    | (
      { readonly __typename?: 'AnnualLeavePreferencesDrawer' }
      & ChildLevel0AnnualLeavePreferencesDrawerFragment
    )
    | (
      { readonly __typename?: 'AnnualLeaveSummaryDrawer' }
      & ChildLevel0AnnualLeaveSummaryDrawerFragment
    )
    | (
      { readonly __typename?: 'AssignBenefitDrawer' }
      & ChildLevel0AssignBenefitDrawerFragment
    )
    | (
      { readonly __typename?: 'B2BContractDraftDrawer' }
      & ChildLevel0B2BContractDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'B2BContractNoteDrawer' }
      & ChildLevel0B2BContractNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'B2BSalaryDetailsDrawer' }
      & ChildLevel0B2BSalaryDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'BasicFinancialReportDrawer' }
      & ChildLevel0BasicFinancialReportDrawerFragment
    )
    | (
      { readonly __typename?: 'BenefitInvoicesReportDrawer' }
      & ChildLevel0BenefitInvoicesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'BenefitNoteDrawer' }
      & ChildLevel0BenefitNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'BonusDrawer' }
      & ChildLevel0BonusDrawerFragment
    )
    | (
      { readonly __typename?: 'BonusPreviewDrawer' }
      & ChildLevel0BonusPreviewDrawerFragment
    )
    | (
      { readonly __typename?: 'BookDeskOnBehalfDrawer' }
      & ChildLevel0BookDeskOnBehalfDrawerFragment
    )
    | (
      { readonly __typename?: 'BookParkingOnBehalfDrawer' }
      & ChildLevel0BookParkingOnBehalfDrawerFragment
    )
    | (
      { readonly __typename?: 'ClientInvoicingReportDrawer' }
      & ChildLevel0ClientInvoicingReportDrawerFragment
    )
    | (
      { readonly __typename?: 'CompanyBankAccountDrawer' }
      & ChildLevel0CompanyBankAccountDrawerFragment
    )
    | (
      { readonly __typename?: 'CompanyDetailsDrawer' }
      & ChildLevel0CompanyDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'ContractBankAccountDrawer' }
      & ChildLevel0ContractBankAccountDrawerFragment
    )
    | (
      { readonly __typename?: 'ContractBonusesSettingsDrawer' }
      & ChildLevel0ContractBonusesSettingsDrawerFragment
    )
    | (
      { readonly __typename?: 'ContractDetailsDrawer' }
      & ChildLevel0ContractDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'CopyrightsDrawer' }
      & ChildLevel0CopyrightsDrawerFragment
    )
    | (
      { readonly __typename?: 'CostAndRevenueItemDrawer' }
      & ChildLevel0CostAndRevenueItemDrawerFragment
    )
    | (
      { readonly __typename?: 'CostSummariesDrawer' }
      & ChildLevel0CostSummariesDrawerFragment
    )
    | (
      { readonly __typename?: 'CreateBenefitDrawer' }
      & ChildLevel0CreateBenefitDrawerFragment
    )
    | (
      { readonly __typename?: 'CreateVariantDrawer' }
      & ChildLevel0CreateVariantDrawerFragment
    )
    | (
      { readonly __typename?: 'DeskAssignmentDrawer' }
      & ChildLevel0DeskAssignmentDrawerFragment
    )
    | (
      { readonly __typename?: 'DeskDrawer' }
      & ChildLevel0DeskDrawerFragment
    )
    | (
      { readonly __typename?: 'DirectReportingDrawer' }
      & ChildLevel0DirectReportingDrawerFragment
    )
    | (
      { readonly __typename?: 'EditBenefitDrawer' }
      & ChildLevel0EditBenefitDrawerFragment
    )
    | (
      { readonly __typename?: 'EditBenefitVariantDrawer' }
      & ChildLevel0EditBenefitVariantDrawerFragment
    )
    | (
      { readonly __typename?: 'EditBenefitVariantPriceDrawer' }
      & ChildLevel0EditBenefitVariantPriceDrawerFragment
    )
    | (
      { readonly __typename?: 'EditClientContractDrawer' }
      & ChildLevel0EditClientContractDrawerFragment
    )
    | (
      { readonly __typename?: 'EditDeskRequestDrawer' }
      & ChildLevel0EditDeskRequestDrawerFragment
    )
    | (
      { readonly __typename?: 'EditOfficeDrawer' }
      & ChildLevel0EditOfficeDrawerFragment
    )
    | (
      { readonly __typename?: 'EditOfficeSettingsDrawer' }
      & ChildLevel0EditOfficeSettingsDrawerFragment
    )
    | (
      { readonly __typename?: 'EditParkingRequestDrawer' }
      & ChildLevel0EditParkingRequestDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileAdditionalDataDrawer' }
      & ChildLevel0EditProfileAdditionalDataDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileAddressDrawer' }
      & ChildLevel0EditProfileAddressDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileBasicInfoDrawer' }
      & ChildLevel0EditProfileBasicInfoDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProjectCrossSellDrawer' }
      & ChildLevel0EditProjectCrossSellDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProjectDrawer' }
      & ChildLevel0EditProjectDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProjectTechStackAndCompetencesDrawer' }
      & ChildLevel0EditProjectTechStackAndCompetencesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSkillsAndCertificatesDrawer' }
      & ChildLevel0EditSkillsAndCertificatesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSocialMediaHandlesDrawer' }
      & ChildLevel0EditSocialMediaHandlesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSpaceDrawer' }
      & ChildLevel0EditSpaceDrawerFragment
    )
    | (
      { readonly __typename?: 'EmployeeDueDatesDrawer' }
      & ChildLevel0EmployeeDueDatesDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentBankAccountDrawer' }
      & ChildLevel0EmploymentBankAccountDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentContractDraftDrawer' }
      & ChildLevel0EmploymentContractDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentContractNoteDrawer' }
      & ChildLevel0EmploymentContractNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'EmploymentSalaryDetailsDrawer' }
      & ChildLevel0EmploymentSalaryDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'InvoiceTransferLinksDrawer' }
      & ChildLevel0InvoiceTransferLinksDrawerFragment
    )
    | (
      { readonly __typename?: 'InvoicesDrawer' }
      & ChildLevel0InvoicesDrawerFragment
    )
    | (
      { readonly __typename?: 'ListColumnControllsDrawer' }
      & ChildLevel0ListColumnControllsDrawerFragment
    )
    | (
      { readonly __typename?: 'ManageKeyPeopleDrawer' }
      & ChildLevel0ManageKeyPeopleDrawerFragment
    )
    | (
      { readonly __typename?: 'ManageProjectTimelineDrawer' }
      & ChildLevel0ManageProjectTimelineDrawerFragment
    )
    | (
      { readonly __typename?: 'OtherEmployeeInformationDrawer' }
      & ChildLevel0OtherEmployeeInformationDrawerFragment
    )
    | (
      { readonly __typename?: 'ParkingSpotDrawer' }
      & ChildLevel0ParkingSpotDrawerFragment
    )
    | (
      { readonly __typename?: 'PaymentDetailsDraftDrawer' }
      & ChildLevel0PaymentDetailsDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'PaymentDetailsDrawer' }
      & ChildLevel0PaymentDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'PendingCopyrightsDrawer' }
      & ChildLevel0PendingCopyrightsDrawerFragment
    )
    | (
      { readonly __typename?: 'PeopleListReportDrawer' }
      & ChildLevel0PeopleListReportDrawerFragment
    )
    | (
      { readonly __typename?: 'ProgressionSchemeLevelDrawer' }
      & ChildLevel0ProgressionSchemeLevelDrawerFragment
    )
    | (
      { readonly __typename?: 'ProjectBillablesReportDrawer' }
      & ChildLevel0ProjectBillablesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'ProjectMembersDrawer' }
      & ChildLevel0ProjectMembersDrawerFragment
    )
    | (
      { readonly __typename?: 'RateCardDrawer' }
      & ChildLevel0RateCardDrawerFragment
    )
    | (
      { readonly __typename?: 'RateChangesReportDrawer' }
      & ChildLevel0RateChangesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'ReservationLimitsDrawer' }
      & ChildLevel0ReservationLimitsDrawerFragment
    )
    | (
      { readonly __typename?: 'RoomDrawer' }
      & ChildLevel0RoomDrawerFragment
    )
    | (
      { readonly __typename?: 'SalariesSummaryReportDrawer' }
      & ChildLevel0SalariesSummaryReportDrawerFragment
    )
    | (
      { readonly __typename?: 'SetFutureEntitlementDrawer' }
      & ChildLevel0SetFutureEntitlementDrawerFragment
    )
    | (
      { readonly __typename?: 'SetRateAndProgressionDrawer' }
      & ChildLevel0SetRateAndProgressionDrawerFragment
    )
    | (
      { readonly __typename?: 'SkillsAndCertificatesReportDrawer' }
      & ChildLevel0SkillsAndCertificatesReportDrawerFragment
    )
    | (
      { readonly __typename?: 'SubcontractDraftDrawer' }
      & ChildLevel0SubcontractDraftDrawerFragment
    )
    | (
      { readonly __typename?: 'SubcontractNoteDrawer' }
      & ChildLevel0SubcontractNoteDrawerFragment
    )
    | (
      { readonly __typename?: 'TaxResidencyCertificatesDrawer' }
      & ChildLevel0TaxResidencyCertificatesDrawerFragment
    )
    | (
      { readonly __typename?: 'TimeReportsReportDrawer' }
      & ChildLevel0TimeReportsReportDrawerFragment
    )
    | (
      { readonly __typename?: 'TrainingPackageReportDrawer' }
      & ChildLevel0TrainingPackageReportDrawerFragment
    )
    | (
      { readonly __typename?: 'TransferDetailsDrawer' }
      & ChildLevel0TransferDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'TransferListExportDrawer' }
      & ChildLevel0TransferListExportDrawerFragment
    )
    | (
      { readonly __typename?: 'UopHolidaysReportDrawer' }
      & ChildLevel0UopHolidaysReportDrawerFragment
    )
    | (
      { readonly __typename?: 'UploadDocumentDrawer' }
      & ChildLevel0UploadDocumentDrawerFragment
    )
    | (
      { readonly __typename?: 'UserProjectsDrawer' }
      & ChildLevel0UserProjectsDrawerFragment
    )
    | (
      { readonly __typename?: 'YearlyCostSummaryDrawer' }
      & ChildLevel0YearlyCostSummaryDrawerFragment
    )
   | null };

export type AdminAdditionalCostsDrawerQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type AdminAdditionalCostsDrawerQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AdditionalCostDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AdditionalCostDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AdditionalCostDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AdditionalCostDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AdditionalCostDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AdditionalCostDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AdditionalCostDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AdditionalCostDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AdditionalCostDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AdditionalCostDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AdditionalCostDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AdditionalCostDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AdditionalCostDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AdditionalCostDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AdditionalCostDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AdditionalCostDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AdditionalCostDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AdditionalCostDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AdditionalCostDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AdditionalCostDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AdditionalCostDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AdditionalCostDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AdditionalCostDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AdditionalCostDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AdditionalCostDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AdditionalCostDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AdditionalCostDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AdditionalCostDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AdditionalCostDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AdditionalCostDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AdditionalCostDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AdditionalCostDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AdditionalCostDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AdditionalCostDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AdditionalCostDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AdditionalCostDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AdditionalCostDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AdditionalCostDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AdditionalCostDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AdditionalCostDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly bonuses:
            | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AdditionalCostDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AdditionalCostDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AdditionalCostDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AdditionalCostDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AdditionalCostDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AdditionalCostDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AdditionalCostDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AdditionalCostDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AdditionalCostDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AdditionalCostDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                >, readonly future: ReadonlyArray<
                  | (
                    { readonly __typename?: 'AppreciationBonus' }
                    & AdditionalCostDrawerBonusAppreciationBonusFragment
                  )
                  | (
                    { readonly __typename?: 'BusinessTravelBonus' }
                    & AdditionalCostDrawerBonusBusinessTravelBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ClientReferralBonus' }
                    & AdditionalCostDrawerBonusClientReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ConferenceBonus' }
                    & AdditionalCostDrawerBonusConferenceBonusFragment
                  )
                  | (
                    { readonly __typename?: 'CostRechargeBonus' }
                    & AdditionalCostDrawerBonusCostRechargeBonusFragment
                  )
                  | (
                    { readonly __typename?: 'EmployeeReferralBonus' }
                    & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
                  )
                  | (
                    { readonly __typename?: 'LanguageLearningBonus' }
                    & AdditionalCostDrawerBonusLanguageLearningBonusFragment
                  )
                  | (
                    { readonly __typename?: 'OtherBonus' }
                    & AdditionalCostDrawerBonusOtherBonusFragment
                  )
                  | (
                    { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                    & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SalesCommissionsBonus' }
                    & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
                  )
                  | (
                    { readonly __typename?: 'SeverancePayBonus' }
                    & AdditionalCostDrawerBonusSeverancePayBonusFragment
                  )
                  | (
                    { readonly __typename?: 'ShareholderDividendBonus' }
                    & AdditionalCostDrawerBonusShareholderDividendBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageBonus' }
                    & AdditionalCostDrawerBonusTrainingPackageBonusFragment
                  )
                  | (
                    { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                    & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
                  )
                > } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
       }
    | { readonly __typename?: 'NfsError' }
   };

export type AdminAdditionalCostDrawerUpsertBonusMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  input: BonusInput;
}>;


export type AdminAdditionalCostDrawerUpsertBonusMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly upsertBonus:
      | { readonly __typename?: 'BonusResponse', readonly value:
          | (
            { readonly __typename?: 'AppreciationBonus' }
            & AdditionalCostDrawerBonusAppreciationBonusFragment
          )
          | (
            { readonly __typename?: 'BusinessTravelBonus' }
            & AdditionalCostDrawerBonusBusinessTravelBonusFragment
          )
          | (
            { readonly __typename?: 'ClientReferralBonus' }
            & AdditionalCostDrawerBonusClientReferralBonusFragment
          )
          | (
            { readonly __typename?: 'ConferenceBonus' }
            & AdditionalCostDrawerBonusConferenceBonusFragment
          )
          | (
            { readonly __typename?: 'CostRechargeBonus' }
            & AdditionalCostDrawerBonusCostRechargeBonusFragment
          )
          | (
            { readonly __typename?: 'EmployeeReferralBonus' }
            & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
          )
          | (
            { readonly __typename?: 'LanguageLearningBonus' }
            & AdditionalCostDrawerBonusLanguageLearningBonusFragment
          )
          | (
            { readonly __typename?: 'OtherBonus' }
            & AdditionalCostDrawerBonusOtherBonusFragment
          )
          | (
            { readonly __typename?: 'RemoteWorkEquipmentBonus' }
            & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
          )
          | (
            { readonly __typename?: 'SalesCommissionsBonus' }
            & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
          )
          | (
            { readonly __typename?: 'SeverancePayBonus' }
            & AdditionalCostDrawerBonusSeverancePayBonusFragment
          )
          | (
            { readonly __typename?: 'ShareholderDividendBonus' }
            & AdditionalCostDrawerBonusShareholderDividendBonusFragment
          )
          | (
            { readonly __typename?: 'TrainingPackageBonus' }
            & AdditionalCostDrawerBonusTrainingPackageBonusFragment
          )
          | (
            { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
            & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
          )
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type AdminAdditionalCostDrawerDeleteMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  id: Scalars['BonusId']['input'];
}>;


export type AdminAdditionalCostDrawerDeleteMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly bonus: { readonly __typename?: 'BonusMutation', readonly delete:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | { readonly __typename?: 'UnitResponse' }
       } } };

export type AdminAdditionalCostDrawerRejectMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  id: Scalars['BonusId']['input'];
}>;


export type AdminAdditionalCostDrawerRejectMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly bonus: { readonly __typename?: 'BonusMutation', readonly reject:
        | { readonly __typename?: 'BonusResponse', readonly value:
            | (
              { readonly __typename?: 'AppreciationBonus' }
              & AdditionalCostDrawerBonusAppreciationBonusFragment
            )
            | (
              { readonly __typename?: 'BusinessTravelBonus' }
              & AdditionalCostDrawerBonusBusinessTravelBonusFragment
            )
            | (
              { readonly __typename?: 'ClientReferralBonus' }
              & AdditionalCostDrawerBonusClientReferralBonusFragment
            )
            | (
              { readonly __typename?: 'ConferenceBonus' }
              & AdditionalCostDrawerBonusConferenceBonusFragment
            )
            | (
              { readonly __typename?: 'CostRechargeBonus' }
              & AdditionalCostDrawerBonusCostRechargeBonusFragment
            )
            | (
              { readonly __typename?: 'EmployeeReferralBonus' }
              & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
            )
            | (
              { readonly __typename?: 'LanguageLearningBonus' }
              & AdditionalCostDrawerBonusLanguageLearningBonusFragment
            )
            | (
              { readonly __typename?: 'OtherBonus' }
              & AdditionalCostDrawerBonusOtherBonusFragment
            )
            | (
              { readonly __typename?: 'RemoteWorkEquipmentBonus' }
              & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
            )
            | (
              { readonly __typename?: 'SalesCommissionsBonus' }
              & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
            )
            | (
              { readonly __typename?: 'SeverancePayBonus' }
              & AdditionalCostDrawerBonusSeverancePayBonusFragment
            )
            | (
              { readonly __typename?: 'ShareholderDividendBonus' }
              & AdditionalCostDrawerBonusShareholderDividendBonusFragment
            )
            | (
              { readonly __typename?: 'TrainingPackageBonus' }
              & AdditionalCostDrawerBonusTrainingPackageBonusFragment
            )
            | (
              { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
              & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
            )
           }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type AdminAdditonalCostDrawerApproveMultipleMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  entityVersion: Scalars['EntityVersion']['input'];
  ids: ReadonlyArray<Scalars['BonusId']['input']> | Scalars['BonusId']['input'];
}>;


export type AdminAdditonalCostDrawerApproveMultipleMutation = { readonly __typename?: 'Mutation', readonly contract: { readonly __typename?: 'ContractMutation', readonly approveBonuses:
      | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
          | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly entityVersion: number, readonly contract: { readonly __typename?: 'B2BContract', readonly id: string, readonly at?: Date | null, readonly bonuses:
                | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                      | (
                        { readonly __typename?: 'AppreciationBonus' }
                        & AdditionalCostDrawerBonusAppreciationBonusFragment
                      )
                      | (
                        { readonly __typename?: 'BusinessTravelBonus' }
                        & AdditionalCostDrawerBonusBusinessTravelBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ClientReferralBonus' }
                        & AdditionalCostDrawerBonusClientReferralBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ConferenceBonus' }
                        & AdditionalCostDrawerBonusConferenceBonusFragment
                      )
                      | (
                        { readonly __typename?: 'CostRechargeBonus' }
                        & AdditionalCostDrawerBonusCostRechargeBonusFragment
                      )
                      | (
                        { readonly __typename?: 'EmployeeReferralBonus' }
                        & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
                      )
                      | (
                        { readonly __typename?: 'LanguageLearningBonus' }
                        & AdditionalCostDrawerBonusLanguageLearningBonusFragment
                      )
                      | (
                        { readonly __typename?: 'OtherBonus' }
                        & AdditionalCostDrawerBonusOtherBonusFragment
                      )
                      | (
                        { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                        & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
                      )
                      | (
                        { readonly __typename?: 'SalesCommissionsBonus' }
                        & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
                      )
                      | (
                        { readonly __typename?: 'SeverancePayBonus' }
                        & AdditionalCostDrawerBonusSeverancePayBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ShareholderDividendBonus' }
                        & AdditionalCostDrawerBonusShareholderDividendBonusFragment
                      )
                      | (
                        { readonly __typename?: 'TrainingPackageBonus' }
                        & AdditionalCostDrawerBonusTrainingPackageBonusFragment
                      )
                      | (
                        { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                        & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
                      )
                    >, readonly future: ReadonlyArray<
                      | (
                        { readonly __typename?: 'AppreciationBonus' }
                        & AdditionalCostDrawerBonusAppreciationBonusFragment
                      )
                      | (
                        { readonly __typename?: 'BusinessTravelBonus' }
                        & AdditionalCostDrawerBonusBusinessTravelBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ClientReferralBonus' }
                        & AdditionalCostDrawerBonusClientReferralBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ConferenceBonus' }
                        & AdditionalCostDrawerBonusConferenceBonusFragment
                      )
                      | (
                        { readonly __typename?: 'CostRechargeBonus' }
                        & AdditionalCostDrawerBonusCostRechargeBonusFragment
                      )
                      | (
                        { readonly __typename?: 'EmployeeReferralBonus' }
                        & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
                      )
                      | (
                        { readonly __typename?: 'LanguageLearningBonus' }
                        & AdditionalCostDrawerBonusLanguageLearningBonusFragment
                      )
                      | (
                        { readonly __typename?: 'OtherBonus' }
                        & AdditionalCostDrawerBonusOtherBonusFragment
                      )
                      | (
                        { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                        & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
                      )
                      | (
                        { readonly __typename?: 'SalesCommissionsBonus' }
                        & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
                      )
                      | (
                        { readonly __typename?: 'SeverancePayBonus' }
                        & AdditionalCostDrawerBonusSeverancePayBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ShareholderDividendBonus' }
                        & AdditionalCostDrawerBonusShareholderDividendBonusFragment
                      )
                      | (
                        { readonly __typename?: 'TrainingPackageBonus' }
                        & AdditionalCostDrawerBonusTrainingPackageBonusFragment
                      )
                      | (
                        { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                        & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
                      )
                    > } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }, readonly salaryState:
              | (
                { readonly __typename?: 'IncompleteData' }
                & SalaryStateIncompleteDataFragment
              )
              | (
                { readonly __typename?: 'PaymentDisbursed' }
                & SalaryStatePaymentDisbursedFragment
              )
              | (
                { readonly __typename?: 'Ready' }
                & SalaryStateReadyFragment
              )
             }
          | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly entityVersion: number, readonly contract: { readonly __typename?: 'EmploymentContract', readonly id: string, readonly at?: Date | null, readonly bonuses:
                | { readonly __typename?: 'AccessGranted__Bonuses', readonly value: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
                      | (
                        { readonly __typename?: 'AppreciationBonus' }
                        & AdditionalCostDrawerBonusAppreciationBonusFragment
                      )
                      | (
                        { readonly __typename?: 'BusinessTravelBonus' }
                        & AdditionalCostDrawerBonusBusinessTravelBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ClientReferralBonus' }
                        & AdditionalCostDrawerBonusClientReferralBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ConferenceBonus' }
                        & AdditionalCostDrawerBonusConferenceBonusFragment
                      )
                      | (
                        { readonly __typename?: 'CostRechargeBonus' }
                        & AdditionalCostDrawerBonusCostRechargeBonusFragment
                      )
                      | (
                        { readonly __typename?: 'EmployeeReferralBonus' }
                        & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
                      )
                      | (
                        { readonly __typename?: 'LanguageLearningBonus' }
                        & AdditionalCostDrawerBonusLanguageLearningBonusFragment
                      )
                      | (
                        { readonly __typename?: 'OtherBonus' }
                        & AdditionalCostDrawerBonusOtherBonusFragment
                      )
                      | (
                        { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                        & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
                      )
                      | (
                        { readonly __typename?: 'SalesCommissionsBonus' }
                        & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
                      )
                      | (
                        { readonly __typename?: 'SeverancePayBonus' }
                        & AdditionalCostDrawerBonusSeverancePayBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ShareholderDividendBonus' }
                        & AdditionalCostDrawerBonusShareholderDividendBonusFragment
                      )
                      | (
                        { readonly __typename?: 'TrainingPackageBonus' }
                        & AdditionalCostDrawerBonusTrainingPackageBonusFragment
                      )
                      | (
                        { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                        & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
                      )
                    >, readonly future: ReadonlyArray<
                      | (
                        { readonly __typename?: 'AppreciationBonus' }
                        & AdditionalCostDrawerBonusAppreciationBonusFragment
                      )
                      | (
                        { readonly __typename?: 'BusinessTravelBonus' }
                        & AdditionalCostDrawerBonusBusinessTravelBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ClientReferralBonus' }
                        & AdditionalCostDrawerBonusClientReferralBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ConferenceBonus' }
                        & AdditionalCostDrawerBonusConferenceBonusFragment
                      )
                      | (
                        { readonly __typename?: 'CostRechargeBonus' }
                        & AdditionalCostDrawerBonusCostRechargeBonusFragment
                      )
                      | (
                        { readonly __typename?: 'EmployeeReferralBonus' }
                        & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
                      )
                      | (
                        { readonly __typename?: 'LanguageLearningBonus' }
                        & AdditionalCostDrawerBonusLanguageLearningBonusFragment
                      )
                      | (
                        { readonly __typename?: 'OtherBonus' }
                        & AdditionalCostDrawerBonusOtherBonusFragment
                      )
                      | (
                        { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                        & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
                      )
                      | (
                        { readonly __typename?: 'SalesCommissionsBonus' }
                        & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
                      )
                      | (
                        { readonly __typename?: 'SeverancePayBonus' }
                        & AdditionalCostDrawerBonusSeverancePayBonusFragment
                      )
                      | (
                        { readonly __typename?: 'ShareholderDividendBonus' }
                        & AdditionalCostDrawerBonusShareholderDividendBonusFragment
                      )
                      | (
                        { readonly __typename?: 'TrainingPackageBonus' }
                        & AdditionalCostDrawerBonusTrainingPackageBonusFragment
                      )
                      | (
                        { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                        & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
                      )
                    > } }
                | (
                  { readonly __typename?: 'Unauthorized' }
                  & UnauthorizedFragment
                )
               }, readonly salaryState:
              | (
                { readonly __typename?: 'IncompleteData' }
                & SalaryStateIncompleteDataFragment
              )
              | (
                { readonly __typename?: 'PaymentDisbursed' }
                & SalaryStatePaymentDisbursedFragment
              )
              | (
                { readonly __typename?: 'Ready' }
                & SalaryStateReadyFragment
              )
             }
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type AdditionalCostDrawerBonusAppreciationBonusFragment = { readonly __typename?: 'AppreciationBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusBusinessTravelBonusFragment = { readonly __typename?: 'BusinessTravelBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusClientReferralBonusFragment = { readonly __typename?: 'ClientReferralBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusConferenceBonusFragment = { readonly __typename?: 'ConferenceBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusCostRechargeBonusFragment = { readonly __typename?: 'CostRechargeBonus', readonly description: string, readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusEmployeeReferralBonusFragment = { readonly __typename?: 'EmployeeReferralBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusLanguageLearningBonusFragment = { readonly __typename?: 'LanguageLearningBonus', readonly language: Language, readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly quarterYear: { readonly __typename?: 'QuarterYear', readonly quarter: Quarter, readonly year: number }, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusOtherBonusFragment = { readonly __typename?: 'OtherBonus', readonly description: string, readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment = { readonly __typename?: 'RemoteWorkEquipmentBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusSalesCommissionsBonusFragment = { readonly __typename?: 'SalesCommissionsBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusSeverancePayBonusFragment = { readonly __typename?: 'SeverancePayBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusShareholderDividendBonusFragment = { readonly __typename?: 'ShareholderDividendBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusTrainingPackageBonusFragment = { readonly __typename?: 'TrainingPackageBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment = { readonly __typename?: 'TrainingPackageExternalDeductionValue', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusFragment =
  | AdditionalCostDrawerBonusAppreciationBonusFragment
  | AdditionalCostDrawerBonusBusinessTravelBonusFragment
  | AdditionalCostDrawerBonusClientReferralBonusFragment
  | AdditionalCostDrawerBonusConferenceBonusFragment
  | AdditionalCostDrawerBonusCostRechargeBonusFragment
  | AdditionalCostDrawerBonusEmployeeReferralBonusFragment
  | AdditionalCostDrawerBonusLanguageLearningBonusFragment
  | AdditionalCostDrawerBonusOtherBonusFragment
  | AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
  | AdditionalCostDrawerBonusSalesCommissionsBonusFragment
  | AdditionalCostDrawerBonusSeverancePayBonusFragment
  | AdditionalCostDrawerBonusShareholderDividendBonusFragment
  | AdditionalCostDrawerBonusTrainingPackageBonusFragment
  | AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
;

export type AdminBenefitSectionsBenefitVariantFragment = { readonly __typename?: 'BenefitVariant', readonly id: string, readonly entityVersion: number, readonly productId: string, readonly startDate: Date, readonly endDate?: Date | null, readonly buyerType: BenefitBuyerType, readonly description?: string | null, readonly contractTypes: ReadonlyArray<ContractType>, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly parent:
    | { readonly __typename?: 'Benefit', readonly id: string, readonly entityVersion: number, readonly name: string, readonly alternativeBenefitsGroupId: string, readonly benefitParent: BenefitGroupType }
    | { readonly __typename?: 'SubBenefit', readonly id: string, readonly entityVersion: number, readonly name: string, readonly alternativeBenefitsGroupId: string }
  , readonly additionalPeople?:
    | (
      { readonly __typename?: 'BenefitAdditionalAdults' }
      & BenefitAdditionalPeopleBenefitAdditionalAdultsFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalFamily' }
      & BenefitAdditionalPeopleBenefitAdditionalFamilyFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalKids' }
      & BenefitAdditionalPeopleBenefitAdditionalKidsFragment
    )
   | null };

export type AdminBenefitSectionsAssignedBenefitVariantsQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type AdminBenefitSectionsAssignedBenefitVariantsQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly conclusionDate:
            | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly note?: string | null, readonly buyerType: { readonly __typename?: 'TimeBasedBenefitBuyerType', readonly value: BenefitBuyerType, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly applyDate: Date, readonly activityId: string, readonly value: BenefitBuyerType }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly applyDate: Date }> }, readonly invoiceTo: { readonly __typename?: 'TimeBasedOptClearableExternalBeneficiary', readonly value?: (
                    { readonly __typename?: 'ExternalBeneficiary' }
                    & ExternalBeneficiaryFragment
                  ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
                        { readonly __typename?: 'ExternalBeneficiary' }
                        & ExternalBeneficiaryFragment
                      ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
                        { readonly __typename?: 'ExternalBeneficiary' }
                        & ExternalBeneficiaryFragment
                      ) | null } }> }, readonly externalBeneficiaries: { readonly __typename?: 'TimeBasedListOfExternalBeneficiary', readonly value: ReadonlyArray<(
                    { readonly __typename?: 'ExternalBeneficiary' }
                    & ExternalBeneficiaryFragment
                  )>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: ReadonlyArray<(
                      { readonly __typename?: 'ExternalBeneficiary' }
                      & ExternalBeneficiaryFragment
                    )> }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: ReadonlyArray<(
                      { readonly __typename?: 'ExternalBeneficiary' }
                      & ExternalBeneficiaryFragment
                    )> }> }, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly activityId: string, readonly value: boolean }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly activityId: string, readonly value: boolean }> }, readonly variant: { readonly __typename?: 'TimeBasedBenefitVariant', readonly value: (
                    { readonly __typename?: 'BenefitVariant' }
                    & AdminBenefitSectionsBenefitVariantFragment
                  ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly applyDate: Date, readonly activityId: string, readonly value: (
                      { readonly __typename?: 'BenefitVariant' }
                      & AdminBenefitSectionsBenefitVariantFragment
                    ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly applyDate: Date, readonly activityId: string, readonly value: (
                      { readonly __typename?: 'BenefitVariant' }
                      & AdminBenefitSectionsBenefitVariantFragment
                    ) }> } }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly conclusionDate:
            | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly note?: string | null, readonly buyerType: { readonly __typename?: 'TimeBasedBenefitBuyerType', readonly value: BenefitBuyerType, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly applyDate: Date, readonly activityId: string, readonly value: BenefitBuyerType }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly applyDate: Date }> }, readonly invoiceTo: { readonly __typename?: 'TimeBasedOptClearableExternalBeneficiary', readonly value?: (
                    { readonly __typename?: 'ExternalBeneficiary' }
                    & ExternalBeneficiaryFragment
                  ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
                        { readonly __typename?: 'ExternalBeneficiary' }
                        & ExternalBeneficiaryFragment
                      ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
                        { readonly __typename?: 'ExternalBeneficiary' }
                        & ExternalBeneficiaryFragment
                      ) | null } }> }, readonly externalBeneficiaries: { readonly __typename?: 'TimeBasedListOfExternalBeneficiary', readonly value: ReadonlyArray<(
                    { readonly __typename?: 'ExternalBeneficiary' }
                    & ExternalBeneficiaryFragment
                  )>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: ReadonlyArray<(
                      { readonly __typename?: 'ExternalBeneficiary' }
                      & ExternalBeneficiaryFragment
                    )> }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: ReadonlyArray<(
                      { readonly __typename?: 'ExternalBeneficiary' }
                      & ExternalBeneficiaryFragment
                    )> }> }, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly activityId: string, readonly value: boolean }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly activityId: string, readonly value: boolean }> }, readonly variant: { readonly __typename?: 'TimeBasedBenefitVariant', readonly value: (
                    { readonly __typename?: 'BenefitVariant' }
                    & AdminBenefitSectionsBenefitVariantFragment
                  ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly applyDate: Date, readonly activityId: string, readonly value: (
                      { readonly __typename?: 'BenefitVariant' }
                      & AdminBenefitSectionsBenefitVariantFragment
                    ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly applyDate: Date, readonly activityId: string, readonly value: (
                      { readonly __typename?: 'BenefitVariant' }
                      & AdminBenefitSectionsBenefitVariantFragment
                    ) }> } }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number, readonly startDate: Date, readonly terminationDate?: Date | null, readonly conclusionDate:
            | { readonly __typename?: 'AccessGranted__LocalDate', readonly value: Date }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly assignedVariants:
            | { readonly __typename?: 'AccessGranted__ListOfAssignedVariant', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedVariant', readonly id: string, readonly note?: string | null, readonly buyerType: { readonly __typename?: 'TimeBasedBenefitBuyerType', readonly value: BenefitBuyerType, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly applyDate: Date, readonly activityId: string, readonly value: BenefitBuyerType }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly applyDate: Date }> }, readonly invoiceTo: { readonly __typename?: 'TimeBasedOptClearableExternalBeneficiary', readonly value?: (
                    { readonly __typename?: 'ExternalBeneficiary' }
                    & ExternalBeneficiaryFragment
                  ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
                        { readonly __typename?: 'ExternalBeneficiary' }
                        & ExternalBeneficiaryFragment
                      ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
                        { readonly __typename?: 'ExternalBeneficiary' }
                        & ExternalBeneficiaryFragment
                      ) | null } }> }, readonly externalBeneficiaries: { readonly __typename?: 'TimeBasedListOfExternalBeneficiary', readonly value: ReadonlyArray<(
                    { readonly __typename?: 'ExternalBeneficiary' }
                    & ExternalBeneficiaryFragment
                  )>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: ReadonlyArray<(
                      { readonly __typename?: 'ExternalBeneficiary' }
                      & ExternalBeneficiaryFragment
                    )> }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: ReadonlyArray<(
                      { readonly __typename?: 'ExternalBeneficiary' }
                      & ExternalBeneficiaryFragment
                    )> }> }, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly activityId: string, readonly value: boolean }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly activityId: string, readonly value: boolean }> }, readonly variant: { readonly __typename?: 'TimeBasedBenefitVariant', readonly value: (
                    { readonly __typename?: 'BenefitVariant' }
                    & AdminBenefitSectionsBenefitVariantFragment
                  ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly applyDate: Date, readonly activityId: string, readonly value: (
                      { readonly __typename?: 'BenefitVariant' }
                      & AdminBenefitSectionsBenefitVariantFragment
                    ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly applyDate: Date, readonly activityId: string, readonly value: (
                      { readonly __typename?: 'BenefitVariant' }
                      & AdminBenefitSectionsBenefitVariantFragment
                    ) }> } }> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BenefitSectionsExternalBeneficiaryFragment = { readonly __typename?: 'ExternalBeneficiary', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly address: (
    { readonly __typename?: 'Address' }
    & AddressFragment
  ) };

export type CopyrightsDrawerWorkTransferFragment = { readonly __typename?: 'WorkTransferProtocol', readonly id: string, readonly description?: string | null, readonly createdBy: string, readonly createdAt: Date, readonly payload:
    | { readonly __typename?: 'File', readonly value: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly downloadUrl: string, readonly openUrl: string, readonly fileName: string } }
    | { readonly __typename?: 'NoWorkToBeTransferedThisMonth' }
  , readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
   };

export type AdminCopyrightsDrawerUpdateWorkTransferMutationVariables = Exact<{
  id: Scalars['WorkTransferProtocolId']['input'];
  description?: InputMaybe<ClearableStringInput>;
  payload?: InputMaybe<Scalars['Upload']['input']>;
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
  approved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminCopyrightsDrawerUpdateWorkTransferMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly update:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & CopyrightsDrawerWorkTransferFragment
        )
       } } };

export type AdminCopyrightsDrawerCreateWorkTransferMutationVariables = Exact<{
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
  id: Scalars['WorkTransferProtocolId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['Upload']['input'];
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
  approved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminCopyrightsDrawerCreateWorkTransferMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly create:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & CopyrightsDrawerWorkTransferFragment
        )
       } } };

export type AdminCopyrightsDrawerRemoveWorkTransferMutationVariables = Exact<{
  id: Scalars['WorkTransferProtocolId']['input'];
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type AdminCopyrightsDrawerRemoveWorkTransferMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly remove:
        | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type AdminCopyrightsDrawerMarkNoWorkMutationVariables = Exact<{
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type AdminCopyrightsDrawerMarkNoWorkMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly workTransferProtocol: { readonly __typename?: 'WorkTransferProtocolOperations', readonly markNoWorkToBeTransferedThisMonth:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & CopyrightsDrawerWorkTransferFragment
        )
       } } };

export type CopyrightsDrawerSalaryFragment = { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly workTransferProtocols: ReadonlyArray<(
    { readonly __typename?: 'WorkTransferProtocol' }
    & CopyrightsDrawerWorkTransferFragment
  )> };

export type CopyrightsDrawerCopyrightsQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
}>;


export type CopyrightsDrawerCopyrightsQuery = { readonly __typename?: 'Query', readonly contractSalaryDetailsInRange:
    | { readonly __typename?: 'ListOfContractSalaryDetailsResponse', readonly value: ReadonlyArray<
        | { readonly __typename?: 'B2BContractSalaryDetails' }
        | (
          { readonly __typename?: 'EmploymentContractSalaryDetails' }
          & CopyrightsDrawerSalaryFragment
        )
      > }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CopyrightTrButtonContractB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly entityVersion: number };

export type CopyrightTrButtonContractEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly id: string, readonly entityVersion: number, readonly copyrightCosts:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableBasisPoint', readonly value: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }> } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type CopyrightTrButtonContractSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string, readonly entityVersion: number };

export type CopyrightTrButtonContractFragment =
  | CopyrightTrButtonContractB2BContractFragment
  | CopyrightTrButtonContractEmploymentContractFragment
  | CopyrightTrButtonContractSubcontractFragment
;

export type CopyrightsTrButtonQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type CopyrightsTrButtonQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract' }
          & CopyrightTrButtonContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract' }
          & CopyrightTrButtonContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract' }
          & CopyrightTrButtonContractSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DirectReportingStructureUserFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly role: { readonly __typename?: 'TimeBasedCompanyRole', readonly value: CompanyRole } };

export type AdminDirectReportingStructureQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type AdminDirectReportingStructureQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User', readonly role: { readonly __typename?: 'TimeBasedCompanyRole', readonly value: CompanyRole, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCompanyRole', readonly activityId: string, readonly applyDate: Date, readonly value: CompanyRole }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCompanyRole', readonly activityId: string, readonly applyDate: Date, readonly value: CompanyRole }> }, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly primaryProjectId: { readonly __typename?: 'TimeBasedOptClearableProjectId', readonly value?: string | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProjectId', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableProjectId', readonly value?: string | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProjectId', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableProjectId', readonly value?: string | null } }> }, readonly assignedProjects:
          | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string, readonly lead?: { readonly __typename?: 'ProjectRoleAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectRoleAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly user: (
                      { readonly __typename?: 'User' }
                      & DirectReportingStructureUserFragment
                    ) }> } | null } }> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly activeProjects:
          | { readonly __typename?: 'AccessGranted__ListOfProjectAssignment', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly user: { readonly __typename?: 'User', readonly id: string }, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string } }> }
          | (
            { readonly __typename?: 'Unauthorized' }
            & UnauthorizedFragment
          )
        , readonly practiceLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: (
            { readonly __typename?: 'User' }
            & DirectReportingStructureUserFragment
          ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableUser', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableUser', readonly value?: (
                { readonly __typename?: 'User' }
                & DirectReportingStructureUserFragment
              ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableUser', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableUser', readonly value?: (
                { readonly __typename?: 'User' }
                & DirectReportingStructureUserFragment
              ) | null } }> }, readonly operationalLead: { readonly __typename?: 'TimeBasedOptClearableUser', readonly value?: (
            { readonly __typename?: 'User' }
            & DirectReportingStructureUserFragment
          ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableUser', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableUser', readonly value?: (
                { readonly __typename?: 'User' }
                & DirectReportingStructureUserFragment
              ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableUser', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableUser', readonly value?: (
                { readonly __typename?: 'User' }
                & DirectReportingStructureUserFragment
              ) | null } }> }, readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: (
              { readonly __typename?: 'User' }
              & DirectReportingStructureUserFragment
            ) }, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantSpace', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: (
                { readonly __typename?: 'User' }
                & DirectReportingStructureUserFragment
              ) } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantSpace', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: (
                { readonly __typename?: 'User' }
                & DirectReportingStructureUserFragment
              ) } }> } } }
      & DirectReportingStructureUserFragment
    )
   };

export type InvoicesDrawerSalaryStateIncompleteDataFragment = { readonly __typename: 'IncompleteData' };

export type InvoicesDrawerSalaryStatePaymentDisbursedFragment = { readonly __typename: 'PaymentDisbursed', readonly transferState:
    | { readonly __typename: 'TransferExecuted' }
    | { readonly __typename: 'TransferOrdered' }
   };

export type InvoicesDrawerSalaryStateReadyFragment = { readonly __typename: 'Ready' };

export type InvoicesDrawerSalaryStateFragment =
  | InvoicesDrawerSalaryStateIncompleteDataFragment
  | InvoicesDrawerSalaryStatePaymentDisbursedFragment
  | InvoicesDrawerSalaryStateReadyFragment
;

export type InvoicesDrawerInvoiceDetailsFragment = { readonly __typename?: 'InvoiceDetails', readonly id: string, readonly correct?: boolean | null, readonly number?: string | null, readonly userNote?: string | null, readonly adminNote?: string | null, readonly ksefNumber?: string | null, readonly saldeoDocumentUrl?: string | null, readonly currency?: string | null, readonly grossValue?: number | null, readonly file?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly downloadUrl: string, readonly openUrl: string, readonly fileName: string } | null };

export type AdminInvoicesDrawerUpdateInvoiceMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
  invoiceDetailsId: Scalars['InvoiceDetailsId']['input'];
  invoiceDetails: UpdateInvoiceDetailsInput;
}>;


export type AdminInvoicesDrawerUpdateInvoiceMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly invoiceDetails: { readonly __typename?: 'InvoiceDetailsOperations', readonly update:
        | (
          { readonly __typename?: 'InvoiceDetails' }
          & InvoicesDrawerInvoiceDetailsFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type AdminInvoicesDrawerCreateInvoiceMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
  invoiceDetails: CreateInvoiceDetailsInput;
}>;


export type AdminInvoicesDrawerCreateInvoiceMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly invoiceDetails: { readonly __typename?: 'InvoiceDetailsOperations', readonly create:
        | (
          { readonly __typename?: 'InvoiceDetails' }
          & InvoicesDrawerInvoiceDetailsFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type AdminInvoicesDrawerRemoveInvoiceMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
  invoiceDetailsId: Scalars['InvoiceDetailsId']['input'];
}>;


export type AdminInvoicesDrawerRemoveInvoiceMutation = { readonly __typename?: 'Mutation', readonly contractSalaryDetails: { readonly __typename?: 'ContractSalaryDetailsMutation', readonly invoiceDetails: { readonly __typename?: 'InvoiceDetailsOperations', readonly remove:
        | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type InvoicesDrawerSalaryFragment = { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
    | (
      { readonly __typename?: 'IncompleteData' }
      & InvoicesDrawerSalaryStateIncompleteDataFragment
    )
    | (
      { readonly __typename?: 'PaymentDisbursed' }
      & InvoicesDrawerSalaryStatePaymentDisbursedFragment
    )
    | (
      { readonly __typename?: 'Ready' }
      & InvoicesDrawerSalaryStateReadyFragment
    )
  , readonly invoiceDetails: ReadonlyArray<(
    { readonly __typename?: 'InvoiceDetails' }
    & InvoicesDrawerInvoiceDetailsFragment
  )> };

export type InvoicesDrawerInvoicesQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
}>;


export type InvoicesDrawerInvoicesQuery = { readonly __typename?: 'Query', readonly contractSalaryDetailsInRange:
    | { readonly __typename?: 'ListOfContractSalaryDetailsResponse', readonly value: ReadonlyArray<
        | (
          { readonly __typename?: 'B2BContractSalaryDetails' }
          & InvoicesDrawerSalaryFragment
        )
        | { readonly __typename?: 'EmploymentContractSalaryDetails' }
      > }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AdminProjectsColorsProviderAllProjectsQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type AdminProjectsColorsProviderAllProjectsQuery = { readonly __typename?: 'Query', readonly getUserProjects:
    | { readonly __typename?: 'ListOfProjectIdResponse', readonly value: ReadonlyArray<string> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AdminTimeReportBlockedMessageSpaceOwnerQueryVariables = Exact<{
  userId: Scalars['UserId']['input'];
}>;


export type AdminTimeReportBlockedMessageSpaceOwnerQuery = { readonly __typename?: 'Query', readonly user:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: { readonly __typename?: 'Space', readonly id: string, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly avatar?: string | null, readonly firstName: string, readonly lastName: string } } } } }
   };

export type TimeReportBulkEditToolbarDeleteSelectedMutationVariables = Exact<{
  workRecordIds: ReadonlyArray<Scalars['WorkRecordId']['input']> | Scalars['WorkRecordId']['input'];
  onCallRecordIds: ReadonlyArray<Scalars['OnCallRecordId']['input']> | Scalars['OnCallRecordId']['input'];
  absenceRecordIds: ReadonlyArray<Scalars['AbsenceRecordId']['input']> | Scalars['AbsenceRecordId']['input'];
}>;


export type TimeReportBulkEditToolbarDeleteSelectedMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly deleteTimeReports:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
     } };

export type AdminTimeReportDashboardProviderContractInfoQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type AdminTimeReportDashboardProviderContractInfoQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly name: string, readonly createdAt: Date, readonly status: ContractStatus, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly b2bContractType: B2BContractType, readonly enableTrainingPackage:
            | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly overtimeRate:
            | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: (
                { readonly __typename?: 'TimeBasedOptClearableNetGross' }
                & TimeReportDashBoardProviderOvertimeRateFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly onCall:
            | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableOnCallRate', readonly value: (
                { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
                & TimeReportDashBoardProviderOnCallFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly rate:
            | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
                { readonly __typename?: 'TimeBasedRate' }
                & TimeReportDashBoardProviderTimeBasedRateFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date, readonly dayType: CalendarDayType }> }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null } }
        | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly name: string, readonly createdAt: Date, readonly status: ContractStatus, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly enableTrainingPackage:
            | { readonly __typename?: 'AccessGranted__Boolean', readonly value: boolean }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly overtimeRate:
            | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: (
                { readonly __typename?: 'TimeBasedOptClearableNetGross' }
                & TimeReportDashBoardProviderOvertimeRateFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly onCall:
            | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableOnCallRate', readonly value: (
                { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
                & TimeReportDashBoardProviderOnCallFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly rate:
            | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: (
                { readonly __typename?: 'TimeBasedRate' }
                & TimeReportDashBoardProviderTimeBasedRateFragment
              ) }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly workingTime:
            | { readonly __typename?: 'AccessGranted__TimeBasedWorkingTime', readonly value: { readonly __typename?: 'TimeBasedWorkingTime', readonly value: (
                  { readonly __typename?: 'WorkingTime' }
                  & WorkingTimeFragment
                ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
                    { readonly __typename?: 'WorkingTime' }
                    & WorkingTimeFragment
                  ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
                    { readonly __typename?: 'WorkingTime' }
                    & WorkingTimeFragment
                  ) }> } }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
          , readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date, readonly dayType: CalendarDayType }> }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null } }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly name: string, readonly createdAt: Date, readonly status: ContractStatus, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date, readonly dayType: CalendarDayType }> }, readonly promisee: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly avatar?: string | null } }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AdminTimeReportDashboardProviderQueryVariables = Exact<{
  dashboardFrom: Scalars['LocalDate']['input'];
  dashboardTo: Scalars['LocalDate']['input'];
  projectsFrom: Scalars['OffsetDateTime']['input'];
  projectsTo: Scalars['OffsetDateTime']['input'];
  contractId: Scalars['ContractId']['input'];
}>;


export type AdminTimeReportDashboardProviderQuery = { readonly __typename?: 'Query', readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportStats?:
        | { readonly __typename?: 'B2BTimeReportStats' }
        | { readonly __typename?: 'EmploymentTimeReportStats', readonly flexTime?: { readonly __typename?: 'TimeBalance', readonly period: { readonly __typename?: 'ClosedEndMonthRange', readonly from: Date, readonly to: Date } } | null }
       | null, readonly timeReportRecords: { readonly __typename?: 'TimeReportRecords', readonly workTags: ReadonlyArray<(
          { readonly __typename?: 'WorkTag' }
          & WorkTagFragment
        )>, readonly work: ReadonlyArray<(
          { readonly __typename?: 'WorkRecord' }
          & WorkRecordFragment
        )>, readonly absence: ReadonlyArray<(
          { readonly __typename?: 'AbsenceRecord' }
          & AbsenceRecordFragment
        )>, readonly onCall: ReadonlyArray<(
          { readonly __typename?: 'OnCallRecord' }
          & OnCallRecordFragment
        )> } }
  , readonly assignedProjects:
    | { readonly __typename?: 'ListOfAssignedProjectResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedProject', readonly projectId: string, readonly projectName: string, readonly assignmentPeriods: ReadonlyArray<{ readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }>, readonly reportingPeriods: ReadonlyArray<{ readonly __typename?: 'ClosedEndLocalDateRange', readonly from: Date, readonly to: Date }> }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly absenceTypeDetails: ReadonlyArray<(
    { readonly __typename?: 'KVAbsenceTypeAbsenceTypeDetails' }
    & TimeReportDashBoardProviderAbsenceTypeDetailsFragment
  )> };

export type TimeReportDashBoardProviderTimeReportValidationsIncompleteEntriesFragment = { readonly __typename?: 'IncompleteEntries', readonly days: ReadonlyArray<Date> };

export type TimeReportDashBoardProviderTimeReportValidationsMissingEntriesFragment = { readonly __typename?: 'MissingEntries', readonly days: ReadonlyArray<Date> };

export type TimeReportDashBoardProviderTimeReportValidationsNegativeFlexTimeBalanceFragment = { readonly __typename?: 'NegativeFlexTimeBalance', readonly minutes: number };

export type TimeReportDashBoardProviderTimeReportValidationsFragment =
  | TimeReportDashBoardProviderTimeReportValidationsIncompleteEntriesFragment
  | TimeReportDashBoardProviderTimeReportValidationsMissingEntriesFragment
  | TimeReportDashBoardProviderTimeReportValidationsNegativeFlexTimeBalanceFragment
;

export type TimeReportDashBoardProviderAbsenceTypeDetailsFragment = { readonly __typename?: 'KVAbsenceTypeAbsenceTypeDetails', readonly key: AbsenceType, readonly value: { readonly __typename?: 'AbsenceTypeDetails', readonly canBeReportedOnHoliday: boolean, readonly applicableFor: ReadonlyArray<ContractType>, readonly canTakeCustomNumberOfHours: boolean, readonly limit?: number | null } };

export type TimeReportDashBoardProviderOnCallFragment = { readonly __typename?: 'TimeBasedOptClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly holiday: { readonly __typename?: 'NetGross', readonly net: number } } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly holiday: { readonly __typename?: 'NetGross', readonly net: number } } | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly holiday: { readonly __typename?: 'NetGross', readonly net: number } } | null } }> };

export type TimeReportDashBoardProviderOvertimeRateFragment = { readonly __typename?: 'TimeBasedOptClearableNetGross', readonly value?: { readonly __typename?: 'NetGross', readonly net: number } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: { readonly __typename?: 'NetGross', readonly net: number } | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: { readonly __typename?: 'NetGross', readonly net: number } | null } }> };

export type TimeReportDashBoardProviderTimeBasedRateFragment = { readonly __typename?: 'TimeBasedRate', readonly value: { readonly __typename?: 'Rate', readonly settlement: Settlement }, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly applyDate: Date, readonly value: { readonly __typename?: 'Rate', readonly settlement: Settlement } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly applyDate: Date, readonly value: { readonly __typename?: 'Rate', readonly settlement: Settlement } }> };

export type TimeReportDashboardProviderValidationsQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  date: Scalars['YearMonth']['input'];
}>;


export type TimeReportDashboardProviderValidationsQuery = { readonly __typename?: 'Query', readonly timeReportValidations:
    | { readonly __typename?: 'ListOfTimeReportValidationResponse', readonly value: ReadonlyArray<
        | (
          { readonly __typename?: 'IncompleteEntries' }
          & TimeReportDashBoardProviderTimeReportValidationsIncompleteEntriesFragment
        )
        | (
          { readonly __typename?: 'MissingEntries' }
          & TimeReportDashBoardProviderTimeReportValidationsMissingEntriesFragment
        )
        | (
          { readonly __typename?: 'NegativeFlexTimeBalance' }
          & TimeReportDashBoardProviderTimeReportValidationsNegativeFlexTimeBalanceFragment
        )
      > }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type AdminTimeReportEntryModalLimitsQueryVariables = Exact<{
  year: Scalars['Year']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  userId: Scalars['UserId']['input'];
  contractId: Scalars['ContractId']['input'];
  hasAnnualLeave: Scalars['Boolean']['input'];
}>;


export type AdminTimeReportEntryModalLimitsQuery = { readonly __typename?: 'Query', readonly remainingWorkTagReportingLimit:
    | { readonly __typename?: 'ListOfKVWorkTagIdMinutesResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'KVWorkTagIdMinutes', readonly key: string, readonly value?: number | null }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly paidLeaveBalanceYearlySummary?:
    | (
      { readonly __typename?: 'DaysBalance' }
      & LeaveBalanceFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   | null, readonly annualLeaveSummary?:
    | (
      { readonly __typename?: 'AnnualLeaveSummary' }
      & TimeReportEntryModalAnnualLeaveSummaryFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportStats?:
        | { readonly __typename?: 'B2BTimeReportStats' }
        | { readonly __typename?: 'EmploymentTimeReportStats', readonly reportedLeaveDays: (
            { readonly __typename?: 'ReportedLeaveDays' }
            & ReportedLeaveDaysFragment
          ) }
       | null }
   };

export type AdminTimeReportEntryModalCreateSingularAbsenceRecordMutationVariables = Exact<{
  absenceRecord: CreateAbsenceRecordInput;
  attachment: Scalars['Upload']['input'];
}>;


export type AdminTimeReportEntryModalCreateSingularAbsenceRecordMutation = { readonly __typename?: 'Mutation', readonly adminCreate: { readonly __typename?: 'ReportingApi', readonly absenceRecord: { readonly __typename?: 'AbsenceRecordApi', readonly create:
        | (
          { readonly __typename?: 'AbsenceRecord' }
          & AbsenceRecordFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type AdminTimeReportEntryModalUpdateAbsenceRecordMutationVariables = Exact<{
  id: Scalars['AbsenceRecordId']['input'];
  absenceType?: InputMaybe<AbsenceTypeInput>;
  dateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  dateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  comment?: InputMaybe<ClearableStringInput>;
  customDurationPerDay?: InputMaybe<ClearableMinutesInput>;
  isOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
  attachment?: InputMaybe<ClearableUploadInput>;
}>;


export type AdminTimeReportEntryModalUpdateAbsenceRecordMutation = { readonly __typename?: 'Mutation', readonly adminUpdate: { readonly __typename?: 'ReportingApi', readonly absenceRecord: { readonly __typename?: 'AbsenceRecordApi', readonly update:
        | (
          { readonly __typename?: 'AbsenceRecord' }
          & AbsenceRecordFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type AdminTimeReportEntryModalCreateAbsenceRecordMutationVariables = Exact<{
  absenceRecords: ReadonlyArray<CreateAbsenceRecordInput> | CreateAbsenceRecordInput;
}>;


export type AdminTimeReportEntryModalCreateAbsenceRecordMutation = { readonly __typename?: 'Mutation', readonly adminCreate: { readonly __typename?: 'ReportingApi', readonly absenceRecord: { readonly __typename?: 'AbsenceRecordApi', readonly createMany:
        | { readonly __typename?: 'ListOfAbsenceRecordResponse', readonly value: ReadonlyArray<(
            { readonly __typename?: 'AbsenceRecord' }
            & AbsenceRecordFragment
          )> }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type TimeReportEntryModalAnnualLeaveSummaryFragment = { readonly __typename?: 'AnnualLeaveSummary', readonly yearlySummary: ReadonlyArray<{ readonly __typename?: 'KVYearAnnualLeaveYearSummary', readonly key: number, readonly value: { readonly __typename?: 'AnnualLeaveYearSummary', readonly year: number, readonly totalBalance: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ), readonly onDemandBalance: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ) } }> };

export type TimeReportEntryModalCreateWorkRecordMutationVariables = Exact<{
  workRecords: ReadonlyArray<CreateWorkRecordInput> | CreateWorkRecordInput;
}>;


export type TimeReportEntryModalCreateWorkRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly workRecord: { readonly __typename?: 'WorkRecordApi', readonly createMany:
        | { readonly __typename?: 'ListOfWorkRecordResponse', readonly value: ReadonlyArray<(
            { readonly __typename?: 'WorkRecord' }
            & WorkRecordFragment
          )> }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type TimeReportEntryModalUpdateWorkRecordMutationVariables = Exact<{
  workRecordId: Scalars['WorkRecordId']['input'];
  projectId?: InputMaybe<ClearableProjectIdInput>;
  workTagId?: InputMaybe<Scalars['WorkTagId']['input']>;
  date: Scalars['LocalDate']['input'];
  duration?: InputMaybe<ClearableMinutesInput>;
  workTime?: InputMaybe<ClearableWorkTimeInput>;
  overtime: Scalars['Boolean']['input'];
  comment?: InputMaybe<ClearableStringInput>;
  remoteWork: Scalars['Boolean']['input'];
}>;


export type TimeReportEntryModalUpdateWorkRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly workRecord: { readonly __typename?: 'WorkRecordApi', readonly update:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkRecord' }
          & WorkRecordFragment
        )
       } } };

export type TimeReportEntryModalDeleteWorkRecordMutationVariables = Exact<{
  workRecordId: Scalars['WorkRecordId']['input'];
}>;


export type TimeReportEntryModalDeleteWorkRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly deleteTimeReports:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
     } };

export type TimeReportEntryModalCreateOnCallRecordMutationVariables = Exact<{
  onCallRecords: ReadonlyArray<CreateOnCallRecordInput> | CreateOnCallRecordInput;
}>;


export type TimeReportEntryModalCreateOnCallRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly oncallRecord: { readonly __typename?: 'OnCallRecordApi', readonly createMany:
        | { readonly __typename?: 'ListOfOnCallRecordResponse', readonly value: ReadonlyArray<(
            { readonly __typename?: 'OnCallRecord' }
            & OnCallRecordFragment
          )> }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type TimeReportEntryModalUpdateOnCallRecordMutationVariables = Exact<{
  onCallRecordId: Scalars['OnCallRecordId']['input'];
  projectId: Scalars['ProjectId']['input'];
  date: Scalars['LocalDate']['input'];
  dayShift: Scalars['Boolean']['input'];
  nightShift: Scalars['Boolean']['input'];
  comment?: InputMaybe<ClearableStringInput>;
}>;


export type TimeReportEntryModalUpdateOnCallRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly oncallRecord: { readonly __typename?: 'OnCallRecordApi', readonly update:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'OnCallRecord' }
          & OnCallRecordFragment
        )
       } } };

export type TimeReportEntryModalDeleteOnCallRecordMutationVariables = Exact<{
  onCallRecordId: Scalars['OnCallRecordId']['input'];
}>;


export type TimeReportEntryModalDeleteOnCallRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly deleteTimeReports:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
     } };

export type TimeReportEntryModalDeleteAbsenceRecordMutationVariables = Exact<{
  absenceRecordId: Scalars['AbsenceRecordId']['input'];
}>;


export type TimeReportEntryModalDeleteAbsenceRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'ReportingApi', readonly deleteTimeReports:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
     } };

export type TimeReportFinancesContractB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: { readonly __typename?: 'TimeBasedRate', readonly value: (
          { readonly __typename?: 'Rate' }
          & RateFragment
        ) } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly overtimeRate:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: { readonly __typename?: 'TimeBasedOptClearableNetGross', readonly value?: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ) | null } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type TimeReportFinancesContractEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly id: string, readonly currency:
    | { readonly __typename?: 'AccessGranted__TimeBasedCurrency', readonly value: { readonly __typename?: 'TimeBasedCurrency', readonly value: string } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly rate:
    | { readonly __typename?: 'AccessGranted__TimeBasedRate', readonly value: { readonly __typename?: 'TimeBasedRate', readonly value: (
          { readonly __typename?: 'Rate' }
          & RateFragment
        ) } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
  , readonly overtimeRate:
    | { readonly __typename?: 'AccessGranted__TimeBasedOptClearableNetGross', readonly value: { readonly __typename?: 'TimeBasedOptClearableNetGross', readonly value?: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ) | null } }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type TimeReportFinancesContractSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string };

export type TimeReportFinancesContractFragment =
  | TimeReportFinancesContractB2BContractFragment
  | TimeReportFinancesContractEmploymentContractFragment
  | TimeReportFinancesContractSubcontractFragment
;

export type AdminTimeReportFinancesQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  month: Scalars['YearMonth']['input'];
}>;


export type AdminTimeReportFinancesQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract' }
          & TimeReportFinancesContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract' }
          & TimeReportFinancesContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract' }
          & TimeReportFinancesContractSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly contractSalaryDetails:
    | (
      { readonly __typename?: 'ContractSalaryDetailsResponse' }
      & TimeReportFinancesSalaryDetailsFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportStats?:
        | { readonly __typename?: 'B2BTimeReportStats', readonly incomeDetails:
            | { readonly __typename?: 'AccessGranted__ListOfIncomeDetails', readonly value: ReadonlyArray<(
                { readonly __typename?: 'IncomeDetails' }
                & TimeReportFinancesIncomeDetailsFragment
              )> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
        | { readonly __typename?: 'EmploymentTimeReportStats', readonly incomeDetails:
            | { readonly __typename?: 'AccessGranted__ListOfIncomeDetails', readonly value: ReadonlyArray<(
                { readonly __typename?: 'IncomeDetails' }
                & TimeReportFinancesIncomeDetailsFragment
              )> }
            | (
              { readonly __typename?: 'Unauthorized' }
              & UnauthorizedFragment
            )
           }
       | null }
   };

export type TimeReportFinancesSalaryDetailsFragment = { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
    | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly transferAmount?: number | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null }
    | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly transferAmount?: number | null, readonly accountingData?: { readonly __typename?: 'AccountingData', readonly taxPrepayment: number, readonly zusContribution: number, readonly ppkAmount?: number | null } | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null }
   };

export type TimeReportFinancesBenefitValueFragment = { readonly __typename?: 'BenefitValue', readonly variant: { readonly __typename?: 'BenefitVariant', readonly id: string, readonly productId: string, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
        { readonly __typename?: 'BenefitVariantRate' }
        & BenefitVariantRateFragment
      ) | null }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
        { readonly __typename?: 'BenefitVariantRate' }
        & BenefitVariantRateFragment
      ) | null }, readonly parent:
      | { readonly __typename?: 'Benefit', readonly id: string, readonly name: string }
      | { readonly __typename?: 'SubBenefit', readonly id: string, readonly name: string }
     }, readonly refundedValue?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly notRefundedValue?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly totalValue: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type TimeReportFinancesIncomeDetailsFragment = { readonly __typename?: 'IncomeDetails', readonly from: Date, readonly to: Date, readonly totalWorkTime: number, readonly overtimeWorkTime: number, readonly standardWorkTime: number, readonly rateDetails?: (
    { readonly __typename?: 'RateDetails' }
    & RateDetailsFragment
  ) | null, readonly remoteWorkReimbursement?: { readonly __typename?: 'RemoteWorkReimbursement', readonly time: number, readonly rate: number, readonly totalValue: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) } | null, readonly totalPayout: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly payoutWithoutBenefits: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueStandardTimeIncome: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueOvertimeIncome: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly standardTimeIncome: ReadonlyArray<
    | (
      { readonly __typename?: 'DailyIncomeRow' }
      & IncomeRowDailyIncomeRowFragment
    )
    | (
      { readonly __typename?: 'HourlyIncomeRow' }
      & IncomeRowHourlyIncomeRowFragment
    )
    | (
      { readonly __typename?: 'MonthlyIncomeRow' }
      & IncomeRowMonthlyIncomeRowFragment
    )
  >, readonly overtimeIncome: ReadonlyArray<(
    { readonly __typename?: 'HourlyIncomeRow' }
    & HourlyIncomeRowFragment
  )>, readonly onCallLogs: ReadonlyArray<{ readonly __typename?: 'OnCallLog', readonly multiplier: OnCallMultiplier, readonly shifts: number, readonly dates: ReadonlyArray<Date>, readonly shift: Shift, readonly multiplierRate: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly totalValue: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) }>, readonly totalValueOnCalls: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly bonusesValueByCategory: ReadonlyArray<{ readonly __typename?: 'BonusCategoryAmount', readonly bonusCategory: BonusType, readonly amount: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) }>, readonly totalValueStandardTimeIncomeIncludingBenefits: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueOvertimeIncomeIncludingBenefits: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueBonuses: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly benefitsValue: { readonly __typename?: 'BenefitsValue', readonly totalValueRefunded: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly refunded: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & TimeReportFinancesBenefitValueFragment
    )>, readonly totalValueNotRefunded: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly notRefunded: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & TimeReportFinancesBenefitValueFragment
    )>, readonly totalValueThirdParty: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly thirdParty: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & TimeReportFinancesBenefitValueFragment
    )>, readonly totalValueAll: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly refundedHourlyRate: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) } };

export type AdminTimeReportLeaveAndTrainingQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  userId: Scalars['UserId']['input'];
  year: Scalars['Year']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
}>;


export type AdminTimeReportLeaveAndTrainingQuery = { readonly __typename?: 'Query', readonly annualLeaveSummary:
    | (
      { readonly __typename?: 'AnnualLeaveSummary' }
      & TimeReportLeaveAndTrainingAnnualLeaveSummaryFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly paidLeaveBalanceYearlySummary?:
    | (
      { readonly __typename?: 'DaysBalance' }
      & LeaveBalanceFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   | null, readonly remainingWorkTagReportingLimit:
    | { readonly __typename?: 'ListOfKVWorkTagIdMinutesResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'KVWorkTagIdMinutes', readonly key: string, readonly value?: number | null }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'TimeReport' }
      & TimeReportLeaveAndTrainingTimeReportFragment
    )
  , readonly trainingBudgetSummary:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'TrainingBudgetSummary' }
      & TimeReportLeaveAndTrainingTrainingPackageFragment
    )
   };

export type TimeReportLeaveAndTrainingStatsB2BTimeReportStatsFragment = { readonly __typename?: 'B2BTimeReportStats', readonly incomeDetails:
    | { readonly __typename?: 'AccessGranted__ListOfIncomeDetails', readonly value: ReadonlyArray<{ readonly __typename?: 'IncomeDetails', readonly from: Date, readonly to: Date, readonly bonusesValueByCategory: ReadonlyArray<{ readonly __typename?: 'BonusCategoryAmount', readonly bonusCategory: BonusType, readonly amount: { readonly __typename?: 'NetGross', readonly net: number, readonly gross: number } }> }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type TimeReportLeaveAndTrainingStatsEmploymentTimeReportStatsFragment = { readonly __typename?: 'EmploymentTimeReportStats', readonly incomeDetails:
    | { readonly __typename?: 'AccessGranted__ListOfIncomeDetails', readonly value: ReadonlyArray<{ readonly __typename?: 'IncomeDetails', readonly from: Date, readonly to: Date, readonly bonusesValueByCategory: ReadonlyArray<{ readonly __typename?: 'BonusCategoryAmount', readonly bonusCategory: BonusType, readonly amount: { readonly __typename?: 'NetGross', readonly net: number, readonly gross: number } }> }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type TimeReportLeaveAndTrainingStatsFragment =
  | TimeReportLeaveAndTrainingStatsB2BTimeReportStatsFragment
  | TimeReportLeaveAndTrainingStatsEmploymentTimeReportStatsFragment
;

export type TimeReportLeaveAndTrainingAnnualLeaveSummaryFragment = { readonly __typename?: 'AnnualLeaveSummary', readonly yearlySummary: ReadonlyArray<{ readonly __typename?: 'KVYearAnnualLeaveYearSummary', readonly key: number, readonly value: { readonly __typename?: 'AnnualLeaveYearSummary', readonly year: number, readonly totalBalance: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ), readonly balanceThisYear: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ), readonly carriedOverEntitlementBalance?: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ) | null, readonly onDemandBalance: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ) } }> };

export type TimeReportLeaveAndTrainingTrainingPackageFragment = { readonly __typename?: 'TrainingBudgetSummary', readonly currency: string, readonly yearlySummary: ReadonlyArray<{ readonly __typename?: 'KVYearTrainingBudgetYearSummary', readonly key: number, readonly value: { readonly __typename?: 'TrainingBudgetYearSummary', readonly year: number, readonly totalBalance: (
        { readonly __typename?: 'CentsBalance' }
        & CentsBalanceFragment
      ), readonly balanceThisYear: (
        { readonly __typename?: 'CentsBalance' }
        & CentsBalanceFragment
      ), readonly carriedOverEntitlementBalance?: (
        { readonly __typename?: 'CentsBalance' }
        & CentsBalanceFragment
      ) | null } }> };

export type TimeReportLeaveAndTrainingTimeReportFragment = { readonly __typename?: 'TimeReport', readonly timeReportStats?:
    | (
      { readonly __typename?: 'B2BTimeReportStats', readonly reportedDaysOff: number }
      & TimeReportLeaveAndTrainingStatsB2BTimeReportStatsFragment
    )
    | (
      { readonly __typename?: 'EmploymentTimeReportStats', readonly reportedLeaveDays: (
        { readonly __typename?: 'ReportedLeaveDays' }
        & ReportedLeaveDaysFragment
      ), readonly flexTime?: { readonly __typename?: 'TimeBalance', readonly balance: number, readonly absenceTime: number } | null }
      & TimeReportLeaveAndTrainingStatsEmploymentTimeReportStatsFragment
    )
   | null };

export type AdminTimeReportOnCallDetailsModalQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminTimeReportOnCallDetailsModalQuery = { readonly __typename?: 'Query', readonly onCallMultipliers:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OnCallMultipliers', readonly weekdays: { readonly __typename?: 'WeekdayDayAndNightMultipliers', readonly day: { readonly __typename?: 'WeekendMultipliers', readonly saturday: OnCallMultiplier, readonly sunday: OnCallMultiplier }, readonly night: { readonly __typename?: 'WeekdayMultipliers', readonly monday: OnCallMultiplier, readonly tuesday: OnCallMultiplier, readonly wednesday: OnCallMultiplier, readonly thursday: OnCallMultiplier, readonly friday: OnCallMultiplier, readonly saturday: OnCallMultiplier, readonly sunday: OnCallMultiplier } }, readonly holidays: { readonly __typename?: 'HolidayMultipliers', readonly beforeHolidayNight: OnCallMultiplier, readonly holidayDay: OnCallMultiplier, readonly holidayNight: OnCallMultiplier } }
   };

export type TimeReportStatsB2BStatsFragment = { readonly __typename?: 'B2BTimeReportStats', readonly reportedDaysOff: number, readonly overtime: number, readonly timeBalanceAtEndOfMonth: { readonly __typename?: 'TimeBalance', readonly reportedStandardWorkTime: number, readonly currentTimeRequirement: number, readonly balance: number, readonly currentTimeRequirementWithAbsenceTimeSubtracted: number, readonly totalTimeInPeriod: number }, readonly incomeDetails:
    | { readonly __typename?: 'AccessGranted__ListOfIncomeDetails', readonly value: ReadonlyArray<{ readonly __typename?: 'IncomeDetails', readonly onCallLogs: ReadonlyArray<{ readonly __typename?: 'OnCallLog', readonly shifts: number, readonly multiplier: OnCallMultiplier, readonly dates: ReadonlyArray<Date>, readonly shift: Shift, readonly multiplierRate: (
            { readonly __typename?: 'NetGross' }
            & NetGrossFragment
          ), readonly totalValue: (
            { readonly __typename?: 'NetGross' }
            & NetGrossFragment
          ) }> }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type TimeReportStatsEmploymentStatsFragment = { readonly __typename?: 'EmploymentTimeReportStats', readonly overtime: number, readonly timeBalanceAtEndOfMonth: { readonly __typename?: 'TimeBalance', readonly reportedStandardWorkTime: number, readonly currentTimeRequirement: number, readonly balance: number, readonly currentTimeRequirementWithAbsenceTimeSubtracted: number, readonly totalTimeInPeriod: number }, readonly reportedLeaveDays: (
    { readonly __typename?: 'ReportedLeaveDays' }
    & ReportedLeaveDaysFragment
  ), readonly flexTime?: { readonly __typename?: 'TimeBalance', readonly balance: number, readonly reportedStandardWorkTime: number, readonly currentTimeRequirement: number, readonly totalTimeInPeriod: number, readonly period: { readonly __typename?: 'ClosedEndMonthRange', readonly from: Date, readonly to: Date } } | null, readonly incomeDetails:
    | { readonly __typename?: 'AccessGranted__ListOfIncomeDetails', readonly value: ReadonlyArray<{ readonly __typename?: 'IncomeDetails', readonly onCallLogs: ReadonlyArray<{ readonly __typename?: 'OnCallLog', readonly shifts: number, readonly multiplier: OnCallMultiplier, readonly dates: ReadonlyArray<Date>, readonly shift: Shift, readonly multiplierRate: (
            { readonly __typename?: 'NetGross' }
            & NetGrossFragment
          ), readonly totalValue: (
            { readonly __typename?: 'NetGross' }
            & NetGrossFragment
          ) }> }> }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type AdminTimeReportStatsQueryVariables = Exact<{
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  year: Scalars['Year']['input'];
  contractId: Scalars['ContractId']['input'];
  hasAnnualLeave: Scalars['Boolean']['input'];
}>;


export type AdminTimeReportStatsQuery = { readonly __typename?: 'Query', readonly annualLeaveSummary?:
    | { readonly __typename?: 'AnnualLeaveSummary', readonly yearlySummary: ReadonlyArray<{ readonly __typename?: 'KVYearAnnualLeaveYearSummary', readonly key: number, readonly value: { readonly __typename?: 'AnnualLeaveYearSummary', readonly year: number, readonly totalBalance: (
            { readonly __typename?: 'AnnualLeaveBalance' }
            & AnnualLeaveBalanceFragment
          ) } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportStats?:
        | (
          { readonly __typename?: 'B2BTimeReportStats' }
          & TimeReportStatsB2BStatsFragment
        )
        | (
          { readonly __typename?: 'EmploymentTimeReportStats' }
          & TimeReportStatsEmploymentStatsFragment
        )
       | null }
   };

export type TimeReportWorkTimeInsightsQueryVariables = Exact<{
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  contractId: Scalars['ContractId']['input'];
}>;


export type TimeReportWorkTimeInsightsQuery = { readonly __typename?: 'Query', readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportRecords: { readonly __typename?: 'TimeReportRecords', readonly work: ReadonlyArray<{ readonly __typename?: 'WorkRecord', readonly id: string, readonly duration?: number | null, readonly remoteWork: boolean, readonly overtime: boolean, readonly workTag: { readonly __typename?: 'WorkTag', readonly id: string, readonly name: string }, readonly project?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null }>, readonly onCall: ReadonlyArray<{ readonly __typename?: 'OnCallRecord', readonly id: string }> }, readonly timeReportStats?:
        | (
          { readonly __typename?: 'B2BTimeReportStats', readonly currentTimeBalance: { readonly __typename?: 'TimeBalance', readonly currentTimeRequirement: number, readonly balance: number, readonly reportedStandardWorkTime: number, readonly absenceTime: number } }
          & TimeReportStatsB2BStatsFragment
        )
        | (
          { readonly __typename?: 'EmploymentTimeReportStats', readonly currentTimeBalance: { readonly __typename?: 'TimeBalance', readonly currentTimeRequirement: number, readonly balance: number, readonly reportedStandardWorkTime: number, readonly absenceTime: number } }
          & TimeReportStatsEmploymentStatsFragment
        )
       | null }
   };

export type BankAccountNumberIbanFragment = { readonly __typename?: 'Iban', readonly value: string };

export type BankAccountNumberOtherBankAccountNumberFragment = { readonly __typename?: 'OtherBankAccountNumber', readonly value: string };

export type BankAccountNumberFragment =
  | BankAccountNumberIbanFragment
  | BankAccountNumberOtherBankAccountNumberFragment
;

export type BankAccountVerificationStateFragment = { readonly __typename?: 'VerifiedBankAccountStatus', readonly result: BankAccountStatus, readonly when: Date };

export type BankAccountFragment = { readonly __typename?: 'BankAccount', readonly bic?: string | null, readonly currency?: string | null, readonly description?: string | null, readonly monitorTransfers: boolean, readonly accountNumber:
    | (
      { readonly __typename?: 'Iban' }
      & BankAccountNumberIbanFragment
    )
    | (
      { readonly __typename?: 'OtherBankAccountNumber' }
      & BankAccountNumberOtherBankAccountNumberFragment
    )
  , readonly verificationState:
    | { readonly __typename?: 'NotVerifiedBankAccountStatus' }
    | (
      { readonly __typename?: 'VerifiedBankAccountStatus' }
      & BankAccountVerificationStateFragment
    )
   };

export type UnauthorizedFragment = { readonly __typename?: 'Unauthorized', readonly reason: string };

export type ProjectRoleAssignmentFragment = { readonly __typename?: 'ProjectRoleAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number }, readonly periods: ReadonlyArray<{ readonly __typename?: 'ProjectRoleAssignmentPeriod', readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly email: string, readonly avatar?: string | null, readonly firstName: string, readonly lastName: string } }> };

export type CrossSellFragment = { readonly __typename?: 'CrossSell', readonly description: string, readonly client?: { readonly __typename?: 'Company', readonly id: string, readonly name: string } | null, readonly project?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly space?: { readonly __typename?: 'Space', readonly id: string, readonly name: string } | null };

export type ProjectLeadFragment = { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly lead?: (
    { readonly __typename?: 'ProjectRoleAssignment' }
    & ProjectRoleAssignmentFragment
  ) | null };

export type KeyPeopleProjectFragment = { readonly __typename?: 'Project', readonly id: string, readonly entityVersion: number, readonly statusHistory: ReadonlyArray<{ readonly __typename?: 'ProjectStatusHistoryEntry', readonly status: ProjectStatus, readonly dateRange: { readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null } }>, readonly lead?: (
    { readonly __typename?: 'ProjectRoleAssignment' }
    & ProjectRoleAssignmentFragment
  ) | null, readonly owner?: (
    { readonly __typename?: 'ProjectRoleAssignment' }
    & ProjectRoleAssignmentFragment
  ) | null, readonly accountManager?: (
    { readonly __typename?: 'ProjectRoleAssignment' }
    & ProjectRoleAssignmentFragment
  ) | null };

export type SalaryStateIncompleteDataFragment = { readonly __typename: 'IncompleteData', readonly description: ReadonlyArray<
    | (
      { readonly __typename?: 'AccountingDataMissing' }
      & IncompleteDataDescriptionAccountingDataMissingFragment
    )
    | (
      { readonly __typename?: 'BonusRequiresApproval' }
      & IncompleteDataDescriptionBonusRequiresApprovalFragment
    )
    | (
      { readonly __typename?: 'InvoiceFileMissing' }
      & IncompleteDataDescriptionInvoiceFileMissingFragment
    )
    | (
      { readonly __typename?: 'InvoiceMissing' }
      & IncompleteDataDescriptionInvoiceMissingFragment
    )
    | (
      { readonly __typename?: 'InvoiceUnchecked' }
      & IncompleteDataDescriptionInvoiceUncheckedFragment
    )
    | (
      { readonly __typename?: 'NoBankAccount' }
      & IncompleteDataDescriptionNoBankAccountFragment
    )
    | (
      { readonly __typename?: 'TimeReportIncomplete' }
      & IncompleteDataDescriptionTimeReportIncompleteFragment
    )
    | (
      { readonly __typename?: 'TimeReportRequiresApproval' }
      & IncompleteDataDescriptionTimeReportRequiresApprovalFragment
    )
    | (
      { readonly __typename?: 'WhiteListInvalid' }
      & IncompleteDataDescriptionWhiteListInvalidFragment
    )
  > };

export type SalaryStatePaymentDisbursedFragment = { readonly __typename: 'PaymentDisbursed', readonly disbursedAt: Date, readonly transferState:
    | { readonly __typename: 'TransferExecuted' }
    | { readonly __typename: 'TransferOrdered' }
   };

export type SalaryStateReadyFragment = { readonly __typename: 'Ready' };

export type SalaryStateFragment =
  | SalaryStateIncompleteDataFragment
  | SalaryStatePaymentDisbursedFragment
  | SalaryStateReadyFragment
;

export type TimeReportValidationIncompleteEntriesFragment = { readonly __typename?: 'IncompleteEntries', readonly days: ReadonlyArray<Date> };

export type TimeReportValidationMissingEntriesFragment = { readonly __typename?: 'MissingEntries', readonly days: ReadonlyArray<Date> };

export type TimeReportValidationNegativeFlexTimeBalanceFragment = { readonly __typename?: 'NegativeFlexTimeBalance' };

export type TimeReportValidationFragment =
  | TimeReportValidationIncompleteEntriesFragment
  | TimeReportValidationMissingEntriesFragment
  | TimeReportValidationNegativeFlexTimeBalanceFragment
;

export type CentsWithCurrencyFragment = { readonly __typename?: 'CentsWithCurrency', readonly amount: number, readonly currency: string };

export type IncompleteDataDescriptionAccountingDataMissingFragment = { readonly __typename: 'AccountingDataMissing' };

export type IncompleteDataDescriptionBonusRequiresApprovalFragment = { readonly __typename?: 'BonusRequiresApproval' };

export type IncompleteDataDescriptionInvoiceFileMissingFragment = { readonly __typename: 'InvoiceFileMissing' };

export type IncompleteDataDescriptionInvoiceMissingFragment = { readonly __typename: 'InvoiceMissing' };

export type IncompleteDataDescriptionInvoiceUncheckedFragment = { readonly __typename: 'InvoiceUnchecked' };

export type IncompleteDataDescriptionNoBankAccountFragment = { readonly __typename: 'NoBankAccount' };

export type IncompleteDataDescriptionTimeReportIncompleteFragment = { readonly __typename: 'TimeReportIncomplete' };

export type IncompleteDataDescriptionTimeReportRequiresApprovalFragment = { readonly __typename?: 'TimeReportRequiresApproval' };

export type IncompleteDataDescriptionWhiteListInvalidFragment = { readonly __typename: 'WhiteListInvalid' };

export type IncompleteDataDescriptionFragment =
  | IncompleteDataDescriptionAccountingDataMissingFragment
  | IncompleteDataDescriptionBonusRequiresApprovalFragment
  | IncompleteDataDescriptionInvoiceFileMissingFragment
  | IncompleteDataDescriptionInvoiceMissingFragment
  | IncompleteDataDescriptionInvoiceUncheckedFragment
  | IncompleteDataDescriptionNoBankAccountFragment
  | IncompleteDataDescriptionTimeReportIncompleteFragment
  | IncompleteDataDescriptionTimeReportRequiresApprovalFragment
  | IncompleteDataDescriptionWhiteListInvalidFragment
;

export type AbsenceRecordFragment = { readonly __typename?: 'AbsenceRecord', readonly id: string, readonly absenceType: AbsenceType, readonly from: Date, readonly to: Date, readonly comment?: string | null, readonly customDurationPerDay?: number | null, readonly isOnDemand?: boolean | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly attachment:
    | { readonly __typename?: 'AccessGranted__OptionalDownloadableExternallyHostedFileUrl', readonly value?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly openUrl: string, readonly downloadUrl: string, readonly fileName: string } | null }
    | (
      { readonly __typename?: 'Unauthorized' }
      & UnauthorizedFragment
    )
   };

export type NfsErrorFragment = { readonly __typename?: 'NfsError', readonly error:
    | { readonly __typename?: 'ActiveReportingRangeError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'AggregatedValidationErrors', readonly nfsErrorId: string, readonly msg: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly fields: ReadonlyArray<string>, readonly desc: string }> }
    | { readonly __typename?: 'DuplicatedEntityError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'EmptyRequestInputError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'EntitiesNotFoundError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'EntityNotFoundError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'EntityVersionMismatched', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'ForeignKeyConstraintError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'IllegalPositionRemovalError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'IncompleteArgumentError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'IncompleteArgumentsError', readonly missingFields: ReadonlyArray<string>, readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InternalNfsError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidApiTokenError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidArgumentsError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidCompanyTypeError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidContentTypeError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidCursorError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidEmailAddress', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidStateError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvoiceAlreadyAcceptedError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvoiceImportedFromSaldeoError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'LeaveEntitlementExceededError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'MissingFileMetadataError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'NBPBaseCurrencyError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'NoParkingSpotAvailableError', readonly dates: ReadonlyArray<Date>, readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'OperationAlreadyInProgressError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'OperationNotAvailableError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'OtherInvalidRequestError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'PaymentCouldNotBeChangedError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'PositionInactiveError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'RaiseNoLongerDueError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'ReservationNotPendingError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'ReservationRequestStateError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'ResourceAlreadyReservedError', readonly dates: ReadonlyArray<Date>, readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'TimeBasedActivityOverlapError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'TimeBasedEffectiveFromInPastError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'TimeReportOverlapError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'TimeReportRecordApprovalNotInPendingStateError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'UnauthorizedOperationError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'UnknownContentTypeError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'UserFacingAuthzError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'ValidationError', readonly fields: ReadonlyArray<string>, readonly nfsErrorId: string, readonly msg: string }
   };

export type ApprovalApprovedFragment = { readonly __typename?: 'Approved', readonly at: Date, readonly by: { readonly __typename?: 'Admin', readonly id: string, readonly firstName: string, readonly lastName: string } };

export type ApprovalNotRequiredFragment = { readonly __typename?: 'NotRequired' };

export type ApprovalPendingApprovalFragment = { readonly __typename?: 'PendingApproval', readonly isCurrentUserAllowedToApprove: boolean };

export type ApprovalFragment =
  | ApprovalApprovedFragment
  | ApprovalNotRequiredFragment
  | ApprovalPendingApprovalFragment
;

export type AddressFragment = { readonly __typename?: 'Address', readonly country: string, readonly region?: string | null, readonly city: string, readonly postalCode?: string | null, readonly streetLine: string };

export type ExternalBeneficiaryFragment = { readonly __typename?: 'ExternalBeneficiary', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly address: (
    { readonly __typename?: 'Address' }
    & AddressFragment
  ) };

export type WorkRecordFragment = { readonly __typename?: 'WorkRecord', readonly id: string, readonly date: Date, readonly duration?: number | null, readonly overtime: boolean, readonly draft: boolean, readonly comment?: string | null, readonly remoteWork: boolean, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly workTag: { readonly __typename?: 'WorkTag', readonly id: string, readonly name: string }, readonly workTime?: { readonly __typename?: 'WorkTime', readonly timeFrom: Date, readonly timeTo?: Date | null, readonly break?: number | null } | null, readonly project?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null };

export type OnCallRecordFragment = { readonly __typename?: 'OnCallRecord', readonly id: string, readonly date: Date, readonly dayShift: boolean, readonly nightShift: boolean, readonly comment?: string | null, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string } };

export type NetGrossFragment = { readonly __typename?: 'NetGross', readonly net: number, readonly gross: number };

export type RateFragment = { readonly __typename?: 'Rate', readonly settlement: Settlement, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ChildLevel3AddClientContractDrawerFragment = (
  { readonly __typename?: 'AddClientContractDrawer' }
  & AbstractDrawerAddClientContractDrawerFragment
);

export type ChildLevel3AddCompanyDrawerFragment = (
  { readonly __typename?: 'AddCompanyDrawer' }
  & AbstractDrawerAddCompanyDrawerFragment
);

export type ChildLevel3AddInternalProjectDrawerFragment = (
  { readonly __typename?: 'AddInternalProjectDrawer' }
  & AbstractDrawerAddInternalProjectDrawerFragment
);

export type ChildLevel3AddOfficeDrawerFragment = (
  { readonly __typename?: 'AddOfficeDrawer' }
  & AbstractDrawerAddOfficeDrawerFragment
);

export type ChildLevel3AddPersonDrawerFragment = (
  { readonly __typename?: 'AddPersonDrawer' }
  & AbstractDrawerAddPersonDrawerFragment
);

export type ChildLevel3AddProgressionSchemeDrawerFragment = (
  { readonly __typename?: 'AddProgressionSchemeDrawer' }
  & AbstractDrawerAddProgressionSchemeDrawerFragment
);

export type ChildLevel3AddProjectDrawerFragment = (
  { readonly __typename?: 'AddProjectDrawer' }
  & AbstractDrawerAddProjectDrawerFragment
);

export type ChildLevel3AddSpaceDrawerFragment = (
  { readonly __typename?: 'AddSpaceDrawer' }
  & AbstractDrawerAddSpaceDrawerFragment
);

export type ChildLevel3AddThirdPersonDrawerFragment = (
  { readonly __typename?: 'AddThirdPersonDrawer' }
  & AbstractDrawerAddThirdPersonDrawerFragment
);

export type ChildLevel3AdditionalCostsDrawerFragment = (
  { readonly __typename?: 'AdditionalCostsDrawer' }
  & AbstractDrawerAdditionalCostsDrawerFragment
);

export type ChildLevel3AllBonusesDrawerFragment = (
  { readonly __typename?: 'AllBonusesDrawer' }
  & AbstractDrawerAllBonusesDrawerFragment
);

export type ChildLevel3AnnualLeaveEntitlementDrawerFragment = (
  { readonly __typename?: 'AnnualLeaveEntitlementDrawer' }
  & AbstractDrawerAnnualLeaveEntitlementDrawerFragment
);

export type ChildLevel3AnnualLeavePreferencesDrawerFragment = (
  { readonly __typename?: 'AnnualLeavePreferencesDrawer' }
  & AbstractDrawerAnnualLeavePreferencesDrawerFragment
);

export type ChildLevel3AnnualLeaveSummaryDrawerFragment = (
  { readonly __typename?: 'AnnualLeaveSummaryDrawer' }
  & AbstractDrawerAnnualLeaveSummaryDrawerFragment
);

export type ChildLevel3AssignBenefitDrawerFragment = (
  { readonly __typename?: 'AssignBenefitDrawer' }
  & AbstractDrawerAssignBenefitDrawerFragment
);

export type ChildLevel3B2BContractDraftDrawerFragment = (
  { readonly __typename?: 'B2BContractDraftDrawer' }
  & AbstractDrawerB2BContractDraftDrawerFragment
);

export type ChildLevel3B2BContractNoteDrawerFragment = (
  { readonly __typename?: 'B2BContractNoteDrawer' }
  & AbstractDrawerB2BContractNoteDrawerFragment
);

export type ChildLevel3B2BSalaryDetailsDrawerFragment = (
  { readonly __typename?: 'B2BSalaryDetailsDrawer' }
  & AbstractDrawerB2BSalaryDetailsDrawerFragment
);

export type ChildLevel3BasicFinancialReportDrawerFragment = (
  { readonly __typename?: 'BasicFinancialReportDrawer' }
  & AbstractDrawerBasicFinancialReportDrawerFragment
);

export type ChildLevel3BenefitInvoicesReportDrawerFragment = (
  { readonly __typename?: 'BenefitInvoicesReportDrawer' }
  & AbstractDrawerBenefitInvoicesReportDrawerFragment
);

export type ChildLevel3BenefitNoteDrawerFragment = (
  { readonly __typename?: 'BenefitNoteDrawer' }
  & AbstractDrawerBenefitNoteDrawerFragment
);

export type ChildLevel3BonusDrawerFragment = (
  { readonly __typename?: 'BonusDrawer' }
  & AbstractDrawerBonusDrawerFragment
);

export type ChildLevel3BonusPreviewDrawerFragment = (
  { readonly __typename?: 'BonusPreviewDrawer' }
  & AbstractDrawerBonusPreviewDrawerFragment
);

export type ChildLevel3BookDeskOnBehalfDrawerFragment = (
  { readonly __typename?: 'BookDeskOnBehalfDrawer' }
  & AbstractDrawerBookDeskOnBehalfDrawerFragment
);

export type ChildLevel3BookParkingOnBehalfDrawerFragment = (
  { readonly __typename?: 'BookParkingOnBehalfDrawer' }
  & AbstractDrawerBookParkingOnBehalfDrawerFragment
);

export type ChildLevel3ClientInvoicingReportDrawerFragment = (
  { readonly __typename?: 'ClientInvoicingReportDrawer' }
  & AbstractDrawerClientInvoicingReportDrawerFragment
);

export type ChildLevel3CompanyBankAccountDrawerFragment = (
  { readonly __typename?: 'CompanyBankAccountDrawer' }
  & AbstractDrawerCompanyBankAccountDrawerFragment
);

export type ChildLevel3CompanyDetailsDrawerFragment = (
  { readonly __typename?: 'CompanyDetailsDrawer' }
  & AbstractDrawerCompanyDetailsDrawerFragment
);

export type ChildLevel3ContractBankAccountDrawerFragment = (
  { readonly __typename?: 'ContractBankAccountDrawer' }
  & AbstractDrawerContractBankAccountDrawerFragment
);

export type ChildLevel3ContractBonusesSettingsDrawerFragment = (
  { readonly __typename?: 'ContractBonusesSettingsDrawer' }
  & AbstractDrawerContractBonusesSettingsDrawerFragment
);

export type ChildLevel3ContractDetailsDrawerFragment = (
  { readonly __typename?: 'ContractDetailsDrawer' }
  & AbstractDrawerContractDetailsDrawerFragment
);

export type ChildLevel3CopyrightsDrawerFragment = (
  { readonly __typename?: 'CopyrightsDrawer' }
  & AbstractDrawerCopyrightsDrawerFragment
);

export type ChildLevel3CostAndRevenueItemDrawerFragment = (
  { readonly __typename?: 'CostAndRevenueItemDrawer' }
  & AbstractDrawerCostAndRevenueItemDrawerFragment
);

export type ChildLevel3CostSummariesDrawerFragment = (
  { readonly __typename?: 'CostSummariesDrawer' }
  & AbstractDrawerCostSummariesDrawerFragment
);

export type ChildLevel3CreateBenefitDrawerFragment = (
  { readonly __typename?: 'CreateBenefitDrawer' }
  & AbstractDrawerCreateBenefitDrawerFragment
);

export type ChildLevel3CreateVariantDrawerFragment = (
  { readonly __typename?: 'CreateVariantDrawer' }
  & AbstractDrawerCreateVariantDrawerFragment
);

export type ChildLevel3DeskAssignmentDrawerFragment = (
  { readonly __typename?: 'DeskAssignmentDrawer' }
  & AbstractDrawerDeskAssignmentDrawerFragment
);

export type ChildLevel3DeskDrawerFragment = (
  { readonly __typename?: 'DeskDrawer' }
  & AbstractDrawerDeskDrawerFragment
);

export type ChildLevel3DirectReportingDrawerFragment = (
  { readonly __typename?: 'DirectReportingDrawer' }
  & AbstractDrawerDirectReportingDrawerFragment
);

export type ChildLevel3EditBenefitDrawerFragment = (
  { readonly __typename?: 'EditBenefitDrawer' }
  & AbstractDrawerEditBenefitDrawerFragment
);

export type ChildLevel3EditBenefitVariantDrawerFragment = (
  { readonly __typename?: 'EditBenefitVariantDrawer' }
  & AbstractDrawerEditBenefitVariantDrawerFragment
);

export type ChildLevel3EditBenefitVariantPriceDrawerFragment = (
  { readonly __typename?: 'EditBenefitVariantPriceDrawer' }
  & AbstractDrawerEditBenefitVariantPriceDrawerFragment
);

export type ChildLevel3EditClientContractDrawerFragment = (
  { readonly __typename?: 'EditClientContractDrawer' }
  & AbstractDrawerEditClientContractDrawerFragment
);

export type ChildLevel3EditDeskRequestDrawerFragment = (
  { readonly __typename?: 'EditDeskRequestDrawer' }
  & AbstractDrawerEditDeskRequestDrawerFragment
);

export type ChildLevel3EditOfficeDrawerFragment = (
  { readonly __typename?: 'EditOfficeDrawer' }
  & AbstractDrawerEditOfficeDrawerFragment
);

export type ChildLevel3EditOfficeSettingsDrawerFragment = (
  { readonly __typename?: 'EditOfficeSettingsDrawer' }
  & AbstractDrawerEditOfficeSettingsDrawerFragment
);

export type ChildLevel3EditParkingRequestDrawerFragment = (
  { readonly __typename?: 'EditParkingRequestDrawer' }
  & AbstractDrawerEditParkingRequestDrawerFragment
);

export type ChildLevel3EditProfileAdditionalDataDrawerFragment = (
  { readonly __typename?: 'EditProfileAdditionalDataDrawer' }
  & AbstractDrawerEditProfileAdditionalDataDrawerFragment
);

export type ChildLevel3EditProfileAddressDrawerFragment = (
  { readonly __typename?: 'EditProfileAddressDrawer' }
  & AbstractDrawerEditProfileAddressDrawerFragment
);

export type ChildLevel3EditProfileBasicInfoDrawerFragment = (
  { readonly __typename?: 'EditProfileBasicInfoDrawer' }
  & AbstractDrawerEditProfileBasicInfoDrawerFragment
);

export type ChildLevel3EditProjectCrossSellDrawerFragment = (
  { readonly __typename?: 'EditProjectCrossSellDrawer' }
  & AbstractDrawerEditProjectCrossSellDrawerFragment
);

export type ChildLevel3EditProjectDrawerFragment = (
  { readonly __typename?: 'EditProjectDrawer' }
  & AbstractDrawerEditProjectDrawerFragment
);

export type ChildLevel3EditProjectTechStackAndCompetencesDrawerFragment = (
  { readonly __typename?: 'EditProjectTechStackAndCompetencesDrawer' }
  & AbstractDrawerEditProjectTechStackAndCompetencesDrawerFragment
);

export type ChildLevel3EditSkillsAndCertificatesDrawerFragment = (
  { readonly __typename?: 'EditSkillsAndCertificatesDrawer' }
  & AbstractDrawerEditSkillsAndCertificatesDrawerFragment
);

export type ChildLevel3EditSocialMediaHandlesDrawerFragment = (
  { readonly __typename?: 'EditSocialMediaHandlesDrawer' }
  & AbstractDrawerEditSocialMediaHandlesDrawerFragment
);

export type ChildLevel3EditSpaceDrawerFragment = (
  { readonly __typename?: 'EditSpaceDrawer' }
  & AbstractDrawerEditSpaceDrawerFragment
);

export type ChildLevel3EmployeeDueDatesDrawerFragment = (
  { readonly __typename?: 'EmployeeDueDatesDrawer' }
  & AbstractDrawerEmployeeDueDatesDrawerFragment
);

export type ChildLevel3EmploymentBankAccountDrawerFragment = (
  { readonly __typename?: 'EmploymentBankAccountDrawer' }
  & AbstractDrawerEmploymentBankAccountDrawerFragment
);

export type ChildLevel3EmploymentContractDraftDrawerFragment = (
  { readonly __typename?: 'EmploymentContractDraftDrawer' }
  & AbstractDrawerEmploymentContractDraftDrawerFragment
);

export type ChildLevel3EmploymentContractNoteDrawerFragment = (
  { readonly __typename?: 'EmploymentContractNoteDrawer' }
  & AbstractDrawerEmploymentContractNoteDrawerFragment
);

export type ChildLevel3EmploymentSalaryDetailsDrawerFragment = (
  { readonly __typename?: 'EmploymentSalaryDetailsDrawer' }
  & AbstractDrawerEmploymentSalaryDetailsDrawerFragment
);

export type ChildLevel3InvoiceTransferLinksDrawerFragment = (
  { readonly __typename?: 'InvoiceTransferLinksDrawer' }
  & AbstractDrawerInvoiceTransferLinksDrawerFragment
);

export type ChildLevel3InvoicesDrawerFragment = (
  { readonly __typename?: 'InvoicesDrawer' }
  & AbstractDrawerInvoicesDrawerFragment
);

export type ChildLevel3ListColumnControllsDrawerFragment = (
  { readonly __typename?: 'ListColumnControllsDrawer' }
  & AbstractDrawerListColumnControllsDrawerFragment
);

export type ChildLevel3ManageKeyPeopleDrawerFragment = (
  { readonly __typename?: 'ManageKeyPeopleDrawer' }
  & AbstractDrawerManageKeyPeopleDrawerFragment
);

export type ChildLevel3ManageProjectTimelineDrawerFragment = (
  { readonly __typename?: 'ManageProjectTimelineDrawer' }
  & AbstractDrawerManageProjectTimelineDrawerFragment
);

export type ChildLevel3OtherEmployeeInformationDrawerFragment = (
  { readonly __typename?: 'OtherEmployeeInformationDrawer' }
  & AbstractDrawerOtherEmployeeInformationDrawerFragment
);

export type ChildLevel3ParkingSpotDrawerFragment = (
  { readonly __typename?: 'ParkingSpotDrawer' }
  & AbstractDrawerParkingSpotDrawerFragment
);

export type ChildLevel3PaymentDetailsDraftDrawerFragment = (
  { readonly __typename?: 'PaymentDetailsDraftDrawer' }
  & AbstractDrawerPaymentDetailsDraftDrawerFragment
);

export type ChildLevel3PaymentDetailsDrawerFragment = (
  { readonly __typename?: 'PaymentDetailsDrawer' }
  & AbstractDrawerPaymentDetailsDrawerFragment
);

export type ChildLevel3PendingCopyrightsDrawerFragment = (
  { readonly __typename?: 'PendingCopyrightsDrawer' }
  & AbstractDrawerPendingCopyrightsDrawerFragment
);

export type ChildLevel3PeopleListReportDrawerFragment = (
  { readonly __typename?: 'PeopleListReportDrawer' }
  & AbstractDrawerPeopleListReportDrawerFragment
);

export type ChildLevel3ProgressionSchemeLevelDrawerFragment = (
  { readonly __typename?: 'ProgressionSchemeLevelDrawer' }
  & AbstractDrawerProgressionSchemeLevelDrawerFragment
);

export type ChildLevel3ProjectBillablesReportDrawerFragment = (
  { readonly __typename?: 'ProjectBillablesReportDrawer' }
  & AbstractDrawerProjectBillablesReportDrawerFragment
);

export type ChildLevel3ProjectMembersDrawerFragment = (
  { readonly __typename?: 'ProjectMembersDrawer' }
  & AbstractDrawerProjectMembersDrawerFragment
);

export type ChildLevel3RateCardDrawerFragment = (
  { readonly __typename?: 'RateCardDrawer' }
  & AbstractDrawerRateCardDrawerFragment
);

export type ChildLevel3RateChangesReportDrawerFragment = (
  { readonly __typename?: 'RateChangesReportDrawer' }
  & AbstractDrawerRateChangesReportDrawerFragment
);

export type ChildLevel3ReservationLimitsDrawerFragment = (
  { readonly __typename?: 'ReservationLimitsDrawer' }
  & AbstractDrawerReservationLimitsDrawerFragment
);

export type ChildLevel3RoomDrawerFragment = (
  { readonly __typename?: 'RoomDrawer' }
  & AbstractDrawerRoomDrawerFragment
);

export type ChildLevel3SalariesSummaryReportDrawerFragment = (
  { readonly __typename?: 'SalariesSummaryReportDrawer' }
  & AbstractDrawerSalariesSummaryReportDrawerFragment
);

export type ChildLevel3SetFutureEntitlementDrawerFragment = (
  { readonly __typename?: 'SetFutureEntitlementDrawer' }
  & AbstractDrawerSetFutureEntitlementDrawerFragment
);

export type ChildLevel3SetRateAndProgressionDrawerFragment = (
  { readonly __typename?: 'SetRateAndProgressionDrawer' }
  & AbstractDrawerSetRateAndProgressionDrawerFragment
);

export type ChildLevel3SkillsAndCertificatesReportDrawerFragment = (
  { readonly __typename?: 'SkillsAndCertificatesReportDrawer' }
  & AbstractDrawerSkillsAndCertificatesReportDrawerFragment
);

export type ChildLevel3SubcontractDraftDrawerFragment = (
  { readonly __typename?: 'SubcontractDraftDrawer' }
  & AbstractDrawerSubcontractDraftDrawerFragment
);

export type ChildLevel3SubcontractNoteDrawerFragment = (
  { readonly __typename?: 'SubcontractNoteDrawer' }
  & AbstractDrawerSubcontractNoteDrawerFragment
);

export type ChildLevel3TaxResidencyCertificatesDrawerFragment = (
  { readonly __typename?: 'TaxResidencyCertificatesDrawer' }
  & AbstractDrawerTaxResidencyCertificatesDrawerFragment
);

export type ChildLevel3TimeReportsReportDrawerFragment = (
  { readonly __typename?: 'TimeReportsReportDrawer' }
  & AbstractDrawerTimeReportsReportDrawerFragment
);

export type ChildLevel3TrainingPackageReportDrawerFragment = (
  { readonly __typename?: 'TrainingPackageReportDrawer' }
  & AbstractDrawerTrainingPackageReportDrawerFragment
);

export type ChildLevel3TransferDetailsDrawerFragment = (
  { readonly __typename?: 'TransferDetailsDrawer' }
  & AbstractDrawerTransferDetailsDrawerFragment
);

export type ChildLevel3TransferListExportDrawerFragment = (
  { readonly __typename?: 'TransferListExportDrawer' }
  & AbstractDrawerTransferListExportDrawerFragment
);

export type ChildLevel3UopHolidaysReportDrawerFragment = (
  { readonly __typename?: 'UopHolidaysReportDrawer' }
  & AbstractDrawerUopHolidaysReportDrawerFragment
);

export type ChildLevel3UploadDocumentDrawerFragment = (
  { readonly __typename?: 'UploadDocumentDrawer' }
  & AbstractDrawerUploadDocumentDrawerFragment
);

export type ChildLevel3UserProjectsDrawerFragment = (
  { readonly __typename?: 'UserProjectsDrawer' }
  & AbstractDrawerUserProjectsDrawerFragment
);

export type ChildLevel3YearlyCostSummaryDrawerFragment = (
  { readonly __typename?: 'YearlyCostSummaryDrawer' }
  & AbstractDrawerYearlyCostSummaryDrawerFragment
);

export type ChildLevel3Fragment =
  | ChildLevel3AddClientContractDrawerFragment
  | ChildLevel3AddCompanyDrawerFragment
  | ChildLevel3AddInternalProjectDrawerFragment
  | ChildLevel3AddOfficeDrawerFragment
  | ChildLevel3AddPersonDrawerFragment
  | ChildLevel3AddProgressionSchemeDrawerFragment
  | ChildLevel3AddProjectDrawerFragment
  | ChildLevel3AddSpaceDrawerFragment
  | ChildLevel3AddThirdPersonDrawerFragment
  | ChildLevel3AdditionalCostsDrawerFragment
  | ChildLevel3AllBonusesDrawerFragment
  | ChildLevel3AnnualLeaveEntitlementDrawerFragment
  | ChildLevel3AnnualLeavePreferencesDrawerFragment
  | ChildLevel3AnnualLeaveSummaryDrawerFragment
  | ChildLevel3AssignBenefitDrawerFragment
  | ChildLevel3B2BContractDraftDrawerFragment
  | ChildLevel3B2BContractNoteDrawerFragment
  | ChildLevel3B2BSalaryDetailsDrawerFragment
  | ChildLevel3BasicFinancialReportDrawerFragment
  | ChildLevel3BenefitInvoicesReportDrawerFragment
  | ChildLevel3BenefitNoteDrawerFragment
  | ChildLevel3BonusDrawerFragment
  | ChildLevel3BonusPreviewDrawerFragment
  | ChildLevel3BookDeskOnBehalfDrawerFragment
  | ChildLevel3BookParkingOnBehalfDrawerFragment
  | ChildLevel3ClientInvoicingReportDrawerFragment
  | ChildLevel3CompanyBankAccountDrawerFragment
  | ChildLevel3CompanyDetailsDrawerFragment
  | ChildLevel3ContractBankAccountDrawerFragment
  | ChildLevel3ContractBonusesSettingsDrawerFragment
  | ChildLevel3ContractDetailsDrawerFragment
  | ChildLevel3CopyrightsDrawerFragment
  | ChildLevel3CostAndRevenueItemDrawerFragment
  | ChildLevel3CostSummariesDrawerFragment
  | ChildLevel3CreateBenefitDrawerFragment
  | ChildLevel3CreateVariantDrawerFragment
  | ChildLevel3DeskAssignmentDrawerFragment
  | ChildLevel3DeskDrawerFragment
  | ChildLevel3DirectReportingDrawerFragment
  | ChildLevel3EditBenefitDrawerFragment
  | ChildLevel3EditBenefitVariantDrawerFragment
  | ChildLevel3EditBenefitVariantPriceDrawerFragment
  | ChildLevel3EditClientContractDrawerFragment
  | ChildLevel3EditDeskRequestDrawerFragment
  | ChildLevel3EditOfficeDrawerFragment
  | ChildLevel3EditOfficeSettingsDrawerFragment
  | ChildLevel3EditParkingRequestDrawerFragment
  | ChildLevel3EditProfileAdditionalDataDrawerFragment
  | ChildLevel3EditProfileAddressDrawerFragment
  | ChildLevel3EditProfileBasicInfoDrawerFragment
  | ChildLevel3EditProjectCrossSellDrawerFragment
  | ChildLevel3EditProjectDrawerFragment
  | ChildLevel3EditProjectTechStackAndCompetencesDrawerFragment
  | ChildLevel3EditSkillsAndCertificatesDrawerFragment
  | ChildLevel3EditSocialMediaHandlesDrawerFragment
  | ChildLevel3EditSpaceDrawerFragment
  | ChildLevel3EmployeeDueDatesDrawerFragment
  | ChildLevel3EmploymentBankAccountDrawerFragment
  | ChildLevel3EmploymentContractDraftDrawerFragment
  | ChildLevel3EmploymentContractNoteDrawerFragment
  | ChildLevel3EmploymentSalaryDetailsDrawerFragment
  | ChildLevel3InvoiceTransferLinksDrawerFragment
  | ChildLevel3InvoicesDrawerFragment
  | ChildLevel3ListColumnControllsDrawerFragment
  | ChildLevel3ManageKeyPeopleDrawerFragment
  | ChildLevel3ManageProjectTimelineDrawerFragment
  | ChildLevel3OtherEmployeeInformationDrawerFragment
  | ChildLevel3ParkingSpotDrawerFragment
  | ChildLevel3PaymentDetailsDraftDrawerFragment
  | ChildLevel3PaymentDetailsDrawerFragment
  | ChildLevel3PendingCopyrightsDrawerFragment
  | ChildLevel3PeopleListReportDrawerFragment
  | ChildLevel3ProgressionSchemeLevelDrawerFragment
  | ChildLevel3ProjectBillablesReportDrawerFragment
  | ChildLevel3ProjectMembersDrawerFragment
  | ChildLevel3RateCardDrawerFragment
  | ChildLevel3RateChangesReportDrawerFragment
  | ChildLevel3ReservationLimitsDrawerFragment
  | ChildLevel3RoomDrawerFragment
  | ChildLevel3SalariesSummaryReportDrawerFragment
  | ChildLevel3SetFutureEntitlementDrawerFragment
  | ChildLevel3SetRateAndProgressionDrawerFragment
  | ChildLevel3SkillsAndCertificatesReportDrawerFragment
  | ChildLevel3SubcontractDraftDrawerFragment
  | ChildLevel3SubcontractNoteDrawerFragment
  | ChildLevel3TaxResidencyCertificatesDrawerFragment
  | ChildLevel3TimeReportsReportDrawerFragment
  | ChildLevel3TrainingPackageReportDrawerFragment
  | ChildLevel3TransferDetailsDrawerFragment
  | ChildLevel3TransferListExportDrawerFragment
  | ChildLevel3UopHolidaysReportDrawerFragment
  | ChildLevel3UploadDocumentDrawerFragment
  | ChildLevel3UserProjectsDrawerFragment
  | ChildLevel3YearlyCostSummaryDrawerFragment
;

export type ChildLevel2AddClientContractDrawerFragment = (
  { readonly __typename?: 'AddClientContractDrawer', readonly child?: ChildLevel3Fragment | null }
  & AbstractDrawerAddClientContractDrawerFragment
);

export type ChildLevel2AddCompanyDrawerFragment = (
  { readonly __typename?: 'AddCompanyDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAddCompanyDrawerFragment
);

export type ChildLevel2AddInternalProjectDrawerFragment = (
  { readonly __typename?: 'AddInternalProjectDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAddInternalProjectDrawerFragment
);

export type ChildLevel2AddOfficeDrawerFragment = (
  { readonly __typename?: 'AddOfficeDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAddOfficeDrawerFragment
);

export type ChildLevel2AddPersonDrawerFragment = (
  { readonly __typename?: 'AddPersonDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAddPersonDrawerFragment
);

export type ChildLevel2AddProgressionSchemeDrawerFragment = (
  { readonly __typename?: 'AddProgressionSchemeDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAddProgressionSchemeDrawerFragment
);

export type ChildLevel2AddProjectDrawerFragment = (
  { readonly __typename?: 'AddProjectDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAddProjectDrawerFragment
);

export type ChildLevel2AddSpaceDrawerFragment = (
  { readonly __typename?: 'AddSpaceDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAddSpaceDrawerFragment
);

export type ChildLevel2AddThirdPersonDrawerFragment = (
  { readonly __typename?: 'AddThirdPersonDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAddThirdPersonDrawerFragment
);

export type ChildLevel2AdditionalCostsDrawerFragment = (
  { readonly __typename?: 'AdditionalCostsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAdditionalCostsDrawerFragment
);

export type ChildLevel2AllBonusesDrawerFragment = (
  { readonly __typename?: 'AllBonusesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAllBonusesDrawerFragment
);

export type ChildLevel2AnnualLeaveEntitlementDrawerFragment = (
  { readonly __typename?: 'AnnualLeaveEntitlementDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAnnualLeaveEntitlementDrawerFragment
);

export type ChildLevel2AnnualLeavePreferencesDrawerFragment = (
  { readonly __typename?: 'AnnualLeavePreferencesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAnnualLeavePreferencesDrawerFragment
);

export type ChildLevel2AnnualLeaveSummaryDrawerFragment = (
  { readonly __typename?: 'AnnualLeaveSummaryDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAnnualLeaveSummaryDrawerFragment
);

export type ChildLevel2AssignBenefitDrawerFragment = (
  { readonly __typename?: 'AssignBenefitDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAssignBenefitDrawerFragment
);

export type ChildLevel2B2BContractDraftDrawerFragment = (
  { readonly __typename?: 'B2BContractDraftDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerB2BContractDraftDrawerFragment
);

export type ChildLevel2B2BContractNoteDrawerFragment = (
  { readonly __typename?: 'B2BContractNoteDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerB2BContractNoteDrawerFragment
);

export type ChildLevel2B2BSalaryDetailsDrawerFragment = (
  { readonly __typename?: 'B2BSalaryDetailsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerB2BSalaryDetailsDrawerFragment
);

export type ChildLevel2BasicFinancialReportDrawerFragment = (
  { readonly __typename?: 'BasicFinancialReportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerBasicFinancialReportDrawerFragment
);

export type ChildLevel2BenefitInvoicesReportDrawerFragment = (
  { readonly __typename?: 'BenefitInvoicesReportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerBenefitInvoicesReportDrawerFragment
);

export type ChildLevel2BenefitNoteDrawerFragment = (
  { readonly __typename?: 'BenefitNoteDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerBenefitNoteDrawerFragment
);

export type ChildLevel2BonusDrawerFragment = (
  { readonly __typename?: 'BonusDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerBonusDrawerFragment
);

export type ChildLevel2BonusPreviewDrawerFragment = (
  { readonly __typename?: 'BonusPreviewDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerBonusPreviewDrawerFragment
);

export type ChildLevel2BookDeskOnBehalfDrawerFragment = (
  { readonly __typename?: 'BookDeskOnBehalfDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerBookDeskOnBehalfDrawerFragment
);

export type ChildLevel2BookParkingOnBehalfDrawerFragment = (
  { readonly __typename?: 'BookParkingOnBehalfDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerBookParkingOnBehalfDrawerFragment
);

export type ChildLevel2ClientInvoicingReportDrawerFragment = (
  { readonly __typename?: 'ClientInvoicingReportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerClientInvoicingReportDrawerFragment
);

export type ChildLevel2CompanyBankAccountDrawerFragment = (
  { readonly __typename?: 'CompanyBankAccountDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerCompanyBankAccountDrawerFragment
);

export type ChildLevel2CompanyDetailsDrawerFragment = (
  { readonly __typename?: 'CompanyDetailsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerCompanyDetailsDrawerFragment
);

export type ChildLevel2ContractBankAccountDrawerFragment = (
  { readonly __typename?: 'ContractBankAccountDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerContractBankAccountDrawerFragment
);

export type ChildLevel2ContractBonusesSettingsDrawerFragment = (
  { readonly __typename?: 'ContractBonusesSettingsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerContractBonusesSettingsDrawerFragment
);

export type ChildLevel2ContractDetailsDrawerFragment = (
  { readonly __typename?: 'ContractDetailsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerContractDetailsDrawerFragment
);

export type ChildLevel2CopyrightsDrawerFragment = (
  { readonly __typename?: 'CopyrightsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerCopyrightsDrawerFragment
);

export type ChildLevel2CostAndRevenueItemDrawerFragment = (
  { readonly __typename?: 'CostAndRevenueItemDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerCostAndRevenueItemDrawerFragment
);

export type ChildLevel2CostSummariesDrawerFragment = (
  { readonly __typename?: 'CostSummariesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerCostSummariesDrawerFragment
);

export type ChildLevel2CreateBenefitDrawerFragment = (
  { readonly __typename?: 'CreateBenefitDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerCreateBenefitDrawerFragment
);

export type ChildLevel2CreateVariantDrawerFragment = (
  { readonly __typename?: 'CreateVariantDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerCreateVariantDrawerFragment
);

export type ChildLevel2DeskAssignmentDrawerFragment = (
  { readonly __typename?: 'DeskAssignmentDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerDeskAssignmentDrawerFragment
);

export type ChildLevel2DeskDrawerFragment = (
  { readonly __typename?: 'DeskDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerDeskDrawerFragment
);

export type ChildLevel2DirectReportingDrawerFragment = (
  { readonly __typename?: 'DirectReportingDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerDirectReportingDrawerFragment
);

export type ChildLevel2EditBenefitDrawerFragment = (
  { readonly __typename?: 'EditBenefitDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditBenefitDrawerFragment
);

export type ChildLevel2EditBenefitVariantDrawerFragment = (
  { readonly __typename?: 'EditBenefitVariantDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditBenefitVariantDrawerFragment
);

export type ChildLevel2EditBenefitVariantPriceDrawerFragment = (
  { readonly __typename?: 'EditBenefitVariantPriceDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditBenefitVariantPriceDrawerFragment
);

export type ChildLevel2EditClientContractDrawerFragment = (
  { readonly __typename?: 'EditClientContractDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditClientContractDrawerFragment
);

export type ChildLevel2EditDeskRequestDrawerFragment = (
  { readonly __typename?: 'EditDeskRequestDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditDeskRequestDrawerFragment
);

export type ChildLevel2EditOfficeDrawerFragment = (
  { readonly __typename?: 'EditOfficeDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditOfficeDrawerFragment
);

export type ChildLevel2EditOfficeSettingsDrawerFragment = (
  { readonly __typename?: 'EditOfficeSettingsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditOfficeSettingsDrawerFragment
);

export type ChildLevel2EditParkingRequestDrawerFragment = (
  { readonly __typename?: 'EditParkingRequestDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditParkingRequestDrawerFragment
);

export type ChildLevel2EditProfileAdditionalDataDrawerFragment = (
  { readonly __typename?: 'EditProfileAdditionalDataDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditProfileAdditionalDataDrawerFragment
);

export type ChildLevel2EditProfileAddressDrawerFragment = (
  { readonly __typename?: 'EditProfileAddressDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditProfileAddressDrawerFragment
);

export type ChildLevel2EditProfileBasicInfoDrawerFragment = (
  { readonly __typename?: 'EditProfileBasicInfoDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditProfileBasicInfoDrawerFragment
);

export type ChildLevel2EditProjectCrossSellDrawerFragment = (
  { readonly __typename?: 'EditProjectCrossSellDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditProjectCrossSellDrawerFragment
);

export type ChildLevel2EditProjectDrawerFragment = (
  { readonly __typename?: 'EditProjectDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditProjectDrawerFragment
);

export type ChildLevel2EditProjectTechStackAndCompetencesDrawerFragment = (
  { readonly __typename?: 'EditProjectTechStackAndCompetencesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditProjectTechStackAndCompetencesDrawerFragment
);

export type ChildLevel2EditSkillsAndCertificatesDrawerFragment = (
  { readonly __typename?: 'EditSkillsAndCertificatesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditSkillsAndCertificatesDrawerFragment
);

export type ChildLevel2EditSocialMediaHandlesDrawerFragment = (
  { readonly __typename?: 'EditSocialMediaHandlesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditSocialMediaHandlesDrawerFragment
);

export type ChildLevel2EditSpaceDrawerFragment = (
  { readonly __typename?: 'EditSpaceDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditSpaceDrawerFragment
);

export type ChildLevel2EmployeeDueDatesDrawerFragment = (
  { readonly __typename?: 'EmployeeDueDatesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEmployeeDueDatesDrawerFragment
);

export type ChildLevel2EmploymentBankAccountDrawerFragment = (
  { readonly __typename?: 'EmploymentBankAccountDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEmploymentBankAccountDrawerFragment
);

export type ChildLevel2EmploymentContractDraftDrawerFragment = (
  { readonly __typename?: 'EmploymentContractDraftDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEmploymentContractDraftDrawerFragment
);

export type ChildLevel2EmploymentContractNoteDrawerFragment = (
  { readonly __typename?: 'EmploymentContractNoteDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEmploymentContractNoteDrawerFragment
);

export type ChildLevel2EmploymentSalaryDetailsDrawerFragment = (
  { readonly __typename?: 'EmploymentSalaryDetailsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEmploymentSalaryDetailsDrawerFragment
);

export type ChildLevel2InvoiceTransferLinksDrawerFragment = (
  { readonly __typename?: 'InvoiceTransferLinksDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerInvoiceTransferLinksDrawerFragment
);

export type ChildLevel2InvoicesDrawerFragment = (
  { readonly __typename?: 'InvoicesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerInvoicesDrawerFragment
);

export type ChildLevel2ListColumnControllsDrawerFragment = (
  { readonly __typename?: 'ListColumnControllsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerListColumnControllsDrawerFragment
);

export type ChildLevel2ManageKeyPeopleDrawerFragment = (
  { readonly __typename?: 'ManageKeyPeopleDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerManageKeyPeopleDrawerFragment
);

export type ChildLevel2ManageProjectTimelineDrawerFragment = (
  { readonly __typename?: 'ManageProjectTimelineDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerManageProjectTimelineDrawerFragment
);

export type ChildLevel2OtherEmployeeInformationDrawerFragment = (
  { readonly __typename?: 'OtherEmployeeInformationDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerOtherEmployeeInformationDrawerFragment
);

export type ChildLevel2ParkingSpotDrawerFragment = (
  { readonly __typename?: 'ParkingSpotDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerParkingSpotDrawerFragment
);

export type ChildLevel2PaymentDetailsDraftDrawerFragment = (
  { readonly __typename?: 'PaymentDetailsDraftDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerPaymentDetailsDraftDrawerFragment
);

export type ChildLevel2PaymentDetailsDrawerFragment = (
  { readonly __typename?: 'PaymentDetailsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerPaymentDetailsDrawerFragment
);

export type ChildLevel2PendingCopyrightsDrawerFragment = (
  { readonly __typename?: 'PendingCopyrightsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerPendingCopyrightsDrawerFragment
);

export type ChildLevel2PeopleListReportDrawerFragment = (
  { readonly __typename?: 'PeopleListReportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerPeopleListReportDrawerFragment
);

export type ChildLevel2ProgressionSchemeLevelDrawerFragment = (
  { readonly __typename?: 'ProgressionSchemeLevelDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerProgressionSchemeLevelDrawerFragment
);

export type ChildLevel2ProjectBillablesReportDrawerFragment = (
  { readonly __typename?: 'ProjectBillablesReportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerProjectBillablesReportDrawerFragment
);

export type ChildLevel2ProjectMembersDrawerFragment = (
  { readonly __typename?: 'ProjectMembersDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerProjectMembersDrawerFragment
);

export type ChildLevel2RateCardDrawerFragment = (
  { readonly __typename?: 'RateCardDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerRateCardDrawerFragment
);

export type ChildLevel2RateChangesReportDrawerFragment = (
  { readonly __typename?: 'RateChangesReportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerRateChangesReportDrawerFragment
);

export type ChildLevel2ReservationLimitsDrawerFragment = (
  { readonly __typename?: 'ReservationLimitsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerReservationLimitsDrawerFragment
);

export type ChildLevel2RoomDrawerFragment = (
  { readonly __typename?: 'RoomDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerRoomDrawerFragment
);

export type ChildLevel2SalariesSummaryReportDrawerFragment = (
  { readonly __typename?: 'SalariesSummaryReportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerSalariesSummaryReportDrawerFragment
);

export type ChildLevel2SetFutureEntitlementDrawerFragment = (
  { readonly __typename?: 'SetFutureEntitlementDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerSetFutureEntitlementDrawerFragment
);

export type ChildLevel2SetRateAndProgressionDrawerFragment = (
  { readonly __typename?: 'SetRateAndProgressionDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerSetRateAndProgressionDrawerFragment
);

export type ChildLevel2SkillsAndCertificatesReportDrawerFragment = (
  { readonly __typename?: 'SkillsAndCertificatesReportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerSkillsAndCertificatesReportDrawerFragment
);

export type ChildLevel2SubcontractDraftDrawerFragment = (
  { readonly __typename?: 'SubcontractDraftDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerSubcontractDraftDrawerFragment
);

export type ChildLevel2SubcontractNoteDrawerFragment = (
  { readonly __typename?: 'SubcontractNoteDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerSubcontractNoteDrawerFragment
);

export type ChildLevel2TaxResidencyCertificatesDrawerFragment = (
  { readonly __typename?: 'TaxResidencyCertificatesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerTaxResidencyCertificatesDrawerFragment
);

export type ChildLevel2TimeReportsReportDrawerFragment = (
  { readonly __typename?: 'TimeReportsReportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerTimeReportsReportDrawerFragment
);

export type ChildLevel2TrainingPackageReportDrawerFragment = (
  { readonly __typename?: 'TrainingPackageReportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerTrainingPackageReportDrawerFragment
);

export type ChildLevel2TransferDetailsDrawerFragment = (
  { readonly __typename?: 'TransferDetailsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerTransferDetailsDrawerFragment
);

export type ChildLevel2TransferListExportDrawerFragment = (
  { readonly __typename?: 'TransferListExportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerTransferListExportDrawerFragment
);

export type ChildLevel2UopHolidaysReportDrawerFragment = (
  { readonly __typename?: 'UopHolidaysReportDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerUopHolidaysReportDrawerFragment
);

export type ChildLevel2UploadDocumentDrawerFragment = (
  { readonly __typename?: 'UploadDocumentDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerUploadDocumentDrawerFragment
);

export type ChildLevel2UserProjectsDrawerFragment = (
  { readonly __typename?: 'UserProjectsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerUserProjectsDrawerFragment
);

export type ChildLevel2YearlyCostSummaryDrawerFragment = (
  { readonly __typename?: 'YearlyCostSummaryDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerYearlyCostSummaryDrawerFragment
);

export type ChildLevel2Fragment =
  | ChildLevel2AddClientContractDrawerFragment
  | ChildLevel2AddCompanyDrawerFragment
  | ChildLevel2AddInternalProjectDrawerFragment
  | ChildLevel2AddOfficeDrawerFragment
  | ChildLevel2AddPersonDrawerFragment
  | ChildLevel2AddProgressionSchemeDrawerFragment
  | ChildLevel2AddProjectDrawerFragment
  | ChildLevel2AddSpaceDrawerFragment
  | ChildLevel2AddThirdPersonDrawerFragment
  | ChildLevel2AdditionalCostsDrawerFragment
  | ChildLevel2AllBonusesDrawerFragment
  | ChildLevel2AnnualLeaveEntitlementDrawerFragment
  | ChildLevel2AnnualLeavePreferencesDrawerFragment
  | ChildLevel2AnnualLeaveSummaryDrawerFragment
  | ChildLevel2AssignBenefitDrawerFragment
  | ChildLevel2B2BContractDraftDrawerFragment
  | ChildLevel2B2BContractNoteDrawerFragment
  | ChildLevel2B2BSalaryDetailsDrawerFragment
  | ChildLevel2BasicFinancialReportDrawerFragment
  | ChildLevel2BenefitInvoicesReportDrawerFragment
  | ChildLevel2BenefitNoteDrawerFragment
  | ChildLevel2BonusDrawerFragment
  | ChildLevel2BonusPreviewDrawerFragment
  | ChildLevel2BookDeskOnBehalfDrawerFragment
  | ChildLevel2BookParkingOnBehalfDrawerFragment
  | ChildLevel2ClientInvoicingReportDrawerFragment
  | ChildLevel2CompanyBankAccountDrawerFragment
  | ChildLevel2CompanyDetailsDrawerFragment
  | ChildLevel2ContractBankAccountDrawerFragment
  | ChildLevel2ContractBonusesSettingsDrawerFragment
  | ChildLevel2ContractDetailsDrawerFragment
  | ChildLevel2CopyrightsDrawerFragment
  | ChildLevel2CostAndRevenueItemDrawerFragment
  | ChildLevel2CostSummariesDrawerFragment
  | ChildLevel2CreateBenefitDrawerFragment
  | ChildLevel2CreateVariantDrawerFragment
  | ChildLevel2DeskAssignmentDrawerFragment
  | ChildLevel2DeskDrawerFragment
  | ChildLevel2DirectReportingDrawerFragment
  | ChildLevel2EditBenefitDrawerFragment
  | ChildLevel2EditBenefitVariantDrawerFragment
  | ChildLevel2EditBenefitVariantPriceDrawerFragment
  | ChildLevel2EditClientContractDrawerFragment
  | ChildLevel2EditDeskRequestDrawerFragment
  | ChildLevel2EditOfficeDrawerFragment
  | ChildLevel2EditOfficeSettingsDrawerFragment
  | ChildLevel2EditParkingRequestDrawerFragment
  | ChildLevel2EditProfileAdditionalDataDrawerFragment
  | ChildLevel2EditProfileAddressDrawerFragment
  | ChildLevel2EditProfileBasicInfoDrawerFragment
  | ChildLevel2EditProjectCrossSellDrawerFragment
  | ChildLevel2EditProjectDrawerFragment
  | ChildLevel2EditProjectTechStackAndCompetencesDrawerFragment
  | ChildLevel2EditSkillsAndCertificatesDrawerFragment
  | ChildLevel2EditSocialMediaHandlesDrawerFragment
  | ChildLevel2EditSpaceDrawerFragment
  | ChildLevel2EmployeeDueDatesDrawerFragment
  | ChildLevel2EmploymentBankAccountDrawerFragment
  | ChildLevel2EmploymentContractDraftDrawerFragment
  | ChildLevel2EmploymentContractNoteDrawerFragment
  | ChildLevel2EmploymentSalaryDetailsDrawerFragment
  | ChildLevel2InvoiceTransferLinksDrawerFragment
  | ChildLevel2InvoicesDrawerFragment
  | ChildLevel2ListColumnControllsDrawerFragment
  | ChildLevel2ManageKeyPeopleDrawerFragment
  | ChildLevel2ManageProjectTimelineDrawerFragment
  | ChildLevel2OtherEmployeeInformationDrawerFragment
  | ChildLevel2ParkingSpotDrawerFragment
  | ChildLevel2PaymentDetailsDraftDrawerFragment
  | ChildLevel2PaymentDetailsDrawerFragment
  | ChildLevel2PendingCopyrightsDrawerFragment
  | ChildLevel2PeopleListReportDrawerFragment
  | ChildLevel2ProgressionSchemeLevelDrawerFragment
  | ChildLevel2ProjectBillablesReportDrawerFragment
  | ChildLevel2ProjectMembersDrawerFragment
  | ChildLevel2RateCardDrawerFragment
  | ChildLevel2RateChangesReportDrawerFragment
  | ChildLevel2ReservationLimitsDrawerFragment
  | ChildLevel2RoomDrawerFragment
  | ChildLevel2SalariesSummaryReportDrawerFragment
  | ChildLevel2SetFutureEntitlementDrawerFragment
  | ChildLevel2SetRateAndProgressionDrawerFragment
  | ChildLevel2SkillsAndCertificatesReportDrawerFragment
  | ChildLevel2SubcontractDraftDrawerFragment
  | ChildLevel2SubcontractNoteDrawerFragment
  | ChildLevel2TaxResidencyCertificatesDrawerFragment
  | ChildLevel2TimeReportsReportDrawerFragment
  | ChildLevel2TrainingPackageReportDrawerFragment
  | ChildLevel2TransferDetailsDrawerFragment
  | ChildLevel2TransferListExportDrawerFragment
  | ChildLevel2UopHolidaysReportDrawerFragment
  | ChildLevel2UploadDocumentDrawerFragment
  | ChildLevel2UserProjectsDrawerFragment
  | ChildLevel2YearlyCostSummaryDrawerFragment
;

export type ChildLevel1AddClientContractDrawerFragment = (
  { readonly __typename?: 'AddClientContractDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAddClientContractDrawerFragment
);

export type ChildLevel1AddCompanyDrawerFragment = (
  { readonly __typename?: 'AddCompanyDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAddCompanyDrawerFragment
);

export type ChildLevel1AddInternalProjectDrawerFragment = (
  { readonly __typename?: 'AddInternalProjectDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAddInternalProjectDrawerFragment
);

export type ChildLevel1AddOfficeDrawerFragment = (
  { readonly __typename?: 'AddOfficeDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAddOfficeDrawerFragment
);

export type ChildLevel1AddPersonDrawerFragment = (
  { readonly __typename?: 'AddPersonDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAddPersonDrawerFragment
);

export type ChildLevel1AddProgressionSchemeDrawerFragment = (
  { readonly __typename?: 'AddProgressionSchemeDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAddProgressionSchemeDrawerFragment
);

export type ChildLevel1AddProjectDrawerFragment = (
  { readonly __typename?: 'AddProjectDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAddProjectDrawerFragment
);

export type ChildLevel1AddSpaceDrawerFragment = (
  { readonly __typename?: 'AddSpaceDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAddSpaceDrawerFragment
);

export type ChildLevel1AddThirdPersonDrawerFragment = (
  { readonly __typename?: 'AddThirdPersonDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAddThirdPersonDrawerFragment
);

export type ChildLevel1AdditionalCostsDrawerFragment = (
  { readonly __typename?: 'AdditionalCostsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAdditionalCostsDrawerFragment
);

export type ChildLevel1AllBonusesDrawerFragment = (
  { readonly __typename?: 'AllBonusesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAllBonusesDrawerFragment
);

export type ChildLevel1AnnualLeaveEntitlementDrawerFragment = (
  { readonly __typename?: 'AnnualLeaveEntitlementDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAnnualLeaveEntitlementDrawerFragment
);

export type ChildLevel1AnnualLeavePreferencesDrawerFragment = (
  { readonly __typename?: 'AnnualLeavePreferencesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAnnualLeavePreferencesDrawerFragment
);

export type ChildLevel1AnnualLeaveSummaryDrawerFragment = (
  { readonly __typename?: 'AnnualLeaveSummaryDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAnnualLeaveSummaryDrawerFragment
);

export type ChildLevel1AssignBenefitDrawerFragment = (
  { readonly __typename?: 'AssignBenefitDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAssignBenefitDrawerFragment
);

export type ChildLevel1B2BContractDraftDrawerFragment = (
  { readonly __typename?: 'B2BContractDraftDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerB2BContractDraftDrawerFragment
);

export type ChildLevel1B2BContractNoteDrawerFragment = (
  { readonly __typename?: 'B2BContractNoteDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerB2BContractNoteDrawerFragment
);

export type ChildLevel1B2BSalaryDetailsDrawerFragment = (
  { readonly __typename?: 'B2BSalaryDetailsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerB2BSalaryDetailsDrawerFragment
);

export type ChildLevel1BasicFinancialReportDrawerFragment = (
  { readonly __typename?: 'BasicFinancialReportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerBasicFinancialReportDrawerFragment
);

export type ChildLevel1BenefitInvoicesReportDrawerFragment = (
  { readonly __typename?: 'BenefitInvoicesReportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerBenefitInvoicesReportDrawerFragment
);

export type ChildLevel1BenefitNoteDrawerFragment = (
  { readonly __typename?: 'BenefitNoteDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerBenefitNoteDrawerFragment
);

export type ChildLevel1BonusDrawerFragment = (
  { readonly __typename?: 'BonusDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerBonusDrawerFragment
);

export type ChildLevel1BonusPreviewDrawerFragment = (
  { readonly __typename?: 'BonusPreviewDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerBonusPreviewDrawerFragment
);

export type ChildLevel1BookDeskOnBehalfDrawerFragment = (
  { readonly __typename?: 'BookDeskOnBehalfDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerBookDeskOnBehalfDrawerFragment
);

export type ChildLevel1BookParkingOnBehalfDrawerFragment = (
  { readonly __typename?: 'BookParkingOnBehalfDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerBookParkingOnBehalfDrawerFragment
);

export type ChildLevel1ClientInvoicingReportDrawerFragment = (
  { readonly __typename?: 'ClientInvoicingReportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerClientInvoicingReportDrawerFragment
);

export type ChildLevel1CompanyBankAccountDrawerFragment = (
  { readonly __typename?: 'CompanyBankAccountDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerCompanyBankAccountDrawerFragment
);

export type ChildLevel1CompanyDetailsDrawerFragment = (
  { readonly __typename?: 'CompanyDetailsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerCompanyDetailsDrawerFragment
);

export type ChildLevel1ContractBankAccountDrawerFragment = (
  { readonly __typename?: 'ContractBankAccountDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerContractBankAccountDrawerFragment
);

export type ChildLevel1ContractBonusesSettingsDrawerFragment = (
  { readonly __typename?: 'ContractBonusesSettingsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerContractBonusesSettingsDrawerFragment
);

export type ChildLevel1ContractDetailsDrawerFragment = (
  { readonly __typename?: 'ContractDetailsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerContractDetailsDrawerFragment
);

export type ChildLevel1CopyrightsDrawerFragment = (
  { readonly __typename?: 'CopyrightsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerCopyrightsDrawerFragment
);

export type ChildLevel1CostAndRevenueItemDrawerFragment = (
  { readonly __typename?: 'CostAndRevenueItemDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerCostAndRevenueItemDrawerFragment
);

export type ChildLevel1CostSummariesDrawerFragment = (
  { readonly __typename?: 'CostSummariesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerCostSummariesDrawerFragment
);

export type ChildLevel1CreateBenefitDrawerFragment = (
  { readonly __typename?: 'CreateBenefitDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerCreateBenefitDrawerFragment
);

export type ChildLevel1CreateVariantDrawerFragment = (
  { readonly __typename?: 'CreateVariantDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerCreateVariantDrawerFragment
);

export type ChildLevel1DeskAssignmentDrawerFragment = (
  { readonly __typename?: 'DeskAssignmentDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerDeskAssignmentDrawerFragment
);

export type ChildLevel1DeskDrawerFragment = (
  { readonly __typename?: 'DeskDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerDeskDrawerFragment
);

export type ChildLevel1DirectReportingDrawerFragment = (
  { readonly __typename?: 'DirectReportingDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerDirectReportingDrawerFragment
);

export type ChildLevel1EditBenefitDrawerFragment = (
  { readonly __typename?: 'EditBenefitDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditBenefitDrawerFragment
);

export type ChildLevel1EditBenefitVariantDrawerFragment = (
  { readonly __typename?: 'EditBenefitVariantDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditBenefitVariantDrawerFragment
);

export type ChildLevel1EditBenefitVariantPriceDrawerFragment = (
  { readonly __typename?: 'EditBenefitVariantPriceDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditBenefitVariantPriceDrawerFragment
);

export type ChildLevel1EditClientContractDrawerFragment = (
  { readonly __typename?: 'EditClientContractDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditClientContractDrawerFragment
);

export type ChildLevel1EditDeskRequestDrawerFragment = (
  { readonly __typename?: 'EditDeskRequestDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditDeskRequestDrawerFragment
);

export type ChildLevel1EditOfficeDrawerFragment = (
  { readonly __typename?: 'EditOfficeDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditOfficeDrawerFragment
);

export type ChildLevel1EditOfficeSettingsDrawerFragment = (
  { readonly __typename?: 'EditOfficeSettingsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditOfficeSettingsDrawerFragment
);

export type ChildLevel1EditParkingRequestDrawerFragment = (
  { readonly __typename?: 'EditParkingRequestDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditParkingRequestDrawerFragment
);

export type ChildLevel1EditProfileAdditionalDataDrawerFragment = (
  { readonly __typename?: 'EditProfileAdditionalDataDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditProfileAdditionalDataDrawerFragment
);

export type ChildLevel1EditProfileAddressDrawerFragment = (
  { readonly __typename?: 'EditProfileAddressDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditProfileAddressDrawerFragment
);

export type ChildLevel1EditProfileBasicInfoDrawerFragment = (
  { readonly __typename?: 'EditProfileBasicInfoDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditProfileBasicInfoDrawerFragment
);

export type ChildLevel1EditProjectCrossSellDrawerFragment = (
  { readonly __typename?: 'EditProjectCrossSellDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditProjectCrossSellDrawerFragment
);

export type ChildLevel1EditProjectDrawerFragment = (
  { readonly __typename?: 'EditProjectDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditProjectDrawerFragment
);

export type ChildLevel1EditProjectTechStackAndCompetencesDrawerFragment = (
  { readonly __typename?: 'EditProjectTechStackAndCompetencesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditProjectTechStackAndCompetencesDrawerFragment
);

export type ChildLevel1EditSkillsAndCertificatesDrawerFragment = (
  { readonly __typename?: 'EditSkillsAndCertificatesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditSkillsAndCertificatesDrawerFragment
);

export type ChildLevel1EditSocialMediaHandlesDrawerFragment = (
  { readonly __typename?: 'EditSocialMediaHandlesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditSocialMediaHandlesDrawerFragment
);

export type ChildLevel1EditSpaceDrawerFragment = (
  { readonly __typename?: 'EditSpaceDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditSpaceDrawerFragment
);

export type ChildLevel1EmployeeDueDatesDrawerFragment = (
  { readonly __typename?: 'EmployeeDueDatesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEmployeeDueDatesDrawerFragment
);

export type ChildLevel1EmploymentBankAccountDrawerFragment = (
  { readonly __typename?: 'EmploymentBankAccountDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEmploymentBankAccountDrawerFragment
);

export type ChildLevel1EmploymentContractDraftDrawerFragment = (
  { readonly __typename?: 'EmploymentContractDraftDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEmploymentContractDraftDrawerFragment
);

export type ChildLevel1EmploymentContractNoteDrawerFragment = (
  { readonly __typename?: 'EmploymentContractNoteDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEmploymentContractNoteDrawerFragment
);

export type ChildLevel1EmploymentSalaryDetailsDrawerFragment = (
  { readonly __typename?: 'EmploymentSalaryDetailsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEmploymentSalaryDetailsDrawerFragment
);

export type ChildLevel1InvoiceTransferLinksDrawerFragment = (
  { readonly __typename?: 'InvoiceTransferLinksDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerInvoiceTransferLinksDrawerFragment
);

export type ChildLevel1InvoicesDrawerFragment = (
  { readonly __typename?: 'InvoicesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerInvoicesDrawerFragment
);

export type ChildLevel1ListColumnControllsDrawerFragment = (
  { readonly __typename?: 'ListColumnControllsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerListColumnControllsDrawerFragment
);

export type ChildLevel1ManageKeyPeopleDrawerFragment = (
  { readonly __typename?: 'ManageKeyPeopleDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerManageKeyPeopleDrawerFragment
);

export type ChildLevel1ManageProjectTimelineDrawerFragment = (
  { readonly __typename?: 'ManageProjectTimelineDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerManageProjectTimelineDrawerFragment
);

export type ChildLevel1OtherEmployeeInformationDrawerFragment = (
  { readonly __typename?: 'OtherEmployeeInformationDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerOtherEmployeeInformationDrawerFragment
);

export type ChildLevel1ParkingSpotDrawerFragment = (
  { readonly __typename?: 'ParkingSpotDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerParkingSpotDrawerFragment
);

export type ChildLevel1PaymentDetailsDraftDrawerFragment = (
  { readonly __typename?: 'PaymentDetailsDraftDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerPaymentDetailsDraftDrawerFragment
);

export type ChildLevel1PaymentDetailsDrawerFragment = (
  { readonly __typename?: 'PaymentDetailsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerPaymentDetailsDrawerFragment
);

export type ChildLevel1PendingCopyrightsDrawerFragment = (
  { readonly __typename?: 'PendingCopyrightsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerPendingCopyrightsDrawerFragment
);

export type ChildLevel1PeopleListReportDrawerFragment = (
  { readonly __typename?: 'PeopleListReportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerPeopleListReportDrawerFragment
);

export type ChildLevel1ProgressionSchemeLevelDrawerFragment = (
  { readonly __typename?: 'ProgressionSchemeLevelDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerProgressionSchemeLevelDrawerFragment
);

export type ChildLevel1ProjectBillablesReportDrawerFragment = (
  { readonly __typename?: 'ProjectBillablesReportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerProjectBillablesReportDrawerFragment
);

export type ChildLevel1ProjectMembersDrawerFragment = (
  { readonly __typename?: 'ProjectMembersDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerProjectMembersDrawerFragment
);

export type ChildLevel1RateCardDrawerFragment = (
  { readonly __typename?: 'RateCardDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerRateCardDrawerFragment
);

export type ChildLevel1RateChangesReportDrawerFragment = (
  { readonly __typename?: 'RateChangesReportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerRateChangesReportDrawerFragment
);

export type ChildLevel1ReservationLimitsDrawerFragment = (
  { readonly __typename?: 'ReservationLimitsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerReservationLimitsDrawerFragment
);

export type ChildLevel1RoomDrawerFragment = (
  { readonly __typename?: 'RoomDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerRoomDrawerFragment
);

export type ChildLevel1SalariesSummaryReportDrawerFragment = (
  { readonly __typename?: 'SalariesSummaryReportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerSalariesSummaryReportDrawerFragment
);

export type ChildLevel1SetFutureEntitlementDrawerFragment = (
  { readonly __typename?: 'SetFutureEntitlementDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerSetFutureEntitlementDrawerFragment
);

export type ChildLevel1SetRateAndProgressionDrawerFragment = (
  { readonly __typename?: 'SetRateAndProgressionDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerSetRateAndProgressionDrawerFragment
);

export type ChildLevel1SkillsAndCertificatesReportDrawerFragment = (
  { readonly __typename?: 'SkillsAndCertificatesReportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerSkillsAndCertificatesReportDrawerFragment
);

export type ChildLevel1SubcontractDraftDrawerFragment = (
  { readonly __typename?: 'SubcontractDraftDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerSubcontractDraftDrawerFragment
);

export type ChildLevel1SubcontractNoteDrawerFragment = (
  { readonly __typename?: 'SubcontractNoteDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerSubcontractNoteDrawerFragment
);

export type ChildLevel1TaxResidencyCertificatesDrawerFragment = (
  { readonly __typename?: 'TaxResidencyCertificatesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerTaxResidencyCertificatesDrawerFragment
);

export type ChildLevel1TimeReportsReportDrawerFragment = (
  { readonly __typename?: 'TimeReportsReportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerTimeReportsReportDrawerFragment
);

export type ChildLevel1TrainingPackageReportDrawerFragment = (
  { readonly __typename?: 'TrainingPackageReportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerTrainingPackageReportDrawerFragment
);

export type ChildLevel1TransferDetailsDrawerFragment = (
  { readonly __typename?: 'TransferDetailsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerTransferDetailsDrawerFragment
);

export type ChildLevel1TransferListExportDrawerFragment = (
  { readonly __typename?: 'TransferListExportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerTransferListExportDrawerFragment
);

export type ChildLevel1UopHolidaysReportDrawerFragment = (
  { readonly __typename?: 'UopHolidaysReportDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerUopHolidaysReportDrawerFragment
);

export type ChildLevel1UploadDocumentDrawerFragment = (
  { readonly __typename?: 'UploadDocumentDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerUploadDocumentDrawerFragment
);

export type ChildLevel1UserProjectsDrawerFragment = (
  { readonly __typename?: 'UserProjectsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerUserProjectsDrawerFragment
);

export type ChildLevel1YearlyCostSummaryDrawerFragment = (
  { readonly __typename?: 'YearlyCostSummaryDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerYearlyCostSummaryDrawerFragment
);

export type ChildLevel1Fragment =
  | ChildLevel1AddClientContractDrawerFragment
  | ChildLevel1AddCompanyDrawerFragment
  | ChildLevel1AddInternalProjectDrawerFragment
  | ChildLevel1AddOfficeDrawerFragment
  | ChildLevel1AddPersonDrawerFragment
  | ChildLevel1AddProgressionSchemeDrawerFragment
  | ChildLevel1AddProjectDrawerFragment
  | ChildLevel1AddSpaceDrawerFragment
  | ChildLevel1AddThirdPersonDrawerFragment
  | ChildLevel1AdditionalCostsDrawerFragment
  | ChildLevel1AllBonusesDrawerFragment
  | ChildLevel1AnnualLeaveEntitlementDrawerFragment
  | ChildLevel1AnnualLeavePreferencesDrawerFragment
  | ChildLevel1AnnualLeaveSummaryDrawerFragment
  | ChildLevel1AssignBenefitDrawerFragment
  | ChildLevel1B2BContractDraftDrawerFragment
  | ChildLevel1B2BContractNoteDrawerFragment
  | ChildLevel1B2BSalaryDetailsDrawerFragment
  | ChildLevel1BasicFinancialReportDrawerFragment
  | ChildLevel1BenefitInvoicesReportDrawerFragment
  | ChildLevel1BenefitNoteDrawerFragment
  | ChildLevel1BonusDrawerFragment
  | ChildLevel1BonusPreviewDrawerFragment
  | ChildLevel1BookDeskOnBehalfDrawerFragment
  | ChildLevel1BookParkingOnBehalfDrawerFragment
  | ChildLevel1ClientInvoicingReportDrawerFragment
  | ChildLevel1CompanyBankAccountDrawerFragment
  | ChildLevel1CompanyDetailsDrawerFragment
  | ChildLevel1ContractBankAccountDrawerFragment
  | ChildLevel1ContractBonusesSettingsDrawerFragment
  | ChildLevel1ContractDetailsDrawerFragment
  | ChildLevel1CopyrightsDrawerFragment
  | ChildLevel1CostAndRevenueItemDrawerFragment
  | ChildLevel1CostSummariesDrawerFragment
  | ChildLevel1CreateBenefitDrawerFragment
  | ChildLevel1CreateVariantDrawerFragment
  | ChildLevel1DeskAssignmentDrawerFragment
  | ChildLevel1DeskDrawerFragment
  | ChildLevel1DirectReportingDrawerFragment
  | ChildLevel1EditBenefitDrawerFragment
  | ChildLevel1EditBenefitVariantDrawerFragment
  | ChildLevel1EditBenefitVariantPriceDrawerFragment
  | ChildLevel1EditClientContractDrawerFragment
  | ChildLevel1EditDeskRequestDrawerFragment
  | ChildLevel1EditOfficeDrawerFragment
  | ChildLevel1EditOfficeSettingsDrawerFragment
  | ChildLevel1EditParkingRequestDrawerFragment
  | ChildLevel1EditProfileAdditionalDataDrawerFragment
  | ChildLevel1EditProfileAddressDrawerFragment
  | ChildLevel1EditProfileBasicInfoDrawerFragment
  | ChildLevel1EditProjectCrossSellDrawerFragment
  | ChildLevel1EditProjectDrawerFragment
  | ChildLevel1EditProjectTechStackAndCompetencesDrawerFragment
  | ChildLevel1EditSkillsAndCertificatesDrawerFragment
  | ChildLevel1EditSocialMediaHandlesDrawerFragment
  | ChildLevel1EditSpaceDrawerFragment
  | ChildLevel1EmployeeDueDatesDrawerFragment
  | ChildLevel1EmploymentBankAccountDrawerFragment
  | ChildLevel1EmploymentContractDraftDrawerFragment
  | ChildLevel1EmploymentContractNoteDrawerFragment
  | ChildLevel1EmploymentSalaryDetailsDrawerFragment
  | ChildLevel1InvoiceTransferLinksDrawerFragment
  | ChildLevel1InvoicesDrawerFragment
  | ChildLevel1ListColumnControllsDrawerFragment
  | ChildLevel1ManageKeyPeopleDrawerFragment
  | ChildLevel1ManageProjectTimelineDrawerFragment
  | ChildLevel1OtherEmployeeInformationDrawerFragment
  | ChildLevel1ParkingSpotDrawerFragment
  | ChildLevel1PaymentDetailsDraftDrawerFragment
  | ChildLevel1PaymentDetailsDrawerFragment
  | ChildLevel1PendingCopyrightsDrawerFragment
  | ChildLevel1PeopleListReportDrawerFragment
  | ChildLevel1ProgressionSchemeLevelDrawerFragment
  | ChildLevel1ProjectBillablesReportDrawerFragment
  | ChildLevel1ProjectMembersDrawerFragment
  | ChildLevel1RateCardDrawerFragment
  | ChildLevel1RateChangesReportDrawerFragment
  | ChildLevel1ReservationLimitsDrawerFragment
  | ChildLevel1RoomDrawerFragment
  | ChildLevel1SalariesSummaryReportDrawerFragment
  | ChildLevel1SetFutureEntitlementDrawerFragment
  | ChildLevel1SetRateAndProgressionDrawerFragment
  | ChildLevel1SkillsAndCertificatesReportDrawerFragment
  | ChildLevel1SubcontractDraftDrawerFragment
  | ChildLevel1SubcontractNoteDrawerFragment
  | ChildLevel1TaxResidencyCertificatesDrawerFragment
  | ChildLevel1TimeReportsReportDrawerFragment
  | ChildLevel1TrainingPackageReportDrawerFragment
  | ChildLevel1TransferDetailsDrawerFragment
  | ChildLevel1TransferListExportDrawerFragment
  | ChildLevel1UopHolidaysReportDrawerFragment
  | ChildLevel1UploadDocumentDrawerFragment
  | ChildLevel1UserProjectsDrawerFragment
  | ChildLevel1YearlyCostSummaryDrawerFragment
;

export type ChildLevel0AddClientContractDrawerFragment = (
  { readonly __typename?: 'AddClientContractDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAddClientContractDrawerFragment
);

export type ChildLevel0AddCompanyDrawerFragment = (
  { readonly __typename?: 'AddCompanyDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAddCompanyDrawerFragment
);

export type ChildLevel0AddInternalProjectDrawerFragment = (
  { readonly __typename?: 'AddInternalProjectDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAddInternalProjectDrawerFragment
);

export type ChildLevel0AddOfficeDrawerFragment = (
  { readonly __typename?: 'AddOfficeDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAddOfficeDrawerFragment
);

export type ChildLevel0AddPersonDrawerFragment = (
  { readonly __typename?: 'AddPersonDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAddPersonDrawerFragment
);

export type ChildLevel0AddProgressionSchemeDrawerFragment = (
  { readonly __typename?: 'AddProgressionSchemeDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAddProgressionSchemeDrawerFragment
);

export type ChildLevel0AddProjectDrawerFragment = (
  { readonly __typename?: 'AddProjectDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAddProjectDrawerFragment
);

export type ChildLevel0AddSpaceDrawerFragment = (
  { readonly __typename?: 'AddSpaceDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAddSpaceDrawerFragment
);

export type ChildLevel0AddThirdPersonDrawerFragment = (
  { readonly __typename?: 'AddThirdPersonDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAddThirdPersonDrawerFragment
);

export type ChildLevel0AdditionalCostsDrawerFragment = (
  { readonly __typename?: 'AdditionalCostsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAdditionalCostsDrawerFragment
);

export type ChildLevel0AllBonusesDrawerFragment = (
  { readonly __typename?: 'AllBonusesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAllBonusesDrawerFragment
);

export type ChildLevel0AnnualLeaveEntitlementDrawerFragment = (
  { readonly __typename?: 'AnnualLeaveEntitlementDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAnnualLeaveEntitlementDrawerFragment
);

export type ChildLevel0AnnualLeavePreferencesDrawerFragment = (
  { readonly __typename?: 'AnnualLeavePreferencesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAnnualLeavePreferencesDrawerFragment
);

export type ChildLevel0AnnualLeaveSummaryDrawerFragment = (
  { readonly __typename?: 'AnnualLeaveSummaryDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAnnualLeaveSummaryDrawerFragment
);

export type ChildLevel0AssignBenefitDrawerFragment = (
  { readonly __typename?: 'AssignBenefitDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerAssignBenefitDrawerFragment
);

export type ChildLevel0B2BContractDraftDrawerFragment = (
  { readonly __typename?: 'B2BContractDraftDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerB2BContractDraftDrawerFragment
);

export type ChildLevel0B2BContractNoteDrawerFragment = (
  { readonly __typename?: 'B2BContractNoteDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerB2BContractNoteDrawerFragment
);

export type ChildLevel0B2BSalaryDetailsDrawerFragment = (
  { readonly __typename?: 'B2BSalaryDetailsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerB2BSalaryDetailsDrawerFragment
);

export type ChildLevel0BasicFinancialReportDrawerFragment = (
  { readonly __typename?: 'BasicFinancialReportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerBasicFinancialReportDrawerFragment
);

export type ChildLevel0BenefitInvoicesReportDrawerFragment = (
  { readonly __typename?: 'BenefitInvoicesReportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerBenefitInvoicesReportDrawerFragment
);

export type ChildLevel0BenefitNoteDrawerFragment = (
  { readonly __typename?: 'BenefitNoteDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerBenefitNoteDrawerFragment
);

export type ChildLevel0BonusDrawerFragment = (
  { readonly __typename?: 'BonusDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerBonusDrawerFragment
);

export type ChildLevel0BonusPreviewDrawerFragment = (
  { readonly __typename?: 'BonusPreviewDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerBonusPreviewDrawerFragment
);

export type ChildLevel0BookDeskOnBehalfDrawerFragment = (
  { readonly __typename?: 'BookDeskOnBehalfDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerBookDeskOnBehalfDrawerFragment
);

export type ChildLevel0BookParkingOnBehalfDrawerFragment = (
  { readonly __typename?: 'BookParkingOnBehalfDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerBookParkingOnBehalfDrawerFragment
);

export type ChildLevel0ClientInvoicingReportDrawerFragment = (
  { readonly __typename?: 'ClientInvoicingReportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerClientInvoicingReportDrawerFragment
);

export type ChildLevel0CompanyBankAccountDrawerFragment = (
  { readonly __typename?: 'CompanyBankAccountDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerCompanyBankAccountDrawerFragment
);

export type ChildLevel0CompanyDetailsDrawerFragment = (
  { readonly __typename?: 'CompanyDetailsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerCompanyDetailsDrawerFragment
);

export type ChildLevel0ContractBankAccountDrawerFragment = (
  { readonly __typename?: 'ContractBankAccountDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerContractBankAccountDrawerFragment
);

export type ChildLevel0ContractBonusesSettingsDrawerFragment = (
  { readonly __typename?: 'ContractBonusesSettingsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerContractBonusesSettingsDrawerFragment
);

export type ChildLevel0ContractDetailsDrawerFragment = (
  { readonly __typename?: 'ContractDetailsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerContractDetailsDrawerFragment
);

export type ChildLevel0CopyrightsDrawerFragment = (
  { readonly __typename?: 'CopyrightsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerCopyrightsDrawerFragment
);

export type ChildLevel0CostAndRevenueItemDrawerFragment = (
  { readonly __typename?: 'CostAndRevenueItemDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerCostAndRevenueItemDrawerFragment
);

export type ChildLevel0CostSummariesDrawerFragment = (
  { readonly __typename?: 'CostSummariesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerCostSummariesDrawerFragment
);

export type ChildLevel0CreateBenefitDrawerFragment = (
  { readonly __typename?: 'CreateBenefitDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerCreateBenefitDrawerFragment
);

export type ChildLevel0CreateVariantDrawerFragment = (
  { readonly __typename?: 'CreateVariantDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerCreateVariantDrawerFragment
);

export type ChildLevel0DeskAssignmentDrawerFragment = (
  { readonly __typename?: 'DeskAssignmentDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerDeskAssignmentDrawerFragment
);

export type ChildLevel0DeskDrawerFragment = (
  { readonly __typename?: 'DeskDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerDeskDrawerFragment
);

export type ChildLevel0DirectReportingDrawerFragment = (
  { readonly __typename?: 'DirectReportingDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerDirectReportingDrawerFragment
);

export type ChildLevel0EditBenefitDrawerFragment = (
  { readonly __typename?: 'EditBenefitDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditBenefitDrawerFragment
);

export type ChildLevel0EditBenefitVariantDrawerFragment = (
  { readonly __typename?: 'EditBenefitVariantDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditBenefitVariantDrawerFragment
);

export type ChildLevel0EditBenefitVariantPriceDrawerFragment = (
  { readonly __typename?: 'EditBenefitVariantPriceDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditBenefitVariantPriceDrawerFragment
);

export type ChildLevel0EditClientContractDrawerFragment = (
  { readonly __typename?: 'EditClientContractDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditClientContractDrawerFragment
);

export type ChildLevel0EditDeskRequestDrawerFragment = (
  { readonly __typename?: 'EditDeskRequestDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditDeskRequestDrawerFragment
);

export type ChildLevel0EditOfficeDrawerFragment = (
  { readonly __typename?: 'EditOfficeDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditOfficeDrawerFragment
);

export type ChildLevel0EditOfficeSettingsDrawerFragment = (
  { readonly __typename?: 'EditOfficeSettingsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditOfficeSettingsDrawerFragment
);

export type ChildLevel0EditParkingRequestDrawerFragment = (
  { readonly __typename?: 'EditParkingRequestDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditParkingRequestDrawerFragment
);

export type ChildLevel0EditProfileAdditionalDataDrawerFragment = (
  { readonly __typename?: 'EditProfileAdditionalDataDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditProfileAdditionalDataDrawerFragment
);

export type ChildLevel0EditProfileAddressDrawerFragment = (
  { readonly __typename?: 'EditProfileAddressDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditProfileAddressDrawerFragment
);

export type ChildLevel0EditProfileBasicInfoDrawerFragment = (
  { readonly __typename?: 'EditProfileBasicInfoDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditProfileBasicInfoDrawerFragment
);

export type ChildLevel0EditProjectCrossSellDrawerFragment = (
  { readonly __typename?: 'EditProjectCrossSellDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditProjectCrossSellDrawerFragment
);

export type ChildLevel0EditProjectDrawerFragment = (
  { readonly __typename?: 'EditProjectDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditProjectDrawerFragment
);

export type ChildLevel0EditProjectTechStackAndCompetencesDrawerFragment = (
  { readonly __typename?: 'EditProjectTechStackAndCompetencesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditProjectTechStackAndCompetencesDrawerFragment
);

export type ChildLevel0EditSkillsAndCertificatesDrawerFragment = (
  { readonly __typename?: 'EditSkillsAndCertificatesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditSkillsAndCertificatesDrawerFragment
);

export type ChildLevel0EditSocialMediaHandlesDrawerFragment = (
  { readonly __typename?: 'EditSocialMediaHandlesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditSocialMediaHandlesDrawerFragment
);

export type ChildLevel0EditSpaceDrawerFragment = (
  { readonly __typename?: 'EditSpaceDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditSpaceDrawerFragment
);

export type ChildLevel0EmployeeDueDatesDrawerFragment = (
  { readonly __typename?: 'EmployeeDueDatesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEmployeeDueDatesDrawerFragment
);

export type ChildLevel0EmploymentBankAccountDrawerFragment = (
  { readonly __typename?: 'EmploymentBankAccountDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEmploymentBankAccountDrawerFragment
);

export type ChildLevel0EmploymentContractDraftDrawerFragment = (
  { readonly __typename?: 'EmploymentContractDraftDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEmploymentContractDraftDrawerFragment
);

export type ChildLevel0EmploymentContractNoteDrawerFragment = (
  { readonly __typename?: 'EmploymentContractNoteDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEmploymentContractNoteDrawerFragment
);

export type ChildLevel0EmploymentSalaryDetailsDrawerFragment = (
  { readonly __typename?: 'EmploymentSalaryDetailsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEmploymentSalaryDetailsDrawerFragment
);

export type ChildLevel0InvoiceTransferLinksDrawerFragment = (
  { readonly __typename?: 'InvoiceTransferLinksDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerInvoiceTransferLinksDrawerFragment
);

export type ChildLevel0InvoicesDrawerFragment = (
  { readonly __typename?: 'InvoicesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerInvoicesDrawerFragment
);

export type ChildLevel0ListColumnControllsDrawerFragment = (
  { readonly __typename?: 'ListColumnControllsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerListColumnControllsDrawerFragment
);

export type ChildLevel0ManageKeyPeopleDrawerFragment = (
  { readonly __typename?: 'ManageKeyPeopleDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerManageKeyPeopleDrawerFragment
);

export type ChildLevel0ManageProjectTimelineDrawerFragment = (
  { readonly __typename?: 'ManageProjectTimelineDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerManageProjectTimelineDrawerFragment
);

export type ChildLevel0OtherEmployeeInformationDrawerFragment = (
  { readonly __typename?: 'OtherEmployeeInformationDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerOtherEmployeeInformationDrawerFragment
);

export type ChildLevel0ParkingSpotDrawerFragment = (
  { readonly __typename?: 'ParkingSpotDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerParkingSpotDrawerFragment
);

export type ChildLevel0PaymentDetailsDraftDrawerFragment = (
  { readonly __typename?: 'PaymentDetailsDraftDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerPaymentDetailsDraftDrawerFragment
);

export type ChildLevel0PaymentDetailsDrawerFragment = (
  { readonly __typename?: 'PaymentDetailsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerPaymentDetailsDrawerFragment
);

export type ChildLevel0PendingCopyrightsDrawerFragment = (
  { readonly __typename?: 'PendingCopyrightsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerPendingCopyrightsDrawerFragment
);

export type ChildLevel0PeopleListReportDrawerFragment = (
  { readonly __typename?: 'PeopleListReportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerPeopleListReportDrawerFragment
);

export type ChildLevel0ProgressionSchemeLevelDrawerFragment = (
  { readonly __typename?: 'ProgressionSchemeLevelDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerProgressionSchemeLevelDrawerFragment
);

export type ChildLevel0ProjectBillablesReportDrawerFragment = (
  { readonly __typename?: 'ProjectBillablesReportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerProjectBillablesReportDrawerFragment
);

export type ChildLevel0ProjectMembersDrawerFragment = (
  { readonly __typename?: 'ProjectMembersDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerProjectMembersDrawerFragment
);

export type ChildLevel0RateCardDrawerFragment = (
  { readonly __typename?: 'RateCardDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerRateCardDrawerFragment
);

export type ChildLevel0RateChangesReportDrawerFragment = (
  { readonly __typename?: 'RateChangesReportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerRateChangesReportDrawerFragment
);

export type ChildLevel0ReservationLimitsDrawerFragment = (
  { readonly __typename?: 'ReservationLimitsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerReservationLimitsDrawerFragment
);

export type ChildLevel0RoomDrawerFragment = (
  { readonly __typename?: 'RoomDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerRoomDrawerFragment
);

export type ChildLevel0SalariesSummaryReportDrawerFragment = (
  { readonly __typename?: 'SalariesSummaryReportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerSalariesSummaryReportDrawerFragment
);

export type ChildLevel0SetFutureEntitlementDrawerFragment = (
  { readonly __typename?: 'SetFutureEntitlementDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerSetFutureEntitlementDrawerFragment
);

export type ChildLevel0SetRateAndProgressionDrawerFragment = (
  { readonly __typename?: 'SetRateAndProgressionDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerSetRateAndProgressionDrawerFragment
);

export type ChildLevel0SkillsAndCertificatesReportDrawerFragment = (
  { readonly __typename?: 'SkillsAndCertificatesReportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerSkillsAndCertificatesReportDrawerFragment
);

export type ChildLevel0SubcontractDraftDrawerFragment = (
  { readonly __typename?: 'SubcontractDraftDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerSubcontractDraftDrawerFragment
);

export type ChildLevel0SubcontractNoteDrawerFragment = (
  { readonly __typename?: 'SubcontractNoteDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerSubcontractNoteDrawerFragment
);

export type ChildLevel0TaxResidencyCertificatesDrawerFragment = (
  { readonly __typename?: 'TaxResidencyCertificatesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerTaxResidencyCertificatesDrawerFragment
);

export type ChildLevel0TimeReportsReportDrawerFragment = (
  { readonly __typename?: 'TimeReportsReportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerTimeReportsReportDrawerFragment
);

export type ChildLevel0TrainingPackageReportDrawerFragment = (
  { readonly __typename?: 'TrainingPackageReportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerTrainingPackageReportDrawerFragment
);

export type ChildLevel0TransferDetailsDrawerFragment = (
  { readonly __typename?: 'TransferDetailsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerTransferDetailsDrawerFragment
);

export type ChildLevel0TransferListExportDrawerFragment = (
  { readonly __typename?: 'TransferListExportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerTransferListExportDrawerFragment
);

export type ChildLevel0UopHolidaysReportDrawerFragment = (
  { readonly __typename?: 'UopHolidaysReportDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerUopHolidaysReportDrawerFragment
);

export type ChildLevel0UploadDocumentDrawerFragment = (
  { readonly __typename?: 'UploadDocumentDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerUploadDocumentDrawerFragment
);

export type ChildLevel0UserProjectsDrawerFragment = (
  { readonly __typename?: 'UserProjectsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerUserProjectsDrawerFragment
);

export type ChildLevel0YearlyCostSummaryDrawerFragment = (
  { readonly __typename?: 'YearlyCostSummaryDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerYearlyCostSummaryDrawerFragment
);

export type ChildLevel0Fragment =
  | ChildLevel0AddClientContractDrawerFragment
  | ChildLevel0AddCompanyDrawerFragment
  | ChildLevel0AddInternalProjectDrawerFragment
  | ChildLevel0AddOfficeDrawerFragment
  | ChildLevel0AddPersonDrawerFragment
  | ChildLevel0AddProgressionSchemeDrawerFragment
  | ChildLevel0AddProjectDrawerFragment
  | ChildLevel0AddSpaceDrawerFragment
  | ChildLevel0AddThirdPersonDrawerFragment
  | ChildLevel0AdditionalCostsDrawerFragment
  | ChildLevel0AllBonusesDrawerFragment
  | ChildLevel0AnnualLeaveEntitlementDrawerFragment
  | ChildLevel0AnnualLeavePreferencesDrawerFragment
  | ChildLevel0AnnualLeaveSummaryDrawerFragment
  | ChildLevel0AssignBenefitDrawerFragment
  | ChildLevel0B2BContractDraftDrawerFragment
  | ChildLevel0B2BContractNoteDrawerFragment
  | ChildLevel0B2BSalaryDetailsDrawerFragment
  | ChildLevel0BasicFinancialReportDrawerFragment
  | ChildLevel0BenefitInvoicesReportDrawerFragment
  | ChildLevel0BenefitNoteDrawerFragment
  | ChildLevel0BonusDrawerFragment
  | ChildLevel0BonusPreviewDrawerFragment
  | ChildLevel0BookDeskOnBehalfDrawerFragment
  | ChildLevel0BookParkingOnBehalfDrawerFragment
  | ChildLevel0ClientInvoicingReportDrawerFragment
  | ChildLevel0CompanyBankAccountDrawerFragment
  | ChildLevel0CompanyDetailsDrawerFragment
  | ChildLevel0ContractBankAccountDrawerFragment
  | ChildLevel0ContractBonusesSettingsDrawerFragment
  | ChildLevel0ContractDetailsDrawerFragment
  | ChildLevel0CopyrightsDrawerFragment
  | ChildLevel0CostAndRevenueItemDrawerFragment
  | ChildLevel0CostSummariesDrawerFragment
  | ChildLevel0CreateBenefitDrawerFragment
  | ChildLevel0CreateVariantDrawerFragment
  | ChildLevel0DeskAssignmentDrawerFragment
  | ChildLevel0DeskDrawerFragment
  | ChildLevel0DirectReportingDrawerFragment
  | ChildLevel0EditBenefitDrawerFragment
  | ChildLevel0EditBenefitVariantDrawerFragment
  | ChildLevel0EditBenefitVariantPriceDrawerFragment
  | ChildLevel0EditClientContractDrawerFragment
  | ChildLevel0EditDeskRequestDrawerFragment
  | ChildLevel0EditOfficeDrawerFragment
  | ChildLevel0EditOfficeSettingsDrawerFragment
  | ChildLevel0EditParkingRequestDrawerFragment
  | ChildLevel0EditProfileAdditionalDataDrawerFragment
  | ChildLevel0EditProfileAddressDrawerFragment
  | ChildLevel0EditProfileBasicInfoDrawerFragment
  | ChildLevel0EditProjectCrossSellDrawerFragment
  | ChildLevel0EditProjectDrawerFragment
  | ChildLevel0EditProjectTechStackAndCompetencesDrawerFragment
  | ChildLevel0EditSkillsAndCertificatesDrawerFragment
  | ChildLevel0EditSocialMediaHandlesDrawerFragment
  | ChildLevel0EditSpaceDrawerFragment
  | ChildLevel0EmployeeDueDatesDrawerFragment
  | ChildLevel0EmploymentBankAccountDrawerFragment
  | ChildLevel0EmploymentContractDraftDrawerFragment
  | ChildLevel0EmploymentContractNoteDrawerFragment
  | ChildLevel0EmploymentSalaryDetailsDrawerFragment
  | ChildLevel0InvoiceTransferLinksDrawerFragment
  | ChildLevel0InvoicesDrawerFragment
  | ChildLevel0ListColumnControllsDrawerFragment
  | ChildLevel0ManageKeyPeopleDrawerFragment
  | ChildLevel0ManageProjectTimelineDrawerFragment
  | ChildLevel0OtherEmployeeInformationDrawerFragment
  | ChildLevel0ParkingSpotDrawerFragment
  | ChildLevel0PaymentDetailsDraftDrawerFragment
  | ChildLevel0PaymentDetailsDrawerFragment
  | ChildLevel0PendingCopyrightsDrawerFragment
  | ChildLevel0PeopleListReportDrawerFragment
  | ChildLevel0ProgressionSchemeLevelDrawerFragment
  | ChildLevel0ProjectBillablesReportDrawerFragment
  | ChildLevel0ProjectMembersDrawerFragment
  | ChildLevel0RateCardDrawerFragment
  | ChildLevel0RateChangesReportDrawerFragment
  | ChildLevel0ReservationLimitsDrawerFragment
  | ChildLevel0RoomDrawerFragment
  | ChildLevel0SalariesSummaryReportDrawerFragment
  | ChildLevel0SetFutureEntitlementDrawerFragment
  | ChildLevel0SetRateAndProgressionDrawerFragment
  | ChildLevel0SkillsAndCertificatesReportDrawerFragment
  | ChildLevel0SubcontractDraftDrawerFragment
  | ChildLevel0SubcontractNoteDrawerFragment
  | ChildLevel0TaxResidencyCertificatesDrawerFragment
  | ChildLevel0TimeReportsReportDrawerFragment
  | ChildLevel0TrainingPackageReportDrawerFragment
  | ChildLevel0TransferDetailsDrawerFragment
  | ChildLevel0TransferListExportDrawerFragment
  | ChildLevel0UopHolidaysReportDrawerFragment
  | ChildLevel0UploadDocumentDrawerFragment
  | ChildLevel0UserProjectsDrawerFragment
  | ChildLevel0YearlyCostSummaryDrawerFragment
;

export type BenefitVariantRateFragment = { readonly __typename?: 'BenefitVariantRate', readonly period: BenefitBillingPeriod, readonly vat:
    | (
      { readonly __typename?: 'VatApplied' }
      & VatTypeVatAppliedFragment
    )
    | (
      { readonly __typename?: 'VatNotApplied' }
      & VatTypeVatNotAppliedFragment
    )
  , readonly netGross: { readonly __typename?: 'NetGross', readonly net: number, readonly gross: number } };

export type BenefitAdditionalPeopleBenefitAdditionalAdultsFragment = { readonly __typename?: 'BenefitAdditionalAdults', readonly adults: AdditionalPeopleNumber };

export type BenefitAdditionalPeopleBenefitAdditionalFamilyFragment = { readonly __typename?: 'BenefitAdditionalFamily', readonly adults: AdditionalPeopleNumber, readonly kids: AdditionalPeopleNumber };

export type BenefitAdditionalPeopleBenefitAdditionalKidsFragment = { readonly __typename?: 'BenefitAdditionalKids', readonly kids: AdditionalPeopleNumber };

export type BenefitAdditionalPeopleFragment =
  | BenefitAdditionalPeopleBenefitAdditionalAdultsFragment
  | BenefitAdditionalPeopleBenefitAdditionalFamilyFragment
  | BenefitAdditionalPeopleBenefitAdditionalKidsFragment
;

export type WorkTagFragment = { readonly __typename?: 'WorkTag', readonly id: string, readonly name: string, readonly canBeOvertime: boolean, readonly canHaveProjectSelected: boolean, readonly canHaveRecurringWorkRecords: boolean };

export type WorkingTimeFragment = { readonly __typename?: 'WorkingTime', readonly numerator: number, readonly denominator: number, readonly monday?: number | null, readonly tuesday?: number | null, readonly wednesday?: number | null, readonly thursday?: number | null, readonly friday?: number | null, readonly saturday?: number | null };

export type AnnualLeaveEntitlementValueFragment = { readonly __typename?: 'AnnualLeaveEntitlementValue', readonly days: number, readonly minutes: number };

export type VatTypeVatAppliedFragment = { readonly __typename?: 'VatApplied', readonly value: number };

export type VatTypeVatNotAppliedFragment = { readonly __typename?: 'VatNotApplied', readonly reason: VatNotAppliedReason };

export type VatTypeFragment =
  | VatTypeVatAppliedFragment
  | VatTypeVatNotAppliedFragment
;

export type ReportedLeaveDaysFragment = { readonly __typename?: 'ReportedLeaveDays', readonly outOfOffice: number, readonly sickLeave: number, readonly sickFamilyMemberCare: number, readonly paid: number, readonly unpaid: number, readonly special: number, readonly maternity: number, readonly paternity: number, readonly caregiving: number, readonly childCare: number, readonly dueToForceMajeure: number, readonly parental: number, readonly annual: (
    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
    & AnnualLeaveEntitlementValueFragment
  ) };

export type AnnualLeaveBalanceFragment = { readonly __typename?: 'AnnualLeaveBalance', readonly entitlement: (
    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
    & AnnualLeaveEntitlementValueFragment
  ), readonly used: (
    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
    & AnnualLeaveEntitlementValueFragment
  ), readonly available: (
    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
    & AnnualLeaveEntitlementValueFragment
  ) };

export type LeaveBalanceFragment = { readonly __typename?: 'DaysBalance', readonly entitlement: number, readonly used: number, readonly available: number };

export type CentsBalanceFragment = { readonly __typename?: 'CentsBalance', readonly entitlement: number, readonly used: number, readonly available: number };

export type DailyIncomeRowFragment = { readonly __typename?: 'DailyIncomeRow', readonly workDays: number, readonly value: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly rateAmount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type HourlyIncomeRowFragment = { readonly __typename?: 'HourlyIncomeRow', readonly workHours: number, readonly rateAmount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly rateIncreaseDueToRefundedBenefits?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly valueWithoutRateIncrease: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly valueIncludingRateIncrease: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type MonthlyIncomeRowFragment = { readonly __typename?: 'MonthlyIncomeRow', readonly rateAmount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type IncomeRowDailyIncomeRowFragment = (
  { readonly __typename?: 'DailyIncomeRow' }
  & DailyIncomeRowFragment
);

export type IncomeRowHourlyIncomeRowFragment = (
  { readonly __typename?: 'HourlyIncomeRow' }
  & HourlyIncomeRowFragment
);

export type IncomeRowMonthlyIncomeRowFragment = (
  { readonly __typename?: 'MonthlyIncomeRow' }
  & MonthlyIncomeRowFragment
);

export type IncomeRowFragment =
  | IncomeRowDailyIncomeRowFragment
  | IncomeRowHourlyIncomeRowFragment
  | IncomeRowMonthlyIncomeRowFragment
;

export type RateDetailsFragment = { readonly __typename?: 'RateDetails', readonly vat?: number | null, readonly currency: string, readonly rate: (
    { readonly __typename?: 'Rate' }
    & RateFragment
  ), readonly overtimeRate?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly rateIncreaseDueToRefundedBenefits?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null };

export type AdminPreviousMonthSalaryStateQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  date: Scalars['YearMonth']['input'];
}>;


export type AdminPreviousMonthSalaryStateQuery = { readonly __typename?: 'Query', readonly contractSalaryDetails:
    | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
        | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
            | { readonly __typename: 'IncompleteData' }
            | { readonly __typename: 'PaymentDisbursed' }
            | { readonly __typename: 'Ready' }
           }
        | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
            | { readonly __typename: 'IncompleteData' }
            | { readonly __typename: 'PaymentDisbursed' }
            | { readonly __typename: 'Ready' }
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };
